// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"1xCJv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _app = require("./App");
var _appDefault = parcelHelpers.interopDefault(_app);
var _globalsCss = require("./globals.css");
const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
const root = (0, _client.createRoot)(container);
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).StrictMode, {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appDefault.default), {})
}));

},{"react/jsx-runtime":"dQjte","react":"eGun2","react-dom/client":"lPt1V","./App":"kkFWx","./globals.css":"giRzh","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dQjte":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("b0fd80fac854f40a");

},{"b0fd80fac854f40a":"6nlqu"}],"6nlqu":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsxProd;
exports.jsxs = jsxProd;

},{}],"eGun2":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("99732499f9521ecc");

},{"99732499f9521ecc":"1llkZ"}],"1llkZ":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray;
function noop() {}
var ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop, noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Activity = REACT_ACTIVITY_TYPE;
exports.Children = Children;
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cacheSignal = function() {
    return null;
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, deps) {
    return ReactSharedInternals.H.useEffect(create, deps);
};
exports.useEffectEvent = function(callback) {
    return ReactSharedInternals.H.useEffectEvent(callback);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.2.0";

},{}],"lPt1V":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("80e1572a4e0f141e");

},{"80e1572a4e0f141e":"67SxW"}],"67SxW":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var Scheduler = require("1922f323170c4d96"), React = require("c3875707f781aa03"), ReactDOM = require("2b5818326f1f024c");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function assertIsMounted(fiber) {
    if (getNearestMountedFiber(fiber) !== fiber) throw Error(formatProdErrorMessage(188));
}
function findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = getNearestMountedFiber(fiber);
        if (null === alternate) throw Error(formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return assertIsMounted(parentA), fiber;
                if (parentB === b) return assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error(formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error(formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_FRAGMENT_TYPE:
            return "Fragment";
        case REACT_PROFILER_TYPE:
            return "Profiler";
        case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_PORTAL_TYPE:
            return "Portal";
        case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
        case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var isArrayImpl = Array.isArray, ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, valueStack = [], index = -1;
function createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function pop(cursor) {
    0 > index || (cursor.current = valueStack[index], valueStack[index] = null, index--);
}
function push(cursor, value) {
    index++;
    valueStack[index] = cursor.current;
    cursor.current = value;
}
var contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null);
function pushHostContainer(fiber, nextRootInstance) {
    push(rootInstanceStackCursor, nextRootInstance);
    push(contextFiberStackCursor, fiber);
    push(contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = getOwnHostContext(nextRootInstance), fiber = getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    pop(contextStackCursor);
    push(contextStackCursor, fiber);
}
function popHostContainer() {
    pop(contextStackCursor);
    pop(contextFiberStackCursor);
    pop(rootInstanceStackCursor);
}
function pushHostContext(fiber) {
    null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber);
    var context = contextStackCursor.current;
    var JSCompiler_inline_result = getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && (push(contextFiberStackCursor, fiber), push(contextStackCursor, JSCompiler_inline_result));
}
function popHostContext(fiber) {
    contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
    hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), HostTransitionContext._currentValue = sharedNotPendingObject);
}
var prefix, suffix;
function describeBuiltInComponentFrame(name) {
    if (void 0 === prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || "";
        suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + prefix + name + suffix;
}
var reentry = !1;
function describeNativeComponentFrame(fn, construct) {
    if (!fn || reentry) return "";
    reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return describeBuiltInComponentFrame(fiber.type);
        case 16:
            return describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? describeBuiltInComponentFrame("Suspense Fallback") : describeBuiltInComponentFrame("Suspense");
        case 19:
            return describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null;
function setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
    if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
        injectedHook.setStrictMode(rendererID, newIsStrictMode);
    } catch (err) {}
}
var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2;
function clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
}
var nextTransitionUpdateLane = 256, nextTransitionDeferredLane = 262144, nextRetryLane = 4194304;
function getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function claimNextRetryLane() {
    var lane = nextRetryLane;
    nextRetryLane <<= 1;
    0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
    return lane;
}
function createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function resolveUpdatePriority() {
    var updatePriority = ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : getEventPriority(updatePriority.type);
}
function runWithPriority(priority, fn) {
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        return ReactDOMSharedInternals.p = priority, fn();
    } finally{
        ReactDOMSharedInternals.p = previousPriority;
    }
}
var randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey;
function detachDeletedInstance(node) {
    delete node[internalInstanceKey];
    delete node[internalPropsKey];
    delete node[internalEventHandlersKey];
    delete node[internalEventHandlerListenersKey];
    delete node[internalEventHandlesSetKey];
}
function getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[internalInstanceKey]) return parentNode;
                targetNode = getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function getInstanceFromNode(node) {
    if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error(formatProdErrorMessage(33));
}
function getResourcesFromRoot(root) {
    var resources = root[internalRootNodeResourcesKey];
    resources || (resources = root[internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function markNodeAsHoistable(node) {
    node[internalHoistableMarker] = !0;
}
var allNativeEvents = new Set(), registrationNameDependencies = {};
function registerTwoPhaseEvent(registrationName, dependencies) {
    registerDirectEvent(registrationName, dependencies);
    registerDirectEvent(registrationName + "Capture", dependencies);
}
function registerDirectEvent(registrationName, dependencies) {
    registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)allNativeEvents.add(dependencies[registrationName]);
}
var VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return !0;
    if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return !1;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return validatedAttributeNameCache[attributeName] = !0;
    illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function setValueForAttribute(node, name, value) {
    if (isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function track(node) {
    if (!node._valueTracker) {
        var valueField = isCheckable(node) ? "checked" : "value";
        node._valueTracker = trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace(escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + getToStringValue(value);
        } else element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? setDefaultValue(element, type, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, type, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + getToStringValue(name) : element.removeAttribute("name");
}
function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
        value = null != value ? "" + getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    track(element);
}
function setDefaultValue(node, type, value) {
    "number" === type && getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
}
function initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error(formatProdErrorMessage(92));
            if (isArrayImpl(children)) {
                if (1 < children.length) throw Error(formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    track(element);
}
function setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error(formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function sanitizeURL(url) {
    return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function noop$1() {}
var currentReplayingEvent = null;
function getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var restoreTarget = null, restoreQueue = null;
function restoreStateOfTarget(target) {
    var internalInstance = getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[internalPropsKey] || null;
                            if (!otherProps) throw Error(formatProdErrorMessage(90));
                            updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var isInsideEventHandler = !1;
function batchedUpdates$1(fn, a, b) {
    if (isInsideEventHandler) return fn(a, b);
    isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if (isInsideEventHandler = !1, null !== restoreTarget || null !== restoreQueue) {
            if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)restoreStateOfTarget(fn[a]);
        }
    }
}
function getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error(formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = !1;
if (canUseDOM) try {
    var options = {};
    Object.defineProperty(options, "passive", {
        get: function() {
            passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
} catch (e) {
    passiveBrowserEventsSupported = !1;
}
var root = null, startText = null, fallbackText = null;
function getData() {
    if (fallbackText) return fallbackText;
    var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function functionThatReturnsTrue() {
    return !0;
}
function functionThatReturnsFalse() {
    return !1;
}
function createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
    }
    assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, {
    view: 0,
    detail: 0
}), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
        return lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : lastMovementY;
    }
}), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, {
    dataTransfer: 0
}), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, {
    relatedTarget: 0
}), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, {
    data: 0
}), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function getEventModifierState() {
    return modifierStateGetter;
}
var KeyboardEventInterface = assign({}, UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: getEventModifierState
}), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
    newState: 0,
    oldState: 0
}), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [
    9,
    13,
    27,
    32
], canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CHAR = String.fromCharCode(32), hasSpaceKeypress = !1;
function isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var isComposing = !1;
function getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            hasSpaceKeypress = !0;
            return SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if (isComposing) return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [
        target
    ] : restoreTarget = target;
    inst = accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var activeElement$1 = null, activeElementInst$1 = null;
function runEventInBatch(dispatchQueue) {
    processDispatchQueue(dispatchQueue, 0);
}
function getInstIfValueChanged(targetInst) {
    var targetNode = getNodeFromInstance(targetInst);
    if (updateValueIfChanged(targetNode)) return targetInst;
}
function getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var isInputEventSupported = !1;
if (canUseDOM) {
    var JSCompiler_inline_result$jscomp$286;
    if (canUseDOM) {
        var isSupported$jscomp$inline_427 = "oninput" in document;
        if (!isSupported$jscomp$inline_427) {
            var element$jscomp$inline_428 = document.createElement("div");
            element$jscomp$inline_428.setAttribute("oninput", "return;");
            isSupported$jscomp$inline_427 = "function" === typeof element$jscomp$inline_428.oninput;
        }
        JSCompiler_inline_result$jscomp$286 = isSupported$jscomp$inline_427;
    } else JSCompiler_inline_result$jscomp$286 = !1;
    isInputEventSupported = JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function stopWatchingForValueChange() {
    activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
}
function handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst$1, nativeEvent, getEventTarget(nativeEvent));
        batchedUpdates$1(runEventInBatch, dispatchQueue);
    }
}
function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
}
function getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return getInstIfValueChanged(activeElementInst$1);
}
function getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return getInstIfValueChanged(targetInst);
}
function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return getInstIfValueChanged(targetInst);
}
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is;
function shallowEqual(objA, objB) {
    if (objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function getNodeForCharacterOffset(root, offset) {
    var node = getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = getLeafNode(node);
    }
}
function containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = getActiveElement(containerInfo.document);
    }
    return element;
}
function hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = !1;
function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = activeElement)));
}
function makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var vendorPrefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: makePrefixMap("Animation", "AnimationIteration"),
    animationstart: makePrefixMap("Animation", "AnimationStart"),
    transitionrun: makePrefixMap("Transition", "TransitionRun"),
    transitionstart: makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
}, prefixedEventNames = {}, style = {};
canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
function getVendorPrefixedEventName(eventName) {
    if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
    if (!vendorPrefixes[eventName]) return eventName;
    var prefixMap = vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
simpleEventPluginEvents.push("scrollEnd");
function registerSimpleEvent(domEventName, reactName) {
    topLevelEventsToReactNames.set(domEventName, reactName);
    registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0;
function finishQueueingConcurrentUpdates() {
    for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var queue = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var update = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var lane = concurrentQueues[i];
        concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function enqueueUpdate$1(fiber, queue, update, lane) {
    concurrentQueues[concurrentQueuesIndex++] = fiber;
    concurrentQueues[concurrentQueuesIndex++] = queue;
    concurrentQueues[concurrentQueuesIndex++] = update;
    concurrentQueues[concurrentQueuesIndex++] = lane;
    concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    enqueueUpdate$1(fiber, queue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function enqueueConcurrentRenderForLane(fiber, lane) {
    enqueueUpdate$1(fiber, null, null, lane);
    return getRootForUpdatedFiber(fiber);
}
function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function getRootForUpdatedFiber(sourceFiber) {
    if (50 < nestedUpdateCount) throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var emptyContextObject = {};
function FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function createFiberImplClass(tag, pendingProps, key, mode) {
    return new FiberNode(tag, pendingProps, key, mode);
}
function shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = isHostHoistableType(type, pendingProps, contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case REACT_ACTIVITY_TYPE:
            return type = createFiberImplClass(31, pendingProps, key, mode), type.elementType = REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case REACT_FRAGMENT_TYPE:
            return createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case REACT_PROFILER_TYPE:
            return type = createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_TYPE:
            return type = createFiberImplClass(13, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_LIST_TYPE:
            return type = createFiberImplClass(19, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error(formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function createFiberFromFragment(elements, mode, lanes, key) {
    elements = createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function createFiberFromText(content, mode, lanes) {
    content = createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function createFiberFromPortal(portal, mode, lanes) {
    mode = createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var CapturedStacks = new WeakMap();
function createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
        CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: getStackByFiberInDevAndProd(source)
    };
}
var forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "";
function pushTreeFork(workInProgress, totalChildren) {
    forkStack[forkStackIndex++] = treeForkCount;
    forkStack[forkStackIndex++] = treeForkProvider;
    treeForkProvider = workInProgress;
    treeForkCount = totalChildren;
}
function pushTreeId(workInProgress, totalChildren, index) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = treeContextId;
    workInProgress = treeContextOverflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        treeContextOverflow = length + workInProgress;
    } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
}
function pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
}
function popTreeContext(workInProgress) {
    for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
    for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
}
function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextId = suspendedContext.id;
    treeContextOverflow = suspendedContext.overflow;
    treeContextProvider = workInProgress;
}
var hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error(formatProdErrorMessage(519));
function throwOnHydrationMismatch(fiber) {
    var error = Error(formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    queueHydrationError(createCapturedValueAtFiber(error, fiber));
    throw HydrationMismatchException;
}
function prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[internalInstanceKey] = fiber;
    instance[internalPropsKey] = props;
    switch(type){
        case "dialog":
            listenToNonDelegatedEvent("cancel", instance);
            listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < mediaEventTypes.length; type++)listenToNonDelegatedEvent(mediaEventTypes[type], instance);
            break;
        case "source":
            listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            listenToNonDelegatedEvent("error", instance);
            listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            listenToNonDelegatedEvent("invalid", instance);
            initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            listenToNonDelegatedEvent("invalid", instance), initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", instance), listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = noop$1), instance = !0) : instance = !1;
    instance || throwOnHydrationMismatch(fiber, !0);
}
function popToNextHostParent(fiber) {
    for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            rootOrSingletonContext = !0;
            return;
        default:
            hydrationParentFiber = hydrationParentFiber.return;
    }
}
function popHydrationState(fiber) {
    if (fiber !== hydrationParentFiber) return !1;
    if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && nextHydratableInstance && throwOnHydrationMismatch(fiber);
    popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error(formatProdErrorMessage(317));
        nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error(formatProdErrorMessage(317));
        nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function resetHydrationState() {
    nextHydratableInstance = hydrationParentFiber = null;
    isHydrating = !1;
}
function upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = hydrationErrors;
    null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, queuedErrors), hydrationErrors = null);
    return queuedErrors;
}
function queueHydrationError(error) {
    null === hydrationErrors ? hydrationErrors = [
        error
    ] : hydrationErrors.push(error);
}
var valueCursor = createCursor(null), currentlyRenderingFiber$1 = null, lastContextDependency = null;
function pushProvider(providerFiber, context, nextValue) {
    push(valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function popProvider(context) {
    context._currentValue = valueCursor.current;
    pop(valueCursor);
}
function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error(formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function prepareToReadContext(workInProgress) {
    currentlyRenderingFiber$1 = workInProgress;
    lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function readContext(context) {
    return readContextForConsumer(currentlyRenderingFiber$1, context);
}
function readContextDuringReconciliation(consumer, context) {
    null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
    return readContextForConsumer(consumer, context);
}
function readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === lastContextDependency) {
        if (null === consumer) throw Error(formatProdErrorMessage(308));
        lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else lastContextDependency = lastContextDependency.next = context;
    return value;
}
var AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function createCache() {
    return {
        controller: new AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
        cache.controller.abort();
    });
}
var currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null;
function entangleAsyncAction(transition, thenable) {
    if (null === currentEntangledListeners) {
        var entangledListeners = currentEntangledListeners = [];
        currentEntangledPendingCount = 0;
        currentEntangledLane = requestTransitionLane();
        currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    currentEntangledPendingCount++;
    thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
    return thenable;
}
function pingEngtangledActionScope() {
    if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
        null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
        var listeners = currentEntangledListeners;
        currentEntangledListeners = null;
        currentEntangledLane = 0;
        currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var prevOnStartTransitionFinish = ReactSharedInternals.S;
ReactSharedInternals.S = function(transition, returnValue) {
    globalMostRecentTransitionTime = now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
    null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
};
var resumedCache = createCursor(null);
function peekCacheFromPool() {
    var cacheResumedFromPreviousRender = resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
}
function pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? push(resumedCache, resumedCache.current) : push(resumedCache, prevCachePool.pool);
}
function getSuspendedCache() {
    var cacheFromPool = peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var SuspenseException = Error(formatProdErrorMessage(460)), SuspenseyCommitException = Error(formatProdErrorMessage(474)), SuspenseActionException = Error(formatProdErrorMessage(542)), noopSuspenseyCommitThenable = {
    then: function() {}
};
function isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop$1, noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then(noop$1, noop$1);
            else {
                thenableState = workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error(formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
function resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw suspendedThenable = x, SuspenseException;
        throw x;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
function checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException) throw Error(formatProdErrorMessage(483));
}
var thenableState$1 = null, thenableIndexCounter$1 = 0;
function unwrapThenable(thenable) {
    var index = thenableIndexCounter$1;
    thenableIndexCounter$1 += 1;
    null === thenableState$1 && (thenableState$1 = []);
    return trackUsedThenable(thenableState$1, thenable, index);
}
function coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error(formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error(formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current;
        current = createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case REACT_PORTAL_TYPE:
                    return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newChild = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error(formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if (isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if (getIteratorFn(newChild)) {
                key = getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error(formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === SuspenseException || x === SuspenseActionException) throw x;
            var fiber = createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), hasForceUpdate = !1;
function initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== (executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = getRootForUpdatedFiber(fiber);
        markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    enqueueUpdate$1(fiber, updateQueue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        markRootEntangled(root, lane);
    }
}
function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var didReadFromEntangledAsyncAction = !1;
function suspendIfUpdateReadFromEntangledAsyncAction() {
    if (didReadFromEntangledAsyncAction) {
        var entangledActionThenable = currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = assign({}, newState, updateLane);
                            break a;
                        case 2:
                            hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error(formatProdErrorMessage(191, callback));
    callback.call(context);
}
function commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
}
var currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0);
function pushHiddenContext(fiber, context) {
    fiber = entangledRenderLanes;
    push(prevEntangledRenderLanesCursor, fiber);
    push(currentTreeHiddenStackCursor, context);
    entangledRenderLanes = fiber | context.baseLanes;
}
function reuseHiddenContextOnStack() {
    push(prevEntangledRenderLanesCursor, entangledRenderLanes);
    push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
}
function popHiddenContext() {
    entangledRenderLanes = prevEntangledRenderLanesCursor.current;
    pop(currentTreeHiddenStackCursor);
    pop(prevEntangledRenderLanesCursor);
}
var suspenseHandlerStackCursor = createCursor(null), shellBoundary = null;
function pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    push(suspenseStackCursor, suspenseStackCursor.current & 1);
    push(suspenseHandlerStackCursor, handler);
    null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
}
function pushDehydratedActivitySuspenseHandler(fiber) {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, fiber);
    null === shellBoundary && (shellBoundary = fiber);
}
function pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? (push(suspenseStackCursor, suspenseStackCursor.current), push(suspenseHandlerStackCursor, fiber), null === shellBoundary && (shellBoundary = fiber)) : reuseSuspenseHandlerOnStack(fiber);
}
function reuseSuspenseHandlerOnStack() {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
}
function popSuspenseHandler(fiber) {
    pop(suspenseHandlerStackCursor);
    shellBoundary === fiber && (shellBoundary = null);
    pop(suspenseStackCursor);
}
var suspenseStackCursor = createCursor(0);
function findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0;
function throwInvalidHookError() {
    throw Error(formatProdErrorMessage(321));
}
function areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    renderLanes = nextRenderLanes;
    currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    ReactSharedInternals.H = null === current || null === current.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(workInProgress, Component, props, secondArg));
    finishRenderingHooks(current);
    return nextRenderLanes;
}
function finishRenderingHooks(current) {
    ReactSharedInternals.H = ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdate = !1;
    thenableIndexCounter = 0;
    thenableState = null;
    if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
    null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
}
function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
        thenableIndexCounter = 0;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
        numberOfReRenders += 1;
        workInProgressHook = currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        ReactSharedInternals.H = HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while (didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function TransitionAwareHostComponent() {
    var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== localIdCounter;
    localIdCounter = 0;
    return didRenderIdHook;
}
function bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function resetHooksOnUnwind(workInProgress) {
    if (didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        didScheduleRenderPhaseUpdate = !1;
    }
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdateDuringThisPass = !1;
    thenableIndexCounter = localIdCounter = 0;
    thenableState = null;
}
function mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
    return workInProgressHook;
}
function updateWorkInProgressHook() {
    if (null === currentHook) {
        var nextCurrentHook = currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = currentHook.next;
    var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
    if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === currentlyRenderingFiber.alternate) throw Error(formatProdErrorMessage(467));
            throw Error(formatProdErrorMessage(310));
        }
        currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
    }
    return workInProgressHook;
}
function createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function useThenable(thenable) {
    var index = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    thenable = trackUsedThenable(thenableState, thenable, index);
    index = currentlyRenderingFiber;
    null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null === index || null === index.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
    return thenable;
}
function use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return useThenable(usable);
        if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
    }
    throw Error(formatProdErrorMessage(438, String(usable)));
}
function useMemoCache(size) {
    var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function updateReducer(reducer) {
    var hook = updateWorkInProgressHook();
    return updateReducerImpl(hook, currentHook, reducer);
}
function updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if ((renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function rerenderReducer(reducer) {
    var hook = updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !objectIs((currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0);
    hook = hook.queue;
    updateEffect(subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        pushSimpleEffect(9, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== (renderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
}
function subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    });
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function forceStoreRerender(fiber) {
    var root = enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && scheduleUpdateOnFiber(root, fiber, 2);
}
function mountStateImpl(initialState) {
    var hook = mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
}
function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        onActionError(actionQueue, node, error$66);
    }
}
function handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return onActionError(actionQueue, node, error);
    }) : onActionSuccess(actionQueue, node, returnValue);
}
function onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
}
function onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function actionStateReducer(oldState, newState) {
    return newState;
}
function mountActionState(action, initialStateProp) {
    if (isHydrating) {
        var ssrFormState = workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = currentlyRenderingFiber;
                if (isHydrating) {
                    if (nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = nextHydratableInstance;
                            for(var inRootOrSingleton = rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            nextHydratableInstance = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = mountStateImpl(!1);
    inRootOrSingleton = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function updateActionState(action) {
    var stateHook = updateWorkInProgressHook();
    return updateActionStateImpl(stateHook, currentHook, action);
}
function updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
    stateHook = updateReducer(basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = useThenable(currentStateHook);
    } catch (x) {
        if (x === SuspenseException) throw SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(9, {
        destroy: void 0
    }, actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function rerenderActionState(action) {
    var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
    if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
    updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = currentlyRenderingFiber.updateQueue;
    null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function updateRef() {
    return updateWorkInProgressHook().memoizedState;
}
function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = mountWorkInProgressHook();
    currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function mountEffect(create, deps) {
    mountEffectImpl(8390656, 8, create, deps);
}
function updateEffect(create, deps) {
    updateEffectImpl(2048, 8, create, deps);
}
function useEffectEventImpl(payload) {
    currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function updateEvent(callback) {
    var ref = updateWorkInProgressHook().memoizedState;
    useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== (executionContext & 2)) throw Error(formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function updateInsertionEffect(create, deps) {
    return updateEffectImpl(4, 2, create, deps);
}
function updateLayoutEffect(create, deps) {
    return updateEffectImpl(4, 4, create, deps);
}
function imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create, ref), deps);
}
function mountDebugValue() {}
function updateCallback(callback, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function updateMemo(nextCreate, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if (objectIs(value, prevValue)) return value;
    if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
    if (0 === (renderLanes & 42) || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return didReceiveUpdate = !0, hook.memoizedState = value;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = ReactDOMSharedInternals.p;
    ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
            dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
        } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
    } catch (error) {
        dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, requestUpdateLane());
    } finally{
        ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
    }
}
function noop() {}
function startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
    var queue = ensureFormComponentIsStateful(formFiber).queue;
    startTransition(formFiber, queue, pendingState, sharedNotPendingObject, null === action ? noop : function() {
        requestFormReset$1(formFiber);
        return action(formData);
    });
}
function ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: sharedNotPendingObject,
        baseState: sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function requestFormReset$1(formFiber) {
    var stateHook = ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, requestUpdateLane());
}
function useHostTransitionStatus() {
    return readContext(HostTransitionContext);
}
function updateId() {
    return updateWorkInProgressHook().memoizedState;
}
function updateRefresh() {
    return updateWorkInProgressHook().memoizedState;
}
function refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = requestUpdateLane();
                fiber = createUpdate(lane);
                var root$69 = enqueueUpdate(provider, fiber, lane);
                null !== root$69 && (scheduleUpdateOnFiber(root$69, provider, lane), entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function dispatchReducerAction(fiber, queue, action) {
    var lane = requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, action) : (action = enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && (scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane)));
}
function dispatchSetState(fiber, queue, action) {
    var lane = requestUpdateLane();
    dispatchSetStateInternal(fiber, queue, action, lane);
}
function dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
    } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
}
function enqueueRenderPhaseUpdate(queue, update) {
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        markRootEntangled(root, lane);
    }
}
var ContextOnlyDispatcher = {
    readContext: readContext,
    use: use,
    useCallback: throwInvalidHookError,
    useContext: throwInvalidHookError,
    useEffect: throwInvalidHookError,
    useImperativeHandle: throwInvalidHookError,
    useLayoutEffect: throwInvalidHookError,
    useInsertionEffect: throwInvalidHookError,
    useMemo: throwInvalidHookError,
    useReducer: throwInvalidHookError,
    useRef: throwInvalidHookError,
    useState: throwInvalidHookError,
    useDebugValue: throwInvalidHookError,
    useDeferredValue: throwInvalidHookError,
    useTransition: throwInvalidHookError,
    useSyncExternalStore: throwInvalidHookError,
    useId: throwInvalidHookError,
    useHostTransitionStatus: throwInvalidHookError,
    useFormState: throwInvalidHookError,
    useActionState: throwInvalidHookError,
    useOptimistic: throwInvalidHookError,
    useMemoCache: throwInvalidHookError,
    useCacheRefresh: throwInvalidHookError
};
ContextOnlyDispatcher.useEffectEvent = throwInvalidHookError;
var HooksDispatcherOnMount = {
    readContext: readContext,
    use: use,
    useCallback: function(callback, deps) {
        mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: readContext,
    useEffect: mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        mountEffectImpl(4194308, 4, imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = mountWorkInProgressHook();
        return mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = mountStateImpl(!1);
        stateHook = startTransition.bind(null, currentlyRenderingFiber, stateHook.queue, !0, !1);
        mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
        if (isHydrating) {
            if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
            0 !== (workInProgressRootRenderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        pushSimpleEffect(9, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
        if (isHydrating) {
            var JSCompiler_inline_result = treeContextOverflow;
            var idWithLeadingBit = treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: mountActionState,
    useActionState: mountActionState,
    useOptimistic: function(passthrough) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: function() {
        return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== (executionContext & 2)) throw Error(formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, HooksDispatcherOnUpdate = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: updateReducer,
    useRef: updateRef,
    useState: function() {
        return updateReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: updateActionState,
    useActionState: updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
};
HooksDispatcherOnUpdate.useEffectEvent = updateEvent;
var HooksDispatcherOnRerender = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: rerenderReducer,
    useRef: updateRef,
    useState: function() {
        return rerenderReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: rerenderActionState,
    useActionState: rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
};
HooksDispatcherOnRerender.useEffectEvent = updateEvent;
function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = enqueueUpdate(inst, update, lane);
        null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
    }
};
function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
}
function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function defaultOnUncaughtError(error) {
    reportGlobalError(error);
}
function defaultOnCaughtError(error) {
    console.error(error);
}
function defaultOnRecoverableError(error) {
    reportGlobalError(error);
}
function logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function createRootErrorUpdate(root, errorInfo, lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        logUncaughtError(root, errorInfo);
    };
    return lane;
}
function createClassErrorUpdate(lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error(formatProdErrorMessage(435, sourceFiber.tag));
        }
        attachPingListener(root, value, rootRenderLanes);
        renderDidSuspendDelayIfPossible();
        return !1;
    }
    if (isHydrating) return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root = Error(formatProdErrorMessage(422), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(root, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage(423), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error(formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
        wrapperError
    ] : workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var SelectiveHydrationException = Error(formatProdErrorMessage(461)), didReceiveUpdate = !1;
function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    prepareToReadContext(workInProgress);
    nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && key && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack(workInProgress));
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && pushTransition(workInProgress, null);
    reuseHiddenContextOnStack();
    pushOffscreenSuspenseHandler(workInProgress);
    null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function mountActivityChildren(workInProgress, nextProps) {
    nextProps = mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if (isHydrating) {
            if ("hidden" === nextProps.mode) return current = mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, bailoutOffscreenComponent(null, current);
            pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = nextHydratableInstance) ? (current = canHydrateHydrationBoundary(current, rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== treeContextProvider ? {
                    id: treeContextId,
                    overflow: treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : current = null;
            if (null === current) throw throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error(formatProdErrorMessage(558));
        } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || didSuspend) {
            nextProps = workInProgressRoot;
            if (null !== nextProps && (dehydrated = getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, enqueueConcurrentRenderForLane(current, dehydrated), scheduleUpdateOnFiber(nextProps, current, dehydrated), SelectiveHydrationException;
            renderDidSuspendDelayIfPossible();
            workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, nextHydratableInstance = getNextHydratable(dehydrated.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error(formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    finishRenderingHooks(current);
    Component = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && Component && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && (applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && classComponentUpdater.enqueueReplaceState(context, context.state, null), processUpdateQueue(workInProgress, nextProps, context, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    resetHydrationState();
    workInProgress.flags |= 256;
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: getSuspendedCache()
    };
}
function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= workInProgressDeferredLane);
    return current;
}
function updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if (isHydrating) {
            showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
            (current = nextHydratableInstance) ? (current = canHydrateHydrationBoundary(current, rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== treeContextProvider ? {
                    id: treeContextId,
                    overflow: treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : current = null;
            if (null === current) throw throwOnHydrationMismatch(workInProgress);
            isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(null, nextProps);
        pushPrimaryTreeSuspenseHandler(workInProgress);
        return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : (reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, workInProgress = bailoutOffscreenComponent(null, nextProps));
        else if (pushPrimaryTreeSuspenseHandler(workInProgress), isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error(formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, enqueueConcurrentRenderForLane(current, nextProps), scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), SelectiveHydrationException;
            isSuspenseInstancePending(nextPrimaryChildren) || renderDidSuspendDelayIfPossible();
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, nextHydratableInstance = getNextHydratable(nextPrimaryChildren.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(current.child, nextProps);
    pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    push(suspenseStackCursor, suspenseContext);
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = isHydrating ? treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error(formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && checkIfContextChanged(current) ? !0 : !1;
}
function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
            resetHydrationState();
            break;
        case 27:
        case 5:
            pushHostContext(workInProgress);
            break;
        case 4:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                pushPrimaryTreeSuspenseHandler(workInProgress);
                current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            push(suspenseStackCursor, suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
    }
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) didReceiveUpdate = !0;
        else {
            if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else didReceiveUpdate = !1, isHydrating && 0 !== (workInProgress.flags & 1048576) && pushTreeId(workInProgress, treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) shouldConstruct(current) ? (props = resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = getComponentNameFromType(current) || current;
                    throw Error(formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = resolveClassComponentProps(props, workInProgress.pendingProps), updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error(formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                cloneUpdateQueue(current, workInProgress);
                processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                pushProvider(workInProgress, CacheContext, props);
                props !== prevState.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0);
                suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = createCapturedValueAtFiber(Error(formatProdErrorMessage(424)), workInProgress);
                        queueHydrationError($$typeof);
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        nextHydratableInstance = getNextHydratable(current.firstChild);
                        hydrationParentFiber = workInProgress;
                        isHydrating = !0;
                        hydrationErrors = null;
                        rootOrSingletonContext = !0;
                        renderLanes = mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current).createElement(renderLanes), props[internalInstanceKey] = workInProgress, props[internalPropsKey] = current, setInitialProperties(props, renderLanes, current), markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return pushHostContext(workInProgress), null === current && isHydrating && (props = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, rootInstanceStackCursor.current), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, $$typeof = nextHydratableInstance, isSingletonScope(workInProgress.type) ? (previousHydratableOnEnteringScopedSingleton = $$typeof, nextHydratableInstance = getNextHydratable(props.firstChild)) : nextHydratableInstance = $$typeof), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && isHydrating) {
                if ($$typeof = props = nextHydratableInstance) props = canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, hydrationParentFiber = workInProgress, nextHydratableInstance = getNextHydratable(props.firstChild), rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || throwOnHydrationMismatch(workInProgress);
            }
            pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), HostTransitionContext._currentValue = $$typeof);
            markRef(current, workInProgress);
            reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && isHydrating) {
                if (current = renderLanes = nextHydratableInstance) renderLanes = canHydrateTextInstance(renderLanes, workInProgress.pendingProps, rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null, current = !0) : current = !1;
                current || throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, props, renderLanes) : reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, pushProvider(workInProgress, workInProgress.type, props.value), reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, prepareToReadContext(workInProgress), $$typeof = readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return prepareToReadContext(workInProgress), props = readContext(CacheContext), null === current ? ($$typeof = peekCacheFromPool(), null === $$typeof && ($$typeof = workInProgressRoot, prevState = createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), pushProvider(workInProgress, CacheContext, props)) : (props = prevState.cache, pushProvider(workInProgress, CacheContext, props), props !== $$typeof.cache && propagateContextChanges(workInProgress, [
                CacheContext
            ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
        if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
    }
}
function scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
}
function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return bubbleProperties(workInProgress), null;
        case 1:
            return bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            popProvider(CacheContext);
            popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) popHydrationState(workInProgress) ? markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, upgradeHydrationErrorsToRecoverable());
            bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? (markUpdate(workInProgress), null !== nextResource ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && markUpdate(workInProgress), bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            popHostContext(workInProgress);
            renderLanes = rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                current = contextStackCursor.current;
                popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, markUpdate(workInProgress));
            }
            bubbleProperties(workInProgress);
            return null;
        case 5:
            popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = contextStackCursor.current;
                if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[internalInstanceKey] = workInProgress;
                    nextResource[internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch(setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && markUpdate(workInProgress);
                }
            }
            bubbleProperties(workInProgress);
            preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                current = rootInstanceStackCursor.current;
                if (popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || throwOnHydrationMismatch(workInProgress, !0);
                } else current = getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error(formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error(formatProdErrorMessage(557));
                        current[internalInstanceKey] = workInProgress;
                    } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                    popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error(formatProdErrorMessage(558));
            }
            bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error(formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error(formatProdErrorMessage(317));
                        type[internalInstanceKey] = workInProgress;
                    } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    bubbleProperties(workInProgress);
                    type = !1;
                } else type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                    popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            bubbleProperties(workInProgress);
            return null;
        case 4:
            return popHostContainer(), null === current && listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), bubbleProperties(workInProgress), null;
        case 10:
            return popProvider(workInProgress.type), bubbleProperties(workInProgress), null;
        case 19:
            pop(suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            push(suspenseStackCursor, suspenseStackCursor.current & 1 | 2);
                            isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && now() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                    } else 2 * now() - newProps.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = now(), current.sibling = null, renderLanes = suspenseStackCursor.current, push(suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount), current;
            bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function unwindWork(current, workInProgress) {
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return popProvider(CacheContext), popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return pop(suspenseStackCursor), null;
        case 4:
            return popHostContainer(), null;
        case 10:
            return popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), null !== current && pop(resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return popProvider(CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function unwindInterruptedWork(current, interruptedWork) {
    popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            popProvider(CacheContext);
            popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            popHostContext(interruptedWork);
            break;
        case 4:
            popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && popSuspenseHandler(interruptedWork);
            break;
        case 13:
            popSuspenseHandler(interruptedWork);
            break;
        case 19:
            pop(suspenseStackCursor);
            break;
        case 10:
            popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            popSuspenseHandler(interruptedWork);
            popHiddenContext();
            null !== current && pop(resumedCache);
            break;
        case 24:
            popProvider(CacheContext);
    }
}
function commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            commitCallbacks(updateQueue, instance);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[internalPropsKey] = newProps;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$1));
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        setInitialProperties(singleton, type, props);
        singleton[internalInstanceKey] = finishedWork;
        singleton[internalPropsKey] = props;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null;
function commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    eventsEnabled = _enabled;
    root = getActiveElementDeep(root);
    if (hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    _enabled = !1;
    for(nextEffect = firstChild; null !== nextEffect;)if (firstChild = nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, nextEffect = root;
    else for(; null !== nextEffect;){
        firstChild = nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error(formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            nextEffect = root;
            break;
        }
        nextEffect = firstChild.return;
    }
}
function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && commitClassCallbacks(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    commitCallbacks(finishedRoot, current);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && commitHostMount(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = retryDehydratedSuspenseBoundary.bind(null, finishedWork), registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                prevProps = offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = flags;
                (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                offscreenSubtreeIsHidden = prevProps;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var hostParent = null, hostParentIsContainer = !1;
function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
        injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
            isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = !1);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            releaseSingletonInstance(deletedFiber.stateNode);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = null;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            if (null !== hostParent) {
                if (hostParentIsContainer) try {
                    (9 === hostParent.nodeType ? hostParent.body : "HTML" === hostParent.nodeName ? hostParent.ownerDocument.body : hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), retryIfBlockedOn(finishedRoot)) : clearHydrationBoundary(hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = deletedFiber.stateNode.containerInfo;
            hostParentIsContainer = !0;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            retryIfBlockedOn(finishedRoot);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        retryIfBlockedOn(finishedRoot);
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
        default:
            throw Error(formatProdErrorMessage(435, finishedWork.tag));
    }
}
function attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if (isSingletonScope(parent.type)) {
                        hostParent = parent.stateNode;
                        hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === hostParent) throw Error(formatProdErrorMessage(160));
        commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        hostParent = null;
        hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var currentHoistableRoot = null;
function commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            flags & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = currentHoistableRoot;
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        setInitialProperties(currentResource, flags, current);
                                        currentResource[internalInstanceKey] = finishedWork;
                                        markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error(formatProdErrorMessage(468, flags));
                                }
                                currentResource[internalInstanceKey] = finishedWork;
                                markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            null !== current && flags & 4 && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    setTextContent(hoistableRoot, "");
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && (needsFormReset = !0);
            break;
        case 6:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error(formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            tagCaches = null;
            hoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(root.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            currentHoistableRoot = hoistableRoot;
            commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            currentHoistableRoot = flags;
            break;
        case 12:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            break;
        case 31:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            recursivelyTraverseMutationEffects(root, finishedWork);
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? hideOrUnhideDehydratedBoundary(instance, !0) : hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork);
    }
}
function commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if (isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error(formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && (setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error(formatProdErrorMessage(161));
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                safelyDetachRef(finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && releaseCache(previousCache));
}
function commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && releaseCache(current));
}
function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var suspenseyCommitFlag = 8192;
function recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(suspendedState, currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, deletions, deletions.return);
                recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== nextEffect;){
        var fiber = nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
            cache = nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            detachFiberAfterEffects(cache);
            if (cache === fiber) {
                nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                break a;
            }
            nextEffect = returnFiber;
        }
    }
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return readContext(CacheContext).controller.signal;
    }
}, PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, globalMostRecentTransitionTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
function requestUpdateLane() {
    return 0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes ? workInProgressRootRenderLanes & -workInProgressRootRenderLanes : null !== ReactSharedInternals.T ? requestTransitionLane() : resolveUpdatePriority();
}
function requestDeferredLane() {
    if (0 === workInProgressDeferredLane) {
        if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
            var lane = nextTransitionDeferredLane;
            nextTransitionDeferredLane <<= 1;
            0 === (nextTransitionDeferredLane & 3932160) && (nextTransitionDeferredLane = 262144);
            workInProgressDeferredLane = lane;
        } else workInProgressDeferredLane = 536870912;
    }
    lane = suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return workInProgressDeferredLane;
}
function scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === workInProgressRoot && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    markRootUpdated$1(root, lane);
    if (0 === (executionContext & 2) || root !== workInProgressRoot) root === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
}
function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && (prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = workInProgressRootRecoverableErrors;
                            workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = renderWasConcurrent : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                prepareFreshStack(root$jscomp$0, 0);
                markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error(formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error(formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = globalMostRecentFallbackTime + 300 - now(), 10 < exitStatus)) {
                    markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = scheduleTimeout(commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                commitRootWhenReady(shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    ensureRootIsScheduled(root$jscomp$0);
}
function commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: noop$1
        };
        accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? globalMostRecentFallbackTime - now() : (lanes & 4194048) === lanes ? globalMostRecentTransitionTime - now() : 0;
        timeoutOffset = waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset(commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~workInProgressRootPingedLanes;
    suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function flushSyncWork$1() {
    return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function resetWorkInProgressStack() {
    if (null !== workInProgress) {
        if (0 === workInProgressSuspendedReason) var interruptedWork = workInProgress.return;
        else interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber$1 = null, resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
        for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        workInProgress = null;
    }
}
function prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    pendingEffectsLanes = 0;
    resetWorkInProgressStack();
    workInProgressRoot = root;
    workInProgress = timeoutHandle = createWorkInProgress(root.current, null);
    workInProgressRootRenderLanes = lanes;
    workInProgressSuspendedReason = 0;
    workInProgressThrownValue = null;
    workInProgressRootDidSkipSuspendedSiblings = !1;
    workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    workInProgressRootDidAttachPingListener = !1;
    workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
    workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
    workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    entangledRenderLanes = lanes;
    finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function handleThrow(root, thrownValue) {
    currentlyRenderingFiber = null;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    workInProgressThrownValue = thrownValue;
    null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current)));
}
function shouldRemainOnPreviousScreen() {
    var handler = suspenseHandlerStackCursor.current;
    return null === handler ? !0 : (workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null === shellBoundary ? !0 : !1 : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : !1;
}
function pushDispatcher() {
    var prevDispatcher = ReactSharedInternals.H;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
}
function pushAsyncDispatcher() {
    var prevAsyncDispatcher = ReactSharedInternals.A;
    ReactSharedInternals.A = DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function renderDidSuspendDelayIfPossible() {
    workInProgressRootExitStatus = 4;
    workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
    0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
}
function renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) workInProgressTransitions = null, prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = workInProgressRootExitStatus;
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
            switch(workInProgressSuspendedReason){
                case 8:
                    resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = workInProgressSuspendedReason;
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        workLoopSync();
        exitStatus = workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    lastContextDependency = currentlyRenderingFiber$1 = null;
    executionContext = prevExecutionContext;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
    return exitStatus;
}
function workLoopSync() {
    for(; null !== workInProgress;)performUnitOfWork(workInProgress);
}
function renderRootConcurrent(root, lanes) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now() + 500, prepareFreshStack(root, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            lanes = workInProgress;
            var thrownValue = workInProgressThrownValue;
            b: switch(workInProgressSuspendedReason){
                case 1:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if (isThenableResolved(thrownValue)) {
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== workInProgressSuspendedReason && 9 !== workInProgressSuspendedReason || workInProgressRoot !== root || (workInProgressSuspendedReason = 7);
                        ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch(workInProgress.tag){
                        case 26:
                            resource = workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = workInProgress;
                            if (resource ? preloadResource(resource) : hostFiber.stateNode.complete) {
                                workInProgressSuspendedReason = 0;
                                workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                }
                                break b;
                            }
                    }
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    resetWorkInProgressStack();
                    workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error(formatProdErrorMessage(462));
            }
        }
        workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        handleThrow(root, thrownValue$167);
    }
    while (1);
    lastContextDependency = currentlyRenderingFiber$1 = null;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    executionContext = prevExecutionContext;
    if (null !== workInProgress) return 0;
    workInProgressRoot = null;
    workInProgressRootRenderLanes = 0;
    finishQueueingConcurrentUpdates();
    return workInProgressRootExitStatus;
}
function workLoopConcurrentByScheduler() {
    for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
}
function performUnitOfWork(unitOfWork) {
    var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, workInProgressRootRenderLanes);
            break;
        case 11:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, workInProgressRootRenderLanes);
            break;
        case 5:
            resetHooksOnUnwind(next);
        default:
            unwindInterruptedWork(current, next), next = workInProgress = resetWorkInProgress(next, entangledRenderLanes), next = beginWork(current, next, entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    lastContextDependency = currentlyRenderingFiber$1 = null;
    resetHooksOnUnwind(unitOfWork);
    thenableState$1 = null;
    thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
            workInProgressRootExitStatus = 1;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw workInProgress = returnFiber, error;
        workInProgressRootExitStatus = 1;
        logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
        workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if (isHydrating || 1 === suspendedReason) root = !0;
        else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
        else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        unwindUnitOfWork(unitOfWork, root);
    } else completeUnitOfWork(unitOfWork);
}
function completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = completeWork(completedWork.alternate, completedWork, entangledRenderLanes);
        if (null !== next) {
            workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            workInProgress = completedWork;
            return;
        }
        workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
}
function unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            workInProgress = unitOfWork;
            return;
        }
        workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    workInProgressRootExitStatus = 6;
    workInProgress = null;
}
function commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do flushPendingEffects();
    while (0 !== pendingEffectsStatus);
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error(formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
        markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
        pendingFinishedWork = finishedWork;
        pendingEffectsRoot = root;
        pendingEffectsLanes = lanes;
        pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        pendingPassiveTransitions = transitions;
        pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
            flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            transitions = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            spawnedLane = executionContext;
            executionContext |= 4;
            try {
                commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
            }
        }
        pendingEffectsStatus = 1;
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
    }
}
function flushMutationEffects() {
    if (1 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = selectionInformation, curFocusedElem = getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                _enabled = !!eventsEnabled;
                selectionInformation = eventsEnabled = null;
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        pendingEffectsStatus = 2;
    }
}
function flushLayoutEffects() {
    if (2 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        pendingEffectsStatus = 3;
    }
}
function flushSpawnedWork() {
    if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        requestPaint();
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, recoverableErrors = pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? pendingEffectsStatus = 5 : (pendingEffectsStatus = 0, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
        lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
            injectedHook.onCommitFiberRoot(rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = ReactSharedInternals.T;
            remainingLanes = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                ReactSharedInternals.T = finishedWork, ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
        ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root) : nestedUpdateCount = 0;
        flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
}
function flushPendingEffects() {
    flushMutationEffects();
    flushLayoutEffects();
    flushSpawnedWork();
    return flushPassiveEffects();
}
function flushPassiveEffects() {
    if (5 !== pendingEffectsStatus) return !1;
    var root = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
    pendingEffectsRemainingLanes = 0;
    var renderPriority = lanesToEventPriority(pendingEffectsLanes), prevTransition = ReactSharedInternals.T, previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        ReactSharedInternals.T = null;
        renderPriority = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root$jscomp$0 = pendingEffectsRoot, lanes = pendingEffectsLanes;
        pendingEffectsStatus = 0;
        pendingFinishedWork = pendingEffectsRoot = null;
        pendingEffectsLanes = 0;
        if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(331));
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        commitPassiveUnmountOnFiber(root$jscomp$0.current);
        commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        executionContext = prevExecutionContext;
        flushSyncWorkAcrossRoots_impl(0, !1);
        if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
            injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition, releaseRootPooledCache(root, remainingLanes);
    }
}
function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
}
function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                error = createClassErrorUpdate(2);
                instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) && prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
    ensureRootIsScheduled(root);
}
function retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = claimNextRetryLane());
    boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
}
function retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error(formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function scheduleCallback$1(priorityLevel, callback) {
    return scheduleCallback$3(priorityLevel, callback);
}
var firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0;
function ensureRootIsScheduled(root) {
    root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
    mightHavePendingSyncWork = !0;
    didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateRootScheduleTask());
}
function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!isFlushingWork && mightHavePendingSyncWork) {
        isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(root$170, root$170 === workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        isFlushingWork = !1;
    }
}
function processRootScheduleInImmediateTask() {
    processRootScheduleInMicrotask();
}
function processRootScheduleInMicrotask() {
    mightHavePendingSyncWork = didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== currentEventTransitionLane && shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane);
    for(var currentTime = now(), prev = null, root = firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus || flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
}
function scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = workInProgressRoot;
    suspendedLanes = workInProgressRootRenderLanes;
    suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && cancelCallback$1(pingedLanes);
        switch(lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = IdlePriority;
                break;
            default:
                suspendedLanes = NormalPriority$1;
        }
        pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if (flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    scheduleTaskForRootDuringMicrotask(root, now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function performSyncWorkOnRoot(root, lanes) {
    if (flushPendingEffects()) return null;
    performWorkOnRoot(root, lanes, !0);
}
function scheduleImmediateRootScheduleTask() {
    scheduleMicrotask(function() {
        0 !== (executionContext & 6) ? scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask) : processRootScheduleInMicrotask();
    });
}
function requestTransitionLane() {
    if (0 === currentEventTransitionLane) {
        var actionScopeLane = currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = nextTransitionUpdateLane, nextTransitionUpdateLane <<= 1, 0 === (nextTransitionUpdateLane & 261888) && (nextTransitionUpdateLane = 256));
        currentEventTransitionLane = actionScopeLane;
    }
    return currentEventTransitionLane;
}
function coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : sanitizeURL("" + actionProp);
}
function createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = coerceFormActionProp((nativeEventTarget[internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== currentEventTransitionLane) {
                                var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var i$jscomp$inline_1577 = 0; i$jscomp$inline_1577 < simpleEventPluginEvents.length; i$jscomp$inline_1577++){
    var eventName$jscomp$inline_1578 = simpleEventPluginEvents[i$jscomp$inline_1577], domEventName$jscomp$inline_1579 = eventName$jscomp$inline_1578.toLowerCase(), capitalizedEvent$jscomp$inline_1580 = eventName$jscomp$inline_1578[0].toUpperCase() + eventName$jscomp$inline_1578.slice(1);
    registerSimpleEvent(domEventName$jscomp$inline_1579, "on" + capitalizedEvent$jscomp$inline_1580);
}
registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
registerSimpleEvent(ANIMATION_START, "onAnimationStart");
registerSimpleEvent("dblclick", "onDoubleClick");
registerSimpleEvent("focusin", "onFocus");
registerSimpleEvent("focusout", "onBlur");
registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
registerSimpleEvent(TRANSITION_START, "onTransitionStart");
registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes));
function processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[listeningMarker]) {
        rootContainerElement[listeningMarker] = !0;
        allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, !1, rootContainerElement), listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = !0, listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch(getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = SyntheticTouchEvent;
                        break;
                    case ANIMATION_END:
                    case ANIMATION_ITERATION:
                    case ANIMATION_START:
                        SyntheticEventCtor = SyntheticAnimationEvent;
                        break;
                    case TRANSITION_END:
                        SyntheticEventCtor = SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = getListener(instance, reactEventName), null != _instance && inCapturePhase.push(createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = getTargetInstForChangeEvent;
                else if (isTextInputElement(reactName)) {
                    if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = getTargetInstForInputEventPolyfill;
                        var handleEventFunc = handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
                    break;
                case "focusout":
                    lastSelection = activeElementInst = activeElement = null;
                    break;
                case "mousedown":
                    mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    mouseDown = !1;
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if (skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if (canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = !0)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = getListener(targetFiber, captureName), null != _instance2 && listeners.unshift(createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = getListener(targetFiber, reactName), null != _instance2 && listeners.push(createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function checkForUnmatchedText(serverText, clientText) {
    clientText = normalizeMarkupForTextOrAttribute(clientText);
    return normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && setTextContent(domElement, "" + value);
            break;
        case "className":
            setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(domElement, tag, "formEncType", props.formEncType, props, null), setProp(domElement, tag, "formMethod", props.formMethod, props, null), setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = aliases.get(key) || key, setValueForAttribute(domElement, key, value);
    }
}
function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
            }
    }
}
function setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(formatProdErrorMessage(137, tag));
                    default:
                        setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? updateOptions(domElement, !!hasSrc, tag, !1) : null != props && updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            listenToNonDelegatedEvent("cancel", domElement);
            listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(formatProdErrorMessage(137, tag));
                default:
                    setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? updateOptions(domElement, !!lastProps, tag, !0) : updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && setProp(domElement, tag, value, name, nextProps, type);
            }
            updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error(formatProdErrorMessage(137, tag));
                    break;
                default:
                    setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var eventsEnabled = null, selectionInformation = null;
function getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var currentPopstateTransitionEvent = null;
function shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === currentPopstateTransitionEvent) return !1;
        currentPopstateTransitionEvent = event;
        return !0;
    }
    currentPopstateTransitionEvent = null;
    return !1;
}
var scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
    return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
} : scheduleTimeout;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function isSingletonScope(type) {
    return "head" === type;
}
function clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    retryIfBlockedOn(hydrationInstance);
}
function hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                clearContainerSparingly(node);
                detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var previousHydratableOnEnteringScopedSingleton = null;
function getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function resolveSingletonInstance(type, props, rootContainerInstance) {
    props = getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error(formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error(formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error(formatProdErrorMessage(454));
            return type;
        default:
            throw Error(formatProdErrorMessage(451));
    }
}
function releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    detachDeletedInstance(instance);
}
var preloadPropsMap = new Map(), preconnectsSet = new Set();
function getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: flushSyncWork,
    r: requestFormReset,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function flushSyncWork() {
    var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function requestFormReset(form) {
    var formInst = getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
}
var globalDocument = "undefined" === typeof document ? null : document;
function preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function prefetchDNS(href) {
    previousDispatcher.D(href);
    preconnectAs("dns-prefetch", href, null);
}
function preconnect(href, crossOrigin) {
    previousDispatcher.C(href, crossOrigin);
    preconnectAs("preconnect", href, crossOrigin);
}
function preload(href, as, options) {
    previousDispatcher.L(href, as, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = getStyleKey(href);
                break;
            case "script":
                key = getScriptKey(href);
        }
        preloadPropsMap.has(key) || (href = assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function preloadModule(href, options) {
    previousDispatcher.m(href, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = getScriptKey(href);
        }
        if (!preloadPropsMap.has(key) && (href = assign({
            rel: "modulepreload",
            href: href
        }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector(getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            setInitialProperties(as, "link", href);
            markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function preinitStyle(href, precedence, options) {
    previousDispatcher.S(href, precedence, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                markNodeAsHoistable(link);
                setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function preinitScript(src, options) {
    previousDispatcher.X(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function preinitModuleScript(src, options) {
    previousDispatcher.M(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = rootInstanceStackCursor.current) ? getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error(formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = getStyleKey(pendingProps.href), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = getStyleKey(pendingProps.href);
                var styles$243 = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector(getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, preloadPropsMap.set(type, pendingProps), styles$243 || preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error(formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error(formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = getScriptKey(pendingProps), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error(formatProdErrorMessage(444, type));
    }
}
function getStyleKey(href) {
    return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function stylesheetPropsFromRawProps(rawProps) {
    return assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function getScriptKey(src) {
    return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, markNodeAsHoistable(instance), instance;
            var styleProps = assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            markNodeAsHoistable(instance);
            setInitialProperties(instance, "style", styleProps);
            insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector(getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, markNodeAsHoistable(instance$249), instance$249;
            instance = stylesheetPropsFromRawProps(props);
            (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector(getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = preloadPropsMap.get(instance$249)) instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            markNodeAsHoistable(styleProps);
            setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error(formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var tagCaches = null;
function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === tagCaches) {
        var cache = new Map();
        var caches = tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = stylesheetPropsFromRawProps(props);
            (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var estimatedBytesWithinLimit = 0;
function waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === estimatedBytesWithinLimit && (estimatedBytesWithinLimit = 62500 * estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var precedencesByRoot = null;
function insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, precedencesByRoot = new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
}
function insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var HostTransitionContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: sharedNotPendingObject,
    _currentValue2: sharedNotPendingObject,
    _threadCount: 0
};
function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = createLaneMap(0);
    this.hiddenUpdates = createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function getContextForSubtree(parentComponent) {
    if (!parentComponent) return emptyContextObject;
    parentComponent = emptyContextObject;
    return parentComponent;
}
function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = enqueueUpdate(rootFiber, container, lane);
    null !== element && (scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
}
function markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function markRetryLaneIfNotHydrated(fiber, retryLane) {
    markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
}
function attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
        markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = requestUpdateLane();
        lane = getBumpedLaneForHydrationByLane(lane);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && scheduleUpdateOnFiber(root, fiber, lane);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var _enabled = !0;
function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 2, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 8, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (_enabled) {
        var blockedOn = findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer), clearIfContinuousEvent(domEventName, nativeEvent);
        else if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                ensureRootIsScheduled(fiber);
                                0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now() + 500, flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = enqueueConcurrentRenderForLane(fiber, 2), null !== root && scheduleUpdateOnFiber(root, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = findInstanceBlockingEvent(nativeEvent);
                null === fiber && dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = getEventTarget(nativeEvent);
    return findInstanceBlockingTarget(nativeEvent);
}
var return_targetInst = null;
function findInstanceBlockingTarget(targetNode) {
    return_targetInst = null;
    targetNode = getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    return_targetInst = targetNode;
    return null;
}
function getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch(getCurrentPriorityLevel()){
                case ImmediatePriority:
                    return 2;
                case UserBlockingPriority:
                    return 8;
                case NormalPriority$1:
                case LowPriority:
                    return 32;
                case IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var hasScheduledReplayAttempt = !1, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = new Map(), queuedPointerCaptures = new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    runWithPriority(queuedTarget.priority, function() {
                        attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    runWithPriority(queuedTarget.priority, function() {
                        attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            currentReplayingEvent = null;
        } else return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function replayUnblockedEvents() {
    hasScheduledReplayAttempt = !1;
    null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
    null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
    null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
    queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
    queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
}
function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = !0, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents)));
}
var lastScheduledReplayQueue = null;
function scheduleReplayQueueIfNeeded(formReplayingQueue) {
    lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, function() {
        lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
    null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
    null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
    queuedPointers.forEach(unblock);
    queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn);)attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            scheduleReplayQueueIfNeeded(i);
        }
    }
}
function defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error(formatProdErrorMessage(409));
    var current = root.current, lane = requestUpdateLane();
    updateContainerImpl(current, lane, children, root, null, null);
};
ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        updateContainerImpl(root.current, 2, null, root, null, null);
        flushSyncWork$1();
        container[internalContainerInstanceKey] = null;
    }
};
function ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++);
        queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && attemptExplicitHydrationTarget(target);
    }
};
var isomorphicReactPackageVersion$jscomp$inline_1840 = React.version;
if ("19.2.0" !== isomorphicReactPackageVersion$jscomp$inline_1840) throw Error(formatProdErrorMessage(527, isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.0"));
ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error(formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error(formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: ReactSharedInternals,
    reconcilerVersion: "19.2.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!hook$jscomp$inline_2348.isDisabled && hook$jscomp$inline_2348.supportsFiber) try {
        rendererID = hook$jscomp$inline_2348.inject(internals$jscomp$inline_2347), injectedHook = hook$jscomp$inline_2348;
    } catch (err) {}
}
exports.createRoot = function(container, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
    container[internalContainerInstanceKey] = options.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMRoot(options);
};
exports.hydrateRoot = function(container, initialChildren, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
    initialChildren.context = getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = requestUpdateLane();
    isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    markRootUpdated$1(initialChildren, options);
    ensureRootIsScheduled(initialChildren);
    container[internalContainerInstanceKey] = initialChildren.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMHydrationRoot(initialChildren);
};
exports.version = "19.2.0";

},{"1922f323170c4d96":"5hgp2","c3875707f781aa03":"eGun2","2b5818326f1f024c":"bLJc5"}],"5hgp2":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e6285b476bd633d9");

},{"e6285b476bd633d9":"2rXAY"}],"2rXAY":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
exports.unstable_now = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var localPerformance = performance;
    exports.unstable_now = function() {
        return localPerformance.now();
    };
} else {
    var localDate = Date, initialTime = localDate.now();
    exports.unstable_now = function() {
        return localDate.now() - initialTime;
    };
}
var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, needsPaint = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function advanceTimers(currentTime) {
    for(var timer = peek(timerQueue); null !== timer;){
        if (null === timer.callback) pop(timerQueue);
        else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
        else break;
        timer = peek(timerQueue);
    }
}
function handleTimeout(currentTime) {
    isHostTimeoutScheduled = !1;
    advanceTimers(currentTime);
    if (!isHostCallbackScheduled) {
        if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = peek(timerQueue);
            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
function shouldYieldToHost() {
    return needsPaint ? !0 : exports.unstable_now() - startTime < frameInterval ? !1 : !0;
}
function performWorkUntilDeadline() {
    needsPaint = !1;
    if (isMessageLoopRunning) {
        var currentTime = exports.unstable_now();
        startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                isHostCallbackScheduled = !1;
                isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                isPerformingWork = !0;
                var previousPriorityLevel = currentPriorityLevel;
                try {
                    b: {
                        advanceTimers(currentTime);
                        for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                            var callback = currentTask.callback;
                            if ("function" === typeof callback) {
                                currentTask.callback = null;
                                currentPriorityLevel = currentTask.priorityLevel;
                                var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                currentTime = exports.unstable_now();
                                if ("function" === typeof continuationCallback) {
                                    currentTask.callback = continuationCallback;
                                    advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                currentTask === peek(taskQueue) && pop(taskQueue);
                                advanceTimers(currentTime);
                            } else pop(taskQueue);
                            currentTask = peek(taskQueue);
                        }
                        if (null !== currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = peek(timerQueue);
                            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
        }
    }
}
var schedulePerformWorkUntilDeadline;
if ("function" === typeof localSetImmediate) schedulePerformWorkUntilDeadline = function() {
    localSetImmediate(performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var channel = new MessageChannel(), port = channel.port2;
    channel.port1.onmessage = performWorkUntilDeadline;
    schedulePerformWorkUntilDeadline = function() {
        port.postMessage(null);
    };
} else schedulePerformWorkUntilDeadline = function() {
    localSetTimeout(performWorkUntilDeadline, 0);
};
function requestHostTimeout(callback, ms) {
    taskTimeoutID = localSetTimeout(function() {
        callback(exports.unstable_now());
    }, ms);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(task) {
    task.callback = null;
};
exports.unstable_forceFrameRate = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return currentPriorityLevel;
};
exports.unstable_next = function(eventHandler) {
    switch(currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = currentPriorityLevel;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_requestPaint = function() {
    needsPaint = !0;
};
exports.unstable_runWithPriority = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_scheduleCallback = function(priorityLevel, callback, options) {
    var currentTime = exports.unstable_now();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
exports.unstable_shouldYield = shouldYieldToHost;
exports.unstable_wrapCallback = function(callback) {
    var parentPriorityLevel = currentPriorityLevel;
    return function() {
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
};

},{}],"bLJc5":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("1cbda9445ec2017b");

},{"1cbda9445ec2017b":"bP9ol"}],"bP9ol":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("163b5ee32ae0b2fb");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.2.0";

},{"163b5ee32ae0b2fb":"eGun2"}],"kkFWx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("@tanstack/react-router");
var _auth0 = require("./auth/auth0");
var _routeTree = require("./routeTree");
var _themeProvider = require("./components/theme-provider");
var _spinner = require("./components/ui/spinner");
var _sonner = require("./components/ui/sonner");
// Create a new router instance
const router = (0, _reactRouter.createRouter)({
    routeTree: (0, _routeTree.routeTree),
    defaultPreload: 'intent',
    context: {
        auth: undefined
    }
});
// Clean up on HMR to prevent duplicate router errors
// Note: router.destroy() was removed in newer versions of TanStack Router
// if (module.hot) {
//   module.hot.dispose(() => {
//     router.destroy();
//   });
// }
/**
 * Wrapper for checking Auth state
 * @returns Router | Loader
 */ function InnerApp() {
    const auth = (0, _auth0.useAuth0Context)();
    return auth.isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex h-screen items-center justify-center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {
            className: "size-8"
        })
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.RouterProvider), {
        router: router,
        context: {
            auth
        }
    });
}
function App() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _auth0.Auth0Wrapper), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _themeProvider.ThemeProvider), {
            defaultTheme: "dark",
            storageKey: "ui-theme",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(InnerApp, {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sonner.Toaster), {
                    position: "top-center"
                })
            ]
        })
    });
}
exports.default = App;

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRouter","7T2Zr"],["RouterProvider","tW00h"]],"./auth/auth0":"kS2VE","./routeTree":"5Jnaj","./components/theme-provider":"6OWVF","./components/ui/spinner":"7htqi","./components/ui/sonner":"9ofSQ","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7T2Zr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
var _routerCore = require("@tanstack/router-core");
var _fileRouteJs = require("./fileRoute.js");
const createRouter = (options)=>{
    return new Router(options);
};
class Router extends (0, _routerCore.RouterCore) {
    constructor(options){
        super(options);
    }
}
if (typeof globalThis !== "undefined") {
    globalThis.createFileRoute = (0, _fileRouteJs.createFileRoute);
    globalThis.createLazyFileRoute = (0, _fileRouteJs.createLazyFileRoute);
} else if (typeof window !== "undefined") {
    window.createFileRoute = (0, _fileRouteJs.createFileRoute);
    window.createLazyFileRoute = (0, _fileRouteJs.createLazyFileRoute);
}

},{"@tanstack/router-core":"6JWyW","./fileRoute.js":"dYDdb","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6JWyW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PathParamError", ()=>PathParamError);
parcelHelpers.export(exports, "RouterCore", ()=>RouterCore);
parcelHelpers.export(exports, "SearchParamError", ()=>SearchParamError);
parcelHelpers.export(exports, "defaultSerializeError", ()=>defaultSerializeError);
parcelHelpers.export(exports, "getInitialRouterState", ()=>getInitialRouterState);
parcelHelpers.export(exports, "getLocationChangeInfo", ()=>getLocationChangeInfo);
parcelHelpers.export(exports, "getMatchedRoutes", ()=>getMatchedRoutes);
parcelHelpers.export(exports, "lazyFn", ()=>lazyFn);
parcelHelpers.export(exports, "trailingSlashOptions", ()=>trailingSlashOptions);
var _store = require("@tanstack/store");
var _history = require("@tanstack/history");
var _utilsJs = require("./utils.js");
var _newProcessRouteTreeJs = require("./new-process-route-tree.js");
var _pathJs = require("./path.js");
var _lruCacheJs = require("./lru-cache.js");
var _notFoundJs = require("./not-found.js");
var _scrollRestorationJs = require("./scroll-restoration.js");
var _searchParamsJs = require("./searchParams.js");
var _rootJs = require("./root.js");
var _redirectJs = require("./redirect.js");
var _loadMatchesJs = require("./load-matches.js");
var _rewriteJs = require("./rewrite.js");
function defaultSerializeError(err) {
    if (err instanceof Error) {
        const obj = {
            name: err.name,
            message: err.message
        };
        return obj;
    }
    return {
        data: err
    };
}
const trailingSlashOptions = {
    always: "always",
    never: "never",
    preserve: "preserve"
};
function getLocationChangeInfo(routerState) {
    const fromLocation = routerState.resolvedLocation;
    const toLocation = routerState.location;
    const pathChanged = fromLocation?.pathname !== toLocation.pathname;
    const hrefChanged = fromLocation?.href !== toLocation.href;
    const hashChanged = fromLocation?.hash !== toLocation.hash;
    return {
        fromLocation,
        toLocation,
        pathChanged,
        hrefChanged,
        hashChanged
    };
}
class RouterCore {
    /**
   * @deprecated Use the `createRouter` function instead
   */ constructor(options){
        this.tempLocationKey = `${Math.round(Math.random() * 1e7)}`;
        this.resetNextScroll = true;
        this.shouldViewTransition = void 0;
        this.isViewTransitionTypesSupported = void 0;
        this.subscribers = /* @__PURE__ */ new Set();
        this.isScrollRestoring = false;
        this.isScrollRestorationSetup = false;
        this.startTransition = (fn)=>fn();
        this.update = (newOptions)=>{
            if (newOptions.notFoundRoute) console.warn("The notFoundRoute API is deprecated and will be removed in the next major version. See https://tanstack.com/router/v1/docs/framework/react/guide/not-found-errors#migrating-from-notfoundroute for more info.");
            const prevOptions = this.options;
            const prevBasepath = this.basepath ?? prevOptions?.basepath ?? "/";
            const basepathWasUnset = this.basepath === void 0;
            const prevRewriteOption = prevOptions?.rewrite;
            this.options = {
                ...prevOptions,
                ...newOptions
            };
            this.isServer = this.options.isServer ?? typeof document === "undefined";
            this.pathParamsDecodeCharMap = this.options.pathParamsAllowedCharacters ? new Map(this.options.pathParamsAllowedCharacters.map((char)=>[
                    encodeURIComponent(char),
                    char
                ])) : void 0;
            if (!this.history || this.options.history && this.options.history !== this.history) {
                if (!this.options.history) {
                    if (!this.isServer) this.history = (0, _history.createBrowserHistory)();
                } else this.history = this.options.history;
            }
            this.origin = this.options.origin;
            if (!this.origin) {
                if (!this.isServer && window?.origin && window.origin !== "null") this.origin = window.origin;
                else this.origin = "http://localhost";
            }
            if (this.history) this.updateLatestLocation();
            if (this.options.routeTree !== this.routeTree) {
                this.routeTree = this.options.routeTree;
                this.buildRouteTree();
            }
            if (!this.__store && this.latestLocation) {
                this.__store = new (0, _store.Store)(getInitialRouterState(this.latestLocation), {
                    onUpdate: ()=>{
                        this.__store.state = {
                            ...this.state,
                            cachedMatches: this.state.cachedMatches.filter((d)=>![
                                    "redirected"
                                ].includes(d.status))
                        };
                    }
                });
                (0, _scrollRestorationJs.setupScrollRestoration)(this);
            }
            let needsLocationUpdate = false;
            const nextBasepath = this.options.basepath ?? "/";
            const nextRewriteOption = this.options.rewrite;
            const basepathChanged = basepathWasUnset || prevBasepath !== nextBasepath;
            const rewriteChanged = prevRewriteOption !== nextRewriteOption;
            if (basepathChanged || rewriteChanged) {
                this.basepath = nextBasepath;
                const rewrites = [];
                if ((0, _pathJs.trimPath)(nextBasepath) !== "") rewrites.push((0, _rewriteJs.rewriteBasepath)({
                    basepath: nextBasepath
                }));
                if (nextRewriteOption) rewrites.push(nextRewriteOption);
                this.rewrite = rewrites.length === 0 ? void 0 : rewrites.length === 1 ? rewrites[0] : (0, _rewriteJs.composeRewrites)(rewrites);
                if (this.history) this.updateLatestLocation();
                needsLocationUpdate = true;
            }
            if (needsLocationUpdate && this.__store) this.__store.state = {
                ...this.state,
                location: this.latestLocation
            };
            if (typeof window !== "undefined" && "CSS" in window && typeof window.CSS?.supports === "function") this.isViewTransitionTypesSupported = window.CSS.supports("selector(:active-view-transition-type(a)");
        };
        this.updateLatestLocation = ()=>{
            this.latestLocation = this.parseLocation(this.history.location, this.latestLocation);
        };
        this.buildRouteTree = ()=>{
            const { routesById, routesByPath, processedTree } = (0, _newProcessRouteTreeJs.processRouteTree)(this.routeTree, this.options.caseSensitive, (route, i)=>{
                route.init({
                    originalIndex: i
                });
            });
            if (this.options.routeMasks) (0, _newProcessRouteTreeJs.processRouteMasks)(this.options.routeMasks, processedTree);
            this.routesById = routesById;
            this.routesByPath = routesByPath;
            this.processedTree = processedTree;
            const notFoundRoute = this.options.notFoundRoute;
            if (notFoundRoute) {
                notFoundRoute.init({
                    originalIndex: 99999999999
                });
                this.routesById[notFoundRoute.id] = notFoundRoute;
            }
        };
        this.subscribe = (eventType, fn)=>{
            const listener = {
                eventType,
                fn
            };
            this.subscribers.add(listener);
            return ()=>{
                this.subscribers.delete(listener);
            };
        };
        this.emit = (routerEvent)=>{
            this.subscribers.forEach((listener)=>{
                if (listener.eventType === routerEvent.type) listener.fn(routerEvent);
            });
        };
        this.parseLocation = (locationToParse, previousLocation)=>{
            const parse = ({ href, state })=>{
                const fullUrl = new URL(href, this.origin);
                const url = (0, _rewriteJs.executeRewriteInput)(this.rewrite, fullUrl);
                const parsedSearch = this.options.parseSearch(url.search);
                const searchStr = this.options.stringifySearch(parsedSearch);
                url.search = searchStr;
                const fullPath = url.href.replace(url.origin, "");
                const { pathname, hash } = url;
                return {
                    href: fullPath,
                    publicHref: href,
                    url: url.href,
                    pathname: (0, _utilsJs.decodePath)(pathname),
                    searchStr,
                    search: (0, _utilsJs.replaceEqualDeep)(previousLocation?.search, parsedSearch),
                    hash: hash.split("#").reverse()[0] ?? "",
                    state: (0, _utilsJs.replaceEqualDeep)(previousLocation?.state, state)
                };
            };
            const location = parse(locationToParse);
            const { __tempLocation, __tempKey } = location.state;
            if (__tempLocation && (!__tempKey || __tempKey === this.tempLocationKey)) {
                const parsedTempLocation = parse(__tempLocation);
                parsedTempLocation.state.key = location.state.key;
                parsedTempLocation.state.__TSR_key = location.state.__TSR_key;
                delete parsedTempLocation.state.__tempLocation;
                return {
                    ...parsedTempLocation,
                    maskedLocation: location
                };
            }
            return location;
        };
        this.resolvePathCache = (0, _lruCacheJs.createLRUCache)(1e3);
        this.resolvePathWithBase = (from, path)=>{
            const resolvedPath = (0, _pathJs.resolvePath)({
                base: from,
                to: (0, _pathJs.cleanPath)(path),
                trailingSlash: this.options.trailingSlash,
                cache: this.resolvePathCache
            });
            return resolvedPath;
        };
        this.matchRoutes = (pathnameOrNext, locationSearchOrOpts, opts)=>{
            if (typeof pathnameOrNext === "string") return this.matchRoutesInternal({
                pathname: pathnameOrNext,
                search: locationSearchOrOpts
            }, opts);
            return this.matchRoutesInternal(pathnameOrNext, locationSearchOrOpts);
        };
        this.getMatchedRoutes = (pathname)=>{
            return getMatchedRoutes({
                pathname,
                routesById: this.routesById,
                processedTree: this.processedTree
            });
        };
        this.cancelMatch = (id)=>{
            const match = this.getMatch(id);
            if (!match) return;
            match.abortController.abort();
            clearTimeout(match._nonReactive.pendingTimeout);
            match._nonReactive.pendingTimeout = void 0;
        };
        this.cancelMatches = ()=>{
            const currentPendingMatches = this.state.matches.filter((match)=>match.status === "pending");
            const currentLoadingMatches = this.state.matches.filter((match)=>match.isFetching === "loader");
            const matchesToCancelArray = /* @__PURE__ */ new Set([
                ...this.state.pendingMatches ?? [],
                ...currentPendingMatches,
                ...currentLoadingMatches
            ]);
            matchesToCancelArray.forEach((match)=>{
                this.cancelMatch(match.id);
            });
        };
        this.buildLocation = (opts)=>{
            const build = (dest = {})=>{
                const currentLocation = dest._fromLocation || this.pendingBuiltLocation || this.latestLocation;
                const allCurrentLocationMatches = this.matchRoutes(currentLocation, {
                    _buildLocation: true
                });
                const lastMatch = (0, _utilsJs.last)(allCurrentLocationMatches);
                dest.from;
                const defaultedFromPath = dest.unsafeRelative === "path" ? currentLocation.pathname : dest.from ?? lastMatch.fullPath;
                const fromPath = this.resolvePathWithBase(defaultedFromPath, ".");
                const fromSearch = lastMatch.search;
                const fromParams = {
                    ...lastMatch.params
                };
                const nextTo = dest.to ? this.resolvePathWithBase(fromPath, `${dest.to}`) : this.resolvePathWithBase(fromPath, ".");
                const nextParams = dest.params === false || dest.params === null ? {} : (dest.params ?? true) === true ? fromParams : Object.assign(fromParams, (0, _utilsJs.functionalUpdate)(dest.params, fromParams));
                const interpolatedNextTo = (0, _pathJs.interpolatePath)({
                    path: nextTo,
                    params: nextParams
                }).interpolatedPath;
                const destRoutes = this.matchRoutes(interpolatedNextTo, void 0, {
                    _buildLocation: true
                }).map((d)=>this.looseRoutesById[d.routeId]);
                if (Object.keys(nextParams).length > 0) for (const route of destRoutes){
                    const fn = route.options.params?.stringify ?? route.options.stringifyParams;
                    if (fn) Object.assign(nextParams, fn(nextParams));
                }
                const nextPathname = opts.leaveParams ? // Use the original template path for interpolation
                // This preserves the original parameter syntax including optional parameters
                nextTo : (0, _utilsJs.decodePath)((0, _pathJs.interpolatePath)({
                    path: nextTo,
                    params: nextParams,
                    decodeCharMap: this.pathParamsDecodeCharMap
                }).interpolatedPath);
                let nextSearch = fromSearch;
                if (opts._includeValidateSearch && this.options.search?.strict) {
                    const validatedSearch = {};
                    destRoutes.forEach((route)=>{
                        if (route.options.validateSearch) try {
                            Object.assign(validatedSearch, validateSearch(route.options.validateSearch, {
                                ...validatedSearch,
                                ...nextSearch
                            }));
                        } catch  {}
                    });
                    nextSearch = validatedSearch;
                }
                nextSearch = applySearchMiddleware({
                    search: nextSearch,
                    dest,
                    destRoutes,
                    _includeValidateSearch: opts._includeValidateSearch
                });
                nextSearch = (0, _utilsJs.replaceEqualDeep)(fromSearch, nextSearch);
                const searchStr = this.options.stringifySearch(nextSearch);
                const hash = dest.hash === true ? currentLocation.hash : dest.hash ? (0, _utilsJs.functionalUpdate)(dest.hash, currentLocation.hash) : void 0;
                const hashStr = hash ? `#${hash}` : "";
                let nextState = dest.state === true ? currentLocation.state : dest.state ? (0, _utilsJs.functionalUpdate)(dest.state, currentLocation.state) : {};
                nextState = (0, _utilsJs.replaceEqualDeep)(currentLocation.state, nextState);
                const fullPath = `${nextPathname}${searchStr}${hashStr}`;
                const url = new URL(fullPath, this.origin);
                const rewrittenUrl = (0, _rewriteJs.executeRewriteOutput)(this.rewrite, url);
                return {
                    publicHref: rewrittenUrl.pathname + rewrittenUrl.search + rewrittenUrl.hash,
                    href: fullPath,
                    url: rewrittenUrl.href,
                    pathname: nextPathname,
                    search: nextSearch,
                    searchStr,
                    state: nextState,
                    hash: hash ?? "",
                    unmaskOnReload: dest.unmaskOnReload
                };
            };
            const buildWithMatches = (dest = {}, maskedDest)=>{
                const next = build(dest);
                let maskedNext = maskedDest ? build(maskedDest) : void 0;
                if (!maskedNext) {
                    const params = {};
                    if (this.options.routeMasks) {
                        const match = (0, _newProcessRouteTreeJs.findFlatMatch)(next.pathname, this.processedTree);
                        if (match) {
                            Object.assign(params, match.params);
                            const { from: _from, ...maskProps } = match.route;
                            maskedDest = {
                                from: opts.from,
                                ...maskProps,
                                params
                            };
                            maskedNext = build(maskedDest);
                        }
                    }
                }
                if (maskedNext) next.maskedLocation = maskedNext;
                return next;
            };
            if (opts.mask) return buildWithMatches(opts, {
                from: opts.from,
                ...opts.mask
            });
            return buildWithMatches(opts);
        };
        this.commitLocation = ({ viewTransition, ignoreBlocker, ...next })=>{
            const isSameState = ()=>{
                const ignoredProps = [
                    "key",
                    // TODO: Remove in v2 - use __TSR_key instead
                    "__TSR_key",
                    "__TSR_index",
                    "__hashScrollIntoViewOptions"
                ];
                ignoredProps.forEach((prop)=>{
                    next.state[prop] = this.latestLocation.state[prop];
                });
                const isEqual = (0, _utilsJs.deepEqual)(next.state, this.latestLocation.state);
                ignoredProps.forEach((prop)=>{
                    delete next.state[prop];
                });
                return isEqual;
            };
            const isSameUrl = (0, _pathJs.trimPathRight)(this.latestLocation.href) === (0, _pathJs.trimPathRight)(next.href);
            const previousCommitPromise = this.commitLocationPromise;
            this.commitLocationPromise = (0, _utilsJs.createControlledPromise)(()=>{
                previousCommitPromise?.resolve();
            });
            if (isSameUrl && isSameState()) this.load();
            else {
                let { maskedLocation, hashScrollIntoView, ...nextHistory } = next;
                if (maskedLocation) {
                    nextHistory = {
                        ...maskedLocation,
                        state: {
                            ...maskedLocation.state,
                            __tempKey: void 0,
                            __tempLocation: {
                                ...nextHistory,
                                search: nextHistory.searchStr,
                                state: {
                                    ...nextHistory.state,
                                    __tempKey: void 0,
                                    __tempLocation: void 0,
                                    __TSR_key: void 0,
                                    key: void 0
                                }
                            }
                        }
                    };
                    if (nextHistory.unmaskOnReload ?? this.options.unmaskOnReload ?? false) nextHistory.state.__tempKey = this.tempLocationKey;
                }
                nextHistory.state.__hashScrollIntoViewOptions = hashScrollIntoView ?? this.options.defaultHashScrollIntoView ?? true;
                this.shouldViewTransition = viewTransition;
                this.history[next.replace ? "replace" : "push"](nextHistory.publicHref, nextHistory.state, {
                    ignoreBlocker
                });
            }
            this.resetNextScroll = next.resetScroll ?? true;
            if (!this.history.subscribers.size) this.load();
            return this.commitLocationPromise;
        };
        this.buildAndCommitLocation = ({ replace, resetScroll, hashScrollIntoView, viewTransition, ignoreBlocker, href, ...rest } = {})=>{
            if (href) {
                const currentIndex = this.history.location.state.__TSR_index;
                const parsed = (0, _history.parseHref)(href, {
                    __TSR_index: replace ? currentIndex : currentIndex + 1
                });
                rest.to = parsed.pathname;
                rest.search = this.options.parseSearch(parsed.search);
                rest.hash = parsed.hash.slice(1);
            }
            const location = this.buildLocation({
                ...rest,
                _includeValidateSearch: true
            });
            this.pendingBuiltLocation = location;
            const commitPromise = this.commitLocation({
                ...location,
                viewTransition,
                replace,
                resetScroll,
                hashScrollIntoView,
                ignoreBlocker
            });
            Promise.resolve().then(()=>{
                if (this.pendingBuiltLocation === location) this.pendingBuiltLocation = void 0;
            });
            return commitPromise;
        };
        this.navigate = async ({ to, reloadDocument, href, ...rest })=>{
            if (!reloadDocument && href) try {
                new URL(`${href}`);
                reloadDocument = true;
            } catch  {}
            if (reloadDocument) {
                if (!href) {
                    const location = this.buildLocation({
                        to,
                        ...rest
                    });
                    href = location.url;
                }
                if (!rest.ignoreBlocker) {
                    const historyWithBlockers = this.history;
                    const blockers = historyWithBlockers.getBlockers?.() ?? [];
                    for (const blocker of blockers)if (blocker?.blockerFn) {
                        const shouldBlock = await blocker.blockerFn({
                            currentLocation: this.latestLocation,
                            nextLocation: this.latestLocation,
                            // External URLs don't have a next location in our router
                            action: "PUSH"
                        });
                        if (shouldBlock) return Promise.resolve();
                    }
                }
                if (rest.replace) window.location.replace(href);
                else window.location.href = href;
                return Promise.resolve();
            }
            return this.buildAndCommitLocation({
                ...rest,
                href,
                to,
                _isNavigate: true
            });
        };
        this.beforeLoad = ()=>{
            this.cancelMatches();
            this.updateLatestLocation();
            if (this.isServer) {
                const nextLocation = this.buildLocation({
                    to: this.latestLocation.pathname,
                    search: true,
                    params: true,
                    hash: true,
                    state: true,
                    _includeValidateSearch: true
                });
                const normalizeUrl = (url)=>{
                    try {
                        return encodeURI(decodeURI(url));
                    } catch  {
                        return url;
                    }
                };
                if ((0, _pathJs.trimPath)(normalizeUrl(this.latestLocation.href)) !== (0, _pathJs.trimPath)(normalizeUrl(nextLocation.href))) {
                    let href = nextLocation.url;
                    if (this.origin && href.startsWith(this.origin)) href = href.replace(this.origin, "") || "/";
                    throw (0, _redirectJs.redirect)({
                        href
                    });
                }
            }
            const pendingMatches = this.matchRoutes(this.latestLocation);
            this.__store.setState((s)=>({
                    ...s,
                    status: "pending",
                    statusCode: 200,
                    isLoading: true,
                    location: this.latestLocation,
                    pendingMatches,
                    // If a cached moved to pendingMatches, remove it from cachedMatches
                    cachedMatches: s.cachedMatches.filter((d)=>!pendingMatches.some((e)=>e.id === d.id))
                }));
        };
        this.load = async (opts)=>{
            let redirect2;
            let notFound;
            let loadPromise;
            loadPromise = new Promise((resolve)=>{
                this.startTransition(async ()=>{
                    try {
                        this.beforeLoad();
                        const next = this.latestLocation;
                        const prevLocation = this.state.resolvedLocation;
                        if (!this.state.redirect) this.emit({
                            type: "onBeforeNavigate",
                            ...getLocationChangeInfo({
                                resolvedLocation: prevLocation,
                                location: next
                            })
                        });
                        this.emit({
                            type: "onBeforeLoad",
                            ...getLocationChangeInfo({
                                resolvedLocation: prevLocation,
                                location: next
                            })
                        });
                        await (0, _loadMatchesJs.loadMatches)({
                            router: this,
                            sync: opts?.sync,
                            matches: this.state.pendingMatches,
                            location: next,
                            updateMatch: this.updateMatch,
                            // eslint-disable-next-line @typescript-eslint/require-await
                            onReady: async ()=>{
                                this.startTransition(()=>{
                                    this.startViewTransition(async ()=>{
                                        let exitingMatches = [];
                                        let enteringMatches = [];
                                        let stayingMatches = [];
                                        (0, _store.batch)(()=>{
                                            this.__store.setState((s)=>{
                                                const previousMatches = s.matches;
                                                const newMatches = s.pendingMatches || s.matches;
                                                exitingMatches = previousMatches.filter((match)=>!newMatches.some((d)=>d.id === match.id));
                                                enteringMatches = newMatches.filter((match)=>!previousMatches.some((d)=>d.id === match.id));
                                                stayingMatches = newMatches.filter((match)=>previousMatches.some((d)=>d.id === match.id));
                                                return {
                                                    ...s,
                                                    isLoading: false,
                                                    loadedAt: Date.now(),
                                                    matches: newMatches,
                                                    pendingMatches: void 0,
                                                    /**
                           * When committing new matches, cache any exiting matches that are still usable.
                           * Routes that resolved with `status: 'error'` or `status: 'notFound'` are
                           * deliberately excluded from `cachedMatches` so that subsequent invalidations
                           * or reloads re-run their loaders instead of reusing the failed/not-found data.
                           */ cachedMatches: [
                                                        ...s.cachedMatches,
                                                        ...exitingMatches.filter((d)=>d.status !== "error" && d.status !== "notFound")
                                                    ]
                                                };
                                            });
                                            this.clearExpiredCache();
                                        });
                                        [
                                            [
                                                exitingMatches,
                                                "onLeave"
                                            ],
                                            [
                                                enteringMatches,
                                                "onEnter"
                                            ],
                                            [
                                                stayingMatches,
                                                "onStay"
                                            ]
                                        ].forEach(([matches, hook])=>{
                                            matches.forEach((match)=>{
                                                this.looseRoutesById[match.routeId].options[hook]?.(match);
                                            });
                                        });
                                    });
                                });
                            }
                        });
                    } catch (err) {
                        if ((0, _redirectJs.isRedirect)(err)) {
                            redirect2 = err;
                            if (!this.isServer) this.navigate({
                                ...redirect2.options,
                                replace: true,
                                ignoreBlocker: true
                            });
                        } else if ((0, _notFoundJs.isNotFound)(err)) notFound = err;
                        this.__store.setState((s)=>({
                                ...s,
                                statusCode: redirect2 ? redirect2.status : notFound ? 404 : s.matches.some((d)=>d.status === "error") ? 500 : 200,
                                redirect: redirect2
                            }));
                    }
                    if (this.latestLoadPromise === loadPromise) {
                        this.commitLocationPromise?.resolve();
                        this.latestLoadPromise = void 0;
                        this.commitLocationPromise = void 0;
                    }
                    resolve();
                });
            });
            this.latestLoadPromise = loadPromise;
            await loadPromise;
            while(this.latestLoadPromise && loadPromise !== this.latestLoadPromise)await this.latestLoadPromise;
            let newStatusCode = void 0;
            if (this.hasNotFoundMatch()) newStatusCode = 404;
            else if (this.__store.state.matches.some((d)=>d.status === "error")) newStatusCode = 500;
            if (newStatusCode !== void 0) this.__store.setState((s)=>({
                    ...s,
                    statusCode: newStatusCode
                }));
        };
        this.startViewTransition = (fn)=>{
            const shouldViewTransition = this.shouldViewTransition ?? this.options.defaultViewTransition;
            delete this.shouldViewTransition;
            if (shouldViewTransition && typeof document !== "undefined" && "startViewTransition" in document && typeof document.startViewTransition === "function") {
                let startViewTransitionParams;
                if (typeof shouldViewTransition === "object" && this.isViewTransitionTypesSupported) {
                    const next = this.latestLocation;
                    const prevLocation = this.state.resolvedLocation;
                    const resolvedViewTransitionTypes = typeof shouldViewTransition.types === "function" ? shouldViewTransition.types(getLocationChangeInfo({
                        resolvedLocation: prevLocation,
                        location: next
                    })) : shouldViewTransition.types;
                    if (resolvedViewTransitionTypes === false) {
                        fn();
                        return;
                    }
                    startViewTransitionParams = {
                        update: fn,
                        types: resolvedViewTransitionTypes
                    };
                } else startViewTransitionParams = fn;
                document.startViewTransition(startViewTransitionParams);
            } else fn();
        };
        this.updateMatch = (id, updater)=>{
            this.startTransition(()=>{
                const matchesKey = this.state.pendingMatches?.some((d)=>d.id === id) ? "pendingMatches" : this.state.matches.some((d)=>d.id === id) ? "matches" : this.state.cachedMatches.some((d)=>d.id === id) ? "cachedMatches" : "";
                if (matchesKey) this.__store.setState((s)=>({
                        ...s,
                        [matchesKey]: s[matchesKey]?.map((d)=>d.id === id ? updater(d) : d)
                    }));
            });
        };
        this.getMatch = (matchId)=>{
            const findFn = (d)=>d.id === matchId;
            return this.state.cachedMatches.find(findFn) ?? this.state.pendingMatches?.find(findFn) ?? this.state.matches.find(findFn);
        };
        this.invalidate = (opts)=>{
            const invalidate = (d)=>{
                if (opts?.filter?.(d) ?? true) return {
                    ...d,
                    invalid: true,
                    ...opts?.forcePending || d.status === "error" || d.status === "notFound" ? {
                        status: "pending",
                        error: void 0
                    } : void 0
                };
                return d;
            };
            this.__store.setState((s)=>({
                    ...s,
                    matches: s.matches.map(invalidate),
                    cachedMatches: s.cachedMatches.map(invalidate),
                    pendingMatches: s.pendingMatches?.map(invalidate)
                }));
            this.shouldViewTransition = false;
            return this.load({
                sync: opts?.sync
            });
        };
        this.resolveRedirect = (redirect2)=>{
            if (!redirect2.options.href) {
                const location = this.buildLocation(redirect2.options);
                let href = location.url;
                if (this.origin && href.startsWith(this.origin)) href = href.replace(this.origin, "") || "/";
                redirect2.options.href = location.href;
                redirect2.headers.set("Location", href);
            }
            if (!redirect2.headers.get("Location")) redirect2.headers.set("Location", redirect2.options.href);
            return redirect2;
        };
        this.clearCache = (opts)=>{
            const filter = opts?.filter;
            if (filter !== void 0) this.__store.setState((s)=>{
                return {
                    ...s,
                    cachedMatches: s.cachedMatches.filter((m)=>!filter(m))
                };
            });
            else this.__store.setState((s)=>{
                return {
                    ...s,
                    cachedMatches: []
                };
            });
        };
        this.clearExpiredCache = ()=>{
            const filter = (d)=>{
                const route = this.looseRoutesById[d.routeId];
                if (!route.options.loader) return true;
                const gcTime = (d.preload ? route.options.preloadGcTime ?? this.options.defaultPreloadGcTime : route.options.gcTime ?? this.options.defaultGcTime) ?? 300000;
                const isError = d.status === "error";
                if (isError) return true;
                const gcEligible = Date.now() - d.updatedAt >= gcTime;
                return gcEligible;
            };
            this.clearCache({
                filter
            });
        };
        this.loadRouteChunk = (0, _loadMatchesJs.loadRouteChunk);
        this.preloadRoute = async (opts)=>{
            const next = this.buildLocation(opts);
            let matches = this.matchRoutes(next, {
                throwOnError: true,
                preload: true,
                dest: opts
            });
            const activeMatchIds = new Set([
                ...this.state.matches,
                ...this.state.pendingMatches ?? []
            ].map((d)=>d.id));
            const loadedMatchIds = /* @__PURE__ */ new Set([
                ...activeMatchIds,
                ...this.state.cachedMatches.map((d)=>d.id)
            ]);
            (0, _store.batch)(()=>{
                matches.forEach((match)=>{
                    if (!loadedMatchIds.has(match.id)) this.__store.setState((s)=>({
                            ...s,
                            cachedMatches: [
                                ...s.cachedMatches,
                                match
                            ]
                        }));
                });
            });
            try {
                matches = await (0, _loadMatchesJs.loadMatches)({
                    router: this,
                    matches,
                    location: next,
                    preload: true,
                    updateMatch: (id, updater)=>{
                        if (activeMatchIds.has(id)) matches = matches.map((d)=>d.id === id ? updater(d) : d);
                        else this.updateMatch(id, updater);
                    }
                });
                return matches;
            } catch (err) {
                if ((0, _redirectJs.isRedirect)(err)) {
                    if (err.options.reloadDocument) return void 0;
                    return await this.preloadRoute({
                        ...err.options,
                        _fromLocation: next
                    });
                }
                if (!(0, _notFoundJs.isNotFound)(err)) console.error(err);
                return void 0;
            }
        };
        this.matchRoute = (location, opts)=>{
            const matchLocation = {
                ...location,
                to: location.to ? this.resolvePathWithBase(location.from || "", location.to) : void 0,
                params: location.params || {},
                leaveParams: true
            };
            const next = this.buildLocation(matchLocation);
            if (opts?.pending && this.state.status !== "pending") return false;
            const pending = opts?.pending === void 0 ? !this.state.isLoading : opts.pending;
            const baseLocation = pending ? this.latestLocation : this.state.resolvedLocation || this.state.location;
            const match = (0, _newProcessRouteTreeJs.findSingleMatch)(next.pathname, opts?.caseSensitive ?? false, opts?.fuzzy ?? false, baseLocation.pathname, this.processedTree);
            if (!match) return false;
            if (location.params) {
                if (!(0, _utilsJs.deepEqual)(match.params, location.params, {
                    partial: true
                })) return false;
            }
            if (opts?.includeSearch ?? true) return (0, _utilsJs.deepEqual)(baseLocation.search, next.search, {
                partial: true
            }) ? match.params : false;
            return match.params;
        };
        this.hasNotFoundMatch = ()=>{
            return this.__store.state.matches.some((d)=>d.status === "notFound" || d.globalNotFound);
        };
        this.update({
            defaultPreloadDelay: 50,
            defaultPendingMs: 1e3,
            defaultPendingMinMs: 500,
            context: void 0,
            ...options,
            caseSensitive: options.caseSensitive ?? false,
            notFoundMode: options.notFoundMode ?? "fuzzy",
            stringifySearch: options.stringifySearch ?? (0, _searchParamsJs.defaultStringifySearch),
            parseSearch: options.parseSearch ?? (0, _searchParamsJs.defaultParseSearch)
        });
        if (typeof document !== "undefined") self.__TSR_ROUTER__ = this;
    }
    isShell() {
        return !!this.options.isShell;
    }
    isPrerendering() {
        return !!this.options.isPrerendering;
    }
    get state() {
        return this.__store.state;
    }
    get looseRoutesById() {
        return this.routesById;
    }
    matchRoutesInternal(next, opts) {
        const matchedRoutesResult = this.getMatchedRoutes(next.pathname);
        const { foundRoute, routeParams } = matchedRoutesResult;
        let { matchedRoutes } = matchedRoutesResult;
        let isGlobalNotFound = false;
        if (// If we found a route, and it's not an index route and we have left over path
        foundRoute ? foundRoute.path !== "/" && routeParams["**"] : // Or if we didn't find a route and we have left over path
        (0, _pathJs.trimPathRight)(next.pathname)) {
            if (this.options.notFoundRoute) matchedRoutes = [
                ...matchedRoutes,
                this.options.notFoundRoute
            ];
            else isGlobalNotFound = true;
        }
        const globalNotFoundRouteId = (()=>{
            if (!isGlobalNotFound) return void 0;
            if (this.options.notFoundMode !== "root") for(let i = matchedRoutes.length - 1; i >= 0; i--){
                const route = matchedRoutes[i];
                if (route.children) return route.id;
            }
            return 0, _rootJs.rootRouteId;
        })();
        const matches = [];
        const getParentContext = (parentMatch)=>{
            const parentMatchId = parentMatch?.id;
            const parentContext = !parentMatchId ? this.options.context ?? void 0 : parentMatch.context ?? this.options.context ?? void 0;
            return parentContext;
        };
        matchedRoutes.forEach((route, index)=>{
            const parentMatch = matches[index - 1];
            const [preMatchSearch, strictMatchSearch, searchError] = (()=>{
                const parentSearch = parentMatch?.search ?? next.search;
                const parentStrictSearch = parentMatch?._strictSearch ?? void 0;
                try {
                    const strictSearch = validateSearch(route.options.validateSearch, {
                        ...parentSearch
                    }) ?? void 0;
                    return [
                        {
                            ...parentSearch,
                            ...strictSearch
                        },
                        {
                            ...parentStrictSearch,
                            ...strictSearch
                        },
                        void 0
                    ];
                } catch (err) {
                    let searchParamError = err;
                    if (!(err instanceof SearchParamError)) searchParamError = new SearchParamError(err.message, {
                        cause: err
                    });
                    if (opts?.throwOnError) throw searchParamError;
                    return [
                        parentSearch,
                        {},
                        searchParamError
                    ];
                }
            })();
            const loaderDeps = route.options.loaderDeps?.({
                search: preMatchSearch
            }) ?? "";
            const loaderDepsHash = loaderDeps ? JSON.stringify(loaderDeps) : "";
            const { interpolatedPath, usedParams } = (0, _pathJs.interpolatePath)({
                path: route.fullPath,
                params: routeParams,
                decodeCharMap: this.pathParamsDecodeCharMap
            });
            const matchId = // route.id for disambiguation
            route.id + // interpolatedPath for param changes
            interpolatedPath + // explicit deps
            loaderDepsHash;
            const existingMatch = this.getMatch(matchId);
            const previousMatch = this.state.matches.find((d)=>d.routeId === route.id);
            const strictParams = existingMatch?._strictParams ?? usedParams;
            let paramsError = void 0;
            if (!existingMatch) {
                const strictParseParams = route.options.params?.parse ?? route.options.parseParams;
                if (strictParseParams) try {
                    Object.assign(strictParams, strictParseParams(strictParams));
                } catch (err) {
                    if ((0, _notFoundJs.isNotFound)(err) || (0, _redirectJs.isRedirect)(err)) paramsError = err;
                    else paramsError = new PathParamError(err.message, {
                        cause: err
                    });
                    if (opts?.throwOnError) throw paramsError;
                }
            }
            Object.assign(routeParams, strictParams);
            const cause = previousMatch ? "stay" : "enter";
            let match;
            if (existingMatch) match = {
                ...existingMatch,
                cause,
                params: previousMatch ? (0, _utilsJs.replaceEqualDeep)(previousMatch.params, routeParams) : routeParams,
                _strictParams: strictParams,
                search: previousMatch ? (0, _utilsJs.replaceEqualDeep)(previousMatch.search, preMatchSearch) : (0, _utilsJs.replaceEqualDeep)(existingMatch.search, preMatchSearch),
                _strictSearch: strictMatchSearch
            };
            else {
                const status = route.options.loader || route.options.beforeLoad || route.lazyFn || (0, _loadMatchesJs.routeNeedsPreload)(route) ? "pending" : "success";
                match = {
                    id: matchId,
                    ssr: this.isServer ? void 0 : route.options.ssr,
                    index,
                    routeId: route.id,
                    params: previousMatch ? (0, _utilsJs.replaceEqualDeep)(previousMatch.params, routeParams) : routeParams,
                    _strictParams: strictParams,
                    pathname: interpolatedPath,
                    updatedAt: Date.now(),
                    search: previousMatch ? (0, _utilsJs.replaceEqualDeep)(previousMatch.search, preMatchSearch) : preMatchSearch,
                    _strictSearch: strictMatchSearch,
                    searchError: void 0,
                    status,
                    isFetching: false,
                    error: void 0,
                    paramsError,
                    __routeContext: void 0,
                    _nonReactive: {
                        loadPromise: (0, _utilsJs.createControlledPromise)()
                    },
                    __beforeLoadContext: void 0,
                    context: {},
                    abortController: new AbortController(),
                    fetchCount: 0,
                    cause,
                    loaderDeps: previousMatch ? (0, _utilsJs.replaceEqualDeep)(previousMatch.loaderDeps, loaderDeps) : loaderDeps,
                    invalid: false,
                    preload: false,
                    links: void 0,
                    scripts: void 0,
                    headScripts: void 0,
                    meta: void 0,
                    staticData: route.options.staticData || {},
                    fullPath: route.fullPath
                };
            }
            if (!opts?.preload) match.globalNotFound = globalNotFoundRouteId === route.id;
            match.searchError = searchError;
            const parentContext = getParentContext(parentMatch);
            match.context = {
                ...parentContext,
                ...match.__routeContext,
                ...match.__beforeLoadContext
            };
            matches.push(match);
        });
        matches.forEach((match, index)=>{
            const route = this.looseRoutesById[match.routeId];
            const existingMatch = this.getMatch(match.id);
            if (!existingMatch && opts?._buildLocation !== true) {
                const parentMatch = matches[index - 1];
                const parentContext = getParentContext(parentMatch);
                if (route.options.context) {
                    const contextFnContext = {
                        deps: match.loaderDeps,
                        params: match.params,
                        context: parentContext ?? {},
                        location: next,
                        navigate: (opts2)=>this.navigate({
                                ...opts2,
                                _fromLocation: next
                            }),
                        buildLocation: this.buildLocation,
                        cause: match.cause,
                        abortController: match.abortController,
                        preload: !!match.preload,
                        matches
                    };
                    match.__routeContext = route.options.context(contextFnContext) ?? void 0;
                }
                match.context = {
                    ...parentContext,
                    ...match.__routeContext,
                    ...match.__beforeLoadContext
                };
            }
        });
        return matches;
    }
}
class SearchParamError extends Error {
}
class PathParamError extends Error {
}
const normalize = (str)=>str.endsWith("/") && str.length > 1 ? str.slice(0, -1) : str;
function comparePaths(a, b) {
    return normalize(a) === normalize(b);
}
function lazyFn(fn, key) {
    return async (...args)=>{
        const imported = await fn();
        return imported[key || "default"](...args);
    };
}
function getInitialRouterState(location) {
    return {
        loadedAt: 0,
        isLoading: false,
        isTransitioning: false,
        status: "idle",
        resolvedLocation: void 0,
        location,
        matches: [],
        pendingMatches: [],
        cachedMatches: [],
        statusCode: 200
    };
}
function validateSearch(validateSearch2, input) {
    if (validateSearch2 == null) return {};
    if ("~standard" in validateSearch2) {
        const result = validateSearch2["~standard"].validate(input);
        if (result instanceof Promise) throw new SearchParamError("Async validation not supported");
        if (result.issues) throw new SearchParamError(JSON.stringify(result.issues, void 0, 2), {
            cause: result
        });
        return result.value;
    }
    if ("parse" in validateSearch2) return validateSearch2.parse(input);
    if (typeof validateSearch2 === "function") return validateSearch2(input);
    return {};
}
function getMatchedRoutes({ pathname, routesById, processedTree }) {
    const routeParams = {};
    const trimmedPath = (0, _pathJs.trimPathRight)(pathname);
    let foundRoute = void 0;
    const match = (0, _newProcessRouteTreeJs.findRouteMatch)(trimmedPath, processedTree, true);
    if (match) {
        foundRoute = match.route;
        Object.assign(routeParams, match.params);
    }
    const matchedRoutes = match?.branch || [
        routesById[0, _rootJs.rootRouteId]
    ];
    return {
        matchedRoutes,
        routeParams,
        foundRoute
    };
}
function applySearchMiddleware({ search, dest, destRoutes, _includeValidateSearch }) {
    const allMiddlewares = destRoutes.reduce((acc, route)=>{
        const middlewares = [];
        if ("search" in route.options) {
            if (route.options.search?.middlewares) middlewares.push(...route.options.search.middlewares);
        } else if (route.options.preSearchFilters || route.options.postSearchFilters) {
            const legacyMiddleware = ({ search: search2, next })=>{
                let nextSearch = search2;
                if ("preSearchFilters" in route.options && route.options.preSearchFilters) nextSearch = route.options.preSearchFilters.reduce((prev, next2)=>next2(prev), search2);
                const result = next(nextSearch);
                if ("postSearchFilters" in route.options && route.options.postSearchFilters) return route.options.postSearchFilters.reduce((prev, next2)=>next2(prev), result);
                return result;
            };
            middlewares.push(legacyMiddleware);
        }
        if (_includeValidateSearch && route.options.validateSearch) {
            const validate = ({ search: search2, next })=>{
                const result = next(search2);
                try {
                    const validatedSearch = {
                        ...result,
                        ...validateSearch(route.options.validateSearch, result) ?? void 0
                    };
                    return validatedSearch;
                } catch  {
                    return result;
                }
            };
            middlewares.push(validate);
        }
        return acc.concat(middlewares);
    }, []) ?? [];
    const final = ({ search: search2 })=>{
        if (!dest.search) return {};
        if (dest.search === true) return search2;
        return (0, _utilsJs.functionalUpdate)(dest.search, search2);
    };
    allMiddlewares.push(final);
    const applyNext = (index, currentSearch)=>{
        if (index >= allMiddlewares.length) return currentSearch;
        const middleware = allMiddlewares[index];
        const next = (newSearch)=>{
            return applyNext(index + 1, newSearch);
        };
        return middleware({
            search: currentSearch,
            next
        });
    };
    return applyNext(0, search);
}

},{"@tanstack/store":[["batch","3YSNI"],["Store","7VTP2"]],"@tanstack/history":"5kcf5","./utils.js":"eTTD3","./new-process-route-tree.js":"ivpM2","./path.js":"b4w6q","./lru-cache.js":"36hTA","./not-found.js":"aBKKv","./scroll-restoration.js":"ePmPj","./searchParams.js":"e6EqZ","./root.js":"fMO9U","./redirect.js":"jmFxY","./load-matches.js":"aGMJX","./rewrite.js":"a0IRc","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3YSNI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__depsThatHaveWrittenThisTick", ()=>__depsThatHaveWrittenThisTick);
parcelHelpers.export(exports, "__derivedToStore", ()=>__derivedToStore);
parcelHelpers.export(exports, "__flush", ()=>__flush);
parcelHelpers.export(exports, "__storeToDerived", ()=>__storeToDerived);
parcelHelpers.export(exports, "batch", ()=>batch);
const __storeToDerived = /* @__PURE__ */ new WeakMap();
const __derivedToStore = /* @__PURE__ */ new WeakMap();
const __depsThatHaveWrittenThisTick = {
    current: []
};
let __isFlushing = false;
let __batchDepth = 0;
const __pendingUpdates = /* @__PURE__ */ new Set();
const __initialBatchValues = /* @__PURE__ */ new Map();
function __flush_internals(relatedVals) {
    for (const derived of relatedVals){
        if (__depsThatHaveWrittenThisTick.current.includes(derived)) continue;
        __depsThatHaveWrittenThisTick.current.push(derived);
        derived.recompute();
        const stores = __derivedToStore.get(derived);
        if (stores) for (const store of stores){
            const relatedLinkedDerivedVals = __storeToDerived.get(store);
            if (!(relatedLinkedDerivedVals == null ? void 0 : relatedLinkedDerivedVals.length)) continue;
            __flush_internals(relatedLinkedDerivedVals);
        }
    }
}
function __notifyListeners(store) {
    const value = {
        prevVal: store.prevState,
        currentVal: store.state
    };
    for (const listener of store.listeners)listener(value);
}
function __notifyDerivedListeners(derived) {
    const value = {
        prevVal: derived.prevState,
        currentVal: derived.state
    };
    for (const listener of derived.listeners)listener(value);
}
function __flush(store) {
    if (__batchDepth > 0 && !__initialBatchValues.has(store)) __initialBatchValues.set(store, store.prevState);
    __pendingUpdates.add(store);
    if (__batchDepth > 0) return;
    if (__isFlushing) return;
    try {
        __isFlushing = true;
        while(__pendingUpdates.size > 0){
            const stores = Array.from(__pendingUpdates);
            __pendingUpdates.clear();
            for (const store2 of stores){
                const prevState = __initialBatchValues.get(store2) ?? store2.prevState;
                store2.prevState = prevState;
                __notifyListeners(store2);
            }
            for (const store2 of stores){
                const derivedVals = __storeToDerived.get(store2);
                if (!derivedVals) continue;
                __depsThatHaveWrittenThisTick.current.push(store2);
                __flush_internals(derivedVals);
            }
            for (const store2 of stores){
                const derivedVals = __storeToDerived.get(store2);
                if (!derivedVals) continue;
                for (const derived of derivedVals)__notifyDerivedListeners(derived);
            }
        }
    } finally{
        __isFlushing = false;
        __depsThatHaveWrittenThisTick.current = [];
        __initialBatchValues.clear();
    }
}
function batch(fn) {
    __batchDepth++;
    try {
        fn();
    } finally{
        __batchDepth--;
        if (__batchDepth === 0) {
            const pendingUpdateToFlush = __pendingUpdates.values().next().value;
            if (pendingUpdateToFlush) __flush(pendingUpdateToFlush);
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3Iwn0":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"7VTP2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Store", ()=>Store);
var _schedulerJs = require("./scheduler.js");
var _typesJs = require("./types.js");
class Store {
    constructor(initialState, options){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = (listener)=>{
            var _a, _b;
            this.listeners.add(listener);
            const unsub = (_b = (_a = this.options) == null ? void 0 : _a.onSubscribe) == null ? void 0 : _b.call(_a, listener, this);
            return ()=>{
                this.listeners.delete(listener);
                unsub == null || unsub();
            };
        };
        this.prevState = initialState;
        this.state = initialState;
        this.options = options;
    }
    setState(updater) {
        var _a, _b, _c;
        this.prevState = this.state;
        if ((_a = this.options) == null ? void 0 : _a.updateFn) this.state = this.options.updateFn(this.prevState)(updater);
        else if ((0, _typesJs.isUpdaterFunction)(updater)) this.state = updater(this.prevState);
        else this.state = updater;
        (_c = (_b = this.options) == null ? void 0 : _b.onUpdate) == null || _c.call(_b);
        (0, _schedulerJs.__flush)(this);
    }
}

},{"./scheduler.js":"3YSNI","./types.js":"4V4fO","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4V4fO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUpdaterFunction", ()=>isUpdaterFunction);
function isUpdaterFunction(updater) {
    return typeof updater === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5kcf5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createHistory", ()=>createHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "parseHref", ()=>parseHref);
const stateIndexKey = "__TSR_index";
const popStateEvent = "popstate";
const beforeUnloadEvent = "beforeunload";
function createHistory(opts) {
    let location = opts.getLocation();
    const subscribers = /* @__PURE__ */ new Set();
    const notify = (action)=>{
        location = opts.getLocation();
        subscribers.forEach((subscriber)=>subscriber({
                location,
                action
            }));
    };
    const handleIndexChange = (action)=>{
        if (opts.notifyOnIndexChange ?? true) notify(action);
        else location = opts.getLocation();
    };
    const tryNavigation = async ({ task, navigateOpts, ...actionInfo })=>{
        const ignoreBlocker = navigateOpts?.ignoreBlocker ?? false;
        if (ignoreBlocker) {
            task();
            return;
        }
        const blockers = opts.getBlockers?.() ?? [];
        const isPushOrReplace = actionInfo.type === "PUSH" || actionInfo.type === "REPLACE";
        if (typeof document !== "undefined" && blockers.length && isPushOrReplace) for (const blocker of blockers){
            const nextLocation = parseHref(actionInfo.path, actionInfo.state);
            const isBlocked = await blocker.blockerFn({
                currentLocation: location,
                nextLocation,
                action: actionInfo.type
            });
            if (isBlocked) {
                opts.onBlocked?.();
                return;
            }
        }
        task();
    };
    return {
        get location () {
            return location;
        },
        get length () {
            return opts.getLength();
        },
        subscribers,
        subscribe: (cb)=>{
            subscribers.add(cb);
            return ()=>{
                subscribers.delete(cb);
            };
        },
        push: (path, state, navigateOpts)=>{
            const currentIndex = location.state[stateIndexKey];
            state = assignKeyAndIndex(currentIndex + 1, state);
            tryNavigation({
                task: ()=>{
                    opts.pushState(path, state);
                    notify({
                        type: "PUSH"
                    });
                },
                navigateOpts,
                type: "PUSH",
                path,
                state
            });
        },
        replace: (path, state, navigateOpts)=>{
            const currentIndex = location.state[stateIndexKey];
            state = assignKeyAndIndex(currentIndex, state);
            tryNavigation({
                task: ()=>{
                    opts.replaceState(path, state);
                    notify({
                        type: "REPLACE"
                    });
                },
                navigateOpts,
                type: "REPLACE",
                path,
                state
            });
        },
        go: (index, navigateOpts)=>{
            tryNavigation({
                task: ()=>{
                    opts.go(index);
                    handleIndexChange({
                        type: "GO",
                        index
                    });
                },
                navigateOpts,
                type: "GO"
            });
        },
        back: (navigateOpts)=>{
            tryNavigation({
                task: ()=>{
                    opts.back(navigateOpts?.ignoreBlocker ?? false);
                    handleIndexChange({
                        type: "BACK"
                    });
                },
                navigateOpts,
                type: "BACK"
            });
        },
        forward: (navigateOpts)=>{
            tryNavigation({
                task: ()=>{
                    opts.forward(navigateOpts?.ignoreBlocker ?? false);
                    handleIndexChange({
                        type: "FORWARD"
                    });
                },
                navigateOpts,
                type: "FORWARD"
            });
        },
        canGoBack: ()=>location.state[stateIndexKey] !== 0,
        createHref: (str)=>opts.createHref(str),
        block: (blocker)=>{
            if (!opts.setBlockers) return ()=>{};
            const blockers = opts.getBlockers?.() ?? [];
            opts.setBlockers([
                ...blockers,
                blocker
            ]);
            return ()=>{
                const blockers2 = opts.getBlockers?.() ?? [];
                opts.setBlockers?.(blockers2.filter((b)=>b !== blocker));
            };
        },
        flush: ()=>opts.flush?.(),
        destroy: ()=>opts.destroy?.(),
        notify
    };
}
function assignKeyAndIndex(index, state) {
    if (!state) state = {};
    const key = createRandomKey();
    return {
        ...state,
        key,
        // TODO: Remove in v2 - use __TSR_key instead
        __TSR_key: key,
        [stateIndexKey]: index
    };
}
function createBrowserHistory(opts) {
    const win = opts?.window ?? (typeof document !== "undefined" ? window : void 0);
    const originalPushState = win.history.pushState;
    const originalReplaceState = win.history.replaceState;
    let blockers = [];
    const _getBlockers = ()=>blockers;
    const _setBlockers = (newBlockers)=>blockers = newBlockers;
    const createHref = opts?.createHref ?? ((path)=>path);
    const parseLocation = opts?.parseLocation ?? (()=>parseHref(`${win.location.pathname}${win.location.search}${win.location.hash}`, win.history.state));
    if (!win.history.state?.__TSR_key && !win.history.state?.key) {
        const addedKey = createRandomKey();
        win.history.replaceState({
            [stateIndexKey]: 0,
            key: addedKey,
            // TODO: Remove in v2 - use __TSR_key instead
            __TSR_key: addedKey
        }, "");
    }
    let currentLocation = parseLocation();
    let rollbackLocation;
    let nextPopIsGo = false;
    let ignoreNextPop = false;
    let skipBlockerNextPop = false;
    let ignoreNextBeforeUnload = false;
    const getLocation = ()=>currentLocation;
    let next;
    let scheduled;
    const flush = ()=>{
        if (!next) return;
        history._ignoreSubscribers = true;
        (next.isPush ? win.history.pushState : win.history.replaceState)(next.state, "", next.href);
        history._ignoreSubscribers = false;
        next = void 0;
        scheduled = void 0;
        rollbackLocation = void 0;
    };
    const queueHistoryAction = (type, destHref, state)=>{
        const href = createHref(destHref);
        if (!scheduled) rollbackLocation = currentLocation;
        currentLocation = parseHref(destHref, state);
        next = {
            href,
            state,
            isPush: next?.isPush || type === "push"
        };
        if (!scheduled) scheduled = Promise.resolve().then(()=>flush());
    };
    const onPushPop = (type)=>{
        currentLocation = parseLocation();
        history.notify({
            type
        });
    };
    const onPushPopEvent = async ()=>{
        if (ignoreNextPop) {
            ignoreNextPop = false;
            return;
        }
        const nextLocation = parseLocation();
        const delta = nextLocation.state[stateIndexKey] - currentLocation.state[stateIndexKey];
        const isForward = delta === 1;
        const isBack = delta === -1;
        const isGo = !isForward && !isBack || nextPopIsGo;
        nextPopIsGo = false;
        const action = isGo ? "GO" : isBack ? "BACK" : "FORWARD";
        const notify = isGo ? {
            type: "GO",
            index: delta
        } : {
            type: isBack ? "BACK" : "FORWARD"
        };
        if (skipBlockerNextPop) skipBlockerNextPop = false;
        else {
            const blockers2 = _getBlockers();
            if (typeof document !== "undefined" && blockers2.length) for (const blocker of blockers2){
                const isBlocked = await blocker.blockerFn({
                    currentLocation,
                    nextLocation,
                    action
                });
                if (isBlocked) {
                    ignoreNextPop = true;
                    win.history.go(1);
                    history.notify(notify);
                    return;
                }
            }
        }
        currentLocation = parseLocation();
        history.notify(notify);
    };
    const onBeforeUnload = (e)=>{
        if (ignoreNextBeforeUnload) {
            ignoreNextBeforeUnload = false;
            return;
        }
        let shouldBlock = false;
        const blockers2 = _getBlockers();
        if (typeof document !== "undefined" && blockers2.length) for (const blocker of blockers2){
            const shouldHaveBeforeUnload = blocker.enableBeforeUnload ?? true;
            if (shouldHaveBeforeUnload === true) {
                shouldBlock = true;
                break;
            }
            if (typeof shouldHaveBeforeUnload === "function" && shouldHaveBeforeUnload() === true) {
                shouldBlock = true;
                break;
            }
        }
        if (shouldBlock) {
            e.preventDefault();
            return e.returnValue = "";
        }
        return;
    };
    const history = createHistory({
        getLocation,
        getLength: ()=>win.history.length,
        pushState: (href, state)=>queueHistoryAction("push", href, state),
        replaceState: (href, state)=>queueHistoryAction("replace", href, state),
        back: (ignoreBlocker)=>{
            if (ignoreBlocker) skipBlockerNextPop = true;
            ignoreNextBeforeUnload = true;
            return win.history.back();
        },
        forward: (ignoreBlocker)=>{
            if (ignoreBlocker) skipBlockerNextPop = true;
            ignoreNextBeforeUnload = true;
            win.history.forward();
        },
        go: (n)=>{
            nextPopIsGo = true;
            win.history.go(n);
        },
        createHref: (href)=>createHref(href),
        flush,
        destroy: ()=>{
            win.history.pushState = originalPushState;
            win.history.replaceState = originalReplaceState;
            win.removeEventListener(beforeUnloadEvent, onBeforeUnload, {
                capture: true
            });
            win.removeEventListener(popStateEvent, onPushPopEvent);
        },
        onBlocked: ()=>{
            if (rollbackLocation && currentLocation !== rollbackLocation) currentLocation = rollbackLocation;
        },
        getBlockers: _getBlockers,
        setBlockers: _setBlockers,
        notifyOnIndexChange: false
    });
    win.addEventListener(beforeUnloadEvent, onBeforeUnload, {
        capture: true
    });
    win.addEventListener(popStateEvent, onPushPopEvent);
    win.history.pushState = function(...args) {
        const res = originalPushState.apply(win.history, args);
        if (!history._ignoreSubscribers) onPushPop("PUSH");
        return res;
    };
    win.history.replaceState = function(...args) {
        const res = originalReplaceState.apply(win.history, args);
        if (!history._ignoreSubscribers) onPushPop("REPLACE");
        return res;
    };
    return history;
}
function createHashHistory(opts) {
    const win = opts?.window ?? (typeof document !== "undefined" ? window : void 0);
    return createBrowserHistory({
        window: win,
        parseLocation: ()=>{
            const hashSplit = win.location.hash.split("#").slice(1);
            const pathPart = hashSplit[0] ?? "/";
            const searchPart = win.location.search;
            const hashEntries = hashSplit.slice(1);
            const hashPart = hashEntries.length === 0 ? "" : `#${hashEntries.join("#")}`;
            const hashHref = `${pathPart}${searchPart}${hashPart}`;
            return parseHref(hashHref, win.history.state);
        },
        createHref: (href)=>`${win.location.pathname}${win.location.search}#${href}`
    });
}
function createMemoryHistory(opts = {
    initialEntries: [
        "/"
    ]
}) {
    const entries = opts.initialEntries;
    let index = opts.initialIndex ? Math.min(Math.max(opts.initialIndex, 0), entries.length - 1) : entries.length - 1;
    const states = entries.map((_entry, index2)=>assignKeyAndIndex(index2, void 0));
    const getLocation = ()=>parseHref(entries[index], states[index]);
    return createHistory({
        getLocation,
        getLength: ()=>entries.length,
        pushState: (path, state)=>{
            if (index < entries.length - 1) {
                entries.splice(index + 1);
                states.splice(index + 1);
            }
            states.push(state);
            entries.push(path);
            index = Math.max(entries.length - 1, 0);
        },
        replaceState: (path, state)=>{
            states[index] = state;
            entries[index] = path;
        },
        back: ()=>{
            index = Math.max(index - 1, 0);
        },
        forward: ()=>{
            index = Math.min(index + 1, entries.length - 1);
        },
        go: (n)=>{
            index = Math.min(Math.max(index + n, 0), entries.length - 1);
        },
        createHref: (path)=>path
    });
}
function parseHref(href, state) {
    const hashIndex = href.indexOf("#");
    const searchIndex = href.indexOf("?");
    const addedKey = createRandomKey();
    return {
        href,
        pathname: href.substring(0, hashIndex > 0 ? searchIndex > 0 ? Math.min(hashIndex, searchIndex) : hashIndex : searchIndex > 0 ? searchIndex : href.length),
        hash: hashIndex > -1 ? href.substring(hashIndex) : "",
        search: searchIndex > -1 ? href.slice(searchIndex, hashIndex === -1 ? void 0 : hashIndex) : "",
        state: state || {
            [stateIndexKey]: 0,
            key: addedKey,
            __TSR_key: addedKey
        }
    };
}
function createRandomKey() {
    return (Math.random() + 1).toString(36).substring(7);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eTTD3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createControlledPromise", ()=>createControlledPromise);
parcelHelpers.export(exports, "decodePath", ()=>decodePath);
parcelHelpers.export(exports, "deepEqual", ()=>deepEqual);
parcelHelpers.export(exports, "findLast", ()=>findLast);
parcelHelpers.export(exports, "functionalUpdate", ()=>functionalUpdate);
parcelHelpers.export(exports, "isModuleNotFoundError", ()=>isModuleNotFoundError);
parcelHelpers.export(exports, "isPlainArray", ()=>isPlainArray);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
parcelHelpers.export(exports, "last", ()=>last);
parcelHelpers.export(exports, "replaceEqualDeep", ()=>replaceEqualDeep);
function last(arr) {
    return arr[arr.length - 1];
}
function isFunction(d) {
    return typeof d === "function";
}
function functionalUpdate(updater, previous) {
    if (isFunction(updater)) return updater(previous);
    return updater;
}
const hasOwn = Object.prototype.hasOwnProperty;
function replaceEqualDeep(prev, _next) {
    if (prev === _next) return prev;
    const next = _next;
    const array = isPlainArray(prev) && isPlainArray(next);
    if (!array && !(isPlainObject(prev) && isPlainObject(next))) return next;
    const prevItems = array ? prev : getEnumerableOwnKeys(prev);
    if (!prevItems) return next;
    const nextItems = array ? next : getEnumerableOwnKeys(next);
    if (!nextItems) return next;
    const prevSize = prevItems.length;
    const nextSize = nextItems.length;
    const copy = array ? new Array(nextSize) : {};
    let equalItems = 0;
    for(let i = 0; i < nextSize; i++){
        const key = array ? i : nextItems[i];
        const p = prev[key];
        const n = next[key];
        if (p === n) {
            copy[key] = p;
            if (array ? i < prevSize : hasOwn.call(prev, key)) equalItems++;
            continue;
        }
        if (p === null || n === null || typeof p !== "object" || typeof n !== "object") {
            copy[key] = n;
            continue;
        }
        const v = replaceEqualDeep(p, n);
        copy[key] = v;
        if (v === p) equalItems++;
    }
    return prevSize === nextSize && equalItems === prevSize ? prev : copy;
}
function getEnumerableOwnKeys(o) {
    const keys = [];
    const names = Object.getOwnPropertyNames(o);
    for (const name of names){
        if (!Object.prototype.propertyIsEnumerable.call(o, name)) return false;
        keys.push(name);
    }
    const symbols = Object.getOwnPropertySymbols(o);
    for (const symbol of symbols){
        if (!Object.prototype.propertyIsEnumerable.call(o, symbol)) return false;
        keys.push(symbol);
    }
    return keys;
}
function isPlainObject(o) {
    if (!hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
    const prot = ctor.prototype;
    if (!hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    return true;
}
function hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function isPlainArray(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function deepEqual(a, b, opts) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        for(let i = 0, l = a.length; i < l; i++){
            if (!deepEqual(a[i], b[i], opts)) return false;
        }
        return true;
    }
    if (isPlainObject(a) && isPlainObject(b)) {
        const ignoreUndefined = opts?.ignoreUndefined ?? true;
        if (opts?.partial) {
            for(const k in b)if (!ignoreUndefined || b[k] !== void 0) {
                if (!deepEqual(a[k], b[k], opts)) return false;
            }
            return true;
        }
        let aCount = 0;
        if (!ignoreUndefined) aCount = Object.keys(a).length;
        else {
            for(const k in a)if (a[k] !== void 0) aCount++;
        }
        let bCount = 0;
        for(const k in b)if (!ignoreUndefined || b[k] !== void 0) {
            bCount++;
            if (bCount > aCount || !deepEqual(a[k], b[k], opts)) return false;
        }
        return aCount === bCount;
    }
    return false;
}
function createControlledPromise(onResolve) {
    let resolveLoadPromise;
    let rejectLoadPromise;
    const controlledPromise = new Promise((resolve, reject)=>{
        resolveLoadPromise = resolve;
        rejectLoadPromise = reject;
    });
    controlledPromise.status = "pending";
    controlledPromise.resolve = (value)=>{
        controlledPromise.status = "resolved";
        controlledPromise.value = value;
        resolveLoadPromise(value);
        onResolve?.(value);
    };
    controlledPromise.reject = (e)=>{
        controlledPromise.status = "rejected";
        rejectLoadPromise(e);
    };
    return controlledPromise;
}
function isModuleNotFoundError(error) {
    if (typeof error?.message !== "string") return false;
    return error.message.startsWith("Failed to fetch dynamically imported module") || error.message.startsWith("error loading dynamically imported module") || error.message.startsWith("Importing a module script failed");
}
function isPromise(value) {
    return Boolean(value && typeof value === "object" && typeof value.then === "function");
}
function findLast(array, predicate) {
    for(let i = array.length - 1; i >= 0; i--){
        const item = array[i];
        if (predicate(item)) return item;
    }
    return void 0;
}
function decodeSegment(segment) {
    try {
        return decodeURI(segment);
    } catch  {
        return segment.replaceAll(/%[0-9A-F]{2}/gi, (match)=>{
            try {
                return decodeURI(match);
            } catch  {
                return match;
            }
        });
    }
}
function decodePath(path, decodeIgnore) {
    if (!path) return path;
    const re = decodeIgnore ? new RegExp(`${decodeIgnore.join("|")}`, "gi") : /%25|%5C/gi;
    let cursor = 0;
    let result = "";
    let match;
    while(null !== (match = re.exec(path))){
        result += decodeSegment(path.slice(cursor, match.index)) + match[0];
        cursor = re.lastIndex;
    }
    return result + decodeSegment(cursor ? path.slice(cursor) : path);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ivpM2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEGMENT_TYPE_OPTIONAL_PARAM", ()=>SEGMENT_TYPE_OPTIONAL_PARAM);
parcelHelpers.export(exports, "SEGMENT_TYPE_PARAM", ()=>SEGMENT_TYPE_PARAM);
parcelHelpers.export(exports, "SEGMENT_TYPE_PATHNAME", ()=>SEGMENT_TYPE_PATHNAME);
parcelHelpers.export(exports, "SEGMENT_TYPE_WILDCARD", ()=>SEGMENT_TYPE_WILDCARD);
parcelHelpers.export(exports, "findFlatMatch", ()=>findFlatMatch);
parcelHelpers.export(exports, "findRouteMatch", ()=>findRouteMatch);
parcelHelpers.export(exports, "findSingleMatch", ()=>findSingleMatch);
parcelHelpers.export(exports, "parseSegment", ()=>parseSegment);
parcelHelpers.export(exports, "processRouteMasks", ()=>processRouteMasks);
parcelHelpers.export(exports, "processRouteTree", ()=>processRouteTree);
parcelHelpers.export(exports, "trimPathRight", ()=>trimPathRight);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _lruCacheJs = require("./lru-cache.js");
var _utilsJs = require("./utils.js");
const SEGMENT_TYPE_PATHNAME = 0;
const SEGMENT_TYPE_PARAM = 1;
const SEGMENT_TYPE_WILDCARD = 2;
const SEGMENT_TYPE_OPTIONAL_PARAM = 3;
const PARAM_W_CURLY_BRACES_RE = /^([^{]*)\{\$([a-zA-Z_$][a-zA-Z0-9_$]*)\}([^}]*)$/;
const OPTIONAL_PARAM_W_CURLY_BRACES_RE = /^([^{]*)\{-\$([a-zA-Z_$][a-zA-Z0-9_$]*)\}([^}]*)$/;
const WILDCARD_W_CURLY_BRACES_RE = /^([^{]*)\{\$\}([^}]*)$/;
function parseSegment(path, start, output = new Uint16Array(6)) {
    const next = path.indexOf("/", start);
    const end = next === -1 ? path.length : next;
    const part = path.substring(start, end);
    if (!part || !part.includes("$")) {
        output[0] = SEGMENT_TYPE_PATHNAME;
        output[1] = start;
        output[2] = start;
        output[3] = end;
        output[4] = end;
        output[5] = end;
        return output;
    }
    if (part === "$") {
        const total = path.length;
        output[0] = SEGMENT_TYPE_WILDCARD;
        output[1] = start;
        output[2] = start;
        output[3] = total;
        output[4] = total;
        output[5] = total;
        return output;
    }
    if (part.charCodeAt(0) === 36) {
        output[0] = SEGMENT_TYPE_PARAM;
        output[1] = start;
        output[2] = start + 1;
        output[3] = end;
        output[4] = end;
        output[5] = end;
        return output;
    }
    const wildcardBracesMatch = part.match(WILDCARD_W_CURLY_BRACES_RE);
    if (wildcardBracesMatch) {
        const prefix = wildcardBracesMatch[1];
        const pLength = prefix.length;
        output[0] = SEGMENT_TYPE_WILDCARD;
        output[1] = start + pLength;
        output[2] = start + pLength + 1;
        output[3] = start + pLength + 2;
        output[4] = start + pLength + 3;
        output[5] = path.length;
        return output;
    }
    const optionalParamBracesMatch = part.match(OPTIONAL_PARAM_W_CURLY_BRACES_RE);
    if (optionalParamBracesMatch) {
        const prefix = optionalParamBracesMatch[1];
        const paramName = optionalParamBracesMatch[2];
        const suffix = optionalParamBracesMatch[3];
        const pLength = prefix.length;
        output[0] = SEGMENT_TYPE_OPTIONAL_PARAM;
        output[1] = start + pLength;
        output[2] = start + pLength + 3;
        output[3] = start + pLength + 3 + paramName.length;
        output[4] = end - suffix.length;
        output[5] = end;
        return output;
    }
    const paramBracesMatch = part.match(PARAM_W_CURLY_BRACES_RE);
    if (paramBracesMatch) {
        const prefix = paramBracesMatch[1];
        const paramName = paramBracesMatch[2];
        const suffix = paramBracesMatch[3];
        const pLength = prefix.length;
        output[0] = SEGMENT_TYPE_PARAM;
        output[1] = start + pLength;
        output[2] = start + pLength + 2;
        output[3] = start + pLength + 2 + paramName.length;
        output[4] = end - suffix.length;
        output[5] = end;
        return output;
    }
    output[0] = SEGMENT_TYPE_PATHNAME;
    output[1] = start;
    output[2] = start;
    output[3] = end;
    output[4] = end;
    output[5] = end;
    return output;
}
function parseSegments(defaultCaseSensitive, data, route, start, node, depth, onRoute) {
    onRoute?.(route);
    let cursor = start;
    {
        const path = route.fullPath ?? route.from;
        const length = path.length;
        const caseSensitive = route.options?.caseSensitive ?? defaultCaseSensitive;
        while(cursor < length){
            const segment = parseSegment(path, cursor, data);
            let nextNode;
            const start2 = cursor;
            const end = segment[5];
            cursor = end + 1;
            depth++;
            const kind = segment[0];
            switch(kind){
                case SEGMENT_TYPE_PATHNAME:
                    {
                        const value = path.substring(segment[2], segment[3]);
                        if (caseSensitive) {
                            const existingNode = node.static?.get(value);
                            if (existingNode) nextNode = existingNode;
                            else {
                                node.static ??= /* @__PURE__ */ new Map();
                                const next = createStaticNode(route.fullPath ?? route.from);
                                next.parent = node;
                                next.depth = depth;
                                nextNode = next;
                                node.static.set(value, next);
                            }
                        } else {
                            const name = value.toLowerCase();
                            const existingNode = node.staticInsensitive?.get(name);
                            if (existingNode) nextNode = existingNode;
                            else {
                                node.staticInsensitive ??= /* @__PURE__ */ new Map();
                                const next = createStaticNode(route.fullPath ?? route.from);
                                next.parent = node;
                                next.depth = depth;
                                nextNode = next;
                                node.staticInsensitive.set(name, next);
                            }
                        }
                        break;
                    }
                case SEGMENT_TYPE_PARAM:
                    {
                        const prefix_raw = path.substring(start2, segment[1]);
                        const suffix_raw = path.substring(segment[4], end);
                        const actuallyCaseSensitive = caseSensitive && !!(prefix_raw || suffix_raw);
                        const prefix = !prefix_raw ? void 0 : actuallyCaseSensitive ? prefix_raw : prefix_raw.toLowerCase();
                        const suffix = !suffix_raw ? void 0 : actuallyCaseSensitive ? suffix_raw : suffix_raw.toLowerCase();
                        const existingNode = node.dynamic?.find((s)=>s.caseSensitive === actuallyCaseSensitive && s.prefix === prefix && s.suffix === suffix);
                        if (existingNode) nextNode = existingNode;
                        else {
                            const next = createDynamicNode(SEGMENT_TYPE_PARAM, route.fullPath ?? route.from, actuallyCaseSensitive, prefix, suffix);
                            nextNode = next;
                            next.depth = depth;
                            next.parent = node;
                            node.dynamic ??= [];
                            node.dynamic.push(next);
                        }
                        break;
                    }
                case SEGMENT_TYPE_OPTIONAL_PARAM:
                    {
                        const prefix_raw = path.substring(start2, segment[1]);
                        const suffix_raw = path.substring(segment[4], end);
                        const actuallyCaseSensitive = caseSensitive && !!(prefix_raw || suffix_raw);
                        const prefix = !prefix_raw ? void 0 : actuallyCaseSensitive ? prefix_raw : prefix_raw.toLowerCase();
                        const suffix = !suffix_raw ? void 0 : actuallyCaseSensitive ? suffix_raw : suffix_raw.toLowerCase();
                        const existingNode = node.optional?.find((s)=>s.caseSensitive === actuallyCaseSensitive && s.prefix === prefix && s.suffix === suffix);
                        if (existingNode) nextNode = existingNode;
                        else {
                            const next = createDynamicNode(SEGMENT_TYPE_OPTIONAL_PARAM, route.fullPath ?? route.from, actuallyCaseSensitive, prefix, suffix);
                            nextNode = next;
                            next.parent = node;
                            next.depth = depth;
                            node.optional ??= [];
                            node.optional.push(next);
                        }
                        break;
                    }
                case SEGMENT_TYPE_WILDCARD:
                    {
                        const prefix_raw = path.substring(start2, segment[1]);
                        const suffix_raw = path.substring(segment[4], end);
                        const actuallyCaseSensitive = caseSensitive && !!(prefix_raw || suffix_raw);
                        const prefix = !prefix_raw ? void 0 : actuallyCaseSensitive ? prefix_raw : prefix_raw.toLowerCase();
                        const suffix = !suffix_raw ? void 0 : actuallyCaseSensitive ? suffix_raw : suffix_raw.toLowerCase();
                        const next = createDynamicNode(SEGMENT_TYPE_WILDCARD, route.fullPath ?? route.from, actuallyCaseSensitive, prefix, suffix);
                        nextNode = next;
                        next.parent = node;
                        next.depth = depth;
                        node.wildcard ??= [];
                        node.wildcard.push(next);
                    }
            }
            node = nextNode;
        }
        if ((route.path || !route.children) && !route.isRoot) {
            const isIndex = path.endsWith("/");
            if (!isIndex) node.notFound = route;
            if (!node.route || !node.isIndex && isIndex) node.route = route;
            node.isIndex ||= isIndex;
        }
    }
    if (route.children) for (const child of route.children)parseSegments(defaultCaseSensitive, data, child, cursor, node, depth, onRoute);
}
function sortDynamic(a, b) {
    if (a.prefix && b.prefix && a.prefix !== b.prefix) {
        if (a.prefix.startsWith(b.prefix)) return -1;
        if (b.prefix.startsWith(a.prefix)) return 1;
    }
    if (a.suffix && b.suffix && a.suffix !== b.suffix) {
        if (a.suffix.endsWith(b.suffix)) return -1;
        if (b.suffix.endsWith(a.suffix)) return 1;
    }
    if (a.prefix && !b.prefix) return -1;
    if (!a.prefix && b.prefix) return 1;
    if (a.suffix && !b.suffix) return -1;
    if (!a.suffix && b.suffix) return 1;
    if (a.caseSensitive && !b.caseSensitive) return -1;
    if (!a.caseSensitive && b.caseSensitive) return 1;
    return 0;
}
function sortTreeNodes(node) {
    if (node.static) for (const child of node.static.values())sortTreeNodes(child);
    if (node.staticInsensitive) for (const child of node.staticInsensitive.values())sortTreeNodes(child);
    if (node.dynamic?.length) {
        node.dynamic.sort(sortDynamic);
        for (const child of node.dynamic)sortTreeNodes(child);
    }
    if (node.optional?.length) {
        node.optional.sort(sortDynamic);
        for (const child of node.optional)sortTreeNodes(child);
    }
    if (node.wildcard?.length) {
        node.wildcard.sort(sortDynamic);
        for (const child of node.wildcard)sortTreeNodes(child);
    }
}
function createStaticNode(fullPath) {
    return {
        kind: SEGMENT_TYPE_PATHNAME,
        depth: 0,
        static: null,
        staticInsensitive: null,
        dynamic: null,
        optional: null,
        wildcard: null,
        route: null,
        fullPath,
        parent: null,
        isIndex: false,
        notFound: null
    };
}
function createDynamicNode(kind, fullPath, caseSensitive, prefix, suffix) {
    return {
        kind,
        depth: 0,
        static: null,
        staticInsensitive: null,
        dynamic: null,
        optional: null,
        wildcard: null,
        route: null,
        fullPath,
        parent: null,
        isIndex: false,
        notFound: null,
        caseSensitive,
        prefix,
        suffix
    };
}
function processRouteMasks(routeList, processedTree) {
    const segmentTree = createStaticNode("/");
    const data = new Uint16Array(6);
    for (const route of routeList)parseSegments(false, data, route, 1, segmentTree, 0);
    sortTreeNodes(segmentTree);
    processedTree.masksTree = segmentTree;
    processedTree.flatCache = (0, _lruCacheJs.createLRUCache)(1e3);
}
function findFlatMatch(path, processedTree) {
    path ||= "/";
    const cached = processedTree.flatCache.get(path);
    if (cached) return cached;
    const result = findMatch(path, processedTree.masksTree);
    processedTree.flatCache.set(path, result);
    return result;
}
function findSingleMatch(from, caseSensitive, fuzzy, path, processedTree) {
    from ||= "/";
    path ||= "/";
    const key = caseSensitive ? `case\0${from}` : from;
    let tree = processedTree.singleCache.get(key);
    if (!tree) {
        tree = createStaticNode("/");
        const data = new Uint16Array(6);
        parseSegments(caseSensitive, data, {
            from
        }, 1, tree, 0);
        processedTree.singleCache.set(key, tree);
    }
    return findMatch(path, tree, fuzzy);
}
function findRouteMatch(path, processedTree, fuzzy = false) {
    const key = fuzzy ? path : `nofuzz\0${path}`;
    const cached = processedTree.matchCache.get(key);
    if (cached !== void 0) return cached;
    path ||= "/";
    const result = findMatch(path, processedTree.segmentTree, fuzzy);
    if (result) result.branch = buildRouteBranch(result.route);
    processedTree.matchCache.set(key, result);
    return result;
}
function trimPathRight(path) {
    return path === "/" ? path : path.replace(/\/{1,}$/, "");
}
function processRouteTree(routeTree, caseSensitive = false, initRoute) {
    const segmentTree = createStaticNode(routeTree.fullPath);
    const data = new Uint16Array(6);
    const routesById = {};
    const routesByPath = {};
    let index = 0;
    parseSegments(caseSensitive, data, routeTree, 1, segmentTree, 0, (route)=>{
        initRoute?.(route, index);
        (0, _tinyInvariantDefault.default)(!(route.id in routesById), `Duplicate routes found with id: ${String(route.id)}`);
        routesById[route.id] = route;
        if (index !== 0 && route.path) {
            const trimmedFullPath = trimPathRight(route.fullPath);
            if (!routesByPath[trimmedFullPath] || route.fullPath.endsWith("/")) routesByPath[trimmedFullPath] = route;
        }
        index++;
    });
    sortTreeNodes(segmentTree);
    const processedTree = {
        segmentTree,
        singleCache: (0, _lruCacheJs.createLRUCache)(1e3),
        matchCache: (0, _lruCacheJs.createLRUCache)(1e3),
        flatCache: null,
        masksTree: null
    };
    return {
        processedTree,
        routesById,
        routesByPath
    };
}
function findMatch(path, segmentTree, fuzzy = false) {
    const parts = path.split("/");
    const leaf = getNodeMatch(path, parts, segmentTree, fuzzy);
    if (!leaf) return null;
    const params = extractParams(path, parts, leaf);
    const isFuzzyMatch = "**" in leaf;
    if (isFuzzyMatch) params["**"] = leaf["**"];
    const route = isFuzzyMatch ? leaf.node.notFound ?? leaf.node.route : leaf.node.route;
    return {
        route,
        params
    };
}
function extractParams(path, parts, leaf) {
    const list = buildBranch(leaf.node);
    let nodeParts = null;
    const params = {};
    for(let partIndex = 0, nodeIndex = 0, pathIndex = 0; nodeIndex < list.length; partIndex++, nodeIndex++, pathIndex++){
        const node = list[nodeIndex];
        const part = parts[partIndex];
        const currentPathIndex = pathIndex;
        if (part) pathIndex += part.length;
        if (node.kind === SEGMENT_TYPE_PARAM) {
            nodeParts ??= leaf.node.fullPath.split("/");
            const nodePart = nodeParts[nodeIndex];
            const preLength = node.prefix?.length ?? 0;
            const isCurlyBraced = nodePart.charCodeAt(preLength) === 123;
            if (isCurlyBraced) {
                const sufLength = node.suffix?.length ?? 0;
                const name = nodePart.substring(preLength + 2, nodePart.length - sufLength - 1);
                const value = part.substring(preLength, part.length - sufLength);
                params[name] = decodeURIComponent(value);
            } else {
                const name = nodePart.substring(1);
                params[name] = decodeURIComponent(part);
            }
        } else if (node.kind === SEGMENT_TYPE_OPTIONAL_PARAM) {
            if (leaf.skipped & 1 << nodeIndex) {
                partIndex--;
                continue;
            }
            nodeParts ??= leaf.node.fullPath.split("/");
            const nodePart = nodeParts[nodeIndex];
            const preLength = node.prefix?.length ?? 0;
            const sufLength = node.suffix?.length ?? 0;
            const name = nodePart.substring(preLength + 3, nodePart.length - sufLength - 1);
            const value = node.suffix || node.prefix ? part.substring(preLength, part.length - sufLength) : part;
            if (value) params[name] = decodeURIComponent(value);
        } else if (node.kind === SEGMENT_TYPE_WILDCARD) {
            const n = node;
            const value = path.substring(currentPathIndex + (n.prefix?.length ?? 0), path.length - (n.suffix?.length ?? 0));
            const splat = decodeURIComponent(value);
            params["*"] = splat;
            params._splat = splat;
            break;
        }
    }
    return params;
}
function buildRouteBranch(route) {
    const list = [
        route
    ];
    while(route.parentRoute){
        route = route.parentRoute;
        list.push(route);
    }
    list.reverse();
    return list;
}
function buildBranch(node) {
    const list = Array(node.depth + 1);
    do {
        list[node.depth] = node;
        node = node.parent;
    }while (node);
    return list;
}
function getNodeMatch(path, parts, segmentTree, fuzzy) {
    const trailingSlash = !(0, _utilsJs.last)(parts);
    const pathIsIndex = trailingSlash && path !== "/";
    const partsLength = parts.length - (trailingSlash ? 1 : 0);
    const stack = [
        {
            node: segmentTree,
            index: 1,
            skipped: 0,
            depth: 1,
            statics: 1,
            dynamics: 0,
            optionals: 0
        }
    ];
    let wildcardMatch = null;
    let bestFuzzy = null;
    let bestMatch = null;
    while(stack.length){
        const frame = stack.pop();
        let { node, index, skipped, depth, statics, dynamics, optionals } = frame;
        if (fuzzy && node.notFound && isFrameMoreSpecific(bestFuzzy, frame)) bestFuzzy = frame;
        const isBeyondPath = index === partsLength;
        if (isBeyondPath) {
            if (node.route && (!pathIsIndex || node.isIndex)) {
                if (isFrameMoreSpecific(bestMatch, frame)) bestMatch = frame;
                if (statics === partsLength && node.isIndex) return bestMatch;
            }
            if (!node.optional && !node.wildcard) continue;
        }
        const part = isBeyondPath ? void 0 : parts[index];
        let lowerPart;
        if (node.wildcard && isFrameMoreSpecific(wildcardMatch, frame)) for (const segment of node.wildcard){
            const { prefix, suffix } = segment;
            if (prefix) {
                if (isBeyondPath) continue;
                const casePart = segment.caseSensitive ? part : lowerPart ??= part.toLowerCase();
                if (!casePart.startsWith(prefix)) continue;
            }
            if (suffix) {
                if (isBeyondPath) continue;
                const end = parts.slice(index).join("/").slice(-suffix.length);
                const casePart = segment.caseSensitive ? end : end.toLowerCase();
                if (casePart !== suffix) continue;
            }
            wildcardMatch = {
                node: segment,
                index,
                skipped,
                depth,
                statics,
                dynamics,
                optionals
            };
            break;
        }
        if (node.optional) {
            const nextSkipped = skipped | 1 << depth;
            const nextDepth = depth + 1;
            for(let i = node.optional.length - 1; i >= 0; i--){
                const segment = node.optional[i];
                stack.push({
                    node: segment,
                    index,
                    skipped: nextSkipped,
                    depth: nextDepth,
                    statics,
                    dynamics,
                    optionals
                });
            }
            if (!isBeyondPath) for(let i = node.optional.length - 1; i >= 0; i--){
                const segment = node.optional[i];
                const { prefix, suffix } = segment;
                if (prefix || suffix) {
                    const casePart = segment.caseSensitive ? part : lowerPart ??= part.toLowerCase();
                    if (prefix && !casePart.startsWith(prefix)) continue;
                    if (suffix && !casePart.endsWith(suffix)) continue;
                }
                stack.push({
                    node: segment,
                    index: index + 1,
                    skipped,
                    depth: nextDepth,
                    statics,
                    dynamics,
                    optionals: optionals + 1
                });
            }
        }
        if (!isBeyondPath && node.dynamic && part) for(let i = node.dynamic.length - 1; i >= 0; i--){
            const segment = node.dynamic[i];
            const { prefix, suffix } = segment;
            if (prefix || suffix) {
                const casePart = segment.caseSensitive ? part : lowerPart ??= part.toLowerCase();
                if (prefix && !casePart.startsWith(prefix)) continue;
                if (suffix && !casePart.endsWith(suffix)) continue;
            }
            stack.push({
                node: segment,
                index: index + 1,
                skipped,
                depth: depth + 1,
                statics,
                dynamics: dynamics + 1,
                optionals
            });
        }
        if (!isBeyondPath && node.staticInsensitive) {
            const match = node.staticInsensitive.get(lowerPart ??= part.toLowerCase());
            if (match) stack.push({
                node: match,
                index: index + 1,
                skipped,
                depth: depth + 1,
                statics: statics + 1,
                dynamics,
                optionals
            });
        }
        if (!isBeyondPath && node.static) {
            const match = node.static.get(part);
            if (match) stack.push({
                node: match,
                index: index + 1,
                skipped,
                depth: depth + 1,
                statics: statics + 1,
                dynamics,
                optionals
            });
        }
    }
    if (bestMatch && wildcardMatch) return isFrameMoreSpecific(wildcardMatch, bestMatch) ? bestMatch : wildcardMatch;
    if (bestMatch) return bestMatch;
    if (wildcardMatch) return wildcardMatch;
    if (fuzzy && bestFuzzy) {
        let sliceIndex = bestFuzzy.index;
        for(let i = 0; i < bestFuzzy.index; i++)sliceIndex += parts[i].length;
        const splat = sliceIndex === path.length ? "/" : path.slice(sliceIndex);
        return {
            node: bestFuzzy.node,
            skipped: bestFuzzy.skipped,
            "**": decodeURIComponent(splat)
        };
    }
    return null;
}
function isFrameMoreSpecific(prev, next) {
    if (!prev) return true;
    return next.statics > prev.statics || next.statics === prev.statics && (next.dynamics > prev.dynamics || next.dynamics === prev.dynamics && (next.optionals > prev.optionals || next.optionals === prev.optionals && (next.node.isIndex > prev.node.isIndex || next.node.isIndex === prev.node.isIndex && next.depth > prev.depth)));
}

},{"tiny-invariant":"4qfOO","./lru-cache.js":"36hTA","./utils.js":"eTTD3","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4qfOO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
var isProduction = true;
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"36hTA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLRUCache", ()=>createLRUCache);
function createLRUCache(max) {
    const cache = /* @__PURE__ */ new Map();
    let oldest;
    let newest;
    const touch = (entry)=>{
        if (!entry.next) return;
        if (!entry.prev) {
            entry.next.prev = void 0;
            oldest = entry.next;
            entry.next = void 0;
            if (newest) {
                entry.prev = newest;
                newest.next = entry;
            }
        } else {
            entry.prev.next = entry.next;
            entry.next.prev = entry.prev;
            entry.next = void 0;
            if (newest) {
                newest.next = entry;
                entry.prev = newest;
            }
        }
        newest = entry;
    };
    return {
        get (key) {
            const entry = cache.get(key);
            if (!entry) return void 0;
            touch(entry);
            return entry.value;
        },
        set (key, value) {
            if (cache.size >= max && oldest) {
                const toDelete = oldest;
                cache.delete(toDelete.key);
                if (toDelete.next) {
                    oldest = toDelete.next;
                    toDelete.next.prev = void 0;
                }
                if (toDelete === newest) newest = void 0;
            }
            const existing = cache.get(key);
            if (existing) {
                existing.value = value;
                touch(existing);
            } else {
                const entry = {
                    key,
                    value,
                    prev: newest
                };
                if (newest) newest.next = entry;
                newest = entry;
                if (!oldest) oldest = entry;
                cache.set(key, entry);
            }
        },
        clear () {
            cache.clear();
            oldest = void 0;
            newest = void 0;
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"b4w6q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanPath", ()=>cleanPath);
parcelHelpers.export(exports, "exactPathTest", ()=>exactPathTest);
parcelHelpers.export(exports, "interpolatePath", ()=>interpolatePath);
parcelHelpers.export(exports, "joinPaths", ()=>joinPaths);
parcelHelpers.export(exports, "removeTrailingSlash", ()=>removeTrailingSlash);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "trimPath", ()=>trimPath);
parcelHelpers.export(exports, "trimPathLeft", ()=>trimPathLeft);
parcelHelpers.export(exports, "trimPathRight", ()=>trimPathRight);
var _utilsJs = require("./utils.js");
var _newProcessRouteTreeJs = require("./new-process-route-tree.js");
function joinPaths(paths) {
    return cleanPath(paths.filter((val)=>{
        return val !== void 0;
    }).join("/"));
}
function cleanPath(path) {
    return path.replace(/\/{2,}/g, "/");
}
function trimPathLeft(path) {
    return path === "/" ? path : path.replace(/^\/{1,}/, "");
}
function trimPathRight(path) {
    const len = path.length;
    return len > 1 && path[len - 1] === "/" ? path.replace(/\/{1,}$/, "") : path;
}
function trimPath(path) {
    return trimPathRight(trimPathLeft(path));
}
function removeTrailingSlash(value, basepath) {
    if (value?.endsWith("/") && value !== "/" && value !== `${basepath}/`) return value.slice(0, -1);
    return value;
}
function exactPathTest(pathName1, pathName2, basepath) {
    return removeTrailingSlash(pathName1, basepath) === removeTrailingSlash(pathName2, basepath);
}
function resolvePath({ base, to, trailingSlash = "never", cache }) {
    const isAbsolute = to.startsWith("/");
    const isBase = !isAbsolute && to === ".";
    let key;
    if (cache) {
        key = isAbsolute ? to : isBase ? base : base + "\0" + to;
        const cached = cache.get(key);
        if (cached) return cached;
    }
    let baseSegments;
    if (isBase) baseSegments = base.split("/");
    else if (isAbsolute) baseSegments = to.split("/");
    else {
        baseSegments = base.split("/");
        while(baseSegments.length > 1 && (0, _utilsJs.last)(baseSegments) === "")baseSegments.pop();
        const toSegments = to.split("/");
        for(let index = 0, length = toSegments.length; index < length; index++){
            const value = toSegments[index];
            if (value === "") {
                if (!index) baseSegments = [
                    value
                ];
                else if (index === length - 1) baseSegments.push(value);
            } else if (value === "..") baseSegments.pop();
            else if (value === ".") ;
            else baseSegments.push(value);
        }
    }
    if (baseSegments.length > 1) {
        if ((0, _utilsJs.last)(baseSegments) === "") {
            if (trailingSlash === "never") baseSegments.pop();
        } else if (trailingSlash === "always") baseSegments.push("");
    }
    let segment;
    let joined = "";
    for(let i = 0; i < baseSegments.length; i++){
        if (i > 0) joined += "/";
        const part = baseSegments[i];
        if (!part) continue;
        segment = (0, _newProcessRouteTreeJs.parseSegment)(part, 0, segment);
        const kind = segment[0];
        if (kind === (0, _newProcessRouteTreeJs.SEGMENT_TYPE_PATHNAME)) {
            joined += part;
            continue;
        }
        const end = segment[5];
        const prefix = part.substring(0, segment[1]);
        const suffix = part.substring(segment[4], end);
        const value = part.substring(segment[2], segment[3]);
        if (kind === (0, _newProcessRouteTreeJs.SEGMENT_TYPE_PARAM)) joined += prefix || suffix ? `${prefix}{$${value}}${suffix}` : `$${value}`;
        else if (kind === (0, _newProcessRouteTreeJs.SEGMENT_TYPE_WILDCARD)) joined += prefix || suffix ? `${prefix}{$}${suffix}` : "$";
        else joined += `${prefix}{-$${value}}${suffix}`;
    }
    joined = cleanPath(joined);
    const result = joined || "/";
    if (key && cache) cache.set(key, result);
    return result;
}
function encodeParam(key, params, decodeCharMap) {
    const value = params[key];
    if (typeof value !== "string") return value;
    if (key === "_splat") return encodeURI(value);
    else return encodePathParam(value, decodeCharMap);
}
function interpolatePath({ path, params, decodeCharMap }) {
    let isMissingParams = false;
    const usedParams = {};
    if (!path || path === "/") return {
        interpolatedPath: "/",
        usedParams,
        isMissingParams
    };
    if (!path.includes("$")) return {
        interpolatedPath: path,
        usedParams,
        isMissingParams
    };
    const length = path.length;
    let cursor = 0;
    let segment;
    let joined = "";
    while(cursor < length){
        const start = cursor;
        segment = (0, _newProcessRouteTreeJs.parseSegment)(path, start, segment);
        const end = segment[5];
        cursor = end + 1;
        if (start === end) continue;
        const kind = segment[0];
        if (kind === (0, _newProcessRouteTreeJs.SEGMENT_TYPE_PATHNAME)) {
            joined += "/" + path.substring(start, end);
            continue;
        }
        if (kind === (0, _newProcessRouteTreeJs.SEGMENT_TYPE_WILDCARD)) {
            const splat = params._splat;
            usedParams._splat = splat;
            usedParams["*"] = splat;
            const prefix = path.substring(start, segment[1]);
            const suffix = path.substring(segment[4], end);
            if (!splat) {
                isMissingParams = true;
                if (prefix || suffix) joined += "/" + prefix + suffix;
                continue;
            }
            const value = encodeParam("_splat", params, decodeCharMap);
            joined += "/" + prefix + value + suffix;
            continue;
        }
        if (kind === (0, _newProcessRouteTreeJs.SEGMENT_TYPE_PARAM)) {
            const key = path.substring(segment[2], segment[3]);
            if (!isMissingParams && !(key in params)) isMissingParams = true;
            usedParams[key] = params[key];
            const prefix = path.substring(start, segment[1]);
            const suffix = path.substring(segment[4], end);
            const value = encodeParam(key, params, decodeCharMap) ?? "undefined";
            joined += "/" + prefix + value + suffix;
            continue;
        }
        if (kind === (0, _newProcessRouteTreeJs.SEGMENT_TYPE_OPTIONAL_PARAM)) {
            const key = path.substring(segment[2], segment[3]);
            const valueRaw = params[key];
            if (valueRaw == null) continue;
            usedParams[key] = valueRaw;
            const prefix = path.substring(start, segment[1]);
            const suffix = path.substring(segment[4], end);
            const value = encodeParam(key, params, decodeCharMap) ?? "";
            joined += "/" + prefix + value + suffix;
            continue;
        }
    }
    if (path.endsWith("/")) joined += "/";
    const interpolatedPath = joined || "/";
    return {
        usedParams,
        interpolatedPath,
        isMissingParams
    };
}
function encodePathParam(value, decodeCharMap) {
    let encoded = encodeURIComponent(value);
    if (decodeCharMap) for (const [encodedChar, char] of decodeCharMap)encoded = encoded.replaceAll(encodedChar, char);
    return encoded;
}

},{"./utils.js":"eTTD3","./new-process-route-tree.js":"ivpM2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"aBKKv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNotFound", ()=>isNotFound);
parcelHelpers.export(exports, "notFound", ()=>notFound);
function notFound(options = {}) {
    options.isNotFound = true;
    if (options.throw) throw options;
    return options;
}
function isNotFound(obj) {
    return !!obj?.isNotFound;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ePmPj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultGetScrollRestorationKey", ()=>defaultGetScrollRestorationKey);
parcelHelpers.export(exports, "getCssSelector", ()=>getCssSelector);
parcelHelpers.export(exports, "handleHashScroll", ()=>handleHashScroll);
parcelHelpers.export(exports, "restoreScroll", ()=>restoreScroll);
parcelHelpers.export(exports, "scrollRestorationCache", ()=>scrollRestorationCache);
parcelHelpers.export(exports, "setupScrollRestoration", ()=>setupScrollRestoration);
parcelHelpers.export(exports, "storageKey", ()=>storageKey);
var _utilsJs = require("./utils.js");
function getSafeSessionStorage() {
    try {
        if (typeof window !== "undefined" && typeof window.sessionStorage === "object") return window.sessionStorage;
    } catch  {}
    return void 0;
}
const storageKey = "tsr-scroll-restoration-v1_3";
const throttle = (fn, wait)=>{
    let timeout;
    return (...args)=>{
        if (!timeout) timeout = setTimeout(()=>{
            fn(...args);
            timeout = null;
        }, wait);
    };
};
function createScrollRestorationCache() {
    const safeSessionStorage = getSafeSessionStorage();
    if (!safeSessionStorage) return null;
    const persistedState = safeSessionStorage.getItem(storageKey);
    let state = persistedState ? JSON.parse(persistedState) : {};
    return {
        state,
        // This setter is simply to make sure that we set the sessionStorage right
        // after the state is updated. It doesn't necessarily need to be a functional
        // update.
        set: (updater)=>(state = (0, _utilsJs.functionalUpdate)(updater, state) || state, safeSessionStorage.setItem(storageKey, JSON.stringify(state)))
    };
}
const scrollRestorationCache = createScrollRestorationCache();
const defaultGetScrollRestorationKey = (location)=>{
    return location.state.__TSR_key || location.href;
};
function getCssSelector(el) {
    const path = [];
    let parent;
    while(parent = el.parentNode){
        path.push(`${el.tagName}:nth-child(${Array.prototype.indexOf.call(parent.children, el) + 1})`);
        el = parent;
    }
    return `${path.reverse().join(" > ")}`.toLowerCase();
}
let ignoreScroll = false;
function restoreScroll({ storageKey: storageKey2, key, behavior, shouldScrollRestoration, scrollToTopSelectors, location }) {
    let byKey;
    try {
        byKey = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
    } catch (error) {
        console.error(error);
        return;
    }
    const resolvedKey = key || window.history.state?.__TSR_key;
    const elementEntries = byKey[resolvedKey];
    ignoreScroll = true;
    scroll: {
        if (shouldScrollRestoration && elementEntries && Object.keys(elementEntries).length > 0) {
            for(const elementSelector in elementEntries){
                const entry = elementEntries[elementSelector];
                if (elementSelector === "window") window.scrollTo({
                    top: entry.scrollY,
                    left: entry.scrollX,
                    behavior
                });
                else if (elementSelector) {
                    const element = document.querySelector(elementSelector);
                    if (element) {
                        element.scrollLeft = entry.scrollX;
                        element.scrollTop = entry.scrollY;
                    }
                }
            }
            break scroll;
        }
        const hash = (location ?? window.location).hash.split("#", 2)[1];
        if (hash) {
            const hashScrollIntoViewOptions = window.history.state?.__hashScrollIntoViewOptions ?? true;
            if (hashScrollIntoViewOptions) {
                const el = document.getElementById(hash);
                if (el) el.scrollIntoView(hashScrollIntoViewOptions);
            }
            break scroll;
        }
        const scrollOptions = {
            top: 0,
            left: 0,
            behavior
        };
        window.scrollTo(scrollOptions);
        if (scrollToTopSelectors) for (const selector of scrollToTopSelectors){
            if (selector === "window") continue;
            const element = typeof selector === "function" ? selector() : document.querySelector(selector);
            if (element) element.scrollTo(scrollOptions);
        }
    }
    ignoreScroll = false;
}
function setupScrollRestoration(router, force) {
    if (!scrollRestorationCache && !router.isServer) return;
    const shouldScrollRestoration = force ?? router.options.scrollRestoration ?? false;
    if (shouldScrollRestoration) router.isScrollRestoring = true;
    if (router.isServer || router.isScrollRestorationSetup || !scrollRestorationCache) return;
    router.isScrollRestorationSetup = true;
    ignoreScroll = false;
    const getKey = router.options.getScrollRestorationKey || defaultGetScrollRestorationKey;
    window.history.scrollRestoration = "manual";
    const onScroll = (event)=>{
        if (ignoreScroll || !router.isScrollRestoring) return;
        let elementSelector = "";
        if (event.target === document || event.target === window) elementSelector = "window";
        else {
            const attrId = event.target.getAttribute("data-scroll-restoration-id");
            if (attrId) elementSelector = `[data-scroll-restoration-id="${attrId}"]`;
            else elementSelector = getCssSelector(event.target);
        }
        const restoreKey = getKey(router.state.location);
        scrollRestorationCache.set((state)=>{
            const keyEntry = state[restoreKey] ||= {};
            const elementEntry = keyEntry[elementSelector] ||= {};
            if (elementSelector === "window") {
                elementEntry.scrollX = window.scrollX || 0;
                elementEntry.scrollY = window.scrollY || 0;
            } else if (elementSelector) {
                const element = document.querySelector(elementSelector);
                if (element) {
                    elementEntry.scrollX = element.scrollLeft || 0;
                    elementEntry.scrollY = element.scrollTop || 0;
                }
            }
            return state;
        });
    };
    if (typeof document !== "undefined") document.addEventListener("scroll", throttle(onScroll, 100), true);
    router.subscribe("onRendered", (event)=>{
        const cacheKey = getKey(event.toLocation);
        if (!router.resetNextScroll) {
            router.resetNextScroll = true;
            return;
        }
        if (typeof router.options.scrollRestoration === "function") {
            const shouldRestore = router.options.scrollRestoration({
                location: router.latestLocation
            });
            if (!shouldRestore) return;
        }
        restoreScroll({
            storageKey,
            key: cacheKey,
            behavior: router.options.scrollRestorationBehavior,
            shouldScrollRestoration: router.isScrollRestoring,
            scrollToTopSelectors: router.options.scrollToTopSelectors,
            location: router.history.location
        });
        if (router.isScrollRestoring) scrollRestorationCache.set((state)=>{
            state[cacheKey] ||= {};
            return state;
        });
    });
}
function handleHashScroll(router) {
    if (typeof document !== "undefined" && document.querySelector) {
        const hashScrollIntoViewOptions = router.state.location.state.__hashScrollIntoViewOptions ?? true;
        if (hashScrollIntoViewOptions && router.state.location.hash !== "") {
            const el = document.getElementById(router.state.location.hash);
            if (el) el.scrollIntoView(hashScrollIntoViewOptions);
        }
    }
}

},{"./utils.js":"eTTD3","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"e6EqZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultParseSearch", ()=>defaultParseSearch);
parcelHelpers.export(exports, "defaultStringifySearch", ()=>defaultStringifySearch);
parcelHelpers.export(exports, "parseSearchWith", ()=>parseSearchWith);
parcelHelpers.export(exports, "stringifySearchWith", ()=>stringifySearchWith);
var _qssJs = require("./qss.js");
const defaultParseSearch = parseSearchWith(JSON.parse);
const defaultStringifySearch = stringifySearchWith(JSON.stringify, JSON.parse);
function parseSearchWith(parser) {
    return (searchStr)=>{
        if (searchStr[0] === "?") searchStr = searchStr.substring(1);
        const query = (0, _qssJs.decode)(searchStr);
        for(const key in query){
            const value = query[key];
            if (typeof value === "string") try {
                query[key] = parser(value);
            } catch (_err) {}
        }
        return query;
    };
}
function stringifySearchWith(stringify, parser) {
    const hasParser = typeof parser === "function";
    function stringifyValue(val) {
        if (typeof val === "object" && val !== null) try {
            return stringify(val);
        } catch (_err) {}
        else if (hasParser && typeof val === "string") try {
            parser(val);
            return stringify(val);
        } catch (_err) {}
        return val;
    }
    return (search)=>{
        const searchStr = (0, _qssJs.encode)(search, stringifyValue);
        return searchStr ? `?${searchStr}` : "";
    };
}

},{"./qss.js":"bPmLp","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bPmLp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "encode", ()=>encode);
function encode(obj, stringify = String) {
    const result = new URLSearchParams();
    for(const key in obj){
        const val = obj[key];
        if (val !== void 0) result.set(key, stringify(val));
    }
    return result.toString();
}
function toValue(str) {
    if (!str) return "";
    if (str === "false") return false;
    if (str === "true") return true;
    return +str * 0 === 0 && +str + "" === str ? +str : str;
}
function decode(str) {
    const searchParams = new URLSearchParams(str);
    const result = {};
    for (const [key, value] of searchParams.entries()){
        const previousValue = result[key];
        if (previousValue == null) result[key] = toValue(value);
        else if (Array.isArray(previousValue)) previousValue.push(toValue(value));
        else result[key] = [
            previousValue,
            toValue(value)
        ];
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fMO9U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rootRouteId", ()=>rootRouteId);
const rootRouteId = "__root__";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jmFxY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRedirect", ()=>isRedirect);
parcelHelpers.export(exports, "isResolvedRedirect", ()=>isResolvedRedirect);
parcelHelpers.export(exports, "parseRedirect", ()=>parseRedirect);
parcelHelpers.export(exports, "redirect", ()=>redirect);
function redirect(opts) {
    opts.statusCode = opts.statusCode || opts.code || 307;
    if (!opts.reloadDocument && typeof opts.href === "string") try {
        new URL(opts.href);
        opts.reloadDocument = true;
    } catch  {}
    const headers = new Headers(opts.headers);
    if (opts.href && headers.get("Location") === null) headers.set("Location", opts.href);
    const response = new Response(null, {
        status: opts.statusCode,
        headers
    });
    response.options = opts;
    if (opts.throw) throw response;
    return response;
}
function isRedirect(obj) {
    return obj instanceof Response && !!obj.options;
}
function isResolvedRedirect(obj) {
    return isRedirect(obj) && !!obj.options.href;
}
function parseRedirect(obj) {
    if (obj !== null && typeof obj === "object" && obj.isSerializedRedirect) return redirect(obj);
    return void 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"aGMJX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "componentTypes", ()=>componentTypes);
parcelHelpers.export(exports, "loadMatches", ()=>loadMatches);
parcelHelpers.export(exports, "loadRouteChunk", ()=>loadRouteChunk);
parcelHelpers.export(exports, "routeNeedsPreload", ()=>routeNeedsPreload);
var _store = require("@tanstack/store");
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _utilsJs = require("./utils.js");
var _notFoundJs = require("./not-found.js");
var _rootJs = require("./root.js");
var _redirectJs = require("./redirect.js");
const triggerOnReady = (inner)=>{
    if (!inner.rendered) {
        inner.rendered = true;
        return inner.onReady?.();
    }
};
const resolvePreload = (inner, matchId)=>{
    return !!(inner.preload && !inner.router.state.matches.some((d)=>d.id === matchId));
};
const _handleNotFound = (inner, err)=>{
    const routeCursor = inner.router.routesById[err.routeId ?? ""] ?? inner.router.routeTree;
    if (!routeCursor.options.notFoundComponent && inner.router.options?.defaultNotFoundComponent) routeCursor.options.notFoundComponent = inner.router.options.defaultNotFoundComponent;
    (0, _tinyInvariantDefault.default)(routeCursor.options.notFoundComponent, "No notFoundComponent found. Please set a notFoundComponent on your route or provide a defaultNotFoundComponent to the router.");
    const matchForRoute = inner.matches.find((m)=>m.routeId === routeCursor.id);
    (0, _tinyInvariantDefault.default)(matchForRoute, "Could not find match for route: " + routeCursor.id);
    inner.updateMatch(matchForRoute.id, (prev)=>({
            ...prev,
            status: "notFound",
            error: err,
            isFetching: false
        }));
    if (err.routerCode === "BEFORE_LOAD" && routeCursor.parentRoute) {
        err.routeId = routeCursor.parentRoute.id;
        _handleNotFound(inner, err);
    }
};
const handleRedirectAndNotFound = (inner, match, err)=>{
    if (!(0, _redirectJs.isRedirect)(err) && !(0, _notFoundJs.isNotFound)(err)) return;
    if ((0, _redirectJs.isRedirect)(err) && err.redirectHandled && !err.options.reloadDocument) throw err;
    if (match) {
        match._nonReactive.beforeLoadPromise?.resolve();
        match._nonReactive.loaderPromise?.resolve();
        match._nonReactive.beforeLoadPromise = void 0;
        match._nonReactive.loaderPromise = void 0;
        const status = (0, _redirectJs.isRedirect)(err) ? "redirected" : "notFound";
        match._nonReactive.error = err;
        inner.updateMatch(match.id, (prev)=>({
                ...prev,
                status,
                isFetching: false,
                error: err
            }));
        if ((0, _notFoundJs.isNotFound)(err) && !err.routeId) err.routeId = match.routeId;
        match._nonReactive.loadPromise?.resolve();
    }
    if ((0, _redirectJs.isRedirect)(err)) {
        inner.rendered = true;
        err.options._fromLocation = inner.location;
        err.redirectHandled = true;
        err = inner.router.resolveRedirect(err);
        throw err;
    } else {
        _handleNotFound(inner, err);
        throw err;
    }
};
const shouldSkipLoader = (inner, matchId)=>{
    const match = inner.router.getMatch(matchId);
    if (!inner.router.isServer && match._nonReactive.dehydrated) return true;
    if (inner.router.isServer && match.ssr === false) return true;
    return false;
};
const handleSerialError = (inner, index, err, routerCode)=>{
    const { id: matchId, routeId } = inner.matches[index];
    const route = inner.router.looseRoutesById[routeId];
    if (err instanceof Promise) throw err;
    err.routerCode = routerCode;
    inner.firstBadMatchIndex ??= index;
    handleRedirectAndNotFound(inner, inner.router.getMatch(matchId), err);
    try {
        route.options.onError?.(err);
    } catch (errorHandlerErr) {
        err = errorHandlerErr;
        handleRedirectAndNotFound(inner, inner.router.getMatch(matchId), err);
    }
    inner.updateMatch(matchId, (prev)=>{
        prev._nonReactive.beforeLoadPromise?.resolve();
        prev._nonReactive.beforeLoadPromise = void 0;
        prev._nonReactive.loadPromise?.resolve();
        return {
            ...prev,
            error: err,
            status: "error",
            isFetching: false,
            updatedAt: Date.now(),
            abortController: new AbortController()
        };
    });
};
const isBeforeLoadSsr = (inner, matchId, index, route)=>{
    const existingMatch = inner.router.getMatch(matchId);
    const parentMatchId = inner.matches[index - 1]?.id;
    const parentMatch = parentMatchId ? inner.router.getMatch(parentMatchId) : void 0;
    if (inner.router.isShell()) {
        existingMatch.ssr = route.id === (0, _rootJs.rootRouteId);
        return;
    }
    if (parentMatch?.ssr === false) {
        existingMatch.ssr = false;
        return;
    }
    const parentOverride = (tempSsr2)=>{
        if (tempSsr2 === true && parentMatch?.ssr === "data-only") return "data-only";
        return tempSsr2;
    };
    const defaultSsr = inner.router.options.defaultSsr ?? true;
    if (route.options.ssr === void 0) {
        existingMatch.ssr = parentOverride(defaultSsr);
        return;
    }
    if (typeof route.options.ssr !== "function") {
        existingMatch.ssr = parentOverride(route.options.ssr);
        return;
    }
    const { search, params } = existingMatch;
    const ssrFnContext = {
        search: makeMaybe(search, existingMatch.searchError),
        params: makeMaybe(params, existingMatch.paramsError),
        location: inner.location,
        matches: inner.matches.map((match)=>({
                index: match.index,
                pathname: match.pathname,
                fullPath: match.fullPath,
                staticData: match.staticData,
                id: match.id,
                routeId: match.routeId,
                search: makeMaybe(match.search, match.searchError),
                params: makeMaybe(match.params, match.paramsError),
                ssr: match.ssr
            }))
    };
    const tempSsr = route.options.ssr(ssrFnContext);
    if ((0, _utilsJs.isPromise)(tempSsr)) return tempSsr.then((ssr)=>{
        existingMatch.ssr = parentOverride(ssr ?? defaultSsr);
    });
    existingMatch.ssr = parentOverride(tempSsr ?? defaultSsr);
    return;
};
const setupPendingTimeout = (inner, matchId, route, match)=>{
    if (match._nonReactive.pendingTimeout !== void 0) return;
    const pendingMs = route.options.pendingMs ?? inner.router.options.defaultPendingMs;
    const shouldPending = !!(inner.onReady && !inner.router.isServer && !resolvePreload(inner, matchId) && (route.options.loader || route.options.beforeLoad || routeNeedsPreload(route)) && typeof pendingMs === "number" && pendingMs !== Infinity && (route.options.pendingComponent ?? inner.router.options?.defaultPendingComponent));
    if (shouldPending) {
        const pendingTimeout = setTimeout(()=>{
            triggerOnReady(inner);
        }, pendingMs);
        match._nonReactive.pendingTimeout = pendingTimeout;
    }
};
const preBeforeLoadSetup = (inner, matchId, route)=>{
    const existingMatch = inner.router.getMatch(matchId);
    if (!existingMatch._nonReactive.beforeLoadPromise && !existingMatch._nonReactive.loaderPromise) return;
    setupPendingTimeout(inner, matchId, route, existingMatch);
    const then = ()=>{
        const match = inner.router.getMatch(matchId);
        if (match.preload && (match.status === "redirected" || match.status === "notFound")) handleRedirectAndNotFound(inner, match, match.error);
    };
    return existingMatch._nonReactive.beforeLoadPromise ? existingMatch._nonReactive.beforeLoadPromise.then(then) : then();
};
const executeBeforeLoad = (inner, matchId, index, route)=>{
    const match = inner.router.getMatch(matchId);
    const prevLoadPromise = match._nonReactive.loadPromise;
    match._nonReactive.loadPromise = (0, _utilsJs.createControlledPromise)(()=>{
        prevLoadPromise?.resolve();
    });
    const { paramsError, searchError } = match;
    if (paramsError) handleSerialError(inner, index, paramsError, "PARSE_PARAMS");
    if (searchError) handleSerialError(inner, index, searchError, "VALIDATE_SEARCH");
    setupPendingTimeout(inner, matchId, route, match);
    const abortController = new AbortController();
    const parentMatchId = inner.matches[index - 1]?.id;
    const parentMatch = parentMatchId ? inner.router.getMatch(parentMatchId) : void 0;
    const parentMatchContext = parentMatch?.context ?? inner.router.options.context ?? void 0;
    const context = {
        ...parentMatchContext,
        ...match.__routeContext
    };
    let isPending = false;
    const pending = ()=>{
        if (isPending) return;
        isPending = true;
        inner.updateMatch(matchId, (prev)=>({
                ...prev,
                isFetching: "beforeLoad",
                fetchCount: prev.fetchCount + 1,
                abortController,
                context
            }));
    };
    const resolve = ()=>{
        match._nonReactive.beforeLoadPromise?.resolve();
        match._nonReactive.beforeLoadPromise = void 0;
        inner.updateMatch(matchId, (prev)=>({
                ...prev,
                isFetching: false
            }));
    };
    if (!route.options.beforeLoad) {
        (0, _store.batch)(()=>{
            pending();
            resolve();
        });
        return;
    }
    match._nonReactive.beforeLoadPromise = (0, _utilsJs.createControlledPromise)();
    const { search, params, cause } = match;
    const preload = resolvePreload(inner, matchId);
    const beforeLoadFnContext = {
        search,
        abortController,
        params,
        preload,
        context,
        location: inner.location,
        navigate: (opts)=>inner.router.navigate({
                ...opts,
                _fromLocation: inner.location
            }),
        buildLocation: inner.router.buildLocation,
        cause: preload ? "preload" : cause,
        matches: inner.matches,
        ...inner.router.options.additionalContext
    };
    const updateContext = (beforeLoadContext2)=>{
        if (beforeLoadContext2 === void 0) {
            (0, _store.batch)(()=>{
                pending();
                resolve();
            });
            return;
        }
        if ((0, _redirectJs.isRedirect)(beforeLoadContext2) || (0, _notFoundJs.isNotFound)(beforeLoadContext2)) {
            pending();
            handleSerialError(inner, index, beforeLoadContext2, "BEFORE_LOAD");
        }
        (0, _store.batch)(()=>{
            pending();
            inner.updateMatch(matchId, (prev)=>({
                    ...prev,
                    __beforeLoadContext: beforeLoadContext2,
                    context: {
                        ...prev.context,
                        ...beforeLoadContext2
                    }
                }));
            resolve();
        });
    };
    let beforeLoadContext;
    try {
        beforeLoadContext = route.options.beforeLoad(beforeLoadFnContext);
        if ((0, _utilsJs.isPromise)(beforeLoadContext)) {
            pending();
            return beforeLoadContext.catch((err)=>{
                handleSerialError(inner, index, err, "BEFORE_LOAD");
            }).then(updateContext);
        }
    } catch (err) {
        pending();
        handleSerialError(inner, index, err, "BEFORE_LOAD");
    }
    updateContext(beforeLoadContext);
    return;
};
const handleBeforeLoad = (inner, index)=>{
    const { id: matchId, routeId } = inner.matches[index];
    const route = inner.router.looseRoutesById[routeId];
    const serverSsr = ()=>{
        if (inner.router.isServer) {
            const maybePromise = isBeforeLoadSsr(inner, matchId, index, route);
            if ((0, _utilsJs.isPromise)(maybePromise)) return maybePromise.then(queueExecution);
        }
        return queueExecution();
    };
    const execute = ()=>executeBeforeLoad(inner, matchId, index, route);
    const queueExecution = ()=>{
        if (shouldSkipLoader(inner, matchId)) return;
        const result = preBeforeLoadSetup(inner, matchId, route);
        return (0, _utilsJs.isPromise)(result) ? result.then(execute) : execute();
    };
    return serverSsr();
};
const executeHead = (inner, matchId, route)=>{
    const match = inner.router.getMatch(matchId);
    if (!match) return;
    if (!route.options.head && !route.options.scripts && !route.options.headers) return;
    const assetContext = {
        matches: inner.matches,
        match,
        params: match.params,
        loaderData: match.loaderData
    };
    return Promise.all([
        route.options.head?.(assetContext),
        route.options.scripts?.(assetContext),
        route.options.headers?.(assetContext)
    ]).then(([headFnContent, scripts, headers])=>{
        const meta = headFnContent?.meta;
        const links = headFnContent?.links;
        const headScripts = headFnContent?.scripts;
        const styles = headFnContent?.styles;
        return {
            meta,
            links,
            headScripts,
            headers,
            scripts,
            styles
        };
    });
};
const getLoaderContext = (inner, matchId, index, route)=>{
    const parentMatchPromise = inner.matchPromises[index - 1];
    const { params, loaderDeps, abortController, cause } = inner.router.getMatch(matchId);
    let context = inner.router.options.context ?? {};
    for(let i = 0; i <= index; i++){
        const innerMatch = inner.matches[i];
        if (!innerMatch) continue;
        const m = inner.router.getMatch(innerMatch.id);
        if (!m) continue;
        context = {
            ...context,
            ...m.__routeContext ?? {},
            ...m.__beforeLoadContext ?? {}
        };
    }
    const preload = resolvePreload(inner, matchId);
    return {
        params,
        deps: loaderDeps,
        preload: !!preload,
        parentMatchPromise,
        abortController,
        context,
        location: inner.location,
        navigate: (opts)=>inner.router.navigate({
                ...opts,
                _fromLocation: inner.location
            }),
        cause: preload ? "preload" : cause,
        route,
        ...inner.router.options.additionalContext
    };
};
const runLoader = async (inner, matchId, index, route)=>{
    try {
        const match = inner.router.getMatch(matchId);
        try {
            if (!inner.router.isServer || match.ssr === true) loadRouteChunk(route);
            const loaderResult = route.options.loader?.(getLoaderContext(inner, matchId, index, route));
            const loaderResultIsPromise = route.options.loader && (0, _utilsJs.isPromise)(loaderResult);
            const willLoadSomething = !!(loaderResultIsPromise || route._lazyPromise || route._componentsPromise || route.options.head || route.options.scripts || route.options.headers || match._nonReactive.minPendingPromise);
            if (willLoadSomething) inner.updateMatch(matchId, (prev)=>({
                    ...prev,
                    isFetching: "loader"
                }));
            if (route.options.loader) {
                const loaderData = loaderResultIsPromise ? await loaderResult : loaderResult;
                handleRedirectAndNotFound(inner, inner.router.getMatch(matchId), loaderData);
                if (loaderData !== void 0) inner.updateMatch(matchId, (prev)=>({
                        ...prev,
                        loaderData
                    }));
            }
            if (route._lazyPromise) await route._lazyPromise;
            const headResult = executeHead(inner, matchId, route);
            const head = headResult ? await headResult : void 0;
            const pendingPromise = match._nonReactive.minPendingPromise;
            if (pendingPromise) await pendingPromise;
            if (route._componentsPromise) await route._componentsPromise;
            inner.updateMatch(matchId, (prev)=>({
                    ...prev,
                    error: void 0,
                    status: "success",
                    isFetching: false,
                    updatedAt: Date.now(),
                    ...head
                }));
        } catch (e) {
            let error = e;
            const pendingPromise = match._nonReactive.minPendingPromise;
            if (pendingPromise) await pendingPromise;
            if ((0, _notFoundJs.isNotFound)(e)) await route.options.notFoundComponent?.preload?.();
            handleRedirectAndNotFound(inner, inner.router.getMatch(matchId), e);
            try {
                route.options.onError?.(e);
            } catch (onErrorError) {
                error = onErrorError;
                handleRedirectAndNotFound(inner, inner.router.getMatch(matchId), onErrorError);
            }
            const headResult = executeHead(inner, matchId, route);
            const head = headResult ? await headResult : void 0;
            inner.updateMatch(matchId, (prev)=>({
                    ...prev,
                    error,
                    status: "error",
                    isFetching: false,
                    ...head
                }));
        }
    } catch (err) {
        const match = inner.router.getMatch(matchId);
        if (match) {
            const headResult = executeHead(inner, matchId, route);
            if (headResult) {
                const head = await headResult;
                inner.updateMatch(matchId, (prev)=>({
                        ...prev,
                        ...head
                    }));
            }
            match._nonReactive.loaderPromise = void 0;
        }
        handleRedirectAndNotFound(inner, match, err);
    }
};
const loadRouteMatch = async (inner, index)=>{
    const { id: matchId, routeId } = inner.matches[index];
    let loaderShouldRunAsync = false;
    let loaderIsRunningAsync = false;
    const route = inner.router.looseRoutesById[routeId];
    if (shouldSkipLoader(inner, matchId)) {
        if (inner.router.isServer) {
            const headResult = executeHead(inner, matchId, route);
            if (headResult) {
                const head = await headResult;
                inner.updateMatch(matchId, (prev)=>({
                        ...prev,
                        ...head
                    }));
            }
            return inner.router.getMatch(matchId);
        }
    } else {
        const prevMatch = inner.router.getMatch(matchId);
        if (prevMatch._nonReactive.loaderPromise) {
            if (prevMatch.status === "success" && !inner.sync && !prevMatch.preload) return prevMatch;
            await prevMatch._nonReactive.loaderPromise;
            const match2 = inner.router.getMatch(matchId);
            const error = match2._nonReactive.error || match2.error;
            if (error) handleRedirectAndNotFound(inner, match2, error);
        } else {
            const age = Date.now() - prevMatch.updatedAt;
            const preload = resolvePreload(inner, matchId);
            const staleAge = preload ? route.options.preloadStaleTime ?? inner.router.options.defaultPreloadStaleTime ?? 3e4 : route.options.staleTime ?? inner.router.options.defaultStaleTime ?? 0;
            const shouldReloadOption = route.options.shouldReload;
            const shouldReload = typeof shouldReloadOption === "function" ? shouldReloadOption(getLoaderContext(inner, matchId, index, route)) : shouldReloadOption;
            const nextPreload = !!preload && !inner.router.state.matches.some((d)=>d.id === matchId);
            const match2 = inner.router.getMatch(matchId);
            match2._nonReactive.loaderPromise = (0, _utilsJs.createControlledPromise)();
            if (nextPreload !== match2.preload) inner.updateMatch(matchId, (prev)=>({
                    ...prev,
                    preload: nextPreload
                }));
            const { status, invalid } = match2;
            loaderShouldRunAsync = status === "success" && (invalid || (shouldReload ?? age > staleAge));
            if (preload && route.options.preload === false) ;
            else if (loaderShouldRunAsync && !inner.sync) {
                loaderIsRunningAsync = true;
                (async ()=>{
                    try {
                        await runLoader(inner, matchId, index, route);
                        const match3 = inner.router.getMatch(matchId);
                        match3._nonReactive.loaderPromise?.resolve();
                        match3._nonReactive.loadPromise?.resolve();
                        match3._nonReactive.loaderPromise = void 0;
                    } catch (err) {
                        if ((0, _redirectJs.isRedirect)(err)) await inner.router.navigate(err.options);
                    }
                })();
            } else if (status !== "success" || loaderShouldRunAsync && inner.sync) await runLoader(inner, matchId, index, route);
            else {
                const headResult = executeHead(inner, matchId, route);
                if (headResult) {
                    const head = await headResult;
                    inner.updateMatch(matchId, (prev)=>({
                            ...prev,
                            ...head
                        }));
                }
            }
        }
    }
    const match = inner.router.getMatch(matchId);
    if (!loaderIsRunningAsync) {
        match._nonReactive.loaderPromise?.resolve();
        match._nonReactive.loadPromise?.resolve();
    }
    clearTimeout(match._nonReactive.pendingTimeout);
    match._nonReactive.pendingTimeout = void 0;
    if (!loaderIsRunningAsync) match._nonReactive.loaderPromise = void 0;
    match._nonReactive.dehydrated = void 0;
    const nextIsFetching = loaderIsRunningAsync ? match.isFetching : false;
    if (nextIsFetching !== match.isFetching || match.invalid !== false) {
        inner.updateMatch(matchId, (prev)=>({
                ...prev,
                isFetching: nextIsFetching,
                invalid: false
            }));
        return inner.router.getMatch(matchId);
    } else return match;
};
async function loadMatches(arg) {
    const inner = Object.assign(arg, {
        matchPromises: []
    });
    if (!inner.router.isServer && inner.router.state.matches.some((d)=>d._forcePending)) triggerOnReady(inner);
    try {
        for(let i = 0; i < inner.matches.length; i++){
            const beforeLoad = handleBeforeLoad(inner, i);
            if ((0, _utilsJs.isPromise)(beforeLoad)) await beforeLoad;
        }
        const max = inner.firstBadMatchIndex ?? inner.matches.length;
        for(let i = 0; i < max; i++)inner.matchPromises.push(loadRouteMatch(inner, i));
        await Promise.all(inner.matchPromises);
        const readyPromise = triggerOnReady(inner);
        if ((0, _utilsJs.isPromise)(readyPromise)) await readyPromise;
    } catch (err) {
        if ((0, _notFoundJs.isNotFound)(err) && !inner.preload) {
            const readyPromise = triggerOnReady(inner);
            if ((0, _utilsJs.isPromise)(readyPromise)) await readyPromise;
            throw err;
        }
        if ((0, _redirectJs.isRedirect)(err)) throw err;
    }
    return inner.matches;
}
async function loadRouteChunk(route) {
    if (!route._lazyLoaded && route._lazyPromise === void 0) {
        if (route.lazyFn) route._lazyPromise = route.lazyFn().then((lazyRoute)=>{
            const { id: _id, ...options } = lazyRoute.options;
            Object.assign(route.options, options);
            route._lazyLoaded = true;
            route._lazyPromise = void 0;
        });
        else route._lazyLoaded = true;
    }
    if (!route._componentsLoaded && route._componentsPromise === void 0) {
        const loadComponents = ()=>{
            const preloads = [];
            for (const type of componentTypes){
                const preload = route.options[type]?.preload;
                if (preload) preloads.push(preload());
            }
            if (preloads.length) return Promise.all(preloads).then(()=>{
                route._componentsLoaded = true;
                route._componentsPromise = void 0;
            });
            route._componentsLoaded = true;
            route._componentsPromise = void 0;
            return;
        };
        route._componentsPromise = route._lazyPromise ? route._lazyPromise.then(loadComponents) : loadComponents();
    }
    return route._componentsPromise;
}
function makeMaybe(value, error) {
    if (error) return {
        status: "error",
        error
    };
    return {
        status: "success",
        value
    };
}
function routeNeedsPreload(route) {
    for (const componentType of componentTypes){
        if (route.options[componentType]?.preload) return true;
    }
    return false;
}
const componentTypes = [
    "component",
    "errorComponent",
    "pendingComponent",
    "notFoundComponent"
];

},{"@tanstack/store":"3YSNI","tiny-invariant":"4qfOO","./utils.js":"eTTD3","./not-found.js":"aBKKv","./root.js":"fMO9U","./redirect.js":"jmFxY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"a0IRc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeRewrites", ()=>composeRewrites);
parcelHelpers.export(exports, "executeRewriteInput", ()=>executeRewriteInput);
parcelHelpers.export(exports, "executeRewriteOutput", ()=>executeRewriteOutput);
parcelHelpers.export(exports, "rewriteBasepath", ()=>rewriteBasepath);
var _pathJs = require("./path.js");
function composeRewrites(rewrites) {
    return {
        input: ({ url })=>{
            for (const rewrite of rewrites)url = executeRewriteInput(rewrite, url);
            return url;
        },
        output: ({ url })=>{
            for(let i = rewrites.length - 1; i >= 0; i--)url = executeRewriteOutput(rewrites[i], url);
            return url;
        }
    };
}
function rewriteBasepath(opts) {
    const trimmedBasepath = (0, _pathJs.trimPath)(opts.basepath);
    const normalizedBasepath = `/${trimmedBasepath}`;
    const normalizedBasepathWithSlash = `${normalizedBasepath}/`;
    const checkBasepath = opts.caseSensitive ? normalizedBasepath : normalizedBasepath.toLowerCase();
    const checkBasepathWithSlash = opts.caseSensitive ? normalizedBasepathWithSlash : normalizedBasepathWithSlash.toLowerCase();
    return {
        input: ({ url })=>{
            const pathname = opts.caseSensitive ? url.pathname : url.pathname.toLowerCase();
            if (pathname === checkBasepath) url.pathname = "/";
            else if (pathname.startsWith(checkBasepathWithSlash)) url.pathname = url.pathname.slice(normalizedBasepath.length);
            return url;
        },
        output: ({ url })=>{
            url.pathname = (0, _pathJs.joinPaths)([
                "/",
                trimmedBasepath,
                url.pathname
            ]);
            return url;
        }
    };
}
function executeRewriteInput(rewrite, url) {
    const res = rewrite?.input?.({
        url
    });
    if (res) {
        if (typeof res === "string") return new URL(res);
        else if (res instanceof URL) return res;
    }
    return url;
}
function executeRewriteOutput(rewrite, url) {
    const res = rewrite?.output?.({
        url
    });
    if (res) {
        if (typeof res === "string") return new URL(res);
        else if (res instanceof URL) return res;
    }
    return url;
}

},{"./path.js":"b4w6q","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dYDdb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FileRoute", ()=>FileRoute);
parcelHelpers.export(exports, "FileRouteLoader", ()=>FileRouteLoader);
parcelHelpers.export(exports, "LazyRoute", ()=>LazyRoute);
parcelHelpers.export(exports, "createFileRoute", ()=>createFileRoute);
parcelHelpers.export(exports, "createLazyFileRoute", ()=>createLazyFileRoute);
parcelHelpers.export(exports, "createLazyRoute", ()=>createLazyRoute);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _routeJs = require("./route.js");
var _useMatchJs = require("./useMatch.js");
var _useLoaderDepsJs = require("./useLoaderDeps.js");
var _useLoaderDataJs = require("./useLoaderData.js");
var _useSearchJs = require("./useSearch.js");
var _useParamsJs = require("./useParams.js");
var _useNavigateJs = require("./useNavigate.js");
var _useRouterJs = require("./useRouter.js");
function createFileRoute(path) {
    if (typeof path === "object") return new FileRoute(path, {
        silent: true
    }).createRoute(path);
    return new FileRoute(path, {
        silent: true
    }).createRoute;
}
class FileRoute {
    constructor(path, _opts){
        this.path = path;
        this.createRoute = (options)=>{
            (0, _tinyWarningDefault.default)(this.silent, "FileRoute is deprecated and will be removed in the next major version. Use the createFileRoute(path)(options) function instead.");
            const route = (0, _routeJs.createRoute)(options);
            route.isRoot = false;
            return route;
        };
        this.silent = _opts?.silent;
    }
}
function FileRouteLoader(_path) {
    (0, _tinyWarningDefault.default)(false, `FileRouteLoader is deprecated and will be removed in the next major version. Please place the loader function in the the main route file, inside the \`createFileRoute('/path/to/file')(options)\` options`);
    return (loaderFn)=>loaderFn;
}
class LazyRoute {
    constructor(opts){
        this.useMatch = (opts2)=>{
            return (0, _useMatchJs.useMatch)({
                select: opts2?.select,
                from: this.options.id,
                structuralSharing: opts2?.structuralSharing
            });
        };
        this.useRouteContext = (opts2)=>{
            return (0, _useMatchJs.useMatch)({
                from: this.options.id,
                select: (d)=>opts2?.select ? opts2.select(d.context) : d.context
            });
        };
        this.useSearch = (opts2)=>{
            return (0, _useSearchJs.useSearch)({
                select: opts2?.select,
                structuralSharing: opts2?.structuralSharing,
                from: this.options.id
            });
        };
        this.useParams = (opts2)=>{
            return (0, _useParamsJs.useParams)({
                select: opts2?.select,
                structuralSharing: opts2?.structuralSharing,
                from: this.options.id
            });
        };
        this.useLoaderDeps = (opts2)=>{
            return (0, _useLoaderDepsJs.useLoaderDeps)({
                ...opts2,
                from: this.options.id
            });
        };
        this.useLoaderData = (opts2)=>{
            return (0, _useLoaderDataJs.useLoaderData)({
                ...opts2,
                from: this.options.id
            });
        };
        this.useNavigate = ()=>{
            const router = (0, _useRouterJs.useRouter)();
            return (0, _useNavigateJs.useNavigate)({
                from: router.routesById[this.options.id].fullPath
            });
        };
        this.options = opts;
        this.$$typeof = Symbol.for("react.memo");
    }
}
function createLazyRoute(id) {
    return (opts)=>{
        return new LazyRoute({
            id,
            ...opts
        });
    };
}
function createLazyFileRoute(id) {
    if (typeof id === "object") return new LazyRoute(id);
    return (opts)=>new LazyRoute({
            id,
            ...opts
        });
}

},{"tiny-warning":"ifQ8B","./route.js":"hPO6R","./useMatch.js":"k5eUN","./useLoaderDeps.js":"liviV","./useLoaderData.js":"xCgSu","./useSearch.js":"4yVFL","./useParams.js":"jBvHB","./useNavigate.js":"aMhxM","./useRouter.js":"nz9fN","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ifQ8B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hPO6R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotFoundRoute", ()=>NotFoundRoute);
parcelHelpers.export(exports, "RootRoute", ()=>RootRoute);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "RouteApi", ()=>RouteApi);
parcelHelpers.export(exports, "createRootRoute", ()=>createRootRoute);
parcelHelpers.export(exports, "createRootRouteWithContext", ()=>createRootRouteWithContext);
parcelHelpers.export(exports, "createRoute", ()=>createRoute);
parcelHelpers.export(exports, "createRouteMask", ()=>createRouteMask);
parcelHelpers.export(exports, "getRouteApi", ()=>getRouteApi);
parcelHelpers.export(exports, "rootRouteWithContext", ()=>rootRouteWithContext);
var _jsxRuntime = require("react/jsx-runtime");
var _routerCore = require("@tanstack/router-core");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useLoaderDataJs = require("./useLoaderData.js");
var _useLoaderDepsJs = require("./useLoaderDeps.js");
var _useParamsJs = require("./useParams.js");
var _useSearchJs = require("./useSearch.js");
var _useNavigateJs = require("./useNavigate.js");
var _useMatchJs = require("./useMatch.js");
var _useRouterJs = require("./useRouter.js");
var _linkJs = require("./link.js");
function getRouteApi(id) {
    return new RouteApi({
        id
    });
}
class RouteApi extends (0, _routerCore.BaseRouteApi) {
    /**
   * @deprecated Use the `getRouteApi` function instead.
   */ constructor({ id }){
        super({
            id
        });
        this.useMatch = (opts)=>{
            return (0, _useMatchJs.useMatch)({
                select: opts?.select,
                from: this.id,
                structuralSharing: opts?.structuralSharing
            });
        };
        this.useRouteContext = (opts)=>{
            return (0, _useMatchJs.useMatch)({
                from: this.id,
                select: (d)=>opts?.select ? opts.select(d.context) : d.context
            });
        };
        this.useSearch = (opts)=>{
            return (0, _useSearchJs.useSearch)({
                select: opts?.select,
                structuralSharing: opts?.structuralSharing,
                from: this.id
            });
        };
        this.useParams = (opts)=>{
            return (0, _useParamsJs.useParams)({
                select: opts?.select,
                structuralSharing: opts?.structuralSharing,
                from: this.id
            });
        };
        this.useLoaderDeps = (opts)=>{
            return (0, _useLoaderDepsJs.useLoaderDeps)({
                ...opts,
                from: this.id,
                strict: false
            });
        };
        this.useLoaderData = (opts)=>{
            return (0, _useLoaderDataJs.useLoaderData)({
                ...opts,
                from: this.id,
                strict: false
            });
        };
        this.useNavigate = ()=>{
            const router = (0, _useRouterJs.useRouter)();
            return (0, _useNavigateJs.useNavigate)({
                from: router.routesById[this.id].fullPath
            });
        };
        this.notFound = (opts)=>{
            return (0, _routerCore.notFound)({
                routeId: this.id,
                ...opts
            });
        };
        this.Link = (0, _reactDefault.default).forwardRef((props, ref)=>{
            const router = (0, _useRouterJs.useRouter)();
            const fullPath = router.routesById[this.id].fullPath;
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _linkJs.Link), {
                ref,
                from: fullPath,
                ...props
            });
        });
    }
}
class Route extends (0, _routerCore.BaseRoute) {
    /**
   * @deprecated Use the `createRoute` function instead.
   */ constructor(options){
        super(options);
        this.useMatch = (opts)=>{
            return (0, _useMatchJs.useMatch)({
                select: opts?.select,
                from: this.id,
                structuralSharing: opts?.structuralSharing
            });
        };
        this.useRouteContext = (opts)=>{
            return (0, _useMatchJs.useMatch)({
                ...opts,
                from: this.id,
                select: (d)=>opts?.select ? opts.select(d.context) : d.context
            });
        };
        this.useSearch = (opts)=>{
            return (0, _useSearchJs.useSearch)({
                select: opts?.select,
                structuralSharing: opts?.structuralSharing,
                from: this.id
            });
        };
        this.useParams = (opts)=>{
            return (0, _useParamsJs.useParams)({
                select: opts?.select,
                structuralSharing: opts?.structuralSharing,
                from: this.id
            });
        };
        this.useLoaderDeps = (opts)=>{
            return (0, _useLoaderDepsJs.useLoaderDeps)({
                ...opts,
                from: this.id
            });
        };
        this.useLoaderData = (opts)=>{
            return (0, _useLoaderDataJs.useLoaderData)({
                ...opts,
                from: this.id
            });
        };
        this.useNavigate = ()=>{
            return (0, _useNavigateJs.useNavigate)({
                from: this.fullPath
            });
        };
        this.Link = (0, _reactDefault.default).forwardRef((props, ref)=>{
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _linkJs.Link), {
                ref,
                from: this.fullPath,
                ...props
            });
        });
        this.$$typeof = Symbol.for("react.memo");
    }
}
function createRoute(options) {
    return new Route(// TODO: Help us TypeChris, you're our only hope!
    options);
}
function createRootRouteWithContext() {
    return (options)=>{
        return createRootRoute(options);
    };
}
const rootRouteWithContext = createRootRouteWithContext;
class RootRoute extends (0, _routerCore.BaseRootRoute) {
    /**
   * @deprecated `RootRoute` is now an internal implementation detail. Use `createRootRoute()` instead.
   */ constructor(options){
        super(options);
        this.useMatch = (opts)=>{
            return (0, _useMatchJs.useMatch)({
                select: opts?.select,
                from: this.id,
                structuralSharing: opts?.structuralSharing
            });
        };
        this.useRouteContext = (opts)=>{
            return (0, _useMatchJs.useMatch)({
                ...opts,
                from: this.id,
                select: (d)=>opts?.select ? opts.select(d.context) : d.context
            });
        };
        this.useSearch = (opts)=>{
            return (0, _useSearchJs.useSearch)({
                select: opts?.select,
                structuralSharing: opts?.structuralSharing,
                from: this.id
            });
        };
        this.useParams = (opts)=>{
            return (0, _useParamsJs.useParams)({
                select: opts?.select,
                structuralSharing: opts?.structuralSharing,
                from: this.id
            });
        };
        this.useLoaderDeps = (opts)=>{
            return (0, _useLoaderDepsJs.useLoaderDeps)({
                ...opts,
                from: this.id
            });
        };
        this.useLoaderData = (opts)=>{
            return (0, _useLoaderDataJs.useLoaderData)({
                ...opts,
                from: this.id
            });
        };
        this.useNavigate = ()=>{
            return (0, _useNavigateJs.useNavigate)({
                from: this.fullPath
            });
        };
        this.Link = (0, _reactDefault.default).forwardRef((props, ref)=>{
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _linkJs.Link), {
                ref,
                from: this.fullPath,
                ...props
            });
        });
        this.$$typeof = Symbol.for("react.memo");
    }
}
function createRootRoute(options) {
    return new RootRoute(options);
}
function createRouteMask(opts) {
    return opts;
}
class NotFoundRoute extends Route {
    constructor(options){
        super({
            ...options,
            id: "404"
        });
    }
}

},{"react/jsx-runtime":"dQjte","@tanstack/router-core":[["BaseRootRoute","cZMtL"],["BaseRoute","cZMtL"],["BaseRouteApi","cZMtL"],["notFound","aBKKv"]],"react":"eGun2","./useLoaderData.js":"xCgSu","./useLoaderDeps.js":"liviV","./useParams.js":"jBvHB","./useSearch.js":"4yVFL","./useNavigate.js":"aMhxM","./useMatch.js":"k5eUN","./useRouter.js":"nz9fN","./link.js":"7k6Lq","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cZMtL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseRootRoute", ()=>BaseRootRoute);
parcelHelpers.export(exports, "BaseRoute", ()=>BaseRoute);
parcelHelpers.export(exports, "BaseRouteApi", ()=>BaseRouteApi);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _pathJs = require("./path.js");
var _notFoundJs = require("./not-found.js");
var _rootJs = require("./root.js");
class BaseRoute {
    constructor(options){
        this.init = (opts)=>{
            this.originalIndex = opts.originalIndex;
            const options2 = this.options;
            const isRoot = !options2?.path && !options2?.id;
            this.parentRoute = this.options.getParentRoute?.();
            if (isRoot) this._path = (0, _rootJs.rootRouteId);
            else if (!this.parentRoute) (0, _tinyInvariantDefault.default)(false, `Child Route instances must pass a 'getParentRoute: () => ParentRoute' option that returns a Route instance.`);
            let path = isRoot ? (0, _rootJs.rootRouteId) : options2?.path;
            if (path && path !== "/") path = (0, _pathJs.trimPathLeft)(path);
            const customId = options2?.id || path;
            let id = isRoot ? (0, _rootJs.rootRouteId) : (0, _pathJs.joinPaths)([
                this.parentRoute.id === (0, _rootJs.rootRouteId) ? "" : this.parentRoute.id,
                customId
            ]);
            if (path === (0, _rootJs.rootRouteId)) path = "/";
            if (id !== (0, _rootJs.rootRouteId)) id = (0, _pathJs.joinPaths)([
                "/",
                id
            ]);
            const fullPath = id === (0, _rootJs.rootRouteId) ? "/" : (0, _pathJs.joinPaths)([
                this.parentRoute.fullPath,
                path
            ]);
            this._path = path;
            this._id = id;
            this._fullPath = fullPath;
            this._to = fullPath;
        };
        this.addChildren = (children)=>{
            return this._addFileChildren(children);
        };
        this._addFileChildren = (children)=>{
            if (Array.isArray(children)) this.children = children;
            if (typeof children === "object" && children !== null) this.children = Object.values(children);
            return this;
        };
        this._addFileTypes = ()=>{
            return this;
        };
        this.updateLoader = (options2)=>{
            Object.assign(this.options, options2);
            return this;
        };
        this.update = (options2)=>{
            Object.assign(this.options, options2);
            return this;
        };
        this.lazy = (lazyFn)=>{
            this.lazyFn = lazyFn;
            return this;
        };
        this.options = options || {};
        this.isRoot = !options?.getParentRoute;
        if (options?.id && options?.path) throw new Error(`Route cannot have both an 'id' and a 'path' option.`);
    }
    get to() {
        return this._to;
    }
    get id() {
        return this._id;
    }
    get path() {
        return this._path;
    }
    get fullPath() {
        return this._fullPath;
    }
}
class BaseRouteApi {
    constructor({ id }){
        this.notFound = (opts)=>{
            return (0, _notFoundJs.notFound)({
                routeId: this.id,
                ...opts
            });
        };
        this.id = id;
    }
}
class BaseRootRoute extends BaseRoute {
    constructor(options){
        super(options);
    }
}

},{"tiny-invariant":"4qfOO","./path.js":"b4w6q","./not-found.js":"aBKKv","./root.js":"fMO9U","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"xCgSu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
var _useMatchJs = require("./useMatch.js");
function useLoaderData(opts) {
    return (0, _useMatchJs.useMatch)({
        from: opts.from,
        strict: opts.strict,
        structuralSharing: opts.structuralSharing,
        select: (s)=>{
            return opts.select ? opts.select(s.loaderData) : s.loaderData;
        }
    });
}

},{"./useMatch.js":"k5eUN","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"k5eUN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
var _react = require("react");
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _useRouterStateJs = require("./useRouterState.js");
var _matchContextJs = require("./matchContext.js");
function useMatch(opts) {
    const nearestMatchId = _react.useContext(opts.from ? (0, _matchContextJs.dummyMatchContext) : (0, _matchContextJs.matchContext));
    const matchSelection = (0, _useRouterStateJs.useRouterState)({
        select: (state)=>{
            const match = state.matches.find((d)=>opts.from ? opts.from === d.routeId : d.id === nearestMatchId);
            (0, _tinyInvariantDefault.default)(!((opts.shouldThrow ?? true) && !match), `Could not find ${opts.from ? `an active match from "${opts.from}"` : "a nearest match!"}`);
            if (match === void 0) return void 0;
            return opts.select ? opts.select(match) : match;
        },
        structuralSharing: opts.structuralSharing
    });
    return matchSelection;
}

},{"react":"eGun2","tiny-invariant":"4qfOO","./useRouterState.js":"2Tx7u","./matchContext.js":"h5nNV","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2Tx7u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRouterState", ()=>useRouterState);
var _reactStore = require("@tanstack/react-store");
var _react = require("react");
var _routerCore = require("@tanstack/router-core");
var _useRouterJs = require("./useRouter.js");
function useRouterState(opts) {
    const contextRouter = (0, _useRouterJs.useRouter)({
        warn: opts?.router === void 0
    });
    const router = opts?.router || contextRouter;
    const previousResult = (0, _react.useRef)(void 0);
    return (0, _reactStore.useStore)(router.__store, (state)=>{
        if (opts?.select) {
            if (opts.structuralSharing ?? router.options.defaultStructuralSharing) {
                const newSlice = (0, _routerCore.replaceEqualDeep)(previousResult.current, opts.select(state));
                previousResult.current = newSlice;
                return newSlice;
            }
            return opts.select(state);
        }
        return state;
    });
}

},{"@tanstack/react-store":"7JcCF","react":"eGun2","@tanstack/router-core":"eTTD3","./useRouter.js":"nz9fN","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7JcCF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shallow", ()=>shallow);
parcelHelpers.export(exports, "useStore", ()=>useStore);
var _withSelectorJs = require("use-sync-external-store/shim/with-selector.js");
var _store = require("@tanstack/store");
parcelHelpers.exportAll(_store, exports);
function useStore(store, selector = (d)=>d, options = {}) {
    const equal = options.equal ?? shallow;
    const slice = (0, _withSelectorJs.useSyncExternalStoreWithSelector)(store.subscribe, ()=>store.state, ()=>store.state, selector, equal);
    return slice;
}
function shallow(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for (const [k, v] of objA){
            if (!objB.has(k) || !Object.is(v, objB.get(k))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for (const v of objA){
            if (!objB.has(v)) return false;
        }
        return true;
    }
    if (objA instanceof Date && objB instanceof Date) {
        if (objA.getTime() !== objB.getTime()) return false;
        return true;
    }
    const keysA = getOwnKeys(objA);
    if (keysA.length !== getOwnKeys(objB).length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function getOwnKeys(obj) {
    return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj));
}

},{"use-sync-external-store/shim/with-selector.js":"8QZkS","@tanstack/store":false,"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8QZkS":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("200d1eae2eff3aef");

},{"200d1eae2eff3aef":"eNJnE"}],"eNJnE":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("1451f73abd422bb1"), shim = require("1aa75051648bf93e");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = shim.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    useDebugValue(value);
    return value;
};

},{"1451f73abd422bb1":"eGun2","1aa75051648bf93e":"ei2Nj"}],"ei2Nj":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("c9e68bc795152ca6");

},{"c9e68bc795152ca6":"jSSIY"}],"jSSIY":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("5380b7aa33bd8e6e");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    useEffect(function() {
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    useDebugValue(value);
    return value;
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
exports.useSyncExternalStore = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;

},{"5380b7aa33bd8e6e":"eGun2"}],"nz9fN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRouter", ()=>useRouter);
var _react = require("react");
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _routerContextJs = require("./routerContext.js");
function useRouter(opts) {
    const value = _react.useContext((0, _routerContextJs.getRouterContext)());
    (0, _tinyWarningDefault.default)(!((opts?.warn ?? true) && !value), "useRouter must be used inside a <RouterProvider> component!");
    return value;
}

},{"react":"eGun2","tiny-warning":"ifQ8B","./routerContext.js":"8Papq","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8Papq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRouterContext", ()=>getRouterContext);
var _react = require("react");
const routerContext = _react.createContext(null);
function getRouterContext() {
    if (typeof document === "undefined") return routerContext;
    if (window.__TSR_ROUTER_CONTEXT__) return window.__TSR_ROUTER_CONTEXT__;
    window.__TSR_ROUTER_CONTEXT__ = routerContext;
    return routerContext;
}

},{"react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"h5nNV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dummyMatchContext", ()=>dummyMatchContext);
parcelHelpers.export(exports, "matchContext", ()=>matchContext);
var _react = require("react");
const matchContext = _react.createContext(void 0);
const dummyMatchContext = _react.createContext(void 0);

},{"react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"liviV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLoaderDeps", ()=>useLoaderDeps);
var _useMatchJs = require("./useMatch.js");
function useLoaderDeps(opts) {
    const { select, ...rest } = opts;
    return (0, _useMatchJs.useMatch)({
        ...rest,
        select: (s)=>{
            return select ? select(s.loaderDeps) : s.loaderDeps;
        }
    });
}

},{"./useMatch.js":"k5eUN","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jBvHB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useParams", ()=>useParams);
var _useMatchJs = require("./useMatch.js");
function useParams(opts) {
    return (0, _useMatchJs.useMatch)({
        from: opts.from,
        shouldThrow: opts.shouldThrow,
        structuralSharing: opts.structuralSharing,
        strict: opts.strict,
        select: (match)=>{
            const params = opts.strict === false ? match.params : match._strictParams;
            return opts.select ? opts.select(params) : params;
        }
    });
}

},{"./useMatch.js":"k5eUN","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4yVFL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSearch", ()=>useSearch);
var _useMatchJs = require("./useMatch.js");
function useSearch(opts) {
    return (0, _useMatchJs.useMatch)({
        from: opts.from,
        strict: opts.strict,
        shouldThrow: opts.shouldThrow,
        structuralSharing: opts.structuralSharing,
        select: (match)=>{
            return opts.select ? opts.select(match.search) : match.search;
        }
    });
}

},{"./useMatch.js":"k5eUN","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"aMhxM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
var _react = require("react");
var _utilsJs = require("./utils.js");
var _useRouterJs = require("./useRouter.js");
function useNavigate(_defaultOpts) {
    const router = (0, _useRouterJs.useRouter)();
    return _react.useCallback((options)=>{
        return router.navigate({
            ...options,
            from: options.from ?? _defaultOpts?.from
        });
    }, [
        _defaultOpts?.from,
        router
    ]);
}
function Navigate(props) {
    const router = (0, _useRouterJs.useRouter)();
    const navigate = useNavigate();
    const previousPropsRef = _react.useRef(null);
    (0, _utilsJs.useLayoutEffect)(()=>{
        if (previousPropsRef.current !== props) {
            navigate(props);
            previousPropsRef.current = props;
        }
    }, [
        router,
        props,
        navigate
    ]);
    return null;
}

},{"react":"eGun2","./utils.js":"5mR9k","./useRouter.js":"nz9fN","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5mR9k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useForwardedRef", ()=>useForwardedRef);
parcelHelpers.export(exports, "useIntersectionObserver", ()=>useIntersectionObserver);
parcelHelpers.export(exports, "useLayoutEffect", ()=>useLayoutEffect);
parcelHelpers.export(exports, "usePrevious", ()=>usePrevious);
parcelHelpers.export(exports, "useStableCallback", ()=>useStableCallback);
var _react = require("react");
function useStableCallback(fn) {
    const fnRef = _react.useRef(fn);
    fnRef.current = fn;
    const ref = _react.useRef((...args)=>fnRef.current(...args));
    return ref.current;
}
const useLayoutEffect = typeof window !== "undefined" ? _react.useLayoutEffect : _react.useEffect;
function usePrevious(value) {
    const ref = _react.useRef({
        value,
        prev: null
    });
    const current = ref.current.value;
    if (value !== current) ref.current = {
        value,
        prev: current
    };
    return ref.current.prev;
}
function useIntersectionObserver(ref, callback, intersectionObserverOptions = {}, options = {}) {
    _react.useEffect(()=>{
        if (!ref.current || options.disabled || typeof IntersectionObserver !== "function") return;
        const observer = new IntersectionObserver(([entry])=>{
            callback(entry);
        }, intersectionObserverOptions);
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        callback,
        intersectionObserverOptions,
        options.disabled,
        ref
    ]);
}
function useForwardedRef(ref) {
    const innerRef = _react.useRef(null);
    _react.useImperativeHandle(ref, ()=>innerRef.current, []);
    return innerRef;
}

},{"react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7k6Lq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "createLink", ()=>createLink);
parcelHelpers.export(exports, "linkOptions", ()=>linkOptions);
parcelHelpers.export(exports, "useLinkProps", ()=>useLinkProps);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDom = require("react-dom");
var _routerCore = require("@tanstack/router-core");
var _useRouterStateJs = require("./useRouterState.js");
var _useRouterJs = require("./useRouter.js");
var _utilsJs = require("./utils.js");
function useLinkProps(options, forwardedRef) {
    const router = (0, _useRouterJs.useRouter)();
    const [isTransitioning, setIsTransitioning] = _react.useState(false);
    const hasRenderFetched = _react.useRef(false);
    const innerRef = (0, _utilsJs.useForwardedRef)(forwardedRef);
    const { // custom props
    activeProps, inactiveProps, activeOptions, to, preload: userPreload, preloadDelay: userPreloadDelay, hashScrollIntoView, replace, startTransition, resetScroll, viewTransition, // element props
    children, target, disabled, style, className, onClick, onFocus, onMouseEnter, onMouseLeave, onTouchStart, ignoreBlocker, // prevent these from being returned
    params: _params, search: _search, hash: _hash, state: _state, mask: _mask, reloadDocument: _reloadDocument, unsafeRelative: _unsafeRelative, from: _from, _fromLocation, ...propsSafeToSpread } = options;
    const currentSearch = (0, _useRouterStateJs.useRouterState)({
        select: (s)=>s.location.search,
        structuralSharing: true
    });
    const from = options.from;
    const _options = _react.useMemo(()=>{
        return {
            ...options,
            from
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router,
        currentSearch,
        from,
        options._fromLocation,
        options.hash,
        options.to,
        options.search,
        options.params,
        options.state,
        options.mask,
        options.unsafeRelative
    ]);
    const next = _react.useMemo(()=>router.buildLocation({
            ..._options
        }), [
        router,
        _options
    ]);
    const hrefOption = _react.useMemo(()=>{
        if (disabled) return void 0;
        let href = next.maskedLocation ? next.maskedLocation.url : next.url;
        let external = false;
        if (router.origin) {
            if (href.startsWith(router.origin)) href = router.history.createHref(href.replace(router.origin, "")) || "/";
            else external = true;
        }
        return {
            href,
            external
        };
    }, [
        disabled,
        next.maskedLocation,
        next.url,
        router.origin,
        router.history
    ]);
    const externalLink = _react.useMemo(()=>{
        if (hrefOption?.external) return hrefOption.href;
        try {
            new URL(to);
            return to;
        } catch  {}
        return void 0;
    }, [
        to,
        hrefOption
    ]);
    const preload = options.reloadDocument || externalLink ? false : userPreload ?? router.options.defaultPreload;
    const preloadDelay = userPreloadDelay ?? router.options.defaultPreloadDelay ?? 0;
    const isActive = (0, _useRouterStateJs.useRouterState)({
        select: (s)=>{
            if (externalLink) return false;
            if (activeOptions?.exact) {
                const testExact = (0, _routerCore.exactPathTest)(s.location.pathname, next.pathname, router.basepath);
                if (!testExact) return false;
            } else {
                const currentPathSplit = (0, _routerCore.removeTrailingSlash)(s.location.pathname, router.basepath);
                const nextPathSplit = (0, _routerCore.removeTrailingSlash)(next.pathname, router.basepath);
                const pathIsFuzzyEqual = currentPathSplit.startsWith(nextPathSplit) && (currentPathSplit.length === nextPathSplit.length || currentPathSplit[nextPathSplit.length] === "/");
                if (!pathIsFuzzyEqual) return false;
            }
            if (activeOptions?.includeSearch ?? true) {
                const searchTest = (0, _routerCore.deepEqual)(s.location.search, next.search, {
                    partial: !activeOptions?.exact,
                    ignoreUndefined: !activeOptions?.explicitUndefined
                });
                if (!searchTest) return false;
            }
            if (activeOptions?.includeHash) return s.location.hash === next.hash;
            return true;
        }
    });
    const doPreload = _react.useCallback(()=>{
        router.preloadRoute({
            ..._options
        }).catch((err)=>{
            console.warn(err);
            console.warn((0, _routerCore.preloadWarning));
        });
    }, [
        router,
        _options
    ]);
    const preloadViewportIoCallback = _react.useCallback((entry)=>{
        if (entry?.isIntersecting) doPreload();
    }, [
        doPreload
    ]);
    (0, _utilsJs.useIntersectionObserver)(innerRef, preloadViewportIoCallback, intersectionObserverOptions, {
        disabled: !!disabled || !(preload === "viewport")
    });
    _react.useEffect(()=>{
        if (hasRenderFetched.current) return;
        if (!disabled && preload === "render") {
            doPreload();
            hasRenderFetched.current = true;
        }
    }, [
        disabled,
        doPreload,
        preload
    ]);
    const handleClick = (e)=>{
        const elementTarget = e.currentTarget.getAttribute("target");
        const effectiveTarget = target !== void 0 ? target : elementTarget;
        if (!disabled && !isCtrlEvent(e) && !e.defaultPrevented && (!effectiveTarget || effectiveTarget === "_self") && e.button === 0) {
            e.preventDefault();
            (0, _reactDom.flushSync)(()=>{
                setIsTransitioning(true);
            });
            const unsub = router.subscribe("onResolved", ()=>{
                unsub();
                setIsTransitioning(false);
            });
            router.navigate({
                ..._options,
                replace,
                resetScroll,
                hashScrollIntoView,
                startTransition,
                viewTransition,
                ignoreBlocker
            });
        }
    };
    if (externalLink) return {
        ...propsSafeToSpread,
        ref: innerRef,
        href: externalLink,
        ...children && {
            children
        },
        ...target && {
            target
        },
        ...disabled && {
            disabled
        },
        ...style && {
            style
        },
        ...className && {
            className
        },
        ...onClick && {
            onClick
        },
        ...onFocus && {
            onFocus
        },
        ...onMouseEnter && {
            onMouseEnter
        },
        ...onMouseLeave && {
            onMouseLeave
        },
        ...onTouchStart && {
            onTouchStart
        }
    };
    const handleFocus = (_)=>{
        if (disabled) return;
        if (preload) doPreload();
    };
    const handleTouchStart = handleFocus;
    const handleEnter = (e)=>{
        if (disabled || !preload) return;
        if (!preloadDelay) doPreload();
        else {
            const eventTarget = e.target;
            if (timeoutMap.has(eventTarget)) return;
            const id = setTimeout(()=>{
                timeoutMap.delete(eventTarget);
                doPreload();
            }, preloadDelay);
            timeoutMap.set(eventTarget, id);
        }
    };
    const handleLeave = (e)=>{
        if (disabled || !preload || !preloadDelay) return;
        const eventTarget = e.target;
        const id = timeoutMap.get(eventTarget);
        if (id) {
            clearTimeout(id);
            timeoutMap.delete(eventTarget);
        }
    };
    const resolvedActiveProps = isActive ? (0, _routerCore.functionalUpdate)(activeProps, {}) ?? STATIC_ACTIVE_OBJECT : STATIC_EMPTY_OBJECT;
    const resolvedInactiveProps = isActive ? STATIC_EMPTY_OBJECT : (0, _routerCore.functionalUpdate)(inactiveProps, {}) ?? STATIC_EMPTY_OBJECT;
    const resolvedClassName = [
        className,
        resolvedActiveProps.className,
        resolvedInactiveProps.className
    ].filter(Boolean).join(" ");
    const resolvedStyle = (style || resolvedActiveProps.style || resolvedInactiveProps.style) && {
        ...style,
        ...resolvedActiveProps.style,
        ...resolvedInactiveProps.style
    };
    return {
        ...propsSafeToSpread,
        ...resolvedActiveProps,
        ...resolvedInactiveProps,
        href: hrefOption?.href,
        ref: innerRef,
        onClick: composeHandlers([
            onClick,
            handleClick
        ]),
        onFocus: composeHandlers([
            onFocus,
            handleFocus
        ]),
        onMouseEnter: composeHandlers([
            onMouseEnter,
            handleEnter
        ]),
        onMouseLeave: composeHandlers([
            onMouseLeave,
            handleLeave
        ]),
        onTouchStart: composeHandlers([
            onTouchStart,
            handleTouchStart
        ]),
        disabled: !!disabled,
        target,
        ...resolvedStyle && {
            style: resolvedStyle
        },
        ...resolvedClassName && {
            className: resolvedClassName
        },
        ...disabled && STATIC_DISABLED_PROPS,
        ...isActive && STATIC_ACTIVE_PROPS,
        ...isTransitioning && STATIC_TRANSITIONING_PROPS
    };
}
const STATIC_EMPTY_OBJECT = {};
const STATIC_ACTIVE_OBJECT = {
    className: "active"
};
const STATIC_DISABLED_PROPS = {
    role: "link",
    "aria-disabled": true
};
const STATIC_ACTIVE_PROPS = {
    "data-status": "active",
    "aria-current": "page"
};
const STATIC_TRANSITIONING_PROPS = {
    "data-transitioning": "transitioning"
};
const timeoutMap = /* @__PURE__ */ new WeakMap();
const intersectionObserverOptions = {
    rootMargin: "100px"
};
const composeHandlers = (handlers)=>(e)=>{
        for (const handler of handlers){
            if (!handler) continue;
            if (e.defaultPrevented) return;
            handler(e);
        }
    };
function createLink(Comp) {
    return _react.forwardRef(function CreatedLink(props, ref) {
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Link, {
            ...props,
            _asChild: Comp,
            ref
        });
    });
}
const Link = _react.forwardRef((props, ref)=>{
    const { _asChild, ...rest } = props;
    const { type: _type, ref: innerRef, ...linkProps } = useLinkProps(rest, ref);
    const children = typeof rest.children === "function" ? rest.children({
        isActive: linkProps["data-status"] === "active"
    }) : rest.children;
    if (_asChild === void 0) delete linkProps.disabled;
    return _react.createElement(_asChild ? _asChild : "a", {
        ...linkProps,
        ref: innerRef
    }, children);
});
function isCtrlEvent(e) {
    return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
const linkOptions = (options)=>{
    return options;
};

},{"react/jsx-runtime":"dQjte","react":"eGun2","react-dom":"bLJc5","@tanstack/router-core":[["deepEqual","eTTD3"],["functionalUpdate","eTTD3"],["exactPathTest","b4w6q"],["removeTrailingSlash","b4w6q"],["preloadWarning","11wqb"]],"./useRouterState.js":"2Tx7u","./useRouter.js":"nz9fN","./utils.js":"5mR9k","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"11wqb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preloadWarning", ()=>preloadWarning);
const preloadWarning = "Error preloading route! \u261D\uFE0F";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"tW00h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RouterContextProvider", ()=>RouterContextProvider);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _matchesJs = require("./Matches.js");
var _routerContextJs = require("./routerContext.js");
function RouterContextProvider({ router, children, ...rest }) {
    if (Object.keys(rest).length > 0) router.update({
        ...router.options,
        ...rest,
        context: {
            ...router.options.context,
            ...rest.context
        }
    });
    const routerContext = (0, _routerContextJs.getRouterContext)();
    const provider = /* @__PURE__ */ (0, _jsxRuntime.jsx)(routerContext.Provider, {
        value: router,
        children
    });
    if (router.options.Wrap) return /* @__PURE__ */ (0, _jsxRuntime.jsx)(router.options.Wrap, {
        children: provider
    });
    return provider;
}
function RouterProvider({ router, ...rest }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(RouterContextProvider, {
        router,
        ...rest,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _matchesJs.Matches), {})
    });
}

},{"react/jsx-runtime":"dQjte","./Matches.js":"4YMMH","./routerContext.js":"8Papq","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4YMMH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MatchRoute", ()=>MatchRoute);
parcelHelpers.export(exports, "Matches", ()=>Matches);
parcelHelpers.export(exports, "useChildMatches", ()=>useChildMatches);
parcelHelpers.export(exports, "useMatchRoute", ()=>useMatchRoute);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useParentMatches", ()=>useParentMatches);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _routerCore = require("@tanstack/router-core");
var _catchBoundaryJs = require("./CatchBoundary.js");
var _useRouterStateJs = require("./useRouterState.js");
var _useRouterJs = require("./useRouter.js");
var _transitionerJs = require("./Transitioner.js");
var _matchContextJs = require("./matchContext.js");
var _matchJs = require("./Match.js");
var _safeFragmentJs = require("./SafeFragment.js");
function Matches() {
    const router = (0, _useRouterJs.useRouter)();
    const rootRoute = router.routesById[0, _routerCore.rootRouteId];
    const PendingComponent = rootRoute.options.pendingComponent ?? router.options.defaultPendingComponent;
    const pendingElement = PendingComponent ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(PendingComponent, {}) : null;
    const ResolvedSuspense = router.isServer || typeof document !== "undefined" && router.ssr ? (0, _safeFragmentJs.SafeFragment) : _react.Suspense;
    const inner = /* @__PURE__ */ (0, _jsxRuntime.jsxs)(ResolvedSuspense, {
        fallback: pendingElement,
        children: [
            !router.isServer && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _transitionerJs.Transitioner), {}),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(MatchesInner, {})
        ]
    });
    return router.options.InnerWrap ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(router.options.InnerWrap, {
        children: inner
    }) : inner;
}
function MatchesInner() {
    const router = (0, _useRouterJs.useRouter)();
    const matchId = (0, _useRouterStateJs.useRouterState)({
        select: (s)=>{
            return s.matches[0]?.id;
        }
    });
    const resetKey = (0, _useRouterStateJs.useRouterState)({
        select: (s)=>s.loadedAt
    });
    const matchComponent = matchId ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _matchJs.Match), {
        matchId
    }) : null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _matchContextJs.matchContext).Provider, {
        value: matchId,
        children: router.options.disableGlobalCatchBoundary ? matchComponent : /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _catchBoundaryJs.CatchBoundary), {
            getResetKey: ()=>resetKey,
            errorComponent: (0, _catchBoundaryJs.ErrorComponent),
            onCatch: (error)=>{
                (0, _tinyWarningDefault.default)(false, `The following error wasn't caught by any route! At the very least, consider setting an 'errorComponent' in your RootRoute!`);
                (0, _tinyWarningDefault.default)(false, error.message || error.toString());
            },
            children: matchComponent
        })
    });
}
function useMatchRoute() {
    const router = (0, _useRouterJs.useRouter)();
    (0, _useRouterStateJs.useRouterState)({
        select: (s)=>[
                s.location.href,
                s.resolvedLocation?.href,
                s.status
            ],
        structuralSharing: true
    });
    return _react.useCallback((opts)=>{
        const { pending, caseSensitive, fuzzy, includeSearch, ...rest } = opts;
        return router.matchRoute(rest, {
            pending,
            caseSensitive,
            fuzzy,
            includeSearch
        });
    }, [
        router
    ]);
}
function MatchRoute(props) {
    const matchRoute = useMatchRoute();
    const params = matchRoute(props);
    if (typeof props.children === "function") return props.children(params);
    return params ? props.children : null;
}
function useMatches(opts) {
    return (0, _useRouterStateJs.useRouterState)({
        select: (state)=>{
            const matches = state.matches;
            return opts?.select ? opts.select(matches) : matches;
        },
        structuralSharing: opts?.structuralSharing
    });
}
function useParentMatches(opts) {
    const contextMatchId = _react.useContext((0, _matchContextJs.matchContext));
    return useMatches({
        select: (matches)=>{
            matches = matches.slice(0, matches.findIndex((d)=>d.id === contextMatchId));
            return opts?.select ? opts.select(matches) : matches;
        },
        structuralSharing: opts?.structuralSharing
    });
}
function useChildMatches(opts) {
    const contextMatchId = _react.useContext((0, _matchContextJs.matchContext));
    return useMatches({
        select: (matches)=>{
            matches = matches.slice(matches.findIndex((d)=>d.id === contextMatchId) + 1);
            return opts?.select ? opts.select(matches) : matches;
        },
        structuralSharing: opts?.structuralSharing
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","tiny-warning":"ifQ8B","@tanstack/router-core":"fMO9U","./CatchBoundary.js":"ihrEX","./useRouterState.js":"2Tx7u","./useRouter.js":"nz9fN","./Transitioner.js":"6QfwC","./matchContext.js":"h5nNV","./Match.js":"aAETe","./SafeFragment.js":"bNgFw","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ihrEX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CatchBoundary", ()=>CatchBoundary);
parcelHelpers.export(exports, "ErrorComponent", ()=>ErrorComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
function CatchBoundary(props) {
    const errorComponent = props.errorComponent ?? ErrorComponent;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CatchBoundaryImpl, {
        getResetKey: props.getResetKey,
        onCatch: props.onCatch,
        children: ({ error, reset })=>{
            if (error) return _react.createElement(errorComponent, {
                error,
                reset
            });
            return props.children;
        }
    });
}
class CatchBoundaryImpl extends _react.Component {
    constructor(){
        super(...arguments);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromProps(props) {
        return {
            resetKey: props.getResetKey()
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    reset() {
        this.setState({
            error: null
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.error && prevState.resetKey !== this.state.resetKey) this.reset();
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onCatch) this.props.onCatch(error, errorInfo);
    }
    render() {
        return this.props.children({
            error: this.state.resetKey !== this.props.getResetKey() ? null : this.state.error,
            reset: ()=>{
                this.reset();
            }
        });
    }
}
function ErrorComponent({ error }) {
    const [show, setShow] = _react.useState(false);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        style: {
            padding: ".5rem",
            maxWidth: "100%"
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: ".5rem"
                },
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("strong", {
                        style: {
                            fontSize: "1rem"
                        },
                        children: "Something went wrong!"
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)("button", {
                        style: {
                            appearance: "none",
                            fontSize: ".6em",
                            border: "1px solid currentColor",
                            padding: ".1rem .2rem",
                            fontWeight: "bold",
                            borderRadius: ".25rem"
                        },
                        onClick: ()=>setShow((d)=>!d),
                        children: show ? "Hide Error" : "Show Error"
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                style: {
                    height: ".25rem"
                }
            }),
            show ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("pre", {
                    style: {
                        fontSize: ".7em",
                        border: "1px solid red",
                        borderRadius: ".25rem",
                        padding: ".3rem",
                        color: "red",
                        overflow: "auto"
                    },
                    children: error.message ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("code", {
                        children: error.message
                    }) : null
                })
            }) : null
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6QfwC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transitioner", ()=>Transitioner);
var _react = require("react");
var _routerCore = require("@tanstack/router-core");
var _utilsJs = require("./utils.js");
var _useRouterJs = require("./useRouter.js");
var _useRouterStateJs = require("./useRouterState.js");
function Transitioner() {
    const router = (0, _useRouterJs.useRouter)();
    const mountLoadForRouter = _react.useRef({
        router,
        mounted: false
    });
    const [isTransitioning, setIsTransitioning] = _react.useState(false);
    const { hasPendingMatches, isLoading } = (0, _useRouterStateJs.useRouterState)({
        select: (s)=>({
                isLoading: s.isLoading,
                hasPendingMatches: s.matches.some((d)=>d.status === "pending")
            }),
        structuralSharing: true
    });
    const previousIsLoading = (0, _utilsJs.usePrevious)(isLoading);
    const isAnyPending = isLoading || isTransitioning || hasPendingMatches;
    const previousIsAnyPending = (0, _utilsJs.usePrevious)(isAnyPending);
    const isPagePending = isLoading || hasPendingMatches;
    const previousIsPagePending = (0, _utilsJs.usePrevious)(isPagePending);
    router.startTransition = (fn)=>{
        setIsTransitioning(true);
        _react.startTransition(()=>{
            fn();
            setIsTransitioning(false);
        });
    };
    _react.useEffect(()=>{
        const unsub = router.history.subscribe(router.load);
        const nextLocation = router.buildLocation({
            to: router.latestLocation.pathname,
            search: true,
            params: true,
            hash: true,
            state: true,
            _includeValidateSearch: true
        });
        if ((0, _routerCore.trimPathRight)(router.latestLocation.href) !== (0, _routerCore.trimPathRight)(nextLocation.href)) router.commitLocation({
            ...nextLocation,
            replace: true
        });
        return ()=>{
            unsub();
        };
    }, [
        router,
        router.history
    ]);
    (0, _utilsJs.useLayoutEffect)(()=>{
        if (// if we are hydrating from SSR, loading is triggered in ssr-client
        typeof window !== "undefined" && router.ssr || mountLoadForRouter.current.router === router && mountLoadForRouter.current.mounted) return;
        mountLoadForRouter.current = {
            router,
            mounted: true
        };
        const tryLoad = async ()=>{
            try {
                await router.load();
            } catch (err) {
                console.error(err);
            }
        };
        tryLoad();
    }, [
        router
    ]);
    (0, _utilsJs.useLayoutEffect)(()=>{
        if (previousIsLoading && !isLoading) router.emit({
            type: "onLoad",
            // When the new URL has committed, when the new matches have been loaded into state.matches
            ...(0, _routerCore.getLocationChangeInfo)(router.state)
        });
    }, [
        previousIsLoading,
        router,
        isLoading
    ]);
    (0, _utilsJs.useLayoutEffect)(()=>{
        if (previousIsPagePending && !isPagePending) router.emit({
            type: "onBeforeRouteMount",
            ...(0, _routerCore.getLocationChangeInfo)(router.state)
        });
    }, [
        isPagePending,
        previousIsPagePending,
        router
    ]);
    (0, _utilsJs.useLayoutEffect)(()=>{
        if (previousIsAnyPending && !isAnyPending) {
            const changeInfo = (0, _routerCore.getLocationChangeInfo)(router.state);
            router.emit({
                type: "onResolved",
                ...changeInfo
            });
            router.__store.setState((s)=>({
                    ...s,
                    status: "idle",
                    resolvedLocation: s.location
                }));
            if (changeInfo.hrefChanged) (0, _routerCore.handleHashScroll)(router);
        }
    }, [
        isAnyPending,
        previousIsAnyPending,
        router
    ]);
    return null;
}

},{"react":"eGun2","@tanstack/router-core":[["getLocationChangeInfo","6JWyW"],["handleHashScroll","ePmPj"],["trimPathRight","b4w6q"]],"./utils.js":"5mR9k","./useRouter.js":"nz9fN","./useRouterState.js":"2Tx7u","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"aAETe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Match", ()=>Match);
parcelHelpers.export(exports, "MatchInner", ()=>MatchInner);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _routerCore = require("@tanstack/router-core");
var _catchBoundaryJs = require("./CatchBoundary.js");
var _useRouterStateJs = require("./useRouterState.js");
var _useRouterJs = require("./useRouter.js");
var _notFoundJs = require("./not-found.js");
var _matchContextJs = require("./matchContext.js");
var _safeFragmentJs = require("./SafeFragment.js");
var _renderRouteNotFoundJs = require("./renderRouteNotFound.js");
var _scrollRestorationJs = require("./scroll-restoration.js");
var _clientOnlyJs = require("./ClientOnly.js");
const Match = _react.memo(function MatchImpl({ matchId }) {
    const router = (0, _useRouterJs.useRouter)();
    const matchState = (0, _useRouterStateJs.useRouterState)({
        select: (s)=>{
            const match = s.matches.find((d)=>d.id === matchId);
            (0, _tinyInvariantDefault.default)(match, `Could not find match for matchId "${matchId}". Please file an issue!`);
            return {
                routeId: match.routeId,
                ssr: match.ssr,
                _displayPending: match._displayPending
            };
        },
        structuralSharing: true
    });
    const route = router.routesById[matchState.routeId];
    const PendingComponent = route.options.pendingComponent ?? router.options.defaultPendingComponent;
    const pendingElement = PendingComponent ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(PendingComponent, {}) : null;
    const routeErrorComponent = route.options.errorComponent ?? router.options.defaultErrorComponent;
    const routeOnCatch = route.options.onCatch ?? router.options.defaultOnCatch;
    const routeNotFoundComponent = route.isRoot ? // If it's the root route, use the globalNotFound option, with fallback to the notFoundRoute's component
    route.options.notFoundComponent ?? router.options.notFoundRoute?.options.component : route.options.notFoundComponent;
    const resolvedNoSsr = matchState.ssr === false || matchState.ssr === "data-only";
    const ResolvedSuspenseBoundary = // If we're on the root route, allow forcefully wrapping in suspense
    (!route.isRoot || route.options.wrapInSuspense || resolvedNoSsr) && (route.options.wrapInSuspense ?? PendingComponent ?? (route.options.errorComponent?.preload || resolvedNoSsr)) ? _react.Suspense : (0, _safeFragmentJs.SafeFragment);
    const ResolvedCatchBoundary = routeErrorComponent ? (0, _catchBoundaryJs.CatchBoundary) : (0, _safeFragmentJs.SafeFragment);
    const ResolvedNotFoundBoundary = routeNotFoundComponent ? (0, _notFoundJs.CatchNotFound) : (0, _safeFragmentJs.SafeFragment);
    const resetKey = (0, _useRouterStateJs.useRouterState)({
        select: (s)=>s.loadedAt
    });
    const parentRouteId = (0, _useRouterStateJs.useRouterState)({
        select: (s)=>{
            const index = s.matches.findIndex((d)=>d.id === matchId);
            return s.matches[index - 1]?.routeId;
        }
    });
    const ShellComponent = route.isRoot ? route.options.shellComponent ?? (0, _safeFragmentJs.SafeFragment) : (0, _safeFragmentJs.SafeFragment);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)(ShellComponent, {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _matchContextJs.matchContext).Provider, {
                value: matchId,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(ResolvedSuspenseBoundary, {
                    fallback: pendingElement,
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(ResolvedCatchBoundary, {
                        getResetKey: ()=>resetKey,
                        errorComponent: routeErrorComponent || (0, _catchBoundaryJs.ErrorComponent),
                        onCatch: (error, errorInfo)=>{
                            if ((0, _routerCore.isNotFound)(error)) throw error;
                            (0, _tinyWarningDefault.default)(false, `Error in route match: ${matchId}`);
                            routeOnCatch?.(error, errorInfo);
                        },
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(ResolvedNotFoundBoundary, {
                            fallback: (error)=>{
                                if (!routeNotFoundComponent || error.routeId && error.routeId !== matchState.routeId || !error.routeId && !route.isRoot) throw error;
                                return _react.createElement(routeNotFoundComponent, error);
                            },
                            children: resolvedNoSsr || matchState._displayPending ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _clientOnlyJs.ClientOnly), {
                                fallback: pendingElement,
                                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(MatchInner, {
                                    matchId
                                })
                            }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(MatchInner, {
                                matchId
                            })
                        })
                    })
                })
            }),
            parentRouteId === (0, _routerCore.rootRouteId) && router.options.scrollRestoration ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(OnRendered, {}),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollRestorationJs.ScrollRestoration), {})
                ]
            }) : null
        ]
    });
});
function OnRendered() {
    const router = (0, _useRouterJs.useRouter)();
    const prevLocationRef = _react.useRef(void 0);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("script", {
        suppressHydrationWarning: true,
        ref: (el)=>{
            if (el && (prevLocationRef.current === void 0 || prevLocationRef.current.href !== router.latestLocation.href)) {
                router.emit({
                    type: "onRendered",
                    ...(0, _routerCore.getLocationChangeInfo)(router.state)
                });
                prevLocationRef.current = router.latestLocation;
            }
        }
    }, router.latestLocation.state.__TSR_key);
}
const MatchInner = _react.memo(function MatchInnerImpl({ matchId }) {
    const router = (0, _useRouterJs.useRouter)();
    const { match, key, routeId } = (0, _useRouterStateJs.useRouterState)({
        select: (s)=>{
            const match2 = s.matches.find((d)=>d.id === matchId);
            const routeId2 = match2.routeId;
            const remountFn = router.routesById[routeId2].options.remountDeps ?? router.options.defaultRemountDeps;
            const remountDeps = remountFn?.({
                routeId: routeId2,
                loaderDeps: match2.loaderDeps,
                params: match2._strictParams,
                search: match2._strictSearch
            });
            const key2 = remountDeps ? JSON.stringify(remountDeps) : void 0;
            return {
                key: key2,
                routeId: routeId2,
                match: {
                    id: match2.id,
                    status: match2.status,
                    error: match2.error,
                    _forcePending: match2._forcePending,
                    _displayPending: match2._displayPending
                }
            };
        },
        structuralSharing: true
    });
    const route = router.routesById[routeId];
    const out = _react.useMemo(()=>{
        const Comp = route.options.component ?? router.options.defaultComponent;
        if (Comp) return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Comp, {}, key);
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Outlet, {});
    }, [
        key,
        route.options.component,
        router.options.defaultComponent
    ]);
    if (match._displayPending) throw router.getMatch(match.id)?._nonReactive.displayPendingPromise;
    if (match._forcePending) throw router.getMatch(match.id)?._nonReactive.minPendingPromise;
    if (match.status === "pending") {
        const pendingMinMs = route.options.pendingMinMs ?? router.options.defaultPendingMinMs;
        if (pendingMinMs) {
            const routerMatch = router.getMatch(match.id);
            if (routerMatch && !routerMatch._nonReactive.minPendingPromise) {
                if (!router.isServer) {
                    const minPendingPromise = (0, _routerCore.createControlledPromise)();
                    routerMatch._nonReactive.minPendingPromise = minPendingPromise;
                    setTimeout(()=>{
                        minPendingPromise.resolve();
                        routerMatch._nonReactive.minPendingPromise = void 0;
                    }, pendingMinMs);
                }
            }
        }
        throw router.getMatch(match.id)?._nonReactive.loadPromise;
    }
    if (match.status === "notFound") {
        (0, _tinyInvariantDefault.default)((0, _routerCore.isNotFound)(match.error), "Expected a notFound error");
        return (0, _renderRouteNotFoundJs.renderRouteNotFound)(router, route, match.error);
    }
    if (match.status === "redirected") {
        (0, _tinyInvariantDefault.default)((0, _routerCore.isRedirect)(match.error), "Expected a redirect error");
        throw router.getMatch(match.id)?._nonReactive.loadPromise;
    }
    if (match.status === "error") {
        if (router.isServer) {
            const RouteErrorComponent = (route.options.errorComponent ?? router.options.defaultErrorComponent) || (0, _catchBoundaryJs.ErrorComponent);
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)(RouteErrorComponent, {
                error: match.error,
                reset: void 0,
                info: {
                    componentStack: ""
                }
            });
        }
        throw match.error;
    }
    return out;
});
const Outlet = _react.memo(function OutletImpl() {
    const router = (0, _useRouterJs.useRouter)();
    const matchId = _react.useContext((0, _matchContextJs.matchContext));
    const routeId = (0, _useRouterStateJs.useRouterState)({
        select: (s)=>s.matches.find((d)=>d.id === matchId)?.routeId
    });
    const route = router.routesById[routeId];
    const parentGlobalNotFound = (0, _useRouterStateJs.useRouterState)({
        select: (s)=>{
            const matches = s.matches;
            const parentMatch = matches.find((d)=>d.id === matchId);
            (0, _tinyInvariantDefault.default)(parentMatch, `Could not find parent match for matchId "${matchId}"`);
            return parentMatch.globalNotFound;
        }
    });
    const childMatchId = (0, _useRouterStateJs.useRouterState)({
        select: (s)=>{
            const matches = s.matches;
            const index = matches.findIndex((d)=>d.id === matchId);
            return matches[index + 1]?.id;
        }
    });
    const pendingElement = router.options.defaultPendingComponent ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(router.options.defaultPendingComponent, {}) : null;
    if (parentGlobalNotFound) return (0, _renderRouteNotFoundJs.renderRouteNotFound)(router, route, void 0);
    if (!childMatchId) return null;
    const nextMatch = /* @__PURE__ */ (0, _jsxRuntime.jsx)(Match, {
        matchId: childMatchId
    });
    if (routeId === (0, _routerCore.rootRouteId)) return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_react.Suspense, {
        fallback: pendingElement,
        children: nextMatch
    });
    return nextMatch;
});

},{"react/jsx-runtime":"dQjte","react":"eGun2","tiny-invariant":"4qfOO","tiny-warning":"ifQ8B","@tanstack/router-core":[["createControlledPromise","eTTD3"],["getLocationChangeInfo","6JWyW"],["isNotFound","aBKKv"],["isRedirect","jmFxY"],["rootRouteId","fMO9U"]],"./CatchBoundary.js":"ihrEX","./useRouterState.js":"2Tx7u","./useRouter.js":"nz9fN","./not-found.js":"jzoKt","./matchContext.js":"h5nNV","./SafeFragment.js":"bNgFw","./renderRouteNotFound.js":"9OmPE","./scroll-restoration.js":"dFqEP","./ClientOnly.js":"4SECm","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jzoKt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CatchNotFound", ()=>CatchNotFound);
parcelHelpers.export(exports, "DefaultGlobalNotFound", ()=>DefaultGlobalNotFound);
var _jsxRuntime = require("react/jsx-runtime");
var _routerCore = require("@tanstack/router-core");
var _catchBoundaryJs = require("./CatchBoundary.js");
var _useRouterStateJs = require("./useRouterState.js");
function CatchNotFound(props) {
    const resetKey = (0, _useRouterStateJs.useRouterState)({
        select: (s)=>`not-found-${s.location.pathname}-${s.status}`
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _catchBoundaryJs.CatchBoundary), {
        getResetKey: ()=>resetKey,
        onCatch: (error, errorInfo)=>{
            if ((0, _routerCore.isNotFound)(error)) props.onCatch?.(error, errorInfo);
            else throw error;
        },
        errorComponent: ({ error })=>{
            if ((0, _routerCore.isNotFound)(error)) return props.fallback?.(error);
            else throw error;
        },
        children: props.children
    });
}
function DefaultGlobalNotFound() {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
        children: "Not Found"
    });
}

},{"react/jsx-runtime":"dQjte","@tanstack/router-core":"aBKKv","./CatchBoundary.js":"ihrEX","./useRouterState.js":"2Tx7u","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bNgFw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SafeFragment", ()=>SafeFragment);
var _jsxRuntime = require("react/jsx-runtime");
function SafeFragment(props) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: props.children
    });
}

},{"react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9OmPE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderRouteNotFound", ()=>renderRouteNotFound);
var _jsxRuntime = require("react/jsx-runtime");
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _notFoundJs = require("./not-found.js");
function renderRouteNotFound(router, route, data) {
    if (!route.options.notFoundComponent) {
        if (router.options.defaultNotFoundComponent) return /* @__PURE__ */ (0, _jsxRuntime.jsx)(router.options.defaultNotFoundComponent, {
            ...data
        });
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _notFoundJs.DefaultGlobalNotFound), {});
    }
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(route.options.notFoundComponent, {
        ...data
    });
}

},{"react/jsx-runtime":"dQjte","tiny-warning":"ifQ8B","./not-found.js":"jzoKt","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dFqEP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
var _jsxRuntime = require("react/jsx-runtime");
var _routerCore = require("@tanstack/router-core");
var _useRouterJs = require("./useRouter.js");
var _scriptOnceJs = require("./ScriptOnce.js");
function ScrollRestoration() {
    const router = (0, _useRouterJs.useRouter)();
    if (!router.isScrollRestoring || !router.isServer) return null;
    if (typeof router.options.scrollRestoration === "function") {
        const shouldRestore = router.options.scrollRestoration({
            location: router.latestLocation
        });
        if (!shouldRestore) return null;
    }
    const getKey = router.options.getScrollRestorationKey || (0, _routerCore.defaultGetScrollRestorationKey);
    const userKey = getKey(router.latestLocation);
    const resolvedKey = userKey !== (0, _routerCore.defaultGetScrollRestorationKey)(router.latestLocation) ? userKey : void 0;
    const restoreScrollOptions = {
        storageKey: (0, _routerCore.storageKey),
        shouldScrollRestoration: true
    };
    if (resolvedKey) restoreScrollOptions.key = resolvedKey;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scriptOnceJs.ScriptOnce), {
        children: `(${(0, _routerCore.restoreScroll).toString()})(${JSON.stringify(restoreScrollOptions)})`
    });
}

},{"react/jsx-runtime":"dQjte","@tanstack/router-core":"ePmPj","./useRouter.js":"nz9fN","./ScriptOnce.js":"7w5Ta","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7w5Ta":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScriptOnce", ()=>ScriptOnce);
var _jsxRuntime = require("react/jsx-runtime");
var _useRouterJs = require("./useRouter.js");
function ScriptOnce({ children }) {
    const router = (0, _useRouterJs.useRouter)();
    if (!router.isServer) return null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("script", {
        nonce: router.options.ssr?.nonce,
        className: "$tsr",
        dangerouslySetInnerHTML: {
            __html: children + ';typeof $_TSR !== "undefined" && $_TSR.c()'
        }
    });
}

},{"react/jsx-runtime":"dQjte","./useRouter.js":"nz9fN","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4SECm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientOnly", ()=>ClientOnly);
parcelHelpers.export(exports, "useHydrated", ()=>useHydrated);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function ClientOnly({ children, fallback = null }) {
    return useHydrated() ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
        children
    }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
        children: fallback
    });
}
function useHydrated() {
    return (0, _reactDefault.default).useSyncExternalStore(subscribe, ()=>true, ()=>false);
}
function subscribe() {
    return ()=>{};
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kS2VE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Auth0Wrapper", ()=>Auth0Wrapper);
parcelHelpers.export(exports, "useAuth0Context", ()=>useAuth0Context);
var _jsxRuntime = require("react/jsx-runtime");
var _auth0React = require("@auth0/auth0-react");
var _react = require("react");
const Auth0Context = /*#__PURE__*/ (0, _react.createContext)(undefined);
function Auth0Wrapper({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _auth0React.Auth0Provider), {
        domain: "invintus.auth0.com",
        clientId: "taaYOJ0KmELK5Fg9JjxQeTHSBNhI7N0k",
        authorizationParams: {
            redirect_uri: window.location.origin,
            audience: "https://admin-portal-api"
        },
        cacheLocation: "localstorage",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Auth0ContextProvider, {
            children: children
        })
    });
}
function Auth0ContextProvider({ children }) {
    const { isAuthenticated, user, loginWithRedirect, logout, isLoading } = (0, _auth0React.useAuth0)();
    const contextValue = {
        isAuthenticated,
        user,
        login: loginWithRedirect,
        logout: ()=>logout({
                logoutParams: {
                    returnTo: window.location.origin
                }
            }),
        isLoading
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Auth0Context.Provider, {
        value: contextValue,
        children: children
    });
}
function useAuth0Context() {
    const context = (0, _react.useContext)(Auth0Context);
    if (context === undefined) throw new Error('useAuth0Context must be used within Auth0Wrapper');
    return context;
}

},{"react/jsx-runtime":"dQjte","@auth0/auth0-react":"gpXrE","react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gpXrE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Auth0Context", ()=>Auth0Context);
parcelHelpers.export(exports, "Auth0Provider", ()=>Auth0Provider);
parcelHelpers.export(exports, "AuthenticationError", ()=>d);
parcelHelpers.export(exports, "ConnectError", ()=>h);
parcelHelpers.export(exports, "GenericError", ()=>u);
parcelHelpers.export(exports, "InMemoryCache", ()=>oe);
parcelHelpers.export(exports, "LocalStorageCache", ()=>ne);
parcelHelpers.export(exports, "MfaRequiredError", ()=>f);
parcelHelpers.export(exports, "MissingRefreshTokenError", ()=>g);
parcelHelpers.export(exports, "OAuthError", ()=>OAuthError);
parcelHelpers.export(exports, "PopupCancelledError", ()=>m);
parcelHelpers.export(exports, "PopupTimeoutError", ()=>p);
parcelHelpers.export(exports, "ResponseType", ()=>ge);
parcelHelpers.export(exports, "TimeoutError", ()=>l);
parcelHelpers.export(exports, "UseDpopNonceError", ()=>w);
parcelHelpers.export(exports, "User", ()=>ye);
parcelHelpers.export(exports, "initialContext", ()=>initialContext);
parcelHelpers.export(exports, "useAuth0", ()=>useAuth0);
parcelHelpers.export(exports, "withAuth0", ()=>withAuth0);
parcelHelpers.export(exports, "withAuthenticationRequired", ()=>withAuthenticationRequired);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var global = arguments[3];
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
function e(e, t) {
    var n = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var i = 0;
        for(o = Object.getOwnPropertySymbols(e); i < o.length; i++)t.indexOf(o[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[i]) && (n[o[i]] = e[o[i]]);
    }
    return n;
}
"function" == typeof SuppressedError && SuppressedError;
var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function n(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function o(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
}
var i = o(function(e, t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e() {
            var e = this;
            this.locked = new Map, this.addToLocked = function(t, n) {
                var o = e.locked.get(t);
                void 0 === o ? void 0 === n ? e.locked.set(t, []) : e.locked.set(t, [
                    n
                ]) : void 0 !== n && (o.unshift(n), e.locked.set(t, o));
            }, this.isLocked = function(t) {
                return e.locked.has(t);
            }, this.lock = function(t) {
                return new Promise(function(n, o) {
                    e.isLocked(t) ? e.addToLocked(t, n) : (e.addToLocked(t), n());
                });
            }, this.unlock = function(t) {
                var n = e.locked.get(t);
                if (void 0 !== n && 0 !== n.length) {
                    var o = n.pop();
                    e.locked.set(t, n), void 0 !== o && setTimeout(o, 0);
                } else e.locked.delete(t);
            };
        }
        return e.getInstance = function() {
            return void 0 === e.instance && (e.instance = new e), e.instance;
        }, e;
    }();
    t.default = function() {
        return n.getInstance();
    };
});
n(i);
var r = n(o(function(e, n) {
    var o = t && t.__awaiter || function(e, t, n, o) {
        return new (n || (n = Promise))(function(i, r) {
            function s(e) {
                try {
                    c(o.next(e));
                } catch (e) {
                    r(e);
                }
            }
            function a(e) {
                try {
                    c(o.throw(e));
                } catch (e) {
                    r(e);
                }
            }
            function c(e) {
                e.done ? i(e.value) : new n(function(t) {
                    t(e.value);
                }).then(s, a);
            }
            c((o = o.apply(e, t || [])).next());
        });
    }, r = t && t.__generator || function(e, t) {
        var n, o, i, r, s = {
            label: 0,
            sent: function() {
                if (1 & i[0]) throw i[1];
                return i[1];
            },
            trys: [],
            ops: []
        };
        return r = {
            next: a(0),
            throw: a(1),
            return: a(2)
        }, "function" == typeof Symbol && (r[Symbol.iterator] = function() {
            return this;
        }), r;
        function a(r) {
            return function(a) {
                return function(r) {
                    if (n) throw new TypeError("Generator is already executing.");
                    for(; s;)try {
                        if (n = 1, o && (i = 2 & r[0] ? o.return : r[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, r[1])).done) return i;
                        switch(o = 0, i && (r = [
                            2 & r[0],
                            i.value
                        ]), r[0]){
                            case 0:
                            case 1:
                                i = r;
                                break;
                            case 4:
                                return s.label++, {
                                    value: r[1],
                                    done: !1
                                };
                            case 5:
                                s.label++, o = r[1], r = [
                                    0
                                ];
                                continue;
                            case 7:
                                r = s.ops.pop(), s.trys.pop();
                                continue;
                            default:
                                if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== r[0] && 2 !== r[0])) {
                                    s = 0;
                                    continue;
                                }
                                if (3 === r[0] && (!i || r[1] > i[0] && r[1] < i[3])) {
                                    s.label = r[1];
                                    break;
                                }
                                if (6 === r[0] && s.label < i[1]) {
                                    s.label = i[1], i = r;
                                    break;
                                }
                                if (i && s.label < i[2]) {
                                    s.label = i[2], s.ops.push(r);
                                    break;
                                }
                                i[2] && s.ops.pop(), s.trys.pop();
                                continue;
                        }
                        r = t.call(e, s);
                    } catch (e) {
                        r = [
                            6,
                            e
                        ], o = 0;
                    } finally{
                        n = i = 0;
                    }
                    if (5 & r[0]) throw r[1];
                    return {
                        value: r[0] ? r[1] : void 0,
                        done: !0
                    };
                }([
                    r,
                    a
                ]);
            };
        }
    }, s = t;
    Object.defineProperty(n, "__esModule", {
        value: !0
    });
    var a = "browser-tabs-lock-key", c = {
        key: function(e) {
            return o(s, void 0, void 0, function() {
                return r(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        getItem: function(e) {
            return o(s, void 0, void 0, function() {
                return r(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        clear: function() {
            return o(s, void 0, void 0, function() {
                return r(this, function(e) {
                    return [
                        2,
                        window.localStorage.clear()
                    ];
                });
            });
        },
        removeItem: function(e) {
            return o(s, void 0, void 0, function() {
                return r(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        setItem: function(e, t) {
            return o(s, void 0, void 0, function() {
                return r(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        keySync: function(e) {
            return window.localStorage.key(e);
        },
        getItemSync: function(e) {
            return window.localStorage.getItem(e);
        },
        clearSync: function() {
            return window.localStorage.clear();
        },
        removeItemSync: function(e) {
            return window.localStorage.removeItem(e);
        },
        setItemSync: function(e, t) {
            return window.localStorage.setItem(e, t);
        }
    };
    function u(e) {
        return new Promise(function(t) {
            return setTimeout(t, e);
        });
    }
    function d(e) {
        for(var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", n = "", o = 0; o < e; o++)n += t[Math.floor(Math.random() * t.length)];
        return n;
    }
    var h = function() {
        function e(t) {
            this.acquiredIatSet = new Set, this.storageHandler = void 0, this.id = Date.now().toString() + d(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, void 0 === e.waiters && (e.waiters = []);
        }
        return e.prototype.acquireLock = function(t, n) {
            return void 0 === n && (n = 5e3), o(this, void 0, void 0, function() {
                var o, i, s, h, l, p, m;
                return r(this, function(r) {
                    switch(r.label){
                        case 0:
                            o = Date.now() + d(4), i = Date.now() + n, s = a + "-" + t, h = void 0 === this.storageHandler ? c : this.storageHandler, r.label = 1;
                        case 1:
                            return Date.now() < i ? [
                                4,
                                u(30)
                            ] : [
                                3,
                                8
                            ];
                        case 2:
                            return r.sent(), null !== h.getItemSync(s) ? [
                                3,
                                5
                            ] : (l = this.id + "-" + t + "-" + o, [
                                4,
                                u(Math.floor(25 * Math.random()))
                            ]);
                        case 3:
                            return r.sent(), h.setItemSync(s, JSON.stringify({
                                id: this.id,
                                iat: o,
                                timeoutKey: l,
                                timeAcquired: Date.now(),
                                timeRefreshed: Date.now()
                            })), [
                                4,
                                u(30)
                            ];
                        case 4:
                            return r.sent(), null !== (p = h.getItemSync(s)) && (m = JSON.parse(p)).id === this.id && m.iat === o ? (this.acquiredIatSet.add(o), this.refreshLockWhileAcquired(s, o), [
                                2,
                                !0
                            ]) : [
                                3,
                                7
                            ];
                        case 5:
                            return e.lockCorrector(void 0 === this.storageHandler ? c : this.storageHandler), [
                                4,
                                this.waitForSomethingToChange(i)
                            ];
                        case 6:
                            r.sent(), r.label = 7;
                        case 7:
                            return o = Date.now() + d(4), [
                                3,
                                1
                            ];
                        case 8:
                            return [
                                2,
                                !1
                            ];
                    }
                });
            });
        }, e.prototype.refreshLockWhileAcquired = function(e, t) {
            return o(this, void 0, void 0, function() {
                var n = this;
                return r(this, function(s) {
                    return setTimeout(function() {
                        return o(n, void 0, void 0, function() {
                            var n, o, s;
                            return r(this, function(r) {
                                switch(r.label){
                                    case 0:
                                        return [
                                            4,
                                            i.default().lock(t)
                                        ];
                                    case 1:
                                        return r.sent(), this.acquiredIatSet.has(t) ? (n = void 0 === this.storageHandler ? c : this.storageHandler, null === (o = n.getItemSync(e)) ? (i.default().unlock(t), [
                                            2
                                        ]) : ((s = JSON.parse(o)).timeRefreshed = Date.now(), n.setItemSync(e, JSON.stringify(s)), i.default().unlock(t), this.refreshLockWhileAcquired(e, t), [
                                            2
                                        ])) : (i.default().unlock(t), [
                                            2
                                        ]);
                                }
                            });
                        });
                    }, 1e3), [
                        2
                    ];
                });
            });
        }, e.prototype.waitForSomethingToChange = function(t) {
            return o(this, void 0, void 0, function() {
                return r(this, function(n) {
                    switch(n.label){
                        case 0:
                            return [
                                4,
                                new Promise(function(n) {
                                    var o = !1, i = Date.now(), r = !1;
                                    function s() {
                                        if (r || (window.removeEventListener("storage", s), e.removeFromWaiting(s), clearTimeout(a), r = !0), !o) {
                                            o = !0;
                                            var t = 50 - (Date.now() - i);
                                            t > 0 ? setTimeout(n, t) : n(null);
                                        }
                                    }
                                    window.addEventListener("storage", s), e.addToWaiting(s);
                                    var a = setTimeout(s, Math.max(0, t - Date.now()));
                                })
                            ];
                        case 1:
                            return n.sent(), [
                                2
                            ];
                    }
                });
            });
        }, e.addToWaiting = function(t) {
            this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
        }, e.removeFromWaiting = function(t) {
            void 0 !== e.waiters && (e.waiters = e.waiters.filter(function(e) {
                return e !== t;
            }));
        }, e.notifyWaiters = function() {
            void 0 !== e.waiters && e.waiters.slice().forEach(function(e) {
                return e();
            });
        }, e.prototype.releaseLock = function(e) {
            return o(this, void 0, void 0, function() {
                return r(this, function(t) {
                    switch(t.label){
                        case 0:
                            return [
                                4,
                                this.releaseLock__private__(e)
                            ];
                        case 1:
                            return [
                                2,
                                t.sent()
                            ];
                    }
                });
            });
        }, e.prototype.releaseLock__private__ = function(t) {
            return o(this, void 0, void 0, function() {
                var n, o, s, u;
                return r(this, function(r) {
                    switch(r.label){
                        case 0:
                            return n = void 0 === this.storageHandler ? c : this.storageHandler, o = a + "-" + t, null === (s = n.getItemSync(o)) ? [
                                2
                            ] : (u = JSON.parse(s)).id !== this.id ? [
                                3,
                                2
                            ] : [
                                4,
                                i.default().lock(u.iat)
                            ];
                        case 1:
                            r.sent(), this.acquiredIatSet.delete(u.iat), n.removeItemSync(o), i.default().unlock(u.iat), e.notifyWaiters(), r.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
        }, e.lockCorrector = function(t) {
            for(var n = Date.now() - 5e3, o = t, i = [], r = 0;;){
                var s = o.keySync(r);
                if (null === s) break;
                i.push(s), r++;
            }
            for(var c = !1, u = 0; u < i.length; u++){
                var d = i[u];
                if (d.includes(a)) {
                    var h = o.getItemSync(d);
                    if (null !== h) {
                        var l = JSON.parse(h);
                        (void 0 === l.timeRefreshed && l.timeAcquired < n || void 0 !== l.timeRefreshed && l.timeRefreshed < n) && (o.removeItemSync(d), c = !0);
                    }
                }
            }
            c && e.notifyWaiters();
        }, e.waiters = void 0, e;
    }();
    n.default = h;
}));
const s = {
    timeoutInSeconds: 60
}, a = {
    name: "auth0-spa-js",
    version: "2.9.0"
}, c = ()=>Date.now();
class u extends Error {
    constructor(e, t){
        super(t), this.error = e, this.error_description = t, Object.setPrototypeOf(this, u.prototype);
    }
    static fromPayload({ error: e, error_description: t }) {
        return new u(e, t);
    }
}
class d extends u {
    constructor(e, t, n, o = null){
        super(e, t), this.state = n, this.appState = o, Object.setPrototypeOf(this, d.prototype);
    }
}
class h extends u {
    constructor(e, t, n, o, i = null){
        super(e, t), this.connection = n, this.state = o, this.appState = i, Object.setPrototypeOf(this, h.prototype);
    }
}
class l extends u {
    constructor(){
        super("timeout", "Timeout"), Object.setPrototypeOf(this, l.prototype);
    }
}
class p extends l {
    constructor(e){
        super(), this.popup = e, Object.setPrototypeOf(this, p.prototype);
    }
}
class m extends u {
    constructor(e){
        super("cancelled", "Popup closed"), this.popup = e, Object.setPrototypeOf(this, m.prototype);
    }
}
class f extends u {
    constructor(e, t, n){
        super(e, t), this.mfa_token = n, Object.setPrototypeOf(this, f.prototype);
    }
}
class g extends u {
    constructor(e, t){
        super("missing_refresh_token", `Missing Refresh Token (audience: '${b(e, [
            "default"
        ])}', scope: '${b(t)}')`), this.audience = e, this.scope = t, Object.setPrototypeOf(this, g.prototype);
    }
}
class y extends u {
    constructor(e, t){
        super("missing_scopes", `Missing requested scopes after refresh (audience: '${b(e, [
            "default"
        ])}', missing scope: '${b(t)}')`), this.audience = e, this.scope = t, Object.setPrototypeOf(this, y.prototype);
    }
}
class w extends u {
    constructor(e){
        super("use_dpop_nonce", "Server rejected DPoP proof: wrong nonce"), this.newDpopNonce = e, Object.setPrototypeOf(this, w.prototype);
    }
}
function b(e, t = []) {
    return e && !t.includes(e) ? e : "";
}
const k = ()=>window.crypto, v = ()=>{
    const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
    let t = "";
    return Array.from(k().getRandomValues(new Uint8Array(43))).forEach((n)=>t += e[n % e.length]), t;
}, _ = (e)=>btoa(e), S = [
    {
        key: "name",
        type: [
            "string"
        ]
    },
    {
        key: "version",
        type: [
            "string",
            "number"
        ]
    },
    {
        key: "env",
        type: [
            "object"
        ]
    }
], I = (e)=>Object.keys(e).reduce((t, n)=>{
        const o = S.find((e)=>e.key === n);
        return o && o.type.includes(typeof e[n]) && (t[n] = e[n]), t;
    }, {}), P = (t)=>{
    var { clientId: n } = t, o = e(t, [
        "clientId"
    ]);
    return new URLSearchParams(((e)=>Object.keys(e).filter((t)=>void 0 !== e[t]).reduce((t, n)=>Object.assign(Object.assign({}, t), {
                [n]: e[n]
            }), {}))(Object.assign({
        client_id: n
    }, o))).toString();
}, T = async (e)=>{
    const t = k().subtle.digest({
        name: "SHA-256"
    }, (new TextEncoder).encode(e));
    return await t;
}, O = (e)=>((e)=>decodeURIComponent(atob(e).split("").map((e)=>"%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), j = (e)=>{
    const t = new Uint8Array(e);
    return ((e)=>{
        const t = {
            "+": "-",
            "/": "_",
            "=": ""
        };
        return e.replace(/[+/=]/g, (e)=>t[e]);
    })(window.btoa(String.fromCharCode(...Array.from(t))));
}, C = new TextEncoder, K = new TextDecoder;
function x(e) {
    return "string" == typeof e ? C.encode(e) : K.decode(e);
}
function z(e) {
    if ("number" != typeof e.modulusLength || e.modulusLength < 2048) throw new A(`${e.name} modulusLength must be at least 2048 bits`);
}
async function E(e, t, n) {
    if (!1 === n.usages.includes("sign")) throw new TypeError('private CryptoKey instances used for signing assertions must include "sign" in their "usages"');
    const o = `${R(x(JSON.stringify(e)))}.${R(x(JSON.stringify(t)))}`;
    return `${o}.${R(await crypto.subtle.sign(function(e) {
        switch(e.algorithm.name){
            case "ECDSA":
                return {
                    name: e.algorithm.name,
                    hash: "SHA-256"
                };
            case "RSA-PSS":
                return z(e.algorithm), {
                    name: e.algorithm.name,
                    saltLength: 32
                };
            case "RSASSA-PKCS1-v1_5":
                return z(e.algorithm), {
                    name: e.algorithm.name
                };
            case "Ed25519":
                return {
                    name: e.algorithm.name
                };
        }
        throw new D;
    }(n), n, x(o)))}`;
}
let N;
if (Uint8Array.prototype.toBase64) N = (e)=>(e instanceof ArrayBuffer && (e = new Uint8Array(e)), e.toBase64({
        alphabet: "base64url",
        omitPadding: !0
    }));
else {
    const e = 32768;
    N = (t)=>{
        t instanceof ArrayBuffer && (t = new Uint8Array(t));
        const n = [];
        for(let o = 0; o < t.byteLength; o += e)n.push(String.fromCharCode.apply(null, t.subarray(o, o + e)));
        return btoa(n.join("")).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
}
function R(e) {
    return N(e);
}
class D extends Error {
    constructor(e){
        var t;
        super(null != e ? e : "operation not supported"), this.name = this.constructor.name, null === (t = Error.captureStackTrace) || void 0 === t || t.call(Error, this, this.constructor);
    }
}
class A extends Error {
    constructor(e){
        var t;
        super(e), this.name = this.constructor.name, null === (t = Error.captureStackTrace) || void 0 === t || t.call(Error, this, this.constructor);
    }
}
function U(e) {
    switch(e.algorithm.name){
        case "RSA-PSS":
            return function(e) {
                if ("SHA-256" === e.algorithm.hash.name) return "PS256";
                throw new D("unsupported RsaHashedKeyAlgorithm hash name");
            }(e);
        case "RSASSA-PKCS1-v1_5":
            return function(e) {
                if ("SHA-256" === e.algorithm.hash.name) return "RS256";
                throw new D("unsupported RsaHashedKeyAlgorithm hash name");
            }(e);
        case "ECDSA":
            return function(e) {
                if ("P-256" === e.algorithm.namedCurve) return "ES256";
                throw new D("unsupported EcKeyAlgorithm namedCurve");
            }(e);
        case "Ed25519":
            return "Ed25519";
        default:
            throw new D("unsupported CryptoKey algorithm name");
    }
}
function L(e) {
    return e instanceof CryptoKey;
}
function Z(e) {
    return L(e) && "public" === e.type;
}
async function H(e, t, n, o, i, r) {
    const s = null == e ? void 0 : e.privateKey, a = null == e ? void 0 : e.publicKey;
    if (!L(c = s) || "private" !== c.type) throw new TypeError('"keypair.privateKey" must be a private CryptoKey');
    var c;
    if (!Z(a)) throw new TypeError('"keypair.publicKey" must be a public CryptoKey');
    if (!0 !== a.extractable) throw new TypeError('"keypair.publicKey.extractable" must be true');
    if ("string" != typeof t) throw new TypeError('"htu" must be a string');
    if ("string" != typeof n) throw new TypeError('"htm" must be a string');
    if (void 0 !== o && "string" != typeof o) throw new TypeError('"nonce" must be a string or undefined');
    if (void 0 !== i && "string" != typeof i) throw new TypeError('"accessToken" must be a string or undefined');
    if (void 0 !== r && ("object" != typeof r || null === r || Array.isArray(r))) throw new TypeError('"additional" must be an object');
    return E({
        alg: U(s),
        typ: "dpop+jwt",
        jwk: await W(a)
    }, Object.assign(Object.assign({}, r), {
        iat: Math.floor(Date.now() / 1e3),
        jti: crypto.randomUUID(),
        htm: n,
        nonce: o,
        htu: t,
        ath: i ? R(await crypto.subtle.digest("SHA-256", x(i))) : void 0
    }), s);
}
async function W(e) {
    const { kty: t, e: n, n: o, x: i, y: r, crv: s } = await crypto.subtle.exportKey("jwk", e);
    return {
        kty: t,
        crv: s,
        e: n,
        n: o,
        x: i,
        y: r
    };
}
const J = [
    "authorization_code",
    "refresh_token",
    "urn:ietf:params:oauth:grant-type:token-exchange"
];
function X() {
    return async function(e, t) {
        var n;
        let o;
        if ("string" != typeof e || 0 === e.length) throw new TypeError('"alg" must be a non-empty string');
        switch(e){
            case "PS256":
                o = {
                    name: "RSA-PSS",
                    hash: "SHA-256",
                    modulusLength: 2048,
                    publicExponent: new Uint8Array([
                        1,
                        0,
                        1
                    ])
                };
                break;
            case "RS256":
                o = {
                    name: "RSASSA-PKCS1-v1_5",
                    hash: "SHA-256",
                    modulusLength: 2048,
                    publicExponent: new Uint8Array([
                        1,
                        0,
                        1
                    ])
                };
                break;
            case "ES256":
                o = {
                    name: "ECDSA",
                    namedCurve: "P-256"
                };
                break;
            case "Ed25519":
                o = {
                    name: "Ed25519"
                };
                break;
            default:
                throw new D;
        }
        return crypto.subtle.generateKey(o, null !== (n = null == t ? void 0 : t.extractable) && void 0 !== n && n, [
            "sign",
            "verify"
        ]);
    }("ES256", {
        extractable: !1
    });
}
function V(e) {
    return async function(e) {
        if (!Z(e)) throw new TypeError('"publicKey" must be a public CryptoKey');
        if (!0 !== e.extractable) throw new TypeError('"publicKey.extractable" must be true');
        const t = await W(e);
        let n;
        switch(t.kty){
            case "EC":
                n = {
                    crv: t.crv,
                    kty: t.kty,
                    x: t.x,
                    y: t.y
                };
                break;
            case "OKP":
                n = {
                    crv: t.crv,
                    kty: t.kty,
                    x: t.x
                };
                break;
            case "RSA":
                n = {
                    e: t.e,
                    kty: t.kty,
                    n: t.n
                };
                break;
            default:
                throw new D("unsupported JWK kty");
        }
        return R(await crypto.subtle.digest({
            name: "SHA-256"
        }, x(JSON.stringify(n))));
    }(e.publicKey);
}
function F({ keyPair: e, url: t, method: n, nonce: o, accessToken: i }) {
    const r = function(e) {
        const t = new URL(e);
        return t.search = "", t.hash = "", t.href;
    }(t);
    return H(e, r, n, o, i);
}
const G = async (e, t)=>{
    const n = await fetch(e, t);
    var o;
    return {
        ok: n.ok,
        json: await n.json(),
        headers: (o = n.headers, [
            ...o
        ].reduce((e, [t, n])=>(e[t] = n, e), {}))
    };
}, M = async (e, t, n)=>{
    const o = new AbortController;
    let i;
    return t.signal = o.signal, Promise.race([
        G(e, t),
        new Promise((e, t)=>{
            i = setTimeout(()=>{
                o.abort(), t(new Error("Timeout when executing 'fetch'"));
            }, n);
        })
    ]).finally(()=>{
        clearTimeout(i);
    });
}, Y = async (e, t, n, o, i, r, s, a)=>{
    var c, u;
    return c = {
        auth: {
            audience: t,
            scope: n
        },
        timeout: i,
        fetchUrl: e,
        fetchOptions: o,
        useFormData: s,
        useMrrt: a
    }, u = r, new Promise(function(e, t) {
        const n = new MessageChannel;
        n.port1.onmessage = function(o) {
            o.data.error ? t(new Error(o.data.error)) : e(o.data), n.port1.close();
        }, u.postMessage(c, [
            n.port2
        ]);
    });
}, $ = async (e, t, n, o, i, r, s = 1e4, a)=>i ? Y(e, t, n, o, s, i, r, a) : M(e, o, s);
async function B(t, n, o, i, r, s, a, c, d, h) {
    if (d) {
        const e = await d.generateProof({
            url: t,
            method: r.method || "GET",
            nonce: await d.getNonce()
        });
        r.headers = Object.assign(Object.assign({}, r.headers), {
            dpop: e
        });
    }
    let l, p = null;
    for(let e = 0; e < 3; e++)try {
        l = await $(t, o, i, r, s, a, n, c), p = null;
        break;
    } catch (e) {
        p = e;
    }
    if (p) throw p;
    const m = l.json, { error: y, error_description: b } = m, k = e(m, [
        "error",
        "error_description"
    ]), { headers: v, ok: _ } = l;
    let S;
    if (d && (S = v["dpop-nonce"], S && await d.setNonce(S)), !_) {
        const e = b || `HTTP error. Unable to fetch ${t}`;
        if ("mfa_required" === y) throw new f(y, e, k.mfa_token);
        if ("missing_refresh_token" === y) throw new g(o, i);
        if ("use_dpop_nonce" === y) {
            if (!d || !S || h) throw new w(S);
            return B(t, n, o, i, r, s, a, c, d, !0);
        }
        throw new u(y || "request_error", e);
    }
    return k;
}
async function q(t, n) {
    var { baseUrl: o, timeout: i, audience: r, scope: s, auth0Client: c, useFormData: u, useMrrt: d, dpop: h } = t, l = e(t, [
        "baseUrl",
        "timeout",
        "audience",
        "scope",
        "auth0Client",
        "useFormData",
        "useMrrt",
        "dpop"
    ]);
    const p = "urn:ietf:params:oauth:grant-type:token-exchange" === l.grant_type, m = "refresh_token" === l.grant_type && d, f = Object.assign(Object.assign(Object.assign(Object.assign({}, l), p && r && {
        audience: r
    }), p && s && {
        scope: s
    }), m && {
        audience: r,
        scope: s
    }), g = u ? P(f) : JSON.stringify(f), y = (w = l.grant_type, J.includes(w));
    var w;
    return await B(`${o}/oauth/token`, i, r || "default", s, {
        method: "POST",
        body: g,
        headers: {
            "Content-Type": u ? "application/x-www-form-urlencoded" : "application/json",
            "Auth0-Client": btoa(JSON.stringify(I(c || a)))
        }
    }, n, u, d, y ? h : void 0);
}
const Q = (...e)=>{
    var t;
    return (t = e.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(t))).join(" ");
}, ee = (e, t, n)=>{
    let o;
    return n && (o = e[n]), o || (o = e.default), Q(o, t);
};
class te {
    constructor(e, t = "@@auth0spajs@@", n){
        this.prefix = t, this.suffix = n, this.clientId = e.clientId, this.scope = e.scope, this.audience = e.audience;
    }
    toKey() {
        return [
            this.prefix,
            this.clientId,
            this.audience,
            this.scope,
            this.suffix
        ].filter(Boolean).join("::");
    }
    static fromKey(e) {
        const [t, n, o, i] = e.split("::");
        return new te({
            clientId: n,
            scope: i,
            audience: o
        }, t);
    }
    static fromCacheEntry(e) {
        const { scope: t, audience: n, client_id: o } = e;
        return new te({
            scope: t,
            audience: n,
            clientId: o
        });
    }
}
class ne {
    set(e, t) {
        localStorage.setItem(e, JSON.stringify(t));
    }
    get(e) {
        const t = window.localStorage.getItem(e);
        if (t) try {
            return JSON.parse(t);
        } catch (e) {
            return;
        }
    }
    remove(e) {
        localStorage.removeItem(e);
    }
    allKeys() {
        return Object.keys(window.localStorage).filter((e)=>e.startsWith("@@auth0spajs@@"));
    }
}
class oe {
    constructor(){
        this.enclosedCache = function() {
            let e = {};
            return {
                set (t, n) {
                    e[t] = n;
                },
                get (t) {
                    const n = e[t];
                    if (n) return n;
                },
                remove (t) {
                    delete e[t];
                },
                allKeys: ()=>Object.keys(e)
            };
        }();
    }
}
class ie {
    constructor(e, t, n){
        this.cache = e, this.keyManifest = t, this.nowProvider = n || c;
    }
    async setIdToken(e, t, n) {
        var o;
        const i = this.getIdTokenCacheKey(e);
        await this.cache.set(i, {
            id_token: t,
            decodedToken: n
        }), await (null === (o = this.keyManifest) || void 0 === o ? void 0 : o.add(i));
    }
    async getIdToken(e) {
        const t = await this.cache.get(this.getIdTokenCacheKey(e.clientId));
        if (!t && e.scope && e.audience) {
            const t = await this.get(e);
            if (!t) return;
            if (!t.id_token || !t.decodedToken) return;
            return {
                id_token: t.id_token,
                decodedToken: t.decodedToken
            };
        }
        if (t) return {
            id_token: t.id_token,
            decodedToken: t.decodedToken
        };
    }
    async get(e, t = 0, n = !1, o) {
        var i;
        let r = await this.cache.get(e.toKey());
        if (!r) {
            const t = await this.getCacheKeys();
            if (!t) return;
            const i = this.matchExistingCacheKey(e, t);
            if (i && (r = await this.cache.get(i)), !i && n && "cache-only" !== o) return this.getEntryWithRefreshToken(e, t);
        }
        if (!r) return;
        const s = await this.nowProvider(), a = Math.floor(s / 1e3);
        return r.expiresAt - t < a ? r.body.refresh_token ? this.modifiedCachedEntry(r, e) : (await this.cache.remove(e.toKey()), void await (null === (i = this.keyManifest) || void 0 === i ? void 0 : i.remove(e.toKey()))) : r.body;
    }
    async modifiedCachedEntry(e, t) {
        return e.body = {
            refresh_token: e.body.refresh_token,
            audience: e.body.audience,
            scope: e.body.scope
        }, await this.cache.set(t.toKey(), e), {
            refresh_token: e.body.refresh_token,
            audience: e.body.audience,
            scope: e.body.scope
        };
    }
    async set(e) {
        var t;
        const n = new te({
            clientId: e.client_id,
            scope: e.scope,
            audience: e.audience
        }), o = await this.wrapCacheEntry(e);
        await this.cache.set(n.toKey(), o), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(n.toKey()));
    }
    async remove(e, t, n) {
        const o = new te({
            clientId: e,
            scope: n,
            audience: t
        });
        await this.cache.remove(o.toKey());
    }
    async clear(e) {
        var t;
        const n = await this.getCacheKeys();
        n && (await n.filter((t)=>!e || t.includes(e)).reduce(async (e, t)=>{
            await e, await this.cache.remove(t);
        }, Promise.resolve()), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear()));
    }
    async wrapCacheEntry(e) {
        const t = await this.nowProvider();
        return {
            body: e,
            expiresAt: Math.floor(t / 1e3) + e.expires_in
        };
    }
    async getCacheKeys() {
        var e;
        return this.keyManifest ? null === (e = await this.keyManifest.get()) || void 0 === e ? void 0 : e.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
    }
    getIdTokenCacheKey(e) {
        return new te({
            clientId: e
        }, "@@auth0spajs@@", "@@user@@").toKey();
    }
    matchExistingCacheKey(e, t) {
        return t.filter((t)=>{
            var n;
            const o = te.fromKey(t), i = new Set(o.scope && o.scope.split(" ")), r = (null === (n = e.scope) || void 0 === n ? void 0 : n.split(" ")) || [], s = o.scope && r.reduce((e, t)=>e && i.has(t), !0);
            return "@@auth0spajs@@" === o.prefix && o.clientId === e.clientId && o.audience === e.audience && s;
        })[0];
    }
    async getEntryWithRefreshToken(e, t) {
        var n;
        for (const o of t){
            const t = te.fromKey(o);
            if ("@@auth0spajs@@" === t.prefix && t.clientId === e.clientId) {
                const t = await this.cache.get(o);
                if (null === (n = null == t ? void 0 : t.body) || void 0 === n ? void 0 : n.refresh_token) return this.modifiedCachedEntry(t, e);
            }
        }
    }
    async updateEntry(e, t) {
        var n;
        const o = await this.getCacheKeys();
        if (o) for (const i of o){
            const o = await this.cache.get(i);
            if ((null === (n = null == o ? void 0 : o.body) || void 0 === n ? void 0 : n.refresh_token) === e) {
                const e = Object.assign(Object.assign({}, o.body), {
                    refresh_token: t
                });
                await this.set(e);
            }
        }
    }
}
class re {
    constructor(e, t, n){
        this.storage = e, this.clientId = t, this.cookieDomain = n, this.storageKey = `a0.spajs.txs.${this.clientId}`;
    }
    create(e) {
        this.storage.save(this.storageKey, e, {
            daysUntilExpire: 1,
            cookieDomain: this.cookieDomain
        });
    }
    get() {
        return this.storage.get(this.storageKey);
    }
    remove() {
        this.storage.remove(this.storageKey, {
            cookieDomain: this.cookieDomain
        });
    }
}
const se = (e)=>"number" == typeof e, ae = [
    "iss",
    "aud",
    "exp",
    "nbf",
    "iat",
    "jti",
    "azp",
    "nonce",
    "auth_time",
    "at_hash",
    "c_hash",
    "acr",
    "amr",
    "sub_jwk",
    "cnf",
    "sip_from_tag",
    "sip_date",
    "sip_callid",
    "sip_cseq_num",
    "sip_via_branch",
    "orig",
    "dest",
    "mky",
    "events",
    "toe",
    "txn",
    "rph",
    "sid",
    "vot",
    "vtm"
], ce = (e)=>{
    if (!e.id_token) throw new Error("ID token is required but missing");
    const t = ((e)=>{
        const t = e.split("."), [n, o, i] = t;
        if (3 !== t.length || !n || !o || !i) throw new Error("ID token could not be decoded");
        const r = JSON.parse(O(o)), s = {
            __raw: e
        }, a = {};
        return Object.keys(r).forEach((e)=>{
            s[e] = r[e], ae.includes(e) || (a[e] = r[e]);
        }), {
            encoded: {
                header: n,
                payload: o,
                signature: i
            },
            header: JSON.parse(O(n)),
            claims: s,
            user: a
        };
    })(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e.iss}", found "${t.claims.iss}"`);
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error(`Signature algorithm of "${t.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e.aud)) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but was not one of "${t.claims.aud.join(", ")}"`);
        if (t.claims.aud.length > 1) {
            if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
            if (t.claims.azp !== e.aud) throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e.aud}", found "${t.claims.azp}"`);
        }
    } else if (t.claims.aud !== e.aud) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but found "${t.claims.aud}"`);
    if (e.nonce) {
        if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
        if (t.claims.nonce !== e.nonce) throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e.nonce}", found "${t.claims.nonce}"`);
    }
    if (e.max_age && !se(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (null == t.claims.exp || !se(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!se(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    const n = e.leeway || 60, o = new Date(e.now || Date.now()), i = new Date(0);
    if (i.setUTCSeconds(t.claims.exp + n), o > i) throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${o}) is after expiration time (${i})`);
    if (null != t.claims.nbf && se(t.claims.nbf)) {
        const e = new Date(0);
        if (e.setUTCSeconds(t.claims.nbf - n), o < e) throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${o}) is before ${e}`);
    }
    if (null != t.claims.auth_time && se(t.claims.auth_time)) {
        const i = new Date(0);
        if (i.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + n), o > i) throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${o}) is after last auth at ${i}`);
    }
    if (e.organization) {
        const n = e.organization.trim();
        if (n.startsWith("org_")) {
            const e = n;
            if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
            if (e !== t.claims.org_id) throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_id}"`);
        } else {
            const e = n.toLowerCase();
            if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
            if (e !== t.claims.org_name) throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_name}"`);
        }
    }
    return t;
};
var ue = o(function(e, n) {
    var o = t && t.__assign || function() {
        return o = Object.assign || function(e) {
            for(var t, n = 1, o = arguments.length; n < o; n++)for(var i in t = arguments[n])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
            return e;
        }, o.apply(this, arguments);
    };
    function i(e, t) {
        if (!t) return "";
        var n = "; " + e;
        return !0 === t ? n : n + "=" + t;
    }
    function r(e, t, n) {
        return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(e) {
            if ("number" == typeof e.expires) {
                var t = new Date;
                t.setMilliseconds(t.getMilliseconds() + 864e5 * e.expires), e.expires = t;
            }
            return i("Expires", e.expires ? e.expires.toUTCString() : "") + i("Domain", e.domain) + i("Path", e.path) + i("Secure", e.secure) + i("SameSite", e.sameSite);
        }(n);
    }
    function s(e) {
        for(var t = {}, n = e ? e.split("; ") : [], o = /(%[\dA-F]{2})+/gi, i = 0; i < n.length; i++){
            var r = n[i].split("="), s = r.slice(1).join("=");
            '"' === s.charAt(0) && (s = s.slice(1, -1));
            try {
                t[r[0].replace(o, decodeURIComponent)] = s.replace(o, decodeURIComponent);
            } catch (e) {}
        }
        return t;
    }
    function a() {
        return s(document.cookie);
    }
    function c(e, t, n) {
        document.cookie = r(e, t, o({
            path: "/"
        }, n));
    }
    n.__esModule = !0, n.encode = r, n.parse = s, n.getAll = a, n.get = function(e) {
        return a()[e];
    }, n.set = c, n.remove = function(e, t) {
        c(e, "", o(o({}, t), {
            expires: -1
        }));
    };
});
n(ue), ue.encode, ue.parse, ue.getAll;
var de = ue.get, he = ue.set, le = ue.remove;
const pe = {
    get (e) {
        const t = de(e);
        if (void 0 !== t) return JSON.parse(t);
    },
    save (e, t, n) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0,
            sameSite: "none"
        }), (null == n ? void 0 : n.daysUntilExpire) && (o.expires = n.daysUntilExpire), (null == n ? void 0 : n.cookieDomain) && (o.domain = n.cookieDomain), he(e, JSON.stringify(t), o);
    },
    remove (e, t) {
        let n = {};
        (null == t ? void 0 : t.cookieDomain) && (n.domain = t.cookieDomain), le(e, n);
    }
}, me = {
    get (e) {
        const t = pe.get(e);
        return t || pe.get(`_legacy_${e}`);
    },
    save (e, t, n) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0
        }), (null == n ? void 0 : n.daysUntilExpire) && (o.expires = n.daysUntilExpire), (null == n ? void 0 : n.cookieDomain) && (o.domain = n.cookieDomain), he(`_legacy_${e}`, JSON.stringify(t), o), pe.save(e, t, n);
    },
    remove (e, t) {
        let n = {};
        (null == t ? void 0 : t.cookieDomain) && (n.domain = t.cookieDomain), le(e, n), pe.remove(e, t), pe.remove(`_legacy_${e}`, t);
    }
}, fe = {
    get (e) {
        if ("undefined" == typeof sessionStorage) return;
        const t = sessionStorage.getItem(e);
        return null != t ? JSON.parse(t) : void 0;
    },
    save (e, t) {
        sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove (e) {
        sessionStorage.removeItem(e);
    }
};
var ge;
!function(e) {
    e.Code = "code", e.ConnectCode = "connect_code";
}(ge || (ge = {}));
class ye {
}
function we(e, t, n) {
    var o = void 0 === t ? null : t, i = function(e, t) {
        var n = atob(e);
        if (t) {
            for(var o = new Uint8Array(n.length), i = 0, r = n.length; i < r; ++i)o[i] = n.charCodeAt(i);
            return String.fromCharCode.apply(null, new Uint16Array(o.buffer));
        }
        return n;
    }(e, void 0 !== n && n), r = i.indexOf("\n", 10) + 1, s = i.substring(r) + (o ? "//# sourceMappingURL=" + o : ""), a = new Blob([
        s
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(a);
}
var be, ke, ve, _e, Se = (be = "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", ke = null, ve = !1, function(e) {
    return _e = _e || we(be, ke, ve), new Worker(_e, e);
});
const Ie = {};
class Pe {
    constructor(e, t){
        this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
    }
    async add(e) {
        var t;
        const n = new Set((null === (t = await this.cache.get(this.manifestKey)) || void 0 === t ? void 0 : t.keys) || []);
        n.add(e), await this.cache.set(this.manifestKey, {
            keys: [
                ...n
            ]
        });
    }
    async remove(e) {
        const t = await this.cache.get(this.manifestKey);
        if (t) {
            const n = new Set(t.keys);
            return n.delete(e), n.size > 0 ? await this.cache.set(this.manifestKey, {
                keys: [
                    ...n
                ]
            }) : await this.cache.remove(this.manifestKey);
        }
    }
    get() {
        return this.cache.get(this.manifestKey);
    }
    clear() {
        return this.cache.remove(this.manifestKey);
    }
    createManifestKeyFrom(e) {
        return `@@auth0spajs@@::${e}`;
    }
}
const Te = {
    memory: ()=>(new oe).enclosedCache,
    localstorage: ()=>new ne
}, Oe = (e)=>Te[e], je = (t)=>{
    const { openUrl: n, onRedirect: o } = t, i = e(t, [
        "openUrl",
        "onRedirect"
    ]);
    return Object.assign(Object.assign({}, i), {
        openUrl: !1 === n || n ? n : o
    });
}, Ce = (e, t)=>{
    const n = (null == t ? void 0 : t.split(" ")) || [];
    return ((null == e ? void 0 : e.split(" ")) || []).every((e)=>n.includes(e));
}, Ke = {
    NONCE: "nonce",
    KEYPAIR: "keypair"
};
class xe {
    constructor(e){
        this.clientId = e;
    }
    getVersion() {
        return 1;
    }
    createDbHandle() {
        const e = window.indexedDB.open("auth0-spa-js", this.getVersion());
        return new Promise((t, n)=>{
            e.onupgradeneeded = ()=>Object.values(Ke).forEach((t)=>e.result.createObjectStore(t)), e.onerror = ()=>n(e.error), e.onsuccess = ()=>t(e.result);
        });
    }
    async getDbHandle() {
        return this.dbHandle || (this.dbHandle = await this.createDbHandle()), this.dbHandle;
    }
    async executeDbRequest(e, t, n) {
        const o = n((await this.getDbHandle()).transaction(e, t).objectStore(e));
        return new Promise((e, t)=>{
            o.onsuccess = ()=>e(o.result), o.onerror = ()=>t(o.error);
        });
    }
    buildKey(e) {
        const t = e ? `_${e}` : "auth0";
        return `${this.clientId}::${t}`;
    }
    setNonce(e, t) {
        return this.save(Ke.NONCE, this.buildKey(t), e);
    }
    setKeyPair(e) {
        return this.save(Ke.KEYPAIR, this.buildKey(), e);
    }
    async save(e, t, n) {
        await this.executeDbRequest(e, "readwrite", (e)=>e.put(n, t));
    }
    findNonce(e) {
        return this.find(Ke.NONCE, this.buildKey(e));
    }
    findKeyPair() {
        return this.find(Ke.KEYPAIR, this.buildKey());
    }
    find(e, t) {
        return this.executeDbRequest(e, "readonly", (e)=>e.get(t));
    }
    async deleteBy(e, t) {
        const n = await this.executeDbRequest(e, "readonly", (e)=>e.getAllKeys());
        null == n || n.filter(t).map((t)=>this.executeDbRequest(e, "readwrite", (e)=>e.delete(t)));
    }
    deleteByClientId(e, t) {
        return this.deleteBy(e, (e)=>"string" == typeof e && e.startsWith(`${t}::`));
    }
    clearNonces() {
        return this.deleteByClientId(Ke.NONCE, this.clientId);
    }
    clearKeyPairs() {
        return this.deleteByClientId(Ke.KEYPAIR, this.clientId);
    }
}
class ze {
    constructor(e){
        this.storage = new xe(e);
    }
    getNonce(e) {
        return this.storage.findNonce(e);
    }
    setNonce(e, t) {
        return this.storage.setNonce(e, t);
    }
    async getOrGenerateKeyPair() {
        let e = await this.storage.findKeyPair();
        return e || (e = await X(), await this.storage.setKeyPair(e)), e;
    }
    async generateProof(e) {
        const t = await this.getOrGenerateKeyPair();
        return F(Object.assign({
            keyPair: t
        }, e));
    }
    async calculateThumbprint() {
        return V(await this.getOrGenerateKeyPair());
    }
    async clear() {
        await Promise.all([
            this.storage.clearNonces(),
            this.storage.clearKeyPairs()
        ]);
    }
}
var Ee;
!function(e) {
    e.Bearer = "Bearer", e.DPoP = "DPoP";
}(Ee || (Ee = {}));
class Ne {
    constructor(e, t){
        this.hooks = t, this.config = Object.assign(Object.assign({}, e), {
            fetch: e.fetch || ("undefined" == typeof window ? fetch : window.fetch.bind(window))
        });
    }
    isAbsoluteUrl(e) {
        return /^(https?:)?\/\//i.test(e);
    }
    buildUrl(e, t) {
        if (t) {
            if (this.isAbsoluteUrl(t)) return t;
            if (e) return `${e.replace(/\/?\/$/, "")}/${t.replace(/^\/+/, "")}`;
        }
        throw new TypeError("`url` must be absolute or `baseUrl` non-empty.");
    }
    getAccessToken(e) {
        return this.config.getAccessToken ? this.config.getAccessToken(e) : this.hooks.getAccessToken(e);
    }
    extractUrl(e) {
        return "string" == typeof e ? e : e instanceof URL ? e.href : e.url;
    }
    buildBaseRequest(e, t) {
        if (!this.config.baseUrl) return new Request(e, t);
        const n = this.buildUrl(this.config.baseUrl, this.extractUrl(e)), o = e instanceof Request ? new Request(n, e) : n;
        return new Request(o, t);
    }
    setAuthorizationHeader(e, t, n = Ee.Bearer) {
        e.headers.set("authorization", `${n} ${t}`);
    }
    async setDpopProofHeader(e, t) {
        if (!this.config.dpopNonceId) return;
        const n = await this.hooks.getDpopNonce(), o = await this.hooks.generateDpopProof({
            accessToken: t,
            method: e.method,
            nonce: n,
            url: e.url
        });
        e.headers.set("dpop", o);
    }
    async prepareRequest(e, t) {
        const n = await this.getAccessToken(t);
        let o, i;
        "string" == typeof n ? (o = this.config.dpopNonceId ? Ee.DPoP : Ee.Bearer, i = n) : (o = n.token_type, i = n.access_token), this.setAuthorizationHeader(e, i, o), o === Ee.DPoP && await this.setDpopProofHeader(e, i);
    }
    getHeader(e, t) {
        return Array.isArray(e) ? new Headers(e).get(t) || "" : "function" == typeof e.get ? e.get(t) || "" : e[t] || "";
    }
    hasUseDpopNonceError(e) {
        if (401 !== e.status) return !1;
        const t = this.getHeader(e.headers, "www-authenticate");
        return t.includes("invalid_dpop_nonce") || t.includes("use_dpop_nonce");
    }
    async handleResponse(e, t) {
        const n = this.getHeader(e.headers, "dpop-nonce");
        if (n && await this.hooks.setDpopNonce(n), !this.hasUseDpopNonceError(e)) return e;
        if (!n || !t.onUseDpopNonceError) throw new w(n);
        return t.onUseDpopNonceError();
    }
    async internalFetchWithAuth(e, t, n, o) {
        const i = this.buildBaseRequest(e, t);
        await this.prepareRequest(i, o);
        const r = await this.config.fetch(i);
        return this.handleResponse(r, n);
    }
    fetchWithAuth(e, t, n) {
        const o = {
            onUseDpopNonceError: ()=>this.internalFetchWithAuth(e, t, Object.assign(Object.assign({}, o), {
                    onUseDpopNonceError: void 0
                }), n)
        };
        return this.internalFetchWithAuth(e, t, o, n);
    }
}
class Re {
    constructor(e, t){
        this.myAccountFetcher = e, this.apiBase = t;
    }
    async connectAccount(e) {
        const t = await this.myAccountFetcher.fetchWithAuth(`${this.apiBase}v1/connected-accounts/connect`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
        });
        return this._handleResponse(t);
    }
    async completeAccount(e) {
        const t = await this.myAccountFetcher.fetchWithAuth(`${this.apiBase}v1/connected-accounts/complete`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
        });
        return this._handleResponse(t);
    }
    async _handleResponse(e) {
        let t;
        try {
            t = await e.text(), t = JSON.parse(t);
        } catch (n) {
            throw new De({
                type: "invalid_json",
                status: e.status,
                title: "Invalid JSON response",
                detail: t || String(n)
            });
        }
        if (e.ok) return t;
        throw new De(t);
    }
}
class De extends Error {
    constructor({ type: e, status: t, title: n, detail: o, validation_errors: i }){
        super(o), this.name = "MyAccountApiError", this.type = e, this.status = t, this.title = n, this.detail = o, this.validation_errors = i, Object.setPrototypeOf(this, De.prototype);
    }
}
const Ae = new r;
class Ue {
    constructor(e){
        let t, n;
        if (this.userCache = (new oe).enclosedCache, this.activeLockKeys = new Set, this.defaultOptions = {
            authorizationParams: {
                scope: "openid profile email"
            },
            useRefreshTokensFallback: !1,
            useFormData: !0
        }, this._releaseLockOnPageHide = async ()=>{
            const e = Array.from(this.activeLockKeys);
            for (const t of e)await Ae.releaseLock(t);
            this.activeLockKeys.clear(), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
        }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), e), {
            authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), e.authorizationParams)
        }), "undefined" != typeof window && (()=>{
            if (!k()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
            if (void 0 === k().subtle) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
        })(), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) n = e.cache;
        else {
            if (t = e.cacheLocation || "memory", !Oe(t)) throw new Error(`Invalid cache location "${t}"`);
            n = Oe(t)();
        }
        this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : 1e4, this.cookieStorage = !1 === e.legacySameSiteCookie ? pe : me, this.orgHintCookieName = `auth0.${this.options.clientId}.organization_hint`, this.isAuthenticatedCookieName = ((e)=>`auth0.${e}.is.authenticated`)(this.options.clientId), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
        const o = e.useCookiesForTransactions ? this.cookieStorage : fe;
        var i;
        this.scope = ((e, t, ...n)=>{
            if ("object" != typeof e) return {
                default: Q(t, e, ...n)
            };
            let o = {
                default: Q(t, ...n)
            };
            return Object.keys(e).forEach((i)=>{
                const r = e[i];
                o[i] = Q(t, r, ...n);
            }), o;
        })(this.options.authorizationParams.scope, "openid", this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new re(o, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || c, this.cacheManager = new ie(n, n.allKeys ? void 0 : new Pe(n, this.options.clientId), this.nowProvider), this.dpop = this.options.useDpop ? new ze(this.options.clientId) : void 0, this.domainUrl = (i = this.options.domain, /^https?:\/\//.test(i) ? i : `https://${i}`), this.tokenIssuer = ((e, t)=>e ? e.startsWith("https://") ? e : `https://${e}/` : `${t}/`)(this.options.issuer, this.domainUrl);
        const r = `${this.domainUrl}/me/`, s = this.createFetcher(Object.assign(Object.assign({}, this.options.useDpop && {
            dpopNonceId: "__auth0_my_account_api__"
        }), {
            getAccessToken: ()=>this.getTokenSilently({
                    authorizationParams: {
                        scope: "create:me:connected_accounts",
                        audience: r
                    },
                    detailedResponse: !0
                })
        }));
        this.myAccountApi = new Re(s, r), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && "memory" === t && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new Se);
    }
    _url(e) {
        const t = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || a)));
        return `${this.domainUrl}${e}&auth0Client=${t}`;
    }
    _authorizeUrl(e) {
        return this._url(`/authorize?${P(e)}`);
    }
    async _verifyIdToken(e, t, n) {
        const o = await this.nowProvider();
        var i;
        return ce({
            iss: this.tokenIssuer,
            aud: this.options.clientId,
            id_token: e,
            nonce: t,
            organization: n,
            leeway: this.options.leeway,
            max_age: (i = this.options.authorizationParams.max_age, "string" != typeof i ? i : parseInt(i, 10) || void 0),
            now: o
        });
    }
    _processOrgHint(e) {
        e ? this.cookieStorage.save(this.orgHintCookieName, e, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }) : this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        });
    }
    async _prepareAuthorizeUrl(e, t, n) {
        var o;
        const i = _(v()), r = _(v()), s = v(), a = await T(s), c = j(a), u = await (null === (o = this.dpop) || void 0 === o ? void 0 : o.calculateThumbprint()), d = ((e, t, n, o, i, r, s, a, c)=>Object.assign(Object.assign(Object.assign({
                client_id: e.clientId
            }, e.authorizationParams), n), {
                scope: ee(t, n.scope, n.audience),
                response_type: "code",
                response_mode: a || "query",
                state: o,
                nonce: i,
                redirect_uri: s || e.authorizationParams.redirect_uri,
                code_challenge: r,
                code_challenge_method: "S256",
                dpop_jkt: c
            }))(this.options, this.scope, e, i, r, c, e.redirect_uri || this.options.authorizationParams.redirect_uri || n, null == t ? void 0 : t.response_mode, u), h = this._authorizeUrl(d);
        return {
            nonce: r,
            code_verifier: s,
            scope: d.scope,
            audience: d.audience || "default",
            redirect_uri: d.redirect_uri,
            state: i,
            url: h
        };
    }
    async loginWithPopup(e, t) {
        var n;
        if (e = e || {}, !(t = t || {}).popup && (t.popup = ((e)=>{
            const t = window.screenX + (window.innerWidth - 400) / 2, n = window.screenY + (window.innerHeight - 600) / 2;
            return window.open(e, "auth0:authorize:popup", `left=${t},top=${n},width=400,height=600,resizable,scrollbars=yes,status=1`);
        })(""), !t.popup)) throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
        const o = await this._prepareAuthorizeUrl(e.authorizationParams || {}, {
            response_mode: "web_message"
        }, window.location.origin);
        t.popup.location.href = o.url;
        const i = await ((e)=>new Promise((t, n)=>{
                let o;
                const i = setInterval(()=>{
                    e.popup && e.popup.closed && (clearInterval(i), clearTimeout(r), window.removeEventListener("message", o, !1), n(new m(e.popup)));
                }, 1e3), r = setTimeout(()=>{
                    clearInterval(i), n(new p(e.popup)), window.removeEventListener("message", o, !1);
                }, 1e3 * (e.timeoutInSeconds || 60));
                o = function(s) {
                    if (s.data && "authorization_response" === s.data.type) {
                        if (clearTimeout(r), clearInterval(i), window.removeEventListener("message", o, !1), e.popup.close(), s.data.response.error) return n(u.fromPayload(s.data.response));
                        t(s.data.response);
                    }
                }, window.addEventListener("message", o);
            }))(Object.assign(Object.assign({}, t), {
            timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
        }));
        if (o.state !== i.state) throw new u("state_mismatch", "Invalid state");
        const r = (null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.organization) || this.options.authorizationParams.organization;
        await this._requestToken({
            audience: o.audience,
            scope: o.scope,
            code_verifier: o.code_verifier,
            grant_type: "authorization_code",
            code: i.code,
            redirect_uri: o.redirect_uri
        }, {
            nonceIn: o.nonce,
            organization: r
        });
    }
    async getUser() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.user;
    }
    async getIdTokenClaims() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.claims;
    }
    async loginWithRedirect(t = {}) {
        var n;
        const o = je(t), { openUrl: i, fragment: r, appState: s } = o, a = e(o, [
            "openUrl",
            "fragment",
            "appState"
        ]), c = (null === (n = a.authorizationParams) || void 0 === n ? void 0 : n.organization) || this.options.authorizationParams.organization, u = await this._prepareAuthorizeUrl(a.authorizationParams || {}), { url: d } = u, h = e(u, [
            "url"
        ]);
        this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, h), {
            appState: s,
            response_type: ge.Code
        }), c && {
            organization: c
        }));
        const l = r ? `${d}#${r}` : d;
        i ? await i(l) : window.location.assign(l);
    }
    async handleRedirectCallback(e = window.location.href) {
        const t = e.split("?").slice(1);
        if (0 === t.length) throw new Error("There are no query params available for parsing.");
        const n = this.transactionManager.get();
        if (!n) throw new u("missing_transaction", "Invalid state");
        this.transactionManager.remove();
        const o = ((e)=>{
            e.indexOf("#") > -1 && (e = e.substring(0, e.indexOf("#")));
            const t = new URLSearchParams(e);
            return {
                state: t.get("state"),
                code: t.get("code") || void 0,
                connect_code: t.get("connect_code") || void 0,
                error: t.get("error") || void 0,
                error_description: t.get("error_description") || void 0
            };
        })(t.join(""));
        return n.response_type === ge.ConnectCode ? this._handleConnectAccountRedirectCallback(o, n) : this._handleLoginRedirectCallback(o, n);
    }
    async _handleLoginRedirectCallback(e, t) {
        const { code: n, state: o, error: i, error_description: r } = e;
        if (i) throw new d(i, r || i, o, t.appState);
        if (!t.code_verifier || t.state && t.state !== o) throw new u("state_mismatch", "Invalid state");
        const s = t.organization, a = t.nonce, c = t.redirect_uri;
        return await this._requestToken(Object.assign({
            audience: t.audience,
            scope: t.scope,
            code_verifier: t.code_verifier,
            grant_type: "authorization_code",
            code: n
        }, c ? {
            redirect_uri: c
        } : {}), {
            nonceIn: a,
            organization: s
        }), {
            appState: t.appState,
            response_type: ge.Code
        };
    }
    async _handleConnectAccountRedirectCallback(e, t) {
        const { connect_code: n, state: o, error: i, error_description: r } = e;
        if (i) throw new h(i, r || i, t.connection, o, t.appState);
        if (!n) throw new u("missing_connect_code", "Missing connect code");
        if (!(t.code_verifier && t.state && t.auth_session && t.redirect_uri && t.state === o)) throw new u("state_mismatch", "Invalid state");
        const s = await this.myAccountApi.completeAccount({
            auth_session: t.auth_session,
            connect_code: n,
            redirect_uri: t.redirect_uri,
            code_verifier: t.code_verifier
        });
        return Object.assign(Object.assign({}, s), {
            appState: t.appState,
            response_type: ge.ConnectCode
        });
    }
    async checkSession(e) {
        if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
            if (!this.cookieStorage.get("auth0.is.authenticated")) return;
            this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
            }), this.cookieStorage.remove("auth0.is.authenticated");
        }
        try {
            await this.getTokenSilently(e);
        } catch (e) {}
    }
    async getTokenSilently(e = {}) {
        var t, n;
        const o = Object.assign(Object.assign({
            cacheMode: "on"
        }, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: ee(this.scope, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope, (null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.audience) || this.options.authorizationParams.audience)
            })
        }), i = await ((e, t)=>{
            let n = Ie[t];
            return n || (n = e().finally(()=>{
                delete Ie[t], n = null;
            }), Ie[t] = n), n;
        })(()=>this._getTokenSilently(o), `${this.options.clientId}::${o.authorizationParams.audience}::${o.authorizationParams.scope}`);
        return e.detailedResponse ? i : null == i ? void 0 : i.access_token;
    }
    async _getTokenSilently(t) {
        const { cacheMode: n } = t, o = e(t, [
            "cacheMode"
        ]);
        if ("off" !== n) {
            const e = await this._getEntryFromCache({
                scope: o.authorizationParams.scope,
                audience: o.authorizationParams.audience || "default",
                clientId: this.options.clientId,
                cacheMode: n
            });
            if (e) return e;
        }
        if ("cache-only" === n) return;
        const i = (r = this.options.clientId, s = o.authorizationParams.audience || "default", `auth0.lock.getTokenSilently.${r}.${s}`);
        var r, s;
        if (!await (async (e, t = 3)=>{
            for(let n = 0; n < t; n++)if (await e()) return !0;
            return !1;
        })(()=>Ae.acquireLock(i, 5e3), 10)) throw new l;
        this.activeLockKeys.add(i), 1 === this.activeLockKeys.size && window.addEventListener("pagehide", this._releaseLockOnPageHide);
        try {
            if ("off" !== n) {
                const e = await this._getEntryFromCache({
                    scope: o.authorizationParams.scope,
                    audience: o.authorizationParams.audience || "default",
                    clientId: this.options.clientId
                });
                if (e) return e;
            }
            const e = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(o) : await this._getTokenFromIFrame(o), { id_token: t, token_type: r, access_token: s, oauthTokenScope: a, expires_in: c } = e;
            return Object.assign(Object.assign({
                id_token: t,
                token_type: r,
                access_token: s
            }, a ? {
                scope: a
            } : null), {
                expires_in: c
            });
        } finally{
            await Ae.releaseLock(i), this.activeLockKeys.delete(i), 0 === this.activeLockKeys.size && window.removeEventListener("pagehide", this._releaseLockOnPageHide);
        }
    }
    async getTokenWithPopup(e = {}, t = {}) {
        var n, o;
        const i = Object.assign(Object.assign({}, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: ee(this.scope, null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.scope, (null === (o = e.authorizationParams) || void 0 === o ? void 0 : o.audience) || this.options.authorizationParams.audience)
            })
        });
        t = Object.assign(Object.assign({}, s), t), await this.loginWithPopup(i, t);
        return (await this.cacheManager.get(new te({
            scope: i.authorizationParams.scope,
            audience: i.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }), void 0, this.options.useMrrt)).access_token;
    }
    async isAuthenticated() {
        return !!await this.getUser();
    }
    _buildLogoutUrl(t) {
        null !== t.clientId ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
        const n = t.logoutParams || {}, { federated: o } = n, i = e(n, [
            "federated"
        ]), r = o ? "&federated" : "";
        return this._url(`/v2/logout?${P(Object.assign({
            clientId: t.clientId
        }, i))}`) + r;
    }
    async logout(t = {}) {
        var n;
        const o = je(t), { openUrl: i } = o, r = e(o, [
            "openUrl"
        ]);
        null === t.clientId ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.cookieStorage.remove(this.isAuthenticatedCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.userCache.remove("@@user@@"), await (null === (n = this.dpop) || void 0 === n ? void 0 : n.clear());
        const s = this._buildLogoutUrl(r);
        i ? await i(s) : !1 !== i && window.location.assign(s);
    }
    async _getTokenFromIFrame(e) {
        const t = Object.assign(Object.assign({}, e.authorizationParams), {
            prompt: "none"
        }), n = this.cookieStorage.get(this.orgHintCookieName);
        n && !t.organization && (t.organization = n);
        const { url: o, state: i, nonce: r, code_verifier: s, redirect_uri: a, scope: c, audience: d } = await this._prepareAuthorizeUrl(t, {
            response_mode: "web_message"
        }, window.location.origin);
        try {
            if (window.crossOriginIsolated) throw new u("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
            const n = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds;
            let h;
            try {
                h = new URL(this.domainUrl).origin;
            } catch (e) {
                h = this.domainUrl;
            }
            const p = await ((e, t, n = 60)=>new Promise((o, i)=>{
                    const r = window.document.createElement("iframe");
                    r.setAttribute("width", "0"), r.setAttribute("height", "0"), r.style.display = "none";
                    const s = ()=>{
                        window.document.body.contains(r) && (window.document.body.removeChild(r), window.removeEventListener("message", a, !1));
                    };
                    let a;
                    const c = setTimeout(()=>{
                        i(new l), s();
                    }, 1e3 * n);
                    a = function(e) {
                        if (e.origin != t) return;
                        if (!e.data || "authorization_response" !== e.data.type) return;
                        const n = e.source;
                        n && n.close(), e.data.response.error ? i(u.fromPayload(e.data.response)) : o(e.data.response), clearTimeout(c), window.removeEventListener("message", a, !1), setTimeout(s, 2e3);
                    }, window.addEventListener("message", a, !1), window.document.body.appendChild(r), r.setAttribute("src", e);
                }))(o, h, n);
            if (i !== p.state) throw new u("state_mismatch", "Invalid state");
            const m = await this._requestToken(Object.assign(Object.assign({}, e.authorizationParams), {
                code_verifier: s,
                code: p.code,
                grant_type: "authorization_code",
                redirect_uri: a,
                timeout: e.authorizationParams.timeout || this.httpTimeoutMs
            }), {
                nonceIn: r,
                organization: t.organization
            });
            return Object.assign(Object.assign({}, m), {
                scope: c,
                oauthTokenScope: m.scope,
                audience: d
            });
        } catch (e) {
            throw "login_required" === e.error && this.logout({
                openUrl: !1
            }), e;
        }
    }
    async _getTokenUsingRefreshToken(e) {
        const t = await this.cacheManager.get(new te({
            scope: e.authorizationParams.scope,
            audience: e.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }), void 0, this.options.useMrrt);
        if (!(t && t.refresh_token || this.worker)) {
            if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw new g(e.authorizationParams.audience || "default", e.authorizationParams.scope);
        }
        const n = e.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, o = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null, i = ((e, t, n, o)=>{
            var i;
            if (e && n && o) {
                if (t.audience !== n) return t.scope;
                const e = o.split(" "), r = (null === (i = t.scope) || void 0 === i ? void 0 : i.split(" ")) || [], s = r.every((t)=>e.includes(t));
                return e.length >= r.length && s ? o : t.scope;
            }
            return t.scope;
        })(this.options.useMrrt, e.authorizationParams, null == t ? void 0 : t.audience, null == t ? void 0 : t.scope);
        try {
            const u = await this._requestToken(Object.assign(Object.assign(Object.assign({}, e.authorizationParams), {
                grant_type: "refresh_token",
                refresh_token: t && t.refresh_token,
                redirect_uri: n
            }), o && {
                timeout: o
            }), {
                scopesToRequest: i
            });
            if (u.refresh_token && this.options.useMrrt && (null == t ? void 0 : t.refresh_token) && await this.cacheManager.updateEntry(t.refresh_token, u.refresh_token), this.options.useMrrt) {
                if (r = null == t ? void 0 : t.audience, s = null == t ? void 0 : t.scope, a = e.authorizationParams.audience, c = e.authorizationParams.scope, r !== a || !Ce(c, s)) {
                    if (!Ce(i, u.scope)) {
                        if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
                        await this.cacheManager.remove(this.options.clientId, e.authorizationParams.audience, e.authorizationParams.scope);
                        const t = ((e, t)=>{
                            const n = (null == e ? void 0 : e.split(" ")) || [], o = (null == t ? void 0 : t.split(" ")) || [];
                            return n.filter((e)=>-1 == o.indexOf(e)).join(",");
                        })(i, u.scope);
                        throw new y(e.authorizationParams.audience || "default", t);
                    }
                }
            }
            return Object.assign(Object.assign({}, u), {
                scope: e.authorizationParams.scope,
                oauthTokenScope: u.scope,
                audience: e.authorizationParams.audience || "default"
            });
        } catch (t) {
            if ((t.message.indexOf("Missing Refresh Token") > -1 || t.message && t.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw t;
        }
        var r, s, a, c;
    }
    async _saveEntryInCache(t) {
        const { id_token: n, decodedToken: o } = t, i = e(t, [
            "id_token",
            "decodedToken"
        ]);
        this.userCache.set("@@user@@", {
            id_token: n,
            decodedToken: o
        }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(i);
    }
    async _getIdTokenFromCache() {
        const e = this.options.authorizationParams.audience || "default", t = this.scope[e], n = await this.cacheManager.getIdToken(new te({
            clientId: this.options.clientId,
            audience: e,
            scope: t
        })), o = this.userCache.get("@@user@@");
        return n && n.id_token === (null == o ? void 0 : o.id_token) ? o : (this.userCache.set("@@user@@", n), n);
    }
    async _getEntryFromCache({ scope: e, audience: t, clientId: n, cacheMode: o }) {
        const i = await this.cacheManager.get(new te({
            scope: e,
            audience: t,
            clientId: n
        }), 60, this.options.useMrrt, o);
        if (i && i.access_token) {
            const { token_type: e, access_token: t, oauthTokenScope: n, expires_in: o } = i, r = await this._getIdTokenFromCache();
            return r && Object.assign(Object.assign({
                id_token: r.id_token,
                token_type: e || "Bearer",
                access_token: t
            }, n ? {
                scope: n
            } : null), {
                expires_in: o
            });
        }
    }
    async _requestToken(e, t) {
        const { nonceIn: n, organization: o, scopesToRequest: i } = t || {}, r = await q(Object.assign(Object.assign({
            baseUrl: this.domainUrl,
            client_id: this.options.clientId,
            auth0Client: this.options.auth0Client,
            useFormData: this.options.useFormData,
            timeout: this.httpTimeoutMs,
            useMrrt: this.options.useMrrt,
            dpop: this.dpop
        }, e), {
            scope: i || e.scope
        }), this.worker), s = await this._verifyIdToken(r.id_token, n, o);
        return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, r), {
            decodedToken: s,
            scope: e.scope,
            audience: e.audience || "default"
        }), r.scope ? {
            oauthTokenScope: r.scope
        } : null), {
            client_id: this.options.clientId
        })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }), this._processOrgHint(o || s.claims.org_id), Object.assign(Object.assign({}, r), {
            decodedToken: s
        });
    }
    async exchangeToken(e) {
        return this._requestToken({
            grant_type: "urn:ietf:params:oauth:grant-type:token-exchange",
            subject_token: e.subject_token,
            subject_token_type: e.subject_token_type,
            scope: ee(this.scope, e.scope, e.audience || this.options.authorizationParams.audience),
            audience: e.audience || this.options.authorizationParams.audience
        });
    }
    _assertDpop(e) {
        if (!e) throw new Error("`useDpop` option must be enabled before using DPoP.");
    }
    getDpopNonce(e) {
        return this._assertDpop(this.dpop), this.dpop.getNonce(e);
    }
    setDpopNonce(e, t) {
        return this._assertDpop(this.dpop), this.dpop.setNonce(e, t);
    }
    generateDpopProof(e) {
        return this._assertDpop(this.dpop), this.dpop.generateProof(e);
    }
    createFetcher(e = {}) {
        return new Ne(e, {
            isDpopEnabled: ()=>!!this.options.useDpop,
            getAccessToken: (e)=>{
                var t;
                return this.getTokenSilently({
                    authorizationParams: {
                        scope: null === (t = null == e ? void 0 : e.scope) || void 0 === t ? void 0 : t.join(" "),
                        audience: null == e ? void 0 : e.audience
                    },
                    detailedResponse: !0
                });
            },
            getDpopNonce: ()=>this.getDpopNonce(e.dpopNonceId),
            setDpopNonce: (t)=>this.setDpopNonce(t, e.dpopNonceId),
            generateDpopProof: (e)=>this.generateDpopProof(e)
        });
    }
    async connectAccountWithRedirect(e) {
        const { openUrl: t, appState: n, connection: o, scopes: i, authorization_params: r, redirectUri: s = this.options.authorizationParams.redirect_uri || window.location.origin } = e;
        if (!o) throw new Error("connection is required");
        const a = _(v()), c = v(), u = await T(c), d = j(u), { connect_uri: h, connect_params: l, auth_session: p } = await this.myAccountApi.connectAccount({
            connection: o,
            scopes: i,
            redirect_uri: s,
            state: a,
            code_challenge: d,
            code_challenge_method: "S256",
            authorization_params: r
        });
        this.transactionManager.create({
            state: a,
            code_verifier: c,
            auth_session: p,
            redirect_uri: s,
            appState: n,
            connection: o,
            response_type: ge.ConnectCode
        });
        const m = new URL(h);
        m.searchParams.set("ticket", l.ticket), t ? await t(m.toString()) : window.location.assign(m);
    }
}
/**
 * The initial auth state.
 */ var initialAuthState = {
    isAuthenticated: false,
    isLoading: true,
    error: undefined,
    user: undefined
};
/**
 * @ignore
 */ var stub = function() {
    throw new Error('You forgot to wrap your component in <Auth0Provider>.');
};
/**
 * @ignore
 */ var initialContext = __assign(__assign({}, initialAuthState), {
    buildAuthorizeUrl: stub,
    buildLogoutUrl: stub,
    getAccessTokenSilently: stub,
    getAccessTokenWithPopup: stub,
    getIdTokenClaims: stub,
    loginWithRedirect: stub,
    loginWithPopup: stub,
    connectAccountWithRedirect: stub,
    logout: stub,
    handleRedirectCallback: stub,
    getDpopNonce: stub,
    setDpopNonce: stub,
    generateDpopProof: stub,
    createFetcher: stub
});
/**
 * The Auth0 Context
 */ var Auth0Context = (0, _react.createContext)(initialContext);
/**
 * An OAuth2 error will come from the authorization server and will have at least an `error` property which will
 * be the error code. And possibly an `error_description` property
 *
 * See: https://openid.net/specs/openid-connect-core-1_0.html#rfc.section.3.1.2.6
 */ var OAuthError = /** @class */ function(_super) {
    __extends(OAuthError, _super);
    function OAuthError(error, error_description) {
        var _this = _super.call(this, error_description !== null && error_description !== void 0 ? error_description : error) || this;
        _this.error = error;
        _this.error_description = error_description;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, OAuthError.prototype);
        return _this;
    }
    return OAuthError;
}(Error);
var CODE_RE = /[?&](?:connect_)?code=[^&]+/;
var STATE_RE = /[?&]state=[^&]+/;
var ERROR_RE = /[?&]error=[^&]+/;
var hasAuthParams = function(searchParams) {
    if (searchParams === void 0) searchParams = window.location.search;
    return (CODE_RE.test(searchParams) || ERROR_RE.test(searchParams)) && STATE_RE.test(searchParams);
};
var normalizeErrorFn = function(fallbackMessage) {
    return function(error) {
        if (error instanceof Error) return error;
        // try to check errors of the following form: {error: string; error_description?: string}
        if (error !== null && typeof error === 'object' && 'error' in error && typeof error.error === 'string') {
            if ('error_description' in error && typeof error.error_description === 'string') {
                var e_1 = error;
                return new OAuthError(e_1.error, e_1.error_description);
            }
            var e = error;
            return new OAuthError(e.error);
        }
        return new Error(fallbackMessage);
    };
};
var loginError = normalizeErrorFn('Login failed');
var tokenError = normalizeErrorFn('Get access token failed');
/**
 * @ignore
 * Helper function to map the v1 `redirectUri` option to the v2 `authorizationParams.redirect_uri`
 * and log a warning.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var deprecateRedirectUri = function(options) {
    var _a, _b;
    if (options === null || options === void 0 ? void 0 : options.redirectUri) {
        console.warn('Using `redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `redirectUri` will be no longer supported in a future version');
        options.authorizationParams = (_a = options.authorizationParams) !== null && _a !== void 0 ? _a : {};
        options.authorizationParams.redirect_uri = options.redirectUri;
        delete options.redirectUri;
    }
    if ((_b = options === null || options === void 0 ? void 0 : options.authorizationParams) === null || _b === void 0 ? void 0 : _b.redirectUri) {
        console.warn('Using `authorizationParams.redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `authorizationParams.redirectUri` will be removed in a future version');
        options.authorizationParams.redirect_uri = options.authorizationParams.redirectUri;
        delete options.authorizationParams.redirectUri;
    }
};
/**
 * Handles how that state changes in the `useAuth0` hook.
 */ var reducer = function(state, action) {
    switch(action.type){
        case 'LOGIN_POPUP_STARTED':
            return __assign(__assign({}, state), {
                isLoading: true
            });
        case 'LOGIN_POPUP_COMPLETE':
        case 'INITIALISED':
            return __assign(__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user,
                isLoading: false,
                error: undefined
            });
        case 'HANDLE_REDIRECT_COMPLETE':
        case 'GET_ACCESS_TOKEN_COMPLETE':
            if (state.user === action.user) return state;
            return __assign(__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user
            });
        case 'LOGOUT':
            return __assign(__assign({}, state), {
                isAuthenticated: false,
                user: undefined
            });
        case 'ERROR':
            return __assign(__assign({}, state), {
                isLoading: false,
                error: action.error
            });
    }
};
/**
 * @ignore
 */ var toAuth0ClientOptions = function(opts) {
    deprecateRedirectUri(opts);
    return __assign(__assign({}, opts), {
        auth0Client: {
            name: 'auth0-react',
            version: '2.9.0'
        }
    });
};
/**
 * @ignore
 */ var defaultOnRedirectCallback = function(appState) {
    var _a;
    window.history.replaceState({}, document.title, (_a = appState.returnTo) !== null && _a !== void 0 ? _a : window.location.pathname);
};
/**
 * ```jsx
 * <Auth0Provider
 *   domain={domain}
 *   clientId={clientId}
 *   authorizationParams={{ redirect_uri: window.location.origin }}>
 *   <MyApp />
 * </Auth0Provider>
 * ```
 *
 * Provides the Auth0Context to its child components.
 */ var Auth0Provider = function(opts) {
    var children = opts.children, skipRedirectCallback = opts.skipRedirectCallback, _a = opts.onRedirectCallback, onRedirectCallback = _a === void 0 ? defaultOnRedirectCallback : _a, _b = opts.context, context = _b === void 0 ? Auth0Context : _b, clientOpts = __rest(opts, [
        "children",
        "skipRedirectCallback",
        "onRedirectCallback",
        "context"
    ]);
    var client = (0, _react.useState)(function() {
        return new Ue(toAuth0ClientOptions(clientOpts));
    })[0];
    var _c = (0, _react.useReducer)(reducer, initialAuthState), state = _c[0], dispatch = _c[1];
    var didInitialise = (0, _react.useRef)(false);
    var handleError = (0, _react.useCallback)(function(error) {
        dispatch({
            type: 'ERROR',
            error: error
        });
        return error;
    }, []);
    (0, _react.useEffect)(function() {
        if (didInitialise.current) return;
        didInitialise.current = true;
        (function() {
            return __awaiter(void 0, void 0, void 0, function() {
                var user, _a, _b, appState, response_type, result, error_1;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            _c.trys.push([
                                0,
                                7,
                                ,
                                8
                            ]);
                            user = void 0;
                            if (!(hasAuthParams() && !skipRedirectCallback)) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                client.handleRedirectCallback()
                            ];
                        case 1:
                            _a = _c.sent(), _b = _a.appState, appState = _b === void 0 ? {} : _b, response_type = _a.response_type, result = __rest(_a, [
                                "appState",
                                "response_type"
                            ]);
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 2:
                            user = _c.sent();
                            appState.response_type = response_type;
                            if (response_type === ge.ConnectCode) appState.connectedAccount = result;
                            onRedirectCallback(appState, user);
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                client.checkSession()
                            ];
                        case 4:
                            _c.sent();
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 5:
                            user = _c.sent();
                            _c.label = 6;
                        case 6:
                            dispatch({
                                type: 'INITIALISED',
                                user: user
                            });
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            error_1 = _c.sent();
                            handleError(loginError(error_1));
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        })();
    }, [
        client,
        onRedirectCallback,
        skipRedirectCallback,
        handleError
    ]);
    var loginWithRedirect = (0, _react.useCallback)(function(opts) {
        deprecateRedirectUri(opts);
        return client.loginWithRedirect(opts);
    }, [
        client
    ]);
    var loginWithPopup = (0, _react.useCallback)(function(options, config) {
        return __awaiter(void 0, void 0, void 0, function() {
            var error_2, user;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dispatch({
                            type: 'LOGIN_POPUP_STARTED'
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.loginWithPopup(options, config)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_2 = _a.sent();
                        handleError(loginError(error_2));
                        return [
                            2 /*return*/ 
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 5:
                        user = _a.sent();
                        dispatch({
                            type: 'LOGIN_POPUP_COMPLETE',
                            user: user
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client,
        handleError
    ]);
    var logout = (0, _react.useCallback)(function() {
        var args_1 = [];
        for(var _i = 0; _i < arguments.length; _i++)args_1[_i] = arguments[_i];
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function(opts) {
            if (opts === void 0) opts = {};
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            client.logout(opts)
                        ];
                    case 1:
                        _a.sent();
                        if (opts.openUrl || opts.openUrl === false) dispatch({
                            type: 'LOGOUT'
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenSilently = (0, _react.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var token, error_3, _a;
            var _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenSilently(opts)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_3 = _c.sent();
                        throw tokenError(error_3);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenWithPopup = (0, _react.useCallback)(function(opts, config) {
        return __awaiter(void 0, void 0, void 0, function() {
            var token, error_4, _a;
            var _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenWithPopup(opts, config)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_4 = _c.sent();
                        throw tokenError(error_4);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var connectAccountWithRedirect = (0, _react.useCallback)(function(options) {
        return client.connectAccountWithRedirect(options);
    }, [
        client
    ]);
    var getIdTokenClaims = (0, _react.useCallback)(function() {
        return client.getIdTokenClaims();
    }, [
        client
    ]);
    var handleRedirectCallback = (0, _react.useCallback)(function(url) {
        return __awaiter(void 0, void 0, void 0, function() {
            var error_5, _a;
            var _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.handleRedirectCallback(url)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 2:
                        error_5 = _c.sent();
                        throw tokenError(error_5);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'HANDLE_REDIRECT_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getDpopNonce = (0, _react.useCallback)(function(id) {
        return client.getDpopNonce(id);
    }, [
        client
    ]);
    var setDpopNonce = (0, _react.useCallback)(function(nonce, id) {
        return client.setDpopNonce(nonce, id);
    }, [
        client
    ]);
    var generateDpopProof = (0, _react.useCallback)(function(params) {
        return client.generateDpopProof(params);
    }, [
        client
    ]);
    var createFetcher = (0, _react.useCallback)(function(config) {
        return client.createFetcher(config);
    }, [
        client
    ]);
    var contextValue = (0, _react.useMemo)(function() {
        return __assign(__assign({}, state), {
            getAccessTokenSilently: getAccessTokenSilently,
            getAccessTokenWithPopup: getAccessTokenWithPopup,
            getIdTokenClaims: getIdTokenClaims,
            loginWithRedirect: loginWithRedirect,
            loginWithPopup: loginWithPopup,
            connectAccountWithRedirect: connectAccountWithRedirect,
            logout: logout,
            handleRedirectCallback: handleRedirectCallback,
            getDpopNonce: getDpopNonce,
            setDpopNonce: setDpopNonce,
            generateDpopProof: generateDpopProof,
            createFetcher: createFetcher
        });
    }, [
        state,
        getAccessTokenSilently,
        getAccessTokenWithPopup,
        getIdTokenClaims,
        loginWithRedirect,
        loginWithPopup,
        connectAccountWithRedirect,
        logout,
        handleRedirectCallback,
        getDpopNonce,
        setDpopNonce,
        generateDpopProof,
        createFetcher
    ]);
    return (0, _reactDefault.default).createElement(context.Provider, {
        value: contextValue
    }, children);
};
/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   isLoading,
 *   user,
 *   // Auth methods:
 *   getAccessTokenSilently,
 *   getAccessTokenWithPopup,
 *   getIdTokenClaims,
 *   loginWithRedirect,
 *   loginWithPopup,
 *   logout,
 * } = useAuth0<TUser>();
 * ```
 *
 * Use the `useAuth0` hook in your components to access the auth state and methods.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */ var useAuth0 = function(context) {
    if (context === void 0) context = Auth0Context;
    return (0, _react.useContext)(context);
};
/**
 * ```jsx
 * class MyComponent extends Component {
 *   render() {
 *     // Access the auth context from the `auth0` prop
 *     const { user } = this.props.auth0;
 *     return <div>Hello {user.name}!</div>
 *   }
 * }
 * // Wrap your class component in withAuth0
 * export default withAuth0(MyComponent);
 * ```
 *
 * Wrap your class components in this Higher Order Component to give them access to the Auth0Context.
 *
 * Providing a context as the second argument allows you to configure the Auth0Provider the Auth0Context
 * should come from f you have multiple within your application.
 */ var withAuth0 = function(Component, context) {
    if (context === void 0) context = Auth0Context;
    return function WithAuth(props) {
        return (0, _reactDefault.default).createElement(context.Consumer, null, function(auth) {
            return (0, _reactDefault.default).createElement(Component, __assign({}, props, {
                auth0: auth
            }));
        });
    };
};
/**
 * @ignore
 */ var defaultOnRedirecting = function() {
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null);
};
/**
* @ignore
*/ var defaultOnBeforeAuthentication = function() {
    return __awaiter(void 0, void 0, void 0, function() {
        return __generator(this, function(_a) {
            return [
                2 /*return*/ 
            ];
        });
    });
};
/**
 * @ignore
 */ var defaultReturnTo = function() {
    return "".concat(window.location.pathname).concat(window.location.search);
};
/**
 * ```js
 * const MyProtectedComponent = withAuthenticationRequired(MyComponent);
 * ```
 *
 * When you wrap your components in this Higher Order Component and an anonymous user visits your component
 * they will be redirected to the login page; after login they will be returned to the page they were redirected from.
 */ var withAuthenticationRequired = function(Component, options) {
    if (options === void 0) options = {};
    return function WithAuthenticationRequired(props) {
        var _this = this;
        var _a = options.returnTo, returnTo = _a === void 0 ? defaultReturnTo : _a, _b = options.onRedirecting, onRedirecting = _b === void 0 ? defaultOnRedirecting : _b, _c = options.onBeforeAuthentication, onBeforeAuthentication = _c === void 0 ? defaultOnBeforeAuthentication : _c, loginOptions = options.loginOptions, _d = options.context, context = _d === void 0 ? Auth0Context : _d;
        var _e = useAuth0(context), isAuthenticated = _e.isAuthenticated, isLoading = _e.isLoading, loginWithRedirect = _e.loginWithRedirect;
        (0, _react.useEffect)(function() {
            if (isLoading || isAuthenticated) return;
            var opts = __assign(__assign({}, loginOptions), {
                appState: __assign(__assign({}, loginOptions === null || loginOptions === void 0 ? void 0 : loginOptions.appState), {
                    returnTo: typeof returnTo === 'function' ? returnTo() : returnTo
                })
            });
            (function() {
                return __awaiter(_this, void 0, void 0, function() {
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    onBeforeAuthentication()
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    loginWithRedirect(opts)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
        }, [
            isLoading,
            isAuthenticated,
            loginWithRedirect,
            onBeforeAuthentication,
            loginOptions,
            returnTo
        ]);
        return isAuthenticated ? (0, _reactDefault.default).createElement(Component, __assign({}, props)) : onRedirecting();
    };
};

},{"react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5Jnaj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "routeTree", ()=>routeTree);
var _root = require("./routes/__root");
var _index = require("./routes/index");
var _dashboard = require("./routes/dashboard");
var _profile = require("./routes/profile");
var _index1 = require("./routes/clients/index");
var _clientID = require("./routes/clients/$clientID");
var _layout = require("./routes/encoders/_layout");
var _index2 = require("./routes/encoders/index");
var _encoderID = require("./routes/encoders/$encoderID");
var _triage = require("./routes/encoders/triage");
var _persistentStreams = require("./routes/persistent-streams");
var _index3 = require("./routes/events/live-streams/index");
var _streamId = require("./routes/events/live-streams/$streamId");
var _index4 = require("./routes/events/upcoming-streams/index");
var _streamId1 = require("./routes/events/upcoming-streams/$streamId");
var _index5 = require("./routes/events/reports/index");
var _simulcast = require("./routes/events/reports/simulcast");
var _index6 = require("./routes/events/trends/index");
var _swapUserClient = require("./routes/utilities/swap-user-client");
var _index7 = require("./routes/runbook/index");
var _page = require("./routes/runbook/$page");
var _index8 = require("./routes/transcode-jobs/index");
var _index9 = require("./routes/pipeline-logs/index");
var _reports = require("./routes/captioning/reports");
var _legislativeSessions = require("./routes/key-dates/legislative-sessions");
var _mediaProbe = require("./routes/utilities/media-probe");
var _vttAnalyzer = require("./routes/utilities/vtt-analyzer");
var _updateEventStatus = require("./routes/utilities/update-event-status");
var _exportVtt = require("./routes/utilities/export-vtt");
var _index10 = require("./routes/ott-manager/index");
var _apIdx = require("./routes/ott-manager/$apIdx");
var _rdsHealth = require("./routes/aws/rds-health");
var _instanceId = require("./routes/aws/rds/$instanceId");
var _ec2Health = require("./routes/aws/ec2-health");
var _instanceId1 = require("./routes/aws/ec2/$instanceId");
var _captionJobs = require("./routes/monitoring/caption-jobs");
var _webhookLogs = require("./routes/monitoring/webhook-logs");
var _eventId = require("./routes/events/$eventId");
const routeTree = (0, _root.Route).addChildren([
    (0, _index.Route),
    (0, _dashboard.Route),
    (0, _profile.Route),
    (0, _index1.Route),
    (0, _clientID.Route),
    (0, _layout.Route).addChildren([
        (0, _index2.Route),
        (0, _encoderID.Route),
        (0, _triage.Route)
    ]),
    (0, _persistentStreams.Route),
    (0, _index3.Route),
    (0, _streamId.Route),
    (0, _index4.Route),
    (0, _streamId1.Route),
    (0, _index5.Route),
    (0, _simulcast.Route),
    (0, _index6.Route),
    (0, _swapUserClient.Route),
    (0, _index7.Route),
    (0, _page.Route),
    (0, _index8.Route),
    (0, _index9.Route),
    (0, _reports.Route),
    (0, _legislativeSessions.Route),
    (0, _mediaProbe.Route),
    (0, _vttAnalyzer.Route),
    (0, _updateEventStatus.Route),
    (0, _exportVtt.Route),
    (0, _index10.Route),
    (0, _apIdx.Route),
    (0, _rdsHealth.Route),
    (0, _instanceId.Route),
    (0, _ec2Health.Route),
    (0, _instanceId1.Route),
    (0, _captionJobs.Route),
    (0, _webhookLogs.Route),
    (0, _eventId.Route)
]);

},{"./routes/__root":"enXay","./routes/index":"jGzf0","./routes/dashboard":"eQIDw","./routes/profile":"clod2","./routes/clients/index":"cs2MQ","./routes/clients/$clientID":"4gE8R","./routes/encoders/_layout":"eMWtI","./routes/encoders/index":"9kKq3","./routes/encoders/$encoderID":"5naD0","./routes/encoders/triage":"5SfFw","./routes/persistent-streams":"aV7V4","./routes/events/live-streams/index":"1VQqb","./routes/events/live-streams/$streamId":"9bvji","./routes/events/upcoming-streams/index":"8Xmln","./routes/events/upcoming-streams/$streamId":"fQwiQ","./routes/events/reports/index":"5QY9u","./routes/events/reports/simulcast":"frZom","./routes/events/trends/index":"89CEz","./routes/utilities/swap-user-client":"2z5ie","./routes/runbook/index":"dl7Bp","./routes/runbook/$page":"aKFRJ","./routes/transcode-jobs/index":"jce4T","./routes/pipeline-logs/index":"3h6Rn","./routes/captioning/reports":"6Nrpu","./routes/key-dates/legislative-sessions":"dmJnG","./routes/utilities/media-probe":"3itSR","./routes/utilities/vtt-analyzer":"5VnDV","./routes/utilities/update-event-status":"3Kygk","./routes/utilities/export-vtt":"2Jvui","./routes/ott-manager/index":"eTAI9","./routes/ott-manager/$apIdx":"FgD33","./routes/aws/rds-health":"4eQku","./routes/aws/rds/$instanceId":"1YgAR","./routes/aws/ec2-health":"9z5Ei","./routes/aws/ec2/$instanceId":"ksSF1","./routes/monitoring/caption-jobs":"eUtwb","./routes/monitoring/webhook-logs":"92SBh","./routes/events/$eventId":"dAXMa","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"enXay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("@tanstack/react-router");
var _reactRouterDevtools = require("@tanstack/react-router-devtools");
var _sonner = require("sonner");
var _404 = require("@/client/components/404");
var _scaledroneProvider = require("@/client/providers/ScaledroneProvider");
var _swapClientDialog = require("@/client/components/swap-client-dialog");
var _ccSwapStore = require("@/client/store/ccSwapStore");
const Route = (0, _reactRouter.createRootRouteWithContext)()({
    component: RootComponent,
    notFoundComponent: (0, _404.NotFound)
});
function RootComponent() {
    const ccSwap = (0, _ccSwapStore.useCCSwapStore)();
    // After a client swap + Auth0 redirect, show a toast with a link to the target URL.
    // We can't auto-open via window.open() because browsers block non-user-initiated popups.
    (0, _react.useEffect)(()=>{
        const openAfterSwap = sessionStorage.getItem('openAfterSwap');
        if (openAfterSwap) {
            sessionStorage.removeItem('openAfterSwap');
            (0, _sonner.toast).success('Client switched successfully', {
                description: 'Click to open Control Center',
                duration: 10000,
                action: {
                    label: 'Open',
                    onClick: ()=>window.open(openAfterSwap, '_blank', 'noopener,noreferrer')
                }
            });
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _scaledroneProvider.ScaledroneProvider), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Outlet), {})
            }),
            false,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _swapClientDialog.SwapClientDialog), {
                open: ccSwap.open,
                onOpenChange: (open)=>{
                    if (!open) ccSwap.close();
                },
                targetClientID: ccSwap.targetClientID,
                targetClientName: ccSwap.targetClientName,
                openUrlAfterSwap: ccSwap.ccUrl
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRootRouteWithContext","hPO6R"],["Outlet","aAETe"]],"@tanstack/react-router-devtools":"eFGlX","sonner":"2p5sL","@/client/components/404":"hsmL6","@/client/providers/ScaledroneProvider":"c053W","@/client/components/swap-client-dialog":"dD6eo","@/client/store/ccSwapStore":"8GoFO","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eFGlX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TanStackRouterDevtools", ()=>TanStackRouterDevtools);
parcelHelpers.export(exports, "TanStackRouterDevtoolsInProd", ()=>TanStackRouterDevtoolsInProd);
parcelHelpers.export(exports, "TanStackRouterDevtoolsPanel", ()=>TanStackRouterDevtoolsPanel);
parcelHelpers.export(exports, "TanStackRouterDevtoolsPanelInProd", ()=>TanStackRouterDevtoolsPanelInProd);
var _tanStackRouterDevtoolsJs = require("./TanStackRouterDevtools.js");
var _tanStackRouterDevtoolsPanelJs = require("./TanStackRouterDevtoolsPanel.js");
const TanStackRouterDevtools = function() {
    return null;
};
const TanStackRouterDevtoolsInProd = (0, _tanStackRouterDevtoolsJs.TanStackRouterDevtools);
const TanStackRouterDevtoolsPanel = function() {
    return null;
};
const TanStackRouterDevtoolsPanelInProd = (0, _tanStackRouterDevtoolsPanelJs.TanStackRouterDevtoolsPanel);

},{"./TanStackRouterDevtools.js":"2otWg","./TanStackRouterDevtoolsPanel.js":"azwQu","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2otWg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TanStackRouterDevtools", ()=>TanStackRouterDevtools);
var _jsxRuntime = require("react/jsx-runtime");
var _routerDevtoolsCore = require("@tanstack/router-devtools-core");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
function TanStackRouterDevtools(props) {
    const { initialIsOpen, panelProps, closeButtonProps, toggleButtonProps, position, containerElement, shadowDOMTarget, router: propsRouter } = props;
    const hookRouter = (0, _reactRouter.useRouter)({
        warn: false
    });
    const activeRouter = propsRouter ?? hookRouter;
    const activeRouterState = (0, _reactRouter.useRouterState)({
        router: activeRouter
    });
    const devToolRef = (0, _react.useRef)(null);
    const [devtools] = (0, _react.useState)(()=>new (0, _routerDevtoolsCore.TanStackRouterDevtoolsCore)({
            initialIsOpen,
            panelProps,
            closeButtonProps,
            toggleButtonProps,
            position,
            containerElement,
            shadowDOMTarget,
            router: activeRouter,
            routerState: activeRouterState
        }));
    (0, _react.useEffect)(()=>{
        devtools.setRouter(activeRouter);
    }, [
        devtools,
        activeRouter
    ]);
    (0, _react.useEffect)(()=>{
        devtools.setRouterState(activeRouterState);
    }, [
        devtools,
        activeRouterState
    ]);
    (0, _react.useEffect)(()=>{
        devtools.setOptions({
            initialIsOpen,
            panelProps,
            closeButtonProps,
            toggleButtonProps,
            position,
            containerElement,
            shadowDOMTarget
        });
    }, [
        devtools,
        initialIsOpen,
        panelProps,
        closeButtonProps,
        toggleButtonProps,
        position,
        containerElement,
        shadowDOMTarget
    ]);
    (0, _react.useEffect)(()=>{
        if (devToolRef.current) devtools.mount(devToolRef.current);
        return ()=>{
            devtools.unmount();
        };
    }, [
        devtools
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            ref: devToolRef
        })
    });
}

},{"react/jsx-runtime":"dQjte","@tanstack/router-devtools-core":[["TanStackRouterDevtoolsCore","dqAWX","T"]],"react":"eGun2","@tanstack/react-router":[["useRouter","nz9fN"],["useRouterState","2Tx7u"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dqAWX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "D", ()=>DevtoolsOnCloseContext);
parcelHelpers.export(exports, "F", ()=>For);
parcelHelpers.export(exports, "M", ()=>Match);
parcelHelpers.export(exports, "S", ()=>ShadowDomTargetContext);
parcelHelpers.export(exports, "T", ()=>TanStackRouterDevtoolsCore);
parcelHelpers.export(exports, "a", ()=>createSignal);
parcelHelpers.export(exports, "b", ()=>createEffect);
parcelHelpers.export(exports, "c", ()=>createUniqueId);
parcelHelpers.export(exports, "d", ()=>createMemo);
parcelHelpers.export(exports, "e", ()=>createComponent);
parcelHelpers.export(exports, "f", ()=>spread);
parcelHelpers.export(exports, "g", ()=>createRenderEffect);
parcelHelpers.export(exports, "h", ()=>className);
parcelHelpers.export(exports, "i", ()=>insert);
parcelHelpers.export(exports, "j", ()=>Dynamic);
parcelHelpers.export(exports, "k", ()=>delegateEvents);
parcelHelpers.export(exports, "l", ()=>memo);
parcelHelpers.export(exports, "m", ()=>mergeProps);
parcelHelpers.export(exports, "n", ()=>useDevtoolsOnClose);
parcelHelpers.export(exports, "o", ()=>addEventListener);
parcelHelpers.export(exports, "p", ()=>untrack);
parcelHelpers.export(exports, "q", ()=>Switch);
parcelHelpers.export(exports, "r", ()=>onCleanup);
parcelHelpers.export(exports, "s", ()=>setAttribute);
parcelHelpers.export(exports, "t", ()=>template);
parcelHelpers.export(exports, "u", ()=>useContext);
parcelHelpers.export(exports, "v", ()=>Show);
parcelHelpers.export(exports, "w", ()=>TanStackRouterDevtoolsPanelCore);
const sharedConfig = {
    context: void 0,
    registry: void 0,
    effects: void 0,
    done: false,
    getContextId () {
        return getContextId(this.context.count);
    },
    getNextContextId () {
        return getContextId(this.context.count++);
    }
};
function getContextId(count) {
    const num = String(count), len = num.length - 1;
    return sharedConfig.context.id + (len ? String.fromCharCode(96 + len) : "") + num;
}
function setHydrateContext(context) {
    sharedConfig.context = context;
}
const IS_DEV = false;
const equalFn = (a, b)=>a === b;
const $PROXY = Symbol("solid-proxy");
const SUPPORTS_PROXY = typeof Proxy === "function";
const $TRACK = Symbol("solid-track");
const signalOptions = {
    equals: equalFn
};
let runEffects = runQueue;
const STALE = 1;
const PENDING = 2;
const UNOWNED = {
    owned: null,
    cleanups: null,
    context: null,
    owner: null
};
const NO_INIT = {};
var Owner = null;
let Transition = null;
let ExternalSourceConfig = null;
let Listener = null;
let Updates = null;
let Effects = null;
let ExecCount = 0;
function createRoot(fn, detachedOwner) {
    const listener = Listener, owner = Owner, unowned = fn.length === 0, current = detachedOwner === void 0 ? owner : detachedOwner, root = unowned ? UNOWNED : {
        owned: null,
        cleanups: null,
        context: current ? current.context : null,
        owner: current
    }, updateFn = unowned ? fn : ()=>fn(()=>untrack(()=>cleanNode(root)));
    Owner = root;
    Listener = null;
    try {
        return runUpdates(updateFn, true);
    } finally{
        Listener = listener;
        Owner = owner;
    }
}
function createSignal(value, options) {
    options = options ? Object.assign({}, signalOptions, options) : signalOptions;
    const s = {
        value,
        observers: null,
        observerSlots: null,
        comparator: options.equals || void 0
    };
    const setter = (value2)=>{
        if (typeof value2 === "function") value2 = value2(s.value);
        return writeSignal(s, value2);
    };
    return [
        readSignal.bind(s),
        setter
    ];
}
function createComputed(fn, value, options) {
    const c = createComputation(fn, value, true, STALE);
    updateComputation(c);
}
function createRenderEffect(fn, value, options) {
    const c = createComputation(fn, value, false, STALE);
    updateComputation(c);
}
function createEffect(fn, value, options) {
    runEffects = runUserEffects;
    const c = createComputation(fn, value, false, STALE);
    if (!options || !options.render) c.user = true;
    Effects ? Effects.push(c) : updateComputation(c);
}
function createMemo(fn, value, options) {
    options = options ? Object.assign({}, signalOptions, options) : signalOptions;
    const c = createComputation(fn, value, true, 0);
    c.observers = null;
    c.observerSlots = null;
    c.comparator = options.equals || void 0;
    updateComputation(c);
    return readSignal.bind(c);
}
function isPromise(v) {
    return v && typeof v === "object" && "then" in v;
}
function createResource(pSource, pFetcher, pOptions) {
    let source;
    let fetcher;
    let options;
    source = true;
    fetcher = pSource;
    options = {};
    let pr = null, initP = NO_INIT, id = null, scheduled = false, resolved = "initialValue" in options, dynamic = typeof source === "function" && createMemo(source);
    const contexts = /* @__PURE__ */ new Set(), [value, setValue] = (options.storage || createSignal)(options.initialValue), [error, setError] = createSignal(void 0), [track, trigger] = createSignal(void 0, {
        equals: false
    }), [state, setState] = createSignal(resolved ? "ready" : "unresolved");
    if (sharedConfig.context) {
        id = sharedConfig.getNextContextId();
        if (options.ssrLoadFrom === "initial") initP = options.initialValue;
        else if (sharedConfig.load && sharedConfig.has(id)) initP = sharedConfig.load(id);
    }
    function loadEnd(p, v, error2, key) {
        if (pr === p) {
            pr = null;
            key !== void 0 && (resolved = true);
            if ((p === initP || v === initP) && options.onHydrated) queueMicrotask(()=>options.onHydrated(key, {
                    value: v
                }));
            initP = NO_INIT;
            completeLoad(v, error2);
        }
        return v;
    }
    function completeLoad(v, err) {
        runUpdates(()=>{
            if (err === void 0) setValue(()=>v);
            setState(err !== void 0 ? "errored" : resolved ? "ready" : "unresolved");
            setError(err);
            for (const c of contexts.keys())c.decrement();
            contexts.clear();
        }, false);
    }
    function read() {
        const c = SuspenseContext, v = value(), err = error();
        if (err !== void 0 && !pr) throw err;
        Listener && !Listener.user && c;
        return v;
    }
    function load(refetching = true) {
        if (refetching !== false && scheduled) return;
        scheduled = false;
        const lookup = dynamic ? dynamic() : source;
        if (lookup == null || lookup === false) {
            loadEnd(pr, untrack(value));
            return;
        }
        let error2;
        const p = initP !== NO_INIT ? initP : untrack(()=>{
            try {
                return fetcher(lookup, {
                    value: value(),
                    refetching
                });
            } catch (fetcherError) {
                error2 = fetcherError;
            }
        });
        if (error2 !== void 0) {
            loadEnd(pr, void 0, castError(error2), lookup);
            return;
        } else if (!isPromise(p)) {
            loadEnd(pr, p, void 0, lookup);
            return p;
        }
        pr = p;
        if ("v" in p) {
            if (p.s === 1) loadEnd(pr, p.v, void 0, lookup);
            else loadEnd(pr, void 0, castError(p.v), lookup);
            return p;
        }
        scheduled = true;
        queueMicrotask(()=>scheduled = false);
        runUpdates(()=>{
            setState(resolved ? "refreshing" : "pending");
            trigger();
        }, false);
        return p.then((v)=>loadEnd(p, v, void 0, lookup), (e)=>loadEnd(p, void 0, castError(e), lookup));
    }
    Object.defineProperties(read, {
        state: {
            get: ()=>state()
        },
        error: {
            get: ()=>error()
        },
        loading: {
            get () {
                const s = state();
                return s === "pending" || s === "refreshing";
            }
        },
        latest: {
            get () {
                if (!resolved) return read();
                const err = error();
                if (err && !pr) throw err;
                return value();
            }
        }
    });
    let owner = Owner;
    if (dynamic) createComputed(()=>(owner = Owner, load(false)));
    else load(false);
    return [
        read,
        {
            refetch: (info)=>runWithOwner(owner, ()=>load(info)),
            mutate: setValue
        }
    ];
}
function untrack(fn) {
    if (Listener === null) return fn();
    const listener = Listener;
    Listener = null;
    try {
        ExternalSourceConfig;
        return fn();
    } finally{
        Listener = listener;
    }
}
function onCleanup(fn) {
    if (Owner === null) ;
    else if (Owner.cleanups === null) Owner.cleanups = [
        fn
    ];
    else Owner.cleanups.push(fn);
    return fn;
}
function runWithOwner(o, fn) {
    const prev = Owner;
    const prevListener = Listener;
    Owner = o;
    Listener = null;
    try {
        return runUpdates(fn, true);
    } catch (err) {
        handleError(err);
    } finally{
        Owner = prev;
        Listener = prevListener;
    }
}
const [transPending, setTransPending] = /* @__PURE__ */ createSignal(false);
function createContext(defaultValue, options) {
    const id = Symbol("context");
    return {
        id,
        Provider: createProvider(id),
        defaultValue
    };
}
function useContext(context) {
    let value;
    return Owner && Owner.context && (value = Owner.context[context.id]) !== void 0 ? value : context.defaultValue;
}
function children(fn) {
    const children2 = createMemo(fn);
    const memo2 = createMemo(()=>resolveChildren(children2()));
    memo2.toArray = ()=>{
        const c = memo2();
        return Array.isArray(c) ? c : c != null ? [
            c
        ] : [];
    };
    return memo2;
}
let SuspenseContext;
function readSignal() {
    if (this.sources && this.state) {
        if (this.state === STALE) updateComputation(this);
        else {
            const updates = Updates;
            Updates = null;
            runUpdates(()=>lookUpstream(this), false);
            Updates = updates;
        }
    }
    if (Listener) {
        const sSlot = this.observers ? this.observers.length : 0;
        if (!Listener.sources) {
            Listener.sources = [
                this
            ];
            Listener.sourceSlots = [
                sSlot
            ];
        } else {
            Listener.sources.push(this);
            Listener.sourceSlots.push(sSlot);
        }
        if (!this.observers) {
            this.observers = [
                Listener
            ];
            this.observerSlots = [
                Listener.sources.length - 1
            ];
        } else {
            this.observers.push(Listener);
            this.observerSlots.push(Listener.sources.length - 1);
        }
    }
    return this.value;
}
function writeSignal(node, value, isComp) {
    let current = node.value;
    if (!node.comparator || !node.comparator(current, value)) {
        node.value = value;
        if (node.observers && node.observers.length) runUpdates(()=>{
            for(let i = 0; i < node.observers.length; i += 1){
                const o = node.observers[i];
                const TransitionRunning = Transition && Transition.running;
                TransitionRunning && Transition.disposed.has(o);
                if (TransitionRunning ? !o.tState : !o.state) {
                    if (o.pure) Updates.push(o);
                    else Effects.push(o);
                    if (o.observers) markDownstream(o);
                }
                if (!TransitionRunning) o.state = STALE;
            }
            if (Updates.length > 1e6) {
                Updates = [];
                IS_DEV;
                throw new Error();
            }
        }, false);
    }
    return value;
}
function updateComputation(node) {
    if (!node.fn) return;
    cleanNode(node);
    const time = ExecCount;
    runComputation(node, node.value, time);
}
function runComputation(node, value, time) {
    let nextValue;
    const owner = Owner, listener = Listener;
    Listener = Owner = node;
    try {
        nextValue = node.fn(value);
    } catch (err) {
        if (node.pure) {
            node.state = STALE;
            node.owned && node.owned.forEach(cleanNode);
            node.owned = null;
        }
        node.updatedAt = time + 1;
        return handleError(err);
    } finally{
        Listener = listener;
        Owner = owner;
    }
    if (!node.updatedAt || node.updatedAt <= time) {
        if (node.updatedAt != null && "observers" in node) writeSignal(node, nextValue);
        else node.value = nextValue;
        node.updatedAt = time;
    }
}
function createComputation(fn, init, pure, state = STALE, options) {
    const c = {
        fn,
        state,
        updatedAt: null,
        owned: null,
        sources: null,
        sourceSlots: null,
        cleanups: null,
        value: init,
        owner: Owner,
        context: Owner ? Owner.context : null,
        pure
    };
    if (Owner === null) ;
    else if (Owner !== UNOWNED) {
        if (!Owner.owned) Owner.owned = [
            c
        ];
        else Owner.owned.push(c);
    }
    return c;
}
function runTop(node) {
    if (node.state === 0) return;
    if (node.state === PENDING) return lookUpstream(node);
    if (node.suspense && untrack(node.suspense.inFallback)) return node.suspense.effects.push(node);
    const ancestors = [
        node
    ];
    while((node = node.owner) && (!node.updatedAt || node.updatedAt < ExecCount))if (node.state) ancestors.push(node);
    for(let i = ancestors.length - 1; i >= 0; i--){
        node = ancestors[i];
        if (node.state === STALE) updateComputation(node);
        else if (node.state === PENDING) {
            const updates = Updates;
            Updates = null;
            runUpdates(()=>lookUpstream(node, ancestors[0]), false);
            Updates = updates;
        }
    }
}
function runUpdates(fn, init) {
    if (Updates) return fn();
    let wait = false;
    if (!init) Updates = [];
    if (Effects) wait = true;
    else Effects = [];
    ExecCount++;
    try {
        const res = fn();
        completeUpdates(wait);
        return res;
    } catch (err) {
        if (!wait) Effects = null;
        Updates = null;
        handleError(err);
    }
}
function completeUpdates(wait) {
    if (Updates) {
        runQueue(Updates);
        Updates = null;
    }
    if (wait) return;
    const e = Effects;
    Effects = null;
    if (e.length) runUpdates(()=>runEffects(e), false);
}
function runQueue(queue) {
    for(let i = 0; i < queue.length; i++)runTop(queue[i]);
}
function runUserEffects(queue) {
    let i, userLength = 0;
    for(i = 0; i < queue.length; i++){
        const e = queue[i];
        if (!e.user) runTop(e);
        else queue[userLength++] = e;
    }
    if (sharedConfig.context) {
        if (sharedConfig.count) {
            sharedConfig.effects || (sharedConfig.effects = []);
            sharedConfig.effects.push(...queue.slice(0, userLength));
            return;
        }
        setHydrateContext();
    }
    if (sharedConfig.effects && (sharedConfig.done || !sharedConfig.count)) {
        queue = [
            ...sharedConfig.effects,
            ...queue
        ];
        userLength += sharedConfig.effects.length;
        delete sharedConfig.effects;
    }
    for(i = 0; i < userLength; i++)runTop(queue[i]);
}
function lookUpstream(node, ignore) {
    node.state = 0;
    for(let i = 0; i < node.sources.length; i += 1){
        const source = node.sources[i];
        if (source.sources) {
            const state = source.state;
            if (state === STALE) {
                if (source !== ignore && (!source.updatedAt || source.updatedAt < ExecCount)) runTop(source);
            } else if (state === PENDING) lookUpstream(source, ignore);
        }
    }
}
function markDownstream(node) {
    for(let i = 0; i < node.observers.length; i += 1){
        const o = node.observers[i];
        if (!o.state) {
            o.state = PENDING;
            if (o.pure) Updates.push(o);
            else Effects.push(o);
            o.observers && markDownstream(o);
        }
    }
}
function cleanNode(node) {
    let i;
    if (node.sources) while(node.sources.length){
        const source = node.sources.pop(), index = node.sourceSlots.pop(), obs = source.observers;
        if (obs && obs.length) {
            const n = obs.pop(), s = source.observerSlots.pop();
            if (index < obs.length) {
                n.sourceSlots[s] = index;
                obs[index] = n;
                source.observerSlots[index] = s;
            }
        }
    }
    if (node.tOwned) {
        for(i = node.tOwned.length - 1; i >= 0; i--)cleanNode(node.tOwned[i]);
        delete node.tOwned;
    }
    if (node.owned) {
        for(i = node.owned.length - 1; i >= 0; i--)cleanNode(node.owned[i]);
        node.owned = null;
    }
    if (node.cleanups) {
        for(i = node.cleanups.length - 1; i >= 0; i--)node.cleanups[i]();
        node.cleanups = null;
    }
    node.state = 0;
}
function castError(err) {
    if (err instanceof Error) return err;
    return new Error(typeof err === "string" ? err : "Unknown error", {
        cause: err
    });
}
function handleError(err, owner = Owner) {
    const error = castError(err);
    throw error;
}
function resolveChildren(children2) {
    if (typeof children2 === "function" && !children2.length) return resolveChildren(children2());
    if (Array.isArray(children2)) {
        const results = [];
        for(let i = 0; i < children2.length; i++){
            const result = resolveChildren(children2[i]);
            Array.isArray(result) ? results.push.apply(results, result) : results.push(result);
        }
        return results;
    }
    return children2;
}
function createProvider(id, options) {
    return function provider(props) {
        let res;
        createRenderEffect(()=>res = untrack(()=>{
                Owner.context = {
                    ...Owner.context,
                    [id]: props.value
                };
                return children(()=>props.children);
            }), void 0);
        return res;
    };
}
const FALLBACK = Symbol("fallback");
function dispose(d) {
    for(let i = 0; i < d.length; i++)d[i]();
}
function mapArray(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], len = 0, indexes = mapFn.length > 1 ? [] : null;
    onCleanup(()=>dispose(disposers));
    return ()=>{
        let newItems = list() || [], newLen = newItems.length, i, j;
        newItems[$TRACK];
        return untrack(()=>{
            let newIndices, newIndicesNext, temp, tempdisposers, tempIndexes, start, end, newEnd, item;
            if (newLen === 0) {
                if (len !== 0) {
                    dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    indexes && (indexes = []);
                }
                if (options.fallback) {
                    items = [
                        FALLBACK
                    ];
                    mapped[0] = createRoot((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
            } else if (len === 0) {
                mapped = new Array(newLen);
                for(j = 0; j < newLen; j++){
                    items[j] = newItems[j];
                    mapped[j] = createRoot(mapper);
                }
                len = newLen;
            } else {
                temp = new Array(newLen);
                tempdisposers = new Array(newLen);
                indexes && (tempIndexes = new Array(newLen));
                for(start = 0, end = Math.min(len, newLen); start < end && items[start] === newItems[start]; start++);
                for(end = len - 1, newEnd = newLen - 1; end >= start && newEnd >= start && items[end] === newItems[newEnd]; end--, newEnd--){
                    temp[newEnd] = mapped[end];
                    tempdisposers[newEnd] = disposers[end];
                    indexes && (tempIndexes[newEnd] = indexes[end]);
                }
                newIndices = /* @__PURE__ */ new Map();
                newIndicesNext = new Array(newEnd + 1);
                for(j = newEnd; j >= start; j--){
                    item = newItems[j];
                    i = newIndices.get(item);
                    newIndicesNext[j] = i === void 0 ? -1 : i;
                    newIndices.set(item, j);
                }
                for(i = start; i <= end; i++){
                    item = items[i];
                    j = newIndices.get(item);
                    if (j !== void 0 && j !== -1) {
                        temp[j] = mapped[i];
                        tempdisposers[j] = disposers[i];
                        indexes && (tempIndexes[j] = indexes[i]);
                        j = newIndicesNext[j];
                        newIndices.set(item, j);
                    } else disposers[i]();
                }
                for(j = start; j < newLen; j++)if (j in temp) {
                    mapped[j] = temp[j];
                    disposers[j] = tempdisposers[j];
                    if (indexes) {
                        indexes[j] = tempIndexes[j];
                        indexes[j](j);
                    }
                } else mapped[j] = createRoot(mapper);
                mapped = mapped.slice(0, len = newLen);
                items = newItems.slice(0);
            }
            return mapped;
        });
        function mapper(disposer) {
            disposers[j] = disposer;
            if (indexes) {
                const [s, set] = createSignal(j);
                indexes[j] = set;
                return mapFn(newItems[j], s);
            }
            return mapFn(newItems[j]);
        }
    };
}
function createComponent(Comp, props) {
    return untrack(()=>Comp(props || {}));
}
function trueFn() {
    return true;
}
const propTraps = {
    get (_, property, receiver) {
        if (property === $PROXY) return receiver;
        return _.get(property);
    },
    has (_, property) {
        if (property === $PROXY) return true;
        return _.has(property);
    },
    set: trueFn,
    deleteProperty: trueFn,
    getOwnPropertyDescriptor (_, property) {
        return {
            configurable: true,
            enumerable: true,
            get () {
                return _.get(property);
            },
            set: trueFn,
            deleteProperty: trueFn
        };
    },
    ownKeys (_) {
        return _.keys();
    }
};
function resolveSource(s) {
    return !(s = typeof s === "function" ? s() : s) ? {} : s;
}
function resolveSources() {
    for(let i = 0, length = this.length; i < length; ++i){
        const v = this[i]();
        if (v !== void 0) return v;
    }
}
function mergeProps(...sources) {
    let proxy = false;
    for(let i = 0; i < sources.length; i++){
        const s = sources[i];
        proxy = proxy || !!s && $PROXY in s;
        sources[i] = typeof s === "function" ? (proxy = true, createMemo(s)) : s;
    }
    if (SUPPORTS_PROXY && proxy) return new Proxy({
        get (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                const v = resolveSource(sources[i])[property];
                if (v !== void 0) return v;
            }
        },
        has (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                if (property in resolveSource(sources[i])) return true;
            }
            return false;
        },
        keys () {
            const keys = [];
            for(let i = 0; i < sources.length; i++)keys.push(...Object.keys(resolveSource(sources[i])));
            return [
                ...new Set(keys)
            ];
        }
    }, propTraps);
    const sourcesMap = {};
    const defined = /* @__PURE__ */ Object.create(null);
    for(let i = sources.length - 1; i >= 0; i--){
        const source = sources[i];
        if (!source) continue;
        const sourceKeys = Object.getOwnPropertyNames(source);
        for(let i2 = sourceKeys.length - 1; i2 >= 0; i2--){
            const key = sourceKeys[i2];
            if (key === "__proto__" || key === "constructor") continue;
            const desc = Object.getOwnPropertyDescriptor(source, key);
            if (!defined[key]) defined[key] = desc.get ? {
                enumerable: true,
                configurable: true,
                get: resolveSources.bind(sourcesMap[key] = [
                    desc.get.bind(source)
                ])
            } : desc.value !== void 0 ? desc : void 0;
            else {
                const sources2 = sourcesMap[key];
                if (sources2) {
                    if (desc.get) sources2.push(desc.get.bind(source));
                    else if (desc.value !== void 0) sources2.push(()=>desc.value);
                }
            }
        }
    }
    const target = {};
    const definedKeys = Object.keys(defined);
    for(let i = definedKeys.length - 1; i >= 0; i--){
        const key = definedKeys[i], desc = defined[key];
        if (desc && desc.get) Object.defineProperty(target, key, desc);
        else target[key] = desc ? desc.value : void 0;
    }
    return target;
}
function splitProps(props, ...keys) {
    const len = keys.length;
    if (SUPPORTS_PROXY && $PROXY in props) {
        const blocked = len > 1 ? keys.flat() : keys[0];
        const res = keys.map((k)=>{
            return new Proxy({
                get (property) {
                    return k.includes(property) ? props[property] : void 0;
                },
                has (property) {
                    return k.includes(property) && property in props;
                },
                keys () {
                    return k.filter((property)=>property in props);
                }
            }, propTraps);
        });
        res.push(new Proxy({
            get (property) {
                return blocked.includes(property) ? void 0 : props[property];
            },
            has (property) {
                return blocked.includes(property) ? false : property in props;
            },
            keys () {
                return Object.keys(props).filter((k)=>!blocked.includes(k));
            }
        }, propTraps));
        return res;
    }
    const objects = [];
    for(let i = 0; i <= len; i++)objects[i] = {};
    for (const propName of Object.getOwnPropertyNames(props)){
        let keyIndex = len;
        for(let i = 0; i < keys.length; i++)if (keys[i].includes(propName)) {
            keyIndex = i;
            break;
        }
        const desc = Object.getOwnPropertyDescriptor(props, propName);
        const isDefaultDesc = !desc.get && !desc.set && desc.enumerable && desc.writable && desc.configurable;
        isDefaultDesc ? objects[keyIndex][propName] = desc.value : Object.defineProperty(objects[keyIndex], propName, desc);
    }
    return objects;
}
function lazy(fn) {
    let comp;
    let p;
    const wrap = (props)=>{
        const ctx = sharedConfig.context;
        if (ctx) {
            const [s, set] = createSignal();
            sharedConfig.count || (sharedConfig.count = 0);
            sharedConfig.count++;
            (p || (p = fn())).then((mod)=>{
                !sharedConfig.done && setHydrateContext(ctx);
                sharedConfig.count--;
                set(()=>mod.default);
                setHydrateContext();
            });
            comp = s;
        } else if (!comp) {
            const [s] = createResource(()=>(p || (p = fn())).then((mod)=>mod.default));
            comp = s;
        }
        let Comp;
        return createMemo(()=>(Comp = comp()) ? untrack(()=>{
                IS_DEV;
                if (!ctx || sharedConfig.done) return Comp(props);
                const c = sharedConfig.context;
                setHydrateContext(ctx);
                const r = Comp(props);
                setHydrateContext(c);
                return r;
            }) : "");
    };
    wrap.preload = ()=>p || ((p = fn()).then((mod)=>comp = ()=>mod.default), p);
    return wrap;
}
let counter = 0;
function createUniqueId() {
    const ctx = sharedConfig.context;
    return ctx ? sharedConfig.getNextContextId() : `cl-${counter++}`;
}
const narrowedError = (name)=>`Stale read from <${name}>.`;
function For(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return createMemo(mapArray(()=>props.each, props.children, fallback || void 0));
}
function Show(props) {
    const keyed = props.keyed;
    const conditionValue = createMemo(()=>props.when, void 0, void 0);
    const condition = keyed ? conditionValue : createMemo(conditionValue, void 0, {
        equals: (a, b)=>!a === !b
    });
    return createMemo(()=>{
        const c = condition();
        if (c) {
            const child = props.children;
            const fn = typeof child === "function" && child.length > 0;
            return fn ? untrack(()=>child(keyed ? c : ()=>{
                    if (!untrack(condition)) throw narrowedError("Show");
                    return conditionValue();
                })) : child;
        }
        return props.fallback;
    }, void 0, void 0);
}
function Switch(props) {
    const chs = children(()=>props.children);
    const switchFunc = createMemo(()=>{
        const ch = chs();
        const mps = Array.isArray(ch) ? ch : [
            ch
        ];
        let func = ()=>void 0;
        for(let i = 0; i < mps.length; i++){
            const index = i;
            const mp = mps[i];
            const prevFunc = func;
            const conditionValue = createMemo(()=>prevFunc() ? void 0 : mp.when, void 0, void 0);
            const condition = mp.keyed ? conditionValue : createMemo(conditionValue, void 0, {
                equals: (a, b)=>!a === !b
            });
            func = ()=>prevFunc() || (condition() ? [
                    index,
                    conditionValue,
                    mp
                ] : void 0);
        }
        return func;
    });
    return createMemo(()=>{
        const sel = switchFunc()();
        if (!sel) return props.fallback;
        const [index, conditionValue, mp] = sel;
        const child = mp.children;
        const fn = typeof child === "function" && child.length > 0;
        return fn ? untrack(()=>child(mp.keyed ? conditionValue() : ()=>{
                if (untrack(switchFunc)()?.[0] !== index) throw narrowedError("Match");
                return conditionValue();
            })) : child;
    }, void 0, void 0);
}
function Match(props) {
    return props;
}
const booleans = [
    "allowfullscreen",
    "async",
    "alpha",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "disabled",
    "formnovalidate",
    "hidden",
    "indeterminate",
    "inert",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "seamless",
    "selected",
    "adauctionheaders",
    "browsingtopics",
    "credentialless",
    "defaultchecked",
    "defaultmuted",
    "defaultselected",
    "defer",
    "disablepictureinpicture",
    "disableremoteplayback",
    "preservespitch",
    "shadowrootclonable",
    "shadowrootcustomelementregistry",
    "shadowrootdelegatesfocus",
    "shadowrootserializable",
    "sharedstoragewritable"
];
const Properties = /* @__PURE__ */ new Set([
    "className",
    "value",
    "readOnly",
    "noValidate",
    "formNoValidate",
    "isMap",
    "noModule",
    "playsInline",
    "adAuctionHeaders",
    "allowFullscreen",
    "browsingTopics",
    "defaultChecked",
    "defaultMuted",
    "defaultSelected",
    "disablePictureInPicture",
    "disableRemotePlayback",
    "preservesPitch",
    "shadowRootClonable",
    "shadowRootCustomElementRegistry",
    "shadowRootDelegatesFocus",
    "shadowRootSerializable",
    "sharedStorageWritable",
    ...booleans
]);
const ChildProperties = /* @__PURE__ */ new Set([
    "innerHTML",
    "textContent",
    "innerText",
    "children"
]);
const Aliases = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
    className: "class",
    htmlFor: "for"
});
const PropAliases = /* @__PURE__ */ Object.assign(/* @__PURE__ */ Object.create(null), {
    class: "className",
    novalidate: {
        $: "noValidate",
        FORM: 1
    },
    formnovalidate: {
        $: "formNoValidate",
        BUTTON: 1,
        INPUT: 1
    },
    ismap: {
        $: "isMap",
        IMG: 1
    },
    nomodule: {
        $: "noModule",
        SCRIPT: 1
    },
    playsinline: {
        $: "playsInline",
        VIDEO: 1
    },
    readonly: {
        $: "readOnly",
        INPUT: 1,
        TEXTAREA: 1
    },
    adauctionheaders: {
        $: "adAuctionHeaders",
        IFRAME: 1
    },
    allowfullscreen: {
        $: "allowFullscreen",
        IFRAME: 1
    },
    browsingtopics: {
        $: "browsingTopics",
        IMG: 1
    },
    defaultchecked: {
        $: "defaultChecked",
        INPUT: 1
    },
    defaultmuted: {
        $: "defaultMuted",
        AUDIO: 1,
        VIDEO: 1
    },
    defaultselected: {
        $: "defaultSelected",
        OPTION: 1
    },
    disablepictureinpicture: {
        $: "disablePictureInPicture",
        VIDEO: 1
    },
    disableremoteplayback: {
        $: "disableRemotePlayback",
        AUDIO: 1,
        VIDEO: 1
    },
    preservespitch: {
        $: "preservesPitch",
        AUDIO: 1,
        VIDEO: 1
    },
    shadowrootclonable: {
        $: "shadowRootClonable",
        TEMPLATE: 1
    },
    shadowrootdelegatesfocus: {
        $: "shadowRootDelegatesFocus",
        TEMPLATE: 1
    },
    shadowrootserializable: {
        $: "shadowRootSerializable",
        TEMPLATE: 1
    },
    sharedstoragewritable: {
        $: "sharedStorageWritable",
        IFRAME: 1,
        IMG: 1
    }
});
function getPropAlias(prop, tagName) {
    const a = PropAliases[prop];
    return typeof a === "object" ? a[tagName] ? a["$"] : void 0 : a;
}
const DelegatedEvents = /* @__PURE__ */ new Set([
    "beforeinput",
    "click",
    "dblclick",
    "contextmenu",
    "focusin",
    "focusout",
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "pointerdown",
    "pointermove",
    "pointerout",
    "pointerover",
    "pointerup",
    "touchend",
    "touchmove",
    "touchstart"
]);
const SVGElements = /* @__PURE__ */ new Set([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "set",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
]);
const SVGNamespace = {
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace"
};
const memo = (fn)=>createMemo(()=>fn());
function reconcileArrays(parentNode, a, b) {
    let bLength = b.length, aEnd = a.length, bEnd = bLength, aStart = 0, bStart = 0, after = a[aEnd - 1].nextSibling, map = null;
    while(aStart < aEnd || bStart < bEnd){
        if (a[aStart] === b[bStart]) {
            aStart++;
            bStart++;
            continue;
        }
        while(a[aEnd - 1] === b[bEnd - 1]){
            aEnd--;
            bEnd--;
        }
        if (aEnd === aStart) {
            const node = bEnd < bLength ? bStart ? b[bStart - 1].nextSibling : b[bEnd - bStart] : after;
            while(bStart < bEnd)parentNode.insertBefore(b[bStart++], node);
        } else if (bEnd === bStart) while(aStart < aEnd){
            if (!map || !map.has(a[aStart])) a[aStart].remove();
            aStart++;
        }
        else if (a[aStart] === b[bEnd - 1] && b[bStart] === a[aEnd - 1]) {
            const node = a[--aEnd].nextSibling;
            parentNode.insertBefore(b[bStart++], a[aStart++].nextSibling);
            parentNode.insertBefore(b[--bEnd], node);
            a[aEnd] = b[bEnd];
        } else {
            if (!map) {
                map = /* @__PURE__ */ new Map();
                let i = bStart;
                while(i < bEnd)map.set(b[i], i++);
            }
            const index = map.get(a[aStart]);
            if (index != null) {
                if (bStart < index && index < bEnd) {
                    let i = aStart, sequence = 1, t;
                    while(++i < aEnd && i < bEnd){
                        if ((t = map.get(a[i])) == null || t !== index + sequence) break;
                        sequence++;
                    }
                    if (sequence > index - bStart) {
                        const node = a[aStart];
                        while(bStart < index)parentNode.insertBefore(b[bStart++], node);
                    } else parentNode.replaceChild(b[bStart++], a[aStart++]);
                } else aStart++;
            } else a[aStart++].remove();
        }
    }
}
const $$EVENTS = "_$DX_DELEGATE";
function render(code, element, init, options = {}) {
    let disposer;
    createRoot((dispose2)=>{
        disposer = dispose2;
        element === document ? code() : insert(element, code(), element.firstChild ? null : void 0, init);
    }, options.owner);
    return ()=>{
        disposer();
        element.textContent = "";
    };
}
function template(html, isImportNode, isSVG, isMathML) {
    let node;
    const create = ()=>{
        const t = document.createElement("template");
        t.innerHTML = html;
        return t.content.firstChild;
    };
    const fn = isImportNode ? ()=>untrack(()=>document.importNode(node || (node = create()), true)) : ()=>(node || (node = create())).cloneNode(true);
    fn.cloneNode = fn;
    return fn;
}
function delegateEvents(eventNames, document2 = window.document) {
    const e = document2[$$EVENTS] || (document2[$$EVENTS] = /* @__PURE__ */ new Set());
    for(let i = 0, l = eventNames.length; i < l; i++){
        const name = eventNames[i];
        if (!e.has(name)) {
            e.add(name);
            document2.addEventListener(name, eventHandler);
        }
    }
}
function setAttribute(node, name, value) {
    if (isHydrating(node)) return;
    if (value == null) node.removeAttribute(name);
    else node.setAttribute(name, value);
}
function setAttributeNS(node, namespace, name, value) {
    if (isHydrating(node)) return;
    if (value == null) node.removeAttributeNS(namespace, name);
    else node.setAttributeNS(namespace, name, value);
}
function setBoolAttribute(node, name, value) {
    if (isHydrating(node)) return;
    value ? node.setAttribute(name, "") : node.removeAttribute(name);
}
function className(node, value) {
    if (isHydrating(node)) return;
    if (value == null) node.removeAttribute("class");
    else node.className = value;
}
function addEventListener(node, name, handler, delegate) {
    if (delegate) {
        if (Array.isArray(handler)) {
            node[`$$${name}`] = handler[0];
            node[`$$${name}Data`] = handler[1];
        } else node[`$$${name}`] = handler;
    } else if (Array.isArray(handler)) {
        const handlerFn = handler[0];
        node.addEventListener(name, handler[0] = (e)=>handlerFn.call(node, handler[1], e));
    } else node.addEventListener(name, handler, typeof handler !== "function" && handler);
}
function classList(node, value, prev = {}) {
    const classKeys = Object.keys(value || {}), prevKeys = Object.keys(prev);
    let i, len;
    for(i = 0, len = prevKeys.length; i < len; i++){
        const key = prevKeys[i];
        if (!key || key === "undefined" || value[key]) continue;
        toggleClassKey(node, key, false);
        delete prev[key];
    }
    for(i = 0, len = classKeys.length; i < len; i++){
        const key = classKeys[i], classValue = !!value[key];
        if (!key || key === "undefined" || prev[key] === classValue || !classValue) continue;
        toggleClassKey(node, key, true);
        prev[key] = classValue;
    }
    return prev;
}
function style(node, value, prev) {
    if (!value) return prev ? setAttribute(node, "style") : value;
    const nodeStyle = node.style;
    if (typeof value === "string") return nodeStyle.cssText = value;
    typeof prev === "string" && (nodeStyle.cssText = prev = void 0);
    prev || (prev = {});
    value || (value = {});
    let v, s;
    for(s in prev){
        value[s] == null && nodeStyle.removeProperty(s);
        delete prev[s];
    }
    for(s in value){
        v = value[s];
        if (v !== prev[s]) {
            nodeStyle.setProperty(s, v);
            prev[s] = v;
        }
    }
    return prev;
}
function spread(node, props = {}, isSVG, skipChildren) {
    const prevProps = {};
    if (!skipChildren) createRenderEffect(()=>prevProps.children = insertExpression(node, props.children, prevProps.children));
    createRenderEffect(()=>typeof props.ref === "function" && use(props.ref, node));
    createRenderEffect(()=>assign(node, props, isSVG, true, prevProps, true));
    return prevProps;
}
function use(fn, element, arg) {
    return untrack(()=>fn(element, arg));
}
function insert(parent, accessor, marker, initial) {
    if (marker !== void 0 && !initial) initial = [];
    if (typeof accessor !== "function") return insertExpression(parent, accessor, initial, marker);
    createRenderEffect((current)=>insertExpression(parent, accessor(), current, marker), initial);
}
function assign(node, props, isSVG, skipChildren, prevProps = {}, skipRef = false) {
    props || (props = {});
    for(const prop in prevProps)if (!(prop in props)) {
        if (prop === "children") continue;
        prevProps[prop] = assignProp(node, prop, null, prevProps[prop], isSVG, skipRef, props);
    }
    for(const prop in props){
        if (prop === "children") continue;
        const value = props[prop];
        prevProps[prop] = assignProp(node, prop, value, prevProps[prop], isSVG, skipRef, props);
    }
}
function getNextElement(template2) {
    let node, key, hydrating = isHydrating();
    if (!hydrating || !(node = sharedConfig.registry.get(key = getHydrationKey()))) return template2();
    if (sharedConfig.completed) sharedConfig.completed.add(node);
    sharedConfig.registry.delete(key);
    return node;
}
function isHydrating(node) {
    return !!sharedConfig.context && !sharedConfig.done && (!node || node.isConnected);
}
function toPropertyName(name) {
    return name.toLowerCase().replace(/-([a-z])/g, (_, w)=>w.toUpperCase());
}
function toggleClassKey(node, key, value) {
    const classNames = key.trim().split(/\s+/);
    for(let i = 0, nameLen = classNames.length; i < nameLen; i++)node.classList.toggle(classNames[i], value);
}
function assignProp(node, prop, value, prev, isSVG, skipRef, props) {
    let isCE, isProp, isChildProp, propAlias, forceProp;
    if (prop === "style") return style(node, value, prev);
    if (prop === "classList") return classList(node, value, prev);
    if (value === prev) return prev;
    if (prop === "ref") {
        if (!skipRef) value(node);
    } else if (prop.slice(0, 3) === "on:") {
        const e = prop.slice(3);
        prev && node.removeEventListener(e, prev, typeof prev !== "function" && prev);
        value && node.addEventListener(e, value, typeof value !== "function" && value);
    } else if (prop.slice(0, 10) === "oncapture:") {
        const e = prop.slice(10);
        prev && node.removeEventListener(e, prev, true);
        value && node.addEventListener(e, value, true);
    } else if (prop.slice(0, 2) === "on") {
        const name = prop.slice(2).toLowerCase();
        const delegate = DelegatedEvents.has(name);
        if (!delegate && prev) {
            const h = Array.isArray(prev) ? prev[0] : prev;
            node.removeEventListener(name, h);
        }
        if (delegate || value) {
            addEventListener(node, name, value, delegate);
            delegate && delegateEvents([
                name
            ]);
        }
    } else if (prop.slice(0, 5) === "attr:") setAttribute(node, prop.slice(5), value);
    else if (prop.slice(0, 5) === "bool:") setBoolAttribute(node, prop.slice(5), value);
    else if ((forceProp = prop.slice(0, 5) === "prop:") || (isChildProp = ChildProperties.has(prop)) || !isSVG && ((propAlias = getPropAlias(prop, node.tagName)) || (isProp = Properties.has(prop))) || (isCE = node.nodeName.includes("-") || "is" in props)) {
        if (forceProp) {
            prop = prop.slice(5);
            isProp = true;
        } else if (isHydrating(node)) return value;
        if (prop === "class" || prop === "className") className(node, value);
        else if (isCE && !isProp && !isChildProp) node[toPropertyName(prop)] = value;
        else node[propAlias || prop] = value;
    } else {
        const ns = isSVG && prop.indexOf(":") > -1 && SVGNamespace[prop.split(":")[0]];
        if (ns) setAttributeNS(node, ns, prop, value);
        else setAttribute(node, Aliases[prop] || prop, value);
    }
    return value;
}
function eventHandler(e) {
    if (sharedConfig.registry && sharedConfig.events) {
        if (sharedConfig.events.find(([el, ev])=>ev === e)) return;
    }
    let node = e.target;
    const key = `$$${e.type}`;
    const oriTarget = e.target;
    const oriCurrentTarget = e.currentTarget;
    const retarget = (value)=>Object.defineProperty(e, "target", {
            configurable: true,
            value
        });
    const handleNode = ()=>{
        const handler = node[key];
        if (handler && !node.disabled) {
            const data = node[`${key}Data`];
            data !== void 0 ? handler.call(node, data, e) : handler.call(node, e);
            if (e.cancelBubble) return;
        }
        node.host && typeof node.host !== "string" && !node.host._$host && node.contains(e.target) && retarget(node.host);
        return true;
    };
    const walkUpTree = ()=>{
        while(handleNode() && (node = node._$host || node.parentNode || node.host));
    };
    Object.defineProperty(e, "currentTarget", {
        configurable: true,
        get () {
            return node || document;
        }
    });
    if (sharedConfig.registry && !sharedConfig.done) sharedConfig.done = _$HY.done = true;
    if (e.composedPath) {
        const path = e.composedPath();
        retarget(path[0]);
        for(let i = 0; i < path.length - 2; i++){
            node = path[i];
            if (!handleNode()) break;
            if (node._$host) {
                node = node._$host;
                walkUpTree();
                break;
            }
            if (node.parentNode === oriCurrentTarget) break;
        }
    } else walkUpTree();
    retarget(oriTarget);
}
function insertExpression(parent, value, current, marker, unwrapArray) {
    const hydrating = isHydrating(parent);
    if (hydrating) {
        !current && (current = [
            ...parent.childNodes
        ]);
        let cleaned = [];
        for(let i = 0; i < current.length; i++){
            const node = current[i];
            if (node.nodeType === 8 && node.data.slice(0, 2) === "!$") node.remove();
            else cleaned.push(node);
        }
        current = cleaned;
    }
    while(typeof current === "function")current = current();
    if (value === current) return current;
    const t = typeof value, multi = marker !== void 0;
    parent = multi && current[0] && current[0].parentNode || parent;
    if (t === "string" || t === "number") {
        if (hydrating) return current;
        if (t === "number") {
            value = value.toString();
            if (value === current) return current;
        }
        if (multi) {
            let node = current[0];
            if (node && node.nodeType === 3) node.data !== value && (node.data = value);
            else node = document.createTextNode(value);
            current = cleanChildren(parent, current, marker, node);
        } else if (current !== "" && typeof current === "string") current = parent.firstChild.data = value;
        else current = parent.textContent = value;
    } else if (value == null || t === "boolean") {
        if (hydrating) return current;
        current = cleanChildren(parent, current, marker);
    } else if (t === "function") {
        createRenderEffect(()=>{
            let v = value();
            while(typeof v === "function")v = v();
            current = insertExpression(parent, v, current, marker);
        });
        return ()=>current;
    } else if (Array.isArray(value)) {
        const array = [];
        const currentArray = current && Array.isArray(current);
        if (normalizeIncomingArray(array, value, current, unwrapArray)) {
            createRenderEffect(()=>current = insertExpression(parent, array, current, marker, true));
            return ()=>current;
        }
        if (hydrating) {
            if (!array.length) return current;
            if (marker === void 0) return current = [
                ...parent.childNodes
            ];
            let node = array[0];
            if (node.parentNode !== parent) return current;
            const nodes = [
                node
            ];
            while((node = node.nextSibling) !== marker)nodes.push(node);
            return current = nodes;
        }
        if (array.length === 0) {
            current = cleanChildren(parent, current, marker);
            if (multi) return current;
        } else if (currentArray) {
            if (current.length === 0) appendNodes(parent, array, marker);
            else reconcileArrays(parent, current, array);
        } else {
            current && cleanChildren(parent);
            appendNodes(parent, array);
        }
        current = array;
    } else if (value.nodeType) {
        if (hydrating && value.parentNode) return current = multi ? [
            value
        ] : value;
        if (Array.isArray(current)) {
            if (multi) return current = cleanChildren(parent, current, marker, value);
            cleanChildren(parent, current, null, value);
        } else if (current == null || current === "" || !parent.firstChild) parent.appendChild(value);
        else parent.replaceChild(value, parent.firstChild);
        current = value;
    }
    return current;
}
function normalizeIncomingArray(normalized, array, current, unwrap) {
    let dynamic = false;
    for(let i = 0, len = array.length; i < len; i++){
        let item = array[i], prev = current && current[normalized.length], t;
        if (item == null || item === true || item === false) ;
        else if ((t = typeof item) === "object" && item.nodeType) normalized.push(item);
        else if (Array.isArray(item)) dynamic = normalizeIncomingArray(normalized, item, prev) || dynamic;
        else if (t === "function") {
            if (unwrap) {
                while(typeof item === "function")item = item();
                dynamic = normalizeIncomingArray(normalized, Array.isArray(item) ? item : [
                    item
                ], Array.isArray(prev) ? prev : [
                    prev
                ]) || dynamic;
            } else {
                normalized.push(item);
                dynamic = true;
            }
        } else {
            const value = String(item);
            if (prev && prev.nodeType === 3 && prev.data === value) normalized.push(prev);
            else normalized.push(document.createTextNode(value));
        }
    }
    return dynamic;
}
function appendNodes(parent, array, marker = null) {
    for(let i = 0, len = array.length; i < len; i++)parent.insertBefore(array[i], marker);
}
function cleanChildren(parent, current, marker, replacement) {
    if (marker === void 0) return parent.textContent = "";
    const node = replacement || document.createTextNode("");
    if (current.length) {
        let inserted = false;
        for(let i = current.length - 1; i >= 0; i--){
            const el = current[i];
            if (node !== el) {
                const isParent = el.parentNode === parent;
                if (!inserted && !i) isParent ? parent.replaceChild(node, el) : parent.insertBefore(node, marker);
                else isParent && el.remove();
            } else inserted = true;
        }
    } else parent.insertBefore(node, marker);
    return [
        node
    ];
}
function getHydrationKey() {
    return sharedConfig.getNextContextId();
}
const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
function createElement(tagName, isSVG = false, is) {
    return isSVG ? document.createElementNS(SVG_NAMESPACE, tagName) : document.createElement(tagName, {
        is
    });
}
function createDynamic(component, props) {
    const cached = createMemo(component);
    return createMemo(()=>{
        const component2 = cached();
        switch(typeof component2){
            case "function":
                return untrack(()=>component2(props));
            case "string":
                const isSvg = SVGElements.has(component2);
                const el = sharedConfig.context ? getNextElement() : createElement(component2, isSvg, untrack(()=>props.is));
                spread(el, props, isSvg);
                return el;
        }
    });
}
function Dynamic(props) {
    const [, others] = splitProps(props, [
        "component"
    ]);
    return createDynamic(()=>props.component, others);
}
const ShadowDomTargetContext = createContext(void 0);
const DevtoolsOnCloseContext = createContext(void 0);
const useDevtoolsOnClose = ()=>{
    const context = useContext(DevtoolsOnCloseContext);
    if (!context) throw new Error("useDevtoolsOnClose must be used within a TanStackRouterDevtools component");
    return context;
};
class TanStackRouterDevtoolsCore {
    #router;
    #routerState;
    #position;
    #initialIsOpen;
    #shadowDOMTarget;
    #panelProps;
    #closeButtonProps;
    #toggleButtonProps;
    #containerElement;
    #isMounted = false;
    #Component;
    #dispose;
    constructor(config){
        this.#router = createSignal(config.router);
        this.#routerState = createSignal(config.routerState);
        this.#position = config.position ?? "bottom-left";
        this.#initialIsOpen = config.initialIsOpen ?? false;
        this.#shadowDOMTarget = config.shadowDOMTarget;
        this.#panelProps = config.panelProps;
        this.#closeButtonProps = config.closeButtonProps;
        this.#toggleButtonProps = config.toggleButtonProps;
        this.#containerElement = config.containerElement;
    }
    mount(el) {
        if (this.#isMounted) throw new Error("Devtools is already mounted");
        const dispose2 = render(()=>{
            const [router] = this.#router;
            const [routerState] = this.#routerState;
            const position = this.#position;
            const initialIsOpen = this.#initialIsOpen;
            const shadowDOMTarget = this.#shadowDOMTarget;
            const panelProps = this.#panelProps;
            const closeButtonProps = this.#closeButtonProps;
            const toggleButtonProps = this.#toggleButtonProps;
            const containerElement = this.#containerElement;
            let Devtools;
            if (this.#Component) Devtools = this.#Component;
            else {
                Devtools = lazy(()=>require("e7604fce7a281ce8"));
                this.#Component = Devtools;
            }
            return createComponent(ShadowDomTargetContext.Provider, {
                value: shadowDOMTarget,
                get children () {
                    return createComponent(Devtools, {
                        position,
                        initialIsOpen,
                        router,
                        routerState,
                        shadowDOMTarget,
                        panelProps,
                        closeButtonProps,
                        toggleButtonProps,
                        containerElement
                    });
                }
            });
        }, el);
        this.#isMounted = true;
        this.#dispose = dispose2;
    }
    unmount() {
        if (!this.#isMounted) throw new Error("Devtools is not mounted");
        this.#dispose?.();
        this.#isMounted = false;
    }
    setRouter(router) {
        this.#router[1](router);
    }
    setRouterState(routerState) {
        this.#routerState[1](routerState);
    }
    setOptions(options) {
        if (options.position !== void 0) this.#position = options.position;
        if (options.initialIsOpen !== void 0) this.#initialIsOpen = options.initialIsOpen;
        if (options.shadowDOMTarget !== void 0) this.#shadowDOMTarget = options.shadowDOMTarget;
        if (options.containerElement !== void 0) this.#containerElement = options.containerElement;
    }
}
class TanStackRouterDevtoolsPanelCore {
    #router;
    #routerState;
    #style;
    #className;
    #shadowDOMTarget;
    #isMounted = false;
    #setIsOpen;
    #dispose;
    #Component;
    constructor(config){
        const { router, routerState, shadowDOMTarget, setIsOpen, style: style2, className: className2 } = config;
        this.#router = createSignal(router);
        this.#routerState = createSignal(routerState);
        this.#style = createSignal(style2);
        this.#className = createSignal(className2);
        this.#shadowDOMTarget = shadowDOMTarget;
        this.#setIsOpen = setIsOpen;
    }
    mount(el) {
        if (this.#isMounted) throw new Error("Devtools is already mounted");
        const dispose2 = render(()=>{
            const [router] = this.#router;
            const [routerState] = this.#routerState;
            const [style2] = this.#style;
            const [className2] = this.#className;
            const shadowDOMTarget = this.#shadowDOMTarget;
            const setIsOpen = this.#setIsOpen;
            let BaseTanStackRouterDevtoolsPanel;
            if (this.#Component) BaseTanStackRouterDevtoolsPanel = this.#Component;
            else {
                BaseTanStackRouterDevtoolsPanel = lazy(()=>require("cd886e9fe60af95d").then((n)=>n.c));
                this.#Component = BaseTanStackRouterDevtoolsPanel;
            }
            return createComponent(ShadowDomTargetContext.Provider, {
                value: shadowDOMTarget,
                get children () {
                    return createComponent(DevtoolsOnCloseContext.Provider, {
                        value: {
                            onCloseClick: ()=>{}
                        },
                        get children () {
                            return createComponent(BaseTanStackRouterDevtoolsPanel, {
                                router,
                                routerState,
                                shadowDOMTarget,
                                setIsOpen,
                                style: style2,
                                className: className2
                            });
                        }
                    });
                }
            });
        }, el);
        this.#isMounted = true;
        this.#dispose = dispose2;
    }
    unmount() {
        if (!this.#isMounted) throw new Error("Devtools is not mounted");
        this.#dispose?.();
        this.#isMounted = false;
    }
    setRouter(router) {
        this.#router[1](router);
    }
    setRouterState(routerState) {
        this.#routerState[1](routerState);
    }
    setStyle(style2) {
        this.#style[1](style2);
    }
    setClassName(className2) {
        this.#className[1](className2);
    }
    setOptions(options) {
        if (options.shadowDOMTarget !== void 0) this.#shadowDOMTarget = options.shadowDOMTarget;
        if (options.router !== void 0) this.setRouter(options.router);
        if (options.routerState !== void 0) this.setRouterState(options.routerState);
        if (options.style !== void 0) this.setStyle(options.style);
        if (options.className !== void 0) this.setClassName(options.className);
    }
}

},{"e7604fce7a281ce8":"hOikg","cd886e9fe60af95d":"iwKtO","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hOikg":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("4QKmM"),
    import("2mE2m")
]).then(()=>module.bundle.root('T8sYk'));

},{}],"iwKtO":[function(require,module,exports,__globalThis) {
module.exports = import("4QKmM").then(()=>module.bundle.root('bnviH'));

},{}],"azwQu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TanStackRouterDevtoolsPanel", ()=>TanStackRouterDevtoolsPanel);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("@tanstack/react-router");
var _routerDevtoolsCore = require("@tanstack/router-devtools-core");
var _react = require("react");
const TanStackRouterDevtoolsPanel = (props)=>{
    const { router: propsRouter, ...rest } = props;
    const hookRouter = (0, _reactRouter.useRouter)({
        warn: false
    });
    const activeRouter = propsRouter ?? hookRouter;
    const activeRouterState = (0, _reactRouter.useRouterState)({
        router: activeRouter
    });
    const devToolRef = (0, _react.useRef)(null);
    const [devtools] = (0, _react.useState)(()=>new (0, _routerDevtoolsCore.TanStackRouterDevtoolsPanelCore)({
            ...rest,
            router: activeRouter,
            routerState: activeRouterState
        }));
    (0, _react.useEffect)(()=>{
        devtools.setRouter(activeRouter);
    }, [
        devtools,
        activeRouter
    ]);
    (0, _react.useEffect)(()=>{
        devtools.setRouterState(activeRouterState);
    }, [
        devtools,
        activeRouterState
    ]);
    (0, _react.useEffect)(()=>{
        devtools.setOptions({
            className: props.className,
            style: props.style,
            shadowDOMTarget: props.shadowDOMTarget
        });
    }, [
        devtools,
        props.className,
        props.style,
        props.shadowDOMTarget
    ]);
    (0, _react.useEffect)(()=>{
        if (devToolRef.current) devtools.mount(devToolRef.current);
        return ()=>{
            devtools.unmount();
        };
    }, [
        devtools
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            ref: devToolRef
        })
    });
};

},{"react/jsx-runtime":"dQjte","@tanstack/react-router":[["useRouter","nz9fN"],["useRouterState","2Tx7u"]],"@tanstack/router-devtools-core":[["TanStackRouterDevtoolsPanelCore","dqAWX","w"]],"react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2p5sL":[function(require,module,exports,__globalThis) {
'use client';
function __insertCSS(code) {
    if (!code || typeof document == 'undefined') return;
    let head = document.head || document.getElementsByTagName('head')[0];
    let style = document.createElement('style');
    style.type = 'text/css';
    head.appendChild(style);
    style.styleSheet ? style.styleSheet.cssText = code : style.appendChild(document.createTextNode(code));
}
Object.defineProperty(exports, '__esModule', {
    value: true
});
var React = require("506d710bd5a66c46");
var ReactDOM = require("5ae9894746045f30");
function _interopDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var React__default = /*#__PURE__*/ _interopDefault(React);
var ReactDOM__default = /*#__PURE__*/ _interopDefault(ReactDOM);
const getAsset = (type)=>{
    switch(type){
        case 'success':
            return SuccessIcon;
        case 'info':
            return InfoIcon;
        case 'warning':
            return WarningIcon;
        case 'error':
            return ErrorIcon;
        default:
            return null;
    }
};
const bars = Array(12).fill(0);
const Loader = ({ visible, className })=>{
    return /*#__PURE__*/ React__default.default.createElement("div", {
        className: [
            'sonner-loading-wrapper',
            className
        ].filter(Boolean).join(' '),
        "data-visible": visible
    }, /*#__PURE__*/ React__default.default.createElement("div", {
        className: "sonner-spinner"
    }, bars.map((_, i)=>/*#__PURE__*/ React__default.default.createElement("div", {
            className: "sonner-loading-bar",
            key: `spinner-bar-${i}`
        }))));
};
const SuccessIcon = /*#__PURE__*/ React__default.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    height: "20",
    width: "20"
}, /*#__PURE__*/ React__default.default.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
    clipRule: "evenodd"
}));
const WarningIcon = /*#__PURE__*/ React__default.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    height: "20",
    width: "20"
}, /*#__PURE__*/ React__default.default.createElement("path", {
    fillRule: "evenodd",
    d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
    clipRule: "evenodd"
}));
const InfoIcon = /*#__PURE__*/ React__default.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    height: "20",
    width: "20"
}, /*#__PURE__*/ React__default.default.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
    clipRule: "evenodd"
}));
const ErrorIcon = /*#__PURE__*/ React__default.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    height: "20",
    width: "20"
}, /*#__PURE__*/ React__default.default.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
    clipRule: "evenodd"
}));
const CloseIcon = /*#__PURE__*/ React__default.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
}, /*#__PURE__*/ React__default.default.createElement("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
}), /*#__PURE__*/ React__default.default.createElement("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
}));
const useIsDocumentHidden = ()=>{
    const [isDocumentHidden, setIsDocumentHidden] = React__default.default.useState(document.hidden);
    React__default.default.useEffect(()=>{
        const callback = ()=>{
            setIsDocumentHidden(document.hidden);
        };
        document.addEventListener('visibilitychange', callback);
        return ()=>window.removeEventListener('visibilitychange', callback);
    }, []);
    return isDocumentHidden;
};
let toastsCounter = 1;
class Observer {
    constructor(){
        // We use arrow functions to maintain the correct `this` reference
        this.subscribe = (subscriber)=>{
            this.subscribers.push(subscriber);
            return ()=>{
                const index = this.subscribers.indexOf(subscriber);
                this.subscribers.splice(index, 1);
            };
        };
        this.publish = (data)=>{
            this.subscribers.forEach((subscriber)=>subscriber(data));
        };
        this.addToast = (data)=>{
            this.publish(data);
            this.toasts = [
                ...this.toasts,
                data
            ];
        };
        this.create = (data)=>{
            var _data_id;
            const { message, ...rest } = data;
            const id = typeof (data == null ? void 0 : data.id) === 'number' || ((_data_id = data.id) == null ? void 0 : _data_id.length) > 0 ? data.id : toastsCounter++;
            const alreadyExists = this.toasts.find((toast)=>{
                return toast.id === id;
            });
            const dismissible = data.dismissible === undefined ? true : data.dismissible;
            if (this.dismissedToasts.has(id)) this.dismissedToasts.delete(id);
            if (alreadyExists) this.toasts = this.toasts.map((toast)=>{
                if (toast.id === id) {
                    this.publish({
                        ...toast,
                        ...data,
                        id,
                        title: message
                    });
                    return {
                        ...toast,
                        ...data,
                        id,
                        dismissible,
                        title: message
                    };
                }
                return toast;
            });
            else this.addToast({
                title: message,
                ...rest,
                dismissible,
                id
            });
            return id;
        };
        this.dismiss = (id)=>{
            if (id) {
                this.dismissedToasts.add(id);
                requestAnimationFrame(()=>this.subscribers.forEach((subscriber)=>subscriber({
                            id,
                            dismiss: true
                        })));
            } else this.toasts.forEach((toast)=>{
                this.subscribers.forEach((subscriber)=>subscriber({
                        id: toast.id,
                        dismiss: true
                    }));
            });
            return id;
        };
        this.message = (message, data)=>{
            return this.create({
                ...data,
                message
            });
        };
        this.error = (message, data)=>{
            return this.create({
                ...data,
                message,
                type: 'error'
            });
        };
        this.success = (message, data)=>{
            return this.create({
                ...data,
                type: 'success',
                message
            });
        };
        this.info = (message, data)=>{
            return this.create({
                ...data,
                type: 'info',
                message
            });
        };
        this.warning = (message, data)=>{
            return this.create({
                ...data,
                type: 'warning',
                message
            });
        };
        this.loading = (message, data)=>{
            return this.create({
                ...data,
                type: 'loading',
                message
            });
        };
        this.promise = (promise, data)=>{
            if (!data) // Nothing to show
            return;
            let id = undefined;
            if (data.loading !== undefined) id = this.create({
                ...data,
                promise,
                type: 'loading',
                message: data.loading,
                description: typeof data.description !== 'function' ? data.description : undefined
            });
            const p = Promise.resolve(promise instanceof Function ? promise() : promise);
            let shouldDismiss = id !== undefined;
            let result;
            const originalPromise = p.then(async (response)=>{
                result = [
                    'resolve',
                    response
                ];
                const isReactElementResponse = React__default.default.isValidElement(response);
                if (isReactElementResponse) {
                    shouldDismiss = false;
                    this.create({
                        id,
                        type: 'default',
                        message: response
                    });
                } else if (isHttpResponse(response) && !response.ok) {
                    shouldDismiss = false;
                    const promiseData = typeof data.error === 'function' ? await data.error(`HTTP error! status: ${response.status}`) : data.error;
                    const description = typeof data.description === 'function' ? await data.description(`HTTP error! status: ${response.status}`) : data.description;
                    const isExtendedResult = typeof promiseData === 'object' && !React__default.default.isValidElement(promiseData);
                    const toastSettings = isExtendedResult ? promiseData : {
                        message: promiseData
                    };
                    this.create({
                        id,
                        type: 'error',
                        description,
                        ...toastSettings
                    });
                } else if (response instanceof Error) {
                    shouldDismiss = false;
                    const promiseData = typeof data.error === 'function' ? await data.error(response) : data.error;
                    const description = typeof data.description === 'function' ? await data.description(response) : data.description;
                    const isExtendedResult = typeof promiseData === 'object' && !React__default.default.isValidElement(promiseData);
                    const toastSettings = isExtendedResult ? promiseData : {
                        message: promiseData
                    };
                    this.create({
                        id,
                        type: 'error',
                        description,
                        ...toastSettings
                    });
                } else if (data.success !== undefined) {
                    shouldDismiss = false;
                    const promiseData = typeof data.success === 'function' ? await data.success(response) : data.success;
                    const description = typeof data.description === 'function' ? await data.description(response) : data.description;
                    const isExtendedResult = typeof promiseData === 'object' && !React__default.default.isValidElement(promiseData);
                    const toastSettings = isExtendedResult ? promiseData : {
                        message: promiseData
                    };
                    this.create({
                        id,
                        type: 'success',
                        description,
                        ...toastSettings
                    });
                }
            }).catch(async (error)=>{
                result = [
                    'reject',
                    error
                ];
                if (data.error !== undefined) {
                    shouldDismiss = false;
                    const promiseData = typeof data.error === 'function' ? await data.error(error) : data.error;
                    const description = typeof data.description === 'function' ? await data.description(error) : data.description;
                    const isExtendedResult = typeof promiseData === 'object' && !React__default.default.isValidElement(promiseData);
                    const toastSettings = isExtendedResult ? promiseData : {
                        message: promiseData
                    };
                    this.create({
                        id,
                        type: 'error',
                        description,
                        ...toastSettings
                    });
                }
            }).finally(()=>{
                if (shouldDismiss) {
                    // Toast is still in load state (and will be indefinitely — dismiss it)
                    this.dismiss(id);
                    id = undefined;
                }
                data.finally == null || data.finally.call(data);
            });
            const unwrap = ()=>new Promise((resolve, reject)=>originalPromise.then(()=>result[0] === 'reject' ? reject(result[1]) : resolve(result[1])).catch(reject));
            if (typeof id !== 'string' && typeof id !== 'number') // cannot Object.assign on undefined
            return {
                unwrap
            };
            else return Object.assign(id, {
                unwrap
            });
        };
        this.custom = (jsx, data)=>{
            const id = (data == null ? void 0 : data.id) || toastsCounter++;
            this.create({
                jsx: jsx(id),
                id,
                ...data
            });
            return id;
        };
        this.getActiveToasts = ()=>{
            return this.toasts.filter((toast)=>!this.dismissedToasts.has(toast.id));
        };
        this.subscribers = [];
        this.toasts = [];
        this.dismissedToasts = new Set();
    }
}
const ToastState = new Observer();
// bind this to the toast function
const toastFunction = (message, data)=>{
    const id = (data == null ? void 0 : data.id) || toastsCounter++;
    ToastState.addToast({
        title: message,
        ...data,
        id
    });
    return id;
};
const isHttpResponse = (data)=>{
    return data && typeof data === 'object' && 'ok' in data && typeof data.ok === 'boolean' && 'status' in data && typeof data.status === 'number';
};
const basicToast = toastFunction;
const getHistory = ()=>ToastState.toasts;
const getToasts = ()=>ToastState.getActiveToasts();
// We use `Object.assign` to maintain the correct types as we would lose them otherwise
const toast = Object.assign(basicToast, {
    success: ToastState.success,
    info: ToastState.info,
    warning: ToastState.warning,
    error: ToastState.error,
    custom: ToastState.custom,
    message: ToastState.message,
    promise: ToastState.promise,
    dismiss: ToastState.dismiss,
    loading: ToastState.loading
}, {
    getHistory,
    getToasts
});
__insertCSS("[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999;transition:transform .4s ease}@media (hover:none) and (pointer:coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);background:var(--normal-bg);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]::before{content:'';position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]::before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]::before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]::before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]::after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]::before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y,0)) translateX(var(--swipe-amount-x,0));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 87%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 93%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 84%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg:#000;--normal-bg-hover:hsl(0, 0%, 12%);--normal-border:hsl(0, 0%, 20%);--normal-border-hover:hsl(0, 0%, 25%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 43%, 17%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 9%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}");
function isAction(action) {
    return action.label !== undefined;
}
// Visible toasts amount
const VISIBLE_TOASTS_AMOUNT = 3;
// Viewport padding
const VIEWPORT_OFFSET = '24px';
// Mobile viewport padding
const MOBILE_VIEWPORT_OFFSET = '16px';
// Default lifetime of a toasts (in ms)
const TOAST_LIFETIME = 4000;
// Default toast width
const TOAST_WIDTH = 356;
// Default gap between toasts
const GAP = 14;
// Threshold to dismiss a toast
const SWIPE_THRESHOLD = 45;
// Equal to exit animation duration
const TIME_BEFORE_UNMOUNT = 200;
function cn(...classes) {
    return classes.filter(Boolean).join(' ');
}
function getDefaultSwipeDirections(position) {
    const [y, x] = position.split('-');
    const directions = [];
    if (y) directions.push(y);
    if (x) directions.push(x);
    return directions;
}
const Toast = (props)=>{
    var _toast_classNames, _toast_classNames1, _toast_classNames2, _toast_classNames3, _toast_classNames4, _toast_classNames5, _toast_classNames6, _toast_classNames7, _toast_classNames8;
    const { invert: ToasterInvert, toast, unstyled, interacting, setHeights, visibleToasts, heights, index, toasts, expanded, removeToast, defaultRichColors, closeButton: closeButtonFromToaster, style, cancelButtonStyle, actionButtonStyle, className = '', descriptionClassName = '', duration: durationFromToaster, position, gap, expandByDefault, classNames, icons, closeButtonAriaLabel = 'Close toast' } = props;
    const [swipeDirection, setSwipeDirection] = React__default.default.useState(null);
    const [swipeOutDirection, setSwipeOutDirection] = React__default.default.useState(null);
    const [mounted, setMounted] = React__default.default.useState(false);
    const [removed, setRemoved] = React__default.default.useState(false);
    const [swiping, setSwiping] = React__default.default.useState(false);
    const [swipeOut, setSwipeOut] = React__default.default.useState(false);
    const [isSwiped, setIsSwiped] = React__default.default.useState(false);
    const [offsetBeforeRemove, setOffsetBeforeRemove] = React__default.default.useState(0);
    const [initialHeight, setInitialHeight] = React__default.default.useState(0);
    const remainingTime = React__default.default.useRef(toast.duration || durationFromToaster || TOAST_LIFETIME);
    const dragStartTime = React__default.default.useRef(null);
    const toastRef = React__default.default.useRef(null);
    const isFront = index === 0;
    const isVisible = index + 1 <= visibleToasts;
    const toastType = toast.type;
    const dismissible = toast.dismissible !== false;
    const toastClassname = toast.className || '';
    const toastDescriptionClassname = toast.descriptionClassName || '';
    // Height index is used to calculate the offset as it gets updated before the toast array, which means we can calculate the new layout faster.
    const heightIndex = React__default.default.useMemo(()=>heights.findIndex((height)=>height.toastId === toast.id) || 0, [
        heights,
        toast.id
    ]);
    const closeButton = React__default.default.useMemo(()=>{
        var _toast_closeButton;
        return (_toast_closeButton = toast.closeButton) != null ? _toast_closeButton : closeButtonFromToaster;
    }, [
        toast.closeButton,
        closeButtonFromToaster
    ]);
    const duration = React__default.default.useMemo(()=>toast.duration || durationFromToaster || TOAST_LIFETIME, [
        toast.duration,
        durationFromToaster
    ]);
    const closeTimerStartTimeRef = React__default.default.useRef(0);
    const offset = React__default.default.useRef(0);
    const lastCloseTimerStartTimeRef = React__default.default.useRef(0);
    const pointerStartRef = React__default.default.useRef(null);
    const [y, x] = position.split('-');
    const toastsHeightBefore = React__default.default.useMemo(()=>{
        return heights.reduce((prev, curr, reducerIndex)=>{
            // Calculate offset up until current toast
            if (reducerIndex >= heightIndex) return prev;
            return prev + curr.height;
        }, 0);
    }, [
        heights,
        heightIndex
    ]);
    const isDocumentHidden = useIsDocumentHidden();
    const invert = toast.invert || ToasterInvert;
    const disabled = toastType === 'loading';
    offset.current = React__default.default.useMemo(()=>heightIndex * gap + toastsHeightBefore, [
        heightIndex,
        toastsHeightBefore
    ]);
    React__default.default.useEffect(()=>{
        remainingTime.current = duration;
    }, [
        duration
    ]);
    React__default.default.useEffect(()=>{
        // Trigger enter animation without using CSS animation
        setMounted(true);
    }, []);
    React__default.default.useEffect(()=>{
        const toastNode = toastRef.current;
        if (toastNode) {
            const height = toastNode.getBoundingClientRect().height;
            // Add toast height to heights array after the toast is mounted
            setInitialHeight(height);
            setHeights((h)=>[
                    {
                        toastId: toast.id,
                        height,
                        position: toast.position
                    },
                    ...h
                ]);
            return ()=>setHeights((h)=>h.filter((height)=>height.toastId !== toast.id));
        }
    }, [
        setHeights,
        toast.id
    ]);
    React__default.default.useLayoutEffect(()=>{
        // Keep height up to date with the content in case it updates
        if (!mounted) return;
        const toastNode = toastRef.current;
        const originalHeight = toastNode.style.height;
        toastNode.style.height = 'auto';
        const newHeight = toastNode.getBoundingClientRect().height;
        toastNode.style.height = originalHeight;
        setInitialHeight(newHeight);
        setHeights((heights)=>{
            const alreadyExists = heights.find((height)=>height.toastId === toast.id);
            if (!alreadyExists) return [
                {
                    toastId: toast.id,
                    height: newHeight,
                    position: toast.position
                },
                ...heights
            ];
            else return heights.map((height)=>height.toastId === toast.id ? {
                    ...height,
                    height: newHeight
                } : height);
        });
    }, [
        mounted,
        toast.title,
        toast.description,
        setHeights,
        toast.id,
        toast.jsx,
        toast.action,
        toast.cancel
    ]);
    const deleteToast = React__default.default.useCallback(()=>{
        // Save the offset for the exit swipe animation
        setRemoved(true);
        setOffsetBeforeRemove(offset.current);
        setHeights((h)=>h.filter((height)=>height.toastId !== toast.id));
        setTimeout(()=>{
            removeToast(toast);
        }, TIME_BEFORE_UNMOUNT);
    }, [
        toast,
        removeToast,
        setHeights,
        offset
    ]);
    React__default.default.useEffect(()=>{
        if (toast.promise && toastType === 'loading' || toast.duration === Infinity || toast.type === 'loading') return;
        let timeoutId;
        // Pause the timer on each hover
        const pauseTimer = ()=>{
            if (lastCloseTimerStartTimeRef.current < closeTimerStartTimeRef.current) {
                // Get the elapsed time since the timer started
                const elapsedTime = new Date().getTime() - closeTimerStartTimeRef.current;
                remainingTime.current = remainingTime.current - elapsedTime;
            }
            lastCloseTimerStartTimeRef.current = new Date().getTime();
        };
        const startTimer = ()=>{
            // setTimeout(, Infinity) behaves as if the delay is 0.
            // As a result, the toast would be closed immediately, giving the appearance that it was never rendered.
            // See: https://github.com/denysdovhan/wtfjs?tab=readme-ov-file#an-infinite-timeout
            if (remainingTime.current === Infinity) return;
            closeTimerStartTimeRef.current = new Date().getTime();
            // Let the toast know it has started
            timeoutId = setTimeout(()=>{
                toast.onAutoClose == null || toast.onAutoClose.call(toast, toast);
                deleteToast();
            }, remainingTime.current);
        };
        if (expanded || interacting || isDocumentHidden) pauseTimer();
        else startTimer();
        return ()=>clearTimeout(timeoutId);
    }, [
        expanded,
        interacting,
        toast,
        toastType,
        isDocumentHidden,
        deleteToast
    ]);
    React__default.default.useEffect(()=>{
        if (toast.delete) {
            deleteToast();
            toast.onDismiss == null || toast.onDismiss.call(toast, toast);
        }
    }, [
        deleteToast,
        toast.delete
    ]);
    function getLoadingIcon() {
        var _toast_classNames;
        if (icons == null ? void 0 : icons.loading) {
            var _toast_classNames1;
            return /*#__PURE__*/ React__default.default.createElement("div", {
                className: cn(classNames == null ? void 0 : classNames.loader, toast == null ? void 0 : (_toast_classNames1 = toast.classNames) == null ? void 0 : _toast_classNames1.loader, 'sonner-loader'),
                "data-visible": toastType === 'loading'
            }, icons.loading);
        }
        return /*#__PURE__*/ React__default.default.createElement(Loader, {
            className: cn(classNames == null ? void 0 : classNames.loader, toast == null ? void 0 : (_toast_classNames = toast.classNames) == null ? void 0 : _toast_classNames.loader),
            visible: toastType === 'loading'
        });
    }
    const icon = toast.icon || (icons == null ? void 0 : icons[toastType]) || getAsset(toastType);
    var _toast_richColors, _icons_close;
    return /*#__PURE__*/ React__default.default.createElement("li", {
        tabIndex: 0,
        ref: toastRef,
        className: cn(className, toastClassname, classNames == null ? void 0 : classNames.toast, toast == null ? void 0 : (_toast_classNames = toast.classNames) == null ? void 0 : _toast_classNames.toast, classNames == null ? void 0 : classNames.default, classNames == null ? void 0 : classNames[toastType], toast == null ? void 0 : (_toast_classNames1 = toast.classNames) == null ? void 0 : _toast_classNames1[toastType]),
        "data-sonner-toast": "",
        "data-rich-colors": (_toast_richColors = toast.richColors) != null ? _toast_richColors : defaultRichColors,
        "data-styled": !Boolean(toast.jsx || toast.unstyled || unstyled),
        "data-mounted": mounted,
        "data-promise": Boolean(toast.promise),
        "data-swiped": isSwiped,
        "data-removed": removed,
        "data-visible": isVisible,
        "data-y-position": y,
        "data-x-position": x,
        "data-index": index,
        "data-front": isFront,
        "data-swiping": swiping,
        "data-dismissible": dismissible,
        "data-type": toastType,
        "data-invert": invert,
        "data-swipe-out": swipeOut,
        "data-swipe-direction": swipeOutDirection,
        "data-expanded": Boolean(expanded || expandByDefault && mounted),
        "data-testid": toast.testId,
        style: {
            '--index': index,
            '--toasts-before': index,
            '--z-index': toasts.length - index,
            '--offset': `${removed ? offsetBeforeRemove : offset.current}px`,
            '--initial-height': expandByDefault ? 'auto' : `${initialHeight}px`,
            ...style,
            ...toast.style
        },
        onDragEnd: ()=>{
            setSwiping(false);
            setSwipeDirection(null);
            pointerStartRef.current = null;
        },
        onPointerDown: (event)=>{
            if (event.button === 2) return; // Return early on right click
            if (disabled || !dismissible) return;
            dragStartTime.current = new Date();
            setOffsetBeforeRemove(offset.current);
            // Ensure we maintain correct pointer capture even when going outside of the toast (e.g. when swiping)
            event.target.setPointerCapture(event.pointerId);
            if (event.target.tagName === 'BUTTON') return;
            setSwiping(true);
            pointerStartRef.current = {
                x: event.clientX,
                y: event.clientY
            };
        },
        onPointerUp: ()=>{
            var _toastRef_current, _toastRef_current1, _dragStartTime_current;
            if (swipeOut || !dismissible) return;
            pointerStartRef.current = null;
            const swipeAmountX = Number(((_toastRef_current = toastRef.current) == null ? void 0 : _toastRef_current.style.getPropertyValue('--swipe-amount-x').replace('px', '')) || 0);
            const swipeAmountY = Number(((_toastRef_current1 = toastRef.current) == null ? void 0 : _toastRef_current1.style.getPropertyValue('--swipe-amount-y').replace('px', '')) || 0);
            const timeTaken = new Date().getTime() - ((_dragStartTime_current = dragStartTime.current) == null ? void 0 : _dragStartTime_current.getTime());
            const swipeAmount = swipeDirection === 'x' ? swipeAmountX : swipeAmountY;
            const velocity = Math.abs(swipeAmount) / timeTaken;
            if (Math.abs(swipeAmount) >= SWIPE_THRESHOLD || velocity > 0.11) {
                setOffsetBeforeRemove(offset.current);
                toast.onDismiss == null || toast.onDismiss.call(toast, toast);
                if (swipeDirection === 'x') setSwipeOutDirection(swipeAmountX > 0 ? 'right' : 'left');
                else setSwipeOutDirection(swipeAmountY > 0 ? 'down' : 'up');
                deleteToast();
                setSwipeOut(true);
                return;
            } else {
                var _toastRef_current2, _toastRef_current3;
                (_toastRef_current2 = toastRef.current) == null || _toastRef_current2.style.setProperty('--swipe-amount-x', `0px`);
                (_toastRef_current3 = toastRef.current) == null || _toastRef_current3.style.setProperty('--swipe-amount-y', `0px`);
            }
            setIsSwiped(false);
            setSwiping(false);
            setSwipeDirection(null);
        },
        onPointerMove: (event)=>{
            var _window_getSelection, _toastRef_current, _toastRef_current1;
            if (!pointerStartRef.current || !dismissible) return;
            const isHighlighted = ((_window_getSelection = window.getSelection()) == null ? void 0 : _window_getSelection.toString().length) > 0;
            if (isHighlighted) return;
            const yDelta = event.clientY - pointerStartRef.current.y;
            const xDelta = event.clientX - pointerStartRef.current.x;
            var _props_swipeDirections;
            const swipeDirections = (_props_swipeDirections = props.swipeDirections) != null ? _props_swipeDirections : getDefaultSwipeDirections(position);
            // Determine swipe direction if not already locked
            if (!swipeDirection && (Math.abs(xDelta) > 1 || Math.abs(yDelta) > 1)) setSwipeDirection(Math.abs(xDelta) > Math.abs(yDelta) ? 'x' : 'y');
            let swipeAmount = {
                x: 0,
                y: 0
            };
            const getDampening = (delta)=>{
                const factor = Math.abs(delta) / 20;
                return 1 / (1.5 + factor);
            };
            // Only apply swipe in the locked direction
            if (swipeDirection === 'y') // Handle vertical swipes
            {
                if (swipeDirections.includes('top') || swipeDirections.includes('bottom')) {
                    if (swipeDirections.includes('top') && yDelta < 0 || swipeDirections.includes('bottom') && yDelta > 0) swipeAmount.y = yDelta;
                    else {
                        // Smoothly transition to dampened movement
                        const dampenedDelta = yDelta * getDampening(yDelta);
                        // Ensure we don't jump when transitioning to dampened movement
                        swipeAmount.y = Math.abs(dampenedDelta) < Math.abs(yDelta) ? dampenedDelta : yDelta;
                    }
                }
            } else if (swipeDirection === 'x') // Handle horizontal swipes
            {
                if (swipeDirections.includes('left') || swipeDirections.includes('right')) {
                    if (swipeDirections.includes('left') && xDelta < 0 || swipeDirections.includes('right') && xDelta > 0) swipeAmount.x = xDelta;
                    else {
                        // Smoothly transition to dampened movement
                        const dampenedDelta = xDelta * getDampening(xDelta);
                        // Ensure we don't jump when transitioning to dampened movement
                        swipeAmount.x = Math.abs(dampenedDelta) < Math.abs(xDelta) ? dampenedDelta : xDelta;
                    }
                }
            }
            if (Math.abs(swipeAmount.x) > 0 || Math.abs(swipeAmount.y) > 0) setIsSwiped(true);
            (_toastRef_current = toastRef.current) == null || _toastRef_current.style.setProperty('--swipe-amount-x', `${swipeAmount.x}px`);
            (_toastRef_current1 = toastRef.current) == null || _toastRef_current1.style.setProperty('--swipe-amount-y', `${swipeAmount.y}px`);
        }
    }, closeButton && !toast.jsx && toastType !== 'loading' ? /*#__PURE__*/ React__default.default.createElement("button", {
        "aria-label": closeButtonAriaLabel,
        "data-disabled": disabled,
        "data-close-button": true,
        onClick: disabled || !dismissible ? ()=>{} : ()=>{
            deleteToast();
            toast.onDismiss == null || toast.onDismiss.call(toast, toast);
        },
        className: cn(classNames == null ? void 0 : classNames.closeButton, toast == null ? void 0 : (_toast_classNames2 = toast.classNames) == null ? void 0 : _toast_classNames2.closeButton)
    }, (_icons_close = icons == null ? void 0 : icons.close) != null ? _icons_close : CloseIcon) : null, (toastType || toast.icon || toast.promise) && toast.icon !== null && ((icons == null ? void 0 : icons[toastType]) !== null || toast.icon) ? /*#__PURE__*/ React__default.default.createElement("div", {
        "data-icon": "",
        className: cn(classNames == null ? void 0 : classNames.icon, toast == null ? void 0 : (_toast_classNames3 = toast.classNames) == null ? void 0 : _toast_classNames3.icon)
    }, toast.promise || toast.type === 'loading' && !toast.icon ? toast.icon || getLoadingIcon() : null, toast.type !== 'loading' ? icon : null) : null, /*#__PURE__*/ React__default.default.createElement("div", {
        "data-content": "",
        className: cn(classNames == null ? void 0 : classNames.content, toast == null ? void 0 : (_toast_classNames4 = toast.classNames) == null ? void 0 : _toast_classNames4.content)
    }, /*#__PURE__*/ React__default.default.createElement("div", {
        "data-title": "",
        className: cn(classNames == null ? void 0 : classNames.title, toast == null ? void 0 : (_toast_classNames5 = toast.classNames) == null ? void 0 : _toast_classNames5.title)
    }, toast.jsx ? toast.jsx : typeof toast.title === 'function' ? toast.title() : toast.title), toast.description ? /*#__PURE__*/ React__default.default.createElement("div", {
        "data-description": "",
        className: cn(descriptionClassName, toastDescriptionClassname, classNames == null ? void 0 : classNames.description, toast == null ? void 0 : (_toast_classNames6 = toast.classNames) == null ? void 0 : _toast_classNames6.description)
    }, typeof toast.description === 'function' ? toast.description() : toast.description) : null), /*#__PURE__*/ React__default.default.isValidElement(toast.cancel) ? toast.cancel : toast.cancel && isAction(toast.cancel) ? /*#__PURE__*/ React__default.default.createElement("button", {
        "data-button": true,
        "data-cancel": true,
        style: toast.cancelButtonStyle || cancelButtonStyle,
        onClick: (event)=>{
            // We need to check twice because typescript
            if (!isAction(toast.cancel)) return;
            if (!dismissible) return;
            toast.cancel.onClick == null || toast.cancel.onClick.call(toast.cancel, event);
            deleteToast();
        },
        className: cn(classNames == null ? void 0 : classNames.cancelButton, toast == null ? void 0 : (_toast_classNames7 = toast.classNames) == null ? void 0 : _toast_classNames7.cancelButton)
    }, toast.cancel.label) : null, /*#__PURE__*/ React__default.default.isValidElement(toast.action) ? toast.action : toast.action && isAction(toast.action) ? /*#__PURE__*/ React__default.default.createElement("button", {
        "data-button": true,
        "data-action": true,
        style: toast.actionButtonStyle || actionButtonStyle,
        onClick: (event)=>{
            // We need to check twice because typescript
            if (!isAction(toast.action)) return;
            toast.action.onClick == null || toast.action.onClick.call(toast.action, event);
            if (event.defaultPrevented) return;
            deleteToast();
        },
        className: cn(classNames == null ? void 0 : classNames.actionButton, toast == null ? void 0 : (_toast_classNames8 = toast.classNames) == null ? void 0 : _toast_classNames8.actionButton)
    }, toast.action.label) : null);
};
function getDocumentDirection() {
    if (typeof window === 'undefined') return 'ltr';
    if (typeof document === 'undefined') return 'ltr'; // For Fresh purpose
    const dirAttribute = document.documentElement.getAttribute('dir');
    if (dirAttribute === 'auto' || !dirAttribute) return window.getComputedStyle(document.documentElement).direction;
    return dirAttribute;
}
function assignOffset(defaultOffset, mobileOffset) {
    const styles = {};
    [
        defaultOffset,
        mobileOffset
    ].forEach((offset, index)=>{
        const isMobile = index === 1;
        const prefix = isMobile ? '--mobile-offset' : '--offset';
        const defaultValue = isMobile ? MOBILE_VIEWPORT_OFFSET : VIEWPORT_OFFSET;
        function assignAll(offset) {
            [
                'top',
                'right',
                'bottom',
                'left'
            ].forEach((key)=>{
                styles[`${prefix}-${key}`] = typeof offset === 'number' ? `${offset}px` : offset;
            });
        }
        if (typeof offset === 'number' || typeof offset === 'string') assignAll(offset);
        else if (typeof offset === 'object') [
            'top',
            'right',
            'bottom',
            'left'
        ].forEach((key)=>{
            if (offset[key] === undefined) styles[`${prefix}-${key}`] = defaultValue;
            else styles[`${prefix}-${key}`] = typeof offset[key] === 'number' ? `${offset[key]}px` : offset[key];
        });
        else assignAll(defaultValue);
    });
    return styles;
}
function useSonner() {
    const [activeToasts, setActiveToasts] = React__default.default.useState([]);
    React__default.default.useEffect(()=>{
        return ToastState.subscribe((toast)=>{
            if (toast.dismiss) {
                setTimeout(()=>{
                    ReactDOM__default.default.flushSync(()=>{
                        setActiveToasts((toasts)=>toasts.filter((t)=>t.id !== toast.id));
                    });
                });
                return;
            }
            // Prevent batching, temp solution.
            setTimeout(()=>{
                ReactDOM__default.default.flushSync(()=>{
                    setActiveToasts((toasts)=>{
                        const indexOfExistingToast = toasts.findIndex((t)=>t.id === toast.id);
                        // Update the toast if it already exists
                        if (indexOfExistingToast !== -1) return [
                            ...toasts.slice(0, indexOfExistingToast),
                            {
                                ...toasts[indexOfExistingToast],
                                ...toast
                            },
                            ...toasts.slice(indexOfExistingToast + 1)
                        ];
                        return [
                            toast,
                            ...toasts
                        ];
                    });
                });
            });
        });
    }, []);
    return {
        toasts: activeToasts
    };
}
const Toaster = /*#__PURE__*/ React__default.default.forwardRef(function Toaster(props, ref) {
    const { id, invert, position = 'bottom-right', hotkey = [
        'altKey',
        'KeyT'
    ], expand, closeButton, className, offset, mobileOffset, theme = 'light', richColors, duration, style, visibleToasts = VISIBLE_TOASTS_AMOUNT, toastOptions, dir = getDocumentDirection(), gap = GAP, icons, containerAriaLabel = 'Notifications' } = props;
    const [toasts, setToasts] = React__default.default.useState([]);
    const filteredToasts = React__default.default.useMemo(()=>{
        if (id) return toasts.filter((toast)=>toast.toasterId === id);
        return toasts.filter((toast)=>!toast.toasterId);
    }, [
        toasts,
        id
    ]);
    const possiblePositions = React__default.default.useMemo(()=>{
        return Array.from(new Set([
            position
        ].concat(filteredToasts.filter((toast)=>toast.position).map((toast)=>toast.position))));
    }, [
        filteredToasts,
        position
    ]);
    const [heights, setHeights] = React__default.default.useState([]);
    const [expanded, setExpanded] = React__default.default.useState(false);
    const [interacting, setInteracting] = React__default.default.useState(false);
    const [actualTheme, setActualTheme] = React__default.default.useState(theme !== 'system' ? theme : typeof window !== 'undefined' ? window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light' : 'light');
    const listRef = React__default.default.useRef(null);
    const hotkeyLabel = hotkey.join('+').replace(/Key/g, '').replace(/Digit/g, '');
    const lastFocusedElementRef = React__default.default.useRef(null);
    const isFocusWithinRef = React__default.default.useRef(false);
    const removeToast = React__default.default.useCallback((toastToRemove)=>{
        setToasts((toasts)=>{
            var _toasts_find;
            if (!((_toasts_find = toasts.find((toast)=>toast.id === toastToRemove.id)) == null ? void 0 : _toasts_find.delete)) ToastState.dismiss(toastToRemove.id);
            return toasts.filter(({ id })=>id !== toastToRemove.id);
        });
    }, []);
    React__default.default.useEffect(()=>{
        return ToastState.subscribe((toast)=>{
            if (toast.dismiss) {
                // Prevent batching of other state updates
                requestAnimationFrame(()=>{
                    setToasts((toasts)=>toasts.map((t)=>t.id === toast.id ? {
                                ...t,
                                delete: true
                            } : t));
                });
                return;
            }
            // Prevent batching, temp solution.
            setTimeout(()=>{
                ReactDOM__default.default.flushSync(()=>{
                    setToasts((toasts)=>{
                        const indexOfExistingToast = toasts.findIndex((t)=>t.id === toast.id);
                        // Update the toast if it already exists
                        if (indexOfExistingToast !== -1) return [
                            ...toasts.slice(0, indexOfExistingToast),
                            {
                                ...toasts[indexOfExistingToast],
                                ...toast
                            },
                            ...toasts.slice(indexOfExistingToast + 1)
                        ];
                        return [
                            toast,
                            ...toasts
                        ];
                    });
                });
            });
        });
    }, [
        toasts
    ]);
    React__default.default.useEffect(()=>{
        if (theme !== 'system') {
            setActualTheme(theme);
            return;
        }
        if (theme === 'system') {
            // check if current preference is dark
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) // it's currently dark
            setActualTheme('dark');
            else // it's not dark
            setActualTheme('light');
        }
        if (typeof window === 'undefined') return;
        const darkMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        try {
            // Chrome & Firefox
            darkMediaQuery.addEventListener('change', ({ matches })=>{
                if (matches) setActualTheme('dark');
                else setActualTheme('light');
            });
        } catch (error) {
            // Safari < 14
            darkMediaQuery.addListener(({ matches })=>{
                try {
                    if (matches) setActualTheme('dark');
                    else setActualTheme('light');
                } catch (e) {
                    console.error(e);
                }
            });
        }
    }, [
        theme
    ]);
    React__default.default.useEffect(()=>{
        // Ensure expanded is always false when no toasts are present / only one left
        if (toasts.length <= 1) setExpanded(false);
    }, [
        toasts
    ]);
    React__default.default.useEffect(()=>{
        const handleKeyDown = (event)=>{
            var _listRef_current;
            const isHotkeyPressed = hotkey.every((key)=>event[key] || event.code === key);
            if (isHotkeyPressed) {
                var _listRef_current1;
                setExpanded(true);
                (_listRef_current1 = listRef.current) == null || _listRef_current1.focus();
            }
            if (event.code === 'Escape' && (document.activeElement === listRef.current || ((_listRef_current = listRef.current) == null ? void 0 : _listRef_current.contains(document.activeElement)))) setExpanded(false);
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>document.removeEventListener('keydown', handleKeyDown);
    }, [
        hotkey
    ]);
    React__default.default.useEffect(()=>{
        if (listRef.current) return ()=>{
            if (lastFocusedElementRef.current) {
                lastFocusedElementRef.current.focus({
                    preventScroll: true
                });
                lastFocusedElementRef.current = null;
                isFocusWithinRef.current = false;
            }
        };
    }, [
        listRef.current
    ]);
    return /*#__PURE__*/ React__default.default.createElement("section", {
        ref: ref,
        "aria-label": `${containerAriaLabel} ${hotkeyLabel}`,
        tabIndex: -1,
        "aria-live": "polite",
        "aria-relevant": "additions text",
        "aria-atomic": "false",
        suppressHydrationWarning: true
    }, possiblePositions.map((position, index)=>{
        var _heights_;
        const [y, x] = position.split('-');
        if (!filteredToasts.length) return null;
        return /*#__PURE__*/ React__default.default.createElement("ol", {
            key: position,
            dir: dir === 'auto' ? getDocumentDirection() : dir,
            tabIndex: -1,
            ref: listRef,
            className: className,
            "data-sonner-toaster": true,
            "data-sonner-theme": actualTheme,
            "data-y-position": y,
            "data-x-position": x,
            style: {
                '--front-toast-height': `${((_heights_ = heights[0]) == null ? void 0 : _heights_.height) || 0}px`,
                '--width': `${TOAST_WIDTH}px`,
                '--gap': `${gap}px`,
                ...style,
                ...assignOffset(offset, mobileOffset)
            },
            onBlur: (event)=>{
                if (isFocusWithinRef.current && !event.currentTarget.contains(event.relatedTarget)) {
                    isFocusWithinRef.current = false;
                    if (lastFocusedElementRef.current) {
                        lastFocusedElementRef.current.focus({
                            preventScroll: true
                        });
                        lastFocusedElementRef.current = null;
                    }
                }
            },
            onFocus: (event)=>{
                const isNotDismissible = event.target instanceof HTMLElement && event.target.dataset.dismissible === 'false';
                if (isNotDismissible) return;
                if (!isFocusWithinRef.current) {
                    isFocusWithinRef.current = true;
                    lastFocusedElementRef.current = event.relatedTarget;
                }
            },
            onMouseEnter: ()=>setExpanded(true),
            onMouseMove: ()=>setExpanded(true),
            onMouseLeave: ()=>{
                // Avoid setting expanded to false when interacting with a toast, e.g. swiping
                if (!interacting) setExpanded(false);
            },
            onDragEnd: ()=>setExpanded(false),
            onPointerDown: (event)=>{
                const isNotDismissible = event.target instanceof HTMLElement && event.target.dataset.dismissible === 'false';
                if (isNotDismissible) return;
                setInteracting(true);
            },
            onPointerUp: ()=>setInteracting(false)
        }, filteredToasts.filter((toast)=>!toast.position && index === 0 || toast.position === position).map((toast, index)=>{
            var _toastOptions_duration, _toastOptions_closeButton;
            return /*#__PURE__*/ React__default.default.createElement(Toast, {
                key: toast.id,
                icons: icons,
                index: index,
                toast: toast,
                defaultRichColors: richColors,
                duration: (_toastOptions_duration = toastOptions == null ? void 0 : toastOptions.duration) != null ? _toastOptions_duration : duration,
                className: toastOptions == null ? void 0 : toastOptions.className,
                descriptionClassName: toastOptions == null ? void 0 : toastOptions.descriptionClassName,
                invert: invert,
                visibleToasts: visibleToasts,
                closeButton: (_toastOptions_closeButton = toastOptions == null ? void 0 : toastOptions.closeButton) != null ? _toastOptions_closeButton : closeButton,
                interacting: interacting,
                position: position,
                style: toastOptions == null ? void 0 : toastOptions.style,
                unstyled: toastOptions == null ? void 0 : toastOptions.unstyled,
                classNames: toastOptions == null ? void 0 : toastOptions.classNames,
                cancelButtonStyle: toastOptions == null ? void 0 : toastOptions.cancelButtonStyle,
                actionButtonStyle: toastOptions == null ? void 0 : toastOptions.actionButtonStyle,
                closeButtonAriaLabel: toastOptions == null ? void 0 : toastOptions.closeButtonAriaLabel,
                removeToast: removeToast,
                toasts: filteredToasts.filter((t)=>t.position == toast.position),
                heights: heights.filter((h)=>h.position == toast.position),
                setHeights: setHeights,
                expandByDefault: expand,
                gap: gap,
                expanded: expanded,
                swipeDirections: props.swipeDirections
            });
        }));
    }));
});
exports.Toaster = Toaster;
exports.toast = toast;
exports.useSonner = useSonner;

},{"506d710bd5a66c46":"eGun2","5ae9894746045f30":"bLJc5"}],"hsmL6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotFound", ()=>NotFound);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("@tanstack/react-router");
var _lucideReact = require("lucide-react");
var _layout = require("@/client/layouts/layout");
var _button = require("@/client/components/ui/button");
function NotFound() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col items-center justify-center min-h-[60vh] text-center space-y-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "relative",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-4xl font-bold text-muted-foreground",
                        children: "404"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "space-y-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "text-3xl font-bold tracking-tight",
                            children: "Page Not Found"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-muted-foreground max-w-md",
                            children: "I'm sorry, Dave. I'm afraid I can't do that."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pt-2 flex justify-center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "h-3 w-3 rounded-full bg-red-600 animate-pulse shadow-[0_0_8px_2px_rgba(220,38,38,0.6)]"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                            variant: "outline",
                            onClick: ()=>window.history.back(),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowLeft), {
                                    className: "mr-2 h-4 w-4"
                                }),
                                "Go Back"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            asChild: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                to: "/dashboard",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Home), {
                                        className: "mr-2 h-4 w-4"
                                    }),
                                    "Dashboard"
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","@tanstack/react-router":"7k6Lq","lucide-react":[["ArrowLeft","2k0dn","default"],["Home","9Fq4M","default"]],"@/client/layouts/layout":"d6QdD","@/client/components/ui/button":"armlb","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2k0dn":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ArrowLeft);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
];
const ArrowLeft = (0, _createLucideIconJsDefault.default)("arrow-left", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"exGNd":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createLucideIcon);
var _react = require("react");
var _utilsJs = require("./shared/src/utils.js");
var _iconJs = require("./Icon.js");
var _iconJsDefault = parcelHelpers.interopDefault(_iconJs);
const createLucideIcon = (iconName, iconNode)=>{
    const Component = (0, _react.forwardRef)(({ className, ...props }, ref)=>(0, _react.createElement)((0, _iconJsDefault.default), {
            ref,
            iconNode,
            className: (0, _utilsJs.mergeClasses)(`lucide-${(0, _utilsJs.toKebabCase)((0, _utilsJs.toPascalCase)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, _utilsJs.toPascalCase)(iconName);
    return Component;
};

},{"react":"eGun2","./shared/src/utils.js":"3TDMr","./Icon.js":"3YXZP","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3TDMr":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasA11yProp", ()=>hasA11yProp);
parcelHelpers.export(exports, "mergeClasses", ()=>mergeClasses);
parcelHelpers.export(exports, "toCamelCase", ()=>toCamelCase);
parcelHelpers.export(exports, "toKebabCase", ()=>toKebabCase);
parcelHelpers.export(exports, "toPascalCase", ()=>toPascalCase);
const toKebabCase = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const toCamelCase = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const toPascalCase = (string)=>{
    const camelCase = toCamelCase(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const mergeClasses = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const hasA11yProp = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3YXZP":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
var _react = require("react");
var _defaultAttributesJs = require("./defaultAttributes.js");
var _defaultAttributesJsDefault = parcelHelpers.interopDefault(_defaultAttributesJs);
var _utilsJs = require("./shared/src/utils.js");
const Icon = (0, _react.forwardRef)(({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, className = "", children, iconNode, ...rest }, ref)=>(0, _react.createElement)("svg", {
        ref,
        ...(0, _defaultAttributesJsDefault.default),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, _utilsJs.mergeClasses)("lucide", className),
        ...!children && !(0, _utilsJs.hasA11yProp)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, _react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));

},{"react":"eGun2","./defaultAttributes.js":"ffgdd","./shared/src/utils.js":"3TDMr","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ffgdd":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>defaultAttributes);
var defaultAttributes = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9Fq4M":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>House);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8",
            key: "5wwlr5"
        }
    ],
    [
        "path",
        {
            d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
            key: "r6nss1"
        }
    ]
];
const House = (0, _createLucideIconJsDefault.default)("house", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"d6QdD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layout", ()=>Layout);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _auth0React = require("@auth0/auth0-react");
var _config = require("@/client/config");
var _sidebar = require("@/client/components/ui/sidebar");
var _appSidebar = require("@/client/components/app-sidebar");
var _separator = require("@/client/components/ui/separator");
var _button = require("@/client/components/ui/button");
var _badge = require("@/client/components/ui/badge");
var _dropdownMenu = require("@/client/components/ui/dropdown-menu");
var _lucideReact = require("lucide-react");
var _reactRouter = require("@tanstack/react-router");
var _scaledroneProvider = require("@/client/providers/ScaledroneProvider");
var _useTriageSSE = require("@/client/hooks/useTriageSSE");
var _alertStore = require("@/client/store/alertStore");
var _encoderWSSStore = require("@/client/store/encoderWSSStore");
var _triageIndicator = require("@/client/components/triage-indicator");
var _configSheet = require("@/client/components/config-sheet");
var _flappingToast = require("@/client/components/flapping-toast");
const USER_METADATA_KEY = 'http://invintus_user_metadata';
function Layout({ children }) {
    const { getAccessTokenSilently, user, isAuthenticated, isLoading } = (0, _auth0React.useAuth0)();
    const [dumping, setDumping] = (0, _react.useState)(false);
    const [clearing, setClearing] = (0, _react.useState)(false);
    // Get Scaledrone status from context (managed at root level)
    const { status: wsStatus, subscriptionProgress } = (0, _scaledroneProvider.useScaledroneContext)();
    // Alert store for global triage state
    const { addAlert, updateAlert, removeAlert, setAlerts, addTriageSession, removeTriageSession, setTriageSessions, updateTriageSessionSample, setSseStatus } = (0, _alertStore.useAlertStore)();
    // Encoder WSS store for flapping state
    const { setFlappingFromServer, handleServerFlapping, handleServerFlappingResolved } = (0, _encoderWSSStore.useEncoderWSSStore)();
    // Global SSE connection for triage alerts
    const { status: sseStatus, connect: connectSSE } = (0, _useTriageSSE.useTriageSSE)({
        autoConnect: false,
        onAlert: (alert1)=>{
            addAlert(alert1);
        },
        onAlertUpdate: ({ encoderId, alertType, lastAnomalyAt, currentValue })=>{
            updateAlert(encoderId, alertType, lastAnomalyAt, currentValue);
        },
        onAlertResolved: ({ encoderId, alertType })=>{
            removeAlert(encoderId, alertType);
        },
        onTriageStarted: (data)=>{
            addTriageSession(data.session);
        },
        onTriageEnded: (data)=>{
            removeTriageSession(data.encoderId);
        },
        onFlapping: (alert1)=>{
            // Only show toast if client-side hasn't already detected this
            const existing = (0, _encoderWSSStore.useEncoderWSSStore).getState().encoders.get(alert1.encoderId);
            if (!existing || existing.state !== alert1.severity) (0, _flappingToast.showFlappingToast)({
                encoderId: alert1.encoderId,
                simpleName: alert1.simpleName,
                cycles: alert1.cycles,
                severity: alert1.severity,
                isLiveStreamDisconnect: alert1.isLiveStreamDisconnect
            });
            handleServerFlapping(alert1);
        },
        onFlappingResolved: (resolved)=>{
            handleServerFlappingResolved(resolved);
        },
        onEvent: (event)=>{
            // Handle encoder:update for live sample data
            if (event.type === 'encoder:update') {
                const { encoderId, sample } = event.data;
                if (sample) updateTriageSessionSample(encoderId, sample);
            }
        }
    });
    // Update store SSE status
    (0, _react.useEffect)(()=>{
        setSseStatus(sseStatus);
    }, [
        sseStatus,
        setSseStatus
    ]);
    // Connect SSE and fetch initial triage sessions + alerts + flapping when authenticated
    (0, _react.useEffect)(()=>{
        if (isLoading || !isAuthenticated) return;
        let mounted = true;
        const init = async ()=>{
            try {
                const token = await getAccessTokenSilently();
                // Fetch initial triage sessions, active alerts, and flapping state in parallel
                const [triageResponse, alertsResponse, flappingResponse] = await Promise.all([
                    fetch(`${(0, _config.API_BASE_URL)}/api/encoders/triage`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }),
                    fetch(`${(0, _config.API_BASE_URL)}/api/encoders/alerts`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }),
                    fetch(`${(0, _config.API_BASE_URL)}/api/encoders/flapping`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                ]);
                if (!mounted) return;
                if (triageResponse.ok) {
                    const data = await triageResponse.json();
                    setTriageSessions(data.sessions || []);
                }
                if (alertsResponse.ok) {
                    const data = await alertsResponse.json();
                    setAlerts(data.alerts || []);
                }
                if (flappingResponse.ok) {
                    const data = await flappingResponse.json();
                    setFlappingFromServer(data.active || []);
                }
                // Connect SSE for real-time updates
                connectSSE();
            } catch (err) {
                console.error('[Layout] Error initializing triage:', err);
            }
        };
        init();
        return ()=>{
            mounted = false;
        };
    // Note: connectSSE now has stable identity (uses refs for callbacks)
    }, [
        isLoading,
        isAuthenticated,
        getAccessTokenSilently,
        setTriageSessions,
        setAlerts,
        setFlappingFromServer,
        connectSSE
    ]);
    const handleClearCache = async ()=>{
        setClearing(true);
        try {
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/cache/clear`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({})
            });
            const data = await response.json();
            if (data.success) alert(data.message);
            else alert(`Failed to clear cache: ${data.message}`);
        } catch (err) {
            console.error('Error clearing cache:', err);
            alert('Failed to clear cache');
        } finally{
            setClearing(false);
        }
    };
    const handleDumpCache = async ()=>{
        setDumping(true);
        try {
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/cache/dump`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({})
            });
            const data = await response.json();
            if (data.success) alert(`Cache dumped to: ${data.filepath}`);
            else alert(`Failed to dump cache: ${data.message}`);
        } catch (err) {
            console.error('Error dumping cache:', err);
            alert('Failed to dump cache');
        } finally{
            setDumping(false);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sidebar.SidebarProvider), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appSidebar.AppSidebar), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sidebar.SidebarInset), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                        className: "flex h-16 shrink-0 items-center gap-2 border-b px-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarTrigger), {
                                className: "-ml-1"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _separator.Separator), {
                                orientation: "vertical",
                                className: "mr-2 h-4"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                variant: wsStatus === 'connected' ? 'default' : 'destructive',
                                className: `dark:text-white font-mono font-normal ${wsStatus === 'connected' ? 'bg-green-600 hover:bg-green-700' : wsStatus === 'connecting' ? 'bg-yellow-600 hover:bg-yellow-700' : 'bg-red-600 hover:bg-red-700'}`,
                                children: subscriptionProgress ? `Rooms: ${subscriptionProgress.subscribed}/${subscriptionProgress.total}` : `WSS`
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _triageIndicator.TriageIndicator), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "ml-auto flex items-center gap-2",
                                children: [
                                    false,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _configSheet.ConfigSheet), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _separator.Separator), {
                                        orientation: "vertical",
                                        className: "mx-2 h-4"
                                    }),
                                    user?.email && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                        to: "/profile",
                                        className: "text-sm text-muted-foreground hover:text-foreground transition-colors",
                                        children: user.email
                                    }),
                                    user?.[USER_METADATA_KEY]?.loginID && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _separator.Separator), {
                                                orientation: "vertical",
                                                className: "mx-2 h-4"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "text-sm text-muted-foreground font-mono",
                                                children: [
                                                    "UserID: ",
                                                    (user?.[USER_METADATA_KEY]).loginID
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowLeftRight), {
                                                className: "h-3 w-3 text-muted-foreground mx-1"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                                to: "/utilities/swap-user-client",
                                                className: "text-sm text-muted-foreground font-mono hover:text-foreground transition-colors",
                                                children: (user?.[USER_METADATA_KEY]).clientID
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex flex-1 flex-col gap-4 p-4 min-w-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex-1 rounded-lg border bg-card p-4 min-w-0 overflow-hidden",
                            children: children
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@auth0/auth0-react":"gpXrE","@/client/config":"8SWgh","@/client/components/ui/sidebar":"cIzmc","@/client/components/app-sidebar":"NohDB","@/client/components/ui/separator":"3WCKI","@/client/components/ui/button":"armlb","@/client/components/ui/badge":"h4e1f","@/client/components/ui/dropdown-menu":"8ox96","lucide-react":[["ArrowLeftRight","g6U9n","default"]],"@tanstack/react-router":"7k6Lq","@/client/providers/ScaledroneProvider":"c053W","@/client/hooks/useTriageSSE":"euLDl","@/client/store/alertStore":"fS0sT","@/client/store/encoderWSSStore":"jpzNm","@/client/components/triage-indicator":"1gsE4","@/client/components/config-sheet":"dzS8l","@/client/components/flapping-toast":"9xDtD","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8SWgh":[function(require,module,exports,__globalThis) {
// App version from package.json (single source of truth)
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "APP_VERSION", ()=>APP_VERSION);
parcelHelpers.export(exports, "API_BASE_URL", ()=>API_BASE_URL);
parcelHelpers.export(exports, "PLAYER_BASE_URL", ()=>PLAYER_BASE_URL);
parcelHelpers.export(exports, "CC_BASE_URL", ()=>CC_BASE_URL);
parcelHelpers.export(exports, "SCALEDRONE_CHANNEL_ID", ()=>SCALEDRONE_CHANNEL_ID);
parcelHelpers.export(exports, "SCALEDRONE_TEST_CLIENT_ID", ()=>SCALEDRONE_TEST_CLIENT_ID);
parcelHelpers.export(exports, "SCALEDRONE_TEST_MODE_MAX_CLIENTS", ()=>SCALEDRONE_TEST_MODE_MAX_CLIENTS);
var _packageJson = require("../../package.json");
var _packageJsonDefault = parcelHelpers.interopDefault(_packageJson);
const APP_VERSION = (0, _packageJsonDefault.default).version;
const API_BASE_URL = "" ?? 'http://127.0.0.1:3000';
const PLAYER_BASE_URL = 'https://player.invintus.com';
const CC_BASE_URL = 'https://controlcenter.invintusmedia.com';
const SCALEDRONE_CHANNEL_ID = "rFYOtL5b7Wqeu7Y2";
const SCALEDRONE_TEST_CLIENT_ID = '';
const SCALEDRONE_TEST_MODE_MAX_CLIENTS = parseInt('0', 10);

},{"../../package.json":"1BI63","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1BI63":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"name\":\"admin-portal\",\"version\":\"1.31.1\",\"description\":\"Admin Portal for Invintus Media\",\"type\":\"module\",\"packageManager\":\"pnpm@10.33.0\",\"alias\":{\"@shared/*\":\"./src/shared/$1\",\"@server/*\":\"./src/server/$1\",\"seroval-plugins/web\":\"./node_modules/seroval-plugins/dist/esm/production/web.mjs\"},\"scripts\":{\"postinstall\":\"prisma generate\",\"prisma:generate\":\"prisma generate\",\"clean\":\"rm -rf .parcel-cache dist\",\"clean:logs\":\"find logs -type f -name '*.log' -exec truncate -s 0 {} +\",\"dev:server\":\"pnpm run clean:logs && tsx watch src/server/index.ts\",\"dev:client\":\"parcel src/client/index.html --port 5173\",\"dev\":\"concurrently \\\"pnpm:dev:server\\\" \\\"pnpm:dev:client\\\"\",\"build:server\":\"pnpm run prisma:generate && tsc --project tsconfig.server.json && tsc-alias -p tsconfig.server.json --resolve-full-paths\",\"build:client\":\"parcel build src/client/index.html --dist-dir dist/client --public-url / --no-scope-hoist\",\"build\":\"pnpm run build:server && pnpm run build:client\",\"start\":\"tsx src/server/index.ts\",\"test\":\"pnpm run test:server\",\"test:server\":\"node --import tsx --import ./src/server/__tests__/setup.ts --experimental-test-module-mocks --test src/server/__tests__/**/*.test.ts\",\"docker:setup\":\"bash docker/generate-certs.sh\",\"db:select\":\"node scripts/select-db.mjs\",\"docker:dev\":\"pnpm run db:select && docker-compose -f docker-compose.yml -f docker-compose.dev.yml --env-file .env.development up --build\",\"docker:dev:down\":\"docker-compose -f docker-compose.yml -f docker-compose.dev.yml --env-file .env.development down\",\"docker:dev:restart\":\"docker-compose -f docker-compose.yml -f docker-compose.dev.yml --env-file .env.development down && docker-compose -f docker-compose.yml -f docker-compose.dev.yml --env-file .env.development up -d\",\"docker:dev:rebuild\":\"pnpm run db:select && docker-compose -f docker-compose.yml -f docker-compose.dev.yml --env-file .env.development down -v && pnpm run clean && docker-compose -f docker-compose.yml -f docker-compose.dev.yml --env-file .env.development build --no-cache && docker-compose -f docker-compose.yml -f docker-compose.dev.yml --env-file .env.development up\",\"docker:prod\":\"docker-compose -f docker-compose.yml -f docker-compose.prod.yml --env-file .env.production up --build\",\"docker:prod:down\":\"docker-compose -f docker-compose.yml -f docker-compose.prod.yml --env-file .env.production down\",\"docker:prod:detach\":\"docker-compose -f docker-compose.yml -f docker-compose.prod.yml --env-file .env.production up --build -d\",\"docker:clean:modules\":\"docker volume rm admin-portal_node_modules\",\"docker:exec\":\"docker exec -it admin-portal sh\"},\"dependencies\":{\"@auth0/auth0-fastify-api\":\"^1.0.0\",\"@auth0/auth0-react\":\"^2.8.0\",\"@aws-sdk/client-cloudwatch\":\"^3.949.0\",\"@aws-sdk/client-ec2\":\"^3.948.0\",\"@aws-sdk/client-rds\":\"^3.948.0\",\"@date-fns/tz\":\"^1.4.1\",\"@fastify/cors\":\"^10.0.1\",\"@fastify/helmet\":\"^13.0.2\",\"@fastify/static\":\"^8.3.0\",\"@prisma/adapter-mariadb\":\"^7.0.0\",\"@prisma/client\":\"^7.0.0\",\"@radix-ui/react-checkbox\":\"^1.3.3\",\"@radix-ui/react-collapsible\":\"^1.1.12\",\"@radix-ui/react-dialog\":\"^1.1.15\",\"@radix-ui/react-dropdown-menu\":\"^2.1.16\",\"@radix-ui/react-label\":\"^2.1.8\",\"@radix-ui/react-popover\":\"^1.1.15\",\"@radix-ui/react-progress\":\"^1.1.8\",\"@radix-ui/react-select\":\"^2.2.6\",\"@radix-ui/react-separator\":\"^1.1.8\",\"@radix-ui/react-slot\":\"^1.2.4\",\"@radix-ui/react-switch\":\"^1.2.6\",\"@radix-ui/react-tabs\":\"^1.1.13\",\"@radix-ui/react-toggle\":\"^1.1.10\",\"@radix-ui/react-tooltip\":\"^1.2.8\",\"@redux-devtools/extension\":\"^3.3.0\",\"@tanstack/react-router\":\"^1.134.12\",\"@tanstack/react-table\":\"^8.21.3\",\"better-sqlite3\":\"^12.5.0\",\"class-variance-authority\":\"^0.7.1\",\"clsx\":\"^2.1.1\",\"cmdk\":\"^1.1.1\",\"date-fns\":\"^4.1.0\",\"dotenv\":\"^17.2.3\",\"fastify\":\"^5.1.0\",\"lucide-react\":\"^0.554.0\",\"markdown-to-jsx\":\"^9.1.1\",\"next-themes\":\"^0.4.6\",\"pino\":\"^10.1.0\",\"pino-pretty\":\"^13.1.2\",\"react\":\"^19.2.0\",\"react-day-picker\":\"^9.11.2\",\"react-dom\":\"^19.2.0\",\"recharts\":\"2.15.4\",\"rotating-file-stream\":\"^3.2.7\",\"scaledrone-node\":\"^1.5.0\",\"sonner\":\"^2.0.7\",\"tailwind-merge\":\"^3.4.0\",\"tsx\":\"^4.19.2\",\"yazl\":\"^3.3.1\",\"zod\":\"^4.3.4\",\"zustand\":\"^5.0.8\"},\"pnpm\":{\"onlyBuiltDependencies\":[\"better-sqlite3\"]},\"devDependencies\":{\"@inquirer/prompts\":\"^8.2.0\",\"@parcel/config-default\":\"^2.16.1\",\"@parcel/transformer-inline-string\":\"^2.16.1\",\"@tailwindcss/typography\":\"^0.5.19\",\"@tanstack/react-router-devtools\":\"^1.134.12\",\"@types/better-sqlite3\":\"^7.6.13\",\"@types/node\":\"^22.9.3\",\"@types/react\":\"^19.2.2\",\"@types/react-dom\":\"^19.2.2\",\"@types/yazl\":\"^3.3.1\",\"autoprefixer\":\"^10.4.22\",\"concurrently\":\"^9.2.1\",\"parcel\":\"^2.16.0\",\"postcss\":\"^8.5.6\",\"prisma\":\"^7.0.0\",\"seroval-plugins\":\"^1.4.0\",\"tailwindcss\":\"^3.4.18\",\"tsc-alias\":\"^1.8.16\",\"typescript\":\"^5.7.2\"}}");

},{}],"cIzmc":[function(require,module,exports,__globalThis) {
/**
 * Sidebar Component (shadcn/ui)
 *
 * A comprehensive sidebar component system with responsive behavior,
 * collapsible states, and nested menu support.
 *
 * ## Component Hierarchy
 *
 * SidebarProvider (context + tooltip provider)
 * └── Sidebar (main container, handles mobile/desktop rendering)
 *     ├── SidebarHeader
 *     ├── SidebarContent (scrollable area)
 *     │   └── SidebarGroup (section container)
 *     │       ├── SidebarGroupLabel
 *     │       ├── SidebarGroupAction
 *     │       └── SidebarGroupContent
 *     │           └── SidebarMenu (top-level menu)
 *     │               └── SidebarMenuItem
 *     │                   ├── SidebarMenuButton (clickable item)
 *     │                   ├── SidebarMenuAction (hover action)
 *     │                   ├── SidebarMenuBadge
 *     │                   └── SidebarMenuSub (nested submenu)
 *     │                       └── SidebarMenuSubItem
 *     │                           └── SidebarMenuSubButton
 *     ├── SidebarFooter
 *     ├── SidebarRail (resize handle)
 *     └── SidebarSeparator
 *
 * ## Usage Example
 *
 * ```tsx
 * <SidebarProvider>
 *   <Sidebar>
 *     <SidebarHeader>Logo</SidebarHeader>
 *     <SidebarContent>
 *       <SidebarGroup>
 *         <SidebarGroupLabel>Navigation</SidebarGroupLabel>
 *         <SidebarGroupContent>
 *           <SidebarMenu>
 *             <SidebarMenuItem>
 *               <SidebarMenuButton asChild>
 *                 <Link to="/dashboard">Dashboard</Link>
 *               </SidebarMenuButton>
 *             </SidebarMenuItem>
 *           </SidebarMenu>
 *         </SidebarGroupContent>
 *       </SidebarGroup>
 *     </SidebarContent>
 *     <SidebarFooter>User info</SidebarFooter>
 *   </Sidebar>
 *   <SidebarInset>Main content</SidebarInset>
 * </SidebarProvider>
 * ```
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// =============================================================================
// EXPORTS
// =============================================================================
parcelHelpers.export(exports, "Sidebar", ()=>Sidebar);
parcelHelpers.export(exports, "SidebarContent", ()=>SidebarContent);
parcelHelpers.export(exports, "SidebarFooter", ()=>SidebarFooter);
parcelHelpers.export(exports, "SidebarGroup", ()=>SidebarGroup);
parcelHelpers.export(exports, "SidebarGroupAction", ()=>SidebarGroupAction);
parcelHelpers.export(exports, "SidebarGroupContent", ()=>SidebarGroupContent);
parcelHelpers.export(exports, "SidebarGroupLabel", ()=>SidebarGroupLabel);
parcelHelpers.export(exports, "SidebarHeader", ()=>SidebarHeader);
parcelHelpers.export(exports, "SidebarInput", ()=>SidebarInput);
parcelHelpers.export(exports, "SidebarInset", ()=>SidebarInset);
parcelHelpers.export(exports, "SidebarMenu", ()=>SidebarMenu);
parcelHelpers.export(exports, "SidebarMenuAction", ()=>SidebarMenuAction);
parcelHelpers.export(exports, "SidebarMenuBadge", ()=>SidebarMenuBadge);
parcelHelpers.export(exports, "SidebarMenuButton", ()=>SidebarMenuButton);
parcelHelpers.export(exports, "SidebarMenuItem", ()=>SidebarMenuItem);
parcelHelpers.export(exports, "SidebarMenuSkeleton", ()=>SidebarMenuSkeleton);
parcelHelpers.export(exports, "SidebarMenuSub", ()=>SidebarMenuSub);
parcelHelpers.export(exports, "SidebarMenuSubButton", ()=>SidebarMenuSubButton);
parcelHelpers.export(exports, "SidebarMenuSubItem", ()=>SidebarMenuSubItem);
parcelHelpers.export(exports, "SidebarProvider", ()=>SidebarProvider);
parcelHelpers.export(exports, "SidebarRail", ()=>SidebarRail);
parcelHelpers.export(exports, "SidebarSeparator", ()=>SidebarSeparator);
parcelHelpers.export(exports, "SidebarTrigger", ()=>SidebarTrigger);
parcelHelpers.export(exports, "useSidebar", ()=>useSidebar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactSlot = require("@radix-ui/react-slot");
var _classVarianceAuthority = require("class-variance-authority");
var _lucideReact = require("lucide-react");
var _useMobile = require("@/client/hooks/use-mobile");
var _utils = require("@/client/lib/utils");
var _button = require("@/client/components/ui/button");
var _input = require("@/client/components/ui/input");
var _separator = require("@/client/components/ui/separator");
var _sheet = require("@/client/components/ui/sheet");
var _skeleton = require("@/client/components/ui/skeleton");
var _tooltip = require("@/client/components/ui/tooltip");
// =============================================================================
// CONSTANTS
// =============================================================================
const SIDEBAR_COOKIE_NAME = "sidebar_state";
const SIDEBAR_COOKIE_MAX_AGE = 604800;
const SIDEBAR_WIDTH = "16rem";
const SIDEBAR_WIDTH_MOBILE = "18rem";
const SIDEBAR_WIDTH_ICON = "3rem";
const SidebarContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Hook to access sidebar state and controls.
 * Must be used within a SidebarProvider.
 */ function useSidebar() {
    const context = _react.useContext(SidebarContext);
    if (!context) throw new Error("useSidebar must be used within a SidebarProvider.");
    return context;
}
// =============================================================================
// PROVIDER
// =============================================================================
/**
 * Provides sidebar context and wraps children with TooltipProvider.
 * Manages open/collapsed state and persists to cookie.
 */ const SidebarProvider = /*#__PURE__*/ _react.forwardRef(({ defaultOpen = true, open: openProp, onOpenChange: setOpenProp, className, style, children, ...props }, ref)=>{
    const isMobile = (0, _useMobile.useIsMobile)();
    const [openMobile, setOpenMobile] = _react.useState(false);
    // This is the internal state of the sidebar.
    // We use openProp and setOpenProp for control from outside the component.
    const [_open, _setOpen] = _react.useState(defaultOpen);
    const open = openProp ?? _open;
    const setOpen = _react.useCallback((value)=>{
        const openState = typeof value === "function" ? value(open) : value;
        if (setOpenProp) setOpenProp(openState);
        else _setOpen(openState);
        // This sets the cookie to keep the sidebar state.
        document.cookie = `${SIDEBAR_COOKIE_NAME}=${openState}; path=/; max-age=${SIDEBAR_COOKIE_MAX_AGE}`;
    }, [
        setOpenProp,
        open
    ]);
    // Helper to toggle the sidebar.
    const toggleSidebar = _react.useCallback(()=>{
        return isMobile ? setOpenMobile((open)=>!open) : setOpen((open)=>!open);
    }, [
        isMobile,
        setOpen,
        setOpenMobile
    ]);
    // We add a state so that we can do data-state="expanded" or "collapsed".
    // This makes it easier to style the sidebar with Tailwind classes.
    const state = open ? "expanded" : "collapsed";
    const contextValue = _react.useMemo(()=>({
            state,
            open,
            setOpen,
            isMobile,
            openMobile,
            setOpenMobile,
            toggleSidebar
        }), [
        state,
        open,
        setOpen,
        isMobile,
        openMobile,
        setOpenMobile,
        toggleSidebar
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipProvider), {
            delayDuration: 0,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    "--sidebar-width": SIDEBAR_WIDTH,
                    "--sidebar-width-icon": SIDEBAR_WIDTH_ICON,
                    ...style
                },
                className: (0, _utils.cn)("group/sidebar-wrapper flex min-h-svh w-full has-[[data-variant=inset]]:bg-sidebar", className),
                ref: ref,
                ...props,
                children: children
            })
        })
    });
});
SidebarProvider.displayName = "SidebarProvider";
// =============================================================================
// MAIN SIDEBAR CONTAINER
// =============================================================================
/**
 * Main sidebar container. Renders as a Sheet on mobile, fixed sidebar on desktop.
 *
 * @param side - "left" or "right" positioning
 * @param variant - "sidebar" (default), "floating", or "inset"
 * @param collapsible - "offcanvas" (slides out), "icon" (collapses to icons), or "none"
 */ const Sidebar = /*#__PURE__*/ _react.forwardRef(({ side = "left", variant = "sidebar", collapsible = "offcanvas", className, children, ...props }, ref)=>{
    const { isMobile, state, openMobile, setOpenMobile } = useSidebar();
    if (collapsible === "none") return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _utils.cn)("flex h-full w-[--sidebar-width] flex-col bg-sidebar text-sidebar-foreground", className),
        ref: ref,
        ...props,
        children: children
    });
    if (isMobile) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sheet.Sheet), {
        open: openMobile,
        onOpenChange: setOpenMobile,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sheet.SheetContent), {
            "data-sidebar": "sidebar",
            "data-mobile": "true",
            className: "w-[--sidebar-width] bg-sidebar p-0 text-sidebar-foreground [&>button]:hidden",
            style: {
                "--sidebar-width": SIDEBAR_WIDTH_MOBILE
            },
            side: side,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sheet.SheetHeader), {
                    className: "sr-only",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sheet.SheetTitle), {
                            children: "Sidebar"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sheet.SheetDescription), {
                            children: "Displays the mobile sidebar."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex h-full w-full flex-col",
                    children: children
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        className: "group peer hidden text-sidebar-foreground md:block",
        "data-state": state,
        "data-collapsible": state === "collapsed" ? collapsible : "",
        "data-variant": variant,
        "data-side": side,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _utils.cn)("relative w-[--sidebar-width] bg-transparent transition-[width] duration-200 ease-linear", "group-data-[collapsible=offcanvas]:w-0", "group-data-[side=right]:rotate-180", variant === "floating" || variant === "inset" ? "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.4))]" : "group-data-[collapsible=icon]:w-[--sidebar-width-icon]")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _utils.cn)("fixed inset-y-0 z-10 hidden h-svh w-[--sidebar-width] transition-[left,right,width] duration-200 ease-linear md:flex", side === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]", // Adjust the padding for floating and inset variants.
                variant === "floating" || variant === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.4)_+2px)]" : "group-data-[collapsible=icon]:w-[--sidebar-width-icon] group-data-[side=left]:border-r group-data-[side=right]:border-l", className),
                ...props,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    "data-sidebar": "sidebar",
                    className: "flex h-full w-full flex-col bg-sidebar group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:border-sidebar-border group-data-[variant=floating]:shadow",
                    children: children
                })
            })
        ]
    });
});
Sidebar.displayName = "Sidebar";
// =============================================================================
// SIDEBAR CONTROLS
// =============================================================================
/** Button to toggle sidebar open/closed state */ const SidebarTrigger = /*#__PURE__*/ _react.forwardRef(({ className, onClick, ...props }, ref)=>{
    const { toggleSidebar } = useSidebar();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
        ref: ref,
        "data-sidebar": "trigger",
        variant: "ghost",
        size: "icon",
        className: (0, _utils.cn)("h-7 w-7", className),
        onClick: (event)=>{
            onClick?.(event);
            toggleSidebar();
        },
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.PanelLeft), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "sr-only",
                children: "Toggle Sidebar"
            })
        ]
    });
});
SidebarTrigger.displayName = "SidebarTrigger";
/** Draggable rail on sidebar edge for resizing/toggling */ const SidebarRail = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>{
    const { toggleSidebar } = useSidebar();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        ref: ref,
        "data-sidebar": "rail",
        "aria-label": "Toggle Sidebar",
        tabIndex: -1,
        onClick: toggleSidebar,
        title: "Toggle Sidebar",
        className: (0, _utils.cn)("absolute inset-y-0 z-20 hidden w-4 -translate-x-1/2 transition-all ease-linear after:absolute after:inset-y-0 after:left-1/2 after:w-[2px] hover:after:bg-sidebar-border group-data-[side=left]:-right-4 group-data-[side=right]:left-0 sm:flex", "[[data-side=left]_&]:cursor-w-resize [[data-side=right]_&]:cursor-e-resize", "[[data-side=left][data-state=collapsed]_&]:cursor-e-resize [[data-side=right][data-state=collapsed]_&]:cursor-w-resize", "group-data-[collapsible=offcanvas]:translate-x-0 group-data-[collapsible=offcanvas]:after:left-full group-data-[collapsible=offcanvas]:hover:bg-sidebar", "[[data-side=left][data-collapsible=offcanvas]_&]:-right-2", "[[data-side=right][data-collapsible=offcanvas]_&]:-left-2", className),
        ...props
    });
});
SidebarRail.displayName = "SidebarRail";
// =============================================================================
// LAYOUT COMPONENTS
// =============================================================================
/** Main content area that sits alongside the sidebar */ const SidebarInset = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("main", {
        ref: ref,
        className: (0, _utils.cn)("relative flex w-full flex-1 flex-col bg-background min-w-0", "md:peer-data-[variant=inset]:m-2 md:peer-data-[state=collapsed]:peer-data-[variant=inset]:ml-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow", className),
        ...props
    });
});
SidebarInset.displayName = "SidebarInset";
/** Search input styled for sidebar */ const SidebarInput = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
        ref: ref,
        "data-sidebar": "input",
        className: (0, _utils.cn)("h-8 w-full bg-background shadow-none focus-visible:ring-2 focus-visible:ring-sidebar-ring", className),
        ...props
    });
});
SidebarInput.displayName = "SidebarInput";
/** Top section of sidebar (logo, branding) */ const SidebarHeader = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        "data-sidebar": "header",
        className: (0, _utils.cn)("flex flex-col gap-2 p-2", className),
        ...props
    });
});
SidebarHeader.displayName = "SidebarHeader";
/** Bottom section of sidebar (user info, settings) */ const SidebarFooter = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        "data-sidebar": "footer",
        className: (0, _utils.cn)("flex flex-col gap-2 p-2", className),
        ...props
    });
});
SidebarFooter.displayName = "SidebarFooter";
/** Horizontal divider for sidebar */ const SidebarSeparator = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _separator.Separator), {
        ref: ref,
        "data-sidebar": "separator",
        className: (0, _utils.cn)("mx-2 w-auto bg-sidebar-border", className),
        ...props
    });
});
SidebarSeparator.displayName = "SidebarSeparator";
/** Scrollable content area of sidebar */ const SidebarContent = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        "data-sidebar": "content",
        className: (0, _utils.cn)("flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden", className),
        ...props
    });
});
SidebarContent.displayName = "SidebarContent";
// =============================================================================
// GROUP COMPONENTS (for organizing menu sections)
// =============================================================================
/** Container for a group of related menu items */ const SidebarGroup = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        "data-sidebar": "group",
        className: (0, _utils.cn)("relative flex w-full min-w-0 flex-col p-2", className),
        ...props
    });
});
SidebarGroup.displayName = "SidebarGroup";
/** Label/title for a sidebar group */ const SidebarGroupLabel = /*#__PURE__*/ _react.forwardRef(({ className, asChild = false, ...props }, ref)=>{
    const Comp = asChild ? (0, _reactSlot.Slot) : "div";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Comp, {
        ref: ref,
        "data-sidebar": "group-label",
        className: (0, _utils.cn)("flex h-8 shrink-0 items-center rounded-md px-2 text-xs font-medium text-sidebar-foreground/70 outline-none ring-sidebar-ring transition-[margin,opacity] duration-200 ease-linear focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0", "group-data-[collapsible=icon]:-mt-8 group-data-[collapsible=icon]:opacity-0", className),
        ...props
    });
});
SidebarGroupLabel.displayName = "SidebarGroupLabel";
/** Action button positioned in group header */ const SidebarGroupAction = /*#__PURE__*/ _react.forwardRef(({ className, asChild = false, ...props }, ref)=>{
    const Comp = asChild ? (0, _reactSlot.Slot) : "button";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Comp, {
        ref: ref,
        "data-sidebar": "group-action",
        className: (0, _utils.cn)("absolute right-3 top-3.5 flex aspect-square w-5 items-center justify-center rounded-md p-0 text-sidebar-foreground outline-none ring-sidebar-ring transition-transform hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0", // Increases the hit area of the button on mobile.
        "after:absolute after:-inset-2 after:md:hidden", "group-data-[collapsible=icon]:hidden", className),
        ...props
    });
});
SidebarGroupAction.displayName = "SidebarGroupAction";
/** Wrapper for menu content within a group */ const SidebarGroupContent = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        "data-sidebar": "group-content",
        className: (0, _utils.cn)("w-full text-sm", className),
        ...props
    }));
SidebarGroupContent.displayName = "SidebarGroupContent";
// =============================================================================
// MENU COMPONENTS (top-level navigation)
// =============================================================================
/** Top-level menu list */ const SidebarMenu = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
        ref: ref,
        "data-sidebar": "menu",
        className: (0, _utils.cn)("flex w-full min-w-0 flex-col gap-1", className),
        ...props
    }));
SidebarMenu.displayName = "SidebarMenu";
/** Individual menu item container */ const SidebarMenuItem = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        ref: ref,
        "data-sidebar": "menu-item",
        className: (0, _utils.cn)("group/menu-item relative", className),
        ...props
    }));
SidebarMenuItem.displayName = "SidebarMenuItem";
const sidebarMenuButtonVariants = (0, _classVarianceAuthority.cva)("peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm outline-none ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 group-has-[[data-sidebar=menu-action]]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:!size-8 group-data-[collapsible=icon]:!p-2 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0", {
    variants: {
        variant: {
            default: "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
            outline: "bg-background shadow-[0_0_0_1px_hsl(var(--sidebar-border))] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:shadow-[0_0_0_1px_hsl(var(--sidebar-accent))]"
        },
        size: {
            default: "h-8 text-sm",
            sm: "h-7 text-xs",
            lg: "h-12 text-sm group-data-[collapsible=icon]:!p-0"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
/**
 * Clickable menu item button. Supports tooltip for collapsed state.
 *
 * @param asChild - Render as child element (for Link components)
 * @param isActive - Highlight as currently active route
 * @param tooltip - Tooltip text shown when sidebar is collapsed
 */ const SidebarMenuButton = /*#__PURE__*/ _react.forwardRef(({ asChild = false, isActive = false, variant = "default", size = "default", tooltip, className, ...props }, ref)=>{
    const Comp = asChild ? (0, _reactSlot.Slot) : "button";
    const { isMobile, state } = useSidebar();
    const button = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Comp, {
        ref: ref,
        "data-sidebar": "menu-button",
        "data-size": size,
        "data-active": isActive,
        className: (0, _utils.cn)(sidebarMenuButtonVariants({
            variant,
            size
        }), className),
        ...props
    });
    if (!tooltip) return button;
    if (typeof tooltip === "string") tooltip = {
        children: tooltip
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltip.Tooltip), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipTrigger), {
                asChild: true,
                children: button
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipContent), {
                side: "right",
                align: "center",
                hidden: state !== "collapsed" || isMobile,
                ...tooltip
            })
        ]
    });
});
SidebarMenuButton.displayName = "SidebarMenuButton";
/** Action button that appears on menu item hover */ const SidebarMenuAction = /*#__PURE__*/ _react.forwardRef(({ className, asChild = false, showOnHover = false, ...props }, ref)=>{
    const Comp = asChild ? (0, _reactSlot.Slot) : "button";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Comp, {
        ref: ref,
        "data-sidebar": "menu-action",
        className: (0, _utils.cn)("absolute right-1 top-1.5 flex aspect-square w-5 items-center justify-center rounded-md p-0 text-sidebar-foreground outline-none ring-sidebar-ring transition-transform hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 peer-hover/menu-button:text-sidebar-accent-foreground [&>svg]:size-4 [&>svg]:shrink-0", // Increases the hit area of the button on mobile.
        "after:absolute after:-inset-2 after:md:hidden", "peer-data-[size=sm]/menu-button:top-1", "peer-data-[size=default]/menu-button:top-1.5", "peer-data-[size=lg]/menu-button:top-2.5", "group-data-[collapsible=icon]:hidden", showOnHover && "group-focus-within/menu-item:opacity-100 group-hover/menu-item:opacity-100 data-[state=open]:opacity-100 peer-data-[active=true]/menu-button:text-sidebar-accent-foreground md:opacity-0", className),
        ...props
    });
});
SidebarMenuAction.displayName = "SidebarMenuAction";
/** Badge/counter displayed on menu item */ const SidebarMenuBadge = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        "data-sidebar": "menu-badge",
        className: (0, _utils.cn)("pointer-events-none absolute right-1 flex h-5 min-w-5 select-none items-center justify-center rounded-md px-1 text-xs font-medium tabular-nums text-sidebar-foreground", "peer-hover/menu-button:text-sidebar-accent-foreground peer-data-[active=true]/menu-button:text-sidebar-accent-foreground", "peer-data-[size=sm]/menu-button:top-1", "peer-data-[size=default]/menu-button:top-1.5", "peer-data-[size=lg]/menu-button:top-2.5", "group-data-[collapsible=icon]:hidden", className),
        ...props
    }));
SidebarMenuBadge.displayName = "SidebarMenuBadge";
/** Loading skeleton for menu items */ const SidebarMenuSkeleton = /*#__PURE__*/ _react.forwardRef(({ className, showIcon = false, ...props }, ref)=>{
    // Random width between 50 to 90%.
    const width = _react.useMemo(()=>{
        return `${Math.floor(Math.random() * 40) + 50}%`;
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        "data-sidebar": "menu-skeleton",
        className: (0, _utils.cn)("flex h-8 items-center gap-2 rounded-md px-2", className),
        ...props,
        children: [
            showIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.Skeleton), {
                className: "size-4 rounded-md",
                "data-sidebar": "menu-skeleton-icon"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.Skeleton), {
                className: "h-4 max-w-[--skeleton-width] flex-1",
                "data-sidebar": "menu-skeleton-text",
                style: {
                    "--skeleton-width": width
                }
            })
        ]
    });
});
SidebarMenuSkeleton.displayName = "SidebarMenuSkeleton";
// =============================================================================
// SUBMENU COMPONENTS (nested navigation)
// =============================================================================
/** Container for nested submenu items */ const SidebarMenuSub = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
        ref: ref,
        "data-sidebar": "menu-sub",
        className: (0, _utils.cn)("mx-3.5 flex min-w-0 translate-x-px flex-col gap-1 border-l border-sidebar-border px-2.5 py-0.5", "group-data-[collapsible=icon]:hidden", className),
        ...props
    }));
SidebarMenuSub.displayName = "SidebarMenuSub";
/** Individual submenu item container */ const SidebarMenuSubItem = /*#__PURE__*/ _react.forwardRef(({ ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        ref: ref,
        ...props
    }));
SidebarMenuSubItem.displayName = "SidebarMenuSubItem";
/**
 * Clickable submenu item button.
 * Shows tooltip only when text is truncated.
 *
 * @param asChild - Render as child element (for Link components)
 * @param size - "sm" or "md"
 * @param isActive - Highlight as currently active route
 * @param tooltip - Tooltip text (only shown when text overflows)
 */ const SidebarMenuSubButton = /*#__PURE__*/ _react.forwardRef(({ asChild = false, size = "md", isActive, tooltip, className, ...props }, ref)=>{
    const Comp = asChild ? (0, _reactSlot.Slot) : "a";
    const [isTruncated, setIsTruncated] = _react.useState(false);
    const textRef = _react.useRef(null);
    _react.useEffect(()=>{
        const checkTruncation = ()=>{
            if (textRef.current) setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
        };
        checkTruncation();
        window.addEventListener("resize", checkTruncation);
        return ()=>window.removeEventListener("resize", checkTruncation);
    }, []);
    const button = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Comp, {
        ref: (node)=>{
            // Forward the ref
            if (typeof ref === "function") ref(node);
            else if (ref) ref.current = node;
            // Find the span for truncation detection
            if (node) {
                const span = node.querySelector("span:last-child");
                textRef.current = span;
            }
        },
        "data-sidebar": "menu-sub-button",
        "data-size": size,
        "data-active": isActive,
        className: (0, _utils.cn)("flex h-7 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-md px-2 text-sidebar-foreground outline-none ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0 [&>svg]:text-sidebar-accent-foreground", "data-[active=true]:bg-sidebar-accent data-[active=true]:text-sidebar-accent-foreground", size === "sm" && "text-xs", size === "md" && "text-sm", "group-data-[collapsible=icon]:hidden", className),
        ...props
    });
    if (!tooltip || !isTruncated) return button;
    const tooltipProps = typeof tooltip === "string" ? {
        children: tooltip
    } : tooltip;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltip.Tooltip), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipTrigger), {
                asChild: true,
                children: button
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipContent), {
                side: "right",
                align: "center",
                ...tooltipProps
            })
        ]
    });
});
SidebarMenuSubButton.displayName = "SidebarMenuSubButton";

},{"react/jsx-runtime":"dQjte","react":"eGun2","@radix-ui/react-slot":"djiMt","class-variance-authority":"l22tX","lucide-react":[["PanelLeft","8fmok","default"]],"@/client/hooks/use-mobile":"4Wkal","@/client/lib/utils":"1ankz","@/client/components/ui/button":"armlb","@/client/components/ui/input":"8UHwi","@/client/components/ui/separator":"3WCKI","@/client/components/ui/sheet":"1Ctvs","@/client/components/ui/skeleton":"bIzUl","@/client/components/ui/tooltip":"dWqZd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"djiMt":[function(require,module,exports,__globalThis) {
// src/slot.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Root", ()=>Slot);
parcelHelpers.export(exports, "Slot", ()=>Slot);
parcelHelpers.export(exports, "Slottable", ()=>Slottable);
parcelHelpers.export(exports, "createSlot", ()=>createSlot);
parcelHelpers.export(exports, "createSlottable", ()=>createSlottable);
var _react = require("react");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _jsxRuntime = require("react/jsx-runtime");
var REACT_LAZY_TYPE = Symbol.for("react.lazy");
var use = _react[" use ".trim().toString()];
function isPromiseLike(value) {
    return typeof value === "object" && value !== null && "then" in value;
}
function isLazyComponent(element) {
    return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === REACT_LAZY_TYPE && "_payload" in element && isPromiseLike(element._payload);
}
// @__NO_SIDE_EFFECTS__
function createSlot(ownerName) {
    const SlotClone = /* @__PURE__ */ createSlotClone(ownerName);
    const Slot2 = _react.forwardRef((props, forwardedRef)=>{
        let { children, ...slotProps } = props;
        if (isLazyComponent(children) && typeof use === "function") children = use(children._payload);
        const childrenArray = _react.Children.toArray(children);
        const slottable = childrenArray.find(isSlottable);
        if (slottable) {
            const newElement = slottable.props.children;
            const newChildren = childrenArray.map((child)=>{
                if (child === slottable) {
                    if (_react.Children.count(newElement) > 1) return _react.Children.only(null);
                    return _react.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)(SlotClone, {
                ...slotProps,
                ref: forwardedRef,
                children: _react.isValidElement(newElement) ? _react.cloneElement(newElement, void 0, newChildren) : null
            });
        }
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children
        });
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var Slot = /* @__PURE__ */ createSlot("Slot");
// @__NO_SIDE_EFFECTS__
function createSlotClone(ownerName) {
    const SlotClone = _react.forwardRef((props, forwardedRef)=>{
        let { children, ...slotProps } = props;
        if (isLazyComponent(children) && typeof use === "function") children = use(children._payload);
        if (_react.isValidElement(children)) {
            const childrenRef = getElementRef(children);
            const props2 = mergeProps(slotProps, children.props);
            if (children.type !== _react.Fragment) props2.ref = forwardedRef ? (0, _reactComposeRefs.composeRefs)(forwardedRef, childrenRef) : childrenRef;
            return _react.cloneElement(children, props2);
        }
        return _react.Children.count(children) > 1 ? _react.Children.only(null) : null;
    });
    SlotClone.displayName = `${ownerName}.SlotClone`;
    return SlotClone;
}
var SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function createSlottable(ownerName) {
    const Slottable2 = ({ children })=>{
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children
        });
    };
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var Slottable = /* @__PURE__ */ createSlottable("Slottable");
function isSlottable(child) {
    return _react.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === SLOTTABLE_IDENTIFIER;
}
function mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}

},{"react":"eGun2","@radix-ui/react-compose-refs":"nN23r","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"nN23r":[function(require,module,exports,__globalThis) {
// packages/react/compose-refs/src/compose-refs.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeRefs", ()=>composeRefs);
parcelHelpers.export(exports, "useComposedRefs", ()=>useComposedRefs);
var _react = require("react");
function setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function composeRefs(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else setRef(refs[i], null);
            }
        };
    };
}
function useComposedRefs(...refs) {
    return _react.useCallback(composeRefs(...refs), refs);
}

},{"react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"l22tX":[function(require,module,exports,__globalThis) {
/**
 * Copyright 2022 Joe Bell. All rights reserved.
 *
 * This file is licensed to you under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with the
 * License. You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR REPRESENTATIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cx", ()=>cx);
parcelHelpers.export(exports, "cva", ()=>cva);
var _clsx = require("clsx");
const falsyToString = (value)=>typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
const cx = (0, _clsx.clsx);
const cva = (base, config)=>(props)=>{
        var _config_compoundVariants;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return cx(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants, defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return cx(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };

},{"clsx":"3mzHT","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3mzHT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8fmok":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>PanelLeft);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            key: "afitv7"
        }
    ],
    [
        "path",
        {
            d: "M9 3v18",
            key: "fh3hqa"
        }
    ]
];
const PanelLeft = (0, _createLucideIconJsDefault.default)("panel-left", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4Wkal":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsMobile", ()=>useIsMobile);
var _react = require("react");
const MOBILE_BREAKPOINT = 768;
function useIsMobile() {
    const [isMobile, setIsMobile] = _react.useState(undefined);
    _react.useEffect(()=>{
        const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
        const onChange = ()=>{
            setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        };
        mql.addEventListener("change", onChange);
        setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        return ()=>mql.removeEventListener("change", onChange);
    }, []);
    return !!isMobile;
}

},{"react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1ankz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// used for tailwind className merging (required by shadcn)
parcelHelpers.export(exports, "cn", ()=>cn);
var _clsx = require("clsx");
var _tailwindMerge = require("tailwind-merge");
function cn(...inputs) {
    return (0, _tailwindMerge.twMerge)((0, _clsx.clsx)(inputs));
}

},{"clsx":"3mzHT","tailwind-merge":"gWRiz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gWRiz":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Concatenates two arrays faster than the array spread operator.
 */ const concatArrays = (array1, array2)=>{
    // Pre-allocate for better V8 optimization
    const combinedArray = new Array(array1.length + array2.length);
    for(let i = 0; i < array1.length; i++)combinedArray[i] = array1[i];
    for(let i = 0; i < array2.length; i++)combinedArray[array1.length + i] = array2[i];
    return combinedArray;
};
// Factory function ensures consistent object shapes
const createClassValidatorObject = (classGroupId, validator)=>({
        classGroupId,
        validator
    });
// Factory ensures consistent ClassPartObject shape
const createClassPartObject = (nextPart = new Map(), validators = null, classGroupId)=>({
        nextPart,
        validators,
        classGroupId
    });
const CLASS_PART_SEPARATOR = '-';
const EMPTY_CONFLICTS = [];
// I use two dots here because one dot is used as prefix for class groups in plugins
const ARBITRARY_PROPERTY_PREFIX = 'arbitrary..';
const createClassGroupUtils = (config)=>{
    const classMap = createClassMap(config);
    const { conflictingClassGroups, conflictingClassGroupModifiers } = config;
    const getClassGroupId = (className)=>{
        if (className.startsWith('[') && className.endsWith(']')) return getGroupIdForArbitraryProperty(className);
        const classParts = className.split(CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and skip it.
        const startIndex = classParts[0] === '' && classParts.length > 1 ? 1 : 0;
        return getGroupRecursive(classParts, startIndex, classMap);
    };
    const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier)=>{
        if (hasPostfixModifier) {
            const modifierConflicts = conflictingClassGroupModifiers[classGroupId];
            const baseConflicts = conflictingClassGroups[classGroupId];
            if (modifierConflicts) {
                if (baseConflicts) // Merge base conflicts with modifier conflicts
                return concatArrays(baseConflicts, modifierConflicts);
                // Only modifier conflicts
                return modifierConflicts;
            }
            // Fall back to without postfix if no modifier conflicts
            return baseConflicts || EMPTY_CONFLICTS;
        }
        return conflictingClassGroups[classGroupId] || EMPTY_CONFLICTS;
    };
    return {
        getClassGroupId,
        getConflictingClassGroupIds
    };
};
const getGroupRecursive = (classParts, startIndex, classPartObject)=>{
    const classPathsLength = classParts.length - startIndex;
    if (classPathsLength === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[startIndex];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    if (nextClassPartObject) {
        const result = getGroupRecursive(classParts, startIndex + 1, nextClassPartObject);
        if (result) return result;
    }
    const validators = classPartObject.validators;
    if (validators === null) return undefined;
    // Build classRest string efficiently by joining from startIndex onwards
    const classRest = startIndex === 0 ? classParts.join(CLASS_PART_SEPARATOR) : classParts.slice(startIndex).join(CLASS_PART_SEPARATOR);
    const validatorsLength = validators.length;
    for(let i = 0; i < validatorsLength; i++){
        const validatorObj = validators[i];
        if (validatorObj.validator(classRest)) return validatorObj.classGroupId;
    }
    return undefined;
};
/**
 * Get the class group ID for an arbitrary property.
 *
 * @param className - The class name to get the group ID for. Is expected to be string starting with `[` and ending with `]`.
 */ const getGroupIdForArbitraryProperty = (className)=>className.slice(1, -1).indexOf(':') === -1 ? undefined : (()=>{
        const content = className.slice(1, -1);
        const colonIndex = content.indexOf(':');
        const property = content.slice(0, colonIndex);
        return property ? ARBITRARY_PROPERTY_PREFIX + property : undefined;
    })();
/**
 * Exported for testing only
 */ const createClassMap = (config)=>{
    const { theme, classGroups } = config;
    return processClassGroups(classGroups, theme);
};
// Split into separate functions to maintain monomorphic call sites
const processClassGroups = (classGroups, theme)=>{
    const classMap = createClassPartObject();
    for(const classGroupId in classGroups){
        const group = classGroups[classGroupId];
        processClassesRecursively(group, classMap, classGroupId, theme);
    }
    return classMap;
};
const processClassesRecursively = (classGroup, classPartObject, classGroupId, theme)=>{
    const len = classGroup.length;
    for(let i = 0; i < len; i++){
        const classDefinition = classGroup[i];
        processClassDefinition(classDefinition, classPartObject, classGroupId, theme);
    }
};
// Split into separate functions for each type to maintain monomorphic call sites
const processClassDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if (typeof classDefinition === 'string') {
        processStringDefinition(classDefinition, classPartObject, classGroupId);
        return;
    }
    if (typeof classDefinition === 'function') {
        processFunctionDefinition(classDefinition, classPartObject, classGroupId, theme);
        return;
    }
    processObjectDefinition(classDefinition, classPartObject, classGroupId, theme);
};
const processStringDefinition = (classDefinition, classPartObject, classGroupId)=>{
    const classPartObjectToEdit = classDefinition === '' ? classPartObject : getPart(classPartObject, classDefinition);
    classPartObjectToEdit.classGroupId = classGroupId;
};
const processFunctionDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
    }
    if (classPartObject.validators === null) classPartObject.validators = [];
    classPartObject.validators.push(createClassValidatorObject(classGroupId, classDefinition));
};
const processObjectDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    const entries = Object.entries(classDefinition);
    const len = entries.length;
    for(let i = 0; i < len; i++){
        const [key, value] = entries[i];
        processClassesRecursively(value, getPart(classPartObject, key), classGroupId, theme);
    }
};
const getPart = (classPartObject, path)=>{
    let current = classPartObject;
    const parts = path.split(CLASS_PART_SEPARATOR);
    const len = parts.length;
    for(let i = 0; i < len; i++){
        const part = parts[i];
        let next = current.nextPart.get(part);
        if (!next) {
            next = createClassPartObject();
            current.nextPart.set(part, next);
        }
        current = next;
    }
    return current;
};
// Type guard maintains monomorphic check
const isThemeGetter = (func)=>'isThemeGetter' in func && func.isThemeGetter === true;
// LRU cache implementation using plain objects for simplicity
const createLruCache = (maxCacheSize)=>{
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = Object.create(null);
    let previousCache = Object.create(null);
    const update = (key, value)=>{
        cache[key] = value;
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = Object.create(null);
        }
    };
    return {
        get (key) {
            let value = cache[key];
            if (value !== undefined) return value;
            if ((value = previousCache[key]) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (key in cache) cache[key] = value;
            else update(key, value);
        }
    };
};
const IMPORTANT_MODIFIER = '!';
const MODIFIER_SEPARATOR = ':';
const EMPTY_MODIFIERS = [];
// Pre-allocated result object shape for consistency
const createResultObject = (modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition, isExternal)=>({
        modifiers,
        hasImportantModifier,
        baseClassName,
        maybePostfixModifierPosition,
        isExternal
    });
const createParseClassName = (config)=>{
    const { prefix, experimentalParseClassName } = config;
    /**
   * Parse class name into parts.
   *
   * Inspired by `splitAtTopLevelOnly` used in Tailwind CSS
   * @see https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
   */ let parseClassName = (className)=>{
        // Use simple array with push for better performance
        const modifiers = [];
        let bracketDepth = 0;
        let parenDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        const len = className.length;
        for(let index = 0; index < len; index++){
            const currentCharacter = className[index];
            if (bracketDepth === 0 && parenDepth === 0) {
                if (currentCharacter === MODIFIER_SEPARATOR) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + 1;
                    continue;
                }
                if (currentCharacter === '/') {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === '[') bracketDepth++;
            else if (currentCharacter === ']') bracketDepth--;
            else if (currentCharacter === '(') parenDepth++;
            else if (currentCharacter === ')') parenDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.slice(modifierStart);
        // Inline important modifier check
        let baseClassName = baseClassNameWithImportantModifier;
        let hasImportantModifier = false;
        if (baseClassNameWithImportantModifier.endsWith(IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(0, -1);
            hasImportantModifier = true;
        } else if (/**
     * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
     * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
     */ baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(1);
            hasImportantModifier = true;
        }
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return createResultObject(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition);
    };
    if (prefix) {
        const fullPrefix = prefix + MODIFIER_SEPARATOR;
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>className.startsWith(fullPrefix) ? parseClassNameOriginal(className.slice(fullPrefix.length)) : createResultObject(EMPTY_MODIFIERS, false, className, undefined, true);
    }
    if (experimentalParseClassName) {
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>experimentalParseClassName({
                className,
                parseClassName: parseClassNameOriginal
            });
    }
    return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ const createSortModifiers = (config)=>{
    // Pre-compute weights for all known modifiers for O(1) comparison
    const modifierWeights = new Map();
    // Assign weights to sensitive modifiers (highest priority, but preserve order)
    config.orderSensitiveModifiers.forEach((mod, index)=>{
        modifierWeights.set(mod, 1000000 + index); // High weights for sensitive mods
    });
    return (modifiers)=>{
        const result = [];
        let currentSegment = [];
        // Process modifiers in one pass
        for(let i = 0; i < modifiers.length; i++){
            const modifier = modifiers[i];
            // Check if modifier is sensitive (starts with '[' or in orderSensitiveModifiers)
            const isArbitrary = modifier[0] === '[';
            const isOrderSensitive = modifierWeights.has(modifier);
            if (isArbitrary || isOrderSensitive) {
                // Sort and flush current segment alphabetically
                if (currentSegment.length > 0) {
                    currentSegment.sort();
                    result.push(...currentSegment);
                    currentSegment = [];
                }
                result.push(modifier);
            } else // Regular modifier - add to current segment for batch sorting
            currentSegment.push(modifier);
        }
        // Sort and add any remaining segment items
        if (currentSegment.length > 0) {
            currentSegment.sort();
            result.push(...currentSegment);
        }
        return result;
    };
};
const createConfigUtils = (config)=>({
        cache: createLruCache(config.cacheSize),
        parseClassName: createParseClassName(config),
        sortModifiers: createSortModifiers(config),
        ...createClassGroupUtils(config)
    });
const SPLIT_CLASSES_REGEX = /\s+/;
const mergeClassList = (classList, configUtils)=>{
    const { parseClassName, getClassGroupId, getConflictingClassGroupIds, sortModifiers } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = [];
    const classNames = classList.trim().split(SPLIT_CLASSES_REGEX);
    let result = '';
    for(let index = classNames.length - 1; index >= 0; index -= 1){
        const originalClassName = classNames[index];
        const { isExternal, modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition } = parseClassName(originalClassName);
        if (isExternal) {
            result = originalClassName + (result.length > 0 ? ' ' + result : result);
            continue;
        }
        let hasPostfixModifier = !!maybePostfixModifierPosition;
        let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            hasPostfixModifier = false;
        }
        // Fast path: skip sorting for empty or single modifier
        const variantModifier = modifiers.length === 0 ? '' : modifiers.length === 1 ? modifiers[0] : sortModifiers(modifiers).join(':');
        const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.indexOf(classId) > -1) continue;
        classGroupsInConflict.push(classId);
        const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
        for(let i = 0; i < conflictGroups.length; ++i){
            const group = conflictGroups[i];
            classGroupsInConflict.push(modifierId + group);
        }
        // Tailwind class not in conflict
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
    }
    return result;
};
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ const twJoin = (...classLists)=>{
    let index = 0;
    let argument;
    let resolvedValue;
    let string = '';
    while(index < classLists.length){
        if (argument = classLists[index++]) {
            if (resolvedValue = toValue(argument)) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const toValue = (mix)=>{
    // Fast path for strings
    if (typeof mix === 'string') return mix;
    let resolvedValue;
    let string = '';
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = toValue(mix[k])) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const createTailwindMerge = (createConfigFirst, ...createConfigRest)=>{
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall;
    const initTailwindMerge = (classList)=>{
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    };
    const tailwindMerge = (classList)=>{
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    };
    functionToCall = initTailwindMerge;
    return (...args)=>functionToCall(twJoin(...args));
};
const fallbackThemeArr = [];
const fromTheme = (key)=>{
    const themeGetter = (theme)=>theme[key] || fallbackThemeArr;
    themeGetter.isThemeGetter = true;
    return themeGetter;
};
const arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
const arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
const fractionRegex = /^\d+\/\d+$/;
const tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const isFraction = (value)=>fractionRegex.test(value);
const isNumber = (value)=>!!value && !Number.isNaN(Number(value));
const isInteger = (value)=>!!value && Number.isInteger(Number(value));
const isPercent = (value)=>value.endsWith('%') && isNumber(value.slice(0, -1));
const isTshirtSize = (value)=>tshirtUnitRegex.test(value);
const isAny = ()=>true;
const isLengthOnly = (value)=>// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    lengthUnitRegex.test(value) && !colorFunctionRegex.test(value);
const isNever = ()=>false;
const isShadow = (value)=>shadowRegex.test(value);
const isImage = (value)=>imageRegex.test(value);
const isAnyNonArbitrary = (value)=>!isArbitraryValue(value) && !isArbitraryVariable(value);
const isArbitrarySize = (value)=>getIsArbitraryValue(value, isLabelSize, isNever);
const isArbitraryValue = (value)=>arbitraryValueRegex.test(value);
const isArbitraryLength = (value)=>getIsArbitraryValue(value, isLabelLength, isLengthOnly);
const isArbitraryNumber = (value)=>getIsArbitraryValue(value, isLabelNumber, isNumber);
const isArbitraryPosition = (value)=>getIsArbitraryValue(value, isLabelPosition, isNever);
const isArbitraryImage = (value)=>getIsArbitraryValue(value, isLabelImage, isImage);
const isArbitraryShadow = (value)=>getIsArbitraryValue(value, isLabelShadow, isShadow);
const isArbitraryVariable = (value)=>arbitraryVariableRegex.test(value);
const isArbitraryVariableLength = (value)=>getIsArbitraryVariable(value, isLabelLength);
const isArbitraryVariableFamilyName = (value)=>getIsArbitraryVariable(value, isLabelFamilyName);
const isArbitraryVariablePosition = (value)=>getIsArbitraryVariable(value, isLabelPosition);
const isArbitraryVariableSize = (value)=>getIsArbitraryVariable(value, isLabelSize);
const isArbitraryVariableImage = (value)=>getIsArbitraryVariable(value, isLabelImage);
const isArbitraryVariableShadow = (value)=>getIsArbitraryVariable(value, isLabelShadow, true);
// Helpers
const getIsArbitraryValue = (value, testLabel, testValue)=>{
    const result = arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return testValue(result[2]);
    }
    return false;
};
const getIsArbitraryVariable = (value, testLabel, shouldMatchNoLabel = false)=>{
    const result = arbitraryVariableRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return shouldMatchNoLabel;
    }
    return false;
};
// Labels
const isLabelPosition = (label)=>label === 'position' || label === 'percentage';
const isLabelImage = (label)=>label === 'image' || label === 'url';
const isLabelSize = (label)=>label === 'length' || label === 'size' || label === 'bg-size';
const isLabelLength = (label)=>label === 'length';
const isLabelNumber = (label)=>label === 'number';
const isLabelFamilyName = (label)=>label === 'family-name';
const isLabelShadow = (label)=>label === 'shadow';
const validators = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny,
    isAnyNonArbitrary,
    isArbitraryImage,
    isArbitraryLength,
    isArbitraryNumber,
    isArbitraryPosition,
    isArbitraryShadow,
    isArbitrarySize,
    isArbitraryValue,
    isArbitraryVariable,
    isArbitraryVariableFamilyName,
    isArbitraryVariableImage,
    isArbitraryVariableLength,
    isArbitraryVariablePosition,
    isArbitraryVariableShadow,
    isArbitraryVariableSize,
    isFraction,
    isInteger,
    isNumber,
    isPercent,
    isTshirtSize
}, Symbol.toStringTag, {
    value: 'Module'
});
const getDefaultConfig = ()=>{
    /**
   * Theme getters for theme variable namespaces
   * @see https://tailwindcss.com/docs/theme#theme-variable-namespaces
   */ /***/ const themeColor = fromTheme('color');
    const themeFont = fromTheme('font');
    const themeText = fromTheme('text');
    const themeFontWeight = fromTheme('font-weight');
    const themeTracking = fromTheme('tracking');
    const themeLeading = fromTheme('leading');
    const themeBreakpoint = fromTheme('breakpoint');
    const themeContainer = fromTheme('container');
    const themeSpacing = fromTheme('spacing');
    const themeRadius = fromTheme('radius');
    const themeShadow = fromTheme('shadow');
    const themeInsetShadow = fromTheme('inset-shadow');
    const themeTextShadow = fromTheme('text-shadow');
    const themeDropShadow = fromTheme('drop-shadow');
    const themeBlur = fromTheme('blur');
    const themePerspective = fromTheme('perspective');
    const themeAspect = fromTheme('aspect');
    const themeEase = fromTheme('ease');
    const themeAnimate = fromTheme('animate');
    /**
   * Helpers to avoid repeating the same scales
   *
   * We use functions that create a new array every time they're called instead of static arrays.
   * This ensures that users who modify any scale by mutating the array (e.g. with `array.push(element)`) don't accidentally mutate arrays in other parts of the config.
   */ /***/ const scaleBreak = ()=>[
            'auto',
            'avoid',
            'all',
            'avoid-page',
            'page',
            'left',
            'right',
            'column'
        ];
    const scalePosition = ()=>[
            'center',
            'top',
            'bottom',
            'left',
            'right',
            'top-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-top',
            'top-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-top',
            'bottom-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-bottom',
            'bottom-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-bottom'
        ];
    const scalePositionWithArbitrary = ()=>[
            ...scalePosition(),
            isArbitraryVariable,
            isArbitraryValue
        ];
    const scaleOverflow = ()=>[
            'auto',
            'hidden',
            'clip',
            'visible',
            'scroll'
        ];
    const scaleOverscroll = ()=>[
            'auto',
            'contain',
            'none'
        ];
    const scaleUnambiguousSpacing = ()=>[
            isArbitraryVariable,
            isArbitraryValue,
            themeSpacing
        ];
    const scaleInset = ()=>[
            isFraction,
            'full',
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleGridTemplateColsRows = ()=>[
            isInteger,
            'none',
            'subgrid',
            isArbitraryVariable,
            isArbitraryValue
        ];
    const scaleGridColRowStartAndEnd = ()=>[
            'auto',
            {
                span: [
                    'full',
                    isInteger,
                    isArbitraryVariable,
                    isArbitraryValue
                ]
            },
            isInteger,
            isArbitraryVariable,
            isArbitraryValue
        ];
    const scaleGridColRowStartOrEnd = ()=>[
            isInteger,
            'auto',
            isArbitraryVariable,
            isArbitraryValue
        ];
    const scaleGridAutoColsRows = ()=>[
            'auto',
            'min',
            'max',
            'fr',
            isArbitraryVariable,
            isArbitraryValue
        ];
    const scaleAlignPrimaryAxis = ()=>[
            'start',
            'end',
            'center',
            'between',
            'around',
            'evenly',
            'stretch',
            'baseline',
            'center-safe',
            'end-safe'
        ];
    const scaleAlignSecondaryAxis = ()=>[
            'start',
            'end',
            'center',
            'stretch',
            'center-safe',
            'end-safe'
        ];
    const scaleMargin = ()=>[
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizing = ()=>[
            isFraction,
            'auto',
            'full',
            'dvw',
            'dvh',
            'lvw',
            'lvh',
            'svw',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleColor = ()=>[
            themeColor,
            isArbitraryVariable,
            isArbitraryValue
        ];
    const scaleBgPosition = ()=>[
            ...scalePosition(),
            isArbitraryVariablePosition,
            isArbitraryPosition,
            {
                position: [
                    isArbitraryVariable,
                    isArbitraryValue
                ]
            }
        ];
    const scaleBgRepeat = ()=>[
            'no-repeat',
            {
                repeat: [
                    '',
                    'x',
                    'y',
                    'space',
                    'round'
                ]
            }
        ];
    const scaleBgSize = ()=>[
            'auto',
            'cover',
            'contain',
            isArbitraryVariableSize,
            isArbitrarySize,
            {
                size: [
                    isArbitraryVariable,
                    isArbitraryValue
                ]
            }
        ];
    const scaleGradientStopPosition = ()=>[
            isPercent,
            isArbitraryVariableLength,
            isArbitraryLength
        ];
    const scaleRadius = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            'full',
            themeRadius,
            isArbitraryVariable,
            isArbitraryValue
        ];
    const scaleBorderWidth = ()=>[
            '',
            isNumber,
            isArbitraryVariableLength,
            isArbitraryLength
        ];
    const scaleLineStyle = ()=>[
            'solid',
            'dashed',
            'dotted',
            'double'
        ];
    const scaleBlendMode = ()=>[
            'normal',
            'multiply',
            'screen',
            'overlay',
            'darken',
            'lighten',
            'color-dodge',
            'color-burn',
            'hard-light',
            'soft-light',
            'difference',
            'exclusion',
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
    const scaleMaskImagePosition = ()=>[
            isNumber,
            isPercent,
            isArbitraryVariablePosition,
            isArbitraryPosition
        ];
    const scaleBlur = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            themeBlur,
            isArbitraryVariable,
            isArbitraryValue
        ];
    const scaleRotate = ()=>[
            'none',
            isNumber,
            isArbitraryVariable,
            isArbitraryValue
        ];
    const scaleScale = ()=>[
            'none',
            isNumber,
            isArbitraryVariable,
            isArbitraryValue
        ];
    const scaleSkew = ()=>[
            isNumber,
            isArbitraryVariable,
            isArbitraryValue
        ];
    const scaleTranslate = ()=>[
            isFraction,
            'full',
            ...scaleUnambiguousSpacing()
        ];
    return {
        cacheSize: 500,
        theme: {
            animate: [
                'spin',
                'ping',
                'pulse',
                'bounce'
            ],
            aspect: [
                'video'
            ],
            blur: [
                isTshirtSize
            ],
            breakpoint: [
                isTshirtSize
            ],
            color: [
                isAny
            ],
            container: [
                isTshirtSize
            ],
            'drop-shadow': [
                isTshirtSize
            ],
            ease: [
                'in',
                'out',
                'in-out'
            ],
            font: [
                isAnyNonArbitrary
            ],
            'font-weight': [
                'thin',
                'extralight',
                'light',
                'normal',
                'medium',
                'semibold',
                'bold',
                'extrabold',
                'black'
            ],
            'inset-shadow': [
                isTshirtSize
            ],
            leading: [
                'none',
                'tight',
                'snug',
                'normal',
                'relaxed',
                'loose'
            ],
            perspective: [
                'dramatic',
                'near',
                'normal',
                'midrange',
                'distant',
                'none'
            ],
            radius: [
                isTshirtSize
            ],
            shadow: [
                isTshirtSize
            ],
            spacing: [
                'px',
                isNumber
            ],
            text: [
                isTshirtSize
            ],
            'text-shadow': [
                isTshirtSize
            ],
            tracking: [
                'tighter',
                'tight',
                'normal',
                'wide',
                'wider',
                'widest'
            ]
        },
        classGroups: {
            // --------------
            // --- Layout ---
            // --------------
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        'auto',
                        'square',
                        isFraction,
                        isArbitraryValue,
                        isArbitraryVariable,
                        themeAspect
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */ container: [
                'container'
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        isNumber,
                        isArbitraryValue,
                        isArbitraryVariable,
                        themeContainer
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ 'break-after': [
                {
                    'break-after': scaleBreak()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ 'break-before': [
                {
                    'break-before': scaleBreak()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ 'break-inside': [
                {
                    'break-inside': [
                        'auto',
                        'avoid',
                        'avoid-page',
                        'avoid-column'
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ 'box-decoration': [
                {
                    'box-decoration': [
                        'slice',
                        'clone'
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        'border',
                        'content'
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                'block',
                'inline-block',
                'inline',
                'flex',
                'inline-flex',
                'table',
                'inline-table',
                'table-caption',
                'table-cell',
                'table-column',
                'table-column-group',
                'table-footer-group',
                'table-header-group',
                'table-row-group',
                'table-row',
                'flow-root',
                'grid',
                'inline-grid',
                'contents',
                'list-item',
                'hidden'
            ],
            /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */ sr: [
                'sr-only',
                'not-sr-only'
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        'right',
                        'left',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        'left',
                        'right',
                        'both',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                'isolate',
                'isolation-auto'
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ 'object-fit': [
                {
                    object: [
                        'contain',
                        'cover',
                        'fill',
                        'none',
                        'scale-down'
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ 'object-position': [
                {
                    object: scalePositionWithArbitrary()
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: scaleOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-x': [
                {
                    'overflow-x': scaleOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-y': [
                {
                    'overflow-y': scaleOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-x': [
                {
                    'overscroll-x': scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-y': [
                {
                    'overscroll-y': scaleOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                'static',
                'fixed',
                'absolute',
                'relative',
                'sticky'
            ],
            /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: scaleInset()
                }
            ],
            /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-x': [
                {
                    'inset-x': scaleInset()
                }
            ],
            /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-y': [
                {
                    'inset-y': scaleInset()
                }
            ],
            /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ start: [
                {
                    start: scaleInset()
                }
            ],
            /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ end: [
                {
                    end: scaleInset()
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: scaleInset()
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: scaleInset()
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: scaleInset()
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: scaleInset()
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                'visible',
                'invisible',
                'collapse'
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        isInteger,
                        'auto',
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            // ------------------------
            // --- Flexbox and Grid ---
            // ------------------------
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: [
                        isFraction,
                        'full',
                        'auto',
                        themeContainer,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ 'flex-direction': [
                {
                    flex: [
                        'row',
                        'row-reverse',
                        'col',
                        'col-reverse'
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ 'flex-wrap': [
                {
                    flex: [
                        'nowrap',
                        'wrap',
                        'wrap-reverse'
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        isNumber,
                        isFraction,
                        'auto',
                        'initial',
                        'none',
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: [
                        '',
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: [
                        '',
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        isInteger,
                        'first',
                        'last',
                        'none',
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ 'grid-cols': [
                {
                    'grid-cols': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start-end': [
                {
                    col: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start': [
                {
                    'col-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-end': [
                {
                    'col-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ 'grid-rows': [
                {
                    'grid-rows': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start-end': [
                {
                    row: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start': [
                {
                    'row-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-end': [
                {
                    'row-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ 'grid-flow': [
                {
                    'grid-flow': [
                        'row',
                        'col',
                        'dense',
                        'row-dense',
                        'col-dense'
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ 'auto-cols': [
                {
                    'auto-cols': scaleGridAutoColsRows()
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ 'auto-rows': [
                {
                    'auto-rows': scaleGridAutoColsRows()
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-x': [
                {
                    'gap-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-y': [
                {
                    'gap-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ 'justify-content': [
                {
                    justify: [
                        ...scaleAlignPrimaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ 'justify-items': [
                {
                    'justify-items': [
                        ...scaleAlignSecondaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ 'justify-self': [
                {
                    'justify-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ 'align-content': [
                {
                    content: [
                        'normal',
                        ...scaleAlignPrimaryAxis()
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ 'align-items': [
                {
                    items: [
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ 'align-self': [
                {
                    self: [
                        'auto',
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ 'place-content': [
                {
                    'place-content': scaleAlignPrimaryAxis()
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ 'place-items': [
                {
                    'place-items': [
                        ...scaleAlignSecondaryAxis(),
                        'baseline'
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ 'place-self': [
                {
                    'place-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: scaleMargin()
                }
            ],
            /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: scaleMargin()
                }
            ],
            /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: scaleMargin()
                }
            ],
            /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: scaleMargin()
                }
            ],
            /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: scaleMargin()
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: scaleMargin()
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: scaleMargin()
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: scaleMargin()
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: scaleMargin()
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x': [
                {
                    'space-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x-reverse': [
                'space-x-reverse'
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y': [
                {
                    'space-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y-reverse': [
                'space-y-reverse'
            ],
            // --------------
            // --- Sizing ---
            // --------------
            /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */ size: [
                {
                    size: scaleSizing()
                }
            ],
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        themeContainer,
                        'screen',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-w': [
                {
                    'min-w': [
                        themeContainer,
                        'screen',
                        /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-w': [
                {
                    'max-w': [
                        themeContainer,
                        'screen',
                        'none',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'prose',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ {
                            screen: [
                                themeBreakpoint
                            ]
                        },
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        'screen',
                        'lh',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-h': [
                {
                    'min-h': [
                        'screen',
                        'lh',
                        'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-h': [
                {
                    'max-h': [
                        'screen',
                        'lh',
                        ...scaleSizing()
                    ]
                }
            ],
            // ------------------
            // --- Typography ---
            // ------------------
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ 'font-size': [
                {
                    text: [
                        'base',
                        themeText,
                        isArbitraryVariableLength,
                        isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ 'font-smoothing': [
                'antialiased',
                'subpixel-antialiased'
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ 'font-style': [
                'italic',
                'not-italic'
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ 'font-weight': [
                {
                    font: [
                        themeFontWeight,
                        isArbitraryVariable,
                        isArbitraryNumber
                    ]
                }
            ],
            /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */ 'font-stretch': [
                {
                    'font-stretch': [
                        'ultra-condensed',
                        'extra-condensed',
                        'condensed',
                        'semi-condensed',
                        'normal',
                        'semi-expanded',
                        'expanded',
                        'extra-expanded',
                        'ultra-expanded',
                        isPercent,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ 'font-family': [
                {
                    font: [
                        isArbitraryVariableFamilyName,
                        isArbitraryValue,
                        themeFont
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-normal': [
                'normal-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-ordinal': [
                'ordinal'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-slashed-zero': [
                'slashed-zero'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-figure': [
                'lining-nums',
                'oldstyle-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-spacing': [
                'proportional-nums',
                'tabular-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-fraction': [
                'diagonal-fractions',
                'stacked-fractions'
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        themeTracking,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ 'line-clamp': [
                {
                    'line-clamp': [
                        isNumber,
                        'none',
                        isArbitraryVariable,
                        isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ themeLeading,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ 'list-image': [
                {
                    'list-image': [
                        'none',
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ 'list-style-position': [
                {
                    list: [
                        'inside',
                        'outside'
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ 'list-style-type': [
                {
                    list: [
                        'disc',
                        'decimal',
                        'none',
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ 'text-alignment': [
                {
                    text: [
                        'left',
                        'center',
                        'right',
                        'justify',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */ 'placeholder-color': [
                {
                    placeholder: scaleColor()
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ 'text-color': [
                {
                    text: scaleColor()
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ 'text-decoration': [
                'underline',
                'overline',
                'line-through',
                'no-underline'
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ 'text-decoration-style': [
                {
                    decoration: [
                        ...scaleLineStyle(),
                        'wavy'
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ 'text-decoration-thickness': [
                {
                    decoration: [
                        isNumber,
                        'from-font',
                        'auto',
                        isArbitraryVariable,
                        isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ 'text-decoration-color': [
                {
                    decoration: scaleColor()
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ 'underline-offset': [
                {
                    'underline-offset': [
                        isNumber,
                        'auto',
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ 'text-transform': [
                'uppercase',
                'lowercase',
                'capitalize',
                'normal-case'
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ 'text-overflow': [
                'truncate',
                'text-ellipsis',
                'text-clip'
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ 'text-wrap': [
                {
                    text: [
                        'wrap',
                        'nowrap',
                        'balance',
                        'pretty'
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ 'vertical-align': [
                {
                    align: [
                        'baseline',
                        'top',
                        'middle',
                        'bottom',
                        'text-top',
                        'text-bottom',
                        'sub',
                        'super',
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        'normal',
                        'nowrap',
                        'pre',
                        'pre-line',
                        'pre-wrap',
                        'break-spaces'
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        'normal',
                        'words',
                        'all',
                        'keep'
                    ]
                }
            ],
            /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */ wrap: [
                {
                    wrap: [
                        'break-word',
                        'anywhere',
                        'normal'
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        'none',
                        'manual',
                        'auto'
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        'none',
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            // -------------------
            // --- Backgrounds ---
            // -------------------
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ 'bg-attachment': [
                {
                    bg: [
                        'fixed',
                        'local',
                        'scroll'
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ 'bg-clip': [
                {
                    'bg-clip': [
                        'border',
                        'padding',
                        'content',
                        'text'
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ 'bg-origin': [
                {
                    'bg-origin': [
                        'border',
                        'padding',
                        'content'
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ 'bg-position': [
                {
                    bg: scaleBgPosition()
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ 'bg-repeat': [
                {
                    bg: scaleBgRepeat()
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ 'bg-size': [
                {
                    bg: scaleBgSize()
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ 'bg-image': [
                {
                    bg: [
                        'none',
                        {
                            linear: [
                                {
                                    to: [
                                        't',
                                        'tr',
                                        'r',
                                        'br',
                                        'b',
                                        'bl',
                                        'l',
                                        'tl'
                                    ]
                                },
                                isInteger,
                                isArbitraryVariable,
                                isArbitraryValue
                            ],
                            radial: [
                                '',
                                isArbitraryVariable,
                                isArbitraryValue
                            ],
                            conic: [
                                isInteger,
                                isArbitraryVariable,
                                isArbitraryValue
                            ]
                        },
                        isArbitraryVariableImage,
                        isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ 'bg-color': [
                {
                    bg: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from-pos': [
                {
                    from: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via-pos': [
                {
                    via: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to-pos': [
                {
                    to: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from': [
                {
                    from: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via': [
                {
                    via: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to': [
                {
                    to: scaleColor()
                }
            ],
            // ---------------
            // --- Borders ---
            // ---------------
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: scaleRadius()
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-s': [
                {
                    'rounded-s': scaleRadius()
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-e': [
                {
                    'rounded-e': scaleRadius()
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-t': [
                {
                    'rounded-t': scaleRadius()
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-r': [
                {
                    'rounded-r': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-b': [
                {
                    'rounded-b': scaleRadius()
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-l': [
                {
                    'rounded-l': scaleRadius()
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ss': [
                {
                    'rounded-ss': scaleRadius()
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-se': [
                {
                    'rounded-se': scaleRadius()
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ee': [
                {
                    'rounded-ee': scaleRadius()
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-es': [
                {
                    'rounded-es': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tl': [
                {
                    'rounded-tl': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tr': [
                {
                    'rounded-tr': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-br': [
                {
                    'rounded-br': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-bl': [
                {
                    'rounded-bl': scaleRadius()
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w': [
                {
                    border: scaleBorderWidth()
                }
            ],
            /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-x': [
                {
                    'border-x': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-y': [
                {
                    'border-y': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-s': [
                {
                    'border-s': scaleBorderWidth()
                }
            ],
            /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-e': [
                {
                    'border-e': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-t': [
                {
                    'border-t': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-r': [
                {
                    'border-r': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-b': [
                {
                    'border-b': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-l': [
                {
                    'border-l': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x': [
                {
                    'divide-x': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x-reverse': [
                'divide-x-reverse'
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y': [
                {
                    'divide-y': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y-reverse': [
                'divide-y-reverse'
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ 'border-style': [
                {
                    border: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */ 'divide-style': [
                {
                    divide: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color': [
                {
                    border: scaleColor()
                }
            ],
            /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-x': [
                {
                    'border-x': scaleColor()
                }
            ],
            /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-y': [
                {
                    'border-y': scaleColor()
                }
            ],
            /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-s': [
                {
                    'border-s': scaleColor()
                }
            ],
            /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-e': [
                {
                    'border-e': scaleColor()
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-t': [
                {
                    'border-t': scaleColor()
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-r': [
                {
                    'border-r': scaleColor()
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-b': [
                {
                    'border-b': scaleColor()
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-l': [
                {
                    'border-l': scaleColor()
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ 'divide-color': [
                {
                    divide: scaleColor()
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ 'outline-style': [
                {
                    outline: [
                        ...scaleLineStyle(),
                        'none',
                        'hidden'
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ 'outline-offset': [
                {
                    'outline-offset': [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ 'outline-w': [
                {
                    outline: [
                        '',
                        isNumber,
                        isArbitraryVariableLength,
                        isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ 'outline-color': [
                {
                    outline: scaleColor()
                }
            ],
            // ---------------
            // --- Effects ---
            // ---------------
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        'none',
                        themeShadow,
                        isArbitraryVariableShadow,
                        isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */ 'shadow-color': [
                {
                    shadow: scaleColor()
                }
            ],
            /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */ 'inset-shadow': [
                {
                    'inset-shadow': [
                        'none',
                        themeInsetShadow,
                        isArbitraryVariableShadow,
                        isArbitraryShadow
                    ]
                }
            ],
            /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */ 'inset-shadow-color': [
                {
                    'inset-shadow': scaleColor()
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */ 'ring-w': [
                {
                    ring: scaleBorderWidth()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-w-inset': [
                'ring-inset'
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */ 'ring-color': [
                {
                    ring: scaleColor()
                }
            ],
            /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-w': [
                {
                    'ring-offset': [
                        isNumber,
                        isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-color': [
                {
                    'ring-offset': scaleColor()
                }
            ],
            /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */ 'inset-ring-w': [
                {
                    'inset-ring': scaleBorderWidth()
                }
            ],
            /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */ 'inset-ring-color': [
                {
                    'inset-ring': scaleColor()
                }
            ],
            /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */ 'text-shadow': [
                {
                    'text-shadow': [
                        'none',
                        themeTextShadow,
                        isArbitraryVariableShadow,
                        isArbitraryShadow
                    ]
                }
            ],
            /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */ 'text-shadow-color': [
                {
                    'text-shadow': scaleColor()
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ 'mix-blend': [
                {
                    'mix-blend': [
                        ...scaleBlendMode(),
                        'plus-darker',
                        'plus-lighter'
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ 'bg-blend': [
                {
                    'bg-blend': scaleBlendMode()
                }
            ],
            /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */ 'mask-clip': [
                {
                    'mask-clip': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                },
                'mask-no-clip'
            ],
            /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */ 'mask-composite': [
                {
                    mask: [
                        'add',
                        'subtract',
                        'intersect',
                        'exclude'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image-linear-pos': [
                {
                    'mask-linear': [
                        isNumber
                    ]
                }
            ],
            'mask-image-linear-from-pos': [
                {
                    'mask-linear-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-to-pos': [
                {
                    'mask-linear-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-from-color': [
                {
                    'mask-linear-from': scaleColor()
                }
            ],
            'mask-image-linear-to-color': [
                {
                    'mask-linear-to': scaleColor()
                }
            ],
            'mask-image-t-from-pos': [
                {
                    'mask-t-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-to-pos': [
                {
                    'mask-t-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-from-color': [
                {
                    'mask-t-from': scaleColor()
                }
            ],
            'mask-image-t-to-color': [
                {
                    'mask-t-to': scaleColor()
                }
            ],
            'mask-image-r-from-pos': [
                {
                    'mask-r-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-to-pos': [
                {
                    'mask-r-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-from-color': [
                {
                    'mask-r-from': scaleColor()
                }
            ],
            'mask-image-r-to-color': [
                {
                    'mask-r-to': scaleColor()
                }
            ],
            'mask-image-b-from-pos': [
                {
                    'mask-b-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-to-pos': [
                {
                    'mask-b-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-from-color': [
                {
                    'mask-b-from': scaleColor()
                }
            ],
            'mask-image-b-to-color': [
                {
                    'mask-b-to': scaleColor()
                }
            ],
            'mask-image-l-from-pos': [
                {
                    'mask-l-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-to-pos': [
                {
                    'mask-l-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-from-color': [
                {
                    'mask-l-from': scaleColor()
                }
            ],
            'mask-image-l-to-color': [
                {
                    'mask-l-to': scaleColor()
                }
            ],
            'mask-image-x-from-pos': [
                {
                    'mask-x-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-to-pos': [
                {
                    'mask-x-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-from-color': [
                {
                    'mask-x-from': scaleColor()
                }
            ],
            'mask-image-x-to-color': [
                {
                    'mask-x-to': scaleColor()
                }
            ],
            'mask-image-y-from-pos': [
                {
                    'mask-y-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-to-pos': [
                {
                    'mask-y-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-from-color': [
                {
                    'mask-y-from': scaleColor()
                }
            ],
            'mask-image-y-to-color': [
                {
                    'mask-y-to': scaleColor()
                }
            ],
            'mask-image-radial': [
                {
                    'mask-radial': [
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            'mask-image-radial-from-pos': [
                {
                    'mask-radial-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-to-pos': [
                {
                    'mask-radial-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-from-color': [
                {
                    'mask-radial-from': scaleColor()
                }
            ],
            'mask-image-radial-to-color': [
                {
                    'mask-radial-to': scaleColor()
                }
            ],
            'mask-image-radial-shape': [
                {
                    'mask-radial': [
                        'circle',
                        'ellipse'
                    ]
                }
            ],
            'mask-image-radial-size': [
                {
                    'mask-radial': [
                        {
                            closest: [
                                'side',
                                'corner'
                            ],
                            farthest: [
                                'side',
                                'corner'
                            ]
                        }
                    ]
                }
            ],
            'mask-image-radial-pos': [
                {
                    'mask-radial-at': scalePosition()
                }
            ],
            'mask-image-conic-pos': [
                {
                    'mask-conic': [
                        isNumber
                    ]
                }
            ],
            'mask-image-conic-from-pos': [
                {
                    'mask-conic-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-to-pos': [
                {
                    'mask-conic-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-from-color': [
                {
                    'mask-conic-from': scaleColor()
                }
            ],
            'mask-image-conic-to-color': [
                {
                    'mask-conic-to': scaleColor()
                }
            ],
            /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */ 'mask-mode': [
                {
                    mask: [
                        'alpha',
                        'luminance',
                        'match'
                    ]
                }
            ],
            /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */ 'mask-origin': [
                {
                    'mask-origin': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                }
            ],
            /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */ 'mask-position': [
                {
                    mask: scaleBgPosition()
                }
            ],
            /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */ 'mask-repeat': [
                {
                    mask: scaleBgRepeat()
                }
            ],
            /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */ 'mask-size': [
                {
                    mask: scaleBgSize()
                }
            ],
            /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */ 'mask-type': [
                {
                    'mask-type': [
                        'alpha',
                        'luminance'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image': [
                {
                    mask: [
                        'none',
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            // ---------------
            // --- Filters ---
            // ---------------
            /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: scaleBlur()
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ 'drop-shadow': [
                {
                    'drop-shadow': [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        'none',
                        themeDropShadow,
                        isArbitraryVariableShadow,
                        isArbitraryShadow
                    ]
                }
            ],
            /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */ 'drop-shadow-color': [
                {
                    'drop-shadow': scaleColor()
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        '',
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ 'hue-rotate': [
                {
                    'hue-rotate': [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        '',
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        '',
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ 'backdrop-filter': [
                {
                    'backdrop-filter': [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ 'backdrop-blur': [
                {
                    'backdrop-blur': scaleBlur()
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ 'backdrop-brightness': [
                {
                    'backdrop-brightness': [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ 'backdrop-contrast': [
                {
                    'backdrop-contrast': [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ 'backdrop-grayscale': [
                {
                    'backdrop-grayscale': [
                        '',
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ 'backdrop-hue-rotate': [
                {
                    'backdrop-hue-rotate': [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ 'backdrop-invert': [
                {
                    'backdrop-invert': [
                        '',
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ 'backdrop-opacity': [
                {
                    'backdrop-opacity': [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ 'backdrop-saturate': [
                {
                    'backdrop-saturate': [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ 'backdrop-sepia': [
                {
                    'backdrop-sepia': [
                        '',
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            // --------------
            // --- Tables ---
            // --------------
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ 'border-collapse': [
                {
                    border: [
                        'collapse',
                        'separate'
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing': [
                {
                    'border-spacing': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-x': [
                {
                    'border-spacing-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-y': [
                {
                    'border-spacing-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ 'table-layout': [
                {
                    table: [
                        'auto',
                        'fixed'
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        'top',
                        'bottom'
                    ]
                }
            ],
            // ---------------------------------
            // --- Transitions and Animation ---
            // ---------------------------------
            /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        '',
                        'all',
                        'colors',
                        'opacity',
                        'shadow',
                        'transform',
                        'none',
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */ 'transition-behavior': [
                {
                    transition: [
                        'normal',
                        'discrete'
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: [
                        isNumber,
                        'initial',
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        'linear',
                        'initial',
                        themeEase,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        'none',
                        themeAnimate,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            // ------------------
            // --- Transforms ---
            // ------------------
            /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */ backface: [
                {
                    backface: [
                        'hidden',
                        'visible'
                    ]
                }
            ],
            /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */ perspective: [
                {
                    perspective: [
                        themePerspective,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */ 'perspective-origin': [
                {
                    'perspective-origin': scalePositionWithArbitrary()
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: scaleRotate()
                }
            ],
            /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-x': [
                {
                    'rotate-x': scaleRotate()
                }
            ],
            /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-y': [
                {
                    'rotate-y': scaleRotate()
                }
            ],
            /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-z': [
                {
                    'rotate-z': scaleRotate()
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: scaleScale()
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-x': [
                {
                    'scale-x': scaleScale()
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-y': [
                {
                    'scale-y': scaleScale()
                }
            ],
            /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-z': [
                {
                    'scale-z': scaleScale()
                }
            ],
            /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-3d': [
                'scale-3d'
            ],
            /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */ skew: [
                {
                    skew: scaleSkew()
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-x': [
                {
                    'skew-x': scaleSkew()
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-y': [
                {
                    'skew-y': scaleSkew()
                }
            ],
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        isArbitraryVariable,
                        isArbitraryValue,
                        '',
                        'none',
                        'gpu',
                        'cpu'
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ 'transform-origin': [
                {
                    origin: scalePositionWithArbitrary()
                }
            ],
            /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */ 'transform-style': [
                {
                    transform: [
                        '3d',
                        'flat'
                    ]
                }
            ],
            /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */ translate: [
                {
                    translate: scaleTranslate()
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-x': [
                {
                    'translate-x': scaleTranslate()
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-y': [
                {
                    'translate-y': scaleTranslate()
                }
            ],
            /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-z': [
                {
                    'translate-z': scaleTranslate()
                }
            ],
            /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-none': [
                'translate-none'
            ],
            // ---------------------
            // --- Interactivity ---
            // ---------------------
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: scaleColor()
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ 'caret-color': [
                {
                    caret: scaleColor()
                }
            ],
            /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */ 'color-scheme': [
                {
                    scheme: [
                        'normal',
                        'dark',
                        'light',
                        'light-dark',
                        'only-dark',
                        'only-light'
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        'auto',
                        'default',
                        'pointer',
                        'wait',
                        'text',
                        'move',
                        'help',
                        'not-allowed',
                        'none',
                        'context-menu',
                        'progress',
                        'cell',
                        'crosshair',
                        'vertical-text',
                        'alias',
                        'copy',
                        'no-drop',
                        'grab',
                        'grabbing',
                        'all-scroll',
                        'col-resize',
                        'row-resize',
                        'n-resize',
                        'e-resize',
                        's-resize',
                        'w-resize',
                        'ne-resize',
                        'nw-resize',
                        'se-resize',
                        'sw-resize',
                        'ew-resize',
                        'ns-resize',
                        'nesw-resize',
                        'nwse-resize',
                        'zoom-in',
                        'zoom-out',
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */ 'field-sizing': [
                {
                    'field-sizing': [
                        'fixed',
                        'content'
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ 'pointer-events': [
                {
                    'pointer-events': [
                        'auto',
                        'none'
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        'none',
                        '',
                        'y',
                        'x'
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ 'scroll-behavior': [
                {
                    scroll: [
                        'auto',
                        'smooth'
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-m': [
                {
                    'scroll-m': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mx': [
                {
                    'scroll-mx': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-my': [
                {
                    'scroll-my': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ms': [
                {
                    'scroll-ms': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-me': [
                {
                    'scroll-me': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mt': [
                {
                    'scroll-mt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mr': [
                {
                    'scroll-mr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mb': [
                {
                    'scroll-mb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ml': [
                {
                    'scroll-ml': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-p': [
                {
                    'scroll-p': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-px': [
                {
                    'scroll-px': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-py': [
                {
                    'scroll-py': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-ps': [
                {
                    'scroll-ps': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pe': [
                {
                    'scroll-pe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pt': [
                {
                    'scroll-pt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pr': [
                {
                    'scroll-pr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pb': [
                {
                    'scroll-pb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pl': [
                {
                    'scroll-pl': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ 'snap-align': [
                {
                    snap: [
                        'start',
                        'end',
                        'center',
                        'align-none'
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ 'snap-stop': [
                {
                    snap: [
                        'normal',
                        'always'
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-type': [
                {
                    snap: [
                        'none',
                        'x',
                        'y',
                        'both'
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-strictness': [
                {
                    snap: [
                        'mandatory',
                        'proximity'
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        'auto',
                        'none',
                        'manipulation'
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-x': [
                {
                    'touch-pan': [
                        'x',
                        'left',
                        'right'
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-y': [
                {
                    'touch-pan': [
                        'y',
                        'up',
                        'down'
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-pz': [
                'touch-pinch-zoom'
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        'none',
                        'text',
                        'all',
                        'auto'
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ 'will-change': [
                {
                    'will-change': [
                        'auto',
                        'scroll',
                        'contents',
                        'transform',
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            // -----------
            // --- SVG ---
            // -----------
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ 'stroke-w': [
                {
                    stroke: [
                        isNumber,
                        isArbitraryVariableLength,
                        isArbitraryLength,
                        isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            // ---------------------
            // --- Accessibility ---
            // ---------------------
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ 'forced-color-adjust': [
                {
                    'forced-color-adjust': [
                        'auto',
                        'none'
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            overflow: [
                'overflow-x',
                'overflow-y'
            ],
            overscroll: [
                'overscroll-x',
                'overscroll-y'
            ],
            inset: [
                'inset-x',
                'inset-y',
                'start',
                'end',
                'top',
                'right',
                'bottom',
                'left'
            ],
            'inset-x': [
                'right',
                'left'
            ],
            'inset-y': [
                'top',
                'bottom'
            ],
            flex: [
                'basis',
                'grow',
                'shrink'
            ],
            gap: [
                'gap-x',
                'gap-y'
            ],
            p: [
                'px',
                'py',
                'ps',
                'pe',
                'pt',
                'pr',
                'pb',
                'pl'
            ],
            px: [
                'pr',
                'pl'
            ],
            py: [
                'pt',
                'pb'
            ],
            m: [
                'mx',
                'my',
                'ms',
                'me',
                'mt',
                'mr',
                'mb',
                'ml'
            ],
            mx: [
                'mr',
                'ml'
            ],
            my: [
                'mt',
                'mb'
            ],
            size: [
                'w',
                'h'
            ],
            'font-size': [
                'leading'
            ],
            'fvn-normal': [
                'fvn-ordinal',
                'fvn-slashed-zero',
                'fvn-figure',
                'fvn-spacing',
                'fvn-fraction'
            ],
            'fvn-ordinal': [
                'fvn-normal'
            ],
            'fvn-slashed-zero': [
                'fvn-normal'
            ],
            'fvn-figure': [
                'fvn-normal'
            ],
            'fvn-spacing': [
                'fvn-normal'
            ],
            'fvn-fraction': [
                'fvn-normal'
            ],
            'line-clamp': [
                'display',
                'overflow'
            ],
            rounded: [
                'rounded-s',
                'rounded-e',
                'rounded-t',
                'rounded-r',
                'rounded-b',
                'rounded-l',
                'rounded-ss',
                'rounded-se',
                'rounded-ee',
                'rounded-es',
                'rounded-tl',
                'rounded-tr',
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-s': [
                'rounded-ss',
                'rounded-es'
            ],
            'rounded-e': [
                'rounded-se',
                'rounded-ee'
            ],
            'rounded-t': [
                'rounded-tl',
                'rounded-tr'
            ],
            'rounded-r': [
                'rounded-tr',
                'rounded-br'
            ],
            'rounded-b': [
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-l': [
                'rounded-tl',
                'rounded-bl'
            ],
            'border-spacing': [
                'border-spacing-x',
                'border-spacing-y'
            ],
            'border-w': [
                'border-w-x',
                'border-w-y',
                'border-w-s',
                'border-w-e',
                'border-w-t',
                'border-w-r',
                'border-w-b',
                'border-w-l'
            ],
            'border-w-x': [
                'border-w-r',
                'border-w-l'
            ],
            'border-w-y': [
                'border-w-t',
                'border-w-b'
            ],
            'border-color': [
                'border-color-x',
                'border-color-y',
                'border-color-s',
                'border-color-e',
                'border-color-t',
                'border-color-r',
                'border-color-b',
                'border-color-l'
            ],
            'border-color-x': [
                'border-color-r',
                'border-color-l'
            ],
            'border-color-y': [
                'border-color-t',
                'border-color-b'
            ],
            translate: [
                'translate-x',
                'translate-y',
                'translate-none'
            ],
            'translate-none': [
                'translate',
                'translate-x',
                'translate-y',
                'translate-z'
            ],
            'scroll-m': [
                'scroll-mx',
                'scroll-my',
                'scroll-ms',
                'scroll-me',
                'scroll-mt',
                'scroll-mr',
                'scroll-mb',
                'scroll-ml'
            ],
            'scroll-mx': [
                'scroll-mr',
                'scroll-ml'
            ],
            'scroll-my': [
                'scroll-mt',
                'scroll-mb'
            ],
            'scroll-p': [
                'scroll-px',
                'scroll-py',
                'scroll-ps',
                'scroll-pe',
                'scroll-pt',
                'scroll-pr',
                'scroll-pb',
                'scroll-pl'
            ],
            'scroll-px': [
                'scroll-pr',
                'scroll-pl'
            ],
            'scroll-py': [
                'scroll-pt',
                'scroll-pb'
            ],
            touch: [
                'touch-x',
                'touch-y',
                'touch-pz'
            ],
            'touch-x': [
                'touch'
            ],
            'touch-y': [
                'touch'
            ],
            'touch-pz': [
                'touch'
            ]
        },
        conflictingClassGroupModifiers: {
            'font-size': [
                'leading'
            ]
        },
        orderSensitiveModifiers: [
            '*',
            '**',
            'after',
            'backdrop',
            'before',
            'details-content',
            'file',
            'first-letter',
            'first-line',
            'marker',
            'placeholder',
            'selection'
        ]
    };
};
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ const mergeConfigs = (baseConfig, { cacheSize, prefix, experimentalParseClassName, extend = {}, override = {} })=>{
    overrideProperty(baseConfig, 'cacheSize', cacheSize);
    overrideProperty(baseConfig, 'prefix', prefix);
    overrideProperty(baseConfig, 'experimentalParseClassName', experimentalParseClassName);
    overrideConfigProperties(baseConfig.theme, override.theme);
    overrideConfigProperties(baseConfig.classGroups, override.classGroups);
    overrideConfigProperties(baseConfig.conflictingClassGroups, override.conflictingClassGroups);
    overrideConfigProperties(baseConfig.conflictingClassGroupModifiers, override.conflictingClassGroupModifiers);
    overrideProperty(baseConfig, 'orderSensitiveModifiers', override.orderSensitiveModifiers);
    mergeConfigProperties(baseConfig.theme, extend.theme);
    mergeConfigProperties(baseConfig.classGroups, extend.classGroups);
    mergeConfigProperties(baseConfig.conflictingClassGroups, extend.conflictingClassGroups);
    mergeConfigProperties(baseConfig.conflictingClassGroupModifiers, extend.conflictingClassGroupModifiers);
    mergeArrayProperties(baseConfig, extend, 'orderSensitiveModifiers');
    return baseConfig;
};
const overrideProperty = (baseObject, overrideKey, overrideValue)=>{
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
};
const overrideConfigProperties = (baseObject, overrideObject)=>{
    if (overrideObject) for(const key in overrideObject)overrideProperty(baseObject, key, overrideObject[key]);
};
const mergeConfigProperties = (baseObject, mergeObject)=>{
    if (mergeObject) for(const key in mergeObject)mergeArrayProperties(baseObject, mergeObject, key);
};
const mergeArrayProperties = (baseObject, mergeObject, key)=>{
    const mergeValue = mergeObject[key];
    if (mergeValue !== undefined) baseObject[key] = baseObject[key] ? baseObject[key].concat(mergeValue) : mergeValue;
};
const extendTailwindMerge = (configExtension, ...createConfig)=>typeof configExtension === 'function' ? createTailwindMerge(getDefaultConfig, configExtension, ...createConfig) : createTailwindMerge(()=>mergeConfigs(getDefaultConfig(), configExtension), ...createConfig);
const twMerge = /*#__PURE__*/ createTailwindMerge(getDefaultConfig);
exports.createTailwindMerge = createTailwindMerge;
exports.extendTailwindMerge = extendTailwindMerge;
exports.fromTheme = fromTheme;
exports.getDefaultConfig = getDefaultConfig;
exports.mergeConfigs = mergeConfigs;
exports.twJoin = twJoin;
exports.twMerge = twMerge;
exports.validators = validators;

},{}],"armlb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
parcelHelpers.export(exports, "buttonVariants", ()=>buttonVariants);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactSlot = require("@radix-ui/react-slot");
var _classVarianceAuthority = require("class-variance-authority");
var _utils = require("@/client/lib/utils");
const buttonVariants = (0, _classVarianceAuthority.cva)("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground hover:bg-primary/90",
            destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
            outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline"
        },
        size: {
            default: "h-10 px-4 py-2",
            sm: "h-9 rounded-md px-3",
            lg: "h-11 rounded-md px-8",
            icon: "h-10 w-10"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
const Button = /*#__PURE__*/ _react.forwardRef(({ className, variant, size, asChild = false, ...props }, ref)=>{
    const Comp = asChild ? (0, _reactSlot.Slot) : "button";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Comp, {
        className: (0, _utils.cn)(buttonVariants({
            variant,
            size,
            className
        })),
        ref: ref,
        ...props
    });
});
Button.displayName = "Button";

},{"react/jsx-runtime":"dQjte","react":"eGun2","@radix-ui/react-slot":"djiMt","class-variance-authority":"l22tX","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8UHwi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Input", ()=>Input);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@/client/lib/utils");
const Input = /*#__PURE__*/ _react.forwardRef(({ className, type, ...props }, ref)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        type: type,
        className: (0, _utils.cn)("flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", className),
        ref: ref,
        ...props
    });
});
Input.displayName = "Input";

},{"react/jsx-runtime":"dQjte","react":"eGun2","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3WCKI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Separator", ()=>Separator);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactSeparator = require("@radix-ui/react-separator");
var _utils = require("@/client/lib/utils");
const Separator = /*#__PURE__*/ _react.forwardRef(({ className, orientation = "horizontal", decorative = true, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactSeparator.Root, {
        ref: ref,
        decorative: decorative,
        orientation: orientation,
        className: (0, _utils.cn)("shrink-0 bg-border", orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]", className),
        ...props
    }));
Separator.displayName = _reactSeparator.Root.displayName;

},{"react/jsx-runtime":"dQjte","react":"eGun2","@radix-ui/react-separator":"4Rr7Z","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4Rr7Z":[function(require,module,exports,__globalThis) {
// src/separator.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Root", ()=>Root);
parcelHelpers.export(exports, "Separator", ()=>Separator);
var _react = require("react");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _jsxRuntime = require("react/jsx-runtime");
var NAME = "Separator";
var DEFAULT_ORIENTATION = "horizontal";
var ORIENTATIONS = [
    "horizontal",
    "vertical"
];
var Separator = _react.forwardRef((props, forwardedRef)=>{
    const { decorative, orientation: orientationProp = DEFAULT_ORIENTATION, ...domProps } = props;
    const orientation = isValidOrientation(orientationProp) ? orientationProp : DEFAULT_ORIENTATION;
    const ariaOrientation = orientation === "vertical" ? orientation : void 0;
    const semanticProps = decorative ? {
        role: "none"
    } : {
        "aria-orientation": ariaOrientation,
        role: "separator"
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        "data-orientation": orientation,
        ...semanticProps,
        ...domProps,
        ref: forwardedRef
    });
});
Separator.displayName = NAME;
function isValidOrientation(orientation) {
    return ORIENTATIONS.includes(orientation);
}
var Root = Separator;

},{"react":"eGun2","@radix-ui/react-primitive":"i36AJ","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"i36AJ":[function(require,module,exports,__globalThis) {
// src/primitive.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Primitive", ()=>Primitive);
parcelHelpers.export(exports, "Root", ()=>Root);
parcelHelpers.export(exports, "dispatchDiscreteCustomEvent", ()=>dispatchDiscreteCustomEvent);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactSlot = require("@radix-ui/react-slot");
var _jsxRuntime = require("react/jsx-runtime");
var NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var Primitive = NODES.reduce((primitive, node)=>{
    const Slot = (0, _reactSlot.createSlot)(`Primitive.${node}`);
    const Node = _react.forwardRef((props, forwardedRef)=>{
        const { asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function dispatchDiscreteCustomEvent(target, event) {
    if (target) _reactDom.flushSync(()=>target.dispatchEvent(event));
}
var Root = Primitive;

},{"react":"eGun2","react-dom":"bLJc5","@radix-ui/react-slot":"djiMt","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1Ctvs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sheet", ()=>Sheet);
parcelHelpers.export(exports, "SheetPortal", ()=>SheetPortal);
parcelHelpers.export(exports, "SheetOverlay", ()=>SheetOverlay);
parcelHelpers.export(exports, "SheetTrigger", ()=>SheetTrigger);
parcelHelpers.export(exports, "SheetClose", ()=>SheetClose);
parcelHelpers.export(exports, "SheetContent", ()=>SheetContent);
parcelHelpers.export(exports, "SheetHeader", ()=>SheetHeader);
parcelHelpers.export(exports, "SheetFooter", ()=>SheetFooter);
parcelHelpers.export(exports, "SheetTitle", ()=>SheetTitle);
parcelHelpers.export(exports, "SheetDescription", ()=>SheetDescription);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDialog = require("@radix-ui/react-dialog");
var _classVarianceAuthority = require("class-variance-authority");
var _lucideReact = require("lucide-react");
var _utils = require("@/client/lib/utils");
"use client";
const Sheet = _reactDialog.Root;
const SheetTrigger = _reactDialog.Trigger;
const SheetClose = _reactDialog.Close;
const SheetPortal = _reactDialog.Portal;
const SheetOverlay = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactDialog.Overlay, {
        className: (0, _utils.cn)("fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
        ...props,
        ref: ref
    }));
SheetOverlay.displayName = _reactDialog.Overlay.displayName;
const sheetVariants = (0, _classVarianceAuthority.cva)("fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500", {
    variants: {
        side: {
            top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
            bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
            left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
            right: "inset-y-0 right-0 h-full w-3/4  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
        }
    },
    defaultVariants: {
        side: "right"
    }
});
const SheetContent = /*#__PURE__*/ _react.forwardRef(({ side = "right", className, children, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(SheetPortal, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SheetOverlay, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactDialog.Content, {
                ref: ref,
                className: (0, _utils.cn)(sheetVariants({
                    side
                }), className),
                ...props,
                children: [
                    children,
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactDialog.Close, {
                        className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.X), {
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "sr-only",
                                children: "Close"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
SheetContent.displayName = _reactDialog.Content.displayName;
const SheetHeader = ({ className, ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _utils.cn)("flex flex-col space-y-2 text-center sm:text-left", className),
        ...props
    });
SheetHeader.displayName = "SheetHeader";
const SheetFooter = ({ className, ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _utils.cn)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className),
        ...props
    });
SheetFooter.displayName = "SheetFooter";
const SheetTitle = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactDialog.Title, {
        ref: ref,
        className: (0, _utils.cn)("text-lg font-semibold text-foreground", className),
        ...props
    }));
SheetTitle.displayName = _reactDialog.Title.displayName;
const SheetDescription = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactDialog.Description, {
        ref: ref,
        className: (0, _utils.cn)("text-sm text-muted-foreground", className),
        ...props
    }));
SheetDescription.displayName = _reactDialog.Description.displayName;

},{"react/jsx-runtime":"dQjte","react":"eGun2","@radix-ui/react-dialog":"3DJ7S","class-variance-authority":"l22tX","lucide-react":[["X","8HSxK","default"]],"@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3DJ7S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Close", ()=>Close);
parcelHelpers.export(exports, "Content", ()=>Content);
parcelHelpers.export(exports, "Description", ()=>Description);
parcelHelpers.export(exports, "Dialog", ()=>Dialog);
parcelHelpers.export(exports, "DialogClose", ()=>DialogClose);
parcelHelpers.export(exports, "DialogContent", ()=>DialogContent);
parcelHelpers.export(exports, "DialogDescription", ()=>DialogDescription);
parcelHelpers.export(exports, "DialogOverlay", ()=>DialogOverlay);
parcelHelpers.export(exports, "DialogPortal", ()=>DialogPortal);
parcelHelpers.export(exports, "DialogTitle", ()=>DialogTitle);
parcelHelpers.export(exports, "DialogTrigger", ()=>DialogTrigger);
parcelHelpers.export(exports, "Overlay", ()=>Overlay);
parcelHelpers.export(exports, "Portal", ()=>Portal);
parcelHelpers.export(exports, "Root", ()=>Root);
parcelHelpers.export(exports, "Title", ()=>Title);
parcelHelpers.export(exports, "Trigger", ()=>Trigger);
parcelHelpers.export(exports, "WarningProvider", ()=>WarningProvider);
parcelHelpers.export(exports, "createDialogScope", ()=>createDialogScope);
// src/dialog.tsx
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactContext = require("@radix-ui/react-context");
var _reactId = require("@radix-ui/react-id");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _reactDismissableLayer = require("@radix-ui/react-dismissable-layer");
var _reactFocusScope = require("@radix-ui/react-focus-scope");
var _reactPortal = require("@radix-ui/react-portal");
var _reactPresence = require("@radix-ui/react-presence");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactFocusGuards = require("@radix-ui/react-focus-guards");
var _reactRemoveScroll = require("react-remove-scroll");
var _ariaHidden = require("aria-hidden");
var _reactSlot = require("@radix-ui/react-slot");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var DIALOG_NAME = "Dialog";
var [createDialogContext, createDialogScope] = (0, _reactContext.createContextScope)(DIALOG_NAME);
var [DialogProvider, useDialogContext] = createDialogContext(DIALOG_NAME);
var Dialog = (props)=>{
    const { __scopeDialog, children, open: openProp, defaultOpen, onOpenChange, modal = true } = props;
    const triggerRef = _react.useRef(null);
    const contentRef = _react.useRef(null);
    const [open, setOpen] = (0, _reactUseControllableState.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: DIALOG_NAME
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(DialogProvider, {
        scope: __scopeDialog,
        triggerRef,
        contentRef,
        contentId: (0, _reactId.useId)(),
        titleId: (0, _reactId.useId)(),
        descriptionId: (0, _reactId.useId)(),
        open,
        onOpenChange: setOpen,
        onOpenToggle: _react.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal,
        children
    });
};
Dialog.displayName = DIALOG_NAME;
var TRIGGER_NAME = "DialogTrigger";
var DialogTrigger = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog, ...triggerProps } = props;
    const context = useDialogContext(TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, _primitive.composeEventHandlers)(props.onClick, context.onOpenToggle)
    });
});
DialogTrigger.displayName = TRIGGER_NAME;
var PORTAL_NAME = "DialogPortal";
var [PortalProvider, usePortalContext] = createDialogContext(PORTAL_NAME, {
    forceMount: void 0
});
var DialogPortal = (props)=>{
    const { __scopeDialog, forceMount, children, container } = props;
    const context = useDialogContext(PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(PortalProvider, {
        scope: __scopeDialog,
        forceMount,
        children: _react.Children.map(children, (child)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPortal.Portal), {
                    asChild: true,
                    container,
                    children: child
                })
            }))
    });
};
DialogPortal.displayName = PORTAL_NAME;
var OVERLAY_NAME = "DialogOverlay";
var DialogOverlay = _react.forwardRef((props, forwardedRef)=>{
    const portalContext = usePortalContext(OVERLAY_NAME, props.__scopeDialog);
    const { forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = useDialogContext(OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
DialogOverlay.displayName = OVERLAY_NAME;
var Slot = (0, _reactSlot.createSlot)("DialogOverlay.RemoveScroll");
var DialogOverlayImpl = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog, ...overlayProps } = props;
    const context = useDialogContext(OVERLAY_NAME, __scopeDialog);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactRemoveScroll.RemoveScroll), {
        as: Slot,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
            "data-state": getState(context.open),
            ...overlayProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var CONTENT_NAME = "DialogContent";
var DialogContent = _react.forwardRef((props, forwardedRef)=>{
    const portalContext = usePortalContext(CONTENT_NAME, props.__scopeDialog);
    const { forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = useDialogContext(CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
DialogContent.displayName = CONTENT_NAME;
var DialogContentModal = _react.forwardRef((props, forwardedRef)=>{
    const context = useDialogContext(CONTENT_NAME, props.__scopeDialog);
    const contentRef = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, context.contentRef, contentRef);
    _react.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, _ariaHidden.hideOthers)(content);
    }, []);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, _primitive.composeEventHandlers)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, _primitive.composeEventHandlers)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, _primitive.composeEventHandlers)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var DialogContentNonModal = _react.forwardRef((props, forwardedRef)=>{
    const context = useDialogContext(CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = _react.useRef(false);
    const hasPointerDownOutsideRef = _react.useRef(false);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var DialogContentImpl = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog, trapFocus, onOpenAutoFocus, onCloseAutoFocus, ...contentProps } = props;
    const context = useDialogContext(CONTENT_NAME, __scopeDialog);
    const contentRef = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, contentRef);
    (0, _reactFocusGuards.useFocusGuards)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactFocusScope.FocusScope), {
                asChild: true,
                loop: true,
                trapped: trapFocus,
                onMountAutoFocus: onOpenAutoFocus,
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactDismissableLayer.DismissableLayer), {
                    role: "dialog",
                    id: context.contentId,
                    "aria-describedby": context.descriptionId,
                    "aria-labelledby": context.titleId,
                    "data-state": getState(context.open),
                    ...contentProps,
                    ref: composedRefs,
                    onDismiss: ()=>context.onOpenChange(false)
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(TitleWarning, {
                        titleId: context.titleId
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(DescriptionWarning, {
                        contentRef,
                        descriptionId: context.descriptionId
                    })
                ]
            })
        ]
    });
});
var TITLE_NAME = "DialogTitle";
var DialogTitle = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog, ...titleProps } = props;
    const context = useDialogContext(TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
DialogTitle.displayName = TITLE_NAME;
var DESCRIPTION_NAME = "DialogDescription";
var DialogDescription = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog, ...descriptionProps } = props;
    const context = useDialogContext(DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
DialogDescription.displayName = DESCRIPTION_NAME;
var CLOSE_NAME = "DialogClose";
var DialogClose = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog, ...closeProps } = props;
    const context = useDialogContext(CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, _primitive.composeEventHandlers)(props.onClick, ()=>context.onOpenChange(false))
    });
});
DialogClose.displayName = CLOSE_NAME;
function getState(open) {
    return open ? "open" : "closed";
}
var TITLE_WARNING_NAME = "DialogTitleWarning";
var [WarningProvider, useWarningContext] = (0, _reactContext.createContext)(TITLE_WARNING_NAME, {
    contentName: CONTENT_NAME,
    titleName: TITLE_NAME,
    docsSlug: "dialog"
});
var TitleWarning = ({ titleId })=>{
    const titleWarningContext = useWarningContext(TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    _react.useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) console.error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
var DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var DescriptionWarning = ({ contentRef, descriptionId })=>{
    const descriptionWarningContext = useWarningContext(DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    _react.useEffect(()=>{
        const describedById = contentRef.current?.getAttribute("aria-describedby");
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
var Root = Dialog;
var Trigger = DialogTrigger;
var Portal = DialogPortal;
var Overlay = DialogOverlay;
var Content = DialogContent;
var Title = DialogTitle;
var Description = DialogDescription;
var Close = DialogClose;

},{"react":"eGun2","@radix-ui/primitive":"k8C5A","@radix-ui/react-compose-refs":"nN23r","@radix-ui/react-context":"4wywa","@radix-ui/react-id":"hoLx9","@radix-ui/react-use-controllable-state":"ThW7y","@radix-ui/react-dismissable-layer":"gdhJG","@radix-ui/react-focus-scope":"dkOta","@radix-ui/react-portal":"4FFRT","@radix-ui/react-presence":"eh7qi","@radix-ui/react-primitive":"hQJ44","@radix-ui/react-focus-guards":"h3kF4","react-remove-scroll":[["RemoveScroll","emctR","default"]],"aria-hidden":"8h7XP","@radix-ui/react-slot":"4sJVf","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"k8C5A":[function(require,module,exports,__globalThis) {
// src/primitive.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canUseDOM", ()=>canUseDOM);
parcelHelpers.export(exports, "composeEventHandlers", ()=>composeEventHandlers);
parcelHelpers.export(exports, "getActiveElement", ()=>getActiveElement);
parcelHelpers.export(exports, "getOwnerDocument", ()=>getOwnerDocument);
parcelHelpers.export(exports, "getOwnerWindow", ()=>getOwnerWindow);
parcelHelpers.export(exports, "isFrame", ()=>isFrame);
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}
function getOwnerWindow(element) {
    if (!canUseDOM) throw new Error("Cannot access window outside of the DOM");
    return element?.ownerDocument?.defaultView ?? window;
}
function getOwnerDocument(element) {
    if (!canUseDOM) throw new Error("Cannot access document outside of the DOM");
    return element?.ownerDocument ?? document;
}
function getActiveElement(node, activeDescendant = false) {
    const { activeElement } = getOwnerDocument(node);
    if (!activeElement?.nodeName) return null;
    if (isFrame(activeElement) && activeElement.contentDocument) return getActiveElement(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = getOwnerDocument(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
function isFrame(element) {
    return element.tagName === "IFRAME";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4wywa":[function(require,module,exports,__globalThis) {
// packages/react/context/src/create-context.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContext", ()=>createContext2);
parcelHelpers.export(exports, "createContextScope", ()=>createContextScope);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function createContext2(rootComponentName, defaultContext) {
    const Context = _react.createContext(defaultContext);
    const Provider = (props)=>{
        const { children, ...context } = props;
        const value = _react.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Context.Provider, {
            value,
            children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = _react.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function createContextScope(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = _react.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope, children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = _react.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Context.Provider, {
                value,
                children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = _react.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return _react.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return _react.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return _react.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}

},{"react":"eGun2","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hoLx9":[function(require,module,exports,__globalThis) {
// packages/react/id/src/id.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useId", ()=>useId);
var _react = require("react");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var useReactId = _react[" useId ".trim().toString()] || (()=>void 0);
var count = 0;
function useId(deterministicId) {
    const [id, setId] = _react.useState(useReactId());
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String(count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}

},{"react":"eGun2","@radix-ui/react-use-layout-effect":"dRDMB","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dRDMB":[function(require,module,exports,__globalThis) {
// packages/react/use-layout-effect/src/use-layout-effect.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLayoutEffect", ()=>useLayoutEffect2);
var _react = require("react");
var useLayoutEffect2 = globalThis?.document ? _react.useLayoutEffect : ()=>{};

},{"react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ThW7y":[function(require,module,exports,__globalThis) {
// src/use-controllable-state.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useControllableState", ()=>useControllableState);
parcelHelpers.export(exports, "useControllableStateReducer", ()=>useControllableStateReducer);
var _react = require("react");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var _reactUseEffectEvent = require("@radix-ui/react-use-effect-event");
var useInsertionEffect = _react[" useInsertionEffect ".trim().toString()] || (0, _reactUseLayoutEffect.useLayoutEffect);
function useControllableState({ prop, defaultProp, onChange = ()=>{}, caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = useUncontrolledState({
        defaultProp,
        onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = _react.useRef(prop !== void 0);
        _react.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = _react.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function useUncontrolledState({ defaultProp, onChange }) {
    const [value, setValue] = _react.useState(defaultProp);
    const prevValueRef = _react.useRef(value);
    const onChangeRef = _react.useRef(onChange);
    useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    _react.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function isFunction(value) {
    return typeof value === "function";
}
var SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function useControllableStateReducer(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp, onChange: onChangeProp, caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, _reactUseEffectEvent.useEffectEvent)(onChangeProp);
    {
        const isControlledRef = _react.useRef(controlledState !== void 0);
        _react.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = _react.useReducer((state2, action)=>{
        if (action.type === SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = _react.useRef(uncontrolledState);
    _react.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        onChange,
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = _react.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    _react.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}

},{"react":"eGun2","@radix-ui/react-use-layout-effect":"dRDMB","@radix-ui/react-use-effect-event":"6yEjJ","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6yEjJ":[function(require,module,exports,__globalThis) {
// src/use-effect-event.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEffectEvent", ()=>useEffectEvent);
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var _react = require("react");
var useReactEffectEvent = _react[" useEffectEvent ".trim().toString()];
var useReactInsertionEffect = _react[" useInsertionEffect ".trim().toString()];
function useEffectEvent(callback) {
    if (typeof useReactEffectEvent === "function") return useReactEffectEvent(callback);
    const ref = _react.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof useReactInsertionEffect === "function") useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        ref.current = callback;
    });
    return _react.useMemo(()=>(...args)=>ref.current?.(...args), []);
}

},{"@radix-ui/react-use-layout-effect":"dRDMB","react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gdhJG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Branch", ()=>Branch);
parcelHelpers.export(exports, "DismissableLayer", ()=>DismissableLayer);
parcelHelpers.export(exports, "DismissableLayerBranch", ()=>DismissableLayerBranch);
parcelHelpers.export(exports, "Root", ()=>Root);
// src/dismissable-layer.tsx
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactUseCallbackRef = require("@radix-ui/react-use-callback-ref");
var _reactUseEscapeKeydown = require("@radix-ui/react-use-escape-keydown");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var DISMISSABLE_LAYER_NAME = "DismissableLayer";
var CONTEXT_UPDATE = "dismissableLayer.update";
var POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var originalBodyPointerEvents;
var DismissableLayerContext = _react.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var DismissableLayer = _react.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents = false, onEscapeKeyDown, onPointerDownOutside, onFocusOutside, onInteractOutside, onDismiss, ...layerProps } = props;
    const context = _react.useContext(DismissableLayerContext);
    const [node, setNode] = _react.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = _react.useState({});
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, _reactUseEscapeKeydown.useEscapeKeydown)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    _react.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    _react.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    _react.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener(CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener(CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, _primitive.composeEventHandlers)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, _primitive.composeEventHandlers)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, _primitive.composeEventHandlers)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
DismissableLayer.displayName = DISMISSABLE_LAYER_NAME;
var BRANCH_NAME = "DismissableLayerBranch";
var DismissableLayerBranch = _react.forwardRef((props, forwardedRef)=>{
    const context = _react.useContext(DismissableLayerContext);
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    _react.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        ...props,
        ref: composedRefs
    });
});
DismissableLayerBranch.displayName = BRANCH_NAME;
function usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, _reactUseCallbackRef.useCallbackRef)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = _react.useRef(false);
    const handleClickRef = _react.useRef(()=>{});
    _react.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    handleAndDispatchCustomEvent(POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, _reactUseCallbackRef.useCallbackRef)(onFocusOutside);
    const isFocusInsideReactTreeRef = _react.useRef(false);
    _react.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                handleAndDispatchCustomEvent(FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function dispatchUpdate() {
    const event = new CustomEvent(CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function handleAndDispatchCustomEvent(name, handler, detail, { discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, _reactPrimitive.dispatchDiscreteCustomEvent)(target, event);
    else target.dispatchEvent(event);
}
var Root = DismissableLayer;
var Branch = DismissableLayerBranch;

},{"react":"eGun2","@radix-ui/primitive":"k8C5A","@radix-ui/react-primitive":"hQJ44","@radix-ui/react-compose-refs":"nN23r","@radix-ui/react-use-callback-ref":"bakzF","@radix-ui/react-use-escape-keydown":"65kTF","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hQJ44":[function(require,module,exports,__globalThis) {
// src/primitive.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Primitive", ()=>Primitive);
parcelHelpers.export(exports, "Root", ()=>Root);
parcelHelpers.export(exports, "dispatchDiscreteCustomEvent", ()=>dispatchDiscreteCustomEvent);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactSlot = require("@radix-ui/react-slot");
var _jsxRuntime = require("react/jsx-runtime");
var NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var Primitive = NODES.reduce((primitive, node)=>{
    const Slot = (0, _reactSlot.createSlot)(`Primitive.${node}`);
    const Node = _react.forwardRef((props, forwardedRef)=>{
        const { asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function dispatchDiscreteCustomEvent(target, event) {
    if (target) _reactDom.flushSync(()=>target.dispatchEvent(event));
}
var Root = Primitive;

},{"react":"eGun2","react-dom":"bLJc5","@radix-ui/react-slot":"4sJVf","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4sJVf":[function(require,module,exports,__globalThis) {
// src/slot.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Root", ()=>Slot);
parcelHelpers.export(exports, "Slot", ()=>Slot);
parcelHelpers.export(exports, "Slottable", ()=>Slottable);
parcelHelpers.export(exports, "createSlot", ()=>createSlot);
parcelHelpers.export(exports, "createSlottable", ()=>createSlottable);
var _react = require("react");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _jsxRuntime = require("react/jsx-runtime");
// @__NO_SIDE_EFFECTS__
function createSlot(ownerName) {
    const SlotClone = /* @__PURE__ */ createSlotClone(ownerName);
    const Slot2 = _react.forwardRef((props, forwardedRef)=>{
        const { children, ...slotProps } = props;
        const childrenArray = _react.Children.toArray(children);
        const slottable = childrenArray.find(isSlottable);
        if (slottable) {
            const newElement = slottable.props.children;
            const newChildren = childrenArray.map((child)=>{
                if (child === slottable) {
                    if (_react.Children.count(newElement) > 1) return _react.Children.only(null);
                    return _react.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)(SlotClone, {
                ...slotProps,
                ref: forwardedRef,
                children: _react.isValidElement(newElement) ? _react.cloneElement(newElement, void 0, newChildren) : null
            });
        }
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children
        });
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var Slot = /* @__PURE__ */ createSlot("Slot");
// @__NO_SIDE_EFFECTS__
function createSlotClone(ownerName) {
    const SlotClone = _react.forwardRef((props, forwardedRef)=>{
        const { children, ...slotProps } = props;
        if (_react.isValidElement(children)) {
            const childrenRef = getElementRef(children);
            const props2 = mergeProps(slotProps, children.props);
            if (children.type !== _react.Fragment) props2.ref = forwardedRef ? (0, _reactComposeRefs.composeRefs)(forwardedRef, childrenRef) : childrenRef;
            return _react.cloneElement(children, props2);
        }
        return _react.Children.count(children) > 1 ? _react.Children.only(null) : null;
    });
    SlotClone.displayName = `${ownerName}.SlotClone`;
    return SlotClone;
}
var SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function createSlottable(ownerName) {
    const Slottable2 = ({ children })=>{
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children
        });
    };
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var Slottable = /* @__PURE__ */ createSlottable("Slottable");
function isSlottable(child) {
    return _react.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === SLOTTABLE_IDENTIFIER;
}
function mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}

},{"react":"eGun2","@radix-ui/react-compose-refs":"nN23r","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bakzF":[function(require,module,exports,__globalThis) {
// packages/react/use-callback-ref/src/use-callback-ref.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallbackRef", ()=>useCallbackRef);
var _react = require("react");
function useCallbackRef(callback) {
    const callbackRef = _react.useRef(callback);
    _react.useEffect(()=>{
        callbackRef.current = callback;
    });
    return _react.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}

},{"react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"65kTF":[function(require,module,exports,__globalThis) {
// packages/react/use-escape-keydown/src/use-escape-keydown.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEscapeKeydown", ()=>useEscapeKeydown);
var _react = require("react");
var _reactUseCallbackRef = require("@radix-ui/react-use-callback-ref");
function useEscapeKeydown(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, _reactUseCallbackRef.useCallbackRef)(onEscapeKeyDownProp);
    _react.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}

},{"react":"eGun2","@radix-ui/react-use-callback-ref":"bakzF","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dkOta":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusScope", ()=>FocusScope);
parcelHelpers.export(exports, "Root", ()=>Root);
// src/focus-scope.tsx
var _react = require("react");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactUseCallbackRef = require("@radix-ui/react-use-callback-ref");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var FOCUS_SCOPE_NAME = "FocusScope";
var FocusScope = _react.forwardRef((props, forwardedRef)=>{
    const { loop = false, trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = _react.useState(null);
    const onMountAutoFocus = (0, _reactUseCallbackRef.useCallbackRef)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, _reactUseCallbackRef.useCallbackRef)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, (node)=>setContainer(node));
    const focusScope = _react.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    _react.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    _react.useEffect(()=>{
        if (container) {
            focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent(AUTOFOCUS_ON_MOUNT, EVENT_OPTIONS);
                container.addEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    focusFirst(removeLinks(getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) focus(container);
                }
            }
            return ()=>{
                container.removeEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent(AUTOFOCUS_ON_UNMOUNT, EVENT_OPTIONS);
                    container.addEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = _react.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
FocusScope.displayName = FOCUS_SCOPE_NAME;
function focusFirst(candidates, { select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        focus(candidate, {
            select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function getTabbableEdges(container) {
    const candidates = getTabbableCandidates(container);
    const first = findVisible(candidates, container);
    const last = findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function findVisible(elements, container) {
    for (const element of elements){
        if (!isHidden(element, {
            upTo: container
        })) return element;
    }
}
function isHidden(node, { upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function focus(element, { select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && isSelectableInput(element) && select) element.select();
    }
}
var focusScopesStack = createFocusScopesStack();
function createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var Root = FocusScope;

},{"react":"eGun2","@radix-ui/react-compose-refs":"nN23r","@radix-ui/react-primitive":"hQJ44","@radix-ui/react-use-callback-ref":"bakzF","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4FFRT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Portal", ()=>Portal);
parcelHelpers.export(exports, "Root", ()=>Root);
// src/portal.tsx
var _react = require("react");
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var PORTAL_NAME = "Portal";
var Portal = _react.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = _react.useState(false);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, _reactDomDefault.default).createPortal(/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
Portal.displayName = PORTAL_NAME;
var Root = Portal;

},{"react":"eGun2","react-dom":"bLJc5","@radix-ui/react-primitive":"hQJ44","@radix-ui/react-use-layout-effect":"dRDMB","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eh7qi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Presence", ()=>Presence);
parcelHelpers.export(exports, "Root", ()=>Root);
// src/presence.tsx
var _react = require("react");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
"use client";
function useStateMachine(initialState, machine) {
    return _react.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// src/presence.tsx
var Presence = (props)=>{
    const { present, children } = props;
    const presence = usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : _react.Children.only(children);
    const ref = (0, _reactComposeRefs.useComposedRefs)(presence.ref, getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? _react.cloneElement(child, {
        ref
    }) : null;
};
Presence.displayName = "Presence";
function usePresence(present) {
    const [node, setNode] = _react.useState();
    const stylesRef = _react.useRef(null);
    const prevPresentRef = _react.useRef(present);
    const prevAnimationNameRef = _react.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    _react.useEffect(()=>{
        const currentAnimationName = getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: _react.useCallback((node2)=>{
            stylesRef.current = node2 ? getComputedStyle(node2) : null;
            setNode(node2);
        }, [])
    };
}
function getAnimationName(styles) {
    return styles?.animationName || "none";
}
function getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var Root = Presence;

},{"react":"eGun2","@radix-ui/react-compose-refs":"nN23r","@radix-ui/react-use-layout-effect":"dRDMB","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"h3kF4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusGuards", ()=>FocusGuards);
parcelHelpers.export(exports, "Root", ()=>FocusGuards);
parcelHelpers.export(exports, "useFocusGuards", ()=>useFocusGuards);
// src/focus-guards.tsx
var _react = require("react");
"use client";
var count = 0;
function FocusGuards(props) {
    useFocusGuards();
    return props.children;
}
function useFocusGuards() {
    _react.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? createFocusGuard());
        document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? createFocusGuard());
        count++;
        return ()=>{
            if (count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            count--;
        };
    }, []);
}
function createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}

},{"react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"emctR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _react = require("react");
var _ui = require("./UI");
var _sidecar = require("./sidecar");
var _sidecarDefault = parcelHelpers.interopDefault(_sidecar);
var ReactRemoveScroll = _react.forwardRef(function(props, ref) {
    return _react.createElement((0, _ui.RemoveScroll), (0, _tslib.__assign)({}, props, {
        ref: ref,
        sideCar: (0, _sidecarDefault.default)
    }));
});
ReactRemoveScroll.classNames = (0, _ui.RemoveScroll).classNames;
exports.default = ReactRemoveScroll;

},{"tslib":"kZvKw","react":"eGun2","./UI":"6NzQx","./sidecar":"eAgDk","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kZvKw":[function(require,module,exports,__globalThis) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
parcelHelpers.export(exports, "__rewriteRelativeImportExtension", ()=>__rewriteRelativeImportExtension);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __esDecorate: __esDecorate,
    __runInitializers: __runInitializers,
    __propKey: __propKey,
    __setFunctionName: __setFunctionName,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
    __rewriteRelativeImportExtension: __rewriteRelativeImportExtension
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6NzQx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveScroll", ()=>RemoveScroll);
var _tslib = require("tslib");
var _react = require("react");
var _constants = require("react-remove-scroll-bar/constants");
var _useCallbackRef = require("use-callback-ref");
var _medium = require("./medium");
var nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var RemoveScroll = _react.forwardRef(function(props, parentRef) {
    var ref = _react.useRef(null);
    var _a = _react.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, _tslib.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, _useCallbackRef.useMergeRefs)([
        ref,
        parentRef
    ]);
    var containerProps = (0, _tslib.__assign)((0, _tslib.__assign)({}, rest), callbacks);
    return _react.createElement(_react.Fragment, null, enabled && _react.createElement(SideCar, {
        sideCar: (0, _medium.effectCar),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? _react.cloneElement(_react.Children.only(children), (0, _tslib.__assign)((0, _tslib.__assign)({}, containerProps), {
        ref: containerRef
    })) : _react.createElement(Container, (0, _tslib.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
RemoveScroll.classNames = {
    fullWidth: (0, _constants.fullWidthClassName),
    zeroRight: (0, _constants.zeroRightClassName)
};

},{"tslib":"kZvKw","react":"eGun2","react-remove-scroll-bar/constants":"dGhng","use-callback-ref":"b6WP1","./medium":"l0jZy","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dGhng":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zeroRightClassName", ()=>zeroRightClassName);
parcelHelpers.export(exports, "fullWidthClassName", ()=>fullWidthClassName);
parcelHelpers.export(exports, "noScrollbarsClassName", ()=>noScrollbarsClassName);
parcelHelpers.export(exports, "removedBarSizeVariable", ()=>removedBarSizeVariable);
var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
var removedBarSizeVariable = '--removed-body-scroll-bar-size';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"b6WP1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */ parcelHelpers.export(exports, "useMergeRefs", ()=>useMergeRefs);
var _react = require("react");
var _assignRef = require("./assignRef");
var _useRef = require("./useRef");
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
var currentValues = new WeakMap();
function useMergeRefs(refs, defaultValue) {
    var callbackRef = (0, _useRef.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, _assignRef.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    useIsomorphicLayoutEffect(function() {
        var oldValue = currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, _assignRef.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, _assignRef.assignRef)(ref, current_1);
            });
        }
        currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

},{"react":"eGun2","./assignRef":"iOLNx","./useRef":"ki02R","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"iOLNx":[function(require,module,exports,__globalThis) {
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignRef", ()=>assignRef);
function assignRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ki02R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */ parcelHelpers.export(exports, "useCallbackRef", ()=>useCallbackRef);
var _react = require("react");
function useCallbackRef(initialValue, callback) {
    var ref = (0, _react.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

},{"react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"l0jZy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "effectCar", ()=>effectCar);
var _useSidecar = require("use-sidecar");
var effectCar = (0, _useSidecar.createSidecarMedium)();

},{"use-sidecar":"5TsCk","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5TsCk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMedium", ()=>createMedium);
// eslint-disable-next-line @typescript-eslint/ban-types
parcelHelpers.export(exports, "createSidecarMedium", ()=>createSidecarMedium);
var _tslib = require("tslib");
function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) middleware = ItoI;
    return innerCreateMedium(defaults, middleware);
}
function createSidecarMedium(options) {
    if (options === void 0) options = {};
    var medium = innerCreateMedium(null);
    medium.options = (0, _tslib.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

},{"tslib":"kZvKw","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eAgDk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useSidecar = require("use-sidecar");
var _sideEffect = require("./SideEffect");
var _medium = require("./medium");
exports.default = (0, _useSidecar.exportSidecar)((0, _medium.effectCar), (0, _sideEffect.RemoveScrollSideCar));

},{"use-sidecar":"ci700","./SideEffect":"cDhSA","./medium":"l0jZy","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ci700":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exportSidecar", ()=>exportSidecar);
var _tslib = require("tslib");
var _react = require("react");
var SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, _tslib.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return _react.createElement(Target, (0, _tslib.__assign)({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar;
}

},{"tslib":"kZvKw","react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cDhSA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTouchXY", ()=>getTouchXY);
parcelHelpers.export(exports, "getDeltaXY", ()=>getDeltaXY);
parcelHelpers.export(exports, "RemoveScrollSideCar", ()=>RemoveScrollSideCar);
var _tslib = require("tslib");
var _react = require("react");
var _reactRemoveScrollBar = require("react-remove-scroll-bar");
var _reactStyleSingleton = require("react-style-singleton");
var _aggresiveCapture = require("./aggresiveCapture");
var _handleScroll = require("./handleScroll");
var getTouchXY = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var getDeltaXY = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = _react.useRef([]);
    var touchStartRef = _react.useRef([
        0,
        0
    ]);
    var activeAxis = _react.useRef();
    var id = _react.useState(idCounter++)[0];
    var Style = _react.useState((0, _reactStyleSingleton.styleSingleton))[0];
    var lastProps = _react.useRef(props);
    _react.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    _react.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, _tslib.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map(extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = _react.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
        var selection = window.getSelection();
        var anchorNode = selection && selection.anchorNode;
        var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
        if (isTouchingSelection) return false;
        var canBeScrolledInMainDirection = (0, _handleScroll.locationCouldBeScrolled)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, _handleScroll.locationCouldBeScrolled)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, _handleScroll.handleScroll)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = _react.useCallback(function(_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = _react.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = _react.useCallback(function(event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = _react.useCallback(function(event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = _react.useCallback(function(event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    _react.useEffect(function() {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, _aggresiveCapture.nonPassive));
        document.addEventListener('touchmove', shouldPrevent, (0, _aggresiveCapture.nonPassive));
        document.addEventListener('touchstart', scrollTouchStart, (0, _aggresiveCapture.nonPassive));
        return function() {
            lockStack = lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, _aggresiveCapture.nonPassive));
            document.removeEventListener('touchmove', shouldPrevent, (0, _aggresiveCapture.nonPassive));
            document.removeEventListener('touchstart', scrollTouchStart, (0, _aggresiveCapture.nonPassive));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return _react.createElement(_react.Fragment, null, inert ? _react.createElement(Style, {
        styles: generateStyle(id)
    }) : null, removeScrollBar ? _react.createElement((0, _reactRemoveScrollBar.RemoveScrollBar), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}

},{"tslib":"kZvKw","react":"eGun2","react-remove-scroll-bar":"cyRPg","react-style-singleton":"3CJEC","./aggresiveCapture":"OVhww","./handleScroll":"don5p","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cyRPg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveScrollBar", ()=>(0, _component.RemoveScrollBar));
parcelHelpers.export(exports, "zeroRightClassName", ()=>(0, _constants.zeroRightClassName));
parcelHelpers.export(exports, "fullWidthClassName", ()=>(0, _constants.fullWidthClassName));
parcelHelpers.export(exports, "noScrollbarsClassName", ()=>(0, _constants.noScrollbarsClassName));
parcelHelpers.export(exports, "removedBarSizeVariable", ()=>(0, _constants.removedBarSizeVariable));
parcelHelpers.export(exports, "getGapWidth", ()=>(0, _utils.getGapWidth));
var _component = require("./component");
var _constants = require("./constants");
var _utils = require("./utils");

},{"./component":"ddno0","./constants":"dGhng","./utils":"4KGAJ","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ddno0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lockAttribute", ()=>lockAttribute);
parcelHelpers.export(exports, "useLockAttribute", ()=>useLockAttribute);
parcelHelpers.export(exports, "RemoveScrollBar", ()=>RemoveScrollBar);
var _react = require("react");
var _reactStyleSingleton = require("react-style-singleton");
var _constants = require("./constants");
var _utils = require("./utils");
var Style = (0, _reactStyleSingleton.styleSingleton)();
var lockAttribute = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, _constants.noScrollbarsClassName), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, _constants.zeroRightClassName), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, _constants.fullWidthClassName), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, _constants.zeroRightClassName), " .").concat((0, _constants.zeroRightClassName), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, _constants.fullWidthClassName), " .").concat((0, _constants.fullWidthClassName), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat((0, _constants.removedBarSizeVariable), ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute(lockAttribute) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function() {
    _react.useEffect(function() {
        document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute(lockAttribute);
            else document.body.setAttribute(lockAttribute, newCounter.toString());
        };
    }, []);
};
var RemoveScrollBar = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    useLockAttribute();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = _react.useMemo(function() {
        return (0, _utils.getGapWidth)(gapMode);
    }, [
        gapMode
    ]);
    return _react.createElement(Style, {
        styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};

},{"react":"eGun2","react-style-singleton":"3CJEC","./constants":"dGhng","./utils":"4KGAJ","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3CJEC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleSingleton", ()=>(0, _component.styleSingleton));
parcelHelpers.export(exports, "stylesheetSingleton", ()=>(0, _singleton.stylesheetSingleton));
parcelHelpers.export(exports, "styleHookSingleton", ()=>(0, _hook.styleHookSingleton));
var _component = require("./component");
var _singleton = require("./singleton");
var _hook = require("./hook");

},{"./component":"f5Igz","./singleton":"6VG09","./hook":"hucpQ","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"f5Igz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleSingleton", ()=>styleSingleton);
var _hook = require("./hook");
var styleSingleton = function() {
    var useStyle = (0, _hook.styleHookSingleton)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

},{"./hook":"hucpQ","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hucpQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleHookSingleton", ()=>styleHookSingleton);
var _react = require("react");
var _singleton = require("./singleton");
var styleHookSingleton = function() {
    var sheet = (0, _singleton.stylesheetSingleton)();
    return function(styles, isDynamic) {
        _react.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};

},{"react":"eGun2","./singleton":"6VG09","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6VG09":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stylesheetSingleton", ()=>stylesheetSingleton);
var _getNonce = require("get-nonce");
function makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, _getNonce.getNonce)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = makeStyleTag()) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

},{"get-nonce":"apbFN","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"apbFN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setNonce", ()=>setNonce);
parcelHelpers.export(exports, "getNonce", ()=>getNonce);
var currentNonce;
var setNonce = function(nonce) {
    currentNonce = nonce;
};
var getNonce = function() {
    if (currentNonce) return currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4KGAJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zeroGap", ()=>zeroGap);
parcelHelpers.export(exports, "getGapWidth", ()=>getGapWidth);
var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        parse(left),
        parse(top),
        parse(right)
    ];
};
var getGapWidth = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return zeroGap;
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"OVhww":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nonPassive", ()=>nonPassive);
var passiveSupported = false;
if (typeof window !== 'undefined') try {
    var options = Object.defineProperty({}, 'passive', {
        get: function() {
            passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', options, options);
    // @ts-ignore
    window.removeEventListener('test', options, options);
} catch (err) {
    passiveSupported = false;
}
var nonPassive = passiveSupported ? {
    passive: false
} : false;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"don5p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "locationCouldBeScrolled", ()=>locationCouldBeScrolled);
parcelHelpers.export(exports, "handleScroll", ()=>handleScroll);
var alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var elementCouldBeVScrolled = function(node) {
    return elementCanBeScrolled(node, 'overflowY');
};
var elementCouldBeHScrolled = function(node) {
    return elementCanBeScrolled(node, 'overflowX');
};
var locationCouldBeScrolled = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function(axis, node) {
    return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8h7XP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hideOthers", ()=>hideOthers);
parcelHelpers.export(exports, "inertOthers", ()=>inertOthers);
parcelHelpers.export(exports, "supportsInert", ()=>supportsInert);
parcelHelpers.export(exports, "suppressOthers", ()=>suppressOthers);
var getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function(node) {
    return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!markerMap[markerName]) markerMap[markerName] = new WeakMap();
    var markerCounter = markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = (counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        lockCount--;
        if (!lockCount) {
            // clear
            counterMap = new WeakMap();
            counterMap = new WeakMap();
            uncontrolledNodes = new WeakMap();
            markerMap = {};
        }
    };
};
var hideOthers = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var inertOthers = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var supportsInert = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var suppressOthers = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return (supportsInert() ? inertOthers : hideOthers)(originalTarget, parentNode, markerName);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8HSxK":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>X);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const X = (0, _createLucideIconJsDefault.default)("x", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bIzUl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Skeleton", ()=>Skeleton);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@/client/lib/utils");
function Skeleton({ className, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _utils.cn)("animate-pulse rounded-md bg-muted", className),
        ...props
    });
}

},{"react/jsx-runtime":"dQjte","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dWqZd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
parcelHelpers.export(exports, "TooltipTrigger", ()=>TooltipTrigger);
parcelHelpers.export(exports, "TooltipContent", ()=>TooltipContent);
parcelHelpers.export(exports, "TooltipProvider", ()=>TooltipProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactTooltip = require("@radix-ui/react-tooltip");
var _utils = require("@/client/lib/utils");
const TooltipProvider = _reactTooltip.Provider;
const Tooltip = _reactTooltip.Root;
const TooltipTrigger = _reactTooltip.Trigger;
const TooltipContent = /*#__PURE__*/ _react.forwardRef(({ className, sideOffset = 4, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactTooltip.Portal, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactTooltip.Content, {
            ref: ref,
            sideOffset: sideOffset,
            className: (0, _utils.cn)("z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-tooltip-content-transform-origin]", className),
            ...props
        })
    }));
TooltipContent.displayName = _reactTooltip.Content.displayName;

},{"react/jsx-runtime":"dQjte","react":"eGun2","@radix-ui/react-tooltip":"M6m6B","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"M6m6B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Arrow", ()=>Arrow2);
parcelHelpers.export(exports, "Content", ()=>Content2);
parcelHelpers.export(exports, "Portal", ()=>Portal);
parcelHelpers.export(exports, "Provider", ()=>Provider);
parcelHelpers.export(exports, "Root", ()=>Root3);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
parcelHelpers.export(exports, "TooltipArrow", ()=>TooltipArrow);
parcelHelpers.export(exports, "TooltipContent", ()=>TooltipContent);
parcelHelpers.export(exports, "TooltipPortal", ()=>TooltipPortal);
parcelHelpers.export(exports, "TooltipProvider", ()=>TooltipProvider);
parcelHelpers.export(exports, "TooltipTrigger", ()=>TooltipTrigger);
parcelHelpers.export(exports, "Trigger", ()=>Trigger);
parcelHelpers.export(exports, "createTooltipScope", ()=>createTooltipScope);
// src/tooltip.tsx
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactContext = require("@radix-ui/react-context");
var _reactDismissableLayer = require("@radix-ui/react-dismissable-layer");
var _reactId = require("@radix-ui/react-id");
var _reactPopper = require("@radix-ui/react-popper");
var _reactPortal = require("@radix-ui/react-portal");
var _reactPresence = require("@radix-ui/react-presence");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactSlot = require("@radix-ui/react-slot");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _reactVisuallyHidden = require("@radix-ui/react-visually-hidden");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var [createTooltipContext, createTooltipScope] = (0, _reactContext.createContextScope)("Tooltip", [
    (0, _reactPopper.createPopperScope)
]);
var usePopperScope = (0, _reactPopper.createPopperScope)();
var PROVIDER_NAME = "TooltipProvider";
var DEFAULT_DELAY_DURATION = 700;
var TOOLTIP_OPEN = "tooltip.open";
var [TooltipProviderContextProvider, useTooltipProviderContext] = createTooltipContext(PROVIDER_NAME);
var TooltipProvider = (props)=>{
    const { __scopeTooltip, delayDuration = DEFAULT_DELAY_DURATION, skipDelayDuration = 300, disableHoverableContent = false, children } = props;
    const isOpenDelayedRef = _react.useRef(true);
    const isPointerInTransitRef = _react.useRef(false);
    const skipDelayTimerRef = _react.useRef(0);
    _react.useEffect(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer);
    }, []);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayedRef,
        delayDuration,
        onOpen: _react.useCallback(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            isOpenDelayedRef.current = false;
        }, []),
        onClose: _react.useCallback(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>isOpenDelayedRef.current = true, skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef,
        onPointerInTransitChange: _react.useCallback((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent,
        children
    });
};
TooltipProvider.displayName = PROVIDER_NAME;
var TOOLTIP_NAME = "Tooltip";
var [TooltipContextProvider, useTooltipContext] = createTooltipContext(TOOLTIP_NAME);
var Tooltip = (props)=>{
    const { __scopeTooltip, children, open: openProp, defaultOpen, onOpenChange, disableHoverableContent: disableHoverableContentProp, delayDuration: delayDurationProp } = props;
    const providerContext = useTooltipProviderContext(TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = _react.useState(null);
    const contentId = (0, _reactId.useId)();
    const openTimerRef = _react.useRef(0);
    const disableHoverableContent = disableHoverableContentProp ?? providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp ?? providerContext.delayDuration;
    const wasOpenDelayedRef = _react.useRef(false);
    const [open, setOpen] = (0, _reactUseControllableState.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: (open2)=>{
            if (open2) {
                providerContext.onOpen();
                document.dispatchEvent(new CustomEvent(TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange?.(open2);
        },
        caller: TOOLTIP_NAME
    });
    const stateAttribute = _react.useMemo(()=>{
        return open ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
    }, [
        open
    ]);
    const handleOpen = _react.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = 0;
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = _react.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = 0;
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = _react.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
            openTimerRef.current = 0;
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    _react.useEffect(()=>{
        return ()=>{
            if (openTimerRef.current) {
                window.clearTimeout(openTimerRef.current);
                openTimerRef.current = 0;
            }
        };
    }, []);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Root, {
        ...popperScope,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(TooltipContextProvider, {
            scope: __scopeTooltip,
            contentId,
            open,
            stateAttribute,
            trigger,
            onTriggerChange: setTrigger,
            onTriggerEnter: _react.useCallback(()=>{
                if (providerContext.isOpenDelayedRef.current) handleDelayedOpen();
                else handleOpen();
            }, [
                providerContext.isOpenDelayedRef,
                handleDelayedOpen,
                handleOpen
            ]),
            onTriggerLeave: _react.useCallback(()=>{
                if (disableHoverableContent) handleClose();
                else {
                    window.clearTimeout(openTimerRef.current);
                    openTimerRef.current = 0;
                }
            }, [
                handleClose,
                disableHoverableContent
            ]),
            onOpen: handleOpen,
            onClose: handleClose,
            disableHoverableContent,
            children
        })
    });
};
Tooltip.displayName = TOOLTIP_NAME;
var TRIGGER_NAME = "TooltipTrigger";
var TooltipTrigger = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip, ...triggerProps } = props;
    const context = useTooltipContext(TRIGGER_NAME, __scopeTooltip);
    const providerContext = useTooltipProviderContext(TRIGGER_NAME, __scopeTooltip);
    const popperScope = usePopperScope(__scopeTooltip);
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = _react.useRef(false);
    const hasPointerMoveOpenedRef = _react.useRef(false);
    const handlePointerUp = _react.useCallback(()=>isPointerDownRef.current = false, []);
    _react.useEffect(()=>{
        return ()=>document.removeEventListener("pointerup", handlePointerUp);
    }, [
        handlePointerUp
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Anchor, {
        asChild: true,
        ...popperScope,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).button, {
            "aria-describedby": context.open ? context.contentId : void 0,
            "data-state": context.stateAttribute,
            ...triggerProps,
            ref: composedRefs,
            onPointerMove: (0, _primitive.composeEventHandlers)(props.onPointerMove, (event)=>{
                if (event.pointerType === "touch") return;
                if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                    context.onTriggerEnter();
                    hasPointerMoveOpenedRef.current = true;
                }
            }),
            onPointerLeave: (0, _primitive.composeEventHandlers)(props.onPointerLeave, ()=>{
                context.onTriggerLeave();
                hasPointerMoveOpenedRef.current = false;
            }),
            onPointerDown: (0, _primitive.composeEventHandlers)(props.onPointerDown, ()=>{
                if (context.open) context.onClose();
                isPointerDownRef.current = true;
                document.addEventListener("pointerup", handlePointerUp, {
                    once: true
                });
            }),
            onFocus: (0, _primitive.composeEventHandlers)(props.onFocus, ()=>{
                if (!isPointerDownRef.current) context.onOpen();
            }),
            onBlur: (0, _primitive.composeEventHandlers)(props.onBlur, context.onClose),
            onClick: (0, _primitive.composeEventHandlers)(props.onClick, context.onClose)
        })
    });
});
TooltipTrigger.displayName = TRIGGER_NAME;
var PORTAL_NAME = "TooltipPortal";
var [PortalProvider, usePortalContext] = createTooltipContext(PORTAL_NAME, {
    forceMount: void 0
});
var TooltipPortal = (props)=>{
    const { __scopeTooltip, forceMount, children, container } = props;
    const context = useTooltipContext(PORTAL_NAME, __scopeTooltip);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(PortalProvider, {
        scope: __scopeTooltip,
        forceMount,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPortal.Portal), {
                asChild: true,
                container,
                children
            })
        })
    });
};
TooltipPortal.displayName = PORTAL_NAME;
var CONTENT_NAME = "TooltipContent";
var TooltipContent = _react.forwardRef((props, forwardedRef)=>{
    const portalContext = usePortalContext(CONTENT_NAME, props.__scopeTooltip);
    const { forceMount = portalContext.forceMount, side = "top", ...contentProps } = props;
    const context = useTooltipContext(CONTENT_NAME, props.__scopeTooltip);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
        present: forceMount || context.open,
        children: context.disableHoverableContent ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(TooltipContentImpl, {
            side,
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(TooltipContentHoverable, {
            side,
            ...contentProps,
            ref: forwardedRef
        })
    });
});
var TooltipContentHoverable = _react.forwardRef((props, forwardedRef)=>{
    const context = useTooltipContext(CONTENT_NAME, props.__scopeTooltip);
    const providerContext = useTooltipProviderContext(CONTENT_NAME, props.__scopeTooltip);
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = _react.useState(null);
    const { trigger, onClose } = context;
    const content = ref.current;
    const { onPointerInTransitChange } = providerContext;
    const handleRemoveGraceArea = _react.useCallback(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = _react.useCallback((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const paddedExitPoints = getPaddedExitPoints(exitPoint, exitSide);
        const hoverTargetPoints = getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = getHull([
            ...paddedExitPoints,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    _react.useEffect(()=>{
        return ()=>handleRemoveGraceArea();
    }, [
        handleRemoveGraceArea
    ]);
    _react.useEffect(()=>{
        if (trigger && content) {
            const handleTriggerLeave = (event)=>handleCreateGraceArea(event, content);
            const handleContentLeave = (event)=>handleCreateGraceArea(event, trigger);
            trigger.addEventListener("pointerleave", handleTriggerLeave);
            content.addEventListener("pointerleave", handleContentLeave);
            return ()=>{
                trigger.removeEventListener("pointerleave", handleTriggerLeave);
                content.removeEventListener("pointerleave", handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    _react.useEffect(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = (event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = trigger?.contains(target) || content?.contains(target);
                const isPointerOutsideGraceArea = !isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            };
            document.addEventListener("pointermove", handleTrackPointerGrace);
            return ()=>document.removeEventListener("pointermove", handleTrackPointerGrace);
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(TooltipContentImpl, {
        ...props,
        ref: composedRefs
    });
});
var [VisuallyHiddenContentContextProvider, useVisuallyHiddenContentContext] = createTooltipContext(TOOLTIP_NAME, {
    isInside: false
});
var Slottable = (0, _reactSlot.createSlottable)("TooltipContent");
var TooltipContentImpl = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip, children, "aria-label": ariaLabel, onEscapeKeyDown, onPointerDownOutside, ...contentProps } = props;
    const context = useTooltipContext(CONTENT_NAME, __scopeTooltip);
    const popperScope = usePopperScope(__scopeTooltip);
    const { onClose } = context;
    _react.useEffect(()=>{
        document.addEventListener(TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener(TOOLTIP_OPEN, onClose);
    }, [
        onClose
    ]);
    _react.useEffect(()=>{
        if (context.trigger) {
            const handleScroll = (event)=>{
                const target = event.target;
                if (target?.contains(context.trigger)) onClose();
            };
            window.addEventListener("scroll", handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener("scroll", handleScroll, {
                    capture: true
                });
        }
    }, [
        context.trigger,
        onClose
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactDismissableLayer.DismissableLayer), {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown,
        onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: onClose,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)(_reactPopper.Content, {
            "data-state": context.stateAttribute,
            ...popperScope,
            ...contentProps,
            ref: forwardedRef,
            style: {
                ...contentProps.style,
                "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
                "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
                "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)(Slottable, {
                    children
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)(VisuallyHiddenContentContextProvider, {
                    scope: __scopeTooltip,
                    isInside: true,
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactVisuallyHidden.Root, {
                        id: context.contentId,
                        role: "tooltip",
                        children: ariaLabel || children
                    })
                })
            ]
        })
    });
});
TooltipContent.displayName = CONTENT_NAME;
var ARROW_NAME = "TooltipArrow";
var TooltipArrow = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip, ...arrowProps } = props;
    const popperScope = usePopperScope(__scopeTooltip);
    const visuallyHiddenContentContext = useVisuallyHiddenContentContext(ARROW_NAME, __scopeTooltip);
    return visuallyHiddenContentContext.isInside ? null : /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Arrow, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
TooltipArrow.displayName = ARROW_NAME;
function getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return "left";
        case right:
            return "right";
        case top:
            return "top";
        case bottom:
            return "bottom";
        default:
            throw new Error("unreachable");
    }
}
function getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
    const paddedExitPoints = [];
    switch(exitSide){
        case "top":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "bottom":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            });
            break;
        case "left":
            paddedExitPoints.push({
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "right":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            });
            break;
    }
    return paddedExitPoints;
}
function getPointsFromRect(rect) {
    const { top, right, bottom, left } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
}
function isPointInPolygon(point, polygon) {
    const { x, y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const ii = polygon[i];
        const jj = polygon[j];
        const xi = ii.x;
        const yi = ii.y;
        const xj = jj.x;
        const yj = jj.y;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return getHullPresorted(newPoints);
}
function getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i = points.length - 1; i >= 0; i--){
        const p = points[i];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
var Provider = TooltipProvider;
var Root3 = Tooltip;
var Trigger = TooltipTrigger;
var Portal = TooltipPortal;
var Content2 = TooltipContent;
var Arrow2 = TooltipArrow;

},{"react":"eGun2","@radix-ui/primitive":"k8C5A","@radix-ui/react-compose-refs":"nN23r","@radix-ui/react-context":"4wywa","@radix-ui/react-dismissable-layer":"gdhJG","@radix-ui/react-id":"hoLx9","@radix-ui/react-popper":"5wakN","@radix-ui/react-portal":"4FFRT","@radix-ui/react-presence":"eh7qi","@radix-ui/react-primitive":"hQJ44","@radix-ui/react-slot":"4sJVf","@radix-ui/react-use-controllable-state":"ThW7y","@radix-ui/react-visually-hidden":"iPxB6","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5wakN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALIGN_OPTIONS", ()=>ALIGN_OPTIONS);
parcelHelpers.export(exports, "Anchor", ()=>Anchor);
parcelHelpers.export(exports, "Arrow", ()=>Arrow);
parcelHelpers.export(exports, "Content", ()=>Content);
parcelHelpers.export(exports, "Popper", ()=>Popper);
parcelHelpers.export(exports, "PopperAnchor", ()=>PopperAnchor);
parcelHelpers.export(exports, "PopperArrow", ()=>PopperArrow);
parcelHelpers.export(exports, "PopperContent", ()=>PopperContent);
parcelHelpers.export(exports, "Root", ()=>Root2);
parcelHelpers.export(exports, "SIDE_OPTIONS", ()=>SIDE_OPTIONS);
parcelHelpers.export(exports, "createPopperScope", ()=>createPopperScope);
// src/popper.tsx
var _react = require("react");
var _reactDom = require("@floating-ui/react-dom");
var _reactArrow = require("@radix-ui/react-arrow");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactContext = require("@radix-ui/react-context");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactUseCallbackRef = require("@radix-ui/react-use-callback-ref");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var _reactUseSize = require("@radix-ui/react-use-size");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var SIDE_OPTIONS = [
    "top",
    "right",
    "bottom",
    "left"
];
var ALIGN_OPTIONS = [
    "start",
    "center",
    "end"
];
var POPPER_NAME = "Popper";
var [createPopperContext, createPopperScope] = (0, _reactContext.createContextScope)(POPPER_NAME);
var [PopperProvider, usePopperContext] = createPopperContext(POPPER_NAME);
var Popper = (props)=>{
    const { __scopePopper, children } = props;
    const [anchor, setAnchor] = _react.useState(null);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(PopperProvider, {
        scope: __scopePopper,
        anchor,
        onAnchorChange: setAnchor,
        children
    });
};
Popper.displayName = POPPER_NAME;
var ANCHOR_NAME = "PopperAnchor";
var PopperAnchor = _react.forwardRef((props, forwardedRef)=>{
    const { __scopePopper, virtualRef, ...anchorProps } = props;
    const context = usePopperContext(ANCHOR_NAME, __scopePopper);
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    const anchorRef = _react.useRef(null);
    _react.useEffect(()=>{
        const previousAnchor = anchorRef.current;
        anchorRef.current = virtualRef?.current || ref.current;
        if (previousAnchor !== anchorRef.current) context.onAnchorChange(anchorRef.current);
    });
    return virtualRef ? null : /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        ...anchorProps,
        ref: composedRefs
    });
});
PopperAnchor.displayName = ANCHOR_NAME;
var CONTENT_NAME = "PopperContent";
var [PopperContentProvider, useContentContext] = createPopperContext(CONTENT_NAME);
var PopperContent = _react.forwardRef((props, forwardedRef)=>{
    const { __scopePopper, side = "bottom", sideOffset = 0, align = "center", alignOffset = 0, arrowPadding = 0, avoidCollisions = true, collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky = "partial", hideWhenDetached = false, updatePositionStrategy = "optimized", onPlaced, ...contentProps } = props;
    const context = usePopperContext(CONTENT_NAME, __scopePopper);
    const [content, setContent] = _react.useState(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = _react.useState(null);
    const arrowSize = (0, _reactUseSize.useSize)(arrow);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter(isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs, floatingStyles, placement, isPositioned, middlewareData } = (0, _reactDom.useFloating)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, _reactDom.autoUpdate)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, _reactDom.offset)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, _reactDom.shift)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, _reactDom.limitShift)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, _reactDom.flip)({
                ...detectOverflowOptions
            }),
            (0, _reactDom.size)({
                ...detectOverflowOptions,
                apply: ({ elements, rects, availableWidth, availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, _reactDom.arrow)({
                element: arrow,
                padding: arrowPadding
            }),
            transformOrigin({
                arrowWidth,
                arrowHeight
            }),
            hideWhenDetached && (0, _reactDom.hide)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, _reactUseCallbackRef.useCallbackRef)(onPlaced);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (isPositioned) handlePlaced?.();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = _react.useState();
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                middlewareData.transformOrigin?.x,
                middlewareData.transformOrigin?.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...middlewareData.hide?.referenceHidden && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(PopperContentProvider, {
            scope: __scopePopper,
            placedSide,
            onArrowChange: setArrow,
            arrowX,
            arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
PopperContent.displayName = CONTENT_NAME;
var ARROW_NAME = "PopperArrow";
var OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var PopperArrow = _react.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper, ...arrowProps } = props;
    const contentContext = useContentContext(ARROW_NAME, __scopePopper);
    const baseSide = OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactArrow.Root, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
PopperArrow.displayName = ARROW_NAME;
function isNotNull(value) {
    return value !== null;
}
var transformOrigin = (options)=>({
        name: "transformOrigin",
        options,
        fn (data) {
            const { placement, rects, middlewareData } = data;
            const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
            const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x,
                    y
                }
            };
        }
    });
function getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var Root2 = Popper;
var Anchor = PopperAnchor;
var Content = PopperContent;
var Arrow = PopperArrow;

},{"react":"eGun2","@floating-ui/react-dom":[["arrow","3OZqv"],["flip","3OZqv"],["hide","3OZqv"],["limitShift","3OZqv"],["offset","3OZqv"],["shift","3OZqv"],["size","3OZqv"],["useFloating","3OZqv"],["autoUpdate","6ZSuD"]],"@radix-ui/react-arrow":"bIJhP","@radix-ui/react-compose-refs":"nN23r","@radix-ui/react-context":"4wywa","@radix-ui/react-primitive":"hQJ44","@radix-ui/react-use-callback-ref":"bakzF","@radix-ui/react-use-layout-effect":"dRDMB","@radix-ui/react-use-size":"1EkiK","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3OZqv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "autoUpdate", ()=>(0, _dom.autoUpdate));
parcelHelpers.export(exports, "computePosition", ()=>(0, _dom.computePosition));
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _dom.detectOverflow));
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "platform", ()=>(0, _dom.platform));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
parcelHelpers.export(exports, "useFloating", ()=>useFloating);
var _dom = require("@floating-ui/dom");
var _react = require("react");
var _reactDom = require("react-dom");
var isClient = typeof document !== 'undefined';
var noop = function noop() {};
var index = isClient ? (0, _react.useLayoutEffect) : noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
    const dpr = getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
    const ref = _react.useRef(value);
    index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function useFloating(options) {
    if (options === void 0) options = {};
    const { placement = 'bottom', strategy = 'absolute', middleware = [], platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform = true, whileElementsMounted, open } = options;
    const [data, setData] = _react.useState({
        x: 0,
        y: 0,
        strategy,
        placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = _react.useState(middleware);
    if (!deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = _react.useState(null);
    const [_floating, _setFloating] = _react.useState(null);
    const setReference = _react.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = _react.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = _react.useRef(null);
    const floatingRef = _react.useRef(null);
    const dataRef = _react.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = useLatestRef(whileElementsMounted);
    const platformRef = useLatestRef(platform);
    const openRef = useLatestRef(open);
    const update = _react.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement,
            strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, _dom.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                _reactDom.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = _react.useRef(false);
    index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = _react.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference,
            setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = _react.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = _react.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = roundByDPR(elements.floating, data.x);
        const y = roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return _react.useMemo(()=>({
            ...data,
            update,
            refs,
            elements,
            floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options,
        fn (state) {
            const { element, padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, _dom.arrow)({
                    element: element.current,
                    padding
                }).fn(state);
                return {};
            }
            if (element) return (0, _dom.arrow)({
                element,
                padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = (options, deps)=>({
        ...(0, _dom.offset)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = (options, deps)=>({
        ...(0, _dom.shift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = (options, deps)=>({
        ...(0, _dom.limitShift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = (options, deps)=>({
        ...(0, _dom.flip)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = (options, deps)=>({
        ...(0, _dom.size)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = (options, deps)=>({
        ...(0, _dom.autoPlacement)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = (options, deps)=>({
        ...(0, _dom.hide)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = (options, deps)=>({
        ...(0, _dom.inline)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options, deps)=>({
        ...arrow$1(options),
        options: [
            options,
            deps
        ]
    });

},{"@floating-ui/dom":"6ZSuD","react":"eGun2","react-dom":"bLJc5","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6ZSuD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "autoUpdate", ()=>autoUpdate);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "platform", ()=>platform);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    const css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, _dom.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width,
        height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    const domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width, height, $ } = getCssDimensions(domElement);
    let x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x,
        y
    };
}
const noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    const win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, _dom.getWindow)(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = unwrapElement(element);
    let scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, _dom.getWindow)(domElement);
        const offsetWin = offsetParent && (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, _dom.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, _dom.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, _dom.getWindow)(currentIFrame);
            currentIFrame = (0, _dom.getFrameElement)(currentWin);
        }
    }
    return (0, _core.rectToClientRect)({
        width,
        height,
        x,
        y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
    const leftScroll = (0, _dom.getNodeScroll)(element).scrollLeft;
    if (!rect) return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x,
        y
    };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements, rect, offsetParent, strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, _dom.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, _utils.createCoords)(1);
    const offsets = (0, _utils.createCoords)(0);
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if ((0, _dom.isHTMLElement)(offsetParent)) {
            const offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    const html = (0, _dom.getDocumentElement)(element);
    const scroll = (0, _dom.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === 'rtl') x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width,
        height,
        x,
        y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy) {
    const win = (0, _dom.getWindow)(element);
    const html = (0, _dom.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, _dom.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width,
        height,
        x,
        y
    };
}
const absoluteOrFixed = /*#__PURE__*/ new Set([
    'absolute',
    'fixed'
]);
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, _dom.isHTMLElement)(element) ? getScale(element) : (0, _utils.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width,
        height,
        x,
        y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, _core.rectToClientRect)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, _dom.getParentNode)(element);
    if (parentNode === stopNode || !(0, _dom.isElement)(parentNode) || (0, _dom.isLastTraversableNode)(parentNode)) return false;
    return (0, _dom.getComputedStyle)(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, _dom.getOverflowAncestors)(element, [], false).filter((el)=>(0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, _dom.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, _dom.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || (0, _dom.isOverflowElement)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    let { element, boundary, rootBoundary, strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, _dom.isTopLayer)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, _utils.max)(rect.top, accRect.top);
        accRect.right = (0, _utils.min)(rect.right, accRect.right);
        accRect.bottom = (0, _utils.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _utils.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function getDimensions(element) {
    const { width, height } = getCssDimensions(element);
    return {
        width,
        height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, _utils.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x,
        y,
        width: rect.width,
        height: rect.height
    };
}
function isStaticPositioned(element) {
    return (0, _dom.getComputedStyle)(element).position === 'static';
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, _dom.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    const win = (0, _dom.getWindow)(element);
    if ((0, _dom.isTopLayer)(element)) return win;
    if (!(0, _dom.isHTMLElement)(element)) {
        let svgOffsetParent = (0, _dom.getParentNode)(element);
        while(svgOffsetParent && !(0, _dom.isLastTraversableNode)(svgOffsetParent)){
            if ((0, _dom.isElement)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, _dom.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, _dom.isLastTraversableNode)(offsetParent) && isStaticPositioned(offsetParent) && !(0, _dom.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, _dom.getContainingBlock)(element) || win;
}
const getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === 'rtl';
}
const platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect,
    getOffsetParent,
    getElementRects,
    getClientRects,
    getDimensions,
    getScale,
    isElement: (0, _dom.isElement),
    isRTL
};
function rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left, top, width, height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, _utils.floor)(top);
        const insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, _utils.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === 'function', layoutShift = typeof IntersectionObserver === 'function', animationFrame = false } = options;
    const referenceEl = unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : [],
        ...(0, _dom.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const detectOverflow = (0, _core.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = (0, _core.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = (0, _core.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = (0, _core.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = (0, _core.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = (0, _core.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = (0, _core.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (0, _core.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = (0, _core.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = (0, _core.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const computePosition = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, _core.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

},{"@floating-ui/core":"fzgwu","@floating-ui/utils":"h8N3M","@floating-ui/utils/dom":"aFyUP","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fzgwu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", ()=>(0, _utils.rectToClientRect));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference, floating } = _ref;
    const sideAxis = (0, _utils.getSideAxis)(placement);
    const alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    const alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    const side = (0, _utils.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, _utils.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const computePosition = async (reference, floating, config)=>{
    const { placement = 'bottom', strategy = 'absolute', middleware = [], platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference,
        floating,
        strategy
    });
    let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name, fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data, reset } = await fn({
            x,
            y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy,
            middlewareData,
            rects,
            platform,
            elements: {
                reference,
                floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference,
                    floating,
                    strategy
                }) : reset.rects;
                ({ x, y } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x,
        y,
        placement: statefulPlacement,
        strategy,
        middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x, y, platform, rects, elements, strategy } = state;
    const { boundary = 'clippingAncestors', rootBoundary = 'viewport', elementContext = 'floating', altBoundary = false, padding = 0 } = (0, _utils.evaluate)(options, state);
    const paddingObject = (0, _utils.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, _utils.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary,
        rootBoundary,
        strategy
    }));
    const rect = elementContext === 'floating' ? {
        x,
        y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, _utils.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements,
        rect,
        offsetParent,
        strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options)=>({
        name: 'arrow',
        options,
        async fn (state) {
            const { x, y, placement, rects, platform, elements, middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element, padding = 0 } = (0, _utils.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            const coords = {
                x,
                y
            };
            const axis = (0, _utils.getAlignmentAxis)(placement);
            const length = (0, _utils.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, _utils.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, _utils.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects, middlewareData, placement, platform, elements } = state;
            const { crossAxis = false, alignment, allowedPlacements = (0, _utils.placements), autoAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, _utils.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, _utils.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, _utils.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement, middlewareData, rects, initialPlacement, platform, elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy = 'bestFit', fallbackAxisSideDirection = 'none', flipAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, _utils.getSide)(placement);
            const initialSideAxis = (0, _utils.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, _utils.getOppositePlacement)(initialPlacement)
            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement,
                    overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, _utils.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, _utils.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, _utils.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options,
        async fn (state) {
            const { rects } = state;
            const { strategy = 'referenceHidden', ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function getBoundingRect(rects) {
    const minX = (0, _utils.min)(...rects.map((rect)=>rect.left));
    const minY = (0, _utils.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, _utils.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, _utils.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, _utils.rectToClientRect)(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options,
        async fn (state) {
            const { placement, elements, rects, platform, strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding = 2, x, y } = (0, _utils.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = getRectsByLine(nativeClientRects);
            const fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, _utils.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, _utils.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top,
                            bottom,
                            left,
                            right,
                            width,
                            height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, _utils.getSide)(placement) === 'left';
                    const maxRight = (0, _utils.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, _utils.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top,
                        bottom,
                        left,
                        right,
                        width,
                        height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect
                },
                floating: elements.floating,
                strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
    const { placement, platform, elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, _utils.getSide)(placement);
    const alignment = (0, _utils.getAlignment)(placement);
    const isVertical = (0, _utils.getSideAxis)(placement) === 'y';
    const mainAxisMulti = originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, _utils.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x, y, placement, middlewareData } = state;
            const diffCoords = await convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options,
        async fn (state) {
            const { x, y, placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter = {
                fn: (_ref)=>{
                    let { x, y } = _ref;
                    return {
                        x,
                        y
                    };
                }
            }, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, _utils.getSideAxis)((0, _utils.getSide)(placement));
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, _utils.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, _utils.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = function(options) {
    if (options === void 0) options = {};
    return {
        options,
        fn (state) {
            const { x, y, placement, rects, middlewareData } = state;
            const { offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const crossAxis = (0, _utils.getSideAxis)(placement);
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, _utils.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = originSides.has((0, _utils.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement, rects, platform, elements } = state;
            const { apply = ()=>{}, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const side = (0, _utils.getSide)(placement);
            const alignment = (0, _utils.getAlignment)(placement);
            const isYAxis = (0, _utils.getSideAxis)(placement) === 'y';
            const { width, height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, _utils.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, _utils.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, _utils.max)(overflow.left, 0);
                const xMax = (0, _utils.max)(overflow.right, 0);
                const yMin = (0, _utils.max)(overflow.top, 0);
                const yMax = (0, _utils.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, _utils.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, _utils.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth,
                availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

},{"@floating-ui/utils":"h8N3M","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"h8N3M":[function(require,module,exports,__globalThis) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", ()=>alignments);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "createCoords", ()=>createCoords);
parcelHelpers.export(exports, "evaluate", ()=>evaluate);
parcelHelpers.export(exports, "expandPaddingObject", ()=>expandPaddingObject);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "getAlignment", ()=>getAlignment);
parcelHelpers.export(exports, "getAlignmentAxis", ()=>getAlignmentAxis);
parcelHelpers.export(exports, "getAlignmentSides", ()=>getAlignmentSides);
parcelHelpers.export(exports, "getAxisLength", ()=>getAxisLength);
parcelHelpers.export(exports, "getExpandedPlacements", ()=>getExpandedPlacements);
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", ()=>getOppositeAlignmentPlacement);
parcelHelpers.export(exports, "getOppositeAxis", ()=>getOppositeAxis);
parcelHelpers.export(exports, "getOppositeAxisPlacements", ()=>getOppositeAxisPlacements);
parcelHelpers.export(exports, "getOppositePlacement", ()=>getOppositePlacement);
parcelHelpers.export(exports, "getPaddingObject", ()=>getPaddingObject);
parcelHelpers.export(exports, "getSide", ()=>getSide);
parcelHelpers.export(exports, "getSideAxis", ()=>getSideAxis);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "rectToClientRect", ()=>rectToClientRect);
parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "sides", ()=>sides);
const sides = [
    'top',
    'right',
    'bottom',
    'left'
];
const alignments = [
    'start',
    'end'
];
const placements = /*#__PURE__*/ sides.reduce((acc, side)=>acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v)=>({
        x: v,
        y: v
    });
const oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
    return placement.split('-')[0];
}
function getAlignment(placement) {
    return placement.split('-')[1];
}
function getOppositeAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
    return axis === 'y' ? 'height' : 'width';
}
const yAxisSides = /*#__PURE__*/ new Set([
    'top',
    'bottom'
]);
function getSideAxis(placement) {
    return yAxisSides.has(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = getAlignment(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const length = getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    const oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>oppositeAlignmentMap[alignment]);
}
const lrPlacement = [
    'left',
    'right'
];
const rlPlacement = [
    'right',
    'left'
];
const tbPlacement = [
    'top',
    'bottom'
];
const btPlacement = [
    'bottom',
    'top'
];
function getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rlPlacement : lrPlacement;
            return isStart ? lrPlacement : rlPlacement;
        case 'left':
        case 'right':
            return isStart ? tbPlacement : btPlacement;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = getAlignment(placement);
    let list = getSideList(getSide(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function getPaddingObject(padding) {
    return typeof padding !== 'number' ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    const { x, y, width, height } = rect;
    return {
        width,
        height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x,
        y
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"aFyUP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
parcelHelpers.export(exports, "getContainingBlock", ()=>getContainingBlock);
parcelHelpers.export(exports, "getDocumentElement", ()=>getDocumentElement);
parcelHelpers.export(exports, "getFrameElement", ()=>getFrameElement);
parcelHelpers.export(exports, "getNearestOverflowAncestor", ()=>getNearestOverflowAncestor);
parcelHelpers.export(exports, "getNodeName", ()=>getNodeName);
parcelHelpers.export(exports, "getNodeScroll", ()=>getNodeScroll);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>getOverflowAncestors);
parcelHelpers.export(exports, "getParentNode", ()=>getParentNode);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "isContainingBlock", ()=>isContainingBlock);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isLastTraversableNode", ()=>isLastTraversableNode);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isOverflowElement", ()=>isOverflowElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
parcelHelpers.export(exports, "isTableElement", ()=>isTableElement);
parcelHelpers.export(exports, "isTopLayer", ()=>isTopLayer);
parcelHelpers.export(exports, "isWebKit", ()=>isWebKit);
function hasWindow() {
    return typeof window !== 'undefined';
}
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    if (!hasWindow()) return false;
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    if (!hasWindow()) return false;
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    if (!hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    if (!hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
const invalidOverflowDisplayValues = /*#__PURE__*/ new Set([
    'inline',
    'contents'
]);
function isOverflowElement(element) {
    const { overflow, overflowX, overflowY, display } = getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !invalidOverflowDisplayValues.has(display);
}
const tableElements = /*#__PURE__*/ new Set([
    'table',
    'td',
    'th'
]);
function isTableElement(element) {
    return tableElements.has(getNodeName(element));
}
const topLayerSelectors = [
    ':popover-open',
    ':modal'
];
function isTopLayer(element) {
    return topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (_e) {
            return false;
        }
    });
}
const transformProperties = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective'
];
const willChangeValues = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective',
    'filter'
];
const containValues = [
    'paint',
    'layout',
    'strict',
    'content'
];
function isContainingBlock(elementOrCss) {
    const webkit = isWebKit();
    const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return transformProperties.some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || willChangeValues.some((value)=>(css.willChange || '').includes(value)) || containValues.some((value)=>(css.contain || '').includes(value));
}
function getContainingBlock(element) {
    let currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else if (isTopLayer(currentNode)) return null;
        currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
const lastTraversableNodeNames = /*#__PURE__*/ new Set([
    'html',
    'body',
    '#document'
]);
function isLastTraversableNode(node) {
    return lastTraversableNodeNames.has(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function getParentNode(node) {
    if (getNodeName(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    const parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = getWindow(scrollableAncestor);
    if (isBody) {
        const frameElement = getFrameElement(win);
        return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
    }
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bIJhP":[function(require,module,exports,__globalThis) {
// src/arrow.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Arrow", ()=>Arrow);
parcelHelpers.export(exports, "Root", ()=>Root);
var _react = require("react");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _jsxRuntime = require("react/jsx-runtime");
var NAME = "Arrow";
var Arrow = _react.forwardRef((props, forwardedRef)=>{
    const { children, width = 10, height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width,
        height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, _jsxRuntime.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
Arrow.displayName = NAME;
var Root = Arrow;

},{"react":"eGun2","@radix-ui/react-primitive":"hQJ44","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1EkiK":[function(require,module,exports,__globalThis) {
// packages/react/use-size/src/use-size.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSize", ()=>useSize);
var _react = require("react");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
function useSize(element) {
    const [size, setSize] = _react.useState(void 0);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width,
                    height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}

},{"react":"eGun2","@radix-ui/react-use-layout-effect":"dRDMB","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"iPxB6":[function(require,module,exports,__globalThis) {
// src/visually-hidden.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Root", ()=>Root);
parcelHelpers.export(exports, "VISUALLY_HIDDEN_STYLES", ()=>VISUALLY_HIDDEN_STYLES);
parcelHelpers.export(exports, "VisuallyHidden", ()=>VisuallyHidden);
var _react = require("react");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _jsxRuntime = require("react/jsx-runtime");
var VISUALLY_HIDDEN_STYLES = Object.freeze({
    // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal"
});
var NAME = "VisuallyHidden";
var VisuallyHidden = _react.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).span, {
        ...props,
        ref: forwardedRef,
        style: {
            ...VISUALLY_HIDDEN_STYLES,
            ...props.style
        }
    });
});
VisuallyHidden.displayName = NAME;
var Root = VisuallyHidden;

},{"react":"eGun2","@radix-ui/react-primitive":"hQJ44","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"NohDB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppSidebar", ()=>AppSidebar);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("@tanstack/react-router");
var _config = require("@/client/config");
var _lucideReact = require("lucide-react");
var _auth0React = require("@auth0/auth0-react");
var _runbook = require("@/client/content/runbook");
var _collapsible = require("@/client/components/ui/collapsible");
var _sidebar = require("@/client/components/ui/sidebar");
var _themeToggle = require("@/client/components/theme-toggle");
const dashboardItem = {
    title: "Dashboard",
    url: "/dashboard",
    icon: (0, _lucideReact.Home)
};
const statusPageItems = [
    {
        title: "Invintus",
        url: "https://status.invintus.com/"
    },
    {
        title: "Invintus (Admin)",
        url: "https://status.invintus.com/admin"
    },
    {
        title: "AWS",
        url: "https://status.aws.amazon.com/"
    },
    {
        title: "Backblaze",
        url: "https://status.backblaze.com/"
    },
    {
        title: "Claude",
        url: "https://status.claude.com/"
    },
    {
        title: "Cloudflare",
        url: "https://www.cloudflarestatus.com/"
    },
    {
        title: "Cloudflare Radar Outages",
        url: "https://radar.cloudflare.com/outage-center"
    },
    {
        title: "Fastly",
        url: "https://www.fastlystatus.com/"
    },
    {
        title: "GitHub",
        url: "https://www.githubstatus.com/"
    },
    {
        title: "Wowza Streaming Cloud",
        url: "https://wowza-streaming-cloud.statuspage.io/"
    }
];
const keyDateItems = [
    {
        title: "2027 Session Dates",
        url: "/key-dates/legislative-sessions",
        icon: (0, _lucideReact.Landmark)
    }
];
const clientItems = [
    {
        title: "Client List",
        url: "/clients",
        icon: (0, _lucideReact.Users)
    },
    {
        title: "OTT Manager",
        url: "/ott-manager",
        icon: (0, _lucideReact.Tv)
    }
];
const monitoringItems = [
    {
        title: "Live Streams",
        url: "/events/live-streams",
        icon: (0, _lucideReact.Radio)
    },
    {
        title: "Upcoming Streams",
        url: "/events/upcoming-streams",
        icon: (0, _lucideReact.Calendar)
    },
    {
        title: "Persistent Streams",
        url: "/persistent-streams",
        icon: (0, _lucideReact.Cast)
    },
    {
        title: "Transcode Jobs",
        url: "/transcode-jobs",
        icon: (0, _lucideReact.Clapperboard)
    },
    {
        title: "Live Caption Jobs",
        url: "/monitoring/caption-jobs",
        icon: (0, _lucideReact.Captions)
    },
    {
        title: "Webhook Logs",
        url: "/monitoring/webhook-logs",
        icon: (0, _lucideReact.Webhook)
    }
];
const encoderItems = [
    {
        title: "Client Encoders",
        url: "/encoders",
        icon: (0, _lucideReact.Cpu)
    },
    {
        title: "Encoder Triage",
        url: "/encoders/triage",
        icon: (0, _lucideReact.Stethoscope)
    }
];
const eventInsightsItems = [
    {
        title: "Event Reports",
        url: "/events/reports",
        icon: (0, _lucideReact.LineChart)
    },
    {
        title: "Yearly Trends",
        url: "/events/trends",
        icon: (0, _lucideReact.TrendingUp)
    },
    {
        title: "Simulcast Reports",
        url: "/events/reports/simulcast",
        icon: (0, _lucideReact.Radio)
    },
    {
        title: "Captioning Reports",
        url: "/captioning/reports",
        icon: (0, _lucideReact.Captions)
    }
];
const utilitiesItems = [
    {
        title: "Pipeline Logs",
        url: "/pipeline-logs",
        icon: (0, _lucideReact.ScrollText)
    },
    {
        title: "Swap User Client",
        url: "/utilities/swap-user-client",
        icon: (0, _lucideReact.UserCog)
    },
    {
        title: "Update Event Status",
        url: "/utilities/update-event-status",
        icon: (0, _lucideReact.RefreshCw)
    },
    {
        title: "Event Media Probe",
        url: "/utilities/media-probe",
        icon: (0, _lucideReact.FileVideo)
    },
    {
        title: "VTT Analyzer",
        url: "/utilities/vtt-analyzer",
        icon: (0, _lucideReact.Captions)
    },
    {
        title: "Export VTT",
        url: "/utilities/export-vtt",
        icon: (0, _lucideReact.FileSpreadsheet)
    }
];
const awsItems = [
    {
        title: "RDS Health",
        url: "/aws/rds-health",
        icon: (0, _lucideReact.Database)
    },
    {
        title: "EC2 Health",
        url: "/aws/ec2-health",
        icon: (0, _lucideReact.Server)
    }
];
const runbookItems = (0, _runbook.runbookPages).map((page)=>({
        title: page.title,
        url: `/runbook/${page.slug}`,
        icon: (0, _lucideReact.FileText)
    }));
function AppSidebar() {
    const { user, logout } = (0, _auth0React.useAuth0)();
    const location = (0, _reactRouter.useLocation)();
    const isActive = (url)=>{
        // Exact match or starts with for nested routes (e.g., /clients/123)
        return location.pathname === url || location.pathname.startsWith(url + '/');
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sidebar.Sidebar), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarHeader), {
                className: "p-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-baseline gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-lg font-semibold",
                                    children: "Admin Portal"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-xs text-muted-foreground font-mono",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                        href: "https://github.com/TVWIT/admin-portal/commits/main/",
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        children: [
                                            "v",
                                            (0, _config.APP_VERSION)
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeToggle.ThemeToggle), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sidebar.SidebarContent), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sidebar.SidebarGroup), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupLabel), {
                                children: "Navigation"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupContent), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sidebar.SidebarMenu), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuItem), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuButton), {
                                                asChild: true,
                                                isActive: isActive(dashboardItem.url),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                                    to: dashboardItem.url,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(dashboardItem.icon, {
                                                            className: "h-4 w-4"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: dashboardItem.title
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.Collapsible), {
                                            asChild: true,
                                            className: "group/status-pages",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sidebar.SidebarMenuItem), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.CollapsibleTrigger), {
                                                        asChild: true,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sidebar.SidebarMenuButton), {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Gauge), {
                                                                    className: "h-4 w-4"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: "Status Pages"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                                    className: "ml-auto h-4 w-4 transition-transform group-data-[state=open]/status-pages:rotate-180"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.CollapsibleContent), {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSub), {
                                                            children: statusPageItems.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubItem), {
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubButton), {
                                                                        asChild: true,
                                                                        tooltip: item.title,
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                                            href: item.url,
                                                                            target: "_blank",
                                                                            rel: "noopener noreferrer",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ExternalLink), {}),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    children: item.title
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }, item.url))
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        keyDateItems.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuItem), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuButton), {
                                                    asChild: true,
                                                    isActive: isActive(item.url),
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                                        to: item.url,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(item.icon, {
                                                                className: "h-4 w-4"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: item.title
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, item.title))
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.Collapsible), {
                        defaultOpen: true,
                        className: "group/collapsible",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sidebar.SidebarGroup), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupLabel), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _collapsible.CollapsibleTrigger), {
                                        className: "w-full",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Users), {
                                                className: "h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "ml-2 dark:text-white light:text-black text-base",
                                                children: "Clients"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                className: "ml-auto h-4 w-4 transition-transform group-data-[state=open]/collapsible:rotate-180"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.CollapsibleContent), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupContent), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSub), {
                                            children: clientItems.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubItem), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubButton), {
                                                        asChild: true,
                                                        isActive: isActive(item.url),
                                                        tooltip: item.title,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                                            to: item.url,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: item.title
                                                            })
                                                        })
                                                    })
                                                }, item.title))
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.Collapsible), {
                        defaultOpen: true,
                        className: "group/collapsible",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sidebar.SidebarGroup), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupLabel), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _collapsible.CollapsibleTrigger), {
                                        className: "w-full",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Activity), {
                                                className: "h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "ml-2 dark:text-white light:text-black text-base",
                                                children: "Monitoring"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                className: "ml-auto h-4 w-4 transition-transform group-data-[state=open]/collapsible:rotate-180"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.CollapsibleContent), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupContent), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSub), {
                                            children: monitoringItems.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubItem), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubButton), {
                                                        asChild: true,
                                                        isActive: isActive(item.url),
                                                        tooltip: item.title,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                                            to: item.url,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: item.title
                                                            })
                                                        })
                                                    })
                                                }, item.title))
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.Collapsible), {
                        defaultOpen: true,
                        className: "group/collapsible",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sidebar.SidebarGroup), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupLabel), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _collapsible.CollapsibleTrigger), {
                                        className: "w-full",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Cpu), {
                                                className: "h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "ml-2 dark:text-white light:text-black text-base",
                                                children: "Encoders"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                className: "ml-auto h-4 w-4 transition-transform group-data-[state=open]/collapsible:rotate-180"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.CollapsibleContent), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupContent), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSub), {
                                            children: encoderItems.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubItem), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubButton), {
                                                        asChild: true,
                                                        isActive: isActive(item.url),
                                                        tooltip: item.title,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                                            to: item.url,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: item.title
                                                            })
                                                        })
                                                    })
                                                }, item.title))
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.Collapsible), {
                        defaultOpen: true,
                        className: "group/collapsible",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sidebar.SidebarGroup), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupLabel), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _collapsible.CollapsibleTrigger), {
                                        className: "w-full",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.BarChart3), {
                                                className: "h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "ml-2 dark:text-white light:text-black text-base",
                                                children: "Event Insights"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                className: "ml-auto h-4 w-4 transition-transform group-data-[state=open]/collapsible:rotate-180"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.CollapsibleContent), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupContent), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSub), {
                                            children: eventInsightsItems.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubItem), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubButton), {
                                                        asChild: true,
                                                        isActive: isActive(item.url),
                                                        tooltip: item.title,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                                            to: item.url,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: item.title
                                                            })
                                                        })
                                                    })
                                                }, item.title))
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.Collapsible), {
                        defaultOpen: true,
                        className: "group/collapsible",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sidebar.SidebarGroup), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupLabel), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _collapsible.CollapsibleTrigger), {
                                        className: "w-full",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Wrench), {
                                                className: "h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "ml-2 dark:text-white light:text-black text-base",
                                                children: "Utilities"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                className: "ml-auto h-4 w-4 transition-transform group-data-[state=open]/collapsible:rotate-180"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.CollapsibleContent), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupContent), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSub), {
                                            children: utilitiesItems.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubItem), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubButton), {
                                                        asChild: true,
                                                        isActive: isActive(item.url),
                                                        tooltip: item.title,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                                            to: item.url,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: item.title
                                                            })
                                                        })
                                                    })
                                                }, item.title))
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.Collapsible), {
                        defaultOpen: true,
                        className: "group/collapsible",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sidebar.SidebarGroup), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupLabel), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _collapsible.CollapsibleTrigger), {
                                        className: "w-full",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Cloud), {
                                                className: "h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "ml-2 dark:text-white light:text-black text-base",
                                                children: "AWS"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                className: "ml-auto h-4 w-4 transition-transform group-data-[state=open]/collapsible:rotate-180"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.CollapsibleContent), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupContent), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSub), {
                                            children: awsItems.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubItem), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubButton), {
                                                        asChild: true,
                                                        isActive: isActive(item.url),
                                                        tooltip: item.title,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                                            to: item.url,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: item.title
                                                            })
                                                        })
                                                    })
                                                }, item.title))
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.Collapsible), {
                        defaultOpen: true,
                        className: "group/collapsible",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sidebar.SidebarGroup), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupLabel), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _collapsible.CollapsibleTrigger), {
                                        className: "w-full",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.BookOpen), {
                                                className: "h-4 w-4"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "ml-2 dark:text-white light:text-black text-base",
                                                children: "Runbook"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                className: "ml-auto h-4 w-4 transition-transform group-data-[state=open]/collapsible:rotate-180"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.CollapsibleContent), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarGroupContent), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSub), {
                                            children: runbookItems.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubItem), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarMenuSubButton), {
                                                        asChild: true,
                                                        isActive: isActive(item.url),
                                                        tooltip: item.title,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                                            to: item.url,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: item.title
                                                            })
                                                        })
                                                    })
                                                }, item.title))
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarFooter), {
                className: "p-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                            to: "/profile",
                            className: "flex items-center gap-2 hover:opacity-80",
                            children: [
                                user?.picture && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: user.picture,
                                    alt: user.name || "User",
                                    className: "h-8 w-8 rounded-full"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-sm truncate max-w-[120px]",
                                    children: user?.name || user?.email
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>logout({
                                    logoutParams: {
                                        returnTo: window.location.origin
                                    }
                                }),
                            className: "p-2 hover:bg-sidebar-accent rounded",
                            title: "Logout",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.LogOut), {
                                className: "h-4 w-4"
                            })
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","@tanstack/react-router":[["Link","7k6Lq"],["useLocation","gd5Qe"]],"@/client/config":"8SWgh","lucide-react":[["Activity","5XJYD","default"],["BarChart3","anbzw","default"],["BookOpen","1xdum","default"],["Calendar","kIwYJ","default"],["Captions","cIbpr","default"],["Cast","irNuu","default"],["ChevronDown","kVmgC","default"],["Clapperboard","baLSZ","default"],["Cloud","ah98I","default"],["Cpu","bh7QC","default"],["Database","cqLcF","default"],["ExternalLink","kIIQA","default"],["FileSpreadsheet","fkevk","default"],["FileText","jrUS7","default"],["FileVideo","2nOAp","default"],["Gauge","ibUN9","default"],["Home","9Fq4M","default"],["Landmark","fnDVc","default"],["LineChart","j91gB","default"],["LogOut","kaHCY","default"],["Radio","8O5hz","default"],["RefreshCw","7a8jT","default"],["ScrollText","hdD9f","default"],["Server","52k00","default"],["Stethoscope","21eRB","default"],["TrendingUp","a4MAn","default"],["Tv","lYwcw","default"],["UserCog","b0icy","default"],["Users","in3JI","default"],["Webhook","1VKcp","default"],["Wrench","3UeVH","default"]],"@auth0/auth0-react":"gpXrE","@/client/content/runbook":"42sj3","@/client/components/ui/collapsible":"ij03O","@/client/components/ui/sidebar":"cIzmc","@/client/components/theme-toggle":"35Jms","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gd5Qe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
var _useRouterStateJs = require("./useRouterState.js");
function useLocation(opts) {
    return (0, _useRouterStateJs.useRouterState)({
        select: (state)=>opts?.select ? opts.select(state.location) : state.location
    });
}

},{"./useRouterState.js":"2Tx7u","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5XJYD":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Activity);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
            key: "169zse"
        }
    ]
];
const Activity = (0, _createLucideIconJsDefault.default)("activity", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"anbzw":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChartColumn);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M3 3v16a2 2 0 0 0 2 2h16",
            key: "c24i48"
        }
    ],
    [
        "path",
        {
            d: "M18 17V9",
            key: "2bz60n"
        }
    ],
    [
        "path",
        {
            d: "M13 17V5",
            key: "1frdt8"
        }
    ],
    [
        "path",
        {
            d: "M8 17v-3",
            key: "17ska0"
        }
    ]
];
const ChartColumn = (0, _createLucideIconJsDefault.default)("chart-column", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1xdum":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>BookOpen);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 7v14",
            key: "1akyts"
        }
    ],
    [
        "path",
        {
            d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
            key: "ruj8y"
        }
    ]
];
const BookOpen = (0, _createLucideIconJsDefault.default)("book-open", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kIwYJ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Calendar);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ]
];
const Calendar = (0, _createLucideIconJsDefault.default)("calendar", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cIbpr":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Captions);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "rect",
        {
            width: "18",
            height: "14",
            x: "3",
            y: "5",
            rx: "2",
            ry: "2",
            key: "12ruh7"
        }
    ],
    [
        "path",
        {
            d: "M7 15h4M15 15h2M7 11h2M13 11h4",
            key: "1ueiar"
        }
    ]
];
const Captions = (0, _createLucideIconJsDefault.default)("captions", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"irNuu":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Cast);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6",
            key: "3zrzxg"
        }
    ],
    [
        "path",
        {
            d: "M2 12a9 9 0 0 1 8 8",
            key: "g6cvee"
        }
    ],
    [
        "path",
        {
            d: "M2 16a5 5 0 0 1 4 4",
            key: "1y1dii"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "2.01",
            y1: "20",
            y2: "20",
            key: "xu2jvo"
        }
    ]
];
const Cast = (0, _createLucideIconJsDefault.default)("cast", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kVmgC":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronDown);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const ChevronDown = (0, _createLucideIconJsDefault.default)("chevron-down", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"baLSZ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Clapperboard);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z",
            key: "1tn4o7"
        }
    ],
    [
        "path",
        {
            d: "m6.2 5.3 3.1 3.9",
            key: "iuk76l"
        }
    ],
    [
        "path",
        {
            d: "m12.4 3.4 3.1 4",
            key: "6hsd6n"
        }
    ],
    [
        "path",
        {
            d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z",
            key: "ltgou9"
        }
    ]
];
const Clapperboard = (0, _createLucideIconJsDefault.default)("clapperboard", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ah98I":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Cloud);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z",
            key: "p7xjir"
        }
    ]
];
const Cloud = (0, _createLucideIconJsDefault.default)("cloud", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bh7QC":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Cpu);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 20v2",
            key: "1lh1kg"
        }
    ],
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "M17 20v2",
            key: "1rnc9c"
        }
    ],
    [
        "path",
        {
            d: "M17 2v2",
            key: "11trls"
        }
    ],
    [
        "path",
        {
            d: "M2 12h2",
            key: "1t8f8n"
        }
    ],
    [
        "path",
        {
            d: "M2 17h2",
            key: "7oei6x"
        }
    ],
    [
        "path",
        {
            d: "M2 7h2",
            key: "asdhe0"
        }
    ],
    [
        "path",
        {
            d: "M20 12h2",
            key: "1q8mjw"
        }
    ],
    [
        "path",
        {
            d: "M20 17h2",
            key: "1fpfkl"
        }
    ],
    [
        "path",
        {
            d: "M20 7h2",
            key: "1o8tra"
        }
    ],
    [
        "path",
        {
            d: "M7 20v2",
            key: "4gnj0m"
        }
    ],
    [
        "path",
        {
            d: "M7 2v2",
            key: "1i4yhu"
        }
    ],
    [
        "rect",
        {
            x: "4",
            y: "4",
            width: "16",
            height: "16",
            rx: "2",
            key: "1vbyd7"
        }
    ],
    [
        "rect",
        {
            x: "8",
            y: "8",
            width: "8",
            height: "8",
            rx: "1",
            key: "z9xiuo"
        }
    ]
];
const Cpu = (0, _createLucideIconJsDefault.default)("cpu", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cqLcF":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Database);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "ellipse",
        {
            cx: "12",
            cy: "5",
            rx: "9",
            ry: "3",
            key: "msslwz"
        }
    ],
    [
        "path",
        {
            d: "M3 5V19A9 3 0 0 0 21 19V5",
            key: "1wlel7"
        }
    ],
    [
        "path",
        {
            d: "M3 12A9 3 0 0 0 21 12",
            key: "mv7ke4"
        }
    ]
];
const Database = (0, _createLucideIconJsDefault.default)("database", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kIIQA":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ExternalLink);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M15 3h6v6",
            key: "1q9fwt"
        }
    ],
    [
        "path",
        {
            d: "M10 14 21 3",
            key: "gplh6r"
        }
    ],
    [
        "path",
        {
            d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
            key: "a6xqqp"
        }
    ]
];
const ExternalLink = (0, _createLucideIconJsDefault.default)("external-link", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fkevk":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>FileSpreadsheet);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
            key: "1oefj6"
        }
    ],
    [
        "path",
        {
            d: "M14 2v5a1 1 0 0 0 1 1h5",
            key: "wfsgrz"
        }
    ],
    [
        "path",
        {
            d: "M8 13h2",
            key: "yr2amv"
        }
    ],
    [
        "path",
        {
            d: "M14 13h2",
            key: "un5t4a"
        }
    ],
    [
        "path",
        {
            d: "M8 17h2",
            key: "2yhykz"
        }
    ],
    [
        "path",
        {
            d: "M14 17h2",
            key: "10kma7"
        }
    ]
];
const FileSpreadsheet = (0, _createLucideIconJsDefault.default)("file-spreadsheet", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jrUS7":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>FileText);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
            key: "1oefj6"
        }
    ],
    [
        "path",
        {
            d: "M14 2v5a1 1 0 0 0 1 1h5",
            key: "wfsgrz"
        }
    ],
    [
        "path",
        {
            d: "M10 9H8",
            key: "b1mrlr"
        }
    ],
    [
        "path",
        {
            d: "M16 13H8",
            key: "t4e002"
        }
    ],
    [
        "path",
        {
            d: "M16 17H8",
            key: "z1uh3a"
        }
    ]
];
const FileText = (0, _createLucideIconJsDefault.default)("file-text", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2nOAp":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>FilePlay);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
            key: "1oefj6"
        }
    ],
    [
        "path",
        {
            d: "M14 2v5a1 1 0 0 0 1 1h5",
            key: "wfsgrz"
        }
    ],
    [
        "path",
        {
            d: "M15.033 13.44a.647.647 0 0 1 0 1.12l-4.065 2.352a.645.645 0 0 1-.968-.56v-4.704a.645.645 0 0 1 .967-.56z",
            key: "1tzo1f"
        }
    ]
];
const FilePlay = (0, _createLucideIconJsDefault.default)("file-play", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ibUN9":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Gauge);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m12 14 4-4",
            key: "9kzdfg"
        }
    ],
    [
        "path",
        {
            d: "M3.34 19a10 10 0 1 1 17.32 0",
            key: "19p75a"
        }
    ]
];
const Gauge = (0, _createLucideIconJsDefault.default)("gauge", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fnDVc":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Landmark);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M10 18v-7",
            key: "wt116b"
        }
    ],
    [
        "path",
        {
            d: "M11.12 2.198a2 2 0 0 1 1.76.006l7.866 3.847c.476.233.31.949-.22.949H3.474c-.53 0-.695-.716-.22-.949z",
            key: "1m329m"
        }
    ],
    [
        "path",
        {
            d: "M14 18v-7",
            key: "vav6t3"
        }
    ],
    [
        "path",
        {
            d: "M18 18v-7",
            key: "aexdmj"
        }
    ],
    [
        "path",
        {
            d: "M3 22h18",
            key: "8prr45"
        }
    ],
    [
        "path",
        {
            d: "M6 18v-7",
            key: "1ivflk"
        }
    ]
];
const Landmark = (0, _createLucideIconJsDefault.default)("landmark", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"j91gB":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChartLine);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M3 3v16a2 2 0 0 0 2 2h16",
            key: "c24i48"
        }
    ],
    [
        "path",
        {
            d: "m19 9-5 5-4-4-3 3",
            key: "2osh9i"
        }
    ]
];
const ChartLine = (0, _createLucideIconJsDefault.default)("chart-line", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kaHCY":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>LogOut);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m16 17 5-5-5-5",
            key: "1bji2h"
        }
    ],
    [
        "path",
        {
            d: "M21 12H9",
            key: "dn1m92"
        }
    ],
    [
        "path",
        {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
            key: "1uf3rs"
        }
    ]
];
const LogOut = (0, _createLucideIconJsDefault.default)("log-out", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8O5hz":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Radio);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M16.247 7.761a6 6 0 0 1 0 8.478",
            key: "1fwjs5"
        }
    ],
    [
        "path",
        {
            d: "M19.075 4.933a10 10 0 0 1 0 14.134",
            key: "ehdyv1"
        }
    ],
    [
        "path",
        {
            d: "M4.925 19.067a10 10 0 0 1 0-14.134",
            key: "1q22gi"
        }
    ],
    [
        "path",
        {
            d: "M7.753 16.239a6 6 0 0 1 0-8.478",
            key: "r2q7qm"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "2",
            key: "1c9p78"
        }
    ]
];
const Radio = (0, _createLucideIconJsDefault.default)("radio", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7a8jT":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>RefreshCw);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const RefreshCw = (0, _createLucideIconJsDefault.default)("refresh-cw", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hdD9f":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ScrollText);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M15 12h-5",
            key: "r7krc0"
        }
    ],
    [
        "path",
        {
            d: "M15 8h-5",
            key: "1khuty"
        }
    ],
    [
        "path",
        {
            d: "M19 17V5a2 2 0 0 0-2-2H4",
            key: "zz82l3"
        }
    ],
    [
        "path",
        {
            d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
            key: "1ph1d7"
        }
    ]
];
const ScrollText = (0, _createLucideIconJsDefault.default)("scroll-text", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"52k00":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Server);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "rect",
        {
            width: "20",
            height: "8",
            x: "2",
            y: "2",
            rx: "2",
            ry: "2",
            key: "ngkwjq"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "8",
            x: "2",
            y: "14",
            rx: "2",
            ry: "2",
            key: "iecqi9"
        }
    ],
    [
        "line",
        {
            x1: "6",
            x2: "6.01",
            y1: "6",
            y2: "6",
            key: "16zg32"
        }
    ],
    [
        "line",
        {
            x1: "6",
            x2: "6.01",
            y1: "18",
            y2: "18",
            key: "nzw8ys"
        }
    ]
];
const Server = (0, _createLucideIconJsDefault.default)("server", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"21eRB":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Stethoscope);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M11 2v2",
            key: "1539x4"
        }
    ],
    [
        "path",
        {
            d: "M5 2v2",
            key: "1yf1q8"
        }
    ],
    [
        "path",
        {
            d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1",
            key: "rb5t3r"
        }
    ],
    [
        "path",
        {
            d: "M8 15a6 6 0 0 0 12 0v-3",
            key: "x18d4x"
        }
    ],
    [
        "circle",
        {
            cx: "20",
            cy: "10",
            r: "2",
            key: "ts1r5v"
        }
    ]
];
const Stethoscope = (0, _createLucideIconJsDefault.default)("stethoscope", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"a4MAn":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>TrendingUp);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M16 7h6v6",
            key: "box55l"
        }
    ],
    [
        "path",
        {
            d: "m22 7-8.5 8.5-5-5L2 17",
            key: "1t1m79"
        }
    ]
];
const TrendingUp = (0, _createLucideIconJsDefault.default)("trending-up", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"lYwcw":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Tv);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m17 2-5 5-5-5",
            key: "16satq"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "15",
            x: "2",
            y: "7",
            rx: "2",
            key: "1e6viu"
        }
    ]
];
const Tv = (0, _createLucideIconJsDefault.default)("tv", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"b0icy":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>UserCog);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M10 15H6a4 4 0 0 0-4 4v2",
            key: "1nfge6"
        }
    ],
    [
        "path",
        {
            d: "m14.305 16.53.923-.382",
            key: "1itpsq"
        }
    ],
    [
        "path",
        {
            d: "m15.228 13.852-.923-.383",
            key: "eplpkm"
        }
    ],
    [
        "path",
        {
            d: "m16.852 12.228-.383-.923",
            key: "13v3q0"
        }
    ],
    [
        "path",
        {
            d: "m16.852 17.772-.383.924",
            key: "1i8mnm"
        }
    ],
    [
        "path",
        {
            d: "m19.148 12.228.383-.923",
            key: "1q8j1v"
        }
    ],
    [
        "path",
        {
            d: "m19.53 18.696-.382-.924",
            key: "vk1qj3"
        }
    ],
    [
        "path",
        {
            d: "m20.772 13.852.924-.383",
            key: "n880s0"
        }
    ],
    [
        "path",
        {
            d: "m20.772 16.148.924.383",
            key: "1g6xey"
        }
    ],
    [
        "circle",
        {
            cx: "18",
            cy: "15",
            r: "3",
            key: "gjjjvw"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ]
];
const UserCog = (0, _createLucideIconJsDefault.default)("user-cog", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"in3JI":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Users);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "path",
        {
            d: "M16 3.128a4 4 0 0 1 0 7.744",
            key: "16gr8j"
        }
    ],
    [
        "path",
        {
            d: "M22 21v-2a4 4 0 0 0-3-3.87",
            key: "kshegd"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ]
];
const Users = (0, _createLucideIconJsDefault.default)("users", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1VKcp":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Webhook);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2",
            key: "q3hayz"
        }
    ],
    [
        "path",
        {
            d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06",
            key: "1go1hn"
        }
    ],
    [
        "path",
        {
            d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8",
            key: "qlwsc0"
        }
    ]
];
const Webhook = (0, _createLucideIconJsDefault.default)("webhook", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3UeVH":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Wrench);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z",
            key: "1ngwbx"
        }
    ]
];
const Wrench = (0, _createLucideIconJsDefault.default)("wrench", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"42sj3":[function(require,module,exports,__globalThis) {
// Import markdown files as raw text using Parcel's bundle-text: scheme
// Add new imports here when creating new runbook pages
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "runbookPages", ()=>runbookPages);
parcelHelpers.export(exports, "runbookBySlug", ()=>runbookBySlug);
var _restartStalledPubliishJobMd = require("bundle-text:./restart-stalled-publiish-job.md");
var _restartStalledPubliishJobMdDefault = parcelHelpers.interopDefault(_restartStalledPubliishJobMd);
var _peristentStreamsGeofencingMd = require("bundle-text:./peristent-streams-geofencing.md");
var _peristentStreamsGeofencingMdDefault = parcelHelpers.interopDefault(_peristentStreamsGeofencingMd);
var _orphanedEncodersMd = require("bundle-text:./orphaned-encoders.md");
var _orphanedEncodersMdDefault = parcelHelpers.interopDefault(_orphanedEncodersMd);
var _duplicateEventsMd = require("bundle-text:./duplicate-events.md");
var _duplicateEventsMdDefault = parcelHelpers.interopDefault(_duplicateEventsMd);
var _missingMediaInvestigationMd = require("bundle-text:./missing-media-investigation.md");
var _missingMediaInvestigationMdDefault = parcelHelpers.interopDefault(_missingMediaInvestigationMd);
var _rtmpVsSrtMd = require("bundle-text:./rtmp-vs-srt.md");
var _rtmpVsSrtMdDefault = parcelHelpers.interopDefault(_rtmpVsSrtMd);
var _setupPersistentStreamMd = require("bundle-text:./setup-persistent-stream.md");
var _setupPersistentStreamMdDefault = parcelHelpers.interopDefault(_setupPersistentStreamMd);
var _liveStreamHealthMd = require("bundle-text:./live-stream-health.md");
var _liveStreamHealthMdDefault = parcelHelpers.interopDefault(_liveStreamHealthMd);
var _transcodeRunningLongMd = require("bundle-text:./transcode-running-long.md");
var _transcodeRunningLongMdDefault = parcelHelpers.interopDefault(_transcodeRunningLongMd);
var _cancelTranscodeJobMd = require("bundle-text:./cancel-transcode-job.md");
var _cancelTranscodeJobMdDefault = parcelHelpers.interopDefault(_cancelTranscodeJobMd);
var _githubActionsBudgetMd = require("bundle-text:./github-actions-budget.md");
var _githubActionsBudgetMdDefault = parcelHelpers.interopDefault(_githubActionsBudgetMd);
var _stuckUnpublishB2Md = require("bundle-text:./stuck-unpublish-b2.md");
var _stuckUnpublishB2MdDefault = parcelHelpers.interopDefault(_stuckUnpublishB2Md);
function extractTitle(content) {
    const match = content.match(/^#\s+(.+)$/m);
    return match ? match[1].trim() : 'Untitled';
}
const docs = [
    {
        slug: 'stalled-publish',
        content: (0, _restartStalledPubliishJobMdDefault.default)
    },
    {
        slug: 'peristent-stream-geofencing',
        content: (0, _peristentStreamsGeofencingMdDefault.default)
    },
    {
        slug: 'orphaned-encoders',
        content: (0, _orphanedEncodersMdDefault.default)
    },
    {
        slug: 'duplicate-events',
        content: (0, _duplicateEventsMdDefault.default)
    },
    {
        slug: 'missing-media',
        content: (0, _missingMediaInvestigationMdDefault.default)
    },
    {
        slug: 'rtmp-vs-srt',
        content: (0, _rtmpVsSrtMdDefault.default)
    },
    {
        slug: 'setup-persistent-stream',
        content: (0, _setupPersistentStreamMdDefault.default)
    },
    {
        slug: 'live-stream-health',
        content: (0, _liveStreamHealthMdDefault.default)
    },
    {
        slug: 'transcode-running-long',
        content: (0, _transcodeRunningLongMdDefault.default)
    },
    {
        slug: 'cancel-transcode-job',
        content: (0, _cancelTranscodeJobMdDefault.default)
    },
    {
        slug: 'github-actions-budget',
        content: (0, _githubActionsBudgetMdDefault.default)
    },
    {
        slug: 'stuck-unpublish-b2',
        content: (0, _stuckUnpublishB2MdDefault.default)
    }
];
const runbookPages = docs.map(({ slug, content })=>({
        slug,
        title: extractTitle(content),
        content
    }));
const runbookBySlug = Object.fromEntries(runbookPages.map((page)=>[
        page.slug,
        page
    ]));

},{"bundle-text:./restart-stalled-publiish-job.md":"a5nIm","bundle-text:./peristent-streams-geofencing.md":"eLQJ0","bundle-text:./orphaned-encoders.md":"kJOQj","bundle-text:./duplicate-events.md":"kXkZ7","bundle-text:./missing-media-investigation.md":"ZMGP5","bundle-text:./rtmp-vs-srt.md":"mtd5h","bundle-text:./setup-persistent-stream.md":"l1Pi9","bundle-text:./live-stream-health.md":"29BKT","bundle-text:./transcode-running-long.md":"bhhff","bundle-text:./cancel-transcode-job.md":"hE4BB","bundle-text:./github-actions-budget.md":"1gWXr","bundle-text:./stuck-unpublish-b2.md":"kZEr6","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"a5nIm":[function(require,module,exports,__globalThis) {
module.exports = "# Restart Stalled Publish job\n\n## Preperation\n\n1. Get assetID that's stuck (e.g. through browser network panel), then query the `transcodeJobs` table and confirm `jobType` is in `publish` status:\n\n```sql\nselect * from transcodeJobs\nwhere assetID = '{ASSET-ID}'\n```\n\n2. Open Asset in `mediaAssets` table:\n\n```sql\nselect * from mediaassets\nwhere assetID = '{ASSET-ID}'\n```\n\n3. Open Event status record in `eventStatus` table:\n\n```sql\nselect * from eventStatus\nwhere eventID = '{CLIENT-ID}_{EVENT-ID}'\n```\n\n---\n\n## Resolution\n\n1. Delete the record from the `transcodeJobs` table\n\n2. Change the asset's status in the mediaassets table to `available`\n\n3. Change the events status table record to available\n- Set the status to `4` (Available)\n\n4. Log into client account, go to the Event and hit publish again on that asset.";

},{}],"eLQJ0":[function(require,module,exports,__globalThis) {
module.exports = "# GeoFencing - Persistent Streams\n\nHow to enable geofencing for a Persistent Stream.\n\n---\n\n1. Get `psIndex` for the given client persistent stream\n\n```sql\nSELECT * FROM CoreMaster.persistentStreams;\n```\n\n---\n\n2. Go to `persistentStreamGeoblock` and see if that `psIndex` exists as a record\n    1. _If not_: you need to add it / create records – do step 3 first\n    2. _If so_: it can be removed / delete row to disable for client's persis stream\n\n---\n\n3. Using the `geoZip` table you can view what Zips are currently assigned \n\n```sql\nSELECT * FROM CoreMaster.geoZip;\n```\n\n```csv\ngeozipIdx clientID    zip     geoBlockID\n863       1000000000  98501   3\n```\n\n- If none are created for the client, you need to find the last `geozipIdx` and increment for new records. \n- `geoBlockID` will always point to `persistentStreamGeoblock.geoBlockID`\n\n\n---\n\n4. Once you have one or more Zip Codes assigned, you can go back to `persistentStreamGeoblock` and \"Turn on\" geofencing by using the Persistent Stream index and using the next available `geoBlockID`. \n\n```csv\npsIndex  geoBlockID\n253      3\n```\n\n---\n\n## Imporntant!\n\nSometimes we will remove a psIndex record from `persistentStreamGeoblock`, so you __NEED TO MAKE SURE__ that `geoBlockID` isn't already taken if you add one back to it!!\n\nYou can do this by looking through the `geoZip` table to see if it's already been used before:\n\n```sql\nSELECT DISTINCT geoBlockID FROM CoreMaster.geoZip;\n```";

},{}],"kJOQj":[function(require,module,exports,__globalThis) {
module.exports = "# Encoders - Orphaned\n\nIf an encoder/stream gets stuck in a `starting` state, you need to manually update the DB as follows.\n\n__Requirements:__\n\n## 1. Updating the Event's Status\n\n```sql\nSELECT * FROM eventStatus\nWHERE eventID = '{EVENT_ID}'\n```\n\nUpdate the Event's status to `4` (\"available\") and apply changes.\n\n## 2. Releasing the Encoder\n\n```sql\nSELECT * FROM liveStreams\nWHERE eventID = '{EVENT_ID}'\n```\n\nIf the `status` field is anything but `terminated`, you need to do 2 things:\n\n1. Update the `status` to `terminated`\n2. Set the `endDateTime` to any time AFTER the `startDateTime` \n  - It can be anything, but chosing a small value like 1 minute is fine\n\nCommit the changes, then you should be OK to use the Encoder again.";

},{}],"kXkZ7":[function(require,module,exports,__globalThis) {
module.exports = "# Events - Duplicate Detection & Cleanup\n\nWhen a system loop or hung process creates duplicate events, use this procedure to identify and remove them while preserving legitimate recurring events.\n\n## Understanding the Problem\n\nDuplicate events can occur when:\n- A scheduling system loops unexpectedly\n- API calls retry without idempotency checks\n- Import processes run multiple times\n\n**Key insight:** Recurring events (e.g., weekly meetings) share the same `title` but have different `customID` values. True duplicates from a hung loop will have the **same title AND same customID**.\n\n## Step 1: Initial Duplicate Scan (by Title Only)\n\nFirst, identify which titles have potential duplicates:\n\n```sql\nSELECT\n    ed.title,\n    COUNT(*) as count,\n    GROUP_CONCAT(e.eventID SEPARATOR ', ') as eventIDs,\n    MIN(e.startDateTime) as earliest,\n    MAX(e.startDateTime) as latest\nFROM events e\nJOIN eventDetails ed ON e.eventID = ed.eventID\nWHERE e.clientID = {CLIENT_ID}\n  AND e.startDateTime >= '{START_DATE}'\n  AND e.startDateTime < '{END_DATE}'\n  -- Optional: filter by title pattern\n  -- AND ed.title LIKE '%template%'\nGROUP BY ed.title\nHAVING COUNT(*) > 1\nORDER BY count DESC;\n```\n\nThis shows titles with multiple events, but some may be legitimate recurring instances.\n\n## Step 2: Breakdown by customID and startDateTime\n\nRefine to find true duplicates - same title, customID, AND exact startDateTime:\n\n```sql\nSELECT\n    ed.title,\n    ed.customID,\n    e.startDateTime,\n    COUNT(*) as count,\n    GROUP_CONCAT(e.eventID SEPARATOR ', ') as eventIDs\nFROM events e\nJOIN eventDetails ed ON e.eventID = ed.eventID\nWHERE e.clientID = {CLIENT_ID}\n  AND e.startDateTime >= '{START_DATE}'\n  AND e.startDateTime < '{END_DATE}'\n  -- Optional: filter by title pattern\n  -- AND ed.title LIKE '%template%'\nGROUP BY ed.title, ed.customID, e.startDateTime\nHAVING COUNT(*) > 1\nORDER BY count DESC;\n```\n\n**Interpretation:**\n- Each row = a unique (title, customID, startDateTime) combination with duplicates\n- `count` = number of duplicate events for that exact combo\n- Legitimate recurring events will NOT appear (different startDateTime or customID)\n\n**Why include startDateTime?** Recurring events (e.g., weekly meetings) share the same title but occur at different times. Grouping by exact `startDateTime` ensures these aren't flagged as duplicates.\n\n## Step 3: Generate Delete List\n\nExtract eventIDs to delete, keeping the first (MIN) eventID per (title, customID, startDateTime):\n\n```sql\nSELECT e.eventID\nFROM events e\nJOIN eventDetails ed ON e.eventID = ed.eventID\nWHERE e.clientID = {CLIENT_ID}\n  AND e.startDateTime >= '{START_DATE}'\n  AND e.startDateTime < '{END_DATE}'\n  -- Optional: filter by title pattern\n  -- AND ed.title LIKE '%template%'\n  AND e.eventID NOT IN (\n      SELECT MIN(e2.eventID)\n      FROM events e2\n      JOIN eventDetails ed2 ON e2.eventID = ed2.eventID\n      WHERE e2.clientID = {CLIENT_ID}\n        AND e2.startDateTime >= '{START_DATE}'\n        AND e2.startDateTime < '{END_DATE}'\n        -- Match the same filter as outer query\n        -- AND ed2.title LIKE '%template%'\n      GROUP BY ed2.title, ed2.customID, e2.startDateTime\n  )\nORDER BY e.eventID;\n```\n\n## Step 4: Execute Deletes via API\n\n**Important:** Do NOT use raw SQL DELETE. Deletes must go through the system dispatcher to propagate changes via Hooks.\n\nExport the eventID list to CSV, then feed to your delete dispatcher/script.\n\n## Verification\n\nAfter deletion, re-run the Step 2 query. All rows should now show `count = 1` (or no results if filtering was applied).\n\n## Quick Reference\n\n| Query | Purpose |\n|-------|---------|\n| Step 1 | Find titles with multiple events (includes recurring) |\n| Step 2 | Find true duplicates (same title + customID + startDateTime) |\n| Step 3 | Get eventIDs to delete (keeps first instance per combo) |\n\n## Example Values\n\nReplace placeholders with actual values:\n- `{CLIENT_ID}`: e.g., `2917038973`\n- `{START_DATE}`: e.g., `'2025-12-01 00:00:00'`\n- `{END_DATE}`: e.g., `'2026-02-28 00:00:00'`\n";

},{}],"ZMGP5":[function(require,module,exports,__globalThis) {
module.exports = "# Archive Events - Missing Media Investigation\n\nWhen clients report missing or inaccessible video assets, use this procedure to diagnose the actual problem before assessing scope.\n\n## Understanding the Problem\n\n\"Missing media\" can mean several different things:\n\n| Symptom | Likely cause |\n|---------|-------------|\n| Player shows no video | Asset not published in CRUD API (`assetCount: 0`) |\n| Video exists in DB but won't play | B2 file deleted or path mismatch |\n| No asset records at all | File never ingested or records purged |\n| Legacy events (pre-2013) missing | Never migrated from legacy storage |\n\n**Key insight:** Always verify what \"not available\" means before investigating storage. The files may be in B2 and playable — the issue is often on the publishing/player side, not the storage side.\n\n## Key Schema Notes\n\n### Event ID Format Difference\n\n| Table | Format | Example |\n|-------|--------|---------|\n| `events` | `{clientID}_{eventID}` | `2789595964_2013101057` |\n| `mediaassets` | `{eventID}` (numeric only) | `2013101057` |\n\nJoins between tables must use `SUBSTRING(e.eventID, 12)` to extract the numeric portion from the events table.\n\n### B2 File Naming\n\nFiles in B2 may use two different naming conventions:\n\n| Convention | Format | Example |\n|------------|--------|---------|\n| Hash-based (current) | `{clientID}/{sha1hash}.mp4` | `2147483647/59473011be...e8066e.mp4` |\n| Legacy event-based | `{clientID}/{eventID}-{profile}.mp4` | `2147483647/2015101033-14.mp4` |\n\nMulti-profile variants: `-audio.mp3`, `-mobile.mp4`, `-1.mp4` (original/source) may also exist alongside the primary `.mp4`.\n\n## Step 1: Check the CRUD API First\n\nBefore touching the database, check if the player-facing API has assets for the reported events. This is what the player actually uses.\n\n```\nGET https://api.v3.invintus.com/event/{clientID}/{eventID}\n```\n\nCheck the response for:\n- `assetCount` — 0 means no published assets\n- `mediaAssets` — empty array means nothing for the player to show\n- `eventStatus` — `new` vs `published`\n\nThis immediately tells you whether it's a publishing issue vs a storage issue.\n\n## Step 2: Check Internal DB Asset Records\n\nQuery `mediaassets` using numeric-only eventID:\n\n```sql\nSELECT\n  m.assetID,\n  m.eventID,\n  m.name,\n  m.assetType,\n  m.currentStatus,\n  m.fileSize,\n  m.path\nFROM mediaassets m\nWHERE m.clientID = {CLIENT_ID}\n  AND m.eventID IN (2015101057, 2015101080)\nORDER BY m.eventID, m.assetType;\n```\n\n**Red flags to watch for:**\n- `fileSize: 0` or very small (e.g. 42 bytes) — corrupt/empty asset record\n- Path points to hash-named file but file may not exist in B2\n- Records exist but CRUD API shows `assetCount: 0` — publishing issue\n\n## Step 3: Verify B2 Storage\n\nUse the B2 API to check if files actually exist. Do **not** list the entire client directory — clients can have 30k+ events with multiple profiles each.\n\n**Targeted approach:**\n- For events WITH asset records: search by the hash from the `path` field\n- For events WITHOUT asset records: search by event ID prefix\n- For a date range: search by `{clientID}/{eventID prefix}` (e.g. `2147483647/201510`)\n\n### B2 API Script\n\nA reusable B2 check script template is at: `.claude/dumps/missing-media/ktoo/check-b2-files.ts`\n\nRequires `.env.b2` with:\n```\nKeyID=your_key_id\napplicationKey=your_app_key\nBucketID=your_bucket_id\n```\n\n```bash\nnpx tsx .claude/dumps/missing-media/ktoo/check-b2-files.ts\n```\n\nAdapt the script for each client — update the `CLIENT_ID`, `EVENTS_WITH_ASSETS`, and `EVENTS_NO_ASSETS` constants.\n\n### Quick URL Check\n\nYou can also verify individual files by checking the public URL directly:\n\n```bash\ncurl -sI \"https://f005.backblazeb2.com/file/invintus-client-media/{clientID}/{assetHash}.mp4\" | head -5\n```\n\nA `200` response with correct `Content-Length` confirms the file exists and is accessible.\n\nAlso check the legacy download URL format:\n```\nhttps://m-download.invintus.com/{clientID}/{eventID}-14.mp4\n```\n\n## Step 4: Year-by-Year Scope Assessment (If Needed)\n\nOnly run this if the investigation suggests a broader problem beyond the reported events.\n\n```sql\nSELECT\n  YEAR(e.startDateTime) as year,\n  COUNT(DISTINCT e.eventID) as totalEvents,\n  COUNT(DISTINCT m.eventID) as eventsWithVideo,\n  COUNT(DISTINCT e.eventID) - COUNT(DISTINCT m.eventID) as missing\nFROM events e\nLEFT JOIN mediaassets m ON m.eventID = SUBSTRING(e.eventID, 12)\n  AND m.clientID = e.clientID\n  AND m.assetType = 'video'\nWHERE e.clientID = {CLIENT_ID}\nGROUP BY YEAR(e.startDateTime)\nORDER BY year ASC;\n```\n\n## Step 5: Classify Each Event\n\nAfter investigation, categorise every reported event:\n\n| Category | Description | Action |\n|----------|-------------|--------|\n| **Published & playable** | CRUD API has assets, B2 file exists | Ask client what they're experiencing |\n| **File exists, not published** | B2 has file, CRUD API shows no assets | Publish through CRUD API |\n| **Corrupt record** | DB has record with 0/tiny fileSize, hash file missing from B2 | Check for legacy-named file in B2, re-link if found |\n| **Truly missing** | No file in B2 under any naming convention | Unrecoverable unless client has source |\n\n## Client Communication Template\n\n```\nSubject: Archive Media Assessment - [Client Name]\n\nWe've investigated the [X] events you reported as unavailable.\n\n[X] events are published and playable — could you share more detail\non what you're experiencing? (Error message, blank player, not\nappearing in search, etc.)\n\n[X] events have video files but aren't currently published. We can\npublish these if you'd like.\n\n[X] events have no video files in our storage. If you have original\nsource recordings, we could re-ingest them.\n\n[List event IDs per category]\n\nLet us know how you'd like to proceed.\n```\n\n## Recovery Options\n\n1. **Publish existing files**: For events where B2 has the file but CRUD API doesn't — create/fix asset records\n2. **Re-link legacy files**: For corrupt records where legacy-named files exist in B2\n3. **Client-provided source files**: If client has original recordings\n4. **Hide unrecoverable events**: Set `visible: 0` for events that cannot be recovered\n\n## Known Client-Specific Patterns\n\n**Client 2789595964 (Wisconsin):** 90% of missing media (158/175 events) are \"Assembly Floor Session\" recordings, particularly multi-part sessions. Other content types were migrated successfully. Suggests Floor Session content was stored/processed differently in the legacy system.\n\n**Client 2147483647 (KTOO):** Massive legacy gaps (2005-2012: ~10,000 events missing video). 2013 onwards mostly intact. Oct 2015 ACH2 investigation (April 2026) found 12/18 reported events were actually published and playable — client communication issue, not storage issue.\n";

},{}],"mtd5h":[function(require,module,exports,__globalThis) {
module.exports = "# Identifying RTMP vs TS over SRT\n\nQuick reference for determining which streaming protocol a client encoder uses.\n\n---\n\n## Check the Database\n\n```sql\nSELECT encoderID, simpleName, inputURI\nFROM encoders\nWHERE clientID = {CLIENT_ID};\n```\n\n| inputURI starts with | Protocol |\n|----------------------|----------|\n| `rtmp://` | RTMP |\n| `rtmps://` | RTMP over TLS |\n| `srt://` | TS over SRT |\n\n---\n\n## Probe an Active Encoder\n\nIf the encoder is online, probe it directly:\n\n```bash\n# RTMP\nffprobe -v quiet -print_format json -show_streams \\\n  \"rtmp://ingress.example.com/srcEncoders/stream-key\"\n\n# SRT (note the port)\nffprobe -v quiet -print_format json -show_streams \\\n  \"srt://server:9998?streamid=stream-key\"\n```\n\nIf the probe succeeds, you've confirmed the protocol.\n\n---\n\n## Common Port Numbers\n\n| Protocol | Port |\n|----------|------|\n| RTMP | 1935 |\n| RTMPS | 443 |\n| SRT | Varies (9998, 9999, custom) |\n\n---\n\n## Haivision Encoder Settings\n\nWhen helping a client configure a Haivision:\n\n**For RTMP:**\n- Output Type: `RTMP` or `RTMP Push`\n- URL: `rtmp://ingress.{region}.invintus.stream/srcEncoders`\n- Stream Key: `{stream-name}`\n\n**For SRT:**\n- Output Type: `TS over SRT`\n- Mode: `Caller` (encoder initiates connection)\n- Address: server IP/hostname\n- Port: assigned SRT port\n- Passphrase: if encryption enabled\n\n---\n\n## Quick Comparison\n\n| Feature | RTMP | SRT |\n|---------|------|-----|\n| Container | FLV | MPEG-TS |\n| Transport | TCP | UDP + ARQ |\n| Latency | 2-5s | 0.5-2s |\n| Encryption | RTMPS (TLS) | Native AES |\n\n**Most Invintus clients use RTMP.** SRT is rare in current deployments.\n";

},{}],"l1Pi9":[function(require,module,exports,__globalThis) {
module.exports = "# Setting Up a New Persistent Stream\n\nHow to create a new 24/7 persistent stream for a client, from database records to Wowza configuration.\n\n---\n\n## Overview\n\nPersistent streams are always-on streams that relay through two Wowza servers:\n\n```\nEncoder/Camera → (RTMP) → ingress.w1.invintus.com (srcEncoders) → (Stream Target, RTMP:1935) → persis.invintus.live (persis) → (HLS) → Player/Embed\n```\n\n- **Ingress server**: Receives RTMP from encoders, relays via Stream Targets\n- **Persis server**: Serves 24/7 HLS playback\n\n### Access\n\n| System | URL | Credentials |\n|--------|-----|-------------|\n| Ingress Wowza Engine Manager | `http://ingress.w1.invintus.com:8088/enginemanager/` | 1Password |\n| Persis Wowza Engine Manager | `http://persis.invintus.live:8088/enginemanager/` | 1Password: \"Persistent Stream monitoring - Wowza\" |\n\n---\n\n## Step 1: Create Encoder + Enable Persistent Stream\n\nThis is done via the **Control Center UI** (no SQL required):\n\n1. Go to [https://controlcenter.invintusmedia.com/manage/encoders](https://controlcenter.invintusmedia.com/manage/encoders)\n2. Create a new encoder for the client (this creates the `clientEncoders` DB record)\n3. Click the **Live 24/7** tab on the encoder\n4. Toggle **\"Enabled\"** to allow 24/7 persistent streaming (this creates the `persistentStreams` DB record)\n\n**Naming convention for streamName**: `{ClientPrefix}-camera{N}` (e.g., `KCIA-camera5`)\n\nIf setting up geofencing later, you'll need the `psIndex` — see [Persistent Stream Geofencing](/runbook/peristent-stream-geofencing).\n\n<details>\n<summary>Manual SQL (if Control Center is unavailable)</summary>\n\n### Create `clientEncoders` record\n\n```sql\nINSERT INTO clientEncoders (encoderID, clientID, simpleName, description, inputURI, streamName)\nVALUES (\n  '{encoderID}',          -- 8-char alphanumeric ID (generate unique)\n  {clientID},\n  '{Display Name}',\n  '{Description}',\n  'rtmp://ingress.w1.invintus.com/srcEncoders/{streamName}',\n  '{streamName}'\n);\n```\n\n### Create `persistentStreams` record\n\n```sql\nINSERT INTO persistentStreams (clientID, encoderID, title)\nVALUES (\n  {clientID},\n  '{encoderID}',\n  '{Human-readable title}'\n);\n```\n\n</details>\n\n---\n\n## Step 2: Create Stream Target on Ingress\n\nThis tells the ingress server to relay the encoder's stream to the persis server.\n\n1. Log into **ingress.w1** Wowza Engine Manager\n2. Go to `srcEncoders` application > **Stream Targets**\n3. If the client already has existing persistent streams, the easiest approach is to **copy** one:\n   - Find an existing stream target in the list (e.g., `persisS3Target_{clientID}_...`)\n   - Click the **\"Copy Stream Target\"** icon in the Action column\n   - Enter the new name: `persisS3Target_{clientID}_{streamName}_247`\n   - Edit the copied record to update the Source Stream Name and Destination Stream Name\n4. Otherwise, create a new RTMP Stream Target with these settings:\n\n| Field | Value |\n|-------|-------|\n| **Name** | `persisS3Target_{clientID}_{streamName}_247` |\n| **Source Stream Name** | `{streamName}` |\n| **Destination Host** | `persis.invintus.live` |\n| **Destination Port** | `1935` |\n| **Destination Application Name** | `persis` |\n| **Destination Stream Name** | `{clientID}_{streamName}_247` |\n| **Destination Application Instance** | _(leave blank / not set)_ |\n\nThe stream target will show \"Waiting...\" until the encoder starts pushing.\n\n---\n\n## Step 3: Verify\n\n### 3a. Encoder pushes to ingress\n\nOnce the client turns on their encoder, check on **ingress.w1**:\n- `srcEncoders` > **Incoming Streams** — should show `{streamName}` as Active\n- `srcEncoders` > **Stream Targets** — should flip from \"Waiting...\" to \"Active\"\n\n### 3b. Persis receives the relay\n\nOn **persis.invintus.live**:\n- `persis` > **Incoming Streams** — should show `{clientID}_{streamName}_247` as Active\n\n### 3c. HLS playback works\n\nTest the playback URL in a browser or VLC:\n\n```\nhttps://api.v3.invintus.com/StreamURI/persis/{clientID}/{streamName}/media.m3u8\n```\n\n---\n\n## Step 4: Send Client Configuration\n\n### Encoder Settings\n\nSend the client their RTMP ingest credentials:\n\n```\nFull URI: rtmp://ingress.w1.invintus.com/srcEncoders/{streamName}\nServer:   rtmp://ingress.w1.invintus.com/\nApplication: srcEncoders\nStream Name: {streamName}\n```\n\n**Note:** Some encoding applications require the URI split into Server + Application + Stream Name. The Server field must have a trailing slash.\n\n### Embed Code\n\nThe client can find embed codes at `https://controlcenter.invintusmedia.com/manage/encoders` under the \"Live 24/7\" tab. The embed follows this pattern:\n\n```html\n<div id=\"persistent-stream-{encoderID}\"></div>\n<script>\n!(function(src,cb){\n  var s=document.createElement('script');\n  s.src=src;s.async=true;s.charset='utf-8';\n  if(s.readyState){\n    s.onreadystatechange=function(){\n      if(s.readyState=='loaded'||s.readyState=='complete'){\n        s.onreadystatechange=null;cb();\n      }\n    };\n  } else {\n    s.onload=function(){cb();};\n  }\n  document.getElementsByTagName('head')[0].appendChild(s);\n})('https://player.invintus.com/app.js', function(){\n  InvintusJwplayer.launch({\n    \"clientID\": \"{clientID}\",\n    \"player\": {\"autoStart\": true, \"trackAnalytics\": true},\n    \"model\": {\n      \"key\": \"encoder\",\n      \"encoderID\": \"uid\",\n      \"streamName\": \"name\",\n      \"live247URI\": \"uri\"\n    },\n    \"encoder\": {\n      \"encoderID\": \"{encoderID}\",\n      \"streamName\": \"{streamName}\",\n      \"live247URI\": \"https://api.v3.invintus.com/StreamURI/persis/{clientID}/{streamName}/media.m3u8\"\n    },\n    \"selector\": \"persistent-stream-{encoderID}\"\n  });\n});\n</script>\n```\n\n---\n\n## Troubleshooting\n\n| Symptom | Check |\n|---------|-------|\n| Stream Target stuck on \"Waiting...\" | Encoder isn't pushing to ingress yet — confirm with client |\n| Ingress shows Active but persis doesn't | Stream Target misconfigured — verify destination host/port/app/stream name |\n| HLS URL returns 404 | Stream not active on persis, or `api.v3` routing issue |\n| DB says `rtmp://ingress.w1.invintus.com` but stream is on persis | That's expected — the DB `inputURI` is the ingest point, persis handles playback |\n\n---\n\n## Reference: Naming Conventions\n\n| Item | Pattern | Example |\n|------|---------|---------|\n| Stream Name | `{Prefix}-camera{N}` | `KCIA-camera5` |\n| Stream Target Name | `persisS3Target_{clientID}_{streamName}_247` | `persisS3Target_6779541715_KCIA-camera5_247` |\n| Persis Stream Name | `{clientID}_{streamName}_247` | `6779541715_KCIA-camera5_247` |\n| Playback URL | `https://api.v3.invintus.com/StreamURI/persis/{clientID}/{streamName}/media.m3u8` | See above |\n\n---\n\n## Why Two Servers?\n\nThe ingress server (`w1`) handles **all** encoder ingest — both event-based and persistent. The persis server is dedicated to **always-on 24/7 restreaming**. This separation provides:\n\n- **Uniform client config** — every encoder gets the same `rtmp://ingress.w1.invintus.com/srcEncoders/{name}` pattern regardless of whether it's persistent or event-based. Clients never need to know about `persis`.\n- **Resource isolation** — a 24/7 stream won't starve resources from live events, and vice versa. Each server can be tuned independently (nDVR, transcoder profiles, etc.).\n- **Migration flexibility** — if the persis server moves, just update the Stream Targets on ingress. No client-side changes needed.\n\nThe DB `inputURI` pointing to `w1` is **correct** — it is the ingest point. The stream just gets relayed onward to `persis` via Stream Targets. This can be confusing if you're looking at the DB and wondering why playback comes from a different server.\n";

},{}],"29BKT":[function(require,module,exports,__globalThis) {
module.exports = "# Live Stream Health — CDN Inspection via Shell\n\nWhen a viewer reports playback problems, the pipeline logs show \"verified OK at CDN Origin\" but you still want a *current* read on the live edge. This runbook walks through probing the HLS manifest stack with `curl` end-to-end.\n\n## When to use this\n\n- Pipeline logs end with `manifests verified OK at CDN Origin` but you want post-startup confirmation\n- A stream restart shows multiple egress spin-ups in the logs and you need to know which hash actually went live\n- A user reports buffering/stalls and you need to check whether the live edge is advancing\n- You want to verify caption segments are tracking with video\n\n## Inputs\n\nYou need:\n- `clientID` — e.g. `6361162879`\n- `eventID` — the **bare** numeric eventID (no client prefix), e.g. `2026041064`\n\nThe master manifest URL is always:\n\n```\nhttps://api.v3.invintus.com/StreamURI/hls/{clientID}/{eventID}/media.m3u8\n```\n\nThis endpoint redirects/proxies to the active hash on the Fastly live CDN. The hash in the response is what matters — pipeline-log restart cascades will leave stale hashes that no longer resolve.\n\n## Step 1: Fetch the master manifest\n\n```sh\nCLIENT=6361162879\nEVENT=2026041064\n\ncurl -sS -o /tmp/media.m3u8 \\\n  -w \"HTTP=%{http_code} SIZE=%{size_download} TIME=%{time_total} CT=%{content_type}\\n\" \\\n  \"https://api.v3.invintus.com/StreamURI/hls/$CLIENT/$EVENT/media.m3u8\"\n\ncat /tmp/media.m3u8\n```\n\n**What to check:**\n\n- `HTTP=200`, `CT=application/x-mpegURL` — manifest is being served\n- The hash directory in each rendition URL (e.g. `094c1b2f218a6542e6feca42b0381f64`) — this should match the **most recent** `LIVE STARTUP: egress spinning up stream` line in the pipeline logs\n- The encoder name in the path (`AZ-247.stream`, `AZ-Encoder9.stream`, etc.) tells you which encoder is currently serving\n- 5 `#EXT-X-STREAM-INF` rungs expected (1080p, 720p, 480p, 360p, 160p)\n- `#EXT-X-MEDIA:TYPE=SUBTITLES` line should be present if captions are enabled\n\nIf the hash here disagrees with the latest pipeline log, the previous restart attempt was abandoned — that is the signal of a half-failed cutover.\n\n## Step 2: Probe every rendition + captions\n\n```sh\nHASH=$(grep -oE '[a-f0-9]{32}' /tmp/media.m3u8 | head -1)\nENCODER=$(grep -oE 'AZ-[A-Za-z0-9]+\\.stream' /tmp/media.m3u8 | head -1)\nBASE=\"https://fastlylivecdn.invintus.com/$HASH\"\n\nfor prof in 1080p 720p 480p 360p 160p; do\n  url=\"$BASE/${ENCODER}_${prof}/chunklist.m3u8\"\n  echo \"=== $prof ===\"\n  curl -sS -D /tmp/h.txt \"$url\" -o /tmp/c.txt \\\n    -w \"HTTP=%{http_code} SIZE=%{size_download} TIME=%{time_total}\\n\"\n  grep -iE '^x-cache:|^age:|^cache-control:' /tmp/h.txt | sed 's/^/  /'\n  tail -8 /tmp/c.txt | sed 's/^/  /'\n  echo\ndone\n\necho \"=== captions ===\"\ncurl -sS \"$BASE/captions/captions.m3u8\" -o /tmp/c.txt \\\n  -w \"HTTP=%{http_code} SIZE=%{size_download} TIME=%{time_total}\\n\"\ntail -8 /tmp/c.txt | sed 's/^/  /'\n```\n\n**What to check per chunklist:**\n\n- `HTTP=200` on every rung\n- `#EXT-X-TARGETDURATION:10` and per-segment `#EXTINF:~10.0` — nominal segment cadence\n- `#EXT-X-MEDIA-SEQUENCE` — note the value; you'll re-poll to confirm it advances\n- All rungs should share the same `MEDIA-SEQUENCE` (or be within ±1)\n- Captions sequence usually runs 1–3 ahead of video — that's normal\n\n**Cache headers:**\n\n- `cache-control: max-age=5` is the live HLS norm. `x-cache: MISS` on every hit is fine — the 5s TTL forces revalidation.\n- If you see `age:` climbing past `5`, Fastly is serving stale — investigate.\n\n## Step 3: Confirm the live edge is current\n\nThe segment filenames are unix-epoch timestamped: `data-1777488209.ts`. Compare the latest segment epoch to wall clock:\n\n```sh\nLATEST=$(grep -oE 'data-[0-9]+\\.ts' /tmp/c.txt | tail -1 | grep -oE '[0-9]+')\necho \"now      = $(date -u +%s) ($(date -u))\"\necho \"latest   = $LATEST ($(date -u -r $LATEST))\"\necho \"drift_s  = $(( $(date -u +%s) - LATEST ))\"\n```\n\n**Expected:** drift of ~10–30 seconds. Larger drift means the encoder has stopped pushing or egress is stalled.\n\n## Step 4: Confirm the sequence is advancing\n\nPoll the same chunklist twice, ~12s apart:\n\n```sh\nseq1=$(curl -sS \"$BASE/${ENCODER}_1080p/chunklist.m3u8\" | grep -oE 'MEDIA-SEQUENCE:[0-9]+')\nsleep 12\nseq2=$(curl -sS \"$BASE/${ENCODER}_1080p/chunklist.m3u8\" | grep -oE 'MEDIA-SEQUENCE:[0-9]+')\necho \"before: $seq1\"\necho \"after:  $seq2\"\n```\n\n`seq2` should be greater than `seq1` (typically by 1 over a 12s window). If it doesn't advance, the live edge is frozen even though the manifest itself is still being served — encoder-side problem, not CDN-side.\n\n## Step 5: Pull a real segment\n\nA 200 on the manifest doesn't prove segments are fetchable. Verify:\n\n```sh\nSEG=$(grep -oE 'data-[0-9]+\\.ts' /tmp/c.txt | tail -1)\ncurl -sS -o /dev/null \\\n  -w \"HTTP=%{http_code} SIZE=%{size_download} TIME=%{time_total} CT=%{content_type}\\n\" \\\n  \"$BASE/${ENCODER}_1080p/$SEG\"\n```\n\n**Expected:** `HTTP=200`, `CT=video/mp2t`, size in the 1–5 MB range for a 10s 1080p chunk. A 404 here with a 200 manifest is the classic \"manifest references segments that haven't published yet\" race — usually self-resolves; if persistent, segmenter is broken.\n\nFor captions:\n\n```sh\nVTT=$(grep -oE 'subtitleSegment[0-9]+\\.webvtt' /tmp/c.txt | tail -1)\ncurl -sS -o /tmp/seg.vtt \\\n  -w \"HTTP=%{http_code} SIZE=%{size_download}\\n\" \\\n  \"$BASE/captions/$VTT\"\nhead -20 /tmp/seg.vtt\n```\n\nWebVTT segments are typically 2–10 KB. An empty or `0`-byte VTT means the caption pipeline is connected but Whisper isn't producing text (silence, or transcription stalled).\n\n## Cleanup\n\n```sh\nrm -f /tmp/media.m3u8 /tmp/h.txt /tmp/c.txt /tmp/seg.vtt\n```\n\n## Red flags reference\n\n| Symptom | Likely cause |\n|---------|-------------|\n| Master manifest 404 | No active live stream; egress never spun up or has been stopped |\n| Master manifest hash differs from latest pipeline log | Earlier restart attempt is the active one — most recent log entry was an aborted attempt |\n| One rendition 404, others 200 | Transcoder rung is down; ABR ladder degraded but viewer still has fallback rungs |\n| Segment epoch drift > 60s | Encoder push has stalled — check source encoder logs (`House Chamber`, etc.) |\n| `MEDIA-SEQUENCE` not advancing across two polls | Live edge frozen at egress despite manifest being served |\n| Manifest 200 but segment 404 (persistent) | Segmenter/origin desync — page on-call |\n| Empty `.webvtt` segments while video segments are populated | Caption pipeline connected but Whisper queue stalled or audio is silent |\n| `age:` header > `max-age` on chunklists | Fastly serving stale, origin unreachable from edge |\n\n## Related\n\n- See `restart-stalled-publish-job` for the post-stream VOD side\n- See `rtmp-vs-srt` for source-encoder ingest debugging\n- Pipeline logs: **Logs > Pipeline** in the sidebar, search by eventID\n";

},{}],"bhhff":[function(require,module,exports,__globalThis) {
module.exports = "# Transcode Job Running Long — Diagnosis\n\nUse this when a transcode has been running far longer than expected and you need to determine *why* before deciding whether to wait or intervene.\n\nTo actually stop or restart a job once you've diagnosed it, see **Cancelling and Restarting a Transcode Job**.\n\n## First: \"long\" relative to what?\n\nEstablish the baseline before investigating. A healthy transcode on the production node runs at roughly **10–20× realtime** for a single 720p job.\n\n| Source duration | Expected transcode time |\n|---|---|\n| 30 min | ~2–3 min |\n| 1 hour | ~4–6 min |\n| 5 hours | ~25–30 min |\n\nTwo concurrent jobs roughly halve throughput each. If you're meaningfully outside these numbers, keep reading.\n\n## Decision tree\n\n```mermaid\nflowchart TD\n    A[Transcode running long] --> B{Pipeline logs still<br/>emitting 'processing'?}\n    B -->|No, stopped early| C{Temp files present?}\n    B -->|Yes, still ticking| D[FFmpeg is alive — measure throughput]\n    C -->|Yes, static| E[Stalled B2 upload<br/>see 'stalled-publish' runbook]\n    C -->|No| F[Truncation — FFmpeg exited 0<br/>with partial output]\n    D --> G{speed= in ffmpeg output}\n    G -->|&lt; 1x| H[Encoder overloaded<br/>or bad encode args]\n    G -->|Normal| I{Multiple jobs on the box?}\n    I -->|Yes| J[GPU contention — expected, wait]\n    I -->|No| K[Check source: length, bitrate,<br/>network read from S3]\n    H --> L{dup= is large?}\n    L -->|Yes| M[Frame-rate arg is wrong<br/>— see 'Runaway frame duplication']\n    L -->|No| N[Check nvidia-smi encoder util]\n```\n\n## Step 1 — Confirm it's alive (no SSH needed)\n\nOpen **Pipeline Logs** and search the asset ID or transcode ID.\n\nThe transcoder emits one `transcode/processing` message **per whole percentage point** of progress (`lib/transcoder/transcode-job/index.js` `extractProgress`, gated by the reducer's change check). That gives you two things for free:\n\n- **Message count ≈ percent complete.** 24 messages ≈ 24% done.\n- **Cadence tells you the shape of the problem.** Steady intervals with mild variance means a running encode. A fixed, perfectly regular interval would suggest a timer, not real progress.\n\nExtrapolate from there: `elapsed ÷ percent × 100` = total runtime.\n\n| Log pattern | Meaning |\n|---|---|\n| Messages still arriving | FFmpeg alive — go to Step 2 |\n| Messages stopped, no `transcode/complete` | Truncation or stalled upload |\n| `starting` with no `processing` at all | Job never got past probe — check source URL reachability |\n\n**Progress is measured against output media time, not frames** — `extractProgress` parses FFmpeg's `time=` and divides by the source `Duration:`. This matters: a job can be at 24% having already encoded far more frames than 24% of the source would imply. That discrepancy is itself a diagnostic (see Step 4).\n\n### Timezone gotcha\n\nThree different zones are in play. Get this wrong and the timeline looks impossible.\n\n| Field | Zone |\n|---|---|\n| Pipeline log timestamps | US/Pacific |\n| `recStartDate` / `recStopDate` | UTC |\n| `dateCreated` (media asset) | Client-local |\n\nSanity check: transcode `starting` should land 2–4 minutes after `recStopDate`. If it doesn't, you've mixed zones.\n\n## Step 2 — Get the actual FFmpeg command\n\nSSH to the transcoder node (`i-0ad3cb7080ccc8f39`, g4dn.2xlarge).\n\n```bash\ncurl -s http://localhost:3000/status     # freeSlots — how many jobs are competing?\nps aux | grep ffmpeg                     # full arg list + start time + cumulative CPU\nls -la /invintus/transcoder-node/temp-files/\ndf -h\n```\n\n**Read the whole argument list.** transcoder-node contributes only the prefix (`lib/transcoder/index.js:20`):\n\n```\n-y -probesize 50M -analyzeduration 50M -vsync 1 [-hwaccel nvdec] -i <source> -nostdin\n```\n\nEverything after `-nostdin` arrives verbatim in the job request as `encoder_options` and is passed through untouched. **If the encode args are wrong, the bug is upstream in whatever built the request, not in transcoder-node.** Don't waste time grepping this repo for them.\n\nThings to check in that arg list:\n\n| Look for | Why it matters |\n|---|---|\n| `-r <rate>` | Combined with `-vsync 1` this forces CFR. A wrong value duplicates frames — see below |\n| `-hwaccel nvdec` | Absent means CPU decode; scaling filters also run on CPU |\n| Number of output files | One output = `transcode` job. Multiple = `publish` ladder |\n| `-i https://...` | Source is streamed from S3, not downloaded first |\n\n## Step 3 — Check whether the box is actually the problem\n\n```bash\nnvidia-smi\nnvidia-smi -q -d UTILIZATION | grep -A2 Encoder    # NVENC util is NOT the GPU-Util figure\n```\n\nPlain `GPU-Util` does not reflect NVENC load. You need the encoder-specific figure.\n\n`ps aux` `%CPU` is a **lifetime average**, not current load. A value near 13% on a `-hwaccel nvdec` job is normal and indicates a GPU-bound pipeline. High CPU with idle NVENC points at CPU-side decode or scaling.\n\n## Step 4 — Measure real throughput\n\nThe single most informative thing you can do. Run a 60-second probe with the **exact same args** as the stuck job:\n\n```bash\nffmpeg -t 60 -hwaccel nvdec -i \"<source-url>\" \\\n  -c:v h264_nvenc -b:v 1200k -vsync 1 -r <rate-from-ps> -s 1280x720 -an -f null -\n```\n\nRead the status line:\n\n```\nframe=10954 fps=268 q=39.0 size=N/A time=00:00:10.94 bitrate=N/A dup=10626 drop=0 speed=0.268x\n```\n\n| Field | What it tells you |\n|---|---|\n| `speed=` | Multiple of realtime. Below 1× on a GPU node is always wrong |\n| `dup=` | **Duplicated frames.** Should be ~0. Anything large is the smoking gun |\n| `frame ÷ time` | Actual output frame rate — compare against the source's real rate |\n| `frame − dup` | Real frames. Divided by `time`, should equal the source frame rate |\n\n### Cross-check without running anything\n\nIf you'd rather not add load, derive progress from the growing temp file:\n\n```\noutput_seconds = file_bytes × 8 ÷ (video_bitrate + audio_bitrate)\npercent        = output_seconds ÷ source_duration\n```\n\nWith CBR (`-b:v X -maxrate X -bufsize X`) this is accurate to a few percent, and it should agree with the pipeline-log message count. If those two agree but the job is still crawling, throughput is the problem, not progress reporting.\n\n## Known cause: runaway frame duplication\n\nThe failure mode most likely to produce a *dramatically* long transcode.\n\n**Signature:** `dup=` is enormous, `speed=` well under 1×, and `frame ÷ time` is far above the source frame rate.\n\n**Mechanism:** `-vsync 1` requests constant frame rate. `-r` sets the target. If `-r` is wrong — e.g. `1000000/1001` (999 fps) where `30000/1001` (29.97 fps) was intended — FFmpeg manufactures frames to fill the target rate. Each source frame is re-submitted to the encoder ~33 times. The GPU runs flat out and 97% of the work is discarded duplicates.\n\n**Verify** by A/B on a 60-second slice:\n\n```bash\nffmpeg -t 60 -i \"<url>\" -c:v h264_nvenc -b:v 1200k -vsync 1 -r 1000000/1001 -s 1280x720 -an -f null -\nffmpeg -t 60 -i \"<url>\" -c:v h264_nvenc -b:v 1200k -vsync 1 -r 30000/1001  -s 1280x720 -an -f null -\n```\n\nThe `frame=` counts should differ by the ratio of the two rates.\n\n**Secondary impact worth checking:** an inflated frame rate also lands in the published container. 720p at ~1000 fps is far outside any H.264 level (level 3.1 caps at 108k macroblocks/sec; 720p at 1000 fps needs ~3.6M). Hardware decoders on phones and set-top boxes may reject or struggle with those files. Probe a previously published asset to scope it:\n\n```bash\nffprobe -v error -select_streams v:0 \\\n  -show_entries stream=r_frame_rate,avg_frame_rate,level \\\n  -of default=nw=1 <published_url>\n```\n\nIf existing published files carry the inflated rate, the problem is longstanding rather than new — playback compatibility then matters more than transcode duration.\n\n**Fix location:** upstream, in whatever service builds `encoder_options`. Not in transcoder-node. Note that encode profiles may live in the database rather than in code, so a clean `grep` across repos does not rule it out — and stale commit dates are not evidence the value is correct.\n\n## Also check the source\n\nBefore blaming the pipeline, confirm the input is what you expect:\n\n```bash\nffprobe -v error -show_format -show_streams -of default=noprint_wrappers=1 \"<source-url>\"\n```\n\n| Field | Watch for |\n|---|---|\n| `duration` | Recording ran past its scheduled end? Compare to the event's `estRuntime` |\n| `size` | Multi-GB sources stream over HTTPS from S3 for the whole job |\n| `nb_frames` vs `duration × fps` | Large mismatch means timestamp gaps; `-vsync 1` will pad them |\n| `time_base=1/90000` | MPEG-TS origin — a remuxed live capture, not a mezzanine |\n\nTwo common non-bugs that look like bugs:\n\n- **Recording overran.** `autoStop: false` on an event means the encoder runs until someone stops it. A 60-minute scheduled meeting can produce a 5-hour asset, mostly dead air. Check `estRuntime` against `totalRunTime`.\n- **Duplicate content.** An operator uploading a master file of the same meeting that was captured live produces two near-identical multi-hour jobs competing for the same GPU. Check `assetCount` and `mediaAssets` on the event.\n\n## Diagnosis summary\n\n| Evidence | Conclusion |\n|---|---|\n| Logs ticking, `dup=` ~0, `speed=` 10×+, multiple jobs running | Normal. GPU contention. Wait |\n| Logs ticking, `dup=` large, `speed=` < 1× | Bad `-r` in the encode profile. Fix upstream |\n| Logs ticking, `dup=` ~0, `speed=` < 1×, NVENC idle | CPU-bound — check for missing `-hwaccel`/CPU scaling |\n| Logs stopped, temp files static, no FFmpeg process | Stalled upload — see `stalled-publish` |\n| Logs stopped early, no temp files, no `complete` | Truncation. FFmpeg exited 0 on partial input |\n| No `processing` at all | Source unreachable or probe failed |\n";

},{}],"hE4BB":[function(require,module,exports,__globalThis) {
module.exports = "# Cancelling and Restarting a Transcode Job\n\nHow to stop a running transcode on the production node without corrupting the node's state.\n\nDiagnose first — see **Transcode Job Running Long — Diagnosis**. This runbook assumes you've already decided the job should die.\n\n## TL;DR\n\n**Kill the ffmpeg PID.** Do not use `DELETE /job`.\n\n```bash\nssh <transcoder-node>\nps aux | grep ffmpeg          # find the PID for your asset ID\nsudo kill <pid>               # SIGTERM, not -9\ncurl -s http://localhost:3000/status   # confirm freeSlots went UP\n```\n\n## Method comparison\n\n| | Kill PID | `DELETE /job` | Service restart |\n|---|:---:|:---:|:---:|\n| Temp files cleaned | ✅ | ✅ | ❌ |\n| Slot correctly returned | ✅ | ❌ **loses 2** | ✅ (reset) |\n| `inProgressJobs` cleaned | ✅ | ✅ | ✅ (reset) |\n| SQS message to CORE | ✅ error | ❌ **silent** | ❌ **silent** |\n| Orphans running ffmpeg | ❌ | ❌ | ✅ **yes** |\n| Needs the job UUID | ❌ | ✅ | ❌ |\n| Can crash the service | ❌ | ✅ | — |\n\n## Method 1 — Kill the ffmpeg PID (recommended)\n\n```bash\nps aux | grep ffmpeg\n```\n\nMatch the PID by the asset ID in the `-i` or output path. Then:\n\n```bash\nsudo kill <pid>\n```\n\nUse SIGTERM. `-9` works but offers nothing extra — both produce a non-zero exit, which is what matters.\n\n**Why this is the clean path.** A non-zero exit routes through the normal error handling, and every piece of bookkeeping happens correctly:\n\n```mermaid\nflowchart LR\n    A[kill PID] --> B[non-zero exit]\n    B --> C[\"transcode-job/index.js:135<br/>cleanTempFiles(targets)\"]\n    C --> D[\"job.emit('error')\"]\n    D --> E[\"reducer error handler<br/>index.js:194<br/>freeSlots += jobs.length\"]\n    D --> F[\"server.js:110<br/>delete inProgressJobs<br/>+ SQS error message\"]\n    F --> G[CORE notified]\n```\n\nThe SQS error message is the part that matters most — it's the only method that tells CORE anything. Without it the asset sits at `currentStatus: \"transcoding\"` forever with no terminal event.\n\n**Verify afterward:**\n\n```bash\ncurl -s http://localhost:3000/status\nls -la /invintus/transcoder-node/temp-files/\n```\n\n`freeSlots` must go **up** by one per killed job, and the temp file for that asset should be gone. If `freeSlots` didn't move, the slot leaked — see Method 2's failure mode, and plan a restart.\n\n## Method 2 — `DELETE /job` (do not use)\n\nThe endpoint exists at `server.js:177` and takes `{\"id\": \"<reducer-uuid>\"}`. It is currently broken in three ways. Tracked as **TVWIT/transcoder-node#64**.\n\n**It leaks two slots per cancel.** `TranscodeJob.prototype.cancel` (`transcode-job/index.js:186`) sets `wasCancelled = true`; the exit branch at `:130` calls `_onEnd` directly and emits neither `end` nor `error`. So the reducer's restore at `index.js:190`/`:194` never runs and the accept-time decrement is never undone. Then `server.js:201` subtracts another with `--transcoder.freeSlots`. Net −2. Four cancels strand an idle node at `freeSlots: 0`, after which `index.js:172` rejects every incoming job until restart.\n\n**It sends no SQS message.** CORE is never told. The asset hangs in `transcoding` indefinitely.\n\n**A wrong id takes the service down.** `server.js:184` does `inProgressJobs[data.id].cancel(...)` with no existence check. On a missing key, the `TypeError` is thrown inside the async `parseBody` callback — outside the `try/catch` at `server.js:217`, which has already returned. Uncaught exception, process exits, and in-flight ffmpeg children are orphaned.\n\n**Finding the id is also a chore.** It's a `uuid.v1` that only appears in `console.log`/pino output that isn't persisted. It does ride along in progress SQS messages, so expanding a `processing` row in Pipeline Logs will show it — but there's no reason to go looking given the above.\n\n## Method 3 — Restart the service (last resort)\n\nChildren are spawned non-detached. **Killing the Node parent orphans the ffmpeg processes** — they keep running and keep the GPU saturated, while `freeSlots` resets to `maxSlots` and the node cheerfully accepts new work onto a busy GPU.\n\nIf you must restart, kill the ffmpeg PIDs first, then restart. At which point you've already done Method 1 and the restart is only needed to repair a corrupted slot count.\n\n```bash\nps aux | grep ffmpeg\nsudo kill <pids>\nsudo systemctl restart transcoder-node    # confirm the actual supervisor first\ncurl -s http://localhost:3000/status\n```\n\nRestart is the correct remedy for exactly one condition: **`freeSlots` is wrong and nothing is running.** That's unrecoverable otherwise, since the counter lives in process memory (`index.js:203`).\n\n## After the job is dead\n\n**1. Confirm node state is sane.**\n\n```bash\ncurl -s http://localhost:3000/status                  # freeSlots back to maxSlots if idle\nls -la /invintus/transcoder-node/temp-files/          # should be empty\nps aux | grep ffmpeg                                  # no orphans\ndf -h\n```\n\n**2. Check whether CORE auto-retries.**\n\nThe SQS error message may trigger an automatic re-submit. **If the underlying cause isn't fixed, an auto-retry immediately restarts the same bad job.** Confirm the behavior before walking away.\n\nIf retries are automatic and you can't fix the root cause yet, letting the original job run to completion is sometimes the lower-risk option — a running job at least terminates eventually.\n\n**3. Re-submit deliberately.**\n\nOnce the cause is fixed, re-trigger the transcode from Control Center. Watch Pipeline Logs for a `transcode/starting` followed by `processing` messages at a healthy cadence (see the diagnosis runbook for what \"healthy\" looks like).\n\n## Known gaps in the error paths\n\nWorth knowing, since they shape what you'll find after a failure:\n\n| Path | Behavior |\n|---|---|\n| FFmpeg exit 0 → upload throws | **Hangs.** No `job.clean()`, no SQS, temp files orphaned. Job never completes |\n| FFmpeg exit ≠ 0 | Cleans target files only — source temp file may remain |\n| Cancel via `DELETE /job` | No SQS message at all; slot count corrupted |\n| SQS send fails after an upload error | Silent — `sendSqsMessage` uses a noop callback in error paths |\n\nThere is no persistent logging on the node. Pino output goes nowhere, so post-hoc diagnosis requires SSH and live state. Capture `ps aux`, `ls temp-files`, and `/status` **before** you kill anything — that evidence is gone once the process exits.\n";

},{}],"1gWXr":[function(require,module,exports,__globalThis) {
module.exports = "# GitHub Actions Budget — Finding What's Burning Minutes\n\nWhen GitHub notifies that the TVWIT org's Actions budget is close to its limit, use this runbook to find which repo and workflow are using the minutes, using only the `gh` CLI.\n\n## TL;DR\n\n```sh\nORG=TVWIT; YEAR=$(date +%Y); MONTH=$(date +%-m)\n\n# 1. Which repo?\ngh api \"/organizations/$ORG/settings/billing/usage?year=$YEAR&month=$MONTH\" --jq '\n  [.usageItems[] | select(.product==\"actions\" and .unitType==\"Minutes\")]\n  | group_by(.repositoryName)\n  | map({repo: .[0].repositoryName, min: (map(.quantity)|add|floor), net: (map(.netAmount)|add)})\n  | sort_by(-.min)[] | \"\\(.min)\\t$\\(.net)\\t\\(.repo)\"'\n\n# 2. Which workflow in that repo? (run counts by workflow + trigger)\ngh run list -R $ORG/<repo> -L 200 --created \">=$(date -v-3d +%F)\" \\\n  --json workflowName,event \\\n  --jq 'group_by(.workflowName+\" \"+.event)[] | \"\\(length)\\t\\(.[0].event)\\t\\(.[0].workflowName)\"'\n\n# 3. How expensive is one run of it? (job fan-out x duration)\ngh api \"repos/$ORG/<repo>/actions/runs/<run_id>/jobs?per_page=100\" \\\n  --jq '\"\\(.total_count) jobs, ~\\([.jobs[]|select(.completed_at)|(((.completed_at|fromdate)-(.started_at|fromdate))/60|ceil)]|add) billed min\"'\n```\n\nMultiply the run count from step 2 by the cost per run from step 3. That shows which workflow is the cause.\n\n## Access\n\nThe billing endpoints require an **org owner or billing manager**. A standard `gh auth login` token (scopes `repo`, `read:org`, `workflow`) is enough if your account has that role. If you don't have it, the call returns 404 or 403. Ask an org owner to run it.\n\n`gh auth status` shows which account is active and its scopes.\n\n## Step 1 — Monthly total and SKU breakdown\n\n```sh\ngh api \"/organizations/$ORG/settings/billing/usage/summary?product=actions\"\n```\n\nThis returns gross minutes, discount (included free minutes), net minutes and net dollars for each SKU (`actions_linux`, `actions_storage`, etc.). Use it to confirm the alert is real and to see how much of the included allowance is already used.\n\n## Step 2 — By repo\n\nUse the TL;DR query #1. The `usage` endpoint returns one row per **day x repo x SKU**, and `repositoryName` is the most detailed level the billing API reports. It does not break usage down by workflow.\n\n## Step 3 — By day (when did it start?)\n\n```sh\ngh api \"/organizations/$ORG/settings/billing/usage?year=$YEAR&month=$MONTH\" --jq '\n  [.usageItems[] | select(.product==\"actions\" and .unitType==\"Minutes\")]\n  | group_by(.date[0:10])[] | \"\\(.[0].date[0:10])\\t\\(map(.quantity)|add|floor)\"'\n```\n\nIf a jump in daily minutes lines up with a date, it usually points to a new workflow, a new matrix, or a burst of PR activity in the top repo. Check that repo's `git log -- .github/workflows/` around that date.\n\n## Step 4 — By workflow (inside the top repo)\n\nBecause billing stops at the repo, you have to work out the per-workflow split from run and job data.\n\n**Run counts and wall-clock time per workflow + trigger:**\n\n```sh\ngh run list -R $ORG/<repo> -L 200 --created \">=YYYY-MM-DD\" \\\n  --json workflowName,event,conclusion,createdAt,updatedAt --jq '\n  group_by(.workflowName+\"|\"+.event)\n  | map({wf: .[0].workflowName, ev: .[0].event, runs: length,\n         wall: (map(((.updatedAt|fromdate)-(.createdAt|fromdate))/60)|add|floor),\n         concl: (group_by(.conclusion)|map(\"\\(.[0].conclusion):\\(length)\")|join(\",\"))})\n  | sort_by(-.wall)[] | \"\\(.wall)m\\t\\(.runs) runs\\t\\(.ev)\\t\\(.wf)\\t\\(.concl)\"'\n```\n\n**Wall-clock time understates the bill.** Billing counts **each job** separately and rounds each one up to the minute. A run that takes 5 minutes but fans out to 18 parallel jobs bills about 90 minutes. If the wall-clock total here is much lower than the billed minutes from Step 2, there's a matrix or parallel jobs somewhere.\n\n**Job fan-out for the latest run of each workflow:**\n\n```sh\nfor wf in <workflow-a> <workflow-b>; do\n  id=$(gh run list -R $ORG/<repo> -w \"$wf\" -L 1 --json databaseId --jq '.[0].databaseId')\n  printf \"%s: \" \"$wf\"\n  gh api \"repos/$ORG/<repo>/actions/runs/$id/jobs?per_page=100\" \\\n    --jq '\"\\(.total_count) jobs, ~\\([.jobs[]|select(.completed_at)|(((.completed_at|fromdate)-(.started_at|fromdate))/60|ceil)]|add) billed min, runners: \\([.jobs[].labels[]]|unique|join(\",\"))\"'\ndone\n```\n\nDon't use `--jq --arg` here. `gh api` doesn't support jq `--arg`, so print the label with `printf` as shown.\n\n**Read the triggers of the expensive workflow:**\n\n```sh\ngh api repos/$ORG/<repo>/contents/.github/workflows/<file>.yml --jq .content | base64 -d | head -40\n```\n\n## What usually causes it\n\n| Pattern | Symptom | Fix |\n|---|---|---|\n| Runs on every `pull_request` **and** every `push` to main | Run count about 2x the PR commit count | Add `paths:` filters, or run the heavy parts only on one trigger |\n| No `concurrency` cancel | Rapid pushes to a PR stack up full runs | `concurrency: { group: ${{ github.workflow }}-${{ github.ref }}, cancel-in-progress: true }` |\n| Wide matrix / many parallel jobs | Billed minutes far above wall-clock | Move the matrix to `schedule:` / `workflow_dispatch`, or merges only |\n| Service containers per job (Postgres, etc.) | Each job spends 1–2 min starting the container | Combine jobs that share a service |\n| Workflow that always fails | Every run fails, nobody looks | Fix it or disable it: `gh workflow disable -R $ORG/<repo> <name>` |\n| Larger / macOS / Windows runners | `runners:` label isn't `ubuntu-*`; SKU isn't `actions_linux` | Use standard Linux runners where possible (macOS costs about 10x, Windows about 2x) |\n\n## Stopping the burn immediately\n\nIf the budget is about to run out before a proper fix can merge:\n\n```sh\ngh workflow list -R $ORG/<repo>\ngh workflow disable -R $ORG/<repo> <workflow-name>\n```\n\nDisabling a workflow can't be done from a PR and doesn't need a code change. Re-enable it with `gh workflow enable` once the triggers are fixed. Tell the repo's owners first. A disabled required check blocks their merges.\n\n## Worked example — October 2026\n\n- Daily usage was about 2 min/day until it jumped on Oct 6–7, then again on Oct 12–14 (5,091 min on Oct 13).\n- Step 2: `inv-documentManagement` used 8,768 of about 10,650 minutes for the month.\n- Step 4: `db-design-proofs.yml` fans out to **18 jobs (about 87 billed min per run)**, each with its own Postgres container. It triggers on every `pull_request` and every push to `main`, with no `paths:` filter and no `concurrency:` cancel. 47 runs in three days came to roughly 4,000 minutes.\n- `event-contract` in the same repo had failed all 47 of its runs over that period.\n";

},{}],"kZEr6":[function(require,module,exports,__globalThis) {
module.exports = "# Stuck Unpublishing (Large B2-Archived Asset)\n\nEvent sits in `unpublishing` (status `10`) and never finishes. Happens when the published asset lives on Backblaze B2 (`storageLocationID = 31`) and is too large for mwf to pull back. mwf downloads the whole file to its local `/tmp`, then uploads it to S3, all inside one request. Large files (tens of GB) die partway with no error and no status reset.\n\n**Nothing changes for viewers until Part 3.** If anything fails before that, the event stays published.\n\n| Part | What | Time |\n|------|------|------|\n| 1 | Diagnose | 5 min |\n| 2 | Reset to published | 2 min |\n| 3 | Manual unpublish (only if it must be unpublished) | 30 min on EC2; hours from a laptop |\n| 4 | Delete B2 copies | 5 min |\n\n---\n\n## Part 1: Diagnose (5 min)\n\n1. Get the IDs. Fill these in and keep them in your shell for every step below:\n\n```bash\nCLIENT_ID={CLIENT-ID}\nEVENT_ID={EVENT-ID}\nASSET_ID={ASSET-ID}   # the published asset (status `archive`)\n```\n\n2. Confirm the unpublish started and died. Look for `unpublishing asset:{ASSET-ID}` with **no** `unpublished event, sending socket` after it:\n\n```sql\nSELECT logDate, type, message FROM msglog\nWHERE logDate >= NOW() - INTERVAL 1 DAY\n  AND message LIKE '%{ASSET-ID}%'\nORDER BY logDate;\n```\n\n> Searching by eventID will **not** find it. The unpublish log line only contains the assetID.\n\n3. Confirm the asset never moved. Expect `archive`, `31`, and a `backblazeb2.com` path:\n\n```sql\nSELECT assetID, currentStatus, storageLocationID, path, fileSize\nFROM mediaassets WHERE assetID = '{ASSET-ID}';\n```\n\n4. Confirm nothing is still running. Expect **empty** output from both:\n\n```bash\naws s3api list-multipart-uploads --bucket invintus-mediaworkflow --prefix \"$CLIENT_ID/$ASSET_ID\"\naws s3api head-object --bucket invintus-mediaworkflow --key \"$CLIENT_ID/$ASSET_ID.mp4\"   # expect 404\n```\n\nFor reference: files around 1 GB unpublish in about 1 minute. If more than about 2x the expected time has passed with no multipart upload, treat the unpublish as dead.\n\n5. If the file is huge, check the encoder bitrate: `fileSize * 8 / durationSeconds`. Anything above 3 Mbps means the encoder is misconfigured. Recommended: 2 to 3 Mbps.\n\n---\n\n## Part 2: Reset to Published (2 min)\n\n1. Put the event back to published:\n\n```sql\nUPDATE eventStatus\nSET eventStatus = 7, published = 1\nWHERE eventID = '{CLIENT-ID}_{EVENT-ID}' AND eventStatus = 10;\n```\n\n2. Open the event in the UI and hit **Save** (pushes the status to the index and player).\n\n3. Verify playback. Expect `200` and a manifest listing the renditions:\n\n```bash\ncurl -s \"https://api.v3.invintus.com/StreamURI/hls/$CLIENT_ID/$EVENT_ID/media.m3u8\" | head -5\n```\n\n**Stop here** unless the event must actually be unpublished (e.g. the tech needs to re-edit).\n\n> Do not retry the unpublish through the UI for a large file. It will fail the same way.\n\n---\n\n## Part 3: Manual Unpublish (30 min on EC2; hours from a laptop)\n\n1. Get the exact B2 file size. Use this number, **not** `mediaassets.fileSize` (the published copy on B2 can differ by a few bytes):\n\n```bash\nB2_URL=\"https://f005.backblazeb2.com/file/invintus-client-media/$CLIENT_ID/$ASSET_ID.mp4\"\nSIZE=$(curl -sI \"$B2_URL\" | awk 'tolower($1)==\"content-length:\"{print $2}' | tr -d '\\r')\necho $SIZE\n```\n\n2. Get the client's retention period (default 14 if no row):\n\n```sql\nSELECT defaultFileRetentionPeriod FROM clientdefaults WHERE clientID = {CLIENT-ID};\n```\n\n3. Stream B2 to S3. No local disk is used. Run on an EC2 box in `us-west-2`, inside `tmux`:\n\n```bash\ncurl -fsS \"$B2_URL\" \\\n| aws s3 cp - \"s3://invintus-mediaworkflow/$CLIENT_ID/$ASSET_ID.mp4\" \\\n    --acl public-read --content-type video/mp4 --expected-size \"$SIZE\"\n```\n\n4. Verify the copy. `len` must equal `$SIZE` exactly:\n\n```bash\naws s3api head-object --bucket invintus-mediaworkflow --key \"$CLIENT_ID/$ASSET_ID.mp4\" \\\n  --query '{len:ContentLength,type:ContentType}'\n```\n\n5. Flip the DB. **The event goes unpublished at this step.** Replace `14` with the retention value from step 2:\n\n```sql\nSTART TRANSACTION;\n\nUPDATE mediaassets\nSET path = 'https://invintus-mediaworkflow.s3.amazonaws.com/{CLIENT-ID}/{ASSET-ID}.mp4',\n    storageLocationID = 5,\n    currentStatus = 'available',\n    ttl = NOW() + INTERVAL 14 DAY\nWHERE assetID = '{ASSET-ID}';\n\nDELETE FROM publishedstreamchildren WHERE assetID = '{ASSET-ID}';   -- expect 6 rows\n\nUPDATE eventStatus\nSET eventStatus = 4, published = 0\nWHERE eventID = '{CLIENT-ID}_{EVENT-ID}';\n\nCOMMIT;\n```\n\n6. Open the event in the UI and hit **Save**. Confirm the asset shows as available and editable.\n\n---\n\n## Part 4: Delete B2 Copies (5 min, irreversible)\n\nOnly after Part 3 step 6 is confirmed. Skipping this breaks nothing; it only leaves orphaned storage on B2.\n\n1. Load B2 credentials (`authenticationID` / `authenticationKey` from `storagelocations` row `31`) into your shell. Do not paste them into chat or tickets.\n\n```bash\nexport AWS_ACCESS_KEY_ID=<b2 keyID> AWS_SECRET_ACCESS_KEY=<b2 appKey>\n```\n\n2. Delete the master, 4 renditions, and audio:\n\n```bash\nB2=\"s3://invintus-client-media/$CLIENT_ID/$ASSET_ID\"\nEP=https://s3.us-east-005.backblazeb2.com   # S3-compatible API, not the f005 download URL\nfor s in \"\" _720p_30fps _480p_30fps _360p_30fps _160p_30fps; do\n  aws s3 rm \"$B2$s.mp4\" --endpoint-url \"$EP\"\ndone\naws s3 rm \"${B2}_audio.mp3\" --endpoint-url \"$EP\"\n```\n\n3. Unset the credentials:\n\n```bash\nunset AWS_ACCESS_KEY_ID AWS_SECRET_ACCESS_KEY\n```\n\n---\n\n## Alternative: Unpublish and Delete (15 min, no copy needed)\n\nUse this instead of Parts 3 and 4 when the tech wants the asset deleted after unpublishing. There is no point copying the file back to S3 just to delete it.\n\n> The UI **cannot** delete an asset stored on B2: `assetMgr::delete()` always uses the AWS S3 client, so it fails for `storageLocationID = 31`. Assets on S3 (e.g. the live recording) can still be deleted from the UI.\n\n1. Unpublish in the DB:\n\n```sql\nSTART TRANSACTION;\nDELETE FROM publishedstreamchildren WHERE assetID = '{ASSET-ID}';   -- expect 6 rows\nUPDATE eventStatus\nSET eventStatus = 4, published = 0\nWHERE eventID = '{CLIENT-ID}_{EVENT-ID}';\nCOMMIT;\n```\n\n2. Open the event in the UI and hit **Save**.\n\n3. Confirm the flip stuck before deleting anything. Expect `4` / `0`. If it shows `10`, someone re-triggered unpublish from the UI; re-run step 1.\n\n```sql\nSELECT eventStatus, published FROM eventStatus WHERE eventID = '{CLIENT-ID}_{EVENT-ID}';\n```\n\n4. Delete the B2 files (**irreversible**). Same commands as Part 4 steps 1 to 3.\n\n5. Find the thumbnail:\n\n```sql\nSELECT thumbAssetID, path FROM thumbnails WHERE parentAssetID = '{ASSET-ID}';\n```\n\n6. If a row came back, delete the thumbnail file and record. The bucket and key come from the `path`:\n\n```bash\naws s3 rm \"s3://invintus-client-images/$CLIENT_ID/{THUMB-FILE}.jpg\"\n```\n\n```sql\nDELETE FROM thumbnails WHERE parentAssetID = '{ASSET-ID}';\n```\n\n7. Delete the asset record:\n\n```sql\nDELETE FROM mediaassets WHERE assetID = '{ASSET-ID}';\n```\n\n8. Delete any remaining S3 assets (e.g. the live recording) from the UI as normal.\n\n---\n\n## Not Covered by the Manual Path\n\nThe PHP `unPublish()` also does these; the manual path skips them:\n\n- **Fastly purge** of the old renditions. Cached copies expire on their own.\n- **OTT channel cue.** Only matters if the client has OTT channels.\n- **Indexer update.** Covered by hitting Save.\n\n## Root Cause Reference\n\n- Code: `Invintus-coreSys/clsCore/publish.php`, `unPublish()` (line ~252) and `pullFromBackBlaze()` (line ~372)\n- No try/catch, no timeout, no status reset or `lastError` on failure\n- The upload retry loop closes the file handle in `finally`, so retries cannot work\n";

},{}],"ij03O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Collapsible", ()=>Collapsible);
parcelHelpers.export(exports, "CollapsibleTrigger", ()=>CollapsibleTrigger);
parcelHelpers.export(exports, "CollapsibleContent", ()=>CollapsibleContent);
var _reactCollapsible = require("@radix-ui/react-collapsible");
const Collapsible = _reactCollapsible.Root;
const CollapsibleTrigger = _reactCollapsible.CollapsibleTrigger;
const CollapsibleContent = _reactCollapsible.CollapsibleContent;

},{"@radix-ui/react-collapsible":"7Kvgd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7Kvgd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Collapsible", ()=>Collapsible);
parcelHelpers.export(exports, "CollapsibleContent", ()=>CollapsibleContent);
parcelHelpers.export(exports, "CollapsibleTrigger", ()=>CollapsibleTrigger);
parcelHelpers.export(exports, "Content", ()=>Content);
parcelHelpers.export(exports, "Root", ()=>Root);
parcelHelpers.export(exports, "Trigger", ()=>Trigger);
parcelHelpers.export(exports, "createCollapsibleScope", ()=>createCollapsibleScope);
// src/collapsible.tsx
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactContext = require("@radix-ui/react-context");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactPresence = require("@radix-ui/react-presence");
var _reactId = require("@radix-ui/react-id");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var COLLAPSIBLE_NAME = "Collapsible";
var [createCollapsibleContext, createCollapsibleScope] = (0, _reactContext.createContextScope)(COLLAPSIBLE_NAME);
var [CollapsibleProvider, useCollapsibleContext] = createCollapsibleContext(COLLAPSIBLE_NAME);
var Collapsible = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible, open: openProp, defaultOpen, disabled, onOpenChange, ...collapsibleProps } = props;
    const [open, setOpen] = (0, _reactUseControllableState.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: COLLAPSIBLE_NAME
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollapsibleProvider, {
        scope: __scopeCollapsible,
        disabled,
        contentId: (0, _reactId.useId)(),
        open,
        onOpenToggle: _react.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
            "data-state": getState(open),
            "data-disabled": disabled ? "" : void 0,
            ...collapsibleProps,
            ref: forwardedRef
        })
    });
});
Collapsible.displayName = COLLAPSIBLE_NAME;
var TRIGGER_NAME = "CollapsibleTrigger";
var CollapsibleTrigger = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible, ...triggerProps } = props;
    const context = useCollapsibleContext(TRIGGER_NAME, __scopeCollapsible);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).button, {
        type: "button",
        "aria-controls": context.contentId,
        "aria-expanded": context.open || false,
        "data-state": getState(context.open),
        "data-disabled": context.disabled ? "" : void 0,
        disabled: context.disabled,
        ...triggerProps,
        ref: forwardedRef,
        onClick: (0, _primitive.composeEventHandlers)(props.onClick, context.onOpenToggle)
    });
});
CollapsibleTrigger.displayName = TRIGGER_NAME;
var CONTENT_NAME = "CollapsibleContent";
var CollapsibleContent = _react.forwardRef((props, forwardedRef)=>{
    const { forceMount, ...contentProps } = props;
    const context = useCollapsibleContext(CONTENT_NAME, props.__scopeCollapsible);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
        present: forceMount || context.open,
        children: ({ present })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(CollapsibleContentImpl, {
                ...contentProps,
                ref: forwardedRef,
                present
            })
    });
});
CollapsibleContent.displayName = CONTENT_NAME;
var CollapsibleContentImpl = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeCollapsible, present, children, ...contentProps } = props;
    const context = useCollapsibleContext(CONTENT_NAME, __scopeCollapsible);
    const [isPresent, setIsPresent] = _react.useState(present);
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    const heightRef = _react.useRef(0);
    const height = heightRef.current;
    const widthRef = _react.useRef(0);
    const width = widthRef.current;
    const isOpen = context.open || isPresent;
    const isMountAnimationPreventedRef = _react.useRef(isOpen);
    const originalStylesRef = _react.useRef(void 0);
    _react.useEffect(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        const node = ref.current;
        if (node) {
            originalStylesRef.current = originalStylesRef.current || {
                transitionDuration: node.style.transitionDuration,
                animationName: node.style.animationName
            };
            node.style.transitionDuration = "0s";
            node.style.animationName = "none";
            const rect = node.getBoundingClientRect();
            heightRef.current = rect.height;
            widthRef.current = rect.width;
            if (!isMountAnimationPreventedRef.current) {
                node.style.transitionDuration = originalStylesRef.current.transitionDuration;
                node.style.animationName = originalStylesRef.current.animationName;
            }
            setIsPresent(present);
        }
    }, [
        context.open,
        present
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        "data-state": getState(context.open),
        "data-disabled": context.disabled ? "" : void 0,
        id: context.contentId,
        hidden: !isOpen,
        ...contentProps,
        ref: composedRefs,
        style: {
            [`--radix-collapsible-content-height`]: height ? `${height}px` : void 0,
            [`--radix-collapsible-content-width`]: width ? `${width}px` : void 0,
            ...props.style
        },
        children: isOpen && children
    });
});
function getState(open) {
    return open ? "open" : "closed";
}
var Root = Collapsible;
var Trigger = CollapsibleTrigger;
var Content = CollapsibleContent;

},{"react":"eGun2","@radix-ui/primitive":"k8C5A","@radix-ui/react-context":"4wywa","@radix-ui/react-use-controllable-state":"ThW7y","@radix-ui/react-use-layout-effect":"dRDMB","@radix-ui/react-compose-refs":"nN23r","@radix-ui/react-primitive":"hQJ44","@radix-ui/react-presence":"eh7qi","@radix-ui/react-id":"hoLx9","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"35Jms":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeToggle", ()=>ThemeToggle);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _button = require("@/client/components/ui/button");
var _themeProvider = require("@/client/components/theme-provider");
const CYCLE = [
    'system',
    'light',
    'dark'
];
function ThemeToggle() {
    const { theme, setTheme } = (0, _themeProvider.useTheme)();
    const next = CYCLE[(CYCLE.indexOf(theme) + 1) % CYCLE.length];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
        variant: "ghost",
        size: "icon",
        onClick: ()=>setTheme(next),
        className: "w-9 h-9",
        title: `Theme: ${theme}`,
        children: [
            theme === 'system' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Monitor), {
                className: "h-[1.2rem] w-[1.2rem]"
            }),
            theme === 'light' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Sun), {
                className: "h-[1.2rem] w-[1.2rem]"
            }),
            theme === 'dark' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Moon), {
                className: "h-[1.2rem] w-[1.2rem]"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "sr-only",
                children: [
                    "Toggle theme (",
                    theme,
                    ")"
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","lucide-react":[["Monitor","iFamc","default"],["Moon","5Rm7e","default"],["Sun","02avy","default"]],"@/client/components/ui/button":"armlb","@/client/components/theme-provider":"6OWVF","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"iFamc":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Monitor);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "3",
            rx: "2",
            key: "48i651"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "16",
            y1: "21",
            y2: "21",
            key: "1svkeh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "17",
            y2: "21",
            key: "vw1qmm"
        }
    ]
];
const Monitor = (0, _createLucideIconJsDefault.default)("monitor", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5Rm7e":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Moon);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401",
            key: "kfwtm"
        }
    ]
];
const Moon = (0, _createLucideIconJsDefault.default)("moon", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"02avy":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Sun);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "4",
            key: "4exip2"
        }
    ],
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "M12 20v2",
            key: "1lh1kg"
        }
    ],
    [
        "path",
        {
            d: "m4.93 4.93 1.41 1.41",
            key: "149t6j"
        }
    ],
    [
        "path",
        {
            d: "m17.66 17.66 1.41 1.41",
            key: "ptbguv"
        }
    ],
    [
        "path",
        {
            d: "M2 12h2",
            key: "1t8f8n"
        }
    ],
    [
        "path",
        {
            d: "M20 12h2",
            key: "1q8mjw"
        }
    ],
    [
        "path",
        {
            d: "m6.34 17.66-1.41 1.41",
            key: "1m8zz5"
        }
    ],
    [
        "path",
        {
            d: "m19.07 4.93-1.41 1.41",
            key: "1shlcs"
        }
    ]
];
const Sun = (0, _createLucideIconJsDefault.default)("sun", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6OWVF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeProvider", ()=>ThemeProvider);
parcelHelpers.export(exports, "useTheme", ()=>useTheme);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const initialState = {
    theme: 'system',
    setTheme: ()=>null
};
const ThemeProviderContext = /*#__PURE__*/ (0, _react.createContext)(initialState);
function ThemeProvider({ children, defaultTheme = 'system', storageKey = 'ui-theme', ...props }) {
    const [theme, setTheme] = (0, _react.useState)(()=>localStorage.getItem(storageKey) || defaultTheme);
    (0, _react.useEffect)(()=>{
        const root = window.document.documentElement;
        const applyTheme = ()=>{
            root.classList.remove('light', 'dark');
            if (theme === 'system') {
                const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
                root.classList.add(systemTheme);
            } else root.classList.add(theme);
        };
        applyTheme();
        // Listen for OS theme changes when in system mode
        if (theme === 'system') {
            const mq = window.matchMedia('(prefers-color-scheme: dark)');
            const handler = ()=>applyTheme();
            mq.addEventListener('change', handler);
            return ()=>mq.removeEventListener('change', handler);
        }
    }, [
        theme
    ]);
    const value = {
        theme,
        setTheme: (theme)=>{
            localStorage.setItem(storageKey, theme);
            setTheme(theme);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThemeProviderContext.Provider, {
        ...props,
        value: value,
        children: children
    });
}
const useTheme = ()=>{
    const context = (0, _react.useContext)(ThemeProviderContext);
    if (context === undefined) throw new Error('useTheme must be used within a ThemeProvider');
    return context;
};

},{"react/jsx-runtime":"dQjte","react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"h4e1f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Badge", ()=>Badge);
parcelHelpers.export(exports, "badgeVariants", ()=>badgeVariants);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _classVarianceAuthority = require("class-variance-authority");
var _utils = require("@/client/lib/utils");
const badgeVariants = (0, _classVarianceAuthority.cva)("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", {
    variants: {
        variant: {
            default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
            secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
            destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
            outline: "text-foreground"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
function Badge({ className, variant, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _utils.cn)(badgeVariants({
            variant
        }), className),
        ...props
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","class-variance-authority":"l22tX","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8ox96":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropdownMenu", ()=>DropdownMenu);
parcelHelpers.export(exports, "DropdownMenuTrigger", ()=>DropdownMenuTrigger);
parcelHelpers.export(exports, "DropdownMenuContent", ()=>DropdownMenuContent);
parcelHelpers.export(exports, "DropdownMenuItem", ()=>DropdownMenuItem);
parcelHelpers.export(exports, "DropdownMenuCheckboxItem", ()=>DropdownMenuCheckboxItem);
parcelHelpers.export(exports, "DropdownMenuRadioItem", ()=>DropdownMenuRadioItem);
parcelHelpers.export(exports, "DropdownMenuLabel", ()=>DropdownMenuLabel);
parcelHelpers.export(exports, "DropdownMenuSeparator", ()=>DropdownMenuSeparator);
parcelHelpers.export(exports, "DropdownMenuShortcut", ()=>DropdownMenuShortcut);
parcelHelpers.export(exports, "DropdownMenuGroup", ()=>DropdownMenuGroup);
parcelHelpers.export(exports, "DropdownMenuPortal", ()=>DropdownMenuPortal);
parcelHelpers.export(exports, "DropdownMenuSub", ()=>DropdownMenuSub);
parcelHelpers.export(exports, "DropdownMenuSubContent", ()=>DropdownMenuSubContent);
parcelHelpers.export(exports, "DropdownMenuSubTrigger", ()=>DropdownMenuSubTrigger);
parcelHelpers.export(exports, "DropdownMenuRadioGroup", ()=>DropdownMenuRadioGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDropdownMenu = require("@radix-ui/react-dropdown-menu");
var _lucideReact = require("lucide-react");
var _utils = require("@/client/lib/utils");
const DropdownMenu = _reactDropdownMenu.Root;
const DropdownMenuTrigger = _reactDropdownMenu.Trigger;
const DropdownMenuGroup = _reactDropdownMenu.Group;
const DropdownMenuPortal = _reactDropdownMenu.Portal;
const DropdownMenuSub = _reactDropdownMenu.Sub;
const DropdownMenuRadioGroup = _reactDropdownMenu.RadioGroup;
const DropdownMenuSubTrigger = /*#__PURE__*/ _react.forwardRef(({ className, inset, children, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactDropdownMenu.SubTrigger, {
        ref: ref,
        className: (0, _utils.cn)("flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", inset && "pl-8", className),
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                className: "ml-auto"
            })
        ]
    }));
DropdownMenuSubTrigger.displayName = _reactDropdownMenu.SubTrigger.displayName;
const DropdownMenuSubContent = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactDropdownMenu.SubContent, {
        ref: ref,
        className: (0, _utils.cn)("z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-dropdown-menu-content-transform-origin]", className),
        ...props
    }));
DropdownMenuSubContent.displayName = _reactDropdownMenu.SubContent.displayName;
const DropdownMenuContent = /*#__PURE__*/ _react.forwardRef(({ className, sideOffset = 4, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactDropdownMenu.Portal, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactDropdownMenu.Content, {
            ref: ref,
            sideOffset: sideOffset,
            className: (0, _utils.cn)("z-50 max-h-[var(--radix-dropdown-menu-content-available-height)] min-w-[8rem] overflow-y-auto overflow-x-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-dropdown-menu-content-transform-origin]", className),
            ...props
        })
    }));
DropdownMenuContent.displayName = _reactDropdownMenu.Content.displayName;
const DropdownMenuItem = /*#__PURE__*/ _react.forwardRef(({ className, inset, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactDropdownMenu.Item, {
        ref: ref,
        className: (0, _utils.cn)("relative flex cursor-pointer select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", inset && "pl-8", className),
        ...props
    }));
DropdownMenuItem.displayName = _reactDropdownMenu.Item.displayName;
const DropdownMenuCheckboxItem = /*#__PURE__*/ _react.forwardRef(({ className, children, checked, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactDropdownMenu.CheckboxItem, {
        ref: ref,
        className: (0, _utils.cn)("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className),
        checked: checked,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactDropdownMenu.ItemIndicator, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                        className: "h-4 w-4"
                    })
                })
            }),
            children
        ]
    }));
DropdownMenuCheckboxItem.displayName = _reactDropdownMenu.CheckboxItem.displayName;
const DropdownMenuRadioItem = /*#__PURE__*/ _react.forwardRef(({ className, children, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactDropdownMenu.RadioItem, {
        ref: ref,
        className: (0, _utils.cn)("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactDropdownMenu.ItemIndicator, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Circle), {
                        className: "h-2 w-2 fill-current"
                    })
                })
            }),
            children
        ]
    }));
DropdownMenuRadioItem.displayName = _reactDropdownMenu.RadioItem.displayName;
const DropdownMenuLabel = /*#__PURE__*/ _react.forwardRef(({ className, inset, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactDropdownMenu.Label, {
        ref: ref,
        className: (0, _utils.cn)("px-2 py-1.5 text-sm font-semibold", inset && "pl-8", className),
        ...props
    }));
DropdownMenuLabel.displayName = _reactDropdownMenu.Label.displayName;
const DropdownMenuSeparator = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactDropdownMenu.Separator, {
        ref: ref,
        className: (0, _utils.cn)("-mx-1 my-1 h-px bg-muted", className),
        ...props
    }));
DropdownMenuSeparator.displayName = _reactDropdownMenu.Separator.displayName;
const DropdownMenuShortcut = ({ className, ...props })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _utils.cn)("ml-auto text-xs tracking-widest opacity-60", className),
        ...props
    });
};
DropdownMenuShortcut.displayName = "DropdownMenuShortcut";

},{"react/jsx-runtime":"dQjte","react":"eGun2","@radix-ui/react-dropdown-menu":"dP1Wl","lucide-react":[["Check","bajJU","default"],["ChevronRight","lOb49","default"],["Circle","lGLGY","default"]],"@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dP1Wl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Arrow", ()=>Arrow2);
parcelHelpers.export(exports, "CheckboxItem", ()=>CheckboxItem2);
parcelHelpers.export(exports, "Content", ()=>Content2);
parcelHelpers.export(exports, "DropdownMenu", ()=>DropdownMenu);
parcelHelpers.export(exports, "DropdownMenuArrow", ()=>DropdownMenuArrow);
parcelHelpers.export(exports, "DropdownMenuCheckboxItem", ()=>DropdownMenuCheckboxItem);
parcelHelpers.export(exports, "DropdownMenuContent", ()=>DropdownMenuContent);
parcelHelpers.export(exports, "DropdownMenuGroup", ()=>DropdownMenuGroup);
parcelHelpers.export(exports, "DropdownMenuItem", ()=>DropdownMenuItem);
parcelHelpers.export(exports, "DropdownMenuItemIndicator", ()=>DropdownMenuItemIndicator);
parcelHelpers.export(exports, "DropdownMenuLabel", ()=>DropdownMenuLabel);
parcelHelpers.export(exports, "DropdownMenuPortal", ()=>DropdownMenuPortal);
parcelHelpers.export(exports, "DropdownMenuRadioGroup", ()=>DropdownMenuRadioGroup);
parcelHelpers.export(exports, "DropdownMenuRadioItem", ()=>DropdownMenuRadioItem);
parcelHelpers.export(exports, "DropdownMenuSeparator", ()=>DropdownMenuSeparator);
parcelHelpers.export(exports, "DropdownMenuSub", ()=>DropdownMenuSub);
parcelHelpers.export(exports, "DropdownMenuSubContent", ()=>DropdownMenuSubContent);
parcelHelpers.export(exports, "DropdownMenuSubTrigger", ()=>DropdownMenuSubTrigger);
parcelHelpers.export(exports, "DropdownMenuTrigger", ()=>DropdownMenuTrigger);
parcelHelpers.export(exports, "Group", ()=>Group2);
parcelHelpers.export(exports, "Item", ()=>Item2);
parcelHelpers.export(exports, "ItemIndicator", ()=>ItemIndicator2);
parcelHelpers.export(exports, "Label", ()=>Label2);
parcelHelpers.export(exports, "Portal", ()=>Portal2);
parcelHelpers.export(exports, "RadioGroup", ()=>RadioGroup2);
parcelHelpers.export(exports, "RadioItem", ()=>RadioItem2);
parcelHelpers.export(exports, "Root", ()=>Root2);
parcelHelpers.export(exports, "Separator", ()=>Separator2);
parcelHelpers.export(exports, "Sub", ()=>Sub2);
parcelHelpers.export(exports, "SubContent", ()=>SubContent2);
parcelHelpers.export(exports, "SubTrigger", ()=>SubTrigger2);
parcelHelpers.export(exports, "Trigger", ()=>Trigger);
parcelHelpers.export(exports, "createDropdownMenuScope", ()=>createDropdownMenuScope);
// src/dropdown-menu.tsx
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactContext = require("@radix-ui/react-context");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactMenu = require("@radix-ui/react-menu");
var _reactId = require("@radix-ui/react-id");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var DROPDOWN_MENU_NAME = "DropdownMenu";
var [createDropdownMenuContext, createDropdownMenuScope] = (0, _reactContext.createContextScope)(DROPDOWN_MENU_NAME, [
    (0, _reactMenu.createMenuScope)
]);
var useMenuScope = (0, _reactMenu.createMenuScope)();
var [DropdownMenuProvider, useDropdownMenuContext] = createDropdownMenuContext(DROPDOWN_MENU_NAME);
var DropdownMenu = (props)=>{
    const { __scopeDropdownMenu, children, dir, open: openProp, defaultOpen, onOpenChange, modal = true } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    const triggerRef = _react.useRef(null);
    const [open, setOpen] = (0, _reactUseControllableState.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: DROPDOWN_MENU_NAME
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(DropdownMenuProvider, {
        scope: __scopeDropdownMenu,
        triggerId: (0, _reactId.useId)(),
        triggerRef,
        contentId: (0, _reactId.useId)(),
        open,
        onOpenChange: setOpen,
        onOpenToggle: _react.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.Root, {
            ...menuScope,
            open,
            onOpenChange: setOpen,
            dir,
            modal,
            children
        })
    });
};
DropdownMenu.displayName = DROPDOWN_MENU_NAME;
var TRIGGER_NAME = "DropdownMenuTrigger";
var DropdownMenuTrigger = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu, disabled = false, ...triggerProps } = props;
    const context = useDropdownMenuContext(TRIGGER_NAME, __scopeDropdownMenu);
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.Anchor, {
        asChild: true,
        ...menuScope,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).button, {
            type: "button",
            id: context.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": context.open,
            "aria-controls": context.open ? context.contentId : void 0,
            "data-state": context.open ? "open" : "closed",
            "data-disabled": disabled ? "" : void 0,
            disabled,
            ...triggerProps,
            ref: (0, _reactComposeRefs.composeRefs)(forwardedRef, context.triggerRef),
            onPointerDown: (0, _primitive.composeEventHandlers)(props.onPointerDown, (event)=>{
                if (!disabled && event.button === 0 && event.ctrlKey === false) {
                    context.onOpenToggle();
                    if (!context.open) event.preventDefault();
                }
            }),
            onKeyDown: (0, _primitive.composeEventHandlers)(props.onKeyDown, (event)=>{
                if (disabled) return;
                if ([
                    "Enter",
                    " "
                ].includes(event.key)) context.onOpenToggle();
                if (event.key === "ArrowDown") context.onOpenChange(true);
                if ([
                    "Enter",
                    " ",
                    "ArrowDown"
                ].includes(event.key)) event.preventDefault();
            })
        })
    });
});
DropdownMenuTrigger.displayName = TRIGGER_NAME;
var PORTAL_NAME = "DropdownMenuPortal";
var DropdownMenuPortal = (props)=>{
    const { __scopeDropdownMenu, ...portalProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.Portal, {
        ...menuScope,
        ...portalProps
    });
};
DropdownMenuPortal.displayName = PORTAL_NAME;
var CONTENT_NAME = "DropdownMenuContent";
var DropdownMenuContent = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu, ...contentProps } = props;
    const context = useDropdownMenuContext(CONTENT_NAME, __scopeDropdownMenu);
    const menuScope = useMenuScope(__scopeDropdownMenu);
    const hasInteractedOutsideRef = _react.useRef(false);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.Content, {
        id: context.contentId,
        "aria-labelledby": context.triggerId,
        ...menuScope,
        ...contentProps,
        ref: forwardedRef,
        onCloseAutoFocus: (0, _primitive.composeEventHandlers)(props.onCloseAutoFocus, (event)=>{
            if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
            hasInteractedOutsideRef.current = false;
            event.preventDefault();
        }),
        onInteractOutside: (0, _primitive.composeEventHandlers)(props.onInteractOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
DropdownMenuContent.displayName = CONTENT_NAME;
var GROUP_NAME = "DropdownMenuGroup";
var DropdownMenuGroup = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu, ...groupProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.Group, {
        ...menuScope,
        ...groupProps,
        ref: forwardedRef
    });
});
DropdownMenuGroup.displayName = GROUP_NAME;
var LABEL_NAME = "DropdownMenuLabel";
var DropdownMenuLabel = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu, ...labelProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.Label, {
        ...menuScope,
        ...labelProps,
        ref: forwardedRef
    });
});
DropdownMenuLabel.displayName = LABEL_NAME;
var ITEM_NAME = "DropdownMenuItem";
var DropdownMenuItem = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu, ...itemProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.Item, {
        ...menuScope,
        ...itemProps,
        ref: forwardedRef
    });
});
DropdownMenuItem.displayName = ITEM_NAME;
var CHECKBOX_ITEM_NAME = "DropdownMenuCheckboxItem";
var DropdownMenuCheckboxItem = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu, ...checkboxItemProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.CheckboxItem, {
        ...menuScope,
        ...checkboxItemProps,
        ref: forwardedRef
    });
});
DropdownMenuCheckboxItem.displayName = CHECKBOX_ITEM_NAME;
var RADIO_GROUP_NAME = "DropdownMenuRadioGroup";
var DropdownMenuRadioGroup = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu, ...radioGroupProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.RadioGroup, {
        ...menuScope,
        ...radioGroupProps,
        ref: forwardedRef
    });
});
DropdownMenuRadioGroup.displayName = RADIO_GROUP_NAME;
var RADIO_ITEM_NAME = "DropdownMenuRadioItem";
var DropdownMenuRadioItem = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu, ...radioItemProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.RadioItem, {
        ...menuScope,
        ...radioItemProps,
        ref: forwardedRef
    });
});
DropdownMenuRadioItem.displayName = RADIO_ITEM_NAME;
var INDICATOR_NAME = "DropdownMenuItemIndicator";
var DropdownMenuItemIndicator = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu, ...itemIndicatorProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.ItemIndicator, {
        ...menuScope,
        ...itemIndicatorProps,
        ref: forwardedRef
    });
});
DropdownMenuItemIndicator.displayName = INDICATOR_NAME;
var SEPARATOR_NAME = "DropdownMenuSeparator";
var DropdownMenuSeparator = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu, ...separatorProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.Separator, {
        ...menuScope,
        ...separatorProps,
        ref: forwardedRef
    });
});
DropdownMenuSeparator.displayName = SEPARATOR_NAME;
var ARROW_NAME = "DropdownMenuArrow";
var DropdownMenuArrow = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu, ...arrowProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.Arrow, {
        ...menuScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
DropdownMenuArrow.displayName = ARROW_NAME;
var DropdownMenuSub = (props)=>{
    const { __scopeDropdownMenu, children, open: openProp, onOpenChange, defaultOpen } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    const [open, setOpen] = (0, _reactUseControllableState.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: "DropdownMenuSub"
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.Sub, {
        ...menuScope,
        open,
        onOpenChange: setOpen,
        children
    });
};
var SUB_TRIGGER_NAME = "DropdownMenuSubTrigger";
var DropdownMenuSubTrigger = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu, ...subTriggerProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.SubTrigger, {
        ...menuScope,
        ...subTriggerProps,
        ref: forwardedRef
    });
});
DropdownMenuSubTrigger.displayName = SUB_TRIGGER_NAME;
var SUB_CONTENT_NAME = "DropdownMenuSubContent";
var DropdownMenuSubContent = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu, ...subContentProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactMenu.SubContent, {
        ...menuScope,
        ...subContentProps,
        ref: forwardedRef,
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
DropdownMenuSubContent.displayName = SUB_CONTENT_NAME;
var Root2 = DropdownMenu;
var Trigger = DropdownMenuTrigger;
var Portal2 = DropdownMenuPortal;
var Content2 = DropdownMenuContent;
var Group2 = DropdownMenuGroup;
var Label2 = DropdownMenuLabel;
var Item2 = DropdownMenuItem;
var CheckboxItem2 = DropdownMenuCheckboxItem;
var RadioGroup2 = DropdownMenuRadioGroup;
var RadioItem2 = DropdownMenuRadioItem;
var ItemIndicator2 = DropdownMenuItemIndicator;
var Separator2 = DropdownMenuSeparator;
var Arrow2 = DropdownMenuArrow;
var Sub2 = DropdownMenuSub;
var SubTrigger2 = DropdownMenuSubTrigger;
var SubContent2 = DropdownMenuSubContent;

},{"react":"eGun2","@radix-ui/primitive":"k8C5A","@radix-ui/react-compose-refs":"nN23r","@radix-ui/react-context":"4wywa","@radix-ui/react-use-controllable-state":"ThW7y","@radix-ui/react-primitive":"hQJ44","@radix-ui/react-menu":"dfZ4G","@radix-ui/react-id":"hoLx9","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dfZ4G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Anchor", ()=>Anchor2);
parcelHelpers.export(exports, "Arrow", ()=>Arrow2);
parcelHelpers.export(exports, "CheckboxItem", ()=>CheckboxItem);
parcelHelpers.export(exports, "Content", ()=>Content2);
parcelHelpers.export(exports, "Group", ()=>Group);
parcelHelpers.export(exports, "Item", ()=>Item2);
parcelHelpers.export(exports, "ItemIndicator", ()=>ItemIndicator);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "Menu", ()=>Menu);
parcelHelpers.export(exports, "MenuAnchor", ()=>MenuAnchor);
parcelHelpers.export(exports, "MenuArrow", ()=>MenuArrow);
parcelHelpers.export(exports, "MenuCheckboxItem", ()=>MenuCheckboxItem);
parcelHelpers.export(exports, "MenuContent", ()=>MenuContent);
parcelHelpers.export(exports, "MenuGroup", ()=>MenuGroup);
parcelHelpers.export(exports, "MenuItem", ()=>MenuItem);
parcelHelpers.export(exports, "MenuItemIndicator", ()=>MenuItemIndicator);
parcelHelpers.export(exports, "MenuLabel", ()=>MenuLabel);
parcelHelpers.export(exports, "MenuPortal", ()=>MenuPortal);
parcelHelpers.export(exports, "MenuRadioGroup", ()=>MenuRadioGroup);
parcelHelpers.export(exports, "MenuRadioItem", ()=>MenuRadioItem);
parcelHelpers.export(exports, "MenuSeparator", ()=>MenuSeparator);
parcelHelpers.export(exports, "MenuSub", ()=>MenuSub);
parcelHelpers.export(exports, "MenuSubContent", ()=>MenuSubContent);
parcelHelpers.export(exports, "MenuSubTrigger", ()=>MenuSubTrigger);
parcelHelpers.export(exports, "Portal", ()=>Portal);
parcelHelpers.export(exports, "RadioGroup", ()=>RadioGroup);
parcelHelpers.export(exports, "RadioItem", ()=>RadioItem);
parcelHelpers.export(exports, "Root", ()=>Root3);
parcelHelpers.export(exports, "Separator", ()=>Separator);
parcelHelpers.export(exports, "Sub", ()=>Sub);
parcelHelpers.export(exports, "SubContent", ()=>SubContent);
parcelHelpers.export(exports, "SubTrigger", ()=>SubTrigger);
parcelHelpers.export(exports, "createMenuScope", ()=>createMenuScope);
// src/menu.tsx
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactCollection = require("@radix-ui/react-collection");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactContext = require("@radix-ui/react-context");
var _reactDirection = require("@radix-ui/react-direction");
var _reactDismissableLayer = require("@radix-ui/react-dismissable-layer");
var _reactFocusGuards = require("@radix-ui/react-focus-guards");
var _reactFocusScope = require("@radix-ui/react-focus-scope");
var _reactId = require("@radix-ui/react-id");
var _reactPopper = require("@radix-ui/react-popper");
var _reactPortal = require("@radix-ui/react-portal");
var _reactPresence = require("@radix-ui/react-presence");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactRovingFocus = require("@radix-ui/react-roving-focus");
var _reactSlot = require("@radix-ui/react-slot");
var _reactUseCallbackRef = require("@radix-ui/react-use-callback-ref");
var _ariaHidden = require("aria-hidden");
var _reactRemoveScroll = require("react-remove-scroll");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var SELECTION_KEYS = [
    "Enter",
    " "
];
var FIRST_KEYS = [
    "ArrowDown",
    "PageUp",
    "Home"
];
var LAST_KEYS = [
    "ArrowUp",
    "PageDown",
    "End"
];
var FIRST_LAST_KEYS = [
    ...FIRST_KEYS,
    ...LAST_KEYS
];
var SUB_OPEN_KEYS = {
    ltr: [
        ...SELECTION_KEYS,
        "ArrowRight"
    ],
    rtl: [
        ...SELECTION_KEYS,
        "ArrowLeft"
    ]
};
var SUB_CLOSE_KEYS = {
    ltr: [
        "ArrowLeft"
    ],
    rtl: [
        "ArrowRight"
    ]
};
var MENU_NAME = "Menu";
var [Collection, useCollection, createCollectionScope] = (0, _reactCollection.createCollection)(MENU_NAME);
var [createMenuContext, createMenuScope] = (0, _reactContext.createContextScope)(MENU_NAME, [
    createCollectionScope,
    (0, _reactPopper.createPopperScope),
    (0, _reactRovingFocus.createRovingFocusGroupScope)
]);
var usePopperScope = (0, _reactPopper.createPopperScope)();
var useRovingFocusGroupScope = (0, _reactRovingFocus.createRovingFocusGroupScope)();
var [MenuProvider, useMenuContext] = createMenuContext(MENU_NAME);
var [MenuRootProvider, useMenuRootContext] = createMenuContext(MENU_NAME);
var Menu = (props)=>{
    const { __scopeMenu, open = false, children, dir, onOpenChange, modal = true } = props;
    const popperScope = usePopperScope(__scopeMenu);
    const [content, setContent] = _react.useState(null);
    const isUsingKeyboardRef = _react.useRef(false);
    const handleOpenChange = (0, _reactUseCallbackRef.useCallbackRef)(onOpenChange);
    const direction = (0, _reactDirection.useDirection)(dir);
    _react.useEffect(()=>{
        const handleKeyDown = ()=>{
            isUsingKeyboardRef.current = true;
            document.addEventListener("pointerdown", handlePointer, {
                capture: true,
                once: true
            });
            document.addEventListener("pointermove", handlePointer, {
                capture: true,
                once: true
            });
        };
        const handlePointer = ()=>isUsingKeyboardRef.current = false;
        document.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
            document.removeEventListener("pointerdown", handlePointer, {
                capture: true
            });
            document.removeEventListener("pointermove", handlePointer, {
                capture: true
            });
        };
    }, []);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Root, {
        ...popperScope,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuProvider, {
            scope: __scopeMenu,
            open,
            onOpenChange: handleOpenChange,
            content,
            onContentChange: setContent,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuRootProvider, {
                scope: __scopeMenu,
                onClose: _react.useCallback(()=>handleOpenChange(false), [
                    handleOpenChange
                ]),
                isUsingKeyboardRef,
                dir: direction,
                modal,
                children
            })
        })
    });
};
Menu.displayName = MENU_NAME;
var ANCHOR_NAME = "MenuAnchor";
var MenuAnchor = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu, ...anchorProps } = props;
    const popperScope = usePopperScope(__scopeMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Anchor, {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
});
MenuAnchor.displayName = ANCHOR_NAME;
var PORTAL_NAME = "MenuPortal";
var [PortalProvider, usePortalContext] = createMenuContext(PORTAL_NAME, {
    forceMount: void 0
});
var MenuPortal = (props)=>{
    const { __scopeMenu, forceMount, children, container } = props;
    const context = useMenuContext(PORTAL_NAME, __scopeMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(PortalProvider, {
        scope: __scopeMenu,
        forceMount,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPortal.Portal), {
                asChild: true,
                container,
                children
            })
        })
    });
};
MenuPortal.displayName = PORTAL_NAME;
var CONTENT_NAME = "MenuContent";
var [MenuContentProvider, useMenuContentContext] = createMenuContext(CONTENT_NAME);
var MenuContent = _react.forwardRef((props, forwardedRef)=>{
    const portalContext = usePortalContext(CONTENT_NAME, props.__scopeMenu);
    const { forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = useMenuContext(CONTENT_NAME, props.__scopeMenu);
    const rootContext = useMenuRootContext(CONTENT_NAME, props.__scopeMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.Provider, {
        scope: props.__scopeMenu,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.Slot, {
                scope: props.__scopeMenu,
                children: rootContext.modal ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuRootContentModal, {
                    ...contentProps,
                    ref: forwardedRef
                }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuRootContentNonModal, {
                    ...contentProps,
                    ref: forwardedRef
                })
            })
        })
    });
});
var MenuRootContentModal = _react.forwardRef((props, forwardedRef)=>{
    const context = useMenuContext(CONTENT_NAME, props.__scopeMenu);
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    _react.useEffect(()=>{
        const content = ref.current;
        if (content) return (0, _ariaHidden.hideOthers)(content);
    }, []);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true,
        onFocusOutside: (0, _primitive.composeEventHandlers)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        }),
        onDismiss: ()=>context.onOpenChange(false)
    });
});
var MenuRootContentNonModal = _react.forwardRef((props, forwardedRef)=>{
    const context = useMenuContext(CONTENT_NAME, props.__scopeMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        onDismiss: ()=>context.onOpenChange(false)
    });
});
var Slot = (0, _reactSlot.createSlot)("MenuContent.ScrollLock");
var MenuContentImpl = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu, loop = false, trapFocus, onOpenAutoFocus, onCloseAutoFocus, disableOutsidePointerEvents, onEntryFocus, onEscapeKeyDown, onPointerDownOutside, onFocusOutside, onInteractOutside, onDismiss, disableOutsideScroll, ...contentProps } = props;
    const context = useMenuContext(CONTENT_NAME, __scopeMenu);
    const rootContext = useMenuRootContext(CONTENT_NAME, __scopeMenu);
    const popperScope = usePopperScope(__scopeMenu);
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeMenu);
    const getItems = useCollection(__scopeMenu);
    const [currentItemId, setCurrentItemId] = _react.useState(null);
    const contentRef = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, contentRef, context.onContentChange);
    const timerRef = _react.useRef(0);
    const searchRef = _react.useRef("");
    const pointerGraceTimerRef = _react.useRef(0);
    const pointerGraceIntentRef = _react.useRef(null);
    const pointerDirRef = _react.useRef("right");
    const lastPointerXRef = _react.useRef(0);
    const ScrollLockWrapper = disableOutsideScroll ? (0, _reactRemoveScroll.RemoveScroll) : _react.Fragment;
    const scrollLockWrapperProps = disableOutsideScroll ? {
        as: Slot,
        allowPinchZoom: true
    } : void 0;
    const handleTypeaheadSearch = (key)=>{
        const search = searchRef.current + key;
        const items = getItems().filter((item)=>!item.disabled);
        const currentItem = document.activeElement;
        const currentMatch = items.find((item)=>item.ref.current === currentItem)?.textValue;
        const values = items.map((item)=>item.textValue);
        const nextMatch = getNextMatch(values, search, currentMatch);
        const newItem = items.find((item)=>item.textValue === nextMatch)?.ref.current;
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1e3);
        })(search);
        if (newItem) setTimeout(()=>newItem.focus());
    };
    _react.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    (0, _reactFocusGuards.useFocusGuards)();
    const isPointerMovingToSubmenu = _react.useCallback((event)=>{
        const isMovingTowards = pointerDirRef.current === pointerGraceIntentRef.current?.side;
        return isMovingTowards && isPointerInGraceArea(event, pointerGraceIntentRef.current?.area);
    }, []);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuContentProvider, {
        scope: __scopeMenu,
        searchRef,
        onItemEnter: _react.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        onItemLeave: _react.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) return;
            contentRef.current?.focus();
            setCurrentItemId(null);
        }, [
            isPointerMovingToSubmenu
        ]),
        onTriggerLeave: _react.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        pointerGraceTimerRef,
        onPointerGraceIntentChange: _react.useCallback((intent)=>{
            pointerGraceIntentRef.current = intent;
        }, []),
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(ScrollLockWrapper, {
            ...scrollLockWrapperProps,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactFocusScope.FocusScope), {
                asChild: true,
                trapped: trapFocus,
                onMountAutoFocus: (0, _primitive.composeEventHandlers)(onOpenAutoFocus, (event)=>{
                    event.preventDefault();
                    contentRef.current?.focus({
                        preventScroll: true
                    });
                }),
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactDismissableLayer.DismissableLayer), {
                    asChild: true,
                    disableOutsidePointerEvents,
                    onEscapeKeyDown,
                    onPointerDownOutside,
                    onFocusOutside,
                    onInteractOutside,
                    onDismiss,
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactRovingFocus.Root, {
                        asChild: true,
                        ...rovingFocusGroupScope,
                        dir: rootContext.dir,
                        orientation: "vertical",
                        loop,
                        currentTabStopId: currentItemId,
                        onCurrentTabStopIdChange: setCurrentItemId,
                        onEntryFocus: (0, _primitive.composeEventHandlers)(onEntryFocus, (event)=>{
                            if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
                        }),
                        preventScrollOnEntryFocus: true,
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Content, {
                            role: "menu",
                            "aria-orientation": "vertical",
                            "data-state": getOpenState(context.open),
                            "data-radix-menu-content": "",
                            dir: rootContext.dir,
                            ...popperScope,
                            ...contentProps,
                            ref: composedRefs,
                            style: {
                                outline: "none",
                                ...contentProps.style
                            },
                            onKeyDown: (0, _primitive.composeEventHandlers)(contentProps.onKeyDown, (event)=>{
                                const target = event.target;
                                const isKeyDownInside = target.closest("[data-radix-menu-content]") === event.currentTarget;
                                const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                                const isCharacterKey = event.key.length === 1;
                                if (isKeyDownInside) {
                                    if (event.key === "Tab") event.preventDefault();
                                    if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
                                }
                                const content = contentRef.current;
                                if (event.target !== content) return;
                                if (!FIRST_LAST_KEYS.includes(event.key)) return;
                                event.preventDefault();
                                const items = getItems().filter((item)=>!item.disabled);
                                const candidateNodes = items.map((item)=>item.ref.current);
                                if (LAST_KEYS.includes(event.key)) candidateNodes.reverse();
                                focusFirst(candidateNodes);
                            }),
                            onBlur: (0, _primitive.composeEventHandlers)(props.onBlur, (event)=>{
                                if (!event.currentTarget.contains(event.target)) {
                                    window.clearTimeout(timerRef.current);
                                    searchRef.current = "";
                                }
                            }),
                            onPointerMove: (0, _primitive.composeEventHandlers)(props.onPointerMove, whenMouse((event)=>{
                                const target = event.target;
                                const pointerXHasChanged = lastPointerXRef.current !== event.clientX;
                                if (event.currentTarget.contains(target) && pointerXHasChanged) {
                                    const newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
                                    pointerDirRef.current = newDir;
                                    lastPointerXRef.current = event.clientX;
                                }
                            }))
                        })
                    })
                })
            })
        })
    });
});
MenuContent.displayName = CONTENT_NAME;
var GROUP_NAME = "MenuGroup";
var MenuGroup = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu, ...groupProps } = props;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        role: "group",
        ...groupProps,
        ref: forwardedRef
    });
});
MenuGroup.displayName = GROUP_NAME;
var LABEL_NAME = "MenuLabel";
var MenuLabel = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu, ...labelProps } = props;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        ...labelProps,
        ref: forwardedRef
    });
});
MenuLabel.displayName = LABEL_NAME;
var ITEM_NAME = "MenuItem";
var ITEM_SELECT = "menu.itemSelect";
var MenuItem = _react.forwardRef((props, forwardedRef)=>{
    const { disabled = false, onSelect, ...itemProps } = props;
    const ref = _react.useRef(null);
    const rootContext = useMenuRootContext(ITEM_NAME, props.__scopeMenu);
    const contentContext = useMenuContentContext(ITEM_NAME, props.__scopeMenu);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    const isPointerDownRef = _react.useRef(false);
    const handleSelect = ()=>{
        const menuItem = ref.current;
        if (!disabled && menuItem) {
            const itemSelectEvent = new CustomEvent(ITEM_SELECT, {
                bubbles: true,
                cancelable: true
            });
            menuItem.addEventListener(ITEM_SELECT, (event)=>onSelect?.(event), {
                once: true
            });
            (0, _reactPrimitive.dispatchDiscreteCustomEvent)(menuItem, itemSelectEvent);
            if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
            else rootContext.onClose();
        }
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuItemImpl, {
        ...itemProps,
        ref: composedRefs,
        disabled,
        onClick: (0, _primitive.composeEventHandlers)(props.onClick, handleSelect),
        onPointerDown: (event)=>{
            props.onPointerDown?.(event);
            isPointerDownRef.current = true;
        },
        onPointerUp: (0, _primitive.composeEventHandlers)(props.onPointerUp, (event)=>{
            if (!isPointerDownRef.current) event.currentTarget?.click();
        }),
        onKeyDown: (0, _primitive.composeEventHandlers)(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== "";
            if (disabled || isTypingAhead && event.key === " ") return;
            if (SELECTION_KEYS.includes(event.key)) {
                event.currentTarget.click();
                event.preventDefault();
            }
        })
    });
});
MenuItem.displayName = ITEM_NAME;
var MenuItemImpl = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu, disabled = false, textValue, ...itemProps } = props;
    const contentContext = useMenuContentContext(ITEM_NAME, __scopeMenu);
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeMenu);
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    const [isFocused, setIsFocused] = _react.useState(false);
    const [textContent, setTextContent] = _react.useState("");
    _react.useEffect(()=>{
        const menuItem = ref.current;
        if (menuItem) setTextContent((menuItem.textContent ?? "").trim());
    }, [
        itemProps.children
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.ItemSlot, {
        scope: __scopeMenu,
        disabled,
        textValue: textValue ?? textContent,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactRovingFocus.Item, {
            asChild: true,
            ...rovingFocusGroupScope,
            focusable: !disabled,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
                role: "menuitem",
                "data-highlighted": isFocused ? "" : void 0,
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                ...itemProps,
                ref: composedRefs,
                onPointerMove: (0, _primitive.composeEventHandlers)(props.onPointerMove, whenMouse((event)=>{
                    if (disabled) contentContext.onItemLeave(event);
                    else {
                        contentContext.onItemEnter(event);
                        if (!event.defaultPrevented) {
                            const item = event.currentTarget;
                            item.focus({
                                preventScroll: true
                            });
                        }
                    }
                })),
                onPointerLeave: (0, _primitive.composeEventHandlers)(props.onPointerLeave, whenMouse((event)=>contentContext.onItemLeave(event))),
                onFocus: (0, _primitive.composeEventHandlers)(props.onFocus, ()=>setIsFocused(true)),
                onBlur: (0, _primitive.composeEventHandlers)(props.onBlur, ()=>setIsFocused(false))
            })
        })
    });
});
var CHECKBOX_ITEM_NAME = "MenuCheckboxItem";
var MenuCheckboxItem = _react.forwardRef((props, forwardedRef)=>{
    const { checked = false, onCheckedChange, ...checkboxItemProps } = props;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuItem, {
            role: "menuitemcheckbox",
            "aria-checked": isIndeterminate(checked) ? "mixed" : checked,
            ...checkboxItemProps,
            ref: forwardedRef,
            "data-state": getCheckedState(checked),
            onSelect: (0, _primitive.composeEventHandlers)(checkboxItemProps.onSelect, ()=>onCheckedChange?.(isIndeterminate(checked) ? true : !checked), {
                checkForDefaultPrevented: false
            })
        })
    });
});
MenuCheckboxItem.displayName = CHECKBOX_ITEM_NAME;
var RADIO_GROUP_NAME = "MenuRadioGroup";
var [RadioGroupProvider, useRadioGroupContext] = createMenuContext(RADIO_GROUP_NAME, {
    value: void 0,
    onValueChange: ()=>{}
});
var MenuRadioGroup = _react.forwardRef((props, forwardedRef)=>{
    const { value, onValueChange, ...groupProps } = props;
    const handleValueChange = (0, _reactUseCallbackRef.useCallbackRef)(onValueChange);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(RadioGroupProvider, {
        scope: props.__scopeMenu,
        value,
        onValueChange: handleValueChange,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuGroup, {
            ...groupProps,
            ref: forwardedRef
        })
    });
});
MenuRadioGroup.displayName = RADIO_GROUP_NAME;
var RADIO_ITEM_NAME = "MenuRadioItem";
var MenuRadioItem = _react.forwardRef((props, forwardedRef)=>{
    const { value, ...radioItemProps } = props;
    const context = useRadioGroupContext(RADIO_ITEM_NAME, props.__scopeMenu);
    const checked = value === context.value;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuItem, {
            role: "menuitemradio",
            "aria-checked": checked,
            ...radioItemProps,
            ref: forwardedRef,
            "data-state": getCheckedState(checked),
            onSelect: (0, _primitive.composeEventHandlers)(radioItemProps.onSelect, ()=>context.onValueChange?.(value), {
                checkForDefaultPrevented: false
            })
        })
    });
});
MenuRadioItem.displayName = RADIO_ITEM_NAME;
var ITEM_INDICATOR_NAME = "MenuItemIndicator";
var [ItemIndicatorProvider, useItemIndicatorContext] = createMenuContext(ITEM_INDICATOR_NAME, {
    checked: false
});
var MenuItemIndicator = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu, forceMount, ...itemIndicatorProps } = props;
    const indicatorContext = useItemIndicatorContext(ITEM_INDICATOR_NAME, __scopeMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
        present: forceMount || isIndeterminate(indicatorContext.checked) || indicatorContext.checked === true,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).span, {
            ...itemIndicatorProps,
            ref: forwardedRef,
            "data-state": getCheckedState(indicatorContext.checked)
        })
    });
});
MenuItemIndicator.displayName = ITEM_INDICATOR_NAME;
var SEPARATOR_NAME = "MenuSeparator";
var MenuSeparator = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu, ...separatorProps } = props;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        role: "separator",
        "aria-orientation": "horizontal",
        ...separatorProps,
        ref: forwardedRef
    });
});
MenuSeparator.displayName = SEPARATOR_NAME;
var ARROW_NAME = "MenuArrow";
var MenuArrow = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu, ...arrowProps } = props;
    const popperScope = usePopperScope(__scopeMenu);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Arrow, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
MenuArrow.displayName = ARROW_NAME;
var SUB_NAME = "MenuSub";
var [MenuSubProvider, useMenuSubContext] = createMenuContext(SUB_NAME);
var MenuSub = (props)=>{
    const { __scopeMenu, children, open = false, onOpenChange } = props;
    const parentMenuContext = useMenuContext(SUB_NAME, __scopeMenu);
    const popperScope = usePopperScope(__scopeMenu);
    const [trigger, setTrigger] = _react.useState(null);
    const [content, setContent] = _react.useState(null);
    const handleOpenChange = (0, _reactUseCallbackRef.useCallbackRef)(onOpenChange);
    _react.useEffect(()=>{
        if (parentMenuContext.open === false) handleOpenChange(false);
        return ()=>handleOpenChange(false);
    }, [
        parentMenuContext.open,
        handleOpenChange
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Root, {
        ...popperScope,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuProvider, {
            scope: __scopeMenu,
            open,
            onOpenChange: handleOpenChange,
            content,
            onContentChange: setContent,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuSubProvider, {
                scope: __scopeMenu,
                contentId: (0, _reactId.useId)(),
                triggerId: (0, _reactId.useId)(),
                trigger,
                onTriggerChange: setTrigger,
                children
            })
        })
    });
};
MenuSub.displayName = SUB_NAME;
var SUB_TRIGGER_NAME = "MenuSubTrigger";
var MenuSubTrigger = _react.forwardRef((props, forwardedRef)=>{
    const context = useMenuContext(SUB_TRIGGER_NAME, props.__scopeMenu);
    const rootContext = useMenuRootContext(SUB_TRIGGER_NAME, props.__scopeMenu);
    const subContext = useMenuSubContext(SUB_TRIGGER_NAME, props.__scopeMenu);
    const contentContext = useMenuContentContext(SUB_TRIGGER_NAME, props.__scopeMenu);
    const openTimerRef = _react.useRef(null);
    const { pointerGraceTimerRef, onPointerGraceIntentChange } = contentContext;
    const scope = {
        __scopeMenu: props.__scopeMenu
    };
    const clearOpenTimer = _react.useCallback(()=>{
        if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
    }, []);
    _react.useEffect(()=>clearOpenTimer, [
        clearOpenTimer
    ]);
    _react.useEffect(()=>{
        const pointerGraceTimer = pointerGraceTimerRef.current;
        return ()=>{
            window.clearTimeout(pointerGraceTimer);
            onPointerGraceIntentChange(null);
        };
    }, [
        pointerGraceTimerRef,
        onPointerGraceIntentChange
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuAnchor, {
        asChild: true,
        ...scope,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuItemImpl, {
            id: subContext.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": context.open,
            "aria-controls": subContext.contentId,
            "data-state": getOpenState(context.open),
            ...props,
            ref: (0, _reactComposeRefs.composeRefs)(forwardedRef, subContext.onTriggerChange),
            onClick: (event)=>{
                props.onClick?.(event);
                if (props.disabled || event.defaultPrevented) return;
                event.currentTarget.focus();
                if (!context.open) context.onOpenChange(true);
            },
            onPointerMove: (0, _primitive.composeEventHandlers)(props.onPointerMove, whenMouse((event)=>{
                contentContext.onItemEnter(event);
                if (event.defaultPrevented) return;
                if (!props.disabled && !context.open && !openTimerRef.current) {
                    contentContext.onPointerGraceIntentChange(null);
                    openTimerRef.current = window.setTimeout(()=>{
                        context.onOpenChange(true);
                        clearOpenTimer();
                    }, 100);
                }
            })),
            onPointerLeave: (0, _primitive.composeEventHandlers)(props.onPointerLeave, whenMouse((event)=>{
                clearOpenTimer();
                const contentRect = context.content?.getBoundingClientRect();
                if (contentRect) {
                    const side = context.content?.dataset.side;
                    const rightSide = side === "right";
                    const bleed = rightSide ? -5 : 5;
                    const contentNearEdge = contentRect[rightSide ? "left" : "right"];
                    const contentFarEdge = contentRect[rightSide ? "right" : "left"];
                    contentContext.onPointerGraceIntentChange({
                        area: [
                            // Apply a bleed on clientX to ensure that our exit point is
                            // consistently within polygon bounds
                            {
                                x: event.clientX + bleed,
                                y: event.clientY
                            },
                            {
                                x: contentNearEdge,
                                y: contentRect.top
                            },
                            {
                                x: contentFarEdge,
                                y: contentRect.top
                            },
                            {
                                x: contentFarEdge,
                                y: contentRect.bottom
                            },
                            {
                                x: contentNearEdge,
                                y: contentRect.bottom
                            }
                        ],
                        side
                    });
                    window.clearTimeout(pointerGraceTimerRef.current);
                    pointerGraceTimerRef.current = window.setTimeout(()=>contentContext.onPointerGraceIntentChange(null), 300);
                } else {
                    contentContext.onTriggerLeave(event);
                    if (event.defaultPrevented) return;
                    contentContext.onPointerGraceIntentChange(null);
                }
            })),
            onKeyDown: (0, _primitive.composeEventHandlers)(props.onKeyDown, (event)=>{
                const isTypingAhead = contentContext.searchRef.current !== "";
                if (props.disabled || isTypingAhead && event.key === " ") return;
                if (SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
                    context.onOpenChange(true);
                    context.content?.focus();
                    event.preventDefault();
                }
            })
        })
    });
});
MenuSubTrigger.displayName = SUB_TRIGGER_NAME;
var SUB_CONTENT_NAME = "MenuSubContent";
var MenuSubContent = _react.forwardRef((props, forwardedRef)=>{
    const portalContext = usePortalContext(CONTENT_NAME, props.__scopeMenu);
    const { forceMount = portalContext.forceMount, ...subContentProps } = props;
    const context = useMenuContext(CONTENT_NAME, props.__scopeMenu);
    const rootContext = useMenuRootContext(CONTENT_NAME, props.__scopeMenu);
    const subContext = useMenuSubContext(SUB_CONTENT_NAME, props.__scopeMenu);
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.Provider, {
        scope: props.__scopeMenu,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.Slot, {
                scope: props.__scopeMenu,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(MenuContentImpl, {
                    id: subContext.contentId,
                    "aria-labelledby": subContext.triggerId,
                    ...subContentProps,
                    ref: composedRefs,
                    align: "start",
                    side: rootContext.dir === "rtl" ? "left" : "right",
                    disableOutsidePointerEvents: false,
                    disableOutsideScroll: false,
                    trapFocus: false,
                    onOpenAutoFocus: (event)=>{
                        if (rootContext.isUsingKeyboardRef.current) ref.current?.focus();
                        event.preventDefault();
                    },
                    onCloseAutoFocus: (event)=>event.preventDefault(),
                    onFocusOutside: (0, _primitive.composeEventHandlers)(props.onFocusOutside, (event)=>{
                        if (event.target !== subContext.trigger) context.onOpenChange(false);
                    }),
                    onEscapeKeyDown: (0, _primitive.composeEventHandlers)(props.onEscapeKeyDown, (event)=>{
                        rootContext.onClose();
                        event.preventDefault();
                    }),
                    onKeyDown: (0, _primitive.composeEventHandlers)(props.onKeyDown, (event)=>{
                        const isKeyDownInside = event.currentTarget.contains(event.target);
                        const isCloseKey = SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
                        if (isKeyDownInside && isCloseKey) {
                            context.onOpenChange(false);
                            subContext.trigger?.focus();
                            event.preventDefault();
                        }
                    })
                })
            })
        })
    });
});
MenuSubContent.displayName = SUB_CONTENT_NAME;
function getOpenState(open) {
    return open ? "open" : "closed";
}
function isIndeterminate(checked) {
    return checked === "indeterminate";
}
function getCheckedState(checked) {
    return isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
function focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
function getNextMatch(values, search, currentMatch) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
    let wrappedValues = wrapArray(values, Math.max(currentMatchIndex, 0));
    const excludeCurrentMatch = normalizedSearch.length === 1;
    if (excludeCurrentMatch) wrappedValues = wrappedValues.filter((v)=>v !== currentMatch);
    const nextMatch = wrappedValues.find((value)=>value.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextMatch !== currentMatch ? nextMatch : void 0;
}
function isPointInPolygon(point, polygon) {
    const { x, y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const ii = polygon[i];
        const jj = polygon[j];
        const xi = ii.x;
        const yi = ii.y;
        const xj = jj.x;
        const yj = jj.y;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function isPointerInGraceArea(event, area) {
    if (!area) return false;
    const cursorPos = {
        x: event.clientX,
        y: event.clientY
    };
    return isPointInPolygon(cursorPos, area);
}
function whenMouse(handler) {
    return (event)=>event.pointerType === "mouse" ? handler(event) : void 0;
}
var Root3 = Menu;
var Anchor2 = MenuAnchor;
var Portal = MenuPortal;
var Content2 = MenuContent;
var Group = MenuGroup;
var Label = MenuLabel;
var Item2 = MenuItem;
var CheckboxItem = MenuCheckboxItem;
var RadioGroup = MenuRadioGroup;
var RadioItem = MenuRadioItem;
var ItemIndicator = MenuItemIndicator;
var Separator = MenuSeparator;
var Arrow2 = MenuArrow;
var Sub = MenuSub;
var SubTrigger = MenuSubTrigger;
var SubContent = MenuSubContent;

},{"react":"eGun2","@radix-ui/primitive":"k8C5A","@radix-ui/react-collection":"kU6H9","@radix-ui/react-compose-refs":"nN23r","@radix-ui/react-context":"4wywa","@radix-ui/react-direction":"boYIn","@radix-ui/react-dismissable-layer":"gdhJG","@radix-ui/react-focus-guards":"h3kF4","@radix-ui/react-focus-scope":"dkOta","@radix-ui/react-id":"hoLx9","@radix-ui/react-popper":"5wakN","@radix-ui/react-portal":"4FFRT","@radix-ui/react-presence":"eh7qi","@radix-ui/react-primitive":"hQJ44","@radix-ui/react-roving-focus":"gOMXg","@radix-ui/react-slot":"4sJVf","@radix-ui/react-use-callback-ref":"bakzF","aria-hidden":"8h7XP","react-remove-scroll":[["RemoveScroll","emctR","default"]],"react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kU6H9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCollection", ()=>createCollection);
parcelHelpers.export(exports, "unstable_createCollection", ()=>createCollection2);
// src/collection-legacy.tsx
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactContext = require("@radix-ui/react-context");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactSlot = require("@radix-ui/react-slot");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function createCollection(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, _reactContext.createContextScope)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope, children } = props;
        const ref = (0, _reactDefault.default).useRef(null);
        const itemMap = (0, _reactDefault.default).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionProviderImpl, {
            scope,
            itemMap,
            collectionRef: ref,
            children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, _reactSlot.createSlot)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
        const { scope, children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, _reactSlot.createSlot)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
        const { scope, children, ...itemData } = props;
        const ref = (0, _reactDefault.default).useRef(null);
        const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, _reactDefault.default).useEffect(()=>{
            context.itemMap.set(ref, {
                ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, _reactDefault.default).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}
// src/ordered-dictionary.ts
var __instanciated = /* @__PURE__ */ new WeakMap();
var OrderedDict = class _OrderedDict extends Map {
    #keys;
    constructor(entries){
        super(entries);
        this.#keys = [
            ...super.keys()
        ];
        __instanciated.set(this, true);
    }
    set(key, value) {
        if (__instanciated.get(this)) {
            if (this.has(key)) this.#keys[this.#keys.indexOf(key)] = key;
            else this.#keys.push(key);
        }
        super.set(key, value);
        return this;
    }
    insert(index, key, value) {
        const has = this.has(key);
        const length = this.#keys.length;
        const relativeIndex = toSafeInteger(index);
        let actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
        const safeIndex = actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
        if (safeIndex === this.size || has && safeIndex === this.size - 1 || safeIndex === -1) {
            this.set(key, value);
            return this;
        }
        const size = this.size + (has ? 0 : 1);
        if (relativeIndex < 0) actualIndex++;
        const keys = [
            ...this.#keys
        ];
        let nextValue;
        let shouldSkip = false;
        for(let i = actualIndex; i < size; i++)if (actualIndex === i) {
            let nextKey = keys[i];
            if (keys[i] === key) nextKey = keys[i + 1];
            if (has) this.delete(key);
            nextValue = this.get(nextKey);
            this.set(key, value);
        } else {
            if (!shouldSkip && keys[i - 1] === key) shouldSkip = true;
            const currentKey = keys[shouldSkip ? i : i - 1];
            const currentValue = nextValue;
            nextValue = this.get(currentKey);
            this.delete(currentKey);
            this.set(currentKey, currentValue);
        }
        return this;
    }
    with(index, key, value) {
        const copy = new _OrderedDict(this);
        copy.insert(index, key, value);
        return copy;
    }
    before(key) {
        const index = this.#keys.indexOf(key) - 1;
        if (index < 0) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position before the given key.
   */ setBefore(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index, newKey, value);
    }
    after(key) {
        let index = this.#keys.indexOf(key);
        index = index === -1 || index === this.size - 1 ? -1 : index + 1;
        if (index === -1) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position after the given key.
   */ setAfter(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index + 1, newKey, value);
    }
    first() {
        return this.entryAt(0);
    }
    last() {
        return this.entryAt(-1);
    }
    clear() {
        this.#keys = [];
        return super.clear();
    }
    delete(key) {
        const deleted = super.delete(key);
        if (deleted) this.#keys.splice(this.#keys.indexOf(key), 1);
        return deleted;
    }
    deleteAt(index) {
        const key = this.keyAt(index);
        if (key !== void 0) return this.delete(key);
        return false;
    }
    at(index) {
        const key = at(this.#keys, index);
        if (key !== void 0) return this.get(key);
    }
    entryAt(index) {
        const key = at(this.#keys, index);
        if (key !== void 0) return [
            key,
            this.get(key)
        ];
    }
    indexOf(key) {
        return this.#keys.indexOf(key);
    }
    keyAt(index) {
        return at(this.#keys, index);
    }
    from(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.at(dest);
    }
    keyFrom(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.keyAt(dest);
    }
    find(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return entry;
            index++;
        }
        return void 0;
    }
    findIndex(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return index;
            index++;
        }
        return -1;
    }
    filter(predicate, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) entries.push(entry);
            index++;
        }
        return new _OrderedDict(entries);
    }
    map(callbackfn, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            entries.push([
                entry[0],
                Reflect.apply(callbackfn, thisArg, [
                    entry,
                    index,
                    this
                ])
            ]);
            index++;
        }
        return new _OrderedDict(entries);
    }
    reduce(...args) {
        const [callbackfn, initialValue] = args;
        let index = 0;
        let accumulator = initialValue ?? this.at(0);
        for (const entry of this){
            if (index === 0 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
            index++;
        }
        return accumulator;
    }
    reduceRight(...args) {
        const [callbackfn, initialValue] = args;
        let accumulator = initialValue ?? this.at(-1);
        for(let index = this.size - 1; index >= 0; index--){
            const entry = this.at(index);
            if (index === this.size - 1 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
        }
        return accumulator;
    }
    toSorted(compareFn) {
        const entries = [
            ...this.entries()
        ].sort(compareFn);
        return new _OrderedDict(entries);
    }
    toReversed() {
        const reversed = new _OrderedDict();
        for(let index = this.size - 1; index >= 0; index--){
            const key = this.keyAt(index);
            const element = this.get(key);
            reversed.set(key, element);
        }
        return reversed;
    }
    toSpliced(...args) {
        const entries = [
            ...this.entries()
        ];
        entries.splice(...args);
        return new _OrderedDict(entries);
    }
    slice(start, end) {
        const result = new _OrderedDict();
        let stop = this.size - 1;
        if (start === void 0) return result;
        if (start < 0) start = start + this.size;
        if (end !== void 0 && end > 0) stop = end - 1;
        for(let index = start; index <= stop; index++){
            const key = this.keyAt(index);
            const element = this.get(key);
            result.set(key, element);
        }
        return result;
    }
    every(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (!Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return false;
            index++;
        }
        return true;
    }
    some(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return true;
            index++;
        }
        return false;
    }
};
function at(array, index) {
    if ("at" in Array.prototype) return Array.prototype.at.call(array, index);
    const actualIndex = toSafeIndex(array, index);
    return actualIndex === -1 ? void 0 : array[actualIndex];
}
function toSafeIndex(array, index) {
    const length = array.length;
    const relativeIndex = toSafeInteger(index);
    const actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
    return actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
}
function toSafeInteger(number) {
    return number !== number || number === 0 ? 0 : Math.trunc(number);
}
function createCollection2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, _reactContext.createContextScope)(PROVIDER_NAME);
    const [CollectionContextProvider, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionElement: null,
        collectionRef: {
            current: null
        },
        collectionRefObject: {
            current: null
        },
        itemMap: new OrderedDict(),
        setItemMap: ()=>void 0
    });
    const CollectionProvider = ({ state, ...props })=>{
        return state ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionProviderImpl, {
            ...props,
            state
        }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionInit, {
            ...props
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const CollectionInit = (props)=>{
        const state = useInitCollection();
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionProviderImpl, {
            ...props,
            state
        });
    };
    CollectionInit.displayName = PROVIDER_NAME + "Init";
    const CollectionProviderImpl = (props)=>{
        const { scope, children, state } = props;
        const ref = (0, _reactDefault.default).useRef(null);
        const [collectionElement, setCollectionElement] = (0, _reactDefault.default).useState(null);
        const composeRefs = (0, _reactComposeRefs.useComposedRefs)(ref, setCollectionElement);
        const [itemMap, setItemMap] = state;
        (0, _reactDefault.default).useEffect(()=>{
            if (!collectionElement) return;
            const observer = getChildListObserver(()=>{});
            observer.observe(collectionElement, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }, [
            collectionElement
        ]);
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionContextProvider, {
            scope,
            itemMap,
            setItemMap,
            collectionRef: composeRefs,
            collectionRefObject: ref,
            collectionElement,
            children
        });
    };
    CollectionProviderImpl.displayName = PROVIDER_NAME + "Impl";
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, _reactSlot.createSlot)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
        const { scope, children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, _reactSlot.createSlot)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
        const { scope, children, ...itemData } = props;
        const ref = (0, _reactDefault.default).useRef(null);
        const [element, setElement] = (0, _reactDefault.default).useState(null);
        const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref, setElement);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        const { setItemMap } = context;
        const itemDataRef = (0, _reactDefault.default).useRef(itemData);
        if (!shallowEqual(itemDataRef.current, itemData)) itemDataRef.current = itemData;
        const memoizedItemData = itemDataRef.current;
        (0, _reactDefault.default).useEffect(()=>{
            const itemData2 = memoizedItemData;
            setItemMap((map)=>{
                if (!element) return map;
                if (!map.has(element)) {
                    map.set(element, {
                        ...itemData2,
                        element
                    });
                    return map.toSorted(sortByDocumentPosition);
                }
                return map.set(element, {
                    ...itemData2,
                    element
                }).toSorted(sortByDocumentPosition);
            });
            return ()=>{
                setItemMap((map)=>{
                    if (!element || !map.has(element)) return map;
                    map.delete(element);
                    return new OrderedDict(map);
                });
            };
        }, [
            element,
            memoizedItemData,
            setItemMap
        ]);
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useInitCollection() {
        return (0, _reactDefault.default).useState(new OrderedDict());
    }
    function useCollection(scope) {
        const { itemMap } = useCollectionContext(name + "CollectionConsumer", scope);
        return itemMap;
    }
    const functions = {
        createCollectionScope,
        useCollection,
        useInitCollection
    };
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        functions
    ];
}
function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || typeof b !== "object") return false;
    if (a == null || b == null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function isElementPreceding(a, b) {
    return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
function sortByDocumentPosition(a, b) {
    return !a[1].element || !b[1].element ? 0 : isElementPreceding(a[1].element, b[1].element) ? -1 : 1;
}
function getChildListObserver(callback) {
    const observer = new MutationObserver((mutationsList)=>{
        for (const mutation of mutationsList)if (mutation.type === "childList") {
            callback();
            return;
        }
    });
    return observer;
}

},{"react":"eGun2","@radix-ui/react-context":"4wywa","@radix-ui/react-compose-refs":"nN23r","@radix-ui/react-slot":"4sJVf","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"boYIn":[function(require,module,exports,__globalThis) {
// packages/react/direction/src/direction.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirectionProvider", ()=>DirectionProvider);
parcelHelpers.export(exports, "Provider", ()=>Provider);
parcelHelpers.export(exports, "useDirection", ()=>useDirection);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var DirectionContext = _react.createContext(void 0);
var DirectionProvider = (props)=>{
    const { dir, children } = props;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(DirectionContext.Provider, {
        value: dir,
        children
    });
};
function useDirection(localDir) {
    const globalDir = _react.useContext(DirectionContext);
    return localDir || globalDir || "ltr";
}
var Provider = DirectionProvider;

},{"react":"eGun2","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gOMXg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>Item);
parcelHelpers.export(exports, "Root", ()=>Root);
parcelHelpers.export(exports, "RovingFocusGroup", ()=>RovingFocusGroup);
parcelHelpers.export(exports, "RovingFocusGroupItem", ()=>RovingFocusGroupItem);
parcelHelpers.export(exports, "createRovingFocusGroupScope", ()=>createRovingFocusGroupScope);
// src/roving-focus-group.tsx
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactCollection = require("@radix-ui/react-collection");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactContext = require("@radix-ui/react-context");
var _reactId = require("@radix-ui/react-id");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactUseCallbackRef = require("@radix-ui/react-use-callback-ref");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _reactDirection = require("@radix-ui/react-direction");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var GROUP_NAME = "RovingFocusGroup";
var [Collection, useCollection, createCollectionScope] = (0, _reactCollection.createCollection)(GROUP_NAME);
var [createRovingFocusGroupContext, createRovingFocusGroupScope] = (0, _reactContext.createContextScope)(GROUP_NAME, [
    createCollectionScope
]);
var [RovingFocusProvider, useRovingFocusContext] = createRovingFocusGroupContext(GROUP_NAME);
var RovingFocusGroup = _react.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
});
RovingFocusGroup.displayName = GROUP_NAME;
var RovingFocusGroupImpl = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup, orientation, loop = false, dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId, onCurrentTabStopIdChange, onEntryFocus, preventScrollOnEntryFocus = false, ...groupProps } = props;
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    const direction = (0, _reactDirection.useDirection)(dir);
    const [currentTabStopId, setCurrentTabStopId] = (0, _reactUseControllableState.useControllableState)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId ?? null,
        onChange: onCurrentTabStopIdChange,
        caller: GROUP_NAME
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = _react.useState(false);
    const handleEntryFocus = (0, _reactUseCallbackRef.useCallbackRef)(onEntryFocus);
    const getItems = useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = _react.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = _react.useState(0);
    _react.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener(ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener(ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation,
        dir: direction,
        loop,
        currentTabStopId,
        onItemFocus: _react.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: _react.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: _react.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: _react.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, _primitive.composeEventHandlers)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, _primitive.composeEventHandlers)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent(ENTRY_FOCUS, EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, _primitive.composeEventHandlers)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
});
var ITEM_NAME = "RovingFocusGroupItem";
var RovingFocusGroupItem = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup, focusable = true, active = false, tabStopId, children, ...itemProps } = props;
    const autoId = (0, _reactId.useId)();
    const id = tabStopId || autoId;
    const context = useRovingFocusContext(ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd, onFocusableItemRemove, currentTabStopId } = context;
    _react.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id,
        focusable,
        active,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, _primitive.composeEventHandlers)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, _primitive.composeEventHandlers)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, _primitive.composeEventHandlers)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>focusFirst(candidateNodes));
                }
            }),
            children: typeof children === "function" ? children({
                isCurrentTabStop,
                hasTabStop: currentTabStopId != null
            }) : children
        })
    });
});
RovingFocusGroupItem.displayName = ITEM_NAME;
var MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function getFocusIntent(event, orientation, dir) {
    const key = getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return MAP_KEY_TO_FOCUS_INTENT[key];
}
function focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var Root = RovingFocusGroup;
var Item = RovingFocusGroupItem;

},{"react":"eGun2","@radix-ui/primitive":"k8C5A","@radix-ui/react-collection":"kU6H9","@radix-ui/react-compose-refs":"nN23r","@radix-ui/react-context":"4wywa","@radix-ui/react-id":"hoLx9","@radix-ui/react-primitive":"hQJ44","@radix-ui/react-use-callback-ref":"bakzF","@radix-ui/react-use-controllable-state":"ThW7y","@radix-ui/react-direction":"boYIn","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bajJU":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Check);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const Check = (0, _createLucideIconJsDefault.default)("check", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"lOb49":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronRight);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const ChevronRight = (0, _createLucideIconJsDefault.default)("chevron-right", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"lGLGY":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Circle);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
];
const Circle = (0, _createLucideIconJsDefault.default)("circle", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"g6U9n":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ArrowLeftRight);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M8 3 4 7l4 4",
            key: "9rb6wj"
        }
    ],
    [
        "path",
        {
            d: "M4 7h16",
            key: "6tx8e3"
        }
    ],
    [
        "path",
        {
            d: "m16 21 4-4-4-4",
            key: "siv7j2"
        }
    ],
    [
        "path",
        {
            d: "M20 17H4",
            key: "h6l3hr"
        }
    ]
];
const ArrowLeftRight = (0, _createLucideIconJsDefault.default)("arrow-left-right", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"c053W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScaledroneContext", ()=>useScaledroneContext);
parcelHelpers.export(exports, "ScaledroneProvider", ()=>ScaledroneProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _config = require("@/client/config");
var _transcodeJobsStore = require("@/client/store/transcodeJobsStore");
var _liveStreamsStore = require("@/client/store/liveStreamsStore");
var _clientsStore = require("@/client/store/clientsStore");
var _encoderWSSStore = require("@/client/store/encoderWSSStore");
var _auth0React = require("@auth0/auth0-react");
var _flappingToast = require("@/client/components/flapping-toast");
var _scaledrone = require("@shared/config/scaledrone");
var _apiError = require("@/client/lib/apiError");
// DDOS Prevention Configuration - uses shared config
const { MAX_CONNECTION_ATTEMPTS, CIRCUIT_BREAKER_THRESHOLD, CONNECTION_TIMEOUT_MS } = (0, _scaledrone.SCALEDRONE_CONFIG);
const ScaledroneContext = /*#__PURE__*/ (0, _react.createContext)(null);
function useScaledroneContext() {
    const context = (0, _react.useContext)(ScaledroneContext);
    if (!context) throw new Error('useScaledroneContext must be used within a ScaledroneProvider');
    return context;
}
function ScaledroneProvider({ children }) {
    const { isAuthenticated, isLoading, getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    const { clients, fetchClients } = (0, _clientsStore.useClientsStore)();
    const [status, setStatus] = (0, _react.useState)('disconnected');
    const [error, setError] = (0, _react.useState)(null);
    const [subscriptionProgress, setSubscriptionProgress] = (0, _react.useState)(null);
    // Refs for connection management
    const workerRef = (0, _react.useRef)(null);
    const droneRef = (0, _react.useRef)(null);
    const roomsRef = (0, _react.useRef)(new Map());
    const subscriptionInProgressRef = (0, _react.useRef)(false);
    const connectionAttemptsRef = (0, _react.useRef)(0);
    const circuitBreakerTrippedRef = (0, _react.useRef)(false);
    const isInitializingRef = (0, _react.useRef)(false);
    const connectionTimeoutRef = (0, _react.useRef)(null);
    const intentionalCloseRef = (0, _react.useRef)(false);
    const hasInitializedRef = (0, _react.useRef)(false);
    const processWorkerMessageRef = (0, _react.useRef)(null);
    // Store actions
    const updateJobFromWSS = (0, _transcodeJobsStore.useTranscodeJobsStore)((state)=>state.updateJobFromWSS);
    const updateEventStatus = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.updateEventStatus);
    const processEncoderEvent = (0, _encoderWSSStore.useEncoderWSSStore)((state)=>state.processEvent);
    // Get active client IDs
    // If SCALEDRONE_TEST_CLIENT_ID is set, only subscribe to that single client
    const activeClientIDs = (0, _react.useMemo)(()=>{
        if (0, _config.SCALEDRONE_TEST_CLIENT_ID) return [
            (0, _config.SCALEDRONE_TEST_CLIENT_ID)
        ];
        return clients.filter((client)=>client.active === 1).map((client)=>client.clientID);
    }, [
        clients
    ]);
    // Process worker messages
    // Note: This callback is stored in a ref and accessed via the worker's onmessage handler.
    // We use getState() to access store data to avoid stale closure issues.
    const processWorkerMessage = (0, _react.useCallback)((message)=>{
        switch(message.type){
            case 'event_status':
                if (message.raw && typeof message.raw === 'object') updateEventStatus(message.raw);
                break;
            case 'transcode_job':
                updateJobFromWSS(message.jobID, message.assetID, message.eventID, message.clientID, message.progress, message.status, message.raw);
                break;
            case 'encoder_wss':
                {
                    // Get previous state before processing
                    const prevState = (0, _encoderWSSStore.useEncoderWSSStore).getState().encoders.get(message.encoderID)?.state;
                    // Process the event and get the new state
                    const newState = processEncoderEvent({
                        encoderID: message.encoderID,
                        eventType: message.eventType,
                        online: message.online,
                        streamInfo: message.streamInfo,
                        simpleName: message.simpleName,
                        clientID: message.clientID,
                        timestamp: message.timestamp
                    });
                    // Show toast when transitioning to warning or alert state (flapping cycles only)
                    // Note: Live stream disconnects are handled server-side and delivered via SSE
                    if ((newState === 'warning' || newState === 'alert') && prevState !== newState) {
                        // Count cycles from encoder state
                        const encoder = (0, _encoderWSSStore.useEncoderWSSStore).getState().encoders.get(message.encoderID);
                        const cycles = encoder?.events.reduce((count, event, i, arr)=>{
                            if (i === 0) return count;
                            if (arr[i - 1].type === 'disconnect' && event.type === 'connect') return count + 1;
                            return count;
                        }, 0) ?? 0;
                        // Only show toast if there are actual flapping cycles
                        // Live stream disconnects (0 cycles) are handled via server SSE
                        if (cycles > 0) (0, _flappingToast.showFlappingToast)({
                            encoderId: message.encoderID,
                            simpleName: message.simpleName,
                            cycles,
                            severity: newState
                        });
                    }
                    break;
                }
            case 'batch':
                for (const update of message.updates)processWorkerMessage(update);
                break;
        }
    }, [
        updateJobFromWSS,
        updateEventStatus,
        processEncoderEvent
    ]);
    // Keep ref updated with latest processWorkerMessage
    // This ensures the worker's onmessage handler always calls the latest version
    processWorkerMessageRef.current = processWorkerMessage;
    // Subscribe to rooms in batches
    const subscribeToBatch = (0, _react.useCallback)(async (clientIDsToSubscribe)=>{
        if (subscriptionInProgressRef.current) return;
        subscriptionInProgressRef.current = true;
        const total = clientIDsToSubscribe.length;
        let subscribed = 0;
        const { BATCH_SIZE, DELAY_BETWEEN_BATCHES_MS } = (0, _scaledrone.SCALEDRONE_CONFIG);
        for(let i = 0; i < clientIDsToSubscribe.length; i += BATCH_SIZE){
            const batch = clientIDsToSubscribe.slice(i, i + BATCH_SIZE);
            for (const clientID of batch)if (!roomsRef.current.has(clientID) && droneRef.current) {
                const room = droneRef.current.subscribe(clientID);
                roomsRef.current.set(clientID, room);
                room.on('open', (err)=>{
                    if (err) {
                        console.warn(`[Scaledrone] Room ${clientID} open error:`, err);
                        return;
                    }
                // console.log(`[Scaledrone] Room ${clientID} opened successfully`);
                });
                room.on('message', (message)=>{
                    if (workerRef.current) workerRef.current.postMessage({
                        type: 'process',
                        clientID,
                        message
                    });
                });
                room.on('error', (err)=>{
                    console.warn(`[Scaledrone] Room ${clientID} error:`, err);
                });
                subscribed++;
            }
            setSubscriptionProgress({
                subscribed,
                total
            });
            if (i + BATCH_SIZE < clientIDsToSubscribe.length) await new Promise((resolve)=>setTimeout(resolve, DELAY_BETWEEN_BATCHES_MS));
        }
        // Clear progress after a short delay
        setTimeout(()=>setSubscriptionProgress(null), 2000);
        subscriptionInProgressRef.current = false;
    }, []);
    // Fetch clients on auth
    (0, _react.useEffect)(()=>{
        if (isLoading || !isAuthenticated) return;
        const loadClients = async ()=>{
            try {
                const token = await getAccessTokenSilently();
                await fetchClients(token, logout);
            } catch (err) {
                if ((0, _apiError.isLoginRequiredError)(err)) {
                    // Session expired - clear stale auth state and redirect to login.
                    // returnTo prevents Auth0 falling back to the dev Allowed Logout URL.
                    logout({
                        logoutParams: {
                            returnTo: window.location.origin
                        }
                    });
                    return;
                }
                console.warn('[ScaledroneProvider] Error fetching clients:', err);
            }
        };
        if (clients.length === 0) loadClients();
    }, [
        isLoading,
        isAuthenticated,
        clients.length,
        fetchClients,
        getAccessTokenSilently
    ]);
    // Initialize Scaledrone connection (only once)
    (0, _react.useEffect)(()=>{
        const enabled = activeClientIDs.length > 0;
        let didInitialize = false;
        if (!enabled) return;
        // Safety checks
        if (droneRef.current) {
            const state = droneRef.current.readyState;
            if (state === 0 || state === 1) return;
        }
        if (isInitializingRef.current) return;
        if (circuitBreakerTrippedRef.current) {
            setStatus('error');
            setError('Circuit breaker tripped - connection disabled');
            return;
        }
        if (connectionAttemptsRef.current >= MAX_CONNECTION_ATTEMPTS) {
            circuitBreakerTrippedRef.current = true;
            setStatus('error');
            setError('Max connection attempts reached');
            return;
        }
        if (!(0, _config.SCALEDRONE_CHANNEL_ID)) {
            setStatus('error');
            setError('Scaledrone channel ID not configured');
            return;
        }
        if (typeof window.Scaledrone === 'undefined') {
            setStatus('error');
            setError('Scaledrone SDK not loaded');
            return;
        }
        if (droneRef.current || workerRef.current) return;
        // Initialize
        didInitialize = true;
        hasInitializedRef.current = true;
        connectionAttemptsRef.current += 1;
        isInitializingRef.current = true;
        // Apply test mode limit
        const testClientIDs = (0, _config.SCALEDRONE_TEST_MODE_MAX_CLIENTS) > 0 ? activeClientIDs.slice(0, (0, _config.SCALEDRONE_TEST_MODE_MAX_CLIENTS)) : activeClientIDs;
        // Create worker
        const worker = new Worker(require("2384eec00db3f196"));
        workerRef.current = worker;
        worker.onmessage = (event)=>{
            // Use ref to always call the latest processWorkerMessage
            processWorkerMessageRef.current?.(event.data);
        };
        worker.onerror = (workerError)=>{
            console.warn('[Scaledrone] Worker error:', workerError);
        };
        // Connection timeout
        connectionTimeoutRef.current = setTimeout(()=>{
            if (!droneRef.current || droneRef.current.readyState !== 1) {
                circuitBreakerTrippedRef.current = true;
                isInitializingRef.current = false;
                setStatus('error');
                setError('Connection timeout');
                if (workerRef.current) {
                    workerRef.current.terminate();
                    workerRef.current = null;
                }
                if (droneRef.current) {
                    droneRef.current.close();
                    droneRef.current = null;
                }
            }
        }, CONNECTION_TIMEOUT_MS);
        setStatus('connecting');
        const drone = new window.Scaledrone((0, _config.SCALEDRONE_CHANNEL_ID));
        droneRef.current = drone;
        drone.on('open', async (openError)=>{
            if (connectionTimeoutRef.current) {
                clearTimeout(connectionTimeoutRef.current);
                connectionTimeoutRef.current = null;
            }
            if (openError) {
                console.warn('[Scaledrone] Connection open error:', openError);
                isInitializingRef.current = false;
                if (connectionAttemptsRef.current >= CIRCUIT_BREAKER_THRESHOLD) circuitBreakerTrippedRef.current = true;
                setStatus('error');
                setError(openError.message);
                return;
            }
            console.log('[Scaledrone] Connection opened, subscribing to rooms...');
            isInitializingRef.current = false;
            setStatus('connected');
            const roomsToSubscribe = testClientIDs.filter((id)=>!roomsRef.current.has(id));
            if (roomsToSubscribe.length > 0) await subscribeToBatch(roomsToSubscribe);
        });
        drone.on('error', (droneError)=>{
            isInitializingRef.current = false;
            if (connectionAttemptsRef.current >= CIRCUIT_BREAKER_THRESHOLD) circuitBreakerTrippedRef.current = true;
            setStatus('error');
            setError(droneError.message);
        });
        drone.on('disconnect', ()=>{
            setStatus('disconnected');
        });
        drone.on('reconnect', async ()=>{
            setStatus('connected');
            const currentRooms = Array.from(roomsRef.current.keys());
            for (const clientID of testClientIDs)currentRooms.includes(clientID);
        });
        // Cleanup
        return ()=>{
            if (connectionTimeoutRef.current) {
                clearTimeout(connectionTimeoutRef.current);
                connectionTimeoutRef.current = null;
            }
            if (droneRef.current) {
                const state = droneRef.current.readyState;
                if ((state === 0 || state === 1 || state === 2) && !intentionalCloseRef.current) return;
            }
            if (!didInitialize) return;
            intentionalCloseRef.current = true;
            if (workerRef.current) workerRef.current.postMessage({
                type: 'flush'
            });
            for (const [, room] of roomsRef.current)try {
                room.unsubscribe();
            } catch (e) {
                console.warn('[Scaledrone] Error unsubscribing from room:', e);
            }
            if (drone) try {
                drone.close();
            } catch (e) {
                console.warn('[Scaledrone] Error closing connection:', e);
            }
            if (workerRef.current) try {
                workerRef.current.terminate();
            } catch (e) {
                console.warn('[Scaledrone] Error terminating worker:', e);
            }
            workerRef.current = null;
            droneRef.current = null;
            roomsRef.current.clear();
            isInitializingRef.current = false;
            intentionalCloseRef.current = false;
            hasInitializedRef.current = false;
        };
    }, [
        activeClientIDs,
        processWorkerMessage,
        subscribeToBatch
    ]);
    // Handle clientID changes (add/remove subscriptions)
    (0, _react.useEffect)(()=>{
        if (!droneRef.current || activeClientIDs.length === 0) return;
        const allowedClientIDs = (0, _config.SCALEDRONE_TEST_MODE_MAX_CLIENTS) > 0 ? activeClientIDs.slice(0, (0, _config.SCALEDRONE_TEST_MODE_MAX_CLIENTS)) : activeClientIDs;
        const currentClients = new Set(roomsRef.current.keys());
        const newClients = new Set(allowedClientIDs);
        // Subscribe to new clients
        for (const clientID of newClients)if (!currentClients.has(clientID)) {
            const room = droneRef.current.subscribe(clientID);
            roomsRef.current.set(clientID, room);
            room.on('open', (err)=>{
                if (err) {
                    console.warn(`[Scaledrone] Room ${clientID} open error:`, err);
                    return;
                }
            // console.log(`[Scaledrone] Room ${clientID} opened successfully`);
            });
            room.on('message', (message)=>{
                if (workerRef.current) workerRef.current.postMessage({
                    type: 'process',
                    clientID,
                    message
                });
            });
            room.on('error', (err)=>{
                console.warn(`[Scaledrone] Room ${clientID} error:`, err);
            });
        }
        // Unsubscribe from removed clients
        for (const clientID of currentClients)if (!newClients.has(clientID)) {
            const room = roomsRef.current.get(clientID);
            if (room) {
                room.unsubscribe();
                roomsRef.current.delete(clientID);
            }
        }
    }, [
        activeClientIDs
    ]);
    const contextValue = (0, _react.useMemo)(()=>({
            status,
            error,
            subscriptionProgress
        }), [
        status,
        error,
        subscriptionProgress
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ScaledroneContext.Provider, {
        value: contextValue,
        children: children
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@/client/config":"8SWgh","@/client/store/transcodeJobsStore":"c7Bdn","@/client/store/liveStreamsStore":"7F9wp","@/client/store/clientsStore":"6bg3l","@/client/store/encoderWSSStore":"jpzNm","@auth0/auth0-react":"gpXrE","@/client/components/flapping-toast":"9xDtD","@shared/config/scaledrone":"6lR2X","@/client/lib/apiError":"aL0RR","2384eec00db3f196":"iuAQl","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"c7Bdn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTranscodeJobsStore", ()=>useTranscodeJobsStore);
/**
 * Selector to get all jobs combined (processing + failed + success)
 * Use this if you need the legacy flat array of all jobs
 */ parcelHelpers.export(exports, "useAllTranscodeJobs", ()=>useAllTranscodeJobs);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
var _config = require("@/client/config");
var _apiError = require("@/client/lib/apiError");
var _types = require("@shared/types");
const useTranscodeJobsStore = (0, _zustand.create)()((0, _middleware.devtools)((set, get)=>({
        // Initial state
        processing: new Map(),
        assetToJobID: new Map(),
        failed: [],
        success: [],
        successPaginated: {
            jobs: [],
            page: 1,
            totalCount: 0,
            totalPages: 0,
            loading: false
        },
        stallConfig: (0, _types.DEFAULT_STALL_CONFIG),
        lastFetched: null,
        lastMeta: null,
        loading: false,
        error: null,
        fetchJobs: async (accessToken, logout, filters)=>{
            set({
                loading: true,
                error: null
            });
            try {
                const params = new URLSearchParams();
                if (filters?.clientID) params.set('clientID', filters.clientID);
                if (filters?.status) params.set('status', filters.status);
                if (filters?.startDate) params.set('startDate', filters.startDate);
                if (filters?.endDate) params.set('endDate', filters.endDate);
                if (filters?.limit) params.set('limit', filters.limit.toString());
                const url = `${(0, _config.API_BASE_URL)}/api/transcode-jobs${params.toString() ? `?${params}` : ''}`;
                const response = await fetch(url, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.ok) {
                    if ((0, _apiError.handleApiError)(response, logout)) return;
                    throw new Error(`Failed to fetch transcode jobs: ${response.statusText}`);
                }
                const data = await response.json();
                const jobs = data.jobs;
                const meta = data.meta;
                const now = Date.now();
                // Categorize jobs by status
                // Note: API only returns processing and failed jobs by default
                // Success jobs come only from WSS (processing -> success transitions)
                const newProcessing = new Map();
                const newAssetToJobID = new Map();
                const newFailed = [];
                for (const job of jobs){
                    if (job.status === 'processing') {
                        const tracked = (0, _types.createTrackedJob)(job, now);
                        newProcessing.set(job.id, tracked);
                        if (job.assetID) newAssetToJobID.set(job.assetID, job.id);
                    } else if (job.status === 'failed') newFailed.push(job);
                }
                set({
                    processing: newProcessing,
                    assetToJobID: newAssetToJobID,
                    failed: newFailed,
                    // Keep existing success jobs (from WSS) - don't overwrite
                    loading: false,
                    lastFetched: now,
                    lastMeta: meta
                });
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
                set({
                    error: errorMessage,
                    loading: false
                });
            }
        },
        /**
       * Fetch paginated success jobs from the API
       * This fetches historical success jobs, separate from WSS live completions
       */ fetchSuccessJobs: async (accessToken, logout, page = 1, filters)=>{
            set((state)=>({
                    successPaginated: {
                        ...state.successPaginated,
                        loading: true
                    }
                }));
            try {
                const params = new URLSearchParams();
                params.set('status', 'success');
                params.set('page', page.toString());
                if (filters?.clientID) params.set('clientID', filters.clientID);
                if (filters?.startDate) params.set('startDate', filters.startDate);
                if (filters?.endDate) params.set('endDate', filters.endDate);
                if (filters?.limit) params.set('limit', filters.limit.toString());
                const url = `${(0, _config.API_BASE_URL)}/api/transcode-jobs?${params}`;
                const response = await fetch(url, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.ok) {
                    if ((0, _apiError.handleApiError)(response, logout)) return;
                    throw new Error(`Failed to fetch success jobs: ${response.statusText}`);
                }
                const data = await response.json();
                const jobs = data.jobs;
                const meta = data.meta;
                set({
                    successPaginated: {
                        jobs,
                        page: meta.page ?? 1,
                        totalCount: meta.totalCount ?? jobs.length,
                        totalPages: meta.totalPages ?? 1,
                        loading: false
                    }
                });
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
                set((state)=>({
                        error: errorMessage,
                        successPaginated: {
                            ...state.successPaginated,
                            loading: false
                        }
                    }));
            }
        },
        /**
       * Update job from WebSocket message
       * Handles start, processing, and complete message types
       */ updateJobFromWSS: (jobID, assetID, eventID, clientID, progress, status, raw)=>{
            set((state)=>{
                const now = Date.now();
                const newProcessing = new Map(state.processing);
                const newAssetToJobID = new Map(state.assetToJobID);
                let newFailed = state.failed;
                let newSuccess = state.success;
                // Handle completion (status === 'success')
                if (status === 'success') {
                    // Find job by assetID correlation (complete messages don't have jobID)
                    const correlatedJobID = assetID ? newAssetToJobID.get(assetID) : undefined;
                    const actualJobID = correlatedJobID || jobID;
                    const existingJob = newProcessing.get(actualJobID);
                    if (existingJob) {
                        // Move from processing to success
                        newProcessing.delete(actualJobID);
                        if (assetID) newAssetToJobID.delete(assetID);
                        const completedJob = {
                            ...existingJob,
                            progress: 100,
                            status: 'success',
                            updatedAt: new Date().toISOString()
                        };
                        newSuccess = [
                            completedJob,
                            ...newSuccess
                        ];
                    }
                    return {
                        processing: newProcessing,
                        assetToJobID: newAssetToJobID,
                        success: newSuccess
                    };
                }
                // Handle failure
                if (status === 'failed') {
                    const existingJob = newProcessing.get(jobID);
                    if (existingJob) {
                        newProcessing.delete(jobID);
                        if (assetID) newAssetToJobID.delete(assetID);
                        const failedJob = {
                            ...existingJob,
                            progress,
                            status: 'failed',
                            updatedAt: new Date().toISOString()
                        };
                        newFailed = [
                            failedJob,
                            ...newFailed
                        ];
                    }
                    return {
                        processing: newProcessing,
                        assetToJobID: newAssetToJobID,
                        failed: newFailed
                    };
                }
                // Handle processing/start (status === 'processing' or 'start')
                const existingJob = newProcessing.get(jobID);
                if (existingJob) {
                    // Update existing job
                    const progressIncreased = progress > existingJob.lastProgressValue;
                    const updatedJob = {
                        ...existingJob,
                        progress,
                        status: 'processing',
                        lastProgressValue: progress,
                        lastProgressChangeAt: progressIncreased ? now : existingJob.lastProgressChangeAt,
                        stallStatus: 'normal'
                    };
                    updatedJob.stallStatus = (0, _types.detectStallStatus)(updatedJob, now, state.stallConfig);
                    newProcessing.set(jobID, updatedJob);
                } else {
                    // New job from WSS - create minimal tracked job
                    const newJob = {
                        id: jobID,
                        status: 'processing',
                        progress,
                        duration: null,
                        filesize: null,
                        message: null,
                        createdAt: new Date().toISOString(),
                        updatedAt: new Date().toISOString(),
                        assetID: assetID ?? null,
                        clientID,
                        eventID: eventID ?? null,
                        jobType: 'transcode',
                        destBucket: null,
                        destKey: null,
                        srcBucket: null,
                        srcKey: null,
                        thumbnails: null,
                        playlist: null,
                        lastProgressValue: progress,
                        lastProgressChangeAt: now,
                        stallStatus: 'normal'
                    };
                    newProcessing.set(jobID, newJob);
                    if (assetID) newAssetToJobID.set(assetID, jobID);
                }
                return {
                    processing: newProcessing,
                    assetToJobID: newAssetToJobID
                };
            });
        },
        /**
       * Re-evaluate stall status for all processing jobs
       * Should be called on an interval (e.g., every 30 seconds)
       */ reEvaluateStallStatus: ()=>{
            set((state)=>{
                const now = Date.now();
                const newProcessing = new Map();
                let hasChanges = false;
                for (const [jobID, job] of state.processing){
                    const newStallStatus = (0, _types.detectStallStatus)(job, now, state.stallConfig);
                    if (newStallStatus !== job.stallStatus) {
                        hasChanges = true;
                        newProcessing.set(jobID, {
                            ...job,
                            stallStatus: newStallStatus
                        });
                    } else newProcessing.set(jobID, job);
                }
                return hasChanges ? {
                    processing: newProcessing
                } : {};
            });
        },
        setStallConfig: (config)=>{
            set((state)=>({
                    stallConfig: {
                        ...state.stallConfig,
                        ...config
                    }
                }));
        },
        clearJobs: ()=>{
            set({
                processing: new Map(),
                assetToJobID: new Map(),
                failed: [],
                success: [],
                successPaginated: {
                    jobs: [],
                    page: 1,
                    totalCount: 0,
                    totalPages: 0,
                    loading: false
                },
                lastFetched: null,
                lastMeta: null
            });
        },
        // Legacy: updateJobProgress for backward compatibility with existing WSS handler
        updateJobProgress: (jobId, progress, status)=>{
            get().updateJobFromWSS(jobId, undefined, undefined, '', progress, status || 'processing', null);
        }
    }), {
    name: 'transcode-jobs-store'
}));
function useAllTranscodeJobs() {
    const processing = useTranscodeJobsStore((state)=>state.processing);
    const failed = useTranscodeJobsStore((state)=>state.failed);
    const success = useTranscodeJobsStore((state)=>state.success);
    return [
        ...Array.from(processing.values()),
        ...failed,
        ...success
    ];
}

},{"zustand":"Ze5I5","zustand/middleware":"9udS2","@/client/config":"8SWgh","@/client/lib/apiError":"aL0RR","@shared/types":"dzHsw","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"Ze5I5":[function(require,module,exports,__globalThis) {
'use strict';
var vanilla = require("4aa65ed297d182cb");
var react = require("28731c0c3f145069");
Object.keys(vanilla).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function() {
            return vanilla[k];
        }
    });
});
Object.keys(react).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function() {
            return react[k];
        }
    });
});

},{"4aa65ed297d182cb":"3lh9m","28731c0c3f145069":"3vS8n"}],"3lh9m":[function(require,module,exports,__globalThis) {
'use strict';
const createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState,
        getState,
        getInitialState,
        subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const createStore = (createState)=>createState ? createStoreImpl(createState) : createStoreImpl;
exports.createStore = createStore;

},{}],"3vS8n":[function(require,module,exports,__globalThis) {
'use strict';
var React = require("f8623e263fa009cd");
var vanilla = require("7040a5722d47320b");
const identity = (arg)=>arg;
function useStore(api, selector = identity) {
    const slice = React.useSyncExternalStore(api.subscribe, React.useCallback(()=>selector(api.getState()), [
        api,
        selector
    ]), React.useCallback(()=>selector(api.getInitialState()), [
        api,
        selector
    ]));
    React.useDebugValue(slice);
    return slice;
}
const createImpl = (createState)=>{
    const api = vanilla.createStore(createState);
    const useBoundStore = (selector)=>useStore(api, selector);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const create = (createState)=>createState ? createImpl(createState) : createImpl;
exports.create = create;
exports.useStore = useStore;

},{"f8623e263fa009cd":"eGun2","7040a5722d47320b":"3lh9m"}],"9udS2":[function(require,module,exports,__globalThis) {
'use strict';
const reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...args)=>api.dispatch(...args),
            ...initial
        };
    };
const redux = reduxImpl;
const trackedConnections = /* @__PURE__ */ new Map();
const getTrackedConnectionState = (name)=>{
    const api = trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store,
        ...newConnection
    };
};
const removeStoreFromTrackedConnections = (name, store)=>{
    if (store === void 0) return;
    const connectionInfo = trackedConnections.get(name);
    if (!connectionInfo) return;
    delete connectionInfo.stores[store];
    if (Object.keys(connectionInfo.stores).length === 0) trackedConnections.delete(name);
};
const findCallerName = (stack)=>{
    var _a, _b;
    if (!stack) return void 0;
    const traceLines = stack.split("\n");
    const apiSetStateLineIndex = traceLines.findIndex((traceLine)=>traceLine.includes("api.setState"));
    if (apiSetStateLineIndex < 0) return void 0;
    const callerLine = ((_a = traceLines[apiSetStateLineIndex + 1]) == null ? void 0 : _a.trim()) || "";
    return (_b = /.+ (.+) .+/.exec(callerLine)) == null ? void 0 : _b[1];
};
const devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled, anonymousActionType, store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        const { connection, ...connectionInformation } = extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || findCallerName(new Error().stack) || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        api.devtools = {
            cleanup: ()=>{
                if (connection && typeof connection.unsubscribe === "function") connection.unsubscribe();
                removeStoreFromTrackedConnections(options.name, store);
            }
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...args)=>{
                originalDispatch(...args);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init(getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init(getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init(getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const devtools = devtoolsImpl;
const parseJsonThen = (stringified, fn)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) fn(parsed);
};
const subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const subscribeWithSelector = subscribeWithSelectorImpl;
function combine(initialState, create) {
    return (...args)=>Object.assign({}, initialState, create(...args));
}
function createJSONStorage(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return toThenable(onRejected)(e);
                }
            };
        }
    };
const persistImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: createJSONStorage(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            return setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            return setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) {
                            const migration = options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            if (migration instanceof Promise) return migration.then((result)=>[
                                    true,
                                    result
                                ]);
                            return [
                                true,
                                migration
                            ];
                        }
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const persist = persistImpl;
function ssrSafe(config, isSSR = typeof window === "undefined") {
    return (set, get, api)=>{
        if (!isSSR) return config(set, get, api);
        const ssrSet = ()=>{
            throw new Error("Cannot set state of Zustand store in SSR");
        };
        api.setState = ssrSet;
        return config(ssrSet, get, api);
    };
}
exports.combine = combine;
exports.createJSONStorage = createJSONStorage;
exports.devtools = devtools;
exports.persist = persist;
exports.redux = redux;
exports.subscribeWithSelector = subscribeWithSelector;
exports.unstable_ssrSafe = ssrSafe;

},{}],"aL0RR":[function(require,module,exports,__globalThis) {
/**
 * API Error Handling Utilities
 *
 * See docs/conventions.md for usage patterns.
 */ /**
 * The Auth0 logout function. Accepts optional logout params; callers throughout
 * the app pass the raw `useAuth0().logout`, which is why `returnTo` is applied
 * here rather than trusting each call site to set it.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handles API response errors, specifically checking for authentication failures.
 * When a 401 is detected, triggers logout and returns true to signal the caller
 * should stop processing.
 *
 * The logout always sets `returnTo` to the current origin. Without it, Auth0
 * falls back to the first configured Allowed Logout URL (the dev
 * `http://127.0.0.1:3000`), sending prod users to localhost after a forced
 * logout on token expiry.
 *
 * @param response - The fetch Response object
 * @param logout - The Auth0 logout function
 * @returns true if an auth error was handled (caller should bail), false otherwise
 *
 * @example
 * ```typescript
 * const response = await fetch('/api/endpoint', { headers });
 * if (!response.ok) {
 *   if (handleApiError(response, logout)) return;
 *   throw new Error('Request failed');
 * }
 * ```
 */ parcelHelpers.export(exports, "handleApiError", ()=>handleApiError);
/**
 * Checks if an error is an Auth0 "Login required" error.
 * This happens when getAccessTokenSilently() is called but the session
 * has expired or the user isn't authenticated.
 *
 * @param error - The error to check
 * @returns true if this is a login required error
 *
 * @example
 * ```typescript
 * try {
 *   const token = await getAccessTokenSilently();
 * } catch (err) {
 *   if (isLoginRequiredError(err)) {
 *     loginWithRedirect();
 *     return;
 *   }
 *   throw err;
 * }
 * ```
 */ parcelHelpers.export(exports, "isLoginRequiredError", ()=>isLoginRequiredError);
function handleApiError(response, logout) {
    if (response.status === 401) {
        // Token expired or invalid - force re-authentication
        logout({
            logoutParams: {
                returnTo: window.location.origin
            }
        });
        return true;
    }
    return false;
}
function isLoginRequiredError(error) {
    if (error instanceof Error) return error.message.includes('Login required') || error.message.includes('login_required');
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dzHsw":[function(require,module,exports,__globalThis) {
/**
 * Shared Types Index
 * Central export point for all shared types
 */ // NOTE: environment.d.ts and css-modules.d.ts are ambient declarations
// that augment global types. They don't need to be exported - TypeScript
// automatically includes them when they're in the tsconfig include path.
// Generic API Types
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isApiError", ()=>(0, _api.isApiError));
parcelHelpers.export(exports, "EVENT_STATUS_NAMES", ()=>(0, _events.EVENT_STATUS_NAMES));
parcelHelpers.export(exports, "getEventStatusName", ()=>(0, _events.getEventStatusName));
parcelHelpers.export(exports, "ENCODER_CONFIG", ()=>(0, _encoders.ENCODER_CONFIG));
parcelHelpers.export(exports, "LIVE_EVENT_STATUSES", ()=>(0, _websocket.LIVE_EVENT_STATUSES));
parcelHelpers.export(exports, "COMPLETED_EVENT_STATUS", ()=>(0, _websocket.COMPLETED_EVENT_STATUS));
parcelHelpers.export(exports, "NEW_EVENT_STATUS", ()=>(0, _websocket.NEW_EVENT_STATUS));
parcelHelpers.export(exports, "isLiveEventStatus", ()=>(0, _websocket.isLiveEventStatus));
parcelHelpers.export(exports, "isCompletedEventStatus", ()=>(0, _websocket.isCompletedEventStatus));
parcelHelpers.export(exports, "isEventMessage", ()=>(0, _websocket.isEventMessage));
parcelHelpers.export(exports, "TRIAGE_CONFIG", ()=>(0, _triage.TRIAGE_CONFIG));
parcelHelpers.export(exports, "ANOMALY_CONFIG", ()=>(0, _triage.ANOMALY_CONFIG));
parcelHelpers.export(exports, "ALERT_HISTORY_CONFIG", ()=>(0, _triage.ALERT_HISTORY_CONFIG));
parcelHelpers.export(exports, "POLLER_CONFIG", ()=>(0, _poller.POLLER_CONFIG));
parcelHelpers.export(exports, "TRANSCODE_CONFIG", ()=>(0, _transcode.TRANSCODE_CONFIG));
parcelHelpers.export(exports, "DEFAULT_STALL_CONFIG", ()=>(0, _transcode.DEFAULT_STALL_CONFIG));
parcelHelpers.export(exports, "detectStallStatus", ()=>(0, _transcode.detectStallStatus));
parcelHelpers.export(exports, "createTrackedJob", ()=>(0, _transcode.createTrackedJob));
parcelHelpers.export(exports, "FLAPPING_CONFIG", ()=>(0, _flapping.FLAPPING_CONFIG));
parcelHelpers.export(exports, "isDuplicateEvent", ()=>(0, _flapping.isDuplicateEvent));
parcelHelpers.export(exports, "VTT_LONG_LINE_THRESHOLD", ()=>(0, _vtt.VTT_LONG_LINE_THRESHOLD));
parcelHelpers.export(exports, "VTT_WORD_REPETITION_THRESHOLD", ()=>(0, _vtt.VTT_WORD_REPETITION_THRESHOLD));
parcelHelpers.export(exports, "LEAC_ENDED_STATUSES", ()=>(0, _captionJobs.LEAC_ENDED_STATUSES));
parcelHelpers.export(exports, "LEAC_ACTIVE_STATUSES", ()=>(0, _captionJobs.LEAC_ACTIVE_STATUSES));
parcelHelpers.export(exports, "CAPTION_JOBS_CONFIG", ()=>(0, _captionJobs.CAPTION_JOBS_CONFIG));
parcelHelpers.export(exports, "PIPELINE_CONFIG", ()=>(0, _pipeline.PIPELINE_CONFIG));
parcelHelpers.export(exports, "WEBHOOK_LOGS_CONFIG", ()=>(0, _webhookLogs.WEBHOOK_LOGS_CONFIG));
parcelHelpers.export(exports, "WEBHOOK_LOG_RANGES", ()=>(0, _webhookLogs.WEBHOOK_LOG_RANGES));
var _api = require("./api");
var _events = require("./events");
var _encoders = require("./encoders");
var _websocket = require("./websocket");
// Auth Types
var _auth = require("./auth");
parcelHelpers.exportAll(_auth, exports);
var _triage = require("./triage");
var _poller = require("./poller");
var _transcode = require("./transcode");
var _flapping = require("./flapping");
var _vtt = require("./vtt");
var _captionJobs = require("./captionJobs");
var _pipeline = require("./pipeline");
var _webhookLogs = require("./webhookLogs");

},{"./api":"7qRcd","./events":"d1idH","./encoders":"2E2xF","./websocket":"4cJ7h","./auth":"gSb0E","./triage":"5wweP","./poller":"hNrej","./transcode":"dqlRx","./flapping":"4gK9D","./vtt":"g6yDs","./captionJobs":"1j7E5","./pipeline":"tqSoe","./webhookLogs":"6kaS8","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7qRcd":[function(require,module,exports,__globalThis) {
/**
 * Generic API Types
 * Common types for API request/response handling
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Type guard for error responses
parcelHelpers.export(exports, "isApiError", ()=>isApiError);
function isApiError(response) {
    return response && response.status === 'error' && typeof response.message === 'string';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"d1idH":[function(require,module,exports,__globalThis) {
/**
 * Event and Stream Types
 * Types for events, live streams, and upcoming streams
 */ // ============================================================================
// Event Status
// ============================================================================
/**
 * Event status code to name mapping
 * Used across the application for displaying event states
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EVENT_STATUS_NAMES", ()=>EVENT_STATUS_NAMES);
/**
 * Get event status name from numeric code
 */ parcelHelpers.export(exports, "getEventStatusName", ()=>getEventStatusName);
const EVENT_STATUS_NAMES = {
    1: 'new',
    2: 'live',
    3: 'on break',
    4: 'available',
    5: 'editing',
    6: 'publishing',
    7: 'published',
    8: 'starting',
    9: 'disconnected',
    10: 'unpublishing',
    12: 'stopping'
};
function getEventStatusName(statusCode) {
    return EVENT_STATUS_NAMES[statusCode] ?? 'unknown';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2E2xF":[function(require,module,exports,__globalThis) {
/**
 * Encoder Types
 * Types for encoders, persistent streams, and probe results
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENCODER_CONFIG", ()=>ENCODER_CONFIG);
const ENCODER_CONFIG = {
    /** Time since lastCommunication before showing warning state (1 hour) */ STALE_WARNING_MS: 3600000,
    /** Time since lastCommunication before showing stale/alert state (24 hours) */ STALE_ALERT_MS: 86400000
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4cJ7h":[function(require,module,exports,__globalThis) {
/**
 * WebSocket Message Types
 * Structures for real-time data received via Scaledrone WebSocket
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LIVE_EVENT_STATUSES", ()=>LIVE_EVENT_STATUSES);
parcelHelpers.export(exports, "COMPLETED_EVENT_STATUS", ()=>COMPLETED_EVENT_STATUS);
parcelHelpers.export(exports, "NEW_EVENT_STATUS", ()=>NEW_EVENT_STATUS);
/**
 * Type guard to check if event status is "live"
 */ parcelHelpers.export(exports, "isLiveEventStatus", ()=>isLiveEventStatus);
/**
 * Type guard to check if event status is "completed"
 */ parcelHelpers.export(exports, "isCompletedEventStatus", ()=>isCompletedEventStatus);
/**
 * Type guard to check if message is an event status message
 */ parcelHelpers.export(exports, "isEventMessage", ()=>isEventMessage);
const LIVE_EVENT_STATUSES = [
    'starting',
    'live',
    'on break',
    'stopping',
    'disconnected'
];
const COMPLETED_EVENT_STATUS = 'available';
const NEW_EVENT_STATUS = 'new';
function isLiveEventStatus(status) {
    return LIVE_EVENT_STATUSES.includes(status);
}
function isCompletedEventStatus(status) {
    return status === COMPLETED_EVENT_STATUS;
}
function isEventMessage(message) {
    return message?.message?.action?.method === 'events' && message?.message?.data?.eventID && message?.message?.data?.eventStatus;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gSb0E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5wweP":[function(require,module,exports,__globalThis) {
/**
 * Shared Triage Types
 *
 * Types shared between client and server for encoder triage system.
 */ // ============================================================================
// Encoder Sample Data (from polling source)
// ============================================================================
/** 
 * @description
 * Raw encoder data as received from the polling source - matches prod JSON schema
 * 
 * @property {number} height
 * @property {number} width
 * @property {number} bitrate - Video bitrate in bits/sec
 * @property {string} real_frame_rate - Fractional notation e.g. "30/1"
 * @property {string} displayAspectRatio
 * @property {string[]} dimensions - Available transcode dimensions
 * @property {boolean} inputHasCaptions
 * @property {string} streamName
 * @property {string} thumbnailUrl
 * @property {string} timestamp - ISO 8601 timestamp from encoder
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRIAGE_CONFIG", ()=>TRIAGE_CONFIG);
parcelHelpers.export(exports, "ALERT_HISTORY_CONFIG", ()=>ALERT_HISTORY_CONFIG);
parcelHelpers.export(exports, "ANOMALY_CONFIG", ()=>ANOMALY_CONFIG);
const TRIAGE_CONFIG = {
    /** Maximum time a triage session can exist (14 days in ms) */ MAX_LIFETIME_MS: 1209600000,
    /** Auto-expire triage sessions untouched for this duration (7 days in ms) */ INACTIVITY_EXPIRY_MS: 604800000,
    /** Maximum samples to store per encoder in triage mode */ MAX_SAMPLES_PER_ENCODER: 600,
    /** How long to retain ended sessions before deletion (24 hours in ms) */ ENDED_SESSION_RETENTION_MS: 86400000
};
const ALERT_HISTORY_CONFIG = {
    /** How long to keep alert history (12 hours in ms) */ RETENTION_MS: 43200000,
    /** How often to run cleanup (1 hour in ms) */ CLEANUP_INTERVAL_MS: 3600000
};
const ANOMALY_CONFIG = {
    /** Minimum samples required before anomaly detection is active */ MIN_SAMPLES_FOR_BASELINE: 3,
    /** Bitrate thresholds */ BITRATE_MAX_BYTES: 5000000,
    BITRATE_DROP_THRESHOLD: 0.5,
    /** Coefficient of Variation threshold for "unstable" */ CV_UNSTABLE_THRESHOLD: 0.35,
    // ============================================================================
    // Persistent Stream (Linear) Relaxed Thresholds
    // VBR-encoded 24/7 channels naturally fluctuate between content tiers
    // (e.g., 1.2 Mbps for static content, 3.5 Mbps for motion content)
    // ============================================================================
    /** CV threshold for persistent streams - allows normal VBR variance */ PERSISTENT_CV_UNSTABLE_THRESHOLD: 0.75,
    /** Absolute minimum bitrate floor for persistent streams (1 Mbps) */ PERSISTENT_BITRATE_FLOOR: 1000000,
    /** Consecutive samples required for warning alerts */ CONSECUTIVE_SAMPLES_WARNING: 4,
    /** Alert types and their severity/consecutive requirements */ ALERT_CONFIG: {
        offline: {
            severity: 'critical',
            consecutive: 1
        },
        zero_bitrate: {
            severity: 'critical',
            consecutive: 1
        },
        bitrate_too_high: {
            severity: 'critical',
            consecutive: 1
        },
        bitrate_drop: {
            severity: 'warning',
            consecutive: 4
        },
        bitrate_unstable: {
            severity: 'warning',
            consecutive: 4
        },
        persistent_bitrate_floor: {
            severity: 'warning',
            consecutive: 5
        },
        frame_rate_drop: {
            severity: 'warning',
            consecutive: 4
        },
        resolution_change: {
            severity: 'info',
            consecutive: 1
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hNrej":[function(require,module,exports,__globalThis) {
/**
 * Shared types for encoder poller worker thread
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "POLLER_CONFIG", ()=>POLLER_CONFIG);
const POLLER_CONFIG = {
    /** Encoders that haven't communicated in this many days are considered stale */ STALE_ENCODER_DAYS: 7
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dqlRx":[function(require,module,exports,__globalThis) {
/**
 * Transcode Job Types
 * Shared types for transcode job monitoring between client and server
 */ // === Base Types ===
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRANSCODE_CONFIG", ()=>TRANSCODE_CONFIG);
parcelHelpers.export(exports, "DEFAULT_STALL_CONFIG", ()=>DEFAULT_STALL_CONFIG);
// === Utility Functions ===
parcelHelpers.export(exports, "detectStallStatus", ()=>detectStallStatus);
parcelHelpers.export(exports, "createTrackedJob", ()=>createTrackedJob);
const TRANSCODE_CONFIG = {
    /** Maximum date range for transcode job queries (days) */ MAX_DATE_RANGE_DAYS: 90,
    /** Interval for re-evaluating stall status on client (ms) */ STALL_CHECK_INTERVAL_MS: 30000
};
const DEFAULT_STALL_CONFIG = {
    stallThresholdMs: 300000,
    silentFailureThresholdMs: 600000
};
function detectStallStatus(job, now, config) {
    if (job.status !== 'processing') return 'normal';
    const timeSinceChange = now - job.lastProgressChangeAt;
    // Silent failure: stuck at 100% waiting for final status
    if (job.progress === 100) return timeSinceChange > config.silentFailureThresholdMs ? 'silent-failure' : 'normal';
    // Progress stall: no progress increase for threshold period
    return timeSinceChange > config.stallThresholdMs ? 'stalled' : 'normal';
}
function createTrackedJob(job, now) {
    return {
        ...job,
        lastProgressValue: job.progress ?? 0,
        lastProgressChangeAt: now,
        stallStatus: 'normal'
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4gK9D":[function(require,module,exports,__globalThis) {
/**
 * Shared Flapping Types
 *
 * Types for server-side encoder flapping detection and persistence.
 */ // ============================================================================
// Configuration
// ============================================================================
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FLAPPING_CONFIG", ()=>FLAPPING_CONFIG);
// ============================================================================
// Utilities
// ============================================================================
/**
 * Check if an event should be considered a duplicate and skipped.
 * Returns true if the event is the same type as the last event and within DEDUP_WINDOW_MS.
 * Upstream (encoder/backend) sometimes sends multiple disconnect events in quick succession.
 */ parcelHelpers.export(exports, "isDuplicateEvent", ()=>isDuplicateEvent);
const FLAPPING_CONFIG = {
    /** Detection window in ms (60 seconds) */ WINDOW_MS: 60000,
    /** Number of cycles to trigger warning state */ WARNING_CYCLES: 2,
    /** Number of cycles to trigger alert state */ ALERT_CYCLES: 3,
    /** Auto-resolve after this duration of stability (10 minutes) */ RESOLVE_AFTER_MS: 600000,
    /** How long to keep flapping history in SQLite (1 hour) */ HISTORY_RETENTION_MS: 3600000,
    /** How often to run cleanup (5 minutes) */ CLEANUP_INTERVAL_MS: 300000,
    /** How often to check for auto-resolution (60 seconds) */ RESOLUTION_CHECK_INTERVAL_MS: 60000,
    /** Deduplication window for same-type events (ms)
   * Upstream sometimes sends multiple disconnect events in quick succession.
   * Observed gaps: 893ms, 1151ms - using 1500ms for safety margin */ DEDUP_WINDOW_MS: 1500
};
function isDuplicateEvent(eventType, eventTimestamp, lastEvent) {
    if (!lastEvent) return false;
    if (lastEvent.type !== eventType) return false;
    // Use absolute value to handle out-of-order events
    // (events may arrive with timestamps slightly out of order)
    const timeDiff = Math.abs(eventTimestamp - lastEvent.timestamp);
    return timeDiff < FLAPPING_CONFIG.DEDUP_WINDOW_MS;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"g6yDs":[function(require,module,exports,__globalThis) {
/**
 * VTT Analysis Types
 * Types for analyzing WebVTT caption files for gaps and issues
 */ /** Threshold for flagging long caption lines (chars) */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VTT_LONG_LINE_THRESHOLD", ()=>VTT_LONG_LINE_THRESHOLD);
parcelHelpers.export(exports, "VTT_WORD_REPETITION_THRESHOLD", ()=>VTT_WORD_REPETITION_THRESHOLD);
const VTT_LONG_LINE_THRESHOLD = 100;
const VTT_WORD_REPETITION_THRESHOLD = 10;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1j7E5":[function(require,module,exports,__globalThis) {
/**
 * Live Caption Job Monitoring Types
 * Shared between client and server for type-safe API contracts
 */ // ============================================================================
// Caption Job Status
// ============================================================================
/** Possible caption statuses derived from pipeline analysis */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LEAC_ENDED_STATUSES", ()=>LEAC_ENDED_STATUSES);
parcelHelpers.export(exports, "LEAC_ACTIVE_STATUSES", ()=>LEAC_ACTIVE_STATUSES);
parcelHelpers.export(exports, "CAPTION_JOBS_CONFIG", ()=>CAPTION_JOBS_CONFIG);
const LEAC_ENDED_STATUSES = [
    'ended',
    'end',
    'End of Transcribe'
];
const LEAC_ACTIVE_STATUSES = [
    'starting',
    'live',
    'running'
];
const CAPTION_JOBS_CONFIG = {
    DEFAULT_PAGE: 1,
    DEFAULT_LIMIT: 25,
    MAX_LIMIT: 100,
    MAX_DATE_RANGE_DAYS: 90,
    /** Default lookback in hours when no date range specified */ DEFAULT_LOOKBACK_HOURS: 72
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"tqSoe":[function(require,module,exports,__globalThis) {
/**
 * Pipeline Message Log Types
 * Types for the msglog audit/debugging tool
 */ // Search type options for the pipeline logs endpoint
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PIPELINE_CONFIG", ()=>PIPELINE_CONFIG);
const PIPELINE_CONFIG = {
    // Maximum time window for queries (2191 hours = ~3 months)
    MAX_WINDOW_HOURS: 2191,
    // Default result limit (reduced from 500 for faster queries)
    DEFAULT_LIMIT: 50,
    // Maximum result limit (reduced from 2000 for faster queries)
    MAX_LIMIT: 200,
    // Log type priority order (for sorting)
    LOG_TYPE_PRIORITY: {
        critical: 0,
        error: 1,
        warning: 2,
        info: 3,
        debug: 4
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6kaS8":[function(require,module,exports,__globalThis) {
/**
 * Webhook Log Monitoring Types
 * Shared between client and server for type-safe API contracts
 *
 * Backed by the `webhookLog` table. The table's own `status` column is disused
 * (always NULL in practice), so status is derived from `returnValue`:
 * anything starting with "Error:" is a failure, everything else is a success.
 */ // ============================================================================
// Webhook Log Status
// ============================================================================
/** Derived delivery status for a webhook log entry */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WEBHOOK_LOG_RANGES", ()=>WEBHOOK_LOG_RANGES);
parcelHelpers.export(exports, "WEBHOOK_LOGS_CONFIG", ()=>WEBHOOK_LOGS_CONFIG);
const WEBHOOK_LOG_RANGES = [
    {
        label: '24h',
        hours: 24
    },
    {
        label: '48h',
        hours: 48
    },
    {
        label: '72h',
        hours: 72
    },
    {
        label: '1 week',
        hours: 168
    },
    {
        label: '2 weeks',
        hours: 336
    },
    {
        label: '1 month',
        hours: 720
    }
];
const WEBHOOK_LOGS_CONFIG = {
    DEFAULT_PAGE: 1,
    DEFAULT_LIMIT: 50,
    MAX_LIMIT: 100,
    /** Default lookback in hours when none specified */ DEFAULT_LOOKBACK_HOURS: 24,
    /** Hard ceiling on the lookback window */ MAX_LOOKBACK_HOURS: 720,
    /** Characters of each payload returned in list responses */ PREVIEW_LENGTH: 1000,
    /** Cache TTL for list responses (ms) */ CACHE_TTL_MS: 60000
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7F9wp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLiveStreamsStore", ()=>useLiveStreamsStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
var _types = require("@shared/types");
var _config = require("@/client/config");
var _apiError = require("@/client/lib/apiError");
const useLiveStreamsStore = (0, _zustand.create)()((0, _middleware.devtools)((set, get)=>({
        // Initial state
        liveStreams: [],
        liveEvents: [],
        completedEvents: [],
        eventMap: new Map(),
        loading: false,
        error: null,
        // Legacy setters
        setLiveStreams: (liveStreams)=>set({
                liveStreams,
                error: null
            }),
        setLoading: (loading)=>set({
                loading
            }),
        setError: (error)=>set({
                error
            }),
        // Fetch live streams from API (used for initial page load)
        // Note: API returns LiveStreamWithEventResponse[], which is different from WebSocketEventData
        // For now, we just populate the legacy liveStreams field
        // The WebSocket will handle populating liveEvents with full event data
        fetchLiveStreams: async (accessToken, logout)=>{
            set({
                loading: true,
                error: null
            });
            try {
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/live-streams`, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.ok) {
                    if ((0, _apiError.handleApiError)(response, logout)) return;
                    throw new Error(`Failed to fetch live streams: ${response.statusText}`);
                }
                const data = await response.json();
                // Store legacy API data
                set({
                    liveStreams: data.liveStreams,
                    loading: false
                });
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
                set({
                    error: errorMessage,
                    loading: false
                });
            }
        },
        /**
   * Update event status from WebSocket message
   * Handles the full event lifecycle and movement between sections
   */ updateEventStatus: (eventData)=>{
            set((state)=>{
                const { eventID, eventStatus } = eventData;
                // Create new eventMap to update immutably
                const newEventMap = new Map(state.eventMap);
                if ((0, _types.isLiveEventStatus)(eventStatus)) {
                    // Event is live (starting, live, on break, stopping)
                    // Track this event as having been live
                    newEventMap.set(eventID, eventData);
                    // Check if event is in completedEvents - if so, move it to liveEvents
                    const inCompleted = state.completedEvents.some((e)=>e.eventID === eventID);
                    if (inCompleted) // Re-streaming: move from completed back to live
                    return {
                        ...state,
                        liveEvents: [
                            ...state.liveEvents,
                            eventData
                        ],
                        completedEvents: state.completedEvents.filter((e)=>e.eventID !== eventID),
                        eventMap: newEventMap
                    };
                    else {
                        // Check if event already exists in liveEvents - update in place
                        const existingIndex = state.liveEvents.findIndex((e)=>e.eventID === eventID);
                        if (existingIndex >= 0) {
                            // Update existing live event in place
                            const newLiveEvents = [
                                ...state.liveEvents
                            ];
                            newLiveEvents[existingIndex] = eventData;
                            return {
                                ...state,
                                liveEvents: newLiveEvents,
                                eventMap: newEventMap
                            };
                        } else // New event going live
                        return {
                            ...state,
                            liveEvents: [
                                ...state.liveEvents,
                                eventData
                            ],
                            eventMap: newEventMap
                        };
                    }
                } else if ((0, _types.isCompletedEventStatus)(eventStatus)) {
                    // Event is now "available"
                    // Only track if event was previously live (in eventMap or liveEvents)
                    const wasLive = state.eventMap.has(eventID) || state.liveEvents.some((e)=>e.eventID === eventID);
                    if (wasLive) {
                        // Track in eventMap for re-streaming support
                        newEventMap.set(eventID, eventData);
                        // Move from liveEvents to completedEvents
                        const newLiveEvents = state.liveEvents.filter((e)=>e.eventID !== eventID);
                        return {
                            ...state,
                            liveEvents: newLiveEvents,
                            completedEvents: [
                                ...state.completedEvents.filter((e)=>e.eventID !== eventID),
                                eventData
                            ],
                            eventMap: newEventMap
                        };
                    } else // Don't track - this was likely a VOD upload that never streamed
                    return state;
                } else {
                    // Other status (e.g., "new", "scheduled", "cancelled")
                    // Only update if we're already tracking this event
                    if (state.eventMap.has(eventID)) {
                        newEventMap.set(eventID, eventData);
                        return {
                            ...state,
                            eventMap: newEventMap
                        };
                    } else // Not tracking this event
                    return state;
                }
            });
        },
        /**
   * Check if an event has ever been live (for determining if we should track it)
   */ hasEverBeenLive: (eventID)=>{
            return get().eventMap.has(eventID);
        }
    }), {
    name: 'live-streams-store'
}));

},{"zustand":"Ze5I5","zustand/middleware":"9udS2","@shared/types":"dzHsw","@/client/config":"8SWgh","@/client/lib/apiError":"aL0RR","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6bg3l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useClientsStore", ()=>useClientsStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
var _config = require("@/client/config");
var _apiError = require("@/client/lib/apiError");
const useClientsStore = (0, _zustand.create)()((0, _middleware.devtools)((set, get)=>({
        clients: [],
        loading: false,
        error: null,
        lastFetched: null,
        cacheInfo: null,
        setClients: (clients)=>set({
                clients,
                error: null
            }),
        setLoading: (loading)=>set({
                loading
            }),
        setError: (error)=>set({
                error
            }),
        fetchClients: async (accessToken, logout, forceRefresh = false)=>{
            const state = get();
            // If we have cached data and not forcing refresh, skip the fetch
            if (!forceRefresh && state.clients.length > 0 && state.lastFetched) return;
            set({
                loading: true,
                error: null
            });
            try {
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/clients`, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.ok) {
                    if ((0, _apiError.handleApiError)(response, logout)) return;
                    throw new Error(`Failed to fetch clients: ${response.statusText}`);
                }
                const data = await response.json();
                set({
                    clients: data.clients,
                    loading: false,
                    lastFetched: Date.now(),
                    cacheInfo: data.cacheInfo ?? null
                });
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
                set({
                    error: errorMessage,
                    loading: false
                });
            }
        }
    }), {
    name: 'clients-store'
}));

},{"zustand":"Ze5I5","zustand/middleware":"9udS2","@/client/config":"8SWgh","@/client/lib/apiError":"aL0RR","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jpzNm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEncoderWSSStore", ()=>useEncoderWSSStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
var _types = require("@shared/types");
// localStorage persistence for encoder online/offline status
const STORAGE_KEY = 'admin-portal:encoder-wss-status';
const STATUS_TTL_MS = 600000; // 10 minutes - stale data is discarded
function loadPersistedStatus() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) return new Map();
        const parsed = JSON.parse(stored);
        const now = Date.now();
        const result = new Map();
        // Filter out stale entries
        for (const entry of parsed)if (now - entry.lastUpdated < STATUS_TTL_MS) result.set(entry.encoderID, entry);
        return result;
    } catch  {
        return new Map();
    }
}
function savePersistedStatus(encoders) {
    try {
        const toSave = [];
        for (const record of encoders.values())toSave.push({
            encoderID: record.encoderID,
            simpleName: record.simpleName,
            clientID: record.clientID,
            online: record.online,
            streamInfo: record.streamInfo,
            lastUpdated: record.lastUpdated
        });
        localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave));
    } catch  {
    // Ignore localStorage errors (quota, private browsing, etc.)
    }
}
// Initialize encoders map from localStorage
function initializeEncoders() {
    const persisted = loadPersistedStatus();
    const encoders = new Map();
    for (const [id, status] of persisted)encoders.set(id, {
        encoderID: status.encoderID,
        simpleName: status.simpleName,
        clientID: status.clientID,
        online: status.online,
        streamInfo: status.streamInfo,
        events: [],
        state: 'normal',
        attachedToLiveStream: false,
        lastUpdated: status.lastUpdated
    });
    return encoders;
}
const useEncoderWSSStore = (0, _zustand.create)()((0, _middleware.devtools)((set, get)=>({
        encoders: initializeEncoders(),
        processEvent: (event)=>{
            let newState = 'normal';
            set((state)=>{
                const encoders = new Map(state.encoders);
                const existing = encoders.get(event.encoderID);
                const now = event.timestamp;
                const lastEvent = existing?.events[existing.events.length - 1];
                // Deduplication: skip if same event type within DEDUP_WINDOW_MS
                if ((0, _types.isDuplicateEvent)(event.eventType, now, lastEvent)) return state;
                // Build event history
                let events = existing?.events || [];
                events = [
                    ...events,
                    {
                        type: event.eventType,
                        timestamp: now
                    }
                ];
                // Prune events outside the DISPLAY window (10 min) - keep for UI/history
                const displayCutoff = now - (0, _types.FLAPPING_CONFIG).RESOLVE_AFTER_MS;
                events = events.filter((e)=>e.timestamp > displayCutoff);
                // Count cycles only from events within the DETECTION window (60s)
                const detectionCutoff = now - (0, _types.FLAPPING_CONFIG).WINDOW_MS;
                const recentEvents = events.filter((e)=>e.timestamp > detectionCutoff);
                let cycles = 0;
                for(let i = 0; i < recentEvents.length - 1; i++)if (recentEvents[i].type === 'disconnect' && recentEvents[i + 1].type === 'connect') cycles++;
                // Determine state based on recent cycles
                if (cycles >= (0, _types.FLAPPING_CONFIG).ALERT_CYCLES) newState = 'alert';
                else if (cycles >= (0, _types.FLAPPING_CONFIG).WARNING_CYCLES) newState = 'warning';
                // Preserve existing state if we're still within the 10-minute window
                // This prevents the alert from disappearing when new events come in after 60s
                const previousState = existing?.state;
                const previousLastUpdated = existing?.lastUpdated;
                if (newState === 'normal' && previousState && previousState !== 'normal' && previousLastUpdated) {
                    const timeSinceLastUpdate = now - previousLastUpdated;
                    if (timeSinceLastUpdate < (0, _types.FLAPPING_CONFIG).RESOLVE_AFTER_MS) // Keep the existing state - still within 10-minute window
                    newState = previousState;
                }
                // Check if attached to live stream (preserve existing value or use false)
                const attachedToLiveStream = existing?.attachedToLiveStream || false;
                // If attached to live stream and just disconnected with at least 1 flapping cycle,
                // show warning. Require cycles >= 1 to avoid false positives from single transient disconnects.
                if (attachedToLiveStream && event.eventType === 'disconnect' && newState === 'normal' && cycles >= 1) newState = 'warning';
                encoders.set(event.encoderID, {
                    encoderID: event.encoderID,
                    simpleName: event.simpleName,
                    clientID: event.clientID,
                    online: event.online,
                    streamInfo: event.streamInfo,
                    events,
                    state: newState,
                    attachedToLiveStream,
                    lastUpdated: now
                });
                // Persist to localStorage
                savePersistedStatus(encoders);
                return {
                    encoders
                };
            });
            return newState;
        },
        setAttachedToLiveStream: (encoderID, attached)=>set((state)=>{
                const encoders = new Map(state.encoders);
                const existing = encoders.get(encoderID);
                if (existing) encoders.set(encoderID, {
                    ...existing,
                    attachedToLiveStream: attached
                });
                return {
                    encoders
                };
            }),
        clearEncoder: (encoderID)=>set((state)=>{
                const encoders = new Map(state.encoders);
                encoders.delete(encoderID);
                return {
                    encoders
                };
            }),
        // Server sync: Set initial flapping state from server on page load
        setFlappingFromServer: (alerts)=>set((state)=>{
                const encoders = new Map(state.encoders);
                for (const alert of alerts){
                    const existing = encoders.get(alert.encoderId);
                    // Merge server state with existing client state
                    encoders.set(alert.encoderId, {
                        encoderID: alert.encoderId,
                        simpleName: alert.simpleName,
                        clientID: alert.clientId,
                        online: alert.online,
                        streamInfo: existing?.streamInfo ?? null,
                        events: alert.events,
                        state: alert.severity,
                        attachedToLiveStream: existing?.attachedToLiveStream ?? false,
                        lastUpdated: alert.detectedAt
                    });
                }
                // Persist to localStorage
                savePersistedStatus(encoders);
                return {
                    encoders
                };
            }),
        // Server sync: Handle incoming flapping alert from SSE
        handleServerFlapping: (alert)=>set((state)=>{
                const encoders = new Map(state.encoders);
                const existing = encoders.get(alert.encoderId);
                encoders.set(alert.encoderId, {
                    encoderID: alert.encoderId,
                    simpleName: alert.simpleName,
                    clientID: alert.clientId,
                    online: alert.online,
                    streamInfo: existing?.streamInfo ?? null,
                    events: alert.events,
                    state: alert.severity,
                    attachedToLiveStream: existing?.attachedToLiveStream ?? false,
                    lastUpdated: Date.now()
                });
                // Persist to localStorage
                savePersistedStatus(encoders);
                return {
                    encoders
                };
            }),
        // Server sync: Handle flapping resolved from SSE
        handleServerFlappingResolved: (resolved)=>set((state)=>{
                const encoders = new Map(state.encoders);
                const existing = encoders.get(resolved.encoderId);
                if (existing) {
                    // Clear the flapping state but keep the encoder record
                    encoders.set(resolved.encoderId, {
                        ...existing,
                        state: 'normal',
                        events: [],
                        lastUpdated: Date.now()
                    });
                    // Persist to localStorage
                    savePersistedStatus(encoders);
                }
                return {
                    encoders
                };
            }),
        getEncodersWithIssues: ()=>{
            const { encoders } = get();
            return Array.from(encoders.values()).filter((e)=>e.state !== 'normal').sort((a, b)=>{
                // Alert first, then warning
                if (a.state === 'alert' && b.state !== 'alert') return -1;
                if (b.state === 'alert' && a.state !== 'alert') return 1;
                // Then by encoderID for stable ordering (prevents jumping on updates)
                return a.encoderID.localeCompare(b.encoderID);
            });
        },
        getEncoder: (encoderID)=>get().encoders.get(encoderID)
    }), {
    name: 'encoder-wss-store'
}));

},{"zustand":"Ze5I5","zustand/middleware":"9udS2","@shared/types":"dzHsw","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9xDtD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Show a persistent flapping toast notification
 * Stacks in bottom-right, requires manual dismissal
 */ parcelHelpers.export(exports, "showFlappingToast", ()=>showFlappingToast);
/**
 * Dismiss a specific flapping toast
 */ parcelHelpers.export(exports, "dismissFlappingToast", ()=>dismissFlappingToast);
/**
 * Dismiss all flapping toasts for an encoder (when resolved)
 */ parcelHelpers.export(exports, "dismissFlappingToastsForEncoder", ()=>dismissFlappingToastsForEncoder);
var _jsxRuntime = require("react/jsx-runtime");
var _sonner = require("sonner");
var _lucideReact = require("lucide-react");
var _sound = require("@/client/lib/sound");
function FlappingToastContent({ toastId, encoderId, simpleName, cycles, severity, isLiveStreamDisconnect }) {
    const isAlert = severity === 'alert';
    // Live stream disconnect uses a distinct blue/info style
    const colorClasses = isLiveStreamDisconnect ? 'bg-blue-100 border-blue-300 text-blue-900' : isAlert ? 'bg-red-100 border-red-300 text-red-900' : 'bg-amber-100 border-amber-300 text-amber-900';
    const iconColor = isLiveStreamDisconnect ? 'text-blue-600' : isAlert ? 'text-red-600' : 'text-amber-600';
    const buttonColor = isLiveStreamDisconnect ? 'text-blue-700' : isAlert ? 'text-red-700' : 'text-amber-700';
    const descColor = isLiveStreamDisconnect ? 'text-blue-800' : isAlert ? 'text-red-800' : 'text-amber-800';
    // Title and description based on type
    const title = isLiveStreamDisconnect ? 'Stream Disconnected' : isAlert ? 'Encoder Flapping' : 'Encoder Warning';
    const description = isLiveStreamDisconnect ? 'Encoder went offline during live stream' : `${cycles} disconnect/reconnect cycle${cycles !== 1 ? 's' : ''} detected`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `
        flex flex-col gap-2 p-4 rounded-lg shadow-lg border min-w-[320px]
        ${colorClasses}
      `,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-start justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                                className: `h-5 w-5 flex-shrink-0 ${iconColor}`
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "font-semibold text-sm",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "font-medium",
                                        children: simpleName || encoderId
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>(0, _sonner.toast).dismiss(toastId),
                        className: `
            p-1 rounded hover:bg-black/10 transition-colors
            ${buttonColor}
          `,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.X), {
                            className: "h-4 w-4"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `text-sm ${descColor}`,
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-3 text-sm font-medium mt-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "/encoders/triage",
                        onClick: ()=>setTimeout(()=>(0, _sonner.toast).dismiss(toastId), 0),
                        className: `hover:underline ${buttonColor}`,
                        children: "Triage Page"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: isLiveStreamDisconnect ? 'text-blue-400' : isAlert ? 'text-red-400' : 'text-amber-400',
                        children: "|"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: `/encoders/${encoderId}`,
                        onClick: ()=>setTimeout(()=>(0, _sonner.toast).dismiss(toastId), 0),
                        className: `hover:underline ${buttonColor}`,
                        children: "Encoder Details"
                    })
                ]
            })
        ]
    });
}
function showFlappingToast(props) {
    const toastId = `flapping-${props.encoderId}-${Date.now()}`;
    // Play sound based on severity
    if (props.severity === 'alert') (0, _sound.playAlertSound)();
    else (0, _sound.playWarningSound)();
    (0, _sonner.toast).custom((id)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(FlappingToastContent, {
            ...props,
            toastId: id
        }), {
        id: toastId,
        duration: Infinity,
        position: 'bottom-right'
    });
    return toastId;
}
function dismissFlappingToast(toastId) {
    (0, _sonner.toast).dismiss(toastId);
}
function dismissFlappingToastsForEncoder(encoderId) {
// Note: Sonner doesn't provide a way to query active toasts by pattern
// We'd need to track toast IDs externally if we want this functionality
// For now, resolved encoders will have their toasts dismissed when user clicks X
}

},{"react/jsx-runtime":"dQjte","sonner":"2p5sL","lucide-react":[["AlertTriangle","cdePa","default"],["X","8HSxK","default"]],"@/client/lib/sound":"kDJOu","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cdePa":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>TriangleAlert);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
            key: "wmoenq"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const TriangleAlert = (0, _createLucideIconJsDefault.default)("triangle-alert", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kDJOu":[function(require,module,exports,__globalThis) {
/**
 * Alert sound utilities using Web Audio API
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Play a warning sound (single lower tone)
 */ parcelHelpers.export(exports, "playWarningSound", ()=>playWarningSound);
/**
 * Play an alert sound (two higher tones)
 */ parcelHelpers.export(exports, "playAlertSound", ()=>playAlertSound);
let audioContext = null;
function getAudioContext() {
    if (!audioContext) audioContext = new AudioContext();
    return audioContext;
}
function playTone({ frequency, duration, volume = 0.3, type = 'sine' }) {
    try {
        const ctx = getAudioContext();
        // Resume context if suspended (browser autoplay policy)
        if (ctx.state === 'suspended') ctx.resume();
        const oscillator = ctx.createOscillator();
        const gainNode = ctx.createGain();
        oscillator.connect(gainNode);
        gainNode.connect(ctx.destination);
        oscillator.type = type;
        oscillator.frequency.setValueAtTime(frequency, ctx.currentTime);
        // Fade out to avoid click
        gainNode.gain.setValueAtTime(volume, ctx.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + duration);
        oscillator.start(ctx.currentTime);
        oscillator.stop(ctx.currentTime + duration);
    } catch (e) {
        // Silently fail if audio isn't available
        console.warn('Could not play alert sound:', e);
    }
}
function playWarningSound() {
    playTone({
        frequency: 440,
        duration: 0.2,
        type: 'sine'
    });
}
function playAlertSound() {
    playTone({
        frequency: 880,
        duration: 0.15,
        type: 'sine'
    });
    setTimeout(()=>{
        playTone({
            frequency: 880,
            duration: 0.15,
            type: 'sine'
        });
    }, 200);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6lR2X":[function(require,module,exports,__globalThis) {
/**
 * Shared Scaledrone Configuration
 *
 * Constants for Scaledrone connection, batching, and event handling.
 * Used by both client (ScaledroneProvider, worker) and server (ScaledroneManager).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SCALEDRONE_CONFIG", ()=>SCALEDRONE_CONFIG);
const SCALEDRONE_CONFIG = {
    /** Number of rooms to subscribe to per batch */ BATCH_SIZE: 10,
    /** Delay between batches in ms */ DELAY_BETWEEN_BATCHES_MS: 100,
    /** Maximum connection retry attempts before giving up */ MAX_CONNECTION_ATTEMPTS: 3,
    /** Failed attempts before circuit breaker trips */ CIRCUIT_BREAKER_THRESHOLD: 1,
    /** Timeout for connection attempts in ms */ CONNECTION_TIMEOUT_MS: 10000,
    /** Maximum events to keep in the event store */ MAX_EVENTS: 100,
    /** Interval for batching worker messages in ms */ BATCH_INTERVAL_MS: 500
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"iuAQl":[function(require,module,exports,__globalThis) {
let workerURL = require("29a3930172867576");
let url = new URL(import.meta.resolve("6UXbF"));
module.exports = workerURL(url.toString(), url.origin, true);

},{"29a3930172867576":"5yEdm"}],"5yEdm":[function(require,module,exports,__globalThis) {
"use strict";
module.exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};

},{}],"euLDl":[function(require,module,exports,__globalThis) {
/**
 * SSE Hook for Encoder Triage Alerts
 *
 * Connects to the triage SSE endpoint with JWT authentication
 * and provides real-time encoder alert updates.
 *
 * SSE Event Listeners
 * - 'connected'
 * - 'heartbeat'
 * - 'encoder:alert'
 * - 'encoder:alert_update'
 * - 'encoder:alert_resolved'
 * - 'encoder:update'
 * - 'triage:started'
 * - 'triage:ended'
 * - 'encoder:flapping'
 * - 'encoder:flapping:resolved'
 * - 'visibilitychange'
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// ============================================================================
// Hook
// ============================================================================
parcelHelpers.export(exports, "useTriageSSE", ()=>useTriageSSE);
var _react = require("react");
var _auth0React = require("@auth0/auth0-react");
var _config = require("@/client/config");
function useTriageSSE(options = {}) {
    const { autoConnect = false, onAlert, onAlertUpdate, onAlertResolved, onTriageStarted, onTriageEnded, onFlapping, onFlappingResolved, onEvent } = options;
    const { getAccessTokenSilently, isAuthenticated } = (0, _auth0React.useAuth0)();
    const [status, setStatus] = (0, _react.useState)('disconnected');
    const [lastEvent, setLastEvent] = (0, _react.useState)(null);
    const [clientId, setClientId] = (0, _react.useState)(null);
    const eventSourceRef = (0, _react.useRef)(null);
    const reconnectTimeoutRef = (0, _react.useRef)(null);
    const reconnectAttempts = (0, _react.useRef)(0);
    const intentionalDisconnectRef = (0, _react.useRef)(false);
    const isReconnectingRef = (0, _react.useRef)(false);
    const wasConnectedBeforeHiddenRef = (0, _react.useRef)(false);
    // Store callbacks in refs to avoid recreating connect() on every render
    const onAlertRef = (0, _react.useRef)(onAlert);
    const onAlertUpdateRef = (0, _react.useRef)(onAlertUpdate);
    const onAlertResolvedRef = (0, _react.useRef)(onAlertResolved);
    const onTriageStartedRef = (0, _react.useRef)(onTriageStarted);
    const onTriageEndedRef = (0, _react.useRef)(onTriageEnded);
    const onFlappingRef = (0, _react.useRef)(onFlapping);
    const onFlappingResolvedRef = (0, _react.useRef)(onFlappingResolved);
    const onEventRef = (0, _react.useRef)(onEvent);
    // Keep refs updated
    (0, _react.useEffect)(()=>{
        onAlertRef.current = onAlert;
        onAlertUpdateRef.current = onAlertUpdate;
        onAlertResolvedRef.current = onAlertResolved;
        onTriageStartedRef.current = onTriageStarted;
        onTriageEndedRef.current = onTriageEnded;
        onFlappingRef.current = onFlapping;
        onFlappingResolvedRef.current = onFlappingResolved;
        onEventRef.current = onEvent;
    }, [
        onAlert,
        onAlertUpdate,
        onAlertResolved,
        onTriageStarted,
        onTriageEnded,
        onFlapping,
        onFlappingResolved,
        onEvent
    ]);
    // Max reconnect delay: 30 seconds
    const MAX_RECONNECT_DELAY = 30000;
    const BASE_RECONNECT_DELAY = 1000;
    const disconnect = (0, _react.useCallback)(()=>{
        intentionalDisconnectRef.current = true;
        if (reconnectTimeoutRef.current) {
            clearTimeout(reconnectTimeoutRef.current);
            reconnectTimeoutRef.current = null;
        }
        if (eventSourceRef.current) {
            eventSourceRef.current.close();
            eventSourceRef.current = null;
        }
        setStatus('disconnected');
        setClientId(null);
        reconnectAttempts.current = 0;
    }, []);
    const connect = (0, _react.useCallback)(async ()=>{
        // Reset intentional disconnect flag
        intentionalDisconnectRef.current = false;
        // Don't connect if not authenticated
        if (!isAuthenticated) {
            console.warn('[TriageSSE] Cannot connect - user not authenticated');
            return;
        }
        // Clean up existing connection
        if (eventSourceRef.current) eventSourceRef.current.close();
        setStatus('connecting');
        try {
            // Get fresh access token
            const token = await getAccessTokenSilently();
            // Create SSE connection with token in query param
            const url = `${(0, _config.API_BASE_URL)}/api/encoders/triage/stream?token=${encodeURIComponent(token)}`;
            const eventSource = new EventSource(url);
            eventSourceRef.current = eventSource;
            // Handle connection open
            eventSource.onopen = ()=>{
                console.info('[TriageSSE] Connection opened');
                setStatus('connected');
                reconnectAttempts.current = 0;
            };
            // Handle errors
            eventSource.onerror = (error)=>{
                // Ignore errors from intentional disconnects (e.g., Strict Mode unmount)
                if (intentionalDisconnectRef.current) return;
                // Use warn instead of error to avoid Parcel error overlay treating this as a crash
                console.warn('[TriageSSE] Connection error (will reconnect):', error);
                // EventSource readyState: 0 = CONNECTING, 1 = OPEN, 2 = CLOSED
                if (eventSource.readyState === EventSource.CLOSED) {
                    setStatus('error');
                    // Prevent multiple simultaneous reconnect attempts
                    if (isReconnectingRef.current) return;
                    // Don't auto-reconnect after too many failures (likely auth issue)
                    if (reconnectAttempts.current >= 5) {
                        console.info('[TriageSSE] Max reconnect attempts reached, stopping');
                        return;
                    }
                    // Clear any pending reconnect before scheduling new one
                    if (reconnectTimeoutRef.current) clearTimeout(reconnectTimeoutRef.current);
                    isReconnectingRef.current = true;
                    // Exponential backoff reconnect
                    const delay = Math.min(BASE_RECONNECT_DELAY * Math.pow(2, reconnectAttempts.current), MAX_RECONNECT_DELAY);
                    reconnectAttempts.current++;
                    console.info(`[TriageSSE] Reconnecting in ${delay}ms (attempt ${reconnectAttempts.current})`);
                    reconnectTimeoutRef.current = setTimeout(()=>{
                        isReconnectingRef.current = false;
                        connect();
                    }, delay);
                }
            };
            // Handle 'connected' event
            eventSource.addEventListener('connected', (e)=>{
                try {
                    const event = JSON.parse(e.data);
                    setClientId(event.data.clientId);
                    setLastEvent(event);
                    onEventRef.current?.(event);
                } catch (err) {
                    console.error('[TriageSSE] Failed to parse connected event:', err);
                }
            });
            // Handle 'heartbeat' event (don't update lastEvent to reduce noise)
            eventSource.addEventListener('heartbeat', ()=>{
            // Heartbeats are just for keeping connection alive, no action needed
            });
            // Handle 'encoder:alert' event
            eventSource.addEventListener('encoder:alert', (e)=>{
                try {
                    const event = JSON.parse(e.data);
                    setLastEvent(event);
                    onEventRef.current?.(event);
                    onAlertRef.current?.(event.data);
                } catch (err) {
                    console.error('[TriageSSE] Failed to parse encoder:alert:', err);
                }
            });
            // Handle 'encoder:alert_update' event (lastAnomalyAt refresh)
            eventSource.addEventListener('encoder:alert_update', (e)=>{
                try {
                    const event = JSON.parse(e.data);
                    setLastEvent(event);
                    onEventRef.current?.(event);
                    onAlertUpdateRef.current?.(event.data);
                } catch (err) {
                    console.error('[TriageSSE] Failed to parse encoder:alert_update:', err);
                }
            });
            // Handle 'encoder:alert_resolved' event
            eventSource.addEventListener('encoder:alert_resolved', (e)=>{
                try {
                    const event = JSON.parse(e.data);
                    setLastEvent(event);
                    onEventRef.current?.(event);
                    onAlertResolvedRef.current?.(event.data);
                } catch (err) {
                    console.error('[TriageSSE] Failed to parse encoder:alert_resolved:', err);
                }
            });
            // Handle 'encoder:update' event
            eventSource.addEventListener('encoder:update', (e)=>{
                try {
                    const event = JSON.parse(e.data);
                    setLastEvent(event);
                    onEventRef.current?.(event);
                } catch (err) {
                    console.error('[TriageSSE] Failed to parse encoder:update:', err);
                }
            });
            // Handle 'triage:started' event
            eventSource.addEventListener('triage:started', (e)=>{
                try {
                    const event = JSON.parse(e.data);
                    setLastEvent(event);
                    onEventRef.current?.(event);
                    onTriageStartedRef.current?.(event.data);
                } catch (err) {
                    console.error('[TriageSSE] Failed to parse triage:started:', err);
                }
            });
            // Handle 'triage:ended' event
            eventSource.addEventListener('triage:ended', (e)=>{
                try {
                    const event = JSON.parse(e.data);
                    setLastEvent(event);
                    onEventRef.current?.(event);
                    onTriageEndedRef.current?.(event.data);
                } catch (err) {
                    console.error('[TriageSSE] Failed to parse triage:ended:', err);
                }
            });
            // Handle 'encoder:flapping' event
            eventSource.addEventListener('encoder:flapping', (e)=>{
                try {
                    const event = JSON.parse(e.data);
                    setLastEvent(event);
                    onEventRef.current?.(event);
                    onFlappingRef.current?.(event.data);
                } catch (err) {
                    console.error('[TriageSSE] Failed to parse encoder:flapping:', err);
                }
            });
            // Handle 'encoder:flapping:resolved' event
            eventSource.addEventListener('encoder:flapping:resolved', (e)=>{
                try {
                    const event = JSON.parse(e.data);
                    setLastEvent(event);
                    onEventRef.current?.(event);
                    onFlappingResolvedRef.current?.(event.data);
                } catch (err) {
                    console.error('[TriageSSE] Failed to parse encoder:flapping:resolved:', err);
                }
            });
        } catch (err) {
            console.error('[TriageSSE] Failed to connect:', err);
            setStatus('error');
        }
    }, [
        isAuthenticated,
        getAccessTokenSilently
    ]); // Removed callback deps - using refs now
    // Auto-connect on mount if enabled and authenticated
    // Small delay allows page to settle and avoids React 18 Strict Mode interruptions
    (0, _react.useEffect)(()=>{
        let timeoutId = null;
        if (autoConnect && isAuthenticated) timeoutId = setTimeout(()=>{
            connect();
        }, 100);
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
            disconnect();
        };
    }, [
        autoConnect,
        isAuthenticated,
        connect,
        disconnect
    ]);
    // Handle visibility change (sleep/wake, tab switch)
    // Disconnect when hidden, reconnect when visible to avoid stale connections
    (0, _react.useEffect)(()=>{
        const handleVisibilityChange = ()=>{
            if (document.hidden) {
                // Page hidden (sleep, tab switch) - remember if we were connected, then disconnect
                wasConnectedBeforeHiddenRef.current = eventSourceRef.current !== null;
                if (eventSourceRef.current) // console.info('[TriageSSE] Page hidden, disconnecting');
                disconnect();
            } else // Page visible again - reconnect if we were connected before hiding
            if (wasConnectedBeforeHiddenRef.current && isAuthenticated && !eventSourceRef.current) {
                // console.info('[TriageSSE] Page visible, reconnecting');
                // Reset reconnect state for fresh start
                reconnectAttempts.current = 0;
                isReconnectingRef.current = false;
                wasConnectedBeforeHiddenRef.current = false;
                // Small delay to let system settle after wake
                setTimeout(()=>{
                    connect();
                }, 500);
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [
        isAuthenticated,
        connect,
        disconnect
    ]);
    return {
        status,
        connect,
        disconnect,
        isConnected: status === 'connected',
        lastEvent,
        clientId
    };
}

},{"react":"eGun2","@auth0/auth0-react":"gpXrE","@/client/config":"8SWgh","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fS0sT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Helper to get alert key for muting
parcelHelpers.export(exports, "getAlertKey", ()=>getAlertKey);
parcelHelpers.export(exports, "useAlertStore", ()=>useAlertStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
// localStorage key for muted alerts
const MUTED_ALERTS_KEY = 'admin-portal:muted-alerts';
function getAlertKey(encoderId, alertType) {
    return `${encoderId}:${alertType}`;
}
// Load muted alerts from localStorage
function loadMutedAlerts() {
    try {
        const stored = localStorage.getItem(MUTED_ALERTS_KEY);
        if (stored) {
            const parsed = JSON.parse(stored);
            if (Array.isArray(parsed)) return new Set(parsed);
        }
    } catch (e) {
        console.warn('Failed to load muted alerts from localStorage:', e);
    }
    return new Set();
}
// Save muted alerts to localStorage
function saveMutedAlerts(muted) {
    try {
        localStorage.setItem(MUTED_ALERTS_KEY, JSON.stringify([
            ...muted
        ]));
    } catch (e) {
        console.warn('Failed to save muted alerts to localStorage:', e);
    }
}
const useAlertStore = (0, _zustand.create)()((0, _middleware.devtools)((set, get)=>({
        alerts: new Map(),
        triageSessions: [],
        sseStatus: 'disconnected',
        mutedAlerts: loadMutedAlerts(),
        addAlert: (alert)=>set((state)=>{
                const newAlerts = new Map(state.alerts);
                if (!newAlerts.has(alert.encoderId)) newAlerts.set(alert.encoderId, new Map());
                newAlerts.get(alert.encoderId).set(alert.alertType, alert);
                return {
                    alerts: newAlerts
                };
            }),
        updateAlert: (encoderId, alertType, lastAnomalyAt, currentValue)=>set((state)=>{
                const newAlerts = new Map(state.alerts);
                const encoderAlerts = newAlerts.get(encoderId);
                if (encoderAlerts) {
                    const existing = encoderAlerts.get(alertType);
                    if (existing) encoderAlerts.set(alertType, {
                        ...existing,
                        lastAnomalyAt,
                        ...currentValue !== undefined && {
                            currentValue
                        }
                    });
                }
                return {
                    alerts: newAlerts
                };
            }),
        removeAlert: (encoderId, alertType)=>set((state)=>{
                const newAlerts = new Map(state.alerts);
                const encoderAlerts = newAlerts.get(encoderId);
                if (encoderAlerts) {
                    encoderAlerts.delete(alertType);
                    if (encoderAlerts.size === 0) newAlerts.delete(encoderId);
                }
                return {
                    alerts: newAlerts
                };
            }),
        clearAlertsForEncoder: (encoderId)=>set((state)=>{
                const newAlerts = new Map(state.alerts);
                newAlerts.delete(encoderId);
                return {
                    alerts: newAlerts
                };
            }),
        setAlerts: (alertList)=>set(()=>{
                const newAlerts = new Map();
                for (const alert of alertList){
                    if (!newAlerts.has(alert.encoderId)) newAlerts.set(alert.encoderId, new Map());
                    newAlerts.get(alert.encoderId).set(alert.alertType, alert);
                }
                return {
                    alerts: newAlerts
                };
            }),
        muteAlert: (encoderId, alertType)=>set((state)=>{
                const key = getAlertKey(encoderId, alertType);
                const newMuted = new Set(state.mutedAlerts);
                newMuted.add(key);
                saveMutedAlerts(newMuted);
                return {
                    mutedAlerts: newMuted
                };
            }),
        unmuteAlert: (encoderId, alertType)=>set((state)=>{
                const key = getAlertKey(encoderId, alertType);
                const newMuted = new Set(state.mutedAlerts);
                newMuted.delete(key);
                saveMutedAlerts(newMuted);
                return {
                    mutedAlerts: newMuted
                };
            }),
        isAlertMuted: (encoderId, alertType)=>{
            const { mutedAlerts } = get();
            return mutedAlerts.has(getAlertKey(encoderId, alertType));
        },
        clearMutedAlerts: ()=>set(()=>{
                saveMutedAlerts(new Set());
                return {
                    mutedAlerts: new Set()
                };
            }),
        setTriageSessions: (sessions)=>set({
                triageSessions: sessions
            }),
        addTriageSession: (session)=>set((state)=>{
                // Dedupe - SSE event may have already added this session
                if (state.triageSessions.some((s)=>s.encoderId === session.encoderId)) return state;
                return {
                    triageSessions: [
                        ...state.triageSessions,
                        session
                    ]
                };
            }),
        removeTriageSession: (encoderId)=>set((state)=>({
                    triageSessions: state.triageSessions.filter((s)=>s.encoderId !== encoderId)
                })),
        updateTriageSessionSample: (encoderId, sample)=>set((state)=>({
                    triageSessions: state.triageSessions.map((s)=>s.encoderId === encoderId ? {
                            ...s,
                            latestSample: sample
                        } : s)
                })),
        setSseStatus: (status)=>set({
                sseStatus: status
            }),
        // Getters exclude muted alerts
        getAlertCount: ()=>{
            const { alerts, mutedAlerts } = get();
            let count = 0;
            for (const encoderAlerts of alerts.values())for (const alert of encoderAlerts.values()){
                const key = getAlertKey(alert.encoderId, alert.alertType);
                if (!mutedAlerts.has(key)) count++;
            }
            return count;
        },
        getTriageCount: ()=>get().triageSessions.length,
        getAlertsByEncoder: (encoderId)=>{
            const { alerts, mutedAlerts } = get();
            const encoderAlerts = alerts.get(encoderId);
            if (!encoderAlerts) return [];
            return Array.from(encoderAlerts.values()).filter((alert)=>!mutedAlerts.has(getAlertKey(alert.encoderId, alert.alertType)));
        },
        getAllAlerts: ()=>{
            const { alerts, mutedAlerts } = get();
            const all = [];
            for (const encoderAlerts of alerts.values())for (const alert of encoderAlerts.values()){
                const key = getAlertKey(alert.encoderId, alert.alertType);
                if (!mutedAlerts.has(key)) all.push(alert);
            }
            // Sort by severity (critical first) then by encoderId
            return all.sort((a, b)=>{
                const severityOrder = {
                    critical: 0,
                    warning: 1,
                    info: 2
                };
                const aSev = severityOrder[a.severity] ?? 3;
                const bSev = severityOrder[b.severity] ?? 3;
                if (aSev !== bSev) return aSev - bSev;
                return a.encoderId.localeCompare(b.encoderId);
            });
        },
        getCriticalCount: ()=>{
            const { alerts, mutedAlerts } = get();
            let count = 0;
            for (const encoderAlerts of alerts.values())for (const alert of encoderAlerts.values()){
                const key = getAlertKey(alert.encoderId, alert.alertType);
                if (!mutedAlerts.has(key) && alert.severity === 'critical') count++;
            }
            return count;
        },
        getWarningCount: ()=>{
            const { alerts, mutedAlerts } = get();
            let count = 0;
            for (const encoderAlerts of alerts.values())for (const alert of encoderAlerts.values()){
                const key = getAlertKey(alert.encoderId, alert.alertType);
                if (!mutedAlerts.has(key) && alert.severity === 'warning') count++;
            }
            return count;
        },
        getMutedCount: ()=>{
            const { alerts, mutedAlerts } = get();
            let count = 0;
            for (const encoderAlerts of alerts.values())for (const alert of encoderAlerts.values()){
                const key = getAlertKey(alert.encoderId, alert.alertType);
                if (mutedAlerts.has(key)) count++;
            }
            return count;
        }
    }), {
    name: 'alert-store'
}));

},{"zustand":"Ze5I5","zustand/middleware":"9udS2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1gsE4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TriageIndicator", ()=>TriageIndicator);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _lucideReact = require("lucide-react");
var _alertStore = require("@/client/store/alertStore");
var _encoderWSSStore = require("@/client/store/encoderWSSStore");
var _encodersStore = require("@/client/store/encodersStore");
var _shallow = require("zustand/react/shallow");
var _popover = require("@/client/components/ui/popover");
var _badge = require("@/client/components/ui/badge");
var _button = require("@/client/components/ui/button");
var _separator = require("@/client/components/ui/separator");
var _utils = require("@/client/lib/utils");
const ALERT_TYPE_LABELS = {
    offline: 'Offline',
    zero_bitrate: 'Zero Bitrate',
    bitrate_too_high: 'Bitrate Too High',
    bitrate_drop: 'Bitrate Drop',
    bitrate_unstable: 'Unstable Bitrate',
    frame_rate_drop: 'Frame Rate Drop',
    resolution_change: 'Resolution Changed'
};
function formatTriageDuration(startedAt) {
    const diff = Date.now() - startedAt;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(minutes / 60);
    if (hours > 0) return `${hours}h ${minutes % 60}m`;
    return `${minutes}m`;
}
function TriageIndicator() {
    // Select raw state (not computed getters) to avoid infinite re-render
    const alertsMap = (0, _alertStore.useAlertStore)((s)=>s.alerts);
    const triageSessions = (0, _alertStore.useAlertStore)((s)=>s.triageSessions);
    const sseStatus = (0, _alertStore.useAlertStore)((s)=>s.sseStatus);
    const mutedAlerts = (0, _alertStore.useAlertStore)((s)=>s.mutedAlerts);
    // Get encoder names for display
    const getEncoder = (0, _encodersStore.useEncodersStore)((s)=>s.getEncoder);
    // Get WSS encoder monitoring data (flapping/connection issues)
    const encodersWithIssues = (0, _encoderWSSStore.useEncoderWSSStore)((0, _shallow.useShallow)((s)=>{
        return Array.from(s.encoders.values()).filter((e)=>e.state !== 'normal').sort((a, b)=>{
            // Alert first, then warning
            if (a.state === 'alert' && b.state !== 'alert') return -1;
            if (b.state === 'alert' && a.state !== 'alert') return 1;
            // Then by encoderID for stable ordering (prevents jumping on updates)
            return a.encoderID.localeCompare(b.encoderID);
        });
    }));
    // Compute derived values with useMemo (excluding muted alerts)
    const { alertCount, mutedCount, criticalCount, alerts } = (0, _react.useMemo)(()=>{
        let count = 0;
        let muted = 0;
        let critical = 0;
        const all = [];
        for (const encoderAlerts of alertsMap.values())for (const alert of encoderAlerts.values()){
            const key = (0, _alertStore.getAlertKey)(alert.encoderId, alert.alertType);
            if (mutedAlerts.has(key)) {
                muted++;
                continue; // Skip muted alerts from main list
            }
            count++;
            all.push(alert);
            if (alert.severity === 'critical') critical++;
        }
        // Sort by severity (critical first) then by encoderId
        all.sort((a, b)=>{
            const severityOrder = {
                critical: 0,
                warning: 1,
                info: 2
            };
            const aSev = severityOrder[a.severity] ?? 3;
            const bSev = severityOrder[b.severity] ?? 3;
            if (aSev !== bSev) return aSev - bSev;
            return a.encoderId.localeCompare(b.encoderId);
        });
        return {
            alertCount: count,
            mutedCount: muted,
            criticalCount: critical,
            alerts: all
        };
    }, [
        alertsMap,
        mutedAlerts
    ]);
    const triageCount = triageSessions.length;
    const hasAlerts = alertCount > 0;
    const hasTriage = triageCount > 0;
    // const hasAny = hasAlerts || hasTriage;
    // Track previous alert count to detect new alerts
    const prevAlertCountRef = (0, _react.useRef)(alertCount);
    const [isAnimating, setIsAnimating] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        // Only animate if count increased (not on initial load when ref is 0)
        if (alertCount > prevAlertCountRef.current && prevAlertCountRef.current > 0) {
            setIsAnimating(true);
            // Remove animation class after it completes
            const timer = setTimeout(()=>setIsAnimating(false), 600);
            prevAlertCountRef.current = alertCount;
            return ()=>clearTimeout(timer);
        }
        prevAlertCountRef.current = alertCount;
    }, [
        alertCount
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _popover.Popover), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.PopoverTrigger), {
                asChild: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                    variant: "outline",
                    size: "sm",
                    className: (0, _utils.cn)('gap-0 px-2 h-8'),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Stethoscope), {
                            className: (0, _utils.cn)('h-4 w-4', // criticalCount > 0 ? 'text-red-600' : hasAlerts ? 'text-amber-600' :
                            'text-muted-foreground', isAnimating && 'animate-alert-shake')
                        }),
                        encodersWithIssues.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _separator.Separator), {
                                    orientation: "vertical",
                                    className: "mx-2 h-4"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "min-w-[1.25rem] text-center text-xs font-medium rounded px-1 bg-blue-500 text-white",
                                    children: encodersWithIssues.length
                                })
                            ]
                        }),
                        alertCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _separator.Separator), {
                                    orientation: "vertical",
                                    className: "mx-2 h-4"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: (0, _utils.cn)('min-w-[1.25rem] text-center text-xs font-medium rounded px-1 bg-amber-500 text-white', isAnimating && 'animate-alert-pop'),
                                    children: alertCount
                                })
                            ]
                        }),
                        triageCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _separator.Separator), {
                                    orientation: "vertical",
                                    className: "mx-2 h-4"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "min-w-[1.25rem] text-center text-xs font-medium rounded px-1 bg-red-500 text-white",
                                    children: triageCount
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _popover.PopoverContent), {
                align: "end",
                className: "w-80 p-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "px-3 py-2 border-b bg-muted/50 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex items-center gap-2",
                                children: sseStatus === 'connected' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                    variant: "outline",
                                    className: "bg-green-50 text-green-700 gap-1 text-xs h-5",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Wifi), {
                                            className: "h-3 w-3"
                                        }),
                                        "Polling"
                                    ]
                                }) : sseStatus === 'connecting' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                    variant: "outline",
                                    className: "bg-yellow-50 text-yellow-700 gap-1 text-xs h-5",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Wifi), {
                                            className: "h-3 w-3 animate-pulse"
                                        }),
                                        "Connecting..."
                                    ]
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                    variant: "outline",
                                    className: "bg-gray-50 text-gray-500 gap-1 text-xs h-5",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.WifiOff), {
                                            className: "h-3 w-3"
                                        }),
                                        "Disconnected"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                to: "/encoders/triage",
                                className: "flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground",
                                children: [
                                    "View All",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                                        className: "h-3 w-3"
                                    })
                                ]
                            })
                        ]
                    }),
                    encodersWithIssues.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Radio), {
                                                className: "h-4 w-4 text-blue-600"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-sm font-medium",
                                                children: "Connection Monitoring"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "ml-auto text-xs bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded",
                                                children: encodersWithIssues.length
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "space-y-1 max-h-24 overflow-y-auto",
                                        children: [
                                            encodersWithIssues.slice(0, 3).map((encoder)=>{
                                                const encoderInfo = getEncoder(encoder.encoderID);
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                                    to: "/encoders/$encoderID",
                                                    params: {
                                                        encoderID: encoder.encoderID
                                                    },
                                                    className: "flex items-center gap-2 p-1.5 rounded hover:bg-muted text-xs",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: (0, _utils.cn)('h-2 w-2 rounded-full flex-shrink-0', encoder.state === 'alert' ? 'bg-red-500' : 'bg-amber-500')
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "truncate flex-1",
                                                            children: [
                                                                encoderInfo?.clientName && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                    className: "text-muted-foreground",
                                                                    children: [
                                                                        encoderInfo.clientName,
                                                                        " / "
                                                                    ]
                                                                }),
                                                                encoder.simpleName || encoderInfo?.simpleName || encoder.encoderID
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "text-muted-foreground",
                                                            children: [
                                                                encoder.events.length,
                                                                " events"
                                                            ]
                                                        })
                                                    ]
                                                }, encoder.encoderID);
                                            }),
                                            encodersWithIssues.length > 3 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "text-xs text-muted-foreground py-1",
                                                children: [
                                                    "+",
                                                    encodersWithIssues.length - 3,
                                                    " more"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _separator.Separator), {})
                        ]
                    }),
                    alertCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                                                className: "h-4 w-4 text-amber-600"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-sm font-medium",
                                                children: "Anomalies"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-xs bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded",
                                                children: alertCount
                                            }),
                                            mutedCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "flex items-center gap-1 text-xs text-muted-foreground ml-auto",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.VolumeX), {
                                                        className: "h-3 w-3"
                                                    }),
                                                    mutedCount,
                                                    " muted"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "space-y-1 max-h-32 overflow-y-auto",
                                        children: [
                                            alerts.slice(0, 5).map((alert)=>{
                                                const encoder = getEncoder(alert.encoderId);
                                                const displayName = encoder?.simpleName || alert.streamName || alert.encoderId;
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                                    to: "/encoders/$encoderID",
                                                    params: {
                                                        encoderID: alert.encoderId
                                                    },
                                                    className: "flex items-center gap-2 p-1.5 rounded hover:bg-muted text-xs",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: (0, _utils.cn)('h-2 w-2 rounded-full flex-shrink-0', alert.severity === 'critical' ? 'bg-red-500' : alert.severity === 'warning' ? 'bg-amber-500' : 'bg-blue-500')
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "truncate flex-1",
                                                            children: displayName
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "text-muted-foreground truncate",
                                                            children: ALERT_TYPE_LABELS[alert.alertType] || alert.alertType
                                                        })
                                                    ]
                                                }, `${alert.encoderId}-${alert.alertType}`);
                                            }),
                                            alerts.length > 5 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "text-xs text-muted-foreground py-1",
                                                children: [
                                                    "+",
                                                    alerts.length - 5,
                                                    " more"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            triageCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _separator.Separator), {})
                        ]
                    }),
                    triageCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "p-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2 mb-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Stethoscope), {
                                        className: "h-4 w-4 text-red-600"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "text-sm font-medium",
                                        children: "In Triage"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "ml-auto text-xs bg-red-100 text-red-700 px-1.5 py-0.5 rounded",
                                        children: triageCount
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "space-y-1 max-h-32 overflow-y-auto",
                                children: [
                                    triageSessions.slice(0, 5).map((session)=>{
                                        const encoder = getEncoder(session.encoderId);
                                        const displayName = encoder?.simpleName || session.streamName || session.encoderId;
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                            to: "/encoders/$encoderID",
                                            params: {
                                                encoderID: session.encoderId
                                            },
                                            className: "flex items-center gap-2 p-1.5 rounded hover:bg-muted text-xs",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "truncate flex-1",
                                                    children: displayName
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "text-muted-foreground",
                                                    children: formatTriageDuration(session.startedAt)
                                                })
                                            ]
                                        }, session.encoderId);
                                    }),
                                    triageSessions.length > 5 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "text-xs text-muted-foreground py-1",
                                        children: [
                                            "+",
                                            triageSessions.length - 5,
                                            " more"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    encodersWithIssues.length === 0 && alertCount === 0 && triageCount === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-xs text-muted-foreground text-center py-2",
                            children: "No active issues"
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":"7k6Lq","lucide-react":[["AlertTriangle","cdePa","default"],["ChevronRight","lOb49","default"],["Radio","8O5hz","default"],["Stethoscope","21eRB","default"],["VolumeX","42MP8","default"],["Wifi","1QI2i","default"],["WifiOff","fo1VD","default"]],"@/client/store/alertStore":"fS0sT","@/client/store/encoderWSSStore":"jpzNm","@/client/store/encodersStore":"7Qwmv","zustand/react/shallow":"6ZS3a","@/client/components/ui/popover":"aASXh","@/client/components/ui/badge":"h4e1f","@/client/components/ui/button":"armlb","@/client/components/ui/separator":"3WCKI","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"42MP8":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>VolumeX);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
            key: "uqj9uw"
        }
    ],
    [
        "line",
        {
            x1: "22",
            x2: "16",
            y1: "9",
            y2: "15",
            key: "1ewh16"
        }
    ],
    [
        "line",
        {
            x1: "16",
            x2: "22",
            y1: "9",
            y2: "15",
            key: "5ykzw1"
        }
    ]
];
const VolumeX = (0, _createLucideIconJsDefault.default)("volume-x", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1QI2i":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Wifi);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 20h.01",
            key: "zekei9"
        }
    ],
    [
        "path",
        {
            d: "M2 8.82a15 15 0 0 1 20 0",
            key: "dnpr2z"
        }
    ],
    [
        "path",
        {
            d: "M5 12.859a10 10 0 0 1 14 0",
            key: "1x1e6c"
        }
    ],
    [
        "path",
        {
            d: "M8.5 16.429a5 5 0 0 1 7 0",
            key: "1bycff"
        }
    ]
];
const Wifi = (0, _createLucideIconJsDefault.default)("wifi", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fo1VD":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>WifiOff);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 20h.01",
            key: "zekei9"
        }
    ],
    [
        "path",
        {
            d: "M8.5 16.429a5 5 0 0 1 7 0",
            key: "1bycff"
        }
    ],
    [
        "path",
        {
            d: "M5 12.859a10 10 0 0 1 5.17-2.69",
            key: "1dl1wf"
        }
    ],
    [
        "path",
        {
            d: "M19 12.859a10 10 0 0 0-2.007-1.523",
            key: "4k23kn"
        }
    ],
    [
        "path",
        {
            d: "M2 8.82a15 15 0 0 1 4.177-2.643",
            key: "1grhjp"
        }
    ],
    [
        "path",
        {
            d: "M22 8.82a15 15 0 0 0-11.288-3.764",
            key: "z3jwby"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ]
];
const WifiOff = (0, _createLucideIconJsDefault.default)("wifi-off", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7Qwmv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEncodersStore", ()=>useEncodersStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
var _config = require("@/client/config");
var _apiError = require("@/client/lib/apiError");
const useEncodersStore = (0, _zustand.create)()((0, _middleware.devtools)((set, get)=>({
        encoders: [],
        loading: false,
        error: null,
        lastFetched: null,
        cacheInfo: null,
        setEncoders: (encoders)=>set({
                encoders,
                error: null
            }),
        setLoading: (loading)=>set({
                loading
            }),
        setError: (error)=>set({
                error
            }),
        getEncoder: (encoderID)=>get().encoders.find((e)=>e.encoderID === encoderID),
        invalidateCache: ()=>set({
                encoders: [],
                lastFetched: null,
                cacheInfo: null
            }),
        fetchEncoders: async (accessToken, logout, forceRefresh = false)=>{
            const state = get();
            // If we have cached data and not forcing refresh, skip the fetch
            if (!forceRefresh && state.encoders.length > 0 && state.lastFetched) return;
            set({
                loading: true,
                error: null
            });
            try {
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/encoders`, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.ok) {
                    if ((0, _apiError.handleApiError)(response, logout)) return;
                    throw new Error(`Failed to fetch encoders: ${response.statusText}`);
                }
                const data = await response.json();
                set({
                    encoders: data.encoders,
                    lastFetched: Date.now(),
                    loading: false,
                    cacheInfo: data.cacheInfo ?? null
                });
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
                set({
                    error: errorMessage,
                    loading: false
                });
            }
        }
    }), {
    name: 'encoders-store'
}));

},{"zustand":"Ze5I5","zustand/middleware":"9udS2","@/client/config":"8SWgh","@/client/lib/apiError":"aL0RR","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6ZS3a":[function(require,module,exports,__globalThis) {
'use strict';
var React = require("7bc07c1a9b67b6eb");
var shallow = require("aa0206b0503ef7c4");
function useShallow(selector) {
    const prev = React.useRef(void 0);
    return (state)=>{
        const next = selector(state);
        return shallow.shallow(prev.current, next) ? prev.current : prev.current = next;
    };
}
exports.useShallow = useShallow;

},{"7bc07c1a9b67b6eb":"eGun2","aa0206b0503ef7c4":"3X4RS"}],"3X4RS":[function(require,module,exports,__globalThis) {
'use strict';
const isIterable = (obj)=>Symbol.iterator in obj;
const hasIterableEntries = (value)=>// HACK: avoid checking entries type
    "entries" in value;
const compareEntries = (valueA, valueB)=>{
    const mapA = valueA instanceof Map ? valueA : new Map(valueA.entries());
    const mapB = valueB instanceof Map ? valueB : new Map(valueB.entries());
    if (mapA.size !== mapB.size) return false;
    for (const [key, value] of mapA){
        if (!mapB.has(key) || !Object.is(value, mapB.get(key))) return false;
    }
    return true;
};
const compareIterables = (valueA, valueB)=>{
    const iteratorA = valueA[Symbol.iterator]();
    const iteratorB = valueB[Symbol.iterator]();
    let nextA = iteratorA.next();
    let nextB = iteratorB.next();
    while(!nextA.done && !nextB.done){
        if (!Object.is(nextA.value, nextB.value)) return false;
        nextA = iteratorA.next();
        nextB = iteratorB.next();
    }
    return !!nextA.done && !!nextB.done;
};
function shallow(valueA, valueB) {
    if (Object.is(valueA, valueB)) return true;
    if (typeof valueA !== "object" || valueA === null || typeof valueB !== "object" || valueB === null) return false;
    if (Object.getPrototypeOf(valueA) !== Object.getPrototypeOf(valueB)) return false;
    if (isIterable(valueA) && isIterable(valueB)) {
        if (hasIterableEntries(valueA) && hasIterableEntries(valueB)) return compareEntries(valueA, valueB);
        return compareIterables(valueA, valueB);
    }
    return compareEntries({
        entries: ()=>Object.entries(valueA)
    }, {
        entries: ()=>Object.entries(valueB)
    });
}
exports.shallow = shallow;

},{}],"aASXh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popover", ()=>Popover);
parcelHelpers.export(exports, "PopoverTrigger", ()=>PopoverTrigger);
parcelHelpers.export(exports, "PopoverContent", ()=>PopoverContent);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactPopover = require("@radix-ui/react-popover");
var _utils = require("@/client/lib/utils");
const Popover = _reactPopover.Root;
const PopoverTrigger = _reactPopover.Trigger;
const PopoverContent = /*#__PURE__*/ _react.forwardRef(({ className, align = "center", sideOffset = 4, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactPopover.Portal, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactPopover.Content, {
            ref: ref,
            align: align,
            sideOffset: sideOffset,
            className: (0, _utils.cn)("z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-popover-content-transform-origin]", className),
            ...props
        })
    }));
PopoverContent.displayName = _reactPopover.Content.displayName;

},{"react/jsx-runtime":"dQjte","react":"eGun2","@radix-ui/react-popover":"4RmJr","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4RmJr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Anchor", ()=>Anchor2);
parcelHelpers.export(exports, "Arrow", ()=>Arrow2);
parcelHelpers.export(exports, "Close", ()=>Close);
parcelHelpers.export(exports, "Content", ()=>Content2);
parcelHelpers.export(exports, "Popover", ()=>Popover);
parcelHelpers.export(exports, "PopoverAnchor", ()=>PopoverAnchor);
parcelHelpers.export(exports, "PopoverArrow", ()=>PopoverArrow);
parcelHelpers.export(exports, "PopoverClose", ()=>PopoverClose);
parcelHelpers.export(exports, "PopoverContent", ()=>PopoverContent);
parcelHelpers.export(exports, "PopoverPortal", ()=>PopoverPortal);
parcelHelpers.export(exports, "PopoverTrigger", ()=>PopoverTrigger);
parcelHelpers.export(exports, "Portal", ()=>Portal);
parcelHelpers.export(exports, "Root", ()=>Root2);
parcelHelpers.export(exports, "Trigger", ()=>Trigger);
parcelHelpers.export(exports, "createPopoverScope", ()=>createPopoverScope);
// src/popover.tsx
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactContext = require("@radix-ui/react-context");
var _reactDismissableLayer = require("@radix-ui/react-dismissable-layer");
var _reactFocusGuards = require("@radix-ui/react-focus-guards");
var _reactFocusScope = require("@radix-ui/react-focus-scope");
var _reactId = require("@radix-ui/react-id");
var _reactPopper = require("@radix-ui/react-popper");
var _reactPortal = require("@radix-ui/react-portal");
var _reactPresence = require("@radix-ui/react-presence");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactSlot = require("@radix-ui/react-slot");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _ariaHidden = require("aria-hidden");
var _reactRemoveScroll = require("react-remove-scroll");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var POPOVER_NAME = "Popover";
var [createPopoverContext, createPopoverScope] = (0, _reactContext.createContextScope)(POPOVER_NAME, [
    (0, _reactPopper.createPopperScope)
]);
var usePopperScope = (0, _reactPopper.createPopperScope)();
var [PopoverProvider, usePopoverContext] = createPopoverContext(POPOVER_NAME);
var Popover = (props)=>{
    const { __scopePopover, children, open: openProp, defaultOpen, onOpenChange, modal = false } = props;
    const popperScope = usePopperScope(__scopePopover);
    const triggerRef = _react.useRef(null);
    const [hasCustomAnchor, setHasCustomAnchor] = _react.useState(false);
    const [open, setOpen] = (0, _reactUseControllableState.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: POPOVER_NAME
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Root, {
        ...popperScope,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(PopoverProvider, {
            scope: __scopePopover,
            contentId: (0, _reactId.useId)(),
            triggerRef,
            open,
            onOpenChange: setOpen,
            onOpenToggle: _react.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
                setOpen
            ]),
            hasCustomAnchor,
            onCustomAnchorAdd: _react.useCallback(()=>setHasCustomAnchor(true), []),
            onCustomAnchorRemove: _react.useCallback(()=>setHasCustomAnchor(false), []),
            modal,
            children
        })
    });
};
Popover.displayName = POPOVER_NAME;
var ANCHOR_NAME = "PopoverAnchor";
var PopoverAnchor = _react.forwardRef((props, forwardedRef)=>{
    const { __scopePopover, ...anchorProps } = props;
    const context = usePopoverContext(ANCHOR_NAME, __scopePopover);
    const popperScope = usePopperScope(__scopePopover);
    const { onCustomAnchorAdd, onCustomAnchorRemove } = context;
    _react.useEffect(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Anchor, {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
});
PopoverAnchor.displayName = ANCHOR_NAME;
var TRIGGER_NAME = "PopoverTrigger";
var PopoverTrigger = _react.forwardRef((props, forwardedRef)=>{
    const { __scopePopover, ...triggerProps } = props;
    const context = usePopoverContext(TRIGGER_NAME, __scopePopover);
    const popperScope = usePopperScope(__scopePopover);
    const composedTriggerRef = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, context.triggerRef);
    const trigger = /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, _primitive.composeEventHandlers)(props.onClick, context.onOpenToggle)
    });
    return context.hasCustomAnchor ? trigger : /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Anchor, {
        asChild: true,
        ...popperScope,
        children: trigger
    });
});
PopoverTrigger.displayName = TRIGGER_NAME;
var PORTAL_NAME = "PopoverPortal";
var [PortalProvider, usePortalContext] = createPopoverContext(PORTAL_NAME, {
    forceMount: void 0
});
var PopoverPortal = (props)=>{
    const { __scopePopover, forceMount, children, container } = props;
    const context = usePopoverContext(PORTAL_NAME, __scopePopover);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(PortalProvider, {
        scope: __scopePopover,
        forceMount,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPortal.Portal), {
                asChild: true,
                container,
                children
            })
        })
    });
};
PopoverPortal.displayName = PORTAL_NAME;
var CONTENT_NAME = "PopoverContent";
var PopoverContent = _react.forwardRef((props, forwardedRef)=>{
    const portalContext = usePortalContext(CONTENT_NAME, props.__scopePopover);
    const { forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = usePopoverContext(CONTENT_NAME, props.__scopePopover);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(PopoverContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(PopoverContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
PopoverContent.displayName = CONTENT_NAME;
var Slot = (0, _reactSlot.createSlot)("PopoverContent.RemoveScroll");
var PopoverContentModal = _react.forwardRef((props, forwardedRef)=>{
    const context = usePopoverContext(CONTENT_NAME, props.__scopePopover);
    const contentRef = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, contentRef);
    const isRightClickOutsideRef = _react.useRef(false);
    _react.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, _ariaHidden.hideOthers)(content);
    }, []);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactRemoveScroll.RemoveScroll), {
        as: Slot,
        allowPinchZoom: true,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(PopoverContentImpl, {
            ...props,
            ref: composedRefs,
            trapFocus: context.open,
            disableOutsidePointerEvents: true,
            onCloseAutoFocus: (0, _primitive.composeEventHandlers)(props.onCloseAutoFocus, (event)=>{
                event.preventDefault();
                if (!isRightClickOutsideRef.current) context.triggerRef.current?.focus();
            }),
            onPointerDownOutside: (0, _primitive.composeEventHandlers)(props.onPointerDownOutside, (event)=>{
                const originalEvent = event.detail.originalEvent;
                const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
                const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
                isRightClickOutsideRef.current = isRightClick;
            }, {
                checkForDefaultPrevented: false
            }),
            onFocusOutside: (0, _primitive.composeEventHandlers)(props.onFocusOutside, (event)=>event.preventDefault(), {
                checkForDefaultPrevented: false
            })
        })
    });
});
var PopoverContentNonModal = _react.forwardRef((props, forwardedRef)=>{
    const context = usePopoverContext(CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = _react.useRef(false);
    const hasPointerDownOutsideRef = _react.useRef(false);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(PopoverContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var PopoverContentImpl = _react.forwardRef((props, forwardedRef)=>{
    const { __scopePopover, trapFocus, onOpenAutoFocus, onCloseAutoFocus, disableOutsidePointerEvents, onEscapeKeyDown, onPointerDownOutside, onFocusOutside, onInteractOutside, ...contentProps } = props;
    const context = usePopoverContext(CONTENT_NAME, __scopePopover);
    const popperScope = usePopperScope(__scopePopover);
    (0, _reactFocusGuards.useFocusGuards)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactFocusScope.FocusScope), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactDismissableLayer.DismissableLayer), {
            asChild: true,
            disableOutsidePointerEvents,
            onInteractOutside,
            onEscapeKeyDown,
            onPointerDownOutside,
            onFocusOutside,
            onDismiss: ()=>context.onOpenChange(false),
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Content, {
                "data-state": getState(context.open),
                role: "dialog",
                id: context.contentId,
                ...popperScope,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...contentProps.style,
                    "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                    "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                    "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                    "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                    "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
            })
        })
    });
});
var CLOSE_NAME = "PopoverClose";
var PopoverClose = _react.forwardRef((props, forwardedRef)=>{
    const { __scopePopover, ...closeProps } = props;
    const context = usePopoverContext(CLOSE_NAME, __scopePopover);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, _primitive.composeEventHandlers)(props.onClick, ()=>context.onOpenChange(false))
    });
});
PopoverClose.displayName = CLOSE_NAME;
var ARROW_NAME = "PopoverArrow";
var PopoverArrow = _react.forwardRef((props, forwardedRef)=>{
    const { __scopePopover, ...arrowProps } = props;
    const popperScope = usePopperScope(__scopePopover);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Arrow, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
PopoverArrow.displayName = ARROW_NAME;
function getState(open) {
    return open ? "open" : "closed";
}
var Root2 = Popover;
var Anchor2 = PopoverAnchor;
var Trigger = PopoverTrigger;
var Portal = PopoverPortal;
var Content2 = PopoverContent;
var Close = PopoverClose;
var Arrow2 = PopoverArrow;

},{"react":"eGun2","@radix-ui/primitive":"k8C5A","@radix-ui/react-compose-refs":"nN23r","@radix-ui/react-context":"4wywa","@radix-ui/react-dismissable-layer":"gdhJG","@radix-ui/react-focus-guards":"h3kF4","@radix-ui/react-focus-scope":"dkOta","@radix-ui/react-id":"hoLx9","@radix-ui/react-popper":"5wakN","@radix-ui/react-portal":"4FFRT","@radix-ui/react-presence":"eh7qi","@radix-ui/react-primitive":"hQJ44","@radix-ui/react-slot":"4sJVf","@radix-ui/react-use-controllable-state":"ThW7y","aria-hidden":"8h7XP","react-remove-scroll":[["RemoveScroll","emctR","default"]],"react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dzS8l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfigSheet", ()=>ConfigSheet);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _auth0React = require("@auth0/auth0-react");
var _lucideReact = require("lucide-react");
var _config = require("@/client/config");
var _button = require("@/client/components/ui/button");
var _sheet = require("@/client/components/ui/sheet");
var _collapsible = require("@/client/components/ui/collapsible");
var _badge = require("@/client/components/ui/badge");
var _utils = require("@/client/lib/utils");
function ConfigSheet() {
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const [open, setOpen] = (0, _react.useState)(false);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    const [config, setConfig] = (0, _react.useState)([]);
    const [expandedGroups, setExpandedGroups] = (0, _react.useState)(new Set());
    const [showSensitive, setShowSensitive] = (0, _react.useState)(false);
    const fetchConfig = async ()=>{
        setLoading(true);
        setError(null);
        try {
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/config`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error(`Failed to fetch config: ${response.status}`);
            const data = await response.json();
            setConfig(data.groups);
            // Expand all groups by default
            setExpandedGroups(new Set(data.groups.map((g)=>g.name)));
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Unknown error');
        } finally{
            setLoading(false);
        }
    };
    // Fetch config when sheet opens
    (0, _react.useEffect)(()=>{
        if (open && config.length === 0) fetchConfig();
    }, [
        open
    ]);
    const toggleGroup = (name)=>{
        setExpandedGroups((prev)=>{
            const next = new Set(prev);
            if (next.has(name)) next.delete(name);
            else next.add(name);
            return next;
        });
    };
    const expandAll = ()=>{
        setExpandedGroups(new Set(config.map((g)=>g.name)));
    };
    const collapseAll = ()=>{
        setExpandedGroups(new Set());
    };
    const formatValue = (item)=>{
        if (item.sensitive && !showSensitive) return "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022";
        if (item.displayValue) return item.displayValue;
        if (typeof item.value === 'boolean') return item.value ? 'true' : 'false';
        return String(item.value);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sheet.Sheet), {
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sheet.SheetTrigger), {
                asChild: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                    variant: "outline",
                    size: "sm",
                    title: "View app configuration",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Settings), {
                            className: "h-4 w-4 mr-2"
                        }),
                        "Config"
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sheet.SheetContent), {
                side: "right",
                className: "w-full sm:max-w-lg overflow-hidden flex flex-col",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sheet.SheetHeader), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sheet.SheetTitle), {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Settings), {
                                        className: "h-5 w-5"
                                    }),
                                    "App Configuration"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sheet.SheetDescription), {
                                children: "All configuration values currently in use"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-2 py-2 border-b",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                variant: "ghost",
                                size: "sm",
                                onClick: fetchConfig,
                                disabled: loading,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                        className: (0, _utils.cn)('h-4 w-4 mr-1', loading && 'animate-spin')
                                    }),
                                    "Refresh"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: "ghost",
                                size: "sm",
                                onClick: expandAll,
                                children: "Expand All"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: "ghost",
                                size: "sm",
                                onClick: collapseAll,
                                children: "Collapse All"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex-1"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                variant: "ghost",
                                size: "sm",
                                onClick: ()=>setShowSensitive(!showSensitive),
                                children: [
                                    showSensitive ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.EyeOff), {
                                        className: "h-4 w-4 mr-1"
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Eye), {
                                        className: "h-4 w-4 mr-1"
                                    }),
                                    showSensitive ? 'Hide' : 'Show',
                                    " Sensitive"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex-1 overflow-y-auto py-4 space-y-4",
                        children: [
                            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "p-3 bg-red-50 text-red-700 rounded-md text-sm",
                                children: error
                            }),
                            loading && config.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-center py-8 text-muted-foreground",
                                children: "Loading configuration..."
                            }),
                            config.map((group)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _collapsible.Collapsible), {
                                    open: expandedGroups.has(group.name),
                                    onOpenChange: ()=>toggleGroup(group.name),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _collapsible.CollapsibleTrigger), {
                                            className: "flex items-center gap-2 w-full p-2 hover:bg-muted rounded-md",
                                            children: [
                                                expandedGroups.has(group.name) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                    className: "h-4 w-4"
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                                                    className: "h-4 w-4"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-medium",
                                                    children: group.name
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                                    variant: "secondary",
                                                    className: "ml-auto",
                                                    children: group.items.length
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _collapsible.CollapsibleContent), {
                                            children: [
                                                group.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "text-xs text-muted-foreground px-6 pb-2",
                                                    children: group.description
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "pl-6 pr-2 space-y-1",
                                                    children: group.items.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "flex items-start gap-2 py-1.5 text-sm border-b border-dashed last:border-0",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "flex-1 min-w-0",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "font-mono text-xs text-muted-foreground",
                                                                        children: [
                                                                            item.key,
                                                                            item.sensitive && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                                                                variant: "outline",
                                                                                className: "ml-2 text-[10px] px-1 py-0",
                                                                                children: "sensitive"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "font-medium truncate",
                                                                        title: String(item.value),
                                                                        children: formatValue(item)
                                                                    }),
                                                                    item.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "text-xs text-muted-foreground",
                                                                        children: item.description
                                                                    })
                                                                ]
                                                            })
                                                        }, item.key))
                                                })
                                            ]
                                        })
                                    ]
                                }, group.name))
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "border-t pt-3 text-xs text-muted-foreground",
                        children: config.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            children: [
                                config.length,
                                " groups, ",
                                config.reduce((acc, g)=>acc + g.items.length, 0),
                                " items"
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@auth0/auth0-react":"gpXrE","lucide-react":[["ChevronDown","kVmgC","default"],["ChevronRight","lOb49","default"],["Eye","3lL96","default"],["EyeOff","gcHst","default"],["RefreshCw","7a8jT","default"],["Settings","cb9bV","default"]],"@/client/config":"8SWgh","@/client/components/ui/button":"armlb","@/client/components/ui/sheet":"1Ctvs","@/client/components/ui/collapsible":"ij03O","@/client/components/ui/badge":"h4e1f","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3lL96":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Eye);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
            key: "1nclc0"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const Eye = (0, _createLucideIconJsDefault.default)("eye", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gcHst":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>EyeOff);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
            key: "ct8e1f"
        }
    ],
    [
        "path",
        {
            d: "M14.084 14.158a3 3 0 0 1-4.242-4.242",
            key: "151rxh"
        }
    ],
    [
        "path",
        {
            d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
            key: "13bj9a"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ]
];
const EyeOff = (0, _createLucideIconJsDefault.default)("eye-off", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cb9bV":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Settings);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
            key: "1i5ecw"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const Settings = (0, _createLucideIconJsDefault.default)("settings", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dD6eo":[function(require,module,exports,__globalThis) {
/**
 * SwapClientDialog - Reusable dialog for switching to a different client
 * Can be used anywhere client switching is needed (OTT Manager, etc.)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwapClientDialog", ()=>SwapClientDialog);
/**
 * Hook to get current user's client info and check if swap is needed
 */ parcelHelpers.export(exports, "useClientSwapInfo", ()=>useClientSwapInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _auth0React = require("@auth0/auth0-react");
var _lucideReact = require("lucide-react");
var _button = require("@/client/components/ui/button");
var _dialog = require("@/client/components/ui/dialog");
var _crud = require("@/client/utils/crud");
const USER_METADATA_KEY = 'http://invintus_user_metadata';
function SwapClientDialog({ open, onOpenChange, targetClientID, targetClientName, hasUnsavedChanges = false, onSwapSuccess, openUrlAfterSwap }) {
    const { getAccessTokenSilently, loginWithRedirect, user } = (0, _auth0React.useAuth0)();
    const [swapping, setSwapping] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    // Get current user's metadata
    const userMetadata = user?.[USER_METADATA_KEY];
    const currentUserLoginID = userMetadata?.loginID ? String(userMetadata.loginID) : '';
    const currentClientName = userMetadata?.clientID ? `Client ${userMetadata.clientID}` : 'current client';
    const handleSwap = async ()=>{
        if (!currentUserLoginID) {
            setError('Unable to determine your user ID. Please try refreshing the page.');
            return;
        }
        setSwapping(true);
        setError(null);
        try {
            const accessToken = await getAccessTokenSilently();
            const payload = {
                userID: currentUserLoginID,
                clientID: targetClientID
            };
            const response = await (0, _crud.callCrudApi)('/Users/swapUserAcc', payload, accessToken);
            if (response.success) {
                onSwapSuccess?.();
                // If we need to open a URL after swap, store it for after refresh
                if (openUrlAfterSwap) sessionStorage.setItem('openAfterSwap', openUrlAfterSwap);
                // Silent re-auth to refresh user metadata from Auth0
                setTimeout(()=>{
                    loginWithRedirect({
                        authorizationParams: {
                            prompt: 'none'
                        },
                        appState: {
                            returnTo: window.location.pathname
                        }
                    });
                }, 1500);
            } else {
                setError('Swap failed. Please try again.');
                setSwapping(false);
            }
        } catch (err) {
            setError(err instanceof Error ? err.message : 'An unexpected error occurred');
            setSwapping(false);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
        open: open,
        onOpenChange: swapping ? undefined : onOpenChange,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.DialogContent), {
            className: "max-w-md",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.DialogHeader), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.DialogTitle), {
                            children: "Switch Client"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.DialogDescription), {
                            children: [
                                "Switch your session to ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: targetClientName
                                }),
                                " to access this app's editor."
                            ]
                        })
                    ]
                }),
                hasUnsavedChanges && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-start gap-3 p-3 bg-amber-50 dark:bg-amber-950 border border-amber-200 dark:border-amber-800 rounded-md",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                            className: "h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-sm text-amber-800 dark:text-amber-200",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: "Warning:"
                                }),
                                " You have unsaved changes that will be lost when the page refreshes."
                            ]
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "p-3 text-sm text-red-500 bg-red-50 dark:bg-red-950 rounded-md",
                    children: error
                }),
                swapping && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center justify-center gap-3 py-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                            className: "h-5 w-5 animate-spin"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "Switching client and refreshing..."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.DialogFooter), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            variant: "outline",
                            onClick: ()=>onOpenChange(false),
                            disabled: swapping,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            onClick: handleSwap,
                            disabled: swapping,
                            children: swapping ? 'Switching...' : 'Switch Client'
                        })
                    ]
                })
            ]
        })
    });
}
function useClientSwapInfo(targetClientID) {
    const { user } = (0, _auth0React.useAuth0)();
    const userMetadata = user?.[USER_METADATA_KEY];
    const currentUserClientID = userMetadata?.clientID ? String(userMetadata.clientID) : '';
    const needsSwap = Boolean(targetClientID && currentUserClientID && targetClientID !== currentUserClientID);
    return {
        currentUserClientID,
        needsSwap
    };
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@auth0/auth0-react":"gpXrE","lucide-react":[["AlertTriangle","cdePa","default"],["RefreshCw","7a8jT","default"]],"@/client/components/ui/button":"armlb","@/client/components/ui/dialog":"6jjic","@/client/utils/crud":"3ws1j","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6jjic":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dialog", ()=>Dialog);
parcelHelpers.export(exports, "DialogPortal", ()=>DialogPortal);
parcelHelpers.export(exports, "DialogOverlay", ()=>DialogOverlay);
parcelHelpers.export(exports, "DialogClose", ()=>DialogClose);
parcelHelpers.export(exports, "DialogTrigger", ()=>DialogTrigger);
parcelHelpers.export(exports, "DialogContent", ()=>DialogContent);
parcelHelpers.export(exports, "DialogHeader", ()=>DialogHeader);
parcelHelpers.export(exports, "DialogFooter", ()=>DialogFooter);
parcelHelpers.export(exports, "DialogTitle", ()=>DialogTitle);
parcelHelpers.export(exports, "DialogDescription", ()=>DialogDescription);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDialog = require("@radix-ui/react-dialog");
var _lucideReact = require("lucide-react");
var _utils = require("@/client/lib/utils");
const Dialog = _reactDialog.Root;
const DialogTrigger = _reactDialog.Trigger;
const DialogPortal = _reactDialog.Portal;
const DialogClose = _reactDialog.Close;
const DialogOverlay = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactDialog.Overlay, {
        ref: ref,
        className: (0, _utils.cn)("fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", className),
        ...props
    }));
DialogOverlay.displayName = _reactDialog.Overlay.displayName;
const DialogContent = /*#__PURE__*/ _react.forwardRef(({ className, children, hideCloseButton, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(DialogPortal, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogOverlay, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactDialog.Content, {
                ref: ref,
                className: (0, _utils.cn)("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg", className),
                ...props,
                children: [
                    children,
                    !hideCloseButton && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactDialog.Close, {
                        className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.X), {
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "sr-only",
                                children: "Close"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
DialogContent.displayName = _reactDialog.Content.displayName;
const DialogHeader = ({ className, ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _utils.cn)("flex flex-col space-y-1.5 text-center sm:text-left", className),
        ...props
    });
DialogHeader.displayName = "DialogHeader";
const DialogFooter = ({ className, ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _utils.cn)("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className),
        ...props
    });
DialogFooter.displayName = "DialogFooter";
const DialogTitle = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactDialog.Title, {
        ref: ref,
        className: (0, _utils.cn)("text-lg font-semibold leading-none tracking-tight", className),
        ...props
    }));
DialogTitle.displayName = _reactDialog.Title.displayName;
const DialogDescription = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactDialog.Description, {
        ref: ref,
        className: (0, _utils.cn)("text-sm text-muted-foreground", className),
        ...props
    }));
DialogDescription.displayName = _reactDialog.Description.displayName;

},{"react/jsx-runtime":"dQjte","react":"eGun2","@radix-ui/react-dialog":"3DJ7S","lucide-react":[["X","8HSxK","default"]],"@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3ws1j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Make a request to the CRUD API via the server proxy
 * @param endpoint - The CRUD API endpoint (e.g., '/Users/swapUserAcc')
 * @param payload - The request payload
 * @param accessToken - Auth0 access token
 * @returns The CRUD API response
 */ parcelHelpers.export(exports, "callCrudApi", ()=>callCrudApi);
var _config = require("@/client/config");
async function callCrudApi(endpoint, payload, accessToken) {
    const response = await fetch(`${(0, _config.API_BASE_URL)}/api/crud`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            endpoint,
            payload
        })
    });
    if (!response.ok) {
        const errorData = await response.json().catch(()=>({}));
        throw new Error(errorData?.data?.error || `CRUD API request failed: ${response.statusText}`);
    }
    return response.json();
}

},{"@/client/config":"8SWgh","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8GoFO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCCSwapStore", ()=>useCCSwapStore);
var _zustand = require("zustand");
const useCCSwapStore = (0, _zustand.create)((set)=>({
        open: false,
        targetClientID: '',
        targetClientName: '',
        ccUrl: '',
        requestSwap: (targetClientID, targetClientName, ccUrl)=>set({
                open: true,
                targetClientID,
                targetClientName,
                ccUrl
            }),
        close: ()=>set({
                open: false,
                targetClientID: '',
                targetClientName: '',
                ccUrl: ''
            })
    }));

},{"zustand":"Ze5I5","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jGzf0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _root = require("./__root");
var _utils = require("@/client/lib/utils");
var _button = require("@/client/components/ui/button");
var _card = require("@/client/components/ui/card");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: '/',
    beforeLoad: async ({ context })=>{
        // Redirect to dashboard if already authenticated
        if (context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/dashboard'
        });
    },
    component: IndexComponent
});
function LoginForm({ className, ...props }) {
    const { loginWithRedirect } = (0, _auth0React.useAuth0)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _utils.cn)('flex flex-col gap-6', className),
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardTitle), {
                        children: "Admin Portal"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        variant: "outline",
                        className: "w-full",
                        onClick: ()=>loginWithRedirect(),
                        children: "Login"
                    })
                })
            ]
        })
    });
}
function IndexComponent() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex min-h-svh w-full items-center justify-center bg-muted shadow-inner p-6 md:p-10",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "w-full max-w-sm",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoginForm, {})
        })
    });
}

},{"react/jsx-runtime":"dQjte","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"]],"@auth0/auth0-react":"gpXrE","./__root":"enXay","@/client/lib/utils":"1ankz","@/client/components/ui/button":"armlb","@/client/components/ui/card":"dhIfn","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dhIfn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Card", ()=>Card);
parcelHelpers.export(exports, "CardHeader", ()=>CardHeader);
parcelHelpers.export(exports, "CardFooter", ()=>CardFooter);
parcelHelpers.export(exports, "CardTitle", ()=>CardTitle);
parcelHelpers.export(exports, "CardDescription", ()=>CardDescription);
parcelHelpers.export(exports, "CardContent", ()=>CardContent);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@/client/lib/utils");
const Card = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        className: (0, _utils.cn)("rounded-lg border bg-card text-card-foreground shadow-sm", className),
        ...props
    }));
Card.displayName = "Card";
const CardHeader = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        className: (0, _utils.cn)("flex flex-col space-y-1.5 p-6", className),
        ...props
    }));
CardHeader.displayName = "CardHeader";
const CardTitle = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        className: (0, _utils.cn)("text-2xl font-semibold leading-none tracking-tight", className),
        ...props
    }));
CardTitle.displayName = "CardTitle";
const CardDescription = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        className: (0, _utils.cn)("text-sm text-muted-foreground", className),
        ...props
    }));
CardDescription.displayName = "CardDescription";
const CardContent = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        className: (0, _utils.cn)("p-6 pt-0", className),
        ...props
    }));
CardContent.displayName = "CardContent";
const CardFooter = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        className: (0, _utils.cn)("flex items-center p-6 pt-0", className),
        ...props
    }));
CardFooter.displayName = "CardFooter";

},{"react/jsx-runtime":"dQjte","react":"eGun2","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eQIDw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _config = require("@/client/config");
var _root = require("./__root");
var _layout = require("@/client/layouts/layout");
var _card = require("@/client/components/ui/card");
var _lucideReact = require("lucide-react");
var _apiError = require("@/client/lib/apiError");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: '/dashboard',
    beforeLoad: async ({ context })=>{
        // Redirect to home if not authenticated
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: DashboardComponent
});
function DashboardComponent() {
    const { getAccessTokenSilently, isAuthenticated, isLoading, logout } = (0, _auth0React.useAuth0)();
    const [upcomingCount, setUpcomingCount] = (0, _react.useState)(null);
    const [liveCount, setLiveCount] = (0, _react.useState)(null);
    const [onlineEncodersCount, setOnlineEncodersCount] = (0, _react.useState)(null);
    const [ec2Counts, setEc2Counts] = (0, _react.useState)(null);
    const [rdsAvailable, setRdsAvailable] = (0, _react.useState)(null);
    const [publishAvgs, setPublishAvgs] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        if (isLoading || !isAuthenticated) return;
        const fetchData = async ()=>{
            try {
                const token = await getAccessTokenSilently();
                const [upcomingRes, liveRes, encodersRes, ec2Res, rdsRes, publishRes] = await Promise.all([
                    fetch(`${(0, _config.API_BASE_URL)}/api/upcoming-streams?dateRange=24hrs`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    }),
                    fetch(`${(0, _config.API_BASE_URL)}/api/live-streams`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    }),
                    fetch(`${(0, _config.API_BASE_URL)}/api/encoders`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    }),
                    fetch(`${(0, _config.API_BASE_URL)}/api/aws/ec2/instances`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    }),
                    fetch(`${(0, _config.API_BASE_URL)}/api/aws/rds/instances`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    }),
                    fetch(`${(0, _config.API_BASE_URL)}/api/events/publish-averages`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    })
                ]);
                const upcomingData = await upcomingRes.json();
                const liveData = await liveRes.json();
                const encodersData = await encodersRes.json();
                setUpcomingCount(upcomingData.upcomingStreams?.length ?? 0);
                setLiveCount(liveData.liveStreams?.length ?? 0);
                // Status 1 = Online
                const onlineCount = encodersData.encoders?.filter((e)=>e.status === 1).length ?? 0;
                setOnlineEncodersCount(onlineCount);
                // AWS EC2 data
                if (ec2Res.ok) {
                    const ec2Data = await ec2Res.json();
                    const running = ec2Data.instances.filter((i)=>i.state === 'running');
                    const counts = {
                        total: 0,
                        ingress: 0,
                        egress: 0,
                        transcode: 0
                    };
                    running.forEach((i)=>{
                        counts.total++;
                        if (i.serverType === 'ingress') counts.ingress++;
                        else if (i.serverType === 'egress') counts.egress++;
                        else if (i.serverType === 'transcode') counts.transcode++;
                    });
                    setEc2Counts(counts);
                }
                // AWS RDS data
                if (rdsRes.ok) {
                    const rdsData = await rdsRes.json();
                    const available = rdsData.instances.filter((i)=>i.status === 'available').length;
                    setRdsAvailable(available);
                }
                // Publish averages
                if (publishRes.ok) setPublishAvgs(await publishRes.json());
            } catch (err) {
                if ((0, _apiError.isLoginRequiredError)(err)) {
                    // Session expired - clear stale auth state and redirect to login
                    logout({
                        logoutParams: {
                            returnTo: window.location.origin
                        }
                    });
                    return;
                }
                console.error('Error fetching dashboard data:', err);
            }
        };
        fetchData();
    }, [
        isLoading,
        isAuthenticated,
        getAccessTokenSilently,
        logout
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "text-3xl font-bold mb-6",
                    children: "Dashboard"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "grid gap-4 md:grid-cols-2 lg:grid-cols-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                            to: "/events/live-streams",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                                className: "cursor-pointer transition-colors hover:bg-accent py-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                                        className: "pb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardTitle), {
                                            className: "text-sm font-medium text-muted-foreground text-center",
                                            children: "Live Streams"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardContent), {
                                        className: "text-center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-6xl font-bold py-4",
                                                children: liveCount !== null ? liveCount : "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-xs text-muted-foreground mt-1",
                                                children: "Currently streaming"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                            to: "/events/upcoming-streams",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                                className: "cursor-pointer transition-colors hover:bg-accent py-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                                        className: "pb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardTitle), {
                                            className: "text-sm font-medium text-muted-foreground text-center",
                                            children: "Upcoming Streams"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardContent), {
                                        className: "text-center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-6xl font-bold py-4",
                                                children: upcomingCount !== null ? upcomingCount : "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-xs text-muted-foreground mt-1",
                                                children: "Next 24 hours"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                            to: "/encoders",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                                className: "cursor-pointer transition-colors hover:bg-accent py-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                                        className: "pb-2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardTitle), {
                                            className: "text-sm font-medium text-muted-foreground text-center",
                                            children: "Online Encoders"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardContent), {
                                        className: "text-center",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-6xl font-bold py-4",
                                                children: onlineEncodersCount !== null ? onlineEncodersCount : "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-xs text-muted-foreground mt-1",
                                                children: "Currently online"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                    className: "text-xl font-semibold mt-8 mb-4 flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Server), {
                            className: "h-5 w-5"
                        }),
                        "AWS Health"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "grid grid-cols-2 md:grid-cols-5 gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                            to: "/aws/ec2-health",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-4 border rounded-lg hover:bg-accent transition-colors cursor-pointer",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-muted-foreground",
                                        children: "EC2 Running"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-2xl font-bold",
                                        children: ec2Counts?.total ?? "\u2014"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                            to: "/aws/ec2-health",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-4 border rounded-lg hover:bg-accent transition-colors cursor-pointer",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-muted-foreground",
                                        children: "Ingress"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-2xl font-bold text-blue-600",
                                        children: ec2Counts?.ingress ?? "\u2014"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                            to: "/aws/ec2-health",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-4 border rounded-lg hover:bg-accent transition-colors cursor-pointer",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-muted-foreground",
                                        children: "Egress"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-2xl font-bold text-purple-600",
                                        children: ec2Counts?.egress ?? "\u2014"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                            to: "/aws/ec2-health",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-4 border rounded-lg hover:bg-accent transition-colors cursor-pointer",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-muted-foreground",
                                        children: "Transcode"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-2xl font-bold text-orange-600",
                                        children: ec2Counts?.transcode ?? "\u2014"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                            to: "/aws/rds-health",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-4 border rounded-lg hover:bg-accent transition-colors cursor-pointer",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "text-sm text-muted-foreground flex items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Database), {
                                                className: "h-4 w-4"
                                            }),
                                            "RDS Available"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-2xl font-bold text-green-600",
                                        children: rdsAvailable ?? "\u2014"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                    className: "text-xl font-semibold mt-8 mb-4 flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.BookCheck), {
                            className: "h-5 w-5"
                        }),
                        "Published Events"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "grid grid-cols-3 gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "p-4 border rounded-lg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-sm text-muted-foreground",
                                    children: "Last 24 Hours"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-2xl font-bold",
                                    children: publishAvgs?.day.count ?? "\u2014"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-xs text-muted-foreground mt-1",
                                    children: "events published"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "p-4 border rounded-lg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-sm text-muted-foreground",
                                    children: "Last 7 Days"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-2xl font-bold",
                                    children: publishAvgs?.week.count ?? "\u2014"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "text-xs text-muted-foreground mt-1",
                                    children: [
                                        "avg ",
                                        publishAvgs?.week.avgPerDay ?? "\u2014",
                                        "/day"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "p-4 border rounded-lg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-sm text-muted-foreground",
                                    children: "Last 30 Days"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-2xl font-bold",
                                    children: publishAvgs?.month.count ?? "\u2014"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "text-xs text-muted-foreground mt-1",
                                    children: [
                                        "avg ",
                                        publishAvgs?.month.avgPerDay ?? "\u2014",
                                        "/day"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["Link","7k6Lq"],["redirect","jmFxY"]],"@auth0/auth0-react":"gpXrE","@/client/config":"8SWgh","./__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/components/ui/card":"dhIfn","lucide-react":[["BookCheck","kkCOF","default"],["Database","cqLcF","default"],["Server","52k00","default"]],"@/client/lib/apiError":"aL0RR","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kkCOF":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>BookCheck);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
            key: "k3hazp"
        }
    ],
    [
        "path",
        {
            d: "m9 9.5 2 2 4-4",
            key: "1dth82"
        }
    ]
];
const BookCheck = (0, _createLucideIconJsDefault.default)("book-check", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"clod2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _root = require("./__root");
var _layout = require("@/client/layouts/layout");
var _card = require("@/client/components/ui/card");
var _lucideReact = require("lucide-react");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: '/profile',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: ProfileComponent
});
function ProfileComponent() {
    const { user } = (0, _auth0React.useAuth0)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "text-3xl font-bold",
                    children: "Profile"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    user?.picture && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: user.picture,
                                        alt: user.name || 'Profile',
                                        className: "h-16 w-16 rounded-full"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardTitle), {
                                                children: user?.name || 'N/A'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-sm text-muted-foreground",
                                                children: user?.email || 'N/A'
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dl", {
                                className: "grid gap-4 sm:grid-cols-2",
                                children: [
                                    user?.nickname && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                                className: "text-sm font-medium text-muted-foreground",
                                                children: "Nickname"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                                className: "text-sm",
                                                children: user.nickname
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                                className: "text-sm font-medium text-muted-foreground",
                                                children: "User ID"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                                className: "text-sm font-mono",
                                                children: user?.sub || 'N/A'
                                            })
                                        ]
                                    }),
                                    user?.email_verified !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                                className: "text-sm font-medium text-muted-foreground",
                                                children: "Email Status"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                                className: "flex items-center gap-1.5 text-sm",
                                                children: user.email_verified ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CheckCircle), {
                                                            className: "h-4 w-4 text-green-500"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: "Verified"
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XCircle), {
                                                            className: "h-4 w-4 text-red-500"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: "Not Verified"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"]],"@auth0/auth0-react":"gpXrE","./__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/components/ui/card":"dhIfn","lucide-react":[["CheckCircle","2O3dV","default"],["XCircle","aDWrd","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2O3dV":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>CircleCheckBig);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M21.801 10A10 10 0 1 1 17 3.335",
            key: "yps3ct"
        }
    ],
    [
        "path",
        {
            d: "m9 11 3 3L22 4",
            key: "1pflzl"
        }
    ]
];
const CircleCheckBig = (0, _createLucideIconJsDefault.default)("circle-check-big", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"aDWrd":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>CircleX);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
];
const CircleX = (0, _createLucideIconJsDefault.default)("circle-x", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cs2MQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _root = require("../__root");
var _clientsStore = require("../../store/clientsStore");
var _layout = require("@/client/layouts/layout");
var _searchParams = require("@/client/lib/searchParams");
var _usePersistedSearch = require("@/client/hooks/usePersistedSearch");
var _resetFiltersButton = require("@/client/components/reset-filters-button");
var _reactTable = require("@tanstack/react-table");
var _clientsColumns = require("@/client/components/tables/clients-columns");
var _table = require("@/client/components/ui/table");
var _input = require("@/client/components/ui/input");
var _switch = require("@/client/components/ui/switch");
var _label = require("@/client/components/ui/label");
var _cacheTimestamp = require("@/client/components/cache-timestamp");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'clients',
    validateSearch: (search)=>({
            search: (0, _searchParams.parseString)(search.search),
            showInactive: (0, _searchParams.parseBoolean)(search.showInactive, false)
        }),
    beforeLoad: async ({ context })=>{
        // Redirect to home if not authenticated
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: ClientsComponent
});
function ClientsComponent() {
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    const { clients, loading, error, cacheInfo, fetchClients } = (0, _clientsStore.useClientsStore)();
    const navigate = (0, _reactRouter.useNavigate)();
    const { search: searchFilter = '', showInactive = false } = (0, _reactRouter.useSearch)({
        from: '/clients'
    });
    // Persist search params across navigation
    (0, _usePersistedSearch.usePersistedSearch)('/clients', {
        search: undefined,
        showInactive: false
    });
    const [sorting, setSorting] = (0, _react.useState)([]);
    // Update URL when search filter changes
    const setSearchFilter = (value)=>{
        navigate({
            to: '/clients',
            search: (0, _searchParams.buildSearchParams)({
                search: value || undefined,
                showInactive: showInactive || undefined
            })
        });
    };
    // Update URL when show-inactive toggle changes
    const setShowInactive = (value)=>{
        navigate({
            to: '/clients',
            search: (0, _searchParams.buildSearchParams)({
                search: searchFilter || undefined,
                showInactive: value || undefined
            })
        });
    };
    (0, _react.useEffect)(()=>{
        const loadClients = async ()=>{
            try {
                const token = await getAccessTokenSilently();
                await fetchClients(token, logout);
            } catch (err) {
                console.error('Error fetching clients:', err);
            }
        };
        loadClients();
    }, [
        getAccessTokenSilently,
        fetchClients
    ]);
    const filteredClients = (0, _react.useMemo)(()=>{
        let filtered = clients;
        // Filter by active status
        if (!showInactive) filtered = filtered.filter((client)=>client.active);
        // Filter by search text
        if (searchFilter) filtered = filtered.filter((client)=>client.name.toLowerCase().includes(searchFilter.toLowerCase()));
        return filtered;
    }, [
        clients,
        searchFilter,
        showInactive
    ]);
    const table = (0, _reactTable.useReactTable)({
        data: filteredClients,
        columns: (0, _clientsColumns.columns),
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        onSortingChange: setSorting,
        getSortedRowModel: (0, _reactTable.getSortedRowModel)(),
        state: {
            sorting
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex justify-between items-center mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "text-2xl font-semibold",
                                children: "Clients"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cacheTimestamp.CacheTimestamp), {
                                cachedAt: cacheInfo?.cachedAt ?? null
                            })
                        ]
                    }),
                    loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Loading clients..."
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-4 bg-red-100 border-l-4 border-red-600 rounded mt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "m-0 text-red-800 font-medium",
                            children: [
                                "Error: ",
                                error
                            ]
                        })
                    }),
                    !loading && !error && clients.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "No clients found."
                    }),
                    !loading && !error && clients.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex justify-end items-center gap-4 mb-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switch.Switch), {
                                                id: "show-inactive",
                                                checked: showInactive,
                                                onCheckedChange: setShowInactive
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                                htmlFor: "show-inactive",
                                                className: "cursor-pointer",
                                                children: "Show inactive clients"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                        placeholder: "Filter by name...",
                                        value: searchFilter,
                                        onChange: (e)=>setSearchFilter(e.target.value),
                                        className: "w-64"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetFiltersButton.ResetFiltersButton), {
                                        routePath: "/clients",
                                        defaultValues: {
                                            search: undefined,
                                            showInactive: false
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "rounded-md border",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                            children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: header.isPlaceholder ? null : (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())
                                                        }, header.id))
                                                }, headerGroup.id))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                            children: table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    onClick: ()=>navigate({
                                                            to: `/clients/${row.original.clientID}`
                                                        }),
                                                    className: "cursor-pointer hover:bg-accent",
                                                    children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                            children: (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                                        }, cell.id))
                                                }, row.id))
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useNavigate","aMhxM"],["useSearch","4yVFL"]],"@auth0/auth0-react":"gpXrE","../__root":"enXay","../../store/clientsStore":"6bg3l","@/client/layouts/layout":"d6QdD","@/client/lib/searchParams":"fgK0T","@/client/hooks/usePersistedSearch":"kPA60","@/client/components/reset-filters-button":"9d8BP","@tanstack/react-table":[["flexRender","brwh1"],["useReactTable","brwh1"],["getCoreRowModel","3MlnA"],["getSortedRowModel","3MlnA"]],"@/client/components/tables/clients-columns":"7xRKF","@/client/components/ui/table":"5vxZ8","@/client/components/ui/input":"8UHwi","@/client/components/ui/switch":"1p4xh","@/client/components/ui/label":"cLMZq","@/client/components/cache-timestamp":"f5Zyx","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fgK0T":[function(require,module,exports,__globalThis) {
/**
 * Centralized URL search params utilities for TanStack Router
 *
 * Provides type-safe helpers for parsing and serializing URL search params
 * with consistent default value handling across all routes.
 */ /**
 * Parse a boolean from URL search param.
 * Handles: 'true', 'false', '1', '0', true, false
 * Returns defaultValue if undefined or invalid
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseBoolean", ()=>parseBoolean);
/**
 * Parse a string from URL search param.
 * Returns undefined for empty strings (to keep URL clean)
 */ parcelHelpers.export(exports, "parseString", ()=>parseString);
/**
 * Parse a number from URL search param.
 * Returns defaultValue if undefined, invalid, or NaN
 */ parcelHelpers.export(exports, "parseNumber", ()=>parseNumber);
/**
 * Serialize a boolean for URL.
 * Only includes in URL if different from default (keeps URLs clean)
 */ parcelHelpers.export(exports, "serializeBoolean", ()=>serializeBoolean);
/**
 * Build search params object, filtering out undefined values.
 * This keeps URLs clean by only including params with actual values.
 */ parcelHelpers.export(exports, "buildSearchParams", ()=>buildSearchParams);
/**
 * Validate common search params from URL
 */ parcelHelpers.export(exports, "validateCommonSearch", ()=>validateCommonSearch);
function parseBoolean(value, defaultValue) {
    if (value === undefined || value === null) return defaultValue;
    if (typeof value === 'boolean') return value;
    if (value === 'true' || value === '1') return true;
    if (value === 'false' || value === '0') return false;
    return defaultValue;
}
function parseString(value) {
    if (typeof value === 'string' && value.length > 0) return value;
    return undefined;
}
function parseNumber(value, defaultValue) {
    if (value === undefined || value === null) return defaultValue;
    const num = typeof value === 'number' ? value : Number(value);
    if (Number.isNaN(num)) return defaultValue;
    return num;
}
function serializeBoolean(value, defaultValue) {
    return value === defaultValue ? undefined : String(value);
}
function buildSearchParams(params) {
    const result = {};
    for (const [key, value] of Object.entries(params))if (value !== undefined && value !== '') result[key] = value;
    return result;
}
function validateCommonSearch(search) {
    return {
        search: parseString(search.search),
        clientID: parseString(search.clientID)
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kPA60":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook that persists URL search params to sessionStorage and restores them
 * when returning to a route without params.
 *
 * This solves the problem where sidebar navigation clears search params.
 *
 * @param routePath - The route path (e.g., '/encoders', '/clients')
 * @param defaultValues - Default values for the search params (used to avoid storing defaults)
 */ parcelHelpers.export(exports, "usePersistedSearch", ()=>usePersistedSearch);
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _searchParams = require("@/client/lib/searchParams");
function usePersistedSearch(routePath, defaultValues) {
    const navigate = (0, _reactRouter.useNavigate)();
    const router = (0, _reactRouter.useRouter)();
    const search = router.state.location.search;
    const hasRestored = (0, _react.useRef)(false);
    const storageKey = `search:${routePath}`;
    // On mount: restore from sessionStorage if URL has no params
    (0, _react.useEffect)(()=>{
        if (hasRestored.current) return;
        hasRestored.current = true;
        // Check if URL has any non-default params
        const hasUrlParams = Object.entries(search).some(([key, value])=>{
            const defaultValue = defaultValues[key];
            return value !== undefined && value !== defaultValue;
        });
        if (hasUrlParams) {
            // URL has params, save them
            sessionStorage.setItem(storageKey, JSON.stringify(search));
            return;
        }
        // Try to restore from sessionStorage
        const stored = sessionStorage.getItem(storageKey);
        if (stored) try {
            const parsed = JSON.parse(stored);
            // Filter out default values and undefined
            const nonDefaultParams = Object.entries(parsed).reduce((acc, [key, value])=>{
                const defaultValue = defaultValues[key];
                if (value !== undefined && value !== defaultValue && value !== '') acc[key] = value;
                return acc;
            }, {});
            if (Object.keys(nonDefaultParams).length > 0) navigate({
                to: routePath,
                search: (0, _searchParams.buildSearchParams)(nonDefaultParams),
                replace: true
            });
        } catch  {
            sessionStorage.removeItem(storageKey);
        }
    }, []);
    // On search change: save to sessionStorage
    (0, _react.useEffect)(()=>{
        if (!hasRestored.current) return;
        const hasNonDefaultParams = Object.entries(search).some(([key, value])=>{
            const defaultValue = defaultValues[key];
            return value !== undefined && value !== defaultValue;
        });
        if (hasNonDefaultParams) sessionStorage.setItem(storageKey, JSON.stringify(search));
        else // Clear storage if all params are default
        sessionStorage.removeItem(storageKey);
    }, [
        search,
        storageKey,
        defaultValues
    ]);
}

},{"react":"eGun2","@tanstack/react-router":[["useNavigate","aMhxM"],["useRouter","nz9fN"]],"@/client/lib/searchParams":"fgK0T","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9d8BP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResetFiltersButton", ()=>ResetFiltersButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _lucideReact = require("lucide-react");
var _button = require("@/client/components/ui/button");
const ResetFiltersButton = /*#__PURE__*/ _react.forwardRef(({ routePath, defaultValues, variant = 'ghost', size = 'icon', className, ...props }, ref)=>{
    const navigate = (0, _reactRouter.useNavigate)();
    const router = (0, _reactRouter.useRouter)();
    const search = router.state.location.search;
    // Check if any filters are active (differ from defaults)
    const hasActiveFilters = Object.entries(defaultValues).some(([key, defaultValue])=>{
        const currentValue = search[key];
        // Filter is active if current value exists and differs from default
        if (currentValue === undefined || currentValue === '') return false;
        return currentValue !== defaultValue;
    });
    // Also check for any search params not in defaultValues (like clientID passed from other routes)
    const hasExtraParams = Object.keys(search).some((key)=>!(key in defaultValues) && search[key] !== undefined && search[key] !== '');
    const isDisabled = !hasActiveFilters && !hasExtraParams;
    const handleReset = ()=>{
        // Clear sessionStorage for this route
        sessionStorage.removeItem(`search:${routePath}`);
        // Navigate to route with empty search params
        navigate({
            to: routePath,
            search: {}
        });
    };
    // Use outline variant when filters are active to make it more prominent
    const activeVariant = isDisabled ? variant : 'outline';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
        ref: ref,
        variant: activeVariant,
        size: size,
        onClick: handleReset,
        title: "Reset filters",
        className: className,
        disabled: isDisabled,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.X), {
            className: "h-4 w-4"
        })
    });
});
ResetFiltersButton.displayName = 'ResetFiltersButton';

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["useNavigate","aMhxM"],["useRouter","nz9fN"]],"lucide-react":[["X","8HSxK","default"]],"@/client/components/ui/button":"armlb","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"brwh1":[function(require,module,exports,__globalThis) {
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flexRender", ()=>flexRender);
parcelHelpers.export(exports, "useReactTable", ()=>useReactTable);
var _react = require("react");
var _tableCore = require("@tanstack/table-core");
parcelHelpers.exportAll(_tableCore, exports);
//
/**
 * If rendering headers, cells, or footers with custom markup, use flexRender instead of `cell.getValue()` or `cell.renderValue()`.
 */ function flexRender(Comp, props) {
    return !Comp ? null : isReactComponent(Comp) ? /*#__PURE__*/ _react.createElement(Comp, props) : Comp;
}
function isReactComponent(component) {
    return isClassComponent(component) || typeof component === 'function' || isExoticComponent(component);
}
function isClassComponent(component) {
    return typeof component === 'function' && (()=>{
        const proto = Object.getPrototypeOf(component);
        return proto.prototype && proto.prototype.isReactComponent;
    })();
}
function isExoticComponent(component) {
    return typeof component === 'object' && typeof component.$$typeof === 'symbol' && [
        'react.memo',
        'react.forward_ref'
    ].includes(component.$$typeof.description);
}
function useReactTable(options) {
    // Compose in the generic options to the user options
    const resolvedOptions = {
        state: {},
        // Dummy state
        onStateChange: ()=>{},
        // noop
        renderFallbackValue: null,
        ...options
    };
    // Create a new table and store it in state
    const [tableRef] = _react.useState(()=>({
            current: (0, _tableCore.createTable)(resolvedOptions)
        }));
    // By default, manage table state here using the table's initial state
    const [state, setState] = _react.useState(()=>tableRef.current.initialState);
    // Compose the default state above with any user state. This will allow the user
    // to only control a subset of the state if desired.
    tableRef.current.setOptions((prev)=>({
            ...prev,
            ...options,
            state: {
                ...state,
                ...options.state
            },
            // Similarly, we'll maintain both our internal state and any user-provided
            // state.
            onStateChange: (updater)=>{
                setState(updater);
                options.onStateChange == null || options.onStateChange(updater);
            }
        }));
    return tableRef.current;
}

},{"react":"eGun2","@tanstack/table-core":"3MlnA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3MlnA":[function(require,module,exports,__globalThis) {
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ // type Person = {
//   firstName: string
//   lastName: string
//   age: number
//   visits: number
//   status: string
//   progress: number
//   createdAt: Date
//   nested: {
//     foo: [
//       {
//         bar: 'bar'
//       }
//     ]
//     bar: { subBar: boolean }[]
//     baz: {
//       foo: 'foo'
//       bar: {
//         baz: 'baz'
//       }
//     }
//   }
// }
// const test: DeepKeys<Person> = 'nested.foo.0.bar'
// const test2: DeepKeys<Person> = 'nested.bar'
// const helper = createColumnHelper<Person>()
// helper.accessor('nested.foo', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.foo.0.bar', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.bar', {
//   cell: info => info.getValue(),
// })
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColumnFaceting", ()=>ColumnFaceting);
parcelHelpers.export(exports, "ColumnFiltering", ()=>ColumnFiltering);
parcelHelpers.export(exports, "ColumnGrouping", ()=>ColumnGrouping);
parcelHelpers.export(exports, "ColumnOrdering", ()=>ColumnOrdering);
parcelHelpers.export(exports, "ColumnPinning", ()=>ColumnPinning);
parcelHelpers.export(exports, "ColumnSizing", ()=>ColumnSizing);
parcelHelpers.export(exports, "ColumnVisibility", ()=>ColumnVisibility);
parcelHelpers.export(exports, "GlobalFaceting", ()=>GlobalFaceting);
parcelHelpers.export(exports, "GlobalFiltering", ()=>GlobalFiltering);
parcelHelpers.export(exports, "Headers", ()=>Headers);
parcelHelpers.export(exports, "RowExpanding", ()=>RowExpanding);
parcelHelpers.export(exports, "RowPagination", ()=>RowPagination);
parcelHelpers.export(exports, "RowPinning", ()=>RowPinning);
parcelHelpers.export(exports, "RowSelection", ()=>RowSelection);
parcelHelpers.export(exports, "RowSorting", ()=>RowSorting);
parcelHelpers.export(exports, "_getVisibleLeafColumns", ()=>_getVisibleLeafColumns);
parcelHelpers.export(exports, "aggregationFns", ()=>aggregationFns);
parcelHelpers.export(exports, "buildHeaderGroups", ()=>buildHeaderGroups);
parcelHelpers.export(exports, "createCell", ()=>createCell);
parcelHelpers.export(exports, "createColumn", ()=>createColumn);
parcelHelpers.export(exports, "createColumnHelper", ()=>createColumnHelper);
parcelHelpers.export(exports, "createRow", ()=>createRow);
parcelHelpers.export(exports, "createTable", ()=>createTable);
parcelHelpers.export(exports, "defaultColumnSizing", ()=>defaultColumnSizing);
parcelHelpers.export(exports, "expandRows", ()=>expandRows);
parcelHelpers.export(exports, "filterFns", ()=>filterFns);
parcelHelpers.export(exports, "flattenBy", ()=>flattenBy);
parcelHelpers.export(exports, "functionalUpdate", ()=>functionalUpdate);
parcelHelpers.export(exports, "getCoreRowModel", ()=>getCoreRowModel);
parcelHelpers.export(exports, "getExpandedRowModel", ()=>getExpandedRowModel);
parcelHelpers.export(exports, "getFacetedMinMaxValues", ()=>getFacetedMinMaxValues);
parcelHelpers.export(exports, "getFacetedRowModel", ()=>getFacetedRowModel);
parcelHelpers.export(exports, "getFacetedUniqueValues", ()=>getFacetedUniqueValues);
parcelHelpers.export(exports, "getFilteredRowModel", ()=>getFilteredRowModel);
parcelHelpers.export(exports, "getGroupedRowModel", ()=>getGroupedRowModel);
parcelHelpers.export(exports, "getMemoOptions", ()=>getMemoOptions);
parcelHelpers.export(exports, "getPaginationRowModel", ()=>getPaginationRowModel);
parcelHelpers.export(exports, "getSortedRowModel", ()=>getSortedRowModel);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isNumberArray", ()=>isNumberArray);
parcelHelpers.export(exports, "isRowSelected", ()=>isRowSelected);
parcelHelpers.export(exports, "isSubRowSelected", ()=>isSubRowSelected);
parcelHelpers.export(exports, "makeStateUpdater", ()=>makeStateUpdater);
parcelHelpers.export(exports, "memo", ()=>memo);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "orderColumns", ()=>orderColumns);
parcelHelpers.export(exports, "passiveEventSupported", ()=>passiveEventSupported);
parcelHelpers.export(exports, "reSplitAlphaNumeric", ()=>reSplitAlphaNumeric);
parcelHelpers.export(exports, "selectRowsFn", ()=>selectRowsFn);
parcelHelpers.export(exports, "shouldAutoRemoveFilter", ()=>shouldAutoRemoveFilter);
parcelHelpers.export(exports, "sortingFns", ()=>sortingFns);
function createColumnHelper() {
    return {
        accessor: (accessor, column)=>{
            return typeof accessor === 'function' ? {
                ...column,
                accessorFn: accessor
            } : {
                ...column,
                accessorKey: accessor
            };
        },
        display: (column)=>column,
        group: (column)=>column
    };
}
// Is this type a tuple?
// If this type is a tuple, what indices are allowed?
///
function functionalUpdate(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function noop() {
//
}
function makeStateUpdater(key, instance) {
    return (updater)=>{
        instance.setState((old)=>{
            return {
                ...old,
                [key]: functionalUpdate(updater, old[key])
            };
        });
    };
}
function isFunction(d) {
    return d instanceof Function;
}
function isNumberArray(d) {
    return Array.isArray(d) && d.every((val)=>typeof val === 'number');
}
function flattenBy(arr, getChildren) {
    const flat = [];
    const recurse = (subArr)=>{
        subArr.forEach((item)=>{
            flat.push(item);
            const children = getChildren(item);
            if (children != null && children.length) recurse(children);
        });
    };
    recurse(arr);
    return flat;
}
function memo(getDeps, fn, opts) {
    let deps = [];
    let result;
    return (depArgs)=>{
        let depTime;
        if (opts.key && opts.debug) depTime = Date.now();
        const newDeps = getDeps(depArgs);
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && opts.debug) resultTime = Date.now();
        result = fn(...newDeps);
        opts == null || opts.onChange == null || opts.onChange(result);
        if (opts.key && opts.debug) {
            if (opts != null && opts.debug()) {
                const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                const resultFpsPercentage = resultEndTime / 16;
                const pad = (str, num)=>{
                    str = String(str);
                    while(str.length < num)str = ' ' + str;
                    return str;
                };
                console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
            }
        }
        return result;
    };
}
function getMemoOptions(tableOptions, debugLevel, key, onChange) {
    return {
        debug: ()=>{
            var _tableOptions$debugAl;
            return (_tableOptions$debugAl = tableOptions == null ? void 0 : tableOptions.debugAll) != null ? _tableOptions$debugAl : tableOptions[debugLevel];
        },
        key: false,
        onChange
    };
}
function createCell(table, row, column, columnId) {
    const getRenderValue = ()=>{
        var _cell$getValue;
        return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
    };
    const cell = {
        id: `${row.id}_${column.id}`,
        row,
        column,
        getValue: ()=>row.getValue(columnId),
        renderValue: getRenderValue,
        getContext: memo(()=>[
                table,
                column,
                row,
                cell
            ], (table, column, row, cell)=>({
                table,
                column,
                row,
                cell: cell,
                getValue: cell.getValue,
                renderValue: cell.renderValue
            }), getMemoOptions(table.options, 'debugCells', 'cell.getContext'))
    };
    table._features.forEach((feature)=>{
        feature.createCell == null || feature.createCell(cell, column, row, table);
    }, {});
    return cell;
}
function createColumn(table, columnDef, depth, parent) {
    var _ref, _resolvedColumnDef$id;
    const defaultColumn = table._getDefaultColumnDef();
    const resolvedColumnDef = {
        ...defaultColumn,
        ...columnDef
    };
    const accessorKey = resolvedColumnDef.accessorKey;
    let id = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? typeof String.prototype.replaceAll === 'function' ? accessorKey.replaceAll('.', '_') : accessorKey.replace(/\./g, '_') : undefined) != null ? _ref : typeof resolvedColumnDef.header === 'string' ? resolvedColumnDef.header : undefined;
    let accessorFn;
    if (resolvedColumnDef.accessorFn) accessorFn = resolvedColumnDef.accessorFn;
    else if (accessorKey) {
        // Support deep accessor keys
        if (accessorKey.includes('.')) accessorFn = (originalRow)=>{
            let result = originalRow;
            for (const key of accessorKey.split('.')){
                var _result;
                result = (_result = result) == null ? void 0 : _result[key];
            }
            return result;
        };
        else accessorFn = (originalRow)=>originalRow[resolvedColumnDef.accessorKey];
    }
    if (!id) throw new Error();
    let column = {
        id: `${String(id)}`,
        accessorFn,
        parent: parent,
        depth,
        columnDef: resolvedColumnDef,
        columns: [],
        getFlatColumns: memo(()=>[
                true
            ], ()=>{
            var _column$columns;
            return [
                column,
                ...(_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap((d)=>d.getFlatColumns())
            ];
        }, getMemoOptions(table.options, 'debugColumns', 'column.getFlatColumns')),
        getLeafColumns: memo(()=>[
                table._getOrderColumnsFn()
            ], (orderColumns)=>{
            var _column$columns2;
            if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
                let leafColumns = column.columns.flatMap((column)=>column.getLeafColumns());
                return orderColumns(leafColumns);
            }
            return [
                column
            ];
        }, getMemoOptions(table.options, 'debugColumns', 'column.getLeafColumns'))
    };
    for (const feature of table._features)feature.createColumn == null || feature.createColumn(column, table);
    // Yes, we have to convert table to unknown, because we know more than the compiler here.
    return column;
}
const debug = 'debugHeaders';
//
function createHeader(table, column, options) {
    var _options$id;
    const id = (_options$id = options.id) != null ? _options$id : column.id;
    let header = {
        id,
        column,
        index: options.index,
        isPlaceholder: !!options.isPlaceholder,
        placeholderId: options.placeholderId,
        depth: options.depth,
        subHeaders: [],
        colSpan: 0,
        rowSpan: 0,
        headerGroup: null,
        getLeafHeaders: ()=>{
            const leafHeaders = [];
            const recurseHeader = (h)=>{
                if (h.subHeaders && h.subHeaders.length) h.subHeaders.map(recurseHeader);
                leafHeaders.push(h);
            };
            recurseHeader(header);
            return leafHeaders;
        },
        getContext: ()=>({
                table,
                header: header,
                column
            })
    };
    table._features.forEach((feature)=>{
        feature.createHeader == null || feature.createHeader(header, table);
    });
    return header;
}
const Headers = {
    createTable: (table)=>{
        // Header Groups
        table.getHeaderGroups = memo(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            var _left$map$filter, _right$map$filter;
            const leftColumns = (_left$map$filter = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
            const rightColumns = (_right$map$filter = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
            const centerColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            const headerGroups = buildHeaderGroups(allColumns, [
                ...leftColumns,
                ...centerColumns,
                ...rightColumns
            ], table);
            return headerGroups;
        }, getMemoOptions(table.options, debug, 'getHeaderGroups'));
        table.getCenterHeaderGroups = memo(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            leafColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            return buildHeaderGroups(allColumns, leafColumns, table, 'center');
        }, getMemoOptions(table.options, debug, 'getCenterHeaderGroups'));
        table.getLeftHeaderGroups = memo(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, leafColumns, left)=>{
            var _left$map$filter2;
            const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
            return buildHeaderGroups(allColumns, orderedLeafColumns, table, 'left');
        }, getMemoOptions(table.options, debug, 'getLeftHeaderGroups'));
        table.getRightHeaderGroups = memo(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, right)=>{
            var _right$map$filter2;
            const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
            return buildHeaderGroups(allColumns, orderedLeafColumns, table, 'right');
        }, getMemoOptions(table.options, debug, 'getRightHeaderGroups'));
        // Footer Groups
        table.getFooterGroups = memo(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, getMemoOptions(table.options, debug, 'getFooterGroups'));
        table.getLeftFooterGroups = memo(()=>[
                table.getLeftHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, getMemoOptions(table.options, debug, 'getLeftFooterGroups'));
        table.getCenterFooterGroups = memo(()=>[
                table.getCenterHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, getMemoOptions(table.options, debug, 'getCenterFooterGroups'));
        table.getRightFooterGroups = memo(()=>[
                table.getRightHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, getMemoOptions(table.options, debug, 'getRightFooterGroups'));
        // Flat Headers
        table.getFlatHeaders = memo(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return headerGroups.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, getMemoOptions(table.options, debug, 'getFlatHeaders'));
        table.getLeftFlatHeaders = memo(()=>[
                table.getLeftHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, getMemoOptions(table.options, debug, 'getLeftFlatHeaders'));
        table.getCenterFlatHeaders = memo(()=>[
                table.getCenterHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, getMemoOptions(table.options, debug, 'getCenterFlatHeaders'));
        table.getRightFlatHeaders = memo(()=>[
                table.getRightHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, getMemoOptions(table.options, debug, 'getRightFlatHeaders'));
        // Leaf Headers
        table.getCenterLeafHeaders = memo(()=>[
                table.getCenterFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders;
                return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
            });
        }, getMemoOptions(table.options, debug, 'getCenterLeafHeaders'));
        table.getLeftLeafHeaders = memo(()=>[
                table.getLeftFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders2;
                return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
            });
        }, getMemoOptions(table.options, debug, 'getLeftLeafHeaders'));
        table.getRightLeafHeaders = memo(()=>[
                table.getRightFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders3;
                return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
            });
        }, getMemoOptions(table.options, debug, 'getRightLeafHeaders'));
        table.getLeafHeaders = memo(()=>[
                table.getLeftHeaderGroups(),
                table.getCenterHeaderGroups(),
                table.getRightHeaderGroups()
            ], (left, center, right)=>{
            var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
            return [
                ...(_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : [],
                ...(_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : [],
                ...(_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : []
            ].map((header)=>{
                return header.getLeafHeaders();
            }).flat();
        }, getMemoOptions(table.options, debug, 'getLeafHeaders'));
    }
};
function buildHeaderGroups(allColumns, columnsToGroup, table, headerFamily) {
    var _headerGroups$0$heade, _headerGroups$;
    // Find the max depth of the columns:
    // build the leaf column row
    // build each buffer row going up
    //    placeholder for non-existent level
    //    real column for existing level
    let maxDepth = 0;
    const findMaxDepth = function(columns, depth) {
        if (depth === void 0) depth = 1;
        maxDepth = Math.max(maxDepth, depth);
        columns.filter((column)=>column.getIsVisible()).forEach((column)=>{
            var _column$columns;
            if ((_column$columns = column.columns) != null && _column$columns.length) findMaxDepth(column.columns, depth + 1);
        }, 0);
    };
    findMaxDepth(allColumns);
    let headerGroups = [];
    const createHeaderGroup = (headersToGroup, depth)=>{
        // The header group we are creating
        const headerGroup = {
            depth,
            id: [
                headerFamily,
                `${depth}`
            ].filter(Boolean).join('_'),
            headers: []
        };
        // The parent columns we're going to scan next
        const pendingParentHeaders = [];
        // Scan each column for parents
        headersToGroup.forEach((headerToGroup)=>{
            // What is the latest (last) parent column?
            const latestPendingParentHeader = [
                ...pendingParentHeaders
            ].reverse()[0];
            const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
            let column;
            let isPlaceholder = false;
            if (isLeafHeader && headerToGroup.column.parent) // The parent header is new
            column = headerToGroup.column.parent;
            else {
                // The parent header is repeated
                column = headerToGroup.column;
                isPlaceholder = true;
            }
            if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) // This column is repeated. Add it as a sub header to the next batch
            latestPendingParentHeader.subHeaders.push(headerToGroup);
            else {
                // This is a new header. Let's create it
                const header = createHeader(table, column, {
                    id: [
                        headerFamily,
                        depth,
                        column.id,
                        headerToGroup == null ? void 0 : headerToGroup.id
                    ].filter(Boolean).join('_'),
                    isPlaceholder,
                    placeholderId: isPlaceholder ? `${pendingParentHeaders.filter((d)=>d.column === column).length}` : undefined,
                    depth,
                    index: pendingParentHeaders.length
                });
                // Add the headerToGroup as a subHeader of the new header
                header.subHeaders.push(headerToGroup);
                // Add the new header to the pendingParentHeaders to get grouped
                // in the next batch
                pendingParentHeaders.push(header);
            }
            headerGroup.headers.push(headerToGroup);
            headerToGroup.headerGroup = headerGroup;
        });
        headerGroups.push(headerGroup);
        if (depth > 0) createHeaderGroup(pendingParentHeaders, depth - 1);
    };
    const bottomHeaders = columnsToGroup.map((column, index)=>createHeader(table, column, {
            depth: maxDepth,
            index
        }));
    createHeaderGroup(bottomHeaders, maxDepth - 1);
    headerGroups.reverse();
    // headerGroups = headerGroups.filter(headerGroup => {
    //   return !headerGroup.headers.every(header => header.isPlaceholder)
    // })
    const recurseHeadersForSpans = (headers)=>{
        const filteredHeaders = headers.filter((header)=>header.column.getIsVisible());
        return filteredHeaders.map((header)=>{
            let colSpan = 0;
            let rowSpan = 0;
            let childRowSpans = [
                0
            ];
            if (header.subHeaders && header.subHeaders.length) {
                childRowSpans = [];
                recurseHeadersForSpans(header.subHeaders).forEach((_ref)=>{
                    let { colSpan: childColSpan, rowSpan: childRowSpan } = _ref;
                    colSpan += childColSpan;
                    childRowSpans.push(childRowSpan);
                });
            } else colSpan = 1;
            const minChildRowSpan = Math.min(...childRowSpans);
            rowSpan = rowSpan + minChildRowSpan;
            header.colSpan = colSpan;
            header.rowSpan = rowSpan;
            return {
                colSpan,
                rowSpan
            };
        });
    };
    recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
    return headerGroups;
}
const createRow = (table, id, original, rowIndex, depth, subRows, parentId)=>{
    let row = {
        id,
        index: rowIndex,
        original,
        depth,
        parentId,
        _valuesCache: {},
        _uniqueValuesCache: {},
        getValue: (columnId)=>{
            if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
            return row._valuesCache[columnId];
        },
        getUniqueValues: (columnId)=>{
            if (row._uniqueValuesCache.hasOwnProperty(columnId)) return row._uniqueValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            if (!column.columnDef.getUniqueValues) {
                row._uniqueValuesCache[columnId] = [
                    row.getValue(columnId)
                ];
                return row._uniqueValuesCache[columnId];
            }
            row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
            return row._uniqueValuesCache[columnId];
        },
        renderValue: (columnId)=>{
            var _row$getValue;
            return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
        },
        subRows: subRows != null ? subRows : [],
        getLeafRows: ()=>flattenBy(row.subRows, (d)=>d.subRows),
        getParentRow: ()=>row.parentId ? table.getRow(row.parentId, true) : undefined,
        getParentRows: ()=>{
            let parentRows = [];
            let currentRow = row;
            while(true){
                const parentRow = currentRow.getParentRow();
                if (!parentRow) break;
                parentRows.push(parentRow);
                currentRow = parentRow;
            }
            return parentRows.reverse();
        },
        getAllCells: memo(()=>[
                table.getAllLeafColumns()
            ], (leafColumns)=>{
            return leafColumns.map((column)=>{
                return createCell(table, row, column, column.id);
            });
        }, getMemoOptions(table.options, 'debugRows', 'getAllCells')),
        _getAllCellsByColumnId: memo(()=>[
                row.getAllCells()
            ], (allCells)=>{
            return allCells.reduce((acc, cell)=>{
                acc[cell.column.id] = cell;
                return acc;
            }, {});
        }, getMemoOptions(table.options, 'debugRows', 'getAllCellsByColumnId'))
    };
    for(let i = 0; i < table._features.length; i++){
        const feature = table._features[i];
        feature == null || feature.createRow == null || feature.createRow(row, table);
    }
    return row;
};
//
const ColumnFaceting = {
    createColumn: (column, table)=>{
        column._getFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id);
        column.getFacetedRowModel = ()=>{
            if (!column._getFacetedRowModel) return table.getPreFilteredRowModel();
            return column._getFacetedRowModel();
        };
        column._getFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id);
        column.getFacetedUniqueValues = ()=>{
            if (!column._getFacetedUniqueValues) return new Map();
            return column._getFacetedUniqueValues();
        };
        column._getFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id);
        column.getFacetedMinMaxValues = ()=>{
            if (!column._getFacetedMinMaxValues) return undefined;
            return column._getFacetedMinMaxValues();
        };
    }
};
const includesString = (row, columnId, filterValue)=>{
    var _filterValue$toString, _row$getValue;
    const search = filterValue == null || (_filterValue$toString = filterValue.toString()) == null ? void 0 : _filterValue$toString.toLowerCase();
    return Boolean((_row$getValue = row.getValue(columnId)) == null || (_row$getValue = _row$getValue.toString()) == null || (_row$getValue = _row$getValue.toLowerCase()) == null ? void 0 : _row$getValue.includes(search));
};
includesString.autoRemove = (val)=>testFalsey(val);
const includesStringSensitive = (row, columnId, filterValue)=>{
    var _row$getValue2;
    return Boolean((_row$getValue2 = row.getValue(columnId)) == null || (_row$getValue2 = _row$getValue2.toString()) == null ? void 0 : _row$getValue2.includes(filterValue));
};
includesStringSensitive.autoRemove = (val)=>testFalsey(val);
const equalsString = (row, columnId, filterValue)=>{
    var _row$getValue3;
    return ((_row$getValue3 = row.getValue(columnId)) == null || (_row$getValue3 = _row$getValue3.toString()) == null ? void 0 : _row$getValue3.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase());
};
equalsString.autoRemove = (val)=>testFalsey(val);
const arrIncludes = (row, columnId, filterValue)=>{
    var _row$getValue4;
    return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
arrIncludes.autoRemove = (val)=>testFalsey(val);
const arrIncludesAll = (row, columnId, filterValue)=>{
    return !filterValue.some((val)=>{
        var _row$getValue5;
        return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
    });
};
arrIncludesAll.autoRemove = (val)=>testFalsey(val) || !(val != null && val.length);
const arrIncludesSome = (row, columnId, filterValue)=>{
    return filterValue.some((val)=>{
        var _row$getValue6;
        return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
    });
};
arrIncludesSome.autoRemove = (val)=>testFalsey(val) || !(val != null && val.length);
const equals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) === filterValue;
};
equals.autoRemove = (val)=>testFalsey(val);
const weakEquals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) == filterValue;
};
weakEquals.autoRemove = (val)=>testFalsey(val);
const inNumberRange = (row, columnId, filterValue)=>{
    let [min, max] = filterValue;
    const rowValue = row.getValue(columnId);
    return rowValue >= min && rowValue <= max;
};
inNumberRange.resolveFilterValue = (val)=>{
    let [unsafeMin, unsafeMax] = val;
    let parsedMin = typeof unsafeMin !== 'number' ? parseFloat(unsafeMin) : unsafeMin;
    let parsedMax = typeof unsafeMax !== 'number' ? parseFloat(unsafeMax) : unsafeMax;
    let min = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
    let max = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
    if (min > max) {
        const temp = min;
        min = max;
        max = temp;
    }
    return [
        min,
        max
    ];
};
inNumberRange.autoRemove = (val)=>testFalsey(val) || testFalsey(val[0]) && testFalsey(val[1]);
// Export
const filterFns = {
    includesString,
    includesStringSensitive,
    equalsString,
    arrIncludes,
    arrIncludesAll,
    arrIncludesSome,
    equals,
    weakEquals,
    inNumberRange
};
// Utils
function testFalsey(val) {
    return val === undefined || val === null || val === '';
}
//
const ColumnFiltering = {
    getDefaultColumnDef: ()=>{
        return {
            filterFn: 'auto'
        };
    },
    getInitialState: (state)=>{
        return {
            columnFilters: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnFiltersChange: makeStateUpdater('columnFilters', table),
            filterFromLeafRows: false,
            maxLeafRowFilterDepth: 100
        };
    },
    createColumn: (column, table)=>{
        column.getAutoFilterFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'string') return filterFns.includesString;
            if (typeof value === 'number') return filterFns.inNumberRange;
            if (typeof value === 'boolean') return filterFns.equals;
            if (value !== null && typeof value === 'object') return filterFns.equals;
            if (Array.isArray(value)) return filterFns.arrIncludes;
            return filterFns.weakEquals;
        };
        column.getFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            return isFunction(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === 'auto' ? column.getAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : filterFns[column.columnDef.filterFn];
        };
        column.getCanFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
            return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
        };
        column.getIsFiltered = ()=>column.getFilterIndex() > -1;
        column.getFilterValue = ()=>{
            var _table$getState$colum;
            return (_table$getState$colum = table.getState().columnFilters) == null || (_table$getState$colum = _table$getState$colum.find((d)=>d.id === column.id)) == null ? void 0 : _table$getState$colum.value;
        };
        column.getFilterIndex = ()=>{
            var _table$getState$colum2, _table$getState$colum3;
            return (_table$getState$colum2 = (_table$getState$colum3 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$colum2 : -1;
        };
        column.setFilterValue = (value)=>{
            table.setColumnFilters((old)=>{
                const filterFn = column.getFilterFn();
                const previousFilter = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const newFilter = functionalUpdate(value, previousFilter ? previousFilter.value : undefined);
                //
                if (shouldAutoRemoveFilter(filterFn, newFilter, column)) {
                    var _old$filter;
                    return (_old$filter = old == null ? void 0 : old.filter((d)=>d.id !== column.id)) != null ? _old$filter : [];
                }
                const newFilterObj = {
                    id: column.id,
                    value: newFilter
                };
                if (previousFilter) {
                    var _old$map;
                    return (_old$map = old == null ? void 0 : old.map((d)=>{
                        if (d.id === column.id) return newFilterObj;
                        return d;
                    })) != null ? _old$map : [];
                }
                if (old != null && old.length) return [
                    ...old,
                    newFilterObj
                ];
                return [
                    newFilterObj
                ];
            });
        };
    },
    createRow: (row, _table)=>{
        row.columnFilters = {};
        row.columnFiltersMeta = {};
    },
    createTable: (table)=>{
        table.setColumnFilters = (updater)=>{
            const leafColumns = table.getAllLeafColumns();
            const updateFn = (old)=>{
                var _functionalUpdate;
                return (_functionalUpdate = functionalUpdate(updater, old)) == null ? void 0 : _functionalUpdate.filter((filter)=>{
                    const column = leafColumns.find((d)=>d.id === filter.id);
                    if (column) {
                        const filterFn = column.getFilterFn();
                        if (shouldAutoRemoveFilter(filterFn, filter.value, column)) return false;
                    }
                    return true;
                });
            };
            table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
        };
        table.resetColumnFilters = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
        };
        table.getPreFilteredRowModel = ()=>table.getCoreRowModel();
        table.getFilteredRowModel = ()=>{
            if (!table._getFilteredRowModel && table.options.getFilteredRowModel) table._getFilteredRowModel = table.options.getFilteredRowModel(table);
            if (table.options.manualFiltering || !table._getFilteredRowModel) return table.getPreFilteredRowModel();
            return table._getFilteredRowModel();
        };
    }
};
function shouldAutoRemoveFilter(filterFn, value, column) {
    return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === 'undefined' || typeof value === 'string' && !value;
}
const sum = (columnId, _leafRows, childRows)=>{
    // It's faster to just add the aggregations together instead of
    // process leaf nodes individually
    return childRows.reduce((sum, next)=>{
        const nextValue = next.getValue(columnId);
        return sum + (typeof nextValue === 'number' ? nextValue : 0);
    }, 0);
};
const min = (columnId, _leafRows, childRows)=>{
    let min;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (min > value || min === undefined && value >= value)) min = value;
    });
    return min;
};
const max = (columnId, _leafRows, childRows)=>{
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (max < value || max === undefined && value >= value)) max = value;
    });
    return max;
};
const extent = (columnId, _leafRows, childRows)=>{
    let min;
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    });
    return [
        min,
        max
    ];
};
const mean = (columnId, leafRows)=>{
    let count = 0;
    let sum = 0;
    leafRows.forEach((row)=>{
        let value = row.getValue(columnId);
        if (value != null && (value = +value) >= value) ++count, sum += value;
    });
    if (count) return sum / count;
    return;
};
const median = (columnId, leafRows)=>{
    if (!leafRows.length) return;
    const values = leafRows.map((row)=>row.getValue(columnId));
    if (!isNumberArray(values)) return;
    if (values.length === 1) return values[0];
    const mid = Math.floor(values.length / 2);
    const nums = values.sort((a, b)=>a - b);
    return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
const unique = (columnId, leafRows)=>{
    return Array.from(new Set(leafRows.map((d)=>d.getValue(columnId))).values());
};
const uniqueCount = (columnId, leafRows)=>{
    return new Set(leafRows.map((d)=>d.getValue(columnId))).size;
};
const count = (_columnId, leafRows)=>{
    return leafRows.length;
};
const aggregationFns = {
    sum,
    min,
    max,
    extent,
    mean,
    median,
    unique,
    uniqueCount,
    count
};
//
const ColumnGrouping = {
    getDefaultColumnDef: ()=>{
        return {
            aggregatedCell: (props)=>{
                var _toString, _props$getValue;
                return (_toString = (_props$getValue = props.getValue()) == null || _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
            },
            aggregationFn: 'auto'
        };
    },
    getInitialState: (state)=>{
        return {
            grouping: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGroupingChange: makeStateUpdater('grouping', table),
            groupedColumnMode: 'reorder'
        };
    },
    createColumn: (column, table)=>{
        column.toggleGrouping = ()=>{
            table.setGrouping((old)=>{
                // Find any existing grouping for this column
                if (old != null && old.includes(column.id)) return old.filter((d)=>d !== column.id);
                return [
                    ...old != null ? old : [],
                    column.id
                ];
            });
        };
        column.getCanGroup = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGrouping) != null ? _table$options$enable : true) && (!!column.accessorFn || !!column.columnDef.getGroupingValue);
        };
        column.getIsGrouped = ()=>{
            var _table$getState$group;
            return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
        };
        column.getGroupedIndex = ()=>{
            var _table$getState$group2;
            return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
        };
        column.getToggleGroupingHandler = ()=>{
            const canGroup = column.getCanGroup();
            return ()=>{
                if (!canGroup) return;
                column.toggleGrouping();
            };
        };
        column.getAutoAggregationFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'number') return aggregationFns.sum;
            if (Object.prototype.toString.call(value) === '[object Date]') return aggregationFns.extent;
        };
        column.getAggregationFn = ()=>{
            var _table$options$aggreg, _table$options$aggreg2;
            if (!column) throw new Error();
            return isFunction(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === 'auto' ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : aggregationFns[column.columnDef.aggregationFn];
        };
    },
    createTable: (table)=>{
        table.setGrouping = (updater)=>table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater);
        table.resetGrouping = (defaultState)=>{
            var _table$initialState$g, _table$initialState;
            table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
        };
        table.getPreGroupedRowModel = ()=>table.getFilteredRowModel();
        table.getGroupedRowModel = ()=>{
            if (!table._getGroupedRowModel && table.options.getGroupedRowModel) table._getGroupedRowModel = table.options.getGroupedRowModel(table);
            if (table.options.manualGrouping || !table._getGroupedRowModel) return table.getPreGroupedRowModel();
            return table._getGroupedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.getIsGrouped = ()=>!!row.groupingColumnId;
        row.getGroupingValue = (columnId)=>{
            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.columnDef.getGroupingValue)) return row.getValue(columnId);
            row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
            return row._groupingValuesCache[columnId];
        };
        row._groupingValuesCache = {};
    },
    createCell: (cell, column, row, table)=>{
        cell.getIsGrouped = ()=>column.getIsGrouped() && column.id === row.groupingColumnId;
        cell.getIsPlaceholder = ()=>!cell.getIsGrouped() && column.getIsGrouped();
        cell.getIsAggregated = ()=>{
            var _row$subRows;
            return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
    }
};
function orderColumns(leafColumns, grouping, groupedColumnMode) {
    if (!(grouping != null && grouping.length) || !groupedColumnMode) return leafColumns;
    const nonGroupingColumns = leafColumns.filter((col)=>!grouping.includes(col.id));
    if (groupedColumnMode === 'remove') return nonGroupingColumns;
    const groupingColumns = grouping.map((g)=>leafColumns.find((col)=>col.id === g)).filter(Boolean);
    return [
        ...groupingColumns,
        ...nonGroupingColumns
    ];
}
//
const ColumnOrdering = {
    getInitialState: (state)=>{
        return {
            columnOrder: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnOrderChange: makeStateUpdater('columnOrder', table)
        };
    },
    createColumn: (column, table)=>{
        column.getIndex = memo((position)=>[
                _getVisibleLeafColumns(table, position)
            ], (columns)=>columns.findIndex((d)=>d.id === column.id), getMemoOptions(table.options, 'debugColumns', 'getIndex'));
        column.getIsFirstColumn = (position)=>{
            var _columns$;
            const columns = _getVisibleLeafColumns(table, position);
            return ((_columns$ = columns[0]) == null ? void 0 : _columns$.id) === column.id;
        };
        column.getIsLastColumn = (position)=>{
            var _columns;
            const columns = _getVisibleLeafColumns(table, position);
            return ((_columns = columns[columns.length - 1]) == null ? void 0 : _columns.id) === column.id;
        };
    },
    createTable: (table)=>{
        table.setColumnOrder = (updater)=>table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater);
        table.resetColumnOrder = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
        };
        table._getOrderColumnsFn = memo(()=>[
                table.getState().columnOrder,
                table.getState().grouping,
                table.options.groupedColumnMode
            ], (columnOrder, grouping, groupedColumnMode)=>(columns)=>{
                // Sort grouped columns to the start of the column list
                // before the headers are built
                let orderedColumns = [];
                // If there is no order, return the normal columns
                if (!(columnOrder != null && columnOrder.length)) orderedColumns = columns;
                else {
                    const columnOrderCopy = [
                        ...columnOrder
                    ];
                    // If there is an order, make a copy of the columns
                    const columnsCopy = [
                        ...columns
                    ];
                    // And make a new ordered array of the columns
                    // Loop over the columns and place them in order into the new array
                    while(columnsCopy.length && columnOrderCopy.length){
                        const targetColumnId = columnOrderCopy.shift();
                        const foundIndex = columnsCopy.findIndex((d)=>d.id === targetColumnId);
                        if (foundIndex > -1) orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
                    }
                    // If there are any columns left, add them to the end
                    orderedColumns = [
                        ...orderedColumns,
                        ...columnsCopy
                    ];
                }
                return orderColumns(orderedColumns, grouping, groupedColumnMode);
            }, getMemoOptions(table.options, 'debugTable', '_getOrderColumnsFn'));
    }
};
//
const getDefaultColumnPinningState = ()=>({
        left: [],
        right: []
    });
const ColumnPinning = {
    getInitialState: (state)=>{
        return {
            columnPinning: getDefaultColumnPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnPinningChange: makeStateUpdater('columnPinning', table)
        };
    },
    createColumn: (column, table)=>{
        column.pin = (position)=>{
            const columnIds = column.getLeafColumns().map((d)=>d.id).filter(Boolean);
            table.setColumnPinning((old)=>{
                var _old$left3, _old$right3;
                if (position === 'right') {
                    var _old$left, _old$right;
                    return {
                        left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                        right: [
                            ...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ]
                    };
                }
                if (position === 'left') {
                    var _old$left2, _old$right2;
                    return {
                        left: [
                            ...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ],
                        right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                    };
                }
                return {
                    left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                    right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                };
            });
        };
        column.getCanPin = ()=>{
            const leafColumns = column.getLeafColumns();
            return leafColumns.some((d)=>{
                var _d$columnDef$enablePi, _ref, _table$options$enable;
                return ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_ref = (_table$options$enable = table.options.enableColumnPinning) != null ? _table$options$enable : table.options.enablePinning) != null ? _ref : true);
            });
        };
        column.getIsPinned = ()=>{
            const leafColumnIds = column.getLeafColumns().map((d)=>d.id);
            const { left, right } = table.getState().columnPinning;
            const isLeft = leafColumnIds.some((d)=>left == null ? void 0 : left.includes(d));
            const isRight = leafColumnIds.some((d)=>right == null ? void 0 : right.includes(d));
            return isLeft ? 'left' : isRight ? 'right' : false;
        };
        column.getPinnedIndex = ()=>{
            var _table$getState$colum, _table$getState$colum2;
            const position = column.getIsPinned();
            return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null || (_table$getState$colum2 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum2.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
        };
    },
    createRow: (row, table)=>{
        row.getCenterVisibleCells = memo(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allCells, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allCells.filter((d)=>!leftAndRight.includes(d.column.id));
        }, getMemoOptions(table.options, 'debugRows', 'getCenterVisibleCells'));
        row.getLeftVisibleCells = memo(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left
            ], (allCells, left)=>{
            const cells = (left != null ? left : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: 'left'
                }));
            return cells;
        }, getMemoOptions(table.options, 'debugRows', 'getLeftVisibleCells'));
        row.getRightVisibleCells = memo(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.right
            ], (allCells, right)=>{
            const cells = (right != null ? right : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: 'right'
                }));
            return cells;
        }, getMemoOptions(table.options, 'debugRows', 'getRightVisibleCells'));
    },
    createTable: (table)=>{
        table.setColumnPinning = (updater)=>table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater);
        table.resetColumnPinning = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            return table.setColumnPinning(defaultState ? getDefaultColumnPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : getDefaultColumnPinningState());
        };
        table.getIsSomeColumnsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().columnPinning;
            if (!position) {
                var _pinningState$left, _pinningState$right;
                return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table.getLeftLeafColumns = memo(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, left)=>{
            return (left != null ? left : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, getMemoOptions(table.options, 'debugColumns', 'getLeftLeafColumns'));
        table.getRightLeafColumns = memo(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, right)=>{
            return (right != null ? right : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, getMemoOptions(table.options, 'debugColumns', 'getRightLeafColumns'));
        table.getCenterLeafColumns = memo(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allColumns.filter((d)=>!leftAndRight.includes(d.id));
        }, getMemoOptions(table.options, 'debugColumns', 'getCenterLeafColumns'));
    }
};
function safelyAccessDocument(_document) {
    return _document || (typeof document !== 'undefined' ? document : null);
}
//
//
const defaultColumnSizing = {
    size: 150,
    minSize: 20,
    maxSize: Number.MAX_SAFE_INTEGER
};
const getDefaultColumnSizingInfoState = ()=>({
        startOffset: null,
        startSize: null,
        deltaOffset: null,
        deltaPercentage: null,
        isResizingColumn: false,
        columnSizingStart: []
    });
const ColumnSizing = {
    getDefaultColumnDef: ()=>{
        return defaultColumnSizing;
    },
    getInitialState: (state)=>{
        return {
            columnSizing: {},
            columnSizingInfo: getDefaultColumnSizingInfoState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            columnResizeMode: 'onEnd',
            columnResizeDirection: 'ltr',
            onColumnSizingChange: makeStateUpdater('columnSizing', table),
            onColumnSizingInfoChange: makeStateUpdater('columnSizingInfo', table)
        };
    },
    createColumn: (column, table)=>{
        column.getSize = ()=>{
            var _column$columnDef$min, _ref, _column$columnDef$max;
            const columnSize = table.getState().columnSizing[column.id];
            return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : defaultColumnSizing.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : defaultColumnSizing.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : defaultColumnSizing.maxSize);
        };
        column.getStart = memo((position)=>[
                position,
                _getVisibleLeafColumns(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(0, column.getIndex(position)).reduce((sum, column)=>sum + column.getSize(), 0), getMemoOptions(table.options, 'debugColumns', 'getStart'));
        column.getAfter = memo((position)=>[
                position,
                _getVisibleLeafColumns(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(column.getIndex(position) + 1).reduce((sum, column)=>sum + column.getSize(), 0), getMemoOptions(table.options, 'debugColumns', 'getAfter'));
        column.resetSize = ()=>{
            table.setColumnSizing((_ref2)=>{
                let { [column.id]: _, ...rest } = _ref2;
                return rest;
            });
        };
        column.getCanResize = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
        };
        column.getIsResizing = ()=>{
            return table.getState().columnSizingInfo.isResizingColumn === column.id;
        };
    },
    createHeader: (header, table)=>{
        header.getSize = ()=>{
            let sum = 0;
            const recurse = (header)=>{
                if (header.subHeaders.length) header.subHeaders.forEach(recurse);
                else {
                    var _header$column$getSiz;
                    sum += (_header$column$getSiz = header.column.getSize()) != null ? _header$column$getSiz : 0;
                }
            };
            recurse(header);
            return sum;
        };
        header.getStart = ()=>{
            if (header.index > 0) {
                const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
                return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
            }
            return 0;
        };
        header.getResizeHandler = (_contextDocument)=>{
            const column = table.getColumn(header.column.id);
            const canResize = column == null ? void 0 : column.getCanResize();
            return (e)=>{
                if (!column || !canResize) return;
                e.persist == null || e.persist();
                if (isTouchStartEvent(e)) {
                    // lets not respond to multiple touches (e.g. 2 or 3 fingers)
                    if (e.touches && e.touches.length > 1) return;
                }
                const startSize = header.getSize();
                const columnSizingStart = header ? header.getLeafHeaders().map((d)=>[
                        d.column.id,
                        d.column.getSize()
                    ]) : [
                    [
                        column.id,
                        column.getSize()
                    ]
                ];
                const clientX = isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;
                const newColumnSizing = {};
                const updateOffset = (eventType, clientXPos)=>{
                    if (typeof clientXPos !== 'number') return;
                    table.setColumnSizingInfo((old)=>{
                        var _old$startOffset, _old$startSize;
                        const deltaDirection = table.options.columnResizeDirection === 'rtl' ? -1 : 1;
                        const deltaOffset = (clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0)) * deltaDirection;
                        const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
                        old.columnSizingStart.forEach((_ref3)=>{
                            let [columnId, headerSize] = _ref3;
                            newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
                        });
                        return {
                            ...old,
                            deltaOffset,
                            deltaPercentage
                        };
                    });
                    if (table.options.columnResizeMode === 'onChange' || eventType === 'end') table.setColumnSizing((old)=>({
                            ...old,
                            ...newColumnSizing
                        }));
                };
                const onMove = (clientXPos)=>updateOffset('move', clientXPos);
                const onEnd = (clientXPos)=>{
                    updateOffset('end', clientXPos);
                    table.setColumnSizingInfo((old)=>({
                            ...old,
                            isResizingColumn: false,
                            startOffset: null,
                            startSize: null,
                            deltaOffset: null,
                            deltaPercentage: null,
                            columnSizingStart: []
                        }));
                };
                const contextDocument = safelyAccessDocument(_contextDocument);
                const mouseEvents = {
                    moveHandler: (e)=>onMove(e.clientX),
                    upHandler: (e)=>{
                        contextDocument == null || contextDocument.removeEventListener('mousemove', mouseEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener('mouseup', mouseEvents.upHandler);
                        onEnd(e.clientX);
                    }
                };
                const touchEvents = {
                    moveHandler: (e)=>{
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onMove(e.touches[0].clientX);
                        return false;
                    },
                    upHandler: (e)=>{
                        var _e$touches$;
                        contextDocument == null || contextDocument.removeEventListener('touchmove', touchEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener('touchend', touchEvents.upHandler);
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onEnd((_e$touches$ = e.touches[0]) == null ? void 0 : _e$touches$.clientX);
                    }
                };
                const passiveIfSupported = passiveEventSupported() ? {
                    passive: false
                } : false;
                if (isTouchStartEvent(e)) {
                    contextDocument == null || contextDocument.addEventListener('touchmove', touchEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener('touchend', touchEvents.upHandler, passiveIfSupported);
                } else {
                    contextDocument == null || contextDocument.addEventListener('mousemove', mouseEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener('mouseup', mouseEvents.upHandler, passiveIfSupported);
                }
                table.setColumnSizingInfo((old)=>({
                        ...old,
                        startOffset: clientX,
                        startSize,
                        deltaOffset: 0,
                        deltaPercentage: 0,
                        columnSizingStart,
                        isResizingColumn: column.id
                    }));
            };
        };
    },
    createTable: (table)=>{
        table.setColumnSizing = (updater)=>table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater);
        table.setColumnSizingInfo = (updater)=>table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater);
        table.resetColumnSizing = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
        };
        table.resetHeaderSizeInfo = (defaultState)=>{
            var _table$initialState$c2;
            table.setColumnSizingInfo(defaultState ? getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : getDefaultColumnSizingInfoState());
        };
        table.getTotalSize = ()=>{
            var _table$getHeaderGroup, _table$getHeaderGroup2;
            return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getHeaderGroup : 0;
        };
        table.getLeftTotalSize = ()=>{
            var _table$getLeftHeaderG, _table$getLeftHeaderG2;
            return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getLeftHeaderG : 0;
        };
        table.getCenterTotalSize = ()=>{
            var _table$getCenterHeade, _table$getCenterHeade2;
            return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getCenterHeade : 0;
        };
        table.getRightTotalSize = ()=>{
            var _table$getRightHeader, _table$getRightHeader2;
            return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getRightHeader : 0;
        };
    }
};
let passiveSupported = null;
function passiveEventSupported() {
    if (typeof passiveSupported === 'boolean') return passiveSupported;
    let supported = false;
    try {
        const options = {
            get passive () {
                supported = true;
                return false;
            }
        };
        const noop = ()=>{};
        window.addEventListener('test', noop, options);
        window.removeEventListener('test', noop);
    } catch (err) {
        supported = false;
    }
    passiveSupported = supported;
    return passiveSupported;
}
function isTouchStartEvent(e) {
    return e.type === 'touchstart';
}
//
const ColumnVisibility = {
    getInitialState: (state)=>{
        return {
            columnVisibility: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnVisibilityChange: makeStateUpdater('columnVisibility', table)
        };
    },
    createColumn: (column, table)=>{
        column.toggleVisibility = (value)=>{
            if (column.getCanHide()) table.setColumnVisibility((old)=>({
                    ...old,
                    [column.id]: value != null ? value : !column.getIsVisible()
                }));
        };
        column.getIsVisible = ()=>{
            var _ref, _table$getState$colum;
            const childColumns = column.columns;
            return (_ref = childColumns.length ? childColumns.some((c)=>c.getIsVisible()) : (_table$getState$colum = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum[column.id]) != null ? _ref : true;
        };
        column.getCanHide = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
        };
        column.getToggleVisibilityHandler = ()=>{
            return (e)=>{
                column.toggleVisibility == null || column.toggleVisibility(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row._getAllVisibleCells = memo(()=>[
                row.getAllCells(),
                table.getState().columnVisibility
            ], (cells)=>{
            return cells.filter((cell)=>cell.column.getIsVisible());
        }, getMemoOptions(table.options, 'debugRows', '_getAllVisibleCells'));
        row.getVisibleCells = memo(()=>[
                row.getLeftVisibleCells(),
                row.getCenterVisibleCells(),
                row.getRightVisibleCells()
            ], (left, center, right)=>[
                ...left,
                ...center,
                ...right
            ], getMemoOptions(table.options, 'debugRows', 'getVisibleCells'));
    },
    createTable: (table)=>{
        const makeVisibleColumnsMethod = (key, getColumns)=>{
            return memo(()=>[
                    getColumns(),
                    getColumns().filter((d)=>d.getIsVisible()).map((d)=>d.id).join('_')
                ], (columns)=>{
                return columns.filter((d)=>d.getIsVisible == null ? void 0 : d.getIsVisible());
            }, getMemoOptions(table.options, 'debugColumns', key));
        };
        table.getVisibleFlatColumns = makeVisibleColumnsMethod('getVisibleFlatColumns', ()=>table.getAllFlatColumns());
        table.getVisibleLeafColumns = makeVisibleColumnsMethod('getVisibleLeafColumns', ()=>table.getAllLeafColumns());
        table.getLeftVisibleLeafColumns = makeVisibleColumnsMethod('getLeftVisibleLeafColumns', ()=>table.getLeftLeafColumns());
        table.getRightVisibleLeafColumns = makeVisibleColumnsMethod('getRightVisibleLeafColumns', ()=>table.getRightLeafColumns());
        table.getCenterVisibleLeafColumns = makeVisibleColumnsMethod('getCenterVisibleLeafColumns', ()=>table.getCenterLeafColumns());
        table.setColumnVisibility = (updater)=>table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater);
        table.resetColumnVisibility = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
        };
        table.toggleAllColumnsVisible = (value)=>{
            var _value;
            value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
            table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column)=>({
                    ...obj,
                    [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value
                }), {}));
        };
        table.getIsAllColumnsVisible = ()=>!table.getAllLeafColumns().some((column)=>!(column.getIsVisible != null && column.getIsVisible()));
        table.getIsSomeColumnsVisible = ()=>table.getAllLeafColumns().some((column)=>column.getIsVisible == null ? void 0 : column.getIsVisible());
        table.getToggleAllColumnsVisibilityHandler = ()=>{
            return (e)=>{
                var _target;
                table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
function _getVisibleLeafColumns(table, position) {
    return !position ? table.getVisibleLeafColumns() : position === 'center' ? table.getCenterVisibleLeafColumns() : position === 'left' ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
}
//
const GlobalFaceting = {
    createTable: (table)=>{
        table._getGlobalFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, '__global__');
        table.getGlobalFacetedRowModel = ()=>{
            if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) return table.getPreFilteredRowModel();
            return table._getGlobalFacetedRowModel();
        };
        table._getGlobalFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, '__global__');
        table.getGlobalFacetedUniqueValues = ()=>{
            if (!table._getGlobalFacetedUniqueValues) return new Map();
            return table._getGlobalFacetedUniqueValues();
        };
        table._getGlobalFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, '__global__');
        table.getGlobalFacetedMinMaxValues = ()=>{
            if (!table._getGlobalFacetedMinMaxValues) return;
            return table._getGlobalFacetedMinMaxValues();
        };
    }
};
//
const GlobalFiltering = {
    getInitialState: (state)=>{
        return {
            globalFilter: undefined,
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGlobalFilterChange: makeStateUpdater('globalFilter', table),
            globalFilterFn: 'auto',
            getColumnCanGlobalFilter: (column)=>{
                var _table$getCoreRowMode;
                const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null || (_table$getCoreRowMode = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode.getValue();
                return typeof value === 'string' || typeof value === 'number';
            }
        };
    },
    createColumn: (column, table)=>{
        column.getCanGlobalFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2, _table$options$getCol;
            return ((_column$columnDef$ena = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGlobalFilter) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
        };
    },
    createTable: (table)=>{
        table.getGlobalAutoFilterFn = ()=>{
            return filterFns.includesString;
        };
        table.getGlobalFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            const { globalFilterFn: globalFilterFn } = table.options;
            return isFunction(globalFilterFn) ? globalFilterFn : globalFilterFn === 'auto' ? table.getGlobalAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[globalFilterFn]) != null ? _table$options$filter : filterFns[globalFilterFn];
        };
        table.setGlobalFilter = (updater)=>{
            table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
        };
        table.resetGlobalFilter = (defaultState)=>{
            table.setGlobalFilter(defaultState ? undefined : table.initialState.globalFilter);
        };
    }
};
//
const RowExpanding = {
    getInitialState: (state)=>{
        return {
            expanded: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onExpandedChange: makeStateUpdater('expanded', table),
            paginateExpandedRows: true
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetExpanded = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetExpanded();
                    queued = false;
                });
            }
        };
        table.setExpanded = (updater)=>table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater);
        table.toggleAllRowsExpanded = (expanded)=>{
            if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) table.setExpanded(true);
            else table.setExpanded({});
        };
        table.resetExpanded = (defaultState)=>{
            var _table$initialState$e, _table$initialState;
            table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
        };
        table.getCanSomeRowsExpand = ()=>{
            return table.getPrePaginationRowModel().flatRows.some((row)=>row.getCanExpand());
        };
        table.getToggleAllRowsExpandedHandler = ()=>{
            return (e)=>{
                e.persist == null || e.persist();
                table.toggleAllRowsExpanded();
            };
        };
        table.getIsSomeRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            return expanded === true || Object.values(expanded).some(Boolean);
        };
        table.getIsAllRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            // If expanded is true, save some cycles and return true
            if (typeof expanded === 'boolean') return expanded === true;
            if (!Object.keys(expanded).length) return false;
            // If any row is not expanded, return false
            if (table.getRowModel().flatRows.some((row)=>!row.getIsExpanded())) return false;
            // They must all be expanded :shrug:
            return true;
        };
        table.getExpandedDepth = ()=>{
            let maxDepth = 0;
            const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
            rowIds.forEach((id)=>{
                const splitId = id.split('.');
                maxDepth = Math.max(maxDepth, splitId.length);
            });
            return maxDepth;
        };
        table.getPreExpandedRowModel = ()=>table.getSortedRowModel();
        table.getExpandedRowModel = ()=>{
            if (!table._getExpandedRowModel && table.options.getExpandedRowModel) table._getExpandedRowModel = table.options.getExpandedRowModel(table);
            if (table.options.manualExpanding || !table._getExpandedRowModel) return table.getPreExpandedRowModel();
            return table._getExpandedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.toggleExpanded = (expanded)=>{
            table.setExpanded((old)=>{
                var _expanded;
                const exists = old === true ? true : !!(old != null && old[row.id]);
                let oldExpanded = {};
                if (old === true) Object.keys(table.getRowModel().rowsById).forEach((rowId)=>{
                    oldExpanded[rowId] = true;
                });
                else oldExpanded = old;
                expanded = (_expanded = expanded) != null ? _expanded : !exists;
                if (!exists && expanded) return {
                    ...oldExpanded,
                    [row.id]: true
                };
                if (exists && !expanded) {
                    const { [row.id]: _, ...rest } = oldExpanded;
                    return rest;
                }
                return old;
            });
        };
        row.getIsExpanded = ()=>{
            var _table$options$getIsR;
            const expanded = table.getState().expanded;
            return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
        };
        row.getCanExpand = ()=>{
            var _table$options$getRow, _table$options$enable, _row$subRows;
            return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
        row.getIsAllParentsExpanded = ()=>{
            let isFullyExpanded = true;
            let currentRow = row;
            while(isFullyExpanded && currentRow.parentId){
                currentRow = table.getRow(currentRow.parentId, true);
                isFullyExpanded = currentRow.getIsExpanded();
            }
            return isFullyExpanded;
        };
        row.getToggleExpandedHandler = ()=>{
            const canExpand = row.getCanExpand();
            return ()=>{
                if (!canExpand) return;
                row.toggleExpanded();
            };
        };
    }
};
//
const defaultPageIndex = 0;
const defaultPageSize = 10;
const getDefaultPaginationState = ()=>({
        pageIndex: defaultPageIndex,
        pageSize: defaultPageSize
    });
const RowPagination = {
    getInitialState: (state)=>{
        return {
            ...state,
            pagination: {
                ...getDefaultPaginationState(),
                ...state == null ? void 0 : state.pagination
            }
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onPaginationChange: makeStateUpdater('pagination', table)
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetPageIndex = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetPageIndex();
                    queued = false;
                });
            }
        };
        table.setPagination = (updater)=>{
            const safeUpdater = (old)=>{
                let newState = functionalUpdate(updater, old);
                return newState;
            };
            return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
        };
        table.resetPagination = (defaultState)=>{
            var _table$initialState$p;
            table.setPagination(defaultState ? getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : getDefaultPaginationState());
        };
        table.setPageIndex = (updater)=>{
            table.setPagination((old)=>{
                let pageIndex = functionalUpdate(updater, old.pageIndex);
                const maxPageIndex = typeof table.options.pageCount === 'undefined' || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
                pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
                return {
                    ...old,
                    pageIndex
                };
            });
        };
        table.resetPageIndex = (defaultState)=>{
            var _table$initialState$p2, _table$initialState;
            table.setPageIndex(defaultState ? defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null || (_table$initialState = _table$initialState.pagination) == null ? void 0 : _table$initialState.pageIndex) != null ? _table$initialState$p2 : defaultPageIndex);
        };
        table.resetPageSize = (defaultState)=>{
            var _table$initialState$p3, _table$initialState2;
            table.setPageSize(defaultState ? defaultPageSize : (_table$initialState$p3 = (_table$initialState2 = table.initialState) == null || (_table$initialState2 = _table$initialState2.pagination) == null ? void 0 : _table$initialState2.pageSize) != null ? _table$initialState$p3 : defaultPageSize);
        };
        table.setPageSize = (updater)=>{
            table.setPagination((old)=>{
                const pageSize = Math.max(1, functionalUpdate(updater, old.pageSize));
                const topRowIndex = old.pageSize * old.pageIndex;
                const pageIndex = Math.floor(topRowIndex / pageSize);
                return {
                    ...old,
                    pageIndex,
                    pageSize
                };
            });
        };
        //deprecated
        table.setPageCount = (updater)=>table.setPagination((old)=>{
                var _table$options$pageCo;
                let newPageCount = functionalUpdate(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
                if (typeof newPageCount === 'number') newPageCount = Math.max(-1, newPageCount);
                return {
                    ...old,
                    pageCount: newPageCount
                };
            });
        table.getPageOptions = memo(()=>[
                table.getPageCount()
            ], (pageCount)=>{
            let pageOptions = [];
            if (pageCount && pageCount > 0) pageOptions = [
                ...new Array(pageCount)
            ].fill(null).map((_, i)=>i);
            return pageOptions;
        }, getMemoOptions(table.options, 'debugTable', 'getPageOptions'));
        table.getCanPreviousPage = ()=>table.getState().pagination.pageIndex > 0;
        table.getCanNextPage = ()=>{
            const { pageIndex } = table.getState().pagination;
            const pageCount = table.getPageCount();
            if (pageCount === -1) return true;
            if (pageCount === 0) return false;
            return pageIndex < pageCount - 1;
        };
        table.previousPage = ()=>{
            return table.setPageIndex((old)=>old - 1);
        };
        table.nextPage = ()=>{
            return table.setPageIndex((old)=>{
                return old + 1;
            });
        };
        table.firstPage = ()=>{
            return table.setPageIndex(0);
        };
        table.lastPage = ()=>{
            return table.setPageIndex(table.getPageCount() - 1);
        };
        table.getPrePaginationRowModel = ()=>table.getExpandedRowModel();
        table.getPaginationRowModel = ()=>{
            if (!table._getPaginationRowModel && table.options.getPaginationRowModel) table._getPaginationRowModel = table.options.getPaginationRowModel(table);
            if (table.options.manualPagination || !table._getPaginationRowModel) return table.getPrePaginationRowModel();
            return table._getPaginationRowModel();
        };
        table.getPageCount = ()=>{
            var _table$options$pageCo2;
            return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getRowCount() / table.getState().pagination.pageSize);
        };
        table.getRowCount = ()=>{
            var _table$options$rowCou;
            return (_table$options$rowCou = table.options.rowCount) != null ? _table$options$rowCou : table.getPrePaginationRowModel().rows.length;
        };
    }
};
//
const getDefaultRowPinningState = ()=>({
        top: [],
        bottom: []
    });
const RowPinning = {
    getInitialState: (state)=>{
        return {
            rowPinning: getDefaultRowPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowPinningChange: makeStateUpdater('rowPinning', table)
        };
    },
    createRow: (row, table)=>{
        row.pin = (position, includeLeafRows, includeParentRows)=>{
            const leafRowIds = includeLeafRows ? row.getLeafRows().map((_ref)=>{
                let { id } = _ref;
                return id;
            }) : [];
            const parentRowIds = includeParentRows ? row.getParentRows().map((_ref2)=>{
                let { id } = _ref2;
                return id;
            }) : [];
            const rowIds = new Set([
                ...parentRowIds,
                row.id,
                ...leafRowIds
            ]);
            table.setRowPinning((old)=>{
                var _old$top3, _old$bottom3;
                if (position === 'bottom') {
                    var _old$top, _old$bottom;
                    return {
                        top: ((_old$top = old == null ? void 0 : old.top) != null ? _old$top : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                        bottom: [
                            ...((_old$bottom = old == null ? void 0 : old.bottom) != null ? _old$bottom : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ]
                    };
                }
                if (position === 'top') {
                    var _old$top2, _old$bottom2;
                    return {
                        top: [
                            ...((_old$top2 = old == null ? void 0 : old.top) != null ? _old$top2 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ],
                        bottom: ((_old$bottom2 = old == null ? void 0 : old.bottom) != null ? _old$bottom2 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                    };
                }
                return {
                    top: ((_old$top3 = old == null ? void 0 : old.top) != null ? _old$top3 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                    bottom: ((_old$bottom3 = old == null ? void 0 : old.bottom) != null ? _old$bottom3 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                };
            });
        };
        row.getCanPin = ()=>{
            var _ref3;
            const { enableRowPinning, enablePinning } = table.options;
            if (typeof enableRowPinning === 'function') return enableRowPinning(row);
            return (_ref3 = enableRowPinning != null ? enableRowPinning : enablePinning) != null ? _ref3 : true;
        };
        row.getIsPinned = ()=>{
            const rowIds = [
                row.id
            ];
            const { top, bottom } = table.getState().rowPinning;
            const isTop = rowIds.some((d)=>top == null ? void 0 : top.includes(d));
            const isBottom = rowIds.some((d)=>bottom == null ? void 0 : bottom.includes(d));
            return isTop ? 'top' : isBottom ? 'bottom' : false;
        };
        row.getPinnedIndex = ()=>{
            var _ref4, _visiblePinnedRowIds$;
            const position = row.getIsPinned();
            if (!position) return -1;
            const visiblePinnedRowIds = (_ref4 = position === 'top' ? table.getTopRows() : table.getBottomRows()) == null ? void 0 : _ref4.map((_ref5)=>{
                let { id } = _ref5;
                return id;
            });
            return (_visiblePinnedRowIds$ = visiblePinnedRowIds == null ? void 0 : visiblePinnedRowIds.indexOf(row.id)) != null ? _visiblePinnedRowIds$ : -1;
        };
    },
    createTable: (table)=>{
        table.setRowPinning = (updater)=>table.options.onRowPinningChange == null ? void 0 : table.options.onRowPinningChange(updater);
        table.resetRowPinning = (defaultState)=>{
            var _table$initialState$r, _table$initialState;
            return table.setRowPinning(defaultState ? getDefaultRowPinningState() : (_table$initialState$r = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.rowPinning) != null ? _table$initialState$r : getDefaultRowPinningState());
        };
        table.getIsSomeRowsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().rowPinning;
            if (!position) {
                var _pinningState$top, _pinningState$bottom;
                return Boolean(((_pinningState$top = pinningState.top) == null ? void 0 : _pinningState$top.length) || ((_pinningState$bottom = pinningState.bottom) == null ? void 0 : _pinningState$bottom.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table._getPinnedRows = (visibleRows, pinnedRowIds, position)=>{
            var _table$options$keepPi;
            const rows = ((_table$options$keepPi = table.options.keepPinnedRows) != null ? _table$options$keepPi : true) ? //get all rows that are pinned even if they would not be otherwise visible
            //account for expanded parent rows, but not pagination or filtering
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>{
                const row = table.getRow(rowId, true);
                return row.getIsAllParentsExpanded() ? row : null;
            }) : //else get only visible rows that are pinned
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>visibleRows.find((row)=>row.id === rowId));
            return rows.filter(Boolean).map((d)=>({
                    ...d,
                    position
                }));
        };
        table.getTopRows = memo(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top
            ], (allRows, topPinnedRowIds)=>table._getPinnedRows(allRows, topPinnedRowIds, 'top'), getMemoOptions(table.options, 'debugRows', 'getTopRows'));
        table.getBottomRows = memo(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.bottom
            ], (allRows, bottomPinnedRowIds)=>table._getPinnedRows(allRows, bottomPinnedRowIds, 'bottom'), getMemoOptions(table.options, 'debugRows', 'getBottomRows'));
        table.getCenterRows = memo(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top,
                table.getState().rowPinning.bottom
            ], (allRows, top, bottom)=>{
            const topAndBottom = new Set([
                ...top != null ? top : [],
                ...bottom != null ? bottom : []
            ]);
            return allRows.filter((d)=>!topAndBottom.has(d.id));
        }, getMemoOptions(table.options, 'debugRows', 'getCenterRows'));
    }
};
//
const RowSelection = {
    getInitialState: (state)=>{
        return {
            rowSelection: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowSelectionChange: makeStateUpdater('rowSelection', table),
            enableRowSelection: true,
            enableMultiRowSelection: true,
            enableSubRowSelection: true
        };
    },
    createTable: (table)=>{
        table.setRowSelection = (updater)=>table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater);
        table.resetRowSelection = (defaultState)=>{
            var _table$initialState$r;
            return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
        };
        table.toggleAllRowsSelected = (value)=>{
            table.setRowSelection((old)=>{
                value = typeof value !== 'undefined' ? value : !table.getIsAllRowsSelected();
                const rowSelection = {
                    ...old
                };
                const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
                // We don't use `mutateRowIsSelected` here for performance reasons.
                // All of the rows are flat already, so it wouldn't be worth it
                if (value) preGroupedFlatRows.forEach((row)=>{
                    if (!row.getCanSelect()) return;
                    rowSelection[row.id] = true;
                });
                else preGroupedFlatRows.forEach((row)=>{
                    delete rowSelection[row.id];
                });
                return rowSelection;
            });
        };
        table.toggleAllPageRowsSelected = (value)=>table.setRowSelection((old)=>{
                const resolvedValue = typeof value !== 'undefined' ? value : !table.getIsAllPageRowsSelected();
                const rowSelection = {
                    ...old
                };
                table.getRowModel().rows.forEach((row)=>{
                    mutateRowIsSelected(rowSelection, row.id, resolvedValue, true, table);
                });
                return rowSelection;
            });
        // addRowSelectionRange: rowId => {
        //   const {
        //     rows,
        //     rowsById,
        //     options: { selectGroupingRows, selectSubRows },
        //   } = table
        //   const findSelectedRow = (rows: Row[]) => {
        //     let found
        //     rows.find(d => {
        //       if (d.getIsSelected()) {
        //         found = d
        //         return true
        //       }
        //       const subFound = findSelectedRow(d.subRows || [])
        //       if (subFound) {
        //         found = subFound
        //         return true
        //       }
        //       return false
        //     })
        //     return found
        //   }
        //   const firstRow = findSelectedRow(rows) || rows[0]
        //   const lastRow = rowsById[rowId]
        //   let include = false
        //   const selectedRowIds = {}
        //   const addRow = (row: Row) => {
        //     mutateRowIsSelected(selectedRowIds, row.id, true, {
        //       rowsById,
        //       selectGroupingRows: selectGroupingRows!,
        //       selectSubRows: selectSubRows!,
        //     })
        //   }
        //   table.rows.forEach(row => {
        //     const isFirstRow = row.id === firstRow.id
        //     const isLastRow = row.id === lastRow.id
        //     if (isFirstRow || isLastRow) {
        //       if (!include) {
        //         include = true
        //       } else if (include) {
        //         addRow(row)
        //         include = false
        //       }
        //     }
        //     if (include) {
        //       addRow(row)
        //     }
        //   })
        //   table.setRowSelection(selectedRowIds)
        // },
        table.getPreSelectedRowModel = ()=>table.getCoreRowModel();
        table.getSelectedRowModel = memo(()=>[
                table.getState().rowSelection,
                table.getCoreRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return selectRowsFn(table, rowModel);
        }, getMemoOptions(table.options, 'debugTable', 'getSelectedRowModel'));
        table.getFilteredSelectedRowModel = memo(()=>[
                table.getState().rowSelection,
                table.getFilteredRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return selectRowsFn(table, rowModel);
        }, getMemoOptions(table.options, 'debugTable', 'getFilteredSelectedRowModel'));
        table.getGroupedSelectedRowModel = memo(()=>[
                table.getState().rowSelection,
                table.getSortedRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return selectRowsFn(table, rowModel);
        }, getMemoOptions(table.options, 'debugTable', 'getGroupedSelectedRowModel'));
        ///
        // getGroupingRowCanSelect: rowId => {
        //   const row = table.getRow(rowId)
        //   if (!row) {
        //     throw new Error()
        //   }
        //   if (typeof table.options.enableGroupingRowSelection === 'function') {
        //     return table.options.enableGroupingRowSelection(row)
        //   }
        //   return table.options.enableGroupingRowSelection ?? false
        // },
        table.getIsAllRowsSelected = ()=>{
            const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
            const { rowSelection } = table.getState();
            let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
            if (isAllRowsSelected) {
                if (preGroupedFlatRows.some((row)=>row.getCanSelect() && !rowSelection[row.id])) isAllRowsSelected = false;
            }
            return isAllRowsSelected;
        };
        table.getIsAllPageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows.filter((row)=>row.getCanSelect());
            const { rowSelection } = table.getState();
            let isAllPageRowsSelected = !!paginationFlatRows.length;
            if (isAllPageRowsSelected && paginationFlatRows.some((row)=>!rowSelection[row.id])) isAllPageRowsSelected = false;
            return isAllPageRowsSelected;
        };
        table.getIsSomeRowsSelected = ()=>{
            var _table$getState$rowSe;
            const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
            return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
        };
        table.getIsSomePageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows;
            return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.filter((row)=>row.getCanSelect()).some((d)=>d.getIsSelected() || d.getIsSomeSelected());
        };
        table.getToggleAllRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllRowsSelected(e.target.checked);
            };
        };
        table.getToggleAllPageRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllPageRowsSelected(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row.toggleSelected = (value, opts)=>{
            const isSelected = row.getIsSelected();
            table.setRowSelection((old)=>{
                var _opts$selectChildren;
                value = typeof value !== 'undefined' ? value : !isSelected;
                if (row.getCanSelect() && isSelected === value) return old;
                const selectedRowIds = {
                    ...old
                };
                mutateRowIsSelected(selectedRowIds, row.id, value, (_opts$selectChildren = opts == null ? void 0 : opts.selectChildren) != null ? _opts$selectChildren : true, table);
                return selectedRowIds;
            });
        };
        row.getIsSelected = ()=>{
            const { rowSelection } = table.getState();
            return isRowSelected(row, rowSelection);
        };
        row.getIsSomeSelected = ()=>{
            const { rowSelection } = table.getState();
            return isSubRowSelected(row, rowSelection) === 'some';
        };
        row.getIsAllSubRowsSelected = ()=>{
            const { rowSelection } = table.getState();
            return isSubRowSelected(row, rowSelection) === 'all';
        };
        row.getCanSelect = ()=>{
            var _table$options$enable;
            if (typeof table.options.enableRowSelection === 'function') return table.options.enableRowSelection(row);
            return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
        };
        row.getCanSelectSubRows = ()=>{
            var _table$options$enable2;
            if (typeof table.options.enableSubRowSelection === 'function') return table.options.enableSubRowSelection(row);
            return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
        };
        row.getCanMultiSelect = ()=>{
            var _table$options$enable3;
            if (typeof table.options.enableMultiRowSelection === 'function') return table.options.enableMultiRowSelection(row);
            return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
        };
        row.getToggleSelectedHandler = ()=>{
            const canSelect = row.getCanSelect();
            return (e)=>{
                var _target;
                if (!canSelect) return;
                row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
const mutateRowIsSelected = (selectedRowIds, id, value, includeChildren, table)=>{
    var _row$subRows;
    const row = table.getRow(id, true);
    // const isGrouped = row.getIsGrouped()
    // if ( // TODO: enforce grouping row selection rules
    //   !isGrouped ||
    //   (isGrouped && table.options.enableGroupingRowSelection)
    // ) {
    if (value) {
        if (!row.getCanMultiSelect()) Object.keys(selectedRowIds).forEach((key)=>delete selectedRowIds[key]);
        if (row.getCanSelect()) selectedRowIds[id] = true;
    } else delete selectedRowIds[id];
    // }
    if (includeChildren && (_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) row.subRows.forEach((row)=>mutateRowIsSelected(selectedRowIds, row.id, value, includeChildren, table));
};
function selectRowsFn(table, rowModel) {
    const rowSelection = table.getState().rowSelection;
    const newSelectedFlatRows = [];
    const newSelectedRowsById = {};
    // Filters top level and nested rows
    const recurseRows = function(rows, depth) {
        return rows.map((row)=>{
            var _row$subRows2;
            const isSelected = isRowSelected(row, rowSelection);
            if (isSelected) {
                newSelectedFlatRows.push(row);
                newSelectedRowsById[row.id] = row;
            }
            if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) row = {
                ...row,
                subRows: recurseRows(row.subRows)
            };
            if (isSelected) return row;
        }).filter(Boolean);
    };
    return {
        rows: recurseRows(rowModel.rows),
        flatRows: newSelectedFlatRows,
        rowsById: newSelectedRowsById
    };
}
function isRowSelected(row, selection) {
    var _selection$row$id;
    return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function isSubRowSelected(row, selection, table) {
    var _row$subRows3;
    if (!((_row$subRows3 = row.subRows) != null && _row$subRows3.length)) return false;
    let allChildrenSelected = true;
    let someSelected = false;
    row.subRows.forEach((subRow)=>{
        // Bail out early if we know both of these
        if (someSelected && !allChildrenSelected) return;
        if (subRow.getCanSelect()) {
            if (isRowSelected(subRow, selection)) someSelected = true;
            else allChildrenSelected = false;
        }
        // Check row selection of nested subrows
        if (subRow.subRows && subRow.subRows.length) {
            const subRowChildrenSelected = isSubRowSelected(subRow, selection);
            if (subRowChildrenSelected === 'all') someSelected = true;
            else if (subRowChildrenSelected === 'some') {
                someSelected = true;
                allChildrenSelected = false;
            } else allChildrenSelected = false;
        }
    });
    return allChildrenSelected ? 'all' : someSelected ? 'some' : false;
}
const reSplitAlphaNumeric = /([0-9]+)/gm;
const alphanumeric = (rowA, rowB, columnId)=>{
    return compareAlphanumeric(toString(rowA.getValue(columnId)).toLowerCase(), toString(rowB.getValue(columnId)).toLowerCase());
};
const alphanumericCaseSensitive = (rowA, rowB, columnId)=>{
    return compareAlphanumeric(toString(rowA.getValue(columnId)), toString(rowB.getValue(columnId)));
};
// The text filter is more basic (less numeric support)
// but is much faster
const text = (rowA, rowB, columnId)=>{
    return compareBasic(toString(rowA.getValue(columnId)).toLowerCase(), toString(rowB.getValue(columnId)).toLowerCase());
};
// The text filter is more basic (less numeric support)
// but is much faster
const textCaseSensitive = (rowA, rowB, columnId)=>{
    return compareBasic(toString(rowA.getValue(columnId)), toString(rowB.getValue(columnId)));
};
const datetime = (rowA, rowB, columnId)=>{
    const a = rowA.getValue(columnId);
    const b = rowB.getValue(columnId);
    // Can handle nullish values
    // Use > and < because == (and ===) doesn't work with
    // Date objects (would require calling getTime()).
    return a > b ? 1 : a < b ? -1 : 0;
};
const basic = (rowA, rowB, columnId)=>{
    return compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
// Utils
function compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
}
function toString(a) {
    if (typeof a === 'number') {
        if (isNaN(a) || a === Infinity || a === -Infinity) return '';
        return String(a);
    }
    if (typeof a === 'string') return a;
    return '';
}
// Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity
function compareAlphanumeric(aStr, bStr) {
    // Split on number groups, but keep the delimiter
    // Then remove falsey split values
    const a = aStr.split(reSplitAlphaNumeric).filter(Boolean);
    const b = bStr.split(reSplitAlphaNumeric).filter(Boolean);
    // While
    while(a.length && b.length){
        const aa = a.shift();
        const bb = b.shift();
        const an = parseInt(aa, 10);
        const bn = parseInt(bb, 10);
        const combo = [
            an,
            bn
        ].sort();
        // Both are string
        if (isNaN(combo[0])) {
            if (aa > bb) return 1;
            if (bb > aa) return -1;
            continue;
        }
        // One is a string, one is a number
        if (isNaN(combo[1])) return isNaN(an) ? -1 : 1;
        // Both are numbers
        if (an > bn) return 1;
        if (bn > an) return -1;
    }
    return a.length - b.length;
}
// Exports
const sortingFns = {
    alphanumeric,
    alphanumericCaseSensitive,
    text,
    textCaseSensitive,
    datetime,
    basic
};
//
const RowSorting = {
    getInitialState: (state)=>{
        return {
            sorting: [],
            ...state
        };
    },
    getDefaultColumnDef: ()=>{
        return {
            sortingFn: 'auto',
            sortUndefined: 1
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onSortingChange: makeStateUpdater('sorting', table),
            isMultiSortEvent: (e)=>{
                return e.shiftKey;
            }
        };
    },
    createColumn: (column, table)=>{
        column.getAutoSortingFn = ()=>{
            const firstRows = table.getFilteredRowModel().flatRows.slice(10);
            let isString = false;
            for (const row of firstRows){
                const value = row == null ? void 0 : row.getValue(column.id);
                if (Object.prototype.toString.call(value) === '[object Date]') return sortingFns.datetime;
                if (typeof value === 'string') {
                    isString = true;
                    if (value.split(reSplitAlphaNumeric).length > 1) return sortingFns.alphanumeric;
                }
            }
            if (isString) return sortingFns.text;
            return sortingFns.basic;
        };
        column.getAutoSortDir = ()=>{
            const firstRow = table.getFilteredRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === 'string') return 'asc';
            return 'desc';
        };
        column.getSortingFn = ()=>{
            var _table$options$sortin, _table$options$sortin2;
            if (!column) throw new Error();
            return isFunction(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === 'auto' ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : sortingFns[column.columnDef.sortingFn];
        };
        column.toggleSorting = (desc, multi)=>{
            // if (column.columns.length) {
            //   column.columns.forEach((c, i) => {
            //     if (c.id) {
            //       table.toggleColumnSorting(c.id, undefined, multi || !!i)
            //     }
            //   })
            //   return
            // }
            // this needs to be outside of table.setSorting to be in sync with rerender
            const nextSortingOrder = column.getNextSortingOrder();
            const hasManualValue = typeof desc !== 'undefined' && desc !== null;
            table.setSorting((old)=>{
                // Find any existing sorting for this column
                const existingSorting = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const existingIndex = old == null ? void 0 : old.findIndex((d)=>d.id === column.id);
                let newSorting = [];
                // What should we do with this sort action?
                let sortAction;
                let nextDesc = hasManualValue ? desc : nextSortingOrder === 'desc';
                // Multi-mode
                if (old != null && old.length && column.getCanMultiSort() && multi) {
                    if (existingSorting) sortAction = 'toggle';
                    else sortAction = 'add';
                } else {
                    // Normal mode
                    if (old != null && old.length && existingIndex !== old.length - 1) sortAction = 'replace';
                    else if (existingSorting) sortAction = 'toggle';
                    else sortAction = 'replace';
                }
                // Handle toggle states that will remove the sorting
                if (sortAction === 'toggle') {
                    // If we are "actually" toggling (not a manual set value), should we remove the sorting?
                    if (!hasManualValue) // Is our intention to remove?
                    {
                        if (!nextSortingOrder) sortAction = 'remove';
                    }
                }
                if (sortAction === 'add') {
                    var _table$options$maxMul;
                    newSorting = [
                        ...old,
                        {
                            id: column.id,
                            desc: nextDesc
                        }
                    ];
                    // Take latest n columns
                    newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
                } else if (sortAction === 'toggle') // This flips (or sets) the
                newSorting = old.map((d)=>{
                    if (d.id === column.id) return {
                        ...d,
                        desc: nextDesc
                    };
                    return d;
                });
                else if (sortAction === 'remove') newSorting = old.filter((d)=>d.id !== column.id);
                else newSorting = [
                    {
                        id: column.id,
                        desc: nextDesc
                    }
                ];
                return newSorting;
            });
        };
        column.getFirstSortDir = ()=>{
            var _ref, _column$columnDef$sor;
            const sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === 'desc';
            return sortDescFirst ? 'desc' : 'asc';
        };
        column.getNextSortingOrder = (multi)=>{
            var _table$options$enable, _table$options$enable2;
            const firstSortDirection = column.getFirstSortDir();
            const isSorted = column.getIsSorted();
            if (!isSorted) return firstSortDirection;
            if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && // If enableSortRemove, enable in general
            (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true // If multi, don't allow if enableMultiRemove))
            )) return false;
            return isSorted === 'desc' ? 'asc' : 'desc';
        };
        column.getCanSort = ()=>{
            var _column$columnDef$ena, _table$options$enable3;
            return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
        };
        column.getCanMultiSort = ()=>{
            var _ref2, _column$columnDef$ena2;
            return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
        };
        column.getIsSorted = ()=>{
            var _table$getState$sorti;
            const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find((d)=>d.id === column.id);
            return !columnSort ? false : columnSort.desc ? 'desc' : 'asc';
        };
        column.getSortIndex = ()=>{
            var _table$getState$sorti2, _table$getState$sorti3;
            return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$sorti2 : -1;
        };
        column.clearSorting = ()=>{
            //clear sorting for just 1 column
            table.setSorting((old)=>old != null && old.length ? old.filter((d)=>d.id !== column.id) : []);
        };
        column.getToggleSortingHandler = ()=>{
            const canSort = column.getCanSort();
            return (e)=>{
                if (!canSort) return;
                e.persist == null || e.persist();
                column.toggleSorting == null || column.toggleSorting(undefined, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e) : false);
            };
        };
    },
    createTable: (table)=>{
        table.setSorting = (updater)=>table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater);
        table.resetSorting = (defaultState)=>{
            var _table$initialState$s, _table$initialState;
            table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
        };
        table.getPreSortedRowModel = ()=>table.getGroupedRowModel();
        table.getSortedRowModel = ()=>{
            if (!table._getSortedRowModel && table.options.getSortedRowModel) table._getSortedRowModel = table.options.getSortedRowModel(table);
            if (table.options.manualSorting || !table._getSortedRowModel) return table.getPreSortedRowModel();
            return table._getSortedRowModel();
        };
    }
};
const builtInFeatures = [
    Headers,
    ColumnVisibility,
    ColumnOrdering,
    ColumnPinning,
    ColumnFaceting,
    ColumnFiltering,
    GlobalFaceting,
    //depends on ColumnFaceting
    GlobalFiltering,
    //depends on ColumnFiltering
    RowSorting,
    ColumnGrouping,
    //depends on RowSorting
    RowExpanding,
    RowPagination,
    RowPinning,
    RowSelection,
    ColumnSizing
];
//
function createTable(options) {
    var _options$_features, _options$initialState;
    const _features = [
        ...builtInFeatures,
        ...(_options$_features = options._features) != null ? _options$_features : []
    ];
    let table = {
        _features
    };
    const defaultOptions = table._features.reduce((obj, feature)=>{
        return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
    }, {});
    const mergeOptions = (options)=>{
        if (table.options.mergeOptions) return table.options.mergeOptions(defaultOptions, options);
        return {
            ...defaultOptions,
            ...options
        };
    };
    const coreInitialState = {};
    let initialState = {
        ...coreInitialState,
        ...(_options$initialState = options.initialState) != null ? _options$initialState : {}
    };
    table._features.forEach((feature)=>{
        var _feature$getInitialSt;
        initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
    });
    const queued = [];
    let queuedTimeout = false;
    const coreInstance = {
        _features,
        options: {
            ...defaultOptions,
            ...options
        },
        initialState,
        _queue: (cb)=>{
            queued.push(cb);
            if (!queuedTimeout) {
                queuedTimeout = true;
                // Schedule a microtask to run the queued callbacks after
                // the current call stack (render, etc) has finished.
                Promise.resolve().then(()=>{
                    while(queued.length)queued.shift()();
                    queuedTimeout = false;
                }).catch((error)=>setTimeout(()=>{
                        throw error;
                    }));
            }
        },
        reset: ()=>{
            table.setState(table.initialState);
        },
        setOptions: (updater)=>{
            const newOptions = functionalUpdate(updater, table.options);
            table.options = mergeOptions(newOptions);
        },
        getState: ()=>{
            return table.options.state;
        },
        setState: (updater)=>{
            table.options.onStateChange == null || table.options.onStateChange(updater);
        },
        _getRowId: (row, index, parent)=>{
            var _table$options$getRow;
            return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index, parent)) != null ? _table$options$getRow : `${parent ? [
                parent.id,
                index
            ].join('.') : index}`;
        },
        getCoreRowModel: ()=>{
            if (!table._getCoreRowModel) table._getCoreRowModel = table.options.getCoreRowModel(table);
            return table._getCoreRowModel();
        },
        // The final calls start at the bottom of the model,
        // expanded rows, which then work their way up
        getRowModel: ()=>{
            return table.getPaginationRowModel();
        },
        //in next version, we should just pass in the row model as the optional 2nd arg
        getRow: (id, searchAll)=>{
            let row = (searchAll ? table.getPrePaginationRowModel() : table.getRowModel()).rowsById[id];
            if (!row) {
                row = table.getCoreRowModel().rowsById[id];
                if (!row) throw new Error();
            }
            return row;
        },
        _getDefaultColumnDef: memo(()=>[
                table.options.defaultColumn
            ], (defaultColumn)=>{
            var _defaultColumn;
            defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
            return {
                header: (props)=>{
                    const resolvedColumnDef = props.header.column.columnDef;
                    if (resolvedColumnDef.accessorKey) return resolvedColumnDef.accessorKey;
                    if (resolvedColumnDef.accessorFn) return resolvedColumnDef.id;
                    return null;
                },
                // footer: props => props.header.column.id,
                cell: (props)=>{
                    var _props$renderValue$to, _props$renderValue;
                    return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null || _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
                },
                ...table._features.reduce((obj, feature)=>{
                    return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
                }, {}),
                ...defaultColumn
            };
        }, getMemoOptions(options, 'debugColumns', '_getDefaultColumnDef')),
        _getColumnDefs: ()=>table.options.columns,
        getAllColumns: memo(()=>[
                table._getColumnDefs()
            ], (columnDefs)=>{
            const recurseColumns = function(columnDefs, parent, depth) {
                if (depth === void 0) depth = 0;
                return columnDefs.map((columnDef)=>{
                    const column = createColumn(table, columnDef, depth, parent);
                    const groupingColumnDef = columnDef;
                    column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
                    return column;
                });
            };
            return recurseColumns(columnDefs);
        }, getMemoOptions(options, 'debugColumns', 'getAllColumns')),
        getAllFlatColumns: memo(()=>[
                table.getAllColumns()
            ], (allColumns)=>{
            return allColumns.flatMap((column)=>{
                return column.getFlatColumns();
            });
        }, getMemoOptions(options, 'debugColumns', 'getAllFlatColumns')),
        _getAllFlatColumnsById: memo(()=>[
                table.getAllFlatColumns()
            ], (flatColumns)=>{
            return flatColumns.reduce((acc, column)=>{
                acc[column.id] = column;
                return acc;
            }, {});
        }, getMemoOptions(options, 'debugColumns', 'getAllFlatColumnsById')),
        getAllLeafColumns: memo(()=>[
                table.getAllColumns(),
                table._getOrderColumnsFn()
            ], (allColumns, orderColumns)=>{
            let leafColumns = allColumns.flatMap((column)=>column.getLeafColumns());
            return orderColumns(leafColumns);
        }, getMemoOptions(options, 'debugColumns', 'getAllLeafColumns')),
        getColumn: (columnId)=>{
            const column = table._getAllFlatColumnsById()[columnId];
            return column;
        }
    };
    Object.assign(table, coreInstance);
    for(let index = 0; index < table._features.length; index++){
        const feature = table._features[index];
        feature == null || feature.createTable == null || feature.createTable(table);
    }
    return table;
}
function getCoreRowModel() {
    return (table)=>memo(()=>[
                table.options.data
            ], (data)=>{
            const rowModel = {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            const accessRows = function(originalRows, depth, parentRow) {
                if (depth === void 0) depth = 0;
                const rows = [];
                for(let i = 0; i < originalRows.length; i++){
                    // This could be an expensive check at scale, so we should move it somewhere else, but where?
                    // if (!id) {
                    //   if (process.env.NODE_ENV !== 'production') {
                    //     throw new Error(`getRowId expected an ID, but got ${id}`)
                    //   }
                    // }
                    // Make the row
                    const row = createRow(table, table._getRowId(originalRows[i], i, parentRow), originalRows[i], i, depth, undefined, parentRow == null ? void 0 : parentRow.id);
                    // Keep track of every row in a flat array
                    rowModel.flatRows.push(row);
                    // Also keep track of every row by its ID
                    rowModel.rowsById[row.id] = row;
                    // Push table row into parent
                    rows.push(row);
                    // Get the original subrows
                    if (table.options.getSubRows) {
                        var _row$originalSubRows;
                        row.originalSubRows = table.options.getSubRows(originalRows[i], i);
                        // Then recursively access them
                        if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) row.subRows = accessRows(row.originalSubRows, depth + 1, row);
                    }
                }
                return rows;
            };
            rowModel.rows = accessRows(data);
            return rowModel;
        }, getMemoOptions(table.options, 'debugTable', 'getRowModel', ()=>table._autoResetPageIndex()));
}
function getExpandedRowModel() {
    return (table)=>memo(()=>[
                table.getState().expanded,
                table.getPreExpandedRowModel(),
                table.options.paginateExpandedRows
            ], (expanded, rowModel, paginateExpandedRows)=>{
            if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) return rowModel;
            if (!paginateExpandedRows) // Only expand rows at this point if they are being paginated
            return rowModel;
            return expandRows(rowModel);
        }, getMemoOptions(table.options, 'debugTable', 'getExpandedRowModel'));
}
function expandRows(rowModel) {
    const expandedRows = [];
    const handleRow = (row)=>{
        var _row$subRows;
        expandedRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) row.subRows.forEach(handleRow);
    };
    rowModel.rows.forEach(handleRow);
    return {
        rows: expandedRows,
        flatRows: rowModel.flatRows,
        rowsById: rowModel.rowsById
    };
}
function getFacetedMinMaxValues() {
    return (table, columnId)=>memo(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return undefined;
            const uniqueValues = facetedRowModel.flatRows.flatMap((flatRow)=>{
                var _flatRow$getUniqueVal;
                return (_flatRow$getUniqueVal = flatRow.getUniqueValues(columnId)) != null ? _flatRow$getUniqueVal : [];
            }).map(Number).filter((value)=>!Number.isNaN(value));
            if (!uniqueValues.length) return;
            let facetedMinValue = uniqueValues[0];
            let facetedMaxValue = uniqueValues[uniqueValues.length - 1];
            for (const value of uniqueValues){
                if (value < facetedMinValue) facetedMinValue = value;
                else if (value > facetedMaxValue) facetedMaxValue = value;
            }
            return [
                facetedMinValue,
                facetedMaxValue
            ];
        }, getMemoOptions(table.options, 'debugTable', 'getFacetedMinMaxValues'));
}
function filterRows(rows, filterRowImpl, table) {
    if (table.options.filterFromLeafRows) return filterRowModelFromLeafs(rows, filterRowImpl, table);
    return filterRowModelFromRoot(rows, filterRowImpl, table);
}
function filterRowModelFromLeafs(rowsToFilter, filterRow, table) {
    var _table$options$maxLea;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea : 100;
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        const rows = [];
        // Filter from children up first
        for(let i = 0; i < rowsToFilter.length; i++){
            var _row$subRows;
            let row = rowsToFilter[i];
            const newRow = createRow(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
            newRow.columnFilters = row.columnFilters;
            if ((_row$subRows = row.subRows) != null && _row$subRows.length && depth < maxDepth) {
                newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                row = newRow;
                if (filterRow(row) && !newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
                if (filterRow(row) || newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
            } else {
                row = newRow;
                if (filterRow(row)) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                }
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function filterRowModelFromRoot(rowsToFilter, filterRow, table) {
    var _table$options$maxLea2;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea2 = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea2 : 100;
    // Filters top level and nested rows
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        // Filter from parents downward first
        const rows = [];
        // Apply the filter to any subRows
        for(let i = 0; i < rowsToFilter.length; i++){
            let row = rowsToFilter[i];
            const pass = filterRow(row);
            if (pass) {
                var _row$subRows2;
                if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length && depth < maxDepth) {
                    const newRow = createRow(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
                    newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                    row = newRow;
                }
                rows.push(row);
                newFilteredFlatRows.push(row);
                newFilteredRowsById[row.id] = row;
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function getFacetedRowModel() {
    return (table, columnId)=>memo(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter,
                table.getFilteredRowModel()
            ], (preRowModel, columnFilters, globalFilter)=>{
            if (!preRowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) return preRowModel;
            const filterableIds = [
                ...columnFilters.map((d)=>d.id).filter((d)=>d !== columnId),
                globalFilter ? '__global__' : undefined
            ].filter(Boolean);
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            return filterRows(preRowModel.rows, filterRowsImpl, table);
        }, getMemoOptions(table.options, 'debugTable', 'getFacetedRowModel'));
}
function getFacetedUniqueValues() {
    return (table, columnId)=>memo(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return new Map();
            let facetedUniqueValues = new Map();
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (facetedUniqueValues.has(value)) {
                        var _facetedUniqueValues$;
                        facetedUniqueValues.set(value, ((_facetedUniqueValues$ = facetedUniqueValues.get(value)) != null ? _facetedUniqueValues$ : 0) + 1);
                    } else facetedUniqueValues.set(value, 1);
                }
            }
            return facetedUniqueValues;
        }, getMemoOptions(table.options, 'debugTable', `getFacetedUniqueValues_${columnId}`));
}
function getFilteredRowModel() {
    return (table)=>memo(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter
            ], (rowModel, columnFilters, globalFilter)=>{
            if (!rowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) {
                for(let i = 0; i < rowModel.flatRows.length; i++){
                    rowModel.flatRows[i].columnFilters = {};
                    rowModel.flatRows[i].columnFiltersMeta = {};
                }
                return rowModel;
            }
            const resolvedColumnFilters = [];
            const resolvedGlobalFilters = [];
            (columnFilters != null ? columnFilters : []).forEach((d)=>{
                var _filterFn$resolveFilt;
                const column = table.getColumn(d.id);
                if (!column) return;
                const filterFn = column.getFilterFn();
                if (!filterFn) return;
                resolvedColumnFilters.push({
                    id: d.id,
                    filterFn,
                    resolvedValue: (_filterFn$resolveFilt = filterFn.resolveFilterValue == null ? void 0 : filterFn.resolveFilterValue(d.value)) != null ? _filterFn$resolveFilt : d.value
                });
            });
            const filterableIds = (columnFilters != null ? columnFilters : []).map((d)=>d.id);
            const globalFilterFn = table.getGlobalFilterFn();
            const globallyFilterableColumns = table.getAllLeafColumns().filter((column)=>column.getCanGlobalFilter());
            if (globalFilter && globalFilterFn && globallyFilterableColumns.length) {
                filterableIds.push('__global__');
                globallyFilterableColumns.forEach((column)=>{
                    var _globalFilterFn$resol;
                    resolvedGlobalFilters.push({
                        id: column.id,
                        filterFn: globalFilterFn,
                        resolvedValue: (_globalFilterFn$resol = globalFilterFn.resolveFilterValue == null ? void 0 : globalFilterFn.resolveFilterValue(globalFilter)) != null ? _globalFilterFn$resol : globalFilter
                    });
                });
            }
            let currentColumnFilter;
            let currentGlobalFilter;
            // Flag the prefiltered row model with each filter state
            for(let j = 0; j < rowModel.flatRows.length; j++){
                const row = rowModel.flatRows[j];
                row.columnFilters = {};
                if (resolvedColumnFilters.length) for(let i = 0; i < resolvedColumnFilters.length; i++){
                    currentColumnFilter = resolvedColumnFilters[i];
                    const id = currentColumnFilter.id;
                    // Tag the row with the column filter state
                    row.columnFilters[id] = currentColumnFilter.filterFn(row, id, currentColumnFilter.resolvedValue, (filterMeta)=>{
                        row.columnFiltersMeta[id] = filterMeta;
                    });
                }
                if (resolvedGlobalFilters.length) {
                    for(let i = 0; i < resolvedGlobalFilters.length; i++){
                        currentGlobalFilter = resolvedGlobalFilters[i];
                        const id = currentGlobalFilter.id;
                        // Tag the row with the first truthy global filter state
                        if (currentGlobalFilter.filterFn(row, id, currentGlobalFilter.resolvedValue, (filterMeta)=>{
                            row.columnFiltersMeta[id] = filterMeta;
                        })) {
                            row.columnFilters.__global__ = true;
                            break;
                        }
                    }
                    if (row.columnFilters.__global__ !== true) row.columnFilters.__global__ = false;
                }
            }
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            // Filter final rows using all of the active filters
            return filterRows(rowModel.rows, filterRowsImpl, table);
        }, getMemoOptions(table.options, 'debugTable', 'getFilteredRowModel', ()=>table._autoResetPageIndex()));
}
function getGroupedRowModel() {
    return (table)=>memo(()=>[
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ], (grouping, rowModel)=>{
            if (!rowModel.rows.length || !grouping.length) {
                rowModel.rows.forEach((row)=>{
                    row.depth = 0;
                    row.parentId = undefined;
                });
                return rowModel;
            }
            // Filter the grouping list down to columns that exist
            const existingGrouping = grouping.filter((columnId)=>table.getColumn(columnId));
            const groupedFlatRows = [];
            const groupedRowsById = {};
            // const onlyGroupedFlatRows: Row[] = [];
            // const onlyGroupedRowsById: Record<RowId, Row> = {};
            // const nonGroupedFlatRows: Row[] = [];
            // const nonGroupedRowsById: Record<RowId, Row> = {};
            // Recursively group the data
            const groupUpRecursively = function(rows, depth, parentId) {
                if (depth === void 0) depth = 0;
                // Grouping depth has been been met
                // Stop grouping and simply rewrite thd depth and row relationships
                if (depth >= existingGrouping.length) return rows.map((row)=>{
                    row.depth = depth;
                    groupedFlatRows.push(row);
                    groupedRowsById[row.id] = row;
                    if (row.subRows) row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
                    return row;
                });
                const columnId = existingGrouping[depth];
                // Group the rows together for this level
                const rowGroupsMap = groupBy(rows, columnId);
                // Perform aggregations for each group
                const aggregatedGroupedRows = Array.from(rowGroupsMap.entries()).map((_ref, index)=>{
                    let [groupingValue, groupedRows] = _ref;
                    let id = `${columnId}:${groupingValue}`;
                    id = parentId ? `${parentId}>${id}` : id;
                    // First, Recurse to group sub rows before aggregation
                    const subRows = groupUpRecursively(groupedRows, depth + 1, id);
                    subRows.forEach((subRow)=>{
                        subRow.parentId = id;
                    });
                    // Flatten the leaf rows of the rows in this group
                    const leafRows = depth ? flattenBy(groupedRows, (row)=>row.subRows) : groupedRows;
                    const row = createRow(table, id, leafRows[0].original, index, depth, undefined, parentId);
                    Object.assign(row, {
                        groupingColumnId: columnId,
                        groupingValue,
                        subRows,
                        leafRows,
                        getValue: (columnId)=>{
                            // Don't aggregate columns that are in the grouping
                            if (existingGrouping.includes(columnId)) {
                                if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
                                if (groupedRows[0]) {
                                    var _groupedRows$0$getVal;
                                    row._valuesCache[columnId] = (_groupedRows$0$getVal = groupedRows[0].getValue(columnId)) != null ? _groupedRows$0$getVal : undefined;
                                }
                                return row._valuesCache[columnId];
                            }
                            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
                            // Aggregate the values
                            const column = table.getColumn(columnId);
                            const aggregateFn = column == null ? void 0 : column.getAggregationFn();
                            if (aggregateFn) {
                                row._groupingValuesCache[columnId] = aggregateFn(columnId, leafRows, groupedRows);
                                return row._groupingValuesCache[columnId];
                            }
                        }
                    });
                    subRows.forEach((subRow)=>{
                        groupedFlatRows.push(subRow);
                        groupedRowsById[subRow.id] = subRow;
                    // if (subRow.getIsGrouped?.()) {
                    //   onlyGroupedFlatRows.push(subRow);
                    //   onlyGroupedRowsById[subRow.id] = subRow;
                    // } else {
                    //   nonGroupedFlatRows.push(subRow);
                    //   nonGroupedRowsById[subRow.id] = subRow;
                    // }
                    });
                    return row;
                });
                return aggregatedGroupedRows;
            };
            const groupedRows = groupUpRecursively(rowModel.rows, 0);
            groupedRows.forEach((subRow)=>{
                groupedFlatRows.push(subRow);
                groupedRowsById[subRow.id] = subRow;
            // if (subRow.getIsGrouped?.()) {
            //   onlyGroupedFlatRows.push(subRow);
            //   onlyGroupedRowsById[subRow.id] = subRow;
            // } else {
            //   nonGroupedFlatRows.push(subRow);
            //   nonGroupedRowsById[subRow.id] = subRow;
            // }
            });
            return {
                rows: groupedRows,
                flatRows: groupedFlatRows,
                rowsById: groupedRowsById
            };
        }, getMemoOptions(table.options, 'debugTable', 'getGroupedRowModel', ()=>{
            table._queue(()=>{
                table._autoResetExpanded();
                table._autoResetPageIndex();
            });
        }));
}
function groupBy(rows, columnId) {
    const groupMap = new Map();
    return rows.reduce((map, row)=>{
        const resKey = `${row.getGroupingValue(columnId)}`;
        const previous = map.get(resKey);
        if (!previous) map.set(resKey, [
            row
        ]);
        else previous.push(row);
        return map;
    }, groupMap);
}
function getPaginationRowModel(opts) {
    return (table)=>memo(()=>[
                table.getState().pagination,
                table.getPrePaginationRowModel(),
                table.options.paginateExpandedRows ? undefined : table.getState().expanded
            ], (pagination, rowModel)=>{
            if (!rowModel.rows.length) return rowModel;
            const { pageSize, pageIndex } = pagination;
            let { rows, flatRows, rowsById } = rowModel;
            const pageStart = pageSize * pageIndex;
            const pageEnd = pageStart + pageSize;
            rows = rows.slice(pageStart, pageEnd);
            let paginatedRowModel;
            if (!table.options.paginateExpandedRows) paginatedRowModel = expandRows({
                rows,
                flatRows,
                rowsById
            });
            else paginatedRowModel = {
                rows,
                flatRows,
                rowsById
            };
            paginatedRowModel.flatRows = [];
            const handleRow = (row)=>{
                paginatedRowModel.flatRows.push(row);
                if (row.subRows.length) row.subRows.forEach(handleRow);
            };
            paginatedRowModel.rows.forEach(handleRow);
            return paginatedRowModel;
        }, getMemoOptions(table.options, 'debugTable', 'getPaginationRowModel'));
}
function getSortedRowModel() {
    return (table)=>memo(()=>[
                table.getState().sorting,
                table.getPreSortedRowModel()
            ], (sorting, rowModel)=>{
            if (!rowModel.rows.length || !(sorting != null && sorting.length)) return rowModel;
            const sortingState = table.getState().sorting;
            const sortedFlatRows = [];
            // Filter out sortings that correspond to non existing columns
            const availableSorting = sortingState.filter((sort)=>{
                var _table$getColumn;
                return (_table$getColumn = table.getColumn(sort.id)) == null ? void 0 : _table$getColumn.getCanSort();
            });
            const columnInfoById = {};
            availableSorting.forEach((sortEntry)=>{
                const column = table.getColumn(sortEntry.id);
                if (!column) return;
                columnInfoById[sortEntry.id] = {
                    sortUndefined: column.columnDef.sortUndefined,
                    invertSorting: column.columnDef.invertSorting,
                    sortingFn: column.getSortingFn()
                };
            });
            const sortData = (rows)=>{
                // This will also perform a stable sorting using the row index
                // if needed.
                const sortedData = rows.map((row)=>({
                        ...row
                    }));
                sortedData.sort((rowA, rowB)=>{
                    for(let i = 0; i < availableSorting.length; i += 1){
                        var _sortEntry$desc;
                        const sortEntry = availableSorting[i];
                        const columnInfo = columnInfoById[sortEntry.id];
                        const sortUndefined = columnInfo.sortUndefined;
                        const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
                        let sortInt = 0;
                        // All sorting ints should always return in ascending order
                        if (sortUndefined) {
                            const aValue = rowA.getValue(sortEntry.id);
                            const bValue = rowB.getValue(sortEntry.id);
                            const aUndefined = aValue === undefined;
                            const bUndefined = bValue === undefined;
                            if (aUndefined || bUndefined) {
                                if (sortUndefined === 'first') return aUndefined ? -1 : 1;
                                if (sortUndefined === 'last') return aUndefined ? 1 : -1;
                                sortInt = aUndefined && bUndefined ? 0 : aUndefined ? sortUndefined : -sortUndefined;
                            }
                        }
                        if (sortInt === 0) sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
                        // If sorting is non-zero, take care of desc and inversion
                        if (sortInt !== 0) {
                            if (isDesc) sortInt *= -1;
                            if (columnInfo.invertSorting) sortInt *= -1;
                            return sortInt;
                        }
                    }
                    return rowA.index - rowB.index;
                });
                // If there are sub-rows, sort them
                sortedData.forEach((row)=>{
                    var _row$subRows;
                    sortedFlatRows.push(row);
                    if ((_row$subRows = row.subRows) != null && _row$subRows.length) row.subRows = sortData(row.subRows);
                });
                return sortedData;
            };
            return {
                rows: sortData(rowModel.rows),
                flatRows: sortedFlatRows,
                rowsById: rowModel.rowsById
            };
        }, getMemoOptions(table.options, 'debugTable', 'getSortedRowModel', ()=>table._autoResetPageIndex()));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7xRKF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columns", ()=>columns);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _button = require("@/client/components/ui/button");
var _tooltip = require("@/client/components/ui/tooltip");
var _react = require("react");
function CopyableClientID({ clientID }) {
    const [copied, setCopied] = (0, _react.useState)(false);
    const handleCopy = async (e)=>{
        e.stopPropagation();
        await navigator.clipboard.writeText(clientID);
        setCopied(true);
        setTimeout(()=>setCopied(false), 2000);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipProvider), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltip.Tooltip), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipTrigger), {
                    asChild: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        onClick: handleCopy,
                        className: "font-mono text-foreground hover:text-zinc-400 cursor-pointer flex items-center gap-1",
                        children: [
                            clientID,
                            copied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                                className: "h-3 w-3 text-green-500"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Copy), {
                                className: "h-3 w-3 opacity-50"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipContent), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-xs",
                        children: "Click to copy"
                    })
                })
            ]
        })
    });
}
const columns = [
    {
        accessorKey: 'clientID',
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Client ID",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        },
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CopyableClientID, {
                clientID: row.getValue('clientID')
            })
    },
    {
        accessorKey: 'name',
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Name",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        }
    },
    {
        accessorKey: 'timeZone',
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Time Zone",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        },
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-mono text-sm",
                children: row.getValue('timeZone') || '-'
            })
    },
    {
        accessorKey: 'ec2Zone',
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "EC2 Zone",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        },
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-mono text-sm",
                children: row.getValue('ec2Zone') || '-'
            })
    },
    {
        accessorKey: 'active',
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Status",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        },
        cell: ({ row })=>{
            const isActive = row.getValue('active');
            return isActive ? 'Active' : 'Inactive';
        }
    }
];

},{"react/jsx-runtime":"dQjte","lucide-react":[["ArrowUpDown","amX4k","default"],["Check","bajJU","default"],["Copy","jM41N","default"]],"@/client/components/ui/button":"armlb","@/client/components/ui/tooltip":"dWqZd","react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"amX4k":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ArrowUpDown);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m21 16-4 4-4-4",
            key: "f6ql7i"
        }
    ],
    [
        "path",
        {
            d: "M17 20V4",
            key: "1ejh1v"
        }
    ],
    [
        "path",
        {
            d: "m3 8 4-4 4 4",
            key: "11wl7u"
        }
    ],
    [
        "path",
        {
            d: "M7 4v16",
            key: "1glfcx"
        }
    ]
];
const ArrowUpDown = (0, _createLucideIconJsDefault.default)("arrow-up-down", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jM41N":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Copy);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "rect",
        {
            width: "14",
            height: "14",
            x: "8",
            y: "8",
            rx: "2",
            ry: "2",
            key: "17jyea"
        }
    ],
    [
        "path",
        {
            d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
            key: "zix9uf"
        }
    ]
];
const Copy = (0, _createLucideIconJsDefault.default)("copy", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5vxZ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
parcelHelpers.export(exports, "TableHeader", ()=>TableHeader);
parcelHelpers.export(exports, "TableBody", ()=>TableBody);
parcelHelpers.export(exports, "TableFooter", ()=>TableFooter);
parcelHelpers.export(exports, "TableHead", ()=>TableHead);
parcelHelpers.export(exports, "TableRow", ()=>TableRow);
parcelHelpers.export(exports, "TableCell", ()=>TableCell);
parcelHelpers.export(exports, "TableCaption", ()=>TableCaption);
parcelHelpers.export(exports, "SortableTableHead", ()=>SortableTableHead);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _lucideReact = require("lucide-react");
var _utils = require("@/client/lib/utils");
const Table = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "relative w-full overflow-auto",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
            ref: ref,
            className: (0, _utils.cn)("w-full caption-bottom text-sm table-auto", className),
            ...props
        })
    }));
Table.displayName = "Table";
const TableHeader = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
        ref: ref,
        className: (0, _utils.cn)("[&_tr]:border-b [&_tr]:bg-muted", className),
        ...props
    }));
TableHeader.displayName = "TableHeader";
const TableBody = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
        ref: ref,
        className: (0, _utils.cn)("[&_tr:last-child]:border-0", className),
        ...props
    }));
TableBody.displayName = "TableBody";
const TableFooter = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("tfoot", {
        ref: ref,
        className: (0, _utils.cn)("border-t bg-muted/50 font-medium [&>tr]:last:border-b-0", className),
        ...props
    }));
TableFooter.displayName = "TableFooter";
const TableRow = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
        ref: ref,
        className: (0, _utils.cn)("border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted", className),
        ...props
    }));
TableRow.displayName = "TableRow";
const TableHead = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
        ref: ref,
        className: (0, _utils.cn)("h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0", className),
        ...props
    }));
TableHead.displayName = "TableHead";
const TableCell = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
        ref: ref,
        className: (0, _utils.cn)("p-4 align-middle [&:has([role=checkbox])]:pr-0", className),
        ...props
    }));
TableCell.displayName = "TableCell";
const TableCaption = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("caption", {
        ref: ref,
        className: (0, _utils.cn)("mt-4 text-sm text-muted-foreground", className),
        ...props
    }));
TableCaption.displayName = "TableCaption";
function SortableTableHead({ field, label, currentSort, currentDirection, onSort, className }) {
    const isActive = currentSort === field;
    const isRightAligned = className?.includes('text-right');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
        className: (0, _utils.cn)("h-12 px-4 align-middle font-medium text-muted-foreground", className),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
            type: "button",
            onClick: ()=>onSort(field),
            className: (0, _utils.cn)("inline-flex items-center gap-1 hover:text-foreground transition-colors", isRightAligned && "ml-auto"),
            children: [
                label,
                isActive ? currentDirection === 'asc' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUp), {
                    className: "h-3 w-3"
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowDown), {
                    className: "h-3 w-3"
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                    className: "h-3 w-3 text-muted-foreground/50"
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","lucide-react":[["ArrowDown","hExmJ","default"],["ArrowUp","g8l66","default"],["ArrowUpDown","amX4k","default"]],"@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hExmJ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ArrowDown);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ],
    [
        "path",
        {
            d: "m19 12-7 7-7-7",
            key: "1idqje"
        }
    ]
];
const ArrowDown = (0, _createLucideIconJsDefault.default)("arrow-down", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"g8l66":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ArrowUp);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m5 12 7-7 7 7",
            key: "hav0vg"
        }
    ],
    [
        "path",
        {
            d: "M12 19V5",
            key: "x0mq9r"
        }
    ]
];
const ArrowUp = (0, _createLucideIconJsDefault.default)("arrow-up", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1p4xh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Switch", ()=>Switch);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactSwitch = require("@radix-ui/react-switch");
var _utils = require("@/client/lib/utils");
const Switch = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactSwitch.Root, {
        className: (0, _utils.cn)("peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input", className),
        ...props,
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactSwitch.Thumb, {
            className: (0, _utils.cn)("pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0")
        })
    }));
Switch.displayName = _reactSwitch.Root.displayName;

},{"react/jsx-runtime":"dQjte","react":"eGun2","@radix-ui/react-switch":"cgRGI","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cgRGI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Root", ()=>Root);
parcelHelpers.export(exports, "Switch", ()=>Switch);
parcelHelpers.export(exports, "SwitchThumb", ()=>SwitchThumb);
parcelHelpers.export(exports, "Thumb", ()=>Thumb);
parcelHelpers.export(exports, "createSwitchScope", ()=>createSwitchScope);
// src/switch.tsx
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactContext = require("@radix-ui/react-context");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _reactUsePrevious = require("@radix-ui/react-use-previous");
var _reactUseSize = require("@radix-ui/react-use-size");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var SWITCH_NAME = "Switch";
var [createSwitchContext, createSwitchScope] = (0, _reactContext.createContextScope)(SWITCH_NAME);
var [SwitchProvider, useSwitchContext] = createSwitchContext(SWITCH_NAME);
var Switch = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch, name, checked: checkedProp, defaultChecked, required, disabled, value = "on", onCheckedChange, form, ...switchProps } = props;
    const [button, setButton] = _react.useState(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = _react.useRef(false);
    const isFormControl = button ? form || !!button.closest("form") : true;
    const [checked, setChecked] = (0, _reactUseControllableState.useControllableState)({
        prop: checkedProp,
        defaultProp: defaultChecked ?? false,
        onChange: onCheckedChange,
        caller: SWITCH_NAME
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)(SwitchProvider, {
        scope: __scopeSwitch,
        checked,
        disabled,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).button, {
                type: "button",
                role: "switch",
                "aria-checked": checked,
                "aria-required": required,
                "data-state": getState(checked),
                "data-disabled": disabled ? "" : void 0,
                disabled,
                value,
                ...switchProps,
                ref: composedRefs,
                onClick: (0, _primitive.composeEventHandlers)(props.onClick, (event)=>{
                    setChecked((prevChecked)=>!prevChecked);
                    if (isFormControl) {
                        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
                    }
                })
            }),
            isFormControl && /* @__PURE__ */ (0, _jsxRuntime.jsx)(SwitchBubbleInput, {
                control: button,
                bubbles: !hasConsumerStoppedPropagationRef.current,
                name,
                value,
                checked,
                required,
                disabled,
                form,
                style: {
                    transform: "translateX(-100%)"
                }
            })
        ]
    });
});
Switch.displayName = SWITCH_NAME;
var THUMB_NAME = "SwitchThumb";
var SwitchThumb = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch, ...thumbProps } = props;
    const context = useSwitchContext(THUMB_NAME, __scopeSwitch);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).span, {
        "data-state": getState(context.checked),
        "data-disabled": context.disabled ? "" : void 0,
        ...thumbProps,
        ref: forwardedRef
    });
});
SwitchThumb.displayName = THUMB_NAME;
var BUBBLE_INPUT_NAME = "SwitchBubbleInput";
var SwitchBubbleInput = _react.forwardRef(({ __scopeSwitch, control, checked, bubbles = true, ...props }, forwardedRef)=>{
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(ref, forwardedRef);
    const prevChecked = (0, _reactUsePrevious.usePrevious)(checked);
    const controlSize = (0, _reactUseSize.useSize)(control);
    _react.useEffect(()=>{
        const input = ref.current;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: checked,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    });
});
SwitchBubbleInput.displayName = BUBBLE_INPUT_NAME;
function getState(checked) {
    return checked ? "checked" : "unchecked";
}
var Root = Switch;
var Thumb = SwitchThumb;

},{"react":"eGun2","@radix-ui/primitive":"k8C5A","@radix-ui/react-compose-refs":"nN23r","@radix-ui/react-context":"4wywa","@radix-ui/react-use-controllable-state":"ThW7y","@radix-ui/react-use-previous":"5zGdn","@radix-ui/react-use-size":"1EkiK","@radix-ui/react-primitive":"hQJ44","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5zGdn":[function(require,module,exports,__globalThis) {
// packages/react/use-previous/src/use-previous.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePrevious", ()=>usePrevious);
var _react = require("react");
function usePrevious(value) {
    const ref = _react.useRef({
        value,
        previous: value
    });
    return _react.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}

},{"react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cLMZq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", ()=>Label);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactLabel = require("@radix-ui/react-label");
var _classVarianceAuthority = require("class-variance-authority");
var _utils = require("@/client/lib/utils");
const labelVariants = (0, _classVarianceAuthority.cva)("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70");
const Label = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactLabel.Root, {
        ref: ref,
        className: (0, _utils.cn)(labelVariants(), className),
        ...props
    }));
Label.displayName = _reactLabel.Root.displayName;

},{"react/jsx-runtime":"dQjte","react":"eGun2","@radix-ui/react-label":"6Bw1g","class-variance-authority":"l22tX","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6Bw1g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "Root", ()=>Root);
// src/label.tsx
var _react = require("react");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var NAME = "Label";
var Label = _react.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).label, {
        ...props,
        ref: forwardedRef,
        onMouseDown: (event)=>{
            const target = event.target;
            if (target.closest("button, input, select, textarea")) return;
            props.onMouseDown?.(event);
            if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
        }
    });
});
Label.displayName = NAME;
var Root = Label;

},{"react":"eGun2","@radix-ui/react-primitive":"i36AJ","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"f5Zyx":[function(require,module,exports,__globalThis) {
/**
 * CacheTimestamp - Displays when data was cached
 * Shows "Data cached at: Dec 6, 2025, 9:51 AM PT" or "Cache info not available" if not cached
 *
 * TODO: Formalize this as a polymorphic component that handles all cache variants:
 * - Cached data with timestamp (current)
 * - Live/uncached data (SSE, WebSocket)
 * - Stale data with refresh action
 * - Loading/refreshing state
 * Consolidate the helper functions (formatCacheTimestamp, force-refresh patterns)
 * so all routes share a single consistent cache status UI.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheTimestamp", ()=>CacheTimestamp);
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Format a cache timestamp for display
 * Returns formatted date string like "Dec 6, 2025, 9:51 AM PT"
 */ function formatCacheTimestamp(isoString) {
    return new Date(isoString).toLocaleString('en-US', {
        timeZone: 'America/Los_Angeles',
        dateStyle: 'medium',
        timeStyle: 'short'
    }) + ' PT';
}
function CacheTimestamp({ cachedAt, className = '' }) {
    const baseClasses = 'font-mono text-sm text-muted-foreground';
    if (!cachedAt) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        className: `${baseClasses} ${className}`,
        children: "Cache info not available"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
        className: `${baseClasses} ${className}`,
        children: [
            "Data cached at: ",
            formatCacheTimestamp(cachedAt)
        ]
    });
}

},{"react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4gE8R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _reactTable = require("@tanstack/react-table");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _clientsStore = require("@/client/store/clientsStore");
var _clientUsersStore = require("@/client/store/clientUsersStore");
var _clientDetailsStore = require("@/client/store/clientDetailsStore");
var _encodersStore = require("@/client/store/encodersStore");
var _allPersistentStreamsStore = require("@/client/store/allPersistentStreamsStore");
var _clientPlatformStore = require("@/client/store/clientPlatformStore");
var _clientSummary = require("@/client/lib/clientSummary");
var _clientContacts = require("@shared/config/clientContacts");
var _sonner = require("sonner");
var _clientUsersColumns = require("@/client/components/tables/client-users-columns");
var _table = require("@/client/components/ui/table");
var _button = require("@/client/components/ui/button");
var _cacheTimestamp = require("@/client/components/cache-timestamp");
var _swapClientDialog = require("@/client/components/swap-client-dialog");
var _clientDetails = require("@/client/components/client-details");
var _lucideReact = require("lucide-react");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'clients/$clientID',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: ClientDetailComponent
});
function ClientDetailComponent() {
    const { clientID } = (0, _reactRouter.useParams)({
        from: '/clients/$clientID'
    });
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    const [sorting, setSorting] = (0, _react.useState)([]);
    const [swapDialogOpen, setSwapDialogOpen] = (0, _react.useState)(false);
    const [clientIDCopied, setClientIDCopied] = (0, _react.useState)(false);
    const { clients, fetchClients } = (0, _clientsStore.useClientsStore)();
    const { needsSwap } = (0, _swapClientDialog.useClientSwapInfo)(clientID);
    const client = clients.find((c)=>c.clientID === clientID);
    const { loading: usersLoading, error: usersError, fetchUsers, getUsers, getCacheInfo } = (0, _clientUsersStore.useClientUsersStore)();
    const users = getUsers(clientID);
    const usersCacheInfo = getCacheInfo(clientID);
    // Client details store
    const { loading: detailsLoading, error: detailsError, fetchDetails, getDetails } = (0, _clientDetailsStore.useClientDetailsStore)();
    const details = getDetails(clientID);
    const { fetchSummary: fetchPlatformSummary, getSummary: getPlatformSummary } = (0, _clientPlatformStore.useClientPlatformStore)();
    const platformSummary = getPlatformSummary(clientID);
    const primaryContacts = (0, _react.useMemo)(()=>{
        const ids = (0, _clientContacts.CLIENT_PRIMARY_CONTACTS)[clientID] ?? [];
        return users.filter((u)=>ids.includes(u.userId));
    }, [
        users,
        clientID
    ]);
    // Use global stores and filter by clientID
    const { encoders, fetchEncoders } = (0, _encodersStore.useEncodersStore)();
    const { streams: persistentStreams, fetchStreams: fetchPersistentStreams } = (0, _allPersistentStreamsStore.useAllPersistentStreamsStore)();
    const clientEncoders = (0, _react.useMemo)(()=>encoders.filter((e)=>e.clientID === clientID), [
        encoders,
        clientID
    ]);
    const onlineEncoders = (0, _react.useMemo)(()=>clientEncoders.filter((e)=>e.status === 1), [
        clientEncoders
    ]);
    const clientPersistentStreams = (0, _react.useMemo)(()=>persistentStreams.filter((s)=>s.clientID === clientID), [
        persistentStreams,
        clientID
    ]);
    (0, _react.useEffect)(()=>{
        const loadData = async ()=>{
            try {
                const token = await getAccessTokenSilently();
                if (clients.length === 0) await fetchClients(token, logout);
                await Promise.all([
                    fetchUsers(clientID, logout, token),
                    fetchDetails(clientID, logout, token),
                    fetchPlatformSummary(clientID, logout, token),
                    fetchEncoders(token, logout),
                    fetchPersistentStreams(token, logout)
                ]);
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };
        loadData();
    }, [
        clientID,
        getAccessTokenSilently,
        fetchUsers,
        fetchDetails,
        fetchPlatformSummary,
        fetchEncoders,
        fetchPersistentStreams,
        fetchClients,
        clients.length
    ]);
    const handleCopyClientID = async ()=>{
        await navigator.clipboard.writeText(clientID);
        setClientIDCopied(true);
        setTimeout(()=>setClientIDCopied(false), 2000);
    };
    const handleCopySummary = async ()=>{
        const text = (0, _clientSummary.buildClientSummary)({
            clientID,
            name: client?.name ?? null,
            timeZone: client?.timeZone ?? null,
            details,
            contacts: primaryContacts,
            encoders: {
                online: onlineEncoders.length,
                total: clientEncoders.length
            },
            persistentStreamCount: clientPersistentStreams.length,
            platform: platformSummary
        });
        try {
            await navigator.clipboard.writeText(text);
            (0, _sonner.toast).success('Client summary copied');
        } catch  {
            (0, _sonner.toast).error('Could not copy to clipboard');
        }
    };
    const table = (0, _reactTable.useReactTable)({
        data: users,
        columns: (0, _clientUsersColumns.columns),
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        onSortingChange: setSorting,
        getSortedRowModel: (0, _reactTable.getSortedRowModel)(),
        state: {
            sorting
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mb-6 flex items-center gap-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                to: "/clients",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    variant: "ghost",
                                    size: "icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowLeft), {
                                        className: "h-4 w-4"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                className: "text-2xl font-semibold flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        type: "button",
                                        onClick: handleCopyClientID,
                                        title: "Copy client ID",
                                        className: "font-mono text-muted-foreground hover:text-foreground flex items-center gap-1.5 transition-colors",
                                        children: [
                                            clientID,
                                            clientIDCopied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                                                className: "h-4 w-4 text-green-500"
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Copy), {
                                                className: "h-4 w-4 opacity-50"
                                            })
                                        ]
                                    }),
                                    client && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: client.name
                                    })
                                ]
                            }),
                            needsSwap && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                variant: "outline",
                                size: "sm",
                                onClick: ()=>setSwapDialogOpen(true),
                                className: "gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                        className: "h-3 w-3"
                                    }),
                                    "Switch to this client"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                variant: "outline",
                                size: "sm",
                                onClick: handleCopySummary,
                                className: "gap-2 ml-auto",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ClipboardCopy), {
                                        className: "h-3 w-3"
                                    }),
                                    "Copy summary"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _swapClientDialog.SwapClientDialog), {
                        open: swapDialogOpen,
                        onOpenChange: setSwapDialogOpen,
                        targetClientID: clientID,
                        targetClientName: client?.name ?? `Client ${clientID}`
                    }),
                    details && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "mb-6",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientDetails.AccountInfoCard), {
                            accountInfo: details.accountInfo,
                            entAuth: details.entAuth
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                to: "/encoders",
                                search: {
                                    clientID
                                },
                                className: "block",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rounded-md border p-4 hover:bg-accent transition-colors",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                        className: "font-medium",
                                                        children: "Encoders"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "text-sm text-muted-foreground",
                                                        children: [
                                                            onlineEncoders.length,
                                                            " online / ",
                                                            clientEncoders.length,
                                                            " total"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowRight), {
                                                className: "h-4 w-4 text-muted-foreground"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                to: "/persistent-streams",
                                search: {
                                    clientID
                                },
                                className: "block",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rounded-md border p-4 hover:bg-accent transition-colors",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                        className: "font-medium",
                                                        children: "Persistent Streams"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "text-sm text-muted-foreground",
                                                        children: [
                                                            clientPersistentStreams.length,
                                                            " configured"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowRight), {
                                                className: "h-4 w-4 text-muted-foreground"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                to: "/pipeline-logs",
                                search: {
                                    searchType: 'clientID',
                                    searchValue: clientID
                                },
                                className: "block",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rounded-md border p-4 hover:bg-accent transition-colors",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                        className: "font-medium",
                                                        children: "Pipeline Logs"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "text-sm text-muted-foreground",
                                                        children: "View message history"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ScrollText), {
                                                className: "h-4 w-4 text-muted-foreground"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                to: "/monitoring/webhook-logs",
                                search: {
                                    clientID
                                },
                                className: "block",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rounded-md border p-4 hover:bg-accent transition-colors",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                        className: "font-medium",
                                                        children: "Webhook Logs"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "text-sm text-muted-foreground",
                                                        children: details?.webhooks.length ? `${details.webhooks.length} configured` : 'View delivery history'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Webhook), {
                                                className: "h-4 w-4 text-muted-foreground"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-6",
                        children: [
                            platformSummary && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientDetails.PlatformSummaryCard), {
                                clientID: clientID,
                                summary: platformSummary
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientDetails.ContactsCard), {
                                contacts: primaryContacts
                            })
                        ]
                    }),
                    details && details.package && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "mb-6",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientDetails.PackageCard), {
                            packageInfo: details.package,
                            transcription: details.transcription
                        })
                    }),
                    details && (details.webhooks.length > 0 || details.api) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientDetails.WebhooksCard), {
                                webhooks: details.webhooks
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientDetails.ApiKeysCard), {
                                api: details.api
                            })
                        ]
                    }),
                    details && !details.accountInfo && !details.package && !details.api && details.webhooks.length === 0 && details.techs.length === 0 && details.vendors.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rounded-md border border-dashed p-4 mb-6 text-center text-muted-foreground",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-sm",
                            children: "No additional client information has been populated yet."
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex justify-between items-center mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                className: "text-lg font-medium",
                                children: "Users"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cacheTimestamp.CacheTimestamp), {
                                cachedAt: usersCacheInfo?.cachedAt ?? null
                            })
                        ]
                    }),
                    usersLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Loading users..."
                    }),
                    usersError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-4 bg-red-100 border-l-4 border-red-600 rounded mt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "m-0 text-red-800 font-medium",
                            children: [
                                "Error: ",
                                usersError
                            ]
                        })
                    }),
                    !usersLoading && !usersError && users.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "No users found for this client."
                    }),
                    !usersLoading && !usersError && users.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rounded-md border",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                    children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                            children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    className: header.column.columnDef.meta?.className,
                                                    children: header.isPlaceholder ? null : (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())
                                                }, header.id))
                                        }, headerGroup.id))
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                    children: table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                            children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: cell.column.columnDef.meta?.className,
                                                    children: (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                                }, cell.id))
                                        }, row.id))
                                })
                            ]
                        })
                    }),
                    details && (details.techs.length > 0 || details.vendors.length > 0) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientDetails.TechsCard), {
                                techs: details.techs
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientDetails.VendorsCard), {
                                vendors: details.vendors
                            })
                        ]
                    }),
                    detailsLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-sm text-muted-foreground mt-4",
                        children: "Loading client details..."
                    }),
                    detailsError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-4 bg-red-100 border-l-4 border-red-600 rounded mt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "m-0 text-red-800 font-medium",
                            children: [
                                "Error loading details: ",
                                detailsError
                            ]
                        })
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["Link","7k6Lq"],["redirect","jmFxY"],["useParams","jBvHB"]],"@auth0/auth0-react":"gpXrE","@tanstack/react-table":[["flexRender","brwh1"],["useReactTable","brwh1"],["getCoreRowModel","3MlnA"],["getSortedRowModel","3MlnA"]],"../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/store/clientsStore":"6bg3l","@/client/store/clientUsersStore":"hnw6M","@/client/store/clientDetailsStore":"b6zIf","@/client/store/encodersStore":"7Qwmv","@/client/store/allPersistentStreamsStore":"bMJjY","@/client/store/clientPlatformStore":"4fRzE","@/client/lib/clientSummary":"eZO0I","@shared/config/clientContacts":"jcJAm","sonner":"2p5sL","@/client/components/tables/client-users-columns":"gJDgB","@/client/components/ui/table":"5vxZ8","@/client/components/ui/button":"armlb","@/client/components/cache-timestamp":"f5Zyx","@/client/components/swap-client-dialog":"dD6eo","@/client/components/client-details":"8YaML","lucide-react":[["ArrowLeft","2k0dn","default"],["ArrowRight","itm6a","default"],["Check","bajJU","default"],["ClipboardCopy","9LO3O","default"],["Copy","jM41N","default"],["RefreshCw","7a8jT","default"],["ScrollText","hdD9f","default"],["Webhook","1VKcp","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hnw6M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useClientUsersStore", ()=>useClientUsersStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
var _config = require("@/client/config");
var _apiError = require("@/client/lib/apiError");
const useClientUsersStore = (0, _zustand.create)()((0, _middleware.devtools)((set, get)=>({
        usersByClient: {},
        loading: false,
        error: null,
        lastFetchedByClient: {},
        cacheInfoByClient: {},
        setUsers: (clientID, users)=>set((state)=>({
                    usersByClient: {
                        ...state.usersByClient,
                        [clientID]: users
                    },
                    error: null
                })),
        setLoading: (loading)=>set({
                loading
            }),
        setError: (error)=>set({
                error
            }),
        getUsers: (clientID)=>get().usersByClient[clientID] || [],
        getCacheInfo: (clientID)=>get().cacheInfoByClient[clientID] || null,
        fetchUsers: async (clientID, logout, accessToken, forceRefresh = false)=>{
            const state = get();
            // If we have cached data for this client and not forcing refresh, skip the fetch
            if (!forceRefresh && state.usersByClient[clientID]?.length > 0 && state.lastFetchedByClient[clientID]) return;
            set({
                loading: true,
                error: null
            });
            try {
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/clients/${clientID}/users`, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.ok) {
                    if ((0, _apiError.handleApiError)(response, logout)) return;
                    throw new Error(`Failed to fetch users: ${response.statusText}`);
                }
                const data = await response.json();
                set((state)=>({
                        usersByClient: {
                            ...state.usersByClient,
                            [clientID]: data.users
                        },
                        lastFetchedByClient: {
                            ...state.lastFetchedByClient,
                            [clientID]: Date.now()
                        },
                        cacheInfoByClient: {
                            ...state.cacheInfoByClient,
                            [clientID]: data.cacheInfo ?? null
                        },
                        loading: false
                    }));
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
                set({
                    error: errorMessage,
                    loading: false
                });
            }
        }
    }), {
    name: 'client-users-store'
}));

},{"zustand":"Ze5I5","zustand/middleware":"9udS2","@/client/config":"8SWgh","@/client/lib/apiError":"aL0RR","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"b6zIf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useClientDetailsStore", ()=>useClientDetailsStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
var _config = require("@/client/config");
var _apiError = require("@/client/lib/apiError");
const useClientDetailsStore = (0, _zustand.create)()((0, _middleware.devtools)((set, get)=>({
        detailsByClient: {},
        loading: false,
        error: null,
        lastFetchedByClient: {},
        cacheInfoByClient: {},
        setDetails: (clientID, details)=>set((state)=>({
                    detailsByClient: {
                        ...state.detailsByClient,
                        [clientID]: details
                    },
                    error: null
                })),
        setLoading: (loading)=>set({
                loading
            }),
        setError: (error)=>set({
                error
            }),
        getDetails: (clientID)=>get().detailsByClient[clientID] || null,
        getCacheInfo: (clientID)=>get().cacheInfoByClient[clientID] || null,
        fetchDetails: async (clientID, logout, accessToken, forceRefresh = false)=>{
            const state = get();
            // If we have cached data for this client and not forcing refresh, skip the fetch
            if (!forceRefresh && state.detailsByClient[clientID] && state.lastFetchedByClient[clientID]) return;
            set({
                loading: true,
                error: null
            });
            try {
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/clients/${clientID}/details`, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.ok) {
                    if ((0, _apiError.handleApiError)(response, logout)) return;
                    throw new Error(`Failed to fetch client details: ${response.statusText}`);
                }
                const data = await response.json();
                set((state)=>({
                        detailsByClient: {
                            ...state.detailsByClient,
                            [clientID]: data.details
                        },
                        lastFetchedByClient: {
                            ...state.lastFetchedByClient,
                            [clientID]: Date.now()
                        },
                        cacheInfoByClient: {
                            ...state.cacheInfoByClient,
                            [clientID]: data.cacheInfo ?? null
                        },
                        loading: false
                    }));
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
                set({
                    error: errorMessage,
                    loading: false
                });
            }
        }
    }), {
    name: 'client-details-store'
}));

},{"zustand":"Ze5I5","zustand/middleware":"9udS2","@/client/config":"8SWgh","@/client/lib/apiError":"aL0RR","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bMJjY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAllPersistentStreamsStore", ()=>useAllPersistentStreamsStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
var _config = require("@/client/config");
var _apiError = require("@/client/lib/apiError");
const useAllPersistentStreamsStore = (0, _zustand.create)()((0, _middleware.devtools)((set, get)=>({
        streams: [],
        loading: false,
        error: null,
        lastFetched: null,
        cacheInfo: null,
        setStreams: (streams)=>set({
                streams,
                error: null
            }),
        setLoading: (loading)=>set({
                loading
            }),
        setError: (error)=>set({
                error
            }),
        invalidateCache: ()=>set({
                streams: [],
                lastFetched: null,
                cacheInfo: null
            }),
        fetchStreams: async (accessToken, logout, forceRefresh = false)=>{
            const state = get();
            // If we have cached data and not forcing refresh, skip the fetch
            if (!forceRefresh && state.streams.length > 0 && state.lastFetched) return;
            set({
                loading: true,
                error: null
            });
            try {
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/persistent-streams`, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.ok) {
                    if ((0, _apiError.handleApiError)(response, logout)) return;
                    throw new Error(`Failed to fetch persistent streams: ${response.statusText}`);
                }
                const data = await response.json();
                set({
                    streams: data.persistentStreams,
                    lastFetched: Date.now(),
                    loading: false,
                    cacheInfo: data.cacheInfo ?? null
                });
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
                set({
                    error: errorMessage,
                    loading: false
                });
            }
        }
    }), {
    name: 'all-persistent-streams-store'
}));

},{"zustand":"Ze5I5","zustand/middleware":"9udS2","@/client/config":"8SWgh","@/client/lib/apiError":"aL0RR","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4fRzE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useClientPlatformStore", ()=>useClientPlatformStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
var _config = require("@/client/config");
var _apiError = require("@/client/lib/apiError");
const useClientPlatformStore = (0, _zustand.create)()((0, _middleware.devtools)((set, get)=>({
        summaryByClient: {},
        cacheInfoByClient: {},
        loading: false,
        error: null,
        getSummary: (clientID)=>get().summaryByClient[clientID] || null,
        fetchSummary: async (clientID, logout, accessToken, forceRefresh = false)=>{
            if (!forceRefresh && get().summaryByClient[clientID]) return;
            set({
                loading: true,
                error: null
            });
            try {
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/clients/${clientID}/platform-summary`, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.ok) {
                    if ((0, _apiError.handleApiError)(response, logout)) return;
                    throw new Error(`Failed to fetch platform summary: ${response.statusText}`);
                }
                const data = await response.json();
                set((state)=>({
                        summaryByClient: {
                            ...state.summaryByClient,
                            [clientID]: data.summary
                        },
                        cacheInfoByClient: {
                            ...state.cacheInfoByClient,
                            [clientID]: data.cacheInfo ?? null
                        },
                        loading: false
                    }));
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
                set({
                    error: errorMessage,
                    loading: false
                });
            }
        }
    }), {
    name: 'client-platform-store'
}));

},{"zustand":"Ze5I5","zustand/middleware":"9udS2","@/client/config":"8SWgh","@/client/lib/apiError":"aL0RR","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eZO0I":[function(require,module,exports,__globalThis) {
/**
 * Plain-text client summary for pasting into email, Slack or a ticket (#231).
 * Missing fields are omitted, never rendered as "null". API keys and webhook
 * credentials are deliberately excluded.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildClientSummary", ()=>buildClientSummary);
function joinPresent(parts, sep) {
    return parts.filter((p)=>Boolean(p)).join(sep);
}
function section(title, lines) {
    return lines.length > 0 ? [
        '',
        title,
        ...lines.map((l)=>`  ${l}`)
    ] : [];
}
function buildClientSummary(input) {
    const { details, platform } = input;
    const account = details?.accountInfo;
    const level = details?.package?.levelName;
    const header = [
        `${input.name ?? `Client ${input.clientID}`} (clientID ${input.clientID})`,
        joinPresent([
            level && `Level: ${level}`,
            input.timeZone && `TZ: ${input.timeZone}`
        ], ' | ')
    ].filter(Boolean);
    const address = account ? joinPresent([
        account.city,
        joinPresent([
            account.state,
            account.zip
        ], ' '),
        account.countryCode
    ], ', ') : '';
    const accountLines = [
        account?.phone && `Phone: ${account.phone}`,
        address && `Address: ${address}`,
        account?.demoTTL && 'Demo account'
    ].filter((l)=>Boolean(l));
    const contactLines = input.contacts.map((c)=>{
        const name = joinPresent([
            c.firstName,
            c.lastName
        ], ' ');
        return name ? `${name} - ${c.email}` : c.email;
    });
    const platformLines = [
        `Encoders: ${input.encoders.online} online / ${input.encoders.total} total`,
        `24x7 streams: ${input.persistentStreamCount}`,
        platform && `Live events (12 mo): ${platform.liveEventCount}`,
        platform && platform.services.length > 0 && `Services: ${platform.services.map((s)=>s.label).join(', ')}`
    ].filter((l)=>Boolean(l));
    return [
        ...header,
        ...section('ACCOUNT', accountLines),
        ...section('CONTACTS', contactLines),
        ...section('PLATFORM', platformLines)
    ].join('\n');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jcJAm":[function(require,module,exports,__globalThis) {
/**
 * Primary business contacts per client.
 *
 * Hand-selected platform users (users.userId) who are the client's primary
 * business contacts — not technicians (those are clientTechs). Intentionally
 * empty until leadership supplies the list. A proper contacts table is
 * tracked in #227.
 *
 * Shape: { [clientID]: userId[] }
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLIENT_PRIMARY_CONTACTS", ()=>CLIENT_PRIMARY_CONTACTS);
const CLIENT_PRIMARY_CONTACTS = {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gJDgB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columns", ()=>columns);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _lucideReact = require("lucide-react");
var _button = require("@/client/components/ui/button");
var _tooltip = require("@/client/components/ui/tooltip");
const USER_ROLES = {
    1: 'Admin',
    2: 'Manager',
    3: 'User'
};
const AUTH_TYPES = {
    1: 'Standard',
    2: 'SSO',
    3: 'LDAP'
};
/** Truncated cell with tooltip on hover */ function TruncatedCell({ value, maxWidth = 200 }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltip.Tooltip), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipTrigger), {
                asChild: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "block truncate",
                    style: {
                        maxWidth: `${maxWidth}px`
                    },
                    children: value
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipContent), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: value
                })
            })
        ]
    });
}
/** Clickable email cell that copies on click */ function CopyableEmailCell({ email }) {
    const [copied, setCopied] = (0, _react.useState)(false);
    const handleCopy = async ()=>{
        await navigator.clipboard.writeText(email);
        setCopied(true);
        setTimeout(()=>setCopied(false), 2000);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        onClick: handleCopy,
        className: "group flex items-center gap-1 max-w-[200px] hover:text-primary transition-colors cursor-pointer text-left",
        title: `Click to copy: ${email}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "truncate",
                children: email
            }),
            copied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                className: "h-3 w-3 text-green-600 flex-shrink-0"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Copy), {
                className: "h-3 w-3 text-muted-foreground flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity"
            })
        ]
    });
}
const columns = [
    {
        accessorKey: 'userId',
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "ID",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        },
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-mono",
                children: row.getValue('userId')
            })
    },
    {
        id: 'name',
        accessorFn: (row)=>{
            const first = row.firstName || '';
            const last = row.lastName || '';
            return `${first} ${last}`.trim() || '-';
        },
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Name",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        },
        cell: ({ row })=>{
            const name = row.getValue('name');
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TruncatedCell, {
                value: name,
                maxWidth: 150
            });
        }
    },
    {
        accessorKey: 'email',
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Email",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        },
        cell: ({ row })=>{
            const email = row.getValue('email');
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CopyableEmailCell, {
                email: email
            });
        }
    },
    {
        accessorKey: 'userRole',
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Role",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        },
        cell: ({ row })=>{
            const role = row.getValue('userRole');
            return role ? USER_ROLES[role] || `Role ${role}` : '-';
        }
    },
    {
        accessorKey: 'authenticationType',
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                className: "hidden lg:flex",
                children: [
                    "Auth Type",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        },
        cell: ({ row })=>{
            const authType = row.getValue('authenticationType');
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "hidden lg:inline",
                children: AUTH_TYPES[authType] || `Type ${authType}`
            });
        },
        meta: {
            className: 'hidden lg:table-cell'
        }
    },
    {
        accessorKey: 'recieveEmails',
        header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "hidden xl:inline",
                children: "Emails"
            }),
        cell: ({ row })=>{
            const value = row.getValue('recieveEmails');
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "hidden xl:inline",
                children: value ? 'Yes' : 'No'
            });
        },
        meta: {
            className: 'hidden xl:table-cell'
        }
    },
    {
        accessorKey: 'locked',
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Status",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        },
        cell: ({ row })=>{
            const locked = row.getValue('locked');
            return locked ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-destructive",
                children: "Locked"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-green-600",
                children: "Active"
            });
        }
    }
];

},{"react/jsx-runtime":"dQjte","react":"eGun2","lucide-react":[["ArrowUpDown","amX4k","default"],["Check","bajJU","default"],["Copy","jM41N","default"]],"@/client/components/ui/button":"armlb","@/client/components/ui/tooltip":"dWqZd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8YaML":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountInfoCard", ()=>(0, _accountInfoCard.AccountInfoCard));
parcelHelpers.export(exports, "PackageCard", ()=>(0, _packageCard.PackageCard));
parcelHelpers.export(exports, "WebhooksCard", ()=>(0, _webhooksCard.WebhooksCard));
parcelHelpers.export(exports, "TechsCard", ()=>(0, _techsCard.TechsCard));
parcelHelpers.export(exports, "ContactsCard", ()=>(0, _contactsCard.ContactsCard));
parcelHelpers.export(exports, "PlatformSummaryCard", ()=>(0, _platformSummaryCard.PlatformSummaryCard));
parcelHelpers.export(exports, "VendorsCard", ()=>(0, _vendorsCard.VendorsCard));
parcelHelpers.export(exports, "ApiKeysCard", ()=>(0, _apiKeysCard.ApiKeysCard));
var _accountInfoCard = require("./AccountInfoCard");
var _packageCard = require("./PackageCard");
var _webhooksCard = require("./WebhooksCard");
var _techsCard = require("./TechsCard");
var _contactsCard = require("./ContactsCard");
var _platformSummaryCard = require("./PlatformSummaryCard");
var _vendorsCard = require("./VendorsCard");
var _apiKeysCard = require("./ApiKeysCard");

},{"./AccountInfoCard":"9skob","./PackageCard":"7Pu07","./WebhooksCard":"cZd9w","./TechsCard":"98hDU","./ContactsCard":"7e7O3","./PlatformSummaryCard":"9hxYy","./VendorsCard":"gI4x8","./ApiKeysCard":"7zrok","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9skob":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountInfoCard", ()=>AccountInfoCard);
var _jsxRuntime = require("react/jsx-runtime");
var _badge = require("@/client/components/ui/badge");
var _lucideReact = require("lucide-react");
function AccountInfoCard({ accountInfo, entAuth }) {
    // Format location string
    const getLocationString = ()=>{
        if (!accountInfo) return null;
        const parts = [
            accountInfo.city,
            accountInfo.state,
            accountInfo.zip
        ].filter(Boolean);
        return parts.length > 0 ? parts.join(', ') : null;
    };
    const location = getLocationString();
    const hasData = location || accountInfo?.phone || entAuth || accountInfo?.demoTTL;
    if (!hasData) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "rounded-md border bg-muted/30 px-4 py-3 flex flex-wrap items-center gap-x-6 gap-y-2",
        children: [
            location && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2 text-sm",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.MapPin), {
                        className: "h-4 w-4 text-muted-foreground"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: location
                    })
                ]
            }),
            accountInfo?.phone && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2 text-sm",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Phone), {
                        className: "h-4 w-4 text-muted-foreground"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: accountInfo.phone
                    })
                ]
            }),
            entAuth && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2 text-sm",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Shield), {
                        className: "h-4 w-4 text-muted-foreground"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                        variant: "secondary",
                        className: "text-xs",
                        children: entAuth.authAppName
                    })
                ]
            }),
            accountInfo?.demoTTL && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2 text-sm",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Clock), {
                        className: "h-4 w-4 text-muted-foreground"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                        variant: "outline",
                        className: "text-xs",
                        children: "Demo Account"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","@/client/components/ui/badge":"h4e1f","lucide-react":[["Clock","eqIIU","default"],["MapPin","hxgmw","default"],["Phone","b1Zrv","default"],["Shield","9l0Bk","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eqIIU":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Clock);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 6v6l4 2",
            key: "mmk7yg"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
];
const Clock = (0, _createLucideIconJsDefault.default)("clock", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hxgmw":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>MapPin);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
            key: "1r0f0z"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "10",
            r: "3",
            key: "ilqhr7"
        }
    ]
];
const MapPin = (0, _createLucideIconJsDefault.default)("map-pin", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"b1Zrv":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Phone);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
            key: "9njp5v"
        }
    ]
];
const Phone = (0, _createLucideIconJsDefault.default)("phone", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9l0Bk":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Shield);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ]
];
const Shield = (0, _createLucideIconJsDefault.default)("shield", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7Pu07":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PackageCard", ()=>PackageCard);
var _jsxRuntime = require("react/jsx-runtime");
var _card = require("@/client/components/ui/card");
var _badge = require("@/client/components/ui/badge");
var _lucideReact = require("lucide-react");
/**
 * Format bytes to human readable (for maxBandwidth - stored in bytes)
 * e.g., 3000000000000 = 3 TB
 */ function formatBytes(bytes) {
    const num = typeof bytes === 'string' ? parseInt(bytes, 10) : bytes;
    if (num === 0) return '0 B';
    const k = 1024;
    const sizes = [
        'B',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB'
    ];
    const i = Math.floor(Math.log(num) / Math.log(k));
    return parseFloat((num / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
}
/**
 * Format megabytes to human readable (for maxStorage - stored in MB)
 * e.g., maxStorage=2048000 means ~2 TB (2,048,000 MB)
 */ function formatMegabytes(mb) {
    const num = typeof mb === 'string' ? parseInt(mb, 10) : mb;
    if (num === 0) return '0 MB';
    if (num < 1024) return `${num} MB`;
    const gb = num / 1024;
    if (gb < 1024) return `${gb.toFixed(gb < 10 ? 1 : 0)} GB`;
    const tb = gb / 1024;
    return `${tb.toFixed(1)} TB`;
}
// Format currency
function formatCurrency(amount) {
    const num = typeof amount === 'string' ? parseFloat(amount) : amount;
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(num);
}
function PackageCard({ packageInfo, transcription }) {
    if (!packageInfo && !transcription) return null;
    const hasDiscounts = packageInfo && (packageInfo.discountPercent > 0 || packageInfo.discountBWOPercent > 0 || packageInfo.discountSTOPercent > 0);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                className: "pb-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                            className: "text-base font-medium flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Package), {
                                    className: "h-4 w-4"
                                }),
                                "Package / Billing"
                            ]
                        }),
                        packageInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                            variant: "default",
                            children: packageInfo.levelName
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardContent), {
                className: "space-y-3",
                children: [
                    packageInfo && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-2 gap-4 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Zap), {
                                                className: "h-4 w-4 text-muted-foreground"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-muted-foreground text-xs",
                                                        children: "Max BW"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: formatBytes(packageInfo.maxBandwidth)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.HardDrive), {
                                                className: "h-4 w-4 text-muted-foreground"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-muted-foreground text-xs",
                                                        children: "Storage"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        children: formatMegabytes(packageInfo.maxStorage)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            hasDiscounts && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Percent), {
                                        className: "h-4 w-4 text-muted-foreground"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "text-muted-foreground",
                                        children: "Discounts:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex gap-1",
                                        children: [
                                            packageInfo.discountPercent > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                                variant: "secondary",
                                                className: "text-xs",
                                                children: [
                                                    packageInfo.discountPercent,
                                                    "% General"
                                                ]
                                            }),
                                            packageInfo.discountBWOPercent > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                                variant: "secondary",
                                                className: "text-xs",
                                                children: [
                                                    packageInfo.discountBWOPercent,
                                                    "% BW"
                                                ]
                                            }),
                                            packageInfo.discountSTOPercent > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                                variant: "secondary",
                                                className: "text-xs",
                                                children: [
                                                    packageInfo.discountSTOPercent,
                                                    "% STO"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "pt-2 border-t text-sm",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "text-muted-foreground",
                                        children: "Monthly Rate:"
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-medium",
                                        children: formatCurrency(packageInfo.monthlyRate)
                                    })
                                ]
                            })
                        ]
                    }),
                    transcription && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "pt-2 border-t",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2 text-sm",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FileText), {
                                    className: "h-4 w-4 text-muted-foreground"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-muted-foreground",
                                    children: "Transcription:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex gap-1 items-center",
                                    children: [
                                        transcription.autoOnPublish && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                            variant: "default",
                                            className: "text-xs",
                                            children: "Auto"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            children: [
                                                transcription.monthlyBulkHrs,
                                                "h bulk"
                                            ]
                                        }),
                                        transcription.rateDiscount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                            variant: "secondary",
                                            className: "text-xs",
                                            children: [
                                                transcription.rateDiscount,
                                                "% off"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","@/client/components/ui/card":"dhIfn","@/client/components/ui/badge":"h4e1f","lucide-react":[["FileText","jrUS7","default"],["HardDrive","1nIEX","default"],["Package","jrJzU","default"],["Percent","g9tBZ","default"],["Zap","gsKiA","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1nIEX":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>HardDrive);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "line",
        {
            x1: "22",
            x2: "2",
            y1: "12",
            y2: "12",
            key: "1y58io"
        }
    ],
    [
        "path",
        {
            d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
            key: "oot6mr"
        }
    ],
    [
        "line",
        {
            x1: "6",
            x2: "6.01",
            y1: "16",
            y2: "16",
            key: "sgf278"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10.01",
            y1: "16",
            y2: "16",
            key: "1l4acy"
        }
    ]
];
const HardDrive = (0, _createLucideIconJsDefault.default)("hard-drive", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jrJzU":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Package);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
            key: "1a0edw"
        }
    ],
    [
        "path",
        {
            d: "M12 22V12",
            key: "d0xqtd"
        }
    ],
    [
        "polyline",
        {
            points: "3.29 7 12 12 20.71 7",
            key: "ousv84"
        }
    ],
    [
        "path",
        {
            d: "m7.5 4.27 9 5.15",
            key: "1c824w"
        }
    ]
];
const Package = (0, _createLucideIconJsDefault.default)("package", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"g9tBZ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Percent);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "line",
        {
            x1: "19",
            x2: "5",
            y1: "5",
            y2: "19",
            key: "1x9vlm"
        }
    ],
    [
        "circle",
        {
            cx: "6.5",
            cy: "6.5",
            r: "2.5",
            key: "4mh3h7"
        }
    ],
    [
        "circle",
        {
            cx: "17.5",
            cy: "17.5",
            r: "2.5",
            key: "1mdrzq"
        }
    ]
];
const Percent = (0, _createLucideIconJsDefault.default)("percent", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gsKiA":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Zap);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
            key: "1xq2db"
        }
    ]
];
const Zap = (0, _createLucideIconJsDefault.default)("zap", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cZd9w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WebhooksCard", ()=>WebhooksCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _card = require("@/client/components/ui/card");
var _badge = require("@/client/components/ui/badge");
var _lucideReact = require("lucide-react");
// Truncate URL for display
function truncateUrl(url, maxLength = 35) {
    if (url.length <= maxLength) return url;
    return url.substring(0, maxLength) + '...';
}
// Get auth type display
function getAuthDisplay(authType) {
    switch(authType.toLowerCase()){
        case 'basic':
            return {
                label: 'Basic',
                icon: (0, _lucideReact.KeyRound)
            };
        case 'bearer':
            return {
                label: 'Bearer',
                icon: (0, _lucideReact.Key)
            };
        default:
            return {
                label: authType,
                icon: (0, _lucideReact.Key)
            };
    }
}
function CopyableUrl({ url }) {
    const [copied, setCopied] = (0, _react.useState)(false);
    const handleCopy = async ()=>{
        await navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(()=>setCopied(false), 2000);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        onClick: handleCopy,
        className: "flex items-center gap-1 truncate font-mono text-xs hover:text-primary transition-colors cursor-pointer text-left",
        title: `Click to copy: ${url}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "truncate",
                children: truncateUrl(url)
            }),
            copied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                className: "h-3 w-3 text-green-600 flex-shrink-0"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Copy), {
                className: "h-3 w-3 text-muted-foreground flex-shrink-0 opacity-0 group-hover:opacity-100"
            })
        ]
    });
}
function WebhooksCard({ webhooks }) {
    if (webhooks.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                className: "pb-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                            className: "text-base font-medium flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Webhook), {
                                    className: "h-4 w-4"
                                }),
                                "Webhooks"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                            variant: "secondary",
                            children: webhooks.length
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "space-y-3",
                    children: webhooks.map((webhook)=>{
                        const authDisplay = webhook.auth ? getAuthDisplay(webhook.auth.authtype) : null;
                        const AuthIcon = authDisplay?.icon ?? (0, _lucideReact.Key);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "group flex items-center justify-between gap-2 text-sm",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "min-w-0 flex-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CopyableUrl, {
                                        url: webhook.callback
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center gap-2 flex-shrink-0",
                                    children: [
                                        authDisplay ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                            variant: "outline",
                                            className: "text-xs gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AuthIcon, {
                                                    className: "h-3 w-3"
                                                }),
                                                authDisplay.label
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                            variant: "outline",
                                            className: "text-xs text-muted-foreground",
                                            children: "None"
                                        }),
                                        webhook.upNow ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                            variant: "default",
                                            className: "text-xs gap-1 bg-green-600",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CheckCircle), {
                                                    className: "h-3 w-3"
                                                }),
                                                "Active"
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                            variant: "secondary",
                                            className: "text-xs gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XCircle), {
                                                    className: "h-3 w-3"
                                                }),
                                                "Inactive"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, webhook.webhookIdx);
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@/client/components/ui/card":"dhIfn","@/client/components/ui/badge":"h4e1f","lucide-react":[["Check","bajJU","default"],["CheckCircle","2O3dV","default"],["Copy","jM41N","default"],["Key","cjoQs","default"],["KeyRound","1n5DY","default"],["Webhook","1VKcp","default"],["XCircle","aDWrd","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cjoQs":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Key);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4",
            key: "g0fldk"
        }
    ],
    [
        "path",
        {
            d: "m21 2-9.6 9.6",
            key: "1j0ho8"
        }
    ],
    [
        "circle",
        {
            cx: "7.5",
            cy: "15.5",
            r: "5.5",
            key: "yqb3hr"
        }
    ]
];
const Key = (0, _createLucideIconJsDefault.default)("key", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1n5DY":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>KeyRound);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z",
            key: "1s6t7t"
        }
    ],
    [
        "circle",
        {
            cx: "16.5",
            cy: "7.5",
            r: ".5",
            fill: "currentColor",
            key: "w0ekpg"
        }
    ]
];
const KeyRound = (0, _createLucideIconJsDefault.default)("key-round", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"98hDU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TechsCard", ()=>TechsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _card = require("@/client/components/ui/card");
var _badge = require("@/client/components/ui/badge");
var _lucideReact = require("lucide-react");
function TechsCard({ techs }) {
    if (techs.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                className: "pb-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                            className: "text-base font-medium flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Users), {
                                    className: "h-4 w-4"
                                }),
                                "Techs"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                            variant: "secondary",
                            children: techs.length
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "space-y-4",
                    children: techs.map((tech)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.User), {
                                            className: "h-4 w-4 text-muted-foreground"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-medium text-sm",
                                            children: tech.techName
                                        })
                                    ]
                                }),
                                tech.assignedUsers.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ml-6 space-y-1",
                                    children: tech.assignedUsers.map((user)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2 text-sm text-muted-foreground",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Mail), {
                                                    className: "h-3 w-3"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: user.firstName || user.lastName ? `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim() : user.email
                                                }),
                                                (user.firstName || user.lastName) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "text-xs",
                                                    children: [
                                                        "(",
                                                        user.email,
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }, user.userId))
                                }),
                                tech.assignedUsers.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "ml-6 text-sm text-muted-foreground italic",
                                    children: "No users assigned"
                                })
                            ]
                        }, tech.techID))
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","@/client/components/ui/card":"dhIfn","@/client/components/ui/badge":"h4e1f","lucide-react":[["Mail","SVW9c","default"],["User","7RvpF","default"],["Users","in3JI","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"SVW9c":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Mail);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7",
            key: "132q7q"
        }
    ],
    [
        "rect",
        {
            x: "2",
            y: "4",
            width: "20",
            height: "16",
            rx: "2",
            key: "izxlao"
        }
    ]
];
const Mail = (0, _createLucideIconJsDefault.default)("mail", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7RvpF":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>User);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
            key: "975kel"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "7",
            r: "4",
            key: "17ys0d"
        }
    ]
];
const User = (0, _createLucideIconJsDefault.default)("user", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7e7O3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Primary business contacts for the client. Not technicians — those are in TechsCard.
 * Sourced from the hand-maintained CLIENT_PRIMARY_CONTACTS map until #227 adds a contacts table.
 */ parcelHelpers.export(exports, "ContactsCard", ()=>ContactsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _card = require("@/client/components/ui/card");
var _badge = require("@/client/components/ui/badge");
var _lucideReact = require("lucide-react");
function ContactsCard({ contacts }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                className: "pb-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                            className: "text-base font-medium flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Contact), {
                                    className: "h-4 w-4"
                                }),
                                "Primary Contacts"
                            ]
                        }),
                        contacts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                            variant: "secondary",
                            children: contacts.length
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                children: contacts.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-sm text-muted-foreground italic",
                    children: "No primary contacts designated yet."
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "space-y-2",
                    children: contacts.map((user)=>{
                        const name = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2 text-sm",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Mail), {
                                    className: "h-3 w-3 text-muted-foreground"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-medium",
                                    children: name || user.email
                                }),
                                name && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "text-xs text-muted-foreground",
                                    children: [
                                        "(",
                                        user.email,
                                        ")"
                                    ]
                                })
                            ]
                        }, user.userId);
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","@/client/components/ui/card":"dhIfn","@/client/components/ui/badge":"h4e1f","lucide-react":[["Contact","cii3E","default"],["Mail","SVW9c","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cii3E":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Contact);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M16 2v2",
            key: "scm5qe"
        }
    ],
    [
        "path",
        {
            d: "M7 22v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2",
            key: "1waht3"
        }
    ],
    [
        "path",
        {
            d: "M8 2v2",
            key: "pbkmx"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "11",
            r: "3",
            key: "itu57m"
        }
    ],
    [
        "rect",
        {
            x: "3",
            y: "4",
            width: "18",
            height: "18",
            rx: "2",
            key: "12vinp"
        }
    ]
];
const Contact = (0, _createLucideIconJsDefault.default)("contact", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9hxYy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PlatformSummaryCard", ()=>PlatformSummaryCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("@tanstack/react-router");
var _card = require("@/client/components/ui/card");
var _badge = require("@/client/components/ui/badge");
var _tooltip = require("@/client/components/ui/tooltip");
var _lucideReact = require("lucide-react");
const BASIS_LABELS = {
    package: 'Included in package',
    configured: 'Configured for this client',
    activity: 'Used in the last 12 months'
};
function PlatformSummaryCard({ clientID, summary }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                className: "pb-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                    className: "text-base font-medium flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Layers), {
                            className: "h-4 w-4"
                        }),
                        "Platform"
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardContent), {
                className: "space-y-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                        to: "/events/reports",
                        search: {
                            clientID,
                            startDate: summary.range.start,
                            endDate: summary.range.end
                        },
                        className: "flex items-center justify-between rounded-md border p-3 hover:bg-accent transition-colors",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Radio), {
                                        className: "h-4 w-4 text-muted-foreground"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-medium",
                                        children: summary.liveEventCount.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "text-muted-foreground",
                                        children: "live events in the last 12 months"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowRight), {
                                className: "h-4 w-4 text-muted-foreground"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-2 text-sm",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-muted-foreground",
                                children: "Services:"
                            }),
                            summary.services.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-muted-foreground italic",
                                children: "None detected"
                            }) : summary.services.map((service)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltip.Tooltip), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipTrigger), {
                                            asChild: true,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                                variant: "secondary",
                                                className: "text-xs cursor-help",
                                                children: service.label
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipContent), {
                                            side: "bottom",
                                            className: "text-xs",
                                            children: service.basis.map((b)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    children: BASIS_LABELS[b]
                                                }, b))
                                        })
                                    ]
                                }, service.key))
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","@tanstack/react-router":"7k6Lq","@/client/components/ui/card":"dhIfn","@/client/components/ui/badge":"h4e1f","@/client/components/ui/tooltip":"dWqZd","lucide-react":[["ArrowRight","itm6a","default"],["Layers","eQ4jd","default"],["Radio","8O5hz","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"itm6a":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ArrowRight);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
];
const ArrowRight = (0, _createLucideIconJsDefault.default)("arrow-right", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eQ4jd":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Layers);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
            key: "zw3jo"
        }
    ],
    [
        "path",
        {
            d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
            key: "1wduqc"
        }
    ],
    [
        "path",
        {
            d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
            key: "kqbvx6"
        }
    ]
];
const Layers = (0, _createLucideIconJsDefault.default)("layers", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gI4x8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VendorsCard", ()=>VendorsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _card = require("@/client/components/ui/card");
var _badge = require("@/client/components/ui/badge");
var _lucideReact = require("lucide-react");
function VendorsCard({ vendors }) {
    if (vendors.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                className: "pb-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                            className: "text-base font-medium flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Briefcase), {
                                    className: "h-4 w-4"
                                }),
                                "Vendors / Contractors"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                            variant: "secondary",
                            children: vendors.length
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "space-y-2",
                    children: vendors.map((vendor)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2 text-sm",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Building), {
                                    className: "h-4 w-4 text-muted-foreground"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-medium",
                                    children: vendor.vendorName || `Vendor ${vendor.vendorID}`
                                }),
                                vendor.vendorCode && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                    variant: "outline",
                                    className: "text-xs font-mono",
                                    children: [
                                        "VendorID: ",
                                        vendor.vendorCode
                                    ]
                                })
                            ]
                        }, vendor.vendorID))
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","@/client/components/ui/card":"dhIfn","@/client/components/ui/badge":"h4e1f","lucide-react":[["Briefcase","9F9Jw","default"],["Building","eFJoJ","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9F9Jw":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Briefcase);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16",
            key: "jecpp"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "6",
            rx: "2",
            key: "i6l2r4"
        }
    ]
];
const Briefcase = (0, _createLucideIconJsDefault.default)("briefcase", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eFJoJ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Building);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 10h.01",
            key: "1nrarc"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M12 6h.01",
            key: "1vi96p"
        }
    ],
    [
        "path",
        {
            d: "M16 10h.01",
            key: "1m94wz"
        }
    ],
    [
        "path",
        {
            d: "M16 14h.01",
            key: "1gbofw"
        }
    ],
    [
        "path",
        {
            d: "M16 6h.01",
            key: "1x0f13"
        }
    ],
    [
        "path",
        {
            d: "M8 10h.01",
            key: "19clt8"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ],
    [
        "path",
        {
            d: "M8 6h.01",
            key: "1dz90k"
        }
    ],
    [
        "path",
        {
            d: "M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3",
            key: "cabbwy"
        }
    ],
    [
        "rect",
        {
            x: "4",
            y: "2",
            width: "16",
            height: "20",
            rx: "2",
            key: "1uxh74"
        }
    ]
];
const Building = (0, _createLucideIconJsDefault.default)("building", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7zrok":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApiKeysCard", ()=>ApiKeysCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _card = require("@/client/components/ui/card");
var _button = require("@/client/components/ui/button");
var _lucideReact = require("lucide-react");
function ApiKeysCard({ api }) {
    const [copied, setCopied] = (0, _react.useState)(false);
    if (!api) return null;
    const handleCopy = async ()=>{
        await navigator.clipboard.writeText(api.APIkey);
        setCopied(true);
        setTimeout(()=>setCopied(false), 2000);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                className: "pb-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                    className: "text-base font-medium flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Key), {
                            className: "h-4 w-4"
                        }),
                        "API Access"
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center justify-between gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "min-w-0 flex-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-xs text-muted-foreground",
                                    children: "API Key"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "font-mono text-sm truncate",
                                    children: api.APIkey
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            variant: "ghost",
                            size: "icon",
                            className: "h-8 w-8 flex-shrink-0",
                            onClick: handleCopy,
                            children: copied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                                className: "h-4 w-4 text-green-600"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Copy), {
                                className: "h-4 w-4"
                            })
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@/client/components/ui/card":"dhIfn","@/client/components/ui/button":"armlb","lucide-react":[["Check","bajJU","default"],["Copy","jM41N","default"],["Key","cjoQs","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9LO3O":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ClipboardCopy);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "rect",
        {
            width: "8",
            height: "4",
            x: "8",
            y: "2",
            rx: "1",
            ry: "1",
            key: "tgr4d6"
        }
    ],
    [
        "path",
        {
            d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2",
            key: "4jdomd"
        }
    ],
    [
        "path",
        {
            d: "M16 4h2a2 2 0 0 1 2 2v4",
            key: "3hqy98"
        }
    ],
    [
        "path",
        {
            d: "M21 14H11",
            key: "1bme5i"
        }
    ],
    [
        "path",
        {
            d: "m15 10-4 4 4 4",
            key: "5dvupr"
        }
    ]
];
const ClipboardCopy = (0, _createLucideIconJsDefault.default)("clipboard-copy", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eMWtI":[function(require,module,exports,__globalThis) {
/**
 * Layout route for all /encoders/* pages
 * Ensures encoder and live streams data is loaded for child routes (index, triage, detail)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _root = require("../__root");
var _encodersStore = require("@/client/store/encodersStore");
var _liveStreamsStore = require("@/client/store/liveStreamsStore");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    id: 'encoders-layout',
    component: EncodersLayout
});
function EncodersLayout() {
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    const fetchEncoders = (0, _encodersStore.useEncodersStore)((s)=>s.fetchEncoders);
    const fetchLiveStreams = (0, _liveStreamsStore.useLiveStreamsStore)((s)=>s.fetchLiveStreams);
    // Fetch encoders and live streams (store handles caching internally)
    (0, _react.useEffect)(()=>{
        const loadData = async ()=>{
            try {
                const token = await getAccessTokenSilently();
                // Both store functions skip fetch if data already cached
                await Promise.all([
                    fetchEncoders(token, logout),
                    fetchLiveStreams(token, logout)
                ]);
            } catch (err) {
                console.error('Error fetching data in encoders layout:', err);
            }
        };
        loadData();
    }, [
        getAccessTokenSilently,
        fetchEncoders,
        fetchLiveStreams,
        logout
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Outlet), {});
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["Outlet","aAETe"]],"@auth0/auth0-react":"gpXrE","../__root":"enXay","@/client/store/encodersStore":"7Qwmv","@/client/store/liveStreamsStore":"7F9wp","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9kKq3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _reactTable = require("@tanstack/react-table");
var _layout = require("./_layout");
var _layout1 = require("@/client/layouts/layout");
var _encodersStore = require("@/client/store/encodersStore");
var _encoderWSSStore = require("@/client/store/encoderWSSStore");
var _clientsStore = require("@/client/store/clientsStore");
var _liveStreamsStore = require("@/client/store/liveStreamsStore");
var _table = require("@/client/components/ui/table");
var _input = require("@/client/components/ui/input");
var _switch = require("@/client/components/ui/switch");
var _label = require("@/client/components/ui/label");
var _button = require("@/client/components/ui/button");
var _cacheTimestamp = require("@/client/components/cache-timestamp");
var _lucideReact = require("lucide-react");
var _config = require("@/client/config");
var _format = require("@/client/lib/format");
var _searchParams = require("@/client/lib/searchParams");
var _usePersistedSearch = require("@/client/hooks/usePersistedSearch");
var _resetFiltersButton = require("@/client/components/reset-filters-button");
var _tableUtils = require("@/client/components/table-utils");
var _cells = require("@/client/components/tables/cells");
/** Parse JSON streamInfo from DB, returns null on failure */ function parseDbStreamInfo(encoder) {
    try {
        const jsonStr = encoder.streamInfo?.streamInfo;
        if (!jsonStr) return null;
        return JSON.parse(jsonStr);
    } catch  {
        return null;
    }
}
/** Get stream info, preferring WSS data over DB data */ function getStreamInfo(encoder) {
    return encoder.wss?.streamInfo ?? encoder.dbStreamInfo;
}
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _layout.Route),
    path: 'encoders',
    validateSearch: (search)=>({
            clientID: (0, _searchParams.parseString)(search.clientID),
            search: (0, _searchParams.parseString)(search.search),
            onlineOnly: (0, _searchParams.parseBoolean)(search.onlineOnly, true)
        }),
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: EncodersComponent
});
const columnHelper = (0, _reactTable.createColumnHelper)();
const columns = [
    columnHelper.accessor('clientName', {
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Client"
            }),
        cell: (info)=>{
            const clientName = info.getValue();
            if (!clientName) return '-';
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.ClientNameCell), {
                clientID: info.row.original.clientID,
                clientName: clientName
            });
        }
    }),
    columnHelper.accessor('simpleName', {
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Name"
            }),
        cell: (info)=>info.getValue()
    }),
    columnHelper.display({
        id: 'liveStatus',
        header: 'Status',
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.LiveStatus), {
                wss: row.original.wss,
                dbStatus: row.original.status
            })
    }),
    columnHelper.display({
        id: 'liveEvent',
        header: 'Live Event',
        cell: ({ row })=>{
            const liveEvent = row.original.liveEvent;
            if (!liveEvent) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-muted-foreground",
                children: "-"
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EventIDCell), {
                eventID: liveEvent.eventID
            });
        }
    }),
    columnHelper.display({
        id: 'resolution',
        header: 'Resolution',
        cell: ({ row })=>{
            const streamInfo = getStreamInfo(row.original);
            if (!streamInfo?.width || !streamInfo?.height) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-muted-foreground",
                children: "-"
            });
            return (0, _format.formatResolution)(streamInfo.width, streamInfo.height);
        }
    }),
    columnHelper.display({
        id: 'bitrate',
        header: 'Bitrate',
        cell: ({ row })=>{
            const streamInfo = getStreamInfo(row.original);
            if (!streamInfo?.bitrate) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-muted-foreground",
                children: "-"
            });
            return (0, _format.formatBitrate)(streamInfo.bitrate);
        }
    }),
    columnHelper.display({
        id: 'frameRate',
        header: 'FPS',
        cell: ({ row })=>{
            const streamInfo = getStreamInfo(row.original);
            if (!streamInfo?.real_frame_rate) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-muted-foreground",
                children: "-"
            });
            return (0, _format.formatFrameRate)(streamInfo.real_frame_rate);
        }
    }),
    columnHelper.accessor('inputURI', {
        header: 'Input URI',
        cell: (info)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-mono text-xs",
                children: info.getValue()
            }),
        enableSorting: false
    }),
    columnHelper.accessor('lastCommunication', {
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Last Comm"
            }),
        cell: (info)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.LastCommunication), {
                lastCommunication: info.getValue()
            })
    }),
    columnHelper.display({
        id: 'eventLinks',
        header: 'Links',
        cell: ({ row })=>{
            const liveEvent = row.original.liveEvent;
            if (!liveEvent) return null;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EventLinksCell), {
                eventID: liveEvent.eventID,
                clientID: liveEvent.clientID
            });
        },
        size: 70
    })
];
function EncodersComponent() {
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    const navigate = (0, _reactRouter.useNavigate)();
    const { clientID, search: searchFilter = '', onlineOnly: showOnlineOnly = true } = Route.useSearch();
    // Persist search params across navigation
    (0, _usePersistedSearch.usePersistedSearch)('/encoders', {
        clientID: undefined,
        search: undefined,
        onlineOnly: true
    });
    const { encoders, loading, error, cacheInfo, fetchEncoders, invalidateCache } = (0, _encodersStore.useEncodersStore)();
    const wssEncoders = (0, _encoderWSSStore.useEncoderWSSStore)((state)=>state.encoders);
    const { clients, fetchClients } = (0, _clientsStore.useClientsStore)();
    const liveStreams = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.liveStreams);
    const liveEvents = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.liveEvents);
    const [sorting, setSorting] = (0, _react.useState)([
        {
            id: 'clientName',
            desc: false
        }
    ]);
    // Build encoder → live event lookup map
    // Use API data (liveStreams) as base, WebSocket data (liveEvents) takes precedence
    const encoderLiveEventMap = (0, _react.useMemo)(()=>{
        const map = new Map();
        // First, populate from API data
        for (const stream of liveStreams)if (stream.encoderID) map.set(stream.encoderID, stream);
        // Then, WebSocket data takes precedence (more real-time)
        for (const event of liveEvents)if (event.assignedEncoder) map.set(event.assignedEncoder, event);
        return map;
    }, [
        liveStreams,
        liveEvents
    ]);
    // Update URL when search filter changes
    const setSearchFilter = (value)=>{
        navigate({
            to: '/encoders',
            search: (0, _searchParams.buildSearchParams)({
                clientID,
                search: value || undefined,
                onlineOnly: showOnlineOnly ? undefined : false
            })
        });
    };
    // Update URL when online-only toggle changes
    const setShowOnlineOnly = (value)=>{
        navigate({
            to: '/encoders',
            search: (0, _searchParams.buildSearchParams)({
                clientID,
                search: searchFilter || undefined,
                onlineOnly: value ? undefined : false
            })
        });
    };
    // Get client name for the filter badge
    const filteredClient = clientID ? clients.find((c)=>c.clientID === clientID) : null;
    (0, _react.useEffect)(()=>{
        const loadData = async ()=>{
            try {
                const token = await getAccessTokenSilently();
                await Promise.all([
                    fetchEncoders(token, logout),
                    clients.length === 0 ? fetchClients(token, logout) : Promise.resolve()
                ]);
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };
        loadData();
    }, [
        getAccessTokenSilently,
        fetchEncoders,
        fetchClients,
        clients.length
    ]);
    // Merge static encoder data with real-time WSS data and live event info
    const filteredEncoders = (0, _react.useMemo)(()=>{
        // Merge WSS data with encoders, parse DB streamInfo as fallback, add live event
        let merged = encoders.map((encoder)=>({
                ...encoder,
                wss: wssEncoders.get(encoder.encoderID) || null,
                dbStreamInfo: parseDbStreamInfo(encoder),
                liveEvent: encoderLiveEventMap.get(encoder.encoderID) || null
            }));
        // Filter by clientID if provided
        if (clientID) merged = merged.filter((encoder)=>encoder.clientID === clientID);
        // Filter by online status (check both DB status and WSS online)
        if (showOnlineOnly) merged = merged.filter((encoder)=>{
            // If we have WSS data, use it
            if (encoder.wss) return encoder.wss.online;
            // Fall back to DB status
            return encoder.status === 1;
        });
        // Filter by search text
        if (searchFilter) {
            const search = searchFilter.toLowerCase();
            merged = merged.filter((encoder)=>encoder.simpleName.toLowerCase().includes(search) || encoder.clientName.toLowerCase().includes(search) || encoder.inputURI.toLowerCase().includes(search));
        }
        return merged;
    }, [
        encoders,
        wssEncoders,
        encoderLiveEventMap,
        clientID,
        searchFilter,
        showOnlineOnly
    ]);
    const table = (0, _reactTable.useReactTable)({
        data: filteredEncoders,
        columns,
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        onSortingChange: setSorting,
        getSortedRowModel: (0, _reactTable.getSortedRowModel)(),
        state: {
            sorting
        }
    });
    const handleRefresh = async ()=>{
        try {
            const token = await getAccessTokenSilently();
            await fetch(`${(0, _config.API_BASE_URL)}/api/cache/invalidate`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    key: 'encoders:all'
                })
            });
            invalidateCache();
            await fetchEncoders(token, logout, true);
        } catch (err) {
            console.error('Error refreshing encoders:', err);
        }
    };
    const clearClientFilter = ()=>{
        navigate({
            to: '/encoders',
            search: (0, _searchParams.buildSearchParams)({
                search: searchFilter || undefined,
                onlineOnly: showOnlineOnly ? undefined : false
            })
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout1.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex justify-between items-center mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "text-2xl font-semibold",
                                        children: "Encoders"
                                    }),
                                    filteredClient && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-1 px-3 py-1 bg-muted rounded-full text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: filteredClient.name
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: clearClientFilter,
                                                className: "ml-1 hover:bg-accent rounded-full p-0.5",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.X), {
                                                    className: "h-3 w-3"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cacheTimestamp.CacheTimestamp), {
                                cachedAt: cacheInfo?.cachedAt ?? null
                            })
                        ]
                    }),
                    loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Loading encoders..."
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-4 bg-red-100 border-l-4 border-red-600 rounded mt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "m-0 text-red-800 font-medium",
                            children: [
                                "Error: ",
                                error
                            ]
                        })
                    }),
                    !loading && !error && encoders.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "No encoders found."
                    }),
                    !loading && !error && encoders.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex justify-end items-center gap-4 mb-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switch.Switch), {
                                                id: "online-only",
                                                checked: showOnlineOnly,
                                                onCheckedChange: setShowOnlineOnly
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                                htmlFor: "online-only",
                                                className: "cursor-pointer",
                                                children: "Online Only"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                        placeholder: "Filter by name, client, or URI...",
                                        value: searchFilter,
                                        onChange: (e)=>setSearchFilter(e.target.value),
                                        className: "w-80"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                        variant: "outline",
                                        onClick: handleRefresh,
                                        disabled: loading,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                                className: `h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`
                                            }),
                                            "Force Refresh"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetFiltersButton.ResetFiltersButton), {
                                        routePath: "/encoders",
                                        defaultValues: {
                                            search: undefined,
                                            onlineOnly: true
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "rounded-md border",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                            children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: header.isPlaceholder ? null : (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())
                                                        }, header.id))
                                                }, headerGroup.id))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                            children: table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    onClick: ()=>navigate({
                                                            to: `/encoders/${row.original.encoderID}`
                                                        }),
                                                    className: "cursor-pointer hover:bg-accent",
                                                    children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                            children: (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                                        }, cell.id))
                                                }, row.id))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "mt-2 text-sm text-muted-foreground",
                                children: [
                                    "Showing ",
                                    filteredEncoders.length,
                                    " of ",
                                    encoders.length,
                                    " encoders"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useNavigate","aMhxM"]],"@auth0/auth0-react":"gpXrE","@tanstack/react-table":[["createColumnHelper","3MlnA"],["getCoreRowModel","3MlnA"],["getSortedRowModel","3MlnA"],["flexRender","brwh1"],["useReactTable","brwh1"]],"./_layout":"eMWtI","@/client/layouts/layout":"d6QdD","@/client/store/encodersStore":"7Qwmv","@/client/store/encoderWSSStore":"jpzNm","@/client/store/clientsStore":"6bg3l","@/client/store/liveStreamsStore":"7F9wp","@/client/components/ui/table":"5vxZ8","@/client/components/ui/input":"8UHwi","@/client/components/ui/switch":"1p4xh","@/client/components/ui/label":"cLMZq","@/client/components/ui/button":"armlb","@/client/components/cache-timestamp":"f5Zyx","lucide-react":[["RefreshCw","7a8jT","default"],["X","8HSxK","default"]],"@/client/config":"8SWgh","@/client/lib/format":"iLptT","@/client/lib/searchParams":"fgK0T","@/client/hooks/usePersistedSearch":"kPA60","@/client/components/reset-filters-button":"9d8BP","@/client/components/table-utils":"lB8sT","@/client/components/tables/cells":"5BSEg","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"iLptT":[function(require,module,exports,__globalThis) {
/**
 * Formatting utilities for display values
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Format duration in seconds to human-readable string
 * @example formatDuration(3661) => "1h 1m 1s"
 * @example formatDuration(125) => "2m 5s"
 * @example formatDuration(45) => "45s"
 * @example formatDuration(null) => "Live"
 */ parcelHelpers.export(exports, "formatDuration", ()=>formatDuration);
/**
 * Format file size in bytes to human-readable string
 * @example formatFileSize(1073741824) => "1.0 GB"
 * @example formatFileSize(1048576) => "1.0 MB"
 * @example formatFileSize(1024) => "1.0 KB"
 * @example formatFileSize(500) => "500 B"
 * @example formatFileSize(null) => "-"
 */ parcelHelpers.export(exports, "formatFileSize", ()=>formatFileSize);
/**
 * Format bitrate in bits/sec to human-readable string
 * @example formatBitrate(1200000) => "1.2 Mbps"
 * @example formatBitrate(500000) => "500 kbps"
 */ parcelHelpers.export(exports, "formatBitrate", ()=>formatBitrate);
/**
 * Format resolution from width and height
 * @example formatResolution(1920, 1080) => "1920x1080"
 */ parcelHelpers.export(exports, "formatResolution", ()=>formatResolution);
/**
 * Parse and format frame rate from fraction string
 * @example formatFrameRate("30000/1001") => "29.97 fps"
 * @example formatFrameRate("30/1") => "30 fps"
 * @example formatFrameRate("25/1") => "25 fps"
 */ parcelHelpers.export(exports, "formatFrameRate", ()=>formatFrameRate);
/**
 * Format encoder stream info field or return dash
 * @example formatStreamField(streamInfo, 'resolution') => "1920x1080"
 * @example formatStreamField(undefined, 'bitrate') => "-"
 */ parcelHelpers.export(exports, "formatStreamField", ()=>formatStreamField);
/**
 * Format a date string to relative time
 * @example formatRelativeTime("2025-01-01T12:00:00Z") => "2h ago"
 * @example formatRelativeTime(null) => ""
 */ parcelHelpers.export(exports, "formatRelativeTime", ()=>formatRelativeTime);
/**
 * Parse frame rate fraction string to number
 * @example parseFrameRateFraction("30000/1001") => 29.97
 * @example parseFrameRateFraction("30/1") => 30
 * @example parseFrameRateFraction(undefined) => null
 */ parcelHelpers.export(exports, "parseFrameRateFraction", ()=>parseFrameRateFraction);
/**
 * Format bitrate from bytes/sec to human-readable string
 * (streamInfo stores bitrate in bytes/sec, not bits/sec)
 * @example formatBitrateFromBytes(500000) => "4.0 Mbps"
 */ parcelHelpers.export(exports, "formatBitrateFromBytes", ()=>formatBitrateFromBytes);
/**
 * Generate streaming URIs from clientID and eventID
 * Pattern: https://api.v3.invintus.com/StreamURI/hls/{clientID}/{eventID}/media.m3u8
 * @param clientID - The client ID
 * @param eventID - The event ID (not the composite clientID_eventID format)
 * @returns Object with main and backup URIs, or null if inputs are missing
 */ parcelHelpers.export(exports, "generateStreamingURIs", ()=>generateStreamingURIs);
function formatDuration(seconds) {
    if (seconds === null || seconds === undefined) return 'Live';
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const secs = Math.floor(seconds % 60);
    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (secs > 0 || parts.length === 0) parts.push(`${secs}s`);
    return parts.join(' ');
}
function formatFileSize(bytes) {
    if (bytes === null || bytes === undefined) return '-';
    if (bytes >= 1000000000) return `${(bytes / 1000000000).toFixed(1)} GB`;
    if (bytes >= 1000000) return `${(bytes / 1000000).toFixed(1)} MB`;
    if (bytes >= 1000) return `${(bytes / 1000).toFixed(1)} KB`;
    return `${bytes} B`;
}
function formatBitrate(bits) {
    if (bits >= 1000000) {
        const mbps = bits / 1000000;
        return `${mbps.toFixed(1)} Mbps`;
    }
    const kbps = Math.round(bits / 1000);
    return `${kbps} kbps`;
}
function formatResolution(width, height) {
    return `${width}x${height}`;
}
function formatFrameRate(fraction) {
    if (!fraction || !fraction.includes('/')) return fraction || '-';
    const [numerator, denominator] = fraction.split('/').map(Number);
    if (!denominator || denominator === 0) return fraction;
    const fps = numerator / denominator;
    // Common frame rates - show cleaner values
    if (Math.abs(fps - 29.97) < 0.01) return '29.97 fps';
    if (Math.abs(fps - 59.94) < 0.01) return '59.94 fps';
    if (Math.abs(fps - 23.976) < 0.01) return '23.98 fps';
    // For whole numbers, show without decimals
    if (Number.isInteger(fps)) return `${fps} fps`;
    return `${fps.toFixed(2)} fps`;
}
function formatStreamField(streamInfo, field) {
    if (!streamInfo) return '-';
    switch(field){
        case 'resolution':
            return streamInfo.width && streamInfo.height ? formatResolution(streamInfo.width, streamInfo.height) : '-';
        case 'bitrate':
            return streamInfo.bitrate ? formatBitrate(streamInfo.bitrate) : '-';
        case 'frameRate':
            return streamInfo.frameRate ? formatFrameRate(streamInfo.frameRate) : '-';
        case 'aspectRatio':
            return streamInfo.aspectRatio || '-';
        case 'hasCaptions':
            return streamInfo.hasCaptions === undefined ? '-' : streamInfo.hasCaptions ? 'Yes' : 'No';
    }
}
function formatRelativeTime(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);
    if (diffMins < 1) return 'just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    return `${diffDays}d ago`;
}
function parseFrameRateFraction(fraction) {
    if (!fraction || !fraction.includes('/')) return null;
    const [num, den] = fraction.split('/').map(Number);
    if (!den || den === 0) return null;
    return num / den;
}
function formatBitrateFromBytes(bytesPerSec) {
    const bitsPerSec = bytesPerSec * 8;
    return formatBitrate(bitsPerSec);
}
function generateStreamingURIs(clientID, eventID) {
    if (!clientID || !eventID) return null;
    // If eventID is composite (clientID_eventID), extract just the eventID part
    const eventIDPart = eventID.includes('_') ? eventID.split('_')[1] : eventID;
    return {
        main: `https://api.v3.invintus.com/StreamURI/hls/${clientID}/${eventIDPart}/media.m3u8`,
        backup: null
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"lB8sT":[function(require,module,exports,__globalThis) {
/**
 * Shared table utility components
 * Used across encoders, persistent-streams, and other table views
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sortable column header for TanStack Table
 */ parcelHelpers.export(exports, "SortableHeader", ()=>SortableHeader);
/**
 * Flapping state indicator for encoders
 */ parcelHelpers.export(exports, "FlappingIndicator", ()=>FlappingIndicator);
/**
 * Live status indicator with WSS real-time data and DB fallback
 */ parcelHelpers.export(exports, "LiveStatus", ()=>LiveStatus);
/**
 * Check how stale a lastCommunication timestamp is
 */ parcelHelpers.export(exports, "getStaleness", ()=>getStaleness);
/**
 * Last communication display
 * Shows relative time, muted if old
 * - Recent (< 1h): normal text
 * - Older: muted text (no icons - lastComm only updates on connect, so old is normal)
 */ parcelHelpers.export(exports, "LastCommunication", ()=>LastCommunication);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _dateFns = require("date-fns");
// Re-export shared cell components for convenience
var _cells = require("./tables/cells");
parcelHelpers.exportAll(_cells, exports);
var _types = require("@shared/types");
function SortableHeader({ column, children }) {
    const sorted = column.getIsSorted();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        className: "flex items-center gap-1 hover:text-foreground",
        onClick: ()=>column.toggleSorting(sorted === 'asc'),
        children: [
            children,
            sorted === 'asc' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUp), {
                className: "h-3 w-3"
            }) : sorted === 'desc' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowDown), {
                className: "h-3 w-3"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                className: "h-3 w-3 opacity-50"
            })
        ]
    });
}
function FlappingIndicator({ state }) {
    if (!state || state === 'normal') return null;
    if (state === 'alert') return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        title: "Encoder flapping (alert)",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertCircle), {
            className: "h-4 w-4 text-red-500"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        title: "Encoder flapping (warning)",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
            className: "h-4 w-4 text-yellow-500"
        })
    });
}
function LiveStatus({ wss, dbStatus }) {
    // If we have WSS data, use it (more real-time)
    if (wss) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: wss.online ? 'text-green-600' : 'opacity-20',
                children: wss.online ? 'Online' : 'Offline'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(FlappingIndicator, {
                state: wss.state
            })
        ]
    });
    // Fall back to DB status
    if (dbStatus === null) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: "-"
    });
    switch(dbStatus){
        case 0:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "opacity-20",
                children: "Offline"
            });
        case 1:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-green-600",
                children: "Online"
            });
        case 2:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: "Streaming"
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    "Unknown (",
                    dbStatus,
                    ")"
                ]
            });
    }
}
/** Staleness thresholds from shared config */ const { STALE_WARNING_MS, STALE_ALERT_MS } = (0, _types.ENCODER_CONFIG);
function getStaleness(lastCommunication) {
    if (!lastCommunication) return 'stale';
    const diffMs = Date.now() - new Date(lastCommunication).getTime();
    if (diffMs > STALE_ALERT_MS) return 'stale';
    if (diffMs > STALE_WARNING_MS) return 'warning';
    return 'fresh';
}
function LastCommunication({ lastCommunication }) {
    if (!lastCommunication) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-muted-foreground",
        children: "-"
    });
    const date = new Date(lastCommunication);
    const staleness = getStaleness(lastCommunication);
    const fullDate = date.toLocaleString();
    const relativeTime = (0, _dateFns.formatDistanceToNow)(date, {
        addSuffix: true
    });
    // Relative time, muted if old. Tooltip shows full timestamp.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: staleness === 'stale' ? 'text-muted-foreground' : '',
        title: fullDate,
        children: relativeTime
    });
}

},{"react/jsx-runtime":"dQjte","lucide-react":[["AlertCircle","65jRl","default"],["AlertTriangle","cdePa","default"],["ArrowDown","hExmJ","default"],["ArrowUp","g8l66","default"],["ArrowUpDown","amX4k","default"]],"date-fns":"1DXja","./tables/cells":"5BSEg","@shared/types":"dzHsw","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"65jRl":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>CircleAlert);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "12",
            key: "1pkeuh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12.01",
            y1: "16",
            y2: "16",
            key: "4dfq90"
        }
    ]
];
const CircleAlert = (0, _createLucideIconJsDefault.default)("circle-alert", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1DXja":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link formatDistanceToNow} function options.
 */ /**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */ parcelHelpers.export(exports, "formatDistanceToNow", ()=>formatDistanceToNow);
var _constructNowJs = require("./constructNow.js");
var _formatDistanceJs = require("./formatDistance.js");
function formatDistanceToNow(date, options) {
    return (0, _formatDistanceJs.formatDistance)(date, (0, _constructNowJs.constructNow)(date), options);
}
// Fallback for modularized imports:
exports.default = formatDistanceToNow;

},{"./constructNow.js":"eumfa","./formatDistance.js":"d9dYS","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eumfa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateArg<DateType>,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */ parcelHelpers.export(exports, "constructNow", ()=>constructNow);
var _constructFromJs = require("./constructFrom.js");
function constructNow(date) {
    return (0, _constructFromJs.constructFrom)(date, Date.now());
}
// Fallback for modularized imports:
exports.default = constructNow;

},{"./constructFrom.js":"aMZJE","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"aMZJE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * Starting from v3.7.0, it allows to construct a date using `[Symbol.for("constructDateFrom")]`
 * enabling to transfer extra properties from the reference date to the new date.
 * It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
 * that accept a time zone as a constructor argument.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from "./constructFrom/date-fns";
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date>(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use constructor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   );
 * }
 */ parcelHelpers.export(exports, "constructFrom", ()=>constructFrom);
var _constantsJs = require("./constants.js");
function constructFrom(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, _constantsJs.constructFromSymbol) in date) return date[0, _constantsJs.constructFromSymbol](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
// Fallback for modularized imports:
exports.default = constructFrom;

},{"./constants.js":"Sfkj0","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"Sfkj0":[function(require,module,exports,__globalThis) {
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", ()=>daysInWeek);
parcelHelpers.export(exports, "daysInYear", ()=>daysInYear);
parcelHelpers.export(exports, "maxTime", ()=>maxTime);
parcelHelpers.export(exports, "minTime", ()=>minTime);
parcelHelpers.export(exports, "millisecondsInWeek", ()=>millisecondsInWeek);
parcelHelpers.export(exports, "millisecondsInDay", ()=>millisecondsInDay);
parcelHelpers.export(exports, "millisecondsInMinute", ()=>millisecondsInMinute);
parcelHelpers.export(exports, "millisecondsInHour", ()=>millisecondsInHour);
parcelHelpers.export(exports, "millisecondsInSecond", ()=>millisecondsInSecond);
parcelHelpers.export(exports, "minutesInYear", ()=>minutesInYear);
parcelHelpers.export(exports, "minutesInMonth", ()=>minutesInMonth);
parcelHelpers.export(exports, "minutesInDay", ()=>minutesInDay);
parcelHelpers.export(exports, "minutesInHour", ()=>minutesInHour);
parcelHelpers.export(exports, "monthsInQuarter", ()=>monthsInQuarter);
parcelHelpers.export(exports, "monthsInYear", ()=>monthsInYear);
parcelHelpers.export(exports, "quartersInYear", ()=>quartersInYear);
parcelHelpers.export(exports, "secondsInHour", ()=>secondsInHour);
parcelHelpers.export(exports, "secondsInMinute", ()=>secondsInMinute);
parcelHelpers.export(exports, "secondsInDay", ()=>secondsInDay);
parcelHelpers.export(exports, "secondsInWeek", ()=>secondsInWeek);
parcelHelpers.export(exports, "secondsInYear", ()=>secondsInYear);
parcelHelpers.export(exports, "secondsInMonth", ()=>secondsInMonth);
parcelHelpers.export(exports, "secondsInQuarter", ()=>secondsInQuarter);
parcelHelpers.export(exports, "constructFromSymbol", ()=>constructFromSymbol);
const daysInWeek = 7;
const daysInYear = 365.2425;
const maxTime = Math.pow(10, 8) * 86400000;
const minTime = -maxTime;
const millisecondsInWeek = 604800000;
const millisecondsInDay = 86400000;
const millisecondsInMinute = 60000;
const millisecondsInHour = 3600000;
const millisecondsInSecond = 1000;
const minutesInYear = 525600;
const minutesInMonth = 43200;
const minutesInDay = 1440;
const minutesInHour = 60;
const monthsInQuarter = 3;
const monthsInYear = 12;
const quartersInYear = 4;
const secondsInHour = 3600;
const secondsInMinute = 60;
const secondsInDay = secondsInHour * 24;
const secondsInWeek = secondsInDay * 7;
const secondsInYear = secondsInDay * daysInYear;
const secondsInMonth = secondsInYear / 12;
const secondsInQuarter = secondsInMonth * 3;
const constructFromSymbol = Symbol.for("constructDateFrom");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"d9dYS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link formatDistance} function options.
 */ /**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param laterDate - The date
 * @param earlierDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */ parcelHelpers.export(exports, "formatDistance", ()=>formatDistance);
var _defaultLocaleJs = require("./_lib/defaultLocale.js");
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _getTimezoneOffsetInMillisecondsJs = require("./_lib/getTimezoneOffsetInMilliseconds.js");
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
var _compareAscJs = require("./compareAsc.js");
var _constantsJs = require("./constants.js");
var _differenceInMonthsJs = require("./differenceInMonths.js");
var _differenceInSecondsJs = require("./differenceInSeconds.js");
function formatDistance(laterDate, earlierDate, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, _defaultLocaleJs.defaultLocale);
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, _compareAscJs.compareAsc)(laterDate, earlierDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    const [laterDate_, earlierDate_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, ...comparison > 0 ? [
        earlierDate,
        laterDate
    ] : [
        laterDate,
        earlierDate
    ]);
    const seconds = (0, _differenceInSecondsJs.differenceInSeconds)(earlierDate_, laterDate_);
    const offsetInSeconds = ((0, _getTimezoneOffsetInMillisecondsJs.getTimezoneOffsetInMilliseconds)(earlierDate_) - (0, _getTimezoneOffsetInMillisecondsJs.getTimezoneOffsetInMilliseconds)(laterDate_)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < (0, _constantsJs.minutesInDay)) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < (0, _constantsJs.minutesInMonth)) {
        const days = Math.round(minutes / (0, _constantsJs.minutesInDay));
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < (0, _constantsJs.minutesInMonth) * 2) {
        months = Math.round(minutes / (0, _constantsJs.minutesInMonth));
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, _differenceInMonthsJs.differenceInMonths)(earlierDate_, laterDate_);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / (0, _constantsJs.minutesInMonth));
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}
// Fallback for modularized imports:
exports.default = formatDistance;

},{"./_lib/defaultLocale.js":[["defaultLocale","3UxOA","enUS"]],"./_lib/defaultOptions.js":"4407t","./_lib/getTimezoneOffsetInMilliseconds.js":"bKJ63","./_lib/normalizeDates.js":"eMMqq","./compareAsc.js":"i7cG8","./constants.js":"Sfkj0","./differenceInMonths.js":"fJGuR","./differenceInSeconds.js":"huDat","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3UxOA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enUS", ()=>enUS);
var _formatDistanceJs = require("./en-US/_lib/formatDistance.js");
var _formatLongJs = require("./en-US/_lib/formatLong.js");
var _formatRelativeJs = require("./en-US/_lib/formatRelative.js");
var _localizeJs = require("./en-US/_lib/localize.js");
var _matchJs = require("./en-US/_lib/match.js");
const enUS = {
    code: "en-US",
    formatDistance: (0, _formatDistanceJs.formatDistance),
    formatLong: (0, _formatLongJs.formatLong),
    formatRelative: (0, _formatRelativeJs.formatRelative),
    localize: (0, _localizeJs.localize),
    match: (0, _matchJs.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
// Fallback for modularized imports:
exports.default = enUS;

},{"./en-US/_lib/formatDistance.js":"iH6ZB","./en-US/_lib/formatLong.js":"kPJrl","./en-US/_lib/formatRelative.js":"eafkT","./en-US/_lib/localize.js":"1E4mR","./en-US/_lib/match.js":"h54kf","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"iH6ZB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDistance", ()=>formatDistance);
const formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kPJrl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatLong", ()=>formatLong);
var _buildFormatLongFnJs = require("../../_lib/buildFormatLongFn.js");
const dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const formatLong = {
    date: (0, _buildFormatLongFnJs.buildFormatLongFn)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _buildFormatLongFnJs.buildFormatLongFn)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _buildFormatLongFnJs.buildFormatLongFn)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};

},{"../../_lib/buildFormatLongFn.js":"cIvMU","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cIvMU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildFormatLongFn", ()=>buildFormatLongFn);
function buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eafkT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatRelative", ()=>formatRelative);
const formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const formatRelative = (token, _date, _baseDate, _options)=>formatRelativeLocale[token];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1E4mR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localize", ()=>localize);
var _buildLocalizeFnJs = require("../../_lib/buildLocalizeFn.js");
const eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const localize = {
    ordinalNumber,
    era: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

},{"../../_lib/buildLocalizeFn.js":"kufYl","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kufYl":[function(require,module,exports,__globalThis) {
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildLocalizeFn", ()=>buildLocalizeFn);
function buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"h54kf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "match", ()=>match);
var _buildMatchFnJs = require("../../_lib/buildMatchFn.js");
var _buildMatchPatternFnJs = require("../../_lib/buildMatchPatternFn.js");
const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const match = {
    ordinalNumber: (0, _buildMatchPatternFnJs.buildMatchPatternFn)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

},{"../../_lib/buildMatchFn.js":"1yYgi","../../_lib/buildMatchPatternFn.js":"lKjL5","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1yYgi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMatchFn", ()=>buildMatchFn);
function buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value,
            rest
        };
    };
}
function findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"lKjL5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMatchPatternFn", ()=>buildMatchPatternFn);
function buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value,
            rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4407t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
parcelHelpers.export(exports, "setDefaultOptions", ()=>setDefaultOptions);
let defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bKJ63":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ parcelHelpers.export(exports, "getTimezoneOffsetInMilliseconds", ()=>getTimezoneOffsetInMilliseconds);
var _toDateJs = require("../toDate.js");
function getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, _toDateJs.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

},{"../toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3EOaA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * Starting from v3.7.0, it clones a date using `[Symbol.for("constructDateFrom")]`
 * enabling to transfer extra properties from the reference date to the new date.
 * It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
 * that accept a time zone as a constructor argument.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ parcelHelpers.export(exports, "toDate", ()=>toDate);
var _constructFromJs = require("./constructFrom.js");
function toDate(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, _constructFromJs.constructFrom)(context || argument, argument);
}
// Fallback for modularized imports:
exports.default = toDate;

},{"./constructFrom.js":"aMZJE","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eMMqq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeDates", ()=>normalizeDates);
var _constructFromJs = require("../constructFrom.js");
function normalizeDates(context, ...dates) {
    const normalize = (0, _constructFromJs.constructFrom).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}

},{"../constructFrom.js":"aMZJE","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"i7cG8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ parcelHelpers.export(exports, "compareAsc", ()=>compareAsc);
var _toDateJs = require("./toDate.js");
function compareAsc(dateLeft, dateRight) {
    const diff = +(0, _toDateJs.toDate)(dateLeft) - +(0, _toDateJs.toDate)(dateRight);
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
// Fallback for modularized imports:
exports.default = compareAsc;

},{"./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fJGuR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInMonths} function options.
 */ /**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @param laterDate - The later date
 * @param earlierDate - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */ parcelHelpers.export(exports, "differenceInMonths", ()=>differenceInMonths);
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
var _compareAscJs = require("./compareAsc.js");
var _differenceInCalendarMonthsJs = require("./differenceInCalendarMonths.js");
var _isLastDayOfMonthJs = require("./isLastDayOfMonth.js");
function differenceInMonths(laterDate, earlierDate, options) {
    const [laterDate_, workingLaterDate, earlierDate_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, laterDate, laterDate, earlierDate);
    const sign = (0, _compareAscJs.compareAsc)(workingLaterDate, earlierDate_);
    const difference = Math.abs((0, _differenceInCalendarMonthsJs.differenceInCalendarMonths)(workingLaterDate, earlierDate_));
    if (difference < 1) return 0;
    if (workingLaterDate.getMonth() === 1 && workingLaterDate.getDate() > 27) workingLaterDate.setDate(30);
    workingLaterDate.setMonth(workingLaterDate.getMonth() - sign * difference);
    let isLastMonthNotFull = (0, _compareAscJs.compareAsc)(workingLaterDate, earlierDate_) === -sign;
    if ((0, _isLastDayOfMonthJs.isLastDayOfMonth)(laterDate_) && difference === 1 && (0, _compareAscJs.compareAsc)(laterDate_, earlierDate_) === 1) isLastMonthNotFull = false;
    const result = sign * (difference - +isLastMonthNotFull);
    return result === 0 ? 0 : result;
}
// Fallback for modularized imports:
exports.default = differenceInMonths;

},{"./_lib/normalizeDates.js":"eMMqq","./compareAsc.js":"i7cG8","./differenceInCalendarMonths.js":"lvB5J","./isLastDayOfMonth.js":"5pn6a","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"lvB5J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInCalendarMonths} function options.
 */ /**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param laterDate - The later date
 * @param earlierDate - The earlier date
 * @param options - An object with options
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ parcelHelpers.export(exports, "differenceInCalendarMonths", ()=>differenceInCalendarMonths);
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
function differenceInCalendarMonths(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
    return yearsDiff * 12 + monthsDiff;
}
// Fallback for modularized imports:
exports.default = differenceInCalendarMonths;

},{"./_lib/normalizeDates.js":"eMMqq","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5pn6a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param date - The date to check
 * @param options - An object with options
 *
 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */ parcelHelpers.export(exports, "isLastDayOfMonth", ()=>isLastDayOfMonth);
var _endOfDayJs = require("./endOfDay.js");
var _endOfMonthJs = require("./endOfMonth.js");
var _toDateJs = require("./toDate.js");
function isLastDayOfMonth(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    return +(0, _endOfDayJs.endOfDay)(_date, options) === +(0, _endOfMonthJs.endOfMonth)(_date, options);
}
// Fallback for modularized imports:
exports.default = isLastDayOfMonth;

},{"./endOfDay.js":"bRidQ","./endOfMonth.js":"jebKl","./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bRidQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link endOfDay} function options.
 */ /**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfDay", ()=>endOfDay);
var _toDateJs = require("./toDate.js");
function endOfDay(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfDay;

},{"./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jebKl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link endOfMonth} function options.
 */ /**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfMonth", ()=>endOfMonth);
var _toDateJs = require("./toDate.js");
function endOfMonth(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfMonth;

},{"./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"huDat":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param laterDate - The later date
 * @param earlierDate - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ parcelHelpers.export(exports, "differenceInSeconds", ()=>differenceInSeconds);
var _getRoundingMethodJs = require("./_lib/getRoundingMethod.js");
var _differenceInMillisecondsJs = require("./differenceInMilliseconds.js");
function differenceInSeconds(laterDate, earlierDate, options) {
    const diff = (0, _differenceInMillisecondsJs.differenceInMilliseconds)(laterDate, earlierDate) / 1000;
    return (0, _getRoundingMethodJs.getRoundingMethod)(options?.roundingMethod)(diff);
}
// Fallback for modularized imports:
exports.default = differenceInSeconds;

},{"./_lib/getRoundingMethod.js":"aHzbs","./differenceInMilliseconds.js":"enAzO","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"aHzbs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRoundingMethod", ()=>getRoundingMethod);
function getRoundingMethod(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"enAzO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param laterDate - The later date
 * @param earlierDate - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ parcelHelpers.export(exports, "differenceInMilliseconds", ()=>differenceInMilliseconds);
var _toDateJs = require("./toDate.js");
function differenceInMilliseconds(laterDate, earlierDate) {
    return +(0, _toDateJs.toDate)(laterDate) - +(0, _toDateJs.toDate)(earlierDate);
}
// Fallback for modularized imports:
exports.default = differenceInMilliseconds;

},{"./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5BSEg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// ============================================================================
// Copyable Cell (reusable)
// ============================================================================
parcelHelpers.export(exports, "CopyableCell", ()=>CopyableCell);
/**
 * Shared table cell components for consistent linking and formatting across tables.
 * All cells include stopPropagation to prevent row click interference.
 */ // ============================================================================
// Client Cells
// ============================================================================
parcelHelpers.export(exports, "ClientNameCell", ()=>ClientNameCell);
parcelHelpers.export(exports, "ClientIDCell", ()=>ClientIDCell);
// ============================================================================
// Event Cells
// ============================================================================
/**
 * Renders an event ID (display only, no external links).
 * Handles both "clientID_eventID" composite format and plain eventID.
 */ parcelHelpers.export(exports, "EventIDCell", ()=>EventIDCell);
/**
 * Renders Player and CC icon buttons for an event.
 * Player opens in a new tab. CC triggers client swap dialog if needed.
 */ parcelHelpers.export(exports, "EventLinksCell", ()=>EventLinksCell);
parcelHelpers.export(exports, "EventTitleCell", ()=>EventTitleCell);
// ============================================================================
// Encoder Cells
// ============================================================================
parcelHelpers.export(exports, "EncoderCell", ()=>EncoderCell);
parcelHelpers.export(exports, "EncoderIDCell", ()=>EncoderIDCell);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _lucideReact = require("lucide-react");
var _tooltip = require("@/client/components/ui/tooltip");
var _swapClientDialog = require("@/client/components/swap-client-dialog");
var _ccSwapStore = require("@/client/store/ccSwapStore");
var _config = require("@/client/config");
function CopyableCell({ value, className = '' }) {
    const [copied, setCopied] = (0, _react.useState)(false);
    const handleCopy = (0, _react.useCallback)((e)=>{
        e.stopPropagation();
        navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(()=>setCopied(false), 2000);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        onClick: handleCopy,
        className: `font-mono text-xs hover:text-zinc-400 flex items-center gap-1 ${className}`,
        children: [
            value,
            copied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                className: "h-3 w-3 text-green-500"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Copy), {
                className: "h-3 w-3 opacity-50"
            })
        ]
    });
}
function ClientNameCell({ clientID, clientName }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
        to: "/clients/$clientID",
        params: {
            clientID: String(clientID)
        },
        className: "hover:underline",
        onClick: (e)=>e.stopPropagation(),
        children: clientName
    });
}
function ClientIDCell({ clientID, copyable = true }) {
    const id = String(clientID);
    if (!copyable) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "font-mono text-xs",
        children: id
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CopyableCell, {
        value: id
    });
}
function EventIDCell({ eventID }) {
    if (!eventID) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-xs text-muted-foreground",
        children: "-"
    });
    const rawID = String(eventID);
    const displayID = rawID.includes('_') ? rawID.split('_')[1] : rawID;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "font-mono text-xs",
        children: displayID
    });
}
function EventLinksCell({ eventID, clientID, clientName }) {
    const clientIDStr = clientID ? String(clientID) : '';
    const { needsSwap } = (0, _swapClientDialog.useClientSwapInfo)(clientIDStr);
    const requestSwap = (0, _ccSwapStore.useCCSwapStore)((s)=>s.requestSwap);
    if (!eventID || !clientID) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-xs text-muted-foreground",
        children: "-"
    });
    const rawID = String(eventID);
    const displayID = rawID.includes('_') ? rawID.split('_')[1] : rawID;
    const playerUrl = `${(0, _config.PLAYER_BASE_URL)}/?clientID=${clientIDStr}&eventID=${displayID}&debug=true`;
    const ccUrl = `${(0, _config.CC_BASE_URL)}/events/slim?eventID=${displayID}`;
    const handleCCClick = (e)=>{
        e.stopPropagation();
        if (needsSwap) requestSwap(clientIDStr, clientName || `Client ${clientIDStr}`, ccUrl);
        else window.open(ccUrl, '_blank', 'noopener,noreferrer');
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipProvider), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-1",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltip.Tooltip), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipTrigger), {
                            asChild: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: playerUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "inline-flex items-center justify-center h-7 w-7 rounded-md btn-player-icon",
                                onClick: (e)=>e.stopPropagation(),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.MonitorPlay), {
                                    className: "h-4 w-4"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipContent), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "Open in Player"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltip.Tooltip), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipTrigger), {
                            asChild: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "inline-flex items-center justify-center h-7 w-7 rounded-md btn-cc-icon",
                                onClick: handleCCClick,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.IdCardLanyard), {
                                    className: "h-4 w-4"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipContent), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: needsSwap ? 'Switch client & open in Control Center' : 'Open in Control Center'
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function EventTitleCell({ title, maxLength = 60 }) {
    if (!title) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-xs text-muted-foreground",
        children: "-"
    });
    if (title.length <= maxLength) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-xs",
        children: title
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipProvider), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltip.Tooltip), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipTrigger), {
                    asChild: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "text-xs cursor-default",
                        children: [
                            title.slice(0, maxLength),
                            "..."
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipContent), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "max-w-md",
                        children: title
                    })
                })
            ]
        })
    });
}
function EncoderCell({ encoderID, encoderName }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
        to: "/encoders/$encoderID",
        params: {
            encoderID: String(encoderID)
        },
        className: "hover:underline",
        onClick: (e)=>e.stopPropagation(),
        children: encoderName ?? `Encoder ${encoderID}`
    });
}
function EncoderIDCell({ encoderID }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
        to: "/encoders/$encoderID",
        params: {
            encoderID: String(encoderID)
        },
        className: "font-mono text-xs hover:underline",
        onClick: (e)=>e.stopPropagation(),
        children: String(encoderID)
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":"7k6Lq","lucide-react":[["Check","bajJU","default"],["Copy","jM41N","default"],["IdCardLanyard","4p9qL","default"],["MonitorPlay","4cSqM","default"]],"@/client/components/ui/tooltip":"dWqZd","@/client/components/swap-client-dialog":"dD6eo","@/client/store/ccSwapStore":"8GoFO","@/client/config":"8SWgh","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4p9qL":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>IdCardLanyard);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M13.5 8h-3",
            key: "xvov4w"
        }
    ],
    [
        "path",
        {
            d: "m15 2-1 2h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h3",
            key: "16uttc"
        }
    ],
    [
        "path",
        {
            d: "M16.899 22A5 5 0 0 0 7.1 22",
            key: "1d0ppr"
        }
    ],
    [
        "path",
        {
            d: "m9 2 3 6",
            key: "1o7bd9"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "15",
            r: "3",
            key: "g36mzq"
        }
    ]
];
const IdCardLanyard = (0, _createLucideIconJsDefault.default)("id-card-lanyard", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4cSqM":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>MonitorPlay);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M15.033 9.44a.647.647 0 0 1 0 1.12l-4.065 2.352a.645.645 0 0 1-.968-.56V7.648a.645.645 0 0 1 .967-.56z",
            key: "vbtd3f"
        }
    ],
    [
        "path",
        {
            d: "M12 17v4",
            key: "1riwvh"
        }
    ],
    [
        "path",
        {
            d: "M8 21h8",
            key: "1ev6f3"
        }
    ],
    [
        "rect",
        {
            x: "2",
            y: "3",
            width: "20",
            height: "14",
            rx: "2",
            key: "x3v2xh"
        }
    ]
];
const MonitorPlay = (0, _createLucideIconJsDefault.default)("monitor-play", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5naD0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _layout = require("./_layout");
var _layout1 = require("@/client/layouts/layout");
var _encoderWSSStore = require("@/client/store/encoderWSSStore");
var _alertStore = require("@/client/store/alertStore");
var _liveStreamsStore = require("@/client/store/liveStreamsStore");
var _alertCard = require("@/client/components/alert-card");
var _encoderMonitorCard = require("@/client/components/encoder/EncoderMonitorCard");
var _button = require("@/client/components/ui/button");
var _badge = require("@/client/components/ui/badge");
var _jsonSyntaxHighlight = require("@/client/components/ui/json-syntax-highlight");
var _lucideReact = require("lucide-react");
var _config = require("@/client/config");
var _format = require("@/client/lib/format");
var _clientInfra = require("@/client/client-infra");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _layout.Route),
    path: 'encoders/$encoderID',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: EncoderDetailComponent
});
function EncoderStatusBadge({ status, wssOnline }) {
    // WSS status overrides DB status when available
    if (wssOnline !== undefined) {
        if (wssOnline) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
            variant: "outline",
            className: "bg-green-50 text-green-700 border-green-200",
            children: "Online"
        });
        else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
            variant: "outline",
            className: "bg-red-50 text-red-700 border-red-200",
            children: "Offline"
        });
    }
    // Fall back to DB status
    if (status === null) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
        variant: "outline",
        className: "text-muted-foreground",
        children: "Unknown"
    });
    switch(status){
        case 0:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                variant: "outline",
                className: "text-muted-foreground",
                children: "Offline"
            });
        case 1:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                variant: "outline",
                className: "bg-green-50 text-green-700 border-green-200",
                children: "Online"
            });
        case 2:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                variant: "outline",
                className: "bg-blue-50 text-blue-700 border-blue-200",
                children: "Streaming"
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                variant: "outline",
                className: "text-muted-foreground",
                children: [
                    "Unknown (",
                    status,
                    ")"
                ]
            });
    }
}
function CopyableField({ label, value }) {
    const [copied, setCopied] = (0, _react.useState)(false);
    const handleCopy = async ()=>{
        if (!value) return;
        await navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(()=>setCopied(false), 2000);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center py-1.5",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-sm text-muted-foreground min-w-[160px]",
                children: label
            }),
            value ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                onClick: handleCopy,
                className: "flex items-center gap-1 hover:bg-muted rounded px-1 -mx-1 transition-colors cursor-pointer",
                title: "Click to copy",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "font-mono text-sm truncate",
                        title: value,
                        children: value
                    }),
                    copied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                        className: "h-3.5 w-3.5 text-green-600 flex-shrink-0"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Copy), {
                        className: "h-3.5 w-3.5 text-muted-foreground flex-shrink-0"
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-mono text-sm",
                children: "-"
            })
        ]
    });
}
function parseStreamInfo(streamInfoJson) {
    if (!streamInfoJson) return null;
    try {
        return JSON.parse(streamInfoJson);
    } catch  {
        return null;
    }
}
function formatTriageDuration(startedAt) {
    const diff = Date.now() - startedAt;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(minutes / 60);
    if (hours > 0) return `${hours}h ${minutes % 60}m`;
    return `${minutes}m`;
}
function MetricCard({ label, value, icon: Icon }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "bg-muted/50 rounded-lg p-3",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2 text-muted-foreground text-xs mb-1",
                children: [
                    Icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                        className: "h-3 w-3"
                    }),
                    label
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-medium text-sm",
                children: value
            })
        ]
    });
}
function ProbeResultDisplay({ result }) {
    const [showRaw, setShowRaw] = (0, _react.useState)(false);
    if (!result.success) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "p-4 rounded-md text-sm bg-red-50 border border-red-200",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            className: "text-red-600",
            children: result.error
        })
    });
    const { metadata, raw, probeTimeMs } = result;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "space-y-4",
        children: [
            metadata?.video && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "border rounded-lg p-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-2 mb-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Video), {
                                className: "h-4 w-4 text-muted-foreground"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                className: "font-medium text-sm",
                                children: "Video Stream"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dl", {
                        className: "grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-2 text-sm",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                        className: "text-muted-foreground text-xs",
                                        children: "Codec"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                        className: "font-mono",
                                        children: metadata.video.codec
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                        className: "text-muted-foreground text-xs",
                                        children: "Profile / Level"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                        className: "font-mono",
                                        children: metadata.video.profile || metadata.video.level ? `${metadata.video.profile || '-'} ${metadata.video.level || ''}` : '-'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                        className: "text-muted-foreground text-xs",
                                        children: "Resolution"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                        className: "font-mono",
                                        children: (0, _format.formatResolution)(metadata.video.width, metadata.video.height)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                        className: "text-muted-foreground text-xs",
                                        children: "Pixel Format"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                        className: "font-mono",
                                        children: metadata.video.pixelFormat || '-'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                        className: "text-muted-foreground text-xs",
                                        children: "Frame Rate"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                        className: "font-mono",
                                        children: metadata.video.frameRate ? `${metadata.video.frameRate.toFixed(2)} fps` : '-'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                        className: "text-muted-foreground text-xs",
                                        children: "Bitrate"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                        className: "font-mono",
                                        children: metadata.video.bitrate ? (0, _format.formatBitrate)(metadata.video.bitrate) : '-'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            metadata?.audio && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "border rounded-lg p-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-2 mb-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Music), {
                                className: "h-4 w-4 text-muted-foreground"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                className: "font-medium text-sm",
                                children: "Audio Stream"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dl", {
                        className: "grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-2 text-sm",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                        className: "text-muted-foreground text-xs",
                                        children: "Codec"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                        className: "font-mono",
                                        children: metadata.audio.codec
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                        className: "text-muted-foreground text-xs",
                                        children: "Sample Rate"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                                        className: "font-mono",
                                        children: [
                                            (metadata.audio.sampleRate / 1000).toFixed(1),
                                            " kHz"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                        className: "text-muted-foreground text-xs",
                                        children: "Channels"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                        className: "font-mono",
                                        children: metadata.audio.channels
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                        className: "text-muted-foreground text-xs",
                                        children: "Bitrate"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                        className: "font-mono",
                                        children: metadata.audio.bitrate ? (0, _format.formatBitrate)(metadata.audio.bitrate) : '-'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            metadata?.size && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "text-sm text-muted-foreground",
                children: [
                    "File Size: ",
                    (0, _format.formatFileSize)(metadata.size)
                ]
            }),
            raw && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "border rounded-lg",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        onClick: ()=>setShowRaw(!showRaw),
                        className: "w-full flex items-center gap-2 p-3 text-sm text-muted-foreground hover:bg-muted/50 transition-colors",
                        children: [
                            showRaw ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                className: "h-4 w-4"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                                className: "h-4 w-4"
                            }),
                            "Raw ffprobe output"
                        ]
                    }),
                    showRaw && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-4 pt-0 overflow-x-auto max-w-full",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsonSyntaxHighlight.JsonSyntaxHighlight), {
                            json: JSON.stringify(raw, null, 2)
                        })
                    })
                ]
            }),
            probeTimeMs && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "text-xs text-muted-foreground",
                children: [
                    "Probed in ",
                    probeTimeMs,
                    "ms"
                ]
            })
        ]
    });
}
function DeepProbeResultDisplay({ result }) {
    if (!result.success) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "p-4 rounded-md text-sm bg-red-50 border border-red-200",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            className: "text-red-600",
            children: result.error
        })
    });
    const { bitrateAnalysis, gopAnalysis, warnings, sampleDurationSec, probeTimeMs } = result;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grid grid-cols-2 md:grid-cols-4 gap-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(MetricCard, {
                        label: "Bitrate Mode",
                        value: bitrateAnalysis?.mode ?? '-'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(MetricCard, {
                        label: "CV (Variance)",
                        value: bitrateAnalysis?.cv !== undefined ? bitrateAnalysis.cv.toFixed(3) : '-'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(MetricCard, {
                        label: "GOP Size",
                        value: gopAnalysis?.avgGopSize !== undefined ? `${gopAnalysis.avgGopSize} frames` : '-'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(MetricCard, {
                        label: "GOP Duration",
                        value: gopAnalysis?.avgGopDurationSec !== undefined ? `${gopAnalysis.avgGopDurationSec}s` : '-'
                    })
                ]
            }),
            warnings && warnings.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "border border-amber-200 bg-amber-50 rounded-lg p-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-2 mb-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                                className: "h-4 w-4 text-amber-600"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                className: "font-medium text-sm text-amber-800",
                                children: "Warnings"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                        className: "text-sm text-amber-700 space-y-1",
                        children: warnings.map((warning, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    "\u2022 ",
                                    warning
                                ]
                            }, i))
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-4",
                children: [
                    bitrateAnalysis && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "border rounded-lg p-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                className: "font-medium text-sm mb-3",
                                children: "Bitrate Analysis"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dl", {
                                className: "text-sm space-y-1",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                                className: "text-muted-foreground",
                                                children: "Mode"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                                className: "font-mono",
                                                children: bitrateAnalysis.mode
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                                className: "text-muted-foreground",
                                                children: "Coefficient of Variation"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                                className: "font-mono",
                                                children: bitrateAnalysis.cv.toFixed(3)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                                className: "text-muted-foreground",
                                                children: "Avg Packet Size"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                                                className: "font-mono",
                                                children: [
                                                    bitrateAnalysis.avgPacketSize.toLocaleString(),
                                                    " bytes"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                                className: "text-muted-foreground",
                                                children: "Std Dev"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                                                className: "font-mono",
                                                children: [
                                                    bitrateAnalysis.stddevPacketSize.toLocaleString(),
                                                    " bytes"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                                className: "text-muted-foreground",
                                                children: "Packets Analyzed"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                                className: "font-mono",
                                                children: bitrateAnalysis.packetCount.toLocaleString()
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    gopAnalysis && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "border rounded-lg p-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                className: "font-medium text-sm mb-3",
                                children: "GOP Analysis"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dl", {
                                className: "text-sm space-y-1",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                                className: "text-muted-foreground",
                                                children: "Avg GOP Size"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                                                className: "font-mono",
                                                children: [
                                                    gopAnalysis.avgGopSize,
                                                    " frames"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                                className: "text-muted-foreground",
                                                children: "Avg GOP Duration"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                                                className: "font-mono",
                                                children: [
                                                    gopAnalysis.avgGopDurationSec,
                                                    "s"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                                className: "text-muted-foreground",
                                                children: "I-Frames Found"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                                className: "font-mono",
                                                children: gopAnalysis.iFrameCount
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                                className: "text-muted-foreground",
                                                children: "Frames Analyzed"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                                className: "font-mono",
                                                children: gopAnalysis.frameCount.toLocaleString()
                                            })
                                        ]
                                    }),
                                    gopAnalysis.gopSizes.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                                className: "text-muted-foreground",
                                                children: "GOP Range"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                                                className: "font-mono",
                                                children: [
                                                    Math.min(...gopAnalysis.gopSizes),
                                                    "-",
                                                    Math.max(...gopAnalysis.gopSizes),
                                                    " frames"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "text-xs text-muted-foreground",
                children: [
                    "Sampled ",
                    sampleDurationSec,
                    "s of stream data in ",
                    probeTimeMs,
                    "ms"
                ]
            })
        ]
    });
}
function InfraNotesPanel({ notes }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "rounded-md border border-blue-200 dark:border-blue-900 bg-blue-50 dark:bg-blue-950/30 p-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2 mb-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Info), {
                        className: "h-4 w-4 text-blue-600 dark:text-blue-400"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                        className: "font-medium text-blue-900 dark:text-blue-100",
                        children: "Infrastructure Notes"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "text-sm text-blue-800 dark:text-blue-200 space-y-2",
                children: [
                    notes.protocol && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "font-medium",
                                children: "Protocol:"
                            }),
                            ' ',
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "font-mono bg-blue-100 dark:bg-blue-900/50 px-1 rounded",
                                children: notes.protocol.actual
                            }),
                            ' ',
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "text-blue-600 dark:text-blue-400",
                                children: [
                                    "(",
                                    notes.protocol.note,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    notes.portPattern && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "font-medium",
                                children: "Port pattern:"
                            }),
                            ' ',
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "font-mono bg-blue-100 dark:bg-blue-900/50 px-1 rounded",
                                children: notes.portPattern
                            })
                        ]
                    }),
                    notes.configLocation && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "space-y-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-medium",
                                        children: "Config location:"
                                    }),
                                    ' ',
                                    notes.configLocation.url ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: notes.configLocation.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "text-blue-700 dark:text-blue-400 underline hover:text-blue-900 dark:hover:text-blue-300",
                                        children: notes.configLocation.system
                                    }) : notes.configLocation.system,
                                    " \u2192 ",
                                    notes.configLocation.path
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-medium",
                                        children: "Credentials:"
                                    }),
                                    ' ',
                                    notes.configLocation.credentials
                                ]
                            })
                        ]
                    }),
                    notes.notes && notes.notes.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                        className: "mt-2 space-y-1",
                        children: notes.notes.map((note, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "font-medium",
                                        children: [
                                            note.title,
                                            ":"
                                        ]
                                    }),
                                    ' ',
                                    note.description
                                ]
                            }, i))
                    })
                ]
            })
        ]
    });
}
function EncoderDetailComponent() {
    const { encoderID } = Route.useParams();
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    // Subscribe to WSS store for real-time online/offline status from Scaledrone
    const wssEncoders = (0, _encoderWSSStore.useEncoderWSSStore)((state)=>state.encoders);
    const wssRecord = wssEncoders.get(encoderID);
    // Get live event for this encoder (if any)
    const liveStreams = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.liveStreams);
    const liveEvent = liveStreams.find((s)=>s.encoderID === encoderID);
    // Subscribe to alert store for active alerts on this encoder
    const getAlertsByEncoder = (0, _alertStore.useAlertStore)((state)=>state.getAlertsByEncoder);
    const triageSessions = (0, _alertStore.useAlertStore)((state)=>state.triageSessions);
    const muteAlert = (0, _alertStore.useAlertStore)((state)=>state.muteAlert);
    const unmuteAlert = (0, _alertStore.useAlertStore)((state)=>state.unmuteAlert);
    const isAlertMuted = (0, _alertStore.useAlertStore)((state)=>state.isAlertMuted);
    const encoderAlerts = getAlertsByEncoder(encoderID);
    const isInTriage = triageSessions.some((s)=>s.encoderId === encoderID);
    const [encoder, setEncoder] = (0, _react.useState)(undefined);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(null);
    const [probeLoading, setProbeLoading] = (0, _react.useState)(false);
    const [probeResult, setProbeResult] = (0, _react.useState)(null);
    const [deepProbeLoading, setDeepProbeLoading] = (0, _react.useState)(false);
    const [deepProbeResult, setDeepProbeResult] = (0, _react.useState)(null);
    // Triage state
    const [triageSession, setTriageSession] = (0, _react.useState)(null);
    const [triageLoading, setTriageLoading] = (0, _react.useState)(false);
    // Raw JSON panel state
    const [showRawJson, setShowRawJson] = (0, _react.useState)(false);
    // Parse streamInfo once
    const streamData = encoder ? parseStreamInfo(encoder.streamInfo?.streamInfo ?? null) : null;
    // Get client-specific infrastructure notes (if any)
    const infraNotes = encoder ? (0, _clientInfra.getClientInfraNotes)(encoder.clientID) : null;
    // Copy handlers
    const handleCopyRawJson = async ()=>{
        if (!encoder) return;
        const rawData = {
            ...encoder,
            streamInfo: encoder.streamInfo?.streamInfo ? JSON.parse(encoder.streamInfo.streamInfo) : null
        };
        await navigator.clipboard.writeText(JSON.stringify(rawData, null, 2));
    };
    const handleCopyFullState = async ()=>{
        if (!encoder) return;
        const fullState = {
            encoder: {
                ...encoder,
                streamInfo: encoder.streamInfo?.streamInfo ? JSON.parse(encoder.streamInfo.streamInfo) : null
            },
            parsedStreamData: streamData,
            probeResult: probeResult,
            triageSession: triageSession
        };
        await navigator.clipboard.writeText(JSON.stringify(fullState, null, 2));
    };
    // Fetch encoder directly from API (no caching - real-time status)
    (0, _react.useEffect)(()=>{
        const loadEncoder = async ()=>{
            setLoading(true);
            setError(null);
            try {
                const token = await getAccessTokenSilently();
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/encoders/${encoderID}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (!response.ok) {
                    if (response.status === 404) setError('Encoder not found');
                    else setError(`Failed to fetch encoder: ${response.statusText}`);
                    return;
                }
                const data = await response.json();
                setEncoder(data.encoder);
            } catch (err) {
                console.error('Error fetching encoder:', err);
                setError(err instanceof Error ? err.message : 'Unknown error');
            } finally{
                setLoading(false);
            }
        };
        loadEncoder();
    }, [
        getAccessTokenSilently,
        encoderID
    ]);
    const handleProbe = async ()=>{
        if (!encoder) return;
        setProbeLoading(true);
        setProbeResult(null);
        try {
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/encoders/probe?inputUri=${encodeURIComponent(encoder.inputURI)}&encoderID=${encodeURIComponent(encoder.encoderID)}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            const result = await response.json();
            setProbeResult(result);
        } catch (err) {
            setProbeResult({
                success: false,
                inputUri: encoder.inputURI,
                error: err instanceof Error ? err.message : 'Failed to probe encoder'
            });
        } finally{
            setProbeLoading(false);
        }
    };
    const handleDeepProbe = async ()=>{
        if (!encoder) return;
        setDeepProbeLoading(true);
        setDeepProbeResult(null);
        try {
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/encoders/probe/deep?inputUri=${encodeURIComponent(encoder.inputURI)}&encoderID=${encodeURIComponent(encoder.encoderID)}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            const result = await response.json();
            setDeepProbeResult(result);
        } catch (err) {
            setDeepProbeResult({
                success: false,
                inputUri: encoder.inputURI,
                error: err instanceof Error ? err.message : 'Failed to deep probe encoder',
                sampleDurationSec: 0,
                probeTimeMs: 0
            });
        } finally{
            setDeepProbeLoading(false);
        }
    };
    // Fetch triage session status on load
    (0, _react.useEffect)(()=>{
        const fetchTriageStatus = async ()=>{
            try {
                const token = await getAccessTokenSilently();
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/encoders/${encoderID}/triage`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (response.ok) {
                    const data = await response.json();
                    setTriageSession(data.session);
                } else if (response.status === 404) setTriageSession(null);
            } catch (err) {
                console.error('Error fetching triage status:', err);
            }
        };
        if (encoderID) fetchTriageStatus();
    }, [
        encoderID,
        getAccessTokenSilently
    ]);
    const handleStartTriage = async ()=>{
        setTriageLoading(true);
        try {
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/encoders/${encoderID}/triage`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({})
            });
            if (response.ok) {
                const data = await response.json();
                setTriageSession(data.session);
            }
        } catch (err) {
            console.error('Error starting triage:', err);
        } finally{
            setTriageLoading(false);
        }
    };
    const handleStopTriage = async ()=>{
        setTriageLoading(true);
        try {
            const token = await getAccessTokenSilently();
            await fetch(`${(0, _config.API_BASE_URL)}/api/encoders/${encoderID}/triage`, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setTriageSession(null);
        } catch (err) {
            console.error('Error stopping triage:', err);
        } finally{
            setTriageLoading(false);
        }
    };
    if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout1.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Loading encoder..."
            })
        })
    });
    if (error || !encoder) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout1.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "mb-4 flex items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                            to: "/encoders",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: "ghost",
                                size: "icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowLeft), {
                                    className: "h-4 w-4"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            className: "text-2xl font-semibold",
                            children: error === 'Encoder not found' ? 'Encoder Not Found' : 'Error'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: error || `The encoder "${encoderID}" could not be found.`
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout1.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "rounded-md border p-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-4 mb-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                    to: "/encoders",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        variant: "ghost",
                                        size: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowLeft), {
                                            className: "h-4 w-4"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-3 flex-wrap",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                    className: "text-2xl font-semibold",
                                                    children: encoder.simpleName
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(EncoderStatusBadge, {
                                                    status: encoder.status,
                                                    wssOnline: wssRecord?.online
                                                }),
                                                liveEvent && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                                            variant: "outline",
                                                            className: "bg-red-600 text-white border-red-600 dark:bg-red-600 dark:text-white",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Play), {
                                                                    className: "h-3 w-3 mr-1 fill-current"
                                                                }),
                                                                "Live"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                                            to: "/events/$eventId",
                                                            params: {
                                                                eventId: `${liveEvent.eventID}`
                                                            },
                                                            className: "text-sm text-primary hover:underline",
                                                            children: [
                                                                "View Stream Info: ",
                                                                liveEvent.eventID
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                wssRecord && wssRecord.state !== 'normal' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                                    variant: "outline",
                                                    className: wssRecord.state === 'alert' ? "bg-red-50 text-red-700 border-red-200" : "bg-amber-50 text-amber-700 border-amber-200",
                                                    title: `${wssRecord.events.length} connect/disconnect events in the last 60 seconds`,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertCircle), {
                                                            className: "h-3 w-3 mr-1"
                                                        }),
                                                        wssRecord.state === 'alert' ? 'Flapping' : 'Unstable'
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-sm text-muted-foreground",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                                to: "/clients/$clientID",
                                                params: {
                                                    clientID: encoder.clientID
                                                },
                                                className: "hover:underline",
                                                children: encoder.clientName
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2 mb-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                    variant: "outline",
                                    size: "sm",
                                    onClick: handleCopyRawJson,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Copy), {
                                            className: "h-3.5 w-3.5 mr-1.5"
                                        }),
                                        "Copy Raw JSON"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                    variant: "outline",
                                    size: "sm",
                                    onClick: handleCopyFullState,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Copy), {
                                            className: "h-3.5 w-3.5 mr-1.5"
                                        }),
                                        "Copy Full State"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                    variant: showRawJson ? "secondary" : "outline",
                                    size: "sm",
                                    onClick: ()=>setShowRawJson(!showRawJson),
                                    children: [
                                        showRawJson ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                            className: "h-3.5 w-3.5 mr-1.5"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                                            className: "h-3.5 w-3.5 mr-1.5"
                                        }),
                                        showRawJson ? 'Hide' : 'View',
                                        " Raw JSON"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    variant: "outline",
                                    size: "sm",
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                        to: "/pipeline-logs",
                                        search: {
                                            searchType: 'encoderID',
                                            searchValue: encoderID
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ScrollText), {
                                                className: "h-3.5 w-3.5 mr-1.5"
                                            }),
                                            "Pipeline Logs"
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "border-t pt-4 space-y-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(CopyableField, {
                                    label: "Stream Name",
                                    value: encoder.streamName
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(CopyableField, {
                                    label: "Encoder ID",
                                    value: encoder.encoderID
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(CopyableField, {
                                    label: "Input URI",
                                    value: encoder.inputURI
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(CopyableField, {
                                    label: "Ingest Instance ID",
                                    value: encoder.ingInstanceID
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(CopyableField, {
                                    label: "WC Stream ID",
                                    value: encoder.wcStreamID
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center py-1.5",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-sm text-muted-foreground min-w-[160px]",
                                            children: "Last Communication"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-sm",
                                            children: encoder.lastCommunication ? `${new Date(encoder.lastCommunication).toLocaleString()} (${(0, _format.formatRelativeTime)(encoder.lastCommunication)})` : '-'
                                        })
                                    ]
                                })
                            ]
                        }),
                        showRawJson && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "border-t pt-4 mt-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                    className: "text-sm font-medium mb-2",
                                    children: "Raw Encoder Data"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "bg-muted p-4 rounded-md text-sm overflow-x-auto max-w-full",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsonSyntaxHighlight.JsonSyntaxHighlight), {
                                        json: JSON.stringify({
                                            ...encoder,
                                            streamInfo: encoder.streamInfo?.streamInfo ? JSON.parse(encoder.streamInfo.streamInfo) : null
                                        }, null, 2)
                                    })
                                })
                            ]
                        })
                    ]
                }),
                infraNotes && /*#__PURE__*/ (0, _jsxRuntime.jsx)(InfraNotesPanel, {
                    notes: infraNotes
                }),
                streamData && (encoder.status === 1 || encoder.status === 2) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "rounded-md border p-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                            className: "text-lg font-medium mb-4",
                            children: "Live Stream Status"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "grid grid-cols-2 md:grid-cols-4 gap-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(MetricCard, {
                                    label: "Resolution",
                                    value: streamData.width && streamData.height ? `${streamData.width}\xd7${streamData.height}` : '-'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(MetricCard, {
                                    label: "Bitrate",
                                    value: streamData.bitrate ? (0, _format.formatBitrate)(streamData.bitrate) : '-',
                                    icon: (0, _lucideReact.Gauge)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(MetricCard, {
                                    label: "Frame Rate",
                                    value: streamData.real_frame_rate ? (0, _format.formatFrameRate)(streamData.real_frame_rate) : '-',
                                    icon: (0, _lucideReact.Clock)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(MetricCard, {
                                    label: "Captions",
                                    value: streamData.inputHasCaptions === undefined ? '-' : streamData.inputHasCaptions ? 'Detected' : 'None',
                                    icon: (0, _lucideReact.Captions)
                                })
                            ]
                        }),
                        streamData.dimensions && streamData.dimensions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "text-sm text-muted-foreground mt-3",
                            children: [
                                "Transcode outputs: ",
                                streamData.dimensions.join(', ')
                            ]
                        })
                    ]
                }),
                wssRecord && wssRecord.state !== 'normal' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "rounded-md border p-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2 mb-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Radio), {
                                    className: "h-5 w-5 text-blue-600"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    className: "text-lg font-medium",
                                    children: "Connection Monitoring"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _encoderMonitorCard.EncoderMonitorCard), {
                            encoder: wssRecord
                        })
                    ]
                }),
                encoderAlerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "rounded-md border p-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2 mb-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                                    className: "h-5 w-5 text-amber-600"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    className: "text-lg font-medium",
                                    children: "Active Alerts"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                    variant: "outline",
                                    className: "bg-amber-100 text-amber-700 border-amber-200",
                                    children: encoderAlerts.length
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "space-y-3",
                            children: encoderAlerts.map((alert)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertCard.AlertCard), {
                                    alert: alert,
                                    isInTriage: isInTriage,
                                    onPinToTriage: handleStartTriage,
                                    isMuted: isAlertMuted(alert.encoderId, alert.alertType),
                                    onMute: muteAlert,
                                    onUnmute: unmuteAlert
                                }, `${alert.encoderId}-${alert.alertType}`))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "rounded-md border p-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center justify-between mb-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    className: "text-lg font-medium",
                                    children: "Stream Diagnostics"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            variant: "outline",
                                            onClick: handleProbe,
                                            disabled: probeLoading || deepProbeLoading,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Radio), {
                                                    className: `h-4 w-4 mr-2 ${probeLoading ? 'animate-pulse' : ''}`
                                                }),
                                                probeLoading ? 'Probing...' : 'Probe Stream'
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            variant: "outline",
                                            onClick: handleDeepProbe,
                                            disabled: probeLoading || deepProbeLoading,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Zap), {
                                                    className: `h-4 w-4 mr-2 ${deepProbeLoading ? 'animate-pulse' : ''}`
                                                }),
                                                deepProbeLoading ? 'Analyzing...' : 'Deep Probe (~15s)'
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        probeResult && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                    className: "text-sm font-medium mb-3 text-muted-foreground",
                                    children: "Standard Probe"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProbeResultDisplay, {
                                    result: probeResult
                                })
                            ]
                        }),
                        deepProbeResult && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                    className: "text-sm font-medium mb-3 text-muted-foreground",
                                    children: "Deep Analysis (CBR/VBR, GOP)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeepProbeResultDisplay, {
                                    result: deepProbeResult
                                })
                            ]
                        }),
                        !probeResult && !deepProbeResult && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "text-sm text-muted-foreground",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: "Probe Stream"
                                }),
                                " - Quick metadata check (codec, resolution, bitrate)",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: "Deep Probe"
                                }),
                                " - Samples 10s of stream to analyze CBR/VBR mode and GOP structure"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "rounded-md border p-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center justify-between mb-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                            to: "/encoders/triage",
                                            className: "inline-flex items-center gap-1 hover:text-foreground group hover:text-zinc-500 text-lg font-medium underline",
                                            children: [
                                                "Encoder Triage ",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowRight), {
                                                    className: "h-3 w-3 hover:text-zinc-500"
                                                })
                                            ]
                                        }),
                                        triageSession && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                            variant: "outline",
                                            className: "bg-amber-50 text-amber-700",
                                            children: [
                                                "In Triage for ",
                                                formatTriageDuration(triageSession.startedAt)
                                            ]
                                        })
                                    ]
                                }),
                                triageSession ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                    variant: "destructive",
                                    onClick: handleStopTriage,
                                    disabled: triageLoading,
                                    children: [
                                        triageLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Loader2), {
                                            className: "h-4 w-4 mr-2 animate-spin"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Stethoscope), {
                                            className: "h-4 w-4 mr-2"
                                        }),
                                        "Stop Triage"
                                    ]
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                    variant: "outline",
                                    onClick: handleStartTriage,
                                    disabled: triageLoading,
                                    children: [
                                        triageLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Loader2), {
                                            className: "h-4 w-4 mr-2 animate-spin"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Stethoscope), {
                                            className: "h-4 w-4 mr-2"
                                        }),
                                        "Start Triage"
                                    ]
                                })
                            ]
                        }),
                        triageSession ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-sm",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "text-muted-foreground mb-2",
                                    children: [
                                        "This encoder is being monitored. Samples are being collected and can be viewed on the",
                                        ' ',
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                            to: "/encoders/triage",
                                            className: "text-primary hover:underline",
                                            children: "Encoder Triage page"
                                        }),
                                        "."
                                    ]
                                }),
                                triageSession.notes && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "text-muted-foreground",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-medium",
                                            children: "Notes:"
                                        }),
                                        " ",
                                        triageSession.notes
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-sm text-muted-foreground",
                            children: "Start a triage session to monitor this encoder's stream metrics in real-time. Samples will be collected and persisted for analysis."
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["Link","7k6Lq"],["redirect","jmFxY"]],"@auth0/auth0-react":"gpXrE","./_layout":"eMWtI","@/client/layouts/layout":"d6QdD","@/client/store/encoderWSSStore":"jpzNm","@/client/store/alertStore":"fS0sT","@/client/store/liveStreamsStore":"7F9wp","@/client/components/alert-card":"6gkFH","@/client/components/encoder/EncoderMonitorCard":"lTlFg","@/client/components/ui/button":"armlb","@/client/components/ui/badge":"h4e1f","@/client/components/ui/json-syntax-highlight":"cBuOL","lucide-react":[["AlertCircle","65jRl","default"],["AlertTriangle","cdePa","default"],["ArrowLeft","2k0dn","default"],["ArrowRight","itm6a","default"],["Captions","cIbpr","default"],["Check","bajJU","default"],["ChevronDown","kVmgC","default"],["ChevronRight","lOb49","default"],["Clock","eqIIU","default"],["Copy","jM41N","default"],["Gauge","ibUN9","default"],["Info","4BuJn","default"],["Loader2","gZHhk","default"],["Music","2IC9T","default"],["Play","8th6f","default"],["Radio","8O5hz","default"],["ScrollText","hdD9f","default"],["Stethoscope","21eRB","default"],["Video","hvmLh","default"],["Zap","gsKiA","default"]],"@/client/config":"8SWgh","@/client/lib/format":"iLptT","@/client/client-infra":"kukyI","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6gkFH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlertCard", ()=>AlertCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _lucideReact = require("lucide-react");
var _dateFns = require("date-fns");
var _button = require("@/client/components/ui/button");
var _badge = require("@/client/components/ui/badge");
var _collapsible = require("@/client/components/ui/collapsible");
var _tooltip = require("@/client/components/ui/tooltip");
var _utils = require("@/client/lib/utils");
var _encodersStore = require("@/client/store/encodersStore");
const ALERT_TYPE_LABELS = {
    offline: 'Offline',
    zero_bitrate: 'Zero Bitrate',
    bitrate_too_high: 'Bitrate Too High',
    bitrate_drop: 'Bitrate Drop',
    bitrate_unstable: 'Unstable Bitrate',
    frame_rate_drop: 'Frame Rate Drop',
    resolution_change: 'Resolution Changed'
};
/** Resolution criteria for each alert type (must match ANOMALY_CONFIG in triage.ts) */ const RESOLUTION_INFO = {
    offline: {
        consecutive: 1,
        description: 'Resolves immediately when encoder comes back online'
    },
    zero_bitrate: {
        consecutive: 1,
        description: 'Resolves immediately when bitrate > 0'
    },
    bitrate_too_high: {
        consecutive: 1,
        description: 'Resolves immediately when bitrate drops below 5 MB/s'
    },
    bitrate_drop: {
        consecutive: 4,
        description: 'Resolves after 4 consecutive normal readings (~4 min)'
    },
    bitrate_unstable: {
        consecutive: 4,
        description: 'Resolves after 4 consecutive stable readings (~4 min)'
    },
    frame_rate_drop: {
        consecutive: 4,
        description: 'Resolves after 4 consecutive normal readings (~4 min)'
    },
    resolution_change: {
        consecutive: 1,
        description: 'Auto-resolves after 5 consecutive stable readings (~5 min)'
    }
};
function formatBitrate(bps) {
    if (!bps && bps !== 0) return '-';
    if (bps === 0) return '0 Mbps';
    const mbps = bps / 1000000;
    return `${mbps.toFixed(2)} Mbps`;
}
function formatValue(value, alertType) {
    if (value === undefined || value === null) return '-';
    if (alertType?.includes('bitrate')) return formatBitrate(value);
    if (alertType === 'frame_rate_drop') return `${value.toFixed(2)} fps`;
    return value.toLocaleString();
}
function AlertCard({ alert, isInTriage, onPinToTriage, isPinning, isMuted, onMute, onUnmute, onExport }) {
    const [isOpen, setIsOpen] = (0, _react.useState)(false);
    const [confirmingPin, setConfirmingPin] = (0, _react.useState)(false);
    // Look up client name from encoders store
    const encoder = (0, _encodersStore.useEncodersStore)((s)=>s.getEncoder(alert.encoderId));
    const clientName = encoder?.clientName;
    const severityStyles = {
        critical: 'border-l-red-500 bg-red-50/10',
        warning: 'border-l-amber-500 bg-amber-50/10',
        info: 'border-l-blue-500 bg-blue-50/10'
    };
    const severityDotStyles = {
        critical: 'bg-red-500',
        warning: 'bg-amber-500',
        info: 'bg-blue-500'
    };
    const severityBadgeStyles = {
        critical: 'bg-red-100 text-red-700 border-red-200',
        warning: 'bg-amber-100 text-amber-700 border-amber-200',
        info: 'bg-blue-100 text-blue-700 border-blue-200'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.Collapsible), {
        open: isOpen,
        onOpenChange: setIsOpen,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _utils.cn)('rounded-lg border border-l-4 transition-colors', severityStyles[alert.severity]),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center gap-3 p-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.CollapsibleTrigger), {
                            asChild: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: "ghost",
                                size: "sm",
                                className: "h-6 w-6 p-0",
                                children: isOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                    className: "h-4 w-4"
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                                    className: "h-4 w-4"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: (0, _utils.cn)('h-2.5 w-2.5 rounded-full flex-shrink-0', severityDotStyles[alert.severity])
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "font-medium text-sm truncate flex-1",
                            children: [
                                clientName && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "text-muted-foreground",
                                    children: [
                                        clientName,
                                        " / "
                                    ]
                                }),
                                alert.streamName || alert.encoderId
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                            variant: "outline",
                            className: "text-xs",
                            children: ALERT_TYPE_LABELS[alert.alertType] || alert.alertType
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                            variant: "outline",
                            className: (0, _utils.cn)('text-xs capitalize', severityBadgeStyles[alert.severity]),
                            children: alert.severity
                        }),
                        alert.firedAt && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltip.Tooltip), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipTrigger), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "text-xs text-muted-foreground flex items-center gap-1 cursor-help",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Clock), {
                                                className: "h-3 w-3"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                children: [
                                                    "Fired ",
                                                    (0, _dateFns.formatDistanceToNow)(alert.firedAt, {
                                                        addSuffix: true
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltip.TooltipContent), {
                                    side: "bottom",
                                    className: "text-xs",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            children: [
                                                "Alert first triggered: ",
                                                new Date(alert.firedAt).toLocaleString()
                                            ]
                                        }),
                                        RESOLUTION_INFO[alert.alertType] && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "mt-1 text-muted-foreground",
                                            children: RESOLUTION_INFO[alert.alertType].description
                                        })
                                    ]
                                })
                            ]
                        }),
                        alert.lastAnomalyAt && alert.firedAt && alert.lastAnomalyAt !== alert.firedAt && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltip.Tooltip), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipTrigger), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "text-xs text-muted-foreground flex items-center gap-1 cursor-help",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Eye), {
                                                className: "h-3 w-3"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                children: [
                                                    "Last detected ",
                                                    (0, _dateFns.formatDistanceToNow)(alert.lastAnomalyAt, {
                                                        addSuffix: true
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipContent), {
                                    side: "bottom",
                                    className: "text-xs",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        children: [
                                            "Condition last detected: ",
                                            new Date(alert.lastAnomalyAt).toLocaleString()
                                        ]
                                    })
                                })
                            ]
                        }),
                        onMute && onUnmute && (isMuted ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                            variant: "ghost",
                            size: "sm",
                            className: "h-7 gap-1 text-xs text-muted-foreground",
                            onClick: (e)=>{
                                e.stopPropagation();
                                onUnmute(alert.encoderId, alert.alertType);
                            },
                            title: "Unmute this alert",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Volume2), {
                                    className: "h-3 w-3"
                                }),
                                "Unmute"
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                            variant: "ghost",
                            size: "sm",
                            className: "h-7 gap-1 text-xs text-muted-foreground",
                            onClick: (e)=>{
                                e.stopPropagation();
                                onMute(alert.encoderId, alert.alertType);
                            },
                            title: "Mute this alert (hide from counts)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.VolumeX), {
                                    className: "h-3 w-3"
                                }),
                                "Mute"
                            ]
                        })),
                        !isInTriage && (confirmingPin ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                            variant: "default",
                            size: "sm",
                            className: "h-7 gap-1 text-xs",
                            onClick: (e)=>{
                                e.stopPropagation();
                                onPinToTriage(alert.encoderId);
                                setConfirmingPin(false);
                            },
                            onBlur: ()=>setConfirmingPin(false),
                            disabled: isPinning,
                            autoFocus: true,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Pin), {
                                    className: "h-3 w-3"
                                }),
                                isPinning ? 'Pinning...' : 'Confirm Pin'
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                            variant: "outline",
                            size: "sm",
                            className: "h-7 gap-1 text-xs",
                            onClick: (e)=>{
                                e.stopPropagation();
                                setConfirmingPin(true);
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Pin), {
                                    className: "h-3 w-3"
                                }),
                                "Pin to Triage"
                            ]
                        })),
                        isInTriage && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                            variant: "secondary",
                            className: "text-xs gap-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Pin), {
                                    className: "h-3 w-3"
                                }),
                                "In Triage"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.CollapsibleContent), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "px-3 pb-3 pt-0 border-t border-dashed ml-9",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-2 md:grid-cols-4 gap-4 py-3 text-sm",
                                children: [
                                    alert.alertType !== 'bitrate_unstable' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-muted-foreground text-xs mb-1",
                                                children: "Current"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-mono font-medium",
                                                children: formatValue(alert.currentValue, alert.alertType)
                                            })
                                        ]
                                    }),
                                    alert.alertType !== 'bitrate_unstable' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-muted-foreground text-xs mb-1",
                                                children: "Expected"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-mono",
                                                children: formatValue(alert.expectedValue, alert.alertType)
                                            })
                                        ]
                                    }),
                                    alert.stats?.mean !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-muted-foreground text-xs mb-1",
                                                children: "Mean"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-mono",
                                                children: formatBitrate(alert.stats.mean)
                                            })
                                        ]
                                    }),
                                    alert.stats?.cv !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-muted-foreground text-xs mb-1",
                                                children: "CV"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "font-mono",
                                                children: [
                                                    (alert.stats.cv * 100).toFixed(1),
                                                    "%"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            alert.message && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-sm text-muted-foreground mb-3",
                                children: alert.message
                            }),
                            alert.stats && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "text-xs text-muted-foreground mb-3",
                                children: [
                                    alert.stats.sampleCount && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        children: [
                                            "Samples: ",
                                            alert.stats.sampleCount
                                        ]
                                    }),
                                    alert.stats.stddev !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "ml-4",
                                        children: [
                                            "Stddev: ",
                                            formatBitrate(alert.stats.stddev)
                                        ]
                                    })
                                ]
                            }),
                            RESOLUTION_INFO[alert.alertType] && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-start gap-2 text-xs text-muted-foreground mb-3 p-2 bg-muted/30 rounded",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Info), {
                                        className: "h-3.5 w-3.5 mt-0.5 flex-shrink-0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-medium",
                                                children: "Resolution: "
                                            }),
                                            RESOLUTION_INFO[alert.alertType].description,
                                            RESOLUTION_INFO[alert.alertType].consecutive > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "ml-1 text-muted-foreground/70",
                                                children: [
                                                    "(requires ",
                                                    RESOLUTION_INFO[alert.alertType].consecutive,
                                                    " consecutive normal samples)"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                        to: "/encoders/$encoderID",
                                        params: {
                                            encoderID: alert.encoderId
                                        },
                                        className: (0, _button.buttonVariants)({
                                            variant: 'outline',
                                            size: 'sm',
                                            className: 'gap-1 text-xs'
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ExternalLink), {
                                                className: "h-3 w-3"
                                            }),
                                            "View Encoder"
                                        ]
                                    }),
                                    onExport && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                        variant: "outline",
                                        size: "sm",
                                        className: "gap-1 text-xs",
                                        onClick: ()=>onExport(alert.encoderId),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FileText), {
                                                className: "h-3 w-3"
                                            }),
                                            "Export Logs"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":"7k6Lq","lucide-react":[["ChevronDown","kVmgC","default"],["ChevronRight","lOb49","default"],["Clock","eqIIU","default"],["ExternalLink","kIIQA","default"],["Eye","3lL96","default"],["FileText","jrUS7","default"],["Info","4BuJn","default"],["Pin","dUwTa","default"],["Volume2","13G7V","default"],["VolumeX","42MP8","default"]],"date-fns":"1DXja","@/client/components/ui/button":"armlb","@/client/components/ui/badge":"h4e1f","@/client/components/ui/collapsible":"ij03O","@/client/components/ui/tooltip":"dWqZd","@/client/lib/utils":"1ankz","@/client/store/encodersStore":"7Qwmv","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4BuJn":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Info);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
];
const Info = (0, _createLucideIconJsDefault.default)("info", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dUwTa":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Pin);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 17v5",
            key: "bb1du9"
        }
    ],
    [
        "path",
        {
            d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
            key: "1nkz8b"
        }
    ]
];
const Pin = (0, _createLucideIconJsDefault.default)("pin", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"13G7V":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Volume2);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
            key: "uqj9uw"
        }
    ],
    [
        "path",
        {
            d: "M16 9a5 5 0 0 1 0 6",
            key: "1q6k2b"
        }
    ],
    [
        "path",
        {
            d: "M19.364 18.364a9 9 0 0 0 0-12.728",
            key: "ijwkga"
        }
    ]
];
const Volume2 = (0, _createLucideIconJsDefault.default)("volume-2", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"lTlFg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EncoderMonitorCard", ()=>EncoderMonitorCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _lucideReact = require("lucide-react");
var _button = require("@/client/components/ui/button");
var _badge = require("@/client/components/ui/badge");
var _utils = require("@/client/lib/utils");
var _alertStore = require("@/client/store/alertStore");
var _config = require("@/client/config");
var _dateFns = require("date-fns");
function EncoderMonitorCard({ encoder, onExport }) {
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const [isPinning, setIsPinning] = (0, _react.useState)(false);
    const [confirmingPin, setConfirmingPin] = (0, _react.useState)(false);
    const [showEventLog, setShowEventLog] = (0, _react.useState)(false);
    const triageSessions = (0, _alertStore.useAlertStore)((state)=>state.triageSessions);
    const addTriageSession = (0, _alertStore.useAlertStore)((state)=>state.addTriageSession);
    const isInTriage = triageSessions.some((s)=>s.encoderId === encoder.encoderID);
    // Count cycles in the event window
    const cycleCount = encoder.events.reduce((count, event, i, arr)=>{
        if (i === 0) return count;
        if (arr[i - 1].type === 'disconnect' && event.type === 'connect') return count + 1;
        return count;
    }, 0);
    const handlePinToTriage = async ()=>{
        try {
            setIsPinning(true);
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/encoders/${encoder.encoderID}/triage`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    notes: 'Pinned from Encoder Monitoring (WSS flapping detected)'
                })
            });
            if (!response.ok) throw new Error('Failed to start triage');
            const data = await response.json();
            addTriageSession(data.session);
        } catch (err) {
            console.error('Failed to pin encoder to triage:', err);
        } finally{
            setIsPinning(false);
            setConfirmingPin(false);
        }
    };
    const stateStyles = {
        alert: 'border-l-red-500 bg-red-50/10',
        warning: 'border-l-amber-500 bg-amber-50/10',
        normal: 'border-l-gray-300 bg-gray-50/10'
    };
    const stateDotStyles = {
        alert: 'bg-red-500',
        warning: 'bg-amber-500',
        normal: 'bg-gray-400'
    };
    const stateBadgeStyles = {
        alert: 'bg-red-100 text-red-700 border-red-200',
        warning: 'bg-amber-100 text-amber-700 border-amber-200',
        normal: 'bg-gray-100 text-gray-700 border-gray-200'
    };
    const stateLabels = {
        alert: 'Flapping',
        warning: 'Warning',
        normal: 'Normal'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _utils.cn)('rounded-lg border border-l-4 p-3 transition-colors', stateStyles[encoder.state]),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _utils.cn)('h-2.5 w-2.5 rounded-full flex-shrink-0', stateDotStyles[encoder.state])
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "font-medium text-sm truncate flex-1",
                        children: encoder.simpleName || encoder.encoderID
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-1 text-xs text-muted-foreground",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Activity), {
                                className: "h-3 w-3"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    cycleCount,
                                    " cycle",
                                    cycleCount !== 1 ? 's' : ''
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                        variant: "outline",
                        className: "text-xs gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Zap), {
                                className: (0, _utils.cn)('h-3 w-3', encoder.online ? 'text-green-500' : 'text-gray-400')
                            }),
                            encoder.online ? 'Online' : 'Offline'
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                        variant: "outline",
                        className: (0, _utils.cn)('text-xs', stateBadgeStyles[encoder.state]),
                        children: stateLabels[encoder.state]
                    }),
                    isInTriage ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                        variant: "secondary",
                        className: "text-xs gap-1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Pin), {
                                className: "h-3 w-3"
                            }),
                            "In Triage"
                        ]
                    }) : confirmingPin ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                        variant: "default",
                        size: "sm",
                        className: "h-7 gap-1 text-xs",
                        onClick: handlePinToTriage,
                        onBlur: ()=>setConfirmingPin(false),
                        disabled: isPinning,
                        autoFocus: true,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Pin), {
                                className: "h-3 w-3"
                            }),
                            isPinning ? 'Pinning...' : 'Confirm'
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                        variant: "outline",
                        size: "sm",
                        className: "h-7 gap-1 text-xs",
                        onClick: ()=>setConfirmingPin(true),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Pin), {
                                className: "h-3 w-3"
                            }),
                            "Pin to Triage"
                        ]
                    }),
                    onExport && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        variant: "ghost",
                        size: "sm",
                        className: "h-7 w-7 p-0",
                        onClick: ()=>onExport(encoder.encoderID),
                        title: "Export logs",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FileText), {
                            className: "h-3.5 w-3.5"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                        to: "/encoders/$encoderID",
                        params: {
                            encoderID: encoder.encoderID
                        },
                        className: (0, _button.buttonVariants)({
                            variant: 'ghost',
                            size: 'sm',
                            className: 'h-7 w-7 p-0'
                        }),
                        title: "View encoder",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ExternalLink), {
                            className: "h-3.5 w-3.5"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2 mt-2 ml-5 text-xs text-muted-foreground",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setShowEventLog(!showEventLog),
                        className: "flex items-center gap-1 hover:text-foreground transition-colors",
                        children: [
                            showEventLog ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronUp), {
                                className: "h-3 w-3"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                className: "h-3 w-3"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    encoder.events.length,
                                    " event",
                                    encoder.events.length !== 1 ? 's' : ''
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-muted-foreground/50",
                        children: "|"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        children: [
                            "Last: ",
                            (0, _dateFns.formatDistanceToNow)(encoder.lastUpdated, {
                                addSuffix: true
                            })
                        ]
                    }),
                    encoder.attachedToLiveStream && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-muted-foreground/50",
                                children: "|"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                variant: "outline",
                                className: "text-xs bg-blue-50 text-blue-700 border-blue-200",
                                children: "Live Stream"
                            })
                        ]
                    })
                ]
            }),
            showEventLog && encoder.events.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-2 ml-5 p-2 bg-zinc-900 rounded text-xs font-mono space-y-0.5 max-h-32 overflow-y-auto border border-zinc-700",
                children: encoder.events.map((event, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-zinc-400",
                                children: (0, _dateFns.format)(event.timestamp, 'HH:mm:ss.SSS')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: (0, _utils.cn)('font-medium', event.type === 'connect' ? 'text-green-400' : 'text-red-400'),
                                children: event.type
                            })
                        ]
                    }, i))
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":"7k6Lq","@auth0/auth0-react":"gpXrE","lucide-react":[["Activity","5XJYD","default"],["ChevronDown","kVmgC","default"],["ChevronUp","9DiT4","default"],["ExternalLink","kIIQA","default"],["FileText","jrUS7","default"],["Pin","dUwTa","default"],["Zap","gsKiA","default"]],"@/client/components/ui/button":"armlb","@/client/components/ui/badge":"h4e1f","@/client/lib/utils":"1ankz","@/client/store/alertStore":"fS0sT","@/client/config":"8SWgh","date-fns":[["format","4NYjc"],["formatDistanceToNow","1DXja"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9DiT4":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronUp);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
];
const ChevronUp = (0, _createLucideIconJsDefault.default)("chevron-up", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4NYjc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
parcelHelpers.export(exports, "formatters", ()=>(0, _formattersJs.formatters));
parcelHelpers.export(exports, "longFormatters", ()=>(0, _longFormattersJs.longFormatters));
parcelHelpers.export(exports, "formatDate", ()=>format);
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ parcelHelpers.export(exports, "format", ()=>format);
var _defaultLocaleJs = require("./_lib/defaultLocale.js");
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _formattersJs = require("./_lib/format/formatters.js");
var _longFormattersJs = require("./_lib/format/longFormatters.js");
var _protectedTokensJs = require("./_lib/protectedTokens.js");
var _isValidJs = require("./isValid.js");
var _toDateJs = require("./toDate.js");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(date, formatStr, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, _defaultLocaleJs.defaultLocale);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, _toDateJs.toDate)(date, options?.in);
    if (!(0, _isValidJs.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match(longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, _longFormattersJs.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: cleanEscapedString(substring)
        };
        if ((0, _formattersJs.formatters)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate,
        weekStartsOn,
        locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, _protectedTokensJs.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, _protectedTokensJs.isProtectedDayOfYearToken)(token)) (0, _protectedTokensJs.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = (0, _formattersJs.formatters)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function cleanEscapedString(input) {
    const matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}
// Fallback for modularized imports:
exports.default = format;

},{"./_lib/defaultLocale.js":[["defaultLocale","3UxOA","enUS"]],"./_lib/defaultOptions.js":"4407t","./_lib/format/formatters.js":"9ybse","./_lib/format/longFormatters.js":"6DfKD","./_lib/protectedTokens.js":"djgnj","./isValid.js":"d8c8F","./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9ybse":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatters", ()=>formatters);
var _getDayOfYearJs = require("../../getDayOfYear.js");
var _getISOWeekJs = require("../../getISOWeek.js");
var _getISOWeekYearJs = require("../../getISOWeekYear.js");
var _getWeekJs = require("../../getWeek.js");
var _getWeekYearJs = require("../../getWeekYear.js");
var _addLeadingZerosJs = require("../addLeadingZeros.js");
var _lightFormattersJs = require("./lightFormatters.js");
const dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const formatters = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, _lightFormattersJs.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, _getWeekYearJs.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, _addLeadingZerosJs.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, _addLeadingZerosJs.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, _getISOWeekYearJs.getISOWeekYear)(date);
        // Padding
        return (0, _addLeadingZerosJs.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, _addLeadingZerosJs.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _addLeadingZerosJs.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _addLeadingZerosJs.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, _lightFormattersJs.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _addLeadingZerosJs.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, _getWeekJs.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, _getISOWeekJs.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, _lightFormattersJs.lightFormatters).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, _getDayOfYearJs.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _addLeadingZerosJs.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _addLeadingZerosJs.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _addLeadingZerosJs.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, _lightFormattersJs.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, _lightFormattersJs.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, _lightFormattersJs.lightFormatters).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, _lightFormattersJs.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, _lightFormattersJs.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, _addLeadingZerosJs.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(+date, token.length);
    }
};
function formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, _addLeadingZerosJs.addLeadingZeros)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, _addLeadingZerosJs.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, delimiter);
}
function formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, _addLeadingZerosJs.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, _addLeadingZerosJs.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

},{"../../getDayOfYear.js":"4oCby","../../getISOWeek.js":"a8CO5","../../getISOWeekYear.js":"kwa9z","../../getWeek.js":"kRlLU","../../getWeekYear.js":"k1LnK","../addLeadingZeros.js":"fvxFu","./lightFormatters.js":"eyffy","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4oCby":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getDayOfYear} function options.
 */ /**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param date - The given date
 * @param options - The options
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ parcelHelpers.export(exports, "getDayOfYear", ()=>getDayOfYear);
var _differenceInCalendarDaysJs = require("./differenceInCalendarDays.js");
var _startOfYearJs = require("./startOfYear.js");
var _toDateJs = require("./toDate.js");
function getDayOfYear(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const diff = (0, _differenceInCalendarDaysJs.differenceInCalendarDays)(_date, (0, _startOfYearJs.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
// Fallback for modularized imports:
exports.default = getDayOfYear;

},{"./differenceInCalendarDays.js":"7OvEK","./startOfYear.js":"Iolia","./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7OvEK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInCalendarDays} function options.
 */ /**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param laterDate - The later date
 * @param earlierDate - The earlier date
 * @param options - The options object
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ parcelHelpers.export(exports, "differenceInCalendarDays", ()=>differenceInCalendarDays);
var _getTimezoneOffsetInMillisecondsJs = require("./_lib/getTimezoneOffsetInMilliseconds.js");
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
var _constantsJs = require("./constants.js");
var _startOfDayJs = require("./startOfDay.js");
function differenceInCalendarDays(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, _startOfDayJs.startOfDay)(laterDate_);
    const earlierStartOfDay = (0, _startOfDayJs.startOfDay)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, _getTimezoneOffsetInMillisecondsJs.getTimezoneOffsetInMilliseconds)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, _getTimezoneOffsetInMillisecondsJs.getTimezoneOffsetInMilliseconds)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, _constantsJs.millisecondsInDay));
}
// Fallback for modularized imports:
exports.default = differenceInCalendarDays;

},{"./_lib/getTimezoneOffsetInMilliseconds.js":"bKJ63","./_lib/normalizeDates.js":"eMMqq","./constants.js":"Sfkj0","./startOfDay.js":"l6QIr","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"l6QIr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfDay} function options.
 */ /**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfDay", ()=>startOfDay);
var _toDateJs = require("./toDate.js");
function startOfDay(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfDay;

},{"./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"Iolia":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfYear} function options.
 */ /**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfYear", ()=>startOfYear);
var _toDateJs = require("./toDate.js");
function startOfYear(date, options) {
    const date_ = (0, _toDateJs.toDate)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
// Fallback for modularized imports:
exports.default = startOfYear;

},{"./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"a8CO5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getISOWeek} function options.
 */ /**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param date - The given date
 * @param options - The options
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ parcelHelpers.export(exports, "getISOWeek", ()=>getISOWeek);
var _constantsJs = require("./constants.js");
var _startOfISOWeekJs = require("./startOfISOWeek.js");
var _startOfISOWeekYearJs = require("./startOfISOWeekYear.js");
var _toDateJs = require("./toDate.js");
function getISOWeek(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const diff = +(0, _startOfISOWeekJs.startOfISOWeek)(_date) - +(0, _startOfISOWeekYearJs.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, _constantsJs.millisecondsInWeek)) + 1;
}
// Fallback for modularized imports:
exports.default = getISOWeek;

},{"./constants.js":"Sfkj0","./startOfISOWeek.js":"hYVHP","./startOfISOWeekYear.js":"imaBi","./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hYVHP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfISOWeek} function options.
 */ /**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfISOWeek", ()=>startOfISOWeek);
var _startOfWeekJs = require("./startOfWeek.js");
function startOfISOWeek(date, options) {
    return (0, _startOfWeekJs.startOfWeek)(date, {
        ...options,
        weekStartsOn: 1
    });
}
// Fallback for modularized imports:
exports.default = startOfISOWeek;

},{"./startOfWeek.js":"96cNt","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"96cNt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfWeek", ()=>startOfWeek);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _toDateJs = require("./toDate.js");
function startOfWeek(date, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfWeek;

},{"./_lib/defaultOptions.js":"4407t","./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"imaBi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfISOWeekYear} function options.
 */ /**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ parcelHelpers.export(exports, "startOfISOWeekYear", ()=>startOfISOWeekYear);
var _constructFromJs = require("./constructFrom.js");
var _getISOWeekYearJs = require("./getISOWeekYear.js");
var _startOfISOWeekJs = require("./startOfISOWeek.js");
function startOfISOWeekYear(date, options) {
    const year = (0, _getISOWeekYearJs.getISOWeekYear)(date, options);
    const fourthOfJanuary = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, _startOfISOWeekJs.startOfISOWeek)(fourthOfJanuary);
}
// Fallback for modularized imports:
exports.default = startOfISOWeekYear;

},{"./constructFrom.js":"aMZJE","./getISOWeekYear.js":"kwa9z","./startOfISOWeek.js":"hYVHP","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kwa9z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getISOWeekYear} function options.
 */ /**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ parcelHelpers.export(exports, "getISOWeekYear", ()=>getISOWeekYear);
var _constructFromJs = require("./constructFrom.js");
var _startOfISOWeekJs = require("./startOfISOWeek.js");
var _toDateJs = require("./toDate.js");
function getISOWeekYear(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, _constructFromJs.constructFrom)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, _startOfISOWeekJs.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, _constructFromJs.constructFrom)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, _startOfISOWeekJs.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
// Fallback for modularized imports:
exports.default = getISOWeekYear;

},{"./constructFrom.js":"aMZJE","./startOfISOWeek.js":"hYVHP","./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kRlLU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ parcelHelpers.export(exports, "getWeek", ()=>getWeek);
var _constantsJs = require("./constants.js");
var _startOfWeekJs = require("./startOfWeek.js");
var _startOfWeekYearJs = require("./startOfWeekYear.js");
var _toDateJs = require("./toDate.js");
function getWeek(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const diff = +(0, _startOfWeekJs.startOfWeek)(_date, options) - +(0, _startOfWeekYearJs.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, _constantsJs.millisecondsInWeek)) + 1;
}
// Fallback for modularized imports:
exports.default = getWeek;

},{"./constants.js":"Sfkj0","./startOfWeek.js":"96cNt","./startOfWeekYear.js":"adoEp","./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"adoEp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ parcelHelpers.export(exports, "startOfWeekYear", ()=>startOfWeekYear);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _constructFromJs = require("./constructFrom.js");
var _getWeekYearJs = require("./getWeekYear.js");
var _startOfWeekJs = require("./startOfWeek.js");
function startOfWeekYear(date, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, _getWeekYearJs.getWeekYear)(date, options);
    const firstWeek = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, _startOfWeekJs.startOfWeek)(firstWeek, options);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfWeekYear;

},{"./_lib/defaultOptions.js":"4407t","./constructFrom.js":"aMZJE","./getWeekYear.js":"k1LnK","./startOfWeek.js":"96cNt","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"k1LnK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ parcelHelpers.export(exports, "getWeekYear", ()=>getWeekYear);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _constructFromJs = require("./constructFrom.js");
var _startOfWeekJs = require("./startOfWeek.js");
var _toDateJs = require("./toDate.js");
function getWeekYear(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, _startOfWeekJs.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, _startOfWeekJs.startOfWeek)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
// Fallback for modularized imports:
exports.default = getWeekYear;

},{"./_lib/defaultOptions.js":"4407t","./constructFrom.js":"aMZJE","./startOfWeek.js":"96cNt","./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fvxFu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addLeadingZeros", ()=>addLeadingZeros);
function addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eyffy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lightFormatters", ()=>lightFormatters);
var _addLeadingZerosJs = require("../addLeadingZeros.js");
const lightFormatters = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _addLeadingZerosJs.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, _addLeadingZerosJs.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _addLeadingZerosJs.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

},{"../addLeadingZeros.js":"fvxFu","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6DfKD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "longFormatters", ()=>longFormatters);
const dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
const longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"djgnj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", ()=>isProtectedDayOfYearToken);
parcelHelpers.export(exports, "isProtectedWeekYearToken", ()=>isProtectedWeekYearToken);
parcelHelpers.export(exports, "warnOrThrowProtectedError", ()=>warnOrThrowProtectedError);
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
    return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format, input) {
    const _message = message(token, format, input);
    console.warn(_message);
    if (throwTokens.includes(token)) throw new RangeError(_message);
}
function message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"d8c8F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertible into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ parcelHelpers.export(exports, "isValid", ()=>isValid);
var _isDateJs = require("./isDate.js");
var _toDateJs = require("./toDate.js");
function isValid(date) {
    return !(!(0, _isDateJs.isDate)(date) && typeof date !== "number" || isNaN(+(0, _toDateJs.toDate)(date)));
}
// Fallback for modularized imports:
exports.default = isValid;

},{"./isDate.js":"8vJhk","./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8vJhk":[function(require,module,exports,__globalThis) {
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDate", ()=>isDate);
function isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
// Fallback for modularized imports:
exports.default = isDate;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cBuOL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JsonSyntaxHighlight", ()=>JsonSyntaxHighlight);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@/client/lib/utils");
/**
 * Escape HTML before it goes through dangerouslySetInnerHTML.
 * Payloads routinely carry markup inside string values (event descriptions,
 * WordPress post content), which would otherwise render as live HTML.
 */ function escapeHtml(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function JsonSyntaxHighlight({ json, className }) {
    try {
        const parsed = JSON.parse(json);
        const formatted = escapeHtml(JSON.stringify(parsed, null, 2));
        // Apply syntax highlighting
        const highlighted = formatted.replace(/("(?:[^"\\]|\\.)*")(\s*:)/g, '<span class="text-blue-600 dark:text-blue-400">$1</span>$2') // keys
        .replace(/:\s*("(?:[^"\\]|\\.)*")/g, ': <span class="text-green-600 dark:text-green-400">$1</span>') // string values
        .replace(/:\s*(\d+\.?\d*)/g, ': <span class="text-amber-600 dark:text-amber-400">$1</span>') // numbers
        .replace(/:\s*(true|false)/g, ': <span class="text-purple-600 dark:text-purple-400">$1</span>') // booleans
        .replace(/:\s*(null)/g, ': <span class="text-gray-500">$1</span>'); // null
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
            className: (0, _utils.cn)('block whitespace-pre-wrap break-all', className),
            dangerouslySetInnerHTML: {
                __html: highlighted
            }
        });
    } catch  {
        // If not valid JSON, just return as-is
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
            className: (0, _utils.cn)('block whitespace-pre-wrap break-all', className),
            children: json
        });
    }
}

},{"react/jsx-runtime":"dQjte","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gZHhk":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>LoaderCircle);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
];
const LoaderCircle = (0, _createLucideIconJsDefault.default)("loader-circle", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2IC9T":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Music);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M9 18V5l12-2v13",
            key: "1jmyc2"
        }
    ],
    [
        "circle",
        {
            cx: "6",
            cy: "18",
            r: "3",
            key: "fqmcym"
        }
    ],
    [
        "circle",
        {
            cx: "18",
            cy: "16",
            r: "3",
            key: "1hluhg"
        }
    ]
];
const Music = (0, _createLucideIconJsDefault.default)("music", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8th6f":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Play);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
            key: "10ikf1"
        }
    ]
];
const Play = (0, _createLucideIconJsDefault.default)("play", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hvmLh":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Video);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
            key: "ftymec"
        }
    ],
    [
        "rect",
        {
            x: "2",
            y: "6",
            width: "14",
            height: "12",
            rx: "2",
            key: "158x01"
        }
    ]
];
const Video = (0, _createLucideIconJsDefault.default)("video", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kukyI":[function(require,module,exports,__globalThis) {
/**
 * Client-specific infrastructure notes
 *
 * These notes are displayed on encoder detail pages to document
 * tribal knowledge about how each client's infrastructure is set up.
 *
 * To add notes for a new client:
 * 1. Create a new file (e.g., acme.ts) with the client's notes
 * 2. Import and register it in CLIENT_INFRA_NOTES below
 */ // Types
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Get infrastructure notes for a client, if any exist
 */ parcelHelpers.export(exports, "getClientInfraNotes", ()=>getClientInfraNotes);
// Import client-specific notes
var _oregon = require("./oregon");
var _arizona = require("./arizona");
var _kcia = require("./kcia");
/**
 * Registry of clientID -> infrastructure notes
 */ const CLIENT_INFRA_NOTES = {
    [(0, _oregon.OREGON_CLIENT_ID)]: (0, _oregon.oregonNotes),
    [(0, _arizona.ARIZONA_CLIENT_ID)]: (0, _arizona.arizonaNotes),
    [(0, _kcia.KCIA_CLIENT_ID)]: (0, _kcia.kciaNotes)
};
function getClientInfraNotes(clientID) {
    return CLIENT_INFRA_NOTES[clientID] ?? null;
}

},{"./oregon":"cnFrZ","./arizona":"hGWhG","./kcia":"8954Z","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cnFrZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OREGON_CLIENT_ID", ()=>OREGON_CLIENT_ID);
parcelHelpers.export(exports, "oregonNotes", ()=>oregonNotes);
const OREGON_CLIENT_ID = '4879615486';
const oregonNotes = {
    clientName: 'State of Oregon',
    protocol: {
        actual: 'TS over SRT',
        note: 'Despite rtmp:// in the URI, all Haivision encoders use SRT'
    },
    portPattern: '10000 + encoder number (e.g., OR-Encoder-1 = port 10001)',
    configLocation: {
        system: 'Wowza Streaming Engine Manager',
        path: "srcEncoders application \u2192 Stream Files",
        credentials: '1Password \u2192 search "Ingress monitoring - Wowza"',
        url: 'http://ingress.state-oregon-cloud.invintus.stream:8088/enginemanager/login.htm'
    },
    notes: [
        {
            title: 'Stream naming',
            description: 'Wowza uses OR-Encoder-X.stream format. DB streamName (e.g., OR-247) is logical only.'
        },
        {
            title: 'Adding new encoders',
            description: 'Create new .stream file in Wowza with next available port. CTO typically handles this.'
        }
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hGWhG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ARIZONA_CLIENT_ID", ()=>ARIZONA_CLIENT_ID);
parcelHelpers.export(exports, "arizonaNotes", ()=>arizonaNotes);
const ARIZONA_CLIENT_ID = '6361162879';
const arizonaNotes = {
    clientName: 'State of Arizona',
    protocol: {
        actual: 'TS over SRT',
        note: 'Despite rtmp:// in the URI, all Haivision encoders use SRT'
    },
    portPattern: '10100 + encoder number (e.g., AZ-Encoder5 = port 10105)',
    configLocation: {
        system: 'Wowza Streaming Engine Manager',
        path: "srcEncoders application \u2192 Stream Files",
        credentials: '1Password \u2192 search "Ingress monitoring - Wowza"',
        url: 'http://ingress.state-oregon-cloud.invintus.stream:8088/enginemanager/login.htm'
    },
    notes: [
        {
            title: 'Shared Wowza server',
            description: 'Arizona streams are on the Oregon cloud Wowza server, not ingress.w1.invintus.com as the database URIs suggest.'
        },
        {
            title: 'Probe hostname mapping',
            description: 'Probes automatically translate w1 hostnames to state-oregon-cloud for AZ- prefixed streams.'
        }
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8954Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KCIA_CLIENT_ID", ()=>KCIA_CLIENT_ID);
parcelHelpers.export(exports, "kciaNotes", ()=>kciaNotes);
const KCIA_CLIENT_ID = '6779541715';
const kciaNotes = {
    clientName: 'King County International Airport (KCIA)',
    protocol: {
        actual: 'TS over SRT',
        note: ''
    },
    portPattern: "42710 (cam1), 42704 (cam2) \u2014 cam4/cam5 use Stream Target relay (no direct port)",
    configLocation: {
        system: 'Wowza Streaming Engine Manager',
        path: '"persis" application \u2192 Stream Files',
        credentials: '1Password \u2192 search "Persistent Stream monitoring - Wowza"',
        url: 'http://persis.invintus.live:8088/enginemanager/login.htm'
    },
    notes: [
        {
            title: 'Shared Wowza server',
            description: 'KCIA streams are technically 24/7 streams so not on the *.w1.invintus.com or whatever the database URIs suggest.'
        },
        {
            title: 'Persistent stream cameras',
            description: "Cam1 (KCIA-camera1, tifkljs1): Runway. Cam2 (KCIA-camera2, pnnuw9bw): Tower. Cam4 (KCIA-camera4, dqvm1jpp): DB Schenker East. Cam5 (KCIA-camera5, eas9oziy): DB Schenker West. All relay through ingress.w1 Stream Targets to persis.invintus.live."
        }
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5SfFw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _layout = require("./_layout");
var _layout1 = require("@/client/layouts/layout");
var _button = require("@/client/components/ui/button");
var _badge = require("@/client/components/ui/badge");
var _table = require("@/client/components/ui/table");
var _lucideReact = require("lucide-react");
var _config = require("@/client/config");
var _exportModal = require("@/client/components/export-modal");
var _alertStore = require("@/client/store/alertStore");
var _encoderWSSStore = require("@/client/store/encoderWSSStore");
var _shallow = require("zustand/react/shallow");
var _alertCard = require("@/client/components/alert-card");
var _groupedAlertCard = require("@/client/components/grouped-alert-card");
var _encoderMonitorCard = require("@/client/components/encoder/EncoderMonitorCard");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _layout.Route),
    path: 'encoders/triage',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: EncoderTriageComponent
});
function formatDuration(startedAt) {
    const diff = Date.now() - startedAt;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    if (days > 0) return `${days}d ${hours % 24}h`;
    if (hours > 0) return `${hours}h ${minutes % 60}m`;
    return `${minutes}m`;
}
function formatBitrate(bitrate) {
    if (!bitrate) return '-';
    if (bitrate >= 1000000) return `${(bitrate / 1000000).toFixed(2)} Mbps`;
    if (bitrate >= 1000) return `${(bitrate / 1000).toFixed(0)} Kbps`;
    return `${bitrate} bps`;
}
function formatBytes(bytes) {
    if (bytes >= 1000000) return `${(bytes / 1000000).toFixed(2)} MB`;
    if (bytes >= 1000) return `${(bytes / 1000).toFixed(1)} KB`;
    return `${bytes} B`;
}
function EncoderTriageComponent() {
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const navigate = (0, _reactRouter.useNavigate)();
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(null);
    const [pollerStats, setPollerStats] = (0, _react.useState)(null);
    const [pinningEncoder, setPinningEncoder] = (0, _react.useState)(null);
    const [confirmingUnpin, setConfirmingUnpin] = (0, _react.useState)(null);
    const [copiedEncoderId, setCopiedEncoderId] = (0, _react.useState)(null);
    // Severity filter state
    const [severityFilter, setSeverityFilter] = (0, _react.useState)('all');
    // Alert type filter state - set of hidden alert types
    const [hiddenAlertTypes, setHiddenAlertTypes] = (0, _react.useState)(new Set());
    // Export modal state
    const [exportModalOpen, setExportModalOpen] = (0, _react.useState)(false);
    const [exportEncoderId, setExportEncoderId] = (0, _react.useState)(null);
    // Copy encoder ID to clipboard
    const handleCopyEncoderId = async (encoderId, e)=>{
        e.stopPropagation();
        try {
            await navigator.clipboard.writeText(encoderId);
            setCopiedEncoderId(encoderId);
            setTimeout(()=>setCopiedEncoderId(null), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };
    // Get sessions and alerts from the store (auto-updated via SSE in layout.tsx)
    const sessions = (0, _alertStore.useAlertStore)((s)=>s.triageSessions);
    const sseStatus = (0, _alertStore.useAlertStore)((s)=>s.sseStatus);
    const alertsMap = (0, _alertStore.useAlertStore)((s)=>s.alerts);
    const mutedAlerts = (0, _alertStore.useAlertStore)((s)=>s.mutedAlerts);
    const addTriageSession = (0, _alertStore.useAlertStore)((s)=>s.addTriageSession);
    const setTriageSessions = (0, _alertStore.useAlertStore)((s)=>s.setTriageSessions);
    const removeTriageSession = (0, _alertStore.useAlertStore)((s)=>s.removeTriageSession);
    const muteAlert = (0, _alertStore.useAlertStore)((s)=>s.muteAlert);
    const unmuteAlert = (0, _alertStore.useAlertStore)((s)=>s.unmuteAlert);
    // Get encoder WSS monitoring data - convert Map to array in selector for stable reference
    const encodersWithIssues = (0, _encoderWSSStore.useEncoderWSSStore)((0, _shallow.useShallow)((s)=>{
        return Array.from(s.encoders.values()).filter((e)=>e.state !== 'normal').sort((a, b)=>{
            if (a.state === 'alert' && b.state !== 'alert') return -1;
            if (b.state === 'alert' && a.state !== 'alert') return 1;
            // Stable alpha sort by name - prevents jumping when alerts update
            return a.simpleName.localeCompare(b.simpleName);
        });
    }));
    const isConnected = sseStatus === 'connected';
    const { alerts, mutedAlertsList, alertTypeCounts, groupedAlerts, singleAlerts } = (0, _react.useMemo)(()=>{
        const active = [];
        const muted = [];
        const typeCounts = {};
        for (const [encoderId, encoderAlerts] of alertsMap.entries())for (const [alertType, alert] of encoderAlerts.entries()){
            const key = (0, _alertStore.getAlertKey)(encoderId, alertType);
            // Count all alert types (before muting filter)
            typeCounts[alertType] = (typeCounts[alertType] || 0) + 1;
            if (mutedAlerts.has(key)) muted.push({
                encoderId,
                alertType,
                alert
            });
            else active.push({
                encoderId,
                alertType,
                alert
            });
        }
        // Sort by severity (critical first) then by encoderId
        const severityOrder = {
            critical: 0,
            warning: 1,
            info: 2
        };
        const sortFn = (a, b)=>{
            const aSev = severityOrder[a.alert.severity] ?? 3;
            const bSev = severityOrder[b.alert.severity] ?? 3;
            if (aSev !== bSev) return aSev - bSev;
            return a.encoderId.localeCompare(b.encoderId);
        };
        const sortedActive = active.sort(sortFn);
        // Group alerts by encoderId - only group if encoder has >1 alert
        const tempGrouped = new Map();
        for (const item of sortedActive){
            const existing = tempGrouped.get(item.encoderId) || [];
            existing.push(item);
            tempGrouped.set(item.encoderId, existing);
        }
        // Separate into grouped (>1 alert) and singles (exactly 1 alert)
        const multiAlertGroups = [];
        const singleAlerts = [];
        for (const [encoderId, encoderAlerts] of tempGrouped.entries())if (encoderAlerts.length > 1) multiAlertGroups.push([
            encoderId,
            encoderAlerts
        ]);
        else singleAlerts.push(...encoderAlerts);
        // Sort grouped entries by highest severity alert in each group
        multiAlertGroups.sort(([, aAlerts], [, bAlerts])=>{
            const aMaxSev = Math.min(...aAlerts.map((a)=>severityOrder[a.alert.severity] ?? 3));
            const bMaxSev = Math.min(...bAlerts.map((b)=>severityOrder[b.alert.severity] ?? 3));
            return aMaxSev - bMaxSev;
        });
        // Sort single alerts by severity
        singleAlerts.sort(sortFn);
        return {
            alerts: sortedActive.map(({ alert })=>alert),
            mutedAlertsList: muted.sort(sortFn).map(({ alert })=>alert),
            alertTypeCounts: typeCounts,
            groupedAlerts: multiAlertGroups,
            singleAlerts: singleAlerts.map(({ alert })=>alert)
        };
    }, [
        alertsMap,
        mutedAlerts
    ]);
    // Filter alerts by severity and hidden types
    const filteredAlerts = (0, _react.useMemo)(()=>{
        let filtered = alerts;
        if (severityFilter !== 'all') filtered = filtered.filter((alert)=>alert.severity === severityFilter);
        if (hiddenAlertTypes.size > 0) filtered = filtered.filter((alert)=>!hiddenAlertTypes.has(alert.alertType));
        return filtered;
    }, [
        alerts,
        severityFilter,
        hiddenAlertTypes
    ]);
    // Filter grouped alerts and single alerts by severity and hidden types
    const { filteredGroupedAlerts, filteredSingleAlerts } = (0, _react.useMemo)(()=>{
        const filterFn = (alert)=>{
            if (severityFilter !== 'all' && alert.severity !== severityFilter) return false;
            if (hiddenAlertTypes.size > 0 && hiddenAlertTypes.has(alert.alertType)) return false;
            return true;
        };
        // Filter grouped alerts - keep groups that have at least one visible alert
        const filteredGroups = groupedAlerts.map(([encoderId, encoderAlerts])=>{
            const visibleAlerts = encoderAlerts.filter((item)=>filterFn(item.alert));
            return [
                encoderId,
                visibleAlerts
            ];
        }).filter(([, visibleAlerts])=>visibleAlerts.length > 0);
        // Filter single alerts
        const filteredSingles = singleAlerts.filter(filterFn);
        return {
            filteredGroupedAlerts: filteredGroups,
            filteredSingleAlerts: filteredSingles
        };
    }, [
        groupedAlerts,
        singleAlerts,
        severityFilter,
        hiddenAlertTypes
    ]);
    // Count alerts by severity for filter badges
    const severityCounts = (0, _react.useMemo)(()=>({
            critical: alerts.filter((a)=>a.severity === 'critical').length,
            warning: alerts.filter((a)=>a.severity === 'warning').length,
            info: alerts.filter((a)=>a.severity === 'info').length
        }), [
        alerts
    ]);
    // Check if encoder is already in triage
    const triageEncoderIds = (0, _react.useMemo)(()=>new Set(sessions.map((s)=>s.encoderId)), [
        sessions
    ]);
    const fetchSessions = async ()=>{
        try {
            setLoading(true);
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/encoders/triage`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error('Failed to fetch triage sessions');
            const data = await response.json();
            setTriageSessions(data.sessions || []);
            setError(null);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Unknown error');
        } finally{
            setLoading(false);
        }
    };
    const fetchPollerStats = async ()=>{
        try {
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/encoders/poller/stats`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.ok) {
                const data = await response.json();
                setPollerStats(data.poller);
            }
        } catch (err) {
            console.error('Failed to fetch poller stats:', err);
        }
    };
    const handleStopTriage = async (encoderId)=>{
        try {
            const token = await getAccessTokenSilently();
            await fetch(`${(0, _config.API_BASE_URL)}/api/encoders/${encoderId}/triage`, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            // Store will be updated via SSE broadcast, but update immediately for responsiveness
            removeTriageSession(encoderId);
        } catch (err) {
            console.error('Failed to stop triage:', err);
        }
    };
    const handlePinToTriage = async (encoderId)=>{
        try {
            setPinningEncoder(encoderId);
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/encoders/${encoderId}/triage`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    notes: 'Pinned from Active Alerts'
                })
            });
            if (!response.ok) throw new Error('Failed to start triage');
            const data = await response.json();
            addTriageSession(data.session);
        } catch (err) {
            console.error('Failed to pin encoder to triage:', err);
        } finally{
            setPinningEncoder(null);
        }
    };
    const handleExport = (encoderId)=>{
        setExportEncoderId(encoderId);
        setExportModalOpen(true);
    };
    (0, _react.useEffect)(()=>{
        fetchSessions();
        fetchPollerStats();
        // Refresh poller stats every 30 seconds
        const interval = setInterval(fetchPollerStats, 30000);
        return ()=>clearInterval(interval);
    }, [
        getAccessTokenSilently
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout1.Layout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center justify-between mb-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Stethoscope), {
                                            className: "h-6 w-6"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            className: "text-2xl font-semibold",
                                            children: "Encoder Triage"
                                        }),
                                        isConnected ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                            variant: "outline",
                                            className: "bg-green-50 text-green-700 gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Wifi), {
                                                    className: "h-3 w-3"
                                                }),
                                                "Polling"
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                            variant: "outline",
                                            className: "bg-gray-50 text-gray-500 gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.WifiOff), {
                                                    className: "h-3 w-3"
                                                }),
                                                sseStatus === 'connecting' ? 'Connecting...' : 'Disconnected'
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                    variant: "outline",
                                    onClick: fetchSessions,
                                    disabled: loading,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                            className: `h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`
                                        }),
                                        "Refresh"
                                    ]
                                })
                            ]
                        }),
                        pollerStats?.ringBufferStats && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "grid grid-cols-2 md:grid-cols-4 gap-4 mb-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "rounded-lg border p-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2 text-muted-foreground text-sm mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Database), {
                                                    className: "h-4 w-4"
                                                }),
                                                "Total Encoders"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-2xl font-semibold",
                                            children: pollerStats.ringBufferStats.totalEncoders
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "rounded-lg border p-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2 text-muted-foreground text-sm mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Stethoscope), {
                                                    className: "h-4 w-4"
                                                }),
                                                "In Triage"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-2xl font-semibold",
                                            children: pollerStats.ringBufferStats.triageEncoders
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "rounded-lg border p-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2 text-muted-foreground text-sm mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Database), {
                                                    className: "h-4 w-4"
                                                }),
                                                "Total Samples"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-2xl font-semibold",
                                            children: pollerStats.ringBufferStats.totalSamples.toLocaleString()
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "rounded-lg border p-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2 text-muted-foreground text-sm mb-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.HardDrive), {
                                                    className: "h-4 w-4"
                                                }),
                                                "Est. Memory"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-2xl font-semibold",
                                            children: formatBytes(pollerStats.ringBufferStats.estimatedMemoryBytes)
                                        })
                                    ]
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "p-4 bg-red-100 border-l-4 border-red-600 rounded mb-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "m-0 text-red-800 font-medium",
                                children: [
                                    "Error: ",
                                    error
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-8",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Radio), {
                                            className: "h-5 w-5 text-blue-600"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                            className: "text-lg font-semibold",
                                            children: "Connection Monitoring"
                                        }),
                                        encodersWithIssues.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                            variant: "outline",
                                            className: "bg-blue-50 text-blue-700 border-blue-200",
                                            children: encodersWithIssues.length
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-xs text-muted-foreground ml-2",
                                            children: "Real-time connection status"
                                        })
                                    ]
                                }),
                                encodersWithIssues.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "text-center py-6 text-muted-foreground border rounded-lg border-dashed",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Radio), {
                                            className: "h-8 w-8 mx-auto mb-2 opacity-30"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-sm",
                                            children: "No encoder connection issues detected"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-xs mt-1",
                                            children: "Rapid connect/disconnect cycles will appear here"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "space-y-2",
                                    children: encodersWithIssues.map((encoder)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _encoderMonitorCard.EncoderMonitorCard), {
                                            encoder: encoder,
                                            onExport: handleExport
                                        }, encoder.encoderID))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-8",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center justify-between mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                                                    className: "h-5 w-5 text-amber-600"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    className: "text-lg font-semibold",
                                                    children: "Active Alerts"
                                                }),
                                                alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                                    variant: "outline",
                                                    className: "bg-amber-50 text-amber-700 border-amber-200",
                                                    children: alerts.length
                                                }),
                                                mutedAlertsList.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "text-xs text-muted-foreground ml-2",
                                                    children: [
                                                        "(",
                                                        mutedAlertsList.length,
                                                        " muted)"
                                                    ]
                                                })
                                            ]
                                        }),
                                        alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    variant: severityFilter === 'all' ? 'secondary' : 'ghost',
                                                    size: "sm",
                                                    onClick: ()=>setSeverityFilter('all'),
                                                    className: "h-7 text-xs",
                                                    children: "All"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                    variant: severityFilter === 'critical' ? 'secondary' : 'ghost',
                                                    size: "sm",
                                                    onClick: ()=>setSeverityFilter('critical'),
                                                    className: "h-7 text-xs gap-1",
                                                    disabled: severityCounts.critical === 0,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "h-2 w-2 rounded-full bg-red-500"
                                                        }),
                                                        "Critical",
                                                        severityCounts.critical > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "text-muted-foreground",
                                                            children: [
                                                                "(",
                                                                severityCounts.critical,
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                    variant: severityFilter === 'warning' ? 'secondary' : 'ghost',
                                                    size: "sm",
                                                    onClick: ()=>setSeverityFilter('warning'),
                                                    className: "h-7 text-xs gap-1",
                                                    disabled: severityCounts.warning === 0,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "h-2 w-2 rounded-full bg-amber-500"
                                                        }),
                                                        "Warning",
                                                        severityCounts.warning > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "text-muted-foreground",
                                                            children: [
                                                                "(",
                                                                severityCounts.warning,
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                    variant: severityFilter === 'info' ? 'secondary' : 'ghost',
                                                    size: "sm",
                                                    onClick: ()=>setSeverityFilter('info'),
                                                    className: "h-7 text-xs gap-1",
                                                    disabled: severityCounts.info === 0,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "h-2 w-2 rounded-full bg-blue-500"
                                                        }),
                                                        "Info",
                                                        severityCounts.info > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "text-muted-foreground",
                                                            children: [
                                                                "(",
                                                                severityCounts.info,
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                alerts.length > 0 && Object.keys(alertTypeCounts).length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-wrap gap-1 mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-xs text-muted-foreground mr-2 self-center",
                                            children: "Filter types:"
                                        }),
                                        Object.entries(alertTypeCounts).sort(([, a], [, b])=>b - a).map(([alertType, count])=>{
                                            const isHidden = hiddenAlertTypes.has(alertType);
                                            const label = alertType.split('_').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                variant: isHidden ? 'outline' : 'secondary',
                                                size: "sm",
                                                onClick: ()=>{
                                                    const newHidden = new Set(hiddenAlertTypes);
                                                    if (isHidden) newHidden.delete(alertType);
                                                    else newHidden.add(alertType);
                                                    setHiddenAlertTypes(newHidden);
                                                },
                                                className: `h-6 text-xs ${isHidden ? 'opacity-50 line-through' : ''}`,
                                                children: [
                                                    label,
                                                    " (",
                                                    count,
                                                    ")"
                                                ]
                                            }, alertType);
                                        }),
                                        hiddenAlertTypes.size > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            variant: "ghost",
                                            size: "sm",
                                            onClick: ()=>setHiddenAlertTypes(new Set()),
                                            className: "h-6 text-xs text-muted-foreground",
                                            children: "Clear filters"
                                        })
                                    ]
                                }),
                                alerts.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "text-center py-8 text-muted-foreground border rounded-lg border-dashed",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                                            className: "h-8 w-8 mx-auto mb-2 opacity-30"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-sm",
                                            children: "No active anomalies detected"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-xs mt-1",
                                            children: "Encoders with issues will appear here automatically"
                                        })
                                    ]
                                }) : filteredAlerts.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "text-center py-8 text-muted-foreground border rounded-lg border-dashed",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                                            className: "h-8 w-8 mx-auto mb-2 opacity-30"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-sm",
                                            children: "No alerts match current filters"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-xs mt-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                variant: "link",
                                                size: "sm",
                                                onClick: ()=>{
                                                    setSeverityFilter('all');
                                                    setHiddenAlertTypes(new Set());
                                                },
                                                className: "h-auto p-0 text-xs",
                                                children: "Clear all filters"
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        filteredGroupedAlerts.map(([encoderId, encoderAlerts])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupedAlertCard.GroupedAlertCard), {
                                                encoderId: encoderId,
                                                alerts: encoderAlerts.map((a)=>a.alert),
                                                isInTriage: triageEncoderIds.has(encoderId),
                                                onPinToTriage: handlePinToTriage,
                                                isPinning: pinningEncoder === encoderId,
                                                onMute: muteAlert,
                                                onUnmute: unmuteAlert,
                                                onExport: handleExport
                                            }, `group-${encoderId}`)),
                                        filteredSingleAlerts.map((alert)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertCard.AlertCard), {
                                                alert: alert,
                                                isInTriage: triageEncoderIds.has(alert.encoderId),
                                                onPinToTriage: handlePinToTriage,
                                                isPinning: pinningEncoder === alert.encoderId,
                                                isMuted: false,
                                                onMute: muteAlert,
                                                onUnmute: unmuteAlert,
                                                onExport: handleExport
                                            }, `${alert.encoderId}-${alert.alertType}`))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2 mb-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Stethoscope), {
                                    className: "h-5 w-5 text-red-600"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    className: "text-lg font-semibold",
                                    children: "Active Triage Sessions"
                                }),
                                sessions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                    variant: "outline",
                                    className: "bg-red-50 text-red-700 border-red-200",
                                    children: sessions.length
                                })
                            ]
                        }),
                        loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Loading triage sessions..."
                        }),
                        !loading && sessions.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-center py-12 text-muted-foreground",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Stethoscope), {
                                    className: "h-12 w-12 mx-auto mb-4 opacity-30"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-lg font-medium",
                                    children: "No Active Triage Sessions"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-sm mt-2",
                                    children: "Start a triage session from an encoder's detail page to monitor it here."
                                })
                            ]
                        }),
                        !loading && sessions.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rounded-md border",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    children: "Encoder ID"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    children: "Stream Name"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    children: "Duration"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    children: "Bitrate"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    children: "Resolution"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    children: "Frame Rate"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    children: "Started By"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    className: "w-40",
                                                    children: "Actions"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                        children: sessions.map((session)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                className: "cursor-pointer hover:bg-muted",
                                                onClick: ()=>navigate({
                                                        to: '/encoders/$encoderID',
                                                        params: {
                                                            encoderID: session.encoderId
                                                        }
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "font-mono text-sm cursor-pointer",
                                                        onClick: (e)=>handleCopyEncoderId(session.encoderId, e),
                                                        title: "Click to copy",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "flex items-center gap-1.5",
                                                            children: [
                                                                session.encoderId,
                                                                copiedEncoderId === session.encoderId ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                                                                    className: "h-3 w-3 text-green-600"
                                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Copy), {
                                                                    className: "h-3 w-3 text-muted-foreground"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        children: session.streamName || '-'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        children: formatDuration(session.startedAt)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "font-mono",
                                                        children: formatBitrate(session.latestSample?.bitrate)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "font-mono",
                                                        children: session.latestSample?.width && session.latestSample?.height ? `${session.latestSample.width}x${session.latestSample.height}` : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "font-mono",
                                                        children: session.latestSample?.real_frame_rate || '-'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "text-sm text-muted-foreground truncate max-w-[150px]",
                                                        children: session.startedBy || '-'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        onClick: (e)=>e.stopPropagation(),
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                                    variant: "outline",
                                                                    size: "sm",
                                                                    onClick: ()=>handleExport(session.encoderId),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FileText), {
                                                                            className: "h-4 w-4 mr-1"
                                                                        }),
                                                                        "Export"
                                                                    ]
                                                                }),
                                                                confirmingUnpin === session.encoderId ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "flex gap-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                                            variant: "destructive",
                                                                            size: "sm",
                                                                            onClick: ()=>{
                                                                                handleStopTriage(session.encoderId);
                                                                                setConfirmingUnpin(null);
                                                                            },
                                                                            autoFocus: true,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                                                                                    className: "h-4 w-4 mr-1"
                                                                                }),
                                                                                "Confirm"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                                            variant: "ghost",
                                                                            size: "sm",
                                                                            onClick: ()=>setConfirmingUnpin(null),
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.X), {
                                                                                className: "h-4 w-4"
                                                                            })
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                                    variant: "outline",
                                                                    size: "sm",
                                                                    onClick: ()=>setConfirmingUnpin(session.encoderId),
                                                                    children: "Unpin"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, session.encoderId))
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "mt-4 text-sm text-muted-foreground",
                            children: [
                                sessions.length,
                                " active triage session",
                                sessions.length !== 1 ? 's' : ''
                            ]
                        }),
                        mutedAlertsList.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mt-8",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.VolumeX), {
                                            className: "h-5 w-5 text-muted-foreground"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                            className: "text-lg font-semibold text-muted-foreground",
                                            children: "Muted Alerts"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                            variant: "outline",
                                            className: "bg-gray-50 text-gray-600 border-gray-200",
                                            children: mutedAlertsList.length
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-xs text-muted-foreground",
                                            children: "Muted only for you"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "space-y-2 opacity-60",
                                    children: mutedAlertsList.map((alert)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertCard.AlertCard), {
                                            alert: alert,
                                            isInTriage: triageEncoderIds.has(alert.encoderId),
                                            onPinToTriage: handlePinToTriage,
                                            isPinning: pinningEncoder === alert.encoderId,
                                            isMuted: true,
                                            onMute: muteAlert,
                                            onUnmute: unmuteAlert,
                                            onExport: handleExport
                                        }, `${alert.encoderId}-${alert.alertType}-muted`))
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exportModal.ExportModal), {
                encoderId: exportEncoderId,
                open: exportModalOpen,
                onOpenChange: setExportModalOpen
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useNavigate","aMhxM"]],"@auth0/auth0-react":"gpXrE","./_layout":"eMWtI","@/client/layouts/layout":"d6QdD","@/client/components/ui/button":"armlb","@/client/components/ui/badge":"h4e1f","@/client/components/ui/table":"5vxZ8","lucide-react":[["AlertTriangle","cdePa","default"],["Check","bajJU","default"],["Copy","jM41N","default"],["Database","cqLcF","default"],["FileText","jrUS7","default"],["HardDrive","1nIEX","default"],["Radio","8O5hz","default"],["RefreshCw","7a8jT","default"],["Stethoscope","21eRB","default"],["VolumeX","42MP8","default"],["Wifi","1QI2i","default"],["WifiOff","fo1VD","default"],["X","8HSxK","default"]],"@/client/config":"8SWgh","@/client/components/export-modal":"hkBfg","@/client/store/alertStore":"fS0sT","@/client/store/encoderWSSStore":"jpzNm","zustand/react/shallow":"6ZS3a","@/client/components/alert-card":"6gkFH","@/client/components/grouped-alert-card":"d86yo","@/client/components/encoder/EncoderMonitorCard":"lTlFg","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hkBfg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExportModal", ()=>ExportModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _auth0React = require("@auth0/auth0-react");
var _lucideReact = require("lucide-react");
var _button = require("@/client/components/ui/button");
var _dialog = require("@/client/components/ui/dialog");
var _config = require("@/client/config");
var _encoderWSSStore = require("@/client/store/encoderWSSStore");
function ExportModal({ encoderId, open, onOpenChange }) {
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const [content, setContent] = (0, _react.useState)('');
    const [loading, setLoading] = (0, _react.useState)(false);
    const [copied, setCopied] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    // Get WSS events for this encoder from the client-side store
    const getEncoderEvents = ()=>{
        if (!encoderId) return [];
        const encoder = (0, _encoderWSSStore.useEncoderWSSStore).getState().encoders.get(encoderId);
        return encoder?.events || [];
    };
    const fetchExport = async (id)=>{
        try {
            setLoading(true);
            setError(null);
            setCopied(false);
            const token = await getAccessTokenSilently();
            const wssEvents = getEncoderEvents();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/triage/${id}/export`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    wssEvents
                })
            });
            if (!response.ok) throw new Error('Failed to export triage data');
            const data = await response.json();
            setContent(data.text);
        } catch (err) {
            console.error('Failed to export triage data:', err);
            setError('Failed to export triage data');
            setContent('');
        } finally{
            setLoading(false);
        }
    };
    // Fetch when modal opens with an encoder
    (0, _react.useEffect)(()=>{
        if (open && encoderId) fetchExport(encoderId);
        if (!open) {
            // Clear state when closing
            setContent('');
            setError(null);
            setCopied(false);
        }
    }, [
        open,
        encoderId
    ]);
    const handleCopyToClipboard = async ()=>{
        try {
            await navigator.clipboard.writeText(content);
            setCopied(true);
            setTimeout(()=>setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy to clipboard:', err);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.DialogContent), {
            className: "max-w-4xl max-h-[80vh] flex flex-col",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.DialogHeader), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.DialogTitle), {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FileText), {
                                    className: "h-5 w-5"
                                }),
                                "Encoder Health Report"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.DialogDescription), {
                            className: "font-mono",
                            children: encoderId && `Encoder ID: ${encoderId}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex-1 min-h-0 overflow-auto",
                    children: loading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center justify-center py-12",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                className: "h-6 w-6 animate-spin text-muted-foreground"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "ml-2 text-muted-foreground",
                                children: "Loading export data..."
                            })
                        ]
                    }) : error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex items-center justify-center py-12 text-red-500",
                        children: error
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                        className: "bg-muted p-4 rounded-md text-xs font-mono whitespace-pre overflow-auto max-h-[50vh]",
                        children: content
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex justify-end gap-2 pt-4 border-t",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            variant: "outline",
                            onClick: handleCopyToClipboard,
                            disabled: loading || !content,
                            children: copied ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                                        className: "h-4 w-4 mr-2 text-green-600"
                                    }),
                                    "Copied!"
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Copy), {
                                        className: "h-4 w-4 mr-2"
                                    }),
                                    "Copy to Clipboard"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            variant: "secondary",
                            onClick: ()=>onOpenChange(false),
                            children: "Close"
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@auth0/auth0-react":"gpXrE","lucide-react":[["Check","bajJU","default"],["Copy","jM41N","default"],["FileText","jrUS7","default"],["RefreshCw","7a8jT","default"]],"@/client/components/ui/button":"armlb","@/client/components/ui/dialog":"6jjic","@/client/config":"8SWgh","@/client/store/encoderWSSStore":"jpzNm","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"d86yo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupedAlertCard", ()=>GroupedAlertCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _lucideReact = require("lucide-react");
var _button = require("@/client/components/ui/button");
var _badge = require("@/client/components/ui/badge");
var _collapsible = require("@/client/components/ui/collapsible");
var _utils = require("@/client/lib/utils");
var _encodersStore = require("@/client/store/encodersStore");
var _alertCard = require("./alert-card");
const ALERT_TYPE_LABELS = {
    offline: 'Offline',
    zero_bitrate: 'Zero Bitrate',
    bitrate_too_high: 'Bitrate Too High',
    bitrate_drop: 'Bitrate Drop',
    bitrate_unstable: 'Unstable Bitrate',
    frame_rate_drop: 'Frame Rate Drop',
    resolution_change: 'Resolution Changed'
};
function GroupedAlertCard({ encoderId, alerts, isInTriage, onPinToTriage, isPinning, onMute, onUnmute, onExport }) {
    const [isOpen, setIsOpen] = (0, _react.useState)(false);
    const [confirmingPin, setConfirmingPin] = (0, _react.useState)(false);
    // Look up client name and stream name from encoders store
    const encoder = (0, _encodersStore.useEncodersStore)((s)=>s.getEncoder(encoderId));
    const clientName = encoder?.clientName;
    const streamName = alerts[0]?.streamName || encoderId;
    // Determine highest severity for border color
    const severityOrder = {
        critical: 0,
        warning: 1,
        info: 2
    };
    const highestSeverity = alerts.reduce((highest, alert)=>{
        const currentOrder = severityOrder[alert.severity] ?? 3;
        const highestOrder = severityOrder[highest] ?? 3;
        return currentOrder < highestOrder ? alert.severity : highest;
    }, 'info');
    // Count by severity
    const criticalCount = alerts.filter((a)=>a.severity === 'critical').length;
    const warningCount = alerts.filter((a)=>a.severity === 'warning').length;
    const infoCount = alerts.filter((a)=>a.severity === 'info').length;
    // Get unique alert types for summary
    const alertTypes = [
        ...new Set(alerts.map((a)=>a.alertType))
    ];
    const severityStyles = {
        critical: 'border-l-red-500 bg-red-50/10',
        warning: 'border-l-amber-500 bg-amber-50/10',
        info: 'border-l-blue-500 bg-blue-50/10'
    };
    const severityDotStyles = {
        critical: 'bg-red-500',
        warning: 'bg-amber-500',
        info: 'bg-blue-500'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.Collapsible), {
        open: isOpen,
        onOpenChange: setIsOpen,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _utils.cn)('rounded-lg border border-l-4 transition-colors', severityStyles[highestSeverity]),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center gap-3 p-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.CollapsibleTrigger), {
                            asChild: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: "ghost",
                                size: "sm",
                                className: "h-6 w-6 p-0",
                                children: isOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                    className: "h-4 w-4"
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                                    className: "h-4 w-4"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex gap-0.5",
                            children: [
                                criticalCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: (0, _utils.cn)('h-2.5 w-2.5 rounded-full', severityDotStyles.critical),
                                    title: `${criticalCount} critical`
                                }),
                                warningCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: (0, _utils.cn)('h-2.5 w-2.5 rounded-full', severityDotStyles.warning),
                                    title: `${warningCount} warning`
                                }),
                                infoCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: (0, _utils.cn)('h-2.5 w-2.5 rounded-full', severityDotStyles.info),
                                    title: `${infoCount} info`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "font-medium text-sm truncate flex-1",
                            children: [
                                clientName && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "text-muted-foreground",
                                    children: [
                                        clientName,
                                        " / "
                                    ]
                                }),
                                streamName
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                            variant: "outline",
                            className: "text-xs",
                            children: [
                                alerts.length,
                                " alert",
                                alerts.length !== 1 ? 's' : ''
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "hidden md:flex gap-1",
                            children: [
                                alertTypes.slice(0, 3).map((type)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                        variant: "secondary",
                                        className: "text-xs",
                                        children: ALERT_TYPE_LABELS[type] || type
                                    }, type)),
                                alertTypes.length > 3 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                    variant: "secondary",
                                    className: "text-xs",
                                    children: [
                                        "+",
                                        alertTypes.length - 3
                                    ]
                                })
                            ]
                        }),
                        !isInTriage && (confirmingPin ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                            variant: "default",
                            size: "sm",
                            className: "h-7 gap-1 text-xs",
                            onClick: (e)=>{
                                e.stopPropagation();
                                onPinToTriage(encoderId);
                                setConfirmingPin(false);
                            },
                            onBlur: ()=>setConfirmingPin(false),
                            disabled: isPinning,
                            autoFocus: true,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Pin), {
                                    className: "h-3 w-3"
                                }),
                                isPinning ? 'Pinning...' : 'Confirm Pin'
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                            variant: "outline",
                            size: "sm",
                            className: "h-7 gap-1 text-xs",
                            onClick: (e)=>{
                                e.stopPropagation();
                                setConfirmingPin(true);
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Pin), {
                                    className: "h-3 w-3"
                                }),
                                "Pin to Triage"
                            ]
                        })),
                        isInTriage && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                            variant: "secondary",
                            className: "text-xs gap-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Pin), {
                                    className: "h-3 w-3"
                                }),
                                "In Triage"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapsible.CollapsibleContent), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "px-3 pb-3 pt-0 border-t border-dashed ml-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "space-y-2 py-3",
                                children: alerts.map((alert)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertCard.AlertCard), {
                                        alert: alert,
                                        isInTriage: isInTriage,
                                        onPinToTriage: onPinToTriage,
                                        isPinning: isPinning,
                                        isMuted: false,
                                        onMute: onMute,
                                        onUnmute: onUnmute,
                                        onExport: onExport
                                    }, `${alert.encoderId}-${alert.alertType}`))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex gap-2 pt-2 border-t",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                        to: "/encoders/$encoderID",
                                        params: {
                                            encoderID: encoderId
                                        },
                                        className: (0, _button.buttonVariants)({
                                            variant: 'outline',
                                            size: 'sm',
                                            className: 'gap-1 text-xs'
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ExternalLink), {
                                                className: "h-3 w-3"
                                            }),
                                            "View Encoder"
                                        ]
                                    }),
                                    onExport && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                        variant: "outline",
                                        size: "sm",
                                        className: "gap-1 text-xs",
                                        onClick: ()=>onExport(encoderId),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FileText), {
                                                className: "h-3 w-3"
                                            }),
                                            "Export Logs"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":"7k6Lq","lucide-react":[["ChevronDown","kVmgC","default"],["ChevronRight","lOb49","default"],["ExternalLink","kIIQA","default"],["FileText","jrUS7","default"],["Pin","dUwTa","default"]],"@/client/components/ui/button":"armlb","@/client/components/ui/badge":"h4e1f","@/client/components/ui/collapsible":"ij03O","@/client/lib/utils":"1ankz","@/client/store/encodersStore":"7Qwmv","./alert-card":"6gkFH","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"aV7V4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _reactTable = require("@tanstack/react-table");
var _root = require("./__root");
var _layout = require("@/client/layouts/layout");
var _allPersistentStreamsStore = require("@/client/store/allPersistentStreamsStore");
var _encoderWSSStore = require("@/client/store/encoderWSSStore");
var _clientsStore = require("@/client/store/clientsStore");
var _table = require("@/client/components/ui/table");
var _input = require("@/client/components/ui/input");
var _switch = require("@/client/components/ui/switch");
var _label = require("@/client/components/ui/label");
var _button = require("@/client/components/ui/button");
var _cacheTimestamp = require("@/client/components/cache-timestamp");
var _lucideReact = require("lucide-react");
var _config = require("@/client/config");
var _format = require("@/client/lib/format");
var _csv = require("@/client/lib/csv");
var _searchParams = require("@/client/lib/searchParams");
var _usePersistedSearch = require("@/client/hooks/usePersistedSearch");
var _resetFiltersButton = require("@/client/components/reset-filters-button");
var _tableUtils = require("@/client/components/table-utils");
var _cells = require("@/client/components/tables/cells");
/** Get stream info, preferring WSS data over DB data */ function getStreamInfo(stream) {
    // WSS provides raw streamInfo with real_frame_rate, DB provides pre-parsed EncoderStreamInfo
    if (stream.wss?.streamInfo) return {
        width: stream.wss.streamInfo.width,
        height: stream.wss.streamInfo.height,
        bitrate: stream.wss.streamInfo.bitrate,
        frameRate: stream.wss.streamInfo.real_frame_rate,
        aspectRatio: stream.wss.streamInfo.displayAspectRatio,
        hasCaptions: stream.wss.streamInfo.inputHasCaptions
    };
    return stream.streamInfo ?? null;
}
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'persistent-streams',
    validateSearch: (search)=>({
            clientID: (0, _searchParams.parseString)(search.clientID),
            search: (0, _searchParams.parseString)(search.search),
            onlineOnly: (0, _searchParams.parseBoolean)(search.onlineOnly, true)
        }),
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: PersistentStreamsComponent
});
const columnHelper = (0, _reactTable.createColumnHelper)();
const columns = [
    columnHelper.accessor('clientName', {
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Client"
            }),
        cell: (info)=>{
            const clientName = info.getValue();
            if (!clientName) return '-';
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.ClientNameCell), {
                clientID: info.row.original.clientID,
                clientName: clientName
            });
        }
    }),
    columnHelper.accessor('title', {
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Title"
            }),
        cell: (info)=>info.getValue() || info.row.original.encoderID
    }),
    columnHelper.display({
        id: 'liveStatus',
        header: 'Status',
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.LiveStatus), {
                wss: row.original.wss,
                dbStatus: row.original.status
            })
    }),
    columnHelper.display({
        id: 'resolution',
        header: 'Resolution',
        cell: ({ row })=>{
            const streamInfo = getStreamInfo(row.original);
            if (!streamInfo?.width || !streamInfo?.height) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-muted-foreground",
                children: "-"
            });
            return (0, _format.formatResolution)(streamInfo.width, streamInfo.height);
        }
    }),
    columnHelper.display({
        id: 'bitrate',
        header: 'Bitrate',
        cell: ({ row })=>{
            const streamInfo = getStreamInfo(row.original);
            if (!streamInfo?.bitrate) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-muted-foreground",
                children: "-"
            });
            return (0, _format.formatBitrate)(streamInfo.bitrate);
        }
    }),
    columnHelper.display({
        id: 'frameRate',
        header: 'FPS',
        cell: ({ row })=>{
            const streamInfo = getStreamInfo(row.original);
            if (!streamInfo?.frameRate) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-muted-foreground",
                children: "-"
            });
            return (0, _format.formatFrameRate)(streamInfo.frameRate);
        }
    }),
    columnHelper.accessor('LiveStreamURI', {
        header: 'Live Stream URI',
        cell: (info)=>{
            const value = info.getValue();
            return value ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-mono text-xs",
                children: value
            }) : '-';
        },
        enableSorting: false
    }),
    columnHelper.accessor('lastCommunication', {
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Last Comm"
            }),
        cell: (info)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.LastCommunication), {
                lastCommunication: info.getValue()
            })
    })
];
function PersistentStreamsComponent() {
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    const navigate = (0, _reactRouter.useNavigate)();
    const { clientID, search: searchFilter = '', onlineOnly: showOnlineOnly = true } = (0, _reactRouter.useSearch)({
        from: '/persistent-streams'
    });
    // Persist search params across navigation
    (0, _usePersistedSearch.usePersistedSearch)('/persistent-streams', {
        clientID: undefined,
        search: undefined,
        onlineOnly: true
    });
    const { streams, loading, error, cacheInfo, fetchStreams, invalidateCache } = (0, _allPersistentStreamsStore.useAllPersistentStreamsStore)();
    const wssEncoders = (0, _encoderWSSStore.useEncoderWSSStore)((state)=>state.encoders);
    const { clients, fetchClients } = (0, _clientsStore.useClientsStore)();
    const [sorting, setSorting] = (0, _react.useState)([
        {
            id: 'clientName',
            desc: false
        }
    ]);
    // Update URL when search filter changes
    const setSearchFilter = (value)=>{
        navigate({
            to: '/persistent-streams',
            search: (0, _searchParams.buildSearchParams)({
                clientID,
                search: value || undefined,
                onlineOnly: showOnlineOnly ? undefined : false
            })
        });
    };
    // Update URL when online-only toggle changes
    const setShowOnlineOnly = (value)=>{
        navigate({
            to: '/persistent-streams',
            search: (0, _searchParams.buildSearchParams)({
                clientID,
                search: searchFilter || undefined,
                onlineOnly: value ? undefined : false
            })
        });
    };
    // Get client name for the filter badge
    const filteredClient = clientID ? clients.find((c)=>c.clientID === clientID) : null;
    (0, _react.useEffect)(()=>{
        const loadData = async ()=>{
            try {
                const token = await getAccessTokenSilently();
                await Promise.all([
                    fetchStreams(token, logout),
                    clients.length === 0 ? fetchClients(token, logout) : Promise.resolve()
                ]);
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };
        loadData();
    }, [
        getAccessTokenSilently,
        fetchStreams,
        fetchClients,
        clients.length
    ]);
    // Merge static stream data with real-time WSS data
    const filteredStreams = (0, _react.useMemo)(()=>{
        // Merge WSS data with streams
        let merged = streams.map((stream)=>({
                ...stream,
                wss: wssEncoders.get(stream.encoderID) || null
            }));
        // Filter by clientID if provided
        if (clientID) merged = merged.filter((stream)=>stream.clientID === clientID);
        // Filter by online status (check both WSS data and DB status)
        if (showOnlineOnly) merged = merged.filter((stream)=>{
            // If we have WSS data, use it
            if (stream.wss) return stream.wss.online;
            // Fall back to DB status (1 = online)
            return stream.status === 1;
        });
        // Filter by search text
        if (searchFilter) {
            const search = searchFilter.toLowerCase();
            merged = merged.filter((stream)=>(stream.title?.toLowerCase() || '').includes(search) || stream.clientName.toLowerCase().includes(search) || stream.encoderID.toLowerCase().includes(search));
        }
        return merged;
    }, [
        streams,
        wssEncoders,
        clientID,
        searchFilter,
        showOnlineOnly
    ]);
    const table = (0, _reactTable.useReactTable)({
        data: filteredStreams,
        columns,
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        onSortingChange: setSorting,
        getSortedRowModel: (0, _reactTable.getSortedRowModel)(),
        state: {
            sorting
        }
    });
    const handleRefresh = async ()=>{
        try {
            const token = await getAccessTokenSilently();
            await fetch(`${(0, _config.API_BASE_URL)}/api/cache/invalidate`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    key: 'persistent-streams:all'
                })
            });
            invalidateCache();
            await fetchStreams(token, logout, true);
        } catch (err) {
            console.error('Error refreshing persistent streams:', err);
        }
    };
    const handleExportCSV = ()=>{
        const headers = [
            'Client',
            'Title',
            'Encoder ID',
            'Status',
            'Resolution',
            'Bitrate',
            'FPS',
            'Live Stream URI',
            'Last Communication'
        ];
        const rows = filteredStreams.map((stream)=>{
            const streamInfo = getStreamInfo(stream);
            const status = stream.wss ? stream.wss.online ? 'Online' : 'Offline' : stream.status === 1 ? 'Online' : stream.status === 0 ? 'Offline' : stream.status === 2 ? 'Streaming' : '-';
            const resolution = streamInfo?.width && streamInfo?.height ? (0, _format.formatResolution)(streamInfo.width, streamInfo.height) : '-';
            const bitrate = streamInfo?.bitrate ? (0, _format.formatBitrate)(streamInfo.bitrate) : '-';
            const fps = streamInfo?.frameRate ? (0, _format.formatFrameRate)(streamInfo.frameRate) : '-';
            return [
                stream.clientName,
                stream.title || stream.encoderID,
                stream.encoderID,
                status,
                resolution,
                bitrate,
                fps,
                stream.LiveStreamURI || '-',
                stream.lastCommunication ? new Date(stream.lastCommunication).toLocaleString() : '-'
            ];
        });
        const date = new Date().toISOString().split('T')[0];
        (0, _csv.downloadCSV)(`persistent_streams_${date}.csv`, headers, rows);
    };
    const clearClientFilter = ()=>{
        navigate({
            to: '/persistent-streams',
            search: (0, _searchParams.buildSearchParams)({
                search: searchFilter || undefined,
                onlineOnly: showOnlineOnly ? undefined : false
            })
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex justify-between items-center mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "text-2xl font-semibold",
                                        children: "Persistent Streams"
                                    }),
                                    filteredClient && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-1 px-3 py-1 bg-muted rounded-full text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: filteredClient.name
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: clearClientFilter,
                                                className: "ml-1 hover:bg-accent rounded-full p-0.5",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.X), {
                                                    className: "h-3 w-3"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cacheTimestamp.CacheTimestamp), {
                                cachedAt: cacheInfo?.cachedAt ?? null
                            })
                        ]
                    }),
                    loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Loading persistent streams..."
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-4 bg-red-100 border-l-4 border-red-600 rounded mt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "m-0 text-red-800 font-medium",
                            children: [
                                "Error: ",
                                error
                            ]
                        })
                    }),
                    !loading && !error && streams.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "No persistent streams found."
                    }),
                    !loading && !error && streams.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex justify-end items-center gap-4 mb-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switch.Switch), {
                                                id: "online-only",
                                                checked: showOnlineOnly,
                                                onCheckedChange: setShowOnlineOnly
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                                htmlFor: "online-only",
                                                className: "cursor-pointer",
                                                children: "Online Only"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                        placeholder: "Filter by title, client, or encoder ID...",
                                        value: searchFilter,
                                        onChange: (e)=>setSearchFilter(e.target.value),
                                        className: "w-80"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                        variant: "outline",
                                        onClick: handleExportCSV,
                                        disabled: filteredStreams.length === 0,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                                className: "h-4 w-4 mr-2"
                                            }),
                                            "Export CSV"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                        variant: "outline",
                                        onClick: handleRefresh,
                                        disabled: loading,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                                className: `h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`
                                            }),
                                            "Force Refresh"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetFiltersButton.ResetFiltersButton), {
                                        routePath: "/persistent-streams",
                                        defaultValues: {
                                            search: undefined,
                                            onlineOnly: true
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "rounded-md border",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                            children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: header.isPlaceholder ? null : (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())
                                                        }, header.id))
                                                }, headerGroup.id))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                            children: table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    onClick: ()=>navigate({
                                                            to: `/encoders/${row.original.encoderID}`
                                                        }),
                                                    className: "cursor-pointer hover:bg-accent",
                                                    children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                            children: (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                                        }, cell.id))
                                                }, row.id))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "mt-2 text-sm text-muted-foreground",
                                children: [
                                    "Showing ",
                                    filteredStreams.length,
                                    " of ",
                                    streams.length,
                                    " persistent streams"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useNavigate","aMhxM"],["useSearch","4yVFL"]],"@auth0/auth0-react":"gpXrE","@tanstack/react-table":[["createColumnHelper","3MlnA"],["getCoreRowModel","3MlnA"],["getSortedRowModel","3MlnA"],["flexRender","brwh1"],["useReactTable","brwh1"]],"./__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/store/allPersistentStreamsStore":"bMJjY","@/client/store/encoderWSSStore":"jpzNm","@/client/store/clientsStore":"6bg3l","@/client/components/ui/table":"5vxZ8","@/client/components/ui/input":"8UHwi","@/client/components/ui/switch":"1p4xh","@/client/components/ui/label":"cLMZq","@/client/components/ui/button":"armlb","@/client/components/cache-timestamp":"f5Zyx","lucide-react":[["Download","eRiW1","default"],["RefreshCw","7a8jT","default"],["X","8HSxK","default"]],"@/client/config":"8SWgh","@/client/lib/format":"iLptT","@/client/lib/csv":"2NpE4","@/client/lib/searchParams":"fgK0T","@/client/hooks/usePersistedSearch":"kPA60","@/client/components/reset-filters-button":"9d8BP","@/client/components/table-utils":"lB8sT","@/client/components/tables/cells":"5BSEg","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eRiW1":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Download);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 15V3",
            key: "m9g1x1"
        }
    ],
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ],
    [
        "path",
        {
            d: "m7 10 5 5 5-5",
            key: "brsn70"
        }
    ]
];
const Download = (0, _createLucideIconJsDefault.default)("download", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2NpE4":[function(require,module,exports,__globalThis) {
/**
 * CSV export utilities
 */ /**
 * Download data as a CSV file
 * @param filename - The name of the file to download (should end in .csv)
 * @param headers - Array of column header strings
 * @param rows - 2D array of row data (each inner array is a row)
 * @param meta - Optional preamble rows (e.g. applied filters) written above the
 *   header, followed by a blank separator line. Each inner array is one row.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "downloadCSV", ()=>downloadCSV);
function downloadCSV(filename, headers, rows, meta) {
    const escape = (cell)=>`"${cell.replace(/"/g, '""')}"`;
    const lines = [];
    if (meta && meta.length > 0) {
        for (const row of meta)lines.push(row.map(escape).join(','));
        lines.push(''); // blank line separating metadata from the data table
    }
    lines.push(headers.join(','));
    for (const row of rows)lines.push(row.map(escape).join(','));
    const csvContent = lines.join('\n');
    const blob = new Blob([
        csvContent
    ], {
        type: 'text/csv;charset=utf-8;'
    });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1VQqb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _root = require("../../__root");
var _liveStreamsStore = require("../../../store/liveStreamsStore");
var _clientsStore = require("../../../store/clientsStore");
var _layout = require("@/client/layouts/layout");
var _format = require("@/client/lib/format");
var _reactTable = require("@tanstack/react-table");
var _liveStreamsColumns = require("@/client/components/tables/live-streams-columns");
var _useViewerCounts = require("@/client/hooks/useViewerCounts");
var _table = require("@/client/components/ui/table");
var _button = require("@/client/components/ui/button");
var _input = require("@/client/components/ui/input");
var _lucideReact = require("lucide-react");
// Transform WebSocket event data to table row format
function wsEventToTableRow(event, clientNameMap, clientTimeZoneMap) {
    return {
        // Core identifiers
        clientID: event.clientID,
        clientName: clientNameMap.get(event.clientID) || null,
        clientTimeZone: clientTimeZoneMap.get(event.clientID) || null,
        eventID: event.eventID,
        eventTitle: event.title,
        liveID: event.liveStats?.liveID || null,
        status: event.eventStatus,
        streamStatus: event.liveStats?.status || null,
        // Schedule
        eventStartDateTime: event.startDateTime,
        eventEndDateTime: null,
        startDateTime: event.liveStats?.startDate || null,
        endDateTime: null,
        autoStart: event.autoStart,
        autoStop: event.autoStop,
        preroll: event.preroll,
        // Encoder & Infrastructure
        encoderID: event.assignedEncoder,
        ingInstanceID: null,
        egInstanceID: null,
        wcStreamID: null,
        // URIs
        streamingURIs: event.streamingURIs ? {
            main: event.streamingURIs.main || null,
            backup: event.streamingURIs.backup || null
        } : null,
        // Metadata
        customID: event.customID,
        description: event.description,
        notes: event.notes,
        private: event.private,
        liveToBreak: event.liveToBreak,
        // Live stats
        liveStats: event.liveStats ? {
            runtime: event.liveStats.runtime,
            status: event.liveStats.status
        } : null
    };
}
// Transform API response to table row format
function apiEventToTableRow(event) {
    return {
        // Core identifiers
        clientID: event.clientID,
        clientName: event.clientName,
        clientTimeZone: event.clientTimeZone,
        eventID: event.eventID,
        eventTitle: event.eventTitle,
        liveID: event.liveID,
        status: event.status,
        streamStatus: event.streamStatus,
        // Schedule
        eventStartDateTime: event.eventStartDateTime,
        eventEndDateTime: event.eventEndDateTime,
        startDateTime: event.startDateTime,
        endDateTime: event.endDateTime,
        autoStart: event.autoStart,
        autoStop: event.autoStop,
        preroll: event.preroll,
        // Encoder & Infrastructure
        encoderID: event.encoderID,
        ingInstanceID: event.ingInstanceID,
        egInstanceID: event.egInstanceID,
        wcStreamID: event.wcStreamID,
        // URIs - generated from clientID/eventID pattern
        streamingURIs: (0, _format.generateStreamingURIs)(event.clientID, event.eventID),
        // Metadata
        customID: event.customID,
        description: event.description,
        notes: event.notes,
        private: event.private,
        liveToBreak: event.liveToBreak,
        // Live stats - not available from API
        liveStats: null
    };
}
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'events/live-streams',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: LiveStreamsComponent
});
function LiveStreamsComponent() {
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    // Select each field individually to ensure reactivity
    const liveEvents = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.liveEvents);
    const completedEvents = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.completedEvents);
    const liveStreams = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.liveStreams); // Legacy API data
    const loading = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.loading);
    const error = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.error);
    const fetchLiveStreams = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.fetchLiveStreams);
    const eventMap = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.eventMap);
    // Get all clients for name lookup
    const clients = (0, _clientsStore.useClientsStore)((state)=>state.clients);
    const navigate = (0, _reactRouter.useNavigate)();
    // Navigate to stream detail, normalizing eventID to clientID_eventID format
    const navigateToStream = (stream)=>{
        const eventID = stream.eventID;
        const streamId = eventID.includes('_') ? eventID : `${stream.clientID}_${eventID}`;
        navigate({
            to: '/events/$eventId',
            params: {
                eventId: streamId
            }
        });
    };
    const [sorting, setSorting] = (0, _react.useState)([]);
    const [searchFilter, setSearchFilter] = (0, _react.useState)('');
    const [refreshCooldown, setRefreshCooldown] = (0, _react.useState)(false);
    // Merge WebSocket and API data intelligently
    // WebSocket data takes precedence; only show API events that haven't been updated via WebSocket yet
    const displayData = (0, _react.useMemo)(()=>{
        if (liveEvents.length === 0 && completedEvents.length === 0) // No WebSocket data yet, use API data
        return liveStreams;
        // Build set of all WebSocket-tracked event IDs
        // Use eventMap (persists even after clearing completedEvents) to track known events
        const wsLiveEventIDs = new Set(liveEvents.map((e)=>e.eventID));
        const allWsEventIDs = new Set([
            ...wsLiveEventIDs,
            ...eventMap.keys()
        ]);
        // Start with all WebSocket LIVE events only (not completed)
        const merged = [
            ...liveEvents
        ];
        // Add API events ONLY if we haven't received ANY WebSocket update for them
        // (including completed events - we don't want to show those in the live list)
        // NOTE: API returns eventID as "clientID_eventID", WebSocket returns just "eventID"
        // We need to extract and compare the eventID part only
        for (const apiEvent of liveStreams){
            // Extract just the eventID part (after the underscore) from API data
            const apiEventIDPart = apiEvent.eventID?.includes('_') ? apiEvent.eventID.split('_')[1] : apiEvent.eventID;
            const isTrackedByWebSocket = allWsEventIDs.has(apiEventIDPart || '');
            if (apiEvent.eventID && !isTrackedByWebSocket) merged.push(apiEvent);
        }
        return merged;
    }, [
        liveEvents,
        completedEvents,
        liveStreams,
        eventMap
    ]);
    const loadLiveStreams = async ()=>{
        try {
            const token = await getAccessTokenSilently();
            await fetchLiveStreams(token, logout);
        } catch (err) {
            console.error('Error fetching live streams:', err);
        }
    };
    const handleRefresh = async ()=>{
        setRefreshCooldown(true);
        await loadLiveStreams();
        setTimeout(()=>setRefreshCooldown(false), 5000);
    };
    (0, _react.useEffect)(()=>{
        loadLiveStreams();
    }, [
        getAccessTokenSilently
    ]);
    // Build client name lookup map (used by multiple transforms)
    const clientNameMap = (0, _react.useMemo)(()=>{
        const map = new Map();
        for (const client of clients)if (client.clientID && client.name) map.set(client.clientID, client.name);
        return map;
    }, [
        clients
    ]);
    // Build client timezone lookup map
    const clientTimeZoneMap = (0, _react.useMemo)(()=>{
        const map = new Map();
        for (const client of clients)if (client.clientID) map.set(client.clientID, client.timeZone);
        return map;
    }, [
        clients
    ]);
    // Transform events to match table structure
    // Works with both WebSocket events and API LiveStream objects
    const transformedEvents = (0, _react.useMemo)(()=>{
        return displayData.map((event)=>{
            // Check if this is WebSocket data (has 'title' and 'eventStatus')
            // or API data (has 'eventTitle' and 'status')
            if ('title' in event || 'eventStatus' in event) return wsEventToTableRow(event, clientNameMap, clientTimeZoneMap);
            else return apiEventToTableRow(event);
        });
    }, [
        displayData,
        clientNameMap,
        clientTimeZoneMap
    ]);
    const filteredLiveEvents = (0, _react.useMemo)(()=>{
        if (!searchFilter) return transformedEvents;
        return transformedEvents.filter((event)=>event.eventTitle?.toLowerCase().includes(searchFilter.toLowerCase()) || event.clientID?.toLowerCase().includes(searchFilter.toLowerCase()));
    }, [
        transformedEvents,
        searchFilter
    ]);
    // Transform completed events to table row format
    const transformedCompletedEvents = (0, _react.useMemo)(()=>{
        return completedEvents.map((event)=>wsEventToTableRow(event, clientNameMap, clientTimeZoneMap));
    }, [
        completedEvents,
        clientNameMap,
        clientTimeZoneMap
    ]);
    // Fetch viewer counts for all displayed live events
    const { viewerCounts, totalViewers, loading: viewerCountsLoading, available: viewerCountsAvailable, lastUpdated: viewerCountsLastUpdated } = (0, _useViewerCounts.useViewerCounts)(filteredLiveEvents, {
        enablePolling: true
    });
    // Create columns with viewer counts data
    const columns = (0, _react.useMemo)(()=>(0, _liveStreamsColumns.createLiveStreamsColumns)(viewerCounts, viewerCountsLoading, viewerCountsAvailable), [
        viewerCounts,
        viewerCountsLoading,
        viewerCountsAvailable
    ]);
    const table = (0, _reactTable.useReactTable)({
        data: filteredLiveEvents,
        columns,
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        onSortingChange: setSorting,
        getSortedRowModel: (0, _reactTable.getSortedRowModel)(),
        state: {
            sorting
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex justify-between items-center mb-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            className: "text-2xl font-semibold",
                                            children: "Live Streams"
                                        }),
                                        viewerCountsAvailable && totalViewers > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100",
                                            children: [
                                                totalViewers.toLocaleString(),
                                                " total viewers"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "font-mono text-sm text-muted-foreground",
                                    children: "Live data"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex justify-end items-center gap-4 mb-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                    placeholder: "Filter by Event name...",
                                    value: searchFilter,
                                    onChange: (e)=>setSearchFilter(e.target.value),
                                    className: "max-w-xs"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                    variant: "outline",
                                    size: "sm",
                                    onClick: handleRefresh,
                                    disabled: loading || refreshCooldown,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                            className: `h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`
                                        }),
                                        "Force Refresh"
                                    ]
                                })
                            ]
                        }),
                        loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Loading live streams..."
                        }),
                        error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "p-4 bg-red-100 border-l-4 border-red-600 rounded mt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "m-0 text-red-800 font-medium",
                                children: [
                                    "Error: ",
                                    error
                                ]
                            })
                        }),
                        !loading && !error && displayData.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "No live events found."
                        }),
                        !loading && !error && displayData.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rounded-md border overflow-x-auto",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                        children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                        children: header.isPlaceholder ? null : (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())
                                                    }, header.id))
                                            }, headerGroup.id))
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                        children: table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                className: "cursor-pointer hover:bg-muted transition-colors",
                                                onClick: ()=>navigateToStream(row.original),
                                                children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        children: (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                                    }, cell.id))
                                            }, row.id))
                                    })
                                ]
                            })
                        })
                    ]
                }),
                transformedCompletedEvents.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    className: "mt-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "text-xl font-semibold",
                                    children: "Completed Streams"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-sm text-muted-foreground mt-1",
                                    children: "Events that recently finished streaming. These can go live again."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rounded-md border",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    className: "text-xs",
                                                    children: "Client"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    className: "text-xs",
                                                    children: "Event Title"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    className: "text-xs",
                                                    children: "Started At"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    className: "text-xs",
                                                    children: "Status"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                        children: transformedCompletedEvents.map((event)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                className: "cursor-pointer hover:bg-muted transition-colors",
                                                onClick: ()=>navigateToStream(event),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "text-xs",
                                                        children: event.clientName || '-'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "text-xs max-w-[300px] truncate",
                                                        children: event.eventTitle || '-'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "font-mono text-xs",
                                                        children: event.startDateTime ? new Date(event.startDateTime).toLocaleString() : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _liveStreamsColumns.StatusBadge), {
                                                            status: event.status
                                                        })
                                                    })
                                                ]
                                            }, event.eventID))
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useNavigate","aMhxM"]],"@auth0/auth0-react":"gpXrE","../../__root":"enXay","../../../store/liveStreamsStore":"7F9wp","../../../store/clientsStore":"6bg3l","@/client/layouts/layout":"d6QdD","@/client/lib/format":"iLptT","@tanstack/react-table":[["flexRender","brwh1"],["useReactTable","brwh1"],["getCoreRowModel","3MlnA"],["getSortedRowModel","3MlnA"]],"@/client/components/tables/live-streams-columns":"ba3MU","@/client/hooks/useViewerCounts":"l97JY","@/client/components/ui/table":"5vxZ8","@/client/components/ui/button":"armlb","@/client/components/ui/input":"8UHwi","lucide-react":[["RefreshCw","7a8jT","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ba3MU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Helper function to render status badge with color coding
parcelHelpers.export(exports, "StatusBadge", ()=>StatusBadge);
// Viewer count badge component
parcelHelpers.export(exports, "ViewerCountBadge", ()=>ViewerCountBadge);
/**
 * Create live streams columns with viewer counts
 */ parcelHelpers.export(exports, "createLiveStreamsColumns", ()=>createLiveStreamsColumns);
parcelHelpers.export(exports, "liveStreamsColumns", ()=>liveStreamsColumns);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _button = require("@/client/components/ui/button");
var _cells = require("./cells");
var _date = require("@/client/lib/date");
function StatusBadge({ status }) {
    if (!status) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: "-"
    });
    const normalizedStatus = status.toLowerCase();
    let bgColor = 'bg-gray-100';
    let textColor = 'text-gray-800';
    if (normalizedStatus === 'live') {
        bgColor = 'bg-red-600';
        textColor = 'text-white';
    } else if (normalizedStatus === 'on break') {
        bgColor = 'bg-yellow-500';
        textColor = 'text-white';
    } else if (normalizedStatus === 'starting' || normalizedStatus === 'stopping') {
        bgColor = 'bg-blue-600';
        textColor = 'text-white';
    } else if (normalizedStatus === 'disconnected') {
        bgColor = 'bg-orange-500';
        textColor = 'text-white';
    } else if (normalizedStatus === 'available') {
        bgColor = 'bg-gray-600';
        textColor = 'text-white';
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: `inline-flex items-center px-2 py-0.5 rounded-full text-xs font-mono font-medium ${bgColor} ${textColor}`,
        children: status
    });
}
function ViewerCountBadge({ count, loading, available }) {
    if (!available) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-xs text-muted-foreground",
        children: "-"
    });
    if (loading && count === undefined) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "inline-flex items-center gap-1 text-xs text-muted-foreground",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "animate-pulse",
            children: "..."
        })
    });
    if (count === undefined || count === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-xs text-muted-foreground",
        children: "0"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-mono font-medium bg-green-600 text-white",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Users), {
                className: "h-3 w-3"
            }),
            count.toLocaleString()
        ]
    });
}
function createLiveStreamsColumns(viewerCounts, viewerCountsLoading, viewerCountsAvailable) {
    return [
        {
            accessorKey: 'clientName',
            header: ({ column })=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                    variant: "ghost",
                    size: "sm",
                    className: "h-8 px-2",
                    onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                    children: [
                        "Client",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                            className: "ml-1 h-3 w-3"
                        })
                    ]
                });
            },
            cell: ({ row })=>{
                const { clientID, clientName } = row.original;
                if (!clientName || !clientID) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-xs text-muted-foreground",
                    children: "-"
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.ClientNameCell), {
                    clientID: clientID,
                    clientName: clientName
                });
            }
        },
        {
            accessorKey: 'eventTitle',
            header: ({ column })=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                    variant: "ghost",
                    size: "sm",
                    className: "h-8 px-2",
                    onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                    children: [
                        "Event Title",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                            className: "ml-1 h-3 w-3"
                        })
                    ]
                });
            },
            cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EventTitleCell), {
                    title: row.getValue('eventTitle')
                })
        },
        {
            accessorKey: 'eventID',
            size: 80,
            header: ({ column })=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                    variant: "ghost",
                    size: "sm",
                    className: "h-8 px-2",
                    onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                    children: [
                        "Event ID",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                            className: "ml-1 h-3 w-3"
                        })
                    ]
                });
            },
            cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EventIDCell), {
                    eventID: row.getValue('eventID')
                })
        },
        {
            accessorKey: 'encoderID',
            size: 80,
            header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-xs font-medium",
                    children: "Encoder"
                }),
            cell: ({ row })=>{
                const encoderID = row.original.encoderID;
                if (!encoderID) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-xs text-muted-foreground",
                    children: "-"
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EncoderIDCell), {
                    encoderID: encoderID
                });
            }
        },
        {
            id: 'viewers',
            header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-xs font-medium",
                    children: "Viewers"
                }),
            cell: ({ row })=>{
                const eventID = row.original.eventID;
                // Handle both "clientID_eventID" and plain "eventID" formats
                const eventIDPart = eventID?.includes('_') ? eventID.split('_')[1] : eventID;
                const count = eventIDPart ? viewerCounts[eventIDPart]?.activePlayers : undefined;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ViewerCountBadge, {
                    count: count,
                    loading: viewerCountsLoading,
                    available: viewerCountsAvailable
                });
            }
        },
        {
            accessorKey: 'startDateTime',
            size: 200,
            header: ({ column })=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                    variant: "ghost",
                    size: "sm",
                    className: "h-8 px-2",
                    onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                    children: [
                        "Started At",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                            className: "ml-1 h-3 w-3"
                        })
                    ]
                });
            },
            cell: ({ row })=>{
                const dateStr = row.getValue('startDateTime');
                const clientTimeZone = row.original.clientTimeZone;
                if (!dateStr) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-xs text-muted-foreground",
                    children: "-"
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "font-mono text-xs whitespace-nowrap",
                    children: (0, _date.formatDateTimeWithClientTZ)(dateStr, clientTimeZone)
                });
            }
        },
        {
            accessorKey: 'status',
            size: 80,
            header: ({ column })=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                    variant: "ghost",
                    size: "sm",
                    className: "h-8 px-2",
                    onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                    children: [
                        "Status",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                            className: "ml-1 h-3 w-3"
                        })
                    ]
                });
            },
            cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusBadge, {
                    status: row.getValue('status')
                })
        },
        {
            id: 'eventLinks',
            header: 'Links',
            cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EventLinksCell), {
                    eventID: row.original.eventID,
                    clientID: row.original.clientID,
                    clientName: row.original.clientName ?? undefined
                }),
            size: 70,
            enableSorting: false
        }
    ];
}
const liveStreamsColumns = [
    {
        accessorKey: 'clientName',
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                size: "sm",
                className: "h-8 px-2",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Client",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-1 h-3 w-3"
                    })
                ]
            });
        },
        cell: ({ row })=>{
            const { clientID, clientName } = row.original;
            if (!clientName || !clientID) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-xs text-muted-foreground",
                children: "-"
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.ClientNameCell), {
                clientID: clientID,
                clientName: clientName
            });
        }
    },
    {
        accessorKey: 'eventTitle',
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                size: "sm",
                className: "h-8 px-2",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Event Title",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-1 h-3 w-3"
                    })
                ]
            });
        },
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EventTitleCell), {
                title: row.getValue('eventTitle')
            })
    },
    {
        accessorKey: 'eventID',
        size: 80,
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                size: "sm",
                className: "h-8 px-2",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Event ID",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-1 h-3 w-3"
                    })
                ]
            });
        },
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EventIDCell), {
                eventID: row.getValue('eventID')
            })
    },
    {
        accessorKey: 'encoderID',
        size: 80,
        header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-xs font-medium",
                children: "Encoder"
            }),
        cell: ({ row })=>{
            const encoderID = row.original.encoderID;
            if (!encoderID) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-xs text-muted-foreground",
                children: "-"
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EncoderIDCell), {
                encoderID: encoderID
            });
        }
    },
    {
        accessorKey: 'startDateTime',
        size: 200,
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                size: "sm",
                className: "h-8 px-2",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Started At",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-1 h-3 w-3"
                    })
                ]
            });
        },
        cell: ({ row })=>{
            const dateStr = row.getValue('startDateTime');
            const clientTimeZone = row.original.clientTimeZone;
            if (!dateStr) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-xs text-muted-foreground",
                children: "-"
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-mono text-xs whitespace-nowrap",
                children: (0, _date.formatDateTimeWithClientTZ)(dateStr, clientTimeZone)
            });
        }
    },
    {
        accessorKey: 'status',
        size: 80,
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                size: "sm",
                className: "h-8 px-2",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Status",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-1 h-3 w-3"
                    })
                ]
            });
        },
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusBadge, {
                status: row.getValue('status')
            })
    },
    {
        id: 'eventLinks',
        header: 'Links',
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EventLinksCell), {
                eventID: row.original.eventID,
                clientID: row.original.clientID,
                clientName: row.original.clientName ?? undefined
            }),
        size: 70,
        enableSorting: false
    }
];

},{"react/jsx-runtime":"dQjte","lucide-react":[["ArrowUpDown","amX4k","default"],["Users","in3JI","default"]],"@/client/components/ui/button":"armlb","./cells":"5BSEg","@/client/lib/date":"7ZbER","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7ZbER":[function(require,module,exports,__globalThis) {
/**
 * Date utility functions using date-fns for consistency
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Get the full month name from a 1-indexed month number
 * @param month - Month number (1-12)
 */ parcelHelpers.export(exports, "getMonthName", ()=>getMonthName);
/**
 * Get the abbreviated month name from a 1-indexed month number
 * @param month - Month number (1-12)
 */ parcelHelpers.export(exports, "getShortMonthName", ()=>getShortMonthName);
/**
 * Format a date, including year only if it's not the current year
 * Uses abbreviated month names with period (Jan., Feb., etc.)
 */ parcelHelpers.export(exports, "formatDateWithConditionalYear", ()=>formatDateWithConditionalYear);
/**
 * Format a date range for display
 * Handles same-year optimization (omits year if both dates are in current year)
 */ parcelHelpers.export(exports, "formatDateRange", ()=>formatDateRange);
/**
 * Get the start of the current week (Monday)
 */ parcelHelpers.export(exports, "getWeekStart", ()=>getWeekStart);
/**
 * Get the end of the current week (Sunday)
 */ parcelHelpers.export(exports, "getWeekEnd", ()=>getWeekEnd);
/**
 * Get week boundaries for a given date
 */ parcelHelpers.export(exports, "getWeekBounds", ()=>getWeekBounds);
/**
 * Get month boundaries for a given date
 */ parcelHelpers.export(exports, "getMonthBounds", ()=>getMonthBounds);
/**
 * Get date range for "tomorrow"
 */ parcelHelpers.export(exports, "getTomorrow", ()=>getTomorrow);
/**
 * Get date range for "next week"
 */ parcelHelpers.export(exports, "getNextWeekBounds", ()=>getNextWeekBounds);
/**
 * Get date range for "next month"
 */ parcelHelpers.export(exports, "getNextMonthBounds", ()=>getNextMonthBounds);
/**
 * Get date range for "last month"
 */ parcelHelpers.export(exports, "getLastMonthBounds", ()=>getLastMonthBounds);
/**
 * Format a date as ISO date string (YYYY-MM-DD)
 */ parcelHelpers.export(exports, "toISODateString", ()=>toISODateString);
/**
 * Format a date for display with weekday
 * e.g., "Monday, Jan. 15" or "Monday, Jan. 15, 2024" if different year
 */ parcelHelpers.export(exports, "formatDateWithWeekday", ()=>formatDateWithWeekday);
/**
 * Format duration in minutes to human-readable format
 * e.g., 90 -> "1h 30m", 45 -> "45m"
 */ parcelHelpers.export(exports, "formatDuration", ()=>formatDuration);
/**
 * Format a date/time showing client timezone with abbreviation and user's local time
 * Format: "Jan 12, 8:32 AM MST (10:32 AM)"
 *
 * @param date - Date string or Date object (in UTC/ISO format)
 * @param clientTimeZone - Client's IANA timezone (e.g., "America/New_York")
 * @returns Formatted string with client TZ and local time
 */ parcelHelpers.export(exports, "formatDateTimeWithClientTZ", ()=>formatDateTimeWithClientTZ);
var _dateFns = require("date-fns");
function getMonthName(month) {
    // Create a date in the given month (month is 0-indexed in Date constructor)
    const date = new Date(2000, month - 1, 1);
    return (0, _dateFns.format)(date, 'MMMM');
}
function getShortMonthName(month) {
    const date = new Date(2000, month - 1, 1);
    return (0, _dateFns.format)(date, 'MMM');
}
function formatDateWithConditionalYear(date, currentYear) {
    const year = currentYear ?? (0, _dateFns.getYear)(new Date());
    const month = (0, _dateFns.format)(date, 'MMM');
    const day = (0, _dateFns.getDate)(date);
    const dateYear = (0, _dateFns.getYear)(date);
    if (dateYear !== year) return `${month}. ${day}, ${dateYear}`;
    return `${month}. ${day}`;
}
function formatDateRange(start, end, currentYear) {
    const year = currentYear ?? (0, _dateFns.getYear)(new Date());
    return `${formatDateWithConditionalYear(start, year)} - ${formatDateWithConditionalYear(end, year)}`;
}
function getWeekStart(date) {
    return (0, _dateFns.startOfWeek)(date, {
        weekStartsOn: 1
    }); // Monday
}
function getWeekEnd(date) {
    return (0, _dateFns.endOfWeek)(date, {
        weekStartsOn: 1
    }); // Sunday
}
function getWeekBounds(date) {
    return {
        start: getWeekStart(date),
        end: getWeekEnd(date)
    };
}
function getMonthBounds(date) {
    return {
        start: (0, _dateFns.startOfMonth)(date),
        end: (0, _dateFns.endOfMonth)(date)
    };
}
function getTomorrow(from = new Date()) {
    return (0, _dateFns.addDays)(from, 1);
}
function getNextWeekBounds(from = new Date()) {
    const nextWeek = (0, _dateFns.addDays)(from, 7);
    return getWeekBounds(nextWeek);
}
function getNextMonthBounds(from = new Date()) {
    const nextMonth = (0, _dateFns.addMonths)(from, 1);
    return getMonthBounds(nextMonth);
}
function getLastMonthBounds(from = new Date()) {
    const lastMonth = (0, _dateFns.subMonths)(from, 1);
    return getMonthBounds(lastMonth);
}
function toISODateString(date) {
    return (0, _dateFns.format)(date, 'yyyy-MM-dd');
}
function formatDateWithWeekday(date, currentYear) {
    const year = currentYear ?? (0, _dateFns.getYear)(new Date());
    const weekday = (0, _dateFns.format)(date, 'EEEE');
    const month = (0, _dateFns.format)(date, 'MMM');
    const day = (0, _dateFns.getDate)(date);
    const dateYear = (0, _dateFns.getYear)(date);
    if (dateYear !== year) return `${weekday}, ${month}. ${day}, ${dateYear}`;
    return `${weekday}, ${month}. ${day}`;
}
function formatDuration(minutes) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours > 0) return `${hours}h ${mins}m`;
    return `${mins}m`;
}
/**
 * Get timezone abbreviation from a date and IANA timezone
 * e.g., "America/New_York" -> "EST" or "EDT"
 */ function getTimezoneAbbr(date, timeZone) {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone,
        timeZoneName: 'short'
    }).formatToParts(date);
    const tzPart = parts.find((p)=>p.type === 'timeZoneName');
    return tzPart?.value || timeZone;
}
function formatDateTimeWithClientTZ(date, clientTimeZone) {
    const d = typeof date === 'string' ? new Date(date) : date;
    // Default to Pacific if no timezone provided
    const tz = clientTimeZone || 'America/Los_Angeles';
    // Format in client's timezone
    const clientTime = d.toLocaleString('en-US', {
        timeZone: tz,
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });
    const tzAbbr = getTimezoneAbbr(d, tz);
    // Format user's local time (just time, no date since it's contextual)
    const localTime = d.toLocaleString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });
    // Check if local time is different from client time
    const clientTimeOnly = d.toLocaleString('en-US', {
        timeZone: tz,
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });
    // Only show local time if different from client time
    if (clientTimeOnly === localTime) return `${clientTime} ${tzAbbr}`;
    return `${clientTime} ${tzAbbr} (${localTime})`;
}

},{"date-fns":[["addDays","489Ts"],["addMonths","flPAZ"],["endOfMonth","jebKl"],["endOfWeek","bFF4j"],["format","4NYjc"],["getDate","4VSXU"],["getYear","cJSDO"],["startOfMonth","dWW3L"],["startOfWeek","96cNt"],["subMonths","5q4d5"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"489Ts":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addDays} function options.
 */ /**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 * @param options - An object with options
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ parcelHelpers.export(exports, "addDays", ()=>addDays);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function addDays(date, amount, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    if (isNaN(amount)) return (0, _constructFromJs.constructFrom)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
// Fallback for modularized imports:
exports.default = addDays;

},{"./constructFrom.js":"aMZJE","./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"flPAZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addMonths} function options.
 */ /**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 * @param options - The options object
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ parcelHelpers.export(exports, "addMonths", ()=>addMonths);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function addMonths(date, amount, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    if (isNaN(amount)) return (0, _constructFromJs.constructFrom)(options?.in || date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, _constructFromJs.constructFrom)(options?.in || date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
// Fallback for modularized imports:
exports.default = addMonths;

},{"./constructFrom.js":"aMZJE","./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bFF4j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfWeek", ()=>endOfWeek);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _toDateJs = require("./toDate.js");
function endOfWeek(date, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfWeek;

},{"./_lib/defaultOptions.js":"4407t","./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4VSXU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getDate} function options.
 */ /**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ parcelHelpers.export(exports, "getDate", ()=>getDate);
var _toDateJs = require("./toDate.js");
function getDate(date, options) {
    return (0, _toDateJs.toDate)(date, options?.in).getDate();
}
// Fallback for modularized imports:
exports.default = getDate;

},{"./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cJSDO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getYear} function options.
 */ /**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ parcelHelpers.export(exports, "getYear", ()=>getYear);
var _toDateJs = require("./toDate.js");
function getYear(date, options) {
    return (0, _toDateJs.toDate)(date, options?.in).getFullYear();
}
// Fallback for modularized imports:
exports.default = getYear;

},{"./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dWW3L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfMonth} function options.
 */ /**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date. The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments.
 * Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed,
 * or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfMonth", ()=>startOfMonth);
var _toDateJs = require("./toDate.js");
function startOfMonth(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfMonth;

},{"./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5q4d5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The subMonths function options.
 */ /**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 * @param options - An object with options
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "subMonths", ()=>subMonths);
var _addMonthsJs = require("./addMonths.js");
function subMonths(date, amount, options) {
    return (0, _addMonthsJs.addMonths)(date, -amount, options);
}
// Fallback for modularized imports:
exports.default = subMonths;

},{"./addMonths.js":"flPAZ","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"l97JY":[function(require,module,exports,__globalThis) {
/**
 * useViewerCounts Hook
 * Fetches and polls viewer counts for live streams from the PlayerStats API
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook to fetch and poll viewer counts for live streams
 */ parcelHelpers.export(exports, "useViewerCounts", ()=>useViewerCounts);
var _react = require("react");
var _auth0React = require("@auth0/auth0-react");
var _config = require("@/client/config");
// Default polling interval: 30 seconds
const DEFAULT_POLL_INTERVAL_MS = 30000;
/**
 * Group events by client ID for batch requests
 */ function groupEventsByClient(events) {
    const grouped = {};
    for (const event of events){
        if (!event.clientID || !event.eventID) continue;
        // Extract just the eventID part if it's in "clientID_eventID" format
        const eventIDPart = event.eventID.includes('_') ? event.eventID.split('_')[1] : event.eventID;
        if (!grouped[event.clientID]) grouped[event.clientID] = [];
        grouped[event.clientID].push(eventIDPart);
    }
    return grouped;
}
function useViewerCounts(events, options = {}) {
    const { pollInterval = DEFAULT_POLL_INTERVAL_MS, enablePolling = true } = options;
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    const [viewerCounts, setViewerCounts] = (0, _react.useState)({});
    const [totalViewers, setTotalViewers] = (0, _react.useState)(0);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    const [available, setAvailable] = (0, _react.useState)(true);
    const [lastUpdated, setLastUpdated] = (0, _react.useState)(null);
    // Track if component is mounted
    const mountedRef = (0, _react.useRef)(true);
    const pollTimeoutRef = (0, _react.useRef)(null);
    /**
   * Fetch viewer counts for a single client
   */ const fetchForClient = (0, _react.useCallback)(async (clientID, eventIDs, token)=>{
        try {
            const params = new URLSearchParams({
                clientID,
                eventIds: eventIDs.join(',')
            });
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/analytics/viewers?${params}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 503) // Service unavailable - not configured
            return null;
            if (response.status === 401) {
                logout({
                    logoutParams: {
                        returnTo: window.location.origin
                    }
                });
                return null;
            }
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return await response.json();
        } catch (err) {
            console.error(`Failed to fetch viewer counts for client ${clientID}:`, err);
            return null;
        }
    }, [
        logout
    ]);
    /**
   * Fetch all viewer counts (for all clients with live events)
   */ const fetchViewerCounts = (0, _react.useCallback)(async ()=>{
        // Skip if no events to fetch
        const eventsByClient = groupEventsByClient(events);
        const clientIDs = Object.keys(eventsByClient);
        if (clientIDs.length === 0) {
            setViewerCounts({});
            setTotalViewers(0);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const token = await getAccessTokenSilently();
            // Fetch viewer counts for each client in parallel
            const results = await Promise.all(clientIDs.map((clientID)=>fetchForClient(clientID, eventsByClient[clientID], token)));
            if (!mountedRef.current) return;
            // Check if service is available
            const allUnavailable = results.every((r)=>r === null);
            if (allUnavailable && results.length > 0) {
                setAvailable(false);
                setLoading(false);
                return;
            }
            // Merge all results
            const mergedCounts = {};
            let total = 0;
            for (const result of results){
                if (!result) continue;
                Object.assign(mergedCounts, result.byEvent);
                total += result.total;
            }
            setViewerCounts(mergedCounts);
            setTotalViewers(total);
            setAvailable(true);
            setLastUpdated(new Date());
        } catch (err) {
            if (!mountedRef.current) return;
            const message = err instanceof Error ? err.message : 'Unknown error';
            setError(message);
            console.error('Failed to fetch viewer counts:', err);
        } finally{
            if (mountedRef.current) setLoading(false);
        }
    }, [
        events,
        getAccessTokenSilently,
        fetchForClient
    ]);
    /**
   * Manual refresh function
   */ const refresh = (0, _react.useCallback)(async ()=>{
        await fetchViewerCounts();
    }, [
        fetchViewerCounts
    ]);
    // Initial fetch and polling setup
    (0, _react.useEffect)(()=>{
        mountedRef.current = true;
        // Initial fetch
        fetchViewerCounts();
        // Setup polling
        if (enablePolling && pollInterval > 0) {
            const poll = ()=>{
                pollTimeoutRef.current = setTimeout(()=>{
                    if (mountedRef.current) fetchViewerCounts().then(()=>{
                        if (mountedRef.current) poll();
                    });
                }, pollInterval);
            };
            poll();
        }
        return ()=>{
            mountedRef.current = false;
            if (pollTimeoutRef.current) clearTimeout(pollTimeoutRef.current);
        };
    }, [
        fetchViewerCounts,
        enablePolling,
        pollInterval
    ]);
    return {
        viewerCounts,
        totalViewers,
        loading,
        error,
        available,
        lastUpdated,
        refresh
    };
}

},{"react":"eGun2","@auth0/auth0-react":"gpXrE","@/client/config":"8SWgh","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9bvji":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _root = require("../../__root");
var _liveStreamsStore = require("@/client/store/liveStreamsStore");
var _clientsStore = require("@/client/store/clientsStore");
var _config = require("@/client/config");
var _format = require("@/client/lib/format");
var _streamDetailView = require("@/client/components/stream-detail-view");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'events/live-streams/$streamId',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: LiveStreamDetailComponent
});
function LiveStreamDetailComponent() {
    // streamId is in format: clientID_eventID
    const { streamId } = (0, _reactRouter.useParams)({
        from: '/events/live-streams/$streamId'
    });
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    // Parse clientID and eventID from streamId
    const [clientID, eventID] = (0, _react.useMemo)(()=>{
        const parts = streamId.split('_');
        if (parts.length >= 2) return [
            parts[0],
            parts.slice(1).join('_')
        ];
        return [
            null,
            streamId
        ];
    }, [
        streamId
    ]);
    // Store state
    const liveEvents = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.liveEvents);
    const completedEvents = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.completedEvents);
    const liveStreams = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.liveStreams);
    const loading = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.loading);
    const fetchLiveStreams = (0, _liveStreamsStore.useLiveStreamsStore)((state)=>state.fetchLiveStreams);
    // Client name and timezone lookup
    const clients = (0, _clientsStore.useClientsStore)((state)=>state.clients);
    const { clientName, clientTimeZone } = (0, _react.useMemo)(()=>{
        if (!clientID) return {
            clientName: null,
            clientTimeZone: null
        };
        const client = clients.find((c)=>c.clientID === clientID);
        return {
            clientName: client?.name || null,
            clientTimeZone: client?.timeZone || null
        };
    }, [
        clientID,
        clients
    ]);
    // Infrastructure data fetched from API (for WebSocket-sourced streams)
    const [infraData, setInfraData] = (0, _react.useState)(null);
    const infraFetchedForRef = (0, _react.useRef)(null);
    // Fetch live streams if store is empty (handles direct navigation / refresh)
    (0, _react.useEffect)(()=>{
        const hasData = liveEvents.length > 0 || liveStreams.length > 0;
        if (!hasData && !loading) getAccessTokenSilently().then((token)=>{
            fetchLiveStreams(token, logout);
        });
    }, []);
    // Find stream by matching against parsed IDs
    // Returns { stream, isFromWebSocket } to track data source
    const { stream, isFromWebSocket } = (0, _react.useMemo)(()=>{
        // Check WebSocket live events first
        for (const event of liveEvents)if (event.clientID === clientID && event.eventID === eventID) {
            const wsStream = transformWsEvent(event, clientName, clientTimeZone);
            // Merge with infrastructure data if available
            if (infraData) return {
                stream: {
                    ...wsStream,
                    liveID: infraData.liveID || wsStream.liveID,
                    ingInstanceID: infraData.ingInstanceID,
                    egInstanceID: infraData.egInstanceID,
                    wcStreamID: infraData.wcStreamID
                },
                isFromWebSocket: true
            };
            return {
                stream: wsStream,
                isFromWebSocket: true
            };
        }
        // Check completed events
        for (const event of completedEvents)if (event.clientID === clientID && event.eventID === eventID) {
            const wsStream = transformWsEvent(event, clientName, clientTimeZone);
            if (infraData) return {
                stream: {
                    ...wsStream,
                    liveID: infraData.liveID || wsStream.liveID,
                    ingInstanceID: infraData.ingInstanceID,
                    egInstanceID: infraData.egInstanceID,
                    wcStreamID: infraData.wcStreamID
                },
                isFromWebSocket: true
            };
            return {
                stream: wsStream,
                isFromWebSocket: true
            };
        }
        // Check API live streams (eventID is already composite: clientID_eventID)
        for (const s of liveStreams){
            if (s.eventID === streamId) // Transform API response to full table row format
            return {
                stream: {
                    ...s,
                    streamingURIs: (0, _format.generateStreamingURIs)(clientID, eventID),
                    private: s.private,
                    liveToBreak: s.liveToBreak,
                    liveStats: null
                },
                isFromWebSocket: false
            };
        }
        return {
            stream: null,
            isFromWebSocket: false
        };
    }, [
        liveEvents,
        completedEvents,
        liveStreams,
        clientID,
        eventID,
        streamId,
        clientName,
        clientTimeZone,
        infraData
    ]);
    // Fetch infrastructure data from API when viewing WebSocket-sourced stream
    // This fills in liveID, ingInstanceID, egInstanceID, wcStreamID
    (0, _react.useEffect)(()=>{
        // Only fetch if:
        // 1. We have a stream from WebSocket
        // 2. We haven't already fetched for this specific stream
        // 3. Stream is in a live state (infrastructure exists)
        const isLiveStatus = stream?.status && [
            'starting',
            'live',
            'on break',
            'stopping'
        ].includes(stream.status);
        if (isFromWebSocket && stream && isLiveStatus && infraFetchedForRef.current !== streamId) {
            infraFetchedForRef.current = streamId;
            getAccessTokenSilently().then(async (token)=>{
                try {
                    const response = await fetch(`${(0, _config.API_BASE_URL)}/api/live-streams`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    });
                    if (response.ok) {
                        const data = await response.json();
                        // Find the matching stream in API response
                        const apiStream = data.liveStreams?.find((s)=>s.eventID === streamId);
                        if (apiStream) setInfraData(apiStream);
                    }
                } catch (err) {
                    console.error('Error fetching infrastructure data:', err);
                }
            });
        }
    }, [
        isFromWebSocket,
        stream,
        streamId,
        getAccessTokenSilently
    ]);
    // Transform WebSocket event to table row format
    function transformWsEvent(event, clientNameOverride, clientTimeZoneOverride) {
        return {
            clientID: event.clientID,
            clientName: clientNameOverride,
            clientTimeZone: clientTimeZoneOverride,
            eventID: event.eventID,
            eventTitle: event.title,
            liveID: event.liveStats?.liveID || null,
            status: event.eventStatus,
            streamStatus: event.liveStats?.status || null,
            eventStartDateTime: event.startDateTime,
            eventEndDateTime: null,
            startDateTime: event.liveStats?.startDate || null,
            endDateTime: null,
            autoStart: event.autoStart,
            autoStop: event.autoStop,
            preroll: event.preroll,
            encoderID: event.assignedEncoder,
            ingInstanceID: null,
            egInstanceID: null,
            wcStreamID: null,
            streamingURIs: event.streamingURIs ? {
                main: event.streamingURIs.main || null,
                backup: event.streamingURIs.backup || null
            } : null,
            customID: event.customID,
            description: event.description,
            notes: event.notes,
            private: event.private,
            liveToBreak: event.liveToBreak,
            liveStats: event.liveStats ? {
                runtime: event.liveStats.runtime,
                status: event.liveStats.status
            } : null
        };
    }
    // Calculate runtime - prefer liveStats, fall back to calculated from startDateTime
    const runtimeValue = (0, _react.useMemo)(()=>{
        if (stream?.liveStats?.runtime) return stream.liveStats.runtime;
        if (!stream?.startDateTime) return null;
        const elapsedSeconds = Math.floor((Date.now() - new Date(stream.startDateTime).getTime()) / 1000);
        return elapsedSeconds > 0 ? (0, _format.formatDuration)(elapsedSeconds) : null;
    }, [
        stream?.liveStats?.runtime,
        stream?.startDateTime
    ]);
    // Get stream status - prefer liveStats, fall back to API streamStatus
    const streamStatusValue = stream?.liveStats?.status || stream?.streamStatus || null;
    // Handle refresh
    const handleRefresh = async ()=>{
        const token = await getAccessTokenSilently();
        await fetchLiveStreams(token, logout);
    };
    // Convert LiveStreamTableRow to StreamDetailData
    const streamDetailData = stream ? {
        clientID: stream.clientID,
        clientName: stream.clientName,
        eventID: stream.eventID,
        eventTitle: stream.eventTitle,
        status: stream.status,
        streamStatus: stream.streamStatus,
        eventStartDateTime: stream.eventStartDateTime,
        eventEndDateTime: stream.eventEndDateTime,
        startDateTime: stream.startDateTime,
        endDateTime: stream.endDateTime,
        autoStart: stream.autoStart,
        autoStop: stream.autoStop,
        preroll: stream.preroll,
        customID: stream.customID,
        description: stream.description,
        notes: stream.notes,
        private: stream.private,
        liveToBreak: stream.liveToBreak,
        encoderID: stream.encoderID,
        liveID: stream.liveID,
        ingInstanceID: stream.ingInstanceID,
        egInstanceID: stream.egInstanceID,
        wcStreamID: stream.wcStreamID,
        streamingURIs: stream.streamingURIs,
        liveStats: stream.liveStats
    } : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _streamDetailView.StreamDetailView), {
        stream: streamDetailData,
        loading: loading && !stream,
        backTo: "/events/live-streams",
        backLabel: "Back to Live Streams",
        onRefresh: handleRefresh,
        streamId: streamId,
        runtimeValue: runtimeValue,
        streamStatusValue: streamStatusValue,
        isLiveStream: true
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useParams","jBvHB"]],"@auth0/auth0-react":"gpXrE","../../__root":"enXay","@/client/store/liveStreamsStore":"7F9wp","@/client/store/clientsStore":"6bg3l","@/client/config":"8SWgh","@/client/lib/format":"iLptT","@/client/components/stream-detail-view":"j7NNO","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"j7NNO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Shared detail view for live and upcoming streams.
 * Renders event info, schedule, streaming URIs, infrastructure, and metadata.
 */ parcelHelpers.export(exports, "StreamDetailView", ()=>StreamDetailView);
var _jsxRuntime = require("react/jsx-runtime");
var _layout = require("@/client/layouts/layout");
var _liveStreamsColumns = require("@/client/components/tables/live-streams-columns");
var _playerButton = require("@/client/components/player-button");
var _ccButton = require("@/client/components/cc-button");
var _detailView = require("@/client/components/ui/detail-view");
var _button = require("@/client/components/ui/button");
var _lucideReact = require("lucide-react");
var _reactRouter = require("@tanstack/react-router");
function StreamDetailView({ stream, loading, backTo, backLabel, onRefresh, streamId, runtimeValue, streamStatusValue, isLiveStream = false, extraCards, hasAiCaptions }) {
    // Parse clientID and eventID from streamId
    const [clientID, eventID] = (()=>{
        const parts = streamId.split('_');
        if (parts.length >= 2) return [
            parts[0],
            parts.slice(1).join('_')
        ];
        return [
            null,
            streamId
        ];
    })();
    // Loading state
    if (loading && !stream) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Layout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailHeader), {
                title: "Loading...",
                backTo: backTo,
                backLabel: backLabel
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "rounded-lg border p-8 text-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Loader2), {
                        className: "h-8 w-8 animate-spin mx-auto text-muted-foreground"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-muted-foreground mt-4",
                        children: "Loading stream data..."
                    })
                ]
            })
        ]
    });
    // Not found state
    if (!stream) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Layout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailHeader), {
                title: "Stream Not Found",
                backTo: backTo,
                backLabel: backLabel
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "rounded-lg border p-8 text-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-muted-foreground mb-4",
                        children: "This stream may have ended or the data is no longer available."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        asChild: true,
                        variant: "outline",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: backTo,
                            children: "Return to streams"
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Layout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailHeader), {
                title: stream.eventTitle || 'Untitled Event',
                subtitle: stream.clientID && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailLink), {
                    to: "/clients/$clientID",
                    params: {
                        clientID: stream.clientID
                    },
                    children: stream.clientName || stream.clientID
                }),
                backTo: backTo,
                backLabel: backLabel,
                badge: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _liveStreamsColumns.StatusBadge), {
                    status: stream.status
                }),
                actions: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _playerButton.PlayerButton), {
                            clientID: clientID,
                            eventID: eventID
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ccButton.CCButton), {
                            clientID: clientID,
                            eventID: eventID,
                            clientName: stream.clientName
                        }),
                        onRefresh && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            variant: "ghost",
                            size: "icon",
                            title: "Refresh",
                            onClick: onRefresh,
                            disabled: loading,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                className: `h-4 w-4 ${loading ? 'animate-spin' : ''}`
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailView.DetailGrid), {
                columns: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailCard), {
                        title: "Event Info",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailView.DetailList), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Event ID",
                                    value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.CopyableText), {
                                        text: streamId
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Client",
                                    value: stream.clientID ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailLink), {
                                        to: "/clients/$clientID",
                                        params: {
                                            clientID: stream.clientID
                                        },
                                        children: stream.clientName || stream.clientID
                                    }) : null
                                }),
                                stream.customID && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Custom ID",
                                    value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.CopyableText), {
                                        text: stream.customID
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Private",
                                    value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.BooleanBadge), {
                                        value: stream.private
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Live to Break",
                                    value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.BooleanBadge), {
                                        value: stream.liveToBreak
                                    })
                                }),
                                hasAiCaptions !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "AI Captions",
                                    value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.BooleanBadge), {
                                        value: hasAiCaptions
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Logs",
                                    value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                        to: "/pipeline-logs",
                                        search: {
                                            searchType: 'eventID',
                                            searchValue: eventID || streamId
                                        },
                                        className: "inline-flex items-center gap-1 text-sm text-primary hover:underline",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ScrollText), {
                                                className: "h-3 w-3"
                                            }),
                                            "View pipeline logs"
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailCard), {
                        title: "Schedule",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailView.DetailList), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Auto Start",
                                    value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.BooleanBadge), {
                                        value: stream.autoStart
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Auto Stop",
                                    value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.BooleanBadge), {
                                        value: stream.autoStop
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Scheduled Start",
                                    value: (0, _detailView.formatDateTime)(stream.eventStartDateTime),
                                    mono: true
                                }),
                                isLiveStream && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Started Streaming",
                                    value: (0, _detailView.formatDateTime)(stream.startDateTime),
                                    mono: true
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Scheduled End",
                                    value: (0, _detailView.formatDateTime)(stream.eventEndDateTime),
                                    mono: true
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Preroll",
                                    value: `${stream.preroll}s`,
                                    mono: true
                                }),
                                runtimeValue && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Runtime",
                                    value: runtimeValue,
                                    mono: true
                                }),
                                streamStatusValue && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Stream Status",
                                    value: streamStatusValue
                                })
                            ]
                        })
                    }),
                    stream.streamingURIs && (stream.streamingURIs.main || stream.streamingURIs.backup) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailCard), {
                        title: "Streaming URIs",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-3",
                            children: [
                                stream.streamingURIs.main && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-xs text-muted-foreground mb-1",
                                            children: "Main"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.CopyableText), {
                                            text: stream.streamingURIs.main,
                                            className: "text-xs break-words text-left"
                                        })
                                    ]
                                }),
                                stream.streamingURIs.backup && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "text-xs text-muted-foreground mb-1",
                                            children: "Backup"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.CopyableText), {
                                            text: stream.streamingURIs.backup,
                                            className: "text-xs break-words text-left"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    isLiveStream && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailCard), {
                        title: "Infrastructure",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailView.DetailList), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Encoder",
                                    value: stream.encoderID ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailLink), {
                                        to: "/encoders/$encoderID",
                                        params: {
                                            encoderID: stream.encoderID
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "font-mono inline-flex items-center gap-1 hover:text-foreground group hover:text-zinc-500",
                                            children: [
                                                stream.encoderID,
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowRight), {
                                                    className: "h-3 w-3 opacity-40 group-hover:opacity-70"
                                                })
                                            ]
                                        })
                                    }) : null
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Live ID",
                                    value: stream.liveID ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.CopyableText), {
                                        text: stream.liveID,
                                        truncate: true
                                    }) : null
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Ingress Instance",
                                    value: stream.ingInstanceID ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailLink), {
                                        to: "/aws/ec2/$instanceId",
                                        params: {
                                            instanceId: stream.ingInstanceID
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "font-mono inline-flex items-center gap-1 hover:text-foreground group hover:text-zinc-500",
                                            children: [
                                                stream.ingInstanceID,
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowRight), {
                                                    className: "h-3 w-3 opacity-40 group-hover:opacity-70"
                                                })
                                            ]
                                        })
                                    }) : null
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Egress Instance",
                                    value: stream.egInstanceID ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailLink), {
                                        to: "/aws/ec2/$instanceId",
                                        params: {
                                            instanceId: stream.egInstanceID
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "font-mono inline-flex items-center gap-1 hover:text-foreground group hover:text-zinc-500",
                                            children: [
                                                stream.egInstanceID,
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowRight), {
                                                    className: "h-3 w-3 opacity-40 group-hover:opacity-70"
                                                })
                                            ]
                                        })
                                    }) : null
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Wowza Stream ID",
                                    value: stream.wcStreamID ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.CopyableText), {
                                        text: stream.wcStreamID
                                    }) : null
                                })
                            ]
                        })
                    }),
                    !isLiveStream && stream.encoderID && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailCard), {
                        title: "Assignment",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailList), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                label: "Encoder",
                                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailLink), {
                                    to: "/encoders/$encoderID",
                                    params: {
                                        encoderID: stream.encoderID
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "font-mono inline-flex items-center gap-1 hover:text-foreground group hover:text-zinc-500",
                                        children: [
                                            stream.encoderID,
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowRight), {
                                                className: "h-3 w-3 opacity-40 group-hover:opacity-70"
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }),
                    extraCards
                ]
            }),
            (stream.description || stream.notes) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailCard), {
                    title: "Metadata",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            stream.description && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                        className: "text-sm text-muted-foreground mb-1",
                                        children: "Description"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm prose prose-sm dark:prose-invert max-w-none prose-p:my-1 prose-ul:my-1 prose-ol:my-1 prose-li:my-0 break-words overflow-hidden",
                                        dangerouslySetInnerHTML: {
                                            __html: stream.description
                                        }
                                    })
                                ]
                            }),
                            stream.notes && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                        className: "text-sm text-muted-foreground mb-1",
                                        children: "Notes"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "text-sm whitespace-pre-wrap break-words overflow-hidden",
                                        children: stream.notes
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","@/client/layouts/layout":"d6QdD","@/client/components/tables/live-streams-columns":"ba3MU","@/client/components/player-button":"k3ESH","@/client/components/cc-button":"3jvYF","@/client/components/ui/detail-view":"5pGcz","@/client/components/ui/button":"armlb","lucide-react":[["ArrowRight","itm6a","default"],["Loader2","gZHhk","default"],["RefreshCw","7a8jT","default"],["ScrollText","hdD9f","default"]],"@tanstack/react-router":"7k6Lq","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"k3ESH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PlayerButton", ()=>PlayerButton);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _button = require("@/client/components/ui/button");
var _config = require("@/client/config");
function buildPlayerUrl(clientID, eventID) {
    return `${0, _config.PLAYER_BASE_URL}/?clientID=${clientID}&eventID=${eventID}&debug=true`;
}
function PlayerButton({ href, clientID, eventID, size = 'sm' }) {
    const url = href || (clientID && eventID ? buildPlayerUrl(clientID, eventID) : null);
    if (!url) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
        asChild: true,
        size: size,
        className: "gap-1.5 btn-player",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.MonitorPlay), {
                    className: "h-3.5 w-3.5"
                }),
                "Open Player"
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","lucide-react":[["MonitorPlay","4cSqM","default"]],"@/client/components/ui/button":"armlb","@/client/config":"8SWgh","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3jvYF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CCButton", ()=>CCButton);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _button = require("@/client/components/ui/button");
var _swapClientDialog = require("@/client/components/swap-client-dialog");
var _ccSwapStore = require("@/client/store/ccSwapStore");
var _config = require("@/client/config");
function buildCCUrl(eventID) {
    return `${0, _config.CC_BASE_URL}/events/slim?eventID=${eventID}`;
}
function CCButton({ clientID, eventID, clientName, size = 'sm' }) {
    const clientIDStr = clientID || '';
    const { needsSwap } = (0, _swapClientDialog.useClientSwapInfo)(clientIDStr);
    const requestSwap = (0, _ccSwapStore.useCCSwapStore)((s)=>s.requestSwap);
    if (!eventID || !clientID) return null;
    const ccUrl = buildCCUrl(eventID);
    const handleClick = ()=>{
        if (needsSwap) requestSwap(clientIDStr, clientName || `Client ${clientIDStr}`, ccUrl);
        else window.open(ccUrl, '_blank', 'noopener,noreferrer');
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
        size: size,
        variant: "default",
        className: "gap-1.5 btn-cc",
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.IdCardLanyard), {
                className: "h-3.5 w-3.5"
            }),
            needsSwap ? 'Switch & Open in Control Center' : 'Open in Control Center'
        ]
    });
}

},{"react/jsx-runtime":"dQjte","lucide-react":[["IdCardLanyard","4p9qL","default"]],"@/client/components/ui/button":"armlb","@/client/components/swap-client-dialog":"dD6eo","@/client/store/ccSwapStore":"8GoFO","@/client/config":"8SWgh","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5pGcz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DetailCard", ()=>DetailCard);
parcelHelpers.export(exports, "DetailGrid", ()=>DetailGrid);
parcelHelpers.export(exports, "DetailRow", ()=>DetailRow);
parcelHelpers.export(exports, "DetailList", ()=>DetailList);
parcelHelpers.export(exports, "CopyableText", ()=>CopyableText);
parcelHelpers.export(exports, "BooleanBadge", ()=>BooleanBadge);
parcelHelpers.export(exports, "DetailLink", ()=>DetailLink);
parcelHelpers.export(exports, "ExternalLinkButton", ()=>ExternalLinkButton);
parcelHelpers.export(exports, "DetailHeader", ()=>DetailHeader);
// ============================================================================
// Utility functions
// ============================================================================
parcelHelpers.export(exports, "formatDateTime", ()=>formatDateTime);
parcelHelpers.export(exports, "formatDate", ()=>formatDate);
parcelHelpers.export(exports, "formatTime", ()=>formatTime);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _lucideReact = require("lucide-react");
var _reactRouter = require("@tanstack/react-router");
var _utils = require("@/client/lib/utils");
function DetailCard({ title, children, className, actions }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _utils.cn)('rounded-lg border bg-card min-w-0', className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center justify-between px-4 py-3 border-b",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "font-medium text-sm",
                        children: title
                    }),
                    actions
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "p-4 overflow-hidden",
                children: children
            })
        ]
    });
}
function DetailGrid({ children, columns = 2, className }) {
    const gridCols = {
        1: 'grid-cols-1',
        2: 'grid-cols-1 lg:grid-cols-2',
        3: 'grid-cols-1 md:grid-cols-2 xl:grid-cols-3'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _utils.cn)('grid gap-4', gridCols[columns], className),
        children: children
    });
}
function DetailRow({ label, value, mono = false, className }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _utils.cn)('flex justify-between items-start py-2 border-b border-border/50 last:border-0', className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-muted-foreground text-sm shrink-0 mr-4",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: (0, _utils.cn)('text-sm text-right', mono && 'font-mono'),
                children: value ?? '-'
            })
        ]
    });
}
function DetailList({ children, className }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _utils.cn)('space-y-0', className),
        children: children
    });
}
function CopyableText({ text, truncate = false, maxLength = 30, className }) {
    const [copied, setCopied] = (0, _react.useState)(false);
    const handleCopy = async (e)=>{
        e.stopPropagation();
        await navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(()=>setCopied(false), 2000);
    };
    const displayText = truncate && text.length > maxLength ? `${text.slice(0, maxLength - 3)}...` : text;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        onClick: handleCopy,
        className: (0, _utils.cn)('inline-flex items-center gap-1.5 font-mono text-sm hover:text-primary cursor-pointer group text-right', className),
        title: truncate && text.length > maxLength ? text : 'Click to copy',
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: displayText
            }),
            copied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                className: "h-3 w-3 text-green-500 shrink-0"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Copy), {
                className: "h-3 w-3 text-muted-foreground shrink-0"
            })
        ]
    });
}
function BooleanBadge({ value, trueLabel = 'Yes', falseLabel = 'No' }) {
    if (value === null || value === undefined) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-sm text-muted-foreground",
        children: "-"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _utils.cn)('text-sm', value ? 'text-green-600 dark:text-green-400' : 'text-muted-foreground'),
        children: value ? trueLabel : falseLabel
    });
}
function DetailLink({ to, params, children, className }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
        to: to,
        params: params,
        className: (0, _utils.cn)('text-sm text-primary hover:underline', className),
        children: children
    });
}
function ExternalLinkButton({ href, children, className }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        className: (0, _utils.cn)('inline-flex items-center gap-1 text-sm text-primary hover:underline', className),
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ExternalLink), {
                className: "h-3 w-3"
            })
        ]
    });
}
function DetailHeader({ title, subtitle, backTo, backLabel, badge, actions }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-start justify-between mb-6",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-start gap-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                        to: backTo,
                        className: "mt-1 p-2 -ml-2 rounded-md hover:bg-muted transition-colors",
                        title: backLabel || 'Go back',
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "m12 19-7-7 7-7"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M19 12H5"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        className: "text-2xl font-semibold",
                                        children: title
                                    }),
                                    badge
                                ]
                            }),
                            subtitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-sm text-muted-foreground mt-1",
                                children: subtitle
                            })
                        ]
                    })
                ]
            }),
            actions && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex items-center gap-2",
                children: actions
            })
        ]
    });
}
function formatDateTime(dateStr) {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleString();
}
function formatDate(dateStr) {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString();
}
function formatTime(dateStr) {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleTimeString();
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","lucide-react":[["Check","bajJU","default"],["Copy","jM41N","default"],["ExternalLink","kIIQA","default"]],"@tanstack/react-router":"7k6Lq","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8Xmln":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _dateFns = require("date-fns");
var _root = require("../../__root");
var _upcomingStreamsStore = require("../../../store/upcomingStreamsStore");
var _layout = require("@/client/layouts/layout");
var _date = require("@/client/lib/date");
var _csv = require("@/client/lib/csv");
var _reactTable = require("@tanstack/react-table");
var _upcomingStreamsColumns = require("@/client/components/tables/upcoming-streams-columns");
var _table = require("@/client/components/ui/table");
var _dropdownMenu = require("@/client/components/ui/dropdown-menu");
var _button = require("@/client/components/ui/button");
var _input = require("@/client/components/ui/input");
var _switch = require("@/client/components/ui/switch");
var _label = require("@/client/components/ui/label");
var _card = require("@/client/components/ui/card");
var _cacheTimestamp = require("@/client/components/cache-timestamp");
var _lucideReact = require("lucide-react");
var _searchParams = require("@/client/lib/searchParams");
var _usePersistedSearch = require("@/client/hooks/usePersistedSearch");
var _resetFiltersButton = require("@/client/components/reset-filters-button");
const DATE_RANGE_LABELS = {
    today: 'Today',
    tomorrow: 'Tomorrow',
    this_week: 'This Week (Mon-Sun)',
    next_week: 'Next Week (Mon-Sun)',
    this_month: 'This Month',
    next_month: 'Next Month',
    last_month: 'Last Month'
};
// Single day ranges just show the day name
const SINGLE_DAY_RANGES = [
    'today',
    'tomorrow'
];
/**
 * Find the index of the closest upcoming event (next to start)
 * Returns the eventID of the first event that starts in the future, or null
 */ function findClosestUpcomingEventId(streams) {
    const now = new Date();
    // Sort by start time and find first future event
    const sorted = [
        ...streams
    ].sort((a, b)=>new Date(a.startDateTimePT).getTime() - new Date(b.startDateTimePT).getTime());
    for (const stream of sorted){
        if (new Date(stream.startDateTimePT) > now) return stream.eventID;
    }
    return null;
}
/**
 * Time indicator component - shows current time with a yellow line
 * Similar to Apple Calendar's "now" indicator
 * Updates every 60 seconds
 */ function NowIndicator() {
    const [now, setNow] = (0, _react.useState)(new Date());
    (0, _react.useEffect)(()=>{
        const interval = setInterval(()=>{
            setNow(new Date());
        }, 5000);
        return ()=>clearInterval(interval);
    }, []);
    const timeStr = now.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "relative h-0 z-10 overflow-visible",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "absolute left-0 right-0 flex items-center",
            style: {
                top: '-1px'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex-1 h-0.5 bg-yellow-400"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "bg-yellow-400 text-black text-xs font-bold px-1.5 py-0.5 rounded-sm shrink-0 -my-2",
                    children: timeStr
                })
            ]
        })
    });
}
/**
 * Check if this row should show the "now" indicator above it
 */ function isClosestUpcoming(eventID, closestEventId) {
    return eventID === closestEventId;
}
/**
 * Format a date range for display in the summary card
 */ function formatDateRangeLabel(dateRange) {
    const now = new Date();
    const currentYear = (0, _dateFns.getYear)(now);
    if (dateRange === 'today') return (0, _date.formatDateWithConditionalYear)(now, currentYear);
    if (dateRange === 'tomorrow') return (0, _date.formatDateWithConditionalYear)((0, _date.getTomorrow)(now), currentYear);
    let start;
    let end;
    switch(dateRange){
        case 'this_week':
            {
                const bounds = (0, _date.getWeekBounds)(now);
                start = bounds.start;
                end = bounds.end;
                break;
            }
        case 'next_week':
            {
                const bounds = (0, _date.getNextWeekBounds)(now);
                start = bounds.start;
                end = bounds.end;
                break;
            }
        case 'this_month':
            {
                const bounds = (0, _date.getMonthBounds)(now);
                start = bounds.start;
                end = bounds.end;
                break;
            }
        case 'next_month':
            {
                const bounds = (0, _date.getNextMonthBounds)(now);
                start = bounds.start;
                end = bounds.end;
                break;
            }
        case 'last_month':
            {
                const bounds = (0, _date.getLastMonthBounds)(now);
                start = bounds.start;
                end = bounds.end;
                break;
            }
        default:
            return DATE_RANGE_LABELS[dateRange];
    }
    return (0, _date.formatDateRange)(start, end, currentYear);
}
function DayTable({ dateLabel, streams, columns, sorting, onSortingChange, onRowClick, closestEventId }) {
    const table = (0, _reactTable.useReactTable)({
        data: streams,
        columns,
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        onSortingChange,
        getSortedRowModel: (0, _reactTable.getSortedRowModel)(),
        state: {
            sorting
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-3 mb-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        className: "text-lg font-medium text-muted-foreground",
                        children: dateLabel
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "inline-flex items-center justify-center rounded-full font-mono dark:bg-gray-50 dark:text-gray-800 text-gray-50 bg-gray-800 text-sm font-bold px-2.5 py-0.5 min-w-[28px]",
                        children: streams.length
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "rounded-md border",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                    className: "table-fixed",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                            children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                    children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                            style: {
                                                width: header.column.columnDef.size ? `${header.column.columnDef.size}px` : undefined
                                            },
                                            children: header.isPlaceholder ? null : (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())
                                        }, header.id))
                                }, headerGroup.id))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                            children: table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                    children: [
                                        isClosestUpcoming(row.original.eventID, closestEventId) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                colSpan: row.getVisibleCells().length,
                                                className: "p-0 border-0",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NowIndicator, {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                            className: "cursor-pointer hover:bg-muted transition-colors",
                                            onClick: ()=>onRowClick(row.original),
                                            children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: cell.column.id === 'startDateTimePT' ? 'whitespace-nowrap' : 'truncate',
                                                    children: (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                                }, cell.id))
                                        })
                                    ]
                                }, row.id))
                        })
                    ]
                })
            })
        ]
    });
}
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'events/upcoming-streams',
    validateSearch: (search)=>({
            search: (0, _searchParams.parseString)(search.search),
            range: Object.keys(DATE_RANGE_LABELS).includes(search.range) ? search.range : undefined
        }),
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: UpcomingStreamsComponent
});
function UpcomingStreamsComponent() {
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    const navigate = (0, _reactRouter.useNavigate)();
    const { search: searchFilter = '', range: urlRange } = (0, _reactRouter.useSearch)({
        from: '/events/upcoming-streams'
    });
    // Persist search params across navigation
    (0, _usePersistedSearch.usePersistedSearch)('/events/upcoming-streams', {
        search: undefined,
        range: undefined
    });
    const { upcomingStreams, dateRange, cacheInfo, loading, error, fetchUpcomingStreams } = (0, _upcomingStreamsStore.useUpcomingStreamsStore)();
    // Default sort: startDateTimePT ascending
    const [sorting, setSorting] = (0, _react.useState)([
        {
            id: 'startDateTimePT',
            desc: false
        }
    ]);
    const [refreshCooldown, setRefreshCooldown] = (0, _react.useState)(false);
    const [showElapsedDays, setShowElapsedDays] = (0, _react.useState)(false);
    // Update URL when search filter changes
    const setSearchFilter = (value)=>{
        navigate({
            to: '/events/upcoming-streams',
            search: (0, _searchParams.buildSearchParams)({
                search: value || undefined,
                range: dateRange !== 'today' ? dateRange : undefined
            })
        });
    };
    const loadUpcomingStreams = async (forceRefresh = false, range)=>{
        try {
            const token = await getAccessTokenSilently();
            await fetchUpcomingStreams(token, logout, forceRefresh, range);
        } catch (err) {
            console.error('Error fetching upcoming streams:', err);
        }
    };
    const handleRefresh = async ()=>{
        setRefreshCooldown(true);
        await loadUpcomingStreams(true); // Force refresh when user clicks button
        setTimeout(()=>setRefreshCooldown(false), 5000);
    };
    const handleDateRangeChange = async (range)=>{
        // Update URL and fetch data
        navigate({
            to: '/events/upcoming-streams',
            search: (0, _searchParams.buildSearchParams)({
                search: searchFilter || undefined,
                range: range !== 'today' ? range : undefined
            })
        });
        await loadUpcomingStreams(false, range);
    };
    const handleExportCSV = ()=>{
        const headers = [
            'Client',
            'Event ID',
            'Title',
            'Start Date/Time (PT)',
            'Encoder',
            'Status'
        ];
        const rows = filteredUpcomingStreams.map((stream)=>[
                stream.clientName || '',
                stream.eventID || '',
                stream.eventTitle || '',
                stream.startDateTimePT ? new Date(stream.startDateTimePT).toLocaleString('en-US', {
                    timeZone: 'America/Los_Angeles',
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit'
                }) : '',
                stream.encoderID || 'VOD',
                stream.status || ''
            ]);
        const filename = `upcoming-streams-${dateRange}-${(0, _date.toISODateString)(new Date())}.csv`;
        (0, _csv.downloadCSV)(filename, headers, rows);
    };
    const handleRowClick = (stream)=>{
        navigate({
            to: '/events/$eventId',
            params: {
                eventId: stream.eventID
            }
        });
    };
    // Sync URL range to store on mount (if URL has a range and it differs from store)
    (0, _react.useEffect)(()=>{
        if (urlRange && urlRange !== dateRange) loadUpcomingStreams(false, urlRange);
        else loadUpcomingStreams();
    }, [
        getAccessTokenSilently
    ]);
    const filteredUpcomingStreams = (0, _react.useMemo)(()=>{
        if (!searchFilter) return upcomingStreams;
        const lowerFilter = searchFilter.toLowerCase();
        return upcomingStreams.filter((stream)=>stream.clientName?.toLowerCase().includes(lowerFilter) || stream.eventTitle?.toLowerCase().includes(lowerFilter));
    }, [
        upcomingStreams,
        searchFilter
    ]);
    // Find the closest upcoming event for the "you are here" marker
    const closestEventId = (0, _react.useMemo)(()=>{
        return findClosestUpcomingEventId(filteredUpcomingStreams);
    }, [
        filteredUpcomingStreams
    ]);
    // Group streams by date for multi-day views (week/month)
    const shouldGroupByDate = [
        'this_week',
        'next_week',
        'this_month',
        'next_month',
        'last_month'
    ].includes(dateRange);
    const streamsByDate = (0, _react.useMemo)(()=>{
        if (!shouldGroupByDate) return null;
        const grouped = {};
        const currentYear = (0, _dateFns.getYear)(new Date());
        const todayStart = (0, _dateFns.startOfDay)(new Date());
        filteredUpcomingStreams.forEach((stream)=>{
            const date = new Date(stream.startDateTimePT);
            const dateKey = (0, _date.formatDateWithWeekday)(date, currentYear);
            if (!grouped[dateKey]) grouped[dateKey] = [];
            grouped[dateKey].push(stream);
        });
        // Sort by date and return as array of [dateLabel, streams]
        const sorted = Object.entries(grouped).sort((a, b)=>{
            const dateA = new Date(a[1][0].startDateTimePT);
            const dateB = new Date(b[1][0].startDateTimePT);
            return (0, _dateFns.getTime)(dateA) - (0, _dateFns.getTime)(dateB);
        });
        // Filter out elapsed days unless showElapsedDays is true
        if (!showElapsedDays) return sorted.filter(([, streams])=>{
            const dayDate = (0, _dateFns.startOfDay)(new Date(streams[0].startDateTimePT));
            return !(0, _dateFns.isBefore)(dayDate, todayStart);
        });
        return sorted;
    }, [
        filteredUpcomingStreams,
        shouldGroupByDate,
        showElapsedDays
    ]);
    const table = (0, _reactTable.useReactTable)({
        data: filteredUpcomingStreams,
        columns: (0, _upcomingStreamsColumns.upcomingStreamsColumns),
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        onSortingChange: setSorting,
        getSortedRowModel: (0, _reactTable.getSortedRowModel)(),
        state: {
            sorting
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex justify-between items-center mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "text-2xl font-semibold",
                                children: "Upcoming Streams"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cacheTimestamp.CacheTimestamp), {
                                cachedAt: cacheInfo?.cachedAt ?? null
                            })
                        ]
                    }),
                    !loading && !error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.Card), {
                            className: "w-fit",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardContent), {
                                className: "flex items-center gap-6 p-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardTitle), {
                                                className: "text-sm font-medium text-muted-foreground",
                                                children: DATE_RANGE_LABELS[dateRange]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-xs text-muted-foreground mt-1",
                                                children: formatDateRangeLabel(dateRange)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-5xl font-bold tabular-nums",
                                        children: upcomingStreams.length
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex justify-end items-center gap-4 mb-4",
                        children: [
                            shouldGroupByDate && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switch.Switch), {
                                        id: "show-elapsed-days",
                                        checked: showElapsedDays,
                                        onCheckedChange: setShowElapsedDays
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                        htmlFor: "show-elapsed-days",
                                        className: "text-sm text-muted-foreground cursor-pointer",
                                        children: "Show elapsed days"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenu), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuTrigger), {
                                        asChild: true,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            variant: "outline",
                                            size: "sm",
                                            children: [
                                                "Date Range: ",
                                                DATE_RANGE_LABELS[dateRange],
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                    className: "ml-2 h-4 w-4"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenuContent), {
                                        align: "end",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                onClick: ()=>handleDateRangeChange('today'),
                                                children: "Today"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                onClick: ()=>handleDateRangeChange('tomorrow'),
                                                children: "Tomorrow"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuSeparator), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                onClick: ()=>handleDateRangeChange('this_week'),
                                                children: "This Week (Mon-Sun)"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                onClick: ()=>handleDateRangeChange('next_week'),
                                                children: "Next Week (Mon-Sun)"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuSeparator), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                onClick: ()=>handleDateRangeChange('this_month'),
                                                children: "This Month"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                onClick: ()=>handleDateRangeChange('next_month'),
                                                children: "Next Month"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuSeparator), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                onClick: ()=>handleDateRangeChange('last_month'),
                                                children: "Last Month"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                placeholder: "Filter by client or title...",
                                value: searchFilter,
                                onChange: (e)=>setSearchFilter(e.target.value),
                                className: "max-w-xs"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                variant: "outline",
                                size: "sm",
                                onClick: handleRefresh,
                                disabled: loading || refreshCooldown,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                        className: `h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`
                                    }),
                                    "Force Refresh"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                variant: "outline",
                                size: "sm",
                                onClick: handleExportCSV,
                                disabled: filteredUpcomingStreams.length === 0,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                        className: "h-4 w-4 mr-2"
                                    }),
                                    "Export CSV"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetFiltersButton.ResetFiltersButton), {
                                routePath: "/events/upcoming-streams",
                                defaultValues: {
                                    search: undefined,
                                    range: undefined
                                }
                            })
                        ]
                    }),
                    loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Loading upcoming streams..."
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-4 bg-red-100 border-l-4 border-red-600 rounded mt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "m-0 text-red-800 font-medium",
                            children: [
                                "Error: ",
                                error
                            ]
                        })
                    }),
                    !loading && !error && upcomingStreams.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            "No upcoming streams found for ",
                            DATE_RANGE_LABELS[dateRange].toLowerCase(),
                            "."
                        ]
                    }),
                    !loading && !error && upcomingStreams.length > 0 && (shouldGroupByDate && streamsByDate ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "space-y-6",
                        children: streamsByDate.map(([dateLabel, streams])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(DayTable, {
                                dateLabel: dateLabel,
                                streams: streams,
                                columns: (0, _upcomingStreamsColumns.upcomingStreamsColumns),
                                sorting: sorting,
                                onSortingChange: setSorting,
                                onRowClick: handleRowClick,
                                closestEventId: closestEventId
                            }, dateLabel))
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rounded-md border",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                    children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                            children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    children: header.isPlaceholder ? null : (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())
                                                }, header.id))
                                        }, headerGroup.id))
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                    children: table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                            children: [
                                                isClosestUpcoming(row.original.eventID, closestEventId) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                        colSpan: row.getVisibleCells().length,
                                                        className: "p-0 border-0",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NowIndicator, {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    className: "cursor-pointer hover:bg-muted transition-colors",
                                                    onClick: ()=>handleRowClick(row.original),
                                                    children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                            children: (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                                        }, cell.id))
                                                })
                                            ]
                                        }, row.id))
                                })
                            ]
                        })
                    }))
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useNavigate","aMhxM"],["useSearch","4yVFL"]],"@auth0/auth0-react":"gpXrE","date-fns":[["getTime","793rO"],["getYear","cJSDO"],["isBefore","jZQRA"],["startOfDay","l6QIr"]],"../../__root":"enXay","../../../store/upcomingStreamsStore":"iTCvS","@/client/layouts/layout":"d6QdD","@/client/lib/date":"7ZbER","@/client/lib/csv":"2NpE4","@tanstack/react-table":[["flexRender","brwh1"],["useReactTable","brwh1"],["getCoreRowModel","3MlnA"],["getSortedRowModel","3MlnA"]],"@/client/components/tables/upcoming-streams-columns":"dlh5w","@/client/components/ui/table":"5vxZ8","@/client/components/ui/dropdown-menu":"8ox96","@/client/components/ui/button":"armlb","@/client/components/ui/input":"8UHwi","@/client/components/ui/switch":"1p4xh","@/client/components/ui/label":"cLMZq","@/client/components/ui/card":"dhIfn","@/client/components/cache-timestamp":"f5Zyx","lucide-react":[["ChevronDown","kVmgC","default"],["Download","eRiW1","default"],["RefreshCw","7a8jT","default"]],"@/client/lib/searchParams":"fgK0T","@/client/hooks/usePersistedSearch":"kPA60","@/client/components/reset-filters-button":"9d8BP","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"793rO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ parcelHelpers.export(exports, "getTime", ()=>getTime);
var _toDateJs = require("./toDate.js");
function getTime(date) {
    return +(0, _toDateJs.toDate)(date);
}
// Fallback for modularized imports:
exports.default = getTime;

},{"./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jZQRA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ parcelHelpers.export(exports, "isBefore", ()=>isBefore);
var _toDateJs = require("./toDate.js");
function isBefore(date, dateToCompare) {
    return +(0, _toDateJs.toDate)(date) < +(0, _toDateJs.toDate)(dateToCompare);
}
// Fallback for modularized imports:
exports.default = isBefore;

},{"./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"iTCvS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUpcomingStreamsStore", ()=>useUpcomingStreamsStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
var _config = require("@/client/config");
var _apiError = require("@/client/lib/apiError");
const useUpcomingStreamsStore = (0, _zustand.create)()((0, _middleware.devtools)((set, get)=>({
        upcomingStreams: [],
        dateRange: 'this_week',
        cacheInfo: null,
        loading: false,
        error: null,
        setUpcomingStreams: (upcomingStreams)=>set({
                upcomingStreams,
                error: null
            }),
        setDateRange: (dateRange)=>set({
                dateRange
            }),
        setCacheInfo: (cacheInfo)=>set({
                cacheInfo
            }),
        setLoading: (loading)=>set({
                loading
            }),
        setError: (error)=>set({
                error
            }),
        fetchUpcomingStreams: async (accessToken, logout, forceRefresh = false, dateRange)=>{
            const range = dateRange ?? get().dateRange;
            set({
                loading: true,
                error: null
            });
            try {
                const params = new URLSearchParams();
                if (forceRefresh) params.set('forceRefresh', 'true');
                params.set('dateRange', range);
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/upcoming-streams?${params.toString()}`, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.ok) {
                    if ((0, _apiError.handleApiError)(response, logout)) return;
                    throw new Error(`Failed to fetch upcoming streams: ${response.statusText}`);
                }
                const data = await response.json();
                set({
                    upcomingStreams: data.upcomingStreams,
                    cacheInfo: data.cacheInfo ?? null,
                    loading: false,
                    dateRange: range
                });
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
                set({
                    error: errorMessage,
                    loading: false
                });
            }
        }
    }), {
    name: 'upcoming-streams-store'
}));

},{"zustand":"Ze5I5","zustand/middleware":"9udS2","@/client/config":"8SWgh","@/client/lib/apiError":"aL0RR","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dlh5w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "upcomingStreamsColumns", ()=>upcomingStreamsColumns);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _button = require("@/client/components/ui/button");
var _badge = require("@/client/components/ui/badge");
var _eventStatusBadge = require("@/client/components/ui/event-status-badge");
var _cells = require("./cells");
var _date = require("@/client/lib/date");
const upcomingStreamsColumns = [
    {
        accessorKey: 'clientName',
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Client",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        },
        cell: ({ row })=>{
            const clientName = row.getValue('clientName');
            if (!clientName) return '-';
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.ClientNameCell), {
                clientID: row.original.clientID,
                clientName: clientName
            });
        }
    },
    {
        accessorKey: 'eventID',
        size: 80,
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "EventID",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        },
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EventIDCell), {
                eventID: row.getValue('eventID')
            })
    },
    {
        accessorKey: 'eventTitle',
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Title",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        },
        cell: ({ row })=>row.getValue('eventTitle') || '-'
    },
    {
        accessorKey: 'startDateTimePT',
        size: 200,
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Start Date/Time",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        },
        cell: ({ row })=>{
            const dateStr = row.getValue('startDateTimePT');
            const clientTimeZone = row.original.clientTimeZone;
            if (!dateStr) return '-';
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-mono text-xs whitespace-nowrap",
                children: (0, _date.formatDateTimeWithClientTZ)(dateStr, clientTimeZone)
            });
        }
    },
    {
        accessorKey: 'encoderID',
        size: 80,
        header: ({ column })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Encoder",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            });
        },
        cell: ({ row })=>{
            const encoderID = row.getValue('encoderID');
            if (!encoderID) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                variant: "default",
                children: "VOD"
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EncoderIDCell), {
                encoderID: encoderID
            });
        }
    },
    {
        accessorKey: 'status',
        size: 80,
        header: 'Status',
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventStatusBadge.EventStatusBadge), {
                status: row.getValue('status')
            })
    },
    {
        id: 'eventLinks',
        header: 'Links',
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EventLinksCell), {
                eventID: row.original.eventID,
                clientID: row.original.clientID,
                clientName: row.original.clientName ?? undefined
            }),
        size: 70,
        enableSorting: false
    }
];

},{"react/jsx-runtime":"dQjte","lucide-react":[["ArrowUpDown","amX4k","default"]],"@/client/components/ui/button":"armlb","@/client/components/ui/badge":"h4e1f","@/client/components/ui/event-status-badge":"5Klkn","./cells":"5BSEg","@/client/lib/date":"7ZbER","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5Klkn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventStatusBadge", ()=>EventStatusBadge);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@/client/lib/utils");
function getStatusColors(status) {
    const normalizedStatus = status.toLowerCase();
    switch(normalizedStatus){
        case 'new':
        case 'available':
            return {
                bgColor: 'bg-blue-600',
                textColor: 'text-white'
            };
        case 'live':
        case 'disconnected':
            return {
                bgColor: 'bg-red-600',
                textColor: 'text-white'
            };
        case 'on break':
        case 'starting':
        case 'stopping':
            return {
                bgColor: 'bg-orange-500',
                textColor: 'text-white'
            };
        case 'editing':
        case 'publishing':
        case 'unpublishing':
            return {
                bgColor: 'bg-gray-500',
                textColor: 'text-white'
            };
        case 'published':
            return {
                bgColor: 'bg-green-600',
                textColor: 'text-white'
            };
        case 'upcoming':
        default:
            return {
                bgColor: 'bg-gray-100',
                textColor: 'text-gray-800'
            };
    }
}
function EventStatusBadge({ status, className }) {
    const { bgColor, textColor } = getStatusColors(status);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _utils.cn)('inline-flex items-center px-2 py-0.5 rounded-full text-xs font-mono font-medium', bgColor, textColor, className),
        children: status
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fQwiQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _root = require("../../__root");
var _config = require("@/client/config");
var _streamDetailView = require("@/client/components/stream-detail-view");
var _format = require("@/client/lib/format");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'events/upcoming-streams/$streamId',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: UpcomingStreamDetailComponent
});
function UpcomingStreamDetailComponent() {
    // streamId is in format: clientID_eventID
    const { streamId } = (0, _reactRouter.useParams)({
        from: '/events/upcoming-streams/$streamId'
    });
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const [eventData, setEventData] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(null);
    // Parse clientID and eventID from streamId
    const [clientID, eventID] = (0, _react.useMemo)(()=>{
        const parts = streamId.split('_');
        if (parts.length >= 2) return [
            parts[0],
            parts.slice(1).join('_')
        ];
        return [
            null,
            streamId
        ];
    }, [
        streamId
    ]);
    // Fetch event details from API
    (0, _react.useEffect)(()=>{
        async function fetchEventDetails() {
            if (!clientID || !eventID) {
                setError('Invalid stream ID');
                setLoading(false);
                return;
            }
            try {
                const token = await getAccessTokenSilently();
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/events/${clientID}/${eventID}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.ok) {
                    if (response.status === 404) setError('Event not found');
                    else setError('Failed to load event details');
                    setLoading(false);
                    return;
                }
                const data = await response.json();
                setEventData(data);
            } catch (err) {
                console.error('Error fetching event details:', err);
                setError('Failed to load event details');
            } finally{
                setLoading(false);
            }
        }
        fetchEventDetails();
    }, [
        clientID,
        eventID,
        getAccessTokenSilently
    ]);
    // Transform API response to StreamDetailData format
    const stream = (0, _react.useMemo)(()=>{
        if (!eventData) return null;
        return {
            clientID: eventData.clientID,
            clientName: eventData.clientName,
            eventID: eventData.eventID,
            eventTitle: eventData.eventTitle,
            status: eventData.status,
            streamStatus: eventData.streamStatus,
            // Schedule
            eventStartDateTime: eventData.eventStartDateTime,
            eventEndDateTime: eventData.eventEndDateTime,
            startDateTime: eventData.startDateTime,
            endDateTime: null,
            autoStart: eventData.autoStart,
            autoStop: eventData.autoStop,
            preroll: eventData.preroll,
            // Metadata
            customID: eventData.customID,
            description: eventData.description,
            notes: eventData.notes,
            private: eventData.private,
            liveToBreak: eventData.liveToBreak,
            // Assignment
            encoderID: eventData.encoderID,
            // Infrastructure (from liveStreams when active)
            liveID: eventData.liveID,
            ingInstanceID: eventData.ingInstanceID,
            egInstanceID: eventData.egInstanceID,
            wcStreamID: eventData.wcStreamID,
            // Generate streaming URIs for upcoming stream
            streamingURIs: clientID && eventID ? (0, _format.generateStreamingURIs)(clientID, eventID) : null
        };
    }, [
        eventData,
        clientID,
        eventID
    ]);
    // Handle refresh
    const handleRefresh = async ()=>{
        setLoading(true);
        setError(null);
        if (!clientID || !eventID) {
            setError('Invalid stream ID');
            setLoading(false);
            return;
        }
        try {
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/events/${clientID}/${eventID}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) {
                setError('Failed to refresh event details');
                setLoading(false);
                return;
            }
            const data = await response.json();
            setEventData(data);
        } catch (err) {
            console.error('Error refreshing event details:', err);
            setError('Failed to refresh event details');
        } finally{
            setLoading(false);
        }
    };
    // If there's an error, show it via the StreamDetailView's not found state
    if (error && !loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _streamDetailView.StreamDetailView), {
        stream: null,
        loading: false,
        backTo: "/events/upcoming-streams",
        backLabel: "Back to Upcoming Streams",
        streamId: streamId,
        isLiveStream: false
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _streamDetailView.StreamDetailView), {
        stream: stream,
        loading: loading,
        backTo: "/events/upcoming-streams",
        backLabel: "Back to Upcoming Streams",
        onRefresh: handleRefresh,
        streamId: streamId,
        isLiveStream: false
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useParams","jBvHB"]],"@auth0/auth0-react":"gpXrE","../../__root":"enXay","@/client/config":"8SWgh","@/client/components/stream-detail-view":"j7NNO","@/client/lib/format":"iLptT","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5QY9u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _root = require("../../__root");
var _layout = require("@/client/layouts/layout");
var _config = require("@/client/config");
var _date = require("@/client/lib/date");
var _searchParams = require("@/client/lib/searchParams");
var _usePersistedSearch = require("@/client/hooks/usePersistedSearch");
var _resetFiltersButton = require("@/client/components/reset-filters-button");
var _format = require("@/client/lib/format");
var _csv = require("@/client/lib/csv");
var _lucideReact = require("lucide-react");
var _badge = require("@/client/components/ui/badge");
var _button = require("@/client/components/ui/button");
var _checkbox = require("@/client/components/ui/checkbox");
var _label = require("@/client/components/ui/label");
var _cacheTimestamp = require("@/client/components/cache-timestamp");
var _table = require("@/client/components/ui/table");
var _clientSelector = require("@/client/components/client-selector");
var _categorySelector = require("@/client/components/category-selector");
var _dateRangePicker = require("@/client/components/date-range-picker");
var _encoderLiveStreamsTable = require("./components/EncoderLiveStreamsTable");
var _encoderVODTable = require("./components/EncoderVODTable");
var _filterSummary = require("./components/FilterSummary");
// Stable empty reference so derived `categories` keeps identity across renders
const EMPTY_CATEGORIES = [];
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'events/reports',
    validateSearch: (search)=>({
            clientID: (0, _searchParams.parseString)(search.clientID),
            categoryID: (0, _searchParams.parseString)(search.categoryID),
            startDate: (0, _searchParams.parseString)(search.startDate),
            endDate: (0, _searchParams.parseString)(search.endDate),
            quickRange: (0, _searchParams.parseString)(search.quickRange),
            groupByEncoder: (0, _searchParams.parseBoolean)(search.groupByEncoder, false),
            allClients: (0, _searchParams.parseBoolean)(search.allClients, false)
        }),
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: ReportsComponent
});
/** Sort encoder data by field */ function sortEncoderData(data, sortField, sortDirection) {
    if (!sortField) return data;
    return [
        ...data
    ].sort((a, b)=>{
        let aVal;
        let bVal;
        switch(sortField){
            case 'simpleName':
                aVal = a.simpleName.toLowerCase();
                bVal = b.simpleName.toLowerCase();
                break;
            case 'distinctEventCount':
                aVal = a.distinctEventCount;
                bVal = b.distinctEventCount;
                break;
            case 'publishedEventCount':
                aVal = a.publishedEventCount;
                bVal = b.publishedEventCount;
                break;
            case 'totalDurationMinutes':
                aVal = a.totalDurationMinutes;
                bVal = b.totalDurationMinutes;
                break;
            case 'bitrate':
                aVal = a.streamInfo?.bitrate ?? 0;
                bVal = b.streamInfo?.bitrate ?? 0;
                break;
            default:
                return 0;
        }
        if (aVal < bVal) return sortDirection === 'asc' ? -1 : 1;
        if (aVal > bVal) return sortDirection === 'asc' ? 1 : -1;
        return 0;
    });
}
function ReportsComponent() {
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const navigate = (0, _reactRouter.useNavigate)();
    const { clientID: selectedClientId = '', categoryID: selectedCategoryId, startDate = '', endDate = '', quickRange = '', groupByEncoder = false, allClients = false } = (0, _reactRouter.useSearch)({
        from: '/events/reports'
    });
    // Persist search params across navigation
    (0, _usePersistedSearch.usePersistedSearch)('/events/reports', {
        clientID: undefined,
        categoryID: undefined,
        startDate: undefined,
        endDate: undefined,
        quickRange: undefined,
        groupByEncoder: false,
        allClients: false
    });
    // Client object state (not in URL, derived from clientID)
    const [selectedClient, setSelectedClient] = (0, _react.useState)(null);
    // Per-client category cache (not in URL); avoids refetching a client already loaded
    const [categoriesByClient, setCategoriesByClient] = (0, _react.useState)({});
    const categories = selectedClientId ? categoriesByClient[selectedClientId] ?? EMPTY_CATEGORIES : EMPTY_CATEGORIES;
    // Helper to update URL with new search params
    // Uses functional update to get latest search state and avoid stale closure issues
    const updateSearchParams = (updates)=>{
        navigate({
            to: '/events/reports',
            search: (prev)=>(0, _searchParams.buildSearchParams)({
                    clientID: prev.clientID || undefined,
                    categoryID: prev.categoryID || undefined,
                    startDate: prev.startDate || undefined,
                    endDate: prev.endDate || undefined,
                    quickRange: prev.quickRange || undefined,
                    groupByEncoder: prev.groupByEncoder || undefined,
                    allClients: prev.allClients || undefined,
                    ...updates
                })
        });
    };
    // Setters that update URL
    const setStartDate = (value)=>updateSearchParams({
            startDate: value || undefined
        });
    const setEndDate = (value)=>updateSearchParams({
            endDate: value || undefined
        });
    const setQuickRange = (value)=>updateSearchParams({
            quickRange: value || undefined
        });
    const setGroupByEncoder = (value)=>updateSearchParams({
            groupByEncoder: value || undefined
        });
    const setCategoryID = (value)=>updateSearchParams({
            categoryID: value || undefined
        });
    // Report state
    const [reportsData, setReportsData] = (0, _react.useState)(null);
    const [encoderReportsData, setEncoderReportsData] = (0, _react.useState)(null);
    const [allClientsData, setAllClientsData] = (0, _react.useState)(null);
    // Sort state for encoder tables - default to Encoder A-Z
    const [liveStreamSort, setLiveStreamSort] = (0, _react.useState)('simpleName');
    const [liveStreamSortDir, setLiveStreamSortDir] = (0, _react.useState)('asc');
    const [vodSort, setVodSort] = (0, _react.useState)('simpleName');
    const [vodSortDir, setVodSortDir] = (0, _react.useState)('asc');
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    const [confirmPending, setConfirmPending] = (0, _react.useState)(false);
    // Fetch a client's categories once and cache them; skip if already loaded or in all-clients mode
    (0, _react.useEffect)(()=>{
        if (!selectedClientId || allClients) return;
        if (categoriesByClient[selectedClientId]) return;
        let cancelled = false;
        const loadCategories = async ()=>{
            try {
                const token = await getAccessTokenSilently();
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/clients/${selectedClientId}/categories`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.ok) throw new Error(`Failed to fetch categories: ${response.statusText}`);
                const data = await response.json();
                if (!cancelled) setCategoriesByClient((prev)=>({
                        ...prev,
                        [selectedClientId]: data.categories
                    }));
            } catch (err) {
                console.error('Error fetching client categories:', err);
            }
        };
        loadCategories();
        return ()=>{
            cancelled = true;
        };
    }, [
        selectedClientId,
        allClients,
        categoriesByClient,
        getAccessTokenSilently
    ]);
    // Selected category object (for header display), derived from URL + fetched list
    const selectedCategory = (0, _react.useMemo)(()=>categories.find((c)=>String(c.categoryID) === selectedCategoryId) ?? null, [
        categories,
        selectedCategoryId
    ]);
    // Can generate report if dates are set AND (allClients OR specific client selected)
    const canGenerateReport = startDate && endDate && (allClients || selectedClientId);
    // Sorted encoder data
    const sortedLiveStreams = (0, _react.useMemo)(()=>{
        if (!encoderReportsData) return [];
        return sortEncoderData(encoderReportsData.liveStreams.byEncoder, liveStreamSort, liveStreamSortDir);
    }, [
        encoderReportsData,
        liveStreamSort,
        liveStreamSortDir
    ]);
    const sortedVOD = (0, _react.useMemo)(()=>{
        if (!encoderReportsData) return [];
        return sortEncoderData(encoderReportsData.vod.byEncoder, vodSort, vodSortDir);
    }, [
        encoderReportsData,
        vodSort,
        vodSortDir
    ]);
    // Event handlers
    const handleClientChange = (clientId, client)=>{
        // Clear category: a category from the previous client does not apply to the new one
        updateSearchParams({
            clientID: clientId || undefined,
            categoryID: undefined
        });
        setSelectedClient(client);
        setReportsData(null);
        setEncoderReportsData(null);
        setAllClientsData(null);
        setConfirmPending(false);
    };
    const handleAllClientsChange = (checked)=>{
        // All-clients mode has no per-client category, so clear any selection
        updateSearchParams({
            allClients: checked || undefined,
            categoryID: undefined
        });
        setReportsData(null);
        setEncoderReportsData(null);
        setAllClientsData(null);
        setConfirmPending(false);
    };
    const handleCategoryChange = (value)=>{
        setCategoryID(value);
        setReportsData(null);
        setEncoderReportsData(null);
        setAllClientsData(null);
        setConfirmPending(false);
    };
    const handleGroupByEncoderChange = (checked)=>{
        setGroupByEncoder(checked);
        setReportsData(null);
        setEncoderReportsData(null);
        setAllClientsData(null);
        setConfirmPending(false);
        // Reset sort state to default (Encoder A-Z)
        setLiveStreamSort('simpleName');
        setLiveStreamSortDir('asc');
        setVodSort('simpleName');
        setVodSortDir('asc');
    };
    const handleLiveStreamSort = (field)=>{
        if (liveStreamSort === field) setLiveStreamSortDir(liveStreamSortDir === 'asc' ? 'desc' : 'asc');
        else {
            setLiveStreamSort(field);
            setLiveStreamSortDir('desc');
        }
    };
    const handleVodSort = (field)=>{
        if (vodSort === field) setVodSortDir(vodSortDir === 'asc' ? 'desc' : 'asc');
        else {
            setVodSort(field);
            setVodSortDir('desc');
        }
    };
    const handleGenerateReport = async ()=>{
        if (!canGenerateReport) return;
        if (!confirmPending) {
            setConfirmPending(true);
            return;
        }
        setConfirmPending(false);
        setLoading(true);
        setError(null);
        try {
            const token = await getAccessTokenSilently();
            if (allClients) {
                // All clients mode
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/events/reports/all?startDate=${startDate}&endDate=${endDate}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.ok) throw new Error(`Failed to fetch reports: ${response.statusText}`);
                const data = await response.json();
                setAllClientsData(data);
                setReportsData(null);
                setEncoderReportsData(null);
            } else {
                // Single client mode
                const endpoint = groupByEncoder ? `${0, _config.API_BASE_URL}/api/events/reports/by-encoder` : `${0, _config.API_BASE_URL}/api/events/reports`;
                const categoryParam = selectedCategoryId ? `&categoryID=${selectedCategoryId}` : '';
                const response = await fetch(`${endpoint}?clientID=${selectedClientId}&startDate=${startDate}&endDate=${endDate}${categoryParam}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.ok) throw new Error(`Failed to fetch reports: ${response.statusText}`);
                if (groupByEncoder) {
                    const data = await response.json();
                    setEncoderReportsData(data);
                    setReportsData(null);
                } else {
                    const data = await response.json();
                    setReportsData(data);
                    setEncoderReportsData(null);
                }
                setAllClientsData(null);
            }
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred';
            setError(errorMessage);
        } finally{
            setLoading(false);
        }
    };
    // CSV Export handlers
    const getClientFileName = ()=>selectedClient?.name.replace(/[^a-zA-Z0-9]/g, '_') || 'client';
    // Category label (display name preferred), or null when no category filter is applied
    const categoryLabel = selectedCategory ? selectedCategory.displayName?.trim() || selectedCategory.categoryName : null;
    // Filename suffix for the applied category, e.g. "_City_Council" (empty when none)
    const getCategorySuffix = ()=>categoryLabel ? `_${categoryLabel.replace(/[^a-zA-Z0-9]/g, '_')}` : '';
    // Preamble rows describing the applied filters, written above the CSV data table
    const buildReportMeta = (start, end)=>{
        const meta = [];
        meta.push([
            'Client',
            selectedClient ? `${selectedClient.name} (${selectedClientId})` : selectedClientId
        ]);
        if (start && end) meta.push([
            'Date Range',
            `${start} to ${end}`
        ]);
        if (categoryLabel) meta.push([
            'Category',
            categoryLabel
        ]);
        return meta;
    };
    const handleExportLiveStreams = ()=>{
        if (!reportsData) return;
        const headers = [
            'Year',
            'Month',
            'Distinct Events',
            'Total Duration (minutes)',
            'Avg Duration (minutes)'
        ];
        const rows = reportsData.liveStreams.monthly.map((row)=>[
                row.year.toString(),
                (0, _date.getMonthName)(row.month),
                row.distinctEventCount.toString(),
                row.totalDurationMinutes.toString(),
                row.avgDurationMinutes.toString()
            ]);
        rows.push([
            'TOTAL',
            '',
            reportsData.liveStreams.totals.distinctEventCount.toString(),
            reportsData.liveStreams.totals.totalDurationMinutes.toString(),
            reportsData.liveStreams.totals.avgDurationMinutes.toString()
        ]);
        (0, _csv.downloadCSV)(`live_streams_${getClientFileName()}${getCategorySuffix()}_${reportsData.dateRange.start}_to_${reportsData.dateRange.end}.csv`, headers, rows, buildReportMeta(reportsData.dateRange.start, reportsData.dateRange.end));
    };
    const handleExportVOD = ()=>{
        if (!reportsData) return;
        const headers = [
            'Year',
            'Month',
            'Published Events',
            'Total Duration (minutes)',
            'Avg Duration (minutes)'
        ];
        const rows = reportsData.vod.monthly.map((row)=>[
                row.year.toString(),
                (0, _date.getMonthName)(row.month),
                row.publishedEventCount.toString(),
                row.totalDurationMinutes.toString(),
                row.avgDurationMinutes.toString()
            ]);
        rows.push([
            'TOTAL',
            '',
            reportsData.vod.totals.publishedEventCount.toString(),
            reportsData.vod.totals.totalDurationMinutes.toString(),
            reportsData.vod.totals.avgDurationMinutes.toString()
        ]);
        (0, _csv.downloadCSV)(`vod_${getClientFileName()}${getCategorySuffix()}_${reportsData.dateRange.start}_to_${reportsData.dateRange.end}.csv`, headers, rows, buildReportMeta(reportsData.dateRange.start, reportsData.dateRange.end));
    };
    const handleExportLiveStreamsByEncoder = ()=>{
        if (!encoderReportsData) return;
        const headers = [
            'Encoder',
            'Resolution',
            'Bitrate',
            'Frame Rate',
            'Aspect Ratio',
            'Captions',
            'Distinct Events',
            'Total Duration (minutes)',
            'Avg Duration (minutes)'
        ];
        const rows = encoderReportsData.liveStreams.byEncoder.map((row)=>[
                row.simpleName,
                (0, _format.formatStreamField)(row.streamInfo, 'resolution'),
                (0, _format.formatStreamField)(row.streamInfo, 'bitrate'),
                (0, _format.formatStreamField)(row.streamInfo, 'frameRate'),
                (0, _format.formatStreamField)(row.streamInfo, 'aspectRatio'),
                (0, _format.formatStreamField)(row.streamInfo, 'hasCaptions'),
                row.distinctEventCount.toString(),
                row.totalDurationMinutes.toString(),
                row.avgDurationMinutes.toString()
            ]);
        rows.push([
            'TOTAL',
            '',
            '',
            '',
            '',
            '',
            encoderReportsData.liveStreams.totals.distinctEventCount.toString(),
            encoderReportsData.liveStreams.totals.totalDurationMinutes.toString(),
            encoderReportsData.liveStreams.totals.avgDurationMinutes.toString()
        ]);
        (0, _csv.downloadCSV)(`live_streams_by_encoder_${getClientFileName()}${getCategorySuffix()}_${encoderReportsData.dateRange.start}_to_${encoderReportsData.dateRange.end}.csv`, headers, rows, buildReportMeta(encoderReportsData.dateRange.start, encoderReportsData.dateRange.end));
    };
    const handleExportVODByEncoder = ()=>{
        if (!encoderReportsData) return;
        const headers = [
            'Encoder',
            'Resolution',
            'Bitrate',
            'Frame Rate',
            'Aspect Ratio',
            'Captions',
            'Published Events',
            'Total Duration (minutes)',
            'Avg Duration (minutes)'
        ];
        const rows = encoderReportsData.vod.byEncoder.map((row)=>[
                row.simpleName,
                (0, _format.formatStreamField)(row.streamInfo, 'resolution'),
                (0, _format.formatStreamField)(row.streamInfo, 'bitrate'),
                (0, _format.formatStreamField)(row.streamInfo, 'frameRate'),
                (0, _format.formatStreamField)(row.streamInfo, 'aspectRatio'),
                (0, _format.formatStreamField)(row.streamInfo, 'hasCaptions'),
                row.publishedEventCount.toString(),
                row.totalDurationMinutes.toString(),
                row.avgDurationMinutes.toString()
            ]);
        rows.push([
            'TOTAL',
            '',
            '',
            '',
            '',
            '',
            encoderReportsData.vod.totals.publishedEventCount.toString(),
            encoderReportsData.vod.totals.totalDurationMinutes.toString(),
            encoderReportsData.vod.totals.avgDurationMinutes.toString()
        ]);
        (0, _csv.downloadCSV)(`vod_by_encoder_${getClientFileName()}${getCategorySuffix()}_${encoderReportsData.dateRange.start}_to_${encoderReportsData.dateRange.end}.csv`, headers, rows, buildReportMeta(encoderReportsData.dateRange.start, encoderReportsData.dateRange.end));
    };
    // CSV Export - All Clients
    const handleExportAllClients = ()=>{
        if (!allClientsData) return;
        const headers = [
            'Client ID',
            'Client Name',
            'Live Stream Events',
            'Live Stream Hours',
            'VOD Events',
            'VOD Hours'
        ];
        const rows = allClientsData.clients.map((client)=>[
                client.clientID,
                client.clientName,
                client.liveStreamEventCount.toString(),
                client.liveStreamDurationHours.toFixed(2),
                client.vodEventCount.toString(),
                client.vodDurationHours.toFixed(2)
            ]);
        rows.push([
            'GRAND TOTAL',
            `(${allClientsData.grandTotals.clientCount} clients)`,
            allClientsData.grandTotals.liveStreamEventCount.toString(),
            allClientsData.grandTotals.liveStreamDurationHours.toFixed(2),
            allClientsData.grandTotals.vodEventCount.toString(),
            allClientsData.grandTotals.vodDurationHours.toFixed(2)
        ]);
        (0, _csv.downloadCSV)(`event_reports_all_clients_${allClientsData.dateRange.start}_to_${allClientsData.dateRange.end}.csv`, headers, rows);
    };
    // Computed values
    const cacheTimestamp = allClients ? allClientsData?.cacheInfo?.cachedAt : groupByEncoder ? encoderReportsData?.cacheInfo?.cachedAt : reportsData?.cacheInfo?.cachedAt;
    const dateRange = allClients ? allClientsData?.dateRange : groupByEncoder ? encoderReportsData?.dateRange : reportsData?.dateRange;
    const clientID = groupByEncoder ? encoderReportsData?.clientID : reportsData?.clientID;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            className: "text-2xl font-semibold",
                            children: "Event Reports"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cacheTimestamp.CacheTimestamp), {
                            cachedAt: cacheTimestamp ?? null
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "border rounded-lg p-4 space-y-4 bg-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-xs font-medium text-muted-foreground uppercase tracking-wide",
                                    children: "Date Range"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-wrap gap-4 items-end",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePicker.DateRangePicker), {
                                        startDate: startDate,
                                        endDate: endDate,
                                        onStartDateChange: setStartDate,
                                        onEndDateChange: setEndDate,
                                        quickRange: quickRange,
                                        onQuickRangeChange: setQuickRange,
                                        onDateChange: ()=>setConfirmPending(false)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-xs font-medium text-muted-foreground uppercase tracking-wide",
                                    children: "Client & Options"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-wrap gap-x-4 gap-y-3 items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                                    id: "all-clients",
                                                    checked: allClients,
                                                    onCheckedChange: (checked)=>handleAllClientsChange(checked === true)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                                    htmlFor: "all-clients",
                                                    className: "cursor-pointer",
                                                    children: "All Clients"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-muted-foreground",
                                            children: "or"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientSelector.ClientSelector), {
                                            value: selectedClientId,
                                            onChange: handleClientChange,
                                            className: "min-w-[250px]",
                                            label: "",
                                            disabled: allClients
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _categorySelector.CategorySelector), {
                                            categories: categories,
                                            value: selectedCategoryId,
                                            onChange: handleCategoryChange,
                                            disabled: allClients || !selectedClientId,
                                            className: "min-w-[220px]"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                                    id: "groupByEncoder",
                                                    checked: groupByEncoder,
                                                    onCheckedChange: handleGroupByEncoderChange,
                                                    disabled: allClients
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                                    htmlFor: "groupByEncoder",
                                                    className: `cursor-pointer ${allClients ? 'text-muted-foreground' : ''}`,
                                                    children: "Group by Encoder"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            onClick: handleGenerateReport,
                                            disabled: !canGenerateReport || loading,
                                            variant: confirmPending ? 'destructive' : 'default',
                                            className: "min-w-[175px]",
                                            children: loading ? 'Loading...' : confirmPending ? 'Click to Confirm' : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FileSpreadsheet), {
                                                        className: "mr-2 h-4 w-4"
                                                    }),
                                                    "Generate Report"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetFiltersButton.ResetFiltersButton), {
                                            routePath: "/events/reports",
                                            defaultValues: {
                                                clientID: undefined,
                                                categoryID: undefined,
                                                startDate: undefined,
                                                endDate: undefined,
                                                quickRange: undefined,
                                                groupByEncoder: false,
                                                allClients: false
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "p-4 bg-red-100 border-l-4 border-red-600 rounded",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "m-0 text-red-800 font-medium",
                        children: [
                            "Error: ",
                            error
                        ]
                    })
                }),
                reportsData && !groupByEncoder && !allClients && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "space-y-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterSummary.FilterSummary), {
                            clientID: clientID,
                            start: dateRange?.start,
                            end: dateRange?.end,
                            categoryName: selectedCategory ? selectedCategory.displayName?.trim() || selectedCategory.categoryName : null
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                            className: "text-lg font-semibold",
                                            children: "Live Streams"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            variant: "outline",
                                            size: "sm",
                                            onClick: handleExportLiveStreams,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                                    className: "mr-2 h-4 w-4"
                                                }),
                                                "Export CSV"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rounded-md border",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Year"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Month"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Distinct Events"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Total Duration"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Avg Duration"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                                children: reportsData.liveStreams.monthly.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        colSpan: 5,
                                                        className: "text-center text-muted-foreground",
                                                        children: "No live stream data for this period"
                                                    })
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        reportsData.liveStreams.monthly.map((row, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: row.year
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: (0, _date.getMonthName)(row.month)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: row.distinctEventCount
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: (0, _date.formatDuration)(row.totalDurationMinutes)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: (0, _date.formatDuration)(row.avgDurationMinutes)
                                                                    })
                                                                ]
                                                            }, idx)),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                            className: "bg-muted/50 font-semibold",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    colSpan: 2,
                                                                    children: "Total"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: reportsData.liveStreams.totals.distinctEventCount
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: (0, _date.formatDuration)(reportsData.liveStreams.totals.totalDurationMinutes)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: (0, _date.formatDuration)(reportsData.liveStreams.totals.avgDurationMinutes)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                            className: "text-lg font-semibold",
                                            children: "VOD (Published Events)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            variant: "outline",
                                            size: "sm",
                                            onClick: handleExportVOD,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                                    className: "mr-2 h-4 w-4"
                                                }),
                                                "Export CSV"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rounded-md border",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Year"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Month"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Published Events"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Total Duration"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Avg Duration"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                                children: reportsData.vod.monthly.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        colSpan: 5,
                                                        className: "text-center text-muted-foreground",
                                                        children: "No VOD data for this period"
                                                    })
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        reportsData.vod.monthly.map((row, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: row.year
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: (0, _date.getMonthName)(row.month)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: row.publishedEventCount
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: (0, _date.formatDuration)(row.totalDurationMinutes)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: (0, _date.formatDuration)(row.avgDurationMinutes)
                                                                    })
                                                                ]
                                                            }, idx)),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                            className: "bg-muted/50 font-semibold",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    colSpan: 2,
                                                                    children: "Total"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: reportsData.vod.totals.publishedEventCount
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: (0, _date.formatDuration)(reportsData.vod.totals.totalDurationMinutes)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: (0, _date.formatDuration)(reportsData.vod.totals.avgDurationMinutes)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                encoderReportsData && groupByEncoder && !allClients && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "space-y-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterSummary.FilterSummary), {
                            clientID: clientID,
                            start: dateRange?.start,
                            end: dateRange?.end,
                            categoryName: selectedCategory ? selectedCategory.displayName?.trim() || selectedCategory.categoryName : null
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _encoderLiveStreamsTable.EncoderLiveStreamsTable), {
                            data: sortedLiveStreams,
                            totals: encoderReportsData.liveStreams.totals,
                            sortField: liveStreamSort,
                            sortDirection: liveStreamSortDir,
                            onSort: handleLiveStreamSort,
                            onExport: handleExportLiveStreamsByEncoder
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _encoderVODTable.EncoderVODTable), {
                            data: sortedVOD,
                            totals: encoderReportsData.vod.totals,
                            multiEncoderEventCount: encoderReportsData.vod.multiEncoderEventCount,
                            sortField: vodSort,
                            sortDirection: vodSortDir,
                            onSort: handleVodSort,
                            onExport: handleExportVODByEncoder
                        })
                    ]
                }),
                allClientsData && allClients && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "space-y-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-sm text-muted-foreground",
                            children: [
                                "All Clients Report from ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                    variant: "outline",
                                    className: "text-xs font-mono",
                                    children: [
                                        allClientsData.dateRange.start,
                                        " to ",
                                        allClientsData.dateRange.end
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                            className: "text-lg font-semibold",
                                            children: "Event Reports - All Clients"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            variant: "outline",
                                            size: "sm",
                                            onClick: handleExportAllClients,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                                    className: "mr-2 h-4 w-4"
                                                }),
                                                "Export CSV"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rounded-md border",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Client ID"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Client Name"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Live Stream Events"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Live Stream Hours"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "VOD Events"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "VOD Hours"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                                children: allClientsData.clients.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        colSpan: 6,
                                                        className: "text-center text-muted-foreground",
                                                        children: "No event data for this period"
                                                    })
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        allClientsData.clients.map((client)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: client.clientID
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: client.clientName
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: client.liveStreamEventCount.toLocaleString()
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: client.liveStreamDurationHours.toFixed(2)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: client.vodEventCount.toLocaleString()
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: client.vodDurationHours.toFixed(2)
                                                                    })
                                                                ]
                                                            }, client.clientID)),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                            className: "bg-muted/50 font-semibold",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    children: "Grand Total"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableCell), {
                                                                    className: "text-muted-foreground",
                                                                    children: [
                                                                        "(",
                                                                        allClientsData.grandTotals.clientCount,
                                                                        " clients)"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: allClientsData.grandTotals.liveStreamEventCount.toLocaleString()
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: allClientsData.grandTotals.liveStreamDurationHours.toFixed(2)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: allClientsData.grandTotals.vodEventCount.toLocaleString()
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: allClientsData.grandTotals.vodDurationHours.toFixed(2)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useNavigate","aMhxM"],["useSearch","4yVFL"]],"@auth0/auth0-react":"gpXrE","../../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/config":"8SWgh","@/client/lib/date":"7ZbER","@/client/lib/searchParams":"fgK0T","@/client/hooks/usePersistedSearch":"kPA60","@/client/components/reset-filters-button":"9d8BP","@/client/lib/format":"iLptT","@/client/lib/csv":"2NpE4","lucide-react":[["Download","eRiW1","default"],["FileSpreadsheet","fkevk","default"]],"@/client/components/ui/badge":"h4e1f","@/client/components/ui/button":"armlb","@/client/components/ui/checkbox":"fh9Pm","@/client/components/ui/label":"cLMZq","@/client/components/cache-timestamp":"f5Zyx","@/client/components/ui/table":"5vxZ8","@/client/components/client-selector":"gxoYe","@/client/components/category-selector":"8lMmB","@/client/components/date-range-picker":"iSBDP","./components/EncoderLiveStreamsTable":"1p6Zf","./components/EncoderVODTable":"8FNpO","./components/FilterSummary":"duJpi","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fh9Pm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactCheckbox = require("@radix-ui/react-checkbox");
var _lucideReact = require("lucide-react");
var _utils = require("@/client/lib/utils");
const Checkbox = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactCheckbox.Root, {
        ref: ref,
        className: (0, _utils.cn)("grid place-content-center peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground", className),
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactCheckbox.Indicator, {
            className: (0, _utils.cn)("grid place-content-center text-current"),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                className: "h-4 w-4"
            })
        })
    }));
Checkbox.displayName = _reactCheckbox.Root.displayName;

},{"react/jsx-runtime":"dQjte","react":"eGun2","@radix-ui/react-checkbox":"32T5U","lucide-react":[["Check","bajJU","default"]],"@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"32T5U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
parcelHelpers.export(exports, "CheckboxIndicator", ()=>CheckboxIndicator);
parcelHelpers.export(exports, "Indicator", ()=>CheckboxIndicator);
parcelHelpers.export(exports, "Root", ()=>Checkbox);
parcelHelpers.export(exports, "createCheckboxScope", ()=>createCheckboxScope);
parcelHelpers.export(exports, "unstable_BubbleInput", ()=>CheckboxBubbleInput);
parcelHelpers.export(exports, "unstable_CheckboxBubbleInput", ()=>CheckboxBubbleInput);
parcelHelpers.export(exports, "unstable_CheckboxProvider", ()=>CheckboxProvider);
parcelHelpers.export(exports, "unstable_CheckboxTrigger", ()=>CheckboxTrigger);
parcelHelpers.export(exports, "unstable_Provider", ()=>CheckboxProvider);
parcelHelpers.export(exports, "unstable_Trigger", ()=>CheckboxTrigger);
// src/checkbox.tsx
var _react = require("react");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactContext = require("@radix-ui/react-context");
var _primitive = require("@radix-ui/primitive");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _reactUsePrevious = require("@radix-ui/react-use-previous");
var _reactUseSize = require("@radix-ui/react-use-size");
var _reactPresence = require("@radix-ui/react-presence");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var CHECKBOX_NAME = "Checkbox";
var [createCheckboxContext, createCheckboxScope] = (0, _reactContext.createContextScope)(CHECKBOX_NAME);
var [CheckboxProviderImpl, useCheckboxContext] = createCheckboxContext(CHECKBOX_NAME);
function CheckboxProvider(props) {
    const { __scopeCheckbox, checked: checkedProp, children, defaultChecked, disabled, form, name, onCheckedChange, required, value = "on", // @ts-expect-error
    internal_do_not_use_render } = props;
    const [checked, setChecked] = (0, _reactUseControllableState.useControllableState)({
        prop: checkedProp,
        defaultProp: defaultChecked ?? false,
        onChange: onCheckedChange,
        caller: CHECKBOX_NAME
    });
    const [control, setControl] = _react.useState(null);
    const [bubbleInput, setBubbleInput] = _react.useState(null);
    const hasConsumerStoppedPropagationRef = _react.useRef(false);
    const isFormControl = control ? !!form || !!control.closest("form") : // We set this to true by default so that events bubble to forms without JS (SSR)
    true;
    const context = {
        checked,
        disabled,
        setChecked,
        control,
        setControl,
        name,
        form,
        value,
        hasConsumerStoppedPropagationRef,
        required,
        defaultChecked: isIndeterminate(defaultChecked) ? false : defaultChecked,
        isFormControl,
        bubbleInput,
        setBubbleInput
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CheckboxProviderImpl, {
        scope: __scopeCheckbox,
        ...context,
        children: isFunction(internal_do_not_use_render) ? internal_do_not_use_render(context) : children
    });
}
var TRIGGER_NAME = "CheckboxTrigger";
var CheckboxTrigger = _react.forwardRef(({ __scopeCheckbox, onKeyDown, onClick, ...checkboxProps }, forwardedRef)=>{
    const { control, value, disabled, checked, required, setControl, setChecked, hasConsumerStoppedPropagationRef, isFormControl, bubbleInput } = useCheckboxContext(TRIGGER_NAME, __scopeCheckbox);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, setControl);
    const initialCheckedStateRef = _react.useRef(checked);
    _react.useEffect(()=>{
        const form = control?.form;
        if (form) {
            const reset = ()=>setChecked(initialCheckedStateRef.current);
            form.addEventListener("reset", reset);
            return ()=>form.removeEventListener("reset", reset);
        }
    }, [
        control,
        setChecked
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).button, {
        type: "button",
        role: "checkbox",
        "aria-checked": isIndeterminate(checked) ? "mixed" : checked,
        "aria-required": required,
        "data-state": getState(checked),
        "data-disabled": disabled ? "" : void 0,
        disabled,
        value,
        ...checkboxProps,
        ref: composedRefs,
        onKeyDown: (0, _primitive.composeEventHandlers)(onKeyDown, (event)=>{
            if (event.key === "Enter") event.preventDefault();
        }),
        onClick: (0, _primitive.composeEventHandlers)(onClick, (event)=>{
            setChecked((prevChecked)=>isIndeterminate(prevChecked) ? true : !prevChecked);
            if (bubbleInput && isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    });
});
CheckboxTrigger.displayName = TRIGGER_NAME;
var Checkbox = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox, name, checked, defaultChecked, required, disabled, value, onCheckedChange, form, ...checkboxProps } = props;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CheckboxProvider, {
        __scopeCheckbox,
        checked,
        defaultChecked,
        disabled,
        required,
        onCheckedChange,
        name,
        form,
        value,
        internal_do_not_use_render: ({ isFormControl })=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)(CheckboxTrigger, {
                        ...checkboxProps,
                        ref: forwardedRef,
                        __scopeCheckbox
                    }),
                    isFormControl && /* @__PURE__ */ (0, _jsxRuntime.jsx)(CheckboxBubbleInput, {
                        __scopeCheckbox
                    })
                ]
            })
    });
});
Checkbox.displayName = CHECKBOX_NAME;
var INDICATOR_NAME = "CheckboxIndicator";
var CheckboxIndicator = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox, forceMount, ...indicatorProps } = props;
    const context = useCheckboxContext(INDICATOR_NAME, __scopeCheckbox);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
        present: forceMount || isIndeterminate(context.checked) || context.checked === true,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).span, {
            "data-state": getState(context.checked),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "none",
                ...props.style
            }
        })
    });
});
CheckboxIndicator.displayName = INDICATOR_NAME;
var BUBBLE_INPUT_NAME = "CheckboxBubbleInput";
var CheckboxBubbleInput = _react.forwardRef(({ __scopeCheckbox, ...props }, forwardedRef)=>{
    const { control, hasConsumerStoppedPropagationRef, checked, defaultChecked, required, disabled, name, value, form, bubbleInput, setBubbleInput } = useCheckboxContext(BUBBLE_INPUT_NAME, __scopeCheckbox);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, setBubbleInput);
    const prevChecked = (0, _reactUsePrevious.usePrevious)(checked);
    const controlSize = (0, _reactUseSize.useSize)(control);
    _react.useEffect(()=>{
        const input = bubbleInput;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        const bubbles = !hasConsumerStoppedPropagationRef.current;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles
            });
            input.indeterminate = isIndeterminate(checked);
            setChecked.call(input, isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        bubbleInput,
        prevChecked,
        checked,
        hasConsumerStoppedPropagationRef
    ]);
    const defaultCheckedRef = _react.useRef(isIndeterminate(checked) ? false : checked);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).input, {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: defaultChecked ?? defaultCheckedRef.current,
        required,
        disabled,
        name,
        value,
        form,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0,
            // We transform because the input is absolutely positioned but we have
            // rendered it **after** the button. This pulls it back to sit on top
            // of the button.
            transform: "translateX(-100%)"
        }
    });
});
CheckboxBubbleInput.displayName = BUBBLE_INPUT_NAME;
function isFunction(value) {
    return typeof value === "function";
}
function isIndeterminate(checked) {
    return checked === "indeterminate";
}
function getState(checked) {
    return isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}

},{"react":"eGun2","@radix-ui/react-compose-refs":"nN23r","@radix-ui/react-context":"4wywa","@radix-ui/primitive":"k8C5A","@radix-ui/react-use-controllable-state":"ThW7y","@radix-ui/react-use-previous":"5zGdn","@radix-ui/react-use-size":"1EkiK","@radix-ui/react-presence":"eh7qi","@radix-ui/react-primitive":"hQJ44","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gxoYe":[function(require,module,exports,__globalThis) {
/**
 * ClientSelector - Reusable combobox for selecting a client
 * Used in reports, trends, and other pages that need client selection
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientSelector", ()=>ClientSelector);
/**
 * Hook for managing client selection state
 * Returns state and handlers for use with ClientSelector
 */ parcelHelpers.export(exports, "useClientSelection", ()=>useClientSelection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _auth0React = require("@auth0/auth0-react");
var _lucideReact = require("lucide-react");
var _clientsStore = require("@/client/store/clientsStore");
var _utils = require("@/client/lib/utils");
var _button = require("@/client/components/ui/button");
var _command = require("@/client/components/ui/command");
var _popover = require("@/client/components/ui/popover");
function ClientSelector({ value, onChange, activeOnly = true, label = 'Client', className, disabled = false }) {
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    const { clients, fetchClients } = (0, _clientsStore.useClientsStore)();
    const [open, setOpen] = (0, _react.useState)(false);
    // Load clients on mount
    (0, _react.useEffect)(()=>{
        const loadClients = async ()=>{
            try {
                const token = await getAccessTokenSilently();
                await fetchClients(token, logout);
            } catch (err) {
                console.error('Error fetching clients:', err);
            }
        };
        loadClients();
    }, [
        getAccessTokenSilently,
        fetchClients
    ]);
    // Filter to active clients if requested
    const filteredClients = (0, _react.useMemo)(()=>{
        return activeOnly ? clients.filter((c)=>c.active === 1) : clients;
    }, [
        clients,
        activeOnly
    ]);
    const selectedClient = (0, _react.useMemo)(()=>{
        return filteredClients.find((c)=>c.clientID === value) || null;
    }, [
        filteredClients,
        value
    ]);
    const handleSelect = (clientId)=>{
        const newValue = clientId === value ? '' : clientId;
        const client = newValue ? filteredClients.find((c)=>c.clientID === newValue) || null : null;
        onChange(newValue, client);
        setOpen(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _utils.cn)('flex flex-col gap-2', className),
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "text-sm font-medium",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _popover.Popover), {
                open: open,
                onOpenChange: setOpen,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.PopoverTrigger), {
                        asChild: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                            variant: "outline",
                            role: "combobox",
                            "aria-expanded": open,
                            disabled: disabled,
                            className: "h-10 w-full justify-between font-normal overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "truncate",
                                    children: value ? `${value} - ${selectedClient?.name}` : 'Select client...'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronsUpDown), {
                                    className: "ml-2 h-4 w-4 shrink-0 opacity-50"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.PopoverContent), {
                        className: "w-[--radix-popover-trigger-width] min-w-[320px] p-0",
                        align: "start",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _command.Command), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _command.CommandInput), {
                                    placeholder: "Search clients..."
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _command.CommandList), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _command.CommandEmpty), {
                                            children: "No client found."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _command.CommandGroup), {
                                            children: filteredClients.map((client)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _command.CommandItem), {
                                                    value: `${client.clientID} ${client.name}`,
                                                    onSelect: ()=>handleSelect(client.clientID),
                                                    className: (0, _utils.cn)(value === client.clientID && 'bg-accent'),
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "font-mono text-muted-foreground shrink-0",
                                                            children: client.clientID
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "truncate",
                                                            children: client.name
                                                        })
                                                    ]
                                                }, client.clientID))
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
function useClientSelection() {
    const [selectedClientId, setSelectedClientId] = (0, _react.useState)('');
    const [selectedClient, setSelectedClient] = (0, _react.useState)(null);
    const handleClientChange = (clientId, client)=>{
        setSelectedClientId(clientId);
        setSelectedClient(client);
    };
    return {
        selectedClientId,
        selectedClient,
        handleClientChange,
        clearSelection: ()=>{
            setSelectedClientId('');
            setSelectedClient(null);
        }
    };
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@auth0/auth0-react":"gpXrE","lucide-react":[["ChevronsUpDown","jOJ7v","default"]],"@/client/store/clientsStore":"6bg3l","@/client/lib/utils":"1ankz","@/client/components/ui/button":"armlb","@/client/components/ui/command":"eBVvu","@/client/components/ui/popover":"aASXh","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jOJ7v":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronsUpDown);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m7 15 5 5 5-5",
            key: "1hf1tw"
        }
    ],
    [
        "path",
        {
            d: "m7 9 5-5 5 5",
            key: "sgt6xg"
        }
    ]
];
const ChevronsUpDown = (0, _createLucideIconJsDefault.default)("chevrons-up-down", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eBVvu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Command", ()=>Command);
parcelHelpers.export(exports, "CommandDialog", ()=>CommandDialog);
parcelHelpers.export(exports, "CommandInput", ()=>CommandInput);
parcelHelpers.export(exports, "CommandList", ()=>CommandList);
parcelHelpers.export(exports, "CommandEmpty", ()=>CommandEmpty);
parcelHelpers.export(exports, "CommandGroup", ()=>CommandGroup);
parcelHelpers.export(exports, "CommandItem", ()=>CommandItem);
parcelHelpers.export(exports, "CommandShortcut", ()=>CommandShortcut);
parcelHelpers.export(exports, "CommandSeparator", ()=>CommandSeparator);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _cmdk = require("cmdk");
var _lucideReact = require("lucide-react");
var _utils = require("@/client/lib/utils");
var _dialog = require("@/client/components/ui/dialog");
"use client";
const Command = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cmdk.Command), {
        ref: ref,
        className: (0, _utils.cn)("flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground", className),
        ...props
    }));
Command.displayName = (0, _cmdk.Command).displayName;
const CommandDialog = ({ children, ...props })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.DialogContent), {
            className: "overflow-hidden p-0 shadow-lg",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Command, {
                className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5",
                children: children
            })
        })
    });
};
const CommandInput = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center border-b px-3",
        "cmdk-input-wrapper": "",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Search), {
                className: "mr-2 h-4 w-4 shrink-0 opacity-50"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cmdk.Command).Input, {
                ref: ref,
                className: (0, _utils.cn)("flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50", className),
                ...props
            })
        ]
    }));
CommandInput.displayName = (0, _cmdk.Command).Input.displayName;
const CommandList = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cmdk.Command).List, {
        ref: ref,
        className: (0, _utils.cn)("max-h-[300px] overflow-y-auto overflow-x-hidden", className),
        ...props
    }));
CommandList.displayName = (0, _cmdk.Command).List.displayName;
const CommandEmpty = /*#__PURE__*/ _react.forwardRef((props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cmdk.Command).Empty, {
        ref: ref,
        className: "py-6 text-center text-sm",
        ...props
    }));
CommandEmpty.displayName = (0, _cmdk.Command).Empty.displayName;
const CommandGroup = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cmdk.Command).Group, {
        ref: ref,
        className: (0, _utils.cn)("overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground", className),
        ...props
    }));
CommandGroup.displayName = (0, _cmdk.Command).Group.displayName;
const CommandSeparator = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cmdk.Command).Separator, {
        ref: ref,
        className: (0, _utils.cn)("-mx-1 h-px bg-border", className),
        ...props
    }));
CommandSeparator.displayName = (0, _cmdk.Command).Separator.displayName;
const CommandItem = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cmdk.Command).Item, {
        ref: ref,
        className: (0, _utils.cn)("relative flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected='true']:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", className),
        ...props
    }));
CommandItem.displayName = (0, _cmdk.Command).Item.displayName;
const CommandShortcut = ({ className, ...props })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _utils.cn)("ml-auto text-xs tracking-widest text-muted-foreground", className),
        ...props
    });
};
CommandShortcut.displayName = "CommandShortcut";

},{"react/jsx-runtime":"dQjte","react":"eGun2","cmdk":"hs1XE","lucide-react":[["Search","7AEK5","default"]],"@/client/lib/utils":"1ankz","@/client/components/ui/dialog":"6jjic","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hs1XE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Command", ()=>_e);
parcelHelpers.export(exports, "CommandDialog", ()=>xe);
parcelHelpers.export(exports, "CommandEmpty", ()=>Ie);
parcelHelpers.export(exports, "CommandGroup", ()=>Ee);
parcelHelpers.export(exports, "CommandInput", ()=>Se);
parcelHelpers.export(exports, "CommandItem", ()=>he);
parcelHelpers.export(exports, "CommandList", ()=>Ce);
parcelHelpers.export(exports, "CommandLoading", ()=>Pe);
parcelHelpers.export(exports, "CommandRoot", ()=>me);
parcelHelpers.export(exports, "CommandSeparator", ()=>ye);
parcelHelpers.export(exports, "defaultFilter", ()=>Re);
parcelHelpers.export(exports, "useCommandState", ()=>P);
var _chunkNZJY6EH4Mjs = require("./chunk-NZJY6EH4.mjs");
var _reactDialog = require("@radix-ui/react-dialog");
var _react = require("react");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactId = require("@radix-ui/react-id");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
"use client";
var N = '[cmdk-group=""]', Y = '[cmdk-group-items=""]', be = '[cmdk-group-heading=""]', le = '[cmdk-item=""]', ce = `${le}:not([aria-disabled="true"])`, Z = "cmdk-item-select", T = "data-value", Re = (r, o, n)=>(0, _chunkNZJY6EH4Mjs.a)(r, o, n), ue = _react.createContext(void 0), K = ()=>_react.useContext(ue), de = _react.createContext(void 0), ee = ()=>_react.useContext(de), fe = _react.createContext(void 0), me = _react.forwardRef((r, o)=>{
    let n = L(()=>{
        var e, a;
        return {
            search: "",
            value: (a = (e = r.value) != null ? e : r.defaultValue) != null ? a : "",
            selectedItemId: void 0,
            filtered: {
                count: 0,
                items: new Map,
                groups: new Set
            }
        };
    }), u = L(()=>new Set), c = L(()=>new Map), d = L(()=>new Map), f = L(()=>new Set), p = pe(r), { label: b, children: m, value: R, onValueChange: x, filter: C, shouldFilter: S, loop: A, disablePointerSelection: ge = !1, vimBindings: j = !0, ...O } = r, $ = (0, _reactId.useId)(), q = (0, _reactId.useId)(), _ = (0, _reactId.useId)(), I = _react.useRef(null), v = ke();
    k(()=>{
        if (R !== void 0) {
            let e = R.trim();
            n.current.value = e, E.emit();
        }
    }, [
        R
    ]), k(()=>{
        v(6, ne);
    }, []);
    let E = _react.useMemo(()=>({
            subscribe: (e)=>(f.current.add(e), ()=>f.current.delete(e)),
            snapshot: ()=>n.current,
            setState: (e, a, s)=>{
                var i, l, g, y;
                if (!Object.is(n.current[e], a)) {
                    if (n.current[e] = a, e === "search") J(), z(), v(1, W);
                    else if (e === "value") {
                        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
                            let h = document.getElementById(_);
                            h ? h.focus() : (i = document.getElementById($)) == null || i.focus();
                        }
                        if (v(7, ()=>{
                            var h;
                            n.current.selectedItemId = (h = M()) == null ? void 0 : h.id, E.emit();
                        }), s || v(5, ne), ((l = p.current) == null ? void 0 : l.value) !== void 0) {
                            let h = a != null ? a : "";
                            (y = (g = p.current).onValueChange) == null || y.call(g, h);
                            return;
                        }
                    }
                    E.emit();
                }
            },
            emit: ()=>{
                f.current.forEach((e)=>e());
            }
        }), []), U = _react.useMemo(()=>({
            value: (e, a, s)=>{
                var i;
                a !== ((i = d.current.get(e)) == null ? void 0 : i.value) && (d.current.set(e, {
                    value: a,
                    keywords: s
                }), n.current.filtered.items.set(e, te(a, s)), v(2, ()=>{
                    z(), E.emit();
                }));
            },
            item: (e, a)=>(u.current.add(e), a && (c.current.has(a) ? c.current.get(a).add(e) : c.current.set(a, new Set([
                    e
                ]))), v(3, ()=>{
                    J(), z(), n.current.value || W(), E.emit();
                }), ()=>{
                    d.current.delete(e), u.current.delete(e), n.current.filtered.items.delete(e);
                    let s = M();
                    v(4, ()=>{
                        J(), (s == null ? void 0 : s.getAttribute("id")) === e && W(), E.emit();
                    });
                }),
            group: (e)=>(c.current.has(e) || c.current.set(e, new Set), ()=>{
                    d.current.delete(e), c.current.delete(e);
                }),
            filter: ()=>p.current.shouldFilter,
            label: b || r["aria-label"],
            getDisablePointerSelection: ()=>p.current.disablePointerSelection,
            listId: $,
            inputId: _,
            labelId: q,
            listInnerRef: I
        }), []);
    function te(e, a) {
        var i, l;
        let s = (l = (i = p.current) == null ? void 0 : i.filter) != null ? l : Re;
        return e ? s(e, n.current.search, a) : 0;
    }
    function z() {
        if (!n.current.search || p.current.shouldFilter === !1) return;
        let e = n.current.filtered.items, a = [];
        n.current.filtered.groups.forEach((i)=>{
            let l = c.current.get(i), g = 0;
            l.forEach((y)=>{
                let h = e.get(y);
                g = Math.max(h, g);
            }), a.push([
                i,
                g
            ]);
        });
        let s = I.current;
        V().sort((i, l)=>{
            var h, F;
            let g = i.getAttribute("id"), y = l.getAttribute("id");
            return ((h = e.get(y)) != null ? h : 0) - ((F = e.get(g)) != null ? F : 0);
        }).forEach((i)=>{
            let l = i.closest(Y);
            l ? l.appendChild(i.parentElement === l ? i : i.closest(`${Y} > *`)) : s.appendChild(i.parentElement === s ? i : i.closest(`${Y} > *`));
        }), a.sort((i, l)=>l[1] - i[1]).forEach((i)=>{
            var g;
            let l = (g = I.current) == null ? void 0 : g.querySelector(`${N}[${T}="${encodeURIComponent(i[0])}"]`);
            l == null || l.parentElement.appendChild(l);
        });
    }
    function W() {
        let e = V().find((s)=>s.getAttribute("aria-disabled") !== "true"), a = e == null ? void 0 : e.getAttribute(T);
        E.setState("value", a || void 0);
    }
    function J() {
        var a, s, i, l;
        if (!n.current.search || p.current.shouldFilter === !1) {
            n.current.filtered.count = u.current.size;
            return;
        }
        n.current.filtered.groups = new Set;
        let e = 0;
        for (let g of u.current){
            let y = (s = (a = d.current.get(g)) == null ? void 0 : a.value) != null ? s : "", h = (l = (i = d.current.get(g)) == null ? void 0 : i.keywords) != null ? l : [], F = te(y, h);
            n.current.filtered.items.set(g, F), F > 0 && e++;
        }
        for (let [g, y] of c.current)for (let h of y)if (n.current.filtered.items.get(h) > 0) {
            n.current.filtered.groups.add(g);
            break;
        }
        n.current.filtered.count = e;
    }
    function ne() {
        var a, s, i;
        let e = M();
        e && (((a = e.parentElement) == null ? void 0 : a.firstChild) === e && ((i = (s = e.closest(N)) == null ? void 0 : s.querySelector(be)) == null || i.scrollIntoView({
            block: "nearest"
        })), e.scrollIntoView({
            block: "nearest"
        }));
    }
    function M() {
        var e;
        return (e = I.current) == null ? void 0 : e.querySelector(`${le}[aria-selected="true"]`);
    }
    function V() {
        var e;
        return Array.from(((e = I.current) == null ? void 0 : e.querySelectorAll(ce)) || []);
    }
    function X(e) {
        let s = V()[e];
        s && E.setState("value", s.getAttribute(T));
    }
    function Q(e) {
        var g;
        let a = M(), s = V(), i = s.findIndex((y)=>y === a), l = s[i + e];
        (g = p.current) != null && g.loop && (l = i + e < 0 ? s[s.length - 1] : i + e === s.length ? s[0] : s[i + e]), l && E.setState("value", l.getAttribute(T));
    }
    function re(e) {
        let a = M(), s = a == null ? void 0 : a.closest(N), i;
        for(; s && !i;)s = e > 0 ? we(s, N) : De(s, N), i = s == null ? void 0 : s.querySelector(ce);
        i ? E.setState("value", i.getAttribute(T)) : Q(e);
    }
    let oe = ()=>X(V().length - 1), ie = (e)=>{
        e.preventDefault(), e.metaKey ? oe() : e.altKey ? re(1) : Q(1);
    }, se = (e)=>{
        e.preventDefault(), e.metaKey ? X(0) : e.altKey ? re(-1) : Q(-1);
    };
    return _react.createElement((0, _reactPrimitive.Primitive).div, {
        ref: o,
        tabIndex: -1,
        ...O,
        "cmdk-root": "",
        onKeyDown: (e)=>{
            var s;
            (s = O.onKeyDown) == null || s.call(O, e);
            let a = e.nativeEvent.isComposing || e.keyCode === 229;
            if (!(e.defaultPrevented || a)) switch(e.key){
                case "n":
                case "j":
                    j && e.ctrlKey && ie(e);
                    break;
                case "ArrowDown":
                    ie(e);
                    break;
                case "p":
                case "k":
                    j && e.ctrlKey && se(e);
                    break;
                case "ArrowUp":
                    se(e);
                    break;
                case "Home":
                    e.preventDefault(), X(0);
                    break;
                case "End":
                    e.preventDefault(), oe();
                    break;
                case "Enter":
                    {
                        e.preventDefault();
                        let i = M();
                        if (i) {
                            let l = new Event(Z);
                            i.dispatchEvent(l);
                        }
                    }
            }
        }
    }, _react.createElement("label", {
        "cmdk-label": "",
        htmlFor: U.inputId,
        id: U.labelId,
        style: Te
    }, b), B(r, (e)=>_react.createElement(de.Provider, {
            value: E
        }, _react.createElement(ue.Provider, {
            value: U
        }, e))));
}), he = _react.forwardRef((r, o)=>{
    var _, I;
    let n = (0, _reactId.useId)(), u = _react.useRef(null), c = _react.useContext(fe), d = K(), f = pe(r), p = (I = (_ = f.current) == null ? void 0 : _.forceMount) != null ? I : c == null ? void 0 : c.forceMount;
    k(()=>{
        if (!p) return d.item(n, c == null ? void 0 : c.id);
    }, [
        p
    ]);
    let b = ve(n, u, [
        r.value,
        r.children,
        u
    ], r.keywords), m = ee(), R = P((v)=>v.value && v.value === b.current), x = P((v)=>p || d.filter() === !1 ? !0 : v.search ? v.filtered.items.get(n) > 0 : !0);
    _react.useEffect(()=>{
        let v = u.current;
        if (!(!v || r.disabled)) return v.addEventListener(Z, C), ()=>v.removeEventListener(Z, C);
    }, [
        x,
        r.onSelect,
        r.disabled
    ]);
    function C() {
        var v, E;
        S(), (E = (v = f.current).onSelect) == null || E.call(v, b.current);
    }
    function S() {
        m.setState("value", b.current, !0);
    }
    if (!x) return null;
    let { disabled: A, value: ge, onSelect: j, forceMount: O, keywords: $, ...q } = r;
    return _react.createElement((0, _reactPrimitive.Primitive).div, {
        ref: (0, _reactComposeRefs.composeRefs)(u, o),
        ...q,
        id: n,
        "cmdk-item": "",
        role: "option",
        "aria-disabled": !!A,
        "aria-selected": !!R,
        "data-disabled": !!A,
        "data-selected": !!R,
        onPointerMove: A || d.getDisablePointerSelection() ? void 0 : S,
        onClick: A ? void 0 : C
    }, r.children);
}), Ee = _react.forwardRef((r, o)=>{
    let { heading: n, children: u, forceMount: c, ...d } = r, f = (0, _reactId.useId)(), p = _react.useRef(null), b = _react.useRef(null), m = (0, _reactId.useId)(), R = K(), x = P((S)=>c || R.filter() === !1 ? !0 : S.search ? S.filtered.groups.has(f) : !0);
    k(()=>R.group(f), []), ve(f, p, [
        r.value,
        r.heading,
        b
    ]);
    let C = _react.useMemo(()=>({
            id: f,
            forceMount: c
        }), [
        c
    ]);
    return _react.createElement((0, _reactPrimitive.Primitive).div, {
        ref: (0, _reactComposeRefs.composeRefs)(p, o),
        ...d,
        "cmdk-group": "",
        role: "presentation",
        hidden: x ? void 0 : !0
    }, n && _react.createElement("div", {
        ref: b,
        "cmdk-group-heading": "",
        "aria-hidden": !0,
        id: m
    }, n), B(r, (S)=>_react.createElement("div", {
            "cmdk-group-items": "",
            role: "group",
            "aria-labelledby": n ? m : void 0
        }, _react.createElement(fe.Provider, {
            value: C
        }, S))));
}), ye = _react.forwardRef((r, o)=>{
    let { alwaysRender: n, ...u } = r, c = _react.useRef(null), d = P((f)=>!f.search);
    return !n && !d ? null : _react.createElement((0, _reactPrimitive.Primitive).div, {
        ref: (0, _reactComposeRefs.composeRefs)(c, o),
        ...u,
        "cmdk-separator": "",
        role: "separator"
    });
}), Se = _react.forwardRef((r, o)=>{
    let { onValueChange: n, ...u } = r, c = r.value != null, d = ee(), f = P((m)=>m.search), p = P((m)=>m.selectedItemId), b = K();
    return _react.useEffect(()=>{
        r.value != null && d.setState("search", r.value);
    }, [
        r.value
    ]), _react.createElement((0, _reactPrimitive.Primitive).input, {
        ref: o,
        ...u,
        "cmdk-input": "",
        autoComplete: "off",
        autoCorrect: "off",
        spellCheck: !1,
        "aria-autocomplete": "list",
        role: "combobox",
        "aria-expanded": !0,
        "aria-controls": b.listId,
        "aria-labelledby": b.labelId,
        "aria-activedescendant": p,
        id: b.inputId,
        type: "text",
        value: c ? r.value : f,
        onChange: (m)=>{
            c || d.setState("search", m.target.value), n == null || n(m.target.value);
        }
    });
}), Ce = _react.forwardRef((r, o)=>{
    let { children: n, label: u = "Suggestions", ...c } = r, d = _react.useRef(null), f = _react.useRef(null), p = P((m)=>m.selectedItemId), b = K();
    return _react.useEffect(()=>{
        if (f.current && d.current) {
            let m = f.current, R = d.current, x, C = new ResizeObserver(()=>{
                x = requestAnimationFrame(()=>{
                    let S = m.offsetHeight;
                    R.style.setProperty("--cmdk-list-height", S.toFixed(1) + "px");
                });
            });
            return C.observe(m), ()=>{
                cancelAnimationFrame(x), C.unobserve(m);
            };
        }
    }, []), _react.createElement((0, _reactPrimitive.Primitive).div, {
        ref: (0, _reactComposeRefs.composeRefs)(d, o),
        ...c,
        "cmdk-list": "",
        role: "listbox",
        tabIndex: -1,
        "aria-activedescendant": p,
        "aria-label": u,
        id: b.listId
    }, B(r, (m)=>_react.createElement("div", {
            ref: (0, _reactComposeRefs.composeRefs)(f, b.listInnerRef),
            "cmdk-list-sizer": ""
        }, m)));
}), xe = _react.forwardRef((r, o)=>{
    let { open: n, onOpenChange: u, overlayClassName: c, contentClassName: d, container: f, ...p } = r;
    return _react.createElement(_reactDialog.Root, {
        open: n,
        onOpenChange: u
    }, _react.createElement(_reactDialog.Portal, {
        container: f
    }, _react.createElement(_reactDialog.Overlay, {
        "cmdk-overlay": "",
        className: c
    }), _react.createElement(_reactDialog.Content, {
        "aria-label": r.label,
        "cmdk-dialog": "",
        className: d
    }, _react.createElement(me, {
        ref: o,
        ...p
    }))));
}), Ie = _react.forwardRef((r, o)=>P((u)=>u.filtered.count === 0) ? _react.createElement((0, _reactPrimitive.Primitive).div, {
        ref: o,
        ...r,
        "cmdk-empty": "",
        role: "presentation"
    }) : null), Pe = _react.forwardRef((r, o)=>{
    let { progress: n, children: u, label: c = "Loading...", ...d } = r;
    return _react.createElement((0, _reactPrimitive.Primitive).div, {
        ref: o,
        ...d,
        "cmdk-loading": "",
        role: "progressbar",
        "aria-valuenow": n,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-label": c
    }, B(r, (f)=>_react.createElement("div", {
            "aria-hidden": !0
        }, f)));
}), _e = Object.assign(me, {
    List: Ce,
    Item: he,
    Input: Se,
    Group: Ee,
    Separator: ye,
    Dialog: xe,
    Empty: Ie,
    Loading: Pe
});
function we(r, o) {
    let n = r.nextElementSibling;
    for(; n;){
        if (n.matches(o)) return n;
        n = n.nextElementSibling;
    }
}
function De(r, o) {
    let n = r.previousElementSibling;
    for(; n;){
        if (n.matches(o)) return n;
        n = n.previousElementSibling;
    }
}
function pe(r) {
    let o = _react.useRef(r);
    return k(()=>{
        o.current = r;
    }), o;
}
var k = typeof window == "undefined" ? _react.useEffect : _react.useLayoutEffect;
function L(r) {
    let o = _react.useRef();
    return o.current === void 0 && (o.current = r()), o;
}
function P(r) {
    let o = ee(), n = ()=>r(o.snapshot());
    return _react.useSyncExternalStore(o.subscribe, n, n);
}
function ve(r, o, n, u = []) {
    let c = _react.useRef(), d = K();
    return k(()=>{
        var b;
        let f = (()=>{
            var m;
            for (let R of n){
                if (typeof R == "string") return R.trim();
                if (typeof R == "object" && "current" in R) return R.current ? (m = R.current.textContent) == null ? void 0 : m.trim() : c.current;
            }
        })(), p = u.map((m)=>m.trim());
        d.value(r, f, p), (b = o.current) == null || b.setAttribute(T, f), c.current = f;
    }), c;
}
var ke = ()=>{
    let [r, o] = _react.useState(), n = L(()=>new Map);
    return k(()=>{
        n.current.forEach((u)=>u()), n.current = new Map;
    }, [
        r
    ]), (u, c)=>{
        n.current.set(u, c), o({});
    };
};
function Me(r) {
    let o = r.type;
    return typeof o == "function" ? o(r.props) : "render" in o ? o.render(r.props) : r;
}
function B({ asChild: r, children: o }, n) {
    return r && _react.isValidElement(o) ? _react.cloneElement(Me(o), {
        ref: o.ref
    }, n(o.props.children)) : n(o);
}
var Te = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: "0"
};

},{"./chunk-NZJY6EH4.mjs":"a01Cn","@radix-ui/react-dialog":"3DJ7S","react":"eGun2","@radix-ui/react-primitive":"i36AJ","@radix-ui/react-id":"hoLx9","@radix-ui/react-compose-refs":"nN23r","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"a01Cn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>W);
var U = 1, Y = .9, H = .8, J = .17, p = .1, u = .999, $ = .9999;
var k = .99, m = /[\\\/_+.#"@\[\(\{&]/, B = /[\\\/_+.#"@\[\(\{&]/g, K = /[\s-]/, X = /[\s-]/g;
function G(_, C, h, P, A, f, O) {
    if (f === C.length) return A === _.length ? U : k;
    var T = `${A},${f}`;
    if (O[T] !== void 0) return O[T];
    for(var L = P.charAt(f), c = h.indexOf(L, A), S = 0, E, N, R, M; c >= 0;)E = G(_, C, h, P, c + 1, f + 1, O), E > S && (c === A ? E *= U : m.test(_.charAt(c - 1)) ? (E *= H, R = _.slice(A, c - 1).match(B), R && A > 0 && (E *= Math.pow(u, R.length))) : K.test(_.charAt(c - 1)) ? (E *= Y, M = _.slice(A, c - 1).match(X), M && A > 0 && (E *= Math.pow(u, M.length))) : (E *= J, A > 0 && (E *= Math.pow(u, c - A))), _.charAt(c) !== C.charAt(f) && (E *= $)), (E < p && h.charAt(c - 1) === P.charAt(f + 1) || P.charAt(f + 1) === P.charAt(f) && h.charAt(c - 1) !== P.charAt(f)) && (N = G(_, C, h, P, c + 1, f + 2, O), N * p > E && (E = N * p)), E > S && (S = E), c = h.indexOf(L, c + 1);
    return O[T] = S, S;
}
function D(_) {
    return _.toLowerCase().replace(X, " ");
}
function W(_, C, h) {
    return _ = h && h.length > 0 ? `${_ + " " + h.join(" ")}` : _, G(_, C, D(_), D(C), 0, 0, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7AEK5":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Search);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const Search = (0, _createLucideIconJsDefault.default)("search", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8lMmB":[function(require,module,exports,__globalThis) {
/**
 * CategorySelector - Searchable single-select for a client's categories.
 * Thin wrapper over the generic Combobox; the parent owns fetching and state.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CategorySelector", ()=>CategorySelector);
var _jsxRuntime = require("react/jsx-runtime");
var _combobox = require("@/client/components/ui/combobox");
function CategorySelector({ categories, value, onChange, disabled = false, className }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _combobox.Combobox), {
        items: categories,
        value: value,
        onChange: onChange,
        getKey: (c)=>String(c.categoryID),
        getLabel: (c)=>c.displayName?.trim() || c.categoryName,
        placeholder: "All categories",
        searchPlaceholder: "Search categories...",
        emptyText: "No categories found.",
        disabled: disabled,
        clearable: true,
        allOption: {
            label: 'All categories'
        },
        className: className
    });
}

},{"react/jsx-runtime":"dQjte","@/client/components/ui/combobox":"7WU0I","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7WU0I":[function(require,module,exports,__globalThis) {
/**
 * Combobox - Generic, data-agnostic searchable select built on the shadcn
 * Command + Popover scaffold. Extracted so client-scoped selectors (categories,
 * and future filters) can reuse the search UX without duplicating the scaffold.
 *
 * Supports a pinned "all" sentinel row and an inline clear affordance, both of
 * which resolve the selection to `undefined`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Combobox", ()=>Combobox);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _lucideReact = require("lucide-react");
var _utils = require("@/client/lib/utils");
var _button = require("@/client/components/ui/button");
var _command = require("@/client/components/ui/command");
var _popover = require("@/client/components/ui/popover");
function Combobox({ items, value, onChange, getKey, getLabel, renderItem, placeholder = 'Select...', searchPlaceholder = 'Search...', emptyText = 'No results found.', disabled = false, clearable = false, allOption, className }) {
    const [open, setOpen] = (0, _react.useState)(false);
    // Treat both undefined and '' (empty search param) as "no selection"
    const hasValue = value !== undefined && value !== '';
    const selectedItem = hasValue ? items.find((item)=>getKey(item) === value) : undefined;
    const triggerLabel = selectedItem ? getLabel(selectedItem) : allOption?.label ?? placeholder;
    const showClear = clearable && hasValue && !disabled;
    const handleSelect = (next)=>{
        onChange(next === value ? undefined : next);
        setOpen(false);
    };
    // Clear is a sibling of the trigger (not a descendant), so its click never
    // reaches the Popover trigger and cannot reopen the dropdown.
    const handleClear = (e)=>{
        e.stopPropagation();
        onChange(undefined);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _utils.cn)('flex flex-col gap-2', className),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _popover.Popover), {
            open: open,
            onOpenChange: setOpen,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.PopoverTrigger), {
                            asChild: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                variant: "outline",
                                role: "combobox",
                                "aria-expanded": open,
                                disabled: disabled,
                                className: (0, _utils.cn)('h-10 w-full justify-between font-normal overflow-hidden', showClear && 'pr-9'),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "truncate",
                                        children: triggerLabel
                                    }),
                                    !showClear && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronsUpDown), {
                                        className: "ml-2 h-4 w-4 shrink-0 opacity-50"
                                    })
                                ]
                            })
                        }),
                        showClear && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            "aria-label": "Clear selection",
                            onClick: handleClear,
                            className: "absolute right-2 top-1/2 -translate-y-1/2 rounded-sm opacity-60 hover:opacity-100 focus:outline-none focus-visible:ring-1 focus-visible:ring-ring",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.X), {
                                className: "h-4 w-4"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.PopoverContent), {
                    className: "w-[--radix-popover-trigger-width] min-w-[250px] p-0",
                    align: "start",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _command.Command), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _command.CommandInput), {
                                placeholder: searchPlaceholder
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _command.CommandList), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _command.CommandEmpty), {
                                        children: emptyText
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _command.CommandGroup), {
                                        children: [
                                            allOption && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _command.CommandItem), {
                                                value: allOption.label,
                                                onSelect: ()=>handleSelect(undefined),
                                                className: (0, _utils.cn)(!hasValue && 'bg-accent'),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                                                        className: (0, _utils.cn)('mr-2 h-4 w-4', !hasValue ? 'opacity-100' : 'opacity-0')
                                                    }),
                                                    allOption.label
                                                ]
                                            }),
                                            items.map((item)=>{
                                                const key = getKey(item);
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _command.CommandItem), {
                                                    value: `${getLabel(item)} ${key}`,
                                                    onSelect: ()=>handleSelect(key),
                                                    className: (0, _utils.cn)(value === key && 'bg-accent'),
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                                                            className: (0, _utils.cn)('mr-2 h-4 w-4', value === key ? 'opacity-100' : 'opacity-0')
                                                        }),
                                                        renderItem ? renderItem(item) : getLabel(item)
                                                    ]
                                                }, key);
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","lucide-react":[["Check","bajJU","default"],["ChevronsUpDown","jOJ7v","default"],["X","8HSxK","default"]],"@/client/lib/utils":"1ankz","@/client/components/ui/button":"armlb","@/client/components/ui/command":"eBVvu","@/client/components/ui/popover":"aASXh","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"iSBDP":[function(require,module,exports,__globalThis) {
/**
 * DateRangePicker - Reusable date range selection component
 * Includes quick range presets and manual date inputs
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Calculate date range for a given quick range preset
 */ parcelHelpers.export(exports, "getQuickRangeDates", ()=>getQuickRangeDates);
parcelHelpers.export(exports, "DateRangePicker", ()=>DateRangePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _dateFns = require("date-fns");
var _date = require("@/client/lib/date");
var _button = require("@/client/components/ui/button");
var _dropdownMenu = require("@/client/components/ui/dropdown-menu");
const QUICK_RANGE_LABELS = {
    'today': 'Today',
    'this-month': 'This Month',
    'last-month': 'Last Month',
    'this-year': 'This Year',
    'last-year': 'Last Year'
};
function getQuickRangeDates(range) {
    const now = new Date();
    let start;
    let end;
    switch(range){
        case 'today':
            start = now;
            end = now;
            break;
        case 'this-month':
            start = (0, _dateFns.startOfMonth)(now);
            end = (0, _dateFns.endOfMonth)(now);
            break;
        case 'last-month':
            {
                const lastMonth = (0, _dateFns.subMonths)(now, 1);
                start = (0, _dateFns.startOfMonth)(lastMonth);
                end = (0, _dateFns.endOfMonth)(lastMonth);
                break;
            }
        case 'this-year':
            start = (0, _dateFns.startOfYear)(now);
            end = (0, _dateFns.endOfYear)(now);
            break;
        case 'last-year':
            {
                const lastYear = (0, _dateFns.subYears)(now, 1);
                start = (0, _dateFns.startOfYear)(lastYear);
                end = (0, _dateFns.endOfYear)(lastYear);
                break;
            }
        default:
            start = now;
            end = now;
    }
    // Cap end date to today
    const today = new Date();
    if (end > today) end = today;
    return {
        start,
        end
    };
}
function DateRangePicker({ startDate, endDate, onStartDateChange, onEndDateChange, quickRange, onQuickRangeChange, availableRanges, showToday = true, onDateChange }) {
    const today = (0, _date.toISODateString)(new Date());
    // Determine which ranges to show
    const ranges = availableRanges ?? (showToday ? [
        'today',
        'this-month',
        'last-month',
        'this-year',
        'last-year'
    ] : [
        'this-month',
        'last-month',
        'this-year',
        'last-year'
    ]);
    const handleQuickRangeSelect = (range)=>{
        const { start, end } = getQuickRangeDates(range);
        onStartDateChange((0, _date.toISODateString)(start));
        onEndDateChange((0, _date.toISODateString)(end));
        onQuickRangeChange(range);
        onDateChange?.();
    };
    const handleStartDateChange = (value)=>{
        onStartDateChange(value);
        onQuickRangeChange(''); // Clear quick range when manually editing
        onDateChange?.();
    };
    const handleEndDateChange = (value)=>{
        onEndDateChange(value);
        onQuickRangeChange(''); // Clear quick range when manually editing
        onDateChange?.();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-2 flex-1 min-w-[140px]",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        className: "text-sm font-medium",
                        children: "Quick Range"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenu), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuTrigger), {
                                asChild: true,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                    variant: "outline",
                                    className: "h-10 w-full justify-between font-normal",
                                    children: [
                                        quickRange ? QUICK_RANGE_LABELS[quickRange] : 'Select...',
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                            className: "ml-2 h-4 w-4 opacity-50"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuContent), {
                                align: "start",
                                className: "w-[--radix-dropdown-menu-trigger-width]",
                                children: ranges.map((range)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                        onClick: ()=>handleQuickRangeSelect(range),
                                        children: QUICK_RANGE_LABELS[range]
                                    }, range))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-2 flex-1 min-w-[150px]",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        className: "text-sm font-medium",
                        children: "Start Date"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "date",
                        value: startDate,
                        onChange: (e)=>handleStartDateChange(e.target.value),
                        max: endDate || today,
                        className: "h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex flex-col gap-2 flex-1 min-w-[150px]",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        className: "text-sm font-medium",
                        children: "End Date"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "date",
                        value: endDate,
                        onChange: (e)=>handleEndDateChange(e.target.value),
                        min: startDate,
                        max: today,
                        className: "h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","lucide-react":[["ChevronDown","kVmgC","default"]],"date-fns":[["endOfMonth","jebKl"],["endOfYear","3VWAv"],["startOfMonth","dWW3L"],["startOfYear","Iolia"],["subMonths","5q4d5"],["subYears","7QRlr"]],"@/client/lib/date":"7ZbER","@/client/components/ui/button":"armlb","@/client/components/ui/dropdown-menu":"8ox96","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3VWAv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link endOfYear} function options.
 */ /**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ parcelHelpers.export(exports, "endOfYear", ()=>endOfYear);
var _toDateJs = require("./toDate.js");
function endOfYear(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
// Fallback for modularized imports:
exports.default = endOfYear;

},{"./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7QRlr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link subYears} function options.
 */ /**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 * @param options - An object with options
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ parcelHelpers.export(exports, "subYears", ()=>subYears);
var _addYearsJs = require("./addYears.js");
function subYears(date, amount, options) {
    return (0, _addYearsJs.addYears)(date, -amount, options);
}
// Fallback for modularized imports:
exports.default = subYears;

},{"./addYears.js":"740nc","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"740nc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addYears} function options.
 */ /**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type.
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 * @param options - The options
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ parcelHelpers.export(exports, "addYears", ()=>addYears);
var _addMonthsJs = require("./addMonths.js");
function addYears(date, amount, options) {
    return (0, _addMonthsJs.addMonths)(date, amount * 12, options);
}
// Fallback for modularized imports:
exports.default = addYears;

},{"./addMonths.js":"flPAZ","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1p6Zf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EncoderLiveStreamsTable", ()=>EncoderLiveStreamsTable);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _date = require("@/client/lib/date");
var _format = require("@/client/lib/format");
var _button = require("@/client/components/ui/button");
var _table = require("@/client/components/ui/table");
function EncoderLiveStreamsTable({ data, totals, sortField, sortDirection, onSort, onExport }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        className: "text-lg font-semibold",
                        children: "Live Streams by Encoder"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                        variant: "outline",
                        size: "sm",
                        onClick: onExport,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                className: "mr-2 h-4 w-4"
                            }),
                            "Export CSV"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "rounded-md border",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.SortableTableHead), {
                                        field: "simpleName",
                                        label: "Encoder",
                                        currentSort: sortField,
                                        currentDirection: sortDirection,
                                        onSort: onSort
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                        className: "whitespace-nowrap",
                                        children: "Resolution"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.SortableTableHead), {
                                        field: "bitrate",
                                        label: "Bitrate",
                                        currentSort: sortField,
                                        currentDirection: sortDirection,
                                        onSort: onSort,
                                        className: "whitespace-nowrap"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                        className: "whitespace-nowrap",
                                        children: "Frame Rate"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                        className: "whitespace-nowrap",
                                        children: "Aspect"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                        className: "whitespace-nowrap",
                                        children: "Captions"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.SortableTableHead), {
                                        field: "distinctEventCount",
                                        label: "Events",
                                        currentSort: sortField,
                                        currentDirection: sortDirection,
                                        onSort: onSort,
                                        className: "text-right whitespace-nowrap"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.SortableTableHead), {
                                        field: "totalDurationMinutes",
                                        label: "Total Dur",
                                        currentSort: sortField,
                                        currentDirection: sortDirection,
                                        onSort: onSort,
                                        className: "text-right whitespace-nowrap"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                        className: "text-right whitespace-nowrap",
                                        children: "Avg Dur"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                            children: data.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                    colSpan: 9,
                                    className: "text-center text-muted-foreground",
                                    children: "No live stream data for this period"
                                })
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    data.map((row, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "font-medium",
                                                    children: row.simpleName
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "whitespace-nowrap",
                                                    children: (0, _format.formatStreamField)(row.streamInfo, 'resolution')
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "whitespace-nowrap",
                                                    children: (0, _format.formatStreamField)(row.streamInfo, 'bitrate')
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "whitespace-nowrap",
                                                    children: (0, _format.formatStreamField)(row.streamInfo, 'frameRate')
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "whitespace-nowrap",
                                                    children: (0, _format.formatStreamField)(row.streamInfo, 'aspectRatio')
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "whitespace-nowrap",
                                                    children: (0, _format.formatStreamField)(row.streamInfo, 'hasCaptions')
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "text-right whitespace-nowrap",
                                                    children: row.distinctEventCount
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "text-right whitespace-nowrap",
                                                    children: (0, _date.formatDuration)(row.totalDurationMinutes)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "text-right whitespace-nowrap",
                                                    children: (0, _date.formatDuration)(row.avgDurationMinutes)
                                                })
                                            ]
                                        }, idx)),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                        className: "bg-muted/50 font-semibold",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                colSpan: 6,
                                                children: "Total"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                className: "text-right whitespace-nowrap",
                                                children: totals.distinctEventCount
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                className: "text-right whitespace-nowrap",
                                                children: (0, _date.formatDuration)(totals.totalDurationMinutes)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                className: "text-right whitespace-nowrap",
                                                children: (0, _date.formatDuration)(totals.avgDurationMinutes)
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","lucide-react":[["Download","eRiW1","default"]],"@/client/lib/date":"7ZbER","@/client/lib/format":"iLptT","@/client/components/ui/button":"armlb","@/client/components/ui/table":"5vxZ8","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8FNpO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EncoderVODTable", ()=>EncoderVODTable);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _date = require("@/client/lib/date");
var _format = require("@/client/lib/format");
var _button = require("@/client/components/ui/button");
var _table = require("@/client/components/ui/table");
function EncoderVODTable({ data, totals, multiEncoderEventCount, sortField, sortDirection, onSort, onExport }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        className: "text-lg font-semibold",
                        children: "VOD by Encoder"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                        variant: "outline",
                        size: "sm",
                        onClick: onExport,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                className: "mr-2 h-4 w-4"
                            }),
                            "Export CSV"
                        ]
                    })
                ]
            }),
            multiEncoderEventCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2 p-3 bg-yellow-50 border border-yellow-200 rounded-md text-sm text-yellow-800",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                        className: "h-4 w-4 flex-shrink-0"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        children: [
                            multiEncoderEventCount,
                            " event",
                            multiEncoderEventCount > 1 ? 's' : '',
                            " used multiple encoders - only primary encoder counted"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "rounded-md border",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.SortableTableHead), {
                                        field: "simpleName",
                                        label: "Encoder",
                                        currentSort: sortField,
                                        currentDirection: sortDirection,
                                        onSort: onSort
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                        className: "whitespace-nowrap",
                                        children: "Resolution"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.SortableTableHead), {
                                        field: "bitrate",
                                        label: "Bitrate",
                                        currentSort: sortField,
                                        currentDirection: sortDirection,
                                        onSort: onSort,
                                        className: "whitespace-nowrap"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                        className: "whitespace-nowrap",
                                        children: "Frame Rate"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                        className: "whitespace-nowrap",
                                        children: "Aspect"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                        className: "whitespace-nowrap",
                                        children: "Captions"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.SortableTableHead), {
                                        field: "publishedEventCount",
                                        label: "Published",
                                        currentSort: sortField,
                                        currentDirection: sortDirection,
                                        onSort: onSort,
                                        className: "text-right whitespace-nowrap"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.SortableTableHead), {
                                        field: "totalDurationMinutes",
                                        label: "Total Dur",
                                        currentSort: sortField,
                                        currentDirection: sortDirection,
                                        onSort: onSort,
                                        className: "text-right whitespace-nowrap"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                        className: "text-right whitespace-nowrap",
                                        children: "Avg Dur"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                            children: data.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                    colSpan: 9,
                                    className: "text-center text-muted-foreground",
                                    children: "No VOD data for this period"
                                })
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    data.map((row, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "font-medium",
                                                    children: row.simpleName
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "whitespace-nowrap",
                                                    children: (0, _format.formatStreamField)(row.streamInfo, 'resolution')
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "whitespace-nowrap",
                                                    children: (0, _format.formatStreamField)(row.streamInfo, 'bitrate')
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "whitespace-nowrap",
                                                    children: (0, _format.formatStreamField)(row.streamInfo, 'frameRate')
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "whitespace-nowrap",
                                                    children: (0, _format.formatStreamField)(row.streamInfo, 'aspectRatio')
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "whitespace-nowrap",
                                                    children: (0, _format.formatStreamField)(row.streamInfo, 'hasCaptions')
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "text-right whitespace-nowrap",
                                                    children: row.publishedEventCount
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "text-right whitespace-nowrap",
                                                    children: (0, _date.formatDuration)(row.totalDurationMinutes)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "text-right whitespace-nowrap",
                                                    children: (0, _date.formatDuration)(row.avgDurationMinutes)
                                                })
                                            ]
                                        }, idx)),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                        className: "bg-muted/50 font-semibold",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                colSpan: 6,
                                                children: "Total"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                className: "text-right whitespace-nowrap",
                                                children: totals.publishedEventCount
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                className: "text-right whitespace-nowrap",
                                                children: (0, _date.formatDuration)(totals.totalDurationMinutes)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                className: "text-right whitespace-nowrap",
                                                children: (0, _date.formatDuration)(totals.avgDurationMinutes)
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","lucide-react":[["AlertTriangle","cdePa","default"],["Download","eRiW1","default"]],"@/client/lib/date":"7ZbER","@/client/lib/format":"iLptT","@/client/components/ui/button":"armlb","@/client/components/ui/table":"5vxZ8","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"duJpi":[function(require,module,exports,__globalThis) {
/**
 * FilterSummary - active-filter callout shown above the result tables.
 * Indigo card that separates the applied filters from the surrounding page.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterSummary", ()=>FilterSummary);
var _jsxRuntime = require("react/jsx-runtime");
var _badge = require("@/client/components/ui/badge");
function FilterSummary({ clientID, start, end, categoryName }) {
    const range = start && end ? `${start} to ${end}` : '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "rounded-lg border border-l-4 border-l-indigo-500 bg-indigo-50 p-4 shadow-sm dark:border-l-indigo-400 dark:bg-indigo-950/40",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mb-3 text-xs font-semibold uppercase tracking-wide text-indigo-700 dark:text-indigo-300",
                children: "Active Filters"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grid grid-cols-[auto_1fr] items-center gap-x-6 gap-y-2 text-sm",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-muted-foreground",
                        children: "Client"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                        variant: "default",
                        className: "justify-self-start text-sm",
                        children: clientID
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-muted-foreground",
                        children: "Range"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                        variant: "default",
                        className: "justify-self-start text-sm",
                        children: range
                    }),
                    categoryName && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-muted-foreground",
                                children: "Category"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                variant: "default",
                                className: "justify-self-start text-sm",
                                children: categoryName
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","@/client/components/ui/badge":"h4e1f","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"frZom":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _root = require("../../__root");
var _layout = require("@/client/layouts/layout");
var _config = require("@/client/config");
var _date = require("@/client/lib/date");
var _csv = require("@/client/lib/csv");
var _lucideReact = require("lucide-react");
var _badge = require("@/client/components/ui/badge");
var _button = require("@/client/components/ui/button");
var _checkbox = require("@/client/components/ui/checkbox");
var _label = require("@/client/components/ui/label");
var _cacheTimestamp = require("@/client/components/cache-timestamp");
var _table = require("@/client/components/ui/table");
var _clientSelector = require("@/client/components/client-selector");
var _dateRangePicker = require("@/client/components/date-range-picker");
var _resetFiltersButton = require("@/client/components/reset-filters-button");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'events/reports/simulcast',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: SimulcastReportsComponent
});
function formatNumber(value) {
    return new Intl.NumberFormat('en-US').format(value);
}
function minutesToHours(minutes) {
    const hours = minutes / 60;
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(hours);
}
function SimulcastReportsComponent() {
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    // Date range state
    const [startDate, setStartDate] = (0, _react.useState)('');
    const [endDate, setEndDate] = (0, _react.useState)('');
    const [quickRange, setQuickRange] = (0, _react.useState)('');
    // Client selection state
    const [selectedClientId, setSelectedClientId] = (0, _react.useState)('');
    const [selectedClient, setSelectedClient] = (0, _react.useState)(null);
    const [allClients, setAllClients] = (0, _react.useState)(false);
    // Report state - single client
    const [singleClientData, setSingleClientData] = (0, _react.useState)(null);
    // Report state - all clients
    const [allClientsData, setAllClientsData] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    const [confirmPending, setConfirmPending] = (0, _react.useState)(false);
    // Can generate report if dates are set AND (allClients OR specific client selected)
    const canGenerateReport = startDate && endDate && (allClients || selectedClientId);
    const handleClientChange = (clientId, client)=>{
        setSelectedClientId(clientId);
        setSelectedClient(client);
        setSingleClientData(null);
        setAllClientsData(null);
        setConfirmPending(false);
    };
    const handleAllClientsChange = (checked)=>{
        setAllClients(checked);
        setSingleClientData(null);
        setAllClientsData(null);
        setConfirmPending(false);
    };
    const handleGenerateReport = async ()=>{
        if (!canGenerateReport) return;
        if (!confirmPending) {
            setConfirmPending(true);
            return;
        }
        setConfirmPending(false);
        setLoading(true);
        setError(null);
        try {
            const token = await getAccessTokenSilently();
            const headers = {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            };
            if (allClients) {
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/events/reports/simulcast/all?startDate=${startDate}&endDate=${endDate}`, {
                    headers
                });
                if (!response.ok) throw new Error(`Failed to fetch simulcast data: ${response.statusText}`);
                const data = await response.json();
                setAllClientsData(data);
                setSingleClientData(null);
            } else {
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/events/reports/simulcast?clientID=${selectedClientId}&startDate=${startDate}&endDate=${endDate}`, {
                    headers
                });
                if (!response.ok) throw new Error(`Failed to fetch simulcast data: ${response.statusText}`);
                const data = await response.json();
                setSingleClientData(data);
                setAllClientsData(null);
            }
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred';
            setError(errorMessage);
        } finally{
            setLoading(false);
        }
    };
    // CSV Export - Single Client
    const handleExportSingleClient = ()=>{
        if (!singleClientData) return;
        const headers = [
            'Year',
            'Month',
            'Events with Simulcast',
            'Total Targets',
            'Event Duration (min)',
            'Event Duration (hrs)',
            'Simulcast Duration (min)',
            'Simulcast Duration (hrs)'
        ];
        const rows = singleClientData.monthly.map((row)=>[
                row.year.toString(),
                (0, _date.getMonthName)(row.month),
                row.eventsWithSimulcast.toString(),
                row.totalTargets.toString(),
                row.totalDurationMinutes.toString(),
                (row.totalDurationMinutes / 60).toFixed(2),
                row.simulcastMinutes.toString(),
                (row.simulcastMinutes / 60).toFixed(2)
            ]);
        rows.push([
            'TOTAL',
            '',
            singleClientData.totals.eventsWithSimulcast.toString(),
            singleClientData.totals.totalTargets.toString(),
            singleClientData.totals.totalDurationMinutes.toString(),
            (singleClientData.totals.totalDurationMinutes / 60).toFixed(2),
            singleClientData.totals.simulcastMinutes.toString(),
            (singleClientData.totals.simulcastMinutes / 60).toFixed(2)
        ]);
        const clientName = selectedClient?.name.replace(/[^a-zA-Z0-9]/g, '_') || 'client';
        (0, _csv.downloadCSV)(`simulcast_${clientName}_${singleClientData.dateRange.start}_to_${singleClientData.dateRange.end}.csv`, headers, rows);
    };
    // CSV Export - All Clients
    const handleExportAllClients = ()=>{
        if (!allClientsData) return;
        const headers = [
            'Client ID',
            'Client Name',
            'Events with Simulcast',
            'Total Targets',
            'Event Duration (hrs)',
            'Simulcast Duration (hrs)'
        ];
        const rows = allClientsData.clients.map((client)=>[
                client.clientID,
                client.clientName,
                client.eventsWithSimulcast.toString(),
                client.totalTargets.toString(),
                client.totalDurationHours.toFixed(2),
                client.simulcastHours.toFixed(2)
            ]);
        rows.push([
            'GRAND TOTAL',
            `(${allClientsData.grandTotals.clientCount} clients)`,
            allClientsData.grandTotals.eventsWithSimulcast.toString(),
            allClientsData.grandTotals.totalTargets.toString(),
            allClientsData.grandTotals.totalDurationHours.toFixed(2),
            allClientsData.grandTotals.simulcastHours.toFixed(2)
        ]);
        (0, _csv.downloadCSV)(`simulcast_all_clients_${allClientsData.dateRange.start}_to_${allClientsData.dateRange.end}.csv`, headers, rows);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Radio), {
                                    className: "h-6 w-6"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "text-2xl font-semibold",
                                    children: "Simulcast Reports"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cacheTimestamp.CacheTimestamp), {
                            cachedAt: singleClientData?.cacheInfo?.cachedAt ?? allClientsData?.cacheInfo?.cachedAt ?? null
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-sm text-muted-foreground",
                    children: "Track events with external stream targets (YouTube, Facebook, Twitch, etc.) and their simulcast durations."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "border rounded-lg p-4 space-y-4 bg-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-xs font-medium text-muted-foreground uppercase tracking-wide",
                                    children: "Date Range"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-wrap gap-4 items-end",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePicker.DateRangePicker), {
                                        startDate: startDate,
                                        endDate: endDate,
                                        onStartDateChange: setStartDate,
                                        onEndDateChange: setEndDate,
                                        quickRange: quickRange,
                                        onQuickRangeChange: setQuickRange,
                                        showToday: false,
                                        onDateChange: ()=>setConfirmPending(false)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-xs font-medium text-muted-foreground uppercase tracking-wide",
                                    children: "Client"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-wrap gap-x-4 gap-y-3 items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                                    id: "all-clients",
                                                    checked: allClients,
                                                    onCheckedChange: (checked)=>handleAllClientsChange(checked === true)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                                    htmlFor: "all-clients",
                                                    className: "cursor-pointer",
                                                    children: "All Clients"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-muted-foreground",
                                            children: "or"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientSelector.ClientSelector), {
                                            value: selectedClientId,
                                            onChange: handleClientChange,
                                            className: "min-w-[250px]",
                                            label: "",
                                            disabled: allClients
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            onClick: handleGenerateReport,
                                            disabled: !canGenerateReport || loading,
                                            variant: confirmPending ? 'destructive' : 'default',
                                            className: "min-w-[175px]",
                                            children: loading ? 'Loading...' : confirmPending ? 'Click to Confirm' : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FileSpreadsheet), {
                                                        className: "mr-2 h-4 w-4"
                                                    }),
                                                    "Generate Report"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetFiltersButton.ResetFiltersButton), {
                                            routePath: "/events/reports/simulcast",
                                            defaultValues: {
                                                clientID: undefined,
                                                startDate: undefined,
                                                endDate: undefined,
                                                quickRange: undefined,
                                                allClients: false
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "p-4 bg-red-100 border-l-4 border-red-600 rounded",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "m-0 text-red-800 font-medium",
                        children: [
                            "Error: ",
                            error
                        ]
                    })
                }),
                singleClientData && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "space-y-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-sm text-muted-foreground",
                            children: [
                                "Report for Client ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                    variant: "outline",
                                    className: "text-xs font-mono",
                                    children: singleClientData.clientID
                                }),
                                " from ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                    variant: "outline",
                                    className: "text-xs font-mono",
                                    children: [
                                        startDate,
                                        " to ",
                                        endDate
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                            className: "text-lg font-semibold",
                                            children: "Simulcast Usage by Month"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            variant: "outline",
                                            size: "sm",
                                            onClick: handleExportSingleClient,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                                    className: "mr-2 h-4 w-4"
                                                }),
                                                "Export CSV"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rounded-md border",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Year"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Month"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Events"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Targets"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Event Duration (min)"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Event Duration (hrs)"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Simulcast Duration (min)"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Simulcast Duration (hrs)"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                                children: singleClientData.monthly.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        colSpan: 8,
                                                        className: "text-center text-muted-foreground",
                                                        children: "No simulcast data for this period"
                                                    })
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        singleClientData.monthly.map((row, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: row.year
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: (0, _date.getMonthName)(row.month)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: formatNumber(row.eventsWithSimulcast)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: formatNumber(row.totalTargets)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: formatNumber(row.totalDurationMinutes)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: minutesToHours(row.totalDurationMinutes)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: formatNumber(row.simulcastMinutes)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: minutesToHours(row.simulcastMinutes)
                                                                    })
                                                                ]
                                                            }, idx)),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                            className: "bg-muted/50 font-semibold",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    colSpan: 2,
                                                                    children: "Total"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: formatNumber(singleClientData.totals.eventsWithSimulcast)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: formatNumber(singleClientData.totals.totalTargets)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: formatNumber(singleClientData.totals.totalDurationMinutes)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: minutesToHours(singleClientData.totals.totalDurationMinutes)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: formatNumber(singleClientData.totals.simulcastMinutes)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: minutesToHours(singleClientData.totals.simulcastMinutes)
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                            className: "bg-muted/30 text-sm",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    colSpan: 3,
                                                                    className: "text-right",
                                                                    children: "Avg Targets/Event:"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right font-medium",
                                                                    children: singleClientData.totals.avgTargetsPerEvent.toFixed(2)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    colSpan: 2,
                                                                    className: "text-right",
                                                                    children: "Avg Duration/Event:"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableCell), {
                                                                    colSpan: 2,
                                                                    className: "text-right font-medium",
                                                                    children: [
                                                                        minutesToHours(singleClientData.totals.avgDurationMinutes),
                                                                        " hrs"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                allClientsData && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "space-y-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-sm text-muted-foreground",
                            children: [
                                "All Clients Report from ",
                                startDate,
                                " to ",
                                endDate
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                            className: "text-lg font-semibold",
                                            children: "Simulcast Usage - All Clients"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            variant: "outline",
                                            size: "sm",
                                            onClick: handleExportAllClients,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                                    className: "mr-2 h-4 w-4"
                                                }),
                                                "Export CSV"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rounded-md border",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Client ID"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Client Name"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Events"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Targets"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Event Duration (hrs)"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Simulcast Duration (hrs)"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                                children: allClientsData.clients.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        colSpan: 6,
                                                        className: "text-center text-muted-foreground",
                                                        children: "No simulcast data for this period"
                                                    })
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        allClientsData.clients.map((client)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: client.clientID
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: client.clientName
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: formatNumber(client.eventsWithSimulcast)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: formatNumber(client.totalTargets)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: client.totalDurationHours.toFixed(2)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: client.simulcastHours.toFixed(2)
                                                                    })
                                                                ]
                                                            }, client.clientID)),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                            className: "bg-muted/50 font-semibold",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    children: "Grand Total"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableCell), {
                                                                    className: "text-muted-foreground",
                                                                    children: [
                                                                        "(",
                                                                        allClientsData.grandTotals.clientCount,
                                                                        " clients)"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: formatNumber(allClientsData.grandTotals.eventsWithSimulcast)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: formatNumber(allClientsData.grandTotals.totalTargets)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: allClientsData.grandTotals.totalDurationHours.toFixed(2)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: allClientsData.grandTotals.simulcastHours.toFixed(2)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"]],"@auth0/auth0-react":"gpXrE","../../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/config":"8SWgh","@/client/lib/date":"7ZbER","@/client/lib/csv":"2NpE4","lucide-react":[["Download","eRiW1","default"],["FileSpreadsheet","fkevk","default"],["Radio","8O5hz","default"]],"@/client/components/ui/badge":"h4e1f","@/client/components/ui/button":"armlb","@/client/components/ui/checkbox":"fh9Pm","@/client/components/ui/label":"cLMZq","@/client/components/cache-timestamp":"f5Zyx","@/client/components/ui/table":"5vxZ8","@/client/components/client-selector":"gxoYe","@/client/components/date-range-picker":"iSBDP","@/client/components/reset-filters-button":"9d8BP","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"89CEz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _root = require("../../__root");
var _layout = require("@/client/layouts/layout");
var _config = require("@/client/config");
var _date = require("@/client/lib/date");
var _searchParams = require("@/client/lib/searchParams");
var _usePersistedSearch = require("@/client/hooks/usePersistedSearch");
var _resetFiltersButton = require("@/client/components/reset-filters-button");
var _csv = require("@/client/lib/csv");
var _lucideReact = require("lucide-react");
var _recharts = require("recharts");
var _button = require("@/client/components/ui/button");
var _cacheTimestamp = require("@/client/components/cache-timestamp");
var _clientSelector = require("@/client/components/client-selector");
var _dropdownMenu = require("@/client/components/ui/dropdown-menu");
var _table = require("@/client/components/ui/table");
var _chart = require("@/client/components/ui/chart");
const YEAR_RANGE_OPTIONS = [
    {
        value: '1',
        label: 'Last 1 year'
    },
    {
        value: '2',
        label: 'Last 2 years'
    },
    {
        value: '3',
        label: 'Last 3 years'
    },
    {
        value: '4',
        label: 'Last 4 years'
    },
    {
        value: '5',
        label: 'Last 5 years'
    },
    {
        value: '6',
        label: 'Last 6 years'
    },
    {
        value: '7',
        label: 'Last 7 years'
    },
    {
        value: '8',
        label: 'Last 8 years'
    },
    {
        value: '9',
        label: 'Last 9 years'
    },
    {
        value: '10',
        label: 'Last 10 years'
    }
];
// Chart colors - monochromatic blue gradient (light to dark)
// CSS variables for 1-5, then continue gradient for 6-10
const CHART_COLORS = [
    'var(--chart-1)',
    'var(--chart-2)',
    'var(--chart-3)',
    'var(--chart-4)',
    'var(--chart-5)',
    'oklch(0.40 0.12 250)',
    'oklch(0.35 0.11 250)',
    'oklch(0.30 0.10 250)',
    'oklch(0.25 0.09 250)',
    'oklch(0.20 0.08 250)'
];
const VALID_YEAR_VALUES = YEAR_RANGE_OPTIONS.map((o)=>o.value);
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'events/trends',
    validateSearch: (search)=>({
            clientID: (0, _searchParams.parseString)(search.clientID),
            years: VALID_YEAR_VALUES.includes(search.years) ? search.years : undefined
        }),
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: TrendsComponent
});
// Transform API data to chart format (grouped by month, with year columns)
function transformToChartData(data, years) {
    const chartData = [];
    // Initialize all 12 months
    for(let month = 1; month <= 12; month++){
        const row = {
            month: (0, _date.getShortMonthName)(month)
        };
        years.forEach((year)=>{
            row[year.toString()] = 0;
        });
        chartData.push(row);
    }
    // Fill in actual data
    data.forEach((point)=>{
        const monthIndex = point.month - 1;
        if (chartData[monthIndex]) chartData[monthIndex][point.year.toString()] = point.eventCount;
    });
    return chartData;
}
function TrendsComponent() {
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const navigate = (0, _reactRouter.useNavigate)();
    const { clientID: selectedClientId = '', years: selectedYears = '2' } = (0, _reactRouter.useSearch)({
        from: '/events/trends'
    });
    // Persist search params across navigation
    (0, _usePersistedSearch.usePersistedSearch)('/events/trends', {
        clientID: undefined,
        years: '2'
    });
    // State
    const [selectedClient, setSelectedClient] = (0, _react.useState)(null);
    const [trendsData, setTrendsData] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    const [confirmPending, setConfirmPending] = (0, _react.useState)(false);
    // Setters that update URL
    const setSelectedYears = (value)=>{
        navigate({
            to: '/events/trends',
            search: (0, _searchParams.buildSearchParams)({
                clientID: selectedClientId || undefined,
                years: value !== '2' ? value : undefined
            })
        });
    };
    // Handle client change from ClientSelector
    const handleClientChange = (clientId, client)=>{
        setSelectedClient(client);
        navigate({
            to: '/events/trends',
            search: (0, _searchParams.buildSearchParams)({
                clientID: clientId || undefined,
                years: selectedYears !== '2' ? selectedYears : undefined
            })
        });
        setTrendsData(null);
        setConfirmPending(false);
    };
    // Get unique years from the data
    const uniqueYears = (0, _react.useMemo)(()=>{
        if (!trendsData) return [];
        const yearsSet = new Set();
        trendsData.liveStreams.forEach((d)=>yearsSet.add(d.year));
        trendsData.vod.forEach((d)=>yearsSet.add(d.year));
        return Array.from(yearsSet).sort((a, b)=>a - b); // Ascending: older years left, newer right
    }, [
        trendsData
    ]);
    // Chart config based on years
    // Dynamically generate colors with good contrast: newest = lightest, oldest = darkest
    const chartConfig = (0, _react.useMemo)(()=>{
        const config = {};
        const count = uniqueYears.length;
        // Generate evenly spaced colors from dark (oldest) to light (newest)
        // Lightness range: 0.40 (darkest/oldest) to 0.75 (lightest/newest)
        uniqueYears.forEach((year, index)=>{
            const t = count === 1 ? 1 : index / (count - 1); // 0 = oldest, 1 = newest
            const lightness = 0.40 + t * 0.35; // 0.40 to 0.75
            config[year.toString()] = {
                label: year.toString(),
                color: `oklch(${lightness.toFixed(2)} 0.13 250)`
            };
        });
        return config;
    }, [
        uniqueYears
    ]);
    // Transform data for charts
    const liveStreamsChartData = (0, _react.useMemo)(()=>{
        if (!trendsData) return [];
        return transformToChartData(trendsData.liveStreams, uniqueYears);
    }, [
        trendsData,
        uniqueYears
    ]);
    const vodChartData = (0, _react.useMemo)(()=>{
        if (!trendsData) return [];
        return transformToChartData(trendsData.vod, uniqueYears);
    }, [
        trendsData,
        uniqueYears
    ]);
    const canGenerateReport = selectedClientId;
    const handleGenerateReport = async ()=>{
        if (!canGenerateReport) return;
        if (!confirmPending) {
            setConfirmPending(true);
            return;
        }
        setConfirmPending(false);
        setLoading(true);
        setError(null);
        try {
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/events/trends?clientID=${selectedClientId}&years=${selectedYears}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) throw new Error(`Failed to fetch trends: ${response.statusText}`);
            const data = await response.json();
            setTrendsData(data);
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred';
            setError(errorMessage);
        } finally{
            setLoading(false);
        }
    };
    const handleExportCSV = ()=>{
        if (!trendsData) return;
        const headers = [
            'Year',
            'Month',
            'Live Events',
            'Live Total Duration',
            'Live Avg Duration',
            'VOD Events',
            'VOD Total Duration',
            'VOD Avg Duration'
        ];
        // Create a map for quick lookup
        const liveMap = new Map();
        const vodMap = new Map();
        trendsData.liveStreams.forEach((d)=>liveMap.set(`${d.year}-${d.month}`, d));
        trendsData.vod.forEach((d)=>vodMap.set(`${d.year}-${d.month}`, d));
        const rows = [];
        // Sort years descending, months ascending
        uniqueYears.forEach((year)=>{
            for(let month = 1; month <= 12; month++){
                const live = liveMap.get(`${year}-${month}`);
                const vod = vodMap.get(`${year}-${month}`);
                if (live || vod) rows.push([
                    year.toString(),
                    (0, _date.getMonthName)(month),
                    (live?.eventCount ?? 0).toString(),
                    (live?.totalDurationMinutes ?? 0).toString(),
                    (live?.avgDurationMinutes ?? 0).toString(),
                    (vod?.eventCount ?? 0).toString(),
                    (vod?.totalDurationMinutes ?? 0).toString(),
                    (vod?.avgDurationMinutes ?? 0).toString()
                ]);
            }
        });
        const clientName = selectedClient?.name.replace(/[^a-zA-Z0-9]/g, '_') || 'client';
        (0, _csv.downloadCSV)(`trends_${clientName}_${selectedYears}yr.csv`, headers, rows);
    };
    const selectedRangeLabel = YEAR_RANGE_OPTIONS.find((o)=>o.value === selectedYears)?.label || '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            className: "text-2xl font-semibold",
                            children: "Yearly Trends"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cacheTimestamp.CacheTimestamp), {
                            cachedAt: trendsData?.cacheInfo?.cachedAt ?? null
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "border rounded-lg p-4 space-y-4 bg-card",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-xs font-medium text-muted-foreground uppercase tracking-wide",
                                children: "Range & Client"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-wrap gap-x-4 gap-y-3 items-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenu), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuTrigger), {
                                                asChild: true,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                    variant: "outline",
                                                    className: "h-10 min-w-[160px] justify-between font-normal",
                                                    children: [
                                                        selectedRangeLabel,
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                            className: "ml-2 h-4 w-4 opacity-50"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuContent), {
                                                align: "start",
                                                className: "w-[--radix-dropdown-menu-trigger-width]",
                                                children: YEAR_RANGE_OPTIONS.map((option)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                        onClick: ()=>{
                                                            setSelectedYears(option.value);
                                                            setConfirmPending(false);
                                                        },
                                                        children: option.label
                                                    }, option.value))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientSelector.ClientSelector), {
                                        value: selectedClientId,
                                        onChange: handleClientChange,
                                        className: "min-w-[250px]",
                                        label: ""
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        onClick: handleGenerateReport,
                                        disabled: !canGenerateReport || loading,
                                        variant: confirmPending ? 'destructive' : 'default',
                                        className: "min-w-[175px]",
                                        children: loading ? 'Loading...' : confirmPending ? 'Click to Confirm' : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.TrendingUp), {
                                                    className: "mr-2 h-4 w-4"
                                                }),
                                                "Generate Report"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetFiltersButton.ResetFiltersButton), {
                                        routePath: "/events/trends",
                                        defaultValues: {
                                            clientID: undefined,
                                            years: '2'
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                }),
                error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "p-4 bg-red-100 border-l-4 border-red-600 rounded",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "m-0 text-red-800 font-medium",
                        children: [
                            "Error: ",
                            error
                        ]
                    })
                }),
                trendsData && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "space-y-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "text-sm text-muted-foreground",
                                    children: [
                                        "Trends for Client ",
                                        trendsData.clientID,
                                        " - Last ",
                                        trendsData.years,
                                        " year",
                                        trendsData.years > 1 ? 's' : ''
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                    variant: "outline",
                                    size: "sm",
                                    onClick: handleExportCSV,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                            className: "mr-2 h-4 w-4"
                                        }),
                                        "Export CSV"
                                    ]
                                })
                            ]
                        }),
                        trendsData.liveStreams.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-4 bg-card rounded-lg p-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    className: "text-lg font-semibold",
                                    children: "Live Streams - Events by Month"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chart.ChartContainer), {
                                    config: chartConfig,
                                    className: "h-[300px] w-full",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _recharts.BarChart), {
                                        data: liveStreamsChartData,
                                        accessibilityLayer: true,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.CartesianGrid), {
                                                vertical: false
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.XAxis), {
                                                dataKey: "month",
                                                tickLine: false,
                                                tickMargin: 10,
                                                axisLine: false
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.YAxis), {
                                                tickLine: false,
                                                axisLine: false
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chart.ChartTooltip), {
                                                content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chart.ChartTooltipContent), {})
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chart.ChartLegend), {
                                                content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chart.ChartLegendContent), {})
                                            }),
                                            uniqueYears.map((year)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Bar), {
                                                    dataKey: year.toString(),
                                                    fill: `var(--color-${year})`,
                                                    radius: [
                                                        4,
                                                        4,
                                                        0,
                                                        0
                                                    ]
                                                }, year))
                                        ]
                                    })
                                })
                            ]
                        }),
                        trendsData.vod.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-4 bg-card rounded-lg p-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    className: "text-lg font-semibold",
                                    children: "VOD - Events by Month"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chart.ChartContainer), {
                                    config: chartConfig,
                                    className: "h-[300px] w-full",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _recharts.BarChart), {
                                        data: vodChartData,
                                        accessibilityLayer: true,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.CartesianGrid), {
                                                vertical: false
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.XAxis), {
                                                dataKey: "month",
                                                tickLine: false,
                                                tickMargin: 10,
                                                axisLine: false
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.YAxis), {
                                                tickLine: false,
                                                axisLine: false
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chart.ChartTooltip), {
                                                content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chart.ChartTooltipContent), {})
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chart.ChartLegend), {
                                                content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chart.ChartLegendContent), {})
                                            }),
                                            uniqueYears.map((year)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Bar), {
                                                    dataKey: year.toString(),
                                                    fill: `var(--color-${year})`,
                                                    radius: [
                                                        4,
                                                        4,
                                                        0,
                                                        0
                                                    ]
                                                }, year))
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    className: "text-lg font-semibold",
                                    children: "Live Streams Data"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rounded-md border",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Year"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Month"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Events"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Total Duration"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Avg Duration"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                                children: trendsData.liveStreams.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        colSpan: 5,
                                                        className: "text-center text-muted-foreground",
                                                        children: "No live stream data for this period"
                                                    })
                                                }) : uniqueYears.map((year)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                                                        children: trendsData.liveStreams.filter((d)=>d.year === year).sort((a, b)=>a.month - b.month).map((row, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                                children: [
                                                                    idx === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "font-semibold",
                                                                        rowSpan: trendsData.liveStreams.filter((d)=>d.year === year).length,
                                                                        children: year
                                                                    }) : null,
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: (0, _date.getMonthName)(row.month)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: row.eventCount
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: (0, _date.formatDuration)(row.totalDurationMinutes)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: (0, _date.formatDuration)(row.avgDurationMinutes)
                                                                    })
                                                                ]
                                                            }, `${year}-${row.month}`))
                                                    }, year))
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                    className: "text-lg font-semibold",
                                    children: "VOD Data"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rounded-md border",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Year"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Month"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Events"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Total Duration"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Avg Duration"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                                children: trendsData.vod.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        colSpan: 5,
                                                        className: "text-center text-muted-foreground",
                                                        children: "No VOD data for this period"
                                                    })
                                                }) : uniqueYears.map((year)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                                                        children: trendsData.vod.filter((d)=>d.year === year).sort((a, b)=>a.month - b.month).map((row, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                                children: [
                                                                    idx === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "font-semibold",
                                                                        rowSpan: trendsData.vod.filter((d)=>d.year === year).length,
                                                                        children: year
                                                                    }) : null,
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: (0, _date.getMonthName)(row.month)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: row.eventCount
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: (0, _date.formatDuration)(row.totalDurationMinutes)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: (0, _date.formatDuration)(row.avgDurationMinutes)
                                                                    })
                                                                ]
                                                            }, `${year}-${row.month}`))
                                                    }, year))
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useNavigate","aMhxM"],["useSearch","4yVFL"]],"@auth0/auth0-react":"gpXrE","../../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/config":"8SWgh","@/client/lib/date":"7ZbER","@/client/lib/searchParams":"fgK0T","@/client/hooks/usePersistedSearch":"kPA60","@/client/components/reset-filters-button":"9d8BP","@/client/lib/csv":"2NpE4","lucide-react":[["ChevronDown","kVmgC","default"],["Download","eRiW1","default"],["TrendingUp","a4MAn","default"]],"recharts":[["Bar","9EUGQ"],["BarChart","euDzi"],["CartesianGrid","8zC4Z"],["XAxis","4nBWG"],["YAxis","NHcEZ"]],"@/client/components/ui/button":"armlb","@/client/components/cache-timestamp":"f5Zyx","@/client/components/client-selector":"gxoYe","@/client/components/ui/dropdown-menu":"8ox96","@/client/components/ui/table":"5vxZ8","@/client/components/ui/chart":"8qrDG","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9EUGQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bar", ()=>Bar);
/**
 * @fileOverview Render a group of bar
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _layer = require("../container/Layer");
var _errorBar = require("./ErrorBar");
var _cell = require("../component/Cell");
var _labelList = require("../component/LabelList");
var _dataUtils = require("../util/DataUtils");
var _reactUtils = require("../util/ReactUtils");
var _global = require("../util/Global");
var _chartUtils = require("../util/ChartUtils");
var _types = require("../util/types");
var _barUtils = require("../util/BarUtils");
var _excluded = [
    "value",
    "background"
];
var _Bar;
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var Bar = /*#__PURE__*/ function(_PureComponent) {
    function Bar() {
        var _this;
        _classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, Bar, [].concat(args));
        _defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        _defineProperty(_this, "id", (0, _dataUtils.uniqueId)('recharts-bar-'));
        _defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        _defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    _inherits(Bar, _PureComponent);
    return _createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, _reactUtils.filterProps)(this.props, false);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = _objectSpread(_objectSpread(_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: "recharts-bar-rectangle"
                    }, (0, _types.adaptEventsOfChild)(_this2.props, entry, i), {
                        // https://github.com/recharts/recharts/issues/5415
                        // eslint-disable-next-line react/no-array-index-key
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value, "-").concat(i)
                    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _barUtils.BarRectangle), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, _dataUtils.interpolateNumber)(prev.x, entry.x);
                            var interpolatorY = (0, _dataUtils.interpolateNumber)(prev.y, entry.y);
                            var interpolatorWidth = (0, _dataUtils.interpolateNumber)(prev.width, entry.width);
                            var interpolatorHeight = (0, _dataUtils.interpolateNumber)(prev.height, entry.height);
                            return _objectSpread(_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === 'horizontal') {
                            var _interpolatorHeight = (0, _dataUtils.interpolateNumber)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return _objectSpread(_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, _dataUtils.interpolateNumber)(0, entry.width);
                        var w = interpolator(t);
                        return _objectSpread(_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqualDefault.default)(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, _reactUtils.filterProps)(this.props.background, false);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = _objectWithoutProperties(entry, _excluded);
                    if (!background) return null;
                    var props = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, _types.adaptEventsOfChild)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        className: 'recharts-bar-background-rectangle'
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _barUtils.BarRectangle), _extends({
                        key: "background-bar-".concat(i),
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, _reactUtils.findAllByType)(children, (0, _errorBar.ErrorBar));
                if (!errorBarItems) return null;
                var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, _chartUtils.getValueByDataKey)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, _clsxDefault.default)('recharts-bar', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, _isNilDefault.default)(id) ? this.id : id;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
}((0, _react.PureComponent));
_Bar = Bar;
_defineProperty(Bar, "displayName", 'Bar');
_defineProperty(Bar, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'rect',
    minPointSize: 0,
    hide: false,
    data: [],
    layout: 'vertical',
    activeBar: false,
    isAnimationActive: !(0, _global.Global).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ _defineProperty(Bar, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, _chartUtils.findPositionOfBar)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var itemDefaultProps = item.type.defaultProps;
    var itemProps = itemDefaultProps !== undefined ? _objectSpread(_objectSpread({}, itemDefaultProps), item.props) : item.props;
    var dataKey = itemProps.dataKey, children = itemProps.children, minPointSizeProp = itemProps.minPointSize;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, _chartUtils.getBaseValueOfBar)({
        numericAxis: numericAxis
    });
    var cells = (0, _reactUtils.findAllByType)(children, (0, _cell.Cell));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, _chartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, _chartUtils.getValueByDataKey)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, _barUtils.minPointSizeCallback)(minPointSizeProp, _Bar.defaultProps.minPointSize)(value[1], index);
        if (layout === 'horizontal') {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, _chartUtils.getCateCoordinateOfBar)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, _dataUtils.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, _chartUtils.getCateCoordinateOfBar)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, _dataUtils.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return _objectSpread(_objectSpread(_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, _chartUtils.getTooltipItem)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return _objectSpread({
        data: rects,
        layout: layout
    }, offset);
});

},{"react":"eGun2","clsx":"3mzHT","react-smooth":"ekPiD","lodash/isEqual":"kMH36","lodash/isNil":"lYi7Z","../container/Layer":"gNfib","./ErrorBar":"2A4Qz","../component/Cell":"6TviG","../component/LabelList":"j6MTq","../util/DataUtils":"lsl3R","../util/ReactUtils":"dBf5D","../util/Global":"dWTWi","../util/ChartUtils":"55u3i","../util/types":"5mtYY","../util/BarUtils":"e7fwF","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ekPiD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configSpring", ()=>(0, _easing.configSpring));
parcelHelpers.export(exports, "configBezier", ()=>(0, _easing.configBezier));
parcelHelpers.export(exports, "AnimateGroup", ()=>(0, _animateGroupDefault.default));
var _animate = require("./Animate");
var _animateDefault = parcelHelpers.interopDefault(_animate);
var _easing = require("./easing");
var _animateGroup = require("./AnimateGroup");
var _animateGroupDefault = parcelHelpers.interopDefault(_animateGroup);
exports.default = (0, _animateDefault.default);

},{"./Animate":"bdiWM","./easing":false,"./AnimateGroup":false,"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bdiWM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _fastEquals = require("fast-equals");
var _animateManager = require("./AnimateManager");
var _animateManagerDefault = parcelHelpers.interopDefault(_animateManager);
var _easing = require("./easing");
var _configUpdate = require("./configUpdate");
var _configUpdateDefault = parcelHelpers.interopDefault(_configUpdate);
var _util = require("./util");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var Animate = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Animate, _PureComponent);
    var _super = _createSuper(Animate);
    function Animate(props, context) {
        var _this;
        _classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === 'function') _this.state = {
                style: to
            };
            return _possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === 'function') {
                _this.state = {
                    style: from
                };
                return _possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? _defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    _createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? _defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, _fastEquals.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? _defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && style[attributeName] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation(_objectSpread(_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, _configUpdateDefault.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === 'function' || easing === 'spring') return [].concat(_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, _util.getTransitionVal)(properties, duration, easing);
                    var newStyle = _objectSpread(_objectSpread(_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat(_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, _util.identity));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat(_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, _animateManagerDefault.default)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    _objectSpread(_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = _objectWithoutProperties(_this$props4, _excluded);
                var count = (0, _react.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = this.state.style;
                if (typeof children === 'function') return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, _react.cloneElement)(container, _objectSpread(_objectSpread({}, others), {}, {
                        style: _objectSpread(_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, _react.Children).only(children));
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, (0, _react.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, _react.PureComponent));
Animate.displayName = 'Animate';
Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: '',
    to: '',
    attributeName: '',
    easing: 'ease',
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
Animate.propTypes = {
    from: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string
    ]),
    to: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string
    ]),
    attributeName: (0, _propTypesDefault.default).string,
    // animation duration
    duration: (0, _propTypesDefault.default).number,
    begin: (0, _propTypesDefault.default).number,
    easing: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    steps: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        duration: (0, _propTypesDefault.default).number.isRequired,
        style: (0, _propTypesDefault.default).object.isRequired,
        easing: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf([
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'linear'
            ]),
            (0, _propTypesDefault.default).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, _propTypesDefault.default).arrayOf('string'),
        onAnimationEnd: (0, _propTypesDefault.default).func
    })),
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]),
    isActive: (0, _propTypesDefault.default).bool,
    canBegin: (0, _propTypesDefault.default).bool,
    onAnimationEnd: (0, _propTypesDefault.default).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, _propTypesDefault.default).bool,
    onAnimationStart: (0, _propTypesDefault.default).func,
    onAnimationReStart: (0, _propTypesDefault.default).func
};
exports.default = Animate;

},{"react":"eGun2","prop-types":"9QK5f","fast-equals":"3r9p2","./AnimateManager":"5smex","./easing":"5j63H","./configUpdate":"iGdiV","./util":"7Nzf1","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9QK5f":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("ec56c2c14d36aeb0")();

},{"ec56c2c14d36aeb0":"5FEhA"}],"5FEhA":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("5378f1047c18e058");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"5378f1047c18e058":"4TVrY"}],"4TVrY":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"3r9p2":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    'use strict';
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the `@@toStringTag` of the value, if it exists.
     */ function getShortTag(value) {
        return value != null ? value[Symbol.toStringTag] : undefined;
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a === b || !a && !b && a !== a && b !== b;
    }
    var PREACT_VNODE = '__v';
    var PREACT_OWNER = '__o';
    var REACT_OWNER = '_owner';
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the errors passed are equal in value.
     */ function areErrorsEqual(a, b) {
        return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
    }
    /**
     * Whether the functions passed are equal in value.
     */ function areFunctionsEqual(a, b) {
        return a === b;
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.entries();
        var aResult;
        var bResult;
        var index = 0;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (matchedIndices[matchIndex]) {
                    matchIndex++;
                    continue;
                }
                var aEntry = aResult.value;
                var bEntry = bResult.value;
                if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the numbers are equal in value.
     */ var areNumbersEqual = sameValueZeroEqual;
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isPropertyEqual(a, b, state, properties[index])) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (!isPropertyEqual(a, b, state, property)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.values();
        var aResult;
        var bResult;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    /**
     * Whether the URL instances are equal in value.
     */ function areUrlsEqual(a, b) {
        return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
    }
    function isPropertyEqual(a, b, state, property) {
        if ((property === REACT_OWNER || property === PREACT_OWNER || property === PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
        return hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var ERROR_TAG = '[object Error]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var REG_EXP_TAG = '[object RegExp]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var URL_TAG = '[object URL]';
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areErrorsEqual = _a.areErrorsEqual, areFunctionsEqual = _a.areFunctionsEqual, areMapsEqual = _a.areMapsEqual, areNumbersEqual = _a.areNumbersEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual, areUrlsEqual = _a.areUrlsEqual, unknownTagComparators = _a.unknownTagComparators;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If either of the items are nullish and fail the strictly equal check
            // above, then they must be unequal.
            if (a == null || b == null) return false;
            var type = typeof a;
            if (type !== typeof b) return false;
            if (type !== 'object') {
                if (type === 'number') return areNumbersEqual(a, b, state);
                if (type === 'function') return areFunctionsEqual(a, b, state);
                // If a primitive value that is not strictly equal, it must be unequal.
                return false;
            }
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            // For RegExp, the properties are not enumerable, and therefore will give false positives if
            // tested like a standard object.
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If a URL tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === URL_TAG) return areUrlsEqual(a, b, state);
            // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === ERROR_TAG) return areErrorsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            if (unknownTagComparators) {
                var unknownTagComparator = unknownTagComparators[tag];
                if (!unknownTagComparator) {
                    var shortTag = getShortTag(a);
                    if (shortTag) unknownTagComparator = unknownTagComparators[shortTag];
                }
                // If the custom config has an unknown tag comparator that matches the captured tag or the
                // @@toStringTag, it is the source of truth for whether the values are equal.
                if (unknownTagComparator) return unknownTagComparator(a, b, state);
            }
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areErrorsEqual: areErrorsEqual,
            areFunctionsEqual: areFunctionsEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areNumbersEqual: areNumbersEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual,
            areUrlsEqual: areUrlsEqual,
            unknownTagComparators: undefined
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});

},{}],"5smex":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createAnimateManager);
var _setRafTimeout = require("./setRafTimeout");
var _setRafTimeoutDefault = parcelHelpers.interopDefault(_setRafTimeout);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function createAnimateManager() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = _toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === 'number') {
                (0, _setRafTimeoutDefault.default)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, _setRafTimeoutDefault.default)(setStyle.bind(null, restStyles));
            return;
        }
        if (_typeof(_style) === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}

},{"./setRafTimeout":"3jccS","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3jccS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setRafTimeout);
function safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function setRafTimeout(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5j63H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configBezier", ()=>configBezier);
parcelHelpers.export(exports, "configSpring", ()=>configSpring);
parcelHelpers.export(exports, "configEasing", ()=>configEasing);
var _util = require("./util");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var ACCURACY = 1e-4;
var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = cubicBezierFactor(c1, c2);
        return multyTime(params, t);
    };
};
var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = cubicBezierFactor(c1, c2);
        var newParams = [].concat(_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return multyTime(newParams, t);
    };
};
var configBezier = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease':
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case 'ease-in':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease-out':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case 'ease-in-out':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
                var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = _slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, _util.warn)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, _util.warn)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === 'number' && num >= 0 && num <= 1;
    }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
    var curveX = cubicBezier(x1, x2);
    var curveY = cubicBezier(y1, y2);
    var derCurveX = derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var configSpring = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var configEasing = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return configBezier(easing);
        case 'spring':
            return configSpring();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return configBezier(easing);
            (0, _util.warn)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === 'function') return easing;
    (0, _util.warn)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
    return null;
};

},{"./util":"7Nzf1","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7Nzf1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIntersectionKeys", ()=>getIntersectionKeys);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "getDashCase", ()=>getDashCase);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "debug", ()=>debug);
parcelHelpers.export(exports, "debugf", ()=>debugf);
parcelHelpers.export(exports, "mapObject", ()=>mapObject);
parcelHelpers.export(exports, "getTransitionVal", ()=>getTransitionVal);
parcelHelpers.export(exports, "warn", ()=>warn);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var identity = function identity(param) {
    return param;
};
var getDashCase = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var log = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var debug = function debug(name) {
    return function(item) {
        log(name, item);
        return item;
    };
};
var debugf = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || 'anonymous function';
        var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
        log("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var mapObject = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var getTransitionVal = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(',');
};
var isDev = false;
var warn = function warn(condition, format, a, b, c, d, e, f) {
    if (isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"iGdiV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _util = require("./util");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, _util.mapObject)(function(key, val) {
        if (needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = _slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return _objectSpread(_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, _util.mapObject)(function(key, val) {
        if (needContinue(val)) return _objectSpread(_objectSpread({}, val), {}, {
            velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
// configure update function
exports.default = function(from, to, easing, duration, render) {
    var interKeys = (0, _util.getIntersectionKeys)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, _util.mapObject)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter(needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render(_objectSpread(_objectSpread(_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, _util.mapObject)(function(key, val) {
            return alpha.apply(void 0, _toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render(_objectSpread(_objectSpread(_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, _util.mapObject)(function(key, val) {
                return alpha.apply(void 0, _toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render(_objectSpread(_objectSpread(_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};

},{"./util":"7Nzf1","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kMH36":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("35a038ae295d50bb");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"35a038ae295d50bb":"dxRRS"}],"dxRRS":[function(require,module,exports,__globalThis) {
var baseIsEqualDeep = require("d3cd074d97c3383d"), isObjectLike = require("7f49b1b27813eba0");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"d3cd074d97c3383d":"4ssXi","7f49b1b27813eba0":"4gHtY"}],"4ssXi":[function(require,module,exports,__globalThis) {
var Stack = require("43a692a1cc72f358"), equalArrays = require("cfdb7930026bd545"), equalByTag = require("683d6bd27e340938"), equalObjects = require("8902676a54e94fee"), getTag = require("f8480820cd16f294"), isArray = require("82ed9abc7b511cc9"), isBuffer = require("728aef3b04b791f0"), isTypedArray = require("5f2833239f1396c6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"43a692a1cc72f358":"ap26Q","cfdb7930026bd545":"3ncPV","683d6bd27e340938":"es5MY","8902676a54e94fee":"f8xkW","f8480820cd16f294":"7Mujc","82ed9abc7b511cc9":"5gfYS","728aef3b04b791f0":"6q24W","5f2833239f1396c6":"2dfhx"}],"ap26Q":[function(require,module,exports,__globalThis) {
var ListCache = require("a3c0f07a1c22e814"), stackClear = require("58275d350c5e11ef"), stackDelete = require("aded231a8d185b21"), stackGet = require("87a2e75bfa4f3460"), stackHas = require("dc3802fda7ee0e9a"), stackSet = require("70c33f51a0558e17");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"a3c0f07a1c22e814":"gaTbM","58275d350c5e11ef":"cokED","aded231a8d185b21":"cGsYG","87a2e75bfa4f3460":"kNgJ8","dc3802fda7ee0e9a":"aBdNz","70c33f51a0558e17":"iOy2A"}],"gaTbM":[function(require,module,exports,__globalThis) {
var listCacheClear = require("fe85a3d4f5515a1b"), listCacheDelete = require("ef62a3c4cddf4cf5"), listCacheGet = require("44668e4e030218e5"), listCacheHas = require("c7eadeb3dabaa461"), listCacheSet = require("7f03e1d6b3530e72");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"fe85a3d4f5515a1b":"kkUvs","ef62a3c4cddf4cf5":"8jyFV","44668e4e030218e5":"fHeQi","c7eadeb3dabaa461":"aiWTX","7f03e1d6b3530e72":"9CFqf"}],"kkUvs":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"8jyFV":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("ab513ee2c4c36e1d");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"ab513ee2c4c36e1d":"anpDN"}],"anpDN":[function(require,module,exports,__globalThis) {
var eq = require("bc948996ffef4e45");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"bc948996ffef4e45":"eLtdL"}],"eLtdL":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"fHeQi":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("b90e0acacf86f6be");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"b90e0acacf86f6be":"anpDN"}],"aiWTX":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("6798207f14c021a9");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"6798207f14c021a9":"anpDN"}],"9CFqf":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("28c817e8113378e9");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"28c817e8113378e9":"anpDN"}],"cokED":[function(require,module,exports,__globalThis) {
var ListCache = require("9de38de7b9be6424");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"9de38de7b9be6424":"gaTbM"}],"cGsYG":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"kNgJ8":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"aBdNz":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"iOy2A":[function(require,module,exports,__globalThis) {
var ListCache = require("98763f531c520c63"), Map = require("451cf0c7b1f450bf"), MapCache = require("b7be41899d5d3d7b");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"98763f531c520c63":"gaTbM","451cf0c7b1f450bf":"kUeJp","b7be41899d5d3d7b":"aGEeK"}],"kUeJp":[function(require,module,exports,__globalThis) {
var getNative = require("990f3d11e92de140"), root = require("14bf7db0eafabb41");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map');
module.exports = Map;

},{"990f3d11e92de140":"3hxI7","14bf7db0eafabb41":"g0sWx"}],"3hxI7":[function(require,module,exports,__globalThis) {
var baseIsNative = require("2f9130b3952bc1cc"), getValue = require("d90b2d549a6bc551");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"2f9130b3952bc1cc":"d6WBc","d90b2d549a6bc551":"2FrJz"}],"d6WBc":[function(require,module,exports,__globalThis) {
var isFunction = require("81663f611597d9a2"), isMasked = require("1e66a43ae6c5dcc3"), isObject = require("216180ae1b68ecf5"), toSource = require("acc270abb6515bf9");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"81663f611597d9a2":"2KQKo","1e66a43ae6c5dcc3":"akLVS","216180ae1b68ecf5":"cNdKD","acc270abb6515bf9":"6du0v"}],"2KQKo":[function(require,module,exports,__globalThis) {
var baseGetTag = require("37dd1aef729915f6"), isObject = require("b3d5e1e761dbc70d");
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"37dd1aef729915f6":"eUzNb","b3d5e1e761dbc70d":"cNdKD"}],"eUzNb":[function(require,module,exports,__globalThis) {
var Symbol = require("540000dc0c0fb42c"), getRawTag = require("e72f47fe40f87f1b"), objectToString = require("3caaec4658f24a13");
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"540000dc0c0fb42c":"6MIK0","e72f47fe40f87f1b":"2O4EJ","3caaec4658f24a13":"4ugFM"}],"6MIK0":[function(require,module,exports,__globalThis) {
var root = require("7aa9bfba99fea5af");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"7aa9bfba99fea5af":"g0sWx"}],"g0sWx":[function(require,module,exports,__globalThis) {
var freeGlobal = require("d794f18c409d65ca");
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

},{"d794f18c409d65ca":"bo6wg"}],"bo6wg":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"2O4EJ":[function(require,module,exports,__globalThis) {
var Symbol = require("64fbed70814cdbb3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"64fbed70814cdbb3":"6MIK0"}],"4ugFM":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"cNdKD":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{}],"akLVS":[function(require,module,exports,__globalThis) {
var coreJsData = require("7e1ccfa8168f81b2");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"7e1ccfa8168f81b2":"fifun"}],"fifun":[function(require,module,exports,__globalThis) {
var root = require("5cc284b800efe448");
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;

},{"5cc284b800efe448":"g0sWx"}],"6du0v":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = toSource;

},{}],"2FrJz":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"aGEeK":[function(require,module,exports,__globalThis) {
var mapCacheClear = require("563a81fb9892ff5"), mapCacheDelete = require("bc7af2a8e29b735a"), mapCacheGet = require("60b4e5cd483125dd"), mapCacheHas = require("827b730fd5e4a766"), mapCacheSet = require("5a9431d066e9611e");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"563a81fb9892ff5":"5hrmm","bc7af2a8e29b735a":"cqq9s","60b4e5cd483125dd":"5Ox4c","827b730fd5e4a766":"fxqRz","5a9431d066e9611e":"cobTw"}],"5hrmm":[function(require,module,exports,__globalThis) {
var Hash = require("accf7a8627eb03e5"), ListCache = require("8574ee00719d23c"), Map = require("d14c1a55b301a982");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
module.exports = mapCacheClear;

},{"accf7a8627eb03e5":"e9q1h","8574ee00719d23c":"gaTbM","d14c1a55b301a982":"kUeJp"}],"e9q1h":[function(require,module,exports,__globalThis) {
var hashClear = require("18782195b8b402f7"), hashDelete = require("7202dda9389ad45f"), hashGet = require("a708dcd2b8cdfa2f"), hashHas = require("1b6c375d13958259"), hashSet = require("ff85e7fd7aa9daab");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"18782195b8b402f7":"b8M1i","7202dda9389ad45f":"4MGAK","a708dcd2b8cdfa2f":"bdNvd","1b6c375d13958259":"gmf8o","ff85e7fd7aa9daab":"6BhsU"}],"b8M1i":[function(require,module,exports,__globalThis) {
var nativeCreate = require("eaca83ad18b3ccbd");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"eaca83ad18b3ccbd":"54Jr4"}],"54Jr4":[function(require,module,exports,__globalThis) {
var getNative = require("d6558d425ea8cfe9");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
module.exports = nativeCreate;

},{"d6558d425ea8cfe9":"3hxI7"}],"4MGAK":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"bdNvd":[function(require,module,exports,__globalThis) {
var nativeCreate = require("e57bc686572a2b86");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"e57bc686572a2b86":"54Jr4"}],"gmf8o":[function(require,module,exports,__globalThis) {
var nativeCreate = require("bd7eb11b54bc2255");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"bd7eb11b54bc2255":"54Jr4"}],"6BhsU":[function(require,module,exports,__globalThis) {
var nativeCreate = require("eb0aad9cd40f614b");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"eb0aad9cd40f614b":"54Jr4"}],"cqq9s":[function(require,module,exports,__globalThis) {
var getMapData = require("44f769dda370ba6a");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"44f769dda370ba6a":"kFk6j"}],"kFk6j":[function(require,module,exports,__globalThis) {
var isKeyable = require("304f43465bd1f054");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = getMapData;

},{"304f43465bd1f054":"7XeEH"}],"7XeEH":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = isKeyable;

},{}],"5Ox4c":[function(require,module,exports,__globalThis) {
var getMapData = require("51bf74be3ef8b99");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"51bf74be3ef8b99":"kFk6j"}],"fxqRz":[function(require,module,exports,__globalThis) {
var getMapData = require("af9113f59534b1ba");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"af9113f59534b1ba":"kFk6j"}],"cobTw":[function(require,module,exports,__globalThis) {
var getMapData = require("50ec59748536df96");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"50ec59748536df96":"kFk6j"}],"3ncPV":[function(require,module,exports,__globalThis) {
var SetCache = require("c8d2ad5aff9b8dfa"), arraySome = require("a205d146e4746e56"), cacheHas = require("f1d6535bcdb83e7c");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = equalArrays;

},{"c8d2ad5aff9b8dfa":"f7SVF","a205d146e4746e56":"ioEgU","f1d6535bcdb83e7c":"hZy6h"}],"f7SVF":[function(require,module,exports,__globalThis) {
var MapCache = require("ea5f1bbbed7872c2"), setCacheAdd = require("1398f902a64c8006"), setCacheHas = require("e30d56bc511d5f81");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"ea5f1bbbed7872c2":"aGEeK","1398f902a64c8006":"lelg9","e30d56bc511d5f81":"cJoOh"}],"lelg9":[function(require,module,exports,__globalThis) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"cJoOh":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"ioEgU":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"hZy6h":[function(require,module,exports,__globalThis) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"es5MY":[function(require,module,exports,__globalThis) {
var Symbol = require("4ddb17aca599e79b"), Uint8Array = require("a145d93baddd61df"), eq = require("7c1b32d90916d53b"), equalArrays = require("daaad688f5c127b4"), mapToArray = require("8ae486d8d5e2696c"), setToArray = require("23180090c26dab39");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"4ddb17aca599e79b":"6MIK0","a145d93baddd61df":"flaHi","7c1b32d90916d53b":"eLtdL","daaad688f5c127b4":"3ncPV","8ae486d8d5e2696c":"5eVZ8","23180090c26dab39":"cIvVD"}],"flaHi":[function(require,module,exports,__globalThis) {
var root = require("90271f824f06572e");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"90271f824f06572e":"g0sWx"}],"5eVZ8":[function(require,module,exports,__globalThis) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"cIvVD":[function(require,module,exports,__globalThis) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"f8xkW":[function(require,module,exports,__globalThis) {
var getAllKeys = require("a3fcf1470b4c2f21");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = equalObjects;

},{"a3fcf1470b4c2f21":"aRNSg"}],"aRNSg":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("ffbf133dcb941ed7"), getSymbols = require("cd9b74549c230832"), keys = require("1234514df38a7e89");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"ffbf133dcb941ed7":"h1lAw","cd9b74549c230832":"knCcy","1234514df38a7e89":"ftmUn"}],"h1lAw":[function(require,module,exports,__globalThis) {
var arrayPush = require("6822d4e4fcbd6a16"), isArray = require("76ee06964d2c2246");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"6822d4e4fcbd6a16":"ixNde","76ee06964d2c2246":"5gfYS"}],"ixNde":[function(require,module,exports,__globalThis) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"5gfYS":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"knCcy":[function(require,module,exports,__globalThis) {
var arrayFilter = require("460681a5f6105aff"), stubArray = require("241b47484afebb4d");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"460681a5f6105aff":"kuVQb","241b47484afebb4d":"9Ghuf"}],"kuVQb":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"9Ghuf":[function(require,module,exports,__globalThis) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"ftmUn":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("1e4904d2d4ad778"), baseKeys = require("193fe847f966e4a9"), isArrayLike = require("f13018c2ad9905a6");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"1e4904d2d4ad778":"fIKFp","193fe847f966e4a9":"hMuXI","f13018c2ad9905a6":"fs9yO"}],"fIKFp":[function(require,module,exports,__globalThis) {
var baseTimes = require("2a0e1c7b866c5d75"), isArguments = require("7d62182e49ec76e4"), isArray = require("6afac48a4c359d17"), isBuffer = require("c104b260516e17cf"), isIndex = require("3d8a9d823c888c23"), isTypedArray = require("85b8f1030ac381fc");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"2a0e1c7b866c5d75":"76YYk","7d62182e49ec76e4":"V8fdP","6afac48a4c359d17":"5gfYS","c104b260516e17cf":"6q24W","3d8a9d823c888c23":"czJh8","85b8f1030ac381fc":"2dfhx"}],"76YYk":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"V8fdP":[function(require,module,exports,__globalThis) {
var baseIsArguments = require("87effe34d5a59006"), isObjectLike = require("5721aa3c24314f46");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;

},{"87effe34d5a59006":"dzPIw","5721aa3c24314f46":"4gHtY"}],"dzPIw":[function(require,module,exports,__globalThis) {
var baseGetTag = require("6b7eee94bf7d524f"), isObjectLike = require("c823888d6f1d6951");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"6b7eee94bf7d524f":"eUzNb","c823888d6f1d6951":"4gHtY"}],"4gHtY":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;

},{}],"6q24W":[function(require,module,exports,__globalThis) {
var root = require("aad8ee97d979e955"), stubFalse = require("b4d9cc4649ef9f8e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"aad8ee97d979e955":"g0sWx","b4d9cc4649ef9f8e":"c1HAv"}],"c1HAv":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"czJh8":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"2dfhx":[function(require,module,exports,__globalThis) {
var baseIsTypedArray = require("44abd4eabcf7b548"), baseUnary = require("15953615dc202d97"), nodeUtil = require("7f629ed06fce2fc3");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"44abd4eabcf7b548":"1BUx7","15953615dc202d97":"1FfIP","7f629ed06fce2fc3":"d86ql"}],"1BUx7":[function(require,module,exports,__globalThis) {
var baseGetTag = require("20bedebd4bc4e465"), isLength = require("f0c26499d803e837"), isObjectLike = require("e642347d1fbff1db");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"20bedebd4bc4e465":"eUzNb","f0c26499d803e837":"jXZRq","e642347d1fbff1db":"4gHtY"}],"jXZRq":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"1FfIP":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"d86ql":[function(require,module,exports,__globalThis) {
var freeGlobal = require("7c95d3aa46a64498");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"7c95d3aa46a64498":"bo6wg"}],"hMuXI":[function(require,module,exports,__globalThis) {
var isPrototype = require("54c8ab7b5a428e10"), nativeKeys = require("b7d5fa6f9cb90e3b");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = baseKeys;

},{"54c8ab7b5a428e10":"iZamn","b7d5fa6f9cb90e3b":"gucv3"}],"iZamn":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"gucv3":[function(require,module,exports,__globalThis) {
var overArg = require("79d1c005904e565d");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"79d1c005904e565d":"bVmR1"}],"bVmR1":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"fs9yO":[function(require,module,exports,__globalThis) {
var isFunction = require("4e7f17c836355f2a"), isLength = require("85bef6ea68558f8c");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"4e7f17c836355f2a":"2KQKo","85bef6ea68558f8c":"jXZRq"}],"7Mujc":[function(require,module,exports,__globalThis) {
var DataView = require("b20b6d21515f23dc"), Map = require("b9a330834774850c"), Promise = require("553a14ab92cc8748"), Set = require("6d2fca9bbba6d830"), WeakMap = require("8245fd02d87c8af5"), baseGetTag = require("cc208e51406dc81d"), toSource = require("ff97a38382fff448");
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"b20b6d21515f23dc":"2r7am","b9a330834774850c":"kUeJp","553a14ab92cc8748":"lMRzf","6d2fca9bbba6d830":"6wJSe","8245fd02d87c8af5":"3YWC2","cc208e51406dc81d":"eUzNb","ff97a38382fff448":"6du0v"}],"2r7am":[function(require,module,exports,__globalThis) {
var getNative = require("7710f83d5040797"), root = require("9370e10463a9aa93");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView');
module.exports = DataView;

},{"7710f83d5040797":"3hxI7","9370e10463a9aa93":"g0sWx"}],"lMRzf":[function(require,module,exports,__globalThis) {
var getNative = require("5c46c4ec3ef02571"), root = require("9d880271920186a8");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, 'Promise');
module.exports = Promise;

},{"5c46c4ec3ef02571":"3hxI7","9d880271920186a8":"g0sWx"}],"6wJSe":[function(require,module,exports,__globalThis) {
var getNative = require("97d344864aa8ac29"), root = require("5b735e9c3d589e98");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, 'Set');
module.exports = Set;

},{"97d344864aa8ac29":"3hxI7","5b735e9c3d589e98":"g0sWx"}],"3YWC2":[function(require,module,exports,__globalThis) {
var getNative = require("736b57ab7a6d1f90"), root = require("7bbf2fa35551ad6e");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, 'WeakMap');
module.exports = WeakMap;

},{"736b57ab7a6d1f90":"3hxI7","7bbf2fa35551ad6e":"g0sWx"}],"lYi7Z":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function isNil(value) {
    return value == null;
}
module.exports = isNil;

},{}],"gNfib":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layer", ()=>Layer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "children",
    "className"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Layer = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = _objectWithoutProperties(props, _excluded);
    var layerClass = (0, _clsxDefault.default)('recharts-layer', className);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", _extends({
        className: layerClass
    }, (0, _reactUtils.filterProps)(others, true), {
        ref: ref
    }), children);
});

},{"react":"eGun2","clsx":"3mzHT","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dBf5D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SCALE_TYPES", ()=>SCALE_TYPES);
parcelHelpers.export(exports, "LEGEND_TYPES", ()=>LEGEND_TYPES);
parcelHelpers.export(exports, "TOOLTIP_TYPES", ()=>TOOLTIP_TYPES);
parcelHelpers.export(exports, "getDisplayName", ()=>getDisplayName);
parcelHelpers.export(exports, "toArray", ()=>toArray);
/*
 * Find and return all matched children by type.
 * `type` must be a React.ComponentType
 */ parcelHelpers.export(exports, "findAllByType", ()=>findAllByType);
/*
 * Return the first matched child by type, return null otherwise.
 * `type` must be a React.ComponentType
 */ parcelHelpers.export(exports, "findChildByType", ()=>findChildByType);
parcelHelpers.export(exports, "withoutType", ()=>withoutType);
parcelHelpers.export(exports, "validateWidthHeight", ()=>validateWidthHeight);
parcelHelpers.export(exports, "hasClipDot", ()=>hasClipDot);
parcelHelpers.export(exports, "isValidSpreadableProp", ()=>isValidSpreadableProp);
parcelHelpers.export(exports, "filterSvgElements", ()=>filterSvgElements);
parcelHelpers.export(exports, "filterProps", ()=>filterProps);
parcelHelpers.export(exports, "isChildrenEqual", ()=>isChildrenEqual);
parcelHelpers.export(exports, "isSingleChildEqual", ()=>isSingleChildEqual);
parcelHelpers.export(exports, "renderByOrder", ()=>renderByOrder);
parcelHelpers.export(exports, "getReactEventByType", ()=>getReactEventByType);
parcelHelpers.export(exports, "parseChildIndex", ()=>parseChildIndex);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _react = require("react");
var _reactIs = require("react-is");
var _dataUtils = require("./DataUtils");
var _shallowEqual = require("./ShallowEqual");
var _types = require("./types");
var _excluded = [
    "children"
], _excluded2 = [
    "children"
];
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var REACT_BROWSER_EVENT_MAP = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    mouseout: 'onMouseOut',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    touchcancel: 'onTouchCancel',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchstart: 'onTouchStart',
    contextmenu: 'onContextMenu',
    dblclick: 'onDoubleClick'
};
var SCALE_TYPES = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var LEGEND_TYPES = [
    'plainline',
    'line',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
    'none'
];
var TOOLTIP_TYPES = [
    'none'
];
var getDisplayName = function getDisplayName(Comp) {
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var lastChildren = null;
var lastResult = null;
var toArray = function toArray(children) {
    if (children === lastChildren && Array.isArray(lastResult)) return lastResult;
    var result = [];
    (0, _react.Children).forEach(children, function(child) {
        if ((0, _isNilDefault.default)(child)) return;
        if ((0, _reactIs.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    lastResult = result;
    lastChildren = children;
    return result;
};
function findAllByType(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return getDisplayName(t);
    });
    else types = [
        getDisplayName(type)
    ];
    toArray(children).forEach(function(child) {
        var childType = (0, _getDefault.default)(child, 'type.displayName') || (0, _getDefault.default)(child, 'type.name');
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function findChildByType(children, type) {
    var result = findAllByType(children, type);
    return result && result[0];
}
var withoutType = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return getDisplayName(t);
    });
    else types = [
        getDisplayName(type)
    ];
    toArray(children).forEach(function(child) {
        var displayName = (0, _getDefault.default)(child, 'type.displayName');
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var validateWidthHeight = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, _dataUtils.isNumber)(width) || width <= 0 || !(0, _dataUtils.isNumber)(height) || height <= 0) return false;
    return true;
};
var SVG_TAGS = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColormatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-url',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'hkern',
    'image',
    'line',
    'lineGradient',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'script',
    'set',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'title',
    'tref',
    'tspan',
    'use',
    'view',
    'vkern'
];
var isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, _isStringDefault.default)(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
};
var hasClipDot = function hasClipDot(dot) {
    return dot && _typeof(dot) === 'object' && 'clipDot' in dot;
};
var isValidSpreadableProp = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, _types.FilteredElementKeyMap) === null || (0, _types.FilteredElementKeyMap) === void 0 ? void 0 : (0, _types.FilteredElementKeyMap)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return key.startsWith('data-') || !(0, _isFunctionDefault.default)(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, _types.SVGElementPropKeys).includes(key)) || includeEvents && (0, _types.EventKeys).includes(key);
};
var filterSvgElements = function filterSvgElements(children) {
    var svgElements = [];
    toArray(children).forEach(function(entry) {
        if (isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var filterProps = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, _react.isValidElement)(props)) inputProps = props.props;
    if (!(0, _isObjectDefault.default)(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if (isValidSpreadableProp((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, _react.Children).count(nextChildren);
    if (count !== (0, _react.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return isSingleChildEqual(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!isSingleChildEqual(nextChild, prevChild)) return false;
    }
    return true;
};
var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, _isNilDefault.default)(nextChild) && (0, _isNilDefault.default)(prevChild)) return true;
    if (!(0, _isNilDefault.default)(nextChild) && !(0, _isNilDefault.default)(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = _objectWithoutProperties(_ref, _excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = _objectWithoutProperties(_ref2, _excluded2);
        if (nextChildren && prevChildren) return (0, _shallowEqual.shallowEqual)(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, _shallowEqual.shallowEqual)(nextProps, prevProps);
        return false;
    }
    return false;
};
var renderByOrder = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    toArray(children).forEach(function(child, index) {
        if (isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = getDisplayName(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var getReactEventByType = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && REACT_BROWSER_EVENT_MAP[type]) return REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var parseChildIndex = function parseChildIndex(child, children) {
    return toArray(children).indexOf(child);
};

},{"lodash/get":"dEpuO","lodash/isNil":"lYi7Z","lodash/isString":"29E9a","lodash/isFunction":"2KQKo","lodash/isObject":"cNdKD","react":"eGun2","react-is":"ibOa6","./DataUtils":"lsl3R","./ShallowEqual":"feNgJ","./types":"5mtYY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dEpuO":[function(require,module,exports,__globalThis) {
var baseGet = require("eeda3fa1535474fc");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"eeda3fa1535474fc":"6iITn"}],"6iITn":[function(require,module,exports,__globalThis) {
var castPath = require("b80dcce1cead760"), toKey = require("e448616b4d097e28");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"b80dcce1cead760":"dIRVx","e448616b4d097e28":"9XfVL"}],"dIRVx":[function(require,module,exports,__globalThis) {
var isArray = require("41fcba5a7360b563"), isKey = require("b25db401c6cb770e"), stringToPath = require("e5dd8d6d99f4cb84"), toString = require("814972e37d9ba27e");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"41fcba5a7360b563":"5gfYS","b25db401c6cb770e":"jkEKv","e5dd8d6d99f4cb84":"8xhPL","814972e37d9ba27e":"feA1o"}],"jkEKv":[function(require,module,exports,__globalThis) {
var isArray = require("b27cbfeb088b8d48"), isSymbol = require("d135d189a73d38a3");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"b27cbfeb088b8d48":"5gfYS","d135d189a73d38a3":"3Ftz1"}],"3Ftz1":[function(require,module,exports,__globalThis) {
var baseGetTag = require("a6e049ae526614b7"), isObjectLike = require("2b3b9710f9fc1744");
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"a6e049ae526614b7":"eUzNb","2b3b9710f9fc1744":"4gHtY"}],"8xhPL":[function(require,module,exports,__globalThis) {
var memoizeCapped = require("7787df095fdcb62e");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"7787df095fdcb62e":"lFAwD"}],"lFAwD":[function(require,module,exports,__globalThis) {
var memoize = require("6246d444eed9959");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"6246d444eed9959":"emt2q"}],"emt2q":[function(require,module,exports,__globalThis) {
var MapCache = require("31611f253b6e51f1");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"31611f253b6e51f1":"aGEeK"}],"feA1o":[function(require,module,exports,__globalThis) {
var baseToString = require("9e2e42697027d96e");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
module.exports = toString;

},{"9e2e42697027d96e":"fNy1r"}],"fNy1r":[function(require,module,exports,__globalThis) {
var Symbol = require("863b86af7d541da4"), arrayMap = require("6fbe99938dcdc996"), isArray = require("b67bb3a5d4f43c9b"), isSymbol = require("69e2e47253d45681");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = baseToString;

},{"863b86af7d541da4":"6MIK0","6fbe99938dcdc996":"eouC0","b67bb3a5d4f43c9b":"5gfYS","69e2e47253d45681":"3Ftz1"}],"eouC0":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"9XfVL":[function(require,module,exports,__globalThis) {
var isSymbol = require("c72f6ab82d984416");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = toKey;

},{"c72f6ab82d984416":"3Ftz1"}],"29E9a":[function(require,module,exports,__globalThis) {
var baseGetTag = require("5d41c12aeee6d34a"), isArray = require("729b353537b0d4fa"), isObjectLike = require("38e27ed7764b75c7");
/** `Object#toString` result references. */ var stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"5d41c12aeee6d34a":"eUzNb","729b353537b0d4fa":"5gfYS","38e27ed7764b75c7":"4gHtY"}],"ibOa6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("17d97b099d36d9f6");

},{"17d97b099d36d9f6":"i9elv"}],"i9elv":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t = Symbol.for("react.offscreen"), u;
u = Symbol.for("react.module.reference");
function v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case m:
                    case n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case h:
                            case l:
                            case q:
                            case p:
                            case g:
                                return a;
                            default:
                                return r;
                        }
                }
            case c:
                return r;
        }
    }
}
exports.ContextConsumer = h;
exports.ContextProvider = g;
exports.Element = b;
exports.ForwardRef = l;
exports.Fragment = d;
exports.Lazy = q;
exports.Memo = p;
exports.Portal = c;
exports.Profiler = f;
exports.StrictMode = e;
exports.Suspense = m;
exports.SuspenseList = n;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return v(a) === h;
};
exports.isContextProvider = function(a) {
    return v(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return v(a) === l;
};
exports.isFragment = function(a) {
    return v(a) === d;
};
exports.isLazy = function(a) {
    return v(a) === q;
};
exports.isMemo = function(a) {
    return v(a) === p;
};
exports.isPortal = function(a) {
    return v(a) === c;
};
exports.isProfiler = function(a) {
    return v(a) === f;
};
exports.isStrictMode = function(a) {
    return v(a) === e;
};
exports.isSuspense = function(a) {
    return v(a) === m;
};
exports.isSuspenseList = function(a) {
    return v(a) === n;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
exports.typeOf = v;

},{}],"lsl3R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mathSign", ()=>mathSign);
parcelHelpers.export(exports, "isPercent", ()=>isPercent);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
parcelHelpers.export(exports, "isNullish", ()=>isNullish);
parcelHelpers.export(exports, "isNumOrStr", ()=>isNumOrStr);
parcelHelpers.export(exports, "uniqueId", ()=>uniqueId);
parcelHelpers.export(exports, "getPercentValue", ()=>getPercentValue);
parcelHelpers.export(exports, "getAnyElementOfObject", ()=>getAnyElementOfObject);
parcelHelpers.export(exports, "hasDuplicate", ()=>hasDuplicate);
parcelHelpers.export(exports, "interpolateNumber", ()=>interpolateNumber);
parcelHelpers.export(exports, "findEntryInArray", ()=>findEntryInArray);
parcelHelpers.export(exports, "getLinearRegression", ()=>getLinearRegression);
parcelHelpers.export(exports, "compareValues", ()=>compareValues);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _isNaN = require("lodash/isNaN");
var _isNaNDefault = parcelHelpers.interopDefault(_isNaN);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isNumber = require("lodash/isNumber");
var _isNumberDefault = parcelHelpers.interopDefault(_isNumber);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var mathSign = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var isPercent = function isPercent(value) {
    return (0, _isStringDefault.default)(value) && value.indexOf('%') === value.length - 1;
};
var isNumber = function isNumber(value) {
    return (0, _isNumberDefault.default)(value) && !(0, _isNaNDefault.default)(value);
};
var isNullish = function isNullish(value) {
    return (0, _isNilDefault.default)(value);
};
var isNumOrStr = function isNumOrStr(value) {
    return isNumber(value) || (0, _isStringDefault.default)(value);
};
var idCounter = 0;
var uniqueId = function uniqueId(prefix) {
    var id = ++idCounter;
    return "".concat(prefix || '').concat(id);
};
var getPercentValue = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!isNumber(percent) && !(0, _isStringDefault.default)(percent)) return defaultValue;
    var value;
    if (isPercent(percent)) {
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, _isNaNDefault.default)(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var getAnyElementOfObject = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var hasDuplicate = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var interpolateNumber = function interpolateNumber(numberA, numberB) {
    if (isNumber(numberA) && isNumber(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function findEntryInArray(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, _getDefault.default)(entry, specifiedKey)) === specifiedValue;
    });
}
var getLinearRegression = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};
var compareValues = function compareValues(a, b) {
    if (isNumber(a) && isNumber(b)) return a - b;
    if ((0, _isStringDefault.default)(a) && (0, _isStringDefault.default)(b)) return a.localeCompare(b);
    if (a instanceof Date && b instanceof Date) return a.getTime() - b.getTime();
    return String(a).localeCompare(String(b));
};

},{"lodash/isString":"29E9a","lodash/isNaN":"aERJU","lodash/get":"dEpuO","lodash/isNumber":"au46v","lodash/isNil":"lYi7Z","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"aERJU":[function(require,module,exports,__globalThis) {
var isNumber = require("9dd3f88177b35e0b");
/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return isNumber(value) && value != +value;
}
module.exports = isNaN;

},{"9dd3f88177b35e0b":"au46v"}],"au46v":[function(require,module,exports,__globalThis) {
var baseGetTag = require("4b79113d6b58c471"), isObjectLike = require("72055bcb44670f14");
/** `Object#toString` result references. */ var numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function isNumber(value) {
    return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
}
module.exports = isNumber;

},{"4b79113d6b58c471":"eUzNb","72055bcb44670f14":"4gHtY"}],"feNgJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
function shallowEqual(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5mtYY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SVGElementPropKeys", ()=>SVGElementPropKeys);
parcelHelpers.export(exports, "FilteredElementKeyMap", ()=>FilteredElementKeyMap);
parcelHelpers.export(exports, "EventKeys", ()=>EventKeys);
parcelHelpers.export(exports, "adaptEventHandlers", ()=>adaptEventHandlers);
parcelHelpers.export(exports, "adaptEventsOfChild", ()=>adaptEventsOfChild);
var _react = require("react");
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var SVGContainerPropKeys = [
    'viewBox',
    'children'
];
var SVGElementPropKeys = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var PolyElementKeys = [
    'points',
    'pathLength'
];
var FilteredElementKeyMap = {
    svg: SVGContainerPropKeys,
    polygon: PolyElementKeys,
    polyline: PolyElementKeys
};
var EventKeys = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
var adaptEventHandlers = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, _react.isValidElement)(props)) inputProps = props.props;
    if (!(0, _isObjectDefault.default)(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if (EventKeys.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var adaptEventsOfChild = function adaptEventsOfChild(props, data, index) {
    if (!(0, _isObjectDefault.default)(props) || _typeof(props) !== 'object') return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if (EventKeys.includes(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};

},{"react":"eGun2","lodash/isObject":"cNdKD","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2A4Qz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBar", ()=>ErrorBar);
/**
 * @fileOverview Render a group of error bar
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _layer = require("../container/Layer");
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var ErrorBar = /*#__PURE__*/ function(_React$Component) {
    function ErrorBar() {
        _classCallCheck(this, ErrorBar);
        return _callSuper(this, ErrorBar, arguments);
    }
    _inherits(ErrorBar, _React$Component);
    return _createClass(ErrorBar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, offset = _this$props.offset, layout = _this$props.layout, width = _this$props.width, dataKey = _this$props.dataKey, data = _this$props.data, dataPointFormatter = _this$props.dataPointFormatter, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, others = _objectWithoutProperties(_this$props, _excluded);
                var svgProps = (0, _reactUtils.filterProps)(others, false);
                !!(this.props.direction === 'x' && xAxis.type !== 'number') && (0, _tinyInvariantDefault.default)(false);
                var errorBars = data.map(function(entry) {
                    var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
                    if (!errorVal) return null;
                    var lineCoordinates = [];
                    var lowBound, highBound;
                    if (Array.isArray(errorVal)) {
                        var _errorVal = _slicedToArray(errorVal, 2);
                        lowBound = _errorVal[0];
                        highBound = _errorVal[1];
                    } else lowBound = highBound = errorVal;
                    if (layout === 'vertical') {
                        // error bar for horizontal charts, the y is fixed, x is a range value
                        var scale = xAxis.scale;
                        var yMid = y + offset;
                        var yMin = yMid + width;
                        var yMax = yMid - width;
                        var xMin = scale(value - lowBound);
                        var xMax = scale(value + highBound);
                        // the right line of |--|
                        lineCoordinates.push({
                            x1: xMax,
                            y1: yMin,
                            x2: xMax,
                            y2: yMax
                        });
                        // the middle line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMid,
                            x2: xMax,
                            y2: yMid
                        });
                        // the left line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMin,
                            x2: xMin,
                            y2: yMax
                        });
                    } else if (layout === 'horizontal') {
                        // error bar for horizontal charts, the x is fixed, y is a range value
                        var _scale = yAxis.scale;
                        var xMid = x + offset;
                        var _xMin = xMid - width;
                        var _xMax = xMid + width;
                        var _yMin = _scale(value - lowBound);
                        var _yMax = _scale(value + highBound);
                        // the top line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMax,
                            x2: _xMax,
                            y2: _yMax
                        });
                        // the middle line
                        lineCoordinates.push({
                            x1: xMid,
                            y1: _yMin,
                            x2: xMid,
                            y2: _yMax
                        });
                        // the bottom line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMin,
                            x2: _xMax,
                            y2: _yMin
                        });
                    }
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: "recharts-errorBar",
                        key: "bar-".concat(lineCoordinates.map(function(c) {
                            return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
                        }))
                    }, svgProps), lineCoordinates.map(function(coordinates) {
                        return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, coordinates, {
                            key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
                        }));
                    }));
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-errorBars"
                }, errorBars);
            }
        }
    ]);
}((0, _reactDefault.default).Component);
_defineProperty(ErrorBar, "defaultProps", {
    stroke: 'black',
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: 'horizontal'
});
_defineProperty(ErrorBar, "displayName", 'ErrorBar');

},{"react":"eGun2","tiny-invariant":"4qfOO","../container/Layer":"gNfib","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6TviG":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Cross
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cell", ()=>Cell);
var Cell = function Cell(_props) {
    return null;
};
Cell.displayName = 'Cell';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"j6MTq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LabelList", ()=>LabelList);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _label = require("./Label");
var _layer = require("../container/Layer");
var _reactUtils = require("../util/ReactUtils");
var _chartUtils = require("../util/ChartUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "valueAccessor"
], _excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, _lastDefault.default)(entry.value) : entry.value;
};
function LabelList(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? defaultAccessor : _ref$valueAccessor, restProps = _objectWithoutProperties(_ref, _excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = _objectWithoutProperties(restProps, _excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, _isNilDefault.default)(dataKey) ? valueAccessor(entry, index) : (0, _chartUtils.getValueByDataKey)(entry && entry.payload, dataKey);
        var idProps = (0, _isNilDefault.default)(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Label), _extends({}, (0, _reactUtils.filterProps)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, _label.Label).parseViewBox((0, _isNilDefault.default)(clockWise) ? entry : _objectSpread(_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
LabelList.displayName = 'LabelList';
function parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, _reactDefault.default).createElement(LabelList, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(label) || (0, _isFunctionDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(LabelList, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, _isObjectDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(LabelList, _extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, _reactUtils.findAllByType)(children, LabelList).map(function(child, index) {
        return /*#__PURE__*/ (0, _react.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat(_toConsumableArray(explicitChildren));
}
LabelList.renderCallByParent = renderCallByParent;

},{"react":"eGun2","lodash/isNil":"lYi7Z","lodash/isObject":"cNdKD","lodash/isFunction":"2KQKo","lodash/last":"747XP","./Label":"jhet4","../container/Layer":"gNfib","../util/ReactUtils":"dBf5D","../util/ChartUtils":"55u3i","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"747XP":[function(require,module,exports,__globalThis) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = last;

},{}],"jhet4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", ()=>Label);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _text = require("./Text");
var _reactUtils = require("../util/ReactUtils");
var _dataUtils = require("../util/DataUtils");
var _polarUtils = require("../util/PolarUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "offset"
];
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, _isNilDefault.default)(props.children) ? value : props.children;
    if ((0, _isFunctionDefault.default)(formatter)) return formatter(label);
    return label;
};
var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === 'insideStart') {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === 'insideEnd') {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === 'end') {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, labelAngle);
    var endPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, _isNilDefault.default)(labelProps.id) ? (0, _dataUtils.uniqueId)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("text", _extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, _clsxDefault.default)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, _polarUtils.polarToCartesian)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return _objectSpread(_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return _objectSpread(_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return _objectSpread(_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return _objectSpread(_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === 'insideLeft') return _objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return _objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return _objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return _objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return _objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return _objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return _objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return _objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, _isObjectDefault.default)(position) && ((0, _dataUtils.isNumber)(position.x) || (0, _dataUtils.isPercent)(position.x)) && ((0, _dataUtils.isNumber)(position.y) || (0, _dataUtils.isPercent)(position.y))) return _objectSpread({
        x: x + (0, _dataUtils.getPercentValue)(position.x, width),
        y: y + (0, _dataUtils.getPercentValue)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return _objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var isPolar = function isPolar(viewBox) {
    return 'cx' in viewBox && (0, _dataUtils.isNumber)(viewBox.cx);
};
function Label(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = _objectWithoutProperties(_ref4, _excluded);
    var props = _objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, _isNilDefault.default)(value) && (0, _isNilDefault.default)(children) && !/*#__PURE__*/ (0, _react.isValidElement)(content) && !(0, _isFunctionDefault.default)(content)) return null;
    if (/*#__PURE__*/ (0, _react.isValidElement)(content)) return /*#__PURE__*/ (0, _react.cloneElement)(content, props);
    var label;
    if ((0, _isFunctionDefault.default)(content)) {
        label = /*#__PURE__*/ (0, _react.createElement)(content, props);
        if (/*#__PURE__*/ (0, _react.isValidElement)(label)) return label;
    } else label = getLabel(props);
    var isPolarLabel = isPolar(viewBox);
    var attrs = (0, _reactUtils.filterProps)(props, true);
    if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) return renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
        className: (0, _clsxDefault.default)('recharts-label', className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
Label.displayName = 'Label';
var parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, _dataUtils.isNumber)(width) && (0, _dataUtils.isNumber)(height)) {
        if ((0, _dataUtils.isNumber)(x) && (0, _dataUtils.isNumber)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, _dataUtils.isNumber)(top) && (0, _dataUtils.isNumber)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, _dataUtils.isNumber)(x) && (0, _dataUtils.isNumber)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, _dataUtils.isNumber)(cx) && (0, _dataUtils.isNumber)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, _dataUtils.isNumOrStr)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, _react.isValidElement)(label)) {
        if (label.type === Label) return /*#__PURE__*/ (0, _react.cloneElement)(label, {
            key: 'label-implicit',
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, _isFunctionDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, _isObjectDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, _extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = parseViewBox(parentProps);
    var explicitChildren = (0, _reactUtils.findAllByType)(children, Label).map(function(child, index) {
        return /*#__PURE__*/ (0, _react.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat(_toConsumableArray(explicitChildren));
};
Label.parseViewBox = parseViewBox;
Label.renderCallByParent = renderCallByParent;

},{"react":"eGun2","lodash/isNil":"lYi7Z","lodash/isFunction":"2KQKo","lodash/isObject":"cNdKD","clsx":"3mzHT","./Text":"6tNNj","../util/ReactUtils":"dBf5D","../util/DataUtils":"lsl3R","../util/PolarUtils":"27snq","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6tNNj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", ()=>Text);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../util/DataUtils");
var _global = require("../util/Global");
var _reactUtils = require("../util/ReactUtils");
var _domutils = require("../util/DOMUtils");
var _reduceCSSCalc = require("../util/ReduceCSSCalc");
var _excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], _excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, _isNilDefault.default)(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split(BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, _domutils.getStringSize)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, _domutils.getStringSize)("\xA0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, _dataUtils.isNumber)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = _slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = _slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, _isNilDefault.default)(children) ? children.toString().split(BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, _global.Global).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return getWordsWithoutCalculate(children);
        return calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return getWordsWithoutCalculate(children);
};
var DEFAULT_FILL = '#808080';
var Text = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? '1em' : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? '0.71em' : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? 'start' : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? 'end' : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? DEFAULT_FILL : _ref5$fill, props = _objectWithoutProperties(_ref5, _excluded);
    var wordsByLines = (0, _react.useMemo)(function() {
        return getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = _objectWithoutProperties(props, _excluded2);
    if (!(0, _dataUtils.isNumOrStr)(propsX) || !(0, _dataUtils.isNumOrStr)(propsY)) return null;
    var x = propsX + ((0, _dataUtils.isNumber)(dx) ? dx : 0);
    var y = propsY + ((0, _dataUtils.isNumber)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, _reduceCSSCalc.reduceCSSCalc)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, _reduceCSSCalc.reduceCSSCalc)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, _reduceCSSCalc.reduceCSSCalc)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, _dataUtils.isNumber)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("text", _extends({}, (0, _reactUtils.filterProps)(textProps, true), {
        x: x,
        y: y,
        className: (0, _clsxDefault.default)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? '' : ' ');
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys
        // eslint-disable-next-line react/no-array-index-key
        (0, _reactDefault.default).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
};

},{"react":"eGun2","lodash/isNil":"lYi7Z","clsx":"3mzHT","../util/DataUtils":"lsl3R","../util/Global":"dWTWi","../util/ReactUtils":"dBf5D","../util/DOMUtils":"dgkk6","../util/ReduceCSSCalc":"ypYYi","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dWTWi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Global", ()=>Global);
var parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var Global = {
    isSsr: parseIsSsrByDefault(),
    get: function get(key) {
        return Global[key];
    },
    set: function set(key, value) {
        if (typeof key === 'string') Global[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                Global[k] = key[k];
            });
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dgkk6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStyleString", ()=>getStyleString);
parcelHelpers.export(exports, "getStringSize", ()=>getStringSize);
parcelHelpers.export(exports, "getOffset", ()=>getOffset);
var _global = require("./Global");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var stringCache = {
    widthCache: {},
    cacheCount: 0
};
var MAX_CACHE_NUM = 2000;
var SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var STYLE_LIST = [
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'lineHeight',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function autoCompleteStyle(name, value) {
    if (STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function camelToMiddleLine(text) {
    var strs = text.split('');
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat(_toConsumableArray(result), [
            '-',
            entry.toLowerCase()
        ]);
        return [].concat(_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join('');
}
var getStyleString = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat(camelToMiddleLine(s), ":").concat(autoCompleteStyle(s, style[s]), ";");
    }, '');
};
function removeInvalidKeys(obj) {
    var copyObj = _objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var getStringSize = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, _global.Global).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if (stringCache.widthCache[cacheKey]) return stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = _objectSpread(_objectSpread({}, SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        stringCache.widthCache[cacheKey] = result;
        if (++stringCache.cacheCount > MAX_CACHE_NUM) {
            stringCache.cacheCount = 0;
            stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var getOffset = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};

},{"./Global":"dWTWi","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ypYYi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeEvaluateExpression", ()=>safeEvaluateExpression);
parcelHelpers.export(exports, "reduceCSSCalc", ()=>reduceCSSCalc);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var FIXED_CSS_LENGTH_UNITS = Object.keys(CONVERSION_RATES);
var STR_NAN = 'NaN';
function convertToPx(value, unit) {
    return value * CONVERSION_RATES[unit];
}
var DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        _classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = '';
        if (unit !== '' && !CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if (FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    return _createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = _slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
            }
        }
    ]);
}();
function calculateArithmetic(expr) {
    if (expr.includes(STR_NAN)) return STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = _slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return STR_NAN;
        newExpr = newExpr.replace(MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = _slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return STR_NAN;
        newExpr = newExpr.replace(ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var PARENTHESES_REGEX = /\(([^()]*)\)/;
function calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes('(')){
        var _PARENTHESES_REGEX$ex = PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = _slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace(PARENTHESES_REGEX, calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = calculateParentheses(newExpr);
    newExpr = calculateArithmetic(newExpr);
    return newExpr;
}
function safeEvaluateExpression(expression) {
    try {
        return evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return STR_NAN;
    }
}
function reduceCSSCalc(expression) {
    var result = safeEvaluateExpression(expression.slice(5, -1));
    if (result === STR_NAN) // notify the user
    return '';
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"27snq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RADIAN", ()=>RADIAN);
parcelHelpers.export(exports, "degreeToRadian", ()=>degreeToRadian);
parcelHelpers.export(exports, "radianToDegree", ()=>radianToDegree);
parcelHelpers.export(exports, "polarToCartesian", ()=>polarToCartesian);
parcelHelpers.export(exports, "getMaxRadius", ()=>getMaxRadius);
parcelHelpers.export(exports, "formatAxisMap", ()=>formatAxisMap);
parcelHelpers.export(exports, "distanceBetweenPoints", ()=>distanceBetweenPoints);
parcelHelpers.export(exports, "getAngleOfPoint", ()=>getAngleOfPoint);
parcelHelpers.export(exports, "formatAngleOfSector", ()=>formatAngleOfSector);
parcelHelpers.export(exports, "inRangeOfSector", ()=>inRangeOfSector);
parcelHelpers.export(exports, "getTickClassName", ()=>getTickClassName);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _react = require("react");
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _dataUtils = require("./DataUtils");
var _chartUtils = require("./ChartUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var RADIAN = Math.PI / 180;
var degreeToRadian = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var radianToDegree = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-RADIAN * angle) * radius,
        y: cy + Math.sin(-RADIAN * angle) * radius
    };
};
var getMaxRadius = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, _dataUtils.getPercentValue)(props.cx, width, width / 2);
    var cy = (0, _dataUtils.getPercentValue)(props.cy, height, height / 2);
    var maxRadius = getMaxRadius(width, height, offset);
    var innerRadius = (0, _dataUtils.getPercentValue)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, _dataUtils.getPercentValue)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, _isNilDefault.default)(axis.range)) {
            if (axisType === 'angleAxis') range = [
                startAngle,
                endAngle
            ];
            else if (axisType === 'radiusAxis') range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = _slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, _chartUtils.parseScale)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, _chartUtils.checkDomainOfScale)(scale);
        var ticks = (0, _chartUtils.getTicksOfScale)(scale, _objectSpread(_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = _objectSpread(_objectSpread(_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, id, finalAxis));
    }, {});
};
var distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = distanceBetweenPoints({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: radianToDegree(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var formatAngleOfSector = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var inRangeOfSector = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = getAngleOfPoint({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = formatAngleOfSector(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return _objectSpread(_objectSpread({}, sector), {}, {
        radius: radius,
        angle: reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};
var getTickClassName = function getTickClassName(tick) {
    return !/*#__PURE__*/ (0, _react.isValidElement)(tick) && !(0, _isFunctionDefault.default)(tick) && typeof tick !== 'boolean' ? tick.className : '';
};

},{"lodash/isNil":"lYi7Z","react":"eGun2","lodash/isFunction":"2KQKo","./DataUtils":"lsl3R","./ChartUtils":"55u3i","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"55u3i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Exported for backwards compatibility
parcelHelpers.export(exports, "getLegendProps", ()=>(0, _getLegendProps.getLegendProps));
parcelHelpers.export(exports, "getValueByDataKey", ()=>getValueByDataKey);
/**
 * Get domain of data by key.
 * @param  {Array}   data      The data displayed in the chart
 * @param  {String}  key       The unique key of a group of data
 * @param  {String}  type      The type of axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array} Domain of data
 */ parcelHelpers.export(exports, "getDomainOfDataByKey", ()=>getDomainOfDataByKey);
parcelHelpers.export(exports, "calculateActiveTickIndex", ()=>calculateActiveTickIndex);
parcelHelpers.export(exports, "getMainColorOfGraphicItem", ()=>getMainColorOfGraphicItem);
parcelHelpers.export(exports, "getBarSizeList", ()=>getBarSizeList);
parcelHelpers.export(exports, "getBarPosition", ()=>getBarPosition);
parcelHelpers.export(exports, "appendOffsetOfLegend", ()=>appendOffsetOfLegend);
parcelHelpers.export(exports, "getDomainOfErrorBars", ()=>getDomainOfErrorBars);
parcelHelpers.export(exports, "parseErrorBarsOfAxis", ()=>parseErrorBarsOfAxis);
parcelHelpers.export(exports, "getDomainOfItemsWithSameAxis", ()=>getDomainOfItemsWithSameAxis);
parcelHelpers.export(exports, "isCategoricalAxis", ()=>isCategoricalAxis);
parcelHelpers.export(exports, "getCoordinatesOfGrid", ()=>getCoordinatesOfGrid);
parcelHelpers.export(exports, "getTicksOfAxis", ()=>getTicksOfAxis);
parcelHelpers.export(exports, "combineEventHandlers", ()=>combineEventHandlers);
parcelHelpers.export(exports, "parseScale", ()=>parseScale);
parcelHelpers.export(exports, "checkDomainOfScale", ()=>checkDomainOfScale);
parcelHelpers.export(exports, "findPositionOfBar", ()=>findPositionOfBar);
parcelHelpers.export(exports, "truncateByDomain", ()=>truncateByDomain);
parcelHelpers.export(exports, "offsetSign", ()=>offsetSign);
parcelHelpers.export(exports, "offsetPositive", ()=>offsetPositive);
parcelHelpers.export(exports, "getStackedData", ()=>getStackedData);
parcelHelpers.export(exports, "getStackGroupsByAxisId", ()=>getStackGroupsByAxisId);
parcelHelpers.export(exports, "getTicksOfScale", ()=>getTicksOfScale);
parcelHelpers.export(exports, "getCateCoordinateOfLine", ()=>getCateCoordinateOfLine);
parcelHelpers.export(exports, "getCateCoordinateOfBar", ()=>getCateCoordinateOfBar);
parcelHelpers.export(exports, "getBaseValueOfBar", ()=>getBaseValueOfBar);
parcelHelpers.export(exports, "getStackedDataOfItem", ()=>getStackedDataOfItem);
parcelHelpers.export(exports, "getDomainOfStackGroups", ()=>getDomainOfStackGroups);
parcelHelpers.export(exports, "MIN_VALUE_REG", ()=>MIN_VALUE_REG);
parcelHelpers.export(exports, "MAX_VALUE_REG", ()=>MAX_VALUE_REG);
parcelHelpers.export(exports, "parseSpecifiedDomain", ()=>parseSpecifiedDomain);
parcelHelpers.export(exports, "getBandSizeOfAxis", ()=>getBandSizeOfAxis);
parcelHelpers.export(exports, "parseDomainOfCategoryAxis", ()=>parseDomainOfCategoryAxis);
parcelHelpers.export(exports, "getTooltipItem", ()=>getTooltipItem);
var _d3Scale = require("victory-vendor/d3-scale");
var _d3Shape = require("victory-vendor/d3-shape");
var _max = require("lodash/max");
var _maxDefault = parcelHelpers.interopDefault(_max);
var _min = require("lodash/min");
var _minDefault = parcelHelpers.interopDefault(_min);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _flatMap = require("lodash/flatMap");
var _flatMapDefault = parcelHelpers.interopDefault(_flatMap);
var _isNaN = require("lodash/isNaN");
var _isNaNDefault = parcelHelpers.interopDefault(_isNaN);
var _upperFirst = require("lodash/upperFirst");
var _upperFirstDefault = parcelHelpers.interopDefault(_upperFirst);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _sortBy = require("lodash/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var _rechartsScale = require("recharts-scale");
var _errorBar = require("../cartesian/ErrorBar");
var _dataUtils = require("./DataUtils");
var _reactUtils = require("./ReactUtils");
// TODO: Cause of circular dependency. Needs refactor.
// import { RadiusAxisProps, AngleAxisProps } from '../polar/types';
var _getLegendProps = require("./getLegendProps");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function getValueByDataKey(obj, dataKey, defaultValue) {
    if ((0, _isNilDefault.default)(obj) || (0, _isNilDefault.default)(dataKey)) return defaultValue;
    if ((0, _dataUtils.isNumOrStr)(dataKey)) return (0, _getDefault.default)(obj, dataKey, defaultValue);
    if ((0, _isFunctionDefault.default)(dataKey)) return dataKey(obj);
    return defaultValue;
}
function getDomainOfDataByKey(data, key, type, filterNil) {
    var flattenData = (0, _flatMapDefault.default)(data, function(entry) {
        return getValueByDataKey(entry, key);
    });
    if (type === 'number') {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, _dataUtils.isNumber)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, _minDefault.default)(domain),
            (0, _maxDefault.default)(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, _isNilDefault.default)(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, _dataUtils.isNumOrStr)(entry) || entry instanceof Date ? entry : '';
    });
}
var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, _dataUtils.mathSign)(cur - before) !== (0, _dataUtils.mathSign)(after - cur)) {
                var diffInterval = [];
                if ((0, _dataUtils.mathSign)(after - cur) === (0, _dataUtils.mathSign)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
    var _item$type;
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var defaultedProps = (_item$type = item.type) !== null && _item$type !== void 0 && _item$type.defaultProps ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stroke = defaultedProps.stroke, fill = defaultedProps.fill;
    var result;
    switch(displayName){
        case 'Line':
            result = stroke;
            break;
        case 'Area':
        case 'Radar':
            result = stroke && stroke !== 'none' ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var getBarSizeList = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, _reactUtils.getDisplayName)(item.type).indexOf('Bar') >= 0;
            });
            if (barItems && barItems.length) {
                var barItemDefaultProps = barItems[0].type.defaultProps;
                var barItemProps = barItemDefaultProps !== undefined ? _objectSpread(_objectSpread({}, barItemDefaultProps), barItems[0].props) : barItems[0].props;
                var selfSize = barItemProps.barSize;
                var cateId = barItemProps[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                var barSize = (0, _isNilDefault.default)(selfSize) ? globalSize : selfSize;
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, _isNilDefault.default)(barSize) ? undefined : (0, _dataUtils.getPercentValue)(barSize, totalSize, 0)
                });
            }
        }
    }
    return result;
};
var getBarPosition = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, _dataUtils.getPercentValue)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat(_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, _dataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat(_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var appendOffsetOfLegend = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, _getLegendProps.getLegendProps)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, _dataUtils.isNumber)(offset[align])) return _objectSpread(_objectSpread({}, offset), {}, _defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, _dataUtils.isNumber)(offset[verticalAlign])) return _objectSpread(_objectSpread({}, offset), {}, _defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, _isNilDefault.default)(axisType)) return true;
    if (layout === 'horizontal') return axisType === 'yAxis';
    if (layout === 'vertical') return axisType === 'xAxis';
    if (direction === 'x') return axisType === 'xAxis';
    if (direction === 'y') return axisType === 'yAxis';
    return true;
};
var getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, _reactUtils.findAllByType)(children, (0, _errorBar.ErrorBar)).filter(function(errorBarChild) {
        return isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = getValueByDataKey(entry, dataKey);
            if ((0, _isNilDefault.default)(entryValue)) return result;
            var mainValue = Array.isArray(entryValue) ? [
                (0, _minDefault.default)(entryValue),
                (0, _maxDefault.default)(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = getValueByDataKey(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return getDomainOfErrorBars(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, _isNilDefault.default)(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === 'number' && dataKey) return getDomainOfErrorBars(data, item, dataKey, layout) || getDomainOfDataByKey(data, dataKey, type, filterNil);
        return getDomainOfDataByKey(data, dataKey, type, filterNil);
    });
    if (type === 'number') // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var isCategoricalAxis = function isCategoricalAxis(layout, axisType) {
    return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, _dataUtils.mathSign)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, _isNaNDefault.default)(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var handlerWeakMap = new WeakMap();
var combineEventHandlers = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== 'function') return defaultHandler;
    if (!handlerWeakMap.has(defaultHandler)) handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var parseScale = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return {
            scale: _d3Scale.scaleBand(),
            realScaleType: 'band'
        };
        if (layout === 'radial' && axisType === 'angleAxis') return {
            scale: _d3Scale.scaleLinear(),
            realScaleType: 'linear'
        };
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return {
            scale: _d3Scale.scalePoint(),
            realScaleType: 'point'
        };
        if (type === 'category') return {
            scale: _d3Scale.scaleBand(),
            realScaleType: 'band'
        };
        return {
            scale: _d3Scale.scaleLinear(),
            realScaleType: 'linear'
        };
    }
    if ((0, _isStringDefault.default)(scale)) {
        var name = "scale".concat((0, _upperFirstDefault.default)(scale));
        return {
            scale: (_d3Scale[name] || _d3Scale.scalePoint)(),
            realScaleType: _d3Scale[name] ? name : 'point'
        };
    }
    return (0, _isFunctionDefault.default)(scale) ? {
        scale: scale
    } : {
        scale: _d3Scale.scalePoint(),
        realScaleType: 'point'
    };
};
var EPS = 1e-4;
var checkDomainOfScale = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - EPS;
    var maxValue = Math.max(range[0], range[1]) + EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var findPositionOfBar = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var truncateByDomain = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, _dataUtils.isNumber)(domain[0]) || !(0, _dataUtils.isNumber)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, _dataUtils.isNumber)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, _dataUtils.isNumber)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var offsetSign = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, _isNaNDefault.default)(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var offsetPositive = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, _isNaNDefault.default)(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var STACK_OFFSET_MAP = {
    sign: offsetSign,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, _d3Shape.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, _d3Shape.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, _d3Shape.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, _d3Shape.stackOffsetWiggle),
    positive: offsetPositive
};
var getStackedData = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = STACK_OFFSET_MAP[offsetType];
    var stack = (0, _d3Shape.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +getValueByDataKey(d, key, 0);
    }).order((0, _d3Shape.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$type2;
        var defaultedProps = (_item$type2 = item.type) !== null && _item$type2 !== void 0 && _item$type2.defaultProps ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
        var stackId = defaultedProps.stackId, hide = defaultedProps.hide;
        if (hide) return result;
        var axisId = defaultedProps[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, _dataUtils.isNumOrStr)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, _dataUtils.uniqueId)('_stackId_')] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: getStackedData(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var getTicksOfScale = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== 'auto' && scaleType !== 'linear') return null;
    if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, _minDefault.default)(tickValues),
            (0, _maxDefault.default)(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === 'number') {
        var _domain = scale.domain();
        var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
function getCateCoordinateOfLine(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, _isNilDefault.default)(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, _dataUtils.findEntryInArray)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = getValueByDataKey(entry, !(0, _isNilDefault.default)(dataKey) ? dataKey : axis.dataKey);
    return !(0, _isNilDefault.default)(value) ? axis.scale(value) : null;
}
var getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
    return !(0, _isNilDefault.default)(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var getBaseValueOfBar = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
    var _item$type3;
    var defaultedProps = (_item$type3 = item.type) !== null && _item$type3 !== void 0 && _item$type3.defaultProps ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stackId = defaultedProps.stackId;
    if ((0, _dataUtils.isNumOrStr)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, _minDefault.default)(entry.concat([
                result[0]
            ]).filter((0, _dataUtils.isNumber))),
            (0, _maxDefault.default)(entry.concat([
                result[1]
            ]).filter((0, _dataUtils.isNumber)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, _isFunctionDefault.default)(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, _dataUtils.isNumber)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
        var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, _isFunctionDefault.default)(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, _dataUtils.isNumber)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
        var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, _isFunctionDefault.default)(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, _sortByDefault.default)(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, _isEqualDefault.default)(specifiedDomain, (0, _getDefault.default)(axisChild, 'type.defaultProps.domain'))) return calculatedDomain;
    return specifiedDomain;
};
var getTooltipItem = function getTooltipItem(graphicalItem, payload) {
    var defaultedProps = graphicalItem.type.defaultProps ? _objectSpread(_objectSpread({}, graphicalItem.type.defaultProps), graphicalItem.props) : graphicalItem.props;
    var dataKey = defaultedProps.dataKey, name = defaultedProps.name, unit = defaultedProps.unit, formatter = defaultedProps.formatter, tooltipType = defaultedProps.tooltipType, chartType = defaultedProps.chartType, hide = defaultedProps.hide;
    return _objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(graphicalItem, false)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: getMainColorOfGraphicItem(graphicalItem),
        value: getValueByDataKey(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType,
        hide: hide
    });
};

},{"victory-vendor/d3-scale":"16Gyx","victory-vendor/d3-shape":"jODwB","lodash/max":"ddnjf","lodash/min":"7VS3d","lodash/isNil":"lYi7Z","lodash/isFunction":"2KQKo","lodash/isString":"29E9a","lodash/get":"dEpuO","lodash/flatMap":"1kDMS","lodash/isNaN":"aERJU","lodash/upperFirst":"eESst","lodash/isEqual":"kMH36","lodash/sortBy":"geSBv","recharts-scale":"1jvFS","../cartesian/ErrorBar":"2A4Qz","./DataUtils":"lsl3R","./ReactUtils":"dBf5D","./getLegendProps":"cnMff","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"16Gyx":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.
module.exports = require("ebfe3b8d6886c667");

},{"ebfe3b8d6886c667":"1ILmM"}],"1ILmM":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`
module.exports = require("22afdf09235f70dd");

},{"22afdf09235f70dd":"btyuR"}],"btyuR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return _band.default;
    }
});
Object.defineProperty(exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return _diverging.default;
    }
});
Object.defineProperty(exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return _diverging.divergingLog;
    }
});
Object.defineProperty(exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return _diverging.divergingPow;
    }
});
Object.defineProperty(exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return _diverging.divergingSqrt;
    }
});
Object.defineProperty(exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return _diverging.divergingSymlog;
    }
});
Object.defineProperty(exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return _identity.default;
    }
});
Object.defineProperty(exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return _ordinal.implicit;
    }
});
Object.defineProperty(exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return _linear.default;
    }
});
Object.defineProperty(exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return _log.default;
    }
});
Object.defineProperty(exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return _ordinal.default;
    }
});
Object.defineProperty(exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return _band.point;
    }
});
Object.defineProperty(exports, "scalePow", {
    enumerable: true,
    get: function() {
        return _pow.default;
    }
});
Object.defineProperty(exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return _quantile.default;
    }
});
Object.defineProperty(exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return _quantize.default;
    }
});
Object.defineProperty(exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return _radial.default;
    }
});
Object.defineProperty(exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return _sequential.default;
    }
});
Object.defineProperty(exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialLog;
    }
});
Object.defineProperty(exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialPow;
    }
});
Object.defineProperty(exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return _sequentialQuantile.default;
    }
});
Object.defineProperty(exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialSqrt;
    }
});
Object.defineProperty(exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialSymlog;
    }
});
Object.defineProperty(exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return _pow.sqrt;
    }
});
Object.defineProperty(exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return _symlog.default;
    }
});
Object.defineProperty(exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return _threshold.default;
    }
});
Object.defineProperty(exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return _time.default;
    }
});
Object.defineProperty(exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return _utcTime.default;
    }
});
Object.defineProperty(exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return _tickFormat.default;
    }
});
var _band = _interopRequireWildcard(require("627392a32fa9a2a"));
var _identity = _interopRequireDefault(require("4c6660f124f78340"));
var _linear = _interopRequireDefault(require("469bd3c56251b8a4"));
var _log = _interopRequireDefault(require("8f0c6c527c4e4ce8"));
var _symlog = _interopRequireDefault(require("774882fd2d49e43"));
var _ordinal = _interopRequireWildcard(require("9ab8a08dbe21712b"));
var _pow = _interopRequireWildcard(require("5284d5c874c3f38f"));
var _radial = _interopRequireDefault(require("5bd3fe7781e4d75"));
var _quantile = _interopRequireDefault(require("caeded3e9d06d309"));
var _quantize = _interopRequireDefault(require("bf57c2a51d7df9da"));
var _threshold = _interopRequireDefault(require("f9cd7e7e4d8cfa6e"));
var _time = _interopRequireDefault(require("28c6731e09457f1a"));
var _utcTime = _interopRequireDefault(require("20174fc149ef300e"));
var _sequential = _interopRequireWildcard(require("ee2b24076ef9869c"));
var _sequentialQuantile = _interopRequireDefault(require("61345a79097ee008"));
var _diverging = _interopRequireWildcard(require("27506c47b7071f87"));
var _tickFormat = _interopRequireDefault(require("5370dd43ddc07082"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"627392a32fa9a2a":"egnsD","4c6660f124f78340":"2UQVZ","469bd3c56251b8a4":"1dzut","8f0c6c527c4e4ce8":"kkUTx","774882fd2d49e43":"lgeZg","9ab8a08dbe21712b":"dMENI","5284d5c874c3f38f":"1LlPy","5bd3fe7781e4d75":"381pj","caeded3e9d06d309":"dHejM","bf57c2a51d7df9da":"h2A8W","f9cd7e7e4d8cfa6e":"6LIdm","28c6731e09457f1a":"6eQCj","20174fc149ef300e":"eeHuN","ee2b24076ef9869c":"ithwT","61345a79097ee008":"eCHVE","27506c47b7071f87":"jPSZ7","5370dd43ddc07082":"6RWUe"}],"egnsD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = band;
exports.point = point;
var _index = require("1145fdf270be28ed");
var _init = require("b64c624a0feda17c");
var _ordinal = _interopRequireDefault(require("861a30645b92f7ea"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function band() {
    var scale = (0, _ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _index.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return _init.initRange.apply(rescale(), arguments);
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band.apply(null, arguments).paddingInner(1));
}

},{"1145fdf270be28ed":"5BPmK","b64c624a0feda17c":"8wgSr","861a30645b92f7ea":"dMENI"}],"5BPmK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Adder", {
    enumerable: true,
    get: function() {
        return _fsum.Adder;
    }
});
Object.defineProperty(exports, "InternMap", {
    enumerable: true,
    get: function() {
        return _index.InternMap;
    }
});
Object.defineProperty(exports, "InternSet", {
    enumerable: true,
    get: function() {
        return _index.InternSet;
    }
});
Object.defineProperty(exports, "ascending", {
    enumerable: true,
    get: function() {
        return _ascending.default;
    }
});
Object.defineProperty(exports, "bin", {
    enumerable: true,
    get: function() {
        return _bin.default;
    }
});
Object.defineProperty(exports, "bisect", {
    enumerable: true,
    get: function() {
        return _bisect.default;
    }
});
Object.defineProperty(exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return _bisect.bisectCenter;
    }
});
Object.defineProperty(exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return _bisect.bisectLeft;
    }
});
Object.defineProperty(exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return _bisect.bisectRight;
    }
});
Object.defineProperty(exports, "bisector", {
    enumerable: true,
    get: function() {
        return _bisector.default;
    }
});
Object.defineProperty(exports, "count", {
    enumerable: true,
    get: function() {
        return _count.default;
    }
});
Object.defineProperty(exports, "cross", {
    enumerable: true,
    get: function() {
        return _cross.default;
    }
});
Object.defineProperty(exports, "cumsum", {
    enumerable: true,
    get: function() {
        return _cumsum.default;
    }
});
Object.defineProperty(exports, "descending", {
    enumerable: true,
    get: function() {
        return _descending.default;
    }
});
Object.defineProperty(exports, "deviation", {
    enumerable: true,
    get: function() {
        return _deviation.default;
    }
});
Object.defineProperty(exports, "difference", {
    enumerable: true,
    get: function() {
        return _difference.default;
    }
});
Object.defineProperty(exports, "disjoint", {
    enumerable: true,
    get: function() {
        return _disjoint.default;
    }
});
Object.defineProperty(exports, "every", {
    enumerable: true,
    get: function() {
        return _every.default;
    }
});
Object.defineProperty(exports, "extent", {
    enumerable: true,
    get: function() {
        return _extent.default;
    }
});
Object.defineProperty(exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return _fsum.fcumsum;
    }
});
Object.defineProperty(exports, "filter", {
    enumerable: true,
    get: function() {
        return _filter.default;
    }
});
Object.defineProperty(exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return _group.flatGroup;
    }
});
Object.defineProperty(exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return _group.flatRollup;
    }
});
Object.defineProperty(exports, "fsum", {
    enumerable: true,
    get: function() {
        return _fsum.fsum;
    }
});
Object.defineProperty(exports, "greatest", {
    enumerable: true,
    get: function() {
        return _greatest.default;
    }
});
Object.defineProperty(exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return _greatestIndex.default;
    }
});
Object.defineProperty(exports, "group", {
    enumerable: true,
    get: function() {
        return _group.default;
    }
});
Object.defineProperty(exports, "groupSort", {
    enumerable: true,
    get: function() {
        return _groupSort.default;
    }
});
Object.defineProperty(exports, "groups", {
    enumerable: true,
    get: function() {
        return _group.groups;
    }
});
Object.defineProperty(exports, "histogram", {
    enumerable: true,
    get: function() {
        return _bin.default;
    }
});
Object.defineProperty(exports, "index", {
    enumerable: true,
    get: function() {
        return _group.index;
    }
});
Object.defineProperty(exports, "indexes", {
    enumerable: true,
    get: function() {
        return _group.indexes;
    }
});
Object.defineProperty(exports, "intersection", {
    enumerable: true,
    get: function() {
        return _intersection.default;
    }
});
Object.defineProperty(exports, "least", {
    enumerable: true,
    get: function() {
        return _least.default;
    }
});
Object.defineProperty(exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return _leastIndex.default;
    }
});
Object.defineProperty(exports, "map", {
    enumerable: true,
    get: function() {
        return _map.default;
    }
});
Object.defineProperty(exports, "max", {
    enumerable: true,
    get: function() {
        return _max.default;
    }
});
Object.defineProperty(exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return _maxIndex.default;
    }
});
Object.defineProperty(exports, "mean", {
    enumerable: true,
    get: function() {
        return _mean.default;
    }
});
Object.defineProperty(exports, "median", {
    enumerable: true,
    get: function() {
        return _median.default;
    }
});
Object.defineProperty(exports, "merge", {
    enumerable: true,
    get: function() {
        return _merge.default;
    }
});
Object.defineProperty(exports, "min", {
    enumerable: true,
    get: function() {
        return _min.default;
    }
});
Object.defineProperty(exports, "minIndex", {
    enumerable: true,
    get: function() {
        return _minIndex.default;
    }
});
Object.defineProperty(exports, "mode", {
    enumerable: true,
    get: function() {
        return _mode.default;
    }
});
Object.defineProperty(exports, "nice", {
    enumerable: true,
    get: function() {
        return _nice.default;
    }
});
Object.defineProperty(exports, "pairs", {
    enumerable: true,
    get: function() {
        return _pairs.default;
    }
});
Object.defineProperty(exports, "permute", {
    enumerable: true,
    get: function() {
        return _permute.default;
    }
});
Object.defineProperty(exports, "quantile", {
    enumerable: true,
    get: function() {
        return _quantile.default;
    }
});
Object.defineProperty(exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return _quantile.quantileSorted;
    }
});
Object.defineProperty(exports, "quickselect", {
    enumerable: true,
    get: function() {
        return _quickselect.default;
    }
});
Object.defineProperty(exports, "range", {
    enumerable: true,
    get: function() {
        return _range.default;
    }
});
Object.defineProperty(exports, "rank", {
    enumerable: true,
    get: function() {
        return _rank.default;
    }
});
Object.defineProperty(exports, "reduce", {
    enumerable: true,
    get: function() {
        return _reduce.default;
    }
});
Object.defineProperty(exports, "reverse", {
    enumerable: true,
    get: function() {
        return _reverse.default;
    }
});
Object.defineProperty(exports, "rollup", {
    enumerable: true,
    get: function() {
        return _group.rollup;
    }
});
Object.defineProperty(exports, "rollups", {
    enumerable: true,
    get: function() {
        return _group.rollups;
    }
});
Object.defineProperty(exports, "scan", {
    enumerable: true,
    get: function() {
        return _scan.default;
    }
});
Object.defineProperty(exports, "shuffle", {
    enumerable: true,
    get: function() {
        return _shuffle.default;
    }
});
Object.defineProperty(exports, "shuffler", {
    enumerable: true,
    get: function() {
        return _shuffle.shuffler;
    }
});
Object.defineProperty(exports, "some", {
    enumerable: true,
    get: function() {
        return _some.default;
    }
});
Object.defineProperty(exports, "sort", {
    enumerable: true,
    get: function() {
        return _sort.default;
    }
});
Object.defineProperty(exports, "subset", {
    enumerable: true,
    get: function() {
        return _subset.default;
    }
});
Object.defineProperty(exports, "sum", {
    enumerable: true,
    get: function() {
        return _sum.default;
    }
});
Object.defineProperty(exports, "superset", {
    enumerable: true,
    get: function() {
        return _superset.default;
    }
});
Object.defineProperty(exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return _freedmanDiaconis.default;
    }
});
Object.defineProperty(exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return _scott.default;
    }
});
Object.defineProperty(exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return _sturges.default;
    }
});
Object.defineProperty(exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return _ticks.tickIncrement;
    }
});
Object.defineProperty(exports, "tickStep", {
    enumerable: true,
    get: function() {
        return _ticks.tickStep;
    }
});
Object.defineProperty(exports, "ticks", {
    enumerable: true,
    get: function() {
        return _ticks.default;
    }
});
Object.defineProperty(exports, "transpose", {
    enumerable: true,
    get: function() {
        return _transpose.default;
    }
});
Object.defineProperty(exports, "union", {
    enumerable: true,
    get: function() {
        return _union.default;
    }
});
Object.defineProperty(exports, "variance", {
    enumerable: true,
    get: function() {
        return _variance.default;
    }
});
Object.defineProperty(exports, "zip", {
    enumerable: true,
    get: function() {
        return _zip.default;
    }
});
var _bisect = _interopRequireWildcard(require("ff4a9a28d7410c90"));
var _ascending = _interopRequireDefault(require("25a9c12e9f7dcc97"));
var _bisector = _interopRequireDefault(require("ccbda642aff354b0"));
var _count = _interopRequireDefault(require("d8bce5484688167c"));
var _cross = _interopRequireDefault(require("7d333560160da904"));
var _cumsum = _interopRequireDefault(require("cd58f279a0ad8dc4"));
var _descending = _interopRequireDefault(require("84847562663058ea"));
var _deviation = _interopRequireDefault(require("a5b586d3be17f517"));
var _extent = _interopRequireDefault(require("34b4f0991e01100f"));
var _fsum = require("93f38eb06bf21063");
var _group = _interopRequireWildcard(require("c04864febc6f7a46"));
var _groupSort = _interopRequireDefault(require("96608e25a5821eea"));
var _bin = _interopRequireDefault(require("29cee9ebd16f96c1"));
var _freedmanDiaconis = _interopRequireDefault(require("777874bf7fb52215"));
var _scott = _interopRequireDefault(require("e57fa0ff7ba50805"));
var _sturges = _interopRequireDefault(require("4faad357788f9349"));
var _max = _interopRequireDefault(require("26993a1e3ff06021"));
var _maxIndex = _interopRequireDefault(require("72e0a4577405566e"));
var _mean = _interopRequireDefault(require("fe6a683baaaf52d4"));
var _median = _interopRequireDefault(require("178051ec720b0bdd"));
var _merge = _interopRequireDefault(require("1428441386d63531"));
var _min = _interopRequireDefault(require("3e94b40b62c8ef3"));
var _minIndex = _interopRequireDefault(require("d8d564ae02ed736d"));
var _mode = _interopRequireDefault(require("4c636fc2c2d7a590"));
var _nice = _interopRequireDefault(require("b2aa4e10f47fef9e"));
var _pairs = _interopRequireDefault(require("ed71c5a845ca7eab"));
var _permute = _interopRequireDefault(require("e014792b1414fecb"));
var _quantile = _interopRequireWildcard(require("bba2a3cd05db3cd4"));
var _quickselect = _interopRequireDefault(require("c50ad0302911fb06"));
var _range = _interopRequireDefault(require("efdd407b1e1ac954"));
var _rank = _interopRequireDefault(require("d520ea120d8f8d31"));
var _least = _interopRequireDefault(require("7af8836021131e2a"));
var _leastIndex = _interopRequireDefault(require("ddf493ef8b7d5a22"));
var _greatest = _interopRequireDefault(require("7ea401cf8103132"));
var _greatestIndex = _interopRequireDefault(require("55044b90df6ebed5"));
var _scan = _interopRequireDefault(require("2023d981c2cf6aad"));
var _shuffle = _interopRequireWildcard(require("c141d6c07ab85760"));
var _sum = _interopRequireDefault(require("3ee024005a2bedd6"));
var _ticks = _interopRequireWildcard(require("c4b4f0e86e0e2c76"));
var _transpose = _interopRequireDefault(require("401571ea2edd887c"));
var _variance = _interopRequireDefault(require("a62492fe952ee4dc"));
var _zip = _interopRequireDefault(require("bb24e4bd8f96db79"));
var _every = _interopRequireDefault(require("1f25cf4b74955a6"));
var _some = _interopRequireDefault(require("aebd264782543b1f"));
var _filter = _interopRequireDefault(require("c5cde0beb09acd3d"));
var _map = _interopRequireDefault(require("42c93982a9d676f8"));
var _reduce = _interopRequireDefault(require("ae71956bb889d332"));
var _reverse = _interopRequireDefault(require("b2c88351e8152db2"));
var _sort = _interopRequireDefault(require("170aaaeed9309030"));
var _difference = _interopRequireDefault(require("21bcb33078a63095"));
var _disjoint = _interopRequireDefault(require("528a114a68451836"));
var _intersection = _interopRequireDefault(require("bb34405ba98018e4"));
var _subset = _interopRequireDefault(require("75110a412b28a012"));
var _superset = _interopRequireDefault(require("ad66e233a1be2854"));
var _union = _interopRequireDefault(require("b252d9e435bc0c86"));
var _index = require("44aa67d16d68e4d4");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"ff4a9a28d7410c90":"8F6jn","25a9c12e9f7dcc97":"2jcoh","ccbda642aff354b0":"h0Zdi","d8bce5484688167c":"2JIJy","7d333560160da904":"3h5yg","cd58f279a0ad8dc4":"khW3f","84847562663058ea":"gu2dD","a5b586d3be17f517":"kPurF","34b4f0991e01100f":"ji9RH","93f38eb06bf21063":"d5F5q","c04864febc6f7a46":"gcb7a","96608e25a5821eea":"hITjv","29cee9ebd16f96c1":"eOCUQ","777874bf7fb52215":"hoE62","e57fa0ff7ba50805":"jwsgL","4faad357788f9349":"2spBC","26993a1e3ff06021":"aITRP","72e0a4577405566e":"bvQHn","fe6a683baaaf52d4":"iDCyL","178051ec720b0bdd":"6SbRX","1428441386d63531":"49x91","3e94b40b62c8ef3":"kDwK7","d8d564ae02ed736d":"1sLYs","4c636fc2c2d7a590":"h1gXV","b2aa4e10f47fef9e":"65UBB","ed71c5a845ca7eab":"f3B80","e014792b1414fecb":"l5cyW","bba2a3cd05db3cd4":"a0Ie4","c50ad0302911fb06":"7vwKy","efdd407b1e1ac954":"kkdU0","d520ea120d8f8d31":"b1mat","7af8836021131e2a":"3Tf0n","ddf493ef8b7d5a22":"6sTex","7ea401cf8103132":"iJKr9","55044b90df6ebed5":"lsR68","2023d981c2cf6aad":"dfADX","c141d6c07ab85760":"lAi4Q","3ee024005a2bedd6":"bzoPJ","c4b4f0e86e0e2c76":"1qfOA","401571ea2edd887c":"7RVeg","a62492fe952ee4dc":"kzjSr","bb24e4bd8f96db79":"bbf3v","1f25cf4b74955a6":"WctGb","aebd264782543b1f":"iKIIE","c5cde0beb09acd3d":"HG1UZ","42c93982a9d676f8":"jaN7D","ae71956bb889d332":"8XMd7","b2c88351e8152db2":"jqBJH","170aaaeed9309030":"b6oeF","21bcb33078a63095":"9gs4I","528a114a68451836":"felju","bb34405ba98018e4":"6TY3r","75110a412b28a012":"lEt4a","ad66e233a1be2854":"h2kae","b252d9e435bc0c86":"126q8","44aa67d16d68e4d4":"h7J1g"}],"8F6jn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.bisectRight = exports.bisectLeft = exports.bisectCenter = void 0;
var _ascending = _interopRequireDefault(require("a1dba7fb8ffdedda"));
var _bisector = _interopRequireDefault(require("69344af94aa6ded2"));
var _number = _interopRequireDefault(require("c683c6eea0b101a0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const ascendingBisect = (0, _bisector.default)(_ascending.default);
const bisectRight = ascendingBisect.right;
exports.bisectRight = bisectRight;
const bisectLeft = ascendingBisect.left;
exports.bisectLeft = bisectLeft;
const bisectCenter = (0, _bisector.default)(_number.default).center;
exports.bisectCenter = bisectCenter;
var _default = bisectRight;
exports.default = _default;

},{"a1dba7fb8ffdedda":"2jcoh","69344af94aa6ded2":"h0Zdi","c683c6eea0b101a0":"cMDR0"}],"2jcoh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ascending;
function ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{}],"h0Zdi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = bisector;
var _ascending = _interopRequireDefault(require("26f782636bc2539c"));
var _descending = _interopRequireDefault(require("142ca10f06644a70"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = _ascending.default;
        compare2 = (d, x)=>(0, _ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === _ascending.default || f === _descending.default ? f : zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left,
        center,
        right
    };
}
function zero() {
    return 0;
}

},{"26f782636bc2539c":"2jcoh","142ca10f06644a70":"gu2dD"}],"gu2dD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = descending;
function descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{}],"cMDR0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = number;
exports.numbers = numbers;
function number(x) {
    return x === null ? NaN : +x;
}
function* numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

},{}],"2JIJy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = count;
function count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

},{}],"3h5yg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cross;
function length(array) {
    return array.length | 0;
}
function empty(length) {
    return !(length > 0);
}
function arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function reducer(reduce) {
    return (values)=>reduce(...values);
}
function cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
    values = values.map(arrayify);
    const lengths = values.map(length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some(empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

},{}],"khW3f":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cumsum;
function cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

},{}],"kPurF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deviation;
var _variance = _interopRequireDefault(require("9158c219d21cdc1f"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function deviation(values, valueof) {
    const v = (0, _variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

},{"9158c219d21cdc1f":"kzjSr"}],"kzjSr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = variance;
function variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

},{}],"ji9RH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = extent;
function extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

},{}],"d5F5q":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Adder = void 0;
exports.fcumsum = fcumsum;
exports.fsum = fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
exports.Adder = Adder;
function fsum(values, valueof) {
    const adder = new Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function fcumsum(values, valueof) {
    const adder = new Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

},{}],"gcb7a":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = group;
exports.flatGroup = flatGroup;
exports.flatRollup = flatRollup;
exports.groups = groups;
exports.index = index;
exports.indexes = indexes;
exports.rollup = rollup;
exports.rollups = rollups;
var _index = require("38a19fafb86cab2f");
var _identity = _interopRequireDefault(require("758db5c4402eb3f7"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function group(values, ...keys) {
    return nest(values, _identity.default, _identity.default, keys);
}
function groups(values, ...keys) {
    return nest(values, Array.from, _identity.default, keys);
}
function flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function flatGroup(values, ...keys) {
    return flatten(groups(values, ...keys), keys);
}
function flatRollup(values, reduce, ...keys) {
    return flatten(rollups(values, reduce, ...keys), keys);
}
function rollup(values, reduce, ...keys) {
    return nest(values, _identity.default, reduce, keys);
}
function rollups(values, reduce, ...keys) {
    return nest(values, Array.from, reduce, keys);
}
function index(values, ...keys) {
    return nest(values, _identity.default, unique, keys);
}
function indexes(values, ...keys) {
    return nest(values, Array.from, unique, keys);
}
function unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new _index.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

},{"38a19fafb86cab2f":"h7J1g","758db5c4402eb3f7":"1A2I0"}],"h7J1g":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InternSet = exports.InternMap = void 0;
class InternMap extends Map {
    constructor(entries, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get(intern_get(this, key));
    }
    has(key) {
        return super.has(intern_get(this, key));
    }
    set(key, value) {
        return super.set(intern_set(this, key), value);
    }
    delete(key) {
        return super.delete(intern_delete(this, key));
    }
}
exports.InternMap = InternMap;
class InternSet extends Set {
    constructor(values, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has(intern_get(this, value));
    }
    add(value) {
        return super.add(intern_set(this, value));
    }
    delete(value) {
        return super.delete(intern_delete(this, value));
    }
}
exports.InternSet = InternSet;
function intern_get({ _intern, _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function intern_delete({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{}],"1A2I0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = identity;
function identity(x) {
    return x;
}

},{}],"hITjv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = groupSort;
var _ascending = _interopRequireDefault(require("74fb6ad27c412e76"));
var _group = _interopRequireWildcard(require("174ef8046f36a9d3"));
var _sort = _interopRequireDefault(require("a4ff02ece62acd25"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, _sort.default)((0, _group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, _ascending.default)(av, bv) || (0, _ascending.default)(ak, bk)) : (0, _sort.default)((0, _group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, _ascending.default)(ak, bk))).map(([key])=>key);
}

},{"74fb6ad27c412e76":"2jcoh","174ef8046f36a9d3":"gcb7a","a4ff02ece62acd25":"b6oeF"}],"b6oeF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ascendingDefined = ascendingDefined;
exports.compareDefined = compareDefined;
exports.default = sort;
var _ascending = _interopRequireDefault(require("f65adcc7b9b72651"));
var _permute = _interopRequireDefault(require("8a5b8227f7758412"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>ascendingDefined(f[i], f[j]));
        }
        return (0, _permute.default)(values, index);
    }
    return values.sort(compareDefined(f));
}
function compareDefined(compare = _ascending.default) {
    if (compare === _ascending.default) return ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

},{"f65adcc7b9b72651":"2jcoh","8a5b8227f7758412":"l5cyW"}],"l5cyW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = permute;
function permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

},{}],"eOCUQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = bin;
var _array = require("2105fdf7fa597639");
var _bisect = _interopRequireDefault(require("5e3b46ee6cc83d8a"));
var _constant = _interopRequireDefault(require("2802d9bb1bc7f9bb"));
var _extent = _interopRequireDefault(require("10f2bfd23c1a448b"));
var _identity = _interopRequireDefault(require("5610a85de7287f4d"));
var _nice = _interopRequireDefault(require("26f4e8685e62660b"));
var _ticks = _interopRequireWildcard(require("8d131c2183aa48dd"));
var _sturges = _interopRequireDefault(require("8717e1706827489e"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function bin() {
    var value = _identity.default, domain = _extent.default, threshold = _sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === _extent.default) [x0, x1] = (0, _nice.default)(x0, x1, tn);
            tz = (0, _ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, _ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === _extent.default) {
                    const step = (0, _ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, _bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constant.default)(_array.slice.call(_)) : (0, _constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

},{"2105fdf7fa597639":"kjmsw","5e3b46ee6cc83d8a":"8F6jn","2802d9bb1bc7f9bb":"25gAN","10f2bfd23c1a448b":"ji9RH","5610a85de7287f4d":"1A2I0","26f4e8685e62660b":"65UBB","8d131c2183aa48dd":"1qfOA","8717e1706827489e":"2spBC"}],"kjmsw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.slice = exports.map = void 0;
var array = Array.prototype;
var slice = array.slice;
exports.slice = slice;
var map = array.map;
exports.map = map;

},{}],"25gAN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = constant;
function constant(x) {
    return ()=>x;
}

},{}],"65UBB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = nice;
var _ticks = require("627caf7ad53df52a");
function nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, _ticks.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

},{"627caf7ad53df52a":"1qfOA"}],"1qfOA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ticks;
exports.tickIncrement = tickIncrement;
exports.tickStep = tickStep;
var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= e10) step1 *= 10;
    else if (error >= e5) step1 *= 5;
    else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

},{}],"2spBC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = thresholdSturges;
var _count = _interopRequireDefault(require("363cebce32267f34"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function thresholdSturges(values) {
    return Math.ceil(Math.log((0, _count.default)(values)) / Math.LN2) + 1;
}

},{"363cebce32267f34":"2JIJy"}],"hoE62":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = thresholdFreedmanDiaconis;
var _count = _interopRequireDefault(require("c3da038062382c"));
var _quantile = _interopRequireDefault(require("60206fa5a1033e60"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, _quantile.default)(values, 0.75) - (0, _quantile.default)(values, 0.25)) * Math.pow((0, _count.default)(values), -1 / 3)));
}

},{"c3da038062382c":"2JIJy","60206fa5a1033e60":"a0Ie4"}],"a0Ie4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quantile;
exports.quantileSorted = quantileSorted;
var _max = _interopRequireDefault(require("dccfcf51648b584f"));
var _min = _interopRequireDefault(require("1a4bfa08beceb37f"));
var _quickselect = _interopRequireDefault(require("7a8647dced92f12e"));
var _number = _interopRequireWildcard(require("7bb994c756d7c386"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function quantile(values, p, valueof) {
    values = Float64Array.from((0, _number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, _min.default)(values);
    if (p >= 1) return (0, _max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, _max.default)((0, _quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, _min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p, valueof = _number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

},{"dccfcf51648b584f":"aITRP","1a4bfa08beceb37f":"kDwK7","7a8647dced92f12e":"7vwKy","7bb994c756d7c386":"cMDR0"}],"aITRP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = max;
function max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

},{}],"kDwK7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = min;
function min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

},{}],"7vwKy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quickselect;
var _sort = require("a900f3920937a21");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? _sort.ascendingDefined : (0, _sort.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        swap(array, left, k);
        if (compare(array[right], t) > 0) swap(array, left, right);
        while(i < j){
            swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) swap(array, left, j);
        else ++j, swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

},{"a900f3920937a21":"b6oeF"}],"jwsgL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = thresholdScott;
var _count = _interopRequireDefault(require("b1c88e498b0ddde2"));
var _deviation = _interopRequireDefault(require("f0667a4cd4fb27bf"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, _count.default)(values)) / (3.49 * (0, _deviation.default)(values)));
}

},{"b1c88e498b0ddde2":"2JIJy","f0667a4cd4fb27bf":"kPurF"}],"bvQHn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = maxIndex;
function maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

},{}],"iDCyL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mean;
function mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

},{}],"6SbRX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = median;
var _quantile = _interopRequireDefault(require("b59060b3f77e4abe"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function median(values, valueof) {
    return (0, _quantile.default)(values, 0.5, valueof);
}

},{"b59060b3f77e4abe":"a0Ie4"}],"49x91":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = merge;
function* flatten(arrays) {
    for (const array of arrays)yield* array;
}
function merge(arrays) {
    return Array.from(flatten(arrays));
}

},{}],"1sLYs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = minIndex;
function minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

},{}],"h1gXV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mode;
var _index = require("7a14813328897cb3");
function mode(values, valueof) {
    const counts = new _index.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

},{"7a14813328897cb3":"h7J1g"}],"f3B80":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pairs;
exports.pair = pair;
function pairs(values, pairof = pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function pair(a, b) {
    return [
        a,
        b
    ];
}

},{}],"kkdU0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = range;
function range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

},{}],"b1mat":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = rank;
var _ascending = _interopRequireDefault(require("f887b1ac4afa859d"));
var _sort = require("b7fece27d36c68d1");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function rank(values, valueof = _ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = _ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === _ascending.default ? (i, j)=>(0, _sort.ascendingDefined)(V[i], V[j]) : (0, _sort.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

},{"f887b1ac4afa859d":"2jcoh","b7fece27d36c68d1":"b6oeF"}],"3Tf0n":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = least;
var _ascending = _interopRequireDefault(require("35a7def11b8ab1ad"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function least(values, compare = _ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascending.default)(value, minValue) < 0 : (0, _ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

},{"35a7def11b8ab1ad":"2jcoh"}],"6sTex":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = leastIndex;
var _ascending = _interopRequireDefault(require("8cd12efb66b08513"));
var _minIndex = _interopRequireDefault(require("f18fee361d17c88"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function leastIndex(values, compare = _ascending.default) {
    if (compare.length === 1) return (0, _minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

},{"8cd12efb66b08513":"2jcoh","f18fee361d17c88":"1sLYs"}],"iJKr9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = greatest;
var _ascending = _interopRequireDefault(require("d2d3ccd8bc596547"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function greatest(values, compare = _ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascending.default)(value, maxValue) > 0 : (0, _ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

},{"d2d3ccd8bc596547":"2jcoh"}],"lsR68":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = greatestIndex;
var _ascending = _interopRequireDefault(require("4eb48ef13457ba19"));
var _maxIndex = _interopRequireDefault(require("d9568ae178fa9ba1"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function greatestIndex(values, compare = _ascending.default) {
    if (compare.length === 1) return (0, _maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

},{"4eb48ef13457ba19":"2jcoh","d9568ae178fa9ba1":"bvQHn"}],"dfADX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = scan;
var _leastIndex = _interopRequireDefault(require("1cbed7069f7df094"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function scan(values, compare) {
    const index = (0, _leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

},{"1cbed7069f7df094":"6sTex"}],"lAi4Q":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.shuffler = shuffler;
var _default = shuffler(Math.random);
exports.default = _default;
function shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

},{}],"bzoPJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sum;
function sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

},{}],"7RVeg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = transpose;
var _min = _interopRequireDefault(require("ce5d2968c83cb269"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, _min.default)(matrix, length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function length(d) {
    return d.length;
}

},{"ce5d2968c83cb269":"kDwK7"}],"bbf3v":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = zip;
var _transpose = _interopRequireDefault(require("d8d2985235466d35"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function zip() {
    return (0, _transpose.default)(arguments);
}

},{"d8d2985235466d35":"7RVeg"}],"WctGb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = every;
function every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

},{}],"iKIIE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = some;
function some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

},{}],"HG1UZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = filter;
function filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

},{}],"jaN7D":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = map;
function map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

},{}],"8XMd7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reduce;
function reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done, value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

},{}],"jqBJH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reverse;
function reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

},{}],"9gs4I":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = difference;
var _index = require("c53f3e174537af76");
function difference(values, ...others) {
    values = new _index.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

},{"c53f3e174537af76":"h7J1g"}],"felju":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = disjoint;
var _index = require("5a2599c78c58d86e");
function disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new _index.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

},{"5a2599c78c58d86e":"h7J1g"}],"6TY3r":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = intersection;
var _index = require("93903b2d73efea16");
function intersection(values, ...others) {
    values = new _index.InternSet(values);
    others = others.map(set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function set(values) {
    return values instanceof _index.InternSet ? values : new _index.InternSet(values);
}

},{"93903b2d73efea16":"h7J1g"}],"lEt4a":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = subset;
var _superset = _interopRequireDefault(require("f8e3d40a2d684dd"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function subset(values, other) {
    return (0, _superset.default)(other, values);
}

},{"f8e3d40a2d684dd":"h2kae"}],"h2kae":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = superset;
function superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) return false;
            const ivalue = intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{}],"126q8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = union;
var _index = require("b94da534d8aa6b4e");
function union(...others) {
    const set = new _index.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

},{"b94da534d8aa6b4e":"h7J1g"}],"8wgSr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initInterpolator = initInterpolator;
exports.initRange = initRange;
function initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

},{}],"dMENI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ordinal;
exports.implicit = void 0;
var _index = require("6ecbdff01822d80f");
var _init = require("7282c9d431045ccf");
const implicit = Symbol("implicit");
exports.implicit = implicit;
function ordinal() {
    var index = new _index.InternMap(), domain = [], range = [], unknown = implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new _index.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal(domain, range).unknown(unknown);
    };
    _init.initRange.apply(scale, arguments);
    return scale;
}

},{"6ecbdff01822d80f":"5BPmK","7282c9d431045ccf":"8wgSr"}],"2UQVZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = identity;
var _linear = require("254685ae5ef37013");
var _number = _interopRequireDefault(require("4082c410eb53fc15"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, _number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, _number.default) : [
        0,
        1
    ];
    return (0, _linear.linearish)(scale);
}

},{"254685ae5ef37013":"1dzut","4082c410eb53fc15":"gYBFC"}],"1dzut":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = linear;
exports.linearish = linearish;
var _index = require("aac118be7b3ba720");
var _continuous = _interopRequireWildcard(require("7713f1786e931e93"));
var _init = require("d90834cbc7e0f302");
var _tickFormat = _interopRequireDefault(require("7e9ed5a9bbd4cbde"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _index.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, _tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, _index.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuous.default)();
    scale.copy = function() {
        return (0, _continuous.copy)(scale, linear());
    };
    _init.initRange.apply(scale, arguments);
    return linearish(scale);
}

},{"aac118be7b3ba720":"5BPmK","7713f1786e931e93":"5Ywil","d90834cbc7e0f302":"8wgSr","7e9ed5a9bbd4cbde":"6RWUe"}],"5Ywil":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copy = copy;
exports.default = continuous;
exports.identity = identity;
exports.transformer = transformer;
var _index = require("231aac6d87fd7ce");
var _index2 = require("22bce12626eaa350");
var _constant = _interopRequireDefault(require("1e47a9766d45f50"));
var _number = _interopRequireDefault(require("89d76e56cf40be4c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var unit = [
    0,
    1
];
function identity(x) {
    return x;
}
function normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constant.default)(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _index.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
    var domain = unit, range = unit, interpolate = _index2.interpolate, transform, untransform, unknown, clamp = identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), _index2.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, _number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = _index2.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function continuous() {
    return transformer()(identity, identity);
}

},{"231aac6d87fd7ce":"5BPmK","22bce12626eaa350":"cavOM","1e47a9766d45f50":"9YrJQ","89d76e56cf40be4c":"gYBFC"}],"cavOM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "interpolate", {
    enumerable: true,
    get: function() {
        return _value.default;
    }
});
Object.defineProperty(exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return _array.default;
    }
});
Object.defineProperty(exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return _basis.default;
    }
});
Object.defineProperty(exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return _basisClosed.default;
    }
});
Object.defineProperty(exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return _cubehelix.default;
    }
});
Object.defineProperty(exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return _cubehelix.cubehelixLong;
    }
});
Object.defineProperty(exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return _date.default;
    }
});
Object.defineProperty(exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return _discrete.default;
    }
});
Object.defineProperty(exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return _hcl.default;
    }
});
Object.defineProperty(exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return _hcl.hclLong;
    }
});
Object.defineProperty(exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return _hsl.default;
    }
});
Object.defineProperty(exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return _hsl.hslLong;
    }
});
Object.defineProperty(exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return _hue.default;
    }
});
Object.defineProperty(exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return _lab.default;
    }
});
Object.defineProperty(exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return _number.default;
    }
});
Object.defineProperty(exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return _numberArray.default;
    }
});
Object.defineProperty(exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return _object.default;
    }
});
Object.defineProperty(exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return _rgb.default;
    }
});
Object.defineProperty(exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return _rgb.rgbBasis;
    }
});
Object.defineProperty(exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return _rgb.rgbBasisClosed;
    }
});
Object.defineProperty(exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return _round.default;
    }
});
Object.defineProperty(exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return _string.default;
    }
});
Object.defineProperty(exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return _index.interpolateTransformCss;
    }
});
Object.defineProperty(exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return _index.interpolateTransformSvg;
    }
});
Object.defineProperty(exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return _zoom.default;
    }
});
Object.defineProperty(exports, "piecewise", {
    enumerable: true,
    get: function() {
        return _piecewise.default;
    }
});
Object.defineProperty(exports, "quantize", {
    enumerable: true,
    get: function() {
        return _quantize.default;
    }
});
var _value = _interopRequireDefault(require("d07c3377e02db783"));
var _array = _interopRequireDefault(require("edacd30c86a77aaf"));
var _basis = _interopRequireDefault(require("f63952198e35cfdd"));
var _basisClosed = _interopRequireDefault(require("973c53f6372c9194"));
var _date = _interopRequireDefault(require("c5cc1fd4cc670691"));
var _discrete = _interopRequireDefault(require("69272aa308f44531"));
var _hue = _interopRequireDefault(require("bf14fd3692d5d331"));
var _number = _interopRequireDefault(require("33785fe833e28c97"));
var _numberArray = _interopRequireDefault(require("79a08437ce573c8d"));
var _object = _interopRequireDefault(require("f719e72f2b536939"));
var _round = _interopRequireDefault(require("1ca6ac6fa3d582ae"));
var _string = _interopRequireDefault(require("78b66a15ac4fef38"));
var _index = require("f593b2575c4fef91");
var _zoom = _interopRequireDefault(require("2388ba69509cf62d"));
var _rgb = _interopRequireWildcard(require("e2dba0777f31681b"));
var _hsl = _interopRequireWildcard(require("4c02aa5ef7907a18"));
var _lab = _interopRequireDefault(require("76f1238a15d249ad"));
var _hcl = _interopRequireWildcard(require("2c25e37c1c46fb24"));
var _cubehelix = _interopRequireWildcard(require("7c34e9f8f123e706"));
var _piecewise = _interopRequireDefault(require("8bdaa40ec2bb6e7d"));
var _quantize = _interopRequireDefault(require("103abe379606b52c"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"d07c3377e02db783":"knAGJ","edacd30c86a77aaf":"6eEwk","f63952198e35cfdd":"j635t","973c53f6372c9194":"1D1hb","c5cc1fd4cc670691":"9oWqi","69272aa308f44531":"cV0Kk","bf14fd3692d5d331":"6pbRu","33785fe833e28c97":"8XYkF","79a08437ce573c8d":"aUP0d","f719e72f2b536939":"1IDRb","1ca6ac6fa3d582ae":"2EIiA","78b66a15ac4fef38":"6rij6","f593b2575c4fef91":"9FHxJ","2388ba69509cf62d":"6DCje","e2dba0777f31681b":"j4cCi","4c02aa5ef7907a18":"4z5D9","76f1238a15d249ad":"g4dOd","2c25e37c1c46fb24":"3dvJC","7c34e9f8f123e706":"2c1Bq","8bdaa40ec2bb6e7d":"hMHGH","103abe379606b52c":"6B6RK"}],"knAGJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("8966791533b7b61f");
var _rgb = _interopRequireDefault(require("9dc1fe341dd38d61"));
var _array = require("2ce8270fca4f2022");
var _date = _interopRequireDefault(require("bc28d944ed678177"));
var _number = _interopRequireDefault(require("8231b8d6c18c2ba0"));
var _object = _interopRequireDefault(require("78a394aa4cd826c4"));
var _string = _interopRequireDefault(require("df7d40bdbf72c662"));
var _constant = _interopRequireDefault(require("af962be5907548be"));
var _numberArray = _interopRequireWildcard(require("afb8f74833a73288"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, _constant.default)(b) : (t === "number" ? _number.default : t === "string" ? (c = (0, _index.color)(b)) ? (b = c, _rgb.default) : _string.default : b instanceof _index.color ? _rgb.default : b instanceof Date ? _date.default : (0, _numberArray.isNumberArray)(b) ? _numberArray.default : Array.isArray(b) ? _array.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? _object.default : _number.default)(a, b);
}

},{"8966791533b7b61f":"9ejnZ","9dc1fe341dd38d61":"j4cCi","2ce8270fca4f2022":"6eEwk","bc28d944ed678177":"9oWqi","8231b8d6c18c2ba0":"8XYkF","78a394aa4cd826c4":"1IDRb","df7d40bdbf72c662":"6rij6","af962be5907548be":"5Jnj6","afb8f74833a73288":"aUP0d"}],"9ejnZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "color", {
    enumerable: true,
    get: function() {
        return _color.default;
    }
});
Object.defineProperty(exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return _cubehelix.default;
    }
});
Object.defineProperty(exports, "gray", {
    enumerable: true,
    get: function() {
        return _lab.gray;
    }
});
Object.defineProperty(exports, "hcl", {
    enumerable: true,
    get: function() {
        return _lab.hcl;
    }
});
Object.defineProperty(exports, "hsl", {
    enumerable: true,
    get: function() {
        return _color.hsl;
    }
});
Object.defineProperty(exports, "lab", {
    enumerable: true,
    get: function() {
        return _lab.default;
    }
});
Object.defineProperty(exports, "lch", {
    enumerable: true,
    get: function() {
        return _lab.lch;
    }
});
Object.defineProperty(exports, "rgb", {
    enumerable: true,
    get: function() {
        return _color.rgb;
    }
});
var _color = _interopRequireWildcard(require("b6e336a4fc706d2f"));
var _lab = _interopRequireWildcard(require("fc4d7bcdda498790"));
var _cubehelix = _interopRequireDefault(require("f6b684c49b0fa4f1"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"b6e336a4fc706d2f":"cvXnY","fc4d7bcdda498790":"1jgGm","f6b684c49b0fa4f1":"8vYdz"}],"cvXnY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;
var _define = _interopRequireWildcard(require("375c55d05dd393ef"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"375c55d05dd393ef":"9TAti"}],"9TAti":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.extend = extend;
function _default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{}],"1jgGm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Hcl = Hcl;
exports.Lab = Lab;
exports.default = lab;
exports.gray = gray;
exports.hcl = hcl;
exports.lch = lch;
var _define = _interopRequireWildcard(require("b8c985966e1fb4a4"));
var _color = require("dad9015ddd28fe88");
var _math = require("72b1e8e7b4ea045d");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1;
function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) return hcl2lab(o);
    if (!(o instanceof _color.Rgb)) o = (0, _color.rgbConvert)(o);
    var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
        z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
    }
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function gray(l, opacity) {
    return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Lab, lab, (0, _define.extend)(_color.Color, {
    brighter (k) {
        return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = Xn * lab2xyz(x);
        y = Yn * lab2xyz(y);
        z = Zn * lab2xyz(z);
        return new _color.Rgb(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * _math.degrees;
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l, c, h, opacity) {
    return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function hcl(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function hcl2lab(o) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * _math.radians;
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, _define.default)(Hcl, hcl, (0, _define.extend)(_color.Color, {
    brighter (k) {
        return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return hcl2lab(this).rgb();
    }
}));

},{"b8c985966e1fb4a4":"9TAti","dad9015ddd28fe88":"cvXnY","72b1e8e7b4ea045d":"hgEFF"}],"hgEFF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.radians = exports.degrees = void 0;
const radians = Math.PI / 180;
exports.radians = radians;
const degrees = 180 / Math.PI;
exports.degrees = degrees;

},{}],"8vYdz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Cubehelix = Cubehelix;
exports.default = cubehelix;
var _define = _interopRequireWildcard(require("95bff6de6dbde745"));
var _color = require("905040765170b68b");
var _math = require("2fa8e968a7edd59b");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof _color.Rgb)) o = (0, _color.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * _math.degrees - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Cubehelix, cubehelix, (0, _define.extend)(_color.Color, {
    brighter (k) {
        k = k == null ? _color.brighter : Math.pow(_color.brighter, k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? _color.darker : Math.pow(_color.darker, k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * _math.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new _color.Rgb(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"95bff6de6dbde745":"9TAti","905040765170b68b":"cvXnY","2fa8e968a7edd59b":"hgEFF"}],"j4cCi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rgbBasisClosed = exports.rgbBasis = exports.default = void 0;
var _index = require("4d2782cc549f3212");
var _basis = _interopRequireDefault(require("b4ad8ad8e1904b27"));
var _basisClosed = _interopRequireDefault(require("a89221fab697d5cb"));
var _color = _interopRequireWildcard(require("fffe43e1bdeb16fa"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = function rgbGamma(y) {
    var color = (0, _color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _index.rgb)(start)).r, (end = (0, _index.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
exports.default = _default;
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _index.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline(_basis.default);
exports.rgbBasis = rgbBasis;
var rgbBasisClosed = rgbSpline(_basisClosed.default);
exports.rgbBasisClosed = rgbBasisClosed;

},{"4d2782cc549f3212":"9ejnZ","b4ad8ad8e1904b27":"j635t","a89221fab697d5cb":"1D1hb","fffe43e1bdeb16fa":"7PjbD"}],"j635t":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.basis = basis;
exports.default = _default;
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function _default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

},{}],"1D1hb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _basis = require("4091e57254f585a8");
function _default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, _basis.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

},{"4091e57254f585a8":"j635t"}],"7PjbD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = nogamma;
exports.gamma = gamma;
exports.hue = hue;
var _constant = _interopRequireDefault(require("11dbf58433685d58"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constant.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constant.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constant.default)(isNaN(a) ? b : a);
}

},{"11dbf58433685d58":"5Jnj6"}],"5Jnj6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _default = (x)=>()=>x;
exports.default = _default;

},{}],"6eEwk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.genericArray = genericArray;
var _value = _interopRequireDefault(require("14f3e2a78a43419"));
var _numberArray = _interopRequireWildcard(require("df331715e13a1d66"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(a, b) {
    return ((0, _numberArray.isNumberArray)(b) ? _numberArray.default : genericArray)(a, b);
}
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"14f3e2a78a43419":"knAGJ","df331715e13a1d66":"aUP0d"}],"aUP0d":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.isNumberArray = isNumberArray;
function _default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{}],"9oWqi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

},{}],"8XYkF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

},{}],"1IDRb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _value = _interopRequireDefault(require("5ab44645cf9987ee"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, _value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

},{"5ab44645cf9987ee":"knAGJ"}],"6rij6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _number = _interopRequireDefault(require("11965aeb99182ab4"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function _default(a, b) {
    var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = reA.exec(a)) && (bm = reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, _number.default)(am, bm)
            });
        }
        bi = reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

},{"11965aeb99182ab4":"8XYkF"}],"cV0Kk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

},{}],"6pbRu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _color = require("e19ff0506ddf5d1");
function _default(a, b) {
    var i = (0, _color.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

},{"e19ff0506ddf5d1":"7PjbD"}],"2EIiA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

},{}],"9FHxJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.interpolateTransformSvg = exports.interpolateTransformCss = void 0;
var _number = _interopRequireDefault(require("5e48622b935b63a"));
var _parse = require("c75779cf4f7cba64");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, _number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, _number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, _number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, _number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var interpolateTransformCss = interpolateTransform(_parse.parseCss, "px, ", "px)", "deg)");
exports.interpolateTransformCss = interpolateTransformCss;
var interpolateTransformSvg = interpolateTransform(_parse.parseSvg, ", ", ")", ")");
exports.interpolateTransformSvg = interpolateTransformSvg;

},{"5e48622b935b63a":"8XYkF","c75779cf4f7cba64":"1Q68W"}],"1Q68W":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseCss = parseCss;
exports.parseSvg = parseSvg;
var _decompose = _interopRequireWildcard(require("6f415cb6a4727a53"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var svgNode;
/* eslint-disable no-undef */ function parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? _decompose.identity : (0, _decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
    if (value == null) return _decompose.identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return _decompose.identity;
    value = value.matrix;
    return (0, _decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

},{"6f415cb6a4727a53":"iAVix"}],"iAVix":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.identity = void 0;
var degrees = 180 / Math.PI;
var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
exports.identity = identity;
function _default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * degrees,
        skewX: Math.atan(skewX) * degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

},{}],"6DCje":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var epsilon2 = 1e-12;
function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var _default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
exports.default = _default;

},{}],"4z5D9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hslLong = exports.default = void 0;
var _index = require("9acbd483cce8336b");
var _color = _interopRequireWildcard(require("a2e4aabdc59140e9"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _index.hsl)(start)).h, (end = (0, _index.hsl)(end)).h), s = (0, _color.default)(start.s, end.s), l = (0, _color.default)(start.l, end.l), opacity = (0, _color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var _default = hsl(_color.hue);
exports.default = _default;
var hslLong = hsl(_color.default);
exports.hslLong = hslLong;

},{"9acbd483cce8336b":"9ejnZ","a2e4aabdc59140e9":"7PjbD"}],"g4dOd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = lab;
var _index = require("37353a51cf733742");
var _color = _interopRequireDefault(require("effc389e5df09d92"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function lab(start, end) {
    var l = (0, _color.default)((start = (0, _index.lab)(start)).l, (end = (0, _index.lab)(end)).l), a = (0, _color.default)(start.a, end.a), b = (0, _color.default)(start.b, end.b), opacity = (0, _color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

},{"37353a51cf733742":"9ejnZ","effc389e5df09d92":"7PjbD"}],"3dvJC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hclLong = exports.default = void 0;
var _index = require("68683fc2faee9ad0");
var _color = _interopRequireWildcard(require("268e0fdf86dc85e4"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _index.hcl)(start)).h, (end = (0, _index.hcl)(end)).h), c = (0, _color.default)(start.c, end.c), l = (0, _color.default)(start.l, end.l), opacity = (0, _color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var _default = hcl(_color.hue);
exports.default = _default;
var hclLong = hcl(_color.default);
exports.hclLong = hclLong;

},{"68683fc2faee9ad0":"9ejnZ","268e0fdf86dc85e4":"7PjbD"}],"2c1Bq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.cubehelixLong = void 0;
var _index = require("2affdc28acbb1f09");
var _color = _interopRequireWildcard(require("8b9d108087dca2f5"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _index.cubehelix)(start)).h, (end = (0, _index.cubehelix)(end)).h), s = (0, _color.default)(start.s, end.s), l = (0, _color.default)(start.l, end.l), opacity = (0, _color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var _default = cubehelix(_color.hue);
exports.default = _default;
var cubehelixLong = cubehelix(_color.default);
exports.cubehelixLong = cubehelixLong;

},{"2affdc28acbb1f09":"9ejnZ","8b9d108087dca2f5":"7PjbD"}],"hMHGH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = piecewise;
var _value = _interopRequireDefault(require("8dc55c5a98f546a9"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = _value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

},{"8dc55c5a98f546a9":"knAGJ"}],"6B6RK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

},{}],"9YrJQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = constants;
function constants(x) {
    return function() {
        return x;
    };
}

},{}],"gYBFC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = number;
function number(x) {
    return +x;
}

},{}],"6RWUe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = tickFormat;
var _index = require("a307d10c8ef07648");
var _index2 = require("2c0f0ba98418b96");
function tickFormat(start, stop, count, specifier) {
    var step = (0, _index.tickStep)(start, stop, count), precision;
    specifier = (0, _index2.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, _index2.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, _index2.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, _index2.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, _index2.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, _index2.format)(specifier);
}

},{"a307d10c8ef07648":"5BPmK","2c0f0ba98418b96":"3GJZs"}],"3GJZs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return _formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(exports, "format", {
    enumerable: true,
    get: function() {
        return _defaultLocale.format;
    }
});
Object.defineProperty(exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return _defaultLocale.default;
    }
});
Object.defineProperty(exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return _locale.default;
    }
});
Object.defineProperty(exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return _defaultLocale.formatPrefix;
    }
});
Object.defineProperty(exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return _formatSpecifier.default;
    }
});
Object.defineProperty(exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return _precisionFixed.default;
    }
});
Object.defineProperty(exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return _precisionPrefix.default;
    }
});
Object.defineProperty(exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return _precisionRound.default;
    }
});
var _defaultLocale = _interopRequireWildcard(require("1dfcf31ad474c38b"));
var _locale = _interopRequireDefault(require("1ed8fc30c64005fa"));
var _formatSpecifier = _interopRequireWildcard(require("fea777790ffbd6a1"));
var _precisionFixed = _interopRequireDefault(require("7b431ffc5038aa2f"));
var _precisionPrefix = _interopRequireDefault(require("9a5d09f7b22fbaf6"));
var _precisionRound = _interopRequireDefault(require("8d43bf25f8cb8254"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"1dfcf31ad474c38b":"cypYJ","1ed8fc30c64005fa":"gYvsH","fea777790ffbd6a1":"7fcu8","7b431ffc5038aa2f":"ibnPs","9a5d09f7b22fbaf6":"5vZ4B","8d43bf25f8cb8254":"8GKYH"}],"cypYJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = defaultLocale;
exports.formatPrefix = exports.format = void 0;
var _locale = _interopRequireDefault(require("b072a1e7fc8191e5"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var locale;
var format;
exports.format = format;
var formatPrefix;
exports.formatPrefix = formatPrefix;
defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function defaultLocale(definition) {
    locale = (0, _locale.default)(definition);
    exports.format = format = locale.format;
    exports.formatPrefix = formatPrefix = locale.formatPrefix;
    return locale;
}

},{"b072a1e7fc8191e5":"gYvsH"}],"gYvsH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("3f1c5d07faaac7b"));
var _formatGroup = _interopRequireDefault(require("331cf33d5004500c"));
var _formatNumerals = _interopRequireDefault(require("66e53307f942c670"));
var _formatSpecifier = _interopRequireDefault(require("387884bb4d64fec7"));
var _formatTrim = _interopRequireDefault(require("d7f8660d9b2591d5"));
var _formatTypes = _interopRequireDefault(require("bd54cb529d96a775"));
var _formatPrefixAuto = require("ffa5900405d88d25");
var _identity = _interopRequireDefault(require("5d7a42131e324e48"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function _default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? _identity.default : (0, _formatGroup.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? _identity.default : (0, _formatNumerals.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, _formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = _formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, _formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? prefixes[8 + _formatPrefixAuto.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, _formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

},{"3f1c5d07faaac7b":"aQbqj","331cf33d5004500c":"2z1bI","66e53307f942c670":"ekvaJ","387884bb4d64fec7":"7fcu8","d7f8660d9b2591d5":"dPgCj","bd54cb529d96a775":"5IWtb","ffa5900405d88d25":"b9t0D","5d7a42131e324e48":"8xY5U"}],"aQbqj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _formatDecimal = require("1a44bae778652a77");
function _default(x) {
    return x = (0, _formatDecimal.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

},{"1a44bae778652a77":"5Hy0M"}],"5Hy0M":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.formatDecimalParts = formatDecimalParts;
function _default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{}],"2z1bI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

},{}],"ekvaJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

},{}],"7fcu8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormatSpecifier = FormatSpecifier;
exports.default = formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{}],"dPgCj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function _default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

},{}],"5IWtb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _formatDecimal = _interopRequireDefault(require("20f02d0fa13ad390"));
var _formatPrefixAuto = _interopRequireDefault(require("ece7e6fa16f1fdf5"));
var _formatRounded = _interopRequireDefault(require("e25f2c03f2334531"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": _formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, _formatRounded.default)(x * 100, p),
    "r": _formatRounded.default,
    "s": _formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
exports.default = _default;

},{"20f02d0fa13ad390":"5Hy0M","ece7e6fa16f1fdf5":"b9t0D","e25f2c03f2334531":"ifUHE"}],"b9t0D":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.prefixExponent = void 0;
var _formatDecimal = require("be70898051c85ca9");
var prefixExponent;
exports.prefixExponent = prefixExponent;
function _default(x, p) {
    var d = (0, _formatDecimal.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (exports.prefixExponent = prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimal.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

},{"be70898051c85ca9":"5Hy0M"}],"ifUHE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _formatDecimal = require("e206defc4f0ff0ba");
function _default(x, p) {
    var d = (0, _formatDecimal.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

},{"e206defc4f0ff0ba":"5Hy0M"}],"8xY5U":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(x) {
    return x;
}

},{}],"ibnPs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("a5d78b69216032a0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(step) {
    return Math.max(0, -(0, _exponent.default)(Math.abs(step)));
}

},{"a5d78b69216032a0":"aQbqj"}],"5vZ4B":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("a22c549d8f2ccdd"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponent.default)(value) / 3))) * 3 - (0, _exponent.default)(Math.abs(step)));
}

},{"a22c549d8f2ccdd":"aQbqj"}],"8GKYH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("27f16635660fd035"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, _exponent.default)(max) - (0, _exponent.default)(step)) + 1;
}

},{"27f16635660fd035":"aQbqj"}],"kkUTx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = log;
exports.loggish = loggish;
var _index = require("3c75a540fbec533e");
var _index2 = require("75503ee6c8fde83a");
var _nice = _interopRequireDefault(require("481c9ebd8c745e9d"));
var _continuous = require("de7043e90f155677");
var _init = require("4053145bc7ae0ff9");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function transformLog(x) {
    return Math.log(x);
}
function transformExp(x) {
    return Math.exp(x);
}
function transformLogn(x) {
    return -Math.log(-x);
}
function transformExpn(x) {
    return -Math.exp(-x);
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function reflect(f) {
    return (x, k)=>-f(-x, k);
}
function loggish(transform) {
    const scale = transform(transformLog, transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) {
            logs = reflect(logs), pows = reflect(pows);
            transform(transformLogn, transformExpn);
        } else transform(transformLog, transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, _index.ticks)(u, v, n);
        } else z = (0, _index.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, _index2.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, _index2.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, _nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function log() {
    const scale = loggish((0, _continuous.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, _continuous.copy)(scale, log()).base(scale.base());
    _init.initRange.apply(scale, arguments);
    return scale;
}

},{"3c75a540fbec533e":"5BPmK","75503ee6c8fde83a":"3GJZs","481c9ebd8c745e9d":"cTjD6","de7043e90f155677":"5Ywil","4053145bc7ae0ff9":"8wgSr"}],"cTjD6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = nice;
function nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

},{}],"lgeZg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = symlog;
exports.symlogish = symlogish;
var _linear = require("b29cf9eb89dc5033");
var _continuous = require("2ba554ea50a3c0e0");
var _init = require("ae690d31e39e33ee");
function transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function symlogish(transform) {
    var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
    };
    return (0, _linear.linearish)(scale);
}
function symlog() {
    var scale = symlogish((0, _continuous.transformer)());
    scale.copy = function() {
        return (0, _continuous.copy)(scale, symlog()).constant(scale.constant());
    };
    return _init.initRange.apply(scale, arguments);
}

},{"b29cf9eb89dc5033":"1dzut","2ba554ea50a3c0e0":"5Ywil","ae690d31e39e33ee":"8wgSr"}],"1LlPy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pow;
exports.powish = powish;
exports.sqrt = sqrt;
var _linear = require("ac29bf6a0c437b92");
var _continuous = require("a77d34ac6b55a3d4");
var _init = require("4293c2ed76886544");
function transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function powish(transform) {
    var scale = transform(_continuous.identity, _continuous.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform(_continuous.identity, _continuous.identity) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, _linear.linearish)(scale);
}
function pow() {
    var scale = powish((0, _continuous.transformer)());
    scale.copy = function() {
        return (0, _continuous.copy)(scale, pow()).exponent(scale.exponent());
    };
    _init.initRange.apply(scale, arguments);
    return scale;
}
function sqrt() {
    return pow.apply(null, arguments).exponent(0.5);
}

},{"ac29bf6a0c437b92":"1dzut","a77d34ac6b55a3d4":"5Ywil","4293c2ed76886544":"8wgSr"}],"381pj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = radial;
var _continuous = _interopRequireDefault(require("899b77b065c7e3b2"));
var _init = require("661cd0cad242a71c");
var _linear = require("791d8ed283490658");
var _number = _interopRequireDefault(require("aa2ae7ce9ee42393"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function square(x) {
    return Math.sign(x) * x * x;
}
function unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function radial() {
    var squared = (0, _continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert(square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, _number.default)).map(square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    _init.initRange.apply(scale, arguments);
    return (0, _linear.linearish)(scale);
}

},{"899b77b065c7e3b2":"5Ywil","661cd0cad242a71c":"8wgSr","791d8ed283490658":"1dzut","aa2ae7ce9ee42393":"gYBFC"}],"dHejM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quantile;
var _index = require("8bd451d622fe2faa");
var _init = require("38e2ced4b859a1c4");
function quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, _index.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, _index.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort(_index.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return quantile().domain(domain).range(range).unknown(unknown);
    };
    return _init.initRange.apply(scale, arguments);
}

},{"8bd451d622fe2faa":"5BPmK","38e2ced4b859a1c4":"8wgSr"}],"h2A8W":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quantize;
var _index = require("182b149debc47ebf");
var _linear = require("15c143aa85f32995");
var _init = require("78dc5449f8ecc692");
function quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, _index.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return _init.initRange.apply((0, _linear.linearish)(scale), arguments);
}

},{"182b149debc47ebf":"5BPmK","15c143aa85f32995":"1dzut","78dc5449f8ecc692":"8wgSr"}],"6LIdm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = threshold;
var _index = require("5f5f54c04d0b6589");
var _init = require("833d8dcdae9a265e");
function threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, _index.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return threshold().domain(domain).range(range).unknown(unknown);
    };
    return _init.initRange.apply(scale, arguments);
}

},{"5f5f54c04d0b6589":"5BPmK","833d8dcdae9a265e":"8wgSr"}],"6eQCj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calendar = calendar;
exports.default = time;
var _index = require("ad54ad3e67120929");
var _index2 = require("c4094464719c5cba");
var _continuous = _interopRequireWildcard(require("2dfdaae473aa2fcf"));
var _init = require("45a0aca9a066bc6b");
var _nice = _interopRequireDefault(require("6c73addaa15971b"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function date(t) {
    return new Date(t);
}
function number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, _continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, _nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, _continuous.copy)(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function time() {
    return _init.initRange.apply(calendar(_index.timeTicks, _index.timeTickInterval, _index.timeYear, _index.timeMonth, _index.timeWeek, _index.timeDay, _index.timeHour, _index.timeMinute, _index.timeSecond, _index2.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

},{"ad54ad3e67120929":"9sM8z","c4094464719c5cba":"jhHm2","2dfdaae473aa2fcf":"5Ywil","45a0aca9a066bc6b":"8wgSr","6c73addaa15971b":"cTjD6"}],"9sM8z":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "timeDay", {
    enumerable: true,
    get: function() {
        return _day.default;
    }
});
Object.defineProperty(exports, "timeDays", {
    enumerable: true,
    get: function() {
        return _day.days;
    }
});
Object.defineProperty(exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return _week.friday;
    }
});
Object.defineProperty(exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return _week.fridays;
    }
});
Object.defineProperty(exports, "timeHour", {
    enumerable: true,
    get: function() {
        return _hour.default;
    }
});
Object.defineProperty(exports, "timeHours", {
    enumerable: true,
    get: function() {
        return _hour.hours;
    }
});
Object.defineProperty(exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return _interval.default;
    }
});
Object.defineProperty(exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return _millisecond.default;
    }
});
Object.defineProperty(exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return _millisecond.milliseconds;
    }
});
Object.defineProperty(exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return _minute.default;
    }
});
Object.defineProperty(exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return _minute.minutes;
    }
});
Object.defineProperty(exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return _week.monday;
    }
});
Object.defineProperty(exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return _week.mondays;
    }
});
Object.defineProperty(exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return _month.default;
    }
});
Object.defineProperty(exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return _month.months;
    }
});
Object.defineProperty(exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return _week.saturday;
    }
});
Object.defineProperty(exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return _week.saturdays;
    }
});
Object.defineProperty(exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return _second.default;
    }
});
Object.defineProperty(exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return _second.seconds;
    }
});
Object.defineProperty(exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return _week.sunday;
    }
});
Object.defineProperty(exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return _week.sundays;
    }
});
Object.defineProperty(exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return _week.thursday;
    }
});
Object.defineProperty(exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return _week.thursdays;
    }
});
Object.defineProperty(exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return _ticks.timeTickInterval;
    }
});
Object.defineProperty(exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return _ticks.timeTicks;
    }
});
Object.defineProperty(exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return _week.tuesday;
    }
});
Object.defineProperty(exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return _week.tuesdays;
    }
});
Object.defineProperty(exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return _week.wednesday;
    }
});
Object.defineProperty(exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return _week.wednesdays;
    }
});
Object.defineProperty(exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return _week.sunday;
    }
});
Object.defineProperty(exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return _week.sundays;
    }
});
Object.defineProperty(exports, "timeYear", {
    enumerable: true,
    get: function() {
        return _year.default;
    }
});
Object.defineProperty(exports, "timeYears", {
    enumerable: true,
    get: function() {
        return _year.years;
    }
});
Object.defineProperty(exports, "utcDay", {
    enumerable: true,
    get: function() {
        return _utcDay.default;
    }
});
Object.defineProperty(exports, "utcDays", {
    enumerable: true,
    get: function() {
        return _utcDay.utcDays;
    }
});
Object.defineProperty(exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcFriday;
    }
});
Object.defineProperty(exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcFridays;
    }
});
Object.defineProperty(exports, "utcHour", {
    enumerable: true,
    get: function() {
        return _utcHour.default;
    }
});
Object.defineProperty(exports, "utcHours", {
    enumerable: true,
    get: function() {
        return _utcHour.utcHours;
    }
});
Object.defineProperty(exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return _millisecond.default;
    }
});
Object.defineProperty(exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return _millisecond.milliseconds;
    }
});
Object.defineProperty(exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return _utcMinute.default;
    }
});
Object.defineProperty(exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return _utcMinute.utcMinutes;
    }
});
Object.defineProperty(exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcMonday;
    }
});
Object.defineProperty(exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcMondays;
    }
});
Object.defineProperty(exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return _utcMonth.default;
    }
});
Object.defineProperty(exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return _utcMonth.utcMonths;
    }
});
Object.defineProperty(exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSaturday;
    }
});
Object.defineProperty(exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSaturdays;
    }
});
Object.defineProperty(exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return _second.default;
    }
});
Object.defineProperty(exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return _second.seconds;
    }
});
Object.defineProperty(exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSunday;
    }
});
Object.defineProperty(exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSundays;
    }
});
Object.defineProperty(exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcThursday;
    }
});
Object.defineProperty(exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcThursdays;
    }
});
Object.defineProperty(exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return _ticks.utcTickInterval;
    }
});
Object.defineProperty(exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return _ticks.utcTicks;
    }
});
Object.defineProperty(exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcTuesday;
    }
});
Object.defineProperty(exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcTuesdays;
    }
});
Object.defineProperty(exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcWednesday;
    }
});
Object.defineProperty(exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcWednesdays;
    }
});
Object.defineProperty(exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSunday;
    }
});
Object.defineProperty(exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSundays;
    }
});
Object.defineProperty(exports, "utcYear", {
    enumerable: true,
    get: function() {
        return _utcYear.default;
    }
});
Object.defineProperty(exports, "utcYears", {
    enumerable: true,
    get: function() {
        return _utcYear.utcYears;
    }
});
var _interval = _interopRequireDefault(require("a34492503cbd9b48"));
var _millisecond = _interopRequireWildcard(require("7524ee8bddcf412c"));
var _second = _interopRequireWildcard(require("7cc428820cde3092"));
var _minute = _interopRequireWildcard(require("bdb123bb05e1deb8"));
var _hour = _interopRequireWildcard(require("c0480bac4dd38efa"));
var _day = _interopRequireWildcard(require("d5dfed50476abbcb"));
var _week = require("f73faf68e8a91cfc");
var _month = _interopRequireWildcard(require("38868b579935b37"));
var _year = _interopRequireWildcard(require("2987b597af2231b6"));
var _utcMinute = _interopRequireWildcard(require("5058a73f08e0aeb2"));
var _utcHour = _interopRequireWildcard(require("88f32a42d53fef3b"));
var _utcDay = _interopRequireWildcard(require("a2d9691cdc6a5682"));
var _utcWeek = require("8df4c67b1ad5d6d0");
var _utcMonth = _interopRequireWildcard(require("d38447a48b4029a8"));
var _utcYear = _interopRequireWildcard(require("c71095d91290cd11"));
var _ticks = require("f5eee4704ecb2204");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"a34492503cbd9b48":"bs9rO","7524ee8bddcf412c":"jCXpW","7cc428820cde3092":"8bxwU","bdb123bb05e1deb8":"2tbNW","c0480bac4dd38efa":"kW3yL","d5dfed50476abbcb":"cpR5V","f73faf68e8a91cfc":"8taIF","38868b579935b37":"9Kk7e","2987b597af2231b6":"9lShp","5058a73f08e0aeb2":"9ujoj","88f32a42d53fef3b":"8Bh49","a2d9691cdc6a5682":"aPC5L","8df4c67b1ad5d6d0":"dUj0A","d38447a48b4029a8":"gPxPm","c71095d91290cd11":"9k3nr","f5eee4704ecb2204":"5D7BW"}],"bs9rO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = newInterval;
var t0 = new Date(), t1 = new Date();
function newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

},{}],"jCXpW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.milliseconds = exports.default = void 0;
var _interval = _interopRequireDefault(require("1a51ad6d96edb2e0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var millisecond = (0, _interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var _default = millisecond;
exports.default = _default;
var milliseconds = millisecond.range;
exports.milliseconds = milliseconds;

},{"1a51ad6d96edb2e0":"bs9rO"}],"8bxwU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.seconds = exports.default = void 0;
var _interval = _interopRequireDefault(require("44b3e316a9b23086"));
var _duration = require("fedc1218fa95fbd9");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var second = (0, _interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * _duration.durationSecond);
}, function(start, end) {
    return (end - start) / _duration.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var _default = second;
exports.default = _default;
var seconds = second.range;
exports.seconds = seconds;

},{"44b3e316a9b23086":"bs9rO","fedc1218fa95fbd9":"jvIxJ"}],"jvIxJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.durationYear = exports.durationWeek = exports.durationSecond = exports.durationMonth = exports.durationMinute = exports.durationHour = exports.durationDay = void 0;
const durationSecond = 1000;
exports.durationSecond = durationSecond;
const durationMinute = durationSecond * 60;
exports.durationMinute = durationMinute;
const durationHour = durationMinute * 60;
exports.durationHour = durationHour;
const durationDay = durationHour * 24;
exports.durationDay = durationDay;
const durationWeek = durationDay * 7;
exports.durationWeek = durationWeek;
const durationMonth = durationDay * 30;
exports.durationMonth = durationMonth;
const durationYear = durationDay * 365;
exports.durationYear = durationYear;

},{}],"2tbNW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.minutes = exports.default = void 0;
var _interval = _interopRequireDefault(require("a3c87a4058e4c8a6"));
var _duration = require("bfb17cf821b510e4");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var minute = (0, _interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * _duration.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationMinute);
}, function(start, end) {
    return (end - start) / _duration.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var _default = minute;
exports.default = _default;
var minutes = minute.range;
exports.minutes = minutes;

},{"a3c87a4058e4c8a6":"bs9rO","bfb17cf821b510e4":"jvIxJ"}],"kW3yL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hours = exports.default = void 0;
var _interval = _interopRequireDefault(require("54564d328d0d4478"));
var _duration = require("97fc72f701167a36");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var hour = (0, _interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * _duration.durationSecond - date.getMinutes() * _duration.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationHour);
}, function(start, end) {
    return (end - start) / _duration.durationHour;
}, function(date) {
    return date.getHours();
});
var _default = hour;
exports.default = _default;
var hours = hour.range;
exports.hours = hours;

},{"54564d328d0d4478":"bs9rO","97fc72f701167a36":"jvIxJ"}],"cpR5V":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.days = void 0;
var _interval = _interopRequireDefault(require("d2212e05222f1f2a"));
var _duration = require("179d136af33f2033");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var day = (0, _interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration.durationMinute) / _duration.durationDay, (date)=>date.getDate() - 1);
var _default = day;
exports.default = _default;
var days = day.range;
exports.days = days;

},{"d2212e05222f1f2a":"bs9rO","179d136af33f2033":"jvIxJ"}],"8taIF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wednesdays = exports.wednesday = exports.tuesdays = exports.tuesday = exports.thursdays = exports.thursday = exports.sundays = exports.sunday = exports.saturdays = exports.saturday = exports.mondays = exports.monday = exports.fridays = exports.friday = void 0;
var _interval = _interopRequireDefault(require("8fce260a40c0c732"));
var _duration = require("a534a2a23d01cc55");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function weekday(i) {
    return (0, _interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration.durationMinute) / _duration.durationWeek;
    });
}
var sunday = weekday(0);
exports.sunday = sunday;
var monday = weekday(1);
exports.monday = monday;
var tuesday = weekday(2);
exports.tuesday = tuesday;
var wednesday = weekday(3);
exports.wednesday = wednesday;
var thursday = weekday(4);
exports.thursday = thursday;
var friday = weekday(5);
exports.friday = friday;
var saturday = weekday(6);
exports.saturday = saturday;
var sundays = sunday.range;
exports.sundays = sundays;
var mondays = monday.range;
exports.mondays = mondays;
var tuesdays = tuesday.range;
exports.tuesdays = tuesdays;
var wednesdays = wednesday.range;
exports.wednesdays = wednesdays;
var thursdays = thursday.range;
exports.thursdays = thursdays;
var fridays = friday.range;
exports.fridays = fridays;
var saturdays = saturday.range;
exports.saturdays = saturdays;

},{"8fce260a40c0c732":"bs9rO","a534a2a23d01cc55":"jvIxJ"}],"9Kk7e":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.months = exports.default = void 0;
var _interval = _interopRequireDefault(require("77a8dc689841c832"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var month = (0, _interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var _default = month;
exports.default = _default;
var months = month.range;
exports.months = months;

},{"77a8dc689841c832":"bs9rO"}],"9lShp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.years = exports.default = void 0;
var _interval = _interopRequireDefault(require("124e9f54764cd2d0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var year = (0, _interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var _default = year;
exports.default = _default;
var years = year.range;
exports.years = years;

},{"124e9f54764cd2d0":"bs9rO"}],"9ujoj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcMinutes = exports.default = void 0;
var _interval = _interopRequireDefault(require("f226cca769b6f7ee"));
var _duration = require("fff58b3a29c67eb7");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcMinute = (0, _interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationMinute);
}, function(start, end) {
    return (end - start) / _duration.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var _default = utcMinute;
exports.default = _default;
var utcMinutes = utcMinute.range;
exports.utcMinutes = utcMinutes;

},{"f226cca769b6f7ee":"bs9rO","fff58b3a29c67eb7":"jvIxJ"}],"8Bh49":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcHours = exports.default = void 0;
var _interval = _interopRequireDefault(require("a34b21541c599b8d"));
var _duration = require("48dc4536ffb0b24a");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcHour = (0, _interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationHour);
}, function(start, end) {
    return (end - start) / _duration.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var _default = utcHour;
exports.default = _default;
var utcHours = utcHour.range;
exports.utcHours = utcHours;

},{"a34b21541c599b8d":"bs9rO","48dc4536ffb0b24a":"jvIxJ"}],"aPC5L":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcDays = exports.default = void 0;
var _interval = _interopRequireDefault(require("74568725d2b18edf"));
var _duration = require("a55c460b3f5b5292");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcDay = (0, _interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / _duration.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var _default = utcDay;
exports.default = _default;
var utcDays = utcDay.range;
exports.utcDays = utcDays;

},{"74568725d2b18edf":"bs9rO","a55c460b3f5b5292":"jvIxJ"}],"dUj0A":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcWednesdays = exports.utcWednesday = exports.utcTuesdays = exports.utcTuesday = exports.utcThursdays = exports.utcThursday = exports.utcSundays = exports.utcSunday = exports.utcSaturdays = exports.utcSaturday = exports.utcMondays = exports.utcMonday = exports.utcFridays = exports.utcFriday = void 0;
var _interval = _interopRequireDefault(require("97d1fc4647a3440c"));
var _duration = require("418630135f28a04");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function utcWeekday(i) {
    return (0, _interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / _duration.durationWeek;
    });
}
var utcSunday = utcWeekday(0);
exports.utcSunday = utcSunday;
var utcMonday = utcWeekday(1);
exports.utcMonday = utcMonday;
var utcTuesday = utcWeekday(2);
exports.utcTuesday = utcTuesday;
var utcWednesday = utcWeekday(3);
exports.utcWednesday = utcWednesday;
var utcThursday = utcWeekday(4);
exports.utcThursday = utcThursday;
var utcFriday = utcWeekday(5);
exports.utcFriday = utcFriday;
var utcSaturday = utcWeekday(6);
exports.utcSaturday = utcSaturday;
var utcSundays = utcSunday.range;
exports.utcSundays = utcSundays;
var utcMondays = utcMonday.range;
exports.utcMondays = utcMondays;
var utcTuesdays = utcTuesday.range;
exports.utcTuesdays = utcTuesdays;
var utcWednesdays = utcWednesday.range;
exports.utcWednesdays = utcWednesdays;
var utcThursdays = utcThursday.range;
exports.utcThursdays = utcThursdays;
var utcFridays = utcFriday.range;
exports.utcFridays = utcFridays;
var utcSaturdays = utcSaturday.range;
exports.utcSaturdays = utcSaturdays;

},{"97d1fc4647a3440c":"bs9rO","418630135f28a04":"jvIxJ"}],"gPxPm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcMonths = exports.default = void 0;
var _interval = _interopRequireDefault(require("64a636ca9e8a6dd2"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcMonth = (0, _interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var _default = utcMonth;
exports.default = _default;
var utcMonths = utcMonth.range;
exports.utcMonths = utcMonths;

},{"64a636ca9e8a6dd2":"bs9rO"}],"9k3nr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcYears = exports.default = void 0;
var _interval = _interopRequireDefault(require("ad6defbb66143d50"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcYear = (0, _interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var _default = utcYear;
exports.default = _default;
var utcYears = utcYear.range;
exports.utcYears = utcYears;

},{"ad6defbb66143d50":"bs9rO"}],"5D7BW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcTicks = exports.utcTickInterval = exports.timeTicks = exports.timeTickInterval = void 0;
var _index = require("38b65dff469faad");
var _duration = require("32753814cb70e543");
var _millisecond = _interopRequireDefault(require("e75a60256de784bb"));
var _second = _interopRequireDefault(require("1592ea599ee15dc4"));
var _minute = _interopRequireDefault(require("96ab4d5de01af588"));
var _hour = _interopRequireDefault(require("428c23b6aaace40f"));
var _day = _interopRequireDefault(require("be453f495774460f"));
var _week = require("9998e2b2d130d74f");
var _month = _interopRequireDefault(require("e731cac202dae08b"));
var _year = _interopRequireDefault(require("ff05b1a260820d2d"));
var _utcMinute = _interopRequireDefault(require("318819771c237852"));
var _utcHour = _interopRequireDefault(require("b409a745f7b02240"));
var _utcDay = _interopRequireDefault(require("40b807b66046f3d6"));
var _utcWeek = require("6a38ecacccb48d19");
var _utcMonth = _interopRequireDefault(require("19176233e8ec4ec9"));
var _utcYear = _interopRequireDefault(require("9963f3fa7a06f600"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            _second.default,
            1,
            _duration.durationSecond
        ],
        [
            _second.default,
            5,
            5 * _duration.durationSecond
        ],
        [
            _second.default,
            15,
            15 * _duration.durationSecond
        ],
        [
            _second.default,
            30,
            30 * _duration.durationSecond
        ],
        [
            minute,
            1,
            _duration.durationMinute
        ],
        [
            minute,
            5,
            5 * _duration.durationMinute
        ],
        [
            minute,
            15,
            15 * _duration.durationMinute
        ],
        [
            minute,
            30,
            30 * _duration.durationMinute
        ],
        [
            hour,
            1,
            _duration.durationHour
        ],
        [
            hour,
            3,
            3 * _duration.durationHour
        ],
        [
            hour,
            6,
            6 * _duration.durationHour
        ],
        [
            hour,
            12,
            12 * _duration.durationHour
        ],
        [
            day,
            1,
            _duration.durationDay
        ],
        [
            day,
            2,
            2 * _duration.durationDay
        ],
        [
            week,
            1,
            _duration.durationWeek
        ],
        [
            month,
            1,
            _duration.durationMonth
        ],
        [
            month,
            3,
            3 * _duration.durationMonth
        ],
        [
            year,
            1,
            _duration.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, _index.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, _index.tickStep)(start / _duration.durationYear, stop / _duration.durationYear, count));
        if (i === 0) return _millisecond.default.every(Math.max((0, _index.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [utcTicks, utcTickInterval] = ticker(_utcYear.default, _utcMonth.default, _utcWeek.utcSunday, _utcDay.default, _utcHour.default, _utcMinute.default);
exports.utcTickInterval = utcTickInterval;
exports.utcTicks = utcTicks;
const [timeTicks, timeTickInterval] = ticker(_year.default, _month.default, _week.sunday, _day.default, _hour.default, _minute.default);
exports.timeTickInterval = timeTickInterval;
exports.timeTicks = timeTicks;

},{"38b65dff469faad":"5BPmK","32753814cb70e543":"jvIxJ","e75a60256de784bb":"jCXpW","1592ea599ee15dc4":"8bxwU","96ab4d5de01af588":"2tbNW","428c23b6aaace40f":"kW3yL","be453f495774460f":"cpR5V","9998e2b2d130d74f":"8taIF","e731cac202dae08b":"9Kk7e","ff05b1a260820d2d":"9lShp","318819771c237852":"9ujoj","b409a745f7b02240":"8Bh49","40b807b66046f3d6":"aPC5L","6a38ecacccb48d19":"dUj0A","19176233e8ec4ec9":"gPxPm","9963f3fa7a06f600":"9k3nr"}],"jhHm2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return _isoFormat.default;
    }
});
Object.defineProperty(exports, "isoParse", {
    enumerable: true,
    get: function() {
        return _isoParse.default;
    }
});
Object.defineProperty(exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return _defaultLocale.timeFormat;
    }
});
Object.defineProperty(exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return _defaultLocale.default;
    }
});
Object.defineProperty(exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return _locale.default;
    }
});
Object.defineProperty(exports, "timeParse", {
    enumerable: true,
    get: function() {
        return _defaultLocale.timeParse;
    }
});
Object.defineProperty(exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return _defaultLocale.utcFormat;
    }
});
Object.defineProperty(exports, "utcParse", {
    enumerable: true,
    get: function() {
        return _defaultLocale.utcParse;
    }
});
var _defaultLocale = _interopRequireWildcard(require("541fdf561b5393f1"));
var _locale = _interopRequireDefault(require("297ea2d12161e581"));
var _isoFormat = _interopRequireDefault(require("47d602f1e5b0cff"));
var _isoParse = _interopRequireDefault(require("a0d0dc388424ec95"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"541fdf561b5393f1":"8bPH9","297ea2d12161e581":"hYamq","47d602f1e5b0cff":"61PAU","a0d0dc388424ec95":"7NxKd"}],"8bPH9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = defaultLocale;
exports.utcParse = exports.utcFormat = exports.timeParse = exports.timeFormat = void 0;
var _locale = _interopRequireDefault(require("a7876a14ffbd01c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var locale;
var timeFormat;
exports.timeFormat = timeFormat;
var timeParse;
exports.timeParse = timeParse;
var utcFormat;
exports.utcFormat = utcFormat;
var utcParse;
exports.utcParse = utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _locale.default)(definition);
    exports.timeFormat = timeFormat = locale.format;
    exports.timeParse = timeParse = locale.parse;
    exports.utcFormat = utcFormat = locale.utcFormat;
    exports.utcParse = utcParse = locale.utcParse;
    return locale;
}

},{"a7876a14ffbd01c":"hYamq"}],"hYamq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatLocale;
var _index = require("5903e1a3923ca41d");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? _index.utcMonday.ceil(week) : (0, _index.utcMonday)(week);
                    week = _index.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? _index.timeMonday.ceil(week) : (0, _index.timeMonday)(week);
                    week = _index.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            } // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, // note: ignores next directive
percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + _index.timeDay.count((0, _index.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad(_index.timeSunday.count((0, _index.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _index.timeThursday)(d) : _index.timeThursday.ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad(_index.timeThursday.count((0, _index.timeYear)(d), d) + ((0, _index.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad(_index.timeMonday.count((0, _index.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _index.timeThursday)(d) : _index.timeThursday.ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + _index.utcDay.count((0, _index.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad(_index.utcSunday.count((0, _index.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _index.utcThursday)(d) : _index.utcThursday.ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad(_index.utcThursday.count((0, _index.utcYear)(d), d) + ((0, _index.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad(_index.utcMonday.count((0, _index.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _index.utcThursday)(d) : _index.utcThursday.ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"5903e1a3923ca41d":"9sM8z"}],"61PAU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isoSpecifier = exports.default = void 0;
var _defaultLocale = require("a1bfecd583652c07");
var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
exports.isoSpecifier = isoSpecifier;
function formatIsoNative(date) {
    return date.toISOString();
}
var formatIso = Date.prototype.toISOString ? formatIsoNative : (0, _defaultLocale.utcFormat)(isoSpecifier);
var _default = formatIso;
exports.default = _default;

},{"a1bfecd583652c07":"8bPH9"}],"7NxKd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _isoFormat = require("ce4209d767958bcd");
var _defaultLocale = require("93f170383b483974");
function parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : (0, _defaultLocale.utcParse)(_isoFormat.isoSpecifier);
var _default = parseIso;
exports.default = _default;

},{"ce4209d767958bcd":"61PAU","93f170383b483974":"8bPH9"}],"eeHuN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = utcTime;
var _index = require("5320c4f35262cc00");
var _index2 = require("705388d9be98e18f");
var _time = require("30e9c4653acfedf2");
var _init = require("a122194e8d27d34e");
function utcTime() {
    return _init.initRange.apply((0, _time.calendar)(_index.utcTicks, _index.utcTickInterval, _index.utcYear, _index.utcMonth, _index.utcWeek, _index.utcDay, _index.utcHour, _index.utcMinute, _index.utcSecond, _index2.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

},{"5320c4f35262cc00":"9sM8z","705388d9be98e18f":"jhHm2","30e9c4653acfedf2":"6eQCj","a122194e8d27d34e":"8wgSr"}],"ithwT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copy = copy;
exports.default = sequential;
exports.sequentialLog = sequentialLog;
exports.sequentialPow = sequentialPow;
exports.sequentialSqrt = sequentialSqrt;
exports.sequentialSymlog = sequentialSymlog;
var _index = require("85682932b4660567");
var _continuous = require("5df11db95b51f67b");
var _init = require("c8971132d352a75e");
var _linear = require("ee921d887c576055");
var _log = require("ffe81c3c3254cb25");
var _symlog = require("7da63be3296b06d");
var _pow = require("48f0525dc9a77035");
function transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = _continuous.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range(_index.interpolate);
    scale.rangeRound = range(_index.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
    var scale = (0, _linear.linearish)(transformer()(_continuous.identity));
    scale.copy = function() {
        return copy(scale, sequential());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialLog() {
    var scale = (0, _log.loggish)(transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return copy(scale, sequentialLog()).base(scale.base());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialSymlog() {
    var scale = (0, _symlog.symlogish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialSymlog()).constant(scale.constant());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialPow() {
    var scale = (0, _pow.powish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialPow()).exponent(scale.exponent());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialSqrt() {
    return sequentialPow.apply(null, arguments).exponent(0.5);
}

},{"85682932b4660567":"cavOM","5df11db95b51f67b":"5Ywil","c8971132d352a75e":"8wgSr","ee921d887c576055":"1dzut","ffe81c3c3254cb25":"kkUTx","7da63be3296b06d":"lgeZg","48f0525dc9a77035":"1LlPy"}],"eCHVE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sequentialQuantile;
var _index = require("a4122ac46a2257e6");
var _continuous = require("72ad11aa5fc71122");
var _init = require("6ab93aa31fa39960");
function sequentialQuantile() {
    var domain = [], interpolator = _continuous.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, _index.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort(_index.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, _index.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return sequentialQuantile(interpolator).domain(domain);
    };
    return _init.initInterpolator.apply(scale, arguments);
}

},{"a4122ac46a2257e6":"5BPmK","72ad11aa5fc71122":"5Ywil","6ab93aa31fa39960":"8wgSr"}],"jPSZ7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = diverging;
exports.divergingLog = divergingLog;
exports.divergingPow = divergingPow;
exports.divergingSqrt = divergingSqrt;
exports.divergingSymlog = divergingSymlog;
var _index = require("e022b8d4410eb92d");
var _continuous = require("e7550e0a9f2fd865");
var _init = require("c3edf5a432fd17b8");
var _linear = require("b0fa7103d2eb88a7");
var _log = require("e06c0e5270175cf8");
var _sequential = require("9533ebaec1c91747");
var _symlog = require("1b60eb6310bc4ecb");
var _pow = require("6a95374df5c88fb1");
function transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = _continuous.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, _index.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range(_index.interpolate);
    scale.rangeRound = range(_index.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function diverging() {
    var scale = (0, _linear.linearish)(transformer()(_continuous.identity));
    scale.copy = function() {
        return (0, _sequential.copy)(scale, diverging());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingLog() {
    var scale = (0, _log.loggish)(transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingLog()).base(scale.base());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingSymlog() {
    var scale = (0, _symlog.symlogish)(transformer());
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingSymlog()).constant(scale.constant());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingPow() {
    var scale = (0, _pow.powish)(transformer());
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingPow()).exponent(scale.exponent());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingSqrt() {
    return divergingPow.apply(null, arguments).exponent(0.5);
}

},{"e022b8d4410eb92d":"cavOM","e7550e0a9f2fd865":"5Ywil","c3edf5a432fd17b8":"8wgSr","b0fa7103d2eb88a7":"1dzut","e06c0e5270175cf8":"kkUTx","9533ebaec1c91747":"ithwT","1b60eb6310bc4ecb":"lgeZg","6a95374df5c88fb1":"1LlPy"}],"jODwB":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.
module.exports = require("65d4b4ec2b7778e6");

},{"65d4b4ec2b7778e6":"ct3E1"}],"ct3E1":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`
module.exports = require("254a8f6206ba17da");

},{"254a8f6206ba17da":"hSGti"}],"hSGti":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "arc", {
    enumerable: true,
    get: function() {
        return _arc.default;
    }
});
Object.defineProperty(exports, "area", {
    enumerable: true,
    get: function() {
        return _area.default;
    }
});
Object.defineProperty(exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return _areaRadial.default;
    }
});
Object.defineProperty(exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return _basis.default;
    }
});
Object.defineProperty(exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return _basisClosed.default;
    }
});
Object.defineProperty(exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return _basisOpen.default;
    }
});
Object.defineProperty(exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return _bump.bumpX;
    }
});
Object.defineProperty(exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return _bump.bumpY;
    }
});
Object.defineProperty(exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return _bundle.default;
    }
});
Object.defineProperty(exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return _cardinal.default;
    }
});
Object.defineProperty(exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return _cardinalClosed.default;
    }
});
Object.defineProperty(exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return _cardinalOpen.default;
    }
});
Object.defineProperty(exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return _catmullRom.default;
    }
});
Object.defineProperty(exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return _catmullRomClosed.default;
    }
});
Object.defineProperty(exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return _catmullRomOpen.default;
    }
});
Object.defineProperty(exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return _linear.default;
    }
});
Object.defineProperty(exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return _linearClosed.default;
    }
});
Object.defineProperty(exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return _monotone.monotoneX;
    }
});
Object.defineProperty(exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return _monotone.monotoneY;
    }
});
Object.defineProperty(exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return _natural.default;
    }
});
Object.defineProperty(exports, "curveStep", {
    enumerable: true,
    get: function() {
        return _step.default;
    }
});
Object.defineProperty(exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return _step.stepAfter;
    }
});
Object.defineProperty(exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return _step.stepBefore;
    }
});
Object.defineProperty(exports, "line", {
    enumerable: true,
    get: function() {
        return _line.default;
    }
});
Object.defineProperty(exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return _lineRadial.default;
    }
});
Object.defineProperty(exports, "link", {
    enumerable: true,
    get: function() {
        return _link.link;
    }
});
Object.defineProperty(exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return _link.linkHorizontal;
    }
});
Object.defineProperty(exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return _link.linkRadial;
    }
});
Object.defineProperty(exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return _link.linkVertical;
    }
});
Object.defineProperty(exports, "pie", {
    enumerable: true,
    get: function() {
        return _pie.default;
    }
});
Object.defineProperty(exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return _pointRadial.default;
    }
});
Object.defineProperty(exports, "radialArea", {
    enumerable: true,
    get: function() {
        return _areaRadial.default;
    }
});
Object.defineProperty(exports, "radialLine", {
    enumerable: true,
    get: function() {
        return _lineRadial.default;
    }
});
Object.defineProperty(exports, "stack", {
    enumerable: true,
    get: function() {
        return _stack.default;
    }
});
Object.defineProperty(exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return _diverging.default;
    }
});
Object.defineProperty(exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return _expand.default;
    }
});
Object.defineProperty(exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return _none.default;
    }
});
Object.defineProperty(exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return _silhouette.default;
    }
});
Object.defineProperty(exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return _wiggle.default;
    }
});
Object.defineProperty(exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return _appearance.default;
    }
});
Object.defineProperty(exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return _ascending.default;
    }
});
Object.defineProperty(exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return _descending.default;
    }
});
Object.defineProperty(exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return _insideOut.default;
    }
});
Object.defineProperty(exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return _none2.default;
    }
});
Object.defineProperty(exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return _reverse.default;
    }
});
Object.defineProperty(exports, "symbol", {
    enumerable: true,
    get: function() {
        return _symbol.default;
    }
});
Object.defineProperty(exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return _asterisk.default;
    }
});
Object.defineProperty(exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return _circle.default;
    }
});
Object.defineProperty(exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return _cross.default;
    }
});
Object.defineProperty(exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return _diamond.default;
    }
});
Object.defineProperty(exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return _diamond2.default;
    }
});
Object.defineProperty(exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return _plus.default;
    }
});
Object.defineProperty(exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return _square.default;
    }
});
Object.defineProperty(exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return _square2.default;
    }
});
Object.defineProperty(exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return _star.default;
    }
});
Object.defineProperty(exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return _triangle.default;
    }
});
Object.defineProperty(exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return _triangle2.default;
    }
});
Object.defineProperty(exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return _wye.default;
    }
});
Object.defineProperty(exports, "symbolX", {
    enumerable: true,
    get: function() {
        return _x.default;
    }
});
Object.defineProperty(exports, "symbols", {
    enumerable: true,
    get: function() {
        return _symbol.symbolsFill;
    }
});
Object.defineProperty(exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return _symbol.symbolsFill;
    }
});
Object.defineProperty(exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return _symbol.symbolsStroke;
    }
});
var _arc = _interopRequireDefault(require("67ec4a8822f0f12"));
var _area = _interopRequireDefault(require("5eb5f5bc167ec2ab"));
var _line = _interopRequireDefault(require("a35d7c29fc969cd5"));
var _pie = _interopRequireDefault(require("dc705c2483ccae2e"));
var _areaRadial = _interopRequireDefault(require("3da15cef4c73a715"));
var _lineRadial = _interopRequireDefault(require("c71fd3065918973c"));
var _pointRadial = _interopRequireDefault(require("fe506ff32b4be84d"));
var _link = require("d18e114470723c06");
var _symbol = _interopRequireWildcard(require("82aebe452bca72d9"));
var _asterisk = _interopRequireDefault(require("4b08f4d8dabe3bf9"));
var _circle = _interopRequireDefault(require("9cbf95ed102f9051"));
var _cross = _interopRequireDefault(require("fb0d848dad5a96e3"));
var _diamond = _interopRequireDefault(require("d1faca52c1668fc2"));
var _diamond2 = _interopRequireDefault(require("6f125031ec885148"));
var _plus = _interopRequireDefault(require("ffd821a5dc68e7a9"));
var _square = _interopRequireDefault(require("51b17355680252d8"));
var _square2 = _interopRequireDefault(require("6f02f8807c306efd"));
var _star = _interopRequireDefault(require("e285e22d363000bc"));
var _triangle = _interopRequireDefault(require("32215ae0d44830a1"));
var _triangle2 = _interopRequireDefault(require("2de44ea85bebf8db"));
var _wye = _interopRequireDefault(require("122dd54c57d69ed2"));
var _x = _interopRequireDefault(require("70ed0a4a0043b8de"));
var _basisClosed = _interopRequireDefault(require("8f3f0c79330afd7"));
var _basisOpen = _interopRequireDefault(require("5191c87671f4e378"));
var _basis = _interopRequireDefault(require("9223f6bd11a31943"));
var _bump = require("985e70ea111027c0");
var _bundle = _interopRequireDefault(require("6e10f41ff0390257"));
var _cardinalClosed = _interopRequireDefault(require("6b2503e13f0813cb"));
var _cardinalOpen = _interopRequireDefault(require("83b1dffdea0c7336"));
var _cardinal = _interopRequireDefault(require("b36aaf1a18cae163"));
var _catmullRomClosed = _interopRequireDefault(require("56a3a5e64a2b983a"));
var _catmullRomOpen = _interopRequireDefault(require("34534b6287f499fc"));
var _catmullRom = _interopRequireDefault(require("202ee64143e0b10f"));
var _linearClosed = _interopRequireDefault(require("a4cff2a41449e001"));
var _linear = _interopRequireDefault(require("5be7584b7416342"));
var _monotone = require("e7250d65b0a3fc8");
var _natural = _interopRequireDefault(require("cc42cd7f07086736"));
var _step = _interopRequireWildcard(require("4655d8e74a220164"));
var _stack = _interopRequireDefault(require("d0c3c10855e4ef29"));
var _expand = _interopRequireDefault(require("9d14d8a76b7d0f9f"));
var _diverging = _interopRequireDefault(require("127c0ddce610857e"));
var _none = _interopRequireDefault(require("d77caf7caa5ee5b8"));
var _silhouette = _interopRequireDefault(require("65a791ee4b40a9"));
var _wiggle = _interopRequireDefault(require("c8e59df1f9a9051d"));
var _appearance = _interopRequireDefault(require("99d162bef46b2c13"));
var _ascending = _interopRequireDefault(require("6cdd0f2887591a2"));
var _descending = _interopRequireDefault(require("a28d9eedcc886cf2"));
var _insideOut = _interopRequireDefault(require("b869fdf64225248f"));
var _none2 = _interopRequireDefault(require("60d0b5b107c43073"));
var _reverse = _interopRequireDefault(require("ada71e6aa03756b5"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"67ec4a8822f0f12":"3IGsR","5eb5f5bc167ec2ab":"1IpCr","a35d7c29fc969cd5":"kLdxK","dc705c2483ccae2e":"iguhO","3da15cef4c73a715":"xPUwg","c71fd3065918973c":"kernD","fe506ff32b4be84d":"fu2AR","d18e114470723c06":"5guo0","82aebe452bca72d9":"6x4M4","4b08f4d8dabe3bf9":"k9Irj","9cbf95ed102f9051":"1IkIi","fb0d848dad5a96e3":"hT05p","d1faca52c1668fc2":"9tY8f","6f125031ec885148":"fyJQI","ffd821a5dc68e7a9":"hw1qk","51b17355680252d8":"3iaz3","6f02f8807c306efd":"2dRuD","e285e22d363000bc":"AQo0F","32215ae0d44830a1":"l2Tya","2de44ea85bebf8db":"as0rw","122dd54c57d69ed2":"e3K3z","70ed0a4a0043b8de":"fLMGL","8f3f0c79330afd7":"9GW03","5191c87671f4e378":"gUuZH","9223f6bd11a31943":"ftJYu","985e70ea111027c0":"eqVQZ","6e10f41ff0390257":"6jzXt","6b2503e13f0813cb":"1b1fw","83b1dffdea0c7336":"l3qNk","b36aaf1a18cae163":"cjhvD","56a3a5e64a2b983a":"bwfaA","34534b6287f499fc":"gFBzY","202ee64143e0b10f":"ikhTB","a4cff2a41449e001":"7HJA1","5be7584b7416342":"e22WZ","e7250d65b0a3fc8":"iAUq0","cc42cd7f07086736":"9fxgE","4655d8e74a220164":"eKodk","d0c3c10855e4ef29":"6tN6Q","9d14d8a76b7d0f9f":"8A2M4","127c0ddce610857e":"4l4Ds","d77caf7caa5ee5b8":"bEiqJ","65a791ee4b40a9":"HZkZR","c8e59df1f9a9051d":"NmhYR","99d162bef46b2c13":"di5uM","6cdd0f2887591a2":"ieV3Q","a28d9eedcc886cf2":"4kJx5","b869fdf64225248f":"bNM4b","60d0b5b107c43073":"fC9D6","ada71e6aa03756b5":"2JRz7"}],"3IGsR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("5e92b15d16f7257c");
var _constant = _interopRequireDefault(require("ea226f3aea6c50bc"));
var _math = require("2e1a18302c30f18d");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function arcInnerRadius(d) {
    return d.innerRadius;
}
function arcOuterRadius(d) {
    return d.outerRadius;
}
function arcStartAngle(d) {
    return d.startAngle;
}
function arcEndAngle(d) {
    return d.endAngle;
}
function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < _math.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, _math.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, _math.sqrt)((0, _math.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function _default() {
    var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = (0, _constant.default)(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - _math.halfPi, a1 = endAngle.apply(this, arguments) - _math.halfPi, da = (0, _math.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, _index.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > _math.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > _math.tau - _math.epsilon) {
            context.moveTo(r1 * (0, _math.cos)(a0), r1 * (0, _math.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > _math.epsilon) {
                context.moveTo(r0 * (0, _math.cos)(a1), r0 * (0, _math.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > _math.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, _math.sqrt)(r0 * r0 + r1 * r1)), rc = (0, _math.min)((0, _math.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > _math.epsilon) {
                var p0 = (0, _math.asin)(rp / r0 * (0, _math.sin)(ap)), p1 = (0, _math.asin)(rp / r1 * (0, _math.sin)(ap));
                if ((da0 -= p0 * 2) > _math.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > _math.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, _math.cos)(a01), y01 = r1 * (0, _math.sin)(a01), x10 = r0 * (0, _math.cos)(a10), y10 = r0 * (0, _math.sin)(a10); // Apply rounded corners?
            if (rc > _math.epsilon) {
                var x11 = r1 * (0, _math.cos)(a11), y11 = r1 * (0, _math.sin)(a11), x00 = r0 * (0, _math.cos)(a00), y00 = r0 * (0, _math.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < _math.pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, _math.sin)((0, _math.acos)((ax * bx + ay * by) / ((0, _math.sqrt)(ax * ax + ay * ay) * (0, _math.sqrt)(bx * bx + by * by))) / 2), lc = (0, _math.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, _math.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, _math.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > _math.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > _math.epsilon) {
                t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, _math.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _math.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, _math.atan2)(t1.y11, t1.x11), (0, _math.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > _math.epsilon) || !(da0 > _math.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > _math.epsilon) {
                t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, _math.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _math.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, _math.atan2)(t1.y11, t1.x11), (0, _math.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - _math.pi / 2;
        return [
            (0, _math.cos)(a) * r,
            (0, _math.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

},{"5e92b15d16f7257c":"g3Z45","ea226f3aea6c50bc":"cZNFc","2e1a18302c30f18d":"4pGtV"}],"g3Z45":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "path", {
    enumerable: true,
    get: function() {
        return _path.default;
    }
});
var _path = _interopRequireDefault(require("7c7b59a183812a89"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"7c7b59a183812a89":"8RX7Z"}],"8RX7Z":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function path() {
    return new Path();
}
Path.prototype = path.prototype = {
    constructor: Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau + tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var _default = path;
exports.default = _default;

},{}],"cZNFc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(x) {
    return function constant() {
        return x;
    };
}

},{}],"4pGtV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.abs = void 0;
exports.acos = acos;
exports.asin = asin;
exports.tau = exports.sqrt = exports.sin = exports.pi = exports.min = exports.max = exports.halfPi = exports.epsilon = exports.cos = exports.atan2 = void 0;
const abs = Math.abs;
exports.abs = abs;
const atan2 = Math.atan2;
exports.atan2 = atan2;
const cos = Math.cos;
exports.cos = cos;
const max = Math.max;
exports.max = max;
const min = Math.min;
exports.min = min;
const sin = Math.sin;
exports.sin = sin;
const sqrt = Math.sqrt;
exports.sqrt = sqrt;
const epsilon = 1e-12;
exports.epsilon = epsilon;
const pi = Math.PI;
exports.pi = pi;
const halfPi = pi / 2;
exports.halfPi = halfPi;
const tau = 2 * pi;
exports.tau = tau;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

},{}],"1IpCr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("741c4352135557d");
var _array = _interopRequireDefault(require("45ca219ad035dd63"));
var _constant = _interopRequireDefault(require("eb2b5b02c41fdabc"));
var _linear = _interopRequireDefault(require("63ac0675eaebb6f"));
var _line = _interopRequireDefault(require("353662a1d37ac700"));
var _point = require("fa8a6785cd83831a");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(x0, y0, y1) {
    var x1 = null, defined = (0, _constant.default)(true), context = null, curve = _linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? _point.x : (0, _constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, _constant.default)(0) : (0, _constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? _point.y : (0, _constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, _array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, _index.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, _line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

},{"741c4352135557d":"g3Z45","45ca219ad035dd63":"elsDb","eb2b5b02c41fdabc":"cZNFc","63ac0675eaebb6f":"e22WZ","353662a1d37ac700":"kLdxK","fa8a6785cd83831a":"8ih7p"}],"elsDb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.slice = void 0;
var slice = Array.prototype.slice;
exports.slice = slice;
function _default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

},{}],"e22WZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function Linear(context) {
    this._context = context;
}
Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function _default(context) {
    return new Linear(context);
}

},{}],"kLdxK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("54c2035e853d955d");
var _array = _interopRequireDefault(require("4adeee81949433c2"));
var _constant = _interopRequireDefault(require("6d58c43ddb474f0b"));
var _linear = _interopRequireDefault(require("b7a3c35f87c96267"));
var _point = require("e9b0c9976339663");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(x, y) {
    var defined = (0, _constant.default)(true), context = null, curve = _linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? _point.x : (0, _constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? _point.y : (0, _constant.default)(y);
    function line(data) {
        var i, n = (data = (0, _array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, _index.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

},{"54c2035e853d955d":"g3Z45","4adeee81949433c2":"elsDb","6d58c43ddb474f0b":"cZNFc","b7a3c35f87c96267":"e22WZ","e9b0c9976339663":"8ih7p"}],"8ih7p":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.x = x;
exports.y = y;
function x(p) {
    return p[0];
}
function y(p) {
    return p[1];
}

},{}],"iguhO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _array = _interopRequireDefault(require("83028966a25e18e6"));
var _constant = _interopRequireDefault(require("23fc4613da2950d"));
var _descending = _interopRequireDefault(require("f68a679d6a3a0dc0"));
var _identity = _interopRequireDefault(require("a5e3accc411adf89"));
var _math = require("44f25e4e1aae065f");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default() {
    var value = _identity.default, sortValues = _descending.default, sort = null, startAngle = (0, _constant.default)(0), endAngle = (0, _constant.default)(_math.tau), padAngle = (0, _constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, _array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min(_math.tau, Math.max(-_math.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

},{"83028966a25e18e6":"elsDb","23fc4613da2950d":"cZNFc","f68a679d6a3a0dc0":"cxUrV","a5e3accc411adf89":"58Ltv","44f25e4e1aae065f":"4pGtV"}],"cxUrV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{}],"58Ltv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(d) {
    return d;
}

},{}],"xPUwg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _radial = _interopRequireWildcard(require("40750c101600e169"));
var _area = _interopRequireDefault(require("a40d12eca2e8d942"));
var _lineRadial = require("6c3d45cf4e26b54f");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _default() {
    var a = (0, _area.default)().curve(_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, _lineRadial.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, _lineRadial.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, _lineRadial.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, _lineRadial.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, _radial.default)(_)) : c()._curve;
    };
    return a;
}

},{"40750c101600e169":"6YbVE","a40d12eca2e8d942":"1IpCr","6c3d45cf4e26b54f":"kernD"}],"6YbVE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.curveRadialLinear = void 0;
exports.default = curveRadial;
var _linear = _interopRequireDefault(require("eecf9ebd3b785061"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var curveRadialLinear = curveRadial(_linear.default);
exports.curveRadialLinear = curveRadialLinear;
function Radial(curve) {
    this._curve = curve;
}
Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function curveRadial(curve) {
    function radial(context) {
        return new Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

},{"eecf9ebd3b785061":"e22WZ"}],"kernD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.lineRadial = lineRadial;
var _radial = _interopRequireWildcard(require("a3ef05e8177e54c1"));
var _line = _interopRequireDefault(require("55c53f6f20146db0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, _radial.default)(_)) : c()._curve;
    };
    return l;
}
function _default() {
    return lineRadial((0, _line.default)().curve(_radial.curveRadialLinear));
}

},{"a3ef05e8177e54c1":"6YbVE","55c53f6f20146db0":"kLdxK"}],"fu2AR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

},{}],"5guo0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.link = link;
exports.linkHorizontal = linkHorizontal;
exports.linkRadial = linkRadial;
exports.linkVertical = linkVertical;
var _index = require("9e1f3de075e4d7c8");
var _array = require("ddde7e351ea52651");
var _constant = _interopRequireDefault(require("f52a235abdc2fa12"));
var _bump = require("42dbebb6b01bb24b");
var _point = require("91ae0f154839030e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function linkSource(d) {
    return d.source;
}
function linkTarget(d) {
    return d.target;
}
function link(curve) {
    let source = linkSource;
    let target = linkTarget;
    let x = _point.x;
    let y = _point.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = _array.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, _index.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function linkHorizontal() {
    return link(_bump.bumpX);
}
function linkVertical() {
    return link(_bump.bumpY);
}
function linkRadial() {
    const l = link(_bump.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

},{"9e1f3de075e4d7c8":"g3Z45","ddde7e351ea52651":"elsDb","f52a235abdc2fa12":"cZNFc","42dbebb6b01bb24b":"eqVQZ","91ae0f154839030e":"8ih7p"}],"eqVQZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bumpRadial = bumpRadial;
exports.bumpX = bumpX;
exports.bumpY = bumpY;
var _pointRadial = _interopRequireDefault(require("f23dbc2a37088655"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, _pointRadial.default)(this._x0, this._y0);
            const p1 = (0, _pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, _pointRadial.default)(x, this._y0);
            const p3 = (0, _pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function bumpX(context) {
    return new Bump(context, true);
}
function bumpY(context) {
    return new Bump(context, false);
}
function bumpRadial(context) {
    return new BumpRadial(context);
}

},{"f23dbc2a37088655":"fu2AR"}],"6x4M4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Symbol;
exports.symbolsStroke = exports.symbolsFill = void 0;
var _index = require("cb08fe4df8a04e2");
var _constant = _interopRequireDefault(require("38f7e7aef2617e30"));
var _asterisk = _interopRequireDefault(require("cc8c41fa31160f7"));
var _circle = _interopRequireDefault(require("d7aa4282125368"));
var _cross = _interopRequireDefault(require("d39e2251e6b0f9bc"));
var _diamond = _interopRequireDefault(require("aa01d7b64fbaa6c3"));
var _diamond2 = _interopRequireDefault(require("fbceb4958464c54f"));
var _plus = _interopRequireDefault(require("b6ac4e809e4875cb"));
var _square = _interopRequireDefault(require("b7d56acf2ea96f38"));
var _square2 = _interopRequireDefault(require("d7e8742f5229b981"));
var _star = _interopRequireDefault(require("937560f0fd117494"));
var _triangle = _interopRequireDefault(require("2263adbfb4a22ac"));
var _triangle2 = _interopRequireDefault(require("c6635d1d8d63df58"));
var _wye = _interopRequireDefault(require("d791d64fdc111131"));
var _x = _interopRequireDefault(require("e8321e6492fede70"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const symbolsFill = [
    _circle.default,
    _cross.default,
    _diamond.default,
    _square.default,
    _star.default,
    _triangle.default,
    _wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
exports.symbolsFill = symbolsFill;
const symbolsStroke = [
    _circle.default,
    _plus.default,
    _x.default,
    _triangle2.default,
    _asterisk.default,
    _square2.default,
    _diamond2.default
];
exports.symbolsStroke = symbolsStroke;
function Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, _constant.default)(type || _circle.default);
    size = typeof size === "function" ? size : (0, _constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, _index.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, _constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, _constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

},{"cb08fe4df8a04e2":"g3Z45","38f7e7aef2617e30":"cZNFc","cc8c41fa31160f7":"k9Irj","d7aa4282125368":"1IkIi","d39e2251e6b0f9bc":"hT05p","aa01d7b64fbaa6c3":"9tY8f","fbceb4958464c54f":"fyJQI","b6ac4e809e4875cb":"hw1qk","b7d56acf2ea96f38":"3iaz3","d7e8742f5229b981":"2dRuD","937560f0fd117494":"AQo0F","2263adbfb4a22ac":"l2Tya","c6635d1d8d63df58":"as0rw","d791d64fdc111131":"e3K3z","e8321e6492fede70":"fLMGL"}],"k9Irj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("d76b5069b67ba638");
const sqrt3 = (0, _math.sqrt)(3);
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size + (0, _math.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
exports.default = _default;

},{"d76b5069b67ba638":"4pGtV"}],"1IkIi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("b483c77006fb9d9e");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size / _math.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, _math.tau);
    }
};
exports.default = _default;

},{"b483c77006fb9d9e":"4pGtV"}],"hT05p":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("3a9d4310fc9cf204");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
exports.default = _default;

},{"3a9d4310fc9cf204":"4pGtV"}],"9tY8f":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("796b600afcdb1b08");
const tan30 = (0, _math.sqrt)(1 / 3);
const tan30_2 = tan30 * 2;
var _default = {
    draw (context, size) {
        const y = (0, _math.sqrt)(size / tan30_2);
        const x = y * tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
exports.default = _default;

},{"796b600afcdb1b08":"4pGtV"}],"fyJQI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("d20452103c23c5f2");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
exports.default = _default;

},{"d20452103c23c5f2":"4pGtV"}],"hw1qk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("f2a611b0bb16fae3");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size - (0, _math.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
exports.default = _default;

},{"f2a611b0bb16fae3":"4pGtV"}],"3iaz3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("6fcc7f44a464be3a");
var _default = {
    draw (context, size) {
        const w = (0, _math.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
exports.default = _default;

},{"6fcc7f44a464be3a":"4pGtV"}],"2dRuD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("a5a14906249fd446");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
exports.default = _default;

},{"a5a14906249fd446":"4pGtV"}],"AQo0F":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("4a4163be2a6e1599");
const ka = 0.89081309152928522810;
const kr = (0, _math.sin)(_math.pi / 10) / (0, _math.sin)(7 * _math.pi / 10);
const kx = (0, _math.sin)(_math.tau / 10) * kr;
const ky = -(0, _math.cos)(_math.tau / 10) * kr;
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size * ka);
        const x = kx * r;
        const y = ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = _math.tau * i / 5;
            const c = (0, _math.cos)(a);
            const s = (0, _math.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
exports.default = _default;

},{"4a4163be2a6e1599":"4pGtV"}],"l2Tya":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("48b650628c33d8f1");
const sqrt3 = (0, _math.sqrt)(3);
var _default = {
    draw (context, size) {
        const y = -(0, _math.sqrt)(size / (sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-sqrt3 * y, -y);
        context.lineTo(sqrt3 * y, -y);
        context.closePath();
    }
};
exports.default = _default;

},{"48b650628c33d8f1":"4pGtV"}],"as0rw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("a0df24d3681eaa21");
const sqrt3 = (0, _math.sqrt)(3);
var _default = {
    draw (context, size) {
        const s = (0, _math.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
exports.default = _default;

},{"a0df24d3681eaa21":"4pGtV"}],"e3K3z":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("65aa82bbd08977ec");
const c = -0.5;
const s = (0, _math.sqrt)(3) / 2;
const k = 1 / (0, _math.sqrt)(12);
const a = (k / 2 + 1) * 3;
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size / a);
        const x0 = r / 2, y0 = r * k;
        const x1 = x0, y1 = r * k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
        context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
        context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
        context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
        context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
        context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
        context.closePath();
    }
};
exports.default = _default;

},{"65aa82bbd08977ec":"4pGtV"}],"fLMGL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("24d6ec02daffc703");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size - (0, _math.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
exports.default = _default;

},{"24d6ec02daffc703":"4pGtV"}],"9GW03":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _noop = _interopRequireDefault(require("412b6f81860a1393"));
var _basis = require("e77dcab8acbc3867");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function BasisClosed(context) {
    this._context = context;
}
BasisClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, _basis.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function _default(context) {
    return new BasisClosed(context);
}

},{"412b6f81860a1393":"hX7Ja","e77dcab8acbc3867":"ftJYu"}],"hX7Ja":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default() {}

},{}],"ftJYu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Basis = Basis;
exports.default = _default;
exports.point = point;
function point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
    this._context = context;
}
Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function _default(context) {
    return new Basis(context);
}

},{}],"gUuZH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _basis = require("ed9d54e0d1ba84a6");
function BasisOpen(context) {
    this._context = context;
}
BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, _basis.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function _default(context) {
    return new BasisOpen(context);
}

},{"ed9d54e0d1ba84a6":"ftJYu"}],"6jzXt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _basis = require("db0dc95167af9274");
function Bundle(context, beta) {
    this._basis = new _basis.Basis(context);
    this._beta = beta;
}
Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var _default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new _basis.Basis(context) : new Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
exports.default = _default;

},{"db0dc95167af9274":"ftJYu"}],"1b1fw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CardinalClosed = CardinalClosed;
exports.default = void 0;
var _noop = _interopRequireDefault(require("139003738756b26"));
var _cardinal = require("741bfb540657dbbe");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _cardinal.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(tension) {
    function cardinal(context) {
        return new CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
exports.default = _default;

},{"139003738756b26":"hX7Ja","741bfb540657dbbe":"cjhvD"}],"cjhvD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Cardinal = Cardinal;
exports.default = void 0;
exports.point = point;
function point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(tension) {
    function cardinal(context) {
        return new Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
exports.default = _default;

},{}],"l3qNk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CardinalOpen = CardinalOpen;
exports.default = void 0;
var _cardinal = require("6dbee052adf77191");
function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, _cardinal.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(tension) {
    function cardinal(context) {
        return new CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
exports.default = _default;

},{"6dbee052adf77191":"cjhvD"}],"bwfaA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _cardinalClosed = require("6f7d4839edd43d73");
var _noop = _interopRequireDefault(require("f72f931197c19d33"));
var _catmullRom = require("2d455a05dc756920");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _catmullRom.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomClosed(context, alpha) : new _cardinalClosed.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

},{"6f7d4839edd43d73":"1b1fw","f72f931197c19d33":"hX7Ja","2d455a05dc756920":"ikhTB"}],"ikhTB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;
var _math = require("457e734f69020818");
var _cardinal = require("184adef49425f35b");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > _math.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > _math.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new _cardinal.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

},{"457e734f69020818":"4pGtV","184adef49425f35b":"cjhvD"}],"gFBzY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _cardinalOpen = require("fe06784d3b88a6be");
var _catmullRom = require("cc07b2fba41dc5b");
function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, _catmullRom.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomOpen(context, alpha) : new _cardinalOpen.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

},{"fe06784d3b88a6be":"l3qNk","cc07b2fba41dc5b":"ikhTB"}],"7HJA1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _noop = _interopRequireDefault(require("5a1326bfa7ef854f"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function LinearClosed(context) {
    this._context = context;
}
LinearClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function _default(context) {
    return new LinearClosed(context);
}

},{"5a1326bfa7ef854f":"hX7Ja"}],"iAUq0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.monotoneX = monotoneX;
exports.monotoneY = monotoneY;
function sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
    this._context = context;
}
MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                point(this, this._t0, slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                break;
            default:
                point(this, this._t0, t1 = slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function MonotoneY(context) {
    this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
    MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
    this._context = context;
}
ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function monotoneX(context) {
    return new MonotoneX(context);
}
function monotoneY(context) {
    return new MonotoneY(context);
}

},{}],"9fxgE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function Natural(context) {
    this._context = context;
}
Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = controlPoints(x), py = controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function _default(context) {
    return new Natural(context);
}

},{}],"eKodk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.stepAfter = stepAfter;
exports.stepBefore = stepBefore;
function Step(context, t) {
    this._context = context;
    this._t = t;
}
Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function _default(context) {
    return new Step(context, 0.5);
}
function stepBefore(context) {
    return new Step(context, 0);
}
function stepAfter(context) {
    return new Step(context, 1);
}

},{}],"6tN6Q":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _array = _interopRequireDefault(require("d7b0215a207b9b6a"));
var _constant = _interopRequireDefault(require("78db2db4b528caf8"));
var _none = _interopRequireDefault(require("d1f293719219c02b"));
var _none2 = _interopRequireDefault(require("53995900b5360742"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function stackValue(d, key) {
    return d[key];
}
function stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function _default() {
    var keys = (0, _constant.default)([]), order = _none2.default, offset = _none.default, value = stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, _array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, _constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? _none2.default : typeof _ === "function" ? _ : (0, _constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? _none.default : _, stack) : offset;
    };
    return stack;
}

},{"d7b0215a207b9b6a":"elsDb","78db2db4b528caf8":"cZNFc","d1f293719219c02b":"bEiqJ","53995900b5360742":"fC9D6"}],"bEiqJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

},{}],"fC9D6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

},{}],"8A2M4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("e5a91564b2029f74"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, _none.default)(series, order);
}

},{"e5a91564b2029f74":"bEiqJ"}],"4l4Ds":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

},{}],"HZkZR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("2d928567b12826de"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, _none.default)(series, order);
}

},{"2d928567b12826de":"bEiqJ"}],"NmhYR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("e2d9f5b77f374a06"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, _none.default)(series, order);
}

},{"e2d9f5b77f374a06":"bEiqJ"}],"di5uM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("3f1c760d19587b3"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    var peaks = series.map(peak);
    return (0, _none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

},{"3f1c760d19587b3":"fC9D6"}],"ieV3Q":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.sum = sum;
var _none = _interopRequireDefault(require("c891105e0b94c932"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    var sums = series.map(sum);
    return (0, _none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

},{"c891105e0b94c932":"fC9D6"}],"4kJx5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _ascending = _interopRequireDefault(require("8a8ec854865d1e3e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    return (0, _ascending.default)(series).reverse();
}

},{"8a8ec854865d1e3e":"ieV3Q"}],"bNM4b":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _appearance = _interopRequireDefault(require("367a4bcc2e6954d4"));
var _ascending = require("e6905642ae1fd898");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    var n = series.length, i, j, sums = series.map(_ascending.sum), order = (0, _appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

},{"367a4bcc2e6954d4":"di5uM","e6905642ae1fd898":"ieV3Q"}],"2JRz7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("c480d5acf312bbc0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    return (0, _none.default)(series).reverse();
}

},{"c480d5acf312bbc0":"fC9D6"}],"ddnjf":[function(require,module,exports,__globalThis) {
var baseExtremum = require("9d941b2d2311618d"), baseGt = require("ae2f4d589f5420e9"), identity = require("88290323c587571f");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function max(array) {
    return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
}
module.exports = max;

},{"9d941b2d2311618d":"jHHQS","ae2f4d589f5420e9":"1FUz2","88290323c587571f":"ex8Ky"}],"jHHQS":[function(require,module,exports,__globalThis) {
var isSymbol = require("ef96a0b1514fbbd");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = baseExtremum;

},{"ef96a0b1514fbbd":"3Ftz1"}],"1FUz2":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function baseGt(value, other) {
    return value > other;
}
module.exports = baseGt;

},{}],"ex8Ky":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"7VS3d":[function(require,module,exports,__globalThis) {
var baseExtremum = require("d7f31f4ab2bddfd2"), baseLt = require("142a08371ca84386"), identity = require("9c595aa6cdbe876d");
/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function min(array) {
    return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
}
module.exports = min;

},{"d7f31f4ab2bddfd2":"jHHQS","142a08371ca84386":"jRYqf","9c595aa6cdbe876d":"ex8Ky"}],"jRYqf":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function baseLt(value, other) {
    return value < other;
}
module.exports = baseLt;

},{}],"1kDMS":[function(require,module,exports,__globalThis) {
var baseFlatten = require("572587ab06a47026"), map = require("b469252bf9777657");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function flatMap(collection, iteratee) {
    return baseFlatten(map(collection, iteratee), 1);
}
module.exports = flatMap;

},{"572587ab06a47026":"dkyY2","b469252bf9777657":"leiFk"}],"dkyY2":[function(require,module,exports,__globalThis) {
var arrayPush = require("e188a6e98d845ddb"), isFlattenable = require("2becf22a77cd190");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = baseFlatten;

},{"e188a6e98d845ddb":"ixNde","2becf22a77cd190":"6QNgb"}],"6QNgb":[function(require,module,exports,__globalThis) {
var Symbol = require("7cfd292cc8b44ecf"), isArguments = require("507c75d3cd3f577c"), isArray = require("1bbda838c1abed0a");
/** Built-in value references. */ var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;

},{"7cfd292cc8b44ecf":"6MIK0","507c75d3cd3f577c":"V8fdP","1bbda838c1abed0a":"5gfYS"}],"leiFk":[function(require,module,exports,__globalThis) {
var arrayMap = require("1bd8c4ea7b5aa319"), baseIteratee = require("fcab83215bd924b5"), baseMap = require("f35d545ae3eb3238"), isArray = require("2a3c866b13362581");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = isArray(collection) ? arrayMap : baseMap;
    return func(collection, baseIteratee(iteratee, 3));
}
module.exports = map;

},{"1bd8c4ea7b5aa319":"eouC0","fcab83215bd924b5":"hmPIl","f35d545ae3eb3238":"gc8Xw","2a3c866b13362581":"5gfYS"}],"hmPIl":[function(require,module,exports,__globalThis) {
var baseMatches = require("aec3d89a3eccafe7"), baseMatchesProperty = require("cac6fc110a76ee1"), identity = require("8ebfaf0ddc68159c"), isArray = require("a59a4041b3e71663"), property = require("be752057e5d0f13d");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"aec3d89a3eccafe7":"k9vht","cac6fc110a76ee1":"fDmYw","8ebfaf0ddc68159c":"ex8Ky","a59a4041b3e71663":"5gfYS","be752057e5d0f13d":"vwgEz"}],"k9vht":[function(require,module,exports,__globalThis) {
var baseIsMatch = require("1244e183095a07f5"), getMatchData = require("e08f9be9406f4d89"), matchesStrictComparable = require("cad4c9223fd94235");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"1244e183095a07f5":"hsJQL","e08f9be9406f4d89":"1lmyV","cad4c9223fd94235":"ijSxF"}],"hsJQL":[function(require,module,exports,__globalThis) {
var Stack = require("d5da16edee7b7e6a"), baseIsEqual = require("2bef1cdda1c3e307");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"d5da16edee7b7e6a":"ap26Q","2bef1cdda1c3e307":"dxRRS"}],"1lmyV":[function(require,module,exports,__globalThis) {
var isStrictComparable = require("eae33874d78c9aa8"), keys = require("cadf61aebf0173dd");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"eae33874d78c9aa8":"czKo6","cadf61aebf0173dd":"ftmUn"}],"czKo6":[function(require,module,exports,__globalThis) {
var isObject = require("599f4eb747bbf1a");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"599f4eb747bbf1a":"cNdKD"}],"ijSxF":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"fDmYw":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("76f025d92cfa5c14"), get = require("ae06e38c52e793ae"), hasIn = require("ba4a17d4023698c7"), isKey = require("54d0e1fd883c1214"), isStrictComparable = require("a16cfbd326bad34f"), matchesStrictComparable = require("b6f0e1ec14783e8"), toKey = require("c1b128aaeb875cb5");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"76f025d92cfa5c14":"dxRRS","ae06e38c52e793ae":"dEpuO","ba4a17d4023698c7":"f3hME","54d0e1fd883c1214":"jkEKv","a16cfbd326bad34f":"czKo6","b6f0e1ec14783e8":"ijSxF","c1b128aaeb875cb5":"9XfVL"}],"f3hME":[function(require,module,exports,__globalThis) {
var baseHasIn = require("e5e4ea2d99574251"), hasPath = require("5bc848aae79418f0");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"e5e4ea2d99574251":"bKVav","5bc848aae79418f0":"dy951"}],"bKVav":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"dy951":[function(require,module,exports,__globalThis) {
var castPath = require("9c879c8719e1007e"), isArguments = require("311eb86c7c719246"), isArray = require("d61b9e1b52dffcd6"), isIndex = require("b86a05d22c056460"), isLength = require("8e33115c97b7f0cf"), toKey = require("7d3b99ebe4543c1b");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"9c879c8719e1007e":"dIRVx","311eb86c7c719246":"V8fdP","d61b9e1b52dffcd6":"5gfYS","b86a05d22c056460":"czJh8","8e33115c97b7f0cf":"jXZRq","7d3b99ebe4543c1b":"9XfVL"}],"vwgEz":[function(require,module,exports,__globalThis) {
var baseProperty = require("2086d638ad5ff473"), basePropertyDeep = require("a485fe2e0746db5b"), isKey = require("bec9e6730588fbd5"), toKey = require("ffc2f2ca368cf378");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"2086d638ad5ff473":"dVskW","a485fe2e0746db5b":"6ran4","bec9e6730588fbd5":"jkEKv","ffc2f2ca368cf378":"9XfVL"}],"dVskW":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"6ran4":[function(require,module,exports,__globalThis) {
var baseGet = require("f023481fe0c7d7fc");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f023481fe0c7d7fc":"6iITn"}],"gc8Xw":[function(require,module,exports,__globalThis) {
var baseEach = require("2e1a3ad851ec8fed"), isArrayLike = require("da0d362b94bfa967");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"2e1a3ad851ec8fed":"acAx3","da0d362b94bfa967":"fs9yO"}],"acAx3":[function(require,module,exports,__globalThis) {
var baseForOwn = require("597c7d24b46ea71f"), createBaseEach = require("ac8a751c1692f999");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"597c7d24b46ea71f":"dC72S","ac8a751c1692f999":"8xNx7"}],"dC72S":[function(require,module,exports,__globalThis) {
var baseFor = require("2838b3c2249f0d47"), keys = require("43d9ff0f1b4b02b2");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"2838b3c2249f0d47":"jr39l","43d9ff0f1b4b02b2":"ftmUn"}],"jr39l":[function(require,module,exports,__globalThis) {
var createBaseFor = require("4d1c968b7d799c41");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"4d1c968b7d799c41":"au2Qw"}],"au2Qw":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"8xNx7":[function(require,module,exports,__globalThis) {
var isArrayLike = require("241251faf9d79a70");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"241251faf9d79a70":"fs9yO"}],"eESst":[function(require,module,exports,__globalThis) {
var createCaseFirst = require("8067d5938624679c");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var upperFirst = createCaseFirst('toUpperCase');
module.exports = upperFirst;

},{"8067d5938624679c":"epbgk"}],"epbgk":[function(require,module,exports,__globalThis) {
var castSlice = require("4d3ee699f5e65312"), hasUnicode = require("75cb55543f5cf904"), stringToArray = require("28dba99b5ff785c"), toString = require("d0739fec9b4a870a");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function createCaseFirst(methodName) {
    return function(string) {
        string = toString(string);
        var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = createCaseFirst;

},{"4d3ee699f5e65312":"1jAZu","75cb55543f5cf904":"fZvfj","28dba99b5ff785c":"5yY7E","d0739fec9b4a870a":"feA1o"}],"1jAZu":[function(require,module,exports,__globalThis) {
var baseSlice = require("957f9de4e7c987e9");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
}
module.exports = castSlice;

},{"957f9de4e7c987e9":"34Gi0"}],"34Gi0":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = baseSlice;

},{}],"fZvfj":[function(require,module,exports,__globalThis) {
/** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function hasUnicode(string) {
    return reHasUnicode.test(string);
}
module.exports = hasUnicode;

},{}],"5yY7E":[function(require,module,exports,__globalThis) {
var asciiToArray = require("46415d676ef6c55"), hasUnicode = require("fee8952dce0b1d9b"), unicodeToArray = require("94de8430a26c4657");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
module.exports = stringToArray;

},{"46415d676ef6c55":"9Wevc","fee8952dce0b1d9b":"fZvfj","94de8430a26c4657":"1hvco"}],"9Wevc":[function(require,module,exports,__globalThis) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function asciiToArray(string) {
    return string.split('');
}
module.exports = asciiToArray;

},{}],"1hvco":[function(require,module,exports,__globalThis) {
/** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var rsAstral = '[' + rsAstralRange + ']', rsCombo = '[' + rsComboRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join('|') + ')' + rsOptVar + reOptMod + ')*', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = '(?:' + [
    rsNonAstral + rsCombo + '?',
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}
module.exports = unicodeToArray;

},{}],"geSBv":[function(require,module,exports,__globalThis) {
var baseFlatten = require("47681c4d1a7ef012"), baseOrderBy = require("e6616c5747a1263"), baseRest = require("a0860f48649d88bf"), isIterateeCall = require("bc4e8af5ea5c7694");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var sortBy = baseRest(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});
module.exports = sortBy;

},{"47681c4d1a7ef012":"dkyY2","e6616c5747a1263":"ceFeF","a0860f48649d88bf":"6QFuT","bc4e8af5ea5c7694":"hCwoo"}],"ceFeF":[function(require,module,exports,__globalThis) {
var arrayMap = require("db63713b9e3f6857"), baseGet = require("f14fe2cf1d6e1437"), baseIteratee = require("aa46ef76ac0f0f20"), baseMap = require("156d6d81bcb54687"), baseSortBy = require("6199681b75a94377"), baseUnary = require("6e6be9ccb294da40"), compareMultiple = require("76d02849906caf76"), identity = require("20ef684240ffbb0b"), isArray = require("113881bb39f4771d");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
        if (isArray(iteratee)) return function(value) {
            return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        identity
    ];
    var index = -1;
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
    });
}
module.exports = baseOrderBy;

},{"db63713b9e3f6857":"eouC0","f14fe2cf1d6e1437":"6iITn","aa46ef76ac0f0f20":"hmPIl","156d6d81bcb54687":"gc8Xw","6199681b75a94377":"aLZM0","6e6be9ccb294da40":"1FfIP","76d02849906caf76":"gnXsi","20ef684240ffbb0b":"ex8Ky","113881bb39f4771d":"5gfYS"}],"aLZM0":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = baseSortBy;

},{}],"gnXsi":[function(require,module,exports,__globalThis) {
var compareAscending = require("514a75faf5183eb0");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = compareMultiple;

},{"514a75faf5183eb0":"cS2ek"}],"cS2ek":[function(require,module,exports,__globalThis) {
var isSymbol = require("1ede98712db2cb56");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = compareAscending;

},{"1ede98712db2cb56":"3Ftz1"}],"6QFuT":[function(require,module,exports,__globalThis) {
var identity = require("750ef60725aa0b20"), overRest = require("268ad3bc1186979a"), setToString = require("22ff78535b45a023");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}
module.exports = baseRest;

},{"750ef60725aa0b20":"ex8Ky","268ad3bc1186979a":"1ymnO","22ff78535b45a023":"jEIfl"}],"1ymnO":[function(require,module,exports,__globalThis) {
var apply = require("377a85ec2aec77b2");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"377a85ec2aec77b2":"iJNFI"}],"iJNFI":[function(require,module,exports,__globalThis) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"jEIfl":[function(require,module,exports,__globalThis) {
var baseSetToString = require("262d3e09990ebe87"), shortOut = require("2befd1ce8b099a43");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"262d3e09990ebe87":"2uh6X","2befd1ce8b099a43":"2PRVv"}],"2uh6X":[function(require,module,exports,__globalThis) {
var constant = require("b81338a16e1647c3"), defineProperty = require("656f2a88d6cd904d"), identity = require("59c6913a0c3cca63");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
    });
};
module.exports = baseSetToString;

},{"b81338a16e1647c3":"e33fK","656f2a88d6cd904d":"9V2gM","59c6913a0c3cca63":"ex8Ky"}],"e33fK":[function(require,module,exports,__globalThis) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"9V2gM":[function(require,module,exports,__globalThis) {
var getNative = require("28d8a503a405bf72");
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"28d8a503a405bf72":"3hxI7"}],"2PRVv":[function(require,module,exports,__globalThis) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"hCwoo":[function(require,module,exports,__globalThis) {
var eq = require("c3f6ffb6f19584c9"), isArrayLike = require("dba4b7ea1658ab35"), isIndex = require("e84bd961ce484b63"), isObject = require("3bd91d1ece60badb");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"c3f6ffb6f19584c9":"eLtdL","dba4b7ea1658ab35":"fs9yO","e84bd961ce484b63":"czJh8","3bd91d1ece60badb":"cNdKD"}],"1jvFS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTickValues", ()=>(0, _getNiceTickValues.getTickValues));
parcelHelpers.export(exports, "getNiceTickValues", ()=>(0, _getNiceTickValues.getNiceTickValues));
parcelHelpers.export(exports, "getTickValuesFixedDomain", ()=>(0, _getNiceTickValues.getTickValuesFixedDomain));
var _getNiceTickValues = require("./getNiceTickValues");

},{"./getNiceTickValues":"cbBci","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cbBci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNiceTickValues", ()=>getNiceTickValues);
parcelHelpers.export(exports, "getTickValues", ()=>getTickValues);
parcelHelpers.export(exports, "getTickValuesFixedDomain", ()=>getTickValuesFixedDomain);
/**
 * @fileOverview calculate tick values of scale
 * @author xile611, arcthur
 * @date 2015-09-17
 */ var _decimalJsLight = require("decimal.js-light");
var _decimalJsLightDefault = parcelHelpers.interopDefault(_decimalJsLight);
var _utils = require("./util/utils");
var _arithmetic = require("./util/arithmetic");
var _arithmeticDefault = parcelHelpers.interopDefault(_arithmetic);
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function getValidInterval(_ref) {
    var _ref2 = _slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, _decimalJsLightDefault.default)(0);
    var digitCount = (0, _arithmeticDefault.default).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, _decimalJsLightDefault.default)(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, _decimalJsLightDefault.default)(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, _decimalJsLightDefault.default)(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, _decimalJsLightDefault.default)(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, _decimalJsLightDefault.default)(10).pow((0, _arithmeticDefault.default).getDigitCount(value) - 1);
            middle = new (0, _decimalJsLightDefault.default)(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, _decimalJsLightDefault.default)(Math.floor(value));
    } else if (value === 0) middle = new (0, _decimalJsLightDefault.default)(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, _decimalJsLightDefault.default)(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, _utils.compose)((0, _utils.map)(function(n) {
        return middle.add(new (0, _decimalJsLightDefault.default)(n - middleIndex).mul(step)).toNumber();
    }), (0, _utils.range));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, _decimalJsLightDefault.default)(0),
        tickMin: new (0, _decimalJsLightDefault.default)(0),
        tickMax: new (0, _decimalJsLightDefault.default)(0)
    };
     // The step which is easy to understand between two ticks
    var step = getFormatStep(new (0, _decimalJsLightDefault.default)(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, _decimalJsLightDefault.default)(0);
    else {
        // calculate the middle value
        middle = new (0, _decimalJsLightDefault.default)(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, _decimalJsLightDefault.default)(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, _decimalJsLightDefault.default)(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, _decimalJsLightDefault.default)(belowCount).mul(step)),
        tickMax: middle.add(new (0, _decimalJsLightDefault.default)(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function getNiceTickValuesFn(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = getValidInterval([
        min,
        max
    ]), _getValidInterval2 = _slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, _utils.reverse)(_values) : _values;
    }
    if (cormin === cormax) return getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, _arithmeticDefault.default).rangeStep(tickMin, tickMax.add(new (0, _decimalJsLightDefault.default)(0.1).mul(step)), step);
    return min > max ? (0, _utils.reverse)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function getTickValuesFn(_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = getValidInterval([
        min,
        max
    ]), _getValidInterval4 = _slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = getFormatStep(new (0, _decimalJsLightDefault.default)(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, _utils.compose)((0, _utils.map)(function(n) {
        return new (0, _decimalJsLightDefault.default)(cormin).add(new (0, _decimalJsLightDefault.default)(n).mul(step)).toNumber();
    }), (0, _utils.range));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, _utils.reverse)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = _slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = getValidInterval([
        min,
        max
    ]), _getValidInterval6 = _slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = getFormatStep(new (0, _decimalJsLightDefault.default)(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat(_toConsumableArray((0, _arithmeticDefault.default).rangeStep(new (0, _decimalJsLightDefault.default)(cormin), new (0, _decimalJsLightDefault.default)(cormax).sub(new (0, _decimalJsLightDefault.default)(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, _utils.reverse)(values) : values;
}
var getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
var getTickValues = (0, _utils.memoize)(getTickValuesFn);
var getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);

},{"decimal.js-light":"i3x2L","./util/utils":"2Xkt3","./util/arithmetic":"jlWWO","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"i3x2L":[function(require,module,exports,__globalThis) {
/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */ (function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if (module.exports) module.exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})(this);

},{}],"2Xkt3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PLACE_HOLDER", ()=>PLACE_HOLDER);
parcelHelpers.export(exports, "curry", ()=>curry);
parcelHelpers.export(exports, "range", ()=>range);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "reverse", ()=>reverse);
parcelHelpers.export(exports, "memoize", ()=>memoize);
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var identity = function identity(i) {
    return i;
};
var PLACE_HOLDER = {
    '@@functional/placeholder': true
};
var isPlaceHolder = function isPlaceHolder(val) {
    return val === PLACE_HOLDER;
};
var curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== PLACE_HOLDER;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, _toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var curry = function curry(fn) {
    return curryN(fn.length, fn);
};
var range = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var map = curry(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var compose = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var reverse = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split('').reverse.join('');
};
var memoize = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jlWWO":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _decimalJsLight = require("decimal.js-light");
var _decimalJsLightDefault = parcelHelpers.interopDefault(_decimalJsLight);
var _utils = require("./utils");
/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, _decimalJsLightDefault.default)(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function rangeStep(start, end, step) {
    var num = new (0, _decimalJsLightDefault.default)(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var interpolateNumber = (0, _utils.curry)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var uninterpolateNumber = (0, _utils.curry)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var uninterpolateTruncation = (0, _utils.curry)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
exports.default = {
    rangeStep: rangeStep,
    getDigitCount: getDigitCount,
    interpolateNumber: interpolateNumber,
    uninterpolateNumber: uninterpolateNumber,
    uninterpolateTruncation: uninterpolateTruncation
};

},{"decimal.js-light":"i3x2L","./utils":"2Xkt3","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cnMff":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLegendProps", ()=>getLegendProps);
var _legend = require("../component/Legend");
var _chartUtils = require("./ChartUtils");
var _reactUtils = require("./ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getLegendProps = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, _reactUtils.findChildByType)(children, (0, _legend.Legend));
    if (!legendItem) return null;
    var legendDefaultProps = (0, _legend.Legend).defaultProps;
    var legendProps = legendDefaultProps !== undefined ? _objectSpread(_objectSpread({}, legendDefaultProps), legendItem.props) : {};
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === 'children') legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var itemDefaultProps = item.type.defaultProps;
        var itemProps = itemDefaultProps !== undefined ? _objectSpread(_objectSpread({}, itemDefaultProps), item.props) : {};
        var dataKey = itemProps.dataKey, name = itemProps.name, legendType = itemProps.legendType, hide = itemProps.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendProps.iconType || legendType || 'square',
            color: (0, _chartUtils.getMainColorOfGraphicItem)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: itemProps
        };
    });
    return _objectSpread(_objectSpread(_objectSpread({}, legendProps), (0, _legend.Legend).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};

},{"../component/Legend":"hn1WY","./ChartUtils":"55u3i","./ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hn1WY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Legend", ()=>Legend);
/**
 * @fileOverview Legend
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _defaultLegendContent = require("./DefaultLegendContent");
var _dataUtils = require("../util/DataUtils");
var _getUniqPayload = require("../util/payload/getUniqPayload");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "ref"
];
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function defaultUniqBy(entry) {
    return entry.value;
}
function renderContent(content, props) {
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(content)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, _reactDefault.default).createElement(content, props);
    var ref = props.ref, otherProps = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _defaultLegendContent.DefaultLegendContent), otherProps);
}
var EPS = 1;
var Legend = /*#__PURE__*/ function(_PureComponent) {
    function Legend() {
        var _this;
        _classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, Legend, [].concat(args));
        _defineProperty(_this, "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    _inherits(Legend, _PureComponent);
    return _createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    box.height = this.wrapperNode.offsetHeight;
                    box.width = this.wrapperNode.offsetWidth;
                    return box;
                }
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                var box = this.getBBox();
                if (box) {
                    if (Math.abs(box.width - this.lastBoundingBox.width) > EPS || Math.abs(box.height - this.lastBoundingBox.height) > EPS) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                        if (onBBoxUpdate) onBBoxUpdate(box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return _objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === 'center' && layout === 'vertical') {
                        var box = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - box.width) / 2
                        };
                    } else hPos = align === 'right' ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === 'middle') {
                        var _box = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box.height) / 2
                        };
                    } else vPos = verticalAlign === 'bottom' ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return _objectSpread(_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = _objectSpread(_objectSpread({
                    position: 'absolute',
                    width: width || 'auto',
                    height: height || 'auto'
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, renderContent(content, _objectSpread(_objectSpread({}, this.props), {}, {
                    payload: (0, _getUniqPayload.getUniqPayload)(payload, payloadUniqBy, defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var _this$defaultProps$it = _objectSpread(_objectSpread({}, this.defaultProps), item.props), layout = _this$defaultProps$it.layout;
                if (layout === 'vertical' && (0, _dataUtils.isNumber)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === 'horizontal') return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(Legend, "displayName", 'Legend');
_defineProperty(Legend, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom'
});

},{"react":"eGun2","./DefaultLegendContent":"eTwVK","../util/DataUtils":"lsl3R","../util/payload/getUniqPayload":"5wAw7","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eTwVK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultLegendContent", ()=>DefaultLegendContent);
/**
 * @fileOverview Default Legend Content
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _logUtils = require("../util/LogUtils");
var _surface = require("../container/Surface");
var _symbols = require("../shape/Symbols");
var _types = require("../util/types");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var SIZE = 32;
var DefaultLegendContent = /*#__PURE__*/ function(_PureComponent) {
    function DefaultLegendContent() {
        _classCallCheck(this, DefaultLegendContent);
        return _callSuper(this, DefaultLegendContent, arguments);
    }
    _inherits(DefaultLegendContent, _PureComponent);
    return _createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = SIZE / 2;
                var sixthSize = SIZE / 6;
                var thirdSize = SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === 'plainline') return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === 'line') return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === 'rect') return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(data.legendIcon)) {
                    var iconProps = _objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _symbols.Symbols), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: SIZE,
                    height: SIZE
                };
                var itemStyle = {
                    display: layout === 'horizontal' ? 'inline-block' : 'block',
                    marginRight: 10
                };
                var svgStyle = {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, _clsxDefault.default)(_defineProperty(_defineProperty({
                        'recharts-legend-item': true
                    }, "legend-item-".concat(i), true), "inactive", entry.inactive));
                    if (entry.type === 'none') return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, _isFunctionDefault.default)(entry.value) ? entry.value : null;
                    (0, _logUtils.warn)(!(0, _isFunctionDefault.default)(entry.value), "The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name=\"Name of my Data\"/>" // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", _extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, _types.adaptEventsOfChild)(_this.props, entry, i)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _surface.Surface), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === 'horizontal' ? align : 'left'
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(DefaultLegendContent, "displayName", 'Legend');
_defineProperty(DefaultLegendContent, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'middle',
    inactiveColor: '#ccc'
});

},{"react":"eGun2","lodash/isFunction":"2KQKo","clsx":"3mzHT","../util/LogUtils":"7Bf7y","../container/Surface":"7sKCX","../shape/Symbols":"eArZD","../util/types":"5mtYY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7Bf7y":[function(require,module,exports,__globalThis) {
/* eslint no-console: 0 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warn", ()=>warn);
var isDev = false;
var warn = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if (isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7sKCX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Surface", ()=>Surface);
/**
 * @fileOverview Surface
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Surface(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = _objectWithoutProperties(props, _excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, _clsxDefault.default)('recharts-surface', className);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({}, (0, _reactUtils.filterProps)(others, true, 'svg'), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title), /*#__PURE__*/ (0, _reactDefault.default).createElement("desc", null, desc), children);
}

},{"react":"eGun2","clsx":"3mzHT","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eArZD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Symbols", ()=>Symbols);
/**
 * @fileOverview Curve
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _upperFirst = require("lodash/upperFirst");
var _upperFirstDefault = parcelHelpers.interopDefault(_upperFirst);
var _d3Shape = require("victory-vendor/d3-shape");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "type",
    "size",
    "sizeType"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var symbolFactories = {
    symbolCircle: (0, _d3Shape.symbolCircle),
    symbolCross: (0, _d3Shape.symbolCross),
    symbolDiamond: (0, _d3Shape.symbolDiamond),
    symbolSquare: (0, _d3Shape.symbolSquare),
    symbolStar: (0, _d3Shape.symbolStar),
    symbolTriangle: (0, _d3Shape.symbolTriangle),
    symbolWye: (0, _d3Shape.symbolWye)
};
var RADIAN = Math.PI / 180;
var getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, _upperFirstDefault.default)(type));
    return symbolFactories[name] || (0, _d3Shape.symbolCircle);
};
var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var registerSymbol = function registerSymbol(key, factory) {
    symbolFactories["symbol".concat((0, _upperFirstDefault.default)(key))] = factory;
};
var Symbols = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'circle' : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? 'area' : _ref$sizeType, rest = _objectWithoutProperties(_ref, _excluded);
    var props = _objectSpread(_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = getSymbolFactory(type);
        var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, _reactUtils.filterProps)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, filteredProps, {
        className: (0, _clsxDefault.default)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
Symbols.registerSymbol = registerSymbol;

},{"react":"eGun2","lodash/upperFirst":"eESst","victory-vendor/d3-shape":"jODwB","clsx":"3mzHT","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5wAw7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This is configuration option that decides how to filter for unique values only:
 *
 * - `false` means "no filter"
 * - `true` means "use recharts default filter"
 * - function means "use return of this function as the default key"
 */ parcelHelpers.export(exports, "getUniqPayload", ()=>getUniqPayload);
var _uniqBy = require("lodash/uniqBy");
var _uniqByDefault = parcelHelpers.interopDefault(_uniqBy);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
function getUniqPayload(payload, option, defaultUniqBy) {
    if (option === true) return (0, _uniqByDefault.default)(payload, defaultUniqBy);
    if ((0, _isFunctionDefault.default)(option)) return (0, _uniqByDefault.default)(payload, option);
    return payload;
}

},{"lodash/uniqBy":"711jy","lodash/isFunction":"2KQKo","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"711jy":[function(require,module,exports,__globalThis) {
var baseIteratee = require("d35a160a12ca01cb"), baseUniq = require("88040d9dbcacd1a1");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function uniqBy(array, iteratee) {
    return array && array.length ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}
module.exports = uniqBy;

},{"d35a160a12ca01cb":"hmPIl","88040d9dbcacd1a1":"1mcsM"}],"1mcsM":[function(require,module,exports,__globalThis) {
var SetCache = require("7f5b764158b34cce"), arrayIncludes = require("39a4750c7ae20f93"), arrayIncludesWith = require("e35905e74459d922"), cacheHas = require("1e890ce855b904ea"), createSet = require("8f29f5bec7a41b1d"), setToArray = require("53440f847f173e28");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseUniq;

},{"7f5b764158b34cce":"f7SVF","39a4750c7ae20f93":"gouSh","e35905e74459d922":"iijgZ","1e890ce855b904ea":"hZy6h","8f29f5bec7a41b1d":"jlB9q","53440f847f173e28":"cIvVD"}],"gouSh":[function(require,module,exports,__globalThis) {
var baseIndexOf = require("7a0805031db4fe8f");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
module.exports = arrayIncludes;

},{"7a0805031db4fe8f":"aS0AB"}],"aS0AB":[function(require,module,exports,__globalThis) {
var baseFindIndex = require("4f714c389a014992"), baseIsNaN = require("d5b71f3e87bff323"), strictIndexOf = require("d0a6d19f21d2065a");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;

},{"4f714c389a014992":"dtc9v","d5b71f3e87bff323":"kaK2S","d0a6d19f21d2065a":"8isVg"}],"dtc9v":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"kaK2S":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;

},{}],"8isVg":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = strictIndexOf;

},{}],"iijgZ":[function(require,module,exports,__globalThis) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = arrayIncludesWith;

},{}],"jlB9q":[function(require,module,exports,__globalThis) {
var Set = require("ea44e2ee627fc44a"), noop = require("6c8054515bcee0e"), setToArray = require("ae3964987ed28570");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set && 1 / setToArray(new Set([
    ,
    -0
]))[1] == INFINITY) ? noop : function(values) {
    return new Set(values);
};
module.exports = createSet;

},{"ea44e2ee627fc44a":"6wJSe","6c8054515bcee0e":"4LKMh","ae3964987ed28570":"cIvVD"}],"4LKMh":[function(require,module,exports,__globalThis) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"e7fwF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BarRectangle", ()=>BarRectangle);
parcelHelpers.export(exports, "minPointSizeCallback", ()=>minPointSizeCallback);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _activeShapeUtils = require("./ActiveShapeUtils");
var _dataUtils = require("./DataUtils");
var _excluded = [
    "x",
    "y"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = _objectWithoutProperties(_ref, _excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function BarRectangle(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _activeShapeUtils.Shape), _extends({
        shapeType: "rectangle",
        propTransformer: typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}
var minPointSizeCallback = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function(value, index) {
        if (typeof minPointSize === 'number') return minPointSize;
        var isValueNumberOrNil = (0, _dataUtils.isNumber)(value) || (0, _dataUtils.isNullish)(value);
        if (isValueNumberOrNil) return minPointSize(value, index);
        !isValueNumberOrNil && (0, _tinyInvariantDefault.default)(false);
        return defaultValue;
    };
};

},{"react":"eGun2","tiny-invariant":"4qfOO","./ActiveShapeUtils":"6kRg3","./DataUtils":"lsl3R","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6kRg3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPropsFromShapeOption", ()=>getPropsFromShapeOption);
parcelHelpers.export(exports, "Shape", ()=>Shape);
/**
 * This is an abstraction to handle identifying the active index from a tooltip mouse interaction
 */ parcelHelpers.export(exports, "isFunnel", ()=>isFunnel);
parcelHelpers.export(exports, "isPie", ()=>isPie);
parcelHelpers.export(exports, "isScatter", ()=>isScatter);
parcelHelpers.export(exports, "compareFunnel", ()=>compareFunnel);
parcelHelpers.export(exports, "comparePie", ()=>comparePie);
parcelHelpers.export(exports, "compareScatter", ()=>compareScatter);
/**
 *
 * @param {GetActiveShapeIndexForTooltip} arg an object of incoming attributes from Tooltip
 * @returns {number}
 *
 * To handle possible duplicates in the data set,
 * match both the data value of the active item to a data value on a graph item,
 * and match the mouse coordinates of the active item to the coordinates of in a particular components shape data.
 * This assumes equal lengths of shape objects to data items.
 */ parcelHelpers.export(exports, "getActiveShapeIndexForTooltip", ()=>getActiveShapeIndexForTooltip);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _isBoolean = require("lodash/isBoolean");
var _isBooleanDefault = parcelHelpers.interopDefault(_isBoolean);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _rectangle = require("../shape/Rectangle");
var _trapezoid = require("../shape/Trapezoid");
var _sector = require("../shape/Sector");
var _layer = require("../container/Layer");
var _symbols = require("../shape/Symbols");
var _excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function defaultPropTransformer(option, props) {
    return _objectSpread(_objectSpread({}, props), option);
}
function isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rectangle.Rectangle), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _trapezoid.Trapezoid), elementProps);
        case 'sector':
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sector.Sector), elementProps);
        case 'symbols':
            if (isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _symbols.Symbols), elementProps);
            break;
        default:
            return null;
    }
}
function getPropsFromShapeOption(option) {
    if (/*#__PURE__*/ (0, _react.isValidElement)(option)) return option.props;
    return option;
}
function Shape(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? 'recharts-active-shape' : _ref2$activeClassName, isActive = _ref2.isActive, props = _objectWithoutProperties(_ref2, _excluded);
    var shape;
    if (/*#__PURE__*/ (0, _react.isValidElement)(option)) shape = /*#__PURE__*/ (0, _react.cloneElement)(option, _objectSpread(_objectSpread({}, props), getPropsFromShapeOption(option)));
    else if ((0, _isFunctionDefault.default)(option)) shape = option(props);
    else if ((0, _isPlainObjectDefault.default)(option) && !(0, _isBooleanDefault.default)(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, _reactDefault.default).createElement(ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, _reactDefault.default).createElement(ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: activeClassName
    }, shape);
    return shape;
}
function isFunnel(graphicalItem, _item) {
    return _item != null && 'trapezoids' in graphicalItem.props;
}
function isPie(graphicalItem, _item) {
    return _item != null && 'sectors' in graphicalItem.props;
}
function isScatter(graphicalItem, _item) {
    return _item != null && 'points' in graphicalItem.props;
}
function compareFunnel(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function comparePie(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function compareScatter(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if (isFunnel(graphicalItem, activeItem)) comparison = compareFunnel;
    else if (isPie(graphicalItem, activeItem)) comparison = comparePie;
    else if (isScatter(graphicalItem, activeItem)) comparison = compareScatter;
    return comparison;
}
function getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if (isFunnel(graphicalItem, activeItem)) shapeKey = 'trapezoids';
    else if (isPie(graphicalItem, activeItem)) shapeKey = 'sectors';
    else if (isScatter(graphicalItem, activeItem)) shapeKey = 'points';
    return shapeKey;
}
function getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if (isFunnel(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if (isPie(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if (isScatter(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function getActiveShapeIndexForTooltip(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, _isEqualDefault.default)(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}

},{"react":"eGun2","lodash/isFunction":"2KQKo","lodash/isPlainObject":"bAA6z","lodash/isBoolean":"79mI1","lodash/isEqual":"kMH36","../shape/Rectangle":"gLZb9","../shape/Trapezoid":"3pate","../shape/Sector":"dCpDt","../container/Layer":"gNfib","../shape/Symbols":"eArZD","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bAA6z":[function(require,module,exports,__globalThis) {
var baseGetTag = require("1fa75ae145548e19"), getPrototype = require("2500fe73fd6283cb"), isObjectLike = require("83a5e0ccc9691a38");
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"1fa75ae145548e19":"eUzNb","2500fe73fd6283cb":"4M6Bs","83a5e0ccc9691a38":"4gHtY"}],"4M6Bs":[function(require,module,exports,__globalThis) {
var overArg = require("140319196a5a03fc");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"140319196a5a03fc":"bVmR1"}],"79mI1":[function(require,module,exports,__globalThis) {
var baseGetTag = require("4bc140cae651dffe"), isObjectLike = require("31aaa2313bec328b");
/** `Object#toString` result references. */ var boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function isBoolean(value) {
    return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
}
module.exports = isBoolean;

},{"4bc140cae651dffe":"eUzNb","31aaa2313bec328b":"4gHtY"}],"gLZb9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInRectangle", ()=>isInRectangle);
parcelHelpers.export(exports, "Rectangle", ()=>Rectangle);
/**
 * @fileOverview Rectangle
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var isInRectangle = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var Rectangle = function Rectangle(rectangleProps) {
    var props = _objectSpread(_objectSpread({}, defaultProps), rectangleProps);
    var pathRef = (0, _react.useRef)();
    var _useState = (0, _react.useState)(-1), _useState2 = _slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, _react.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, _clsxDefault.default)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
        className: layerClass,
        d: getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
            className: layerClass,
            d: getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};

},{"react":"eGun2","clsx":"3mzHT","react-smooth":"ekPiD","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3pate":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Trapezoid", ()=>Trapezoid);
/**
 * @fileOverview Rectangle
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var Trapezoid = function Trapezoid(props) {
    var trapezoidProps = _objectSpread(_objectSpread({}, defaultProps), props);
    var pathRef = (0, _react.useRef)();
    var _useState = (0, _react.useState)(-1), _useState2 = _slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, _react.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, _clsxDefault.default)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(trapezoidProps, true), {
        className: layerClass,
        d: getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(trapezoidProps, true), {
            className: layerClass,
            d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};

},{"react":"eGun2","clsx":"3mzHT","react-smooth":"ekPiD","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dCpDt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sector", ()=>Sector);
/**
 * @fileOverview Sector
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _polarUtils = require("../util/PolarUtils");
var _dataUtils = require("../util/DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, _polarUtils.RADIAN);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, _polarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, _polarUtils.polarToCartesian)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, _polarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * (0, _polarUtils.RADIAN)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var _getTangentCircle = getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var Sector = function Sector(sectorProps) {
    var props = _objectSpread(_objectSpread({}, defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, _clsxDefault.default)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, _dataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};

},{"react":"eGun2","clsx":"3mzHT","../util/ReactUtils":"dBf5D","../util/PolarUtils":"27snq","../util/DataUtils":"lsl3R","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"euDzi":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Bar Chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BarChart", ()=>BarChart);
var _generateCategoricalChart = require("./generateCategoricalChart");
var _bar = require("../cartesian/Bar");
var _xaxis = require("../cartesian/XAxis");
var _yaxis = require("../cartesian/YAxis");
var _cartesianUtils = require("../util/CartesianUtils");
var BarChart = (0, _generateCategoricalChart.generateCategoricalChart)({
    chartName: 'BarChart',
    GraphicalChild: (0, _bar.Bar),
    defaultTooltipEventType: 'axis',
    validateTooltipEventTypes: [
        'axis',
        'item'
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, _xaxis.XAxis)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, _yaxis.YAxis)
        }
    ],
    formatAxisMap: (0, _cartesianUtils.formatAxisMap)
});

},{"./generateCategoricalChart":"l1e9D","../cartesian/Bar":"9EUGQ","../cartesian/XAxis":"4nBWG","../cartesian/YAxis":"NHcEZ","../util/CartesianUtils":"1I6yD","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"l1e9D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAxisMapByAxes", ()=>getAxisMapByAxes);
parcelHelpers.export(exports, "createDefaultState", ()=>createDefaultState);
parcelHelpers.export(exports, "generateCategoricalChart", ()=>generateCategoricalChart);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _range = require("lodash/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _sortBy = require("lodash/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var _throttle = require("lodash/throttle");
var _throttleDefault = parcelHelpers.interopDefault(_throttle);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
// eslint-disable-next-line no-restricted-imports
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _surface = require("../container/Surface");
var _layer = require("../container/Layer");
var _tooltip = require("../component/Tooltip");
var _legend = require("../component/Legend");
var _dot = require("../shape/Dot");
var _rectangle = require("../shape/Rectangle");
var _reactUtils = require("../util/ReactUtils");
var _brush = require("../cartesian/Brush");
var _domutils = require("../util/DOMUtils");
var _dataUtils = require("../util/DataUtils");
var _chartUtils = require("../util/ChartUtils");
var _detectReferenceElementsDomain = require("../util/DetectReferenceElementsDomain");
var _polarUtils = require("../util/PolarUtils");
var _shallowEqual = require("../util/ShallowEqual");
var _events = require("../util/Events");
var _types = require("../util/types");
var _accessibilityManager = require("./AccessibilityManager");
var _isDomainSpecifiedByUser = require("../util/isDomainSpecifiedByUser");
var _activeShapeUtils = require("../util/ActiveShapeUtils");
var _cursor = require("../component/Cursor");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _excluded = [
    "item"
], _excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var ORIENT_MAP = {
    xAxis: [
        'bottom',
        'top'
    ],
    yAxis: [
        'left',
        'right'
    ]
};
var FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%'
};
var originCoordinate = {
    x: 0,
    y: 0
};
/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */ function renderAsIs(element) {
    return element;
}
var calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === 'horizontal') return rangeObj.x;
    if (layout === 'vertical') return rangeObj.y;
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};
var getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === 'vertical') return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return _objectSpread(_objectSpread(_objectSpread({}, rangeObj), (0, _polarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return _objectSpread(_objectSpread(_objectSpread({}, rangeObj), (0, _polarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return originCoordinate;
};
var getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, _dataUtils.isNumber)(dataStartIndex) && (0, _dataUtils.isNumber)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function getDefaultDomainByAxisType(axisType) {
    return axisType === 'number' ? [
        0,
        'auto'
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
        // The data is sliced only when the active index is within the start/end index range.
        state.dataEndIndex - state.dataStartIndex >= activeIndex) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, _dataUtils.findEntryInArray)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat(_toConsumableArray(result), [
            (0, _chartUtils.getTooltipItem)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, _chartUtils.calculateActiveTickIndex)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var getAxisMapByAxes = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, _chartUtils.isCategoricalAxis)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _childProps$domain2;
        var childProps = child.type.defaultProps !== undefined ? _objectSpread(_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var type = childProps.type, dataKey = childProps.dataKey, allowDataOverflow = childProps.allowDataOverflow, allowDuplicatedCategory = childProps.allowDuplicatedCategory, scale = childProps.scale, ticks = childProps.ticks, includeHidden = childProps.includeHidden;
        var axisId = childProps[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                var _defaultProps;
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps = item.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps[axisIdKey];
                return itemAxisId === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, _isDomainSpecifiedByUser.isDomainSpecifiedByUser)(childProps.domain, allowDataOverflow, type)) {
            domain = (0, _chartUtils.parseSpecifiedDomain)(childProps.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, _chartUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _childProps$domain;
            var childDomain = (_childProps$domain = childProps.domain) !== null && _childProps$domain !== void 0 ? _childProps$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, _chartUtils.getDomainOfDataByKey)(displayedData, dataKey, type);
                if (type === 'category' && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, _dataUtils.hasDuplicate)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, _rangeDefault.default)(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, _chartUtils.parseDomainOfCategoryAxis)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === 'category') {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, _chartUtils.parseDomainOfCategoryAxis)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, _isNilDefault.default)(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== '' && !(0, _isNilDefault.default)(entry);
                    });
                } else if (type === 'number') {
                    // the field type is numerical
                    var errorBarsDomain = (0, _chartUtils.parseErrorBarsOfAxis)(displayedData, graphicalItems.filter(function(item) {
                        var _defaultProps2, _defaultProps3;
                        var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps2 = item.type.defaultProps) === null || _defaultProps2 === void 0 ? void 0 : _defaultProps2[axisIdKey];
                        var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps3 = item.type.defaultProps) === null || _defaultProps3 === void 0 ? void 0 : _defaultProps3.hide;
                        return itemAxisId === axisId && (includeHidden || !itemHide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, _chartUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, _rangeDefault.default)(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [
                0,
                1
            ] : (0, _chartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, _chartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function(item) {
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : item.type.defaultProps[axisIdKey];
                var itemHide = 'hide' in item.props ? item.props.hide : item.type.defaultProps.hide;
                return itemAxisId === axisId && (includeHidden || !itemHide);
            }), type, layout, true);
            if (type === 'number') {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, _detectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, _chartUtils.parseSpecifiedDomain)(childDomain, domain, allowDataOverflow);
            } else if (type === 'category' && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, _objectSpread(_objectSpread({}, childProps), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_childProps$domain2 = childProps.domain) !== null && _childProps$domain2 !== void 0 ? _childProps$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, _chartUtils.isCategoricalAxis)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var childProps = child.type.defaultProps !== undefined ? _objectSpread(_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var axisId = childProps[axisIdKey];
        var originalDomain = getDefaultDomainByAxisType('number');
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, _rangeDefault.default)(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, _chartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, _detectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
            } else {
                domain = (0, _chartUtils.parseSpecifiedDomain)(originalDomain, (0, _chartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function(item) {
                    var _defaultProps4, _defaultProps5;
                    var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps4 = item.type.defaultProps) === null || _defaultProps4 === void 0 ? void 0 : _defaultProps4[axisIdKey];
                    var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps5 = item.type.defaultProps) === null || _defaultProps5 === void 0 ? void 0 : _defaultProps5.hide;
                    return itemAxisId === axisId && !itemHide;
                }), 'number', layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, _detectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
            }
            return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, _objectSpread(_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, _getDefault.default)(ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, _reactUtils.findAllByType)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = getAxisMapByAxes(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, _dataUtils.getAnyElementOfObject)(axisMap);
    var tooltipTicks = (0, _chartUtils.getTicksOfAxis)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, _sortByDefault.default)(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, _chartUtils.getBandSizeOfAxis)(axis, tooltipTicks)
    };
};
var createDefaultState = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, _reactUtils.findChildByType)(children, (0, _brush.Brush));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, _reactUtils.getDisplayName)(item && item.type);
        return name && name.indexOf('Bar') >= 0;
    });
};
var getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === 'horizontal') return {
        numericAxisName: 'yAxis',
        cateAxisName: 'xAxis'
    };
    if (layout === 'vertical') return {
        numericAxisName: 'xAxis',
        cateAxisName: 'yAxis'
    };
    if (layout === 'centric') return {
        numericAxisName: 'radiusAxis',
        cateAxisName: 'angleAxis'
    };
    return {
        numericAxisName: 'angleAxis',
        cateAxisName: 'radiusAxis'
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, _reactUtils.findChildByType)(children, (0, _brush.Brush));
    var legendItem = (0, _reactUtils.findChildByType)(children, (0, _legend.Legend));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, orientation, (0, _getDefault.default)(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = _objectSpread(_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, _brush.Brush).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, _chartUtils.appendOffsetOfLegend)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return _objectSpread(_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
// Determine the size of the axis, used for calculation of relative bar sizes
var getCartesianAxisSize = function getCartesianAxisSize(axisObj, axisName) {
    if (axisName === 'xAxis') return axisObj[axisName].width;
    if (axisName === 'yAxis') return axisObj[axisName].height;
    // This is only supported for Bar charts (i.e. charts with cartesian axes), so we should never get here
    return undefined;
};
var generateCategoricalChart = function generateCategoricalChart(_ref6) {
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        'axis'
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = hasGraphicalBarItem(graphicalItems);
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var itemProps = item.type.defaultProps !== undefined ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
            var dataKey = itemProps.dataKey, childMaxBarSize = itemProps.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = itemProps["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = itemProps["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = itemProps["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === 'zAxis') && (0, _tinyInvariantDefault.default)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return _objectSpread(_objectSpread({}, result), {}, _defineProperty(_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), (0, _chartUtils.getTicksOfAxis)(axis)));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _chartUtils.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, _reactUtils.getDisplayName)(item.type).indexOf('Bar') >= 0;
            var bandSize = (0, _chartUtils.getBandSizeOfAxis)(cateAxis, cateTicks);
            var barPosition = [];
            var sizeList = hasBar && (0, _chartUtils.getBarSizeList)({
                barSize: barSize,
                stackGroups: stackGroups,
                totalSize: getCartesianAxisSize(axisObj, cateAxisName)
            });
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // If it is bar, calculate the position of bar
                var maxBarSize = (0, _isNilDefault.default)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, _chartUtils.getBandSizeOfAxis)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, _chartUtils.getBarPosition)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return _objectSpread(_objectSpread({}, pos), {}, {
                        position: _objectSpread(_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) formattedItems.push({
                props: _objectSpread(_objectSpread({}, composedFn(_objectSpread(_objectSpread({}, axisObj), {}, {
                    displayedData: displayedData,
                    props: props,
                    dataKey: dataKey,
                    item: item,
                    bandSize: bandSize,
                    barPosition: barPosition,
                    offset: offset,
                    stackedData: stackedData,
                    layout: layout,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }))), {}, _defineProperty(_defineProperty(_defineProperty({
                    key: item.key || "item-".concat(index)
                }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
                childIndex: (0, _reactUtils.parseChildIndex)(item, props.children),
                item: item
            });
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, _reactUtils.validateWidthHeight)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, _reactUtils.findAllByType)(children, GraphicalChild);
        var stackGroups = (0, _chartUtils.getStackGroupsByAxisId)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, name, getAxisMap(props, _objectSpread(_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = calculateOffset(_objectSpread(_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, _objectSpread(_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return _objectSpread(_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    var CategoricalChartWrapper = /*#__PURE__*/ function(_Component) {
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            _classCallCheck(this, CategoricalChartWrapper);
            _this = _callSuper(this, CategoricalChartWrapper, [
                _props
            ]);
            _defineProperty(_this, "eventEmitterSymbol", Symbol('rechartsEventEmitter'));
            _defineProperty(_this, "accessibilityManager", new (0, _accessibilityManager.AccessibilityManager)());
            _defineProperty(_this, "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState(_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, _objectSpread(_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            _defineProperty(_this, "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== 'function') return;
                    _this.applySyncEvent(data);
                }
            });
            _defineProperty(_this, "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return _objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ _defineProperty(_this, "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = _objectSpread(_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, _isFunctionDefault.default)(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            _defineProperty(_this, "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? _objectSpread(_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, _isFunctionDefault.default)(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ _defineProperty(_this, "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ _defineProperty(_this, "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ _defineProperty(_this, "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ _defineProperty(_this, "handleMouseLeave", function(e) {
                _this.throttleTriggeredAfterMouseMove.cancel();
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, _isFunctionDefault.default)(onMouseLeave)) onMouseLeave(nextState, e);
            });
            _defineProperty(_this, "handleOuterEvent", function(e) {
                var eventName = (0, _reactUtils.getReactEventByType)(e);
                var event = (0, _getDefault.default)(_this.props, "".concat(eventName));
                if (eventName && (0, _isFunctionDefault.default)(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            _defineProperty(_this, "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = _objectSpread(_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, _isFunctionDefault.default)(onClick)) onClick(_nextState2, e);
                }
            });
            _defineProperty(_this, "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, _isFunctionDefault.default)(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            _defineProperty(_this, "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, _isFunctionDefault.default)(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            _defineProperty(_this, "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            _defineProperty(_this, "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            _defineProperty(_this, "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            _defineProperty(_this, "handleDoubleClick", function(e) {
                var onDoubleClick = _this.props.onDoubleClick;
                if ((0, _isFunctionDefault.default)(onDoubleClick)) {
                    var _nextState5 = _this.getMouseInfo(e);
                    onDoubleClick(_nextState5, e);
                }
            });
            _defineProperty(_this, "handleContextMenu", function(e) {
                var onContextMenu = _this.props.onContextMenu;
                if ((0, _isFunctionDefault.default)(onContextMenu)) {
                    var _nextState6 = _this.getMouseInfo(e);
                    onContextMenu(_nextState6, e);
                }
            });
            _defineProperty(_this, "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, _events.eventCenter).emit((0, _events.SYNC_EVENT), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            _defineProperty(_this, "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState(_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === 'function') // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === 'value') {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = _objectSpread(_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : originCoordinate;
                    _this.setState(_objectSpread(_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            _defineProperty(_this, "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || '_recharts-cursor';
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cursor.Cursor), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            _defineProperty(_this, "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, _getDefault.default)(element, 'type.axisType');
                var axisMap = (0, _getDefault.default)(_this.state, "".concat(axisType, "Map"));
                var elementDefaultProps = element.type.defaultProps;
                var elementProps = elementDefaultProps !== undefined ? _objectSpread(_objectSpread({}, elementDefaultProps), element.props) : element.props;
                var axisOption = axisMap && axisMap[elementProps["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread({}, axisOption), {}, {
                    className: (0, _clsxDefault.default)(axisType, axisOption.className),
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, _chartUtils.getTicksOfAxis)(axisOption, true)
                }));
            });
            _defineProperty(_this, "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, _dataUtils.getAnyElementOfObject)(radiusAxisMap);
                var angleAxis = (0, _dataUtils.getAnyElementOfObject)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, _react.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, _chartUtils.getTicksOfAxis)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, _chartUtils.getTicksOfAxis)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || 'polar-grid',
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ _defineProperty(_this, "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, _chartUtils.getLegendProps)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = _objectWithoutProperties(props, _excluded);
                return /*#__PURE__*/ (0, _react.cloneElement)(item, _objectSpread(_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ _defineProperty(_this, "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
                var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, _react.cloneElement)(tooltipItem, {
                    viewBox: _objectSpread(_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate,
                    accessibilityLayer: accessibilityLayer
                });
            });
            _defineProperty(_this, "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, _react.cloneElement)(element, {
                    key: element.key || '_recharts-brush',
                    onChange: (0, _chartUtils.combineEventHandlers)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, _dataUtils.isNumber)(element.props.x) ? element.props.x : offset.left,
                    y: (0, _dataUtils.isNumber)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, _dataUtils.isNumber)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            _defineProperty(_this, "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _this2 = _this, clipPathId = _this2.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var elementDefaultProps = element.type.defaultProps || {};
                var _element$props2 = element.props, _element$props2$xAxis = _element$props2.xAxisId, xAxisId = _element$props2$xAxis === void 0 ? elementDefaultProps.xAxisId : _element$props2$xAxis, _element$props2$yAxis = _element$props2.yAxisId, yAxisId = _element$props2$yAxis === void 0 ? elementDefaultProps.yAxisId : _element$props2$yAxis;
                return /*#__PURE__*/ (0, _react.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            _defineProperty(_this, "renderActivePoints", function(_ref10) {
                var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
                var result = [];
                // item is not a React Element so we don't need to resolve defaultProps.
                var key = item.props.key;
                var itemItemProps = item.item.type.defaultProps !== undefined ? _objectSpread(_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, dataKey = itemItemProps.dataKey;
                var dotProps = _objectSpread(_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, _chartUtils.getMainColorOfGraphicItem)(item.item),
                    strokeWidth: 2,
                    stroke: '#fff',
                    payload: activePoint.payload,
                    value: activePoint.value
                }, (0, _reactUtils.filterProps)(activeDot, false)), (0, _types.adaptEventHandlers)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps, "".concat(key, "-activePoint-").concat(childIndex)));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, _objectSpread(_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y
                }), "".concat(key, "-basePoint-").concat(childIndex)));
                else if (isRange) result.push(null);
                return result;
            });
            _defineProperty(_this, "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                // item is not a React Element so we don't need to resolve defaultProps
                var _item$props = item.props, points = _item$props.points, isRange = _item$props.isRange, baseLine = _item$props.baseLine;
                var itemItemProps = item.item.type.defaultProps !== undefined ? _objectSpread(_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, hide = itemItemProps.hide, activeBar = itemItemProps.activeBar, activeShape = itemItemProps.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') itemEvents = {
                    onClick: (0, _chartUtils.combineEventHandlers)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== 'axis') itemEvents = {
                    onMouseLeave: (0, _chartUtils.combineEventHandlers)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, _chartUtils.combineEventHandlers)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, _dataUtils.findEntryInArray)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, _dataUtils.findEntryInArray)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread(_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, _isNilDefault.default)(activePoint)) return [
                            graphicalItem
                        ].concat(_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
                        var elementProps = _objectSpread(_objectSpread(_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, _react.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            _defineProperty(_this, "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            _defineProperty(_this, "renderMap", {
                CartesianGrid: {
                    handler: renderAsIs,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: renderAsIs
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: renderAsIs
                },
                YAxis: {
                    handler: renderAsIs
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, _dataUtils.uniqueId)('recharts'), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, _throttleDefault.default)(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        _inherits(CategoricalChartWrapper, _Component);
        return _createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                    this.displayDefaultTooltip();
                }
            },
            {
                key: "displayDefaultTooltip",
                value: function displayDefaultTooltip() {
                    var _this$props5 = this.props, children = _this$props5.children, data = _this$props5.data, height = _this$props5.height, layout = _this$props5.layout;
                    var tooltipElem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                    // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
                    if (!tooltipElem) return;
                    var defaultIndex = tooltipElem.props.defaultIndex;
                    // Protect against runtime errors
                    if (typeof defaultIndex !== 'number' || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length - 1) return;
                    var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
                    var activePayload = getTooltipContent(this.state, data, defaultIndex, activeLabel);
                    var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
                    var dependentAxisCoord = (this.state.offset.top + height) / 2;
                    var isHorizontal = layout === 'horizontal';
                    var activeCoordinate = isHorizontal ? {
                        x: independentAxisCoord,
                        y: dependentAxisCoord
                    } : {
                        y: independentAxisCoord,
                        x: dependentAxisCoord
                    };
                    // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
                    // element knows its own Y coordinates.
                    // If there's a scatter plot, we'll want to grab that element for an interrogation.
                    var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
                        var item = _ref12.item;
                        return item.type.name === 'Scatter';
                    });
                    if (scatterPlotElement) {
                        activeCoordinate = _objectSpread(_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
                        activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
                    }
                    var nextState = {
                        activeTooltipIndex: defaultIndex,
                        isTooltipActive: true,
                        activeLabel: activeLabel,
                        activePayload: activePayload,
                        activeCoordinate: activeCoordinate
                    };
                    this.setState(nextState);
                    this.renderCursor(tooltipElem);
                    // Make sure that anyone who keyboard-only users who tab to the chart will start their
                    // cursors at defaultIndex
                    this.accessibilityManager.setIndex(defaultIndex);
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // Check to see if the Tooltip updated. If so, re-check default tooltip position
                    if (!(0, _reactUtils.isChildrenEqual)([
                        (0, _reactUtils.findChildByType)(prevProps.children, (0, _tooltip.Tooltip))
                    ], [
                        (0, _reactUtils.findChildByType)(this.props.children, (0, _tooltip.Tooltip))
                    ])) this.displayDefaultTooltip();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, _reactUtils.findChildByType)(this.props.children, (0, _tooltip.Tooltip));
                    if (tooltipItem && typeof tooltipItem.props.shared === 'boolean') {
                        var eventType = tooltipItem.props.shared ? 'axis' : 'item';
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, _domutils.getOffset)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    var toolTipData = getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
                        var xScale = (0, _dataUtils.getAnyElementOfObject)(xAxisMap).scale;
                        var yScale = (0, _dataUtils.getAnyElementOfObject)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return _objectSpread(_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        }, toolTipData);
                    }
                    if (toolTipData) return _objectSpread(_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === 'horizontal' || layout === 'vertical') {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, _dataUtils.getAnyElementOfObject)(angleAxisMap);
                        return (0, _polarUtils.inRangeOfSector)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === 'axis') {
                        if (tooltipItem.props.trigger === 'click') tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onDoubleClick: this.handleDoubleClick,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd,
                            onContextMenu: this.handleContextMenu
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, _types.adaptEventHandlers)(this.props, this.handleOuterEvent);
                    return _objectSpread(_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, _events.eventCenter).on((0, _events.SYNC_EVENT), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, _events.eventCenter).removeListener((0, _events.SYNC_EVENT), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, _reactUtils.getDisplayName)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = _slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = _slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        // graphicalItem is not a React Element so we don't need to resolve defaultProps
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemProps = item.type.defaultProps !== undefined ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
                        var itemDisplayName = (0, _reactUtils.getDisplayName)(item.type);
                        if (itemDisplayName === 'Bar') {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, _rectangle.isInRectangle)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === 'RadialBar') {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, _polarUtils.inRangeOfSector)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, _activeShapeUtils.isFunnel)(graphicalItem, activeItem) || (0, _activeShapeUtils.isPie)(graphicalItem, activeItem) || (0, _activeShapeUtils.isScatter)(graphicalItem, activeItem)) {
                            var activeIndex = (0, _activeShapeUtils.getActiveShapeIndexForTooltip)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: itemProps.data
                            });
                            var childIndex = itemProps.activeIndex === undefined ? activeIndex : itemProps.activeIndex;
                            return {
                                graphicalItem: _objectSpread(_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, _activeShapeUtils.isScatter)(graphicalItem, activeItem) ? itemProps.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this3 = this;
                    if (!(0, _reactUtils.validateWidthHeight)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = _objectWithoutProperties(_this$props6, _excluded2);
                    var attrs = (0, _reactUtils.filterProps)(others, false);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chartLayoutContext.ChartLayoutContextProvider), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _surface.Surface), _extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, _reactUtils.renderByOrder)(children, this.renderMap)));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : 'application';
                        attrs.onKeyDown = function(e) {
                            _this3.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this3.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chartLayoutContext.ChartLayoutContextProvider), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({
                        className: (0, _clsxDefault.default)('recharts-wrapper', className),
                        style: _objectSpread({
                            position: 'relative',
                            cursor: 'default',
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this3.container = node;
                        }
                    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _surface.Surface), _extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, _reactUtils.renderByOrder)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
                }
            }
        ]);
    }((0, _react.Component));
    _defineProperty(CategoricalChartWrapper, "displayName", chartName);
    // todo join specific chart propTypes
    _defineProperty(CategoricalChartWrapper, "defaultProps", _objectSpread({
        layout: 'horizontal',
        stackOffset: 'none',
        barCategoryGap: '10%',
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: 'index'
    }, defaultProps));
    _defineProperty(CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = createDefaultState(nextProps);
            return _objectSpread(_objectSpread(_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread(_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, _shallowEqual.shallowEqual)(margin, prevState.prevMargin)) {
            var _defaultState = createDefaultState(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = _objectSpread(_objectSpread({}, getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = _objectSpread(_objectSpread(_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return _objectSpread(_objectSpread(_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, _reactUtils.isChildrenEqual)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, _reactUtils.findChildByType)(children, (0, _brush.Brush));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, _isNilDefault.default)(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return _objectSpread(_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread(_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    });
    _defineProperty(CategoricalChartWrapper, "renderActiveDot", function(option, props, key) {
        var dot;
        if (/*#__PURE__*/ (0, _react.isValidElement)(option)) dot = /*#__PURE__*/ (0, _react.cloneElement)(option, props);
        else if ((0, _isFunctionDefault.default)(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), props);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
            className: "recharts-active-dot",
            key: key
        }, dot);
    });
    var CategoricalChart = /*#__PURE__*/ (0, _react.forwardRef)(function CategoricalChart(props, ref) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(CategoricalChartWrapper, _extends({}, props, {
            ref: ref
        }));
    });
    CategoricalChart.displayName = CategoricalChartWrapper.displayName;
    return CategoricalChart;
};

},{"react":"eGun2","lodash/isNil":"lYi7Z","lodash/isFunction":"2KQKo","lodash/range":"cLky5","lodash/get":"dEpuO","lodash/sortBy":"geSBv","lodash/throttle":"buA1M","clsx":"3mzHT","tiny-invariant":"4qfOO","../container/Surface":"7sKCX","../container/Layer":"gNfib","../component/Tooltip":"5PITU","../component/Legend":"hn1WY","../shape/Dot":"lScwe","../shape/Rectangle":"gLZb9","../util/ReactUtils":"dBf5D","../cartesian/Brush":"aKFkv","../util/DOMUtils":"dgkk6","../util/DataUtils":"lsl3R","../util/ChartUtils":"55u3i","../util/DetectReferenceElementsDomain":"d5iL9","../util/PolarUtils":"27snq","../util/ShallowEqual":"feNgJ","../util/Events":"2jjPe","../util/types":"5mtYY","./AccessibilityManager":"kTHq4","../util/isDomainSpecifiedByUser":"7W70y","../util/ActiveShapeUtils":"6kRg3","../component/Cursor":"eO75U","../context/chartLayoutContext":"gEXMQ","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cLky5":[function(require,module,exports,__globalThis) {
var createRange = require("53a756dadf224710");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var range = createRange();
module.exports = range;

},{"53a756dadf224710":"fZTOZ"}],"fZTOZ":[function(require,module,exports,__globalThis) {
var baseRange = require("65ab4b2744dbb12c"), isIterateeCall = require("bae707871f1dbdd9"), toFinite = require("936083133d4bce30");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = toFinite(end);
        step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
        return baseRange(start, end, step, fromRight);
    };
}
module.exports = createRange;

},{"65ab4b2744dbb12c":"9rvsI","bae707871f1dbdd9":"hCwoo","936083133d4bce30":"2RmDC"}],"9rvsI":[function(require,module,exports,__globalThis) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function baseRange(start, end, step, fromRight) {
    var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = baseRange;

},{}],"2RmDC":[function(require,module,exports,__globalThis) {
var toNumber = require("314973451be27b8");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;

},{"314973451be27b8":"5oZQP"}],"5oZQP":[function(require,module,exports,__globalThis) {
var baseTrim = require("76abf94fb06a947a"), isObject = require("8a1b9585a49708a2"), isSymbol = require("1fc5c881d45e9b3c");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"76abf94fb06a947a":"6rOz3","8a1b9585a49708a2":"cNdKD","1fc5c881d45e9b3c":"3Ftz1"}],"6rOz3":[function(require,module,exports,__globalThis) {
var trimmedEndIndex = require("ce82d7e52befa271");
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}
module.exports = baseTrim;

},{"ce82d7e52befa271":"gHNLo"}],"gHNLo":[function(require,module,exports,__globalThis) {
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = trimmedEndIndex;

},{}],"buA1M":[function(require,module,exports,__globalThis) {
var debounce = require("1708ee6a37b72fa5"), isObject = require("65faabc4a67d6469");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = throttle;

},{"1708ee6a37b72fa5":"jH0oC","65faabc4a67d6469":"cNdKD"}],"jH0oC":[function(require,module,exports,__globalThis) {
var isObject = require("d29a700023e61000"), now = require("5e0bb844a509cd1c"), toNumber = require("79616679d3693e34");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = debounce;

},{"d29a700023e61000":"cNdKD","5e0bb844a509cd1c":"4SbFy","79616679d3693e34":"5oZQP"}],"4SbFy":[function(require,module,exports,__globalThis) {
var root = require("600587bb88992b64");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return root.Date.now();
};
module.exports = now;

},{"600587bb88992b64":"g0sWx"}],"5PITU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
/**
 * @fileOverview Tooltip
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _defaultTooltipContent = require("./DefaultTooltipContent");
var _tooltipBoundingBox = require("./TooltipBoundingBox");
var _global = require("../util/Global");
var _getUniqPayload = require("../util/payload/getUniqPayload");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function defaultUniqBy(entry) {
    return entry.dataKey;
}
function renderContent(content, props) {
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(content)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, _reactDefault.default).createElement(content, props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _defaultTooltipContent.DefaultTooltipContent), props);
}
var Tooltip = /*#__PURE__*/ function(_PureComponent) {
    function Tooltip() {
        _classCallCheck(this, Tooltip);
        return _callSuper(this, Tooltip, arguments);
    }
    _inherits(Tooltip, _PureComponent);
    return _createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, _getUniqPayload.getUniqPayload)(payload.filter(function(entry) {
                    return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
                }), payloadUniqBy, defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipBoundingBox.TooltipBoundingBox), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, renderContent(content, _objectSpread(_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(Tooltip, "displayName", 'Tooltip');
_defineProperty(Tooltip, "defaultProps", {
    accessibilityLayer: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, _global.Global).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});

},{"react":"eGun2","./DefaultTooltipContent":"lJbWv","./TooltipBoundingBox":"7a4zz","../util/Global":"dWTWi","../util/payload/getUniqPayload":"5wAw7","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"lJbWv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultTooltipContent", ()=>DefaultTooltipContent);
/**
 * @fileOverview Default Tooltip Content
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sortBy = require("lodash/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../util/DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function defaultFormatter(value) {
    return Array.isArray(value) && (0, _dataUtils.isNumOrStr)(value[0]) && (0, _dataUtils.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
}
var DefaultTooltipContent = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? ' : ' : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, _sortByDefault.default)(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === 'none') return null;
                var finalItemStyle = _objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = _slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, _reactDefault.default).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, _dataUtils.isNumOrStr)(finalName) ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, _dataUtils.isNumOrStr)(finalName) ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || '')));
            });
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = _objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = _objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, _isNilDefault.default)(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, _clsxDefault.default)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, _clsxDefault.default)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, _reactDefault.default).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};

},{"react":"eGun2","lodash/sortBy":"geSBv","lodash/isNil":"lYi7Z","clsx":"3mzHT","../util/DataUtils":"lsl3R","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7a4zz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipBoundingBox", ()=>TooltipBoundingBox);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _translate = require("../util/tooltip/translate");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var EPSILON = 1;
var TooltipBoundingBox = /*#__PURE__*/ function(_PureComponent) {
    function TooltipBoundingBox() {
        var _this;
        _classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, TooltipBoundingBox, [].concat(args));
        _defineProperty(_this, "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            },
            lastBoundingBox: {
                width: -1,
                height: -1
            }
        });
        _defineProperty(_this, "handleKeyDown", function(event) {
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    _inherits(TooltipBoundingBox, _PureComponent);
    return _createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.state.lastBoundingBox.width) > EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > EPSILON) this.setState({
                        lastBoundingBox: {
                            width: box.width,
                            height: box.height
                        }
                    });
                } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) this.setState({
                    lastBoundingBox: {
                        width: -1,
                        height: -1
                    }
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('keydown', this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, _translate.getTooltipTranslate)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: this.state.lastBoundingBox,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = _objectSpread(_objectSpread({
                    transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
                }, cssProperties), {}, {
                    pointerEvents: 'none',
                    visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
                    position: 'absolute',
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, _reactDefault.default).createElement("div", {
                    tabIndex: -1,
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
}((0, _react.PureComponent));

},{"react":"eGun2","../util/tooltip/translate":"d4Lt4","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"d4Lt4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTooltipCSSClassName", ()=>getTooltipCSSClassName);
parcelHelpers.export(exports, "getTooltipTranslateXY", ()=>getTooltipTranslateXY);
parcelHelpers.export(exports, "getTransformStyle", ()=>getTransformStyle);
parcelHelpers.export(exports, "getTooltipTranslate", ()=>getTooltipTranslate);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function getTooltipCSSClassName(_ref) {
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, _clsxDefault.default)(CSS_CLASS_PREFIX, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(CSS_CLASS_PREFIX, "-right"), (0, _dataUtils.isNumber)(translateX) && coordinate && (0, _dataUtils.isNumber)(coordinate.x) && translateX >= coordinate.x), "".concat(CSS_CLASS_PREFIX, "-left"), (0, _dataUtils.isNumber)(translateX) && coordinate && (0, _dataUtils.isNumber)(coordinate.x) && translateX < coordinate.x), "".concat(CSS_CLASS_PREFIX, "-bottom"), (0, _dataUtils.isNumber)(translateY) && coordinate && (0, _dataUtils.isNumber)(coordinate.y) && translateY >= coordinate.y), "".concat(CSS_CLASS_PREFIX, "-top"), (0, _dataUtils.isNumber)(translateY) && coordinate && (0, _dataUtils.isNumber)(coordinate.y) && translateY < coordinate.y));
}
function getTooltipTranslateXY(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, _dataUtils.isNumber)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function getTransformStyle(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function getTooltipTranslate(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = getTooltipTranslateXY({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = getTooltipTranslateXY({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = getTransformStyle({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: getTooltipCSSClassName({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}

},{"clsx":"3mzHT","../DataUtils":"lsl3R","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"lScwe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dot", ()=>Dot);
/**
 * @fileOverview Dot
 */ var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var Dot = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, _clsxDefault.default)('recharts-dot', className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ _react.createElement("circle", _extends({}, (0, _reactUtils.filterProps)(props, false), (0, _types.adaptEventHandlers)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};

},{"react":"eGun2","clsx":"3mzHT","../util/types":"5mtYY","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"aKFkv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Brush", ()=>Brush);
/**
 * @fileOverview Brush
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _d3Scale = require("victory-vendor/d3-scale");
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _range = require("lodash/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _layer = require("../container/Layer");
var _text = require("../component/Text");
var _chartUtils = require("../util/ChartUtils");
var _dataUtils = require("../util/DataUtils");
var _cssPrefixUtils = require("../util/CssPrefixUtils");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, _d3Scale.scalePoint)().domain((0, _rangeDefault.default)(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var Brush = /*#__PURE__*/ function(_PureComponent) {
    function Brush(props) {
        var _this;
        _classCallCheck(this, Brush);
        _this = _callSuper(this, Brush, [
            props
        ]);
        _defineProperty(_this, "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        _defineProperty(_this, "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        _defineProperty(_this, "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        _defineProperty(_this, "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        _defineProperty(_this, "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        _defineProperty(_this, "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        _defineProperty(_this, "handleSlideDragStart", function(e) {
            var event = isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
            endX: _this.handleTravellerDragStart.bind(_this, 'endX')
        };
        _this.state = {};
        return _this;
    }
    _inherits(Brush, _PureComponent);
    return _createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, _chartUtils.getValueByDataKey)(data[index], dataKey, index);
                return (0, _isFunctionDefault.default)(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener('mouseup', this.handleDragEnd, true);
                window.addEventListener('touchend', this.handleDragEnd, true);
                window.addEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener('mouseup', this.handleDragEnd, true);
                window.removeEventListener('touchend', this.handleDragEnd, true);
                window.removeEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState(_defineProperty(_defineProperty({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === 'startX' && newScaleValue >= endX || id === 'endX' && newScaleValue <= startX) return;
                this.setState(_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, _react.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _data$startIndex, _data$endIndex, _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = _objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(this.props, false)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat((_data$startIndex = data[startIndex]) === null || _data$startIndex === void 0 ? void 0 : _data$startIndex.name, ", Max value: ").concat((_data$endIndex = data[endIndex]) === null || _data$endIndex === void 0 ? void 0 : _data$endIndex.name);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            'ArrowLeft',
                            'ArrowRight'
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === 'ArrowRight' ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: 'col-resize'
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: 'move'
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: 'none',
                    fill: stroke
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, _dataUtils.isNumber)(x) || !(0, _dataUtils.isNumber)(y) || !(0, _dataUtils.isNumber)(width) || !(0, _dataUtils.isNumber)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, _clsxDefault.default)('recharts-brush', className);
                var isPanoramic = (0, _reactDefault.default).Children.count(children) === 1;
                var style = (0, _cssPrefixUtils.generatePrefixStyle)('userSelect', 'none');
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) rectangle = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return _objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(Brush, "displayName", 'Brush');
_defineProperty(Brush, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: '#fff',
    stroke: '#666',
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});

},{"react":"eGun2","clsx":"3mzHT","victory-vendor/d3-scale":"16Gyx","lodash/isFunction":"2KQKo","lodash/range":"cLky5","../container/Layer":"gNfib","../component/Text":"6tNNj","../util/ChartUtils":"55u3i","../util/DataUtils":"lsl3R","../util/CssPrefixUtils":"eJKt2","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eJKt2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generatePrefixStyle", ()=>generatePrefixStyle);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var generatePrefixStyle = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = PREFIX_LIST.reduce(function(res, entry) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"d5iL9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detectReferenceElementsDomain", ()=>detectReferenceElementsDomain);
var _referenceDot = require("../cartesian/ReferenceDot");
var _referenceLine = require("../cartesian/ReferenceLine");
var _referenceArea = require("../cartesian/ReferenceArea");
var _ifOverflowMatches = require("./IfOverflowMatches");
var _reactUtils = require("./ReactUtils");
var _dataUtils = require("./DataUtils");
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, _reactUtils.findAllByType)(children, (0, _referenceLine.ReferenceLine));
    var dots = (0, _reactUtils.findAllByType)(children, (0, _referenceDot.ReferenceDot));
    var elements = [].concat(_toConsumableArray(lines), _toConsumableArray(dots));
    var areas = (0, _reactUtils.findAllByType)(children, (0, _referenceArea.ReferenceArea));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, _ifOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _dataUtils.isNumber)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, _ifOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _dataUtils.isNumber)(el.props[key1]) && (0, _dataUtils.isNumber)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, _dataUtils.isNumber)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};

},{"../cartesian/ReferenceDot":"es4cV","../cartesian/ReferenceLine":"bfpaV","../cartesian/ReferenceArea":"3tiU1","./IfOverflowMatches":"apOtS","./ReactUtils":"dBf5D","./DataUtils":"lsl3R","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"es4cV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReferenceDot", ()=>ReferenceDot);
/**
 * @fileOverview Reference Dot
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _dot = require("../shape/Dot");
var _label = require("../component/Label");
var _dataUtils = require("../util/DataUtils");
var _ifOverflowMatches = require("../util/IfOverflowMatches");
var _cartesianUtils = require("../util/CartesianUtils");
var _logUtils = require("../util/LogUtils");
var _reactUtils = require("../util/ReactUtils");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, _cartesianUtils.createLabeledScales)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, _ifOverflowMatches.ifOverflowMatches)(props, 'discard') && !scales.isInRange(result)) return null;
    return result;
};
var ReferenceDot = /*#__PURE__*/ function(_React$Component) {
    function ReferenceDot() {
        _classCallCheck(this, ReferenceDot);
        return _callSuper(this, ReferenceDot, arguments);
    }
    _inherits(ReferenceDot, _React$Component);
    return _createClass(ReferenceDot, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, r = _this$props.r, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                var isX = (0, _dataUtils.isNumOrStr)(x);
                var isY = (0, _dataUtils.isNumOrStr)(y);
                (0, _logUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                if (!isX || !isY) return null;
                var coordinate = getCoordinate(this.props);
                if (!coordinate) return null;
                var cx = coordinate.x, cy = coordinate.y;
                var _this$props2 = this.props, shape = _this$props2.shape, className = _this$props2.className;
                var clipPath = (0, _ifOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                var dotProps = _objectSpread(_objectSpread({
                    clipPath: clipPath
                }, (0, _reactUtils.filterProps)(this.props, true)), {}, {
                    cx: cx,
                    cy: cy
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: (0, _clsxDefault.default)('recharts-reference-dot', className)
                }, ReferenceDot.renderDot(shape, dotProps), (0, _label.Label).renderCallByParent(this.props, {
                    x: cx - r,
                    y: cy - r,
                    width: 2 * r,
                    height: 2 * r
                }));
            }
        }
    ]);
}((0, _reactDefault.default).Component);
_defineProperty(ReferenceDot, "displayName", 'ReferenceDot');
_defineProperty(ReferenceDot, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#fff',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1
});
_defineProperty(ReferenceDot, "renderDot", function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) dot = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), _extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
});

},{"react":"eGun2","lodash/isFunction":"2KQKo","clsx":"3mzHT","../container/Layer":"gNfib","../shape/Dot":"lScwe","../component/Label":"jhet4","../util/DataUtils":"lsl3R","../util/IfOverflowMatches":"apOtS","../util/CartesianUtils":"1I6yD","../util/LogUtils":"7Bf7y","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"apOtS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ifOverflowMatches", ()=>ifOverflowMatches);
var ifOverflowMatches = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = 'extendDomain';
    return ifOverflow === value;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1I6yD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatAxisMap", ()=>formatAxisMap);
parcelHelpers.export(exports, "rectWithPoints", ()=>rectWithPoints);
parcelHelpers.export(exports, "rectWithCoords", ()=>rectWithCoords);
parcelHelpers.export(exports, "ScaleHelper", ()=>ScaleHelper);
parcelHelpers.export(exports, "createLabeledScales", ()=>createLabeledScales);
/** Normalizes the angle so that 0 <= angle < 180.
 * @param {number} angle Angle in degrees.
 * @return {number} the normalized angle with a value of at least 0 and never greater or equal to 180. */ parcelHelpers.export(exports, "normalizeAngle", ()=>normalizeAngle);
parcelHelpers.export(exports, "getAngledRectangleWidth", ()=>getAngledRectangleWidth);
var _mapValues = require("lodash/mapValues");
var _mapValuesDefault = parcelHelpers.interopDefault(_mapValues);
var _every = require("lodash/every");
var _everyDefault = parcelHelpers.interopDefault(_every);
var _chartUtils = require("./ChartUtils");
var _reactUtils = require("./ReactUtils");
var _dataUtils = require("./DataUtils");
var _bar = require("../cartesian/Bar");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, _reactUtils.findChildByType)(children, (0, _bar.Bar));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort((0, _dataUtils.compareValues));
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            if (Number.isFinite(smallestDistanceBetweenValues)) {
                var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
                var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
                if (axis.padding === 'gap') calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
                if (axis.padding === 'no-gap') {
                    var gap = (0, _dataUtils.getPercentValue)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                    var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                    calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
                }
            }
        }
        if (axisType === 'xAxis') range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === 'yAxis') range = layout === 'horizontal' ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, _chartUtils.parseScale)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, _chartUtils.checkDomainOfScale)(scale);
        var ticks = (0, _chartUtils.getTicksOfScale)(scale, _objectSpread(_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === 'yAxis') {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = _objectSpread(_objectSpread(_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, _chartUtils.getBandSizeOfAxis)(finalAxis, ticks);
        if (!axis.hide && axisType === 'xAxis') steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, id, finalAxis));
    }, {});
};
var rectWithPoints = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var rectWithCoords = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return rectWithPoints({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var ScaleHelper = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        _classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    return _createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case 'start':
                        return this.scale(value);
                    case 'middle':
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case 'end':
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
}();
_defineProperty(ScaleHelper, "EPS", 1e-4);
var createLabeledScales = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, ScaleHelper.create(options[key])));
    }, {});
    return _objectSpread(_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, _mapValuesDefault.default)(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, _everyDefault.default)(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function normalizeAngle(angle) {
    return (angle % 180 + 180) % 180;
}
var getAngledRectangleWidth = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = normalizeAngle(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};

},{"lodash/mapValues":"kgQ52","lodash/every":"jMFCS","./ChartUtils":"55u3i","./ReactUtils":"dBf5D","./DataUtils":"lsl3R","../cartesian/Bar":"9EUGQ","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kgQ52":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("c9a3981baf073e4"), baseForOwn = require("47fdc1ca91865546"), baseIteratee = require("20d62285d8a234d2");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function mapValues(object, iteratee) {
    var result = {};
    iteratee = baseIteratee(iteratee, 3);
    baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = mapValues;

},{"c9a3981baf073e4":"cT7xv","47fdc1ca91865546":"dC72S","20d62285d8a234d2":"hmPIl"}],"cT7xv":[function(require,module,exports,__globalThis) {
var defineProperty = require("f333f6ec0c9c5a8d");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"f333f6ec0c9c5a8d":"9V2gM"}],"jMFCS":[function(require,module,exports,__globalThis) {
var arrayEvery = require("83787278cabd73a3"), baseEvery = require("dc754c7dd44dbd24"), baseIteratee = require("a79df1be52eb67b3"), isArray = require("71961841d60bc7b"), isIterateeCall = require("2d14119db43394bb");
/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function every(collection, predicate, guard) {
    var func = isArray(collection) ? arrayEvery : baseEvery;
    if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
    return func(collection, baseIteratee(predicate, 3));
}
module.exports = every;

},{"83787278cabd73a3":"c1X6C","dc754c7dd44dbd24":"3j42A","a79df1be52eb67b3":"hmPIl","71961841d60bc7b":"5gfYS","2d14119db43394bb":"hCwoo"}],"c1X6C":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
module.exports = arrayEvery;

},{}],"3j42A":[function(require,module,exports,__globalThis) {
var baseEach = require("68921ee6eb8226ad");
/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function baseEvery(collection, predicate) {
    var result = true;
    baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
module.exports = baseEvery;

},{"68921ee6eb8226ad":"acAx3"}],"bfpaV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEndPoints", ()=>getEndPoints);
parcelHelpers.export(exports, "ReferenceLine", ()=>ReferenceLine);
/**
 * @fileOverview Reference Line
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _some = require("lodash/some");
var _someDefault = parcelHelpers.interopDefault(_some);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _label = require("../component/Label");
var _ifOverflowMatches = require("../util/IfOverflowMatches");
var _dataUtils = require("../util/DataUtils");
var _cartesianUtils = require("../util/CartesianUtils");
var _logUtils = require("../util/LogUtils");
var _reactUtils = require("../util/ReactUtils");
var _chartLayoutContext = require("../context/chartLayoutContext");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) line = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) line = option(props);
    else line = /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var getEndPoints = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (isFixedY) {
        var yCoord = props.y;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, _ifOverflowMatches.ifOverflowMatches)(props, 'discard') && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return yAxisOrientation === 'left' ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, _ifOverflowMatches.ifOverflowMatches)(props, 'discard') && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return xAxisOrientation === 'top' ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, _ifOverflowMatches.ifOverflowMatches)(props, 'discard') && (0, _someDefault.default)(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function ReferenceLineImpl(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
    var clipPathId = (0, _chartLayoutContext.useClipPathId)();
    var xAxis = (0, _chartLayoutContext.useXAxisOrThrow)(xAxisId);
    var yAxis = (0, _chartLayoutContext.useYAxisOrThrow)(yAxisId);
    var viewBox = (0, _chartLayoutContext.useViewBox)();
    if (!clipPathId || !viewBox) return null;
    (0, _logUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, _cartesianUtils.createLabeledScales)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, _dataUtils.isNumOrStr)(fixedX);
    var isY = (0, _dataUtils.isNumOrStr)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = getEndPoints(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var _endPoints = _slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, _ifOverflowMatches.ifOverflowMatches)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = _objectSpread(_objectSpread({
        clipPath: clipPath
    }, (0, _reactUtils.filterProps)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: (0, _clsxDefault.default)('recharts-reference-line', className)
    }, renderLine(shape, lineProps), (0, _label.Label).renderCallByParent(props, (0, _cartesianUtils.rectWithCoords)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
var ReferenceLine = /*#__PURE__*/ function(_React$Component) {
    function ReferenceLine() {
        _classCallCheck(this, ReferenceLine);
        return _callSuper(this, ReferenceLine, arguments);
    }
    _inherits(ReferenceLine, _React$Component);
    return _createClass(ReferenceLine, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(ReferenceLineImpl, this.props);
            }
        }
    ]);
}((0, _reactDefault.default).Component);
_defineProperty(ReferenceLine, "displayName", 'ReferenceLine');
_defineProperty(ReferenceLine, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle'
});

},{"react":"eGun2","lodash/isFunction":"2KQKo","lodash/some":"ioR7c","clsx":"3mzHT","../container/Layer":"gNfib","../component/Label":"jhet4","../util/IfOverflowMatches":"apOtS","../util/DataUtils":"lsl3R","../util/CartesianUtils":"1I6yD","../util/LogUtils":"7Bf7y","../util/ReactUtils":"dBf5D","../context/chartLayoutContext":"gEXMQ","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ioR7c":[function(require,module,exports,__globalThis) {
var arraySome = require("4639a59eef0bf4e0"), baseIteratee = require("8e40995f5d3f128e"), baseSome = require("3fe5f1bbcdeb373c"), isArray = require("d210f6096e33d516"), isIterateeCall = require("5fa7c52098b6a2e1");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function some(collection, predicate, guard) {
    var func = isArray(collection) ? arraySome : baseSome;
    if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
    return func(collection, baseIteratee(predicate, 3));
}
module.exports = some;

},{"4639a59eef0bf4e0":"ioEgU","8e40995f5d3f128e":"hmPIl","3fe5f1bbcdeb373c":"6MRvL","d210f6096e33d516":"5gfYS","5fa7c52098b6a2e1":"hCwoo"}],"6MRvL":[function(require,module,exports,__globalThis) {
var baseEach = require("1a62664fc4e8fe88");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function baseSome(collection, predicate) {
    var result;
    baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = baseSome;

},{"1a62664fc4e8fe88":"acAx3"}],"gEXMQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XAxisContext", ()=>XAxisContext);
parcelHelpers.export(exports, "YAxisContext", ()=>YAxisContext);
parcelHelpers.export(exports, "ViewBoxContext", ()=>ViewBoxContext);
parcelHelpers.export(exports, "OffsetContext", ()=>OffsetContext);
parcelHelpers.export(exports, "ClipPathIdContext", ()=>ClipPathIdContext);
parcelHelpers.export(exports, "ChartHeightContext", ()=>ChartHeightContext);
parcelHelpers.export(exports, "ChartWidthContext", ()=>ChartWidthContext);
parcelHelpers.export(exports, "ChartLayoutContextProvider", ()=>ChartLayoutContextProvider);
parcelHelpers.export(exports, "useClipPathId", ()=>useClipPathId);
parcelHelpers.export(exports, "useXAxisOrThrow", ()=>useXAxisOrThrow);
parcelHelpers.export(exports, "useArbitraryXAxis", ()=>useArbitraryXAxis);
parcelHelpers.export(exports, "useArbitraryYAxis", ()=>useArbitraryYAxis);
parcelHelpers.export(exports, "useYAxisWithFiniteDomainOrRandom", ()=>useYAxisWithFiniteDomainOrRandom);
parcelHelpers.export(exports, "useYAxisOrThrow", ()=>useYAxisOrThrow);
parcelHelpers.export(exports, "useViewBox", ()=>useViewBox);
parcelHelpers.export(exports, "useOffset", ()=>useOffset);
parcelHelpers.export(exports, "useChartWidth", ()=>useChartWidth);
parcelHelpers.export(exports, "useChartHeight", ()=>useChartHeight);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _find = require("lodash/find");
var _findDefault = parcelHelpers.interopDefault(_find);
var _every = require("lodash/every");
var _everyDefault = parcelHelpers.interopDefault(_every);
var _calculateViewBox = require("../util/calculateViewBox");
var _dataUtils = require("../util/DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var XAxisContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var YAxisContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var ViewBoxContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var OffsetContext = /*#__PURE__*/ (0, _react.createContext)({});
var ClipPathIdContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var ChartHeightContext = /*#__PURE__*/ (0, _react.createContext)(0);
var ChartWidthContext = /*#__PURE__*/ (0, _react.createContext)(0);
var ChartLayoutContextProvider = function ChartLayoutContextProvider(props) {
    var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
    /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */ var viewBox = (0, _calculateViewBox.calculateViewBox)(offset);
    /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */ return /*#__PURE__*/ (0, _reactDefault.default).createElement(XAxisContext.Provider, {
        value: xAxisMap
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(YAxisContext.Provider, {
        value: yAxisMap
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(OffsetContext.Provider, {
        value: offset
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ViewBoxContext.Provider, {
        value: viewBox
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ClipPathIdContext.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ChartHeightContext.Provider, {
        value: height
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ChartWidthContext.Provider, {
        value: width
    }, children)))))));
};
var useClipPathId = function useClipPathId() {
    return (0, _react.useContext)(ClipPathIdContext);
};
function getKeysForDebug(object) {
    var keys = Object.keys(object);
    if (keys.length === 0) return 'There are no available ids.';
    return "Available ids are: ".concat(keys, ".");
}
var useXAxisOrThrow = function useXAxisOrThrow(xAxisId) {
    var xAxisMap = (0, _react.useContext)(XAxisContext);
    !(xAxisMap != null) && (0, _tinyInvariantDefault.default)(false);
    var xAxis = xAxisMap[xAxisId];
    !(xAxis != null) && (0, _tinyInvariantDefault.default)(false);
    return xAxis;
};
var useArbitraryXAxis = function useArbitraryXAxis() {
    var xAxisMap = (0, _react.useContext)(XAxisContext);
    return (0, _dataUtils.getAnyElementOfObject)(xAxisMap);
};
var useArbitraryYAxis = function useArbitraryYAxis() {
    var yAxisMap = (0, _react.useContext)(YAxisContext);
    return (0, _dataUtils.getAnyElementOfObject)(yAxisMap);
};
var useYAxisWithFiniteDomainOrRandom = function useYAxisWithFiniteDomainOrRandom() {
    var yAxisMap = (0, _react.useContext)(YAxisContext);
    var yAxisWithFiniteDomain = (0, _findDefault.default)(yAxisMap, function(axis) {
        return (0, _everyDefault.default)(axis.domain, Number.isFinite);
    });
    return yAxisWithFiniteDomain || (0, _dataUtils.getAnyElementOfObject)(yAxisMap);
};
var useYAxisOrThrow = function useYAxisOrThrow(yAxisId) {
    var yAxisMap = (0, _react.useContext)(YAxisContext);
    !(yAxisMap != null) && (0, _tinyInvariantDefault.default)(false);
    var yAxis = yAxisMap[yAxisId];
    !(yAxis != null) && (0, _tinyInvariantDefault.default)(false);
    return yAxis;
};
var useViewBox = function useViewBox() {
    var viewBox = (0, _react.useContext)(ViewBoxContext);
    return viewBox;
};
var useOffset = function useOffset() {
    return (0, _react.useContext)(OffsetContext);
};
var useChartWidth = function useChartWidth() {
    return (0, _react.useContext)(ChartWidthContext);
};
var useChartHeight = function useChartHeight() {
    return (0, _react.useContext)(ChartHeightContext);
};

},{"react":"eGun2","tiny-invariant":"4qfOO","lodash/find":"iOEsL","lodash/every":"jMFCS","../util/calculateViewBox":"2X2cV","../util/DataUtils":"lsl3R","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"iOEsL":[function(require,module,exports,__globalThis) {
var createFind = require("8ca27d74f4311a8d"), findIndex = require("7c431d904dd565e7");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var find = createFind(findIndex);
module.exports = find;

},{"8ca27d74f4311a8d":"3mn2l","7c431d904dd565e7":"bFJ0Y"}],"3mn2l":[function(require,module,exports,__globalThis) {
var baseIteratee = require("b94c3b5779689b73"), isArrayLike = require("6e25a1556fce2b9f"), keys = require("5439444e3902ac5c");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
            var iteratee = baseIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = createFind;

},{"b94c3b5779689b73":"hmPIl","6e25a1556fce2b9f":"fs9yO","5439444e3902ac5c":"ftmUn"}],"bFJ0Y":[function(require,module,exports,__globalThis) {
var baseFindIndex = require("76b826fe2c0c7c5b"), baseIteratee = require("ff31fc49c7404cc"), toInteger = require("9255741038ab6a3f");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : toInteger(fromIndex);
    if (index < 0) index = nativeMax(length + index, 0);
    return baseFindIndex(array, baseIteratee(predicate, 3), index);
}
module.exports = findIndex;

},{"76b826fe2c0c7c5b":"dtc9v","ff31fc49c7404cc":"hmPIl","9255741038ab6a3f":"gCNoL"}],"gCNoL":[function(require,module,exports,__globalThis) {
var toFinite = require("a6f4ba1f5dda0a54");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = toInteger;

},{"a6f4ba1f5dda0a54":"2RmDC"}],"2X2cV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateViewBox", ()=>calculateViewBox);
var _memoize = require("lodash/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var calculateViewBox = (0, _memoizeDefault.default)(function(offset) {
    return {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
}, function(offset) {
    return [
        'l',
        offset.left,
        't',
        offset.top,
        'w',
        offset.width,
        'h',
        offset.height
    ].join('');
});

},{"lodash/memoize":"emt2q","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3tiU1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReferenceArea", ()=>ReferenceArea);
/**
 * @fileOverview Reference Line
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _label = require("../component/Label");
var _cartesianUtils = require("../util/CartesianUtils");
var _ifOverflowMatches = require("../util/IfOverflowMatches");
var _dataUtils = require("../util/DataUtils");
var _logUtils = require("../util/LogUtils");
var _rectangle = require("../shape/Rectangle");
var _reactUtils = require("../util/ReactUtils");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, _cartesianUtils.createLabeledScales)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: 'start'
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: 'start'
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: 'end'
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: 'end'
        }) : scales.y.rangeMax
    };
    if ((0, _ifOverflowMatches.ifOverflowMatches)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, _cartesianUtils.rectWithPoints)(p1, p2);
};
var ReferenceArea = /*#__PURE__*/ function(_React$Component) {
    function ReferenceArea() {
        _classCallCheck(this, ReferenceArea);
        return _callSuper(this, ReferenceArea, arguments);
    }
    _inherits(ReferenceArea, _React$Component);
    return _createClass(ReferenceArea, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x1 = _this$props.x1, x2 = _this$props.x2, y1 = _this$props.y1, y2 = _this$props.y2, className = _this$props.className, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                (0, _logUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                var hasX1 = (0, _dataUtils.isNumOrStr)(x1);
                var hasX2 = (0, _dataUtils.isNumOrStr)(x2);
                var hasY1 = (0, _dataUtils.isNumOrStr)(y1);
                var hasY2 = (0, _dataUtils.isNumOrStr)(y2);
                var shape = this.props.shape;
                if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
                var rect = getRect(hasX1, hasX2, hasY1, hasY2, this.props);
                if (!rect && !shape) return null;
                var clipPath = (0, _ifOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: (0, _clsxDefault.default)('recharts-reference-area', className)
                }, ReferenceArea.renderRect(shape, _objectSpread(_objectSpread({
                    clipPath: clipPath
                }, (0, _reactUtils.filterProps)(this.props, true)), rect)), (0, _label.Label).renderCallByParent(this.props, rect));
            }
        }
    ]);
}((0, _reactDefault.default).Component);
_defineProperty(ReferenceArea, "displayName", 'ReferenceArea');
_defineProperty(ReferenceArea, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#ccc',
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1
});
_defineProperty(ReferenceArea, "renderRect", function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) rect = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rectangle.Rectangle), _extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
});

},{"react":"eGun2","lodash/isFunction":"2KQKo","clsx":"3mzHT","../container/Layer":"gNfib","../component/Label":"jhet4","../util/CartesianUtils":"1I6yD","../util/IfOverflowMatches":"apOtS","../util/DataUtils":"lsl3R","../util/LogUtils":"7Bf7y","../shape/Rectangle":"gLZb9","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2jjPe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventCenter", ()=>eventCenter);
parcelHelpers.export(exports, "SYNC_EVENT", ()=>SYNC_EVENT);
var _eventemitter3 = require("eventemitter3");
var _eventemitter3Default = parcelHelpers.interopDefault(_eventemitter3);
var eventCenter = new (0, _eventemitter3Default.default)();
var SYNC_EVENT = 'recharts.syncMouseEvents';

},{"eventemitter3":"eXdIU","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eXdIU":[function(require,module,exports,__globalThis) {
'use strict';
var has = Object.prototype.hasOwnProperty, prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) clearEvent(this, evt);
    } else {
        this._events = new Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;
//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;
module.exports = EventEmitter;

},{}],"kTHq4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccessibilityManager", ()=>AccessibilityManager);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var AccessibilityManager = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        _classCallCheck(this, AccessibilityManager);
        _defineProperty(this, "activeIndex", 0);
        _defineProperty(this, "coordinateList", []);
        _defineProperty(this, "layout", 'horizontal');
    }
    return _createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref2;
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case 'ArrowRight':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case 'ArrowLeft':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "setIndex",
            value: function setIndex(newIndex) {
                this.activeIndex = newIndex;
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== 'horizontal') return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7W70y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Takes a domain and user props to determine whether he provided the domain via props or if we need to calculate it.
 * @param   {AxisDomain}  domain              The potential domain from props
 * @param   {Boolean}     allowDataOverflow   from props
 * @param   {String}      axisType            from props
 * @returns {Boolean}                         `true` if domain is specified by user
 */ parcelHelpers.export(exports, "isDomainSpecifiedByUser", ()=>isDomainSpecifiedByUser);
var _dataUtils = require("./DataUtils");
function isDomainSpecifiedByUser(domain, allowDataOverflow, axisType) {
    if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, _dataUtils.isNumber)(domainStart) && (0, _dataUtils.isNumber)(domainEnd)) return true;
    }
    return false;
}

},{"./DataUtils":"lsl3R","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eO75U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/*
 * Cursor is the background, or a highlight,
 * that shows when user mouses over or activates
 * an area.
 *
 * It usually shows together with a tooltip
 * to emphasise which part of the chart does the tooltip refer to.
 */ parcelHelpers.export(exports, "Cursor", ()=>Cursor);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _curve = require("../shape/Curve");
var _cross = require("../shape/Cross");
var _getCursorRectangle = require("../util/cursor/getCursorRectangle");
var _rectangle = require("../shape/Rectangle");
var _getRadialCursorPoints = require("../util/cursor/getRadialCursorPoints");
var _sector = require("../shape/Sector");
var _getCursorPoints = require("../util/cursor/getCursorPoints");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function Cursor(props) {
    var _element$props$cursor, _defaultProps;
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    var elementPropsCursor = (_element$props$cursor = element.props.cursor) !== null && _element$props$cursor !== void 0 ? _element$props$cursor : (_defaultProps = element.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps.cursor;
    if (!element || !elementPropsCursor || !isActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps;
    var cursorComp = (0, _curve.Curve);
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, _cross.Cross);
    } else if (chartName === 'BarChart') {
        restProps = (0, _getCursorRectangle.getCursorRectangle)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, _rectangle.Rectangle);
    } else if (layout === 'radial') {
        var _getRadialCursorPoint = (0, _getRadialCursorPoints.getRadialCursorPoints)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, _sector.Sector);
    } else {
        restProps = {
            points: (0, _getCursorPoints.getCursorPoints)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, _curve.Curve);
    }
    var cursorProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, _reactUtils.filterProps)(elementPropsCursor, false)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, _clsxDefault.default)('recharts-tooltip-cursor', elementPropsCursor.className)
    });
    return /*#__PURE__*/ (0, _react.isValidElement)(elementPropsCursor) ? /*#__PURE__*/ (0, _react.cloneElement)(elementPropsCursor, cursorProps) : /*#__PURE__*/ (0, _react.createElement)(cursorComp, cursorProps);
}

},{"react":"eGun2","clsx":"3mzHT","../shape/Curve":"3D54B","../shape/Cross":"6ZY1y","../util/cursor/getCursorRectangle":"fV60N","../shape/Rectangle":"gLZb9","../util/cursor/getRadialCursorPoints":"gGorx","../shape/Sector":"dCpDt","../util/cursor/getCursorPoints":"4voPr","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3D54B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPath", ()=>getPath);
parcelHelpers.export(exports, "Curve", ()=>Curve);
/**
 * @fileOverview Curve
 */ var _react = require("react");
var _d3Shape = require("victory-vendor/d3-shape");
var _upperFirst = require("lodash/upperFirst");
var _upperFirstDefault = parcelHelpers.interopDefault(_upperFirst);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
var _dataUtils = require("../util/DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var CURVE_FACTORIES = {
    curveBasisClosed: (0, _d3Shape.curveBasisClosed),
    curveBasisOpen: (0, _d3Shape.curveBasisOpen),
    curveBasis: (0, _d3Shape.curveBasis),
    curveBumpX: (0, _d3Shape.curveBumpX),
    curveBumpY: (0, _d3Shape.curveBumpY),
    curveLinearClosed: (0, _d3Shape.curveLinearClosed),
    curveLinear: (0, _d3Shape.curveLinear),
    curveMonotoneX: (0, _d3Shape.curveMonotoneX),
    curveMonotoneY: (0, _d3Shape.curveMonotoneY),
    curveNatural: (0, _d3Shape.curveNatural),
    curveStep: (0, _d3Shape.curveStep),
    curveStepAfter: (0, _d3Shape.curveStepAfter),
    curveStepBefore: (0, _d3Shape.curveStepBefore)
};
var defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var getX = function getX(p) {
    return p.x;
};
var getY = function getY(p) {
    return p.y;
};
var getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, _isFunctionDefault.default)(type)) return type;
    var name = "curve".concat((0, _upperFirstDefault.default)(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return CURVE_FACTORIES[name] || (0, _d3Shape.curveLinear);
};
var getPath = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'linear' : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return _objectSpread(_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === 'vertical') lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined(defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === 'vertical' && (0, _dataUtils.isNumber)(baseLine)) lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
    else if ((0, _dataUtils.isNumber)(baseLine)) lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
    else lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
    lineFunction.defined(defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var Curve = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? getPath(props) : path;
    return /*#__PURE__*/ _react.createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, false), (0, _types.adaptEventHandlers)(props), {
        className: (0, _clsxDefault.default)('recharts-curve', className),
        d: realPath,
        ref: pathRef
    }));
};

},{"react":"eGun2","victory-vendor/d3-shape":"jODwB","lodash/upperFirst":"eESst","lodash/isFunction":"2KQKo","clsx":"3mzHT","../util/types":"5mtYY","../util/ReactUtils":"dBf5D","../util/DataUtils":"lsl3R","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6ZY1y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cross", ()=>Cross);
/**
 * @fileOverview Cross
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../util/DataUtils");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var Cross = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    var props = _objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, _dataUtils.isNumber)(x) || !(0, _dataUtils.isNumber)(y) || !(0, _dataUtils.isNumber)(width) || !(0, _dataUtils.isNumber)(height) || !(0, _dataUtils.isNumber)(top) || !(0, _dataUtils.isNumber)(left)) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
        className: (0, _clsxDefault.default)('recharts-cross', className),
        d: getPath(x, y, width, height, top, left)
    }));
};

},{"react":"eGun2","clsx":"3mzHT","../util/DataUtils":"lsl3R","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fV60N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCursorRectangle", ()=>getCursorRectangle);
function getCursorRectangle(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gGorx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Only applicable for radial layouts
 * @param {Object} activeCoordinate ChartCoordinate
 * @returns {Object} RadialCursorPoints
 */ parcelHelpers.export(exports, "getRadialCursorPoints", ()=>getRadialCursorPoints);
var _polarUtils = require("../PolarUtils");
function getRadialCursorPoints(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, startAngle);
    var endPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}

},{"../PolarUtils":"27snq","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4voPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCursorPoints", ()=>getCursorPoints);
var _polarUtils = require("../PolarUtils");
var _getRadialCursorPoints = require("./getRadialCursorPoints");
function getCursorPoints(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === 'horizontal') {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === 'vertical') {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === 'centric') {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, angle);
            var outerPoint = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, _getRadialCursorPoints.getRadialCursorPoints)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}

},{"../PolarUtils":"27snq","./getRadialCursorPoints":"gGorx","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4nBWG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XAxis", ()=>XAxis);
/**
 * @fileOverview X Axis
 */ var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _chartLayoutContext = require("../context/chartLayoutContext");
var _cartesianAxis = require("./CartesianAxis");
var _chartUtils = require("../util/ChartUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/** Define of XAxis props */ function XAxisImpl(_ref) {
    var xAxisId = _ref.xAxisId;
    var width = (0, _chartLayoutContext.useChartWidth)();
    var height = (0, _chartLayoutContext.useChartHeight)();
    var axisOptions = (0, _chartLayoutContext.useXAxisOrThrow)(xAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    _react.createElement((0, _cartesianAxis.CartesianAxis), _extends({}, axisOptions, {
        className: (0, _clsxDefault.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, _chartUtils.getTicksOfAxis)(axis, true);
        }
    })));
}
var XAxis = /*#__PURE__*/ function(_React$Component) {
    function XAxis() {
        _classCallCheck(this, XAxis);
        return _callSuper(this, XAxis, arguments);
    }
    _inherits(XAxis, _React$Component);
    return _createClass(XAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ _react.createElement(XAxisImpl, this.props);
            }
        }
    ]);
}(_react.Component);
_defineProperty(XAxis, "displayName", 'XAxis');
_defineProperty(XAxis, "defaultProps", {
    allowDecimals: true,
    hide: false,
    orientation: 'bottom',
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: 'category',
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false,
    allowDuplicatedCategory: true
});

},{"react":"eGun2","clsx":"3mzHT","../context/chartLayoutContext":"gEXMQ","./CartesianAxis":"2ZoIX","../util/ChartUtils":"55u3i","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2ZoIX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartesianAxis", ()=>CartesianAxis);
/**
 * @fileOverview Cartesian Axis
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _shallowEqual = require("../util/ShallowEqual");
var _layer = require("../container/Layer");
var _text = require("../component/Text");
var _label = require("../component/Label");
var _dataUtils = require("../util/DataUtils");
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
var _getTicks = require("./getTicks");
var _excluded = [
    "viewBox"
], _excluded2 = [
    "viewBox"
], _excluded3 = [
    "ticks"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var CartesianAxis = /*#__PURE__*/ function(_Component) {
    function CartesianAxis(props) {
        var _this;
        _classCallCheck(this, CartesianAxis);
        _this = _callSuper(this, CartesianAxis, [
            props
        ]);
        _this.state = {
            fontSize: '',
            letterSpacing: ''
        };
        return _this;
    }
    _inherits(CartesianAxis, _Component);
    return _createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = _objectWithoutProperties(_ref, _excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = _objectWithoutProperties(_this$props, _excluded2);
                return !(0, _shallowEqual.shallowEqual)(viewBox, viewBoxOld) || !(0, _shallowEqual.shallowEqual)(restProps, restPropsOld) || !(0, _shallowEqual.shallowEqual)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, _dataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case 'top':
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case 'left':
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case 'right':
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = mirror ? 'start' : 'end';
                        break;
                    case 'right':
                        textAnchor = mirror ? 'end' : 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = 'end';
                switch(orientation){
                    case 'left':
                    case 'right':
                        verticalAnchor = 'middle';
                        break;
                    case 'top':
                        verticalAnchor = mirror ? 'start' : 'end';
                        break;
                    default:
                        verticalAnchor = mirror ? 'end' : 'start';
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = _objectSpread(_objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(this.props, false)), (0, _reactUtils.filterProps)(axisLine, false)), {}, {
                    fill: 'none'
                });
                if (orientation === 'top' || orientation === 'bottom') {
                    var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
                    props = _objectSpread(_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
                    props = _objectSpread(_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, props, {
                    className: (0, _clsxDefault.default)('recharts-cartesian-axis-line', (0, _getDefault.default)(axisLine, 'className'))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, _getTicks.getTicks)(_objectSpread(_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, _reactUtils.filterProps)(this.props, false);
                var customTickProps = (0, _reactUtils.filterProps)(tick, false);
                var tickLineProps = _objectSpread(_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, _reactUtils.filterProps)(tickLine, false));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, _types.adaptEventsOfChild)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, tickLineProps, lineCoord, {
                        className: (0, _clsxDefault.default)('recharts-cartesian-axis-tick-line', (0, _getDefault.default)(tickLine, 'className'))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, _isFunctionDefault.default)(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = _objectWithoutProperties(_this$props8, _excluded3);
                var finalTicks = ticks;
                if ((0, _isFunctionDefault.default)(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: (0, _clsxDefault.default)('recharts-cartesian-axis', className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, _label.Label).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                var combinedClassName = (0, _clsxDefault.default)(props.className, 'recharts-cartesian-axis-tick-value');
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) tickItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, _objectSpread(_objectSpread({}, props), {}, {
                    className: combinedClassName
                }));
                else if ((0, _isFunctionDefault.default)(option)) tickItem = option(_objectSpread(_objectSpread({}, props), {}, {
                    className: combinedClassName
                }));
                else tickItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, _react.Component));
_defineProperty(CartesianAxis, "displayName", 'CartesianAxis');
_defineProperty(CartesianAxis, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd'
});

},{"react":"eGun2","lodash/isFunction":"2KQKo","lodash/get":"dEpuO","clsx":"3mzHT","../util/ShallowEqual":"feNgJ","../container/Layer":"gNfib","../component/Text":"6tNNj","../component/Label":"jhet4","../util/DataUtils":"lsl3R","../util/types":"5mtYY","../util/ReactUtils":"dBf5D","./getTicks":"cp4u6","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cp4u6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTicks", ()=>getTicks);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _dataUtils = require("../util/DataUtils");
var _domutils = require("../util/DOMUtils");
var _global = require("../util/Global");
var _tickUtils = require("../util/TickUtils");
var _getEquidistantTicks = require("./getEquidistantTicks");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, _tickUtils.isVisible)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = _objectSpread(_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = _objectSpread(_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, _tickUtils.isVisible)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = _objectSpread(_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, _tickUtils.isVisible)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = _objectSpread(_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function getTicks(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, _dataUtils.isNumber)(interval) || (0, _global.Global).isSsr) return (0, _tickUtils.getNumberIntervalTicks)(ticks, typeof interval === 'number' && (0, _dataUtils.isNumber)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, _domutils.getStringSize)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, _isFunctionDefault.default)(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, _tickUtils.getAngledTickWidth)((0, _domutils.getStringSize)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, _domutils.getStringSize)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, _dataUtils.mathSign)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, _tickUtils.getTickBoundaries)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, _getEquidistantTicks.getEquidistantTicks)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}

},{"lodash/isFunction":"2KQKo","../util/DataUtils":"lsl3R","../util/DOMUtils":"dgkk6","../util/Global":"dWTWi","../util/TickUtils":"6eZ5Y","./getEquidistantTicks":"f4cO9","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6eZ5Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAngledTickWidth", ()=>getAngledTickWidth);
parcelHelpers.export(exports, "getTickBoundaries", ()=>getTickBoundaries);
parcelHelpers.export(exports, "isVisible", ()=>isVisible);
parcelHelpers.export(exports, "getNumberIntervalTicks", ()=>getNumberIntervalTicks);
var _cartesianUtils = require("./CartesianUtils");
var _getEveryNthWithCondition = require("./getEveryNthWithCondition");
function getAngledTickWidth(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, _cartesianUtils.getAngledRectangleWidth)(size, angle);
}
function getTickBoundaries(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function isVisible(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function getNumberIntervalTicks(ticks, interval) {
    return (0, _getEveryNthWithCondition.getEveryNthWithCondition)(ticks, interval + 1);
}

},{"./CartesianUtils":"1I6yD","./getEveryNthWithCondition":"3yulS","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3yulS":[function(require,module,exports,__globalThis) {
/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEveryNthWithCondition", ()=>getEveryNthWithCondition);
function getEveryNthWithCondition(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"f4cO9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEquidistantTicks", ()=>getEquidistantTicks);
var _tickUtils = require("../util/TickUtils");
var _getEveryNthWithCondition = require("../util/getEveryNthWithCondition");
function getEquidistantTicks(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, _getEveryNthWithCondition.getEveryNthWithCondition)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, _tickUtils.isVisible)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}

},{"../util/TickUtils":"6eZ5Y","../util/getEveryNthWithCondition":"3yulS","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"NHcEZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YAxis", ()=>YAxis);
/**
 * @fileOverview Y Axis
 */ var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _chartLayoutContext = require("../context/chartLayoutContext");
var _cartesianAxis = require("./CartesianAxis");
var _chartUtils = require("../util/ChartUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var YAxisImpl = function YAxisImpl(_ref) {
    var yAxisId = _ref.yAxisId;
    var width = (0, _chartLayoutContext.useChartWidth)();
    var height = (0, _chartLayoutContext.useChartHeight)();
    var axisOptions = (0, _chartLayoutContext.useYAxisOrThrow)(yAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    _react.createElement((0, _cartesianAxis.CartesianAxis), _extends({}, axisOptions, {
        className: (0, _clsxDefault.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, _chartUtils.getTicksOfAxis)(axis, true);
        }
    })));
};
var YAxis = /*#__PURE__*/ function(_React$Component) {
    function YAxis() {
        _classCallCheck(this, YAxis);
        return _callSuper(this, YAxis, arguments);
    }
    _inherits(YAxis, _React$Component);
    return _createClass(YAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ _react.createElement(YAxisImpl, this.props);
            }
        }
    ]);
}(_react.Component);
_defineProperty(YAxis, "displayName", 'YAxis');
_defineProperty(YAxis, "defaultProps", {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: 'left',
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: 'number',
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false
});

},{"react":"eGun2","clsx":"3mzHT","../context/chartLayoutContext":"gEXMQ","./CartesianAxis":"2ZoIX","../util/ChartUtils":"55u3i","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8zC4Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartesianGrid", ()=>CartesianGrid);
/**
 * @fileOverview Cartesian Grid
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _logUtils = require("../util/LogUtils");
var _dataUtils = require("../util/DataUtils");
var _reactUtils = require("../util/ReactUtils");
var _chartUtils = require("../util/ChartUtils");
var _getTicks = require("./getTicks");
var _cartesianAxis = require("./CartesianAxis");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], _excluded2 = [
    "offset"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The <CartesianGrid horizontal
 */ var Background = function Background(props) {
    var fill = props.fill;
    if (!fill || fill === 'none') return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, ry = props.ry;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function renderLineItem(option, props) {
    var lineItem;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) lineItem = option(props);
    else {
        var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = _objectWithoutProperties(props, _excluded);
        var _filterProps = (0, _reactUtils.filterProps)(others, false), __ = _filterProps.offset, restOfFilteredProps = _objectWithoutProperties(_filterProps, _excluded2);
        lineItem = /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var items = horizontalPoints.map(function(entry, i) {
        var lineItemProps = _objectSpread(_objectSpread({}, props), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return renderLineItem(horizontal, lineItemProps);
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var items = verticalPoints.map(function(entry, i) {
        var lineItemProps = _objectSpread(_objectSpread({}, props), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return renderLineItem(vertical, lineItemProps);
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length) return null;
    // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
    var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
        return Math.round(e + y - y);
    }).sort(function(a, b) {
        return a - b;
    });
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map(function(entry, i) {
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
        return Math.round(e + x - x);
    }).sort(function(a, b) {
        return a - b;
    });
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map(function(entry, i) {
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
    var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset = _ref.offset;
    return (0, _chartUtils.getCoordinatesOfGrid)((0, _getTicks.getTicks)(_objectSpread(_objectSpread(_objectSpread({}, (0, _cartesianAxis.CartesianAxis).defaultProps), xAxis), {}, {
        ticks: (0, _chartUtils.getTicksOfAxis)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
    var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset = _ref2.offset;
    return (0, _chartUtils.getCoordinatesOfGrid)((0, _getTicks.getTicks)(_objectSpread(_objectSpread(_objectSpread({}, (0, _cartesianAxis.CartesianAxis).defaultProps), yAxis), {}, {
        ticks: (0, _chartUtils.getTicksOfAxis)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};
function CartesianGrid(props) {
    var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
    var chartWidth = (0, _chartLayoutContext.useChartWidth)();
    var chartHeight = (0, _chartLayoutContext.useChartHeight)();
    var offset = (0, _chartLayoutContext.useOffset)();
    var propsIncludingDefaults = _objectSpread(_objectSpread({}, props), {}, {
        stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : defaultProps.stroke,
        fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : defaultProps.fill,
        horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : defaultProps.horizontal,
        horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : defaultProps.horizontalFill,
        vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : defaultProps.vertical,
        verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : defaultProps.verticalFill,
        x: (0, _dataUtils.isNumber)(props.x) ? props.x : offset.left,
        y: (0, _dataUtils.isNumber)(props.y) ? props.y : offset.top,
        width: (0, _dataUtils.isNumber)(props.width) ? props.width : offset.width,
        height: (0, _dataUtils.isNumber)(props.height) ? props.height : offset.height
    });
    var x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var xAxis = (0, _chartLayoutContext.useArbitraryXAxis)();
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var yAxis = (0, _chartLayoutContext.useYAxisWithFiniteDomainOrRandom)();
    if (!(0, _dataUtils.isNumber)(width) || width <= 0 || !(0, _dataUtils.isNumber)(height) || height <= 0 || !(0, _dataUtils.isNumber)(x) || x !== +x || !(0, _dataUtils.isNumber)(y) || y !== +y) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && (0, _isFunctionDefault.default)(horizontalCoordinatesGenerator)) {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? _objectSpread(_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, _logUtils.warn)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(_typeof(generatorResult), "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && (0, _isFunctionDefault.default)(verticalCoordinatesGenerator)) {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? _objectSpread(_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, _logUtils.warn)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(_typeof(_generatorResult), "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(HorizontalGridLines, _extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement(VerticalGridLines, _extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement(HorizontalStripes, _extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement(VerticalStripes, _extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })));
}
CartesianGrid.displayName = 'CartesianGrid';

},{"react":"eGun2","lodash/isFunction":"2KQKo","../util/LogUtils":"7Bf7y","../util/DataUtils":"lsl3R","../util/ReactUtils":"dBf5D","../util/ChartUtils":"55u3i","./getTicks":"cp4u6","./CartesianAxis":"2ZoIX","../context/chartLayoutContext":"gEXMQ","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8qrDG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChartContainer", ()=>ChartContainer);
parcelHelpers.export(exports, "ChartTooltip", ()=>ChartTooltip);
parcelHelpers.export(exports, "ChartTooltipContent", ()=>ChartTooltipContent);
parcelHelpers.export(exports, "ChartLegend", ()=>ChartLegend);
parcelHelpers.export(exports, "ChartLegendContent", ()=>ChartLegendContent);
parcelHelpers.export(exports, "ChartStyle", ()=>ChartStyle);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _recharts = require("recharts");
var _utils = require("@/client/lib/utils");
// Format: { THEME_NAME: CSS_SELECTOR }
const THEMES = {
    light: "",
    dark: ".dark"
};
const ChartContext = /*#__PURE__*/ _react.createContext(null);
function useChart() {
    const context = _react.useContext(ChartContext);
    if (!context) throw new Error("useChart must be used within a <ChartContainer />");
    return context;
}
const ChartContainer = /*#__PURE__*/ _react.forwardRef(({ id, className, children, config, ...props }, ref)=>{
    const uniqueId = _react.useId();
    const chartId = `chart-${id || uniqueId.replace(/:/g, "")}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChartContext.Provider, {
        value: {
            config
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            "data-chart": chartId,
            ref: ref,
            className: (0, _utils.cn)("flex aspect-video justify-center text-xs [&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-none [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-sector]:outline-none [&_.recharts-surface]:outline-none", className),
            ...props,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChartStyle, {
                    id: chartId,
                    config: config
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_recharts.ResponsiveContainer, {
                    children: children
                })
            ]
        })
    });
});
ChartContainer.displayName = "Chart";
const ChartStyle = ({ id, config })=>{
    const colorConfig = Object.entries(config).filter(([, config])=>config.theme || config.color);
    if (!colorConfig.length) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("style", {
        dangerouslySetInnerHTML: {
            __html: Object.entries(THEMES).map(([theme, prefix])=>`
${prefix} [data-chart=${id}] {
${colorConfig.map(([key, itemConfig])=>{
                    const color = itemConfig.theme?.[theme] || itemConfig.color;
                    return color ? `  --color-${key}: ${color};` : null;
                }).join("\n")}
}
`).join("\n")
        }
    });
};
const ChartTooltip = _recharts.Tooltip;
const ChartTooltipContent = /*#__PURE__*/ _react.forwardRef(({ active, payload, className, indicator = "dot", hideLabel = false, hideIndicator = false, label, labelFormatter, labelClassName, formatter, color, nameKey, labelKey }, ref)=>{
    const { config } = useChart();
    const tooltipLabel = _react.useMemo(()=>{
        if (hideLabel || !payload?.length) return null;
        const [item] = payload;
        const key = `${labelKey || item?.dataKey || item?.name || "value"}`;
        const itemConfig = getPayloadConfigFromPayload(config, item, key);
        const value = !labelKey && typeof label === "string" ? config[label]?.label || label : itemConfig?.label;
        if (labelFormatter) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: (0, _utils.cn)("font-medium", labelClassName),
            children: labelFormatter(value, payload)
        });
        if (!value) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: (0, _utils.cn)("font-medium", labelClassName),
            children: value
        });
    }, [
        label,
        labelFormatter,
        payload,
        hideLabel,
        labelClassName,
        config,
        labelKey
    ]);
    if (!active || !payload?.length) return null;
    const nestLabel = payload.length === 1 && indicator !== "dot";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: ref,
        className: (0, _utils.cn)("grid min-w-[8rem] items-start gap-1.5 rounded-lg border border-border/50 bg-background px-2.5 py-1.5 text-xs shadow-xl", className),
        children: [
            !nestLabel ? tooltipLabel : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "grid gap-1.5",
                children: payload.filter((item)=>item.type !== "none").map((item, index)=>{
                    const key = `${nameKey || item.name || item.dataKey || "value"}`;
                    const itemConfig = getPayloadConfigFromPayload(config, item, key);
                    const indicatorColor = color || item.payload.fill || item.color;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _utils.cn)("flex w-full flex-wrap items-stretch gap-2 [&>svg]:h-2.5 [&>svg]:w-2.5 [&>svg]:text-muted-foreground", indicator === "dot" && "items-center"),
                        children: formatter && item?.value !== undefined && item.name ? formatter(item.value, item.name, item, index, item.payload) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                itemConfig?.icon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(itemConfig.icon, {}) : !hideIndicator && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: (0, _utils.cn)("shrink-0 rounded-[2px] border-[--color-border] bg-[--color-bg]", {
                                        "h-2.5 w-2.5": indicator === "dot",
                                        "w-1": indicator === "line",
                                        "w-0 border-[1.5px] border-dashed bg-transparent": indicator === "dashed",
                                        "my-0.5": nestLabel && indicator === "dashed"
                                    }),
                                    style: {
                                        "--color-bg": indicatorColor,
                                        "--color-border": indicatorColor
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: (0, _utils.cn)("flex flex-1 justify-between leading-none", nestLabel ? "items-end" : "items-center"),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "grid gap-1.5",
                                            children: [
                                                nestLabel ? tooltipLabel : null,
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "text-muted-foreground",
                                                    children: itemConfig?.label || item.name
                                                })
                                            ]
                                        }),
                                        item.value && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-mono font-medium tabular-nums text-foreground",
                                            children: item.value.toLocaleString()
                                        })
                                    ]
                                })
                            ]
                        })
                    }, item.dataKey);
                })
            })
        ]
    });
});
ChartTooltipContent.displayName = "ChartTooltip";
const ChartLegend = _recharts.Legend;
const ChartLegendContent = /*#__PURE__*/ _react.forwardRef(({ className, hideIcon = false, payload, verticalAlign = "bottom", nameKey }, ref)=>{
    const { config } = useChart();
    if (!payload?.length) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        className: (0, _utils.cn)("flex items-center justify-center gap-4", verticalAlign === "top" ? "pb-3" : "pt-3", className),
        children: payload.filter((item)=>item.type !== "none").map((item)=>{
            const key = `${nameKey || item.dataKey || "value"}`;
            const itemConfig = getPayloadConfigFromPayload(config, item, key);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _utils.cn)("flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3 [&>svg]:text-muted-foreground"),
                children: [
                    itemConfig?.icon && !hideIcon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(itemConfig.icon, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "h-2 w-2 shrink-0 rounded-[2px]",
                        style: {
                            backgroundColor: item.color
                        }
                    }),
                    itemConfig?.label
                ]
            }, item.value);
        })
    });
});
ChartLegendContent.displayName = "ChartLegend";
// Helper to extract item config from a payload.
function getPayloadConfigFromPayload(config, payload, key) {
    if (typeof payload !== "object" || payload === null) return undefined;
    const payloadPayload = "payload" in payload && typeof payload.payload === "object" && payload.payload !== null ? payload.payload : undefined;
    let configLabelKey = key;
    if (key in payload && typeof payload[key] === "string") configLabelKey = payload[key];
    else if (payloadPayload && key in payloadPayload && typeof payloadPayload[key] === "string") configLabelKey = payloadPayload[key];
    return configLabelKey in config ? config[configLabelKey] : config[key];
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","recharts":"3gdVt","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3gdVt":[function(require,module,exports,__globalThis) {
// "export type" declarations on separate lines are in use
// to workaround babel issue(s) 11465 12578
//
// see https://github.com/babel/babel/issues/11464#issuecomment-617606898
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Surface", ()=>(0, _surface.Surface));
parcelHelpers.export(exports, "Layer", ()=>(0, _layer.Layer));
parcelHelpers.export(exports, "Legend", ()=>(0, _legend.Legend));
parcelHelpers.export(exports, "DefaultLegendContent", ()=>(0, _defaultLegendContent.DefaultLegendContent));
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltip.Tooltip));
parcelHelpers.export(exports, "DefaultTooltipContent", ()=>(0, _defaultTooltipContent.DefaultTooltipContent));
parcelHelpers.export(exports, "ResponsiveContainer", ()=>(0, _responsiveContainer.ResponsiveContainer));
parcelHelpers.export(exports, "Cell", ()=>(0, _cell.Cell));
parcelHelpers.export(exports, "Text", ()=>(0, _text.Text));
parcelHelpers.export(exports, "Label", ()=>(0, _label.Label));
parcelHelpers.export(exports, "LabelList", ()=>(0, _labelList.LabelList));
parcelHelpers.export(exports, "Customized", ()=>(0, _customized.Customized));
parcelHelpers.export(exports, "Sector", ()=>(0, _sector.Sector));
parcelHelpers.export(exports, "Curve", ()=>(0, _curve.Curve));
parcelHelpers.export(exports, "Rectangle", ()=>(0, _rectangle.Rectangle));
parcelHelpers.export(exports, "Polygon", ()=>(0, _polygon.Polygon));
parcelHelpers.export(exports, "Dot", ()=>(0, _dot.Dot));
parcelHelpers.export(exports, "Cross", ()=>(0, _cross.Cross));
parcelHelpers.export(exports, "Symbols", ()=>(0, _symbols.Symbols));
parcelHelpers.export(exports, "PolarGrid", ()=>(0, _polarGrid.PolarGrid));
parcelHelpers.export(exports, "PolarRadiusAxis", ()=>(0, _polarRadiusAxis.PolarRadiusAxis));
parcelHelpers.export(exports, "PolarAngleAxis", ()=>(0, _polarAngleAxis.PolarAngleAxis));
parcelHelpers.export(exports, "Pie", ()=>(0, _pie.Pie));
parcelHelpers.export(exports, "Radar", ()=>(0, _radar.Radar));
parcelHelpers.export(exports, "RadialBar", ()=>(0, _radialBar.RadialBar));
parcelHelpers.export(exports, "Brush", ()=>(0, _brush.Brush));
parcelHelpers.export(exports, "ReferenceLine", ()=>(0, _referenceLine.ReferenceLine));
parcelHelpers.export(exports, "ReferenceDot", ()=>(0, _referenceDot.ReferenceDot));
parcelHelpers.export(exports, "ReferenceArea", ()=>(0, _referenceArea.ReferenceArea));
parcelHelpers.export(exports, "CartesianAxis", ()=>(0, _cartesianAxis.CartesianAxis));
parcelHelpers.export(exports, "CartesianGrid", ()=>(0, _cartesianGrid.CartesianGrid));
parcelHelpers.export(exports, "Line", ()=>(0, _line.Line));
parcelHelpers.export(exports, "Area", ()=>(0, _area.Area));
parcelHelpers.export(exports, "Bar", ()=>(0, _bar.Bar));
parcelHelpers.export(exports, "Scatter", ()=>(0, _scatter.Scatter));
parcelHelpers.export(exports, "XAxis", ()=>(0, _xaxis.XAxis));
parcelHelpers.export(exports, "YAxis", ()=>(0, _yaxis.YAxis));
parcelHelpers.export(exports, "ZAxis", ()=>(0, _zaxis.ZAxis));
parcelHelpers.export(exports, "ErrorBar", ()=>(0, _errorBar.ErrorBar));
parcelHelpers.export(exports, "LineChart", ()=>(0, _lineChart.LineChart));
parcelHelpers.export(exports, "BarChart", ()=>(0, _barChart.BarChart));
parcelHelpers.export(exports, "PieChart", ()=>(0, _pieChart.PieChart));
parcelHelpers.export(exports, "Treemap", ()=>(0, _treemap.Treemap));
parcelHelpers.export(exports, "Sankey", ()=>(0, _sankey.Sankey));
parcelHelpers.export(exports, "RadarChart", ()=>(0, _radarChart.RadarChart));
parcelHelpers.export(exports, "ScatterChart", ()=>(0, _scatterChart.ScatterChart));
parcelHelpers.export(exports, "AreaChart", ()=>(0, _areaChart.AreaChart));
parcelHelpers.export(exports, "RadialBarChart", ()=>(0, _radialBarChart.RadialBarChart));
parcelHelpers.export(exports, "ComposedChart", ()=>(0, _composedChart.ComposedChart));
parcelHelpers.export(exports, "SunburstChart", ()=>(0, _sunburstChart.SunburstChart));
parcelHelpers.export(exports, "Funnel", ()=>(0, _funnel.Funnel));
parcelHelpers.export(exports, "FunnelChart", ()=>(0, _funnelChart.FunnelChart));
parcelHelpers.export(exports, "Trapezoid", ()=>(0, _trapezoid.Trapezoid));
parcelHelpers.export(exports, "Global", ()=>(0, _global.Global));
var _surface = require("./container/Surface");
var _layer = require("./container/Layer");
var _legend = require("./component/Legend");
var _defaultLegendContent = require("./component/DefaultLegendContent");
var _tooltip = require("./component/Tooltip");
var _defaultTooltipContent = require("./component/DefaultTooltipContent");
var _responsiveContainer = require("./component/ResponsiveContainer");
var _cell = require("./component/Cell");
var _text = require("./component/Text");
var _label = require("./component/Label");
var _labelList = require("./component/LabelList");
var _customized = require("./component/Customized");
var _sector = require("./shape/Sector");
var _curve = require("./shape/Curve");
var _rectangle = require("./shape/Rectangle");
var _polygon = require("./shape/Polygon");
var _dot = require("./shape/Dot");
var _cross = require("./shape/Cross");
var _symbols = require("./shape/Symbols");
var _polarGrid = require("./polar/PolarGrid");
var _polarRadiusAxis = require("./polar/PolarRadiusAxis");
var _polarAngleAxis = require("./polar/PolarAngleAxis");
var _pie = require("./polar/Pie");
var _radar = require("./polar/Radar");
var _radialBar = require("./polar/RadialBar");
var _brush = require("./cartesian/Brush");
var _referenceLine = require("./cartesian/ReferenceLine");
var _referenceDot = require("./cartesian/ReferenceDot");
var _referenceArea = require("./cartesian/ReferenceArea");
var _cartesianAxis = require("./cartesian/CartesianAxis");
var _cartesianGrid = require("./cartesian/CartesianGrid");
var _line = require("./cartesian/Line");
var _area = require("./cartesian/Area");
var _bar = require("./cartesian/Bar");
var _scatter = require("./cartesian/Scatter");
var _xaxis = require("./cartesian/XAxis");
var _yaxis = require("./cartesian/YAxis");
var _zaxis = require("./cartesian/ZAxis");
var _errorBar = require("./cartesian/ErrorBar");
var _lineChart = require("./chart/LineChart");
var _barChart = require("./chart/BarChart");
var _pieChart = require("./chart/PieChart");
var _treemap = require("./chart/Treemap");
var _sankey = require("./chart/Sankey");
var _radarChart = require("./chart/RadarChart");
var _scatterChart = require("./chart/ScatterChart");
var _areaChart = require("./chart/AreaChart");
var _radialBarChart = require("./chart/RadialBarChart");
var _composedChart = require("./chart/ComposedChart");
var _sunburstChart = require("./chart/SunburstChart");
var _funnel = require("./numberAxis/Funnel");
var _funnelChart = require("./chart/FunnelChart");
var _trapezoid = require("./shape/Trapezoid");
var _global = require("./util/Global");

},{"./container/Surface":"7sKCX","./container/Layer":"gNfib","./component/Legend":"hn1WY","./component/DefaultLegendContent":"eTwVK","./component/Tooltip":"5PITU","./component/DefaultTooltipContent":"lJbWv","./component/ResponsiveContainer":"fTtLu","./component/Cell":"6TviG","./component/Text":"6tNNj","./component/Label":"jhet4","./component/LabelList":"j6MTq","./component/Customized":"cM1mm","./shape/Sector":"dCpDt","./shape/Curve":"3D54B","./shape/Rectangle":"gLZb9","./shape/Polygon":"9X8Ya","./shape/Dot":"lScwe","./shape/Cross":"6ZY1y","./shape/Symbols":"eArZD","./polar/PolarGrid":"8Nd9M","./polar/PolarRadiusAxis":"bcj3U","./polar/PolarAngleAxis":"lel0p","./polar/Pie":"kXPp1","./polar/Radar":"erEnc","./polar/RadialBar":"6Prav","./cartesian/Brush":"aKFkv","./cartesian/ReferenceLine":"bfpaV","./cartesian/ReferenceDot":"es4cV","./cartesian/ReferenceArea":"3tiU1","./cartesian/CartesianAxis":"2ZoIX","./cartesian/CartesianGrid":"8zC4Z","./cartesian/Line":"eU152","./cartesian/Area":"nNjdk","./cartesian/Bar":"9EUGQ","./cartesian/Scatter":"cEWud","./cartesian/XAxis":"4nBWG","./cartesian/YAxis":"NHcEZ","./cartesian/ZAxis":"9mmH7","./cartesian/ErrorBar":"2A4Qz","./chart/LineChart":"6HDbf","./chart/BarChart":"euDzi","./chart/PieChart":"42UF9","./chart/Treemap":"dzypJ","./chart/Sankey":"jGpFD","./chart/RadarChart":"6hzed","./chart/ScatterChart":"fOuW8","./chart/AreaChart":"03rLr","./chart/RadialBarChart":"1bSde","./chart/ComposedChart":"5E7p6","./chart/SunburstChart":"bb3Qw","./numberAxis/Funnel":"7Ev5N","./chart/FunnelChart":"dLKDB","./shape/Trapezoid":"3pate","./util/Global":"dWTWi","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fTtLu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponsiveContainer", ()=>ResponsiveContainer);
/**
 * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
 */ var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _throttle = require("lodash/throttle");
var _throttleDefault = parcelHelpers.interopDefault(_throttle);
var _dataUtils = require("../util/DataUtils");
var _logUtils = require("../util/LogUtils");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var ResponsiveContainer = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? '100%' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? '100%' : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, _react.useRef)(null);
    var onResizeRef = (0, _react.useRef)();
    onResizeRef.current = onResize;
    (0, _react.useImperativeHandle)(ref, function() {
        return Object.defineProperty(containerRef.current, 'current', {
            get: function get() {
                // eslint-disable-next-line no-console
                console.warn('The usage of ref.current.current is deprecated and will no longer be supported.');
                return containerRef.current;
            },
            configurable: true
        });
    });
    var _useState = (0, _react.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = _slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, _react.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, _react.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, _throttleDefault.default)(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, _react.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, _logUtils.warn)((0, _dataUtils.isPercent)(width) || (0, _dataUtils.isPercent)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, _logUtils.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
        var calculatedWidth = (0, _dataUtils.isPercent)(width) ? containerWidth : width;
        var calculatedHeight = (0, _dataUtils.isPercent)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, _logUtils.warn)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, _reactUtils.getDisplayName)(children.type).endsWith('Chart');
        return (0, _reactDefault.default).Children.map(children, function(child) {
            if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) return /*#__PURE__*/ (0, _react.cloneElement)(child, _objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: _objectSpread({
                    height: '100%',
                    width: '100%',
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, _clsxDefault.default)('recharts-responsive-container', className),
        style: _objectSpread(_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});

},{"clsx":"3mzHT","react":"eGun2","lodash/throttle":"buA1M","../util/DataUtils":"lsl3R","../util/LogUtils":"7Bf7y","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cM1mm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * custom svg elements by rechart instance props and state.
 * @returns {Object}   svg elements
 */ parcelHelpers.export(exports, "Customized", ()=>Customized);
/**
 * @fileOverview Customized
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _layer = require("../container/Layer");
var _logUtils = require("../util/LogUtils");
var _excluded = [
    "component"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Customized(_ref) {
    var component = _ref.component, props = _objectWithoutProperties(_ref, _excluded);
    var child;
    if (/*#__PURE__*/ (0, _react.isValidElement)(component)) child = /*#__PURE__*/ (0, _react.cloneElement)(component, props);
    else if ((0, _isFunctionDefault.default)(component)) child = /*#__PURE__*/ (0, _react.createElement)(component, props);
    else (0, _logUtils.warn)(false, "Customized's props `component` must be React.element or Function, but got %s.", _typeof(component));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: "recharts-customized-wrapper"
    }, child);
}
Customized.displayName = 'Customized';

},{"react":"eGun2","lodash/isFunction":"2KQKo","../container/Layer":"gNfib","../util/LogUtils":"7Bf7y","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9X8Ya":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Polygon", ()=>Polygon);
/**
 * @fileOverview Polygon
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "points",
    "className",
    "baseLinePoints",
    "connectNulls"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var isValidatePoint = function isValidatePoint(point) {
    return point && point.x === +point.x && point.y === +point.y;
};
var getParsedPoints = function getParsedPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var segmentPoints = [
        []
    ];
    points.forEach(function(entry) {
        if (isValidatePoint(entry)) segmentPoints[segmentPoints.length - 1].push(entry);
        else if (segmentPoints[segmentPoints.length - 1].length > 0) // add another path
        segmentPoints.push([]);
    });
    if (isValidatePoint(points[0])) segmentPoints[segmentPoints.length - 1].push(points[0]);
    if (segmentPoints[segmentPoints.length - 1].length <= 0) segmentPoints = segmentPoints.slice(0, -1);
    return segmentPoints;
};
var getSinglePolygonPath = function getSinglePolygonPath(points, connectNulls) {
    var segmentPoints = getParsedPoints(points);
    if (connectNulls) segmentPoints = [
        segmentPoints.reduce(function(res, segPoints) {
            return [].concat(_toConsumableArray(res), _toConsumableArray(segPoints));
        }, [])
    ];
    var polygonPath = segmentPoints.map(function(segPoints) {
        return segPoints.reduce(function(path, point, index) {
            return "".concat(path).concat(index === 0 ? 'M' : 'L').concat(point.x, ",").concat(point.y);
        }, '');
    }).join('');
    return segmentPoints.length === 1 ? "".concat(polygonPath, "Z") : polygonPath;
};
var getRanglePath = function getRanglePath(points, baseLinePoints, connectNulls) {
    var outerPath = getSinglePolygonPath(points, connectNulls);
    return "".concat(outerPath.slice(-1) === 'Z' ? outerPath.slice(0, -1) : outerPath, "L").concat(getSinglePolygonPath(baseLinePoints.reverse(), connectNulls).slice(1));
};
var Polygon = function Polygon(props) {
    var points = props.points, className = props.className, baseLinePoints = props.baseLinePoints, connectNulls = props.connectNulls, others = _objectWithoutProperties(props, _excluded);
    if (!points || !points.length) return null;
    var layerClass = (0, _clsxDefault.default)('recharts-polygon', className);
    if (baseLinePoints && baseLinePoints.length) {
        var hasStroke = others.stroke && others.stroke !== 'none';
        var rangePath = getRanglePath(points, baseLinePoints, connectNulls);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
            className: layerClass
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(others, true), {
            fill: rangePath.slice(-1) === 'Z' ? others.fill : 'none',
            stroke: "none",
            d: rangePath
        })), hasStroke ? /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(others, true), {
            fill: "none",
            d: getSinglePolygonPath(points, connectNulls)
        })) : null, hasStroke ? /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(others, true), {
            fill: "none",
            d: getSinglePolygonPath(baseLinePoints, connectNulls)
        })) : null);
    }
    var singlePath = getSinglePolygonPath(points, connectNulls);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(others, true), {
        fill: singlePath.slice(-1) === 'Z' ? others.fill : 'none',
        className: layerClass,
        d: singlePath
    }));
};

},{"react":"eGun2","clsx":"3mzHT","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8Nd9M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PolarGrid", ()=>PolarGrid);
/**
 * @fileOverview Polar Grid
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _polarUtils = require("../util/PolarUtils");
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "cx",
    "cy",
    "innerRadius",
    "outerRadius",
    "gridType",
    "radialLines"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getPolygonPath = function getPolygonPath(radius, cx, cy, polarAngles) {
    var path = '';
    polarAngles.forEach(function(angle, i) {
        var point = (0, _polarUtils.polarToCartesian)(cx, cy, radius, angle);
        if (i) path += "L ".concat(point.x, ",").concat(point.y);
        else path += "M ".concat(point.x, ",").concat(point.y);
    });
    path += 'Z';
    return path;
};
// Draw axis of radial line
var PolarAngles = function PolarAngles(props) {
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, polarAngles = props.polarAngles, radialLines = props.radialLines;
    if (!polarAngles || !polarAngles.length || !radialLines) return null;
    var polarAnglesProps = _objectSpread({
        stroke: '#ccc'
    }, (0, _reactUtils.filterProps)(props, false));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-polar-grid-angle"
    }, polarAngles.map(function(entry) {
        var start = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, entry);
        var end = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, entry);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, polarAnglesProps, {
            key: "line-".concat(entry),
            x1: start.x,
            y1: start.y,
            x2: end.x,
            y2: end.y
        }));
    }));
};
// Draw concentric circles
var ConcentricCircle = function ConcentricCircle(props) {
    var cx = props.cx, cy = props.cy, radius = props.radius, index = props.index;
    var concentricCircleProps = _objectSpread(_objectSpread({
        stroke: '#ccc'
    }, (0, _reactUtils.filterProps)(props, false)), {}, {
        fill: 'none'
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", _extends({}, concentricCircleProps, {
        className: (0, _clsxDefault.default)('recharts-polar-grid-concentric-circle', props.className),
        key: "circle-".concat(index),
        cx: cx,
        cy: cy,
        r: radius
    }));
};
// Draw concentric polygons
var ConcentricPolygon = function ConcentricPolygon(props) {
    var radius = props.radius, index = props.index;
    var concentricPolygonProps = _objectSpread(_objectSpread({
        stroke: '#ccc'
    }, (0, _reactUtils.filterProps)(props, false)), {}, {
        fill: 'none'
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, concentricPolygonProps, {
        className: (0, _clsxDefault.default)('recharts-polar-grid-concentric-polygon', props.className),
        key: "path-".concat(index),
        d: getPolygonPath(radius, props.cx, props.cy, props.polarAngles)
    }));
};
// Draw concentric axis
// TODO Optimize the name
var ConcentricPath = function ConcentricPath(props) {
    var polarRadius = props.polarRadius, gridType = props.gridType;
    if (!polarRadius || !polarRadius.length) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-polar-grid-concentric"
    }, polarRadius.map(function(entry, i) {
        var key = i;
        if (gridType === 'circle') return /*#__PURE__*/ (0, _reactDefault.default).createElement(ConcentricCircle, _extends({
            key: key
        }, props, {
            radius: entry,
            index: i
        }));
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(ConcentricPolygon, _extends({
            key: key
        }, props, {
            radius: entry,
            index: i
        }));
    }));
};
var PolarGrid = function PolarGrid(_ref) {
    var _ref$cx = _ref.cx, cx = _ref$cx === void 0 ? 0 : _ref$cx, _ref$cy = _ref.cy, cy = _ref$cy === void 0 ? 0 : _ref$cy, _ref$innerRadius = _ref.innerRadius, innerRadius = _ref$innerRadius === void 0 ? 0 : _ref$innerRadius, _ref$outerRadius = _ref.outerRadius, outerRadius = _ref$outerRadius === void 0 ? 0 : _ref$outerRadius, _ref$gridType = _ref.gridType, gridType = _ref$gridType === void 0 ? 'polygon' : _ref$gridType, _ref$radialLines = _ref.radialLines, radialLines = _ref$radialLines === void 0 ? true : _ref$radialLines, props = _objectWithoutProperties(_ref, _excluded);
    if (outerRadius <= 0) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-polar-grid"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(PolarAngles, _extends({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        gridType: gridType,
        radialLines: radialLines
    }, props)), /*#__PURE__*/ (0, _reactDefault.default).createElement(ConcentricPath, _extends({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        gridType: gridType,
        radialLines: radialLines
    }, props)));
};
PolarGrid.displayName = 'PolarGrid';

},{"react":"eGun2","clsx":"3mzHT","../util/PolarUtils":"27snq","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bcj3U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PolarRadiusAxis", ()=>PolarRadiusAxis);
/**
 * @fileOverview The axis of polar coordinate system
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _maxBy = require("lodash/maxBy");
var _maxByDefault = parcelHelpers.interopDefault(_maxBy);
var _minBy = require("lodash/minBy");
var _minByDefault = parcelHelpers.interopDefault(_minBy);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _text = require("../component/Text");
var _label = require("../component/Label");
var _layer = require("../container/Layer");
var _polarUtils = require("../util/PolarUtils");
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "cx",
    "cy",
    "angle",
    "ticks",
    "axisLine"
], _excluded2 = [
    "ticks",
    "tick",
    "angle",
    "tickFormatter",
    "stroke"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var PolarRadiusAxis = /*#__PURE__*/ function(_PureComponent) {
    function PolarRadiusAxis() {
        _classCallCheck(this, PolarRadiusAxis);
        return _callSuper(this, PolarRadiusAxis, arguments);
    }
    _inherits(PolarRadiusAxis, _PureComponent);
    return _createClass(PolarRadiusAxis, [
        {
            key: "getTickValueCoord",
            value: /**
     * Calculate the coordinate of tick
     * @param  {Number} coordinate The radius of tick
     * @return {Object} (x, y)
     */ function getTickValueCoord(_ref) {
                var coordinate = _ref.coordinate;
                var _this$props = this.props, angle = _this$props.angle, cx = _this$props.cx, cy = _this$props.cy;
                return (0, _polarUtils.polarToCartesian)(cx, cy, coordinate, angle);
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var orientation = this.props.orientation;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = 'end';
                        break;
                    case 'right':
                        textAnchor = 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getViewBox",
            value: function getViewBox() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, angle = _this$props2.angle, ticks = _this$props2.ticks;
                var maxRadiusTick = (0, _maxByDefault.default)(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                var minRadiusTick = (0, _minByDefault.default)(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                return {
                    cx: cx,
                    cy: cy,
                    startAngle: angle,
                    endAngle: angle,
                    innerRadius: minRadiusTick.coordinate || 0,
                    outerRadius: maxRadiusTick.coordinate || 0
                };
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props3 = this.props, cx = _this$props3.cx, cy = _this$props3.cy, angle = _this$props3.angle, ticks = _this$props3.ticks, axisLine = _this$props3.axisLine, others = _objectWithoutProperties(_this$props3, _excluded);
                var extent = ticks.reduce(function(result, entry) {
                    return [
                        Math.min(result[0], entry.coordinate),
                        Math.max(result[1], entry.coordinate)
                    ];
                }, [
                    Infinity,
                    -Infinity
                ]);
                var point0 = (0, _polarUtils.polarToCartesian)(cx, cy, extent[0], angle);
                var point1 = (0, _polarUtils.polarToCartesian)(cx, cy, extent[1], angle);
                var props = _objectSpread(_objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(others, false)), {}, {
                    fill: 'none'
                }, (0, _reactUtils.filterProps)(axisLine, false)), {}, {
                    x1: point0.x,
                    y1: point0.y,
                    x2: point1.x,
                    y2: point1.y
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({
                    className: "recharts-polar-radius-axis-line"
                }, props));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props4 = this.props, ticks = _this$props4.ticks, tick = _this$props4.tick, angle = _this$props4.angle, tickFormatter = _this$props4.tickFormatter, stroke = _this$props4.stroke, others = _objectWithoutProperties(_this$props4, _excluded2);
                var textAnchor = this.getTickTextAnchor();
                var axisProps = (0, _reactUtils.filterProps)(others, false);
                var customTickProps = (0, _reactUtils.filterProps)(tick, false);
                var items = ticks.map(function(entry, i) {
                    var coord = _this.getTickValueCoord(entry);
                    var tickProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                        textAnchor: textAnchor,
                        transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i
                    }, coord), {}, {
                        payload: entry
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: (0, _clsxDefault.default)('recharts-polar-radius-axis-tick', (0, _polarUtils.getTickClassName)(tick)),
                        key: "tick-".concat(entry.coordinate)
                    }, (0, _types.adaptEventsOfChild)(_this.props, entry, i)), PolarRadiusAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-polar-radius-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, ticks = _this$props5.ticks, axisLine = _this$props5.axisLine, tick = _this$props5.tick;
                if (!ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: (0, _clsxDefault.default)('recharts-polar-radius-axis', this.props.className)
                }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), (0, _label.Label).renderCallByParent(this.props, this.getViewBox()));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) tickItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({}, props, {
                    className: "recharts-polar-radius-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(PolarRadiusAxis, "displayName", 'PolarRadiusAxis');
_defineProperty(PolarRadiusAxis, "axisType", 'radiusAxis');
_defineProperty(PolarRadiusAxis, "defaultProps", {
    type: 'number',
    radiusAxisId: 0,
    cx: 0,
    cy: 0,
    angle: 0,
    orientation: 'right',
    stroke: '#ccc',
    axisLine: true,
    tick: true,
    tickCount: 5,
    allowDataOverflow: false,
    scale: 'auto',
    allowDuplicatedCategory: true
});

},{"react":"eGun2","lodash/maxBy":"9wmso","lodash/minBy":"9qmKp","lodash/isFunction":"2KQKo","clsx":"3mzHT","../component/Text":"6tNNj","../component/Label":"jhet4","../container/Layer":"gNfib","../util/PolarUtils":"27snq","../util/types":"5mtYY","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9wmso":[function(require,module,exports,__globalThis) {
var baseExtremum = require("65c9c784ddff04eb"), baseGt = require("a913d89fdc4cb303"), baseIteratee = require("eb0ae91ff206c0b6");
/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */ function maxBy(array, iteratee) {
    return array && array.length ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt) : undefined;
}
module.exports = maxBy;

},{"65c9c784ddff04eb":"jHHQS","a913d89fdc4cb303":"1FUz2","eb0ae91ff206c0b6":"hmPIl"}],"9qmKp":[function(require,module,exports,__globalThis) {
var baseExtremum = require("5619c24634864933"), baseIteratee = require("cc7eb8e0d57914b1"), baseLt = require("d42cd094d3bfe4e8");
/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */ function minBy(array, iteratee) {
    return array && array.length ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt) : undefined;
}
module.exports = minBy;

},{"5619c24634864933":"jHHQS","cc7eb8e0d57914b1":"hmPIl","d42cd094d3bfe4e8":"jRYqf"}],"lel0p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PolarAngleAxis", ()=>PolarAngleAxis);
/**
 * @fileOverview Axis of radial direction
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _dot = require("../shape/Dot");
var _polygon = require("../shape/Polygon");
var _text = require("../component/Text");
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
var _polarUtils = require("../util/PolarUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var RADIAN = Math.PI / 180;
var eps = 1e-5;
var PolarAngleAxis = /*#__PURE__*/ function(_PureComponent) {
    function PolarAngleAxis() {
        _classCallCheck(this, PolarAngleAxis);
        return _callSuper(this, PolarAngleAxis, arguments);
    }
    _inherits(PolarAngleAxis, _PureComponent);
    return _createClass(PolarAngleAxis, [
        {
            key: "getTickLineCoord",
            value: /**
     * Calculate the coordinate of line endpoint
     * @param  {Object} data The Data if ticks
     * @return {Object} (x0, y0): The start point of text,
     *                  (x1, y1): The end point close to text,
     *                  (x2, y2): The end point close to axis
     */ function getTickLineCoord(data) {
                var _this$props = this.props, cx = _this$props.cx, cy = _this$props.cy, radius = _this$props.radius, orientation = _this$props.orientation, tickSize = _this$props.tickSize;
                var tickLineSize = tickSize || 8;
                var p1 = (0, _polarUtils.polarToCartesian)(cx, cy, radius, data.coordinate);
                var p2 = (0, _polarUtils.polarToCartesian)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
                return {
                    x1: p1.x,
                    y1: p1.y,
                    x2: p2.x,
                    y2: p2.y
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor(data) {
                var orientation = this.props.orientation;
                var cos = Math.cos(-data.coordinate * RADIAN);
                var textAnchor;
                if (cos > eps) textAnchor = orientation === 'outer' ? 'start' : 'end';
                else if (cos < -eps) textAnchor = orientation === 'outer' ? 'end' : 'start';
                else textAnchor = 'middle';
                return textAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, radius = _this$props2.radius, axisLine = _this$props2.axisLine, axisLineType = _this$props2.axisLineType;
                var props = _objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(this.props, false)), {}, {
                    fill: 'none'
                }, (0, _reactUtils.filterProps)(axisLine, false));
                if (axisLineType === 'circle') return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), _extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    cx: cx,
                    cy: cy,
                    r: radius
                }));
                var ticks = this.props.ticks;
                var points = ticks.map(function(entry) {
                    return (0, _polarUtils.polarToCartesian)(cx, cy, radius, entry.coordinate);
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _polygon.Polygon), _extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    points: points
                }));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props3 = this.props, ticks = _this$props3.ticks, tick = _this$props3.tick, tickLine = _this$props3.tickLine, tickFormatter = _this$props3.tickFormatter, stroke = _this$props3.stroke;
                var axisProps = (0, _reactUtils.filterProps)(this.props, false);
                var customTickProps = (0, _reactUtils.filterProps)(tick, false);
                var tickLineProps = _objectSpread(_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, _reactUtils.filterProps)(tickLine, false));
                var items = ticks.map(function(entry, i) {
                    var lineCoord = _this.getTickLineCoord(entry);
                    var textAnchor = _this.getTickTextAnchor(entry);
                    var tickProps = _objectSpread(_objectSpread(_objectSpread({
                        textAnchor: textAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i,
                        payload: entry,
                        x: lineCoord.x2,
                        y: lineCoord.y2
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: (0, _clsxDefault.default)('recharts-polar-angle-axis-tick', (0, _polarUtils.getTickClassName)(tick)),
                        key: "tick-".concat(entry.coordinate)
                    }, (0, _types.adaptEventsOfChild)(_this.props, entry, i)), tickLine && /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({
                        className: "recharts-polar-angle-axis-tick-line"
                    }, tickLineProps, lineCoord)), tick && PolarAngleAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-polar-angle-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, ticks = _this$props4.ticks, radius = _this$props4.radius, axisLine = _this$props4.axisLine;
                if (radius <= 0 || !ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: (0, _clsxDefault.default)('recharts-polar-angle-axis', this.props.className)
                }, axisLine && this.renderAxisLine(), this.renderTicks());
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) tickItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({}, props, {
                    className: "recharts-polar-angle-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(PolarAngleAxis, "displayName", 'PolarAngleAxis');
_defineProperty(PolarAngleAxis, "axisType", 'angleAxis');
_defineProperty(PolarAngleAxis, "defaultProps", {
    type: 'category',
    angleAxisId: 0,
    scale: 'auto',
    cx: 0,
    cy: 0,
    orientation: 'outer',
    axisLine: true,
    tickLine: true,
    tickSize: 8,
    tick: true,
    hide: false,
    allowDuplicatedCategory: true
});

},{"react":"eGun2","lodash/isFunction":"2KQKo","clsx":"3mzHT","../container/Layer":"gNfib","../shape/Dot":"lScwe","../shape/Polygon":"9X8Ya","../component/Text":"6tNNj","../util/types":"5mtYY","../util/ReactUtils":"dBf5D","../util/PolarUtils":"27snq","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kXPp1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pie", ()=>Pie);
/**
 * @fileOverview Render sectors of a pie
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _curve = require("../shape/Curve");
var _text = require("../component/Text");
var _label = require("../component/Label");
var _labelList = require("../component/LabelList");
var _cell = require("../component/Cell");
var _reactUtils = require("../util/ReactUtils");
var _global = require("../util/Global");
var _polarUtils = require("../util/PolarUtils");
var _dataUtils = require("../util/DataUtils");
var _chartUtils = require("../util/ChartUtils");
var _logUtils = require("../util/LogUtils");
var _types = require("../util/types");
var _activeShapeUtils = require("../util/ActiveShapeUtils");
var _Pie;
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var Pie = /*#__PURE__*/ function(_PureComponent) {
    function Pie(props) {
        var _this;
        _classCallCheck(this, Pie);
        _this = _callSuper(this, Pie, [
            props
        ]);
        _defineProperty(_this, "pieRef", null);
        _defineProperty(_this, "sectorRefs", []);
        _defineProperty(_this, "id", (0, _dataUtils.uniqueId)('recharts-pie-'));
        _defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, _isFunctionDefault.default)(onAnimationEnd)) onAnimationEnd();
        });
        _defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, _isFunctionDefault.default)(onAnimationStart)) onAnimationStart();
        });
        _this.state = {
            isAnimationFinished: !props.isAnimationActive,
            prevIsAnimationActive: props.isAnimationActive,
            prevAnimationId: props.animationId,
            sectorToFocus: 0
        };
        return _this;
    }
    _inherits(Pie, _PureComponent);
    return _createClass(Pie, [
        {
            key: "isActiveIndex",
            value: function isActiveIndex(i) {
                var activeIndex = this.props.activeIndex;
                if (Array.isArray(activeIndex)) return activeIndex.indexOf(i) !== -1;
                return i === activeIndex;
            }
        },
        {
            key: "hasActiveIndex",
            value: function hasActiveIndex() {
                var activeIndex = this.props.activeIndex;
                return Array.isArray(activeIndex) ? activeIndex.length !== 0 : activeIndex || activeIndex === 0;
            }
        },
        {
            key: "renderLabels",
            value: function renderLabels(sectors) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, label = _this$props.label, labelLine = _this$props.labelLine, dataKey = _this$props.dataKey, valueKey = _this$props.valueKey;
                var pieProps = (0, _reactUtils.filterProps)(this.props, false);
                var customLabelProps = (0, _reactUtils.filterProps)(label, false);
                var customLabelLineProps = (0, _reactUtils.filterProps)(labelLine, false);
                var offsetRadius = label && label.offsetRadius || 20;
                var labels = sectors.map(function(entry, i) {
                    var midAngle = (entry.startAngle + entry.endAngle) / 2;
                    var endPoint = (0, _polarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
                    var labelProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, pieProps), entry), {}, {
                        stroke: 'none'
                    }, customLabelProps), {}, {
                        index: i,
                        textAnchor: Pie.getTextAnchor(endPoint.x, entry.cx)
                    }, endPoint);
                    var lineProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, pieProps), entry), {}, {
                        fill: 'none',
                        stroke: entry.fill
                    }, customLabelLineProps), {}, {
                        index: i,
                        points: [
                            (0, _polarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle),
                            endPoint
                        ]
                    });
                    var realDataKey = dataKey;
                    // TODO: compatible to lower versions
                    if ((0, _isNilDefault.default)(dataKey) && (0, _isNilDefault.default)(valueKey)) realDataKey = 'value';
                    else if ((0, _isNilDefault.default)(dataKey)) realDataKey = valueKey;
                    return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                    (0, _reactDefault.default).createElement((0, _layer.Layer), {
                        key: "label-".concat(entry.startAngle, "-").concat(entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
                    }, labelLine && Pie.renderLabelLineItem(labelLine, lineProps, 'line'), Pie.renderLabelItem(label, labelProps, (0, _chartUtils.getValueByDataKey)(entry, realDataKey))));
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-pie-labels"
                }, labels);
            }
        },
        {
            key: "renderSectorsStatically",
            value: function renderSectorsStatically(sectors) {
                var _this2 = this;
                var _this$props2 = this.props, activeShape = _this$props2.activeShape, blendStroke = _this$props2.blendStroke, inactiveShapeProp = _this$props2.inactiveShape;
                return sectors.map(function(entry, i) {
                    if ((entry === null || entry === void 0 ? void 0 : entry.startAngle) === 0 && (entry === null || entry === void 0 ? void 0 : entry.endAngle) === 0 && sectors.length !== 1) return null;
                    var isActive = _this2.isActiveIndex(i);
                    var inactiveShape = inactiveShapeProp && _this2.hasActiveIndex() ? inactiveShapeProp : null;
                    var sectorOptions = isActive ? activeShape : inactiveShape;
                    var sectorProps = _objectSpread(_objectSpread({}, entry), {}, {
                        stroke: blendStroke ? entry.fill : entry.stroke,
                        tabIndex: -1
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        ref: function ref(_ref) {
                            if (_ref && !_this2.sectorRefs.includes(_ref)) _this2.sectorRefs.push(_ref);
                        },
                        tabIndex: -1,
                        className: "recharts-pie-sector"
                    }, (0, _types.adaptEventsOfChild)(_this2.props, entry, i), {
                        // eslint-disable-next-line react/no-array-index-key
                        key: "sector-".concat(entry === null || entry === void 0 ? void 0 : entry.startAngle, "-").concat(entry === null || entry === void 0 ? void 0 : entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
                    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _activeShapeUtils.Shape), _extends({
                        option: sectorOptions,
                        isActive: isActive,
                        shapeType: "sector"
                    }, sectorProps)));
                });
            }
        },
        {
            key: "renderSectorsWithAnimation",
            value: function renderSectorsWithAnimation() {
                var _this3 = this;
                var _this$props3 = this.props, sectors = _this$props3.sectors, isAnimationActive = _this$props3.isAnimationActive, animationBegin = _this$props3.animationBegin, animationDuration = _this$props3.animationDuration, animationEasing = _this$props3.animationEasing, animationId = _this$props3.animationId;
                var _this$state = this.state, prevSectors = _this$state.prevSectors, prevIsAnimationActive = _this$state.prevIsAnimationActive;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId, "-").concat(prevIsAnimationActive),
                    onAnimationStart: this.handleAnimationStart,
                    onAnimationEnd: this.handleAnimationEnd
                }, function(_ref2) {
                    var t = _ref2.t;
                    var stepData = [];
                    var first = sectors && sectors[0];
                    var curAngle = first.startAngle;
                    sectors.forEach(function(entry, index) {
                        var prev = prevSectors && prevSectors[index];
                        var paddingAngle = index > 0 ? (0, _getDefault.default)(entry, 'paddingAngle', 0) : 0;
                        if (prev) {
                            var angleIp = (0, _dataUtils.interpolateNumber)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
                            var latest = _objectSpread(_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + angleIp(t) + paddingAngle
                            });
                            stepData.push(latest);
                            curAngle = latest.endAngle;
                        } else {
                            var endAngle = entry.endAngle, startAngle = entry.startAngle;
                            var interpolatorAngle = (0, _dataUtils.interpolateNumber)(0, endAngle - startAngle);
                            var deltaAngle = interpolatorAngle(t);
                            var _latest = _objectSpread(_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + deltaAngle + paddingAngle
                            });
                            stepData.push(_latest);
                            curAngle = _latest.endAngle;
                        }
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), null, _this3.renderSectorsStatically(stepData));
                });
            }
        },
        {
            key: "attachKeyboardHandlers",
            value: function attachKeyboardHandlers(pieRef) {
                var _this4 = this;
                // eslint-disable-next-line no-param-reassign
                pieRef.onkeydown = function(e) {
                    if (!e.altKey) switch(e.key){
                        case 'ArrowLeft':
                            var next = ++_this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[next].focus();
                            _this4.setState({
                                sectorToFocus: next
                            });
                            break;
                        case 'ArrowRight':
                            var _next = --_this4.state.sectorToFocus < 0 ? _this4.sectorRefs.length - 1 : _this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[_next].focus();
                            _this4.setState({
                                sectorToFocus: _next
                            });
                            break;
                        case 'Escape':
                            _this4.sectorRefs[_this4.state.sectorToFocus].blur();
                            _this4.setState({
                                sectorToFocus: 0
                            });
                            break;
                        default:
                    }
                };
            }
        },
        {
            key: "renderSectors",
            value: function renderSectors() {
                var _this$props4 = this.props, sectors = _this$props4.sectors, isAnimationActive = _this$props4.isAnimationActive;
                var prevSectors = this.state.prevSectors;
                if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, _isEqualDefault.default)(prevSectors, sectors))) return this.renderSectorsWithAnimation();
                return this.renderSectorsStatically(sectors);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.pieRef) this.attachKeyboardHandlers(this.pieRef);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                var _this$props5 = this.props, hide = _this$props5.hide, sectors = _this$props5.sectors, className = _this$props5.className, label = _this$props5.label, cx = _this$props5.cx, cy = _this$props5.cy, innerRadius = _this$props5.innerRadius, outerRadius = _this$props5.outerRadius, isAnimationActive = _this$props5.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (hide || !sectors || !sectors.length || !(0, _dataUtils.isNumber)(cx) || !(0, _dataUtils.isNumber)(cy) || !(0, _dataUtils.isNumber)(innerRadius) || !(0, _dataUtils.isNumber)(outerRadius)) return null;
                var layerClass = (0, _clsxDefault.default)('recharts-pie', className);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    tabIndex: this.props.rootTabIndex,
                    className: layerClass,
                    ref: function ref(_ref3) {
                        _this5.pieRef = _ref3;
                    }
                }, this.renderSectors(), label && this.renderLabels(sectors), (0, _label.Label).renderCallByParent(this.props, null, false), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(this.props, sectors, false));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (prevState.prevIsAnimationActive !== nextProps.isAnimationActive) return {
                    prevIsAnimationActive: nextProps.isAnimationActive,
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: [],
                    isAnimationFinished: true
                };
                if (nextProps.isAnimationActive && nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: prevState.curSectors,
                    isAnimationFinished: true
                };
                if (nextProps.sectors !== prevState.curSectors) return {
                    curSectors: nextProps.sectors,
                    isAnimationFinished: true
                };
                return null;
            }
        },
        {
            key: "getTextAnchor",
            value: function getTextAnchor(x, cx) {
                if (x > cx) return 'start';
                if (x < cx) return 'end';
                return 'middle';
            }
        },
        {
            key: "renderLabelLineItem",
            value: function renderLabelLineItem(option, props, key) {
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                if ((0, _isFunctionDefault.default)(option)) return option(props);
                var className = (0, _clsxDefault.default)('recharts-pie-label-line', typeof option !== 'boolean' ? option.className : '');
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _curve.Curve), _extends({}, props, {
                    key: key,
                    type: "linear",
                    className: className
                }));
            }
        },
        {
            key: "renderLabelItem",
            value: function renderLabelItem(option, props, value) {
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                var label = value;
                if ((0, _isFunctionDefault.default)(option)) {
                    label = option(props);
                    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(label)) return label;
                }
                var className = (0, _clsxDefault.default)('recharts-pie-label-text', typeof option !== 'boolean' && !(0, _isFunctionDefault.default)(option) ? option.className : '');
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({}, props, {
                    alignmentBaseline: "middle",
                    className: className
                }), label);
            }
        }
    ]);
}((0, _react.PureComponent));
_Pie = Pie;
_defineProperty(Pie, "displayName", 'Pie');
_defineProperty(Pie, "defaultProps", {
    stroke: '#fff',
    fill: '#808080',
    legendType: 'rect',
    cx: '50%',
    cy: '50%',
    startAngle: 0,
    endAngle: 360,
    innerRadius: 0,
    outerRadius: '80%',
    paddingAngle: 0,
    labelLine: true,
    hide: false,
    minAngle: 0,
    isAnimationActive: !(0, _global.Global).isSsr,
    animationBegin: 400,
    animationDuration: 1500,
    animationEasing: 'ease',
    nameKey: 'name',
    blendStroke: false,
    rootTabIndex: 0
});
_defineProperty(Pie, "parseDeltaAngle", function(startAngle, endAngle) {
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
});
_defineProperty(Pie, "getRealPieData", function(itemProps) {
    var data = itemProps.data, children = itemProps.children;
    var presentationProps = (0, _reactUtils.filterProps)(itemProps, false);
    var cells = (0, _reactUtils.findAllByType)(children, (0, _cell.Cell));
    if (data && data.length) return data.map(function(entry, index) {
        return _objectSpread(_objectSpread(_objectSpread({
            payload: entry
        }, presentationProps), entry), cells && cells[index] && cells[index].props);
    });
    if (cells && cells.length) return cells.map(function(cell) {
        return _objectSpread(_objectSpread({}, presentationProps), cell.props);
    });
    return [];
});
_defineProperty(Pie, "parseCoordinateOfPie", function(itemProps, offset) {
    var top = offset.top, left = offset.left, width = offset.width, height = offset.height;
    var maxPieRadius = (0, _polarUtils.getMaxRadius)(width, height);
    var cx = left + (0, _dataUtils.getPercentValue)(itemProps.cx, width, width / 2);
    var cy = top + (0, _dataUtils.getPercentValue)(itemProps.cy, height, height / 2);
    var innerRadius = (0, _dataUtils.getPercentValue)(itemProps.innerRadius, maxPieRadius, 0);
    var outerRadius = (0, _dataUtils.getPercentValue)(itemProps.outerRadius, maxPieRadius, maxPieRadius * 0.8);
    var maxRadius = itemProps.maxRadius || Math.sqrt(width * width + height * height) / 2;
    return {
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        maxRadius: maxRadius
    };
});
_defineProperty(Pie, "getComposedData", function(_ref4) {
    var item = _ref4.item, offset = _ref4.offset;
    var itemProps = item.type.defaultProps !== undefined ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var pieData = _Pie.getRealPieData(itemProps);
    if (!pieData || !pieData.length) return null;
    var cornerRadius = itemProps.cornerRadius, startAngle = itemProps.startAngle, endAngle = itemProps.endAngle, paddingAngle = itemProps.paddingAngle, dataKey = itemProps.dataKey, nameKey = itemProps.nameKey, valueKey = itemProps.valueKey, tooltipType = itemProps.tooltipType;
    var minAngle = Math.abs(itemProps.minAngle);
    var coordinate = _Pie.parseCoordinateOfPie(itemProps, offset);
    var deltaAngle = _Pie.parseDeltaAngle(startAngle, endAngle);
    var absDeltaAngle = Math.abs(deltaAngle);
    var realDataKey = dataKey;
    if ((0, _isNilDefault.default)(dataKey) && (0, _isNilDefault.default)(valueKey)) {
        (0, _logUtils.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
        realDataKey = 'value';
    } else if ((0, _isNilDefault.default)(dataKey)) {
        (0, _logUtils.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
        realDataKey = valueKey;
    }
    var notZeroItemCount = pieData.filter(function(entry) {
        return (0, _chartUtils.getValueByDataKey)(entry, realDataKey, 0) !== 0;
    }).length;
    var totalPadingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle;
    var realTotalAngle = absDeltaAngle - notZeroItemCount * minAngle - totalPadingAngle;
    var sum = pieData.reduce(function(result, entry) {
        var val = (0, _chartUtils.getValueByDataKey)(entry, realDataKey, 0);
        return result + ((0, _dataUtils.isNumber)(val) ? val : 0);
    }, 0);
    var sectors;
    if (sum > 0) {
        var prev;
        sectors = pieData.map(function(entry, i) {
            var val = (0, _chartUtils.getValueByDataKey)(entry, realDataKey, 0);
            var name = (0, _chartUtils.getValueByDataKey)(entry, nameKey, i);
            var percent = ((0, _dataUtils.isNumber)(val) ? val : 0) / sum;
            var tempStartAngle;
            if (i) tempStartAngle = prev.endAngle + (0, _dataUtils.mathSign)(deltaAngle) * paddingAngle * (val !== 0 ? 1 : 0);
            else tempStartAngle = startAngle;
            var tempEndAngle = tempStartAngle + (0, _dataUtils.mathSign)(deltaAngle) * ((val !== 0 ? minAngle : 0) + percent * realTotalAngle);
            var midAngle = (tempStartAngle + tempEndAngle) / 2;
            var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
            var tooltipPayload = [
                {
                    name: name,
                    value: val,
                    payload: entry,
                    dataKey: realDataKey,
                    type: tooltipType
                }
            ];
            var tooltipPosition = (0, _polarUtils.polarToCartesian)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
            prev = _objectSpread(_objectSpread(_objectSpread({
                percent: percent,
                cornerRadius: cornerRadius,
                name: name,
                tooltipPayload: tooltipPayload,
                midAngle: midAngle,
                middleRadius: middleRadius,
                tooltipPosition: tooltipPosition
            }, entry), coordinate), {}, {
                value: (0, _chartUtils.getValueByDataKey)(entry, realDataKey),
                startAngle: tempStartAngle,
                endAngle: tempEndAngle,
                payload: entry,
                paddingAngle: (0, _dataUtils.mathSign)(deltaAngle) * paddingAngle
            });
            return prev;
        });
    }
    return _objectSpread(_objectSpread({}, coordinate), {}, {
        sectors: sectors,
        data: pieData
    });
});

},{"react":"eGun2","react-smooth":"ekPiD","lodash/get":"dEpuO","lodash/isEqual":"kMH36","lodash/isNil":"lYi7Z","lodash/isFunction":"2KQKo","clsx":"3mzHT","../container/Layer":"gNfib","../shape/Curve":"3D54B","../component/Text":"6tNNj","../component/Label":"jhet4","../component/LabelList":"j6MTq","../component/Cell":"6TviG","../util/ReactUtils":"dBf5D","../util/Global":"dWTWi","../util/PolarUtils":"27snq","../util/DataUtils":"lsl3R","../util/ChartUtils":"55u3i","../util/LogUtils":"7Bf7y","../util/types":"5mtYY","../util/ActiveShapeUtils":"6kRg3","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"erEnc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Radar", ()=>Radar);
/**
 * @fileOverview Radar
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _first = require("lodash/first");
var _firstDefault = parcelHelpers.interopDefault(_first);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../util/DataUtils");
var _global = require("../util/Global");
var _polarUtils = require("../util/PolarUtils");
var _chartUtils = require("../util/ChartUtils");
var _polygon = require("../shape/Polygon");
var _dot = require("../shape/Dot");
var _layer = require("../container/Layer");
var _labelList = require("../component/LabelList");
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "key"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var Radar = /*#__PURE__*/ function(_PureComponent) {
    function Radar() {
        var _this;
        _classCallCheck(this, Radar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, Radar, [].concat(args));
        _defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        _defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, _isFunctionDefault.default)(onAnimationEnd)) onAnimationEnd();
        });
        _defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, _isFunctionDefault.default)(onAnimationStart)) onAnimationStart();
        });
        _defineProperty(_this, "handleMouseEnter", function(e) {
            var onMouseEnter = _this.props.onMouseEnter;
            if (onMouseEnter) onMouseEnter(_this.props, e);
        });
        _defineProperty(_this, "handleMouseLeave", function(e) {
            var onMouseLeave = _this.props.onMouseLeave;
            if (onMouseLeave) onMouseLeave(_this.props, e);
        });
        return _this;
    }
    _inherits(Radar, _PureComponent);
    return _createClass(Radar, [
        {
            key: "renderDots",
            value: function renderDots(points) {
                var _this$props = this.props, dot = _this$props.dot, dataKey = _this$props.dataKey;
                var baseProps = (0, _reactUtils.filterProps)(this.props, false);
                var customDotProps = (0, _reactUtils.filterProps)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = _objectSpread(_objectSpread(_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, baseProps), customDotProps), {}, {
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        payload: entry
                    });
                    return Radar.renderDotItem(dot, dotProps);
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-radar-dots"
                }, dots);
            }
        },
        {
            key: "renderPolygonStatically",
            value: function renderPolygonStatically(points) {
                var _this$props2 = this.props, shape = _this$props2.shape, dot = _this$props2.dot, isRange = _this$props2.isRange, baseLinePoints = _this$props2.baseLinePoints, connectNulls = _this$props2.connectNulls;
                var radar;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(shape)) radar = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(shape, _objectSpread(_objectSpread({}, this.props), {}, {
                    points: points
                }));
                else if ((0, _isFunctionDefault.default)(shape)) radar = shape(_objectSpread(_objectSpread({}, this.props), {}, {
                    points: points
                }));
                else radar = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _polygon.Polygon), _extends({}, (0, _reactUtils.filterProps)(this.props, true), {
                    onMouseEnter: this.handleMouseEnter,
                    onMouseLeave: this.handleMouseLeave,
                    points: points,
                    baseLinePoints: isRange ? baseLinePoints : null,
                    connectNulls: connectNulls
                }));
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-radar-polygon"
                }, radar, dot ? this.renderDots(points) : null);
            }
        },
        {
            key: "renderPolygonWithAnimation",
            value: function renderPolygonWithAnimation() {
                var _this2 = this;
                var _this$props3 = this.props, points = _this$props3.points, isAnimationActive = _this$props3.isAnimationActive, animationBegin = _this$props3.animationBegin, animationDuration = _this$props3.animationDuration, animationEasing = _this$props3.animationEasing, animationId = _this$props3.animationId;
                var prevPoints = this.state.prevPoints;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "radar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var prevPointsDiffFactor = prevPoints && prevPoints.length / points.length;
                    var stepData = points.map(function(entry, index) {
                        var prev = prevPoints && prevPoints[Math.floor(index * prevPointsDiffFactor)];
                        if (prev) {
                            var _interpolatorX = (0, _dataUtils.interpolateNumber)(prev.x, entry.x);
                            var _interpolatorY = (0, _dataUtils.interpolateNumber)(prev.y, entry.y);
                            return _objectSpread(_objectSpread({}, entry), {}, {
                                x: _interpolatorX(t),
                                y: _interpolatorY(t)
                            });
                        }
                        var interpolatorX = (0, _dataUtils.interpolateNumber)(entry.cx, entry.x);
                        var interpolatorY = (0, _dataUtils.interpolateNumber)(entry.cy, entry.y);
                        return _objectSpread(_objectSpread({}, entry), {}, {
                            x: interpolatorX(t),
                            y: interpolatorY(t)
                        });
                    });
                    return _this2.renderPolygonStatically(stepData);
                });
            }
        },
        {
            key: "renderPolygon",
            value: function renderPolygon() {
                var _this$props4 = this.props, points = _this$props4.points, isAnimationActive = _this$props4.isAnimationActive, isRange = _this$props4.isRange;
                var prevPoints = this.state.prevPoints;
                if (isAnimationActive && points && points.length && !isRange && (!prevPoints || !(0, _isEqualDefault.default)(prevPoints, points))) return this.renderPolygonWithAnimation();
                return this.renderPolygonStatically(points);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, hide = _this$props5.hide, className = _this$props5.className, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, _clsxDefault.default)('recharts-radar', className);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass
                }, this.renderPolygon(), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "renderDotItem",
            value: function renderDotItem(option, props) {
                var dotItem;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) dotItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) dotItem = option(props);
                else {
                    var key = props.key, dotProps = _objectWithoutProperties(props, _excluded);
                    dotItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), _extends({}, dotProps, {
                        key: key,
                        className: (0, _clsxDefault.default)('recharts-radar-dot', typeof option !== 'boolean' ? option.className : '')
                    }));
                }
                return dotItem;
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(Radar, "displayName", 'Radar');
_defineProperty(Radar, "defaultProps", {
    angleAxisId: 0,
    radiusAxisId: 0,
    hide: false,
    activeDot: true,
    dot: false,
    legendType: 'rect',
    isAnimationActive: !(0, _global.Global).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
});
_defineProperty(Radar, "getComposedData", function(_ref2) {
    var radiusAxis = _ref2.radiusAxis, angleAxis = _ref2.angleAxis, displayedData = _ref2.displayedData, dataKey = _ref2.dataKey, bandSize = _ref2.bandSize;
    var cx = angleAxis.cx, cy = angleAxis.cy;
    var isRange = false;
    var points = [];
    var angleBandSize = angleAxis.type !== 'number' ? bandSize !== null && bandSize !== void 0 ? bandSize : 0 : 0;
    displayedData.forEach(function(entry, i) {
        var name = (0, _chartUtils.getValueByDataKey)(entry, angleAxis.dataKey, i);
        var value = (0, _chartUtils.getValueByDataKey)(entry, dataKey);
        var angle = angleAxis.scale(name) + angleBandSize;
        var pointValue = Array.isArray(value) ? (0, _lastDefault.default)(value) : value;
        var radius = (0, _isNilDefault.default)(pointValue) ? undefined : radiusAxis.scale(pointValue);
        if (Array.isArray(value) && value.length >= 2) isRange = true;
        points.push(_objectSpread(_objectSpread({}, (0, _polarUtils.polarToCartesian)(cx, cy, radius, angle)), {}, {
            name: name,
            value: value,
            cx: cx,
            cy: cy,
            radius: radius,
            angle: angle,
            payload: entry
        }));
    });
    var baseLinePoints = [];
    if (isRange) points.forEach(function(point) {
        if (Array.isArray(point.value)) {
            var baseValue = (0, _firstDefault.default)(point.value);
            var radius = (0, _isNilDefault.default)(baseValue) ? undefined : radiusAxis.scale(baseValue);
            baseLinePoints.push(_objectSpread(_objectSpread({}, point), {}, {
                radius: radius
            }, (0, _polarUtils.polarToCartesian)(cx, cy, radius, point.angle)));
        } else baseLinePoints.push(point);
    });
    return {
        points: points,
        isRange: isRange,
        baseLinePoints: baseLinePoints
    };
});

},{"react":"eGun2","react-smooth":"ekPiD","lodash/isNil":"lYi7Z","lodash/last":"747XP","lodash/first":"88Rxu","lodash/isEqual":"kMH36","lodash/isFunction":"2KQKo","clsx":"3mzHT","../util/DataUtils":"lsl3R","../util/Global":"dWTWi","../util/PolarUtils":"27snq","../util/ChartUtils":"55u3i","../shape/Polygon":"9X8Ya","../shape/Dot":"lScwe","../container/Layer":"gNfib","../component/LabelList":"j6MTq","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"88Rxu":[function(require,module,exports,__globalThis) {
module.exports = require("e3f7df4b34be229f");

},{"e3f7df4b34be229f":"85iCE"}],"85iCE":[function(require,module,exports,__globalThis) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = head;

},{}],"6Prav":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadialBar", ()=>RadialBar);
/**
 * @fileOverview Render a group of radial bar
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _radialBarUtils = require("../util/RadialBarUtils");
var _layer = require("../container/Layer");
var _reactUtils = require("../util/ReactUtils");
var _global = require("../util/Global");
var _labelList = require("../component/LabelList");
var _cell = require("../component/Cell");
var _dataUtils = require("../util/DataUtils");
var _chartUtils = require("../util/ChartUtils");
var _types = require("../util/types");
var _polarUtils = require("../util/PolarUtils");
var _excluded = [
    "shape",
    "activeShape",
    "activeIndex",
    "cornerRadius"
], _excluded2 = [
    "value",
    "background"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var RadialBar = /*#__PURE__*/ function(_PureComponent) {
    function RadialBar() {
        var _this;
        _classCallCheck(this, RadialBar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, RadialBar, [].concat(args));
        _defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        _defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, _isFunctionDefault.default)(onAnimationEnd)) onAnimationEnd();
        });
        _defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, _isFunctionDefault.default)(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    _inherits(RadialBar, _PureComponent);
    return _createClass(RadialBar, [
        {
            key: "getDeltaAngle",
            value: function getDeltaAngle() {
                var _this$props = this.props, startAngle = _this$props.startAngle, endAngle = _this$props.endAngle;
                var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
                var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
                return sign * deltaAngle;
            }
        },
        {
            key: "renderSectorsStatically",
            value: function renderSectorsStatically(sectors) {
                var _this2 = this;
                var _this$props2 = this.props, shape = _this$props2.shape, activeShape = _this$props2.activeShape, activeIndex = _this$props2.activeIndex, cornerRadius = _this$props2.cornerRadius, others = _objectWithoutProperties(_this$props2, _excluded);
                var baseProps = (0, _reactUtils.filterProps)(others, false);
                return sectors.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var props = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, baseProps), {}, {
                        cornerRadius: (0, _radialBarUtils.parseCornerRadius)(cornerRadius)
                    }, entry), (0, _types.adaptEventsOfChild)(_this2.props, entry, i)), {}, {
                        className: "recharts-radial-bar-sector ".concat(entry.className),
                        forceCornerRadius: others.forceCornerRadius,
                        cornerIsExternal: others.cornerIsExternal,
                        isActive: isActive,
                        option: isActive ? activeShape : shape
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radialBarUtils.RadialBarSector), _extends({}, props, {
                        key: "sector-".concat(i)
                    }));
                });
            }
        },
        {
            key: "renderSectorsWithAnimation",
            value: function renderSectorsWithAnimation() {
                var _this3 = this;
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive, animationBegin = _this$props3.animationBegin, animationDuration = _this$props3.animationDuration, animationEasing = _this$props3.animationEasing, animationId = _this$props3.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "radialBar-".concat(animationId),
                    onAnimationStart: this.handleAnimationStart,
                    onAnimationEnd: this.handleAnimationEnd
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorStartAngle = (0, _dataUtils.interpolateNumber)(prev.startAngle, entry.startAngle);
                            var interpolatorEndAngle = (0, _dataUtils.interpolateNumber)(prev.endAngle, entry.endAngle);
                            return _objectSpread(_objectSpread({}, entry), {}, {
                                startAngle: interpolatorStartAngle(t),
                                endAngle: interpolatorEndAngle(t)
                            });
                        }
                        var endAngle = entry.endAngle, startAngle = entry.startAngle;
                        var interpolator = (0, _dataUtils.interpolateNumber)(startAngle, endAngle);
                        return _objectSpread(_objectSpread({}, entry), {}, {
                            endAngle: interpolator(t)
                        });
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), null, _this3.renderSectorsStatically(stepData));
                });
            }
        },
        {
            key: "renderSectors",
            value: function renderSectors() {
                var _this$props4 = this.props, data = _this$props4.data, isAnimationActive = _this$props4.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqualDefault.default)(prevData, data))) return this.renderSectorsWithAnimation();
                return this.renderSectorsStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground(sectors) {
                var _this4 = this;
                var cornerRadius = this.props.cornerRadius;
                var backgroundProps = (0, _reactUtils.filterProps)(this.props.background, false);
                return sectors.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = _objectWithoutProperties(entry, _excluded2);
                    if (!background) return null;
                    var props = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
                        cornerRadius: (0, _radialBarUtils.parseCornerRadius)(cornerRadius)
                    }, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, _types.adaptEventsOfChild)(_this4.props, entry, i)), {}, {
                        index: i,
                        className: (0, _clsxDefault.default)('recharts-radial-bar-background-sector', backgroundProps === null || backgroundProps === void 0 ? void 0 : backgroundProps.className),
                        option: background,
                        isActive: false
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radialBarUtils.RadialBarSector), _extends({}, props, {
                        key: "sector-".concat(i)
                    }));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, hide = _this$props5.hide, data = _this$props5.data, className = _this$props5.className, background = _this$props5.background, isAnimationActive = _this$props5.isAnimationActive;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, _clsxDefault.default)('recharts-area', className);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass
                }, background && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-radial-bar-background"
                }, this.renderBackground(data)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-radial-bar-sectors"
                }, this.renderSectors()), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(_objectSpread({}, this.props), data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(RadialBar, "displayName", 'RadialBar');
_defineProperty(RadialBar, "defaultProps", {
    angleAxisId: 0,
    radiusAxisId: 0,
    minPointSize: 0,
    hide: false,
    legendType: 'rect',
    data: [],
    isAnimationActive: !(0, _global.Global).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    forceCornerRadius: false,
    cornerIsExternal: false
});
_defineProperty(RadialBar, "getComposedData", function(_ref2) {
    var item = _ref2.item, props = _ref2.props, radiusAxis = _ref2.radiusAxis, radiusAxisTicks = _ref2.radiusAxisTicks, angleAxis = _ref2.angleAxis, angleAxisTicks = _ref2.angleAxisTicks, displayedData = _ref2.displayedData, dataKey = _ref2.dataKey, stackedData = _ref2.stackedData, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, dataStartIndex = _ref2.dataStartIndex;
    var pos = (0, _chartUtils.findPositionOfBar)(barPosition, item);
    if (!pos) return null;
    var cx = angleAxis.cx, cy = angleAxis.cy;
    var layout = props.layout;
    var _item$props = item.props, children = _item$props.children, minPointSize = _item$props.minPointSize;
    var numericAxis = layout === 'radial' ? angleAxis : radiusAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, _chartUtils.getBaseValueOfBar)({
        numericAxis: numericAxis
    });
    var cells = (0, _reactUtils.findAllByType)(children, (0, _cell.Cell));
    var sectors = displayedData.map(function(entry, index) {
        var value, innerRadius, outerRadius, startAngle, endAngle, backgroundSector;
        if (stackedData) value = (0, _chartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, _chartUtils.getValueByDataKey)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        if (layout === 'radial') {
            innerRadius = (0, _chartUtils.getCateCoordinateOfBar)({
                axis: radiusAxis,
                ticks: radiusAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            endAngle = angleAxis.scale(value[1]);
            startAngle = angleAxis.scale(value[0]);
            outerRadius = innerRadius + pos.size;
            var deltaAngle = endAngle - startAngle;
            if (Math.abs(minPointSize) > 0 && Math.abs(deltaAngle) < Math.abs(minPointSize)) {
                var delta = (0, _dataUtils.mathSign)(deltaAngle || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaAngle));
                endAngle += delta;
            }
            backgroundSector = {
                background: {
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    startAngle: props.startAngle,
                    endAngle: props.endAngle
                }
            };
        } else {
            innerRadius = radiusAxis.scale(value[0]);
            outerRadius = radiusAxis.scale(value[1]);
            startAngle = (0, _chartUtils.getCateCoordinateOfBar)({
                axis: angleAxis,
                ticks: angleAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            endAngle = startAngle + pos.size;
            var deltaRadius = outerRadius - innerRadius;
            if (Math.abs(minPointSize) > 0 && Math.abs(deltaRadius) < Math.abs(minPointSize)) {
                var _delta = (0, _dataUtils.mathSign)(deltaRadius || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaRadius));
                outerRadius += _delta;
            }
        }
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, entry), backgroundSector), {}, {
            payload: entry,
            value: stackedData ? value : value[1],
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, _chartUtils.getTooltipItem)(item, entry)
            ],
            tooltipPosition: (0, _polarUtils.polarToCartesian)(cx, cy, (innerRadius + outerRadius) / 2, (startAngle + endAngle) / 2)
        });
    });
    return {
        data: sectors,
        layout: layout
    };
});

},{"react":"eGun2","clsx":"3mzHT","react-smooth":"ekPiD","lodash/isEqual":"kMH36","lodash/isFunction":"2KQKo","../util/RadialBarUtils":"6xrwK","../container/Layer":"gNfib","../util/ReactUtils":"dBf5D","../util/Global":"dWTWi","../component/LabelList":"j6MTq","../component/Cell":"6TviG","../util/DataUtils":"lsl3R","../util/ChartUtils":"55u3i","../util/types":"5mtYY","../util/PolarUtils":"27snq","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6xrwK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseCornerRadius", ()=>parseCornerRadius);
// Sector props is expecting cx, cy as numbers.
// When props are being spread in from a user defined component in RadialBar,
// the prop types of an SVGElement have these typed as string | number.
// This function will return the passed in props along with cx, cy as numbers.
parcelHelpers.export(exports, "typeGuardSectorProps", ()=>typeGuardSectorProps);
parcelHelpers.export(exports, "RadialBarSector", ()=>RadialBarSector);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _activeShapeUtils = require("./ActiveShapeUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function parseCornerRadius(cornerRadius) {
    if (typeof cornerRadius === 'string') return parseInt(cornerRadius, 10);
    return cornerRadius;
}
function typeGuardSectorProps(option, props) {
    var cxValue = "".concat(props.cx || option.cx);
    var cx = Number(cxValue);
    var cyValue = "".concat(props.cy || option.cy);
    var cy = Number(cyValue);
    return _objectSpread(_objectSpread(_objectSpread({}, props), option), {}, {
        cx: cx,
        cy: cy
    });
}
function RadialBarSector(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _activeShapeUtils.Shape), _extends({
        shapeType: "sector",
        propTransformer: typeGuardSectorProps
    }, props));
}

},{"react":"eGun2","./ActiveShapeUtils":"6kRg3","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eU152":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Line", ()=>Line);
/**
 * @fileOverview Line
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _curve = require("../shape/Curve");
var _dot = require("../shape/Dot");
var _layer = require("../container/Layer");
var _labelList = require("../component/LabelList");
var _errorBar = require("./ErrorBar");
var _dataUtils = require("../util/DataUtils");
var _reactUtils = require("../util/ReactUtils");
var _global = require("../util/Global");
var _chartUtils = require("../util/ChartUtils");
var _excluded = [
    "type",
    "layout",
    "connectNulls",
    "ref"
], _excluded2 = [
    "key"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var Line = /*#__PURE__*/ function(_PureComponent) {
    function Line() {
        var _this;
        _classCallCheck(this, Line);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, Line, [].concat(args));
        _defineProperty(_this, "state", {
            isAnimationFinished: true,
            totalLength: 0
        });
        _defineProperty(_this, "generateSimpleStrokeDasharray", function(totalLength, length) {
            return "".concat(length, "px ").concat(totalLength - length, "px");
        });
        _defineProperty(_this, "getStrokeDasharray", function(length, totalLength, lines) {
            var lineLength = lines.reduce(function(pre, next) {
                return pre + next;
            });
            // if lineLength is 0 return the default when no strokeDasharray is provided
            if (!lineLength) return _this.generateSimpleStrokeDasharray(totalLength, length);
            var count = Math.floor(length / lineLength);
            var remainLength = length % lineLength;
            var restLength = totalLength - length;
            var remainLines = [];
            for(var i = 0, sum = 0; i < lines.length; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
                remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [
                    remainLength - sum
                ]);
                break;
            }
            var emptyLines = remainLines.length % 2 === 0 ? [
                0,
                restLength
            ] : [
                restLength
            ];
            return [].concat(_toConsumableArray(Line.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function(line) {
                return "".concat(line, "px");
            }).join(', ');
        });
        _defineProperty(_this, "id", (0, _dataUtils.uniqueId)('recharts-line-'));
        _defineProperty(_this, "pathRef", function(node) {
            _this.mainCurve = node;
        });
        _defineProperty(_this, "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
            if (_this.props.onAnimationEnd) _this.props.onAnimationEnd();
        });
        _defineProperty(_this, "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
            if (_this.props.onAnimationStart) _this.props.onAnimationStart();
        });
        return _this;
    }
    _inherits(Line, _PureComponent);
    return _createClass(Line, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                if (totalLength !== this.state.totalLength) this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                var curveDom = this.mainCurve;
                try {
                    return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
                } catch (err) {
                    return 0;
                }
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, points = _this$props.points, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, layout = _this$props.layout, children = _this$props.children;
                var errorBarItems = (0, _reactUtils.findAllByType)(children, (0, _errorBar.ErrorBar));
                if (!errorBarItems) return null;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: dataPoint.value,
                        errorVal: (0, _chartUtils.getValueByDataKey)(dataPoint.payload, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(item, {
                        key: "bar-".concat(item.props.dataKey),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props2 = this.props, dot = _this$props2.dot, points = _this$props2.points, dataKey = _this$props2.dataKey;
                var lineProps = (0, _reactUtils.filterProps)(this.props, false);
                var customDotProps = (0, _reactUtils.filterProps)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = _objectSpread(_objectSpread(_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, lineProps), customDotProps), {}, {
                        index: i,
                        cx: entry.x,
                        cy: entry.y,
                        value: entry.value,
                        dataKey: dataKey,
                        payload: entry.payload,
                        points: points
                    });
                    return Line.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                    className: "recharts-line-dots",
                    key: "dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderCurveStatically",
            value: function renderCurveStatically(points, needClip, clipPathId, props) {
                var _this$props3 = this.props, type = _this$props3.type, layout = _this$props3.layout, connectNulls = _this$props3.connectNulls, ref = _this$props3.ref, others = _objectWithoutProperties(_this$props3, _excluded);
                var curveProps = _objectSpread(_objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(others, true)), {}, {
                    fill: 'none',
                    className: 'recharts-line-curve',
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
                    points: points
                }, props), {}, {
                    type: type,
                    layout: layout,
                    connectNulls: connectNulls
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _curve.Curve), _extends({}, curveProps, {
                    pathRef: this.pathRef
                }));
            }
        },
        {
            key: "renderCurveWithAnimation",
            value: function renderCurveWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props4 = this.props, points = _this$props4.points, strokeDasharray = _this$props4.strokeDasharray, isAnimationActive = _this$props4.isAnimationActive, animationBegin = _this$props4.animationBegin, animationDuration = _this$props4.animationDuration, animationEasing = _this$props4.animationEasing, animationId = _this$props4.animationId, animateNewValues = _this$props4.animateNewValues, width = _this$props4.width, height = _this$props4.height;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, totalLength = _this$state.totalLength;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "line-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        var stepData = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, _dataUtils.interpolateNumber)(prev.x, entry.x);
                                var interpolatorY = (0, _dataUtils.interpolateNumber)(prev.y, entry.y);
                                return _objectSpread(_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            // magic number of faking previous x and y location
                            if (animateNewValues) {
                                var _interpolatorX = (0, _dataUtils.interpolateNumber)(width * 2, entry.x);
                                var _interpolatorY = (0, _dataUtils.interpolateNumber)(height / 2, entry.y);
                                return _objectSpread(_objectSpread({}, entry), {}, {
                                    x: _interpolatorX(t),
                                    y: _interpolatorY(t)
                                });
                            }
                            return _objectSpread(_objectSpread({}, entry), {}, {
                                x: entry.x,
                                y: entry.y
                            });
                        });
                        return _this2.renderCurveStatically(stepData, needClip, clipPathId);
                    }
                    var interpolator = (0, _dataUtils.interpolateNumber)(0, totalLength);
                    var curLength = interpolator(t);
                    var currentStrokeDasharray;
                    if (strokeDasharray) {
                        var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function(num) {
                            return parseFloat(num);
                        });
                        currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
                    } else currentStrokeDasharray = _this2.generateSimpleStrokeDasharray(totalLength, curLength);
                    return _this2.renderCurveStatically(points, needClip, clipPathId, {
                        strokeDasharray: currentStrokeDasharray
                    });
                });
            }
        },
        {
            key: "renderCurve",
            value: function renderCurve(needClip, clipPathId) {
                var _this$props5 = this.props, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqualDefault.default)(prevPoints, points))) return this.renderCurveWithAnimation(needClip, clipPathId);
                return this.renderCurveStatically(points, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props6 = this.props, hide = _this$props6.hide, dot = _this$props6.dot, points = _this$props6.points, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, top = _this$props6.top, left = _this$props6.left, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, id = _this$props6.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, _clsxDefault.default)('recharts-line', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, _isNilDefault.default)(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, _reactUtils.filterProps)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, _reactUtils.hasClipDot)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "repeat",
            value: function repeat(lines, count) {
                var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [
                    0
                ]) : lines;
                var result = [];
                for(var i = 0; i < count; ++i)result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
                return result;
            }
        },
        {
            key: "renderDotItem",
            value: function renderDotItem(option, props) {
                var dotItem;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) dotItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) dotItem = option(props);
                else {
                    var key = props.key, dotProps = _objectWithoutProperties(props, _excluded2);
                    var className = (0, _clsxDefault.default)('recharts-line-dot', typeof option !== 'boolean' ? option.className : '');
                    dotItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), _extends({
                        key: key
                    }, dotProps, {
                        className: className
                    }));
                }
                return dotItem;
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(Line, "displayName", 'Line');
_defineProperty(Line, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    connectNulls: false,
    activeDot: true,
    dot: true,
    legendType: 'line',
    stroke: '#3182bd',
    strokeWidth: 1,
    fill: '#fff',
    points: [],
    isAnimationActive: !(0, _global.Global).isSsr,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    hide: false,
    label: false
});
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ _defineProperty(Line, "getComposedData", function(_ref4) {
    var props = _ref4.props, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, dataKey = _ref4.dataKey, bandSize = _ref4.bandSize, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var points = displayedData.map(function(entry, index) {
        var value = (0, _chartUtils.getValueByDataKey)(entry, dataKey);
        if (layout === 'horizontal') return {
            x: (0, _chartUtils.getCateCoordinateOfLine)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: (0, _isNilDefault.default)(value) ? null : yAxis.scale(value),
            value: value,
            payload: entry
        };
        return {
            x: (0, _isNilDefault.default)(value) ? null : xAxis.scale(value),
            y: (0, _chartUtils.getCateCoordinateOfLine)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    return _objectSpread({
        points: points,
        layout: layout
    }, offset);
});

},{"react":"eGun2","react-smooth":"ekPiD","lodash/isFunction":"2KQKo","lodash/isNil":"lYi7Z","lodash/isEqual":"kMH36","clsx":"3mzHT","../shape/Curve":"3D54B","../shape/Dot":"lScwe","../container/Layer":"gNfib","../component/LabelList":"j6MTq","./ErrorBar":"2A4Qz","../util/DataUtils":"lsl3R","../util/ReactUtils":"dBf5D","../util/Global":"dWTWi","../util/ChartUtils":"55u3i","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"nNjdk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Area", ()=>Area);
/**
 * @fileOverview Area
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _max = require("lodash/max");
var _maxDefault = parcelHelpers.interopDefault(_max);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isNaN = require("lodash/isNaN");
var _isNaNDefault = parcelHelpers.interopDefault(_isNaN);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _curve = require("../shape/Curve");
var _dot = require("../shape/Dot");
var _layer = require("../container/Layer");
var _labelList = require("../component/LabelList");
var _global = require("../util/Global");
var _dataUtils = require("../util/DataUtils");
var _chartUtils = require("../util/ChartUtils");
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "layout",
    "type",
    "stroke",
    "connectNulls",
    "isRange",
    "ref"
], _excluded2 = [
    "key"
];
var _Area;
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var Area = /*#__PURE__*/ function(_PureComponent) {
    function Area() {
        var _this;
        _classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, Area, [].concat(args));
        _defineProperty(_this, "state", {
            isAnimationFinished: true
        });
        _defineProperty(_this, "id", (0, _dataUtils.uniqueId)('recharts-area-'));
        _defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, _isFunctionDefault.default)(onAnimationEnd)) onAnimationEnd();
        });
        _defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, _isFunctionDefault.default)(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    _inherits(Area, _PureComponent);
    return _createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, _reactUtils.filterProps)(this.props, false);
                var customDotProps = (0, _reactUtils.filterProps)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = _objectSpread(_objectSpread(_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        index: i,
                        cx: entry.x,
                        cy: entry.y,
                        dataKey: dataKey,
                        value: entry.value,
                        payload: entry.payload,
                        points: points
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, _maxDefault.default)(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, _dataUtils.isNumber)(baseLine) && typeof baseLine === 'number') maxY = Math.max(baseLine, maxY);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxY = Math.max((0, _maxDefault.default)(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, _dataUtils.isNumber)(maxY)) return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, _maxDefault.default)(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, _dataUtils.isNumber)(baseLine) && typeof baseLine === 'number') maxX = Math.max(baseLine, maxX);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxX = Math.max((0, _maxDefault.default)(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, _dataUtils.isNumber)(maxX)) return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === 'vertical') return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = _objectWithoutProperties(_this$props4, _excluded);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _curve.Curve), _extends({}, (0, _reactUtils.filterProps)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== 'none' && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _curve.Curve), _extends({}, (0, _reactUtils.filterProps)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== 'none' && isRange && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _curve.Curve), _extends({}, (0, _reactUtils.filterProps)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
                // const clipPathId = isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, _dataUtils.interpolateNumber)(prev.x, entry.x);
                                var interpolatorY = (0, _dataUtils.interpolateNumber)(prev.y, entry.y);
                                return _objectSpread(_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, _dataUtils.isNumber)(baseLine) && typeof baseLine === 'number') {
                            var interpolator = (0, _dataUtils.interpolateNumber)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, _isNilDefault.default)(baseLine) || (0, _isNaNDefault.default)(baseLine)) {
                            var _interpolator = (0, _dataUtils.interpolateNumber)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, _dataUtils.interpolateNumber)(prev.x, entry.x);
                                var interpolatorY = (0, _dataUtils.interpolateNumber)(prev.y, entry.y);
                                return _objectSpread(_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqualDefault.default)(prevPoints, points) || !(0, _isEqualDefault.default)(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, _clsxDefault.default)('recharts-area', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, _isNilDefault.default)(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, _reactUtils.filterProps)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, _reactUtils.hasClipDot)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
}((0, _react.PureComponent));
_Area = Area;
_defineProperty(Area, "displayName", 'Area');
_defineProperty(Area, "defaultProps", {
    stroke: '#3182bd',
    fill: '#3182bd',
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'line',
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, _global.Global).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
});
_defineProperty(Area, "getBaseValue", function(props, item, xAxis, yAxis) {
    var layout = props.layout, chartBaseValue = props.baseValue;
    var itemBaseValue = item.props.baseValue;
    // The baseValue can be defined both on the AreaChart as well as on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, _dataUtils.isNumber)(baseValue) && typeof baseValue === 'number') return baseValue;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var domainMax = Math.max(domain[0], domain[1]);
        var domainMin = Math.min(domain[0], domain[1]);
        if (baseValue === 'dataMin') return domainMin;
        if (baseValue === 'dataMax') return domainMax;
        return domainMax < 0 ? domainMax : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === 'dataMin') return domain[0];
    if (baseValue === 'dataMax') return domain[1];
    return domain[0];
});
_defineProperty(Area, "getComposedData", function(_ref4) {
    var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = _Area.getBaseValue(props, item, xAxis, yAxis);
    var isHorizontalLayout = layout === 'horizontal';
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = (0, _chartUtils.getValueByDataKey)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = value[1] == null || hasStack && (0, _chartUtils.getValueByDataKey)(entry, dataKey) == null;
        if (isHorizontalLayout) return {
            x: (0, _chartUtils.getCateCoordinateOfLine)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, _chartUtils.getCateCoordinateOfLine)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        var x = Array.isArray(entry.value) ? entry.value[0] : null;
        if (isHorizontalLayout) return {
            x: entry.x,
            y: x != null && entry.y != null ? yAxis.scale(x) : null
        };
        return {
            x: x != null ? xAxis.scale(x) : null,
            y: entry.y
        };
    });
    else baseLine = isHorizontalLayout ? yAxis.scale(baseValue) : xAxis.scale(baseValue);
    return _objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
});
_defineProperty(Area, "renderDotItem", function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) dotItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) dotItem = option(props);
    else {
        var className = (0, _clsxDefault.default)('recharts-area-dot', typeof option !== 'boolean' ? option.className : '');
        var key = props.key, rest = _objectWithoutProperties(props, _excluded2);
        dotItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), _extends({}, rest, {
            key: key,
            className: className
        }));
    }
    return dotItem;
});

},{"react":"eGun2","clsx":"3mzHT","react-smooth":"ekPiD","lodash/isFunction":"2KQKo","lodash/max":"ddnjf","lodash/isNil":"lYi7Z","lodash/isNaN":"aERJU","lodash/isEqual":"kMH36","../shape/Curve":"3D54B","../shape/Dot":"lScwe","../container/Layer":"gNfib","../component/LabelList":"j6MTq","../util/Global":"dWTWi","../util/DataUtils":"lsl3R","../util/ChartUtils":"55u3i","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cEWud":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scatter", ()=>Scatter);
/**
 * @fileOverview Render a group of scatters
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _labelList = require("../component/LabelList");
var _reactUtils = require("../util/ReactUtils");
var _global = require("../util/Global");
var _zaxis = require("./ZAxis");
var _curve = require("../shape/Curve");
var _errorBar = require("./ErrorBar");
var _cell = require("../component/Cell");
var _dataUtils = require("../util/DataUtils");
var _chartUtils = require("../util/ChartUtils");
var _types = require("../util/types");
var _scatterUtils = require("../util/ScatterUtils");
var _Scatter;
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var Scatter = /*#__PURE__*/ function(_PureComponent) {
    function Scatter() {
        var _this;
        _classCallCheck(this, Scatter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, Scatter, [].concat(args));
        _defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        _defineProperty(_this, "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
        });
        _defineProperty(_this, "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
        });
        _defineProperty(_this, "id", (0, _dataUtils.uniqueId)('recharts-scatter-'));
        return _this;
    }
    _inherits(Scatter, _PureComponent);
    return _createClass(Scatter, [
        {
            key: "renderSymbolsStatically",
            value: function renderSymbolsStatically(points) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, activeShape = _this$props.activeShape, activeIndex = _this$props.activeIndex;
                var baseProps = (0, _reactUtils.filterProps)(this.props, false);
                return points.map(function(entry, i) {
                    var isActive = activeIndex === i;
                    var option = isActive ? activeShape : shape;
                    var props = _objectSpread(_objectSpread({}, baseProps), entry);
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: "recharts-scatter-symbol",
                        key: "symbol-".concat(entry === null || entry === void 0 ? void 0 : entry.cx, "-").concat(entry === null || entry === void 0 ? void 0 : entry.cy, "-").concat(entry === null || entry === void 0 ? void 0 : entry.size, "-").concat(i)
                    }, (0, _types.adaptEventsOfChild)(_this2.props, entry, i), {
                        role: "img"
                    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _scatterUtils.ScatterSymbol), _extends({
                        option: option,
                        isActive: isActive,
                        key: "symbol-".concat(i)
                    }, props)));
                });
            }
        },
        {
            key: "renderSymbolsWithAnimation",
            value: function renderSymbolsWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, points = _this$props2.points, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevPoints = this.state.prevPoints;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = points.map(function(entry, index) {
                        var prev = prevPoints && prevPoints[index];
                        if (prev) {
                            var interpolatorCx = (0, _dataUtils.interpolateNumber)(prev.cx, entry.cx);
                            var interpolatorCy = (0, _dataUtils.interpolateNumber)(prev.cy, entry.cy);
                            var interpolatorSize = (0, _dataUtils.interpolateNumber)(prev.size, entry.size);
                            return _objectSpread(_objectSpread({}, entry), {}, {
                                cx: interpolatorCx(t),
                                cy: interpolatorCy(t),
                                size: interpolatorSize(t)
                            });
                        }
                        var interpolator = (0, _dataUtils.interpolateNumber)(0, entry.size);
                        return _objectSpread(_objectSpread({}, entry), {}, {
                            size: interpolator(t)
                        });
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), null, _this3.renderSymbolsStatically(stepData));
                });
            }
        },
        {
            key: "renderSymbols",
            value: function renderSymbols() {
                var _this$props3 = this.props, points = _this$props3.points, isAnimationActive = _this$props3.isAnimationActive;
                var prevPoints = this.state.prevPoints;
                if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqualDefault.default)(prevPoints, points))) return this.renderSymbolsWithAnimation();
                return this.renderSymbolsStatically(points);
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar() {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props4 = this.props, points = _this$props4.points, xAxis = _this$props4.xAxis, yAxis = _this$props4.yAxis, children = _this$props4.children;
                var errorBarItems = (0, _reactUtils.findAllByType)(children, (0, _errorBar.ErrorBar));
                if (!errorBarItems) return null;
                return errorBarItems.map(function(item, i) {
                    var _item$props = item.props, direction = _item$props.direction, errorDataKey = _item$props.dataKey;
                    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(item, {
                        key: "".concat(direction, "-").concat(errorDataKey, "-").concat(points[i]),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: direction === 'x' ? 'vertical' : 'horizontal',
                        dataPointFormatter: function dataPointFormatter(dataPoint, dataKey) {
                            return {
                                x: dataPoint.cx,
                                y: dataPoint.cy,
                                value: direction === 'x' ? +dataPoint.node.x : +dataPoint.node.y,
                                errorVal: (0, _chartUtils.getValueByDataKey)(dataPoint, dataKey)
                            };
                        }
                    });
                });
            }
        },
        {
            key: "renderLine",
            value: function renderLine() {
                var _this$props5 = this.props, points = _this$props5.points, line = _this$props5.line, lineType = _this$props5.lineType, lineJointType = _this$props5.lineJointType;
                var scatterProps = (0, _reactUtils.filterProps)(this.props, false);
                var customLineProps = (0, _reactUtils.filterProps)(line, false);
                var linePoints, lineItem;
                if (lineType === 'joint') linePoints = points.map(function(entry) {
                    return {
                        x: entry.cx,
                        y: entry.cy
                    };
                });
                else if (lineType === 'fitting') {
                    var _getLinearRegression = (0, _dataUtils.getLinearRegression)(points), xmin = _getLinearRegression.xmin, xmax = _getLinearRegression.xmax, a = _getLinearRegression.a, b = _getLinearRegression.b;
                    var linearExp = function linearExp(x) {
                        return a * x + b;
                    };
                    linePoints = [
                        {
                            x: xmin,
                            y: linearExp(xmin)
                        },
                        {
                            x: xmax,
                            y: linearExp(xmax)
                        }
                    ];
                }
                var lineProps = _objectSpread(_objectSpread(_objectSpread({}, scatterProps), {}, {
                    fill: 'none',
                    stroke: scatterProps && scatterProps.fill
                }, customLineProps), {}, {
                    points: linePoints
                });
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(line)) lineItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(line, lineProps);
                else if ((0, _isFunctionDefault.default)(line)) lineItem = line(lineProps);
                else lineItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _curve.Curve), _extends({}, lineProps, {
                    type: lineJointType
                }));
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-scatter-line",
                    key: "recharts-scatter-line"
                }, lineItem);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, points = _this$props6.points, line = _this$props6.line, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, id = _this$props6.id, isAnimationActive = _this$props6.isAnimationActive;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, _clsxDefault.default)('recharts-scatter', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, _isNilDefault.default)(id) ? this.id : id;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass,
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, needClipX || needClipY ? /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, line && this.renderLine(), this.renderErrorBar(), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    key: "recharts-scatter-symbols"
                }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        }
    ]);
}((0, _react.PureComponent));
_Scatter = Scatter;
_defineProperty(Scatter, "displayName", 'Scatter');
_defineProperty(Scatter, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    zAxisId: 0,
    legendType: 'circle',
    lineType: 'joint',
    lineJointType: 'linear',
    data: [],
    shape: 'circle',
    hide: false,
    isAnimationActive: !(0, _global.Global).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'linear'
});
/**
 * Compose the data of each group
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ _defineProperty(Scatter, "getComposedData", function(_ref2) {
    var xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, zAxis = _ref2.zAxis, item = _ref2.item, displayedData = _ref2.displayedData, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, offset = _ref2.offset;
    var tooltipType = item.props.tooltipType;
    var cells = (0, _reactUtils.findAllByType)(item.props.children, (0, _cell.Cell));
    var xAxisDataKey = (0, _isNilDefault.default)(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
    var yAxisDataKey = (0, _isNilDefault.default)(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
    var zAxisDataKey = zAxis && zAxis.dataKey;
    var defaultRangeZ = zAxis ? zAxis.range : (0, _zaxis.ZAxis).defaultProps.range;
    var defaultZ = defaultRangeZ && defaultRangeZ[0];
    var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
    var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
    var points = displayedData.map(function(entry, index) {
        var x = (0, _chartUtils.getValueByDataKey)(entry, xAxisDataKey);
        var y = (0, _chartUtils.getValueByDataKey)(entry, yAxisDataKey);
        var z = !(0, _isNilDefault.default)(zAxisDataKey) && (0, _chartUtils.getValueByDataKey)(entry, zAxisDataKey) || '-';
        var tooltipPayload = [
            {
                name: (0, _isNilDefault.default)(xAxis.dataKey) ? item.props.name : xAxis.name || xAxis.dataKey,
                unit: xAxis.unit || '',
                value: x,
                payload: entry,
                dataKey: xAxisDataKey,
                type: tooltipType
            },
            {
                name: (0, _isNilDefault.default)(yAxis.dataKey) ? item.props.name : yAxis.name || yAxis.dataKey,
                unit: yAxis.unit || '',
                value: y,
                payload: entry,
                dataKey: yAxisDataKey,
                type: tooltipType
            }
        ];
        if (z !== '-') tooltipPayload.push({
            name: zAxis.name || zAxis.dataKey,
            unit: zAxis.unit || '',
            value: z,
            payload: entry,
            dataKey: zAxisDataKey,
            type: tooltipType
        });
        var cx = (0, _chartUtils.getCateCoordinateOfLine)({
            axis: xAxis,
            ticks: xAxisTicks,
            bandSize: xBandSize,
            entry: entry,
            index: index,
            dataKey: xAxisDataKey
        });
        var cy = (0, _chartUtils.getCateCoordinateOfLine)({
            axis: yAxis,
            ticks: yAxisTicks,
            bandSize: yBandSize,
            entry: entry,
            index: index,
            dataKey: yAxisDataKey
        });
        var size = z !== '-' ? zAxis.scale(z) : defaultZ;
        var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
        return _objectSpread(_objectSpread({}, entry), {}, {
            cx: cx,
            cy: cy,
            x: cx - radius,
            y: cy - radius,
            xAxis: xAxis,
            yAxis: yAxis,
            zAxis: zAxis,
            width: 2 * radius,
            height: 2 * radius,
            size: size,
            node: {
                x: x,
                y: y,
                z: z
            },
            tooltipPayload: tooltipPayload,
            tooltipPosition: {
                x: cx,
                y: cy
            },
            payload: entry
        }, cells && cells[index] && cells[index].props);
    });
    return _objectSpread({
        points: points
    }, offset);
});

},{"react":"eGun2","react-smooth":"ekPiD","lodash/isNil":"lYi7Z","lodash/isEqual":"kMH36","lodash/isFunction":"2KQKo","clsx":"3mzHT","../container/Layer":"gNfib","../component/LabelList":"j6MTq","../util/ReactUtils":"dBf5D","../util/Global":"dWTWi","./ZAxis":"9mmH7","../shape/Curve":"3D54B","./ErrorBar":"2A4Qz","../component/Cell":"6TviG","../util/DataUtils":"lsl3R","../util/ChartUtils":"55u3i","../util/types":"5mtYY","../util/ScatterUtils":"jBM3c","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9mmH7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZAxis", ()=>ZAxis);
/**
 * @fileOverview Z Axis
 */ var _react = require("react");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var ZAxis = /*#__PURE__*/ function(_React$Component) {
    function ZAxis() {
        _classCallCheck(this, ZAxis);
        return _callSuper(this, ZAxis, arguments);
    }
    _inherits(ZAxis, _React$Component);
    return _createClass(ZAxis, [
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
}(_react.Component);
_defineProperty(ZAxis, "displayName", 'ZAxis');
_defineProperty(ZAxis, "defaultProps", {
    zAxisId: 0,
    range: [
        64,
        64
    ],
    scale: 'auto',
    type: 'number'
});

},{"react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jBM3c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScatterSymbol", ()=>ScatterSymbol);
var _react = require("react");
var _symbols = require("../shape/Symbols");
var _activeShapeUtils = require("./ActiveShapeUtils");
var _excluded = [
    "option",
    "isActive"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ScatterSymbol(_ref) {
    var option = _ref.option, isActive = _ref.isActive, props = _objectWithoutProperties(_ref, _excluded);
    if (typeof option === 'string') return /*#__PURE__*/ _react.createElement((0, _activeShapeUtils.Shape), _extends({
        option: /*#__PURE__*/ _react.createElement((0, _symbols.Symbols), _extends({
            type: option
        }, props)),
        isActive: isActive,
        shapeType: "symbols"
    }, props));
    return /*#__PURE__*/ _react.createElement((0, _activeShapeUtils.Shape), _extends({
        option: option,
        isActive: isActive,
        shapeType: "symbols"
    }, props));
}

},{"react":"eGun2","../shape/Symbols":"eArZD","./ActiveShapeUtils":"6kRg3","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6HDbf":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Line Chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LineChart", ()=>LineChart);
var _generateCategoricalChart = require("./generateCategoricalChart");
var _line = require("../cartesian/Line");
var _xaxis = require("../cartesian/XAxis");
var _yaxis = require("../cartesian/YAxis");
var _cartesianUtils = require("../util/CartesianUtils");
var LineChart = (0, _generateCategoricalChart.generateCategoricalChart)({
    chartName: 'LineChart',
    GraphicalChild: (0, _line.Line),
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, _xaxis.XAxis)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, _yaxis.YAxis)
        }
    ],
    formatAxisMap: (0, _cartesianUtils.formatAxisMap)
});

},{"./generateCategoricalChart":"l1e9D","../cartesian/Line":"eU152","../cartesian/XAxis":"4nBWG","../cartesian/YAxis":"NHcEZ","../util/CartesianUtils":"1I6yD","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"42UF9":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Pie Chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PieChart", ()=>PieChart);
var _generateCategoricalChart = require("./generateCategoricalChart");
var _polarAngleAxis = require("../polar/PolarAngleAxis");
var _polarRadiusAxis = require("../polar/PolarRadiusAxis");
var _polarUtils = require("../util/PolarUtils");
var _pie = require("../polar/Pie");
var PieChart = (0, _generateCategoricalChart.generateCategoricalChart)({
    chartName: 'PieChart',
    GraphicalChild: (0, _pie.Pie),
    validateTooltipEventTypes: [
        'item'
    ],
    defaultTooltipEventType: 'item',
    legendContent: 'children',
    axisComponents: [
        {
            axisType: 'angleAxis',
            AxisComp: (0, _polarAngleAxis.PolarAngleAxis)
        },
        {
            axisType: 'radiusAxis',
            AxisComp: (0, _polarRadiusAxis.PolarRadiusAxis)
        }
    ],
    formatAxisMap: (0, _polarUtils.formatAxisMap),
    defaultProps: {
        layout: 'centric',
        startAngle: 0,
        endAngle: 360,
        cx: '50%',
        cy: '50%',
        innerRadius: 0,
        outerRadius: '80%'
    }
});

},{"./generateCategoricalChart":"l1e9D","../polar/PolarAngleAxis":"lel0p","../polar/PolarRadiusAxis":"bcj3U","../util/PolarUtils":"27snq","../polar/Pie":"kXPp1","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dzypJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Treemap", ()=>Treemap);
var _isNaN = require("lodash/isNaN");
var _isNaNDefault = parcelHelpers.interopDefault(_isNaN);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
/**
 * @fileOverview TreemapChart
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _tooltip = require("../component/Tooltip");
var _layer = require("../container/Layer");
var _surface = require("../container/Surface");
var _polygon = require("../shape/Polygon");
var _rectangle = require("../shape/Rectangle");
var _chartUtils = require("../util/ChartUtils");
var _constants = require("../util/Constants");
var _dataUtils = require("../util/DataUtils");
var _domutils = require("../util/DOMUtils");
var _global = require("../util/Global");
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "width",
    "height",
    "className",
    "style",
    "children",
    "type"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var NODE_VALUE_KEY = 'value';
var computeNode = function computeNode(_ref) {
    var depth = _ref.depth, node = _ref.node, index = _ref.index, valueKey = _ref.valueKey;
    var children = node.children;
    var childDepth = depth + 1;
    var computedChildren = children && children.length ? children.map(function(child, i) {
        return computeNode({
            depth: childDepth,
            node: child,
            index: i,
            valueKey: valueKey
        });
    }) : null;
    var nodeValue;
    if (children && children.length) nodeValue = computedChildren.reduce(function(result, child) {
        return result + child[NODE_VALUE_KEY];
    }, 0);
    else // TODO need to verify valueKey
    nodeValue = (0, _isNaNDefault.default)(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
    return _objectSpread(_objectSpread({}, node), {}, _defineProperty(_defineProperty(_defineProperty({
        children: computedChildren
    }, NODE_VALUE_KEY, nodeValue), "depth", depth), "index", index));
};
var filterRect = function filterRect(node) {
    return {
        x: node.x,
        y: node.y,
        width: node.width,
        height: node.height
    };
};
// Compute the area for each child based on value & scale.
var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
    var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
    return children.map(function(child) {
        var area = child[NODE_VALUE_KEY] * ratio;
        return _objectSpread(_objectSpread({}, child), {}, {
            area: (0, _isNaNDefault.default)(area) || area <= 0 ? 0 : area
        });
    });
};
// Computes the score for the specified row, as the worst aspect ratio.
var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
    var parentArea = parentSize * parentSize;
    var rowArea = row.area * row.area;
    var _row$reduce = row.reduce(function(result, child) {
        return {
            min: Math.min(result.min, child.area),
            max: Math.max(result.max, child.area)
        };
    }, {
        min: Infinity,
        max: 0
    }), min = _row$reduce.min, max = _row$reduce.max;
    return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
};
var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
    var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;
    if (isFlush || rowHeight > parentRect.height) rowHeight = parentRect.height;
    var curX = parentRect.x;
    var child;
    for(var i = 0, len = row.length; i < len; i++){
        child = row[i];
        child.x = curX;
        child.y = parentRect.y;
        child.height = rowHeight;
        child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
        curX += child.width;
    }
    // add the remain x to the last one of row
    child.width += parentRect.x + parentRect.width - curX;
    return _objectSpread(_objectSpread({}, parentRect), {}, {
        y: parentRect.y + rowHeight,
        height: parentRect.height - rowHeight
    });
};
var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
    var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;
    if (isFlush || rowWidth > parentRect.width) rowWidth = parentRect.width;
    var curY = parentRect.y;
    var child;
    for(var i = 0, len = row.length; i < len; i++){
        child = row[i];
        child.x = parentRect.x;
        child.y = curY;
        child.width = rowWidth;
        child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
        curY += child.height;
    }
    if (child) child.height += parentRect.y + parentRect.height - curY;
    return _objectSpread(_objectSpread({}, parentRect), {}, {
        x: parentRect.x + rowWidth,
        width: parentRect.width - rowWidth
    });
};
var position = function position(row, parentSize, parentRect, isFlush) {
    if (parentSize === parentRect.width) return horizontalPosition(row, parentSize, parentRect, isFlush);
    return verticalPosition(row, parentSize, parentRect, isFlush);
};
// Recursively arranges the specified node's children into squarified rows.
var squarify = function squarify(node, aspectRatio) {
    var children = node.children;
    if (children && children.length) {
        var rect = filterRect(node);
        // maybe a bug
        var row = [];
        var best = Infinity; // the best row score so far
        var child, score; // the current row score
        var size = Math.min(rect.width, rect.height); // initial orientation
        var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node[NODE_VALUE_KEY]);
        var tempChildren = scaleChildren.slice();
        row.area = 0;
        while(tempChildren.length > 0){
            // row first
            // eslint-disable-next-line prefer-destructuring
            row.push(child = tempChildren[0]);
            row.area += child.area;
            score = getWorstScore(row, size, aspectRatio);
            if (score <= best) {
                // continue with this orientation
                tempChildren.shift();
                best = score;
            } else {
                // abort, and try a different orientation
                row.area -= row.pop().area;
                rect = position(row, size, rect, false);
                size = Math.min(rect.width, rect.height);
                row.length = row.area = 0;
                best = Infinity;
            }
        }
        if (row.length) {
            rect = position(row, size, rect, true);
            row.length = row.area = 0;
        }
        return _objectSpread(_objectSpread({}, node), {}, {
            children: scaleChildren.map(function(c) {
                return squarify(c, aspectRatio);
            })
        });
    }
    return node;
};
var defaultState = {
    isTooltipActive: false,
    isAnimationFinished: false,
    activeNode: null,
    formatRoot: null,
    currentRoot: null,
    nestIndex: []
};
var Treemap = /*#__PURE__*/ function(_PureComponent) {
    function Treemap() {
        var _this;
        _classCallCheck(this, Treemap);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, Treemap, [].concat(args));
        _defineProperty(_this, "state", _objectSpread({}, defaultState));
        _defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, _isFunctionDefault.default)(onAnimationEnd)) onAnimationEnd();
        });
        _defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, _isFunctionDefault.default)(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    _inherits(Treemap, _PureComponent);
    return _createClass(Treemap, [
        {
            key: "handleMouseEnter",
            value: function handleMouseEnter(node, e) {
                e.persist();
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, children = _this$props.children;
                var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                if (tooltipItem) this.setState({
                    isTooltipActive: true,
                    activeNode: node
                }, function() {
                    if (onMouseEnter) onMouseEnter(node, e);
                });
                else if (onMouseEnter) onMouseEnter(node, e);
            }
        },
        {
            key: "handleMouseLeave",
            value: function handleMouseLeave(node, e) {
                e.persist();
                var _this$props2 = this.props, onMouseLeave = _this$props2.onMouseLeave, children = _this$props2.children;
                var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                if (tooltipItem) this.setState({
                    isTooltipActive: false,
                    activeNode: null
                }, function() {
                    if (onMouseLeave) onMouseLeave(node, e);
                });
                else if (onMouseLeave) onMouseLeave(node, e);
            }
        },
        {
            key: "handleClick",
            value: function handleClick(node) {
                var _this$props3 = this.props, onClick = _this$props3.onClick, type = _this$props3.type;
                if (type === 'nest' && node.children) {
                    var _this$props4 = this.props, width = _this$props4.width, height = _this$props4.height, dataKey = _this$props4.dataKey, aspectRatio = _this$props4.aspectRatio;
                    var root = computeNode({
                        depth: 0,
                        node: _objectSpread(_objectSpread({}, node), {}, {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        }),
                        index: 0,
                        valueKey: dataKey
                    });
                    var formatRoot = squarify(root, aspectRatio);
                    var nestIndex = this.state.nestIndex;
                    nestIndex.push(node);
                    this.setState({
                        formatRoot: formatRoot,
                        currentRoot: root,
                        nestIndex: nestIndex
                    });
                }
                if (onClick) onClick(node);
            }
        },
        {
            key: "handleNestIndex",
            value: function handleNestIndex(node, i) {
                var nestIndex = this.state.nestIndex;
                var _this$props5 = this.props, width = _this$props5.width, height = _this$props5.height, dataKey = _this$props5.dataKey, aspectRatio = _this$props5.aspectRatio;
                var root = computeNode({
                    depth: 0,
                    node: _objectSpread(_objectSpread({}, node), {}, {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }),
                    index: 0,
                    valueKey: dataKey
                });
                var formatRoot = squarify(root, aspectRatio);
                nestIndex = nestIndex.slice(0, i + 1);
                this.setState({
                    formatRoot: formatRoot,
                    currentRoot: node,
                    nestIndex: nestIndex
                });
            }
        },
        {
            key: "renderItem",
            value: function renderItem(content, nodeProps, isLeaf) {
                var _this2 = this;
                var _this$props6 = this.props, isAnimationActive = _this$props6.isAnimationActive, animationBegin = _this$props6.animationBegin, animationDuration = _this$props6.animationDuration, animationEasing = _this$props6.animationEasing, isUpdateAnimationActive = _this$props6.isUpdateAnimationActive, type = _this$props6.type, animationId = _this$props6.animationId, colorPanel = _this$props6.colorPanel;
                var isAnimationFinished = this.state.isAnimationFinished;
                var width = nodeProps.width, height = nodeProps.height, x = nodeProps.x, y = nodeProps.y, depth = nodeProps.depth;
                var translateX = parseInt("".concat((Math.random() * 2 - 1) * width), 10);
                var event = {};
                if (isLeaf || type === 'nest') event = {
                    onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
                    onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
                    onClick: this.handleClick.bind(this, nodeProps)
                };
                if (!isAnimationActive) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), event, this.constructor.renderContentItem(content, _objectSpread(_objectSpread({}, nodeProps), {}, {
                    isAnimationActive: false,
                    isUpdateAnimationActive: false,
                    width: width,
                    height: height,
                    x: x,
                    y: y
                }), type, colorPanel));
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    key: "treemap-".concat(animationId),
                    from: {
                        x: x,
                        y: y,
                        width: width,
                        height: height
                    },
                    to: {
                        x: x,
                        y: y,
                        width: width,
                        height: height
                    },
                    onAnimationStart: this.handleAnimationStart,
                    onAnimationEnd: this.handleAnimationEnd
                }, function(_ref2) {
                    var currX = _ref2.x, currY = _ref2.y, currWidth = _ref2.width, currHeight = _ref2.height;
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                        from: "translate(".concat(translateX, "px, ").concat(translateX, "px)"),
                        to: "translate(0, 0)",
                        attributeName: "transform",
                        begin: animationBegin,
                        easing: animationEasing,
                        isActive: isAnimationActive,
                        duration: animationDuration
                    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), event, function() {
                        // when animation Duration , only render depth=1 nodes
                        if (depth > 2 && !isAnimationFinished) return null;
                        return _this2.constructor.renderContentItem(content, _objectSpread(_objectSpread({}, nodeProps), {}, {
                            isAnimationActive: isAnimationActive,
                            isUpdateAnimationActive: !isUpdateAnimationActive,
                            width: currWidth,
                            height: currHeight,
                            x: currX,
                            y: currY
                        }), type, colorPanel);
                    }()));
                });
            }
        },
        {
            key: "renderNode",
            value: function renderNode(root, node) {
                var _this3 = this;
                var _this$props7 = this.props, content = _this$props7.content, type = _this$props7.type;
                var nodeProps = _objectSpread(_objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(this.props, false)), node), {}, {
                    root: root
                });
                var isLeaf = !node.children || !node.children.length;
                var currentRoot = this.state.currentRoot;
                var isCurrentRootChild = (currentRoot.children || []).filter(function(item) {
                    return item.depth === node.depth && item.name === node.name;
                });
                if (!isCurrentRootChild.length && root.depth && type === 'nest') return null;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    key: "recharts-treemap-node-".concat(nodeProps.x, "-").concat(nodeProps.y, "-").concat(nodeProps.name),
                    className: "recharts-treemap-depth-".concat(node.depth)
                }, this.renderItem(content, nodeProps, isLeaf), node.children && node.children.length ? node.children.map(function(child) {
                    return _this3.renderNode(node, child);
                }) : null);
            }
        },
        {
            key: "renderAllNodes",
            value: function renderAllNodes() {
                var formatRoot = this.state.formatRoot;
                if (!formatRoot) return null;
                return this.renderNode(formatRoot, formatRoot);
            }
        },
        {
            key: "renderTooltip",
            value: function renderTooltip() {
                var _this$props8 = this.props, children = _this$props8.children, nameKey = _this$props8.nameKey;
                var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                if (!tooltipItem) return null;
                var _this$props9 = this.props, width = _this$props9.width, height = _this$props9.height;
                var _this$state = this.state, isTooltipActive = _this$state.isTooltipActive, activeNode = _this$state.activeNode;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: width,
                    height: height
                };
                var coordinate = activeNode ? {
                    x: activeNode.x + activeNode.width / 2,
                    y: activeNode.y + activeNode.height / 2
                } : null;
                var payload = isTooltipActive && activeNode ? [
                    {
                        payload: activeNode,
                        name: (0, _chartUtils.getValueByDataKey)(activeNode, nameKey, ''),
                        value: (0, _chartUtils.getValueByDataKey)(activeNode, NODE_VALUE_KEY)
                    }
                ] : [];
                return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(tooltipItem, {
                    viewBox: viewBox,
                    active: isTooltipActive,
                    coordinate: coordinate,
                    label: '',
                    payload: payload
                });
            }
        },
        {
            key: "renderNestIndex",
            value: function renderNestIndex() {
                var _this4 = this;
                var _this$props10 = this.props, nameKey = _this$props10.nameKey, nestIndexContent = _this$props10.nestIndexContent;
                var nestIndex = this.state.nestIndex;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                    className: "recharts-treemap-nest-index-wrapper",
                    style: {
                        marginTop: '8px',
                        textAlign: 'center'
                    }
                }, nestIndex.map(function(item, i) {
                    // TODO need to verify nameKey type
                    var name = (0, _getDefault.default)(item, nameKey, 'root');
                    var content = null;
                    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(nestIndexContent)) content = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(nestIndexContent, item, i);
                    if ((0, _isFunctionDefault.default)(nestIndexContent)) content = nestIndexContent(item, i);
                    else content = name;
                    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                    (0, _reactDefault.default).createElement("div", {
                        onClick: _this4.handleNestIndex.bind(_this4, item, i),
                        key: "nest-index-".concat((0, _dataUtils.uniqueId)()),
                        className: "recharts-treemap-nest-index-box",
                        style: {
                            cursor: 'pointer',
                            display: 'inline-block',
                            padding: '0 7px',
                            background: '#000',
                            color: '#fff',
                            marginRight: '3px'
                        }
                    }, content));
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                if (!(0, _reactUtils.validateWidthHeight)(this)) return null;
                var _this$props11 = this.props, width = _this$props11.width, height = _this$props11.height, className = _this$props11.className, style = _this$props11.style, children = _this$props11.children, type = _this$props11.type, others = _objectWithoutProperties(_this$props11, _excluded);
                var attrs = (0, _reactUtils.filterProps)(others, false);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                    className: (0, _clsxDefault.default)('recharts-wrapper', className),
                    style: _objectSpread(_objectSpread({}, style), {}, {
                        position: 'relative',
                        cursor: 'default',
                        width: width,
                        height: height
                    }),
                    role: "region"
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _surface.Surface), _extends({}, attrs, {
                    width: width,
                    height: type === 'nest' ? height - 30 : height
                }), this.renderAllNodes(), (0, _reactUtils.filterSvgElements)(children)), this.renderTooltip(), type === 'nest' && this.renderNestIndex());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.data !== prevState.prevData || nextProps.type !== prevState.prevType || nextProps.width !== prevState.prevWidth || nextProps.height !== prevState.prevHeight || nextProps.dataKey !== prevState.prevDataKey || nextProps.aspectRatio !== prevState.prevAspectRatio) {
                    var root = computeNode({
                        depth: 0,
                        node: {
                            children: nextProps.data,
                            x: 0,
                            y: 0,
                            width: nextProps.width,
                            height: nextProps.height
                        },
                        index: 0,
                        valueKey: nextProps.dataKey
                    });
                    var formatRoot = squarify(root, nextProps.aspectRatio);
                    return _objectSpread(_objectSpread({}, prevState), {}, {
                        formatRoot: formatRoot,
                        currentRoot: root,
                        nestIndex: [
                            root
                        ],
                        prevAspectRatio: nextProps.aspectRatio,
                        prevData: nextProps.data,
                        prevWidth: nextProps.width,
                        prevHeight: nextProps.height,
                        prevDataKey: nextProps.dataKey,
                        prevType: nextProps.type
                    });
                }
                return null;
            }
        },
        {
            key: "renderContentItem",
            value: function renderContentItem(content, nodeProps, type, colorPanel) {
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(content)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(content, nodeProps);
                if ((0, _isFunctionDefault.default)(content)) return content(nodeProps);
                // optimize default shape
                var x = nodeProps.x, y = nodeProps.y, width = nodeProps.width, height = nodeProps.height, index = nodeProps.index;
                var arrow = null;
                if (width > 10 && height > 10 && nodeProps.children && type === 'nest') arrow = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _polygon.Polygon), {
                    points: [
                        {
                            x: x + 2,
                            y: y + height / 2
                        },
                        {
                            x: x + 6,
                            y: y + height / 2 + 3
                        },
                        {
                            x: x + 2,
                            y: y + height / 2 + 6
                        }
                    ]
                });
                var text = null;
                var nameSize = (0, _domutils.getStringSize)(nodeProps.name);
                if (width > 20 && height > 20 && nameSize.width < width && nameSize.height < height) text = /*#__PURE__*/ (0, _reactDefault.default).createElement("text", {
                    x: x + 8,
                    y: y + height / 2 + 7,
                    fontSize: 14
                }, nodeProps.name);
                var colors = colorPanel || (0, _constants.COLOR_PANEL);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rectangle.Rectangle), _extends({
                    fill: nodeProps.depth < 2 ? colors[index % colors.length] : 'rgba(255,255,255,0)',
                    stroke: "#fff"
                }, (0, _omitDefault.default)(nodeProps, 'children'), {
                    role: "img"
                })), arrow, text);
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(Treemap, "displayName", 'Treemap');
_defineProperty(Treemap, "defaultProps", {
    aspectRatio: 0.5 * (1 + Math.sqrt(5)),
    dataKey: 'value',
    type: 'flat',
    isAnimationActive: !(0, _global.Global).isSsr,
    isUpdateAnimationActive: !(0, _global.Global).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'linear'
});

},{"lodash/isNaN":"aERJU","lodash/isFunction":"2KQKo","lodash/omit":"lkehy","lodash/get":"dEpuO","clsx":"3mzHT","react":"eGun2","react-smooth":"ekPiD","../component/Tooltip":"5PITU","../container/Layer":"gNfib","../container/Surface":"7sKCX","../shape/Polygon":"9X8Ya","../shape/Rectangle":"gLZb9","../util/ChartUtils":"55u3i","../util/Constants":"gXyfx","../util/DataUtils":"lsl3R","../util/DOMUtils":"dgkk6","../util/Global":"dWTWi","../util/ReactUtils":"dBf5D","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"lkehy":[function(require,module,exports,__globalThis) {
var arrayMap = require("122b5d18812cb83f"), baseClone = require("95425530e6e4fc38"), baseUnset = require("a95067000c54cf2e"), castPath = require("b257f288cc1872ac"), copyObject = require("20872845ddd8a115"), customOmitClone = require("9ba2c00405fdd82b"), flatRest = require("2ed16c04c65c0f4f"), getAllKeysIn = require("8dc4156e3b958bfb");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var omit = flatRest(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    copyObject(object, getAllKeysIn(object), result);
    if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
    var length = paths.length;
    while(length--)baseUnset(result, paths[length]);
    return result;
});
module.exports = omit;

},{"122b5d18812cb83f":"eouC0","95425530e6e4fc38":"dVzDN","a95067000c54cf2e":"9KgtB","b257f288cc1872ac":"dIRVx","20872845ddd8a115":"1OniH","9ba2c00405fdd82b":"6rHCT","2ed16c04c65c0f4f":"dyRyQ","8dc4156e3b958bfb":"a9kZT"}],"dVzDN":[function(require,module,exports,__globalThis) {
var Stack = require("6d5cd9672b5ba36b"), arrayEach = require("efd58b4613fdcef9"), assignValue = require("ea1dee2a1e5735b2"), baseAssign = require("74666b5b746c3398"), baseAssignIn = require("af0d2371e639cf5"), cloneBuffer = require("151b7318d952238"), copyArray = require("2b07030fd47be3ca"), copySymbols = require("bf246a281b59673d"), copySymbolsIn = require("977ce128b711681f"), getAllKeys = require("ee29142460f16cd0"), getAllKeysIn = require("dd754355960bd9d0"), getTag = require("74f01e676fd9ec2"), initCloneArray = require("ea3d6ecb0df430fb"), initCloneByTag = require("139e19a015874173"), initCloneObject = require("3af04861929577a2"), isArray = require("77e3f91eab178279"), isBuffer = require("ff0eaf1d0938aa6d"), isMap = require("2d4f2b7467cb56b6"), isObject = require("332f3d2f7bfddb19"), isSet = require("dfa59a78ad55aa4b"), keys = require("611a58a6b03d30b1"), keysIn = require("42a842ca3cfed299");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (isSet(value)) value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if (isMap(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = baseClone;

},{"6d5cd9672b5ba36b":"ap26Q","efd58b4613fdcef9":"7k17b","ea1dee2a1e5735b2":"cyb5c","74666b5b746c3398":"g5h62","af0d2371e639cf5":"hjnHv","151b7318d952238":"1bKue","2b07030fd47be3ca":"kWxEe","bf246a281b59673d":"bdUxY","977ce128b711681f":"jJ9du","ee29142460f16cd0":"aRNSg","dd754355960bd9d0":"a9kZT","74f01e676fd9ec2":"7Mujc","ea3d6ecb0df430fb":"gUYxI","139e19a015874173":"e14l7","3af04861929577a2":"2aRRP","77e3f91eab178279":"5gfYS","ff0eaf1d0938aa6d":"6q24W","2d4f2b7467cb56b6":"i0oNz","332f3d2f7bfddb19":"cNdKD","dfa59a78ad55aa4b":"h9iTJ","611a58a6b03d30b1":"ftmUn","42a842ca3cfed299":"ky4ip"}],"7k17b":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = arrayEach;

},{}],"cyb5c":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("1e050c86412c4f60"), eq = require("fbcd14f3e3fe8c5a");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"1e050c86412c4f60":"cT7xv","fbcd14f3e3fe8c5a":"eLtdL"}],"g5h62":[function(require,module,exports,__globalThis) {
var copyObject = require("dd513c953226e6c4"), keys = require("ecc217c9ee448b4f");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
module.exports = baseAssign;

},{"dd513c953226e6c4":"1OniH","ecc217c9ee448b4f":"ftmUn"}],"1OniH":[function(require,module,exports,__globalThis) {
var assignValue = require("a01c98457eef2952"), baseAssignValue = require("589183627ee93816");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"a01c98457eef2952":"cyb5c","589183627ee93816":"cT7xv"}],"hjnHv":[function(require,module,exports,__globalThis) {
var copyObject = require("ba6ae778e114bd96"), keysIn = require("2895a0aed3a7e13c");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
}
module.exports = baseAssignIn;

},{"ba6ae778e114bd96":"1OniH","2895a0aed3a7e13c":"ky4ip"}],"ky4ip":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("a1125d35a77d599"), baseKeysIn = require("dadb121540b5990c"), isArrayLike = require("e499f70085872a09");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"a1125d35a77d599":"fIKFp","dadb121540b5990c":"1VxQ7","e499f70085872a09":"fs9yO"}],"1VxQ7":[function(require,module,exports,__globalThis) {
var isObject = require("c14f66a98b632186"), isPrototype = require("1f047c3be6f46f45"), nativeKeysIn = require("f63d48b4a235c6c8");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"c14f66a98b632186":"cNdKD","1f047c3be6f46f45":"iZamn","f63d48b4a235c6c8":"lIuKe"}],"lIuKe":[function(require,module,exports,__globalThis) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"1bKue":[function(require,module,exports,__globalThis) {
var root = require("34c5f7ff3b592572");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"34c5f7ff3b592572":"g0sWx"}],"kWxEe":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"bdUxY":[function(require,module,exports,__globalThis) {
var copyObject = require("66b0707e04467ee0"), getSymbols = require("5d51c0806484d88a");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
module.exports = copySymbols;

},{"66b0707e04467ee0":"1OniH","5d51c0806484d88a":"knCcy"}],"jJ9du":[function(require,module,exports,__globalThis) {
var copyObject = require("b0c9327db9e84355"), getSymbolsIn = require("a4ca67af61de3c53");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
}
module.exports = copySymbolsIn;

},{"b0c9327db9e84355":"1OniH","a4ca67af61de3c53":"gCyyU"}],"gCyyU":[function(require,module,exports,__globalThis) {
var arrayPush = require("4184a6f1767f6797"), getPrototype = require("cb1f9bb200522fa"), getSymbols = require("76e0310d85a00012"), stubArray = require("d9457b903b849f31");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"4184a6f1767f6797":"ixNde","cb1f9bb200522fa":"4M6Bs","76e0310d85a00012":"knCcy","d9457b903b849f31":"9Ghuf"}],"a9kZT":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("b2c624ac8c870718"), getSymbolsIn = require("769771da03b8c126"), keysIn = require("b2cd9db593378099");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"b2c624ac8c870718":"h1lAw","769771da03b8c126":"gCyyU","b2cd9db593378099":"ky4ip"}],"gUYxI":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;

},{}],"e14l7":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("70dd44968eaa00c4"), cloneDataView = require("f0460228a549a8d8"), cloneRegExp = require("a4884077172e56d9"), cloneSymbol = require("62e7fbb246b07fdc"), cloneTypedArray = require("67c5214bedb43e06");
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return cloneSymbol(object);
    }
}
module.exports = initCloneByTag;

},{"70dd44968eaa00c4":"hOtTW","f0460228a549a8d8":"jd67s","a4884077172e56d9":"dUVrf","62e7fbb246b07fdc":"jVQcY","67c5214bedb43e06":"sSupj"}],"hOtTW":[function(require,module,exports,__globalThis) {
var Uint8Array = require("9f9ecf204f42f20e");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"9f9ecf204f42f20e":"flaHi"}],"jd67s":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("2943bd4f8d8b8350");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = cloneDataView;

},{"2943bd4f8d8b8350":"hOtTW"}],"dUVrf":[function(require,module,exports,__globalThis) {
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = cloneRegExp;

},{}],"jVQcY":[function(require,module,exports,__globalThis) {
var Symbol = require("9c3e65c34f6552c6");
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
module.exports = cloneSymbol;

},{"9c3e65c34f6552c6":"6MIK0"}],"sSupj":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("41cd7c14dcd067e4");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"41cd7c14dcd067e4":"hOtTW"}],"2aRRP":[function(require,module,exports,__globalThis) {
var baseCreate = require("8f955a4c17becae2"), getPrototype = require("a539d929373cfe81"), isPrototype = require("c7caf5bf5b6f2d20");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"8f955a4c17becae2":"ctjdl","a539d929373cfe81":"4M6Bs","c7caf5bf5b6f2d20":"iZamn"}],"ctjdl":[function(require,module,exports,__globalThis) {
var isObject = require("920dddf7aa1bef9");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"920dddf7aa1bef9":"cNdKD"}],"i0oNz":[function(require,module,exports,__globalThis) {
var baseIsMap = require("62133b3489976b94"), baseUnary = require("d1c0952747e52e50"), nodeUtil = require("1c79a1fd91424112");
/* Node.js helper references. */ var nodeIsMap = nodeUtil && nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
module.exports = isMap;

},{"62133b3489976b94":"1w8lY","d1c0952747e52e50":"1FfIP","1c79a1fd91424112":"d86ql"}],"1w8lY":[function(require,module,exports,__globalThis) {
var getTag = require("7070bf4d9be95482"), isObjectLike = require("3ffe3651db4b81ca");
/** `Object#toString` result references. */ var mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
}
module.exports = baseIsMap;

},{"7070bf4d9be95482":"7Mujc","3ffe3651db4b81ca":"4gHtY"}],"h9iTJ":[function(require,module,exports,__globalThis) {
var baseIsSet = require("286ffd47a600c6a"), baseUnary = require("7f30a0d9451a4134"), nodeUtil = require("10a57684d3621769");
/* Node.js helper references. */ var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
module.exports = isSet;

},{"286ffd47a600c6a":"6BWOu","7f30a0d9451a4134":"1FfIP","10a57684d3621769":"d86ql"}],"6BWOu":[function(require,module,exports,__globalThis) {
var getTag = require("99cc73c119e83d96"), isObjectLike = require("fcf969a338ab97d6");
/** `Object#toString` result references. */ var setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
}
module.exports = baseIsSet;

},{"99cc73c119e83d96":"7Mujc","fcf969a338ab97d6":"4gHtY"}],"9KgtB":[function(require,module,exports,__globalThis) {
var castPath = require("2c5ad22ac4dd41f7"), last = require("2bce98b6d3ccf1cf"), parent = require("9308299f6831e4e7"), toKey = require("430064c7340eb728");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function baseUnset(object, path) {
    path = castPath(path, object);
    object = parent(object, path);
    return object == null || delete object[toKey(last(path))];
}
module.exports = baseUnset;

},{"2c5ad22ac4dd41f7":"dIRVx","2bce98b6d3ccf1cf":"747XP","9308299f6831e4e7":"mXWw7","430064c7340eb728":"9XfVL"}],"mXWw7":[function(require,module,exports,__globalThis) {
var baseGet = require("a34953d4c4a2f64"), baseSlice = require("ee9ae849fa77bc43");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function parent(object, path) {
    return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}
module.exports = parent;

},{"a34953d4c4a2f64":"6iITn","ee9ae849fa77bc43":"34Gi0"}],"6rHCT":[function(require,module,exports,__globalThis) {
var isPlainObject = require("d741e10edf3db799");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function customOmitClone(value) {
    return isPlainObject(value) ? undefined : value;
}
module.exports = customOmitClone;

},{"d741e10edf3db799":"bAA6z"}],"dyRyQ":[function(require,module,exports,__globalThis) {
var flatten = require("cbcbaff69b7cafe8"), overRest = require("cf52d86d76f2d04a"), setToString = require("b9dfcac25648136c");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function flatRest(func) {
    return setToString(overRest(func, undefined, flatten), func + '');
}
module.exports = flatRest;

},{"cbcbaff69b7cafe8":"hmgF7","cf52d86d76f2d04a":"1ymnO","b9dfcac25648136c":"jEIfl"}],"hmgF7":[function(require,module,exports,__globalThis) {
var baseFlatten = require("3bb304eb25d1cfb0");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
}
module.exports = flatten;

},{"3bb304eb25d1cfb0":"dkyY2"}],"gXyfx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COLOR_PANEL", ()=>COLOR_PANEL);
var COLOR_PANEL = [
    '#1890FF',
    '#66B5FF',
    '#41D9C7',
    '#2FC25B',
    '#6EDB8F',
    '#9AE65C',
    '#FACC14',
    '#E6965C',
    '#57AD71',
    '#223273',
    '#738AE6',
    '#7564CC',
    '#8543E0',
    '#A877ED',
    '#5C8EE6',
    '#13C2C2',
    '#70E0E0',
    '#5CA3E6',
    '#3436C7',
    '#8082FF',
    '#DD81E6',
    '#F04864',
    '#FA7D92',
    '#D598D9'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jGpFD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sankey", ()=>Sankey);
/**
 * @file TreemapChart
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _maxBy = require("lodash/maxBy");
var _maxByDefault = parcelHelpers.interopDefault(_maxBy);
var _min = require("lodash/min");
var _minDefault = parcelHelpers.interopDefault(_min);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _sumBy = require("lodash/sumBy");
var _sumByDefault = parcelHelpers.interopDefault(_sumBy);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _surface = require("../container/Surface");
var _layer = require("../container/Layer");
var _tooltip = require("../component/Tooltip");
var _rectangle = require("../shape/Rectangle");
var _shallowEqual = require("../util/ShallowEqual");
var _reactUtils = require("../util/ReactUtils");
var _chartUtils = require("../util/ChartUtils");
var _excluded = [
    "width",
    "height",
    "className",
    "style",
    "children"
], _excluded2 = [
    "sourceX",
    "sourceY",
    "sourceControlX",
    "targetX",
    "targetY",
    "targetControlX",
    "linkWidth"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var defaultCoordinateOfTooltip = {
    x: 0,
    y: 0
};
var interpolationGenerator = function interpolationGenerator(a, b) {
    var ka = +a;
    var kb = b - ka;
    return function(t) {
        return ka + kb * t;
    };
};
var centerY = function centerY(node) {
    return node.y + node.dy / 2;
};
var getValue = function getValue(entry) {
    return entry && entry.value || 0;
};
var getSumOfIds = function getSumOfIds(links, ids) {
    return ids.reduce(function(result, id) {
        return result + getValue(links[id]);
    }, 0);
};
var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
    return ids.reduce(function(result, id) {
        var link = links[id];
        var sourceNode = tree[link.source];
        return result + centerY(sourceNode) * getValue(links[id]);
    }, 0);
};
var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
    return ids.reduce(function(result, id) {
        var link = links[id];
        var targetNode = tree[link.target];
        return result + centerY(targetNode) * getValue(links[id]);
    }, 0);
};
var ascendingY = function ascendingY(a, b) {
    return a.y - b.y;
};
var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
    var sourceNodes = [];
    var sourceLinks = [];
    var targetNodes = [];
    var targetLinks = [];
    for(var i = 0, len = links.length; i < len; i++){
        var link = links[i];
        if (link.source === id) {
            targetNodes.push(link.target);
            targetLinks.push(i);
        }
        if (link.target === id) {
            sourceNodes.push(link.source);
            sourceLinks.push(i);
        }
    }
    return {
        sourceNodes: sourceNodes,
        sourceLinks: sourceLinks,
        targetLinks: targetLinks,
        targetNodes: targetNodes
    };
};
var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
    var targetNodes = curNode.targetNodes;
    for(var i = 0, len = targetNodes.length; i < len; i++){
        var target = tree[targetNodes[i]];
        if (target) {
            target.depth = Math.max(curNode.depth + 1, target.depth);
            updateDepthOfTargets(tree, target);
        }
    }
};
var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
    var nodes = _ref.nodes, links = _ref.links;
    var tree = nodes.map(function(entry, index) {
        var result = searchTargetsAndSources(links, index);
        return _objectSpread(_objectSpread(_objectSpread({}, entry), result), {}, {
            value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
            depth: 0
        });
    });
    for(var i = 0, len = tree.length; i < len; i++){
        var node = tree[i];
        if (!node.sourceNodes.length) updateDepthOfTargets(tree, node);
    }
    var maxDepth = (0, _maxByDefault.default)(tree, function(entry) {
        return entry.depth;
    }).depth;
    if (maxDepth >= 1) {
        var childWidth = (width - nodeWidth) / maxDepth;
        for(var _i = 0, _len = tree.length; _i < _len; _i++){
            var _node = tree[_i];
            if (!_node.targetNodes.length) _node.depth = maxDepth;
            _node.x = _node.depth * childWidth;
            _node.dx = nodeWidth;
        }
    }
    return {
        tree: tree,
        maxDepth: maxDepth
    };
};
var getDepthTree = function getDepthTree(tree) {
    var result = [];
    for(var i = 0, len = tree.length; i < len; i++){
        var node = tree[i];
        if (!result[node.depth]) result[node.depth] = [];
        result[node.depth].push(node);
    }
    return result;
};
var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
    var yRatio = (0, _minDefault.default)(depthTree.map(function(nodes) {
        return (height - (nodes.length - 1) * nodePadding) / (0, _sumByDefault.default)(nodes, getValue);
    }));
    for(var d = 0, maxDepth = depthTree.length; d < maxDepth; d++)for(var i = 0, len = depthTree[d].length; i < len; i++){
        var node = depthTree[d][i];
        node.y = i;
        node.dy = node.value * yRatio;
    }
    return links.map(function(link) {
        return _objectSpread(_objectSpread({}, link), {}, {
            dy: getValue(link) * yRatio
        });
    });
};
var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
    var sort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    for(var i = 0, len = depthTree.length; i < len; i++){
        var nodes = depthTree[i];
        var n = nodes.length;
        // Sort by the value of y
        if (sort) nodes.sort(ascendingY);
        var y0 = 0;
        for(var j = 0; j < n; j++){
            var node = nodes[j];
            var dy = y0 - node.y;
            if (dy > 0) node.y += dy;
            y0 = node.y + node.dy + nodePadding;
        }
        y0 = height + nodePadding;
        for(var _j = n - 1; _j >= 0; _j--){
            var _node2 = nodes[_j];
            var _dy = _node2.y + _node2.dy + nodePadding - y0;
            if (_dy > 0) {
                _node2.y -= _dy;
                y0 = _node2.y;
            } else break;
        }
    }
};
var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
    for(var i = 0, maxDepth = depthTree.length; i < maxDepth; i++){
        var nodes = depthTree[i];
        for(var j = 0, len = nodes.length; j < len; j++){
            var node = nodes[j];
            if (node.sourceLinks.length) {
                var sourceSum = getSumOfIds(links, node.sourceLinks);
                var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
                var y = weightedSum / sourceSum;
                node.y += (y - centerY(node)) * alpha;
            }
        }
    }
};
var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
    for(var i = depthTree.length - 1; i >= 0; i--){
        var nodes = depthTree[i];
        for(var j = 0, len = nodes.length; j < len; j++){
            var node = nodes[j];
            if (node.targetLinks.length) {
                var targetSum = getSumOfIds(links, node.targetLinks);
                var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
                var y = weightedSum / targetSum;
                node.y += (y - centerY(node)) * alpha;
            }
        }
    }
};
var updateYOfLinks = function updateYOfLinks(tree, links) {
    for(var i = 0, len = tree.length; i < len; i++){
        var node = tree[i];
        var sy = 0;
        var ty = 0;
        node.targetLinks.sort(function(a, b) {
            return tree[links[a].target].y - tree[links[b].target].y;
        });
        node.sourceLinks.sort(function(a, b) {
            return tree[links[a].source].y - tree[links[b].source].y;
        });
        for(var j = 0, tLen = node.targetLinks.length; j < tLen; j++){
            var link = links[node.targetLinks[j]];
            if (link) {
                link.sy = sy;
                sy += link.dy;
            }
        }
        for(var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++){
            var _link = links[node.sourceLinks[_j2]];
            if (_link) {
                _link.ty = ty;
                ty += _link.dy;
            }
        }
    }
};
var computeData = function computeData(_ref2) {
    var data = _ref2.data, width = _ref2.width, height = _ref2.height, iterations = _ref2.iterations, nodeWidth = _ref2.nodeWidth, nodePadding = _ref2.nodePadding, sort = _ref2.sort;
    var links = data.links;
    var _getNodesTree = getNodesTree(data, width, nodeWidth), tree = _getNodesTree.tree;
    var depthTree = getDepthTree(tree);
    var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
    resolveCollisions(depthTree, height, nodePadding, sort);
    var alpha = 1;
    for(var i = 1; i <= iterations; i++){
        relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
        resolveCollisions(depthTree, height, nodePadding, sort);
        relaxLeftToRight(tree, depthTree, newLinks, alpha);
        resolveCollisions(depthTree, height, nodePadding, sort);
    }
    updateYOfLinks(tree, newLinks);
    return {
        nodes: tree,
        links: newLinks
    };
};
var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
    if (type === 'node') return {
        x: el.x + el.width / 2,
        y: el.y + el.height / 2
    };
    return {
        x: (el.sourceX + el.targetX) / 2,
        y: (el.sourceY + el.targetY) / 2
    };
};
var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
    var payload = el.payload;
    if (type === 'node') return [
        {
            payload: el,
            name: (0, _chartUtils.getValueByDataKey)(payload, nameKey, ''),
            value: (0, _chartUtils.getValueByDataKey)(payload, 'value')
        }
    ];
    if (payload.source && payload.target) {
        var sourceName = (0, _chartUtils.getValueByDataKey)(payload.source, nameKey, '');
        var targetName = (0, _chartUtils.getValueByDataKey)(payload.target, nameKey, '');
        return [
            {
                payload: el,
                name: "".concat(sourceName, " - ").concat(targetName),
                value: (0, _chartUtils.getValueByDataKey)(payload, 'value')
            }
        ];
    }
    return [];
};
var Sankey = /*#__PURE__*/ function(_PureComponent) {
    function Sankey() {
        var _this;
        _classCallCheck(this, Sankey);
        for(var _len2 = arguments.length, args = new Array(_len2), _key = 0; _key < _len2; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, Sankey, [].concat(args));
        _defineProperty(_this, "state", {
            activeElement: null,
            activeElementType: null,
            isTooltipActive: false,
            nodes: [],
            links: []
        });
        return _this;
    }
    _inherits(Sankey, _PureComponent);
    return _createClass(Sankey, [
        {
            key: "handleMouseEnter",
            value: function handleMouseEnter(el, type, e) {
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, children = _this$props.children;
                var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                if (tooltipItem) this.setState(function(prev) {
                    if (tooltipItem.props.trigger === 'hover') return _objectSpread(_objectSpread({}, prev), {}, {
                        activeElement: el,
                        activeElementType: type,
                        isTooltipActive: true
                    });
                    return prev;
                }, function() {
                    if (onMouseEnter) onMouseEnter(el, type, e);
                });
                else if (onMouseEnter) onMouseEnter(el, type, e);
            }
        },
        {
            key: "handleMouseLeave",
            value: function handleMouseLeave(el, type, e) {
                var _this$props2 = this.props, onMouseLeave = _this$props2.onMouseLeave, children = _this$props2.children;
                var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                if (tooltipItem) this.setState(function(prev) {
                    if (tooltipItem.props.trigger === 'hover') return _objectSpread(_objectSpread({}, prev), {}, {
                        activeElement: undefined,
                        activeElementType: undefined,
                        isTooltipActive: false
                    });
                    return prev;
                }, function() {
                    if (onMouseLeave) onMouseLeave(el, type, e);
                });
                else if (onMouseLeave) onMouseLeave(el, type, e);
            }
        },
        {
            key: "handleClick",
            value: function handleClick(el, type, e) {
                var _this$props3 = this.props, onClick = _this$props3.onClick, children = _this$props3.children;
                var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                if (tooltipItem && tooltipItem.props.trigger === 'click') {
                    if (this.state.isTooltipActive) this.setState(function(prev) {
                        return _objectSpread(_objectSpread({}, prev), {}, {
                            activeElement: undefined,
                            activeElementType: undefined,
                            isTooltipActive: false
                        });
                    });
                    else this.setState(function(prev) {
                        return _objectSpread(_objectSpread({}, prev), {}, {
                            activeElement: el,
                            activeElementType: type,
                            isTooltipActive: true
                        });
                    });
                }
                if (onClick) onClick(el, type, e);
            }
        },
        {
            key: "renderLinks",
            value: function renderLinks(links, nodes) {
                var _this2 = this;
                var _this$props4 = this.props, linkCurvature = _this$props4.linkCurvature, linkContent = _this$props4.link, margin = _this$props4.margin;
                var top = (0, _getDefault.default)(margin, 'top') || 0;
                var left = (0, _getDefault.default)(margin, 'left') || 0;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-sankey-links",
                    key: "recharts-sankey-links"
                }, links.map(function(link, i) {
                    var sourceRelativeY = link.sy, targetRelativeY = link.ty, linkWidth = link.dy;
                    var source = nodes[link.source];
                    var target = nodes[link.target];
                    var sourceX = source.x + source.dx + left;
                    var targetX = target.x + left;
                    var interpolationFunc = interpolationGenerator(sourceX, targetX);
                    var sourceControlX = interpolationFunc(linkCurvature);
                    var targetControlX = interpolationFunc(1 - linkCurvature);
                    var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
                    var targetY = target.y + targetRelativeY + linkWidth / 2 + top;
                    var linkProps = _objectSpread({
                        sourceX: sourceX,
                        targetX: targetX,
                        sourceY: sourceY,
                        targetY: targetY,
                        sourceControlX: sourceControlX,
                        targetControlX: targetControlX,
                        sourceRelativeY: sourceRelativeY,
                        targetRelativeY: targetRelativeY,
                        linkWidth: linkWidth,
                        index: i,
                        payload: _objectSpread(_objectSpread({}, link), {}, {
                            source: source,
                            target: target
                        })
                    }, (0, _reactUtils.filterProps)(linkContent, false));
                    var events = {
                        onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
                        onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link'),
                        onClick: _this2.handleClick.bind(_this2, linkProps, 'link')
                    };
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        key: "link-".concat(link.source, "-").concat(link.target, "-").concat(link.value)
                    }, events), _this2.constructor.renderLinkItem(linkContent, linkProps));
                }));
            }
        },
        {
            key: "renderNodes",
            value: function renderNodes(nodes) {
                var _this3 = this;
                var _this$props5 = this.props, nodeContent = _this$props5.node, margin = _this$props5.margin;
                var top = (0, _getDefault.default)(margin, 'top') || 0;
                var left = (0, _getDefault.default)(margin, 'left') || 0;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-sankey-nodes",
                    key: "recharts-sankey-nodes"
                }, nodes.map(function(node, i) {
                    var x = node.x, y = node.y, dx = node.dx, dy = node.dy;
                    var nodeProps = _objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(nodeContent, false)), {}, {
                        x: x + left,
                        y: y + top,
                        width: dx,
                        height: dy,
                        index: i,
                        payload: node
                    });
                    var events = {
                        onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
                        onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node'),
                        onClick: _this3.handleClick.bind(_this3, nodeProps, 'node')
                    };
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        key: "node-".concat(node.x, "-").concat(node.y, "-").concat(node.value)
                    }, events), _this3.constructor.renderNodeItem(nodeContent, nodeProps));
                }));
            }
        },
        {
            key: "renderTooltip",
            value: function renderTooltip() {
                var _this$props6 = this.props, children = _this$props6.children, width = _this$props6.width, height = _this$props6.height, nameKey = _this$props6.nameKey;
                var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                if (!tooltipItem) return null;
                var _this$state = this.state, isTooltipActive = _this$state.isTooltipActive, activeElement = _this$state.activeElement, activeElementType = _this$state.activeElementType;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: width,
                    height: height
                };
                var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
                var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
                return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(tooltipItem, {
                    viewBox: viewBox,
                    active: isTooltipActive,
                    coordinate: coordinate,
                    label: '',
                    payload: payload
                });
            }
        },
        {
            key: "render",
            value: function render() {
                if (!(0, _reactUtils.validateWidthHeight)(this)) return null;
                var _this$props7 = this.props, width = _this$props7.width, height = _this$props7.height, className = _this$props7.className, style = _this$props7.style, children = _this$props7.children, others = _objectWithoutProperties(_this$props7, _excluded);
                var _this$state2 = this.state, links = _this$state2.links, nodes = _this$state2.nodes;
                var attrs = (0, _reactUtils.filterProps)(others, false);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                    className: (0, _clsxDefault.default)('recharts-wrapper', className),
                    style: _objectSpread(_objectSpread({}, style), {}, {
                        position: 'relative',
                        cursor: 'default',
                        width: width,
                        height: height
                    }),
                    role: "region"
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _surface.Surface), _extends({}, attrs, {
                    width: width,
                    height: height
                }), (0, _reactUtils.filterSvgElements)(children), this.renderLinks(links, nodes), this.renderNodes(nodes)), this.renderTooltip());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, height = nextProps.height, margin = nextProps.margin, iterations = nextProps.iterations, nodeWidth = nextProps.nodeWidth, nodePadding = nextProps.nodePadding, sort = nextProps.sort;
                if (data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || !(0, _shallowEqual.shallowEqual)(margin, prevState.prevMargin) || iterations !== prevState.prevIterations || nodeWidth !== prevState.prevNodeWidth || nodePadding !== prevState.prevNodePadding || sort !== prevState.sort) {
                    var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
                    var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);
                    var _computeData = computeData({
                        data: data,
                        width: contentWidth,
                        height: contentHeight,
                        iterations: iterations,
                        nodeWidth: nodeWidth,
                        nodePadding: nodePadding,
                        sort: sort
                    }), links = _computeData.links, nodes = _computeData.nodes;
                    return _objectSpread(_objectSpread({}, prevState), {}, {
                        nodes: nodes,
                        links: links,
                        prevData: data,
                        prevWidth: iterations,
                        prevHeight: height,
                        prevMargin: margin,
                        prevNodePadding: nodePadding,
                        prevNodeWidth: nodeWidth,
                        prevIterations: iterations,
                        prevSort: sort
                    });
                }
                return null;
            }
        },
        {
            key: "renderLinkItem",
            value: function renderLinkItem(option, props) {
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                if ((0, _isFunctionDefault.default)(option)) return option(props);
                var sourceX = props.sourceX, sourceY = props.sourceY, sourceControlX = props.sourceControlX, targetX = props.targetX, targetY = props.targetY, targetControlX = props.targetControlX, linkWidth = props.linkWidth, others = _objectWithoutProperties(props, _excluded2);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({
                    className: "recharts-sankey-link",
                    d: "\n          M".concat(sourceX, ",").concat(sourceY, "\n          C").concat(sourceControlX, ",").concat(sourceY, " ").concat(targetControlX, ",").concat(targetY, " ").concat(targetX, ",").concat(targetY, "\n        "),
                    fill: "none",
                    stroke: "#333",
                    strokeWidth: linkWidth,
                    strokeOpacity: "0.2"
                }, (0, _reactUtils.filterProps)(others, false)));
            }
        },
        {
            key: "renderNodeItem",
            value: function renderNodeItem(option, props) {
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                if ((0, _isFunctionDefault.default)(option)) return option(props);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rectangle.Rectangle), _extends({
                    className: "recharts-sankey-node",
                    fill: "#0088fe",
                    fillOpacity: "0.8"
                }, (0, _reactUtils.filterProps)(props, false), {
                    role: "img"
                }));
            }
        }
    ]);
}((0, _react.PureComponent));
_defineProperty(Sankey, "displayName", 'Sankey');
_defineProperty(Sankey, "defaultProps", {
    nameKey: 'name',
    dataKey: 'value',
    nodePadding: 10,
    nodeWidth: 10,
    linkCurvature: 0.5,
    iterations: 32,
    margin: {
        top: 5,
        right: 5,
        bottom: 5,
        left: 5
    },
    sort: true
});

},{"react":"eGun2","lodash/maxBy":"9wmso","lodash/min":"7VS3d","lodash/get":"dEpuO","lodash/sumBy":"gHDnk","lodash/isFunction":"2KQKo","clsx":"3mzHT","../container/Surface":"7sKCX","../container/Layer":"gNfib","../component/Tooltip":"5PITU","../shape/Rectangle":"gLZb9","../util/ShallowEqual":"feNgJ","../util/ReactUtils":"dBf5D","../util/ChartUtils":"55u3i","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gHDnk":[function(require,module,exports,__globalThis) {
var baseIteratee = require("6783eacb0bbfcb55"), baseSum = require("70eb553ebe955dca");
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function sumBy(array, iteratee) {
    return array && array.length ? baseSum(array, baseIteratee(iteratee, 2)) : 0;
}
module.exports = sumBy;

},{"6783eacb0bbfcb55":"hmPIl","70eb553ebe955dca":"cgKaN"}],"cgKaN":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = baseSum;

},{}],"6hzed":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Radar Chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadarChart", ()=>RadarChart);
var _generateCategoricalChart = require("./generateCategoricalChart");
var _radar = require("../polar/Radar");
var _polarAngleAxis = require("../polar/PolarAngleAxis");
var _polarRadiusAxis = require("../polar/PolarRadiusAxis");
var _polarUtils = require("../util/PolarUtils");
var RadarChart = (0, _generateCategoricalChart.generateCategoricalChart)({
    chartName: 'RadarChart',
    GraphicalChild: (0, _radar.Radar),
    axisComponents: [
        {
            axisType: 'angleAxis',
            AxisComp: (0, _polarAngleAxis.PolarAngleAxis)
        },
        {
            axisType: 'radiusAxis',
            AxisComp: (0, _polarRadiusAxis.PolarRadiusAxis)
        }
    ],
    formatAxisMap: (0, _polarUtils.formatAxisMap),
    defaultProps: {
        layout: 'centric',
        startAngle: 90,
        endAngle: -270,
        cx: '50%',
        cy: '50%',
        innerRadius: 0,
        outerRadius: '80%'
    }
});

},{"./generateCategoricalChart":"l1e9D","../polar/Radar":"erEnc","../polar/PolarAngleAxis":"lel0p","../polar/PolarRadiusAxis":"bcj3U","../util/PolarUtils":"27snq","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fOuW8":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Scatter Chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScatterChart", ()=>ScatterChart);
var _generateCategoricalChart = require("./generateCategoricalChart");
var _scatter = require("../cartesian/Scatter");
var _xaxis = require("../cartesian/XAxis");
var _yaxis = require("../cartesian/YAxis");
var _zaxis = require("../cartesian/ZAxis");
var _cartesianUtils = require("../util/CartesianUtils");
var ScatterChart = (0, _generateCategoricalChart.generateCategoricalChart)({
    chartName: 'ScatterChart',
    GraphicalChild: (0, _scatter.Scatter),
    defaultTooltipEventType: 'item',
    validateTooltipEventTypes: [
        'item'
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, _xaxis.XAxis)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, _yaxis.YAxis)
        },
        {
            axisType: 'zAxis',
            AxisComp: (0, _zaxis.ZAxis)
        }
    ],
    formatAxisMap: (0, _cartesianUtils.formatAxisMap)
});

},{"./generateCategoricalChart":"l1e9D","../cartesian/Scatter":"cEWud","../cartesian/XAxis":"4nBWG","../cartesian/YAxis":"NHcEZ","../cartesian/ZAxis":"9mmH7","../util/CartesianUtils":"1I6yD","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"03rLr":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Area Chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AreaChart", ()=>AreaChart);
var _generateCategoricalChart = require("./generateCategoricalChart");
var _area = require("../cartesian/Area");
var _xaxis = require("../cartesian/XAxis");
var _yaxis = require("../cartesian/YAxis");
var _cartesianUtils = require("../util/CartesianUtils");
var AreaChart = (0, _generateCategoricalChart.generateCategoricalChart)({
    chartName: 'AreaChart',
    GraphicalChild: (0, _area.Area),
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, _xaxis.XAxis)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, _yaxis.YAxis)
        }
    ],
    formatAxisMap: (0, _cartesianUtils.formatAxisMap)
});

},{"./generateCategoricalChart":"l1e9D","../cartesian/Area":"nNjdk","../cartesian/XAxis":"4nBWG","../cartesian/YAxis":"NHcEZ","../util/CartesianUtils":"1I6yD","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1bSde":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Radar Bar Chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadialBarChart", ()=>RadialBarChart);
var _generateCategoricalChart = require("./generateCategoricalChart");
var _polarAngleAxis = require("../polar/PolarAngleAxis");
var _polarRadiusAxis = require("../polar/PolarRadiusAxis");
var _polarUtils = require("../util/PolarUtils");
var _radialBar = require("../polar/RadialBar");
var RadialBarChart = (0, _generateCategoricalChart.generateCategoricalChart)({
    chartName: 'RadialBarChart',
    GraphicalChild: (0, _radialBar.RadialBar),
    legendContent: 'children',
    defaultTooltipEventType: 'axis',
    validateTooltipEventTypes: [
        'axis',
        'item'
    ],
    axisComponents: [
        {
            axisType: 'angleAxis',
            AxisComp: (0, _polarAngleAxis.PolarAngleAxis)
        },
        {
            axisType: 'radiusAxis',
            AxisComp: (0, _polarRadiusAxis.PolarRadiusAxis)
        }
    ],
    formatAxisMap: (0, _polarUtils.formatAxisMap),
    defaultProps: {
        layout: 'radial',
        startAngle: 0,
        endAngle: 360,
        cx: '50%',
        cy: '50%',
        innerRadius: 0,
        outerRadius: '80%'
    }
});

},{"./generateCategoricalChart":"l1e9D","../polar/PolarAngleAxis":"lel0p","../polar/PolarRadiusAxis":"bcj3U","../util/PolarUtils":"27snq","../polar/RadialBar":"6Prav","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5E7p6":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Composed Chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComposedChart", ()=>ComposedChart);
var _generateCategoricalChart = require("./generateCategoricalChart");
var _area = require("../cartesian/Area");
var _bar = require("../cartesian/Bar");
var _line = require("../cartesian/Line");
var _scatter = require("../cartesian/Scatter");
var _xaxis = require("../cartesian/XAxis");
var _yaxis = require("../cartesian/YAxis");
var _zaxis = require("../cartesian/ZAxis");
var _cartesianUtils = require("../util/CartesianUtils");
var ComposedChart = (0, _generateCategoricalChart.generateCategoricalChart)({
    chartName: 'ComposedChart',
    GraphicalChild: [
        (0, _line.Line),
        (0, _area.Area),
        (0, _bar.Bar),
        (0, _scatter.Scatter)
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, _xaxis.XAxis)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, _yaxis.YAxis)
        },
        {
            axisType: 'zAxis',
            AxisComp: (0, _zaxis.ZAxis)
        }
    ],
    formatAxisMap: (0, _cartesianUtils.formatAxisMap)
});

},{"./generateCategoricalChart":"l1e9D","../cartesian/Area":"nNjdk","../cartesian/Bar":"9EUGQ","../cartesian/Line":"eU152","../cartesian/Scatter":"cEWud","../cartesian/XAxis":"4nBWG","../cartesian/YAxis":"NHcEZ","../cartesian/ZAxis":"9mmH7","../util/CartesianUtils":"1I6yD","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bb3Qw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SunburstChart", ()=>SunburstChart);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _d3Scale = require("victory-vendor/d3-scale");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _surface = require("../container/Surface");
var _layer = require("../container/Layer");
var _sector = require("../shape/Sector");
var _text = require("../component/Text");
var _polarUtils = require("../util/PolarUtils");
var _tooltip = require("../component/Tooltip");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var defaultTextProps = {
    fontWeight: 'bold',
    paintOrder: 'stroke fill',
    fontSize: '.75rem',
    stroke: '#FFF',
    fill: 'black',
    pointerEvents: 'none'
};
function getMaxDepthOf(node) {
    if (!node.children || node.children.length === 0) return 1;
    // Calculate depth for each child and find the maximum
    var childDepths = node.children.map(function(d) {
        return getMaxDepthOf(d);
    });
    return 1 + Math.max.apply(Math, _toConsumableArray(childDepths));
}
var SunburstChart = function SunburstChart(_ref) {
    var className = _ref.className, data = _ref.data, children = _ref.children, width = _ref.width, height = _ref.height, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? 2 : _ref$padding, _ref$dataKey = _ref.dataKey, dataKey = _ref$dataKey === void 0 ? 'value' : _ref$dataKey, _ref$ringPadding = _ref.ringPadding, ringPadding = _ref$ringPadding === void 0 ? 2 : _ref$ringPadding, _ref$innerRadius = _ref.innerRadius, innerRadius = _ref$innerRadius === void 0 ? 50 : _ref$innerRadius, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? '#333' : _ref$fill, _ref$stroke = _ref.stroke, stroke = _ref$stroke === void 0 ? '#FFF' : _ref$stroke, _ref$textOptions = _ref.textOptions, textOptions = _ref$textOptions === void 0 ? defaultTextProps : _ref$textOptions, _ref$outerRadius = _ref.outerRadius, outerRadius = _ref$outerRadius === void 0 ? Math.min(width, height) / 2 : _ref$outerRadius, _ref$cx = _ref.cx, cx = _ref$cx === void 0 ? width / 2 : _ref$cx, _ref$cy = _ref.cy, cy = _ref$cy === void 0 ? height / 2 : _ref$cy, _ref$startAngle = _ref.startAngle, startAngle = _ref$startAngle === void 0 ? 0 : _ref$startAngle, _ref$endAngle = _ref.endAngle, endAngle = _ref$endAngle === void 0 ? 360 : _ref$endAngle, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave;
    var _useState = (0, _react.useState)(false), _useState2 = _slicedToArray(_useState, 2), isTooltipActive = _useState2[0], setIsTooltipActive = _useState2[1];
    var _useState3 = (0, _react.useState)(null), _useState4 = _slicedToArray(_useState3, 2), activeNode = _useState4[0], setActiveNode = _useState4[1];
    var rScale = (0, _d3Scale.scaleLinear)([
        0,
        data[dataKey]
    ], [
        0,
        endAngle
    ]);
    var treeDepth = getMaxDepthOf(data);
    var thickness = (outerRadius - innerRadius) / treeDepth;
    var sectors = [];
    var positions = new Map([]);
    // event handlers
    function handleMouseEnter(node, e) {
        if (onMouseEnter) onMouseEnter(node, e);
        setActiveNode(node);
        setIsTooltipActive(true);
    }
    function handleMouseLeave(node, e) {
        if (onMouseLeave) onMouseLeave(node, e);
        setActiveNode(null);
        setIsTooltipActive(false);
    }
    function handleClick(node) {
        if (onClick) onClick(node);
    }
    // recursively add nodes for each data point and its children
    function drawArcs(childNodes, options) {
        var radius = options.radius, innerR = options.innerR, initialAngle = options.initialAngle, childColor = options.childColor;
        var currentAngle = initialAngle;
        if (!childNodes) return; // base case: no children of this node
        childNodes.forEach(function(d) {
            var _ref2, _d$fill;
            var arcLength = rScale(d[dataKey]);
            var start = currentAngle;
            // color priority - if there's a color on the individual point use that, otherwise use parent color or default
            var fillColor = (_ref2 = (_d$fill = d === null || d === void 0 ? void 0 : d.fill) !== null && _d$fill !== void 0 ? _d$fill : childColor) !== null && _ref2 !== void 0 ? _ref2 : fill;
            var _polarToCartesian = (0, _polarUtils.polarToCartesian)(0, 0, innerR + radius / 2, -(start + arcLength - arcLength / 2)), textX = _polarToCartesian.x, textY = _polarToCartesian.y;
            currentAngle += arcLength;
            sectors.push(/*#__PURE__*/ // TODO: Missing key warning. Can we use `key={d.name}`?
            (0, _reactDefault.default).createElement("g", {
                "aria-label": d.name,
                tabIndex: 0
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sector.Sector), {
                onClick: function onClick() {
                    return handleClick(d);
                },
                onMouseEnter: function onMouseEnter(e) {
                    return handleMouseEnter(d, e);
                },
                onMouseLeave: function onMouseLeave(e) {
                    return handleMouseLeave(d, e);
                },
                fill: fillColor,
                stroke: stroke,
                strokeWidth: padding,
                startAngle: start,
                endAngle: start + arcLength,
                innerRadius: innerR,
                outerRadius: innerR + radius,
                cx: cx,
                cy: cy
            }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({}, textOptions, {
                alignmentBaseline: "middle",
                textAnchor: "middle",
                x: textX + cx,
                y: cy - textY
            }), d[dataKey])));
            var _polarToCartesian2 = (0, _polarUtils.polarToCartesian)(cx, cy, innerR + radius / 2, start), tooltipX = _polarToCartesian2.x, tooltipY = _polarToCartesian2.y;
            positions.set(d.name, {
                x: tooltipX,
                y: tooltipY
            });
            return drawArcs(d.children, {
                radius: radius,
                innerR: innerR + radius + ringPadding,
                initialAngle: start,
                childColor: fillColor
            });
        });
    }
    drawArcs(data.children, {
        radius: thickness,
        innerR: innerRadius,
        initialAngle: startAngle
    });
    var layerClass = (0, _clsxDefault.default)('recharts-sunburst', className);
    function renderTooltip() {
        var tooltipComponent = (0, _reactUtils.findChildByType)([
            children
        ], (0, _tooltip.Tooltip));
        if (!tooltipComponent || !activeNode) return null;
        var viewBox = {
            x: 0,
            y: 0,
            width: width,
            height: height
        };
        return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(tooltipComponent, {
            viewBox: viewBox,
            coordinate: positions.get(activeNode.name),
            payload: [
                activeNode
            ],
            active: isTooltipActive
        });
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsxDefault.default)('recharts-wrapper', className),
        style: {
            position: 'relative',
            width: width,
            height: height
        },
        role: "region"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _surface.Surface), {
        width: width,
        height: height
    }, children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: layerClass
    }, sectors)), renderTooltip());
};

},{"react":"eGun2","victory-vendor/d3-scale":"16Gyx","clsx":"3mzHT","../util/ReactUtils":"dBf5D","../container/Surface":"7sKCX","../container/Layer":"gNfib","../shape/Sector":"dCpDt","../component/Text":"6tNNj","../util/PolarUtils":"27snq","../component/Tooltip":"5PITU","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7Ev5N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Funnel", ()=>Funnel);
/**
 * @fileOverview Render sectors of a funnel
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isNumber = require("lodash/isNumber");
var _isNumberDefault = parcelHelpers.interopDefault(_isNumber);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _labelList = require("../component/LabelList");
var _cell = require("../component/Cell");
var _reactUtils = require("../util/ReactUtils");
var _global = require("../util/Global");
var _dataUtils = require("../util/DataUtils");
var _chartUtils = require("../util/ChartUtils");
var _types = require("../util/types");
var _funnelUtils = require("../util/FunnelUtils");
var _Funnel;
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var Funnel = /*#__PURE__*/ function(_PureComponent) {
    function Funnel() {
        var _this;
        _classCallCheck(this, Funnel);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, Funnel, [].concat(args));
        _defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        _defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, _isFunctionDefault.default)(onAnimationEnd)) onAnimationEnd();
        });
        _defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, _isFunctionDefault.default)(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    _inherits(Funnel, _PureComponent);
    return _createClass(Funnel, [
        {
            key: "isActiveIndex",
            value: function isActiveIndex(i) {
                var activeIndex = this.props.activeIndex;
                if (Array.isArray(activeIndex)) return activeIndex.indexOf(i) !== -1;
                return i === activeIndex;
            }
        },
        {
            key: "renderTrapezoidsStatically",
            value: function renderTrapezoidsStatically(trapezoids) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, activeShape = _this$props.activeShape;
                return trapezoids.map(function(entry, i) {
                    var trapezoidOptions = _this2.isActiveIndex(i) ? activeShape : shape;
                    var trapezoidProps = _objectSpread(_objectSpread({}, entry), {}, {
                        isActive: _this2.isActiveIndex(i),
                        stroke: entry.stroke
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: "recharts-funnel-trapezoid"
                    }, (0, _types.adaptEventsOfChild)(_this2.props, entry, i), {
                        key: "trapezoid-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.name, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value),
                        role: "img"
                    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _funnelUtils.FunnelTrapezoid), _extends({
                        option: trapezoidOptions
                    }, trapezoidProps)));
                });
            }
        },
        {
            key: "renderTrapezoidsWithAnimation",
            value: function renderTrapezoidsWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, trapezoids = _this$props2.trapezoids, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevTrapezoids = this.state.prevTrapezoids;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "funnel-".concat(animationId),
                    onAnimationStart: this.handleAnimationStart,
                    onAnimationEnd: this.handleAnimationEnd
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = trapezoids.map(function(entry, index) {
                        var prev = prevTrapezoids && prevTrapezoids[index];
                        if (prev) {
                            var _interpolatorX = (0, _dataUtils.interpolateNumber)(prev.x, entry.x);
                            var _interpolatorY = (0, _dataUtils.interpolateNumber)(prev.y, entry.y);
                            var _interpolatorUpperWidth = (0, _dataUtils.interpolateNumber)(prev.upperWidth, entry.upperWidth);
                            var _interpolatorLowerWidth = (0, _dataUtils.interpolateNumber)(prev.lowerWidth, entry.lowerWidth);
                            var _interpolatorHeight = (0, _dataUtils.interpolateNumber)(prev.height, entry.height);
                            return _objectSpread(_objectSpread({}, entry), {}, {
                                x: _interpolatorX(t),
                                y: _interpolatorY(t),
                                upperWidth: _interpolatorUpperWidth(t),
                                lowerWidth: _interpolatorLowerWidth(t),
                                height: _interpolatorHeight(t)
                            });
                        }
                        var interpolatorX = (0, _dataUtils.interpolateNumber)(entry.x + entry.upperWidth / 2, entry.x);
                        var interpolatorY = (0, _dataUtils.interpolateNumber)(entry.y + entry.height / 2, entry.y);
                        var interpolatorUpperWidth = (0, _dataUtils.interpolateNumber)(0, entry.upperWidth);
                        var interpolatorLowerWidth = (0, _dataUtils.interpolateNumber)(0, entry.lowerWidth);
                        var interpolatorHeight = (0, _dataUtils.interpolateNumber)(0, entry.height);
                        return _objectSpread(_objectSpread({}, entry), {}, {
                            x: interpolatorX(t),
                            y: interpolatorY(t),
                            upperWidth: interpolatorUpperWidth(t),
                            lowerWidth: interpolatorLowerWidth(t),
                            height: interpolatorHeight(t)
                        });
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), null, _this3.renderTrapezoidsStatically(stepData));
                });
            }
        },
        {
            key: "renderTrapezoids",
            value: function renderTrapezoids() {
                var _this$props3 = this.props, trapezoids = _this$props3.trapezoids, isAnimationActive = _this$props3.isAnimationActive;
                var prevTrapezoids = this.state.prevTrapezoids;
                if (isAnimationActive && trapezoids && trapezoids.length && (!prevTrapezoids || !(0, _isEqualDefault.default)(prevTrapezoids, trapezoids))) return this.renderTrapezoidsWithAnimation();
                return this.renderTrapezoidsStatically(trapezoids);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, hide = _this$props4.hide, trapezoids = _this$props4.trapezoids, className = _this$props4.className, isAnimationActive = _this$props4.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (hide || !trapezoids || !trapezoids.length) return null;
                var layerClass = (0, _clsxDefault.default)('recharts-trapezoids', className);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass
                }, this.renderTrapezoids(), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(this.props, trapezoids));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curTrapezoids: nextProps.trapezoids,
                    prevTrapezoids: prevState.curTrapezoids
                };
                if (nextProps.trapezoids !== prevState.curTrapezoids) return {
                    curTrapezoids: nextProps.trapezoids
                };
                return null;
            }
        }
    ]);
}((0, _react.PureComponent));
_Funnel = Funnel;
_defineProperty(Funnel, "displayName", 'Funnel');
_defineProperty(Funnel, "defaultProps", {
    stroke: '#fff',
    fill: '#808080',
    legendType: 'rect',
    labelLine: true,
    hide: false,
    isAnimationActive: !(0, _global.Global).isSsr,
    animationBegin: 400,
    animationDuration: 1500,
    animationEasing: 'ease',
    nameKey: 'name',
    lastShapeType: 'triangle'
});
_defineProperty(Funnel, "getRealFunnelData", function(item) {
    var _item$props = item.props, data = _item$props.data, children = _item$props.children;
    var presentationProps = (0, _reactUtils.filterProps)(item.props, false);
    var cells = (0, _reactUtils.findAllByType)(children, (0, _cell.Cell));
    if (data && data.length) return data.map(function(entry, index) {
        return _objectSpread(_objectSpread(_objectSpread({
            payload: entry
        }, presentationProps), entry), cells && cells[index] && cells[index].props);
    });
    if (cells && cells.length) return cells.map(function(cell) {
        return _objectSpread(_objectSpread({}, presentationProps), cell.props);
    });
    return [];
});
_defineProperty(Funnel, "getRealWidthHeight", function(item, offset) {
    var customWidth = item.props.width;
    var width = offset.width, height = offset.height, left = offset.left, right = offset.right, top = offset.top, bottom = offset.bottom;
    var realHeight = height;
    var realWidth = width;
    if ((0, _isNumberDefault.default)(customWidth)) realWidth = customWidth;
    else if ((0, _isStringDefault.default)(customWidth)) realWidth = realWidth * parseFloat(customWidth) / 100;
    return {
        realWidth: realWidth - left - right - 50,
        realHeight: realHeight - bottom - top,
        offsetX: (width - realWidth) / 2,
        offsetY: (height - realHeight) / 2
    };
});
_defineProperty(Funnel, "getComposedData", function(_ref2) {
    var item = _ref2.item, offset = _ref2.offset;
    var funnelData = _Funnel.getRealFunnelData(item);
    var _item$props2 = item.props, dataKey = _item$props2.dataKey, nameKey = _item$props2.nameKey, tooltipType = _item$props2.tooltipType, lastShapeType = _item$props2.lastShapeType, reversed = _item$props2.reversed;
    var left = offset.left, top = offset.top;
    var _Funnel$getRealWidthH = _Funnel.getRealWidthHeight(item, offset), realHeight = _Funnel$getRealWidthH.realHeight, realWidth = _Funnel$getRealWidthH.realWidth, offsetX = _Funnel$getRealWidthH.offsetX, offsetY = _Funnel$getRealWidthH.offsetY;
    var maxValue = Math.max.apply(null, funnelData.map(function(entry) {
        return (0, _chartUtils.getValueByDataKey)(entry, dataKey, 0);
    }));
    var len = funnelData.length;
    var rowHeight = realHeight / len;
    var parentViewBox = {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
    var trapezoids = funnelData.map(function(entry, i) {
        var rawVal = (0, _chartUtils.getValueByDataKey)(entry, dataKey, 0);
        var name = (0, _chartUtils.getValueByDataKey)(entry, nameKey, i);
        var val = rawVal;
        var nextVal;
        if (i !== len - 1) {
            nextVal = (0, _chartUtils.getValueByDataKey)(funnelData[i + 1], dataKey, 0);
            if (nextVal instanceof Array) {
                var _nextVal = nextVal;
                var _nextVal2 = _slicedToArray(_nextVal, 1);
                nextVal = _nextVal2[0];
            }
        } else if (rawVal instanceof Array && rawVal.length === 2) {
            var _rawVal = _slicedToArray(rawVal, 2);
            val = _rawVal[0];
            nextVal = _rawVal[1];
        } else if (lastShapeType === 'rectangle') nextVal = val;
        else nextVal = 0;
        var x = (maxValue - val) * realWidth / (2 * maxValue) + top + 25 + offsetX;
        var y = rowHeight * i + left + offsetY;
        var upperWidth = val / maxValue * realWidth;
        var lowerWidth = nextVal / maxValue * realWidth;
        var tooltipPayload = [
            {
                name: name,
                value: val,
                payload: entry,
                dataKey: dataKey,
                type: tooltipType
            }
        ];
        var tooltipPosition = {
            x: x + upperWidth / 2,
            y: y + rowHeight / 2
        };
        return _objectSpread(_objectSpread({
            x: x,
            y: y,
            width: Math.max(upperWidth, lowerWidth),
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: rowHeight,
            name: name,
            val: val,
            tooltipPayload: tooltipPayload,
            tooltipPosition: tooltipPosition
        }, (0, _omitDefault.default)(entry, 'width')), {}, {
            payload: entry,
            parentViewBox: parentViewBox,
            labelViewBox: {
                x: x + (upperWidth - lowerWidth) / 4,
                y: y,
                width: Math.abs(upperWidth - lowerWidth) / 2 + Math.min(upperWidth, lowerWidth),
                height: rowHeight
            }
        });
    });
    if (reversed) trapezoids = trapezoids.map(function(entry, index) {
        var newY = entry.y - index * rowHeight + (len - 1 - index) * rowHeight;
        return _objectSpread(_objectSpread({}, entry), {}, {
            upperWidth: entry.lowerWidth,
            lowerWidth: entry.upperWidth,
            x: entry.x - (entry.lowerWidth - entry.upperWidth) / 2,
            y: entry.y - index * rowHeight + (len - 1 - index) * rowHeight,
            tooltipPosition: _objectSpread(_objectSpread({}, entry.tooltipPosition), {}, {
                y: newY + rowHeight / 2
            }),
            labelViewBox: _objectSpread(_objectSpread({}, entry.labelViewBox), {}, {
                y: newY
            })
        });
    });
    return {
        trapezoids: trapezoids,
        data: funnelData
    };
});

},{"react":"eGun2","react-smooth":"ekPiD","lodash/isFunction":"2KQKo","lodash/isNumber":"au46v","lodash/isString":"29E9a","lodash/omit":"lkehy","lodash/isEqual":"kMH36","clsx":"3mzHT","../container/Layer":"gNfib","../component/LabelList":"j6MTq","../component/Cell":"6TviG","../util/ReactUtils":"dBf5D","../util/Global":"dWTWi","../util/DataUtils":"lsl3R","../util/ChartUtils":"55u3i","../util/types":"5mtYY","../util/FunnelUtils":"hUm1d","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hUm1d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Trapezoid props is expecting x, y, height as numbers.
// When props are being spread in from a user defined component in Funnel,
// the prop types of an SVGElement have these typed as string | number.
// This function will return the passed in props along with x, y, height as numbers.
parcelHelpers.export(exports, "typeGuardTrapezoidProps", ()=>typeGuardTrapezoidProps);
parcelHelpers.export(exports, "FunnelTrapezoid", ()=>FunnelTrapezoid);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _activeShapeUtils = require("./ActiveShapeUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function typeGuardTrapezoidProps(option, props) {
    var xValue = "".concat(props.x || option.x);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(props.y || option.y);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat((props === null || props === void 0 ? void 0 : props.height) || (option === null || option === void 0 ? void 0 : option.height));
    var height = parseInt(heightValue, 10);
    return _objectSpread(_objectSpread(_objectSpread({}, props), (0, _activeShapeUtils.getPropsFromShapeOption)(option)), {}, {
        height: height,
        x: x,
        y: y
    });
}
function FunnelTrapezoid(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _activeShapeUtils.Shape), _extends({
        shapeType: "trapezoid",
        propTransformer: typeGuardTrapezoidProps
    }, props));
}

},{"react":"eGun2","./ActiveShapeUtils":"6kRg3","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dLKDB":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Funnel Chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FunnelChart", ()=>FunnelChart);
var _generateCategoricalChart = require("./generateCategoricalChart");
var _funnel = require("../numberAxis/Funnel");
var FunnelChart = (0, _generateCategoricalChart.generateCategoricalChart)({
    chartName: 'FunnelChart',
    GraphicalChild: (0, _funnel.Funnel),
    validateTooltipEventTypes: [
        'item'
    ],
    defaultTooltipEventType: 'item',
    axisComponents: [],
    defaultProps: {
        layout: 'centric'
    }
});

},{"./generateCategoricalChart":"l1e9D","../numberAxis/Funnel":"7Ev5N","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2z5ie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _zod = require("zod");
var _lucideReact = require("lucide-react");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _input = require("@/client/components/ui/input");
var _button = require("@/client/components/ui/button");
var _label = require("@/client/components/ui/label");
var _dialog = require("@/client/components/ui/dialog");
var _spinner = require("@/client/components/ui/spinner");
var _table = require("@/client/components/ui/table");
var _crud = require("@/client/utils/crud");
var _clientsStore = require("@/client/store/clientsStore");
const USER_METADATA_KEY = 'http://invintus_user_metadata';
// Validation schema for swap form
const swapSchema = (0, _zod.z).object({
    userID: (0, _zod.z).string().min(1, 'User ID is required').regex(/^\d+$/, 'User ID must be a number'),
    clientID: (0, _zod.z).string().length(10, 'Client ID invalid').regex(/^\d+$/, 'Client ID must be a number')
});
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'utilities/swap-user-client',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: SwapUserClientComponent
});
function SwapUserClientComponent() {
    const { getAccessTokenSilently, loginWithRedirect, user, logout } = (0, _auth0React.useAuth0)();
    const [userID, setUserID] = (0, _react.useState)('');
    const [clientID, setClientID] = (0, _react.useState)('');
    const [initialUserID, setInitialUserID] = (0, _react.useState)('');
    const [initialClientID, setInitialClientID] = (0, _react.useState)('');
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    const [success, setSuccess] = (0, _react.useState)(false);
    const [dialogOpen, setDialogOpen] = (0, _react.useState)(false);
    const [clientFilter, setClientFilter] = (0, _react.useState)('');
    const { clients, fetchClients, loading: clientsLoading } = (0, _clientsStore.useClientsStore)();
    // Pre-populate from user metadata
    (0, _react.useEffect)(()=>{
        if (user) {
            const metadata = user[USER_METADATA_KEY];
            if (metadata) {
                if (metadata.loginID !== undefined) {
                    const loginIDStr = String(metadata.loginID);
                    setUserID(loginIDStr);
                    setInitialUserID(loginIDStr);
                }
                if (metadata.clientID !== undefined) {
                    const clientIDStr = String(metadata.clientID);
                    setClientID(clientIDStr);
                    setInitialClientID(clientIDStr);
                }
            }
        }
    }, [
        user
    ]);
    // Fetch clients on mount
    (0, _react.useEffect)(()=>{
        const loadClients = async ()=>{
            const token = await getAccessTokenSilently();
            await fetchClients(token, logout);
        };
        if (clients.length === 0) loadClients();
    }, [
        getAccessTokenSilently,
        fetchClients,
        clients.length
    ]);
    // Filter active clients, apply search filter, and sort alphabetically
    const activeClients = clients.filter((client)=>client.active === 1).filter((client)=>clientFilter === '' || client.name.toLowerCase().includes(clientFilter.toLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
    const hasChanges = userID !== initialUserID || clientID !== initialClientID;
    const canSubmit = !loading && userID && clientID && hasChanges;
    const initialClientName = clients.find((c)=>c.clientID === initialClientID)?.name;
    const newClientName = clients.find((c)=>c.clientID === clientID)?.name;
    const handleClientSelect = (selectedClientID)=>{
        setClientID(selectedClientID);
        setDialogOpen(false);
        setClientFilter('');
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError(null);
        setSuccess(false);
        const validation = swapSchema.safeParse({
            userID,
            clientID
        });
        if (!validation.success) {
            setError(validation.error.issues[0].message);
            return;
        }
        setLoading(true);
        try {
            const accessToken = await getAccessTokenSilently();
            const payload = {
                userID,
                clientID
            };
            const response = await (0, _crud.callCrudApi)('/Users/swapUserAcc', payload, accessToken);
            if (response.success) {
                setSuccess(true);
                // Silent re-auth to refresh user metadata from Auth0 after delay
                setTimeout(()=>{
                    loginWithRedirect({
                        authorizationParams: {
                            prompt: 'none'
                        },
                        appState: {
                            returnTo: window.location.pathname
                        }
                    });
                }, 4000);
            } else setError('Operation failed. Please check the IDs and try again.');
        } catch (err) {
            setError(err instanceof Error ? err.message : 'An unexpected error occurred');
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Layout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            className: "text-2xl font-semibold mb-4",
                            children: "Swap User Client"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-muted-foreground mb-6",
                            children: "This utility allows you to swap a user's client association."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                            onSubmit: handleSubmit,
                            className: "max-w-md space-y-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                            htmlFor: "userID",
                                            children: "User ID"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                            id: "userID",
                                            type: "text",
                                            value: userID,
                                            onChange: (e)=>setUserID(e.target.value),
                                            placeholder: "Enter user ID",
                                            required: true,
                                            disabled: loading,
                                            className: "font-mono"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                            htmlFor: "clientID",
                                            children: "Client ID"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                                    id: "clientID",
                                                    type: "text",
                                                    value: clientID,
                                                    onChange: (e)=>setClientID(e.target.value),
                                                    placeholder: "Enter client ID",
                                                    required: true,
                                                    disabled: loading,
                                                    className: "font-mono"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    type: "button",
                                                    variant: "outline",
                                                    onClick: ()=>setDialogOpen(true),
                                                    disabled: loading,
                                                    children: "Browse"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "p-3 text-sm text-red-500 bg-red-50 dark:bg-red-950 rounded-md",
                                    children: error
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    type: "submit",
                                    disabled: !canSubmit,
                                    children: loading ? 'Processing...' : 'Swap Client'
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
                open: success,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.DialogContent), {
                    className: "max-w-sm",
                    onPointerDownOutside: (e)=>e.preventDefault(),
                    onEscapeKeyDown: (e)=>e.preventDefault(),
                    hideCloseButton: true,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.DialogTitle), {
                            className: "sr-only",
                            children: "Success"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex flex-col items-center justify-center py-6 gap-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {
                                    className: "size-8"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-lg font-medium text-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Success!"
                                    })
                                }),
                                initialClientName && newClientName && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-col items-center gap-1 text-base bg-muted rounded-md p-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-muted-foreground",
                                            children: initialClientName
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.MoveDown), {
                                            className: "size-5"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "font-bold",
                                            children: newClientName
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
                open: dialogOpen,
                onOpenChange: (open)=>{
                    setDialogOpen(open);
                    if (!open) setClientFilter('');
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.DialogContent), {
                    className: "max-w-2xl max-h-[80vh] flex flex-col top-[10%] translate-y-0",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.DialogHeader), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.DialogTitle), {
                                    children: "Select Client"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.DialogDescription), {
                                    children: "Choose an active client from the list below."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                            type: "text",
                            placeholder: "Filter by client name...",
                            value: clientFilter,
                            onChange: (e)=>setClientFilter(e.target.value),
                            className: "mb-2"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overflow-auto flex-1",
                            children: clientsLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "py-8 text-center text-muted-foreground",
                                children: "Loading clients..."
                            }) : activeClients.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "py-8 text-center text-muted-foreground",
                                children: "No active clients found."
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                className: "table-fixed",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    className: "w-32",
                                                    children: "Client ID"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    children: "Name"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                        children: activeClients.map((client)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                className: "cursor-pointer hover:bg-muted",
                                                onClick: ()=>handleClientSelect(client.clientID),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "font-mono",
                                                        children: client.clientID
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        children: client.name
                                                    })
                                                ]
                                            }, client.clientID))
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"]],"@auth0/auth0-react":"gpXrE","zod":"dmnwW","lucide-react":[["MoveDown","7Dz6x","default"]],"../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/components/ui/input":"8UHwi","@/client/components/ui/button":"armlb","@/client/components/ui/label":"cLMZq","@/client/components/ui/dialog":"6jjic","@/client/components/ui/spinner":"7htqi","@/client/components/ui/table":"5vxZ8","@/client/utils/crud":"3ws1j","@/client/store/clientsStore":"6bg3l","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dmnwW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "z", ()=>_externalJs);
var _externalJs = require("./v4/classic/external.js");
parcelHelpers.exportAll(_externalJs, exports);
exports.default = _externalJs;

},{"./v4/classic/external.js":"6yJev","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6yJev":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "core", ()=>_indexJs);
parcelHelpers.export(exports, "globalRegistry", ()=>(0, _indexJs.globalRegistry));
parcelHelpers.export(exports, "registry", ()=>(0, _indexJs.registry));
parcelHelpers.export(exports, "config", ()=>(0, _indexJs.config));
parcelHelpers.export(exports, "$output", ()=>(0, _indexJs.$output));
parcelHelpers.export(exports, "$input", ()=>(0, _indexJs.$input));
parcelHelpers.export(exports, "$brand", ()=>(0, _indexJs.$brand));
parcelHelpers.export(exports, "clone", ()=>(0, _indexJs.clone));
parcelHelpers.export(exports, "regexes", ()=>(0, _indexJs.regexes));
parcelHelpers.export(exports, "treeifyError", ()=>(0, _indexJs.treeifyError));
parcelHelpers.export(exports, "prettifyError", ()=>(0, _indexJs.prettifyError));
parcelHelpers.export(exports, "formatError", ()=>(0, _indexJs.formatError));
parcelHelpers.export(exports, "flattenError", ()=>(0, _indexJs.flattenError));
parcelHelpers.export(exports, "TimePrecision", ()=>(0, _indexJs.TimePrecision));
parcelHelpers.export(exports, "util", ()=>(0, _indexJs.util));
parcelHelpers.export(exports, "NEVER", ()=>(0, _indexJs.NEVER));
parcelHelpers.export(exports, "toJSONSchema", ()=>(0, _jsonSchemaProcessorsJs.toJSONSchema));
parcelHelpers.export(exports, "fromJSONSchema", ()=>(0, _fromJsonSchemaJs.fromJSONSchema));
parcelHelpers.export(exports, "locales", ()=>_indexJs1);
// iso
// must be exported from top-level
// https://github.com/colinhacks/zod/issues/4491
parcelHelpers.export(exports, "ZodISODateTime", ()=>(0, _isoJs.ZodISODateTime));
parcelHelpers.export(exports, "ZodISODate", ()=>(0, _isoJs.ZodISODate));
parcelHelpers.export(exports, "ZodISOTime", ()=>(0, _isoJs.ZodISOTime));
parcelHelpers.export(exports, "ZodISODuration", ()=>(0, _isoJs.ZodISODuration));
parcelHelpers.export(exports, "iso", ()=>_isoJs);
parcelHelpers.export(exports, "coerce", ()=>_coerceJs);
var _indexJs = require("../core/index.js");
var _schemasJs = require("./schemas.js");
parcelHelpers.exportAll(_schemasJs, exports);
var _checksJs = require("./checks.js");
parcelHelpers.exportAll(_checksJs, exports);
var _errorsJs = require("./errors.js");
parcelHelpers.exportAll(_errorsJs, exports);
var _parseJs = require("./parse.js");
parcelHelpers.exportAll(_parseJs, exports);
var _compatJs = require("./compat.js");
parcelHelpers.exportAll(_compatJs, exports);
var _enJs = require("../locales/en.js");
var _enJsDefault = parcelHelpers.interopDefault(_enJs);
var _jsonSchemaProcessorsJs = require("../core/json-schema-processors.js");
var _fromJsonSchemaJs = require("./from-json-schema.js");
var _indexJs1 = require("../locales/index.js");
var _isoJs = require("./iso.js");
var _coerceJs = require("./coerce.js");
(0, _indexJs.config)((0, _enJsDefault.default)());

},{"../core/index.js":"63UT7","./schemas.js":"6nTcv","./checks.js":"1AKdd","./errors.js":"8fkl5","./parse.js":"5Z06C","./compat.js":"9Gu9u","../locales/en.js":"giZBF","../core/json-schema-processors.js":"c7eX7","./from-json-schema.js":"19Ne8","../locales/index.js":"8wwdV","./iso.js":"iqX89","./coerce.js":"DJhOY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"63UT7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "util", ()=>_utilJs);
parcelHelpers.export(exports, "regexes", ()=>_regexesJs);
parcelHelpers.export(exports, "locales", ()=>_indexJs);
parcelHelpers.export(exports, "toJSONSchema", ()=>(0, _jsonSchemaProcessorsJs.toJSONSchema));
parcelHelpers.export(exports, "JSONSchemaGenerator", ()=>(0, _jsonSchemaGeneratorJs.JSONSchemaGenerator));
parcelHelpers.export(exports, "JSONSchema", ()=>_jsonSchemaJs);
var _coreJs = require("./core.js");
parcelHelpers.exportAll(_coreJs, exports);
var _parseJs = require("./parse.js");
parcelHelpers.exportAll(_parseJs, exports);
var _errorsJs = require("./errors.js");
parcelHelpers.exportAll(_errorsJs, exports);
var _schemasJs = require("./schemas.js");
parcelHelpers.exportAll(_schemasJs, exports);
var _checksJs = require("./checks.js");
parcelHelpers.exportAll(_checksJs, exports);
var _versionsJs = require("./versions.js");
parcelHelpers.exportAll(_versionsJs, exports);
var _utilJs = require("./util.js");
var _regexesJs = require("./regexes.js");
var _indexJs = require("../locales/index.js");
var _registriesJs = require("./registries.js");
parcelHelpers.exportAll(_registriesJs, exports);
var _docJs = require("./doc.js");
parcelHelpers.exportAll(_docJs, exports);
var _apiJs = require("./api.js");
parcelHelpers.exportAll(_apiJs, exports);
var _toJsonSchemaJs = require("./to-json-schema.js");
parcelHelpers.exportAll(_toJsonSchemaJs, exports);
var _jsonSchemaProcessorsJs = require("./json-schema-processors.js");
var _jsonSchemaGeneratorJs = require("./json-schema-generator.js");
var _jsonSchemaJs = require("./json-schema.js");

},{"./core.js":"cST2y","./parse.js":"eT8JT","./errors.js":"bsKVl","./schemas.js":"c5Ly7","./checks.js":"f4OM4","./versions.js":"8tnlW","./util.js":"kNqJY","./regexes.js":"2Kw1v","../locales/index.js":"8wwdV","./registries.js":"fccKK","./doc.js":"8A0Wo","./api.js":"fE0q8","./to-json-schema.js":"7JRwT","./json-schema-processors.js":"c7eX7","./json-schema-generator.js":"40MpB","./json-schema.js":"gOGX9","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cST2y":[function(require,module,exports,__globalThis) {
/** A special constant with type `never` */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NEVER", ()=>NEVER);
parcelHelpers.export(exports, "$constructor", ()=>$constructor);
parcelHelpers.export(exports, "$brand", ()=>$brand);
parcelHelpers.export(exports, "$ZodAsyncError", ()=>$ZodAsyncError);
parcelHelpers.export(exports, "$ZodEncodeError", ()=>$ZodEncodeError);
parcelHelpers.export(exports, "globalConfig", ()=>globalConfig);
parcelHelpers.export(exports, "config", ()=>config);
const NEVER = Object.freeze({
    status: "aborted"
});
/*@__NO_SIDE_EFFECTS__*/ function $constructor(name, initializer, params) {
    function init(inst, def) {
        if (!inst._zod) Object.defineProperty(inst, "_zod", {
            value: {
                def,
                constr: _,
                traits: new Set()
            },
            enumerable: false
        });
        if (inst._zod.traits.has(name)) return;
        inst._zod.traits.add(name);
        initializer(inst, def);
        // support prototype modifications
        const proto = _.prototype;
        const keys = Object.keys(proto);
        for(let i = 0; i < keys.length; i++){
            const k = keys[i];
            if (!(k in inst)) inst[k] = proto[k].bind(inst);
        }
    }
    // doesn't work if Parent has a constructor with arguments
    const Parent = params?.Parent ?? Object;
    class Definition extends Parent {
    }
    Object.defineProperty(Definition, "name", {
        value: name
    });
    function _(def) {
        var _a;
        const inst = params?.Parent ? new Definition() : this;
        init(inst, def);
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        for (const fn of inst._zod.deferred)fn();
        return inst;
    }
    Object.defineProperty(_, "init", {
        value: init
    });
    Object.defineProperty(_, Symbol.hasInstance, {
        value: (inst)=>{
            if (params?.Parent && inst instanceof params.Parent) return true;
            return inst?._zod?.traits?.has(name);
        }
    });
    Object.defineProperty(_, "name", {
        value: name
    });
    return _;
}
const $brand = Symbol("zod_brand");
class $ZodAsyncError extends Error {
    constructor(){
        super(`Encountered Promise during synchronous parse. Use .parseAsync() instead.`);
    }
}
class $ZodEncodeError extends Error {
    constructor(name){
        super(`Encountered unidirectional transform during encode: ${name}`);
        this.name = "ZodEncodeError";
    }
}
const globalConfig = {};
function config(newConfig) {
    if (newConfig) Object.assign(globalConfig, newConfig);
    return globalConfig;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eT8JT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_parse", ()=>_parse);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "_parseAsync", ()=>_parseAsync);
parcelHelpers.export(exports, "parseAsync", ()=>parseAsync);
parcelHelpers.export(exports, "_safeParse", ()=>_safeParse);
parcelHelpers.export(exports, "safeParse", ()=>safeParse);
parcelHelpers.export(exports, "_safeParseAsync", ()=>_safeParseAsync);
parcelHelpers.export(exports, "safeParseAsync", ()=>safeParseAsync);
parcelHelpers.export(exports, "_encode", ()=>_encode);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "_decode", ()=>_decode);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "_encodeAsync", ()=>_encodeAsync);
parcelHelpers.export(exports, "encodeAsync", ()=>encodeAsync);
parcelHelpers.export(exports, "_decodeAsync", ()=>_decodeAsync);
parcelHelpers.export(exports, "decodeAsync", ()=>decodeAsync);
parcelHelpers.export(exports, "_safeEncode", ()=>_safeEncode);
parcelHelpers.export(exports, "safeEncode", ()=>safeEncode);
parcelHelpers.export(exports, "_safeDecode", ()=>_safeDecode);
parcelHelpers.export(exports, "safeDecode", ()=>safeDecode);
parcelHelpers.export(exports, "_safeEncodeAsync", ()=>_safeEncodeAsync);
parcelHelpers.export(exports, "safeEncodeAsync", ()=>safeEncodeAsync);
parcelHelpers.export(exports, "_safeDecodeAsync", ()=>_safeDecodeAsync);
parcelHelpers.export(exports, "safeDecodeAsync", ()=>safeDecodeAsync);
var _coreJs = require("./core.js");
var _errorsJs = require("./errors.js");
var _utilJs = require("./util.js");
const _parse = (_Err)=>(schema, value, _ctx, _params)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            async: false
        }) : {
            async: false
        };
        const result = schema._zod.run({
            value,
            issues: []
        }, ctx);
        if (result instanceof Promise) throw new _coreJs.$ZodAsyncError();
        if (result.issues.length) {
            const e = new (_params?.Err ?? _Err)(result.issues.map((iss)=>_utilJs.finalizeIssue(iss, ctx, _coreJs.config())));
            _utilJs.captureStackTrace(e, _params?.callee);
            throw e;
        }
        return result.value;
    };
const parse = /* @__PURE__*/ _parse(_errorsJs.$ZodRealError);
const _parseAsync = (_Err)=>async (schema, value, _ctx, params)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            async: true
        }) : {
            async: true
        };
        let result = schema._zod.run({
            value,
            issues: []
        }, ctx);
        if (result instanceof Promise) result = await result;
        if (result.issues.length) {
            const e = new (params?.Err ?? _Err)(result.issues.map((iss)=>_utilJs.finalizeIssue(iss, ctx, _coreJs.config())));
            _utilJs.captureStackTrace(e, params?.callee);
            throw e;
        }
        return result.value;
    };
const parseAsync = /* @__PURE__*/ _parseAsync(_errorsJs.$ZodRealError);
const _safeParse = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: false
        } : {
            async: false
        };
        const result = schema._zod.run({
            value,
            issues: []
        }, ctx);
        if (result instanceof Promise) throw new _coreJs.$ZodAsyncError();
        return result.issues.length ? {
            success: false,
            error: new (_Err ?? _errorsJs.$ZodError)(result.issues.map((iss)=>_utilJs.finalizeIssue(iss, ctx, _coreJs.config())))
        } : {
            success: true,
            data: result.value
        };
    };
const safeParse = /* @__PURE__*/ _safeParse(_errorsJs.$ZodRealError);
const _safeParseAsync = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            async: true
        }) : {
            async: true
        };
        let result = schema._zod.run({
            value,
            issues: []
        }, ctx);
        if (result instanceof Promise) result = await result;
        return result.issues.length ? {
            success: false,
            error: new _Err(result.issues.map((iss)=>_utilJs.finalizeIssue(iss, ctx, _coreJs.config())))
        } : {
            success: true,
            data: result.value
        };
    };
const safeParseAsync = /* @__PURE__*/ _safeParseAsync(_errorsJs.$ZodRealError);
const _encode = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return _parse(_Err)(schema, value, ctx);
    };
const encode = /* @__PURE__*/ _encode(_errorsJs.$ZodRealError);
const _decode = (_Err)=>(schema, value, _ctx)=>{
        return _parse(_Err)(schema, value, _ctx);
    };
const decode = /* @__PURE__*/ _decode(_errorsJs.$ZodRealError);
const _encodeAsync = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return _parseAsync(_Err)(schema, value, ctx);
    };
const encodeAsync = /* @__PURE__*/ _encodeAsync(_errorsJs.$ZodRealError);
const _decodeAsync = (_Err)=>async (schema, value, _ctx)=>{
        return _parseAsync(_Err)(schema, value, _ctx);
    };
const decodeAsync = /* @__PURE__*/ _decodeAsync(_errorsJs.$ZodRealError);
const _safeEncode = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return _safeParse(_Err)(schema, value, ctx);
    };
const safeEncode = /* @__PURE__*/ _safeEncode(_errorsJs.$ZodRealError);
const _safeDecode = (_Err)=>(schema, value, _ctx)=>{
        return _safeParse(_Err)(schema, value, _ctx);
    };
const safeDecode = /* @__PURE__*/ _safeDecode(_errorsJs.$ZodRealError);
const _safeEncodeAsync = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return _safeParseAsync(_Err)(schema, value, ctx);
    };
const safeEncodeAsync = /* @__PURE__*/ _safeEncodeAsync(_errorsJs.$ZodRealError);
const _safeDecodeAsync = (_Err)=>async (schema, value, _ctx)=>{
        return _safeParseAsync(_Err)(schema, value, _ctx);
    };
const safeDecodeAsync = /* @__PURE__*/ _safeDecodeAsync(_errorsJs.$ZodRealError);

},{"./core.js":"cST2y","./errors.js":"bsKVl","./util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bsKVl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$ZodError", ()=>$ZodError);
parcelHelpers.export(exports, "$ZodRealError", ()=>$ZodRealError);
parcelHelpers.export(exports, "flattenError", ()=>flattenError);
parcelHelpers.export(exports, "formatError", ()=>formatError);
parcelHelpers.export(exports, "treeifyError", ()=>treeifyError);
/** Format a ZodError as a human-readable string in the following form.
 *
 * From
 *
 * ```ts
 * ZodError {
 *   issues: [
 *     {
 *       expected: 'string',
 *       code: 'invalid_type',
 *       path: [ 'username' ],
 *       message: 'Invalid input: expected string'
 *     },
 *     {
 *       expected: 'number',
 *       code: 'invalid_type',
 *       path: [ 'favoriteNumbers', 1 ],
 *       message: 'Invalid input: expected number'
 *     }
 *   ];
 * }
 * ```
 *
 * to
 *
 * ```
 * username
 *   ✖ Expected number, received string at "username
 * favoriteNumbers[0]
 *   ✖ Invalid input: expected number
 * ```
 */ parcelHelpers.export(exports, "toDotPath", ()=>toDotPath);
parcelHelpers.export(exports, "prettifyError", ()=>prettifyError);
var _coreJs = require("./core.js");
var _utilJs = require("./util.js");
const initializer = (inst, def)=>{
    inst.name = "$ZodError";
    Object.defineProperty(inst, "_zod", {
        value: inst._zod,
        enumerable: false
    });
    Object.defineProperty(inst, "issues", {
        value: def,
        enumerable: false
    });
    inst.message = JSON.stringify(def, _utilJs.jsonStringifyReplacer, 2);
    Object.defineProperty(inst, "toString", {
        value: ()=>inst.message,
        enumerable: false
    });
};
const $ZodError = (0, _coreJs.$constructor)("$ZodError", initializer);
const $ZodRealError = (0, _coreJs.$constructor)("$ZodError", initializer, {
    Parent: Error
});
function flattenError(error, mapper = (issue)=>issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of error.issues)if (sub.path.length > 0) {
        fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
        fieldErrors[sub.path[0]].push(mapper(sub));
    } else formErrors.push(mapper(sub));
    return {
        formErrors,
        fieldErrors
    };
}
function formatError(error, mapper = (issue)=>issue.message) {
    const fieldErrors = {
        _errors: []
    };
    const processError = (error)=>{
        for (const issue of error.issues){
            if (issue.code === "invalid_union" && issue.errors.length) issue.errors.map((issues)=>processError({
                    issues
                }));
            else if (issue.code === "invalid_key") processError({
                issues: issue.issues
            });
            else if (issue.code === "invalid_element") processError({
                issues: issue.issues
            });
            else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
            else {
                let curr = fieldErrors;
                let i = 0;
                while(i < issue.path.length){
                    const el = issue.path[i];
                    const terminal = i === issue.path.length - 1;
                    if (!terminal) curr[el] = curr[el] || {
                        _errors: []
                    };
                    else {
                        curr[el] = curr[el] || {
                            _errors: []
                        };
                        curr[el]._errors.push(mapper(issue));
                    }
                    curr = curr[el];
                    i++;
                }
            }
        }
    };
    processError(error);
    return fieldErrors;
}
function treeifyError(error, mapper = (issue)=>issue.message) {
    const result = {
        errors: []
    };
    const processError = (error, path = [])=>{
        var _a, _b;
        for (const issue of error.issues){
            if (issue.code === "invalid_union" && issue.errors.length) // regular union error
            issue.errors.map((issues)=>processError({
                    issues
                }, issue.path));
            else if (issue.code === "invalid_key") processError({
                issues: issue.issues
            }, issue.path);
            else if (issue.code === "invalid_element") processError({
                issues: issue.issues
            }, issue.path);
            else {
                const fullpath = [
                    ...path,
                    ...issue.path
                ];
                if (fullpath.length === 0) {
                    result.errors.push(mapper(issue));
                    continue;
                }
                let curr = result;
                let i = 0;
                while(i < fullpath.length){
                    const el = fullpath[i];
                    const terminal = i === fullpath.length - 1;
                    if (typeof el === "string") {
                        curr.properties ?? (curr.properties = {});
                        (_a = curr.properties)[el] ?? (_a[el] = {
                            errors: []
                        });
                        curr = curr.properties[el];
                    } else {
                        curr.items ?? (curr.items = []);
                        (_b = curr.items)[el] ?? (_b[el] = {
                            errors: []
                        });
                        curr = curr.items[el];
                    }
                    if (terminal) curr.errors.push(mapper(issue));
                    i++;
                }
            }
        }
    };
    processError(error);
    return result;
}
function toDotPath(_path) {
    const segs = [];
    const path = _path.map((seg)=>typeof seg === "object" ? seg.key : seg);
    for (const seg of path){
        if (typeof seg === "number") segs.push(`[${seg}]`);
        else if (typeof seg === "symbol") segs.push(`[${JSON.stringify(String(seg))}]`);
        else if (/[^\w$]/.test(seg)) segs.push(`[${JSON.stringify(seg)}]`);
        else {
            if (segs.length) segs.push(".");
            segs.push(seg);
        }
    }
    return segs.join("");
}
function prettifyError(error) {
    const lines = [];
    // sort by path length
    const issues = [
        ...error.issues
    ].sort((a, b)=>(a.path ?? []).length - (b.path ?? []).length);
    // Process each issue
    for (const issue of issues){
        lines.push(`\u{2716} ${issue.message}`);
        if (issue.path?.length) lines.push(`  \u{2192} at ${toDotPath(issue.path)}`);
    }
    // Convert Map to formatted string
    return lines.join("\n");
}

},{"./core.js":"cST2y","./util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kNqJY":[function(require,module,exports,__globalThis) {
// functions
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assertEqual", ()=>assertEqual);
parcelHelpers.export(exports, "assertNotEqual", ()=>assertNotEqual);
parcelHelpers.export(exports, "assertIs", ()=>assertIs);
parcelHelpers.export(exports, "assertNever", ()=>assertNever);
parcelHelpers.export(exports, "assert", ()=>assert);
parcelHelpers.export(exports, "getEnumValues", ()=>getEnumValues);
parcelHelpers.export(exports, "joinValues", ()=>joinValues);
parcelHelpers.export(exports, "jsonStringifyReplacer", ()=>jsonStringifyReplacer);
parcelHelpers.export(exports, "cached", ()=>cached);
parcelHelpers.export(exports, "nullish", ()=>nullish);
parcelHelpers.export(exports, "cleanRegex", ()=>cleanRegex);
parcelHelpers.export(exports, "floatSafeRemainder", ()=>floatSafeRemainder);
parcelHelpers.export(exports, "defineLazy", ()=>defineLazy);
parcelHelpers.export(exports, "objectClone", ()=>objectClone);
parcelHelpers.export(exports, "assignProp", ()=>assignProp);
parcelHelpers.export(exports, "mergeDefs", ()=>mergeDefs);
parcelHelpers.export(exports, "cloneDef", ()=>cloneDef);
parcelHelpers.export(exports, "getElementAtPath", ()=>getElementAtPath);
parcelHelpers.export(exports, "promiseAllObject", ()=>promiseAllObject);
parcelHelpers.export(exports, "randomString", ()=>randomString);
parcelHelpers.export(exports, "esc", ()=>esc);
parcelHelpers.export(exports, "slugify", ()=>slugify);
parcelHelpers.export(exports, "captureStackTrace", ()=>captureStackTrace);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "allowsEval", ()=>allowsEval);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "shallowClone", ()=>shallowClone);
parcelHelpers.export(exports, "numKeys", ()=>numKeys);
parcelHelpers.export(exports, "getParsedType", ()=>getParsedType);
parcelHelpers.export(exports, "propertyKeyTypes", ()=>propertyKeyTypes);
parcelHelpers.export(exports, "primitiveTypes", ()=>primitiveTypes);
parcelHelpers.export(exports, "escapeRegex", ()=>escapeRegex);
// zod-specific utils
parcelHelpers.export(exports, "clone", ()=>clone);
parcelHelpers.export(exports, "normalizeParams", ()=>normalizeParams);
parcelHelpers.export(exports, "createTransparentProxy", ()=>createTransparentProxy);
parcelHelpers.export(exports, "stringifyPrimitive", ()=>stringifyPrimitive);
parcelHelpers.export(exports, "optionalKeys", ()=>optionalKeys);
parcelHelpers.export(exports, "NUMBER_FORMAT_RANGES", ()=>NUMBER_FORMAT_RANGES);
parcelHelpers.export(exports, "BIGINT_FORMAT_RANGES", ()=>BIGINT_FORMAT_RANGES);
parcelHelpers.export(exports, "pick", ()=>pick);
parcelHelpers.export(exports, "omit", ()=>omit);
parcelHelpers.export(exports, "extend", ()=>extend);
parcelHelpers.export(exports, "safeExtend", ()=>safeExtend);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "partial", ()=>partial);
parcelHelpers.export(exports, "required", ()=>required);
// invalid_type | too_big | too_small | invalid_format | not_multiple_of | unrecognized_keys | invalid_union | invalid_key | invalid_element | invalid_value | custom
parcelHelpers.export(exports, "aborted", ()=>aborted);
parcelHelpers.export(exports, "prefixIssues", ()=>prefixIssues);
parcelHelpers.export(exports, "unwrapMessage", ()=>unwrapMessage);
parcelHelpers.export(exports, "finalizeIssue", ()=>finalizeIssue);
parcelHelpers.export(exports, "getSizableOrigin", ()=>getSizableOrigin);
parcelHelpers.export(exports, "getLengthableOrigin", ()=>getLengthableOrigin);
parcelHelpers.export(exports, "parsedType", ()=>parsedType);
parcelHelpers.export(exports, "issue", ()=>issue);
parcelHelpers.export(exports, "cleanEnum", ()=>cleanEnum);
// Codec utility functions
parcelHelpers.export(exports, "base64ToUint8Array", ()=>base64ToUint8Array);
parcelHelpers.export(exports, "uint8ArrayToBase64", ()=>uint8ArrayToBase64);
parcelHelpers.export(exports, "base64urlToUint8Array", ()=>base64urlToUint8Array);
parcelHelpers.export(exports, "uint8ArrayToBase64url", ()=>uint8ArrayToBase64url);
parcelHelpers.export(exports, "hexToUint8Array", ()=>hexToUint8Array);
parcelHelpers.export(exports, "uint8ArrayToHex", ()=>uint8ArrayToHex);
// instanceof
parcelHelpers.export(exports, "Class", ()=>Class);
function assertEqual(val) {
    return val;
}
function assertNotEqual(val) {
    return val;
}
function assertIs(_arg) {}
function assertNever(_x) {
    throw new Error("Unexpected value in exhaustive check");
}
function assert(_) {}
function getEnumValues(entries) {
    const numericValues = Object.values(entries).filter((v)=>typeof v === "number");
    const values = Object.entries(entries).filter(([k, _])=>numericValues.indexOf(+k) === -1).map(([_, v])=>v);
    return values;
}
function joinValues(array, separator = "|") {
    return array.map((val)=>stringifyPrimitive(val)).join(separator);
}
function jsonStringifyReplacer(_, value) {
    if (typeof value === "bigint") return value.toString();
    return value;
}
function cached(getter) {
    const set = false;
    return {
        get value () {
            if (!set) {
                const value = getter();
                Object.defineProperty(this, "value", {
                    value
                });
                return value;
            }
            throw new Error("cached value already set");
        }
    };
}
function nullish(input) {
    return input === null || input === undefined;
}
function cleanRegex(source) {
    const start = source.startsWith("^") ? 1 : 0;
    const end = source.endsWith("$") ? source.length - 1 : source.length;
    return source.slice(start, end);
}
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepString = step.toString();
    let stepDecCount = (stepString.split(".")[1] || "").length;
    if (stepDecCount === 0 && /\d?e-\d?/.test(stepString)) {
        const match = stepString.match(/\d?e-(\d?)/);
        if (match?.[1]) stepDecCount = Number.parseInt(match[1]);
    }
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
const EVALUATING = Symbol("evaluating");
function defineLazy(object, key, getter) {
    let value = undefined;
    Object.defineProperty(object, key, {
        get () {
            if (value === EVALUATING) // Circular reference detected, return undefined to break the cycle
            return undefined;
            if (value === undefined) {
                value = EVALUATING;
                value = getter();
            }
            return value;
        },
        set (v) {
            Object.defineProperty(object, key, {
                value: v
            });
        // object[key] = v;
        },
        configurable: true
    });
}
function objectClone(obj) {
    return Object.create(Object.getPrototypeOf(obj), Object.getOwnPropertyDescriptors(obj));
}
function assignProp(target, prop, value) {
    Object.defineProperty(target, prop, {
        value,
        writable: true,
        enumerable: true,
        configurable: true
    });
}
function mergeDefs(...defs) {
    const mergedDescriptors = {};
    for (const def of defs){
        const descriptors = Object.getOwnPropertyDescriptors(def);
        Object.assign(mergedDescriptors, descriptors);
    }
    return Object.defineProperties({}, mergedDescriptors);
}
function cloneDef(schema) {
    return mergeDefs(schema._zod.def);
}
function getElementAtPath(obj, path) {
    if (!path) return obj;
    return path.reduce((acc, key)=>acc?.[key], obj);
}
function promiseAllObject(promisesObj) {
    const keys = Object.keys(promisesObj);
    const promises = keys.map((key)=>promisesObj[key]);
    return Promise.all(promises).then((results)=>{
        const resolvedObj = {};
        for(let i = 0; i < keys.length; i++)resolvedObj[keys[i]] = results[i];
        return resolvedObj;
    });
}
function randomString(length = 10) {
    const chars = "abcdefghijklmnopqrstuvwxyz";
    let str = "";
    for(let i = 0; i < length; i++)str += chars[Math.floor(Math.random() * chars.length)];
    return str;
}
function esc(str) {
    return JSON.stringify(str);
}
function slugify(input) {
    return input.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const captureStackTrace = "captureStackTrace" in Error ? Error.captureStackTrace : (..._args)=>{};
function isObject(data) {
    return typeof data === "object" && data !== null && !Array.isArray(data);
}
const allowsEval = cached(()=>{
    // @ts-ignore
    if (typeof navigator !== "undefined" && navigator?.userAgent?.includes("Cloudflare")) return false;
    try {
        const F = Function;
        new F("");
        return true;
    } catch (_) {
        return false;
    }
});
function isPlainObject(o) {
    if (isObject(o) === false) return false;
    // modified constructor
    const ctor = o.constructor;
    if (ctor === undefined) return true;
    if (typeof ctor !== "function") return true;
    // modified prototype
    const prot = ctor.prototype;
    if (isObject(prot) === false) return false;
    // ctor doesn't have static `isPrototypeOf`
    if (Object.prototype.hasOwnProperty.call(prot, "isPrototypeOf") === false) return false;
    return true;
}
function shallowClone(o) {
    if (isPlainObject(o)) return {
        ...o
    };
    if (Array.isArray(o)) return [
        ...o
    ];
    return o;
}
function numKeys(data) {
    let keyCount = 0;
    for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) keyCount++;
    return keyCount;
}
const getParsedType = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return "undefined";
        case "string":
            return "string";
        case "number":
            return Number.isNaN(data) ? "nan" : "number";
        case "boolean":
            return "boolean";
        case "function":
            return "function";
        case "bigint":
            return "bigint";
        case "symbol":
            return "symbol";
        case "object":
            if (Array.isArray(data)) return "array";
            if (data === null) return "null";
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return "promise";
            if (typeof Map !== "undefined" && data instanceof Map) return "map";
            if (typeof Set !== "undefined" && data instanceof Set) return "set";
            if (typeof Date !== "undefined" && data instanceof Date) return "date";
            // @ts-ignore
            if (typeof File !== "undefined" && data instanceof File) return "file";
            return "object";
        default:
            throw new Error(`Unknown data type: ${t}`);
    }
};
const propertyKeyTypes = new Set([
    "string",
    "number",
    "symbol"
]);
const primitiveTypes = new Set([
    "string",
    "number",
    "bigint",
    "boolean",
    "symbol",
    "undefined"
]);
function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function clone(inst, def, params) {
    const cl = new inst._zod.constr(def ?? inst._zod.def);
    if (!def || params?.parent) cl._zod.parent = inst;
    return cl;
}
function normalizeParams(_params) {
    const params = _params;
    if (!params) return {};
    if (typeof params === "string") return {
        error: ()=>params
    };
    if (params?.message !== undefined) {
        if (params?.error !== undefined) throw new Error("Cannot specify both `message` and `error` params");
        params.error = params.message;
    }
    delete params.message;
    if (typeof params.error === "string") return {
        ...params,
        error: ()=>params.error
    };
    return params;
}
function createTransparentProxy(getter) {
    let target;
    return new Proxy({}, {
        get (_, prop, receiver) {
            target ?? (target = getter());
            return Reflect.get(target, prop, receiver);
        },
        set (_, prop, value, receiver) {
            target ?? (target = getter());
            return Reflect.set(target, prop, value, receiver);
        },
        has (_, prop) {
            target ?? (target = getter());
            return Reflect.has(target, prop);
        },
        deleteProperty (_, prop) {
            target ?? (target = getter());
            return Reflect.deleteProperty(target, prop);
        },
        ownKeys (_) {
            target ?? (target = getter());
            return Reflect.ownKeys(target);
        },
        getOwnPropertyDescriptor (_, prop) {
            target ?? (target = getter());
            return Reflect.getOwnPropertyDescriptor(target, prop);
        },
        defineProperty (_, prop, descriptor) {
            target ?? (target = getter());
            return Reflect.defineProperty(target, prop, descriptor);
        }
    });
}
function stringifyPrimitive(value) {
    if (typeof value === "bigint") return value.toString() + "n";
    if (typeof value === "string") return `"${value}"`;
    return `${value}`;
}
function optionalKeys(shape) {
    return Object.keys(shape).filter((k)=>{
        return shape[k]._zod.optin === "optional" && shape[k]._zod.optout === "optional";
    });
}
const NUMBER_FORMAT_RANGES = {
    safeint: [
        Number.MIN_SAFE_INTEGER,
        Number.MAX_SAFE_INTEGER
    ],
    int32: [
        -2147483648,
        2147483647
    ],
    uint32: [
        0,
        4294967295
    ],
    float32: [
        -340282346638528860000000000000000000000,
        3.4028234663852886e38
    ],
    float64: [
        -Number.MAX_VALUE,
        Number.MAX_VALUE
    ]
};
const BIGINT_FORMAT_RANGES = {
    int64: [
        /* @__PURE__*/ BigInt("-9223372036854775808"),
        /* @__PURE__*/ BigInt("9223372036854775807")
    ],
    uint64: [
        /* @__PURE__*/ BigInt(0),
        /* @__PURE__*/ BigInt("18446744073709551615")
    ]
};
function pick(schema, mask) {
    const currDef = schema._zod.def;
    const checks = currDef.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error(".pick() cannot be used on object schemas containing refinements");
    const def = mergeDefs(schema._zod.def, {
        get shape () {
            const newShape = {};
            for(const key in mask){
                if (!(key in currDef.shape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                newShape[key] = currDef.shape[key];
            }
            assignProp(this, "shape", newShape); // self-caching
            return newShape;
        },
        checks: []
    });
    return clone(schema, def);
}
function omit(schema, mask) {
    const currDef = schema._zod.def;
    const checks = currDef.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error(".omit() cannot be used on object schemas containing refinements");
    const def = mergeDefs(schema._zod.def, {
        get shape () {
            const newShape = {
                ...schema._zod.def.shape
            };
            for(const key in mask){
                if (!(key in currDef.shape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                delete newShape[key];
            }
            assignProp(this, "shape", newShape); // self-caching
            return newShape;
        },
        checks: []
    });
    return clone(schema, def);
}
function extend(schema, shape) {
    if (!isPlainObject(shape)) throw new Error("Invalid input to extend: expected a plain object");
    const checks = schema._zod.def.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) {
        // Only throw if new shape overlaps with existing shape
        // Use getOwnPropertyDescriptor to check key existence without accessing values
        const existingShape = schema._zod.def.shape;
        for(const key in shape){
            if (Object.getOwnPropertyDescriptor(existingShape, key) !== undefined) throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
        }
    }
    const def = mergeDefs(schema._zod.def, {
        get shape () {
            const _shape = {
                ...schema._zod.def.shape,
                ...shape
            };
            assignProp(this, "shape", _shape); // self-caching
            return _shape;
        }
    });
    return clone(schema, def);
}
function safeExtend(schema, shape) {
    if (!isPlainObject(shape)) throw new Error("Invalid input to safeExtend: expected a plain object");
    const def = mergeDefs(schema._zod.def, {
        get shape () {
            const _shape = {
                ...schema._zod.def.shape,
                ...shape
            };
            assignProp(this, "shape", _shape); // self-caching
            return _shape;
        }
    });
    return clone(schema, def);
}
function merge(a, b) {
    const def = mergeDefs(a._zod.def, {
        get shape () {
            const _shape = {
                ...a._zod.def.shape,
                ...b._zod.def.shape
            };
            assignProp(this, "shape", _shape); // self-caching
            return _shape;
        },
        get catchall () {
            return b._zod.def.catchall;
        },
        checks: []
    });
    return clone(a, def);
}
function partial(Class, schema, mask) {
    const currDef = schema._zod.def;
    const checks = currDef.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error(".partial() cannot be used on object schemas containing refinements");
    const def = mergeDefs(schema._zod.def, {
        get shape () {
            const oldShape = schema._zod.def.shape;
            const shape = {
                ...oldShape
            };
            if (mask) for(const key in mask){
                if (!(key in oldShape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                // if (oldShape[key]!._zod.optin === "optional") continue;
                shape[key] = Class ? new Class({
                    type: "optional",
                    innerType: oldShape[key]
                }) : oldShape[key];
            }
            else for(const key in oldShape)// if (oldShape[key]!._zod.optin === "optional") continue;
            shape[key] = Class ? new Class({
                type: "optional",
                innerType: oldShape[key]
            }) : oldShape[key];
            assignProp(this, "shape", shape); // self-caching
            return shape;
        },
        checks: []
    });
    return clone(schema, def);
}
function required(Class, schema, mask) {
    const def = mergeDefs(schema._zod.def, {
        get shape () {
            const oldShape = schema._zod.def.shape;
            const shape = {
                ...oldShape
            };
            if (mask) for(const key in mask){
                if (!(key in shape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                // overwrite with non-optional
                shape[key] = new Class({
                    type: "nonoptional",
                    innerType: oldShape[key]
                });
            }
            else for(const key in oldShape)// overwrite with non-optional
            shape[key] = new Class({
                type: "nonoptional",
                innerType: oldShape[key]
            });
            assignProp(this, "shape", shape); // self-caching
            return shape;
        }
    });
    return clone(schema, def);
}
function aborted(x, startIndex = 0) {
    if (x.aborted === true) return true;
    for(let i = startIndex; i < x.issues.length; i++){
        if (x.issues[i]?.continue !== true) return true;
    }
    return false;
}
function prefixIssues(path, issues) {
    return issues.map((iss)=>{
        var _a;
        (_a = iss).path ?? (_a.path = []);
        iss.path.unshift(path);
        return iss;
    });
}
function unwrapMessage(message) {
    return typeof message === "string" ? message : message?.message;
}
function finalizeIssue(iss, ctx, config) {
    const full = {
        ...iss,
        path: iss.path ?? []
    };
    // for backwards compatibility
    if (!iss.message) {
        const message = unwrapMessage(iss.inst?._zod.def?.error?.(iss)) ?? unwrapMessage(ctx?.error?.(iss)) ?? unwrapMessage(config.customError?.(iss)) ?? unwrapMessage(config.localeError?.(iss)) ?? "Invalid input";
        full.message = message;
    }
    // delete (full as any).def;
    delete full.inst;
    delete full.continue;
    if (!ctx?.reportInput) delete full.input;
    return full;
}
function getSizableOrigin(input) {
    if (input instanceof Set) return "set";
    if (input instanceof Map) return "map";
    // @ts-ignore
    if (input instanceof File) return "file";
    return "unknown";
}
function getLengthableOrigin(input) {
    if (Array.isArray(input)) return "array";
    if (typeof input === "string") return "string";
    return "unknown";
}
function parsedType(data) {
    const t = typeof data;
    switch(t){
        case "number":
            return Number.isNaN(data) ? "nan" : "number";
        case "object":
            {
                if (data === null) return "null";
                if (Array.isArray(data)) return "array";
                const obj = data;
                if (obj && Object.getPrototypeOf(obj) !== Object.prototype && "constructor" in obj && obj.constructor) return obj.constructor.name;
            }
    }
    return t;
}
function issue(...args) {
    const [iss, input, inst] = args;
    if (typeof iss === "string") return {
        message: iss,
        code: "custom",
        input,
        inst
    };
    return {
        ...iss
    };
}
function cleanEnum(obj) {
    return Object.entries(obj).filter(([k, _])=>{
        // return true if NaN, meaning it's not a number, thus a string key
        return Number.isNaN(Number.parseInt(k, 10));
    }).map((el)=>el[1]);
}
function base64ToUint8Array(base64) {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for(let i = 0; i < binaryString.length; i++)bytes[i] = binaryString.charCodeAt(i);
    return bytes;
}
function uint8ArrayToBase64(bytes) {
    let binaryString = "";
    for(let i = 0; i < bytes.length; i++)binaryString += String.fromCharCode(bytes[i]);
    return btoa(binaryString);
}
function base64urlToUint8Array(base64url) {
    const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
    const padding = "=".repeat((4 - base64.length % 4) % 4);
    return base64ToUint8Array(base64 + padding);
}
function uint8ArrayToBase64url(bytes) {
    return uint8ArrayToBase64(bytes).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function hexToUint8Array(hex) {
    const cleanHex = hex.replace(/^0x/, "");
    if (cleanHex.length % 2 !== 0) throw new Error("Invalid hex string length");
    const bytes = new Uint8Array(cleanHex.length / 2);
    for(let i = 0; i < cleanHex.length; i += 2)bytes[i / 2] = Number.parseInt(cleanHex.slice(i, i + 2), 16);
    return bytes;
}
function uint8ArrayToHex(bytes) {
    return Array.from(bytes).map((b)=>b.toString(16).padStart(2, "0")).join("");
}
class Class {
    constructor(..._args){}
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"c5Ly7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clone", ()=>(0, _utilJs.clone));
parcelHelpers.export(exports, "$ZodType", ()=>$ZodType);
parcelHelpers.export(exports, "$ZodString", ()=>$ZodString);
parcelHelpers.export(exports, "$ZodStringFormat", ()=>$ZodStringFormat);
parcelHelpers.export(exports, "$ZodGUID", ()=>$ZodGUID);
parcelHelpers.export(exports, "$ZodUUID", ()=>$ZodUUID);
parcelHelpers.export(exports, "$ZodEmail", ()=>$ZodEmail);
parcelHelpers.export(exports, "$ZodURL", ()=>$ZodURL);
parcelHelpers.export(exports, "$ZodEmoji", ()=>$ZodEmoji);
parcelHelpers.export(exports, "$ZodNanoID", ()=>$ZodNanoID);
parcelHelpers.export(exports, "$ZodCUID", ()=>$ZodCUID);
parcelHelpers.export(exports, "$ZodCUID2", ()=>$ZodCUID2);
parcelHelpers.export(exports, "$ZodULID", ()=>$ZodULID);
parcelHelpers.export(exports, "$ZodXID", ()=>$ZodXID);
parcelHelpers.export(exports, "$ZodKSUID", ()=>$ZodKSUID);
parcelHelpers.export(exports, "$ZodISODateTime", ()=>$ZodISODateTime);
parcelHelpers.export(exports, "$ZodISODate", ()=>$ZodISODate);
parcelHelpers.export(exports, "$ZodISOTime", ()=>$ZodISOTime);
parcelHelpers.export(exports, "$ZodISODuration", ()=>$ZodISODuration);
parcelHelpers.export(exports, "$ZodIPv4", ()=>$ZodIPv4);
parcelHelpers.export(exports, "$ZodIPv6", ()=>$ZodIPv6);
parcelHelpers.export(exports, "$ZodMAC", ()=>$ZodMAC);
parcelHelpers.export(exports, "$ZodCIDRv4", ()=>$ZodCIDRv4);
parcelHelpers.export(exports, "$ZodCIDRv6", ()=>$ZodCIDRv6);
//////////////////////////////   ZodBase64   //////////////////////////////
parcelHelpers.export(exports, "isValidBase64", ()=>isValidBase64);
parcelHelpers.export(exports, "$ZodBase64", ()=>$ZodBase64);
//////////////////////////////   ZodBase64   //////////////////////////////
parcelHelpers.export(exports, "isValidBase64URL", ()=>isValidBase64URL);
parcelHelpers.export(exports, "$ZodBase64URL", ()=>$ZodBase64URL);
parcelHelpers.export(exports, "$ZodE164", ()=>$ZodE164);
//////////////////////////////   ZodJWT   //////////////////////////////
parcelHelpers.export(exports, "isValidJWT", ()=>isValidJWT);
parcelHelpers.export(exports, "$ZodJWT", ()=>$ZodJWT);
parcelHelpers.export(exports, "$ZodCustomStringFormat", ()=>$ZodCustomStringFormat);
parcelHelpers.export(exports, "$ZodNumber", ()=>$ZodNumber);
parcelHelpers.export(exports, "$ZodNumberFormat", ()=>$ZodNumberFormat);
parcelHelpers.export(exports, "$ZodBoolean", ()=>$ZodBoolean);
parcelHelpers.export(exports, "$ZodBigInt", ()=>$ZodBigInt);
parcelHelpers.export(exports, "$ZodBigIntFormat", ()=>$ZodBigIntFormat);
parcelHelpers.export(exports, "$ZodSymbol", ()=>$ZodSymbol);
parcelHelpers.export(exports, "$ZodUndefined", ()=>$ZodUndefined);
parcelHelpers.export(exports, "$ZodNull", ()=>$ZodNull);
parcelHelpers.export(exports, "$ZodAny", ()=>$ZodAny);
parcelHelpers.export(exports, "$ZodUnknown", ()=>$ZodUnknown);
parcelHelpers.export(exports, "$ZodNever", ()=>$ZodNever);
parcelHelpers.export(exports, "$ZodVoid", ()=>$ZodVoid);
parcelHelpers.export(exports, "$ZodDate", ()=>$ZodDate);
parcelHelpers.export(exports, "$ZodArray", ()=>$ZodArray);
parcelHelpers.export(exports, "$ZodObject", ()=>$ZodObject);
parcelHelpers.export(exports, "$ZodObjectJIT", ()=>$ZodObjectJIT);
parcelHelpers.export(exports, "$ZodUnion", ()=>$ZodUnion);
parcelHelpers.export(exports, "$ZodXor", ()=>$ZodXor);
parcelHelpers.export(exports, "$ZodDiscriminatedUnion", ()=>$ZodDiscriminatedUnion);
parcelHelpers.export(exports, "$ZodIntersection", ()=>$ZodIntersection);
parcelHelpers.export(exports, "$ZodTuple", ()=>$ZodTuple);
parcelHelpers.export(exports, "$ZodRecord", ()=>$ZodRecord);
parcelHelpers.export(exports, "$ZodMap", ()=>$ZodMap);
parcelHelpers.export(exports, "$ZodSet", ()=>$ZodSet);
parcelHelpers.export(exports, "$ZodEnum", ()=>$ZodEnum);
parcelHelpers.export(exports, "$ZodLiteral", ()=>$ZodLiteral);
parcelHelpers.export(exports, "$ZodFile", ()=>$ZodFile);
parcelHelpers.export(exports, "$ZodTransform", ()=>$ZodTransform);
parcelHelpers.export(exports, "$ZodOptional", ()=>$ZodOptional);
parcelHelpers.export(exports, "$ZodExactOptional", ()=>$ZodExactOptional);
parcelHelpers.export(exports, "$ZodNullable", ()=>$ZodNullable);
parcelHelpers.export(exports, "$ZodDefault", ()=>$ZodDefault);
parcelHelpers.export(exports, "$ZodPrefault", ()=>$ZodPrefault);
parcelHelpers.export(exports, "$ZodNonOptional", ()=>$ZodNonOptional);
parcelHelpers.export(exports, "$ZodSuccess", ()=>$ZodSuccess);
parcelHelpers.export(exports, "$ZodCatch", ()=>$ZodCatch);
parcelHelpers.export(exports, "$ZodNaN", ()=>$ZodNaN);
parcelHelpers.export(exports, "$ZodPipe", ()=>$ZodPipe);
parcelHelpers.export(exports, "$ZodCodec", ()=>$ZodCodec);
parcelHelpers.export(exports, "$ZodReadonly", ()=>$ZodReadonly);
parcelHelpers.export(exports, "$ZodTemplateLiteral", ()=>$ZodTemplateLiteral);
parcelHelpers.export(exports, "$ZodFunction", ()=>$ZodFunction);
parcelHelpers.export(exports, "$ZodPromise", ()=>$ZodPromise);
parcelHelpers.export(exports, "$ZodLazy", ()=>$ZodLazy);
parcelHelpers.export(exports, "$ZodCustom", ()=>$ZodCustom);
var _checksJs = require("./checks.js");
var _coreJs = require("./core.js");
var _docJs = require("./doc.js");
var _parseJs = require("./parse.js");
var _regexesJs = require("./regexes.js");
var _utilJs = require("./util.js");
var _versionsJs = require("./versions.js");
const $ZodType = /*@__PURE__*/ _coreJs.$constructor("$ZodType", (inst, def)=>{
    var _a;
    inst ?? (inst = {});
    inst._zod.def = def; // set _def property
    inst._zod.bag = inst._zod.bag || {}; // initialize _bag object
    inst._zod.version = (0, _versionsJs.version);
    const checks = [
        ...inst._zod.def.checks ?? []
    ];
    // if inst is itself a checks.$ZodCheck, run it as a check
    if (inst._zod.traits.has("$ZodCheck")) checks.unshift(inst);
    for (const ch of checks)for (const fn of ch._zod.onattach)fn(inst);
    if (checks.length === 0) {
        // deferred initializer
        // inst._zod.parse is not yet defined
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        inst._zod.deferred?.push(()=>{
            inst._zod.run = inst._zod.parse;
        });
    } else {
        const runChecks = (payload, checks, ctx)=>{
            let isAborted = _utilJs.aborted(payload);
            let asyncResult;
            for (const ch of checks){
                if (ch._zod.def.when) {
                    const shouldRun = ch._zod.def.when(payload);
                    if (!shouldRun) continue;
                } else if (isAborted) continue;
                const currLen = payload.issues.length;
                const _ = ch._zod.check(payload);
                if (_ instanceof Promise && ctx?.async === false) throw new _coreJs.$ZodAsyncError();
                if (asyncResult || _ instanceof Promise) asyncResult = (asyncResult ?? Promise.resolve()).then(async ()=>{
                    await _;
                    const nextLen = payload.issues.length;
                    if (nextLen === currLen) return;
                    if (!isAborted) isAborted = _utilJs.aborted(payload, currLen);
                });
                else {
                    const nextLen = payload.issues.length;
                    if (nextLen === currLen) continue;
                    if (!isAborted) isAborted = _utilJs.aborted(payload, currLen);
                }
            }
            if (asyncResult) return asyncResult.then(()=>{
                return payload;
            });
            return payload;
        };
        const handleCanaryResult = (canary, payload, ctx)=>{
            // abort if the canary is aborted
            if (_utilJs.aborted(canary)) {
                canary.aborted = true;
                return canary;
            }
            // run checks first, then
            const checkResult = runChecks(payload, checks, ctx);
            if (checkResult instanceof Promise) {
                if (ctx.async === false) throw new _coreJs.$ZodAsyncError();
                return checkResult.then((checkResult)=>inst._zod.parse(checkResult, ctx));
            }
            return inst._zod.parse(checkResult, ctx);
        };
        inst._zod.run = (payload, ctx)=>{
            if (ctx.skipChecks) return inst._zod.parse(payload, ctx);
            if (ctx.direction === "backward") {
                // run canary
                // initial pass (no checks)
                const canary = inst._zod.parse({
                    value: payload.value,
                    issues: []
                }, {
                    ...ctx,
                    skipChecks: true
                });
                if (canary instanceof Promise) return canary.then((canary)=>{
                    return handleCanaryResult(canary, payload, ctx);
                });
                return handleCanaryResult(canary, payload, ctx);
            }
            // forward
            const result = inst._zod.parse(payload, ctx);
            if (result instanceof Promise) {
                if (ctx.async === false) throw new _coreJs.$ZodAsyncError();
                return result.then((result)=>runChecks(result, checks, ctx));
            }
            return runChecks(result, checks, ctx);
        };
    }
    // Lazy initialize ~standard to avoid creating objects for every schema
    _utilJs.defineLazy(inst, "~standard", ()=>({
            validate: (value)=>{
                try {
                    const r = (0, _parseJs.safeParse)(inst, value);
                    return r.success ? {
                        value: r.data
                    } : {
                        issues: r.error?.issues
                    };
                } catch (_) {
                    return (0, _parseJs.safeParseAsync)(inst, value).then((r)=>r.success ? {
                            value: r.data
                        } : {
                            issues: r.error?.issues
                        });
                }
            },
            vendor: "zod",
            version: 1
        }));
});
const $ZodString = /*@__PURE__*/ _coreJs.$constructor("$ZodString", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.pattern = [
        ...inst?._zod.bag?.patterns ?? []
    ].pop() ?? _regexesJs.string(inst._zod.bag);
    inst._zod.parse = (payload, _)=>{
        if (def.coerce) try {
            payload.value = String(payload.value);
        } catch (_) {}
        if (typeof payload.value === "string") return payload;
        payload.issues.push({
            expected: "string",
            code: "invalid_type",
            input: payload.value,
            inst
        });
        return payload;
    };
});
const $ZodStringFormat = /*@__PURE__*/ _coreJs.$constructor("$ZodStringFormat", (inst, def)=>{
    // check initialization must come first
    _checksJs.$ZodCheckStringFormat.init(inst, def);
    $ZodString.init(inst, def);
});
const $ZodGUID = /*@__PURE__*/ _coreJs.$constructor("$ZodGUID", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.guid);
    $ZodStringFormat.init(inst, def);
});
const $ZodUUID = /*@__PURE__*/ _coreJs.$constructor("$ZodUUID", (inst, def)=>{
    if (def.version) {
        const versionMap = {
            v1: 1,
            v2: 2,
            v3: 3,
            v4: 4,
            v5: 5,
            v6: 6,
            v7: 7,
            v8: 8
        };
        const v = versionMap[def.version];
        if (v === undefined) throw new Error(`Invalid UUID version: "${def.version}"`);
        def.pattern ?? (def.pattern = _regexesJs.uuid(v));
    } else def.pattern ?? (def.pattern = _regexesJs.uuid());
    $ZodStringFormat.init(inst, def);
});
const $ZodEmail = /*@__PURE__*/ _coreJs.$constructor("$ZodEmail", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.email);
    $ZodStringFormat.init(inst, def);
});
const $ZodURL = /*@__PURE__*/ _coreJs.$constructor("$ZodURL", (inst, def)=>{
    $ZodStringFormat.init(inst, def);
    inst._zod.check = (payload)=>{
        try {
            // Trim whitespace from input
            const trimmed = payload.value.trim();
            // @ts-ignore
            const url = new URL(trimmed);
            if (def.hostname) {
                def.hostname.lastIndex = 0;
                if (!def.hostname.test(url.hostname)) payload.issues.push({
                    code: "invalid_format",
                    format: "url",
                    note: "Invalid hostname",
                    pattern: def.hostname.source,
                    input: payload.value,
                    inst,
                    continue: !def.abort
                });
            }
            if (def.protocol) {
                def.protocol.lastIndex = 0;
                if (!def.protocol.test(url.protocol.endsWith(":") ? url.protocol.slice(0, -1) : url.protocol)) payload.issues.push({
                    code: "invalid_format",
                    format: "url",
                    note: "Invalid protocol",
                    pattern: def.protocol.source,
                    input: payload.value,
                    inst,
                    continue: !def.abort
                });
            }
            // Set the output value based on normalize flag
            if (def.normalize) // Use normalized URL
            payload.value = url.href;
            else // Preserve the original input (trimmed)
            payload.value = trimmed;
            return;
        } catch (_) {
            payload.issues.push({
                code: "invalid_format",
                format: "url",
                input: payload.value,
                inst,
                continue: !def.abort
            });
        }
    };
});
const $ZodEmoji = /*@__PURE__*/ _coreJs.$constructor("$ZodEmoji", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.emoji());
    $ZodStringFormat.init(inst, def);
});
const $ZodNanoID = /*@__PURE__*/ _coreJs.$constructor("$ZodNanoID", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.nanoid);
    $ZodStringFormat.init(inst, def);
});
const $ZodCUID = /*@__PURE__*/ _coreJs.$constructor("$ZodCUID", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.cuid);
    $ZodStringFormat.init(inst, def);
});
const $ZodCUID2 = /*@__PURE__*/ _coreJs.$constructor("$ZodCUID2", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.cuid2);
    $ZodStringFormat.init(inst, def);
});
const $ZodULID = /*@__PURE__*/ _coreJs.$constructor("$ZodULID", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.ulid);
    $ZodStringFormat.init(inst, def);
});
const $ZodXID = /*@__PURE__*/ _coreJs.$constructor("$ZodXID", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.xid);
    $ZodStringFormat.init(inst, def);
});
const $ZodKSUID = /*@__PURE__*/ _coreJs.$constructor("$ZodKSUID", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.ksuid);
    $ZodStringFormat.init(inst, def);
});
const $ZodISODateTime = /*@__PURE__*/ _coreJs.$constructor("$ZodISODateTime", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.datetime(def));
    $ZodStringFormat.init(inst, def);
});
const $ZodISODate = /*@__PURE__*/ _coreJs.$constructor("$ZodISODate", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.date);
    $ZodStringFormat.init(inst, def);
});
const $ZodISOTime = /*@__PURE__*/ _coreJs.$constructor("$ZodISOTime", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.time(def));
    $ZodStringFormat.init(inst, def);
});
const $ZodISODuration = /*@__PURE__*/ _coreJs.$constructor("$ZodISODuration", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.duration);
    $ZodStringFormat.init(inst, def);
});
const $ZodIPv4 = /*@__PURE__*/ _coreJs.$constructor("$ZodIPv4", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.ipv4);
    $ZodStringFormat.init(inst, def);
    inst._zod.bag.format = `ipv4`;
});
const $ZodIPv6 = /*@__PURE__*/ _coreJs.$constructor("$ZodIPv6", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.ipv6);
    $ZodStringFormat.init(inst, def);
    inst._zod.bag.format = `ipv6`;
    inst._zod.check = (payload)=>{
        try {
            // @ts-ignore
            new URL(`http://[${payload.value}]`);
        // return;
        } catch  {
            payload.issues.push({
                code: "invalid_format",
                format: "ipv6",
                input: payload.value,
                inst,
                continue: !def.abort
            });
        }
    };
});
const $ZodMAC = /*@__PURE__*/ _coreJs.$constructor("$ZodMAC", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.mac(def.delimiter));
    $ZodStringFormat.init(inst, def);
    inst._zod.bag.format = `mac`;
});
const $ZodCIDRv4 = /*@__PURE__*/ _coreJs.$constructor("$ZodCIDRv4", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.cidrv4);
    $ZodStringFormat.init(inst, def);
});
const $ZodCIDRv6 = /*@__PURE__*/ _coreJs.$constructor("$ZodCIDRv6", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.cidrv6); // not used for validation
    $ZodStringFormat.init(inst, def);
    inst._zod.check = (payload)=>{
        const parts = payload.value.split("/");
        try {
            if (parts.length !== 2) throw new Error();
            const [address, prefix] = parts;
            if (!prefix) throw new Error();
            const prefixNum = Number(prefix);
            if (`${prefixNum}` !== prefix) throw new Error();
            if (prefixNum < 0 || prefixNum > 128) throw new Error();
            // @ts-ignore
            new URL(`http://[${address}]`);
        } catch  {
            payload.issues.push({
                code: "invalid_format",
                format: "cidrv6",
                input: payload.value,
                inst,
                continue: !def.abort
            });
        }
    };
});
function isValidBase64(data) {
    if (data === "") return true;
    if (data.length % 4 !== 0) return false;
    try {
        // @ts-ignore
        atob(data);
        return true;
    } catch  {
        return false;
    }
}
const $ZodBase64 = /*@__PURE__*/ _coreJs.$constructor("$ZodBase64", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.base64);
    $ZodStringFormat.init(inst, def);
    inst._zod.bag.contentEncoding = "base64";
    inst._zod.check = (payload)=>{
        if (isValidBase64(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "base64",
            input: payload.value,
            inst,
            continue: !def.abort
        });
    };
});
function isValidBase64URL(data) {
    if (!_regexesJs.base64url.test(data)) return false;
    const base64 = data.replace(/[-_]/g, (c)=>c === "-" ? "+" : "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    return isValidBase64(padded);
}
const $ZodBase64URL = /*@__PURE__*/ _coreJs.$constructor("$ZodBase64URL", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.base64url);
    $ZodStringFormat.init(inst, def);
    inst._zod.bag.contentEncoding = "base64url";
    inst._zod.check = (payload)=>{
        if (isValidBase64URL(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "base64url",
            input: payload.value,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodE164 = /*@__PURE__*/ _coreJs.$constructor("$ZodE164", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.e164);
    $ZodStringFormat.init(inst, def);
});
function isValidJWT(token, algorithm = null) {
    try {
        const tokensParts = token.split(".");
        if (tokensParts.length !== 3) return false;
        const [header] = tokensParts;
        if (!header) return false;
        // @ts-ignore
        const parsedHeader = JSON.parse(atob(header));
        if ("typ" in parsedHeader && parsedHeader?.typ !== "JWT") return false;
        if (!parsedHeader.alg) return false;
        if (algorithm && (!("alg" in parsedHeader) || parsedHeader.alg !== algorithm)) return false;
        return true;
    } catch  {
        return false;
    }
}
const $ZodJWT = /*@__PURE__*/ _coreJs.$constructor("$ZodJWT", (inst, def)=>{
    $ZodStringFormat.init(inst, def);
    inst._zod.check = (payload)=>{
        if (isValidJWT(payload.value, def.alg)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "jwt",
            input: payload.value,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCustomStringFormat = /*@__PURE__*/ _coreJs.$constructor("$ZodCustomStringFormat", (inst, def)=>{
    $ZodStringFormat.init(inst, def);
    inst._zod.check = (payload)=>{
        if (def.fn(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodNumber = /*@__PURE__*/ _coreJs.$constructor("$ZodNumber", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.pattern = inst._zod.bag.pattern ?? _regexesJs.number;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = Number(payload.value);
        } catch (_) {}
        const input = payload.value;
        if (typeof input === "number" && !Number.isNaN(input) && Number.isFinite(input)) return payload;
        const received = typeof input === "number" ? Number.isNaN(input) ? "NaN" : !Number.isFinite(input) ? "Infinity" : undefined : undefined;
        payload.issues.push({
            expected: "number",
            code: "invalid_type",
            input,
            inst,
            ...received ? {
                received
            } : {}
        });
        return payload;
    };
});
const $ZodNumberFormat = /*@__PURE__*/ _coreJs.$constructor("$ZodNumberFormat", (inst, def)=>{
    _checksJs.$ZodCheckNumberFormat.init(inst, def);
    $ZodNumber.init(inst, def); // no format checks
});
const $ZodBoolean = /*@__PURE__*/ _coreJs.$constructor("$ZodBoolean", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.pattern = _regexesJs.boolean;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = Boolean(payload.value);
        } catch (_) {}
        const input = payload.value;
        if (typeof input === "boolean") return payload;
        payload.issues.push({
            expected: "boolean",
            code: "invalid_type",
            input,
            inst
        });
        return payload;
    };
});
const $ZodBigInt = /*@__PURE__*/ _coreJs.$constructor("$ZodBigInt", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.pattern = _regexesJs.bigint;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = BigInt(payload.value);
        } catch (_) {}
        if (typeof payload.value === "bigint") return payload;
        payload.issues.push({
            expected: "bigint",
            code: "invalid_type",
            input: payload.value,
            inst
        });
        return payload;
    };
});
const $ZodBigIntFormat = /*@__PURE__*/ _coreJs.$constructor("$ZodBigIntFormat", (inst, def)=>{
    _checksJs.$ZodCheckBigIntFormat.init(inst, def);
    $ZodBigInt.init(inst, def); // no format checks
});
const $ZodSymbol = /*@__PURE__*/ _coreJs.$constructor("$ZodSymbol", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "symbol") return payload;
        payload.issues.push({
            expected: "symbol",
            code: "invalid_type",
            input,
            inst
        });
        return payload;
    };
});
const $ZodUndefined = /*@__PURE__*/ _coreJs.$constructor("$ZodUndefined", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.pattern = _regexesJs.undefined;
    inst._zod.values = new Set([
        undefined
    ]);
    inst._zod.optin = "optional";
    inst._zod.optout = "optional";
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "undefined") return payload;
        payload.issues.push({
            expected: "undefined",
            code: "invalid_type",
            input,
            inst
        });
        return payload;
    };
});
const $ZodNull = /*@__PURE__*/ _coreJs.$constructor("$ZodNull", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.pattern = _regexesJs.null;
    inst._zod.values = new Set([
        null
    ]);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (input === null) return payload;
        payload.issues.push({
            expected: "null",
            code: "invalid_type",
            input,
            inst
        });
        return payload;
    };
});
const $ZodAny = /*@__PURE__*/ _coreJs.$constructor("$ZodAny", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload)=>payload;
});
const $ZodUnknown = /*@__PURE__*/ _coreJs.$constructor("$ZodUnknown", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload)=>payload;
});
const $ZodNever = /*@__PURE__*/ _coreJs.$constructor("$ZodNever", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        payload.issues.push({
            expected: "never",
            code: "invalid_type",
            input: payload.value,
            inst
        });
        return payload;
    };
});
const $ZodVoid = /*@__PURE__*/ _coreJs.$constructor("$ZodVoid", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "undefined") return payload;
        payload.issues.push({
            expected: "void",
            code: "invalid_type",
            input,
            inst
        });
        return payload;
    };
});
const $ZodDate = /*@__PURE__*/ _coreJs.$constructor("$ZodDate", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = new Date(payload.value);
        } catch (_err) {}
        const input = payload.value;
        const isDate = input instanceof Date;
        const isValidDate = isDate && !Number.isNaN(input.getTime());
        if (isValidDate) return payload;
        payload.issues.push({
            expected: "date",
            code: "invalid_type",
            input,
            ...isDate ? {
                received: "Invalid Date"
            } : {},
            inst
        });
        return payload;
    };
});
function handleArrayResult(result, final, index) {
    if (result.issues.length) final.issues.push(..._utilJs.prefixIssues(index, result.issues));
    final.value[index] = result.value;
}
const $ZodArray = /*@__PURE__*/ _coreJs.$constructor("$ZodArray", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!Array.isArray(input)) {
            payload.issues.push({
                expected: "array",
                code: "invalid_type",
                input,
                inst
            });
            return payload;
        }
        payload.value = Array(input.length);
        const proms = [];
        for(let i = 0; i < input.length; i++){
            const item = input[i];
            const result = def.element._zod.run({
                value: item,
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>handleArrayResult(result, payload, i)));
            else handleArrayResult(result, payload, i);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload; //handleArrayResultsAsync(parseResults, final);
    };
});
function handlePropertyResult(result, final, key, input, isOptionalOut) {
    if (result.issues.length) {
        // For optional-out schemas, ignore errors on absent keys
        if (isOptionalOut && !(key in input)) return;
        final.issues.push(..._utilJs.prefixIssues(key, result.issues));
    }
    if (result.value === undefined) {
        if (key in input) final.value[key] = undefined;
    } else final.value[key] = result.value;
}
function normalizeDef(def) {
    const keys = Object.keys(def.shape);
    for (const k of keys){
        if (!def.shape?.[k]?._zod?.traits?.has("$ZodType")) throw new Error(`Invalid element at key "${k}": expected a Zod schema`);
    }
    const okeys = _utilJs.optionalKeys(def.shape);
    return {
        ...def,
        keys,
        keySet: new Set(keys),
        numKeys: keys.length,
        optionalKeys: new Set(okeys)
    };
}
function handleCatchall(proms, input, payload, ctx, def, inst) {
    const unrecognized = [];
    // iterate over input keys
    const keySet = def.keySet;
    const _catchall = def.catchall._zod;
    const t = _catchall.def.type;
    const isOptionalOut = _catchall.optout === "optional";
    for(const key in input){
        if (keySet.has(key)) continue;
        if (t === "never") {
            unrecognized.push(key);
            continue;
        }
        const r = _catchall.run({
            value: input[key],
            issues: []
        }, ctx);
        if (r instanceof Promise) proms.push(r.then((r)=>handlePropertyResult(r, payload, key, input, isOptionalOut)));
        else handlePropertyResult(r, payload, key, input, isOptionalOut);
    }
    if (unrecognized.length) payload.issues.push({
        code: "unrecognized_keys",
        keys: unrecognized,
        input,
        inst
    });
    if (!proms.length) return payload;
    return Promise.all(proms).then(()=>{
        return payload;
    });
}
const $ZodObject = /*@__PURE__*/ _coreJs.$constructor("$ZodObject", (inst, def)=>{
    // requires cast because technically $ZodObject doesn't extend
    $ZodType.init(inst, def);
    // const sh = def.shape;
    const desc = Object.getOwnPropertyDescriptor(def, "shape");
    if (!desc?.get) {
        const sh = def.shape;
        Object.defineProperty(def, "shape", {
            get: ()=>{
                const newSh = {
                    ...sh
                };
                Object.defineProperty(def, "shape", {
                    value: newSh
                });
                return newSh;
            }
        });
    }
    const _normalized = _utilJs.cached(()=>normalizeDef(def));
    _utilJs.defineLazy(inst._zod, "propValues", ()=>{
        const shape = def.shape;
        const propValues = {};
        for(const key in shape){
            const field = shape[key]._zod;
            if (field.values) {
                propValues[key] ?? (propValues[key] = new Set());
                for (const v of field.values)propValues[key].add(v);
            }
        }
        return propValues;
    });
    const isObject = _utilJs.isObject;
    const catchall = def.catchall;
    let value;
    inst._zod.parse = (payload, ctx)=>{
        value ?? (value = _normalized.value);
        const input = payload.value;
        if (!isObject(input)) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input,
                inst
            });
            return payload;
        }
        payload.value = {};
        const proms = [];
        const shape = value.shape;
        for (const key of value.keys){
            const el = shape[key];
            const isOptionalOut = el._zod.optout === "optional";
            const r = el._zod.run({
                value: input[key],
                issues: []
            }, ctx);
            if (r instanceof Promise) proms.push(r.then((r)=>handlePropertyResult(r, payload, key, input, isOptionalOut)));
            else handlePropertyResult(r, payload, key, input, isOptionalOut);
        }
        if (!catchall) return proms.length ? Promise.all(proms).then(()=>payload) : payload;
        return handleCatchall(proms, input, payload, ctx, _normalized.value, inst);
    };
});
const $ZodObjectJIT = /*@__PURE__*/ _coreJs.$constructor("$ZodObjectJIT", (inst, def)=>{
    // requires cast because technically $ZodObject doesn't extend
    $ZodObject.init(inst, def);
    const superParse = inst._zod.parse;
    const _normalized = _utilJs.cached(()=>normalizeDef(def));
    const generateFastpass = (shape)=>{
        const doc = new (0, _docJs.Doc)([
            "shape",
            "payload",
            "ctx"
        ]);
        const normalized = _normalized.value;
        const parseStr = (key)=>{
            const k = _utilJs.esc(key);
            return `shape[${k}]._zod.run({ value: input[${k}], issues: [] }, ctx)`;
        };
        doc.write(`const input = payload.value;`);
        const ids = Object.create(null);
        let counter = 0;
        for (const key of normalized.keys)ids[key] = `key_${counter++}`;
        // A: preserve key order {
        doc.write(`const newResult = {};`);
        for (const key of normalized.keys){
            const id = ids[key];
            const k = _utilJs.esc(key);
            const schema = shape[key];
            const isOptionalOut = schema?._zod?.optout === "optional";
            doc.write(`const ${id} = ${parseStr(key)};`);
            if (isOptionalOut) // For optional-out schemas, ignore errors on absent keys
            doc.write(`
        if (${id}.issues.length) {
          if (${k} in input) {
            payload.issues = payload.issues.concat(${id}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${k}, ...iss.path] : [${k}]
            })));
          }
        }
        
        if (${id}.value === undefined) {
          if (${k} in input) {
            newResult[${k}] = undefined;
          }
        } else {
          newResult[${k}] = ${id}.value;
        }
        
      `);
            else doc.write(`
        if (${id}.issues.length) {
          payload.issues = payload.issues.concat(${id}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${k}, ...iss.path] : [${k}]
          })));
        }
        
        if (${id}.value === undefined) {
          if (${k} in input) {
            newResult[${k}] = undefined;
          }
        } else {
          newResult[${k}] = ${id}.value;
        }
        
      `);
        }
        doc.write(`payload.value = newResult;`);
        doc.write(`return payload;`);
        const fn = doc.compile();
        return (payload, ctx)=>fn(shape, payload, ctx);
    };
    let fastpass;
    const isObject = _utilJs.isObject;
    const jit = !_coreJs.globalConfig.jitless;
    const allowsEval = _utilJs.allowsEval;
    const fastEnabled = jit && allowsEval.value; // && !def.catchall;
    const catchall = def.catchall;
    let value;
    inst._zod.parse = (payload, ctx)=>{
        value ?? (value = _normalized.value);
        const input = payload.value;
        if (!isObject(input)) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input,
                inst
            });
            return payload;
        }
        if (jit && fastEnabled && ctx?.async === false && ctx.jitless !== true) {
            // always synchronous
            if (!fastpass) fastpass = generateFastpass(def.shape);
            payload = fastpass(payload, ctx);
            if (!catchall) return payload;
            return handleCatchall([], input, payload, ctx, value, inst);
        }
        return superParse(payload, ctx);
    };
});
function handleUnionResults(results, final, inst, ctx) {
    for (const result of results)if (result.issues.length === 0) {
        final.value = result.value;
        return final;
    }
    const nonaborted = results.filter((r)=>!_utilJs.aborted(r));
    if (nonaborted.length === 1) {
        final.value = nonaborted[0].value;
        return nonaborted[0];
    }
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst,
        errors: results.map((result)=>result.issues.map((iss)=>_utilJs.finalizeIssue(iss, ctx, _coreJs.config())))
    });
    return final;
}
const $ZodUnion = /*@__PURE__*/ _coreJs.$constructor("$ZodUnion", (inst, def)=>{
    $ZodType.init(inst, def);
    _utilJs.defineLazy(inst._zod, "optin", ()=>def.options.some((o)=>o._zod.optin === "optional") ? "optional" : undefined);
    _utilJs.defineLazy(inst._zod, "optout", ()=>def.options.some((o)=>o._zod.optout === "optional") ? "optional" : undefined);
    _utilJs.defineLazy(inst._zod, "values", ()=>{
        if (def.options.every((o)=>o._zod.values)) return new Set(def.options.flatMap((option)=>Array.from(option._zod.values)));
        return undefined;
    });
    _utilJs.defineLazy(inst._zod, "pattern", ()=>{
        if (def.options.every((o)=>o._zod.pattern)) {
            const patterns = def.options.map((o)=>o._zod.pattern);
            return new RegExp(`^(${patterns.map((p)=>_utilJs.cleanRegex(p.source)).join("|")})$`);
        }
        return undefined;
    });
    const single = def.options.length === 1;
    const first = def.options[0]._zod.run;
    inst._zod.parse = (payload, ctx)=>{
        if (single) return first(payload, ctx);
        let async = false;
        const results = [];
        for (const option of def.options){
            const result = option._zod.run({
                value: payload.value,
                issues: []
            }, ctx);
            if (result instanceof Promise) {
                results.push(result);
                async = true;
            } else {
                if (result.issues.length === 0) return result;
                results.push(result);
            }
        }
        if (!async) return handleUnionResults(results, payload, inst, ctx);
        return Promise.all(results).then((results)=>{
            return handleUnionResults(results, payload, inst, ctx);
        });
    };
});
function handleExclusiveUnionResults(results, final, inst, ctx) {
    const successes = results.filter((r)=>r.issues.length === 0);
    if (successes.length === 1) {
        final.value = successes[0].value;
        return final;
    }
    if (successes.length === 0) // No matches - same as regular union
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst,
        errors: results.map((result)=>result.issues.map((iss)=>_utilJs.finalizeIssue(iss, ctx, _coreJs.config())))
    });
    else // Multiple matches - exclusive union failure
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst,
        errors: [],
        inclusive: false
    });
    return final;
}
const $ZodXor = /*@__PURE__*/ _coreJs.$constructor("$ZodXor", (inst, def)=>{
    $ZodUnion.init(inst, def);
    def.inclusive = false;
    const single = def.options.length === 1;
    const first = def.options[0]._zod.run;
    inst._zod.parse = (payload, ctx)=>{
        if (single) return first(payload, ctx);
        let async = false;
        const results = [];
        for (const option of def.options){
            const result = option._zod.run({
                value: payload.value,
                issues: []
            }, ctx);
            if (result instanceof Promise) {
                results.push(result);
                async = true;
            } else results.push(result);
        }
        if (!async) return handleExclusiveUnionResults(results, payload, inst, ctx);
        return Promise.all(results).then((results)=>{
            return handleExclusiveUnionResults(results, payload, inst, ctx);
        });
    };
});
const $ZodDiscriminatedUnion = /*@__PURE__*/ _coreJs.$constructor("$ZodDiscriminatedUnion", (inst, def)=>{
    def.inclusive = false;
    $ZodUnion.init(inst, def);
    const _super = inst._zod.parse;
    _utilJs.defineLazy(inst._zod, "propValues", ()=>{
        const propValues = {};
        for (const option of def.options){
            const pv = option._zod.propValues;
            if (!pv || Object.keys(pv).length === 0) throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(option)}"`);
            for (const [k, v] of Object.entries(pv)){
                if (!propValues[k]) propValues[k] = new Set();
                for (const val of v)propValues[k].add(val);
            }
        }
        return propValues;
    });
    const disc = _utilJs.cached(()=>{
        const opts = def.options;
        const map = new Map();
        for (const o of opts){
            const values = o._zod.propValues?.[def.discriminator];
            if (!values || values.size === 0) throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(o)}"`);
            for (const v of values){
                if (map.has(v)) throw new Error(`Duplicate discriminator value "${String(v)}"`);
                map.set(v, o);
            }
        }
        return map;
    });
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!_utilJs.isObject(input)) {
            payload.issues.push({
                code: "invalid_type",
                expected: "object",
                input,
                inst
            });
            return payload;
        }
        const opt = disc.value.get(input?.[def.discriminator]);
        if (opt) return opt._zod.run(payload, ctx);
        if (def.unionFallback) return _super(payload, ctx);
        // no matching discriminator
        payload.issues.push({
            code: "invalid_union",
            errors: [],
            note: "No matching discriminator",
            discriminator: def.discriminator,
            input,
            path: [
                def.discriminator
            ],
            inst
        });
        return payload;
    };
});
const $ZodIntersection = /*@__PURE__*/ _coreJs.$constructor("$ZodIntersection", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        const left = def.left._zod.run({
            value: input,
            issues: []
        }, ctx);
        const right = def.right._zod.run({
            value: input,
            issues: []
        }, ctx);
        const async = left instanceof Promise || right instanceof Promise;
        if (async) return Promise.all([
            left,
            right
        ]).then(([left, right])=>{
            return handleIntersectionResults(payload, left, right);
        });
        return handleIntersectionResults(payload, left, right);
    };
});
function mergeValues(a, b) {
    // const aType = parse.t(a);
    // const bType = parse.t(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    if (a instanceof Date && b instanceof Date && +a === +b) return {
        valid: true,
        data: a
    };
    if (_utilJs.isPlainObject(a) && _utilJs.isPlainObject(b)) {
        const bKeys = Object.keys(b);
        const sharedKeys = Object.keys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false,
                mergeErrorPath: [
                    key,
                    ...sharedValue.mergeErrorPath
                ]
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return {
            valid: false,
            mergeErrorPath: []
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false,
                mergeErrorPath: [
                    index,
                    ...sharedValue.mergeErrorPath
                ]
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    }
    return {
        valid: false,
        mergeErrorPath: []
    };
}
function handleIntersectionResults(result, left, right) {
    // Track which side(s) report each key as unrecognized
    const unrecKeys = new Map();
    let unrecIssue;
    for (const iss of left.issues)if (iss.code === "unrecognized_keys") {
        unrecIssue ?? (unrecIssue = iss);
        for (const k of iss.keys){
            if (!unrecKeys.has(k)) unrecKeys.set(k, {});
            unrecKeys.get(k).l = true;
        }
    } else result.issues.push(iss);
    for (const iss of right.issues){
        if (iss.code === "unrecognized_keys") for (const k of iss.keys){
            if (!unrecKeys.has(k)) unrecKeys.set(k, {});
            unrecKeys.get(k).r = true;
        }
        else result.issues.push(iss);
    }
    // Report only keys unrecognized by BOTH sides
    const bothKeys = [
        ...unrecKeys
    ].filter(([, f])=>f.l && f.r).map(([k])=>k);
    if (bothKeys.length && unrecIssue) result.issues.push({
        ...unrecIssue,
        keys: bothKeys
    });
    if (_utilJs.aborted(result)) return result;
    const merged = mergeValues(left.value, right.value);
    if (!merged.valid) throw new Error(`Unmergable intersection. Error path: ` + `${JSON.stringify(merged.mergeErrorPath)}`);
    result.value = merged.data;
    return result;
}
const $ZodTuple = /*@__PURE__*/ _coreJs.$constructor("$ZodTuple", (inst, def)=>{
    $ZodType.init(inst, def);
    const items = def.items;
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!Array.isArray(input)) {
            payload.issues.push({
                input,
                inst,
                expected: "tuple",
                code: "invalid_type"
            });
            return payload;
        }
        payload.value = [];
        const proms = [];
        const reversedIndex = [
            ...items
        ].reverse().findIndex((item)=>item._zod.optin !== "optional");
        const optStart = reversedIndex === -1 ? 0 : items.length - reversedIndex;
        if (!def.rest) {
            const tooBig = input.length > items.length;
            const tooSmall = input.length < optStart - 1;
            if (tooBig || tooSmall) {
                payload.issues.push({
                    ...tooBig ? {
                        code: "too_big",
                        maximum: items.length,
                        inclusive: true
                    } : {
                        code: "too_small",
                        minimum: items.length
                    },
                    input,
                    inst,
                    origin: "array"
                });
                return payload;
            }
        }
        let i = -1;
        for (const item of items){
            i++;
            if (i >= input.length) {
                if (i >= optStart) continue;
            }
            const result = item._zod.run({
                value: input[i],
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>handleTupleResult(result, payload, i)));
            else handleTupleResult(result, payload, i);
        }
        if (def.rest) {
            const rest = input.slice(items.length);
            for (const el of rest){
                i++;
                const result = def.rest._zod.run({
                    value: el,
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>handleTupleResult(result, payload, i)));
                else handleTupleResult(result, payload, i);
            }
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function handleTupleResult(result, final, index) {
    if (result.issues.length) final.issues.push(..._utilJs.prefixIssues(index, result.issues));
    final.value[index] = result.value;
}
const $ZodRecord = /*@__PURE__*/ _coreJs.$constructor("$ZodRecord", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!_utilJs.isPlainObject(input)) {
            payload.issues.push({
                expected: "record",
                code: "invalid_type",
                input,
                inst
            });
            return payload;
        }
        const proms = [];
        const values = def.keyType._zod.values;
        if (values) {
            payload.value = {};
            const recordKeys = new Set();
            for (const key of values)if (typeof key === "string" || typeof key === "number" || typeof key === "symbol") {
                recordKeys.add(typeof key === "number" ? key.toString() : key);
                const result = def.valueType._zod.run({
                    value: input[key],
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>{
                    if (result.issues.length) payload.issues.push(..._utilJs.prefixIssues(key, result.issues));
                    payload.value[key] = result.value;
                }));
                else {
                    if (result.issues.length) payload.issues.push(..._utilJs.prefixIssues(key, result.issues));
                    payload.value[key] = result.value;
                }
            }
            let unrecognized;
            for(const key in input)if (!recordKeys.has(key)) {
                unrecognized = unrecognized ?? [];
                unrecognized.push(key);
            }
            if (unrecognized && unrecognized.length > 0) payload.issues.push({
                code: "unrecognized_keys",
                input,
                inst,
                keys: unrecognized
            });
        } else {
            payload.value = {};
            for (const key of Reflect.ownKeys(input)){
                if (key === "__proto__") continue;
                let keyResult = def.keyType._zod.run({
                    value: key,
                    issues: []
                }, ctx);
                if (keyResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
                // Numeric string fallback: if key failed with "expected number", retry with Number(key)
                const checkNumericKey = typeof key === "string" && _regexesJs.number.test(key) && keyResult.issues.length && keyResult.issues.some((iss)=>iss.code === "invalid_type" && iss.expected === "number");
                if (checkNumericKey) {
                    const retryResult = def.keyType._zod.run({
                        value: Number(key),
                        issues: []
                    }, ctx);
                    if (retryResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
                    if (retryResult.issues.length === 0) keyResult = retryResult;
                }
                if (keyResult.issues.length) {
                    if (def.mode === "loose") // Pass through unchanged
                    payload.value[key] = input[key];
                    else // Default "strict" behavior: error on invalid key
                    payload.issues.push({
                        code: "invalid_key",
                        origin: "record",
                        issues: keyResult.issues.map((iss)=>_utilJs.finalizeIssue(iss, ctx, _coreJs.config())),
                        input: key,
                        path: [
                            key
                        ],
                        inst
                    });
                    continue;
                }
                const result = def.valueType._zod.run({
                    value: input[key],
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>{
                    if (result.issues.length) payload.issues.push(..._utilJs.prefixIssues(key, result.issues));
                    payload.value[keyResult.value] = result.value;
                }));
                else {
                    if (result.issues.length) payload.issues.push(..._utilJs.prefixIssues(key, result.issues));
                    payload.value[keyResult.value] = result.value;
                }
            }
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
const $ZodMap = /*@__PURE__*/ _coreJs.$constructor("$ZodMap", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!(input instanceof Map)) {
            payload.issues.push({
                expected: "map",
                code: "invalid_type",
                input,
                inst
            });
            return payload;
        }
        const proms = [];
        payload.value = new Map();
        for (const [key, value] of input){
            const keyResult = def.keyType._zod.run({
                value: key,
                issues: []
            }, ctx);
            const valueResult = def.valueType._zod.run({
                value: value,
                issues: []
            }, ctx);
            if (keyResult instanceof Promise || valueResult instanceof Promise) proms.push(Promise.all([
                keyResult,
                valueResult
            ]).then(([keyResult, valueResult])=>{
                handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
            }));
            else handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function handleMapResult(keyResult, valueResult, final, key, input, inst, ctx) {
    if (keyResult.issues.length) {
        if (_utilJs.propertyKeyTypes.has(typeof key)) final.issues.push(..._utilJs.prefixIssues(key, keyResult.issues));
        else final.issues.push({
            code: "invalid_key",
            origin: "map",
            input,
            inst,
            issues: keyResult.issues.map((iss)=>_utilJs.finalizeIssue(iss, ctx, _coreJs.config()))
        });
    }
    if (valueResult.issues.length) {
        if (_utilJs.propertyKeyTypes.has(typeof key)) final.issues.push(..._utilJs.prefixIssues(key, valueResult.issues));
        else final.issues.push({
            origin: "map",
            code: "invalid_element",
            input,
            inst,
            key: key,
            issues: valueResult.issues.map((iss)=>_utilJs.finalizeIssue(iss, ctx, _coreJs.config()))
        });
    }
    final.value.set(keyResult.value, valueResult.value);
}
const $ZodSet = /*@__PURE__*/ _coreJs.$constructor("$ZodSet", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!(input instanceof Set)) {
            payload.issues.push({
                input,
                inst,
                expected: "set",
                code: "invalid_type"
            });
            return payload;
        }
        const proms = [];
        payload.value = new Set();
        for (const item of input){
            const result = def.valueType._zod.run({
                value: item,
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>handleSetResult(result, payload)));
            else handleSetResult(result, payload);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function handleSetResult(result, final) {
    if (result.issues.length) final.issues.push(...result.issues);
    final.value.add(result.value);
}
const $ZodEnum = /*@__PURE__*/ _coreJs.$constructor("$ZodEnum", (inst, def)=>{
    $ZodType.init(inst, def);
    const values = _utilJs.getEnumValues(def.entries);
    const valuesSet = new Set(values);
    inst._zod.values = valuesSet;
    inst._zod.pattern = new RegExp(`^(${values.filter((k)=>_utilJs.propertyKeyTypes.has(typeof k)).map((o)=>typeof o === "string" ? _utilJs.escapeRegex(o) : o.toString()).join("|")})$`);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (valuesSet.has(input)) return payload;
        payload.issues.push({
            code: "invalid_value",
            values,
            input,
            inst
        });
        return payload;
    };
});
const $ZodLiteral = /*@__PURE__*/ _coreJs.$constructor("$ZodLiteral", (inst, def)=>{
    $ZodType.init(inst, def);
    if (def.values.length === 0) throw new Error("Cannot create literal schema with no valid values");
    const values = new Set(def.values);
    inst._zod.values = values;
    inst._zod.pattern = new RegExp(`^(${def.values.map((o)=>typeof o === "string" ? _utilJs.escapeRegex(o) : o ? _utilJs.escapeRegex(o.toString()) : String(o)).join("|")})$`);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (values.has(input)) return payload;
        payload.issues.push({
            code: "invalid_value",
            values: def.values,
            input,
            inst
        });
        return payload;
    };
});
const $ZodFile = /*@__PURE__*/ _coreJs.$constructor("$ZodFile", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        // @ts-ignore
        if (input instanceof File) return payload;
        payload.issues.push({
            expected: "file",
            code: "invalid_type",
            input,
            inst
        });
        return payload;
    };
});
const $ZodTransform = /*@__PURE__*/ _coreJs.$constructor("$ZodTransform", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") throw new _coreJs.$ZodEncodeError(inst.constructor.name);
        const _out = def.transform(payload.value, payload);
        if (ctx.async) {
            const output = _out instanceof Promise ? _out : Promise.resolve(_out);
            return output.then((output)=>{
                payload.value = output;
                return payload;
            });
        }
        if (_out instanceof Promise) throw new _coreJs.$ZodAsyncError();
        payload.value = _out;
        return payload;
    };
});
function handleOptionalResult(result, input) {
    if (result.issues.length && input === undefined) return {
        issues: [],
        value: undefined
    };
    return result;
}
const $ZodOptional = /*@__PURE__*/ _coreJs.$constructor("$ZodOptional", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.optin = "optional";
    inst._zod.optout = "optional";
    _utilJs.defineLazy(inst._zod, "values", ()=>{
        return def.innerType._zod.values ? new Set([
            ...def.innerType._zod.values,
            undefined
        ]) : undefined;
    });
    _utilJs.defineLazy(inst._zod, "pattern", ()=>{
        const pattern = def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${_utilJs.cleanRegex(pattern.source)})?$`) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        if (def.innerType._zod.optin === "optional") {
            const result = def.innerType._zod.run(payload, ctx);
            if (result instanceof Promise) return result.then((r)=>handleOptionalResult(r, payload.value));
            return handleOptionalResult(result, payload.value);
        }
        if (payload.value === undefined) return payload;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $ZodExactOptional = /*@__PURE__*/ _coreJs.$constructor("$ZodExactOptional", (inst, def)=>{
    // Call parent init - inherits optin/optout = "optional"
    $ZodOptional.init(inst, def);
    // Override values/pattern to NOT add undefined
    _utilJs.defineLazy(inst._zod, "values", ()=>def.innerType._zod.values);
    _utilJs.defineLazy(inst._zod, "pattern", ()=>def.innerType._zod.pattern);
    // Override parse to just delegate (no undefined handling)
    inst._zod.parse = (payload, ctx)=>{
        return def.innerType._zod.run(payload, ctx);
    };
});
const $ZodNullable = /*@__PURE__*/ _coreJs.$constructor("$ZodNullable", (inst, def)=>{
    $ZodType.init(inst, def);
    _utilJs.defineLazy(inst._zod, "optin", ()=>def.innerType._zod.optin);
    _utilJs.defineLazy(inst._zod, "optout", ()=>def.innerType._zod.optout);
    _utilJs.defineLazy(inst._zod, "pattern", ()=>{
        const pattern = def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${_utilJs.cleanRegex(pattern.source)}|null)$`) : undefined;
    });
    _utilJs.defineLazy(inst._zod, "values", ()=>{
        return def.innerType._zod.values ? new Set([
            ...def.innerType._zod.values,
            null
        ]) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        // Forward direction (decode): allow null to pass through
        if (payload.value === null) return payload;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $ZodDefault = /*@__PURE__*/ _coreJs.$constructor("$ZodDefault", (inst, def)=>{
    $ZodType.init(inst, def);
    // inst._zod.qin = "true";
    inst._zod.optin = "optional";
    _utilJs.defineLazy(inst._zod, "values", ()=>def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply defaults for undefined input
        if (payload.value === undefined) {
            payload.value = def.defaultValue;
            /**
             * $ZodDefault returns the default value immediately in forward direction.
             * It doesn't pass the default value into the validator ("prefault"). There's no reason to pass the default value through validation. The validity of the default is enforced by TypeScript statically. Otherwise, it's the responsibility of the user to ensure the default is valid. In the case of pipes with divergent in/out types, you can specify the default on the `in` schema of your ZodPipe to set a "prefault" for the pipe.   */ return payload;
        }
        // Forward direction: continue with default handling
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>handleDefaultResult(result, def));
        return handleDefaultResult(result, def);
    };
});
function handleDefaultResult(payload, def) {
    if (payload.value === undefined) payload.value = def.defaultValue;
    return payload;
}
const $ZodPrefault = /*@__PURE__*/ _coreJs.$constructor("$ZodPrefault", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.optin = "optional";
    _utilJs.defineLazy(inst._zod, "values", ()=>def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply prefault for undefined input
        if (payload.value === undefined) payload.value = def.defaultValue;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $ZodNonOptional = /*@__PURE__*/ _coreJs.$constructor("$ZodNonOptional", (inst, def)=>{
    $ZodType.init(inst, def);
    _utilJs.defineLazy(inst._zod, "values", ()=>{
        const v = def.innerType._zod.values;
        return v ? new Set([
            ...v
        ].filter((x)=>x !== undefined)) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>handleNonOptionalResult(result, inst));
        return handleNonOptionalResult(result, inst);
    };
});
function handleNonOptionalResult(payload, inst) {
    if (!payload.issues.length && payload.value === undefined) payload.issues.push({
        code: "invalid_type",
        expected: "nonoptional",
        input: payload.value,
        inst
    });
    return payload;
}
const $ZodSuccess = /*@__PURE__*/ _coreJs.$constructor("$ZodSuccess", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") throw new _coreJs.$ZodEncodeError("ZodSuccess");
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>{
            payload.value = result.issues.length === 0;
            return payload;
        });
        payload.value = result.issues.length === 0;
        return payload;
    };
});
const $ZodCatch = /*@__PURE__*/ _coreJs.$constructor("$ZodCatch", (inst, def)=>{
    $ZodType.init(inst, def);
    _utilJs.defineLazy(inst._zod, "optin", ()=>def.innerType._zod.optin);
    _utilJs.defineLazy(inst._zod, "optout", ()=>def.innerType._zod.optout);
    _utilJs.defineLazy(inst._zod, "values", ()=>def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply catch logic
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>{
            payload.value = result.value;
            if (result.issues.length) {
                payload.value = def.catchValue({
                    ...payload,
                    error: {
                        issues: result.issues.map((iss)=>_utilJs.finalizeIssue(iss, ctx, _coreJs.config()))
                    },
                    input: payload.value
                });
                payload.issues = [];
            }
            return payload;
        });
        payload.value = result.value;
        if (result.issues.length) {
            payload.value = def.catchValue({
                ...payload,
                error: {
                    issues: result.issues.map((iss)=>_utilJs.finalizeIssue(iss, ctx, _coreJs.config()))
                },
                input: payload.value
            });
            payload.issues = [];
        }
        return payload;
    };
});
const $ZodNaN = /*@__PURE__*/ _coreJs.$constructor("$ZodNaN", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "number" || !Number.isNaN(payload.value)) {
            payload.issues.push({
                input: payload.value,
                inst,
                expected: "nan",
                code: "invalid_type"
            });
            return payload;
        }
        return payload;
    };
});
const $ZodPipe = /*@__PURE__*/ _coreJs.$constructor("$ZodPipe", (inst, def)=>{
    $ZodType.init(inst, def);
    _utilJs.defineLazy(inst._zod, "values", ()=>def.in._zod.values);
    _utilJs.defineLazy(inst._zod, "optin", ()=>def.in._zod.optin);
    _utilJs.defineLazy(inst._zod, "optout", ()=>def.out._zod.optout);
    _utilJs.defineLazy(inst._zod, "propValues", ()=>def.in._zod.propValues);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") {
            const right = def.out._zod.run(payload, ctx);
            if (right instanceof Promise) return right.then((right)=>handlePipeResult(right, def.in, ctx));
            return handlePipeResult(right, def.in, ctx);
        }
        const left = def.in._zod.run(payload, ctx);
        if (left instanceof Promise) return left.then((left)=>handlePipeResult(left, def.out, ctx));
        return handlePipeResult(left, def.out, ctx);
    };
});
function handlePipeResult(left, next, ctx) {
    if (left.issues.length) {
        // prevent further checks
        left.aborted = true;
        return left;
    }
    return next._zod.run({
        value: left.value,
        issues: left.issues
    }, ctx);
}
const $ZodCodec = /*@__PURE__*/ _coreJs.$constructor("$ZodCodec", (inst, def)=>{
    $ZodType.init(inst, def);
    _utilJs.defineLazy(inst._zod, "values", ()=>def.in._zod.values);
    _utilJs.defineLazy(inst._zod, "optin", ()=>def.in._zod.optin);
    _utilJs.defineLazy(inst._zod, "optout", ()=>def.out._zod.optout);
    _utilJs.defineLazy(inst._zod, "propValues", ()=>def.in._zod.propValues);
    inst._zod.parse = (payload, ctx)=>{
        const direction = ctx.direction || "forward";
        if (direction === "forward") {
            const left = def.in._zod.run(payload, ctx);
            if (left instanceof Promise) return left.then((left)=>handleCodecAResult(left, def, ctx));
            return handleCodecAResult(left, def, ctx);
        } else {
            const right = def.out._zod.run(payload, ctx);
            if (right instanceof Promise) return right.then((right)=>handleCodecAResult(right, def, ctx));
            return handleCodecAResult(right, def, ctx);
        }
    };
});
function handleCodecAResult(result, def, ctx) {
    if (result.issues.length) {
        // prevent further checks
        result.aborted = true;
        return result;
    }
    const direction = ctx.direction || "forward";
    if (direction === "forward") {
        const transformed = def.transform(result.value, result);
        if (transformed instanceof Promise) return transformed.then((value)=>handleCodecTxResult(result, value, def.out, ctx));
        return handleCodecTxResult(result, transformed, def.out, ctx);
    } else {
        const transformed = def.reverseTransform(result.value, result);
        if (transformed instanceof Promise) return transformed.then((value)=>handleCodecTxResult(result, value, def.in, ctx));
        return handleCodecTxResult(result, transformed, def.in, ctx);
    }
}
function handleCodecTxResult(left, value, nextSchema, ctx) {
    // Check if transform added any issues
    if (left.issues.length) {
        left.aborted = true;
        return left;
    }
    return nextSchema._zod.run({
        value,
        issues: left.issues
    }, ctx);
}
const $ZodReadonly = /*@__PURE__*/ _coreJs.$constructor("$ZodReadonly", (inst, def)=>{
    $ZodType.init(inst, def);
    _utilJs.defineLazy(inst._zod, "propValues", ()=>def.innerType._zod.propValues);
    _utilJs.defineLazy(inst._zod, "values", ()=>def.innerType._zod.values);
    _utilJs.defineLazy(inst._zod, "optin", ()=>def.innerType?._zod?.optin);
    _utilJs.defineLazy(inst._zod, "optout", ()=>def.innerType?._zod?.optout);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then(handleReadonlyResult);
        return handleReadonlyResult(result);
    };
});
function handleReadonlyResult(payload) {
    payload.value = Object.freeze(payload.value);
    return payload;
}
const $ZodTemplateLiteral = /*@__PURE__*/ _coreJs.$constructor("$ZodTemplateLiteral", (inst, def)=>{
    $ZodType.init(inst, def);
    const regexParts = [];
    for (const part of def.parts){
        if (typeof part === "object" && part !== null) {
            // is Zod schema
            if (!part._zod.pattern) // if (!source)
            throw new Error(`Invalid template literal part, no pattern found: ${[
                ...part._zod.traits
            ].shift()}`);
            const source = part._zod.pattern instanceof RegExp ? part._zod.pattern.source : part._zod.pattern;
            if (!source) throw new Error(`Invalid template literal part: ${part._zod.traits}`);
            const start = source.startsWith("^") ? 1 : 0;
            const end = source.endsWith("$") ? source.length - 1 : source.length;
            regexParts.push(source.slice(start, end));
        } else if (part === null || _utilJs.primitiveTypes.has(typeof part)) regexParts.push(_utilJs.escapeRegex(`${part}`));
        else throw new Error(`Invalid template literal part: ${part}`);
    }
    inst._zod.pattern = new RegExp(`^${regexParts.join("")}$`);
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "string") {
            payload.issues.push({
                input: payload.value,
                inst,
                expected: "string",
                code: "invalid_type"
            });
            return payload;
        }
        inst._zod.pattern.lastIndex = 0;
        if (!inst._zod.pattern.test(payload.value)) {
            payload.issues.push({
                input: payload.value,
                inst,
                code: "invalid_format",
                format: def.format ?? "template_literal",
                pattern: inst._zod.pattern.source
            });
            return payload;
        }
        return payload;
    };
});
const $ZodFunction = /*@__PURE__*/ _coreJs.$constructor("$ZodFunction", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._def = def;
    inst._zod.def = def;
    inst.implement = (func)=>{
        if (typeof func !== "function") throw new Error("implement() must be called with a function");
        return function(...args) {
            const parsedArgs = inst._def.input ? (0, _parseJs.parse)(inst._def.input, args) : args;
            const result = Reflect.apply(func, this, parsedArgs);
            if (inst._def.output) return (0, _parseJs.parse)(inst._def.output, result);
            return result;
        };
    };
    inst.implementAsync = (func)=>{
        if (typeof func !== "function") throw new Error("implementAsync() must be called with a function");
        return async function(...args) {
            const parsedArgs = inst._def.input ? await (0, _parseJs.parseAsync)(inst._def.input, args) : args;
            const result = await Reflect.apply(func, this, parsedArgs);
            if (inst._def.output) return await (0, _parseJs.parseAsync)(inst._def.output, result);
            return result;
        };
    };
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "function") {
            payload.issues.push({
                code: "invalid_type",
                expected: "function",
                input: payload.value,
                inst
            });
            return payload;
        }
        // Check if output is a promise type to determine if we should use async implementation
        const hasPromiseOutput = inst._def.output && inst._def.output._zod.def.type === "promise";
        if (hasPromiseOutput) payload.value = inst.implementAsync(payload.value);
        else payload.value = inst.implement(payload.value);
        return payload;
    };
    inst.input = (...args)=>{
        const F = inst.constructor;
        if (Array.isArray(args[0])) return new F({
            type: "function",
            input: new $ZodTuple({
                type: "tuple",
                items: args[0],
                rest: args[1]
            }),
            output: inst._def.output
        });
        return new F({
            type: "function",
            input: args[0],
            output: inst._def.output
        });
    };
    inst.output = (output)=>{
        const F = inst.constructor;
        return new F({
            type: "function",
            input: inst._def.input,
            output
        });
    };
    return inst;
});
const $ZodPromise = /*@__PURE__*/ _coreJs.$constructor("$ZodPromise", (inst, def)=>{
    $ZodType.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        return Promise.resolve(payload.value).then((inner)=>def.innerType._zod.run({
                value: inner,
                issues: []
            }, ctx));
    };
});
const $ZodLazy = /*@__PURE__*/ _coreJs.$constructor("$ZodLazy", (inst, def)=>{
    $ZodType.init(inst, def);
    // let _innerType!: any;
    // util.defineLazy(def, "getter", () => {
    //   if (!_innerType) {
    //     _innerType = def.getter();
    //   }
    //   return () => _innerType;
    // });
    _utilJs.defineLazy(inst._zod, "innerType", ()=>def.getter());
    _utilJs.defineLazy(inst._zod, "pattern", ()=>inst._zod.innerType?._zod?.pattern);
    _utilJs.defineLazy(inst._zod, "propValues", ()=>inst._zod.innerType?._zod?.propValues);
    _utilJs.defineLazy(inst._zod, "optin", ()=>inst._zod.innerType?._zod?.optin ?? undefined);
    _utilJs.defineLazy(inst._zod, "optout", ()=>inst._zod.innerType?._zod?.optout ?? undefined);
    inst._zod.parse = (payload, ctx)=>{
        const inner = inst._zod.innerType;
        return inner._zod.run(payload, ctx);
    };
});
const $ZodCustom = /*@__PURE__*/ _coreJs.$constructor("$ZodCustom", (inst, def)=>{
    _checksJs.$ZodCheck.init(inst, def);
    $ZodType.init(inst, def);
    inst._zod.parse = (payload, _)=>{
        return payload;
    };
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const r = def.fn(input);
        if (r instanceof Promise) return r.then((r)=>handleRefineResult(r, payload, input, inst));
        handleRefineResult(r, payload, input, inst);
        return;
    };
});
function handleRefineResult(result, payload, input, inst) {
    if (!result) {
        const _iss = {
            code: "custom",
            input,
            inst,
            path: [
                ...inst._zod.def.path ?? []
            ],
            continue: !inst._zod.def.abort
        };
        if (inst._zod.def.params) _iss.params = inst._zod.def.params;
        payload.issues.push(_utilJs.issue(_iss));
    }
}

},{"./checks.js":"f4OM4","./core.js":"cST2y","./doc.js":"8A0Wo","./parse.js":"eT8JT","./regexes.js":"2Kw1v","./util.js":"kNqJY","./versions.js":"8tnlW","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"f4OM4":[function(require,module,exports,__globalThis) {
// import { $ZodType } from "./schemas.js";
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$ZodCheck", ()=>$ZodCheck);
parcelHelpers.export(exports, "$ZodCheckLessThan", ()=>$ZodCheckLessThan);
parcelHelpers.export(exports, "$ZodCheckGreaterThan", ()=>$ZodCheckGreaterThan);
parcelHelpers.export(exports, "$ZodCheckMultipleOf", ()=>$ZodCheckMultipleOf);
parcelHelpers.export(exports, "$ZodCheckNumberFormat", ()=>$ZodCheckNumberFormat);
parcelHelpers.export(exports, "$ZodCheckBigIntFormat", ()=>$ZodCheckBigIntFormat);
parcelHelpers.export(exports, "$ZodCheckMaxSize", ()=>$ZodCheckMaxSize);
parcelHelpers.export(exports, "$ZodCheckMinSize", ()=>$ZodCheckMinSize);
parcelHelpers.export(exports, "$ZodCheckSizeEquals", ()=>$ZodCheckSizeEquals);
parcelHelpers.export(exports, "$ZodCheckMaxLength", ()=>$ZodCheckMaxLength);
parcelHelpers.export(exports, "$ZodCheckMinLength", ()=>$ZodCheckMinLength);
parcelHelpers.export(exports, "$ZodCheckLengthEquals", ()=>$ZodCheckLengthEquals);
parcelHelpers.export(exports, "$ZodCheckStringFormat", ()=>$ZodCheckStringFormat);
parcelHelpers.export(exports, "$ZodCheckRegex", ()=>$ZodCheckRegex);
parcelHelpers.export(exports, "$ZodCheckLowerCase", ()=>$ZodCheckLowerCase);
parcelHelpers.export(exports, "$ZodCheckUpperCase", ()=>$ZodCheckUpperCase);
parcelHelpers.export(exports, "$ZodCheckIncludes", ()=>$ZodCheckIncludes);
parcelHelpers.export(exports, "$ZodCheckStartsWith", ()=>$ZodCheckStartsWith);
parcelHelpers.export(exports, "$ZodCheckEndsWith", ()=>$ZodCheckEndsWith);
parcelHelpers.export(exports, "$ZodCheckProperty", ()=>$ZodCheckProperty);
parcelHelpers.export(exports, "$ZodCheckMimeType", ()=>$ZodCheckMimeType);
parcelHelpers.export(exports, "$ZodCheckOverwrite", ()=>$ZodCheckOverwrite);
var _coreJs = require("./core.js");
var _regexesJs = require("./regexes.js");
var _utilJs = require("./util.js");
const $ZodCheck = /*@__PURE__*/ _coreJs.$constructor("$ZodCheck", (inst, def)=>{
    var _a;
    inst._zod ?? (inst._zod = {});
    inst._zod.def = def;
    (_a = inst._zod).onattach ?? (_a.onattach = []);
});
const numericOriginMap = {
    number: "number",
    bigint: "bigint",
    object: "date"
};
const $ZodCheckLessThan = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckLessThan", (inst, def)=>{
    $ZodCheck.init(inst, def);
    const origin = numericOriginMap[typeof def.value];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        const curr = (def.inclusive ? bag.maximum : bag.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
        if (def.value < curr) {
            if (def.inclusive) bag.maximum = def.value;
            else bag.exclusiveMaximum = def.value;
        }
    });
    inst._zod.check = (payload)=>{
        if (def.inclusive ? payload.value <= def.value : payload.value < def.value) return;
        payload.issues.push({
            origin,
            code: "too_big",
            maximum: typeof def.value === "object" ? def.value.getTime() : def.value,
            input: payload.value,
            inclusive: def.inclusive,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCheckGreaterThan = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckGreaterThan", (inst, def)=>{
    $ZodCheck.init(inst, def);
    const origin = numericOriginMap[typeof def.value];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        const curr = (def.inclusive ? bag.minimum : bag.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
        if (def.value > curr) {
            if (def.inclusive) bag.minimum = def.value;
            else bag.exclusiveMinimum = def.value;
        }
    });
    inst._zod.check = (payload)=>{
        if (def.inclusive ? payload.value >= def.value : payload.value > def.value) return;
        payload.issues.push({
            origin,
            code: "too_small",
            minimum: typeof def.value === "object" ? def.value.getTime() : def.value,
            input: payload.value,
            inclusive: def.inclusive,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCheckMultipleOf = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckMultipleOf", (inst, def)=>{
    $ZodCheck.init(inst, def);
    inst._zod.onattach.push((inst)=>{
        var _a;
        (_a = inst._zod.bag).multipleOf ?? (_a.multipleOf = def.value);
    });
    inst._zod.check = (payload)=>{
        if (typeof payload.value !== typeof def.value) throw new Error("Cannot mix number and bigint in multiple_of check.");
        const isMultiple = typeof payload.value === "bigint" ? payload.value % def.value === BigInt(0) : _utilJs.floatSafeRemainder(payload.value, def.value) === 0;
        if (isMultiple) return;
        payload.issues.push({
            origin: typeof payload.value,
            code: "not_multiple_of",
            divisor: def.value,
            input: payload.value,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCheckNumberFormat = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckNumberFormat", (inst, def)=>{
    $ZodCheck.init(inst, def); // no format checks
    def.format = def.format || "float64";
    const isInt = def.format?.includes("int");
    const origin = isInt ? "int" : "number";
    const [minimum, maximum] = _utilJs.NUMBER_FORMAT_RANGES[def.format];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = def.format;
        bag.minimum = minimum;
        bag.maximum = maximum;
        if (isInt) bag.pattern = _regexesJs.integer;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        if (isInt) {
            if (!Number.isInteger(input)) {
                // invalid_format issue
                // payload.issues.push({
                //   expected: def.format,
                //   format: def.format,
                //   code: "invalid_format",
                //   input,
                //   inst,
                // });
                // invalid_type issue
                payload.issues.push({
                    expected: origin,
                    format: def.format,
                    code: "invalid_type",
                    continue: false,
                    input,
                    inst
                });
                return;
            // not_multiple_of issue
            // payload.issues.push({
            //   code: "not_multiple_of",
            //   origin: "number",
            //   input,
            //   inst,
            //   divisor: 1,
            // });
            }
            if (!Number.isSafeInteger(input)) {
                if (input > 0) // too_big
                payload.issues.push({
                    input,
                    code: "too_big",
                    maximum: Number.MAX_SAFE_INTEGER,
                    note: "Integers must be within the safe integer range.",
                    inst,
                    origin,
                    inclusive: true,
                    continue: !def.abort
                });
                else // too_small
                payload.issues.push({
                    input,
                    code: "too_small",
                    minimum: Number.MIN_SAFE_INTEGER,
                    note: "Integers must be within the safe integer range.",
                    inst,
                    origin,
                    inclusive: true,
                    continue: !def.abort
                });
                return;
            }
        }
        if (input < minimum) payload.issues.push({
            origin: "number",
            input,
            code: "too_small",
            minimum,
            inclusive: true,
            inst,
            continue: !def.abort
        });
        if (input > maximum) payload.issues.push({
            origin: "number",
            input,
            code: "too_big",
            maximum,
            inclusive: true,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCheckBigIntFormat = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckBigIntFormat", (inst, def)=>{
    $ZodCheck.init(inst, def); // no format checks
    const [minimum, maximum] = _utilJs.BIGINT_FORMAT_RANGES[def.format];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = def.format;
        bag.minimum = minimum;
        bag.maximum = maximum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        if (input < minimum) payload.issues.push({
            origin: "bigint",
            input,
            code: "too_small",
            minimum: minimum,
            inclusive: true,
            inst,
            continue: !def.abort
        });
        if (input > maximum) payload.issues.push({
            origin: "bigint",
            input,
            code: "too_big",
            maximum,
            inclusive: true,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCheckMaxSize = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckMaxSize", (inst, def)=>{
    var _a;
    $ZodCheck.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !_utilJs.nullish(val) && val.size !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        if (def.maximum < curr) inst._zod.bag.maximum = def.maximum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size <= def.maximum) return;
        payload.issues.push({
            origin: _utilJs.getSizableOrigin(input),
            code: "too_big",
            maximum: def.maximum,
            inclusive: true,
            input,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCheckMinSize = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckMinSize", (inst, def)=>{
    var _a;
    $ZodCheck.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !_utilJs.nullish(val) && val.size !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        if (def.minimum > curr) inst._zod.bag.minimum = def.minimum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size >= def.minimum) return;
        payload.issues.push({
            origin: _utilJs.getSizableOrigin(input),
            code: "too_small",
            minimum: def.minimum,
            inclusive: true,
            input,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCheckSizeEquals = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckSizeEquals", (inst, def)=>{
    var _a;
    $ZodCheck.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !_utilJs.nullish(val) && val.size !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.minimum = def.size;
        bag.maximum = def.size;
        bag.size = def.size;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size === def.size) return;
        const tooBig = size > def.size;
        payload.issues.push({
            origin: _utilJs.getSizableOrigin(input),
            ...tooBig ? {
                code: "too_big",
                maximum: def.size
            } : {
                code: "too_small",
                minimum: def.size
            },
            inclusive: true,
            exact: true,
            input: payload.value,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCheckMaxLength = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckMaxLength", (inst, def)=>{
    var _a;
    $ZodCheck.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !_utilJs.nullish(val) && val.length !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        if (def.maximum < curr) inst._zod.bag.maximum = def.maximum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const length = input.length;
        if (length <= def.maximum) return;
        const origin = _utilJs.getLengthableOrigin(input);
        payload.issues.push({
            origin,
            code: "too_big",
            maximum: def.maximum,
            inclusive: true,
            input,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCheckMinLength = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckMinLength", (inst, def)=>{
    var _a;
    $ZodCheck.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !_utilJs.nullish(val) && val.length !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        if (def.minimum > curr) inst._zod.bag.minimum = def.minimum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const length = input.length;
        if (length >= def.minimum) return;
        const origin = _utilJs.getLengthableOrigin(input);
        payload.issues.push({
            origin,
            code: "too_small",
            minimum: def.minimum,
            inclusive: true,
            input,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCheckLengthEquals = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckLengthEquals", (inst, def)=>{
    var _a;
    $ZodCheck.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !_utilJs.nullish(val) && val.length !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.minimum = def.length;
        bag.maximum = def.length;
        bag.length = def.length;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const length = input.length;
        if (length === def.length) return;
        const origin = _utilJs.getLengthableOrigin(input);
        const tooBig = length > def.length;
        payload.issues.push({
            origin,
            ...tooBig ? {
                code: "too_big",
                maximum: def.length
            } : {
                code: "too_small",
                minimum: def.length
            },
            inclusive: true,
            exact: true,
            input: payload.value,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCheckStringFormat = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckStringFormat", (inst, def)=>{
    var _a, _b;
    $ZodCheck.init(inst, def);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = def.format;
        if (def.pattern) {
            bag.patterns ?? (bag.patterns = new Set());
            bag.patterns.add(def.pattern);
        }
    });
    if (def.pattern) (_a = inst._zod).check ?? (_a.check = (payload)=>{
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            ...def.pattern ? {
                pattern: def.pattern.toString()
            } : {},
            inst,
            continue: !def.abort
        });
    });
    else (_b = inst._zod).check ?? (_b.check = ()=>{});
});
const $ZodCheckRegex = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckRegex", (inst, def)=>{
    $ZodCheckStringFormat.init(inst, def);
    inst._zod.check = (payload)=>{
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "regex",
            input: payload.value,
            pattern: def.pattern.toString(),
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCheckLowerCase = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckLowerCase", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.lowercase);
    $ZodCheckStringFormat.init(inst, def);
});
const $ZodCheckUpperCase = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckUpperCase", (inst, def)=>{
    def.pattern ?? (def.pattern = _regexesJs.uppercase);
    $ZodCheckStringFormat.init(inst, def);
});
const $ZodCheckIncludes = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckIncludes", (inst, def)=>{
    $ZodCheck.init(inst, def);
    const escapedRegex = _utilJs.escapeRegex(def.includes);
    const pattern = new RegExp(typeof def.position === "number" ? `^.{${def.position}}${escapedRegex}` : escapedRegex);
    def.pattern = pattern;
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.patterns ?? (bag.patterns = new Set());
        bag.patterns.add(pattern);
    });
    inst._zod.check = (payload)=>{
        if (payload.value.includes(def.includes, def.position)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "includes",
            includes: def.includes,
            input: payload.value,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCheckStartsWith = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckStartsWith", (inst, def)=>{
    $ZodCheck.init(inst, def);
    const pattern = new RegExp(`^${_utilJs.escapeRegex(def.prefix)}.*`);
    def.pattern ?? (def.pattern = pattern);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.patterns ?? (bag.patterns = new Set());
        bag.patterns.add(pattern);
    });
    inst._zod.check = (payload)=>{
        if (payload.value.startsWith(def.prefix)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "starts_with",
            prefix: def.prefix,
            input: payload.value,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCheckEndsWith = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckEndsWith", (inst, def)=>{
    $ZodCheck.init(inst, def);
    const pattern = new RegExp(`.*${_utilJs.escapeRegex(def.suffix)}$`);
    def.pattern ?? (def.pattern = pattern);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.patterns ?? (bag.patterns = new Set());
        bag.patterns.add(pattern);
    });
    inst._zod.check = (payload)=>{
        if (payload.value.endsWith(def.suffix)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "ends_with",
            suffix: def.suffix,
            input: payload.value,
            inst,
            continue: !def.abort
        });
    };
});
///////////////////////////////////
/////    $ZodCheckProperty    /////
///////////////////////////////////
function handleCheckPropertyResult(result, payload, property) {
    if (result.issues.length) payload.issues.push(..._utilJs.prefixIssues(property, result.issues));
}
const $ZodCheckProperty = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckProperty", (inst, def)=>{
    $ZodCheck.init(inst, def);
    inst._zod.check = (payload)=>{
        const result = def.schema._zod.run({
            value: payload.value[def.property],
            issues: []
        }, {});
        if (result instanceof Promise) return result.then((result)=>handleCheckPropertyResult(result, payload, def.property));
        handleCheckPropertyResult(result, payload, def.property);
        return;
    };
});
const $ZodCheckMimeType = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckMimeType", (inst, def)=>{
    $ZodCheck.init(inst, def);
    const mimeSet = new Set(def.mime);
    inst._zod.onattach.push((inst)=>{
        inst._zod.bag.mime = def.mime;
    });
    inst._zod.check = (payload)=>{
        if (mimeSet.has(payload.value.type)) return;
        payload.issues.push({
            code: "invalid_value",
            values: def.mime,
            input: payload.value.type,
            inst,
            continue: !def.abort
        });
    };
});
const $ZodCheckOverwrite = /*@__PURE__*/ _coreJs.$constructor("$ZodCheckOverwrite", (inst, def)=>{
    $ZodCheck.init(inst, def);
    inst._zod.check = (payload)=>{
        payload.value = def.tx(payload.value);
    };
});

},{"./core.js":"cST2y","./regexes.js":"2Kw1v","./util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2Kw1v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cuid", ()=>cuid);
parcelHelpers.export(exports, "cuid2", ()=>cuid2);
parcelHelpers.export(exports, "ulid", ()=>ulid);
parcelHelpers.export(exports, "xid", ()=>xid);
parcelHelpers.export(exports, "ksuid", ()=>ksuid);
parcelHelpers.export(exports, "nanoid", ()=>nanoid);
parcelHelpers.export(exports, "duration", ()=>duration);
parcelHelpers.export(exports, "extendedDuration", ()=>extendedDuration);
parcelHelpers.export(exports, "guid", ()=>guid);
parcelHelpers.export(exports, "uuid", ()=>uuid);
parcelHelpers.export(exports, "uuid4", ()=>uuid4);
parcelHelpers.export(exports, "uuid6", ()=>uuid6);
parcelHelpers.export(exports, "uuid7", ()=>uuid7);
parcelHelpers.export(exports, "email", ()=>email);
parcelHelpers.export(exports, "html5Email", ()=>html5Email);
parcelHelpers.export(exports, "rfc5322Email", ()=>rfc5322Email);
parcelHelpers.export(exports, "unicodeEmail", ()=>unicodeEmail);
parcelHelpers.export(exports, "idnEmail", ()=>idnEmail);
parcelHelpers.export(exports, "browserEmail", ()=>browserEmail);
parcelHelpers.export(exports, "emoji", ()=>emoji);
parcelHelpers.export(exports, "ipv4", ()=>ipv4);
parcelHelpers.export(exports, "ipv6", ()=>ipv6);
parcelHelpers.export(exports, "mac", ()=>mac);
parcelHelpers.export(exports, "cidrv4", ()=>cidrv4);
parcelHelpers.export(exports, "cidrv6", ()=>cidrv6);
parcelHelpers.export(exports, "base64", ()=>base64);
parcelHelpers.export(exports, "base64url", ()=>base64url);
parcelHelpers.export(exports, "hostname", ()=>hostname);
parcelHelpers.export(exports, "domain", ()=>domain);
parcelHelpers.export(exports, "e164", ()=>e164);
parcelHelpers.export(exports, "date", ()=>date);
parcelHelpers.export(exports, "time", ()=>time);
// Adapted from https://stackoverflow.com/a/3143231
parcelHelpers.export(exports, "datetime", ()=>datetime);
parcelHelpers.export(exports, "string", ()=>string);
parcelHelpers.export(exports, "bigint", ()=>bigint);
parcelHelpers.export(exports, "integer", ()=>integer);
parcelHelpers.export(exports, "number", ()=>number);
parcelHelpers.export(exports, "boolean", ()=>boolean);
parcelHelpers.export(exports, "null", ()=>_null);
parcelHelpers.export(exports, "undefined", ()=>_undefined);
parcelHelpers.export(exports, "lowercase", ()=>lowercase);
parcelHelpers.export(exports, "uppercase", ()=>uppercase);
parcelHelpers.export(exports, "hex", ()=>hex);
parcelHelpers.export(exports, "md5_hex", ()=>md5_hex);
parcelHelpers.export(exports, "md5_base64", ()=>md5_base64);
parcelHelpers.export(exports, "md5_base64url", ()=>md5_base64url);
parcelHelpers.export(exports, "sha1_hex", ()=>sha1_hex);
parcelHelpers.export(exports, "sha1_base64", ()=>sha1_base64);
parcelHelpers.export(exports, "sha1_base64url", ()=>sha1_base64url);
parcelHelpers.export(exports, "sha256_hex", ()=>sha256_hex);
parcelHelpers.export(exports, "sha256_base64", ()=>sha256_base64);
parcelHelpers.export(exports, "sha256_base64url", ()=>sha256_base64url);
parcelHelpers.export(exports, "sha384_hex", ()=>sha384_hex);
parcelHelpers.export(exports, "sha384_base64", ()=>sha384_base64);
parcelHelpers.export(exports, "sha384_base64url", ()=>sha384_base64url);
parcelHelpers.export(exports, "sha512_hex", ()=>sha512_hex);
parcelHelpers.export(exports, "sha512_base64", ()=>sha512_base64);
parcelHelpers.export(exports, "sha512_base64url", ()=>sha512_base64url);
var _utilJs = require("./util.js");
const cuid = /^[cC][^\s-]{8,}$/;
const cuid2 = /^[0-9a-z]+$/;
const ulid = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/;
const xid = /^[0-9a-vA-V]{20}$/;
const ksuid = /^[A-Za-z0-9]{27}$/;
const nanoid = /^[a-zA-Z0-9_-]{21}$/;
const duration = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/;
const extendedDuration = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
const guid = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;
const uuid = (version)=>{
    if (!version) return /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/;
    return new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${version}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`);
};
const uuid4 = /*@__PURE__*/ uuid(4);
const uuid6 = /*@__PURE__*/ uuid(6);
const uuid7 = /*@__PURE__*/ uuid(7);
const email = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/;
const html5Email = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const rfc5322Email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const unicodeEmail = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u;
const idnEmail = unicodeEmail;
const browserEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emoji = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
function emoji() {
    return new RegExp(_emoji, "u");
}
const ipv4 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv6 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;
const mac = (delimiter)=>{
    const escapedDelim = _utilJs.escapeRegex(delimiter ?? ":");
    return new RegExp(`^(?:[0-9A-F]{2}${escapedDelim}){5}[0-9A-F]{2}$|^(?:[0-9a-f]{2}${escapedDelim}){5}[0-9a-f]{2}$`);
};
const cidrv4 = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/;
const cidrv6 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
const base64 = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/;
const base64url = /^[A-Za-z0-9_-]*$/;
const hostname = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/;
const domain = /^([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
const e164 = /^\+[1-9]\d{6,14}$/;
// const dateSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateSource = `(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))`;
const date = /*@__PURE__*/ new RegExp(`^${dateSource}$`);
function timeSource(args) {
    const hhmm = `(?:[01]\\d|2[0-3]):[0-5]\\d`;
    const regex = typeof args.precision === "number" ? args.precision === -1 ? `${hhmm}` : args.precision === 0 ? `${hhmm}:[0-5]\\d` : `${hhmm}:[0-5]\\d\\.\\d{${args.precision}}` : `${hhmm}(?::[0-5]\\d(?:\\.\\d+)?)?`;
    return regex;
}
function time(args) {
    return new RegExp(`^${timeSource(args)}$`);
}
function datetime(args) {
    const time = timeSource({
        precision: args.precision
    });
    const opts = [
        "Z"
    ];
    if (args.local) opts.push("");
    // if (args.offset) opts.push(`([+-]\\d{2}:\\d{2})`);
    if (args.offset) opts.push(`([+-](?:[01]\\d|2[0-3]):[0-5]\\d)`);
    const timeRegex = `${time}(?:${opts.join("|")})`;
    return new RegExp(`^${dateSource}T(?:${timeRegex})$`);
}
const string = (params)=>{
    const regex = params ? `[\\s\\S]{${params?.minimum ?? 0},${params?.maximum ?? ""}}` : `[\\s\\S]*`;
    return new RegExp(`^${regex}$`);
};
const bigint = /^-?\d+n?$/;
const integer = /^-?\d+$/;
const number = /^-?\d+(?:\.\d+)?$/;
const boolean = /^(?:true|false)$/i;
const _null = /^null$/i;
const _undefined = /^undefined$/i;
const lowercase = /^[^A-Z]*$/;
const uppercase = /^[^a-z]*$/;
const hex = /^[0-9a-fA-F]*$/;
// Hash regexes for different algorithms and encodings
// Helper function to create base64 regex with exact length and padding
function fixedBase64(bodyLength, padding) {
    return new RegExp(`^[A-Za-z0-9+/]{${bodyLength}}${padding}$`);
}
// Helper function to create base64url regex with exact length (no padding)
function fixedBase64url(length) {
    return new RegExp(`^[A-Za-z0-9_-]{${length}}$`);
}
const md5_hex = /^[0-9a-fA-F]{32}$/;
const md5_base64 = /*@__PURE__*/ fixedBase64(22, "==");
const md5_base64url = /*@__PURE__*/ fixedBase64url(22);
const sha1_hex = /^[0-9a-fA-F]{40}$/;
const sha1_base64 = /*@__PURE__*/ fixedBase64(27, "=");
const sha1_base64url = /*@__PURE__*/ fixedBase64url(27);
const sha256_hex = /^[0-9a-fA-F]{64}$/;
const sha256_base64 = /*@__PURE__*/ fixedBase64(43, "=");
const sha256_base64url = /*@__PURE__*/ fixedBase64url(43);
const sha384_hex = /^[0-9a-fA-F]{96}$/;
const sha384_base64 = /*@__PURE__*/ fixedBase64(64, "");
const sha384_base64url = /*@__PURE__*/ fixedBase64url(64);
const sha512_hex = /^[0-9a-fA-F]{128}$/;
const sha512_base64 = /*@__PURE__*/ fixedBase64(86, "==");
const sha512_base64url = /*@__PURE__*/ fixedBase64url(86);

},{"./util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8A0Wo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Doc", ()=>Doc);
class Doc {
    constructor(args = []){
        this.content = [];
        this.indent = 0;
        if (this) this.args = args;
    }
    indented(fn) {
        this.indent += 1;
        fn(this);
        this.indent -= 1;
    }
    write(arg) {
        if (typeof arg === "function") {
            arg(this, {
                execution: "sync"
            });
            arg(this, {
                execution: "async"
            });
            return;
        }
        const content = arg;
        const lines = content.split("\n").filter((x)=>x);
        const minIndent = Math.min(...lines.map((x)=>x.length - x.trimStart().length));
        const dedented = lines.map((x)=>x.slice(minIndent)).map((x)=>" ".repeat(this.indent * 2) + x);
        for (const line of dedented)this.content.push(line);
    }
    compile() {
        const F = Function;
        const args = this?.args;
        const content = this?.content ?? [
            ``
        ];
        const lines = [
            ...content.map((x)=>`  ${x}`)
        ];
        // console.log(lines.join("\n"));
        return new F(...args, lines.join("\n"));
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8tnlW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = {
    major: 4,
    minor: 3,
    patch: 4
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8wwdV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ar", ()=>(0, _arJsDefault.default));
parcelHelpers.export(exports, "az", ()=>(0, _azJsDefault.default));
parcelHelpers.export(exports, "be", ()=>(0, _beJsDefault.default));
parcelHelpers.export(exports, "bg", ()=>(0, _bgJsDefault.default));
parcelHelpers.export(exports, "ca", ()=>(0, _caJsDefault.default));
parcelHelpers.export(exports, "cs", ()=>(0, _csJsDefault.default));
parcelHelpers.export(exports, "da", ()=>(0, _daJsDefault.default));
parcelHelpers.export(exports, "de", ()=>(0, _deJsDefault.default));
parcelHelpers.export(exports, "en", ()=>(0, _enJsDefault.default));
parcelHelpers.export(exports, "eo", ()=>(0, _eoJsDefault.default));
parcelHelpers.export(exports, "es", ()=>(0, _esJsDefault.default));
parcelHelpers.export(exports, "fa", ()=>(0, _faJsDefault.default));
parcelHelpers.export(exports, "fi", ()=>(0, _fiJsDefault.default));
parcelHelpers.export(exports, "fr", ()=>(0, _frJsDefault.default));
parcelHelpers.export(exports, "frCA", ()=>(0, _frCAJsDefault.default));
parcelHelpers.export(exports, "he", ()=>(0, _heJsDefault.default));
parcelHelpers.export(exports, "hu", ()=>(0, _huJsDefault.default));
parcelHelpers.export(exports, "hy", ()=>(0, _hyJsDefault.default));
parcelHelpers.export(exports, "id", ()=>(0, _idJsDefault.default));
parcelHelpers.export(exports, "is", ()=>(0, _isJsDefault.default));
parcelHelpers.export(exports, "it", ()=>(0, _itJsDefault.default));
parcelHelpers.export(exports, "ja", ()=>(0, _jaJsDefault.default));
parcelHelpers.export(exports, "ka", ()=>(0, _kaJsDefault.default));
parcelHelpers.export(exports, "kh", ()=>(0, _khJsDefault.default));
parcelHelpers.export(exports, "km", ()=>(0, _kmJsDefault.default));
parcelHelpers.export(exports, "ko", ()=>(0, _koJsDefault.default));
parcelHelpers.export(exports, "lt", ()=>(0, _ltJsDefault.default));
parcelHelpers.export(exports, "mk", ()=>(0, _mkJsDefault.default));
parcelHelpers.export(exports, "ms", ()=>(0, _msJsDefault.default));
parcelHelpers.export(exports, "nl", ()=>(0, _nlJsDefault.default));
parcelHelpers.export(exports, "no", ()=>(0, _noJsDefault.default));
parcelHelpers.export(exports, "ota", ()=>(0, _otaJsDefault.default));
parcelHelpers.export(exports, "ps", ()=>(0, _psJsDefault.default));
parcelHelpers.export(exports, "pl", ()=>(0, _plJsDefault.default));
parcelHelpers.export(exports, "pt", ()=>(0, _ptJsDefault.default));
parcelHelpers.export(exports, "ru", ()=>(0, _ruJsDefault.default));
parcelHelpers.export(exports, "sl", ()=>(0, _slJsDefault.default));
parcelHelpers.export(exports, "sv", ()=>(0, _svJsDefault.default));
parcelHelpers.export(exports, "ta", ()=>(0, _taJsDefault.default));
parcelHelpers.export(exports, "th", ()=>(0, _thJsDefault.default));
parcelHelpers.export(exports, "tr", ()=>(0, _trJsDefault.default));
parcelHelpers.export(exports, "ua", ()=>(0, _uaJsDefault.default));
parcelHelpers.export(exports, "uk", ()=>(0, _ukJsDefault.default));
parcelHelpers.export(exports, "ur", ()=>(0, _urJsDefault.default));
parcelHelpers.export(exports, "uz", ()=>(0, _uzJsDefault.default));
parcelHelpers.export(exports, "vi", ()=>(0, _viJsDefault.default));
parcelHelpers.export(exports, "zhCN", ()=>(0, _zhCNJsDefault.default));
parcelHelpers.export(exports, "zhTW", ()=>(0, _zhTWJsDefault.default));
parcelHelpers.export(exports, "yo", ()=>(0, _yoJsDefault.default));
var _arJs = require("./ar.js");
var _arJsDefault = parcelHelpers.interopDefault(_arJs);
var _azJs = require("./az.js");
var _azJsDefault = parcelHelpers.interopDefault(_azJs);
var _beJs = require("./be.js");
var _beJsDefault = parcelHelpers.interopDefault(_beJs);
var _bgJs = require("./bg.js");
var _bgJsDefault = parcelHelpers.interopDefault(_bgJs);
var _caJs = require("./ca.js");
var _caJsDefault = parcelHelpers.interopDefault(_caJs);
var _csJs = require("./cs.js");
var _csJsDefault = parcelHelpers.interopDefault(_csJs);
var _daJs = require("./da.js");
var _daJsDefault = parcelHelpers.interopDefault(_daJs);
var _deJs = require("./de.js");
var _deJsDefault = parcelHelpers.interopDefault(_deJs);
var _enJs = require("./en.js");
var _enJsDefault = parcelHelpers.interopDefault(_enJs);
var _eoJs = require("./eo.js");
var _eoJsDefault = parcelHelpers.interopDefault(_eoJs);
var _esJs = require("./es.js");
var _esJsDefault = parcelHelpers.interopDefault(_esJs);
var _faJs = require("./fa.js");
var _faJsDefault = parcelHelpers.interopDefault(_faJs);
var _fiJs = require("./fi.js");
var _fiJsDefault = parcelHelpers.interopDefault(_fiJs);
var _frJs = require("./fr.js");
var _frJsDefault = parcelHelpers.interopDefault(_frJs);
var _frCAJs = require("./fr-CA.js");
var _frCAJsDefault = parcelHelpers.interopDefault(_frCAJs);
var _heJs = require("./he.js");
var _heJsDefault = parcelHelpers.interopDefault(_heJs);
var _huJs = require("./hu.js");
var _huJsDefault = parcelHelpers.interopDefault(_huJs);
var _hyJs = require("./hy.js");
var _hyJsDefault = parcelHelpers.interopDefault(_hyJs);
var _idJs = require("./id.js");
var _idJsDefault = parcelHelpers.interopDefault(_idJs);
var _isJs = require("./is.js");
var _isJsDefault = parcelHelpers.interopDefault(_isJs);
var _itJs = require("./it.js");
var _itJsDefault = parcelHelpers.interopDefault(_itJs);
var _jaJs = require("./ja.js");
var _jaJsDefault = parcelHelpers.interopDefault(_jaJs);
var _kaJs = require("./ka.js");
var _kaJsDefault = parcelHelpers.interopDefault(_kaJs);
var _khJs = require("./kh.js");
var _khJsDefault = parcelHelpers.interopDefault(_khJs);
var _kmJs = require("./km.js");
var _kmJsDefault = parcelHelpers.interopDefault(_kmJs);
var _koJs = require("./ko.js");
var _koJsDefault = parcelHelpers.interopDefault(_koJs);
var _ltJs = require("./lt.js");
var _ltJsDefault = parcelHelpers.interopDefault(_ltJs);
var _mkJs = require("./mk.js");
var _mkJsDefault = parcelHelpers.interopDefault(_mkJs);
var _msJs = require("./ms.js");
var _msJsDefault = parcelHelpers.interopDefault(_msJs);
var _nlJs = require("./nl.js");
var _nlJsDefault = parcelHelpers.interopDefault(_nlJs);
var _noJs = require("./no.js");
var _noJsDefault = parcelHelpers.interopDefault(_noJs);
var _otaJs = require("./ota.js");
var _otaJsDefault = parcelHelpers.interopDefault(_otaJs);
var _psJs = require("./ps.js");
var _psJsDefault = parcelHelpers.interopDefault(_psJs);
var _plJs = require("./pl.js");
var _plJsDefault = parcelHelpers.interopDefault(_plJs);
var _ptJs = require("./pt.js");
var _ptJsDefault = parcelHelpers.interopDefault(_ptJs);
var _ruJs = require("./ru.js");
var _ruJsDefault = parcelHelpers.interopDefault(_ruJs);
var _slJs = require("./sl.js");
var _slJsDefault = parcelHelpers.interopDefault(_slJs);
var _svJs = require("./sv.js");
var _svJsDefault = parcelHelpers.interopDefault(_svJs);
var _taJs = require("./ta.js");
var _taJsDefault = parcelHelpers.interopDefault(_taJs);
var _thJs = require("./th.js");
var _thJsDefault = parcelHelpers.interopDefault(_thJs);
var _trJs = require("./tr.js");
var _trJsDefault = parcelHelpers.interopDefault(_trJs);
var _uaJs = require("./ua.js");
var _uaJsDefault = parcelHelpers.interopDefault(_uaJs);
var _ukJs = require("./uk.js");
var _ukJsDefault = parcelHelpers.interopDefault(_ukJs);
var _urJs = require("./ur.js");
var _urJsDefault = parcelHelpers.interopDefault(_urJs);
var _uzJs = require("./uz.js");
var _uzJsDefault = parcelHelpers.interopDefault(_uzJs);
var _viJs = require("./vi.js");
var _viJsDefault = parcelHelpers.interopDefault(_viJs);
var _zhCNJs = require("./zh-CN.js");
var _zhCNJsDefault = parcelHelpers.interopDefault(_zhCNJs);
var _zhTWJs = require("./zh-TW.js");
var _zhTWJsDefault = parcelHelpers.interopDefault(_zhTWJs);
var _yoJs = require("./yo.js");
var _yoJsDefault = parcelHelpers.interopDefault(_yoJs);

},{"./ar.js":"gNZdb","./az.js":"iVnaQ","./be.js":"4li75","./bg.js":"6QkG5","./ca.js":"gELrS","./cs.js":"FOmjK","./da.js":"8529x","./de.js":"cXZD1","./en.js":"giZBF","./eo.js":"bzEho","./es.js":"ij7l2","./fa.js":"kfYXb","./fi.js":"jj3V4","./fr.js":"kS4Ek","./fr-CA.js":"ddbx4","./he.js":"7Em55","./hu.js":"jLfvv","./hy.js":"39jG3","./id.js":"kht6n","./is.js":"dbuB0","./it.js":"bAEOP","./ja.js":"28QhZ","./ka.js":"eAdEV","./kh.js":"7S9aa","./km.js":"5ZRkg","./ko.js":"bHTrD","./lt.js":"8XGvO","./mk.js":"aGcvI","./ms.js":"6OryG","./nl.js":"a0j2t","./no.js":"21t6k","./ota.js":"f88MQ","./ps.js":"3v7j6","./pl.js":"k6EpX","./pt.js":"31Zoi","./ru.js":"5ZN7a","./sl.js":"2IrWn","./sv.js":"6aIy5","./ta.js":"eIcb9","./th.js":"10AUw","./tr.js":"9tMyQ","./ua.js":"cLCYu","./uk.js":"hTLTa","./ur.js":"9NiID","./uz.js":"gG1xl","./vi.js":"9orAI","./zh-CN.js":"PKpjY","./zh-TW.js":"8R0Qg","./yo.js":"ho2L9","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gNZdb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\u062D\u0631\u0641",
            verb: "\u0623\u0646 \u064A\u062D\u0648\u064A"
        },
        file: {
            unit: "\u0628\u0627\u064A\u062A",
            verb: "\u0623\u0646 \u064A\u062D\u0648\u064A"
        },
        array: {
            unit: "\u0639\u0646\u0635\u0631",
            verb: "\u0623\u0646 \u064A\u062D\u0648\u064A"
        },
        set: {
            unit: "\u0639\u0646\u0635\u0631",
            verb: "\u0623\u0646 \u064A\u062D\u0648\u064A"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0645\u062F\u062E\u0644",
        email: "\u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        url: "\u0631\u0627\u0628\u0637",
        emoji: "\u0625\u064A\u0645\u0648\u062C\u064A",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u062A\u0627\u0631\u064A\u062E \u0648\u0648\u0642\u062A \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        date: "\u062A\u0627\u0631\u064A\u062E \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        time: "\u0648\u0642\u062A \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        duration: "\u0645\u062F\u0629 \u0628\u0645\u0639\u064A\u0627\u0631 ISO",
        ipv4: "\u0639\u0646\u0648\u0627\u0646 IPv4",
        ipv6: "\u0639\u0646\u0648\u0627\u0646 IPv6",
        cidrv4: "\u0645\u062F\u0649 \u0639\u0646\u0627\u0648\u064A\u0646 \u0628\u0635\u064A\u063A\u0629 IPv4",
        cidrv6: "\u0645\u062F\u0649 \u0639\u0646\u0627\u0648\u064A\u0646 \u0628\u0635\u064A\u063A\u0629 IPv6",
        base64: "\u0646\u064E\u0635 \u0628\u062A\u0631\u0645\u064A\u0632 base64-encoded",
        base64url: "\u0646\u064E\u0635 \u0628\u062A\u0631\u0645\u064A\u0632 base64url-encoded",
        json_string: "\u0646\u064E\u0635 \u0639\u0644\u0649 \u0647\u064A\u0626\u0629 JSON",
        e164: "\u0631\u0642\u0645 \u0647\u0627\u062A\u0641 \u0628\u0645\u0639\u064A\u0627\u0631 E.164",
        jwt: "JWT",
        template_literal: "\u0645\u062F\u062E\u0644"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{645}\u{62F}\u{62E}\u{644}\u{627}\u{62A} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}\u{629}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{625}\u{62F}\u{62E}\u{627}\u{644} instanceof ${issue.expected}\u{60C} \u{648}\u{644}\u{643}\u{646} \u{62A}\u{645} \u{625}\u{62F}\u{62E}\u{627}\u{644} ${received}`;
                    return `\u{645}\u{62F}\u{62E}\u{644}\u{627}\u{62A} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}\u{629}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{625}\u{62F}\u{62E}\u{627}\u{644} ${expected}\u{60C} \u{648}\u{644}\u{643}\u{646} \u{62A}\u{645} \u{625}\u{62F}\u{62E}\u{627}\u{644} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{645}\u{62F}\u{62E}\u{644}\u{627}\u{62A} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}\u{629}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{625}\u{62F}\u{62E}\u{627}\u{644} ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `\u{627}\u{62E}\u{62A}\u{64A}\u{627}\u{631} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62A}\u{648}\u{642}\u{639} \u{627}\u{646}\u{62A}\u{642}\u{627}\u{621} \u{623}\u{62D}\u{62F} \u{647}\u{630}\u{647} \u{627}\u{644}\u{62E}\u{64A}\u{627}\u{631}\u{627}\u{62A}: ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return ` \u{623}\u{643}\u{628}\u{631} \u{645}\u{646} \u{627}\u{644}\u{644}\u{627}\u{632}\u{645}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} ${issue.origin ?? "\u0627\u0644\u0642\u064A\u0645\u0629"} ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0635\u0631"}`;
                    return `\u{623}\u{643}\u{628}\u{631} \u{645}\u{646} \u{627}\u{644}\u{644}\u{627}\u{632}\u{645}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} ${issue.origin ?? "\u0627\u0644\u0642\u064A\u0645\u0629"} ${adj} ${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{623}\u{635}\u{63A}\u{631} \u{645}\u{646} \u{627}\u{644}\u{644}\u{627}\u{632}\u{645}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{644}\u{640} ${issue.origin} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{623}\u{635}\u{63A}\u{631} \u{645}\u{646} \u{627}\u{644}\u{644}\u{627}\u{632}\u{645}: \u{64A}\u{641}\u{62A}\u{631}\u{636} \u{644}\u{640} ${issue.origin} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${adj} ${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{646}\u{64E}\u{635} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{628}\u{62F}\u{623} \u{628}\u{640} "${issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{646}\u{64E}\u{635} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{646}\u{62A}\u{647}\u{64A} \u{628}\u{640} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{646}\u{64E}\u{635} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{62A}\u{636}\u{645}\u{651}\u{64E}\u{646} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{646}\u{64E}\u{635} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{637}\u{627}\u{628}\u{642} \u{627}\u{644}\u{646}\u{645}\u{637} ${_issue.pattern}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}`;
                }
            case "not_multiple_of":
                return `\u{631}\u{642}\u{645} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644}: \u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} \u{645}\u{646} \u{645}\u{636}\u{627}\u{639}\u{641}\u{627}\u{62A} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{645}\u{639}\u{631}\u{641}${issue.keys.length > 1 ? "\u0627\u062A" : ""} \u{63A}\u{631}\u{64A}\u{628}${issue.keys.length > 1 ? "\u0629" : ""}: ${_utilJs.joinValues(issue.keys, "\u060C ")}`;
            case "invalid_key":
                return `\u{645}\u{639}\u{631}\u{641} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644} \u{641}\u{64A} ${issue.origin}`;
            case "invalid_union":
                return "\u0645\u062F\u062E\u0644 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644";
            case "invalid_element":
                return `\u{645}\u{62F}\u{62E}\u{644} \u{63A}\u{64A}\u{631} \u{645}\u{642}\u{628}\u{648}\u{644} \u{641}\u{64A} ${issue.origin}`;
            default:
                return "\u0645\u062F\u062E\u0644 \u063A\u064A\u0631 \u0645\u0642\u0628\u0648\u0644";
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"iVnaQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "simvol",
            verb: "olmal\u0131d\u0131r"
        },
        file: {
            unit: "bayt",
            verb: "olmal\u0131d\u0131r"
        },
        array: {
            unit: "element",
            verb: "olmal\u0131d\u0131r"
        },
        set: {
            unit: "element",
            verb: "olmal\u0131d\u0131r"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        jwt: "JWT",
        template_literal: "input"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Yanl\u{131}\u{15F} d\u{259}y\u{259}r: g\xf6zl\u{259}nil\u{259}n instanceof ${issue.expected}, daxil olan ${received}`;
                    return `Yanl\u{131}\u{15F} d\u{259}y\u{259}r: g\xf6zl\u{259}nil\u{259}n ${expected}, daxil olan ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Yanl\u{131}\u{15F} d\u{259}y\u{259}r: g\xf6zl\u{259}nil\u{259}n ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Yanl\u{131}\u{15F} se\xe7im: a\u{15F}a\u{11F}\u{131}dak\u{131}lardan biri olmal\u{131}d\u{131}r: ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\xc7ox b\xf6y\xfck: g\xf6zl\u{259}nil\u{259}n ${issue.origin ?? "d\u0259y\u0259r"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "element"}`;
                    return `\xc7ox b\xf6y\xfck: g\xf6zl\u{259}nil\u{259}n ${issue.origin ?? "d\u0259y\u0259r"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\xc7ox ki\xe7ik: g\xf6zl\u{259}nil\u{259}n ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\xc7ox ki\xe7ik: g\xf6zl\u{259}nil\u{259}n ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Yanl\u{131}\u{15F} m\u{259}tn: "${_issue.prefix}" il\u{259} ba\u{15F}lamal\u{131}d\u{131}r`;
                    if (_issue.format === "ends_with") return `Yanl\u{131}\u{15F} m\u{259}tn: "${_issue.suffix}" il\u{259} bitm\u{259}lidir`;
                    if (_issue.format === "includes") return `Yanl\u{131}\u{15F} m\u{259}tn: "${_issue.includes}" daxil olmal\u{131}d\u{131}r`;
                    if (_issue.format === "regex") return `Yanl\u{131}\u{15F} m\u{259}tn: ${_issue.pattern} \u{15F}ablonuna uy\u{11F}un olmal\u{131}d\u{131}r`;
                    return `Yanl\u{131}\u{15F} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Yanl\u{131}\u{15F} \u{259}d\u{259}d: ${issue.divisor} il\u{259} b\xf6l\xfcn\u{259} bil\u{259}n olmal\u{131}d\u{131}r`;
            case "unrecognized_keys":
                return `Tan\u{131}nmayan a\xe7ar${issue.keys.length > 1 ? "lar" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} daxilind\u{259} yanl\u{131}\u{15F} a\xe7ar`;
            case "invalid_union":
                return "Yanl\u0131\u015F d\u0259y\u0259r";
            case "invalid_element":
                return `${issue.origin} daxilind\u{259} yanl\u{131}\u{15F} d\u{259}y\u{259}r`;
            default:
                return `Yanl\u{131}\u{15F} d\u{259}y\u{259}r`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4li75":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
function getBelarusianPlural(count, one, few, many) {
    const absCount = Math.abs(count);
    const lastDigit = absCount % 10;
    const lastTwoDigits = absCount % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return many;
    if (lastDigit === 1) return one;
    if (lastDigit >= 2 && lastDigit <= 4) return few;
    return many;
}
const error = ()=>{
    const Sizable = {
        string: {
            unit: {
                one: "\u0441\u0456\u043C\u0432\u0430\u043B",
                few: "\u0441\u0456\u043C\u0432\u0430\u043B\u044B",
                many: "\u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E"
            },
            verb: "\u043C\u0435\u0446\u044C"
        },
        array: {
            unit: {
                one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
                few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B",
                many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u045E"
            },
            verb: "\u043C\u0435\u0446\u044C"
        },
        set: {
            unit: {
                one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
                few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B",
                many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u045E"
            },
            verb: "\u043C\u0435\u0446\u044C"
        },
        file: {
            unit: {
                one: "\u0431\u0430\u0439\u0442",
                few: "\u0431\u0430\u0439\u0442\u044B",
                many: "\u0431\u0430\u0439\u0442\u0430\u045E"
            },
            verb: "\u043C\u0435\u0446\u044C"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0443\u0432\u043E\u0434",
        email: "email \u0430\u0434\u0440\u0430\u0441",
        url: "URL",
        emoji: "\u044D\u043C\u043E\u0434\u0437\u0456",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0434\u0430\u0442\u0430 \u0456 \u0447\u0430\u0441",
        date: "ISO \u0434\u0430\u0442\u0430",
        time: "ISO \u0447\u0430\u0441",
        duration: "ISO \u043F\u0440\u0430\u0446\u044F\u0433\u043B\u0430\u0441\u0446\u044C",
        ipv4: "IPv4 \u0430\u0434\u0440\u0430\u0441",
        ipv6: "IPv6 \u0430\u0434\u0440\u0430\u0441",
        cidrv4: "IPv4 \u0434\u044B\u044F\u043F\u0430\u0437\u043E\u043D",
        cidrv6: "IPv6 \u0434\u044B\u044F\u043F\u0430\u0437\u043E\u043D",
        base64: "\u0440\u0430\u0434\u043E\u043A \u0443 \u0444\u0430\u0440\u043C\u0430\u0446\u0435 base64",
        base64url: "\u0440\u0430\u0434\u043E\u043A \u0443 \u0444\u0430\u0440\u043C\u0430\u0446\u0435 base64url",
        json_string: "JSON \u0440\u0430\u0434\u043E\u043A",
        e164: "\u043D\u0443\u043C\u0430\u0440 E.164",
        jwt: "JWT",
        template_literal: "\u0443\u0432\u043E\u0434"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u043B\u0456\u043A",
        array: "\u043C\u0430\u0441\u0456\u045E"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{45E}\u{432}\u{43E}\u{434}: \u{447}\u{430}\u{43A}\u{430}\u{45E}\u{441}\u{44F} instanceof ${issue.expected}, \u{430}\u{442}\u{440}\u{44B}\u{43C}\u{430}\u{43D}\u{430} ${received}`;
                    return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{45E}\u{432}\u{43E}\u{434}: \u{447}\u{430}\u{43A}\u{430}\u{45E}\u{441}\u{44F} ${expected}, \u{430}\u{442}\u{440}\u{44B}\u{43C}\u{430}\u{43D}\u{430} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{45E}\u{432}\u{43E}\u{434}: \u{447}\u{430}\u{43A}\u{430}\u{43B}\u{430}\u{441}\u{44F} ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{432}\u{430}\u{440}\u{44B}\u{44F}\u{43D}\u{442}: \u{447}\u{430}\u{43A}\u{430}\u{45E}\u{441}\u{44F} \u{430}\u{434}\u{437}\u{456}\u{43D} \u{437} ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const maxValue = Number(issue.maximum);
                        const unit = getBelarusianPlural(maxValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
                        return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{430} \u{432}\u{44F}\u{43B}\u{456}\u{43A}\u{456}: \u{447}\u{430}\u{43A}\u{430}\u{43B}\u{430}\u{441}\u{44F}, \u{448}\u{442}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435"} \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{43D}\u{430} ${sizing.verb} ${adj}${issue.maximum.toString()} ${unit}`;
                    }
                    return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{430} \u{432}\u{44F}\u{43B}\u{456}\u{43A}\u{456}: \u{447}\u{430}\u{43A}\u{430}\u{43B}\u{430}\u{441}\u{44F}, \u{448}\u{442}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435"} \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{43D}\u{430} \u{431}\u{44B}\u{446}\u{44C} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const minValue = Number(issue.minimum);
                        const unit = getBelarusianPlural(minValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
                        return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{430} \u{43C}\u{430}\u{43B}\u{44B}: \u{447}\u{430}\u{43A}\u{430}\u{43B}\u{430}\u{441}\u{44F}, \u{448}\u{442}\u{43E} ${issue.origin} \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{43D}\u{430} ${sizing.verb} ${adj}${issue.minimum.toString()} ${unit}`;
                    }
                    return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{430} \u{43C}\u{430}\u{43B}\u{44B}: \u{447}\u{430}\u{43A}\u{430}\u{43B}\u{430}\u{441}\u{44F}, \u{448}\u{442}\u{43E} ${issue.origin} \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{43D}\u{430} \u{431}\u{44B}\u{446}\u{44C} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{440}\u{430}\u{434}\u{43E}\u{43A}: \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{435}\u{43D} \u{43F}\u{430}\u{447}\u{44B}\u{43D}\u{430}\u{446}\u{446}\u{430} \u{437} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{440}\u{430}\u{434}\u{43E}\u{43A}: \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{435}\u{43D} \u{437}\u{430}\u{43A}\u{430}\u{43D}\u{447}\u{432}\u{430}\u{446}\u{446}\u{430} \u{43D}\u{430} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{440}\u{430}\u{434}\u{43E}\u{43A}: \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{435}\u{43D} \u{437}\u{43C}\u{44F}\u{448}\u{447}\u{430}\u{446}\u{44C} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{440}\u{430}\u{434}\u{43E}\u{43A}: \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{435}\u{43D} \u{430}\u{434}\u{43F}\u{430}\u{432}\u{44F}\u{434}\u{430}\u{446}\u{44C} \u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D}\u{443} ${_issue.pattern}`;
                    return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{43B}\u{456}\u{43A}: \u{43F}\u{430}\u{432}\u{456}\u{43D}\u{435}\u{43D} \u{431}\u{44B}\u{446}\u{44C} \u{43A}\u{440}\u{430}\u{442}\u{43D}\u{44B}\u{43C} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{41D}\u{435}\u{440}\u{430}\u{441}\u{43F}\u{430}\u{437}\u{43D}\u{430}\u{43D}\u{44B} ${issue.keys.length > 1 ? "\u043A\u043B\u044E\u0447\u044B" : "\u043A\u043B\u044E\u0447"}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{43A}\u{43B}\u{44E}\u{447} \u{443} ${issue.origin}`;
            case "invalid_union":
                return "\u041D\u044F\u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u044B \u045E\u0432\u043E\u0434";
            case "invalid_element":
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{430}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{44D}\u{43D}\u{43D}\u{435} \u{45E} ${issue.origin}`;
            default:
                return `\u{41D}\u{44F}\u{43F}\u{440}\u{430}\u{432}\u{456}\u{43B}\u{44C}\u{43D}\u{44B} \u{45E}\u{432}\u{43E}\u{434}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6QkG5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\u0441\u0438\u043C\u0432\u043E\u043B\u0430",
            verb: "\u0434\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430"
        },
        file: {
            unit: "\u0431\u0430\u0439\u0442\u0430",
            verb: "\u0434\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430"
        },
        array: {
            unit: "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430",
            verb: "\u0434\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430"
        },
        set: {
            unit: "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430",
            verb: "\u0434\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0432\u0445\u043E\u0434",
        email: "\u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441",
        url: "URL",
        emoji: "\u0435\u043C\u043E\u0434\u0436\u0438",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0432\u0440\u0435\u043C\u0435",
        date: "ISO \u0434\u0430\u0442\u0430",
        time: "ISO \u0432\u0440\u0435\u043C\u0435",
        duration: "ISO \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u043E\u0441\u0442",
        ipv4: "IPv4 \u0430\u0434\u0440\u0435\u0441",
        ipv6: "IPv6 \u0430\u0434\u0440\u0435\u0441",
        cidrv4: "IPv4 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
        cidrv6: "IPv6 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
        base64: "base64-\u043A\u043E\u0434\u0438\u0440\u0430\u043D \u043D\u0438\u0437",
        base64url: "base64url-\u043A\u043E\u0434\u0438\u0440\u0430\u043D \u043D\u0438\u0437",
        json_string: "JSON \u043D\u0438\u0437",
        e164: "E.164 \u043D\u043E\u043C\u0435\u0440",
        jwt: "JWT",
        template_literal: "\u0432\u0445\u043E\u0434"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0447\u0438\u0441\u043B\u043E",
        array: "\u043C\u0430\u0441\u0438\u0432"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{432}\u{445}\u{43E}\u{434}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430}\u{43D} instanceof ${issue.expected}, \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D} ${received}`;
                    return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{432}\u{445}\u{43E}\u{434}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430}\u{43D} ${expected}, \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{432}\u{445}\u{43E}\u{434}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430}\u{43D} ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{43D}\u{430} \u{43E}\u{43F}\u{446}\u{438}\u{44F}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430}\u{43D}\u{43E} \u{435}\u{434}\u{43D}\u{43E} \u{43E}\u{442} ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{422}\u{432}\u{44A}\u{440}\u{434}\u{435} \u{433}\u{43E}\u{43B}\u{44F}\u{43C}\u{43E}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430} \u{441}\u{435} ${issue.origin ?? "\u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442"} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430"}`;
                    return `\u{422}\u{432}\u{44A}\u{440}\u{434}\u{435} \u{433}\u{43E}\u{43B}\u{44F}\u{43C}\u{43E}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430} \u{441}\u{435} ${issue.origin ?? "\u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442"} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{422}\u{432}\u{44A}\u{440}\u{434}\u{435} \u{43C}\u{430}\u{43B}\u{43A}\u{43E}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430} \u{441}\u{435} ${issue.origin} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{422}\u{432}\u{44A}\u{440}\u{434}\u{435} \u{43C}\u{430}\u{43B}\u{43A}\u{43E}: \u{43E}\u{447}\u{430}\u{43A}\u{432}\u{430} \u{441}\u{435} ${issue.origin} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{43D}\u{438}\u{437}: \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{432}\u{430} \u{441} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{43D}\u{438}\u{437}: \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{437}\u{430}\u{432}\u{44A}\u{440}\u{448}\u{432}\u{430} \u{441} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{43D}\u{438}\u{437}: \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{432}\u{43A}\u{43B}\u{44E}\u{447}\u{432}\u{430} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{43D}\u{438}\u{437}: \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{441}\u{44A}\u{432}\u{43F}\u{430}\u{434}\u{430} \u{441} ${_issue.pattern}`;
                    let invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u0435\u043D";
                    if (_issue.format === "emoji") invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u043E";
                    if (_issue.format === "datetime") invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u043E";
                    if (_issue.format === "date") invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u0430";
                    if (_issue.format === "time") invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u043E";
                    if (_issue.format === "duration") invalid_adj = "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u0430";
                    return `${invalid_adj} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{43D}\u{43E} \u{447}\u{438}\u{441}\u{43B}\u{43E}: \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{43A}\u{440}\u{430}\u{442}\u{43D}\u{43E} \u{43D}\u{430} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{41D}\u{435}\u{440}\u{430}\u{437}\u{43F}\u{43E}\u{437}\u{43D}\u{430}\u{442}${issue.keys.length > 1 ? "\u0438" : ""} \u{43A}\u{43B}\u{44E}\u{447}${issue.keys.length > 1 ? "\u043E\u0432\u0435" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{43A}\u{43B}\u{44E}\u{447} \u{432} ${issue.origin}`;
            case "invalid_union":
                return "\u041D\u0435\u0432\u0430\u043B\u0438\u0434\u0435\u043D \u0432\u0445\u043E\u0434";
            case "invalid_element":
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{43D}\u{430} \u{441}\u{442}\u{43E}\u{439}\u{43D}\u{43E}\u{441}\u{442} \u{432} ${issue.origin}`;
            default:
                return `\u{41D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} \u{432}\u{445}\u{43E}\u{434}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gELrS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "car\xe0cters",
            verb: "contenir"
        },
        file: {
            unit: "bytes",
            verb: "contenir"
        },
        array: {
            unit: "elements",
            verb: "contenir"
        },
        set: {
            unit: "elements",
            verb: "contenir"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "entrada",
        email: "adre\xe7a electr\xf2nica",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data i hora ISO",
        date: "data ISO",
        time: "hora ISO",
        duration: "durada ISO",
        ipv4: "adre\xe7a IPv4",
        ipv6: "adre\xe7a IPv6",
        cidrv4: "rang IPv4",
        cidrv6: "rang IPv6",
        base64: "cadena codificada en base64",
        base64url: "cadena codificada en base64url",
        json_string: "cadena JSON",
        e164: "n\xfamero E.164",
        jwt: "JWT",
        template_literal: "entrada"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Tipus inv\xe0lid: s'esperava instanceof ${issue.expected}, s'ha rebut ${received}`;
                    return `Tipus inv\xe0lid: s'esperava ${expected}, s'ha rebut ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Valor inv\xe0lid: s'esperava ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Opci\xf3 inv\xe0lida: s'esperava una de ${_utilJs.joinValues(issue.values, " o ")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "com a m\xe0xim" : "menys de";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Massa gran: s'esperava que ${issue.origin ?? "el valor"} contingu\xe9s ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "elements"}`;
                    return `Massa gran: s'esperava que ${issue.origin ?? "el valor"} fos ${adj} ${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? "com a m\xednim" : "m\xe9s de";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Massa petit: s'esperava que ${issue.origin} contingu\xe9s ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
                    return `Massa petit: s'esperava que ${issue.origin} fos ${adj} ${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Format inv\xe0lid: ha de comen\xe7ar amb "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Format inv\xe0lid: ha d'acabar amb "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Format inv\xe0lid: ha d'incloure "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Format inv\xe0lid: ha de coincidir amb el patr\xf3 ${_issue.pattern}`;
                    return `Format inv\xe0lid per a ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `N\xfamero inv\xe0lid: ha de ser m\xfaltiple de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Clau${issue.keys.length > 1 ? "s" : ""} no reconeguda${issue.keys.length > 1 ? "s" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Clau inv\xe0lida a ${issue.origin}`;
            case "invalid_union":
                return "Entrada inv\xe0lida"; // Could also be "Tipus d'unió invàlid" but "Entrada invàlida" is more general
            case "invalid_element":
                return `Element inv\xe0lid a ${issue.origin}`;
            default:
                return `Entrada inv\xe0lida`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"FOmjK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "znak\u016F",
            verb: "m\xedt"
        },
        file: {
            unit: "bajt\u016F",
            verb: "m\xedt"
        },
        array: {
            unit: "prvk\u016F",
            verb: "m\xedt"
        },
        set: {
            unit: "prvk\u016F",
            verb: "m\xedt"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "regul\xe1rn\xed v\xfdraz",
        email: "e-mailov\xe1 adresa",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "datum a \u010Das ve form\xe1tu ISO",
        date: "datum ve form\xe1tu ISO",
        time: "\u010Das ve form\xe1tu ISO",
        duration: "doba trv\xe1n\xed ISO",
        ipv4: "IPv4 adresa",
        ipv6: "IPv6 adresa",
        cidrv4: "rozsah IPv4",
        cidrv6: "rozsah IPv6",
        base64: "\u0159et\u011Bzec zak\xf3dovan\xfd ve form\xe1tu base64",
        base64url: "\u0159et\u011Bzec zak\xf3dovan\xfd ve form\xe1tu base64url",
        json_string: "\u0159et\u011Bzec ve form\xe1tu JSON",
        e164: "\u010D\xedslo E.164",
        jwt: "JWT",
        template_literal: "vstup"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u010D\xedslo",
        string: "\u0159et\u011Bzec",
        function: "funkce",
        array: "pole"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Neplatn\xfd vstup: o\u{10D}ek\xe1v\xe1no instanceof ${issue.expected}, obdr\u{17E}eno ${received}`;
                    return `Neplatn\xfd vstup: o\u{10D}ek\xe1v\xe1no ${expected}, obdr\u{17E}eno ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Neplatn\xfd vstup: o\u{10D}ek\xe1v\xe1no ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Neplatn\xe1 mo\u{17E}nost: o\u{10D}ek\xe1v\xe1na jedna z hodnot ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Hodnota je p\u{159}\xedli\u{161} velk\xe1: ${issue.origin ?? "hodnota"} mus\xed m\xedt ${adj}${issue.maximum.toString()} ${sizing.unit ?? "prvk\u016F"}`;
                    return `Hodnota je p\u{159}\xedli\u{161} velk\xe1: ${issue.origin ?? "hodnota"} mus\xed b\xfdt ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Hodnota je p\u{159}\xedli\u{161} mal\xe1: ${issue.origin ?? "hodnota"} mus\xed m\xedt ${adj}${issue.minimum.toString()} ${sizing.unit ?? "prvk\u016F"}`;
                    return `Hodnota je p\u{159}\xedli\u{161} mal\xe1: ${issue.origin ?? "hodnota"} mus\xed b\xfdt ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Neplatn\xfd \u{159}et\u{11B}zec: mus\xed za\u{10D}\xednat na "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Neplatn\xfd \u{159}et\u{11B}zec: mus\xed kon\u{10D}it na "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Neplatn\xfd \u{159}et\u{11B}zec: mus\xed obsahovat "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Neplatn\xfd \u{159}et\u{11B}zec: mus\xed odpov\xeddat vzoru ${_issue.pattern}`;
                    return `Neplatn\xfd form\xe1t ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Neplatn\xe9 \u{10D}\xedslo: mus\xed b\xfdt n\xe1sobkem ${issue.divisor}`;
            case "unrecognized_keys":
                return `Nezn\xe1m\xe9 kl\xed\u{10D}e: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Neplatn\xfd kl\xed\u{10D} v ${issue.origin}`;
            case "invalid_union":
                return "Neplatn\xfd vstup";
            case "invalid_element":
                return `Neplatn\xe1 hodnota v ${issue.origin}`;
            default:
                return `Neplatn\xfd vstup`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8529x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "tegn",
            verb: "havde"
        },
        file: {
            unit: "bytes",
            verb: "havde"
        },
        array: {
            unit: "elementer",
            verb: "indeholdt"
        },
        set: {
            unit: "elementer",
            verb: "indeholdt"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "e-mailadresse",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dato- og klokkesl\xe6t",
        date: "ISO-dato",
        time: "ISO-klokkesl\xe6t",
        duration: "ISO-varighed",
        ipv4: "IPv4-omr\xe5de",
        ipv6: "IPv6-omr\xe5de",
        cidrv4: "IPv4-spektrum",
        cidrv6: "IPv6-spektrum",
        base64: "base64-kodet streng",
        base64url: "base64url-kodet streng",
        json_string: "JSON-streng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "input"
    };
    const TypeDictionary = {
        nan: "NaN",
        string: "streng",
        number: "tal",
        boolean: "boolean",
        array: "liste",
        object: "objekt",
        set: "s\xe6t",
        file: "fil"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Ugyldigt input: forventede instanceof ${issue.expected}, fik ${received}`;
                    return `Ugyldigt input: forventede ${expected}, fik ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Ugyldig v\xe6rdi: forventede ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Ugyldigt valg: forventede en af f\xf8lgende ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    const origin = TypeDictionary[issue.origin] ?? issue.origin;
                    if (sizing) return `For stor: forventede ${origin ?? "value"} ${sizing.verb} ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "elementer"}`;
                    return `For stor: forventede ${origin ?? "value"} havde ${adj} ${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    const origin = TypeDictionary[issue.origin] ?? issue.origin;
                    if (sizing) return `For lille: forventede ${origin} ${sizing.verb} ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
                    return `For lille: forventede ${origin} havde ${adj} ${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ugyldig streng: skal starte med "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Ugyldig streng: skal ende med "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Ugyldig streng: skal indeholde "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Ugyldig streng: skal matche m\xf8nsteret ${_issue.pattern}`;
                    return `Ugyldig ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ugyldigt tal: skal v\xe6re deleligt med ${issue.divisor}`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "Ukendte n\xf8gler" : "Ukendt n\xf8gle"}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Ugyldig n\xf8gle i ${issue.origin}`;
            case "invalid_union":
                return "Ugyldigt input: matcher ingen af de tilladte typer";
            case "invalid_element":
                return `Ugyldig v\xe6rdi i ${issue.origin}`;
            default:
                return `Ugyldigt input`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cXZD1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "Zeichen",
            verb: "zu haben"
        },
        file: {
            unit: "Bytes",
            verb: "zu haben"
        },
        array: {
            unit: "Elemente",
            verb: "zu haben"
        },
        set: {
            unit: "Elemente",
            verb: "zu haben"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "Eingabe",
        email: "E-Mail-Adresse",
        url: "URL",
        emoji: "Emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-Datum und -Uhrzeit",
        date: "ISO-Datum",
        time: "ISO-Uhrzeit",
        duration: "ISO-Dauer",
        ipv4: "IPv4-Adresse",
        ipv6: "IPv6-Adresse",
        cidrv4: "IPv4-Bereich",
        cidrv6: "IPv6-Bereich",
        base64: "Base64-codierter String",
        base64url: "Base64-URL-codierter String",
        json_string: "JSON-String",
        e164: "E.164-Nummer",
        jwt: "JWT",
        template_literal: "Eingabe"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "Zahl",
        array: "Array"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Ung\xfcltige Eingabe: erwartet instanceof ${issue.expected}, erhalten ${received}`;
                    return `Ung\xfcltige Eingabe: erwartet ${expected}, erhalten ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Ung\xfcltige Eingabe: erwartet ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Ung\xfcltige Option: erwartet eine von ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Zu gro\xdf: erwartet, dass ${issue.origin ?? "Wert"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "Elemente"} hat`;
                    return `Zu gro\xdf: erwartet, dass ${issue.origin ?? "Wert"} ${adj}${issue.maximum.toString()} ist`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Zu klein: erwartet, dass ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} hat`;
                    return `Zu klein: erwartet, dass ${issue.origin} ${adj}${issue.minimum.toString()} ist`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ung\xfcltiger String: muss mit "${_issue.prefix}" beginnen`;
                    if (_issue.format === "ends_with") return `Ung\xfcltiger String: muss mit "${_issue.suffix}" enden`;
                    if (_issue.format === "includes") return `Ung\xfcltiger String: muss "${_issue.includes}" enthalten`;
                    if (_issue.format === "regex") return `Ung\xfcltiger String: muss dem Muster ${_issue.pattern} entsprechen`;
                    return `Ung\xfcltig: ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ung\xfcltige Zahl: muss ein Vielfaches von ${issue.divisor} sein`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "Unbekannte Schl\xfcssel" : "Unbekannter Schl\xfcssel"}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Ung\xfcltiger Schl\xfcssel in ${issue.origin}`;
            case "invalid_union":
                return "Ung\xfcltige Eingabe";
            case "invalid_element":
                return `Ung\xfcltiger Wert in ${issue.origin}`;
            default:
                return `Ung\xfcltige Eingabe`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"giZBF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "characters",
            verb: "to have"
        },
        file: {
            unit: "bytes",
            verb: "to have"
        },
        array: {
            unit: "items",
            verb: "to have"
        },
        set: {
            unit: "items",
            verb: "to have"
        },
        map: {
            unit: "entries",
            verb: "to have"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        mac: "MAC address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        jwt: "JWT",
        template_literal: "input"
    };
    // type names: missing keys = do not translate (use raw value via ?? fallback)
    const TypeDictionary = {
        // Compatibility: "nan" -> "NaN" for display
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    return `Invalid input: expected ${expected}, received ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Invalid input: expected ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Invalid option: expected one of ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Too big: expected ${issue.origin ?? "value"} to have ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elements"}`;
                    return `Too big: expected ${issue.origin ?? "value"} to be ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Too small: expected ${issue.origin} to have ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Too small: expected ${issue.origin} to be ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Invalid string: must start with "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Invalid string: must end with "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Invalid string: must include "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Invalid string: must match pattern ${_issue.pattern}`;
                    return `Invalid ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Invalid number: must be a multiple of ${issue.divisor}`;
            case "unrecognized_keys":
                return `Unrecognized key${issue.keys.length > 1 ? "s" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Invalid key in ${issue.origin}`;
            case "invalid_union":
                return "Invalid input";
            case "invalid_element":
                return `Invalid value in ${issue.origin}`;
            default:
                return `Invalid input`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bzEho":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "karaktrojn",
            verb: "havi"
        },
        file: {
            unit: "bajtojn",
            verb: "havi"
        },
        array: {
            unit: "elementojn",
            verb: "havi"
        },
        set: {
            unit: "elementojn",
            verb: "havi"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "enigo",
        email: "retadreso",
        url: "URL",
        emoji: "emo\u011Dio",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-datotempo",
        date: "ISO-dato",
        time: "ISO-tempo",
        duration: "ISO-da\u016Dro",
        ipv4: "IPv4-adreso",
        ipv6: "IPv6-adreso",
        cidrv4: "IPv4-rango",
        cidrv6: "IPv6-rango",
        base64: "64-ume kodita karaktraro",
        base64url: "URL-64-ume kodita karaktraro",
        json_string: "JSON-karaktraro",
        e164: "E.164-nombro",
        jwt: "JWT",
        template_literal: "enigo"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "nombro",
        array: "tabelo",
        null: "senvalora"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Nevalida enigo: atendi\u{11D}is instanceof ${issue.expected}, ricevi\u{11D}is ${received}`;
                    return `Nevalida enigo: atendi\u{11D}is ${expected}, ricevi\u{11D}is ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Nevalida enigo: atendi\u{11D}is ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Nevalida opcio: atendi\u{11D}is unu el ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Tro granda: atendi\u{11D}is ke ${issue.origin ?? "valoro"} havu ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementojn"}`;
                    return `Tro granda: atendi\u{11D}is ke ${issue.origin ?? "valoro"} havu ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Tro malgranda: atendi\u{11D}is ke ${issue.origin} havu ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Tro malgranda: atendi\u{11D}is ke ${issue.origin} estu ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Nevalida karaktraro: devas komenci\u{11D}i per "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Nevalida karaktraro: devas fini\u{11D}i per "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Nevalida karaktraro: devas inkluzivi "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Nevalida karaktraro: devas kongrui kun la modelo ${_issue.pattern}`;
                    return `Nevalida ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Nevalida nombro: devas esti oblo de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Nekonata${issue.keys.length > 1 ? "j" : ""} \u{15D}losilo${issue.keys.length > 1 ? "j" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Nevalida \u{15D}losilo en ${issue.origin}`;
            case "invalid_union":
                return "Nevalida enigo";
            case "invalid_element":
                return `Nevalida valoro en ${issue.origin}`;
            default:
                return `Nevalida enigo`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ij7l2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "caracteres",
            verb: "tener"
        },
        file: {
            unit: "bytes",
            verb: "tener"
        },
        array: {
            unit: "elementos",
            verb: "tener"
        },
        set: {
            unit: "elementos",
            verb: "tener"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "entrada",
        email: "direcci\xf3n de correo electr\xf3nico",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "fecha y hora ISO",
        date: "fecha ISO",
        time: "hora ISO",
        duration: "duraci\xf3n ISO",
        ipv4: "direcci\xf3n IPv4",
        ipv6: "direcci\xf3n IPv6",
        cidrv4: "rango IPv4",
        cidrv6: "rango IPv6",
        base64: "cadena codificada en base64",
        base64url: "URL codificada en base64",
        json_string: "cadena JSON",
        e164: "n\xfamero E.164",
        jwt: "JWT",
        template_literal: "entrada"
    };
    const TypeDictionary = {
        nan: "NaN",
        string: "texto",
        number: "n\xfamero",
        boolean: "booleano",
        array: "arreglo",
        object: "objeto",
        set: "conjunto",
        file: "archivo",
        date: "fecha",
        bigint: "n\xfamero grande",
        symbol: "s\xedmbolo",
        undefined: "indefinido",
        null: "nulo",
        function: "funci\xf3n",
        map: "mapa",
        record: "registro",
        tuple: "tupla",
        enum: "enumeraci\xf3n",
        union: "uni\xf3n",
        literal: "literal",
        promise: "promesa",
        void: "vac\xedo",
        never: "nunca",
        unknown: "desconocido",
        any: "cualquiera"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Entrada inv\xe1lida: se esperaba instanceof ${issue.expected}, recibido ${received}`;
                    return `Entrada inv\xe1lida: se esperaba ${expected}, recibido ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Entrada inv\xe1lida: se esperaba ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Opci\xf3n inv\xe1lida: se esperaba una de ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    const origin = TypeDictionary[issue.origin] ?? issue.origin;
                    if (sizing) return `Demasiado grande: se esperaba que ${origin ?? "valor"} tuviera ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementos"}`;
                    return `Demasiado grande: se esperaba que ${origin ?? "valor"} fuera ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    const origin = TypeDictionary[issue.origin] ?? issue.origin;
                    if (sizing) return `Demasiado peque\xf1o: se esperaba que ${origin} tuviera ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Demasiado peque\xf1o: se esperaba que ${origin} fuera ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Cadena inv\xe1lida: debe comenzar con "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Cadena inv\xe1lida: debe terminar en "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Cadena inv\xe1lida: debe incluir "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Cadena inv\xe1lida: debe coincidir con el patr\xf3n ${_issue.pattern}`;
                    return `Inv\xe1lido ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `N\xfamero inv\xe1lido: debe ser m\xfaltiplo de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Llave${issue.keys.length > 1 ? "s" : ""} desconocida${issue.keys.length > 1 ? "s" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Llave inv\xe1lida en ${TypeDictionary[issue.origin] ?? issue.origin}`;
            case "invalid_union":
                return "Entrada inv\xe1lida";
            case "invalid_element":
                return `Valor inv\xe1lido en ${TypeDictionary[issue.origin] ?? issue.origin}`;
            default:
                return `Entrada inv\xe1lida`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kfYXb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\u06A9\u0627\u0631\u0627\u06A9\u062A\u0631",
            verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F"
        },
        file: {
            unit: "\u0628\u0627\u06CC\u062A",
            verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F"
        },
        array: {
            unit: "\u0622\u06CC\u062A\u0645",
            verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F"
        },
        set: {
            unit: "\u0622\u06CC\u062A\u0645",
            verb: "\u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0648\u0631\u0648\u062F\u06CC",
        email: "\u0622\u062F\u0631\u0633 \u0627\u06CC\u0645\u06CC\u0644",
        url: "URL",
        emoji: "\u0627\u06CC\u0645\u0648\u062C\u06CC",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u062A\u0627\u0631\u06CC\u062E \u0648 \u0632\u0645\u0627\u0646 \u0627\u06CC\u0632\u0648",
        date: "\u062A\u0627\u0631\u06CC\u062E \u0627\u06CC\u0632\u0648",
        time: "\u0632\u0645\u0627\u0646 \u0627\u06CC\u0632\u0648",
        duration: "\u0645\u062F\u062A \u0632\u0645\u0627\u0646 \u0627\u06CC\u0632\u0648",
        ipv4: "IPv4 \u0622\u062F\u0631\u0633",
        ipv6: "IPv6 \u0622\u062F\u0631\u0633",
        cidrv4: "IPv4 \u062F\u0627\u0645\u0646\u0647",
        cidrv6: "IPv6 \u062F\u0627\u0645\u0646\u0647",
        base64: "base64-encoded \u0631\u0634\u062A\u0647",
        base64url: "base64url-encoded \u0631\u0634\u062A\u0647",
        json_string: "JSON \u0631\u0634\u062A\u0647",
        e164: "E.164 \u0639\u062F\u062F",
        jwt: "JWT",
        template_literal: "\u0648\u0631\u0648\u062F\u06CC"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0639\u062F\u062F",
        array: "\u0622\u0631\u0627\u06CC\u0647"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{645}\u{6CC}\u{200C}\u{628}\u{627}\u{6CC}\u{633}\u{62A} instanceof ${issue.expected} \u{645}\u{6CC}\u{200C}\u{628}\u{648}\u{62F}\u{60C} ${received} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{634}\u{62F}`;
                    return `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{645}\u{6CC}\u{200C}\u{628}\u{627}\u{6CC}\u{633}\u{62A} ${expected} \u{645}\u{6CC}\u{200C}\u{628}\u{648}\u{62F}\u{60C} ${received} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A} \u{634}\u{62F}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{645}\u{6CC}\u{200C}\u{628}\u{627}\u{6CC}\u{633}\u{62A} ${_utilJs.stringifyPrimitive(issue.values[0])} \u{645}\u{6CC}\u{200C}\u{628}\u{648}\u{62F}`;
                return `\u{6AF}\u{632}\u{6CC}\u{646}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{645}\u{6CC}\u{200C}\u{628}\u{627}\u{6CC}\u{633}\u{62A} \u{6CC}\u{6A9}\u{6CC} \u{627}\u{632} ${_utilJs.joinValues(issue.values, "|")} \u{645}\u{6CC}\u{200C}\u{628}\u{648}\u{62F}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{62E}\u{6CC}\u{644}\u{6CC} \u{628}\u{632}\u{631}\u{6AF}: ${issue.origin ?? "\u0645\u0642\u062F\u0627\u0631"} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0635\u0631"} \u{628}\u{627}\u{634}\u{62F}`;
                    return `\u{62E}\u{6CC}\u{644}\u{6CC} \u{628}\u{632}\u{631}\u{6AF}: ${issue.origin ?? "\u0645\u0642\u062F\u0627\u0631"} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.maximum.toString()} \u{628}\u{627}\u{634}\u{62F}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{62E}\u{6CC}\u{644}\u{6CC} \u{6A9}\u{648}\u{686}\u{6A9}: ${issue.origin} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.minimum.toString()} ${sizing.unit} \u{628}\u{627}\u{634}\u{62F}`;
                    return `\u{62E}\u{6CC}\u{644}\u{6CC} \u{6A9}\u{648}\u{686}\u{6A9}: ${issue.origin} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.minimum.toString()} \u{628}\u{627}\u{634}\u{62F}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{631}\u{634}\u{62A}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{627} "${_issue.prefix}" \u{634}\u{631}\u{648}\u{639} \u{634}\u{648}\u{62F}`;
                    if (_issue.format === "ends_with") return `\u{631}\u{634}\u{62A}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{627} "${_issue.suffix}" \u{62A}\u{645}\u{627}\u{645} \u{634}\u{648}\u{62F}`;
                    if (_issue.format === "includes") return `\u{631}\u{634}\u{62A}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{628}\u{627}\u{6CC}\u{62F} \u{634}\u{627}\u{645}\u{644} "${_issue.includes}" \u{628}\u{627}\u{634}\u{62F}`;
                    if (_issue.format === "regex") return `\u{631}\u{634}\u{62A}\u{647} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{627} \u{627}\u{644}\u{6AF}\u{648}\u{6CC} ${_issue.pattern} \u{645}\u{637}\u{627}\u{628}\u{642}\u{62A} \u{62F}\u{627}\u{634}\u{62A}\u{647} \u{628}\u{627}\u{634}\u{62F}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}`;
                }
            case "not_multiple_of":
                return `\u{639}\u{62F}\u{62F} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}: \u{628}\u{627}\u{6CC}\u{62F} \u{645}\u{636}\u{631}\u{628} ${issue.divisor} \u{628}\u{627}\u{634}\u{62F}`;
            case "unrecognized_keys":
                return `\u{6A9}\u{644}\u{6CC}\u{62F}${issue.keys.length > 1 ? "\u0647\u0627\u06CC" : ""} \u{646}\u{627}\u{634}\u{646}\u{627}\u{633}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{6A9}\u{644}\u{6CC}\u{62F} \u{646}\u{627}\u{634}\u{646}\u{627}\u{633} \u{62F}\u{631} ${issue.origin}`;
            case "invalid_union":
                return `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}`;
            case "invalid_element":
                return `\u{645}\u{642}\u{62F}\u{627}\u{631} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631} \u{62F}\u{631} ${issue.origin}`;
            default:
                return `\u{648}\u{631}\u{648}\u{62F}\u{6CC} \u{646}\u{627}\u{645}\u{639}\u{62A}\u{628}\u{631}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jj3V4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "merkki\xe4",
            subject: "merkkijonon"
        },
        file: {
            unit: "tavua",
            subject: "tiedoston"
        },
        array: {
            unit: "alkiota",
            subject: "listan"
        },
        set: {
            unit: "alkiota",
            subject: "joukon"
        },
        number: {
            unit: "",
            subject: "luvun"
        },
        bigint: {
            unit: "",
            subject: "suuren kokonaisluvun"
        },
        int: {
            unit: "",
            subject: "kokonaisluvun"
        },
        date: {
            unit: "",
            subject: "p\xe4iv\xe4m\xe4\xe4r\xe4n"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "s\xe4\xe4nn\xf6llinen lauseke",
        email: "s\xe4hk\xf6postiosoite",
        url: "URL-osoite",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-aikaleima",
        date: "ISO-p\xe4iv\xe4m\xe4\xe4r\xe4",
        time: "ISO-aika",
        duration: "ISO-kesto",
        ipv4: "IPv4-osoite",
        ipv6: "IPv6-osoite",
        cidrv4: "IPv4-alue",
        cidrv6: "IPv6-alue",
        base64: "base64-koodattu merkkijono",
        base64url: "base64url-koodattu merkkijono",
        json_string: "JSON-merkkijono",
        e164: "E.164-luku",
        jwt: "JWT",
        template_literal: "templaattimerkkijono"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Virheellinen tyyppi: odotettiin instanceof ${issue.expected}, oli ${received}`;
                    return `Virheellinen tyyppi: odotettiin ${expected}, oli ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Virheellinen sy\xf6te: t\xe4ytyy olla ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Virheellinen valinta: t\xe4ytyy olla yksi seuraavista: ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Liian suuri: ${sizing.subject} t\xe4ytyy olla ${adj}${issue.maximum.toString()} ${sizing.unit}`.trim();
                    return `Liian suuri: arvon t\xe4ytyy olla ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Liian pieni: ${sizing.subject} t\xe4ytyy olla ${adj}${issue.minimum.toString()} ${sizing.unit}`.trim();
                    return `Liian pieni: arvon t\xe4ytyy olla ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Virheellinen sy\xf6te: t\xe4ytyy alkaa "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Virheellinen sy\xf6te: t\xe4ytyy loppua "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Virheellinen sy\xf6te: t\xe4ytyy sis\xe4lt\xe4\xe4 "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Virheellinen sy\xf6te: t\xe4ytyy vastata s\xe4\xe4nn\xf6llist\xe4 lauseketta ${_issue.pattern}`;
                    return `Virheellinen ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Virheellinen luku: t\xe4ytyy olla luvun ${issue.divisor} monikerta`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "Tuntemattomat avaimet" : "Tuntematon avain"}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return "Virheellinen avain tietueessa";
            case "invalid_union":
                return "Virheellinen unioni";
            case "invalid_element":
                return "Virheellinen arvo joukossa";
            default:
                return `Virheellinen sy\xf6te`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kS4Ek":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "caract\xe8res",
            verb: "avoir"
        },
        file: {
            unit: "octets",
            verb: "avoir"
        },
        array: {
            unit: "\xe9l\xe9ments",
            verb: "avoir"
        },
        set: {
            unit: "\xe9l\xe9ments",
            verb: "avoir"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "entr\xe9e",
        email: "adresse e-mail",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "date et heure ISO",
        date: "date ISO",
        time: "heure ISO",
        duration: "dur\xe9e ISO",
        ipv4: "adresse IPv4",
        ipv6: "adresse IPv6",
        cidrv4: "plage IPv4",
        cidrv6: "plage IPv6",
        base64: "cha\xeene encod\xe9e en base64",
        base64url: "cha\xeene encod\xe9e en base64url",
        json_string: "cha\xeene JSON",
        e164: "num\xe9ro E.164",
        jwt: "JWT",
        template_literal: "entr\xe9e"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "nombre",
        array: "tableau"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Entr\xe9e invalide : instanceof ${issue.expected} attendu, ${received} re\xe7u`;
                    return `Entr\xe9e invalide : ${expected} attendu, ${received} re\xe7u`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Entr\xe9e invalide : ${_utilJs.stringifyPrimitive(issue.values[0])} attendu`;
                return `Option invalide : une valeur parmi ${_utilJs.joinValues(issue.values, "|")} attendue`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Trop grand : ${issue.origin ?? "valeur"} doit ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\xe9l\xe9ment(s)"}`;
                    return `Trop grand : ${issue.origin ?? "valeur"} doit \xeatre ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Trop petit : ${issue.origin} doit ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Trop petit : ${issue.origin} doit \xeatre ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Cha\xeene invalide : doit commencer par "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Cha\xeene invalide : doit se terminer par "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Cha\xeene invalide : doit inclure "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Cha\xeene invalide : doit correspondre au mod\xe8le ${_issue.pattern}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} invalide`;
                }
            case "not_multiple_of":
                return `Nombre invalide : doit \xeatre un multiple de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Cl\xe9${issue.keys.length > 1 ? "s" : ""} non reconnue${issue.keys.length > 1 ? "s" : ""} : ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Cl\xe9 invalide dans ${issue.origin}`;
            case "invalid_union":
                return "Entr\xe9e invalide";
            case "invalid_element":
                return `Valeur invalide dans ${issue.origin}`;
            default:
                return `Entr\xe9e invalide`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ddbx4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "caract\xe8res",
            verb: "avoir"
        },
        file: {
            unit: "octets",
            verb: "avoir"
        },
        array: {
            unit: "\xe9l\xe9ments",
            verb: "avoir"
        },
        set: {
            unit: "\xe9l\xe9ments",
            verb: "avoir"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "entr\xe9e",
        email: "adresse courriel",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "date-heure ISO",
        date: "date ISO",
        time: "heure ISO",
        duration: "dur\xe9e ISO",
        ipv4: "adresse IPv4",
        ipv6: "adresse IPv6",
        cidrv4: "plage IPv4",
        cidrv6: "plage IPv6",
        base64: "cha\xeene encod\xe9e en base64",
        base64url: "cha\xeene encod\xe9e en base64url",
        json_string: "cha\xeene JSON",
        e164: "num\xe9ro E.164",
        jwt: "JWT",
        template_literal: "entr\xe9e"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Entr\xe9e invalide : attendu instanceof ${issue.expected}, re\xe7u ${received}`;
                    return `Entr\xe9e invalide : attendu ${expected}, re\xe7u ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Entr\xe9e invalide : attendu ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Option invalide : attendu l'une des valeurs suivantes ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "\u2264" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Trop grand : attendu que ${issue.origin ?? "la valeur"} ait ${adj}${issue.maximum.toString()} ${sizing.unit}`;
                    return `Trop grand : attendu que ${issue.origin ?? "la valeur"} soit ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? "\u2265" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Trop petit : attendu que ${issue.origin} ait ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Trop petit : attendu que ${issue.origin} soit ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Cha\xeene invalide : doit commencer par "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Cha\xeene invalide : doit se terminer par "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Cha\xeene invalide : doit inclure "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Cha\xeene invalide : doit correspondre au motif ${_issue.pattern}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} invalide`;
                }
            case "not_multiple_of":
                return `Nombre invalide : doit \xeatre un multiple de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Cl\xe9${issue.keys.length > 1 ? "s" : ""} non reconnue${issue.keys.length > 1 ? "s" : ""} : ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Cl\xe9 invalide dans ${issue.origin}`;
            case "invalid_union":
                return "Entr\xe9e invalide";
            case "invalid_element":
                return `Valeur invalide dans ${issue.origin}`;
            default:
                return `Entr\xe9e invalide`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7Em55":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    // Hebrew labels + grammatical gender
    const TypeNames = {
        string: {
            label: "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA",
            gender: "f"
        },
        number: {
            label: "\u05DE\u05E1\u05E4\u05E8",
            gender: "m"
        },
        boolean: {
            label: "\u05E2\u05E8\u05DA \u05D1\u05D5\u05DC\u05D9\u05D0\u05E0\u05D9",
            gender: "m"
        },
        bigint: {
            label: "BigInt",
            gender: "m"
        },
        date: {
            label: "\u05EA\u05D0\u05E8\u05D9\u05DA",
            gender: "m"
        },
        array: {
            label: "\u05DE\u05E2\u05E8\u05DA",
            gender: "m"
        },
        object: {
            label: "\u05D0\u05D5\u05D1\u05D9\u05D9\u05E7\u05D8",
            gender: "m"
        },
        null: {
            label: "\u05E2\u05E8\u05DA \u05E8\u05D9\u05E7 (null)",
            gender: "m"
        },
        undefined: {
            label: "\u05E2\u05E8\u05DA \u05DC\u05D0 \u05DE\u05D5\u05D2\u05D3\u05E8 (undefined)",
            gender: "m"
        },
        symbol: {
            label: "\u05E1\u05D9\u05DE\u05D1\u05D5\u05DC (Symbol)",
            gender: "m"
        },
        function: {
            label: "\u05E4\u05D5\u05E0\u05E7\u05E6\u05D9\u05D4",
            gender: "f"
        },
        map: {
            label: "\u05DE\u05E4\u05D4 (Map)",
            gender: "f"
        },
        set: {
            label: "\u05E7\u05D1\u05D5\u05E6\u05D4 (Set)",
            gender: "f"
        },
        file: {
            label: "\u05E7\u05D5\u05D1\u05E5",
            gender: "m"
        },
        promise: {
            label: "Promise",
            gender: "m"
        },
        NaN: {
            label: "NaN",
            gender: "m"
        },
        unknown: {
            label: "\u05E2\u05E8\u05DA \u05DC\u05D0 \u05D9\u05D3\u05D5\u05E2",
            gender: "m"
        },
        value: {
            label: "\u05E2\u05E8\u05DA",
            gender: "m"
        }
    };
    // Sizing units for size-related messages + localized origin labels
    const Sizable = {
        string: {
            unit: "\u05EA\u05D5\u05D5\u05D9\u05DD",
            shortLabel: "\u05E7\u05E6\u05E8",
            longLabel: "\u05D0\u05E8\u05D5\u05DA"
        },
        file: {
            unit: "\u05D1\u05D9\u05D9\u05D8\u05D9\u05DD",
            shortLabel: "\u05E7\u05D8\u05DF",
            longLabel: "\u05D2\u05D3\u05D5\u05DC"
        },
        array: {
            unit: "\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD",
            shortLabel: "\u05E7\u05D8\u05DF",
            longLabel: "\u05D2\u05D3\u05D5\u05DC"
        },
        set: {
            unit: "\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD",
            shortLabel: "\u05E7\u05D8\u05DF",
            longLabel: "\u05D2\u05D3\u05D5\u05DC"
        },
        number: {
            unit: "",
            shortLabel: "\u05E7\u05D8\u05DF",
            longLabel: "\u05D2\u05D3\u05D5\u05DC"
        }
    };
    // Helpers — labels, articles, and verbs
    const typeEntry = (t)=>t ? TypeNames[t] : undefined;
    const typeLabel = (t)=>{
        const e = typeEntry(t);
        if (e) return e.label;
        // fallback: show raw string if unknown
        return t ?? TypeNames.unknown.label;
    };
    const withDefinite = (t)=>`\u{5D4}${typeLabel(t)}`;
    const verbFor = (t)=>{
        const e = typeEntry(t);
        const gender = e?.gender ?? "m";
        return gender === "f" ? "\u05E6\u05E8\u05D9\u05DB\u05D4 \u05DC\u05D4\u05D9\u05D5\u05EA" : "\u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA";
    };
    const getSizing = (origin)=>{
        if (!origin) return null;
        return Sizable[origin] ?? null;
    };
    const FormatDictionary = {
        regex: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        },
        email: {
            label: "\u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
            gender: "f"
        },
        url: {
            label: "\u05DB\u05EA\u05D5\u05D1\u05EA \u05E8\u05E9\u05EA",
            gender: "f"
        },
        emoji: {
            label: "\u05D0\u05D9\u05DE\u05D5\u05D2'\u05D9",
            gender: "m"
        },
        uuid: {
            label: "UUID",
            gender: "m"
        },
        nanoid: {
            label: "nanoid",
            gender: "m"
        },
        guid: {
            label: "GUID",
            gender: "m"
        },
        cuid: {
            label: "cuid",
            gender: "m"
        },
        cuid2: {
            label: "cuid2",
            gender: "m"
        },
        ulid: {
            label: "ULID",
            gender: "m"
        },
        xid: {
            label: "XID",
            gender: "m"
        },
        ksuid: {
            label: "KSUID",
            gender: "m"
        },
        datetime: {
            label: "\u05EA\u05D0\u05E8\u05D9\u05DA \u05D5\u05D6\u05DE\u05DF ISO",
            gender: "m"
        },
        date: {
            label: "\u05EA\u05D0\u05E8\u05D9\u05DA ISO",
            gender: "m"
        },
        time: {
            label: "\u05D6\u05DE\u05DF ISO",
            gender: "m"
        },
        duration: {
            label: "\u05DE\u05E9\u05DA \u05D6\u05DE\u05DF ISO",
            gender: "m"
        },
        ipv4: {
            label: "\u05DB\u05EA\u05D5\u05D1\u05EA IPv4",
            gender: "f"
        },
        ipv6: {
            label: "\u05DB\u05EA\u05D5\u05D1\u05EA IPv6",
            gender: "f"
        },
        cidrv4: {
            label: "\u05D8\u05D5\u05D5\u05D7 IPv4",
            gender: "m"
        },
        cidrv6: {
            label: "\u05D8\u05D5\u05D5\u05D7 IPv6",
            gender: "m"
        },
        base64: {
            label: "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA \u05D1\u05D1\u05E1\u05D9\u05E1 64",
            gender: "f"
        },
        base64url: {
            label: "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA \u05D1\u05D1\u05E1\u05D9\u05E1 64 \u05DC\u05DB\u05EA\u05D5\u05D1\u05D5\u05EA \u05E8\u05E9\u05EA",
            gender: "f"
        },
        json_string: {
            label: "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA JSON",
            gender: "f"
        },
        e164: {
            label: "\u05DE\u05E1\u05E4\u05E8 E.164",
            gender: "m"
        },
        jwt: {
            label: "JWT",
            gender: "m"
        },
        ends_with: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        },
        includes: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        },
        lowercase: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        },
        starts_with: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        },
        uppercase: {
            label: "\u05E7\u05DC\u05D8",
            gender: "m"
        }
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    // Expected type: show without definite article for clearer Hebrew
                    const expectedKey = issue.expected;
                    const expected = TypeDictionary[expectedKey ?? ""] ?? typeLabel(expectedKey);
                    // Received: show localized label if known, otherwise constructor/raw
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? TypeNames[receivedType]?.label ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{5E7}\u{5DC}\u{5D8} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5E6}\u{5E8}\u{5D9}\u{5DA} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} instanceof ${issue.expected}, \u{5D4}\u{5EA}\u{5E7}\u{5D1}\u{5DC} ${received}`;
                    return `\u{5E7}\u{5DC}\u{5D8} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5E6}\u{5E8}\u{5D9}\u{5DA} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${expected}, \u{5D4}\u{5EA}\u{5E7}\u{5D1}\u{5DC} ${received}`;
                }
            case "invalid_value":
                {
                    if (issue.values.length === 1) return `\u{5E2}\u{5E8}\u{5DA} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5D4}\u{5E2}\u{5E8}\u{5DA} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                    // Join values with proper Hebrew formatting
                    const stringified = issue.values.map((v)=>_utilJs.stringifyPrimitive(v));
                    if (issue.values.length === 2) return `\u{5E2}\u{5E8}\u{5DA} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5D4}\u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D4}\u{5DE}\u{5EA}\u{5D0}\u{5D9}\u{5DE}\u{5D5}\u{5EA} \u{5D4}\u{5DF} ${stringified[0]} \u{5D0}\u{5D5} ${stringified[1]}`;
                    // For 3+ values: "a", "b" או "c"
                    const lastValue = stringified[stringified.length - 1];
                    const restValues = stringified.slice(0, -1).join(", ");
                    return `\u{5E2}\u{5E8}\u{5DA} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5D4}\u{5D0}\u{5E4}\u{5E9}\u{5E8}\u{5D5}\u{5D9}\u{5D5}\u{5EA} \u{5D4}\u{5DE}\u{5EA}\u{5D0}\u{5D9}\u{5DE}\u{5D5}\u{5EA} \u{5D4}\u{5DF} ${restValues} \u{5D0}\u{5D5} ${lastValue}`;
                }
            case "too_big":
                {
                    const sizing = getSizing(issue.origin);
                    const subject = withDefinite(issue.origin ?? "value");
                    if (issue.origin === "string") // Special handling for strings - more natural Hebrew
                    return `${sizing?.longLabel ?? "\u05D0\u05E8\u05D5\u05DA"} \u{5DE}\u{5D3}\u{5D9}: ${subject} \u{5E6}\u{5E8}\u{5D9}\u{5DB}\u{5D4} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} ${issue.maximum.toString()} ${sizing?.unit ?? ""} ${issue.inclusive ? "\u05D0\u05D5 \u05E4\u05D7\u05D5\u05EA" : "\u05DC\u05DB\u05DC \u05D4\u05D9\u05D5\u05EA\u05E8"}`.trim();
                    if (issue.origin === "number") {
                        // Natural Hebrew for numbers
                        const comparison = issue.inclusive ? `\u{5E7}\u{5D8}\u{5DF} \u{5D0}\u{5D5} \u{5E9}\u{5D5}\u{5D5}\u{5D4} \u{5DC}-${issue.maximum}` : `\u{5E7}\u{5D8}\u{5DF} \u{5DE}-${issue.maximum}`;
                        return `\u{5D2}\u{5D3}\u{5D5}\u{5DC} \u{5DE}\u{5D3}\u{5D9}: ${subject} \u{5E6}\u{5E8}\u{5D9}\u{5DA} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${comparison}`;
                    }
                    if (issue.origin === "array" || issue.origin === "set") {
                        // Natural Hebrew for arrays and sets
                        const verb = issue.origin === "set" ? "\u05E6\u05E8\u05D9\u05DB\u05D4" : "\u05E6\u05E8\u05D9\u05DA";
                        const comparison = issue.inclusive ? `${issue.maximum} ${sizing?.unit ?? ""} \u{5D0}\u{5D5} \u{5E4}\u{5D7}\u{5D5}\u{5EA}` : `\u{5E4}\u{5D7}\u{5D5}\u{5EA} \u{5DE}-${issue.maximum} ${sizing?.unit ?? ""}`;
                        return `\u{5D2}\u{5D3}\u{5D5}\u{5DC} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${verb} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} ${comparison}`.trim();
                    }
                    const adj = issue.inclusive ? "<=" : "<";
                    const be = verbFor(issue.origin ?? "value");
                    if (sizing?.unit) return `${sizing.longLabel} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${be} ${adj}${issue.maximum.toString()} ${sizing.unit}`;
                    return `${sizing?.longLabel ?? "\u05D2\u05D3\u05D5\u05DC"} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${be} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const sizing = getSizing(issue.origin);
                    const subject = withDefinite(issue.origin ?? "value");
                    if (issue.origin === "string") // Special handling for strings - more natural Hebrew
                    return `${sizing?.shortLabel ?? "\u05E7\u05E6\u05E8"} \u{5DE}\u{5D3}\u{5D9}: ${subject} \u{5E6}\u{5E8}\u{5D9}\u{5DB}\u{5D4} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} ${issue.minimum.toString()} ${sizing?.unit ?? ""} ${issue.inclusive ? "\u05D0\u05D5 \u05D9\u05D5\u05EA\u05E8" : "\u05DC\u05E4\u05D7\u05D5\u05EA"}`.trim();
                    if (issue.origin === "number") {
                        // Natural Hebrew for numbers
                        const comparison = issue.inclusive ? `\u{5D2}\u{5D3}\u{5D5}\u{5DC} \u{5D0}\u{5D5} \u{5E9}\u{5D5}\u{5D5}\u{5D4} \u{5DC}-${issue.minimum}` : `\u{5D2}\u{5D3}\u{5D5}\u{5DC} \u{5DE}-${issue.minimum}`;
                        return `\u{5E7}\u{5D8}\u{5DF} \u{5DE}\u{5D3}\u{5D9}: ${subject} \u{5E6}\u{5E8}\u{5D9}\u{5DA} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${comparison}`;
                    }
                    if (issue.origin === "array" || issue.origin === "set") {
                        // Natural Hebrew for arrays and sets
                        const verb = issue.origin === "set" ? "\u05E6\u05E8\u05D9\u05DB\u05D4" : "\u05E6\u05E8\u05D9\u05DA";
                        // Special case for singular (minimum === 1)
                        if (issue.minimum === 1 && issue.inclusive) {
                            const singularPhrase = issue.origin === "set" ? "\u05DC\u05E4\u05D7\u05D5\u05EA \u05E4\u05E8\u05D9\u05D8 \u05D0\u05D7\u05D3" : "\u05DC\u05E4\u05D7\u05D5\u05EA \u05E4\u05E8\u05D9\u05D8 \u05D0\u05D7\u05D3";
                            return `\u{5E7}\u{5D8}\u{5DF} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${verb} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} ${singularPhrase}`;
                        }
                        const comparison = issue.inclusive ? `${issue.minimum} ${sizing?.unit ?? ""} \u{5D0}\u{5D5} \u{5D9}\u{5D5}\u{5EA}\u{5E8}` : `\u{5D9}\u{5D5}\u{5EA}\u{5E8} \u{5DE}-${issue.minimum} ${sizing?.unit ?? ""}`;
                        return `\u{5E7}\u{5D8}\u{5DF} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${verb} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} ${comparison}`.trim();
                    }
                    const adj = issue.inclusive ? ">=" : ">";
                    const be = verbFor(issue.origin ?? "value");
                    if (sizing?.unit) return `${sizing.shortLabel} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${be} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `${sizing?.shortLabel ?? "\u05E7\u05D8\u05DF"} \u{5DE}\u{5D3}\u{5D9}: ${subject} ${be} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    // These apply to strings — use feminine grammar + ה׳ הידיעה
                    if (_issue.format === "starts_with") return `\u{5D4}\u{5DE}\u{5D7}\u{5E8}\u{5D5}\u{5D6}\u{5EA} \u{5D7}\u{5D9}\u{5D9}\u{5D1}\u{5EA} \u{5DC}\u{5D4}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5D1} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{5D4}\u{5DE}\u{5D7}\u{5E8}\u{5D5}\u{5D6}\u{5EA} \u{5D7}\u{5D9}\u{5D9}\u{5D1}\u{5EA} \u{5DC}\u{5D4}\u{5E1}\u{5EA}\u{5D9}\u{5D9}\u{5DD} \u{5D1} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{5D4}\u{5DE}\u{5D7}\u{5E8}\u{5D5}\u{5D6}\u{5EA} \u{5D7}\u{5D9}\u{5D9}\u{5D1}\u{5EA} \u{5DC}\u{5DB}\u{5DC}\u{5D5}\u{5DC} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{5D4}\u{5DE}\u{5D7}\u{5E8}\u{5D5}\u{5D6}\u{5EA} \u{5D7}\u{5D9}\u{5D9}\u{5D1}\u{5EA} \u{5DC}\u{5D4}\u{5EA}\u{5D0}\u{5D9}\u{5DD} \u{5DC}\u{5EA}\u{5D1}\u{5E0}\u{5D9}\u{5EA} ${_issue.pattern}`;
                    // Handle gender agreement for formats
                    const nounEntry = FormatDictionary[_issue.format];
                    const noun = nounEntry?.label ?? _issue.format;
                    const gender = nounEntry?.gender ?? "m";
                    const adjective = gender === "f" ? "\u05EA\u05E7\u05D9\u05E0\u05D4" : "\u05EA\u05E7\u05D9\u05DF";
                    return `${noun} \u{5DC}\u{5D0} ${adjective}`;
                }
            case "not_multiple_of":
                return `\u{5DE}\u{5E1}\u{5E4}\u{5E8} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}: \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5DE}\u{5DB}\u{5E4}\u{5DC}\u{5D4} \u{5E9}\u{5DC} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{5DE}\u{5E4}\u{5EA}\u{5D7}${issue.keys.length > 1 ? "\u05D5\u05EA" : ""} \u{5DC}\u{5D0} \u{5DE}\u{5D6}\u{5D5}\u{5D4}${issue.keys.length > 1 ? "\u05D9\u05DD" : "\u05D4"}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{5E9}\u{5D3}\u{5D4} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF} \u{5D1}\u{5D0}\u{5D5}\u{5D1}\u{5D9}\u{5D9}\u{5E7}\u{5D8}`;
            case "invalid_union":
                return "\u05E7\u05DC\u05D8 \u05DC\u05D0 \u05EA\u05E7\u05D9\u05DF";
            case "invalid_element":
                {
                    const place = withDefinite(issue.origin ?? "array");
                    return `\u{5E2}\u{5E8}\u{5DA} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF} \u{5D1}${place}`;
                }
            default:
                return `\u{5E7}\u{5DC}\u{5D8} \u{5DC}\u{5D0} \u{5EA}\u{5E7}\u{5D9}\u{5DF}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jLfvv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "karakter",
            verb: "legyen"
        },
        file: {
            unit: "byte",
            verb: "legyen"
        },
        array: {
            unit: "elem",
            verb: "legyen"
        },
        set: {
            unit: "elem",
            verb: "legyen"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "bemenet",
        email: "email c\xedm",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO id\u0151b\xe9lyeg",
        date: "ISO d\xe1tum",
        time: "ISO id\u0151",
        duration: "ISO id\u0151intervallum",
        ipv4: "IPv4 c\xedm",
        ipv6: "IPv6 c\xedm",
        cidrv4: "IPv4 tartom\xe1ny",
        cidrv6: "IPv6 tartom\xe1ny",
        base64: "base64-k\xf3dolt string",
        base64url: "base64url-k\xf3dolt string",
        json_string: "JSON string",
        e164: "E.164 sz\xe1m",
        jwt: "JWT",
        template_literal: "bemenet"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "sz\xe1m",
        array: "t\xf6mb"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\xc9rv\xe9nytelen bemenet: a v\xe1rt \xe9rt\xe9k instanceof ${issue.expected}, a kapott \xe9rt\xe9k ${received}`;
                    return `\xc9rv\xe9nytelen bemenet: a v\xe1rt \xe9rt\xe9k ${expected}, a kapott \xe9rt\xe9k ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\xc9rv\xe9nytelen bemenet: a v\xe1rt \xe9rt\xe9k ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `\xc9rv\xe9nytelen opci\xf3: valamelyik \xe9rt\xe9k v\xe1rt ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `T\xfal nagy: ${issue.origin ?? "\xe9rt\xe9k"} m\xe9rete t\xfal nagy ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elem"}`;
                    return `T\xfal nagy: a bemeneti \xe9rt\xe9k ${issue.origin ?? "\xe9rt\xe9k"} t\xfal nagy: ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `T\xfal kicsi: a bemeneti \xe9rt\xe9k ${issue.origin} m\xe9rete t\xfal kicsi ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `T\xfal kicsi: a bemeneti \xe9rt\xe9k ${issue.origin} t\xfal kicsi ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\xc9rv\xe9nytelen string: "${_issue.prefix}" \xe9rt\xe9kkel kell kezd\u{151}dnie`;
                    if (_issue.format === "ends_with") return `\xc9rv\xe9nytelen string: "${_issue.suffix}" \xe9rt\xe9kkel kell v\xe9gz\u{151}dnie`;
                    if (_issue.format === "includes") return `\xc9rv\xe9nytelen string: "${_issue.includes}" \xe9rt\xe9ket kell tartalmaznia`;
                    if (_issue.format === "regex") return `\xc9rv\xe9nytelen string: ${_issue.pattern} mint\xe1nak kell megfelelnie`;
                    return `\xc9rv\xe9nytelen ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\xc9rv\xe9nytelen sz\xe1m: ${issue.divisor} t\xf6bbsz\xf6r\xf6s\xe9nek kell lennie`;
            case "unrecognized_keys":
                return `Ismeretlen kulcs${issue.keys.length > 1 ? "s" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `\xc9rv\xe9nytelen kulcs ${issue.origin}`;
            case "invalid_union":
                return "\xc9rv\xe9nytelen bemenet";
            case "invalid_element":
                return `\xc9rv\xe9nytelen \xe9rt\xe9k: ${issue.origin}`;
            default:
                return `\xc9rv\xe9nytelen bemenet`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"39jG3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
function getArmenianPlural(count, one, many) {
    return Math.abs(count) === 1 ? one : many;
}
function withDefiniteArticle(word) {
    if (!word) return "";
    const vowels = [
        "\u0561",
        "\u0565",
        "\u0568",
        "\u056B",
        "\u0578",
        "\u0578\u0582",
        "\u0585"
    ];
    const lastChar = word[word.length - 1];
    return word + (vowels.includes(lastChar) ? "\u0576" : "\u0568");
}
const error = ()=>{
    const Sizable = {
        string: {
            unit: {
                one: "\u0576\u0577\u0561\u0576",
                many: "\u0576\u0577\u0561\u0576\u0576\u0565\u0580"
            },
            verb: "\u0578\u0582\u0576\u0565\u0576\u0561\u056C"
        },
        file: {
            unit: {
                one: "\u0562\u0561\u0575\u0569",
                many: "\u0562\u0561\u0575\u0569\u0565\u0580"
            },
            verb: "\u0578\u0582\u0576\u0565\u0576\u0561\u056C"
        },
        array: {
            unit: {
                one: "\u057F\u0561\u0580\u0580",
                many: "\u057F\u0561\u0580\u0580\u0565\u0580"
            },
            verb: "\u0578\u0582\u0576\u0565\u0576\u0561\u056C"
        },
        set: {
            unit: {
                one: "\u057F\u0561\u0580\u0580",
                many: "\u057F\u0561\u0580\u0580\u0565\u0580"
            },
            verb: "\u0578\u0582\u0576\u0565\u0576\u0561\u056C"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0574\u0578\u0582\u057F\u0584",
        email: "\u0567\u056C. \u0570\u0561\u057D\u0581\u0565",
        url: "URL",
        emoji: "\u0567\u0574\u0578\u057B\u056B",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0561\u0574\u057D\u0561\u0569\u056B\u057E \u0587 \u056A\u0561\u0574",
        date: "ISO \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        time: "ISO \u056A\u0561\u0574",
        duration: "ISO \u057F\u0587\u0578\u0572\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ipv4: "IPv4 \u0570\u0561\u057D\u0581\u0565",
        ipv6: "IPv6 \u0570\u0561\u057D\u0581\u0565",
        cidrv4: "IPv4 \u0574\u056B\u057B\u0561\u056F\u0561\u0575\u0584",
        cidrv6: "IPv6 \u0574\u056B\u057B\u0561\u056F\u0561\u0575\u0584",
        base64: "base64 \u0571\u0587\u0561\u0579\u0561\u0583\u0578\u057E \u057F\u0578\u0572",
        base64url: "base64url \u0571\u0587\u0561\u0579\u0561\u0583\u0578\u057E \u057F\u0578\u0572",
        json_string: "JSON \u057F\u0578\u0572",
        e164: "E.164 \u0570\u0561\u0574\u0561\u0580",
        jwt: "JWT",
        template_literal: "\u0574\u0578\u0582\u057F\u0584"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0569\u056B\u057E",
        array: "\u0566\u0561\u0576\u0563\u057E\u0561\u056E"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{54D}\u{56D}\u{561}\u{56C} \u{574}\u{578}\u{582}\u{57F}\u{584}\u{561}\u{563}\u{580}\u{578}\u{582}\u{574}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}\u{580} instanceof ${issue.expected}, \u{57D}\u{57F}\u{561}\u{581}\u{57E}\u{565}\u{56C} \u{567} ${received}`;
                    return `\u{54D}\u{56D}\u{561}\u{56C} \u{574}\u{578}\u{582}\u{57F}\u{584}\u{561}\u{563}\u{580}\u{578}\u{582}\u{574}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}\u{580} ${expected}, \u{57D}\u{57F}\u{561}\u{581}\u{57E}\u{565}\u{56C} \u{567} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{54D}\u{56D}\u{561}\u{56C} \u{574}\u{578}\u{582}\u{57F}\u{584}\u{561}\u{563}\u{580}\u{578}\u{582}\u{574}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}\u{580} ${_utilJs.stringifyPrimitive(issue.values[1])}`;
                return `\u{54D}\u{56D}\u{561}\u{56C} \u{57F}\u{561}\u{580}\u{562}\u{565}\u{580}\u{561}\u{56F}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}\u{580} \u{570}\u{565}\u{57F}\u{587}\u{575}\u{561}\u{56C}\u{576}\u{565}\u{580}\u{56B}\u{581} \u{574}\u{565}\u{56F}\u{568}\u{55D} ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const maxValue = Number(issue.maximum);
                        const unit = getArmenianPlural(maxValue, sizing.unit.one, sizing.unit.many);
                        return `\u{549}\u{561}\u{583}\u{561}\u{566}\u{561}\u{576}\u{581} \u{574}\u{565}\u{56E} \u{561}\u{580}\u{56A}\u{565}\u{584}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}, \u{578}\u{580} ${withDefiniteArticle(issue.origin ?? "\u0561\u0580\u056A\u0565\u0584")} \u{56F}\u{578}\u{582}\u{576}\u{565}\u{576}\u{561} ${adj}${issue.maximum.toString()} ${unit}`;
                    }
                    return `\u{549}\u{561}\u{583}\u{561}\u{566}\u{561}\u{576}\u{581} \u{574}\u{565}\u{56E} \u{561}\u{580}\u{56A}\u{565}\u{584}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}, \u{578}\u{580} ${withDefiniteArticle(issue.origin ?? "\u0561\u0580\u056A\u0565\u0584")} \u{56C}\u{56B}\u{576}\u{56B} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const minValue = Number(issue.minimum);
                        const unit = getArmenianPlural(minValue, sizing.unit.one, sizing.unit.many);
                        return `\u{549}\u{561}\u{583}\u{561}\u{566}\u{561}\u{576}\u{581} \u{583}\u{578}\u{584}\u{580} \u{561}\u{580}\u{56A}\u{565}\u{584}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}, \u{578}\u{580} ${withDefiniteArticle(issue.origin)} \u{56F}\u{578}\u{582}\u{576}\u{565}\u{576}\u{561} ${adj}${issue.minimum.toString()} ${unit}`;
                    }
                    return `\u{549}\u{561}\u{583}\u{561}\u{566}\u{561}\u{576}\u{581} \u{583}\u{578}\u{584}\u{580} \u{561}\u{580}\u{56A}\u{565}\u{584}\u{2024} \u{57D}\u{57A}\u{561}\u{57D}\u{57E}\u{578}\u{582}\u{574} \u{567}, \u{578}\u{580} ${withDefiniteArticle(issue.origin)} \u{56C}\u{56B}\u{576}\u{56B} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{54D}\u{56D}\u{561}\u{56C} \u{57F}\u{578}\u{572}\u{2024} \u{57A}\u{565}\u{57F}\u{584} \u{567} \u{57D}\u{56F}\u{57D}\u{57E}\u{56B} "${_issue.prefix}"-\u{578}\u{57E}`;
                    if (_issue.format === "ends_with") return `\u{54D}\u{56D}\u{561}\u{56C} \u{57F}\u{578}\u{572}\u{2024} \u{57A}\u{565}\u{57F}\u{584} \u{567} \u{561}\u{57E}\u{561}\u{580}\u{57F}\u{57E}\u{56B} "${_issue.suffix}"-\u{578}\u{57E}`;
                    if (_issue.format === "includes") return `\u{54D}\u{56D}\u{561}\u{56C} \u{57F}\u{578}\u{572}\u{2024} \u{57A}\u{565}\u{57F}\u{584} \u{567} \u{57A}\u{561}\u{580}\u{578}\u{582}\u{576}\u{561}\u{56F}\u{56B} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{54D}\u{56D}\u{561}\u{56C} \u{57F}\u{578}\u{572}\u{2024} \u{57A}\u{565}\u{57F}\u{584} \u{567} \u{570}\u{561}\u{574}\u{561}\u{57A}\u{561}\u{57F}\u{561}\u{57D}\u{56D}\u{561}\u{576}\u{56B} ${_issue.pattern} \u{571}\u{587}\u{561}\u{579}\u{561}\u{583}\u{56B}\u{576}`;
                    return `\u{54D}\u{56D}\u{561}\u{56C} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{54D}\u{56D}\u{561}\u{56C} \u{569}\u{56B}\u{57E}\u{2024} \u{57A}\u{565}\u{57F}\u{584} \u{567} \u{562}\u{561}\u{566}\u{574}\u{561}\u{57A}\u{561}\u{57F}\u{56B}\u{56F} \u{56C}\u{56B}\u{576}\u{56B} ${issue.divisor}-\u{56B}`;
            case "unrecognized_keys":
                return `\u{549}\u{573}\u{561}\u{576}\u{561}\u{579}\u{57E}\u{561}\u{56E} \u{562}\u{561}\u{576}\u{561}\u{56C}\u{56B}${issue.keys.length > 1 ? "\u0576\u0565\u0580" : ""}. ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{54D}\u{56D}\u{561}\u{56C} \u{562}\u{561}\u{576}\u{561}\u{56C}\u{56B} ${withDefiniteArticle(issue.origin)}-\u{578}\u{582}\u{574}`;
            case "invalid_union":
                return "\u054D\u056D\u0561\u056C \u0574\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0578\u0582\u0574";
            case "invalid_element":
                return `\u{54D}\u{56D}\u{561}\u{56C} \u{561}\u{580}\u{56A}\u{565}\u{584} ${withDefiniteArticle(issue.origin)}-\u{578}\u{582}\u{574}`;
            default:
                return `\u{54D}\u{56D}\u{561}\u{56C} \u{574}\u{578}\u{582}\u{57F}\u{584}\u{561}\u{563}\u{580}\u{578}\u{582}\u{574}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kht6n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "karakter",
            verb: "memiliki"
        },
        file: {
            unit: "byte",
            verb: "memiliki"
        },
        array: {
            unit: "item",
            verb: "memiliki"
        },
        set: {
            unit: "item",
            verb: "memiliki"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "alamat email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "tanggal dan waktu format ISO",
        date: "tanggal format ISO",
        time: "jam format ISO",
        duration: "durasi format ISO",
        ipv4: "alamat IPv4",
        ipv6: "alamat IPv6",
        cidrv4: "rentang alamat IPv4",
        cidrv6: "rentang alamat IPv6",
        base64: "string dengan enkode base64",
        base64url: "string dengan enkode base64url",
        json_string: "string JSON",
        e164: "angka E.164",
        jwt: "JWT",
        template_literal: "input"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Input tidak valid: diharapkan instanceof ${issue.expected}, diterima ${received}`;
                    return `Input tidak valid: diharapkan ${expected}, diterima ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Input tidak valid: diharapkan ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Pilihan tidak valid: diharapkan salah satu dari ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Terlalu besar: diharapkan ${issue.origin ?? "value"} memiliki ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elemen"}`;
                    return `Terlalu besar: diharapkan ${issue.origin ?? "value"} menjadi ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Terlalu kecil: diharapkan ${issue.origin} memiliki ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Terlalu kecil: diharapkan ${issue.origin} menjadi ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `String tidak valid: harus dimulai dengan "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `String tidak valid: harus berakhir dengan "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `String tidak valid: harus menyertakan "${_issue.includes}"`;
                    if (_issue.format === "regex") return `String tidak valid: harus sesuai pola ${_issue.pattern}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} tidak valid`;
                }
            case "not_multiple_of":
                return `Angka tidak valid: harus kelipatan dari ${issue.divisor}`;
            case "unrecognized_keys":
                return `Kunci tidak dikenali ${issue.keys.length > 1 ? "s" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Kunci tidak valid di ${issue.origin}`;
            case "invalid_union":
                return "Input tidak valid";
            case "invalid_element":
                return `Nilai tidak valid di ${issue.origin}`;
            default:
                return `Input tidak valid`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dbuB0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "stafi",
            verb: "a\xf0 hafa"
        },
        file: {
            unit: "b\xe6ti",
            verb: "a\xf0 hafa"
        },
        array: {
            unit: "hluti",
            verb: "a\xf0 hafa"
        },
        set: {
            unit: "hluti",
            verb: "a\xf0 hafa"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "gildi",
        email: "netfang",
        url: "vefsl\xf3\xf0",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dagsetning og t\xedmi",
        date: "ISO dagsetning",
        time: "ISO t\xedmi",
        duration: "ISO t\xedmalengd",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded strengur",
        base64url: "base64url-encoded strengur",
        json_string: "JSON strengur",
        e164: "E.164 t\xf6lugildi",
        jwt: "JWT",
        template_literal: "gildi"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "n\xfamer",
        array: "fylki"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Rangt gildi: \xde\xfa sl\xf3st inn ${received} \xfear sem \xe1 a\xf0 vera instanceof ${issue.expected}`;
                    return `Rangt gildi: \xde\xfa sl\xf3st inn ${received} \xfear sem \xe1 a\xf0 vera ${expected}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Rangt gildi: gert r\xe1\xf0 fyrir ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `\xd3gilt val: m\xe1 vera eitt af eftirfarandi ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Of st\xf3rt: gert er r\xe1\xf0 fyrir a\xf0 ${issue.origin ?? "gildi"} hafi ${adj}${issue.maximum.toString()} ${sizing.unit ?? "hluti"}`;
                    return `Of st\xf3rt: gert er r\xe1\xf0 fyrir a\xf0 ${issue.origin ?? "gildi"} s\xe9 ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Of l\xedti\xf0: gert er r\xe1\xf0 fyrir a\xf0 ${issue.origin} hafi ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Of l\xedti\xf0: gert er r\xe1\xf0 fyrir a\xf0 ${issue.origin} s\xe9 ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\xd3gildur strengur: ver\xf0ur a\xf0 byrja \xe1 "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\xd3gildur strengur: ver\xf0ur a\xf0 enda \xe1 "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\xd3gildur strengur: ver\xf0ur a\xf0 innihalda "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\xd3gildur strengur: ver\xf0ur a\xf0 fylgja mynstri ${_issue.pattern}`;
                    return `Rangt ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `R\xf6ng tala: ver\xf0ur a\xf0 vera margfeldi af ${issue.divisor}`;
            case "unrecognized_keys":
                return `\xd3\xfeekkt ${issue.keys.length > 1 ? "ir lyklar" : "ur lykill"}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Rangur lykill \xed ${issue.origin}`;
            case "invalid_union":
                return "Rangt gildi";
            case "invalid_element":
                return `Rangt gildi \xed ${issue.origin}`;
            default:
                return `Rangt gildi`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bAEOP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "caratteri",
            verb: "avere"
        },
        file: {
            unit: "byte",
            verb: "avere"
        },
        array: {
            unit: "elementi",
            verb: "avere"
        },
        set: {
            unit: "elementi",
            verb: "avere"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "indirizzo email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data e ora ISO",
        date: "data ISO",
        time: "ora ISO",
        duration: "durata ISO",
        ipv4: "indirizzo IPv4",
        ipv6: "indirizzo IPv6",
        cidrv4: "intervallo IPv4",
        cidrv6: "intervallo IPv6",
        base64: "stringa codificata in base64",
        base64url: "URL codificata in base64",
        json_string: "stringa JSON",
        e164: "numero E.164",
        jwt: "JWT",
        template_literal: "input"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "numero",
        array: "vettore"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Input non valido: atteso instanceof ${issue.expected}, ricevuto ${received}`;
                    return `Input non valido: atteso ${expected}, ricevuto ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Input non valido: atteso ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Opzione non valida: atteso uno tra ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Troppo grande: ${issue.origin ?? "valore"} deve avere ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementi"}`;
                    return `Troppo grande: ${issue.origin ?? "valore"} deve essere ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Troppo piccolo: ${issue.origin} deve avere ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Troppo piccolo: ${issue.origin} deve essere ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Stringa non valida: deve iniziare con "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Stringa non valida: deve terminare con "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Stringa non valida: deve includere "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Stringa non valida: deve corrispondere al pattern ${_issue.pattern}`;
                    return `Invalid ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Numero non valido: deve essere un multiplo di ${issue.divisor}`;
            case "unrecognized_keys":
                return `Chiav${issue.keys.length > 1 ? "i" : "e"} non riconosciut${issue.keys.length > 1 ? "e" : "a"}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Chiave non valida in ${issue.origin}`;
            case "invalid_union":
                return "Input non valido";
            case "invalid_element":
                return `Valore non valido in ${issue.origin}`;
            default:
                return `Input non valido`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"28QhZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\u6587\u5B57",
            verb: "\u3067\u3042\u308B"
        },
        file: {
            unit: "\u30D0\u30A4\u30C8",
            verb: "\u3067\u3042\u308B"
        },
        array: {
            unit: "\u8981\u7D20",
            verb: "\u3067\u3042\u308B"
        },
        set: {
            unit: "\u8981\u7D20",
            verb: "\u3067\u3042\u308B"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u5165\u529B\u5024",
        email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        url: "URL",
        emoji: "\u7D75\u6587\u5B57",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO\u65E5\u6642",
        date: "ISO\u65E5\u4ED8",
        time: "ISO\u6642\u523B",
        duration: "ISO\u671F\u9593",
        ipv4: "IPv4\u30A2\u30C9\u30EC\u30B9",
        ipv6: "IPv6\u30A2\u30C9\u30EC\u30B9",
        cidrv4: "IPv4\u7BC4\u56F2",
        cidrv6: "IPv6\u7BC4\u56F2",
        base64: "base64\u30A8\u30F3\u30B3\u30FC\u30C9\u6587\u5B57\u5217",
        base64url: "base64url\u30A8\u30F3\u30B3\u30FC\u30C9\u6587\u5B57\u5217",
        json_string: "JSON\u6587\u5B57\u5217",
        e164: "E.164\u756A\u53F7",
        jwt: "JWT",
        template_literal: "\u5165\u529B\u5024"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u6570\u5024",
        array: "\u914D\u5217"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{7121}\u{52B9}\u{306A}\u{5165}\u{529B}: instanceof ${issue.expected}\u{304C}\u{671F}\u{5F85}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{304C}\u{3001}${received}\u{304C}\u{5165}\u{529B}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}`;
                    return `\u{7121}\u{52B9}\u{306A}\u{5165}\u{529B}: ${expected}\u{304C}\u{671F}\u{5F85}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{304C}\u{3001}${received}\u{304C}\u{5165}\u{529B}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{7121}\u{52B9}\u{306A}\u{5165}\u{529B}: ${_utilJs.stringifyPrimitive(issue.values[0])}\u{304C}\u{671F}\u{5F85}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}`;
                return `\u{7121}\u{52B9}\u{306A}\u{9078}\u{629E}: ${_utilJs.joinValues(issue.values, "\u3001")}\u{306E}\u{3044}\u{305A}\u{308C}\u{304B}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "\u4EE5\u4E0B\u3067\u3042\u308B" : "\u3088\u308A\u5C0F\u3055\u3044";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{5927}\u{304D}\u{3059}\u{304E}\u{308B}\u{5024}: ${issue.origin ?? "\u5024"}\u{306F}${issue.maximum.toString()}${sizing.unit ?? "\u8981\u7D20"}${adj}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    return `\u{5927}\u{304D}\u{3059}\u{304E}\u{308B}\u{5024}: ${issue.origin ?? "\u5024"}\u{306F}${issue.maximum.toString()}${adj}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? "\u4EE5\u4E0A\u3067\u3042\u308B" : "\u3088\u308A\u5927\u304D\u3044";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{5C0F}\u{3055}\u{3059}\u{304E}\u{308B}\u{5024}: ${issue.origin}\u{306F}${issue.minimum.toString()}${sizing.unit}${adj}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    return `\u{5C0F}\u{3055}\u{3059}\u{304E}\u{308B}\u{5024}: ${issue.origin}\u{306F}${issue.minimum.toString()}${adj}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{7121}\u{52B9}\u{306A}\u{6587}\u{5B57}\u{5217}: "${_issue.prefix}"\u{3067}\u{59CB}\u{307E}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    if (_issue.format === "ends_with") return `\u{7121}\u{52B9}\u{306A}\u{6587}\u{5B57}\u{5217}: "${_issue.suffix}"\u{3067}\u{7D42}\u{308F}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    if (_issue.format === "includes") return `\u{7121}\u{52B9}\u{306A}\u{6587}\u{5B57}\u{5217}: "${_issue.includes}"\u{3092}\u{542B}\u{3080}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    if (_issue.format === "regex") return `\u{7121}\u{52B9}\u{306A}\u{6587}\u{5B57}\u{5217}: \u{30D1}\u{30BF}\u{30FC}\u{30F3}${_issue.pattern}\u{306B}\u{4E00}\u{81F4}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
                    return `\u{7121}\u{52B9}\u{306A}${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{7121}\u{52B9}\u{306A}\u{6570}\u{5024}: ${issue.divisor}\u{306E}\u{500D}\u{6570}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}`;
            case "unrecognized_keys":
                return `\u{8A8D}\u{8B58}\u{3055}\u{308C}\u{3066}\u{3044}\u{306A}\u{3044}\u{30AD}\u{30FC}${issue.keys.length > 1 ? "\u7FA4" : ""}: ${_utilJs.joinValues(issue.keys, "\u3001")}`;
            case "invalid_key":
                return `${issue.origin}\u{5185}\u{306E}\u{7121}\u{52B9}\u{306A}\u{30AD}\u{30FC}`;
            case "invalid_union":
                return "\u7121\u52B9\u306A\u5165\u529B";
            case "invalid_element":
                return `${issue.origin}\u{5185}\u{306E}\u{7121}\u{52B9}\u{306A}\u{5024}`;
            default:
                return `\u{7121}\u{52B9}\u{306A}\u{5165}\u{529B}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eAdEV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD",
            verb: "\u10E3\u10DC\u10D3\u10D0 \u10E8\u10D4\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1"
        },
        file: {
            unit: "\u10D1\u10D0\u10D8\u10E2\u10D8",
            verb: "\u10E3\u10DC\u10D3\u10D0 \u10E8\u10D4\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1"
        },
        array: {
            unit: "\u10D4\u10DA\u10D4\u10DB\u10D4\u10DC\u10E2\u10D8",
            verb: "\u10E3\u10DC\u10D3\u10D0 \u10E8\u10D4\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1"
        },
        set: {
            unit: "\u10D4\u10DA\u10D4\u10DB\u10D4\u10DC\u10E2\u10D8",
            verb: "\u10E3\u10DC\u10D3\u10D0 \u10E8\u10D4\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u10E8\u10D4\u10E7\u10D5\u10D0\u10DC\u10D0",
        email: "\u10D4\u10DA-\u10E4\u10DD\u10E1\u10E2\u10D8\u10E1 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8",
        url: "URL",
        emoji: "\u10D4\u10DB\u10DD\u10EF\u10D8",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8-\u10D3\u10E0\u10DD",
        date: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8",
        time: "\u10D3\u10E0\u10DD",
        duration: "\u10EE\u10D0\u10DC\u10D2\u10E0\u10EB\u10DA\u10D8\u10D5\u10DD\u10D1\u10D0",
        ipv4: "IPv4 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8",
        ipv6: "IPv6 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8",
        cidrv4: "IPv4 \u10D3\u10D8\u10D0\u10DE\u10D0\u10D6\u10DD\u10DC\u10D8",
        cidrv6: "IPv6 \u10D3\u10D8\u10D0\u10DE\u10D0\u10D6\u10DD\u10DC\u10D8",
        base64: "base64-\u10D9\u10DD\u10D3\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E1\u10E2\u10E0\u10D8\u10DC\u10D2\u10D8",
        base64url: "base64url-\u10D9\u10DD\u10D3\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E1\u10E2\u10E0\u10D8\u10DC\u10D2\u10D8",
        json_string: "JSON \u10E1\u10E2\u10E0\u10D8\u10DC\u10D2\u10D8",
        e164: "E.164 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8",
        jwt: "JWT",
        template_literal: "\u10E8\u10D4\u10E7\u10D5\u10D0\u10DC\u10D0"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8",
        string: "\u10E1\u10E2\u10E0\u10D8\u10DC\u10D2\u10D8",
        boolean: "\u10D1\u10E3\u10DA\u10D4\u10D0\u10DC\u10D8",
        function: "\u10E4\u10E3\u10DC\u10E5\u10EA\u10D8\u10D0",
        array: "\u10DB\u10D0\u10E1\u10D8\u10D5\u10D8"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E8}\u{10D4}\u{10E7}\u{10D5}\u{10D0}\u{10DC}\u{10D0}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} instanceof ${issue.expected}, \u{10DB}\u{10D8}\u{10E6}\u{10D4}\u{10D1}\u{10E3}\u{10DA}\u{10D8} ${received}`;
                    return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E8}\u{10D4}\u{10E7}\u{10D5}\u{10D0}\u{10DC}\u{10D0}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${expected}, \u{10DB}\u{10D8}\u{10E6}\u{10D4}\u{10D1}\u{10E3}\u{10DA}\u{10D8} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E8}\u{10D4}\u{10E7}\u{10D5}\u{10D0}\u{10DC}\u{10D0}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10D5}\u{10D0}\u{10E0}\u{10D8}\u{10D0}\u{10DC}\u{10E2}\u{10D8}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8}\u{10D0} \u{10D4}\u{10E0}\u{10D7}-\u{10D4}\u{10E0}\u{10D7}\u{10D8} ${_utilJs.joinValues(issue.values, "|")}-\u{10D3}\u{10D0}\u{10DC}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{10D6}\u{10D4}\u{10D3}\u{10DB}\u{10D4}\u{10E2}\u{10D0}\u{10D3} \u{10D3}\u{10D8}\u{10D3}\u{10D8}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${issue.origin ?? "\u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D1\u10D0"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit}`;
                    return `\u{10D6}\u{10D4}\u{10D3}\u{10DB}\u{10D4}\u{10E2}\u{10D0}\u{10D3} \u{10D3}\u{10D8}\u{10D3}\u{10D8}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${issue.origin ?? "\u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D1\u10D0"} \u{10D8}\u{10E7}\u{10DD}\u{10E1} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{10D6}\u{10D4}\u{10D3}\u{10DB}\u{10D4}\u{10E2}\u{10D0}\u{10D3} \u{10DE}\u{10D0}\u{10E2}\u{10D0}\u{10E0}\u{10D0}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{10D6}\u{10D4}\u{10D3}\u{10DB}\u{10D4}\u{10E2}\u{10D0}\u{10D3} \u{10DE}\u{10D0}\u{10E2}\u{10D0}\u{10E0}\u{10D0}: \u{10DB}\u{10DD}\u{10E1}\u{10D0}\u{10DA}\u{10DD}\u{10D3}\u{10DC}\u{10D4}\u{10DA}\u{10D8} ${issue.origin} \u{10D8}\u{10E7}\u{10DD}\u{10E1} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E1}\u{10E2}\u{10E0}\u{10D8}\u{10DC}\u{10D2}\u{10D8}: \u{10E3}\u{10DC}\u{10D3}\u{10D0} \u{10D8}\u{10EC}\u{10E7}\u{10D4}\u{10D1}\u{10DD}\u{10D3}\u{10D4}\u{10E1} "${_issue.prefix}"-\u{10D8}\u{10D7}`;
                    if (_issue.format === "ends_with") return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E1}\u{10E2}\u{10E0}\u{10D8}\u{10DC}\u{10D2}\u{10D8}: \u{10E3}\u{10DC}\u{10D3}\u{10D0} \u{10DB}\u{10D7}\u{10D0}\u{10D5}\u{10E0}\u{10D3}\u{10D4}\u{10D1}\u{10DD}\u{10D3}\u{10D4}\u{10E1} "${_issue.suffix}"-\u{10D8}\u{10D7}`;
                    if (_issue.format === "includes") return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E1}\u{10E2}\u{10E0}\u{10D8}\u{10DC}\u{10D2}\u{10D8}: \u{10E3}\u{10DC}\u{10D3}\u{10D0} \u{10E8}\u{10D4}\u{10D8}\u{10EA}\u{10D0}\u{10D5}\u{10D3}\u{10D4}\u{10E1} "${_issue.includes}"-\u{10E1}`;
                    if (_issue.format === "regex") return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E1}\u{10E2}\u{10E0}\u{10D8}\u{10DC}\u{10D2}\u{10D8}: \u{10E3}\u{10DC}\u{10D3}\u{10D0} \u{10E8}\u{10D4}\u{10D4}\u{10E1}\u{10D0}\u{10D1}\u{10D0}\u{10DB}\u{10D4}\u{10D1}\u{10DD}\u{10D3}\u{10D4}\u{10E1} \u{10E8}\u{10D0}\u{10D1}\u{10DA}\u{10DD}\u{10DC}\u{10E1} ${_issue.pattern}`;
                    return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E0}\u{10D8}\u{10EA}\u{10EE}\u{10D5}\u{10D8}: \u{10E3}\u{10DC}\u{10D3}\u{10D0} \u{10D8}\u{10E7}\u{10DD}\u{10E1} ${issue.divisor}-\u{10D8}\u{10E1} \u{10EF}\u{10D4}\u{10E0}\u{10D0}\u{10D3}\u{10D8}`;
            case "unrecognized_keys":
                return `\u{10E3}\u{10EA}\u{10DC}\u{10DD}\u{10D1}\u{10D8} \u{10D2}\u{10D0}\u{10E1}\u{10D0}\u{10E6}\u{10D4}\u{10D1}${issue.keys.length > 1 ? "\u10D4\u10D1\u10D8" : "\u10D8"}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10D2}\u{10D0}\u{10E1}\u{10D0}\u{10E6}\u{10D4}\u{10D1}\u{10D8} ${issue.origin}-\u{10E8}\u{10D8}`;
            case "invalid_union":
                return "\u10D0\u10E0\u10D0\u10E1\u10EC\u10DD\u10E0\u10D8 \u10E8\u10D4\u10E7\u10D5\u10D0\u10DC\u10D0";
            case "invalid_element":
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10DB}\u{10DC}\u{10D8}\u{10E8}\u{10D5}\u{10DC}\u{10D4}\u{10DA}\u{10DD}\u{10D1}\u{10D0} ${issue.origin}-\u{10E8}\u{10D8}`;
            default:
                return `\u{10D0}\u{10E0}\u{10D0}\u{10E1}\u{10EC}\u{10DD}\u{10E0}\u{10D8} \u{10E8}\u{10D4}\u{10E7}\u{10D5}\u{10D0}\u{10DC}\u{10D0}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7S9aa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @deprecated Use `km` instead. */ parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _kmJsDefault.default)();
    });
var _kmJs = require("./km.js");
var _kmJsDefault = parcelHelpers.interopDefault(_kmJs);

},{"./km.js":"5ZRkg","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5ZRkg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\u178F\u17BD\u17A2\u1780\u17D2\u179F\u179A",
            verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793"
        },
        file: {
            unit: "\u1794\u17C3",
            verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793"
        },
        array: {
            unit: "\u1792\u17B6\u178F\u17BB",
            verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793"
        },
        set: {
            unit: "\u1792\u17B6\u178F\u17BB",
            verb: "\u1782\u17BD\u179A\u1798\u17B6\u1793"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u1794\u1789\u17D2\u1785\u17BC\u179B",
        email: "\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793\u17A2\u17CA\u17B8\u1798\u17C2\u179B",
        url: "URL",
        emoji: "\u179F\u1789\u17D2\u1789\u17B6\u17A2\u17B6\u179A\u1798\u17D2\u1798\u178E\u17CD",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u1780\u17B6\u179B\u1794\u179A\u17B7\u1785\u17D2\u1786\u17C1\u1791 \u1793\u17B7\u1784\u1798\u17C9\u17C4\u1784 ISO",
        date: "\u1780\u17B6\u179B\u1794\u179A\u17B7\u1785\u17D2\u1786\u17C1\u1791 ISO",
        time: "\u1798\u17C9\u17C4\u1784 ISO",
        duration: "\u179A\u1799\u17C8\u1796\u17C1\u179B ISO",
        ipv4: "\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv4",
        ipv6: "\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv6",
        cidrv4: "\u178A\u17C2\u1793\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv4",
        cidrv6: "\u178A\u17C2\u1793\u17A2\u17B6\u179F\u1799\u178A\u17D2\u178B\u17B6\u1793 IPv6",
        base64: "\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A\u17A2\u17CA\u17B7\u1780\u17BC\u178A base64",
        base64url: "\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A\u17A2\u17CA\u17B7\u1780\u17BC\u178A base64url",
        json_string: "\u1781\u17D2\u179F\u17C2\u17A2\u1780\u17D2\u179F\u179A JSON",
        e164: "\u179B\u17C1\u1781 E.164",
        jwt: "JWT",
        template_literal: "\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u1794\u1789\u17D2\u1785\u17BC\u179B"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u179B\u17C1\u1781",
        array: "\u17A2\u17B6\u179A\u17C1 (Array)",
        null: "\u1782\u17D2\u1798\u17B6\u1793\u178F\u1798\u17D2\u179B\u17C3 (null)"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1794}\u{1789}\u{17D2}\u{1785}\u{17BC}\u{179B}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} instanceof ${issue.expected} \u{1794}\u{17C9}\u{17BB}\u{1793}\u{17D2}\u{178F}\u{17C2}\u{1791}\u{1791}\u{17BD}\u{179B}\u{1794}\u{17B6}\u{1793} ${received}`;
                    return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1794}\u{1789}\u{17D2}\u{1785}\u{17BC}\u{179B}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${expected} \u{1794}\u{17C9}\u{17BB}\u{1793}\u{17D2}\u{178F}\u{17C2}\u{1791}\u{1791}\u{17BD}\u{179B}\u{1794}\u{17B6}\u{1793} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1794}\u{1789}\u{17D2}\u{1785}\u{17BC}\u{179B}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `\u{1787}\u{1798}\u{17D2}\u{179A}\u{17BE}\u{179F}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1787}\u{17B6}\u{1798}\u{17BD}\u{1799}\u{1780}\u{17D2}\u{1793}\u{17BB}\u{1784}\u{1785}\u{17C6}\u{178E}\u{17C4}\u{1798} ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{1792}\u{17C6}\u{1796}\u{17C1}\u{1780}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${issue.origin ?? "\u178F\u1798\u17D2\u179B\u17C3"} ${adj} ${issue.maximum.toString()} ${sizing.unit ?? "\u1792\u17B6\u178F\u17BB"}`;
                    return `\u{1792}\u{17C6}\u{1796}\u{17C1}\u{1780}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${issue.origin ?? "\u178F\u1798\u17D2\u179B\u17C3"} ${adj} ${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{178F}\u{17BC}\u{1785}\u{1796}\u{17C1}\u{1780}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${issue.origin} ${adj} ${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{178F}\u{17BC}\u{1785}\u{1796}\u{17C1}\u{1780}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1780}\u{17B6}\u{179A} ${issue.origin} ${adj} ${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{1781}\u{17D2}\u{179F}\u{17C2}\u{17A2}\u{1780}\u{17D2}\u{179F}\u{179A}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1785}\u{17B6}\u{1794}\u{17CB}\u{1795}\u{17D2}\u{178F}\u{17BE}\u{1798}\u{178A}\u{17C4}\u{1799} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{1781}\u{17D2}\u{179F}\u{17C2}\u{17A2}\u{1780}\u{17D2}\u{179F}\u{179A}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1794}\u{1789}\u{17D2}\u{1785}\u{1794}\u{17CB}\u{178A}\u{17C4}\u{1799} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{1781}\u{17D2}\u{179F}\u{17C2}\u{17A2}\u{1780}\u{17D2}\u{179F}\u{179A}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1798}\u{17B6}\u{1793} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{1781}\u{17D2}\u{179F}\u{17C2}\u{17A2}\u{1780}\u{17D2}\u{179F}\u{179A}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{178F}\u{17C2}\u{1795}\u{17D2}\u{1782}\u{17BC}\u{1795}\u{17D2}\u{1782}\u{1784}\u{1793}\u{17B9}\u{1784}\u{1791}\u{1798}\u{17D2}\u{179A}\u{1784}\u{17CB}\u{178A}\u{17C2}\u{179B}\u{1794}\u{17B6}\u{1793}\u{1780}\u{17C6}\u{178E}\u{178F}\u{17CB} ${_issue.pattern}`;
                    return `\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{179B}\u{17C1}\u{1781}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{17D6} \u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{178F}\u{17C2}\u{1787}\u{17B6}\u{1796}\u{17A0}\u{17BB}\u{1782}\u{17BB}\u{178E}\u{1793}\u{17C3} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{179A}\u{1780}\u{1783}\u{17BE}\u{1789}\u{179F}\u{17C4}\u{1798}\u{17B7}\u{1793}\u{179F}\u{17D2}\u{1782}\u{17B6}\u{179B}\u{17CB}\u{17D6} ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{179F}\u{17C4}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1793}\u{17C5}\u{1780}\u{17D2}\u{1793}\u{17BB}\u{1784} ${issue.origin}`;
            case "invalid_union":
                return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}`;
            case "invalid_element":
                return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}\u{1793}\u{17C5}\u{1780}\u{17D2}\u{1793}\u{17BB}\u{1784} ${issue.origin}`;
            default:
                return `\u{1791}\u{17B7}\u{1793}\u{17D2}\u{1793}\u{1793}\u{17D0}\u{1799}\u{1798}\u{17B7}\u{1793}\u{178F}\u{17D2}\u{179A}\u{17B9}\u{1798}\u{178F}\u{17D2}\u{179A}\u{17BC}\u{179C}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bHTrD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\uBB38\uC790",
            verb: "to have"
        },
        file: {
            unit: "\uBC14\uC774\uD2B8",
            verb: "to have"
        },
        array: {
            unit: "\uAC1C",
            verb: "to have"
        },
        set: {
            unit: "\uAC1C",
            verb: "to have"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\uC785\uB825",
        email: "\uC774\uBA54\uC77C \uC8FC\uC18C",
        url: "URL",
        emoji: "\uC774\uBAA8\uC9C0",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \uB0A0\uC9DC\uC2DC\uAC04",
        date: "ISO \uB0A0\uC9DC",
        time: "ISO \uC2DC\uAC04",
        duration: "ISO \uAE30\uAC04",
        ipv4: "IPv4 \uC8FC\uC18C",
        ipv6: "IPv6 \uC8FC\uC18C",
        cidrv4: "IPv4 \uBC94\uC704",
        cidrv6: "IPv6 \uBC94\uC704",
        base64: "base64 \uC778\uCF54\uB529 \uBB38\uC790\uC5F4",
        base64url: "base64url \uC778\uCF54\uB529 \uBB38\uC790\uC5F4",
        json_string: "JSON \uBB38\uC790\uC5F4",
        e164: "E.164 \uBC88\uD638",
        jwt: "JWT",
        template_literal: "\uC785\uB825"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{C798}\u{BABB}\u{B41C} \u{C785}\u{B825}: \u{C608}\u{C0C1} \u{D0C0}\u{C785}\u{C740} instanceof ${issue.expected}, \u{BC1B}\u{C740} \u{D0C0}\u{C785}\u{C740} ${received}\u{C785}\u{B2C8}\u{B2E4}`;
                    return `\u{C798}\u{BABB}\u{B41C} \u{C785}\u{B825}: \u{C608}\u{C0C1} \u{D0C0}\u{C785}\u{C740} ${expected}, \u{BC1B}\u{C740} \u{D0C0}\u{C785}\u{C740} ${received}\u{C785}\u{B2C8}\u{B2E4}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{C798}\u{BABB}\u{B41C} \u{C785}\u{B825}: \u{AC12}\u{C740} ${_utilJs.stringifyPrimitive(issue.values[0])} \u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
                return `\u{C798}\u{BABB}\u{B41C} \u{C635}\u{C158}: ${_utilJs.joinValues(issue.values, "\uB610\uB294 ")} \u{C911} \u{D558}\u{B098}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "\uC774\uD558" : "\uBBF8\uB9CC";
                    const suffix = adj === "\uBBF8\uB9CC" ? "\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4" : "\uC5EC\uC57C \uD569\uB2C8\uB2E4";
                    const sizing = getSizing(issue.origin);
                    const unit = sizing?.unit ?? "\uC694\uC18C";
                    if (sizing) return `${issue.origin ?? "\uAC12"}\u{C774} \u{B108}\u{BB34} \u{D07D}\u{B2C8}\u{B2E4}: ${issue.maximum.toString()}${unit} ${adj}${suffix}`;
                    return `${issue.origin ?? "\uAC12"}\u{C774} \u{B108}\u{BB34} \u{D07D}\u{B2C8}\u{B2E4}: ${issue.maximum.toString()} ${adj}${suffix}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? "\uC774\uC0C1" : "\uCD08\uACFC";
                    const suffix = adj === "\uC774\uC0C1" ? "\uC774\uC5B4\uC57C \uD569\uB2C8\uB2E4" : "\uC5EC\uC57C \uD569\uB2C8\uB2E4";
                    const sizing = getSizing(issue.origin);
                    const unit = sizing?.unit ?? "\uC694\uC18C";
                    if (sizing) return `${issue.origin ?? "\uAC12"}\u{C774} \u{B108}\u{BB34} \u{C791}\u{C2B5}\u{B2C8}\u{B2E4}: ${issue.minimum.toString()}${unit} ${adj}${suffix}`;
                    return `${issue.origin ?? "\uAC12"}\u{C774} \u{B108}\u{BB34} \u{C791}\u{C2B5}\u{B2C8}\u{B2E4}: ${issue.minimum.toString()} ${adj}${suffix}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{C798}\u{BABB}\u{B41C} \u{BB38}\u{C790}\u{C5F4}: "${_issue.prefix}"(\u{C73C})\u{B85C} \u{C2DC}\u{C791}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
                    if (_issue.format === "ends_with") return `\u{C798}\u{BABB}\u{B41C} \u{BB38}\u{C790}\u{C5F4}: "${_issue.suffix}"(\u{C73C})\u{B85C} \u{B05D}\u{B098}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
                    if (_issue.format === "includes") return `\u{C798}\u{BABB}\u{B41C} \u{BB38}\u{C790}\u{C5F4}: "${_issue.includes}"\u{C744}(\u{B97C}) \u{D3EC}\u{D568}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
                    if (_issue.format === "regex") return `\u{C798}\u{BABB}\u{B41C} \u{BB38}\u{C790}\u{C5F4}: \u{C815}\u{ADDC}\u{C2DD} ${_issue.pattern} \u{D328}\u{D134}\u{ACFC} \u{C77C}\u{CE58}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
                    return `\u{C798}\u{BABB}\u{B41C} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{C798}\u{BABB}\u{B41C} \u{C22B}\u{C790}: ${issue.divisor}\u{C758} \u{BC30}\u{C218}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
            case "unrecognized_keys":
                return `\u{C778}\u{C2DD}\u{D560} \u{C218} \u{C5C6}\u{B294} \u{D0A4}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{C798}\u{BABB}\u{B41C} \u{D0A4}: ${issue.origin}`;
            case "invalid_union":
                return `\u{C798}\u{BABB}\u{B41C} \u{C785}\u{B825}`;
            case "invalid_element":
                return `\u{C798}\u{BABB}\u{B41C} \u{AC12}: ${issue.origin}`;
            default:
                return `\u{C798}\u{BABB}\u{B41C} \u{C785}\u{B825}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8XGvO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const capitalizeFirstCharacter = (text)=>{
    return text.charAt(0).toUpperCase() + text.slice(1);
};
function getUnitTypeFromNumber(number) {
    const abs = Math.abs(number);
    const last = abs % 10;
    const last2 = abs % 100;
    if (last2 >= 11 && last2 <= 19 || last === 0) return "many";
    if (last === 1) return "one";
    return "few";
}
const error = ()=>{
    const Sizable = {
        string: {
            unit: {
                one: "simbolis",
                few: "simboliai",
                many: "simboli\u0173"
            },
            verb: {
                smaller: {
                    inclusive: "turi b\u016Bti ne ilgesn\u0117 kaip",
                    notInclusive: "turi b\u016Bti trumpesn\u0117 kaip"
                },
                bigger: {
                    inclusive: "turi b\u016Bti ne trumpesn\u0117 kaip",
                    notInclusive: "turi b\u016Bti ilgesn\u0117 kaip"
                }
            }
        },
        file: {
            unit: {
                one: "baitas",
                few: "baitai",
                many: "bait\u0173"
            },
            verb: {
                smaller: {
                    inclusive: "turi b\u016Bti ne didesnis kaip",
                    notInclusive: "turi b\u016Bti ma\u017Eesnis kaip"
                },
                bigger: {
                    inclusive: "turi b\u016Bti ne ma\u017Eesnis kaip",
                    notInclusive: "turi b\u016Bti didesnis kaip"
                }
            }
        },
        array: {
            unit: {
                one: "element\u0105",
                few: "elementus",
                many: "element\u0173"
            },
            verb: {
                smaller: {
                    inclusive: "turi tur\u0117ti ne daugiau kaip",
                    notInclusive: "turi tur\u0117ti ma\u017Eiau kaip"
                },
                bigger: {
                    inclusive: "turi tur\u0117ti ne ma\u017Eiau kaip",
                    notInclusive: "turi tur\u0117ti daugiau kaip"
                }
            }
        },
        set: {
            unit: {
                one: "element\u0105",
                few: "elementus",
                many: "element\u0173"
            },
            verb: {
                smaller: {
                    inclusive: "turi tur\u0117ti ne daugiau kaip",
                    notInclusive: "turi tur\u0117ti ma\u017Eiau kaip"
                },
                bigger: {
                    inclusive: "turi tur\u0117ti ne ma\u017Eiau kaip",
                    notInclusive: "turi tur\u0117ti daugiau kaip"
                }
            }
        }
    };
    function getSizing(origin, unitType, inclusive, targetShouldBe) {
        const result = Sizable[origin] ?? null;
        if (result === null) return result;
        return {
            unit: result.unit[unitType],
            verb: result.verb[targetShouldBe][inclusive ? "inclusive" : "notInclusive"]
        };
    }
    const FormatDictionary = {
        regex: "\u012Fvestis",
        email: "el. pa\u0161to adresas",
        url: "URL",
        emoji: "jaustukas",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO data ir laikas",
        date: "ISO data",
        time: "ISO laikas",
        duration: "ISO trukm\u0117",
        ipv4: "IPv4 adresas",
        ipv6: "IPv6 adresas",
        cidrv4: "IPv4 tinklo prefiksas (CIDR)",
        cidrv6: "IPv6 tinklo prefiksas (CIDR)",
        base64: "base64 u\u017Ekoduota eilut\u0117",
        base64url: "base64url u\u017Ekoduota eilut\u0117",
        json_string: "JSON eilut\u0117",
        e164: "E.164 numeris",
        jwt: "JWT",
        template_literal: "\u012Fvestis"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "skai\u010Dius",
        bigint: "sveikasis skai\u010Dius",
        string: "eilut\u0117",
        boolean: "login\u0117 reik\u0161m\u0117",
        undefined: "neapibr\u0117\u017Eta reik\u0161m\u0117",
        function: "funkcija",
        symbol: "simbolis",
        array: "masyvas",
        object: "objektas",
        null: "nulin\u0117 reik\u0161m\u0117"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Gautas tipas ${received}, o tik\u{117}tasi - instanceof ${issue.expected}`;
                    return `Gautas tipas ${received}, o tik\u{117}tasi - ${expected}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Privalo b\u{16B}ti ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Privalo b\u{16B}ti vienas i\u{161} ${_utilJs.joinValues(issue.values, "|")} pasirinkim\u{173}`;
            case "too_big":
                {
                    const origin = TypeDictionary[issue.origin] ?? issue.origin;
                    const sizing = getSizing(issue.origin, getUnitTypeFromNumber(Number(issue.maximum)), issue.inclusive ?? false, "smaller");
                    if (sizing?.verb) return `${capitalizeFirstCharacter(origin ?? issue.origin ?? "reik\u0161m\u0117")} ${sizing.verb} ${issue.maximum.toString()} ${sizing.unit ?? "element\u0173"}`;
                    const adj = issue.inclusive ? "ne didesnis kaip" : "ma\u017Eesnis kaip";
                    return `${capitalizeFirstCharacter(origin ?? issue.origin ?? "reik\u0161m\u0117")} turi b\u{16B}ti ${adj} ${issue.maximum.toString()} ${sizing?.unit}`;
                }
            case "too_small":
                {
                    const origin = TypeDictionary[issue.origin] ?? issue.origin;
                    const sizing = getSizing(issue.origin, getUnitTypeFromNumber(Number(issue.minimum)), issue.inclusive ?? false, "bigger");
                    if (sizing?.verb) return `${capitalizeFirstCharacter(origin ?? issue.origin ?? "reik\u0161m\u0117")} ${sizing.verb} ${issue.minimum.toString()} ${sizing.unit ?? "element\u0173"}`;
                    const adj = issue.inclusive ? "ne ma\u017Eesnis kaip" : "didesnis kaip";
                    return `${capitalizeFirstCharacter(origin ?? issue.origin ?? "reik\u0161m\u0117")} turi b\u{16B}ti ${adj} ${issue.minimum.toString()} ${sizing?.unit}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Eilut\u{117} privalo prasid\u{117}ti "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Eilut\u{117} privalo pasibaigti "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Eilut\u{117} privalo \u{12F}traukti "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Eilut\u{117} privalo atitikti ${_issue.pattern}`;
                    return `Neteisingas ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Skai\u{10D}ius privalo b\u{16B}ti ${issue.divisor} kartotinis.`;
            case "unrecognized_keys":
                return `Neatpa\u{17E}int${issue.keys.length > 1 ? "i" : "as"} rakt${issue.keys.length > 1 ? "ai" : "as"}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return "Rastas klaidingas raktas";
            case "invalid_union":
                return "Klaidinga \u012Fvestis";
            case "invalid_element":
                {
                    const origin = TypeDictionary[issue.origin] ?? issue.origin;
                    return `${capitalizeFirstCharacter(origin ?? issue.origin ?? "reik\u0161m\u0117")} turi klaiding\u{105} \u{12F}vest\u{12F}`;
                }
            default:
                return "Klaidinga \u012Fvestis";
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"aGcvI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\u0437\u043D\u0430\u0446\u0438",
            verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442"
        },
        file: {
            unit: "\u0431\u0430\u0458\u0442\u0438",
            verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442"
        },
        array: {
            unit: "\u0441\u0442\u0430\u0432\u043A\u0438",
            verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442"
        },
        set: {
            unit: "\u0441\u0442\u0430\u0432\u043A\u0438",
            verb: "\u0434\u0430 \u0438\u043C\u0430\u0430\u0442"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0432\u043D\u0435\u0441",
        email: "\u0430\u0434\u0440\u0435\u0441\u0430 \u043D\u0430 \u0435-\u043F\u043E\u0448\u0442\u0430",
        url: "URL",
        emoji: "\u0435\u043C\u043E\u045F\u0438",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0434\u0430\u0442\u0443\u043C \u0438 \u0432\u0440\u0435\u043C\u0435",
        date: "ISO \u0434\u0430\u0442\u0443\u043C",
        time: "ISO \u0432\u0440\u0435\u043C\u0435",
        duration: "ISO \u0432\u0440\u0435\u043C\u0435\u0442\u0440\u0430\u0435\u045A\u0435",
        ipv4: "IPv4 \u0430\u0434\u0440\u0435\u0441\u0430",
        ipv6: "IPv6 \u0430\u0434\u0440\u0435\u0441\u0430",
        cidrv4: "IPv4 \u043E\u043F\u0441\u0435\u0433",
        cidrv6: "IPv6 \u043E\u043F\u0441\u0435\u0433",
        base64: "base64-\u0435\u043D\u043A\u043E\u0434\u0438\u0440\u0430\u043D\u0430 \u043D\u0438\u0437\u0430",
        base64url: "base64url-\u0435\u043D\u043A\u043E\u0434\u0438\u0440\u0430\u043D\u0430 \u043D\u0438\u0437\u0430",
        json_string: "JSON \u043D\u0438\u0437\u0430",
        e164: "E.164 \u0431\u0440\u043E\u0458",
        jwt: "JWT",
        template_literal: "\u0432\u043D\u0435\u0441"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0431\u0440\u043E\u0458",
        array: "\u043D\u0438\u0437\u0430"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{413}\u{440}\u{435}\u{448}\u{435}\u{43D} \u{432}\u{43D}\u{435}\u{441}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} instanceof ${issue.expected}, \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{43E} ${received}`;
                    return `\u{413}\u{440}\u{435}\u{448}\u{435}\u{43D} \u{432}\u{43D}\u{435}\u{441}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} ${expected}, \u{43F}\u{440}\u{438}\u{43C}\u{435}\u{43D}\u{43E} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Invalid input: expected ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `\u{413}\u{440}\u{435}\u{448}\u{430}\u{43D}\u{430} \u{43E}\u{43F}\u{446}\u{438}\u{458}\u{430}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} \u{435}\u{434}\u{43D}\u{430} ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{41F}\u{440}\u{435}\u{43C}\u{43D}\u{43E}\u{433}\u{443} \u{433}\u{43E}\u{43B}\u{435}\u{43C}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} ${issue.origin ?? "\u0432\u0440\u0435\u0434\u043D\u043E\u0441\u0442\u0430"} \u{434}\u{430} \u{438}\u{43C}\u{430} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438"}`;
                    return `\u{41F}\u{440}\u{435}\u{43C}\u{43D}\u{43E}\u{433}\u{443} \u{433}\u{43E}\u{43B}\u{435}\u{43C}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} ${issue.origin ?? "\u0432\u0440\u0435\u0434\u043D\u043E\u0441\u0442\u0430"} \u{434}\u{430} \u{431}\u{438}\u{434}\u{435} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{41F}\u{440}\u{435}\u{43C}\u{43D}\u{43E}\u{433}\u{443} \u{43C}\u{430}\u{43B}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} ${issue.origin} \u{434}\u{430} \u{438}\u{43C}\u{430} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{41F}\u{440}\u{435}\u{43C}\u{43D}\u{43E}\u{433}\u{443} \u{43C}\u{430}\u{43B}: \u{441}\u{435} \u{43E}\u{447}\u{435}\u{43A}\u{443}\u{432}\u{430} ${issue.origin} \u{434}\u{430} \u{431}\u{438}\u{434}\u{435} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{41D}\u{435}\u{432}\u{430}\u{436}\u{435}\u{447}\u{43A}\u{430} \u{43D}\u{438}\u{437}\u{430}: \u{43C}\u{43E}\u{440}\u{430} \u{434}\u{430} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{43D}\u{443}\u{432}\u{430} \u{441}\u{43E} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{41D}\u{435}\u{432}\u{430}\u{436}\u{435}\u{447}\u{43A}\u{430} \u{43D}\u{438}\u{437}\u{430}: \u{43C}\u{43E}\u{440}\u{430} \u{434}\u{430} \u{437}\u{430}\u{432}\u{440}\u{448}\u{443}\u{432}\u{430} \u{441}\u{43E} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{41D}\u{435}\u{432}\u{430}\u{436}\u{435}\u{447}\u{43A}\u{430} \u{43D}\u{438}\u{437}\u{430}: \u{43C}\u{43E}\u{440}\u{430} \u{434}\u{430} \u{432}\u{43A}\u{43B}\u{443}\u{447}\u{443}\u{432}\u{430} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{41D}\u{435}\u{432}\u{430}\u{436}\u{435}\u{447}\u{43A}\u{430} \u{43D}\u{438}\u{437}\u{430}: \u{43C}\u{43E}\u{440}\u{430} \u{434}\u{430} \u{43E}\u{434}\u{433}\u{43E}\u{430}\u{440}\u{430} \u{43D}\u{430} \u{43F}\u{430}\u{442}\u{435}\u{440}\u{43D}\u{43E}\u{442} ${_issue.pattern}`;
                    return `Invalid ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{413}\u{440}\u{435}\u{448}\u{435}\u{43D} \u{431}\u{440}\u{43E}\u{458}: \u{43C}\u{43E}\u{440}\u{430} \u{434}\u{430} \u{431}\u{438}\u{434}\u{435} \u{434}\u{435}\u{43B}\u{438}\u{432} \u{441}\u{43E} ${issue.divisor}`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "\u041D\u0435\u043F\u0440\u0435\u043F\u043E\u0437\u043D\u0430\u0435\u043D\u0438 \u043A\u043B\u0443\u0447\u0435\u0432\u0438" : "\u041D\u0435\u043F\u0440\u0435\u043F\u043E\u0437\u043D\u0430\u0435\u043D \u043A\u043B\u0443\u0447"}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{413}\u{440}\u{435}\u{448}\u{435}\u{43D} \u{43A}\u{43B}\u{443}\u{447} \u{432}\u{43E} ${issue.origin}`;
            case "invalid_union":
                return "\u0413\u0440\u0435\u0448\u0435\u043D \u0432\u043D\u0435\u0441";
            case "invalid_element":
                return `\u{413}\u{440}\u{435}\u{448}\u{43D}\u{430} \u{432}\u{440}\u{435}\u{434}\u{43D}\u{43E}\u{441}\u{442} \u{432}\u{43E} ${issue.origin}`;
            default:
                return `\u{413}\u{440}\u{435}\u{448}\u{435}\u{43D} \u{432}\u{43D}\u{435}\u{441}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6OryG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "aksara",
            verb: "mempunyai"
        },
        file: {
            unit: "bait",
            verb: "mempunyai"
        },
        array: {
            unit: "elemen",
            verb: "mempunyai"
        },
        set: {
            unit: "elemen",
            verb: "mempunyai"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "alamat e-mel",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "tarikh masa ISO",
        date: "tarikh ISO",
        time: "masa ISO",
        duration: "tempoh ISO",
        ipv4: "alamat IPv4",
        ipv6: "alamat IPv6",
        cidrv4: "julat IPv4",
        cidrv6: "julat IPv6",
        base64: "string dikodkan base64",
        base64url: "string dikodkan base64url",
        json_string: "string JSON",
        e164: "nombor E.164",
        jwt: "JWT",
        template_literal: "input"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "nombor"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Input tidak sah: dijangka instanceof ${issue.expected}, diterima ${received}`;
                    return `Input tidak sah: dijangka ${expected}, diterima ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Input tidak sah: dijangka ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Pilihan tidak sah: dijangka salah satu daripada ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Terlalu besar: dijangka ${issue.origin ?? "nilai"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elemen"}`;
                    return `Terlalu besar: dijangka ${issue.origin ?? "nilai"} adalah ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Terlalu kecil: dijangka ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Terlalu kecil: dijangka ${issue.origin} adalah ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `String tidak sah: mesti bermula dengan "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `String tidak sah: mesti berakhir dengan "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `String tidak sah: mesti mengandungi "${_issue.includes}"`;
                    if (_issue.format === "regex") return `String tidak sah: mesti sepadan dengan corak ${_issue.pattern}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} tidak sah`;
                }
            case "not_multiple_of":
                return `Nombor tidak sah: perlu gandaan ${issue.divisor}`;
            case "unrecognized_keys":
                return `Kunci tidak dikenali: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Kunci tidak sah dalam ${issue.origin}`;
            case "invalid_union":
                return "Input tidak sah";
            case "invalid_element":
                return `Nilai tidak sah dalam ${issue.origin}`;
            default:
                return `Input tidak sah`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"a0j2t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "tekens",
            verb: "heeft"
        },
        file: {
            unit: "bytes",
            verb: "heeft"
        },
        array: {
            unit: "elementen",
            verb: "heeft"
        },
        set: {
            unit: "elementen",
            verb: "heeft"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "invoer",
        email: "emailadres",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datum en tijd",
        date: "ISO datum",
        time: "ISO tijd",
        duration: "ISO duur",
        ipv4: "IPv4-adres",
        ipv6: "IPv6-adres",
        cidrv4: "IPv4-bereik",
        cidrv6: "IPv6-bereik",
        base64: "base64-gecodeerde tekst",
        base64url: "base64 URL-gecodeerde tekst",
        json_string: "JSON string",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "invoer"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "getal"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Ongeldige invoer: verwacht instanceof ${issue.expected}, ontving ${received}`;
                    return `Ongeldige invoer: verwacht ${expected}, ontving ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Ongeldige invoer: verwacht ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Ongeldige optie: verwacht \xe9\xe9n van ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    const longName = issue.origin === "date" ? "laat" : issue.origin === "string" ? "lang" : "groot";
                    if (sizing) return `Te ${longName}: verwacht dat ${issue.origin ?? "waarde"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementen"} ${sizing.verb}`;
                    return `Te ${longName}: verwacht dat ${issue.origin ?? "waarde"} ${adj}${issue.maximum.toString()} is`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    const shortName = issue.origin === "date" ? "vroeg" : issue.origin === "string" ? "kort" : "klein";
                    if (sizing) return `Te ${shortName}: verwacht dat ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} ${sizing.verb}`;
                    return `Te ${shortName}: verwacht dat ${issue.origin} ${adj}${issue.minimum.toString()} is`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ongeldige tekst: moet met "${_issue.prefix}" beginnen`;
                    if (_issue.format === "ends_with") return `Ongeldige tekst: moet op "${_issue.suffix}" eindigen`;
                    if (_issue.format === "includes") return `Ongeldige tekst: moet "${_issue.includes}" bevatten`;
                    if (_issue.format === "regex") return `Ongeldige tekst: moet overeenkomen met patroon ${_issue.pattern}`;
                    return `Ongeldig: ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ongeldig getal: moet een veelvoud van ${issue.divisor} zijn`;
            case "unrecognized_keys":
                return `Onbekende key${issue.keys.length > 1 ? "s" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Ongeldige key in ${issue.origin}`;
            case "invalid_union":
                return "Ongeldige invoer";
            case "invalid_element":
                return `Ongeldige waarde in ${issue.origin}`;
            default:
                return `Ongeldige invoer`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"21t6k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "tegn",
            verb: "\xe5 ha"
        },
        file: {
            unit: "bytes",
            verb: "\xe5 ha"
        },
        array: {
            unit: "elementer",
            verb: "\xe5 inneholde"
        },
        set: {
            unit: "elementer",
            verb: "\xe5 inneholde"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "e-postadresse",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO dato- og klokkeslett",
        date: "ISO-dato",
        time: "ISO-klokkeslett",
        duration: "ISO-varighet",
        ipv4: "IPv4-omr\xe5de",
        ipv6: "IPv6-omr\xe5de",
        cidrv4: "IPv4-spekter",
        cidrv6: "IPv6-spekter",
        base64: "base64-enkodet streng",
        base64url: "base64url-enkodet streng",
        json_string: "JSON-streng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "input"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "tall",
        array: "liste"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Ugyldig input: forventet instanceof ${issue.expected}, fikk ${received}`;
                    return `Ugyldig input: forventet ${expected}, fikk ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Ugyldig verdi: forventet ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Ugyldig valg: forventet en av ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `For stor(t): forventet ${issue.origin ?? "value"} til \xe5 ha ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementer"}`;
                    return `For stor(t): forventet ${issue.origin ?? "value"} til \xe5 ha ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `For lite(n): forventet ${issue.origin} til \xe5 ha ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `For lite(n): forventet ${issue.origin} til \xe5 ha ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ugyldig streng: m\xe5 starte med "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Ugyldig streng: m\xe5 ende med "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Ugyldig streng: m\xe5 inneholde "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Ugyldig streng: m\xe5 matche m\xf8nsteret ${_issue.pattern}`;
                    return `Ugyldig ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ugyldig tall: m\xe5 v\xe6re et multiplum av ${issue.divisor}`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "Ukjente n\xf8kler" : "Ukjent n\xf8kkel"}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Ugyldig n\xf8kkel i ${issue.origin}`;
            case "invalid_union":
                return "Ugyldig input";
            case "invalid_element":
                return `Ugyldig verdi i ${issue.origin}`;
            default:
                return `Ugyldig input`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"f88MQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "harf",
            verb: "olmal\u0131d\u0131r"
        },
        file: {
            unit: "bayt",
            verb: "olmal\u0131d\u0131r"
        },
        array: {
            unit: "unsur",
            verb: "olmal\u0131d\u0131r"
        },
        set: {
            unit: "unsur",
            verb: "olmal\u0131d\u0131r"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "giren",
        email: "epostag\xe2h",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO heng\xe2m\u0131",
        date: "ISO tarihi",
        time: "ISO zaman\u0131",
        duration: "ISO m\xfcddeti",
        ipv4: "IPv4 ni\u015F\xe2n\u0131",
        ipv6: "IPv6 ni\u015F\xe2n\u0131",
        cidrv4: "IPv4 menzili",
        cidrv6: "IPv6 menzili",
        base64: "base64-\u015Fifreli metin",
        base64url: "base64url-\u015Fifreli metin",
        json_string: "JSON metin",
        e164: "E.164 say\u0131s\u0131",
        jwt: "JWT",
        template_literal: "giren"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "numara",
        array: "saf",
        null: "gayb"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `F\xe2sit giren: umulan instanceof ${issue.expected}, al\u{131}nan ${received}`;
                    return `F\xe2sit giren: umulan ${expected}, al\u{131}nan ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `F\xe2sit giren: umulan ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `F\xe2sit tercih: m\xfbteberler ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Fazla b\xfcy\xfck: ${issue.origin ?? "value"}, ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elements"} sahip olmal\u{131}yd\u{131}.`;
                    return `Fazla b\xfcy\xfck: ${issue.origin ?? "value"}, ${adj}${issue.maximum.toString()} olmal\u{131}yd\u{131}.`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Fazla k\xfc\xe7\xfck: ${issue.origin}, ${adj}${issue.minimum.toString()} ${sizing.unit} sahip olmal\u{131}yd\u{131}.`;
                    return `Fazla k\xfc\xe7\xfck: ${issue.origin}, ${adj}${issue.minimum.toString()} olmal\u{131}yd\u{131}.`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `F\xe2sit metin: "${_issue.prefix}" ile ba\u{15F}lamal\u{131}.`;
                    if (_issue.format === "ends_with") return `F\xe2sit metin: "${_issue.suffix}" ile bitmeli.`;
                    if (_issue.format === "includes") return `F\xe2sit metin: "${_issue.includes}" ihtiv\xe2 etmeli.`;
                    if (_issue.format === "regex") return `F\xe2sit metin: ${_issue.pattern} nak\u{15F}\u{131}na uymal\u{131}.`;
                    return `F\xe2sit ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `F\xe2sit say\u{131}: ${issue.divisor} kat\u{131} olmal\u{131}yd\u{131}.`;
            case "unrecognized_keys":
                return `Tan\u{131}nmayan anahtar ${issue.keys.length > 1 ? "s" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} i\xe7in tan\u{131}nmayan anahtar var.`;
            case "invalid_union":
                return "Giren tan\u0131namad\u0131.";
            case "invalid_element":
                return `${issue.origin} i\xe7in tan\u{131}nmayan k\u{131}ymet var.`;
            default:
                return `K\u{131}ymet tan\u{131}namad\u{131}.`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3v7j6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\u062A\u0648\u06A9\u064A",
            verb: "\u0648\u0644\u0631\u064A"
        },
        file: {
            unit: "\u0628\u0627\u06CC\u067C\u0633",
            verb: "\u0648\u0644\u0631\u064A"
        },
        array: {
            unit: "\u062A\u0648\u06A9\u064A",
            verb: "\u0648\u0644\u0631\u064A"
        },
        set: {
            unit: "\u062A\u0648\u06A9\u064A",
            verb: "\u0648\u0644\u0631\u064A"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0648\u0631\u0648\u062F\u064A",
        email: "\u0628\u0631\u06CC\u069A\u0646\u0627\u0644\u06CC\u06A9",
        url: "\u06CC\u0648 \u0622\u0631 \u0627\u0644",
        emoji: "\u0627\u06CC\u0645\u0648\u062C\u064A",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u0646\u06CC\u067C\u0647 \u0627\u0648 \u0648\u062E\u062A",
        date: "\u0646\u06D0\u067C\u0647",
        time: "\u0648\u062E\u062A",
        duration: "\u0645\u0648\u062F\u0647",
        ipv4: "\u062F IPv4 \u067E\u062A\u0647",
        ipv6: "\u062F IPv6 \u067E\u062A\u0647",
        cidrv4: "\u062F IPv4 \u0633\u0627\u062D\u0647",
        cidrv6: "\u062F IPv6 \u0633\u0627\u062D\u0647",
        base64: "base64-encoded \u0645\u062A\u0646",
        base64url: "base64url-encoded \u0645\u062A\u0646",
        json_string: "JSON \u0645\u062A\u0646",
        e164: "\u062F E.164 \u0634\u0645\u06D0\u0631\u0647",
        jwt: "JWT",
        template_literal: "\u0648\u0631\u0648\u062F\u064A"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0639\u062F\u062F",
        array: "\u0627\u0631\u06D0"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{646}\u{627}\u{633}\u{645} \u{648}\u{631}\u{648}\u{62F}\u{64A}: \u{628}\u{627}\u{6CC}\u{62F} instanceof ${issue.expected} \u{648}\u{627}\u{6CC}, \u{645}\u{6AB}\u{631} ${received} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{634}\u{648}`;
                    return `\u{646}\u{627}\u{633}\u{645} \u{648}\u{631}\u{648}\u{62F}\u{64A}: \u{628}\u{627}\u{6CC}\u{62F} ${expected} \u{648}\u{627}\u{6CC}, \u{645}\u{6AB}\u{631} ${received} \u{62A}\u{631}\u{644}\u{627}\u{633}\u{647} \u{634}\u{648}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{646}\u{627}\u{633}\u{645} \u{648}\u{631}\u{648}\u{62F}\u{64A}: \u{628}\u{627}\u{6CC}\u{62F} ${_utilJs.stringifyPrimitive(issue.values[0])} \u{648}\u{627}\u{6CC}`;
                return `\u{646}\u{627}\u{633}\u{645} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628}: \u{628}\u{627}\u{6CC}\u{62F} \u{6CC}\u{648} \u{644}\u{647} ${_utilJs.joinValues(issue.values, "|")} \u{685}\u{62E}\u{647} \u{648}\u{627}\u{6CC}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{689}\u{6CC}\u{631} \u{644}\u{648}\u{6CC}: ${issue.origin ?? "\u0627\u0631\u0632\u069A\u062A"} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0635\u0631\u0648\u0646\u0647"} \u{648}\u{644}\u{631}\u{64A}`;
                    return `\u{689}\u{6CC}\u{631} \u{644}\u{648}\u{6CC}: ${issue.origin ?? "\u0627\u0631\u0632\u069A\u062A"} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.maximum.toString()} \u{648}\u{64A}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{689}\u{6CC}\u{631} \u{6A9}\u{648}\u{686}\u{646}\u{6CC}: ${issue.origin} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.minimum.toString()} ${sizing.unit} \u{648}\u{644}\u{631}\u{64A}`;
                    return `\u{689}\u{6CC}\u{631} \u{6A9}\u{648}\u{686}\u{646}\u{6CC}: ${issue.origin} \u{628}\u{627}\u{6CC}\u{62F} ${adj}${issue.minimum.toString()} \u{648}\u{64A}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{646}\u{627}\u{633}\u{645} \u{645}\u{62A}\u{646}: \u{628}\u{627}\u{6CC}\u{62F} \u{62F} "${_issue.prefix}" \u{633}\u{631}\u{647} \u{67E}\u{6CC}\u{644} \u{634}\u{64A}`;
                    if (_issue.format === "ends_with") return `\u{646}\u{627}\u{633}\u{645} \u{645}\u{62A}\u{646}: \u{628}\u{627}\u{6CC}\u{62F} \u{62F} "${_issue.suffix}" \u{633}\u{631}\u{647} \u{67E}\u{627}\u{6CC} \u{62A}\u{647} \u{648}\u{631}\u{633}\u{64A}\u{696}\u{64A}`;
                    if (_issue.format === "includes") return `\u{646}\u{627}\u{633}\u{645} \u{645}\u{62A}\u{646}: \u{628}\u{627}\u{6CC}\u{62F} "${_issue.includes}" \u{648}\u{644}\u{631}\u{64A}`;
                    if (_issue.format === "regex") return `\u{646}\u{627}\u{633}\u{645} \u{645}\u{62A}\u{646}: \u{628}\u{627}\u{6CC}\u{62F} \u{62F} ${_issue.pattern} \u{633}\u{631}\u{647} \u{645}\u{637}\u{627}\u{628}\u{642}\u{62A} \u{648}\u{644}\u{631}\u{64A}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} \u{646}\u{627}\u{633}\u{645} \u{62F}\u{6CC}`;
                }
            case "not_multiple_of":
                return `\u{646}\u{627}\u{633}\u{645} \u{639}\u{62F}\u{62F}: \u{628}\u{627}\u{6CC}\u{62F} \u{62F} ${issue.divisor} \u{645}\u{636}\u{631}\u{628} \u{648}\u{64A}`;
            case "unrecognized_keys":
                return `\u{646}\u{627}\u{633}\u{645} ${issue.keys.length > 1 ? "\u06A9\u0644\u06CC\u0689\u0648\u0646\u0647" : "\u06A9\u0644\u06CC\u0689"}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{646}\u{627}\u{633}\u{645} \u{6A9}\u{644}\u{6CC}\u{689} \u{67E}\u{647} ${issue.origin} \u{6A9}\u{6D0}`;
            case "invalid_union":
                return `\u{646}\u{627}\u{633}\u{645}\u{647} \u{648}\u{631}\u{648}\u{62F}\u{64A}`;
            case "invalid_element":
                return `\u{646}\u{627}\u{633}\u{645} \u{639}\u{646}\u{635}\u{631} \u{67E}\u{647} ${issue.origin} \u{6A9}\u{6D0}`;
            default:
                return `\u{646}\u{627}\u{633}\u{645}\u{647} \u{648}\u{631}\u{648}\u{62F}\u{64A}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"k6EpX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "znak\xf3w",
            verb: "mie\u0107"
        },
        file: {
            unit: "bajt\xf3w",
            verb: "mie\u0107"
        },
        array: {
            unit: "element\xf3w",
            verb: "mie\u0107"
        },
        set: {
            unit: "element\xf3w",
            verb: "mie\u0107"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "wyra\u017Cenie",
        email: "adres email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data i godzina w formacie ISO",
        date: "data w formacie ISO",
        time: "godzina w formacie ISO",
        duration: "czas trwania ISO",
        ipv4: "adres IPv4",
        ipv6: "adres IPv6",
        cidrv4: "zakres IPv4",
        cidrv6: "zakres IPv6",
        base64: "ci\u0105g znak\xf3w zakodowany w formacie base64",
        base64url: "ci\u0105g znak\xf3w zakodowany w formacie base64url",
        json_string: "ci\u0105g znak\xf3w w formacie JSON",
        e164: "liczba E.164",
        jwt: "JWT",
        template_literal: "wej\u015Bcie"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "liczba",
        array: "tablica"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Nieprawid\u{142}owe dane wej\u{15B}ciowe: oczekiwano instanceof ${issue.expected}, otrzymano ${received}`;
                    return `Nieprawid\u{142}owe dane wej\u{15B}ciowe: oczekiwano ${expected}, otrzymano ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Nieprawid\u{142}owe dane wej\u{15B}ciowe: oczekiwano ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Nieprawid\u{142}owa opcja: oczekiwano jednej z warto\u{15B}ci ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Za du\u{17C}a warto\u{15B}\u{107}: oczekiwano, \u{17C}e ${issue.origin ?? "warto\u015B\u0107"} b\u{119}dzie mie\u{107} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "element\xf3w"}`;
                    return `Zbyt du\u{17C}(y/a/e): oczekiwano, \u{17C}e ${issue.origin ?? "warto\u015B\u0107"} b\u{119}dzie wynosi\u{107} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Za ma\u{142}a warto\u{15B}\u{107}: oczekiwano, \u{17C}e ${issue.origin ?? "warto\u015B\u0107"} b\u{119}dzie mie\u{107} ${adj}${issue.minimum.toString()} ${sizing.unit ?? "element\xf3w"}`;
                    return `Zbyt ma\u{142}(y/a/e): oczekiwano, \u{17C}e ${issue.origin ?? "warto\u015B\u0107"} b\u{119}dzie wynosi\u{107} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Nieprawid\u{142}owy ci\u{105}g znak\xf3w: musi zaczyna\u{107} si\u{119} od "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Nieprawid\u{142}owy ci\u{105}g znak\xf3w: musi ko\u{144}czy\u{107} si\u{119} na "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Nieprawid\u{142}owy ci\u{105}g znak\xf3w: musi zawiera\u{107} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Nieprawid\u{142}owy ci\u{105}g znak\xf3w: musi odpowiada\u{107} wzorcowi ${_issue.pattern}`;
                    return `Nieprawid\u{142}ow(y/a/e) ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Nieprawid\u{142}owa liczba: musi by\u{107} wielokrotno\u{15B}ci\u{105} ${issue.divisor}`;
            case "unrecognized_keys":
                return `Nierozpoznane klucze${issue.keys.length > 1 ? "s" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Nieprawid\u{142}owy klucz w ${issue.origin}`;
            case "invalid_union":
                return "Nieprawid\u0142owe dane wej\u015Bciowe";
            case "invalid_element":
                return `Nieprawid\u{142}owa warto\u{15B}\u{107} w ${issue.origin}`;
            default:
                return `Nieprawid\u{142}owe dane wej\u{15B}ciowe`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"31Zoi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "caracteres",
            verb: "ter"
        },
        file: {
            unit: "bytes",
            verb: "ter"
        },
        array: {
            unit: "itens",
            verb: "ter"
        },
        set: {
            unit: "itens",
            verb: "ter"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "padr\xe3o",
        email: "endere\xe7o de e-mail",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "data e hora ISO",
        date: "data ISO",
        time: "hora ISO",
        duration: "dura\xe7\xe3o ISO",
        ipv4: "endere\xe7o IPv4",
        ipv6: "endere\xe7o IPv6",
        cidrv4: "faixa de IPv4",
        cidrv6: "faixa de IPv6",
        base64: "texto codificado em base64",
        base64url: "URL codificada em base64",
        json_string: "texto JSON",
        e164: "n\xfamero E.164",
        jwt: "JWT",
        template_literal: "entrada"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "n\xfamero",
        null: "nulo"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Tipo inv\xe1lido: esperado instanceof ${issue.expected}, recebido ${received}`;
                    return `Tipo inv\xe1lido: esperado ${expected}, recebido ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Entrada inv\xe1lida: esperado ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Op\xe7\xe3o inv\xe1lida: esperada uma das ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Muito grande: esperado que ${issue.origin ?? "valor"} tivesse ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementos"}`;
                    return `Muito grande: esperado que ${issue.origin ?? "valor"} fosse ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Muito pequeno: esperado que ${issue.origin} tivesse ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Muito pequeno: esperado que ${issue.origin} fosse ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Texto inv\xe1lido: deve come\xe7ar com "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Texto inv\xe1lido: deve terminar com "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Texto inv\xe1lido: deve incluir "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Texto inv\xe1lido: deve corresponder ao padr\xe3o ${_issue.pattern}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} inv\xe1lido`;
                }
            case "not_multiple_of":
                return `N\xfamero inv\xe1lido: deve ser m\xfaltiplo de ${issue.divisor}`;
            case "unrecognized_keys":
                return `Chave${issue.keys.length > 1 ? "s" : ""} desconhecida${issue.keys.length > 1 ? "s" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Chave inv\xe1lida em ${issue.origin}`;
            case "invalid_union":
                return "Entrada inv\xe1lida";
            case "invalid_element":
                return `Valor inv\xe1lido em ${issue.origin}`;
            default:
                return `Campo inv\xe1lido`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5ZN7a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
function getRussianPlural(count, one, few, many) {
    const absCount = Math.abs(count);
    const lastDigit = absCount % 10;
    const lastTwoDigits = absCount % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return many;
    if (lastDigit === 1) return one;
    if (lastDigit >= 2 && lastDigit <= 4) return few;
    return many;
}
const error = ()=>{
    const Sizable = {
        string: {
            unit: {
                one: "\u0441\u0438\u043C\u0432\u043E\u043B",
                few: "\u0441\u0438\u043C\u0432\u043E\u043B\u0430",
                many: "\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432"
            },
            verb: "\u0438\u043C\u0435\u0442\u044C"
        },
        file: {
            unit: {
                one: "\u0431\u0430\u0439\u0442",
                few: "\u0431\u0430\u0439\u0442\u0430",
                many: "\u0431\u0430\u0439\u0442"
            },
            verb: "\u0438\u043C\u0435\u0442\u044C"
        },
        array: {
            unit: {
                one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
                few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430",
                many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432"
            },
            verb: "\u0438\u043C\u0435\u0442\u044C"
        },
        set: {
            unit: {
                one: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442",
                few: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430",
                many: "\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432"
            },
            verb: "\u0438\u043C\u0435\u0442\u044C"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0432\u0432\u043E\u0434",
        email: "email \u0430\u0434\u0440\u0435\u0441",
        url: "URL",
        emoji: "\u044D\u043C\u043E\u0434\u0437\u0438",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0434\u0430\u0442\u0430 \u0438 \u0432\u0440\u0435\u043C\u044F",
        date: "ISO \u0434\u0430\u0442\u0430",
        time: "ISO \u0432\u0440\u0435\u043C\u044F",
        duration: "ISO \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C",
        ipv4: "IPv4 \u0430\u0434\u0440\u0435\u0441",
        ipv6: "IPv6 \u0430\u0434\u0440\u0435\u0441",
        cidrv4: "IPv4 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
        cidrv6: "IPv6 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
        base64: "\u0441\u0442\u0440\u043E\u043A\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 base64",
        base64url: "\u0441\u0442\u0440\u043E\u043A\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 base64url",
        json_string: "JSON \u0441\u0442\u0440\u043E\u043A\u0430",
        e164: "\u043D\u043E\u043C\u0435\u0440 E.164",
        jwt: "JWT",
        template_literal: "\u0432\u0432\u043E\u0434"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0447\u0438\u0441\u043B\u043E",
        array: "\u043C\u0430\u0441\u0441\u0438\u0432"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} \u{432}\u{432}\u{43E}\u{434}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} instanceof ${issue.expected}, \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{43E} ${received}`;
                    return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} \u{432}\u{432}\u{43E}\u{434}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} ${expected}, \u{43F}\u{43E}\u{43B}\u{443}\u{447}\u{435}\u{43D}\u{43E} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} \u{432}\u{432}\u{43E}\u{434}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} \u{432}\u{430}\u{440}\u{438}\u{430}\u{43D}\u{442}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} \u{43E}\u{434}\u{43D}\u{43E} \u{438}\u{437} ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const maxValue = Number(issue.maximum);
                        const unit = getRussianPlural(maxValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
                        return `\u{421}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C}, \u{447}\u{442}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435"} \u{431}\u{443}\u{434}\u{435}\u{442} \u{438}\u{43C}\u{435}\u{442}\u{44C} ${adj}${issue.maximum.toString()} ${unit}`;
                    }
                    return `\u{421}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C}, \u{447}\u{442}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435"} \u{431}\u{443}\u{434}\u{435}\u{442} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) {
                        const minValue = Number(issue.minimum);
                        const unit = getRussianPlural(minValue, sizing.unit.one, sizing.unit.few, sizing.unit.many);
                        return `\u{421}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{43C}\u{430}\u{43B}\u{435}\u{43D}\u{44C}\u{43A}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C}, \u{447}\u{442}\u{43E} ${issue.origin} \u{431}\u{443}\u{434}\u{435}\u{442} \u{438}\u{43C}\u{435}\u{442}\u{44C} ${adj}${issue.minimum.toString()} ${unit}`;
                    }
                    return `\u{421}\u{43B}\u{438}\u{448}\u{43A}\u{43E}\u{43C} \u{43C}\u{430}\u{43B}\u{435}\u{43D}\u{44C}\u{43A}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}: \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C}, \u{447}\u{442}\u{43E} ${issue.origin} \u{431}\u{443}\u{434}\u{435}\u{442} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430}: \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{43D}\u{430}\u{447}\u{438}\u{43D}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{441} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430}: \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{437}\u{430}\u{43A}\u{430}\u{43D}\u{447}\u{438}\u{432}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{43D}\u{430} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430}: \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{430}\u{44F} \u{441}\u{442}\u{440}\u{43E}\u{43A}\u{430}: \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{441}\u{43E}\u{43E}\u{442}\u{432}\u{435}\u{442}\u{441}\u{442}\u{432}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D}\u{443} ${_issue.pattern}`;
                    return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{43E}\u{435} \u{447}\u{438}\u{441}\u{43B}\u{43E}: \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43A}\u{440}\u{430}\u{442}\u{43D}\u{44B}\u{43C} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{41D}\u{435}\u{440}\u{430}\u{441}\u{43F}\u{43E}\u{437}\u{43D}\u{430}\u{43D}\u{43D}${issue.keys.length > 1 ? "\u044B\u0435" : "\u044B\u0439"} \u{43A}\u{43B}\u{44E}\u{447}${issue.keys.length > 1 ? "\u0438" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{439} \u{43A}\u{43B}\u{44E}\u{447} \u{432} ${issue.origin}`;
            case "invalid_union":
                return "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u0432\u0445\u043E\u0434\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435";
            case "invalid_element":
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{432} ${issue.origin}`;
            default:
                return `\u{41D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{44B}\u{435} \u{432}\u{445}\u{43E}\u{434}\u{43D}\u{44B}\u{435} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{435}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2IrWn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "znakov",
            verb: "imeti"
        },
        file: {
            unit: "bajtov",
            verb: "imeti"
        },
        array: {
            unit: "elementov",
            verb: "imeti"
        },
        set: {
            unit: "elementov",
            verb: "imeti"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "vnos",
        email: "e-po\u0161tni naslov",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datum in \u010Das",
        date: "ISO datum",
        time: "ISO \u010Das",
        duration: "ISO trajanje",
        ipv4: "IPv4 naslov",
        ipv6: "IPv6 naslov",
        cidrv4: "obseg IPv4",
        cidrv6: "obseg IPv6",
        base64: "base64 kodiran niz",
        base64url: "base64url kodiran niz",
        json_string: "JSON niz",
        e164: "E.164 \u0161tevilka",
        jwt: "JWT",
        template_literal: "vnos"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0161tevilo",
        array: "tabela"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Neveljaven vnos: pri\u{10D}akovano instanceof ${issue.expected}, prejeto ${received}`;
                    return `Neveljaven vnos: pri\u{10D}akovano ${expected}, prejeto ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Neveljaven vnos: pri\u{10D}akovano ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Neveljavna mo\u{17E}nost: pri\u{10D}akovano eno izmed ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Preveliko: pri\u{10D}akovano, da bo ${issue.origin ?? "vrednost"} imelo ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elementov"}`;
                    return `Preveliko: pri\u{10D}akovano, da bo ${issue.origin ?? "vrednost"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Premajhno: pri\u{10D}akovano, da bo ${issue.origin} imelo ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Premajhno: pri\u{10D}akovano, da bo ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Neveljaven niz: mora se za\u{10D}eti z "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Neveljaven niz: mora se kon\u{10D}ati z "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Neveljaven niz: mora vsebovati "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Neveljaven niz: mora ustrezati vzorcu ${_issue.pattern}`;
                    return `Neveljaven ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Neveljavno \u{161}tevilo: mora biti ve\u{10D}kratnik ${issue.divisor}`;
            case "unrecognized_keys":
                return `Neprepoznan${issue.keys.length > 1 ? "i klju\u010Di" : " klju\u010D"}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Neveljaven klju\u{10D} v ${issue.origin}`;
            case "invalid_union":
                return "Neveljaven vnos";
            case "invalid_element":
                return `Neveljavna vrednost v ${issue.origin}`;
            default:
                return "Neveljaven vnos";
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6aIy5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "tecken",
            verb: "att ha"
        },
        file: {
            unit: "bytes",
            verb: "att ha"
        },
        array: {
            unit: "objekt",
            verb: "att inneh\xe5lla"
        },
        set: {
            unit: "objekt",
            verb: "att inneh\xe5lla"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "regulj\xe4rt uttryck",
        email: "e-postadress",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO-datum och tid",
        date: "ISO-datum",
        time: "ISO-tid",
        duration: "ISO-varaktighet",
        ipv4: "IPv4-intervall",
        ipv6: "IPv6-intervall",
        cidrv4: "IPv4-spektrum",
        cidrv6: "IPv6-spektrum",
        base64: "base64-kodad str\xe4ng",
        base64url: "base64url-kodad str\xe4ng",
        json_string: "JSON-str\xe4ng",
        e164: "E.164-nummer",
        jwt: "JWT",
        template_literal: "mall-literal"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "antal",
        array: "lista"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Ogiltig inmatning: f\xf6rv\xe4ntat instanceof ${issue.expected}, fick ${received}`;
                    return `Ogiltig inmatning: f\xf6rv\xe4ntat ${expected}, fick ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Ogiltig inmatning: f\xf6rv\xe4ntat ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Ogiltigt val: f\xf6rv\xe4ntade en av ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `F\xf6r stor(t): f\xf6rv\xe4ntade ${issue.origin ?? "v\xe4rdet"} att ha ${adj}${issue.maximum.toString()} ${sizing.unit ?? "element"}`;
                    return `F\xf6r stor(t): f\xf6rv\xe4ntat ${issue.origin ?? "v\xe4rdet"} att ha ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `F\xf6r lite(t): f\xf6rv\xe4ntade ${issue.origin ?? "v\xe4rdet"} att ha ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `F\xf6r lite(t): f\xf6rv\xe4ntade ${issue.origin ?? "v\xe4rdet"} att ha ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ogiltig str\xe4ng: m\xe5ste b\xf6rja med "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Ogiltig str\xe4ng: m\xe5ste sluta med "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Ogiltig str\xe4ng: m\xe5ste inneh\xe5lla "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Ogiltig str\xe4ng: m\xe5ste matcha m\xf6nstret "${_issue.pattern}"`;
                    return `Ogiltig(t) ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ogiltigt tal: m\xe5ste vara en multipel av ${issue.divisor}`;
            case "unrecognized_keys":
                return `${issue.keys.length > 1 ? "Ok\xe4nda nycklar" : "Ok\xe4nd nyckel"}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Ogiltig nyckel i ${issue.origin ?? "v\xe4rdet"}`;
            case "invalid_union":
                return "Ogiltig input";
            case "invalid_element":
                return `Ogiltigt v\xe4rde i ${issue.origin ?? "v\xe4rdet"}`;
            default:
                return `Ogiltig input`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eIcb9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\u0B8E\u0BB4\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BCD\u0B95\u0BB3\u0BCD",
            verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD"
        },
        file: {
            unit: "\u0BAA\u0BC8\u0B9F\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD"
        },
        array: {
            unit: "\u0B89\u0BB1\u0BC1\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD",
            verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD"
        },
        set: {
            unit: "\u0B89\u0BB1\u0BC1\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD",
            verb: "\u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BBF\u0BB0\u0BC1\u0B95\u0BCD\u0B95 \u0BB5\u0BC7\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1",
        email: "\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BCD \u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u0BA4\u0BC7\u0BA4\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
        date: "ISO \u0BA4\u0BC7\u0BA4\u0BBF",
        time: "ISO \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
        duration: "ISO \u0B95\u0BBE\u0BB2 \u0B85\u0BB3\u0BB5\u0BC1",
        ipv4: "IPv4 \u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF",
        ipv6: "IPv6 \u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF",
        cidrv4: "IPv4 \u0BB5\u0BB0\u0BAE\u0BCD\u0BAA\u0BC1",
        cidrv6: "IPv6 \u0BB5\u0BB0\u0BAE\u0BCD\u0BAA\u0BC1",
        base64: "base64-encoded \u0B9A\u0BB0\u0BAE\u0BCD",
        base64url: "base64url-encoded \u0B9A\u0BB0\u0BAE\u0BCD",
        json_string: "JSON \u0B9A\u0BB0\u0BAE\u0BCD",
        e164: "E.164 \u0B8E\u0BA3\u0BCD",
        jwt: "JWT",
        template_literal: "input"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0B8E\u0BA3\u0BCD",
        array: "\u0B85\u0BA3\u0BBF",
        null: "\u0BB5\u0BC6\u0BB1\u0BC1\u0BAE\u0BC8"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B89}\u{BB3}\u{BCD}\u{BB3}\u{BC0}\u{B9F}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} instanceof ${issue.expected}, \u{BAA}\u{BC6}\u{BB1}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${received}`;
                    return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B89}\u{BB3}\u{BCD}\u{BB3}\u{BC0}\u{B9F}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${expected}, \u{BAA}\u{BC6}\u{BB1}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B89}\u{BB3}\u{BCD}\u{BB3}\u{BC0}\u{B9F}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{BB5}\u{BBF}\u{BB0}\u{BC1}\u{BAA}\u{BCD}\u{BAA}\u{BAE}\u{BCD}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${_utilJs.joinValues(issue.values, "|")} \u{B87}\u{BB2}\u{BCD} \u{B92}\u{BA9}\u{BCD}\u{BB1}\u{BC1}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{BAE}\u{BBF}\u{B95} \u{BAA}\u{BC6}\u{BB0}\u{BBF}\u{BAF}\u{BA4}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${issue.origin ?? "\u0BAE\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0B89\u0BB1\u0BC1\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD"} \u{B86}\u{B95} \u{B87}\u{BB0}\u{BC1}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                    return `\u{BAE}\u{BBF}\u{B95} \u{BAA}\u{BC6}\u{BB0}\u{BBF}\u{BAF}\u{BA4}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${issue.origin ?? "\u0BAE\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1"} ${adj}${issue.maximum.toString()} \u{B86}\u{B95} \u{B87}\u{BB0}\u{BC1}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{BAE}\u{BBF}\u{B95}\u{B9A}\u{BCD} \u{B9A}\u{BBF}\u{BB1}\u{BBF}\u{BAF}\u{BA4}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} \u{B86}\u{B95} \u{B87}\u{BB0}\u{BC1}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`; //
                    return `\u{BAE}\u{BBF}\u{B95}\u{B9A}\u{BCD} \u{B9A}\u{BBF}\u{BB1}\u{BBF}\u{BAF}\u{BA4}\u{BC1}: \u{B8E}\u{BA4}\u{BBF}\u{BB0}\u{BCD}\u{BAA}\u{BBE}\u{BB0}\u{BCD}\u{B95}\u{BCD}\u{B95}\u{BAA}\u{BCD}\u{BAA}\u{B9F}\u{BCD}\u{B9F}\u{BA4}\u{BC1} ${issue.origin} ${adj}${issue.minimum.toString()} \u{B86}\u{B95} \u{B87}\u{BB0}\u{BC1}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B9A}\u{BB0}\u{BAE}\u{BCD}: "${_issue.prefix}" \u{B87}\u{BB2}\u{BCD} \u{BA4}\u{BCA}\u{B9F}\u{B99}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                    if (_issue.format === "ends_with") return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B9A}\u{BB0}\u{BAE}\u{BCD}: "${_issue.suffix}" \u{B87}\u{BB2}\u{BCD} \u{BAE}\u{BC1}\u{B9F}\u{BBF}\u{BB5}\u{B9F}\u{BC8}\u{BAF} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                    if (_issue.format === "includes") return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B9A}\u{BB0}\u{BAE}\u{BCD}: "${_issue.includes}" \u{B90} \u{B89}\u{BB3}\u{BCD}\u{BB3}\u{B9F}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                    if (_issue.format === "regex") return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B9A}\u{BB0}\u{BAE}\u{BCD}: ${_issue.pattern} \u{BAE}\u{BC1}\u{BB1}\u{BC8}\u{BAA}\u{BBE}\u{B9F}\u{BCD}\u{B9F}\u{BC1}\u{B9F}\u{BA9}\u{BCD} \u{BAA}\u{BCA}\u{BB0}\u{BC1}\u{BA8}\u{BCD}\u{BA4} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
                    return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B8E}\u{BA3}\u{BCD}: ${issue.divisor} \u{B87}\u{BA9}\u{BCD} \u{BAA}\u{BB2}\u{BAE}\u{BBE}\u{B95} \u{B87}\u{BB0}\u{BC1}\u{B95}\u{BCD}\u{B95} \u{BB5}\u{BC7}\u{BA3}\u{BCD}\u{B9F}\u{BC1}\u{BAE}\u{BCD}`;
            case "unrecognized_keys":
                return `\u{B85}\u{B9F}\u{BC8}\u{BAF}\u{BBE}\u{BB3}\u{BAE}\u{BCD} \u{BA4}\u{BC6}\u{BB0}\u{BBF}\u{BAF}\u{BBE}\u{BA4} \u{BB5}\u{BBF}\u{B9A}\u{BC8}${issue.keys.length > 1 ? "\u0B95\u0BB3\u0BCD" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} \u{B87}\u{BB2}\u{BCD} \u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{BB5}\u{BBF}\u{B9A}\u{BC8}`;
            case "invalid_union":
                return "\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1";
            case "invalid_element":
                return `${issue.origin} \u{B87}\u{BB2}\u{BCD} \u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{BAE}\u{BA4}\u{BBF}\u{BAA}\u{BCD}\u{BAA}\u{BC1}`;
            default:
                return `\u{BA4}\u{BB5}\u{BB1}\u{BBE}\u{BA9} \u{B89}\u{BB3}\u{BCD}\u{BB3}\u{BC0}\u{B9F}\u{BC1}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"10AUw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23",
            verb: "\u0E04\u0E27\u0E23\u0E21\u0E35"
        },
        file: {
            unit: "\u0E44\u0E1A\u0E15\u0E4C",
            verb: "\u0E04\u0E27\u0E23\u0E21\u0E35"
        },
        array: {
            unit: "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
            verb: "\u0E04\u0E27\u0E23\u0E21\u0E35"
        },
        set: {
            unit: "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
            verb: "\u0E04\u0E27\u0E23\u0E21\u0E35"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E1B\u0E49\u0E2D\u0E19",
        email: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25",
        url: "URL",
        emoji: "\u0E2D\u0E34\u0E42\u0E21\u0E08\u0E34",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E40\u0E27\u0E25\u0E32\u0E41\u0E1A\u0E1A ISO",
        date: "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E41\u0E1A\u0E1A ISO",
        time: "\u0E40\u0E27\u0E25\u0E32\u0E41\u0E1A\u0E1A ISO",
        duration: "\u0E0A\u0E48\u0E27\u0E07\u0E40\u0E27\u0E25\u0E32\u0E41\u0E1A\u0E1A ISO",
        ipv4: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48 IPv4",
        ipv6: "\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48 IPv6",
        cidrv4: "\u0E0A\u0E48\u0E27\u0E07 IP \u0E41\u0E1A\u0E1A IPv4",
        cidrv6: "\u0E0A\u0E48\u0E27\u0E07 IP \u0E41\u0E1A\u0E1A IPv6",
        base64: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E1A\u0E1A Base64",
        base64url: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E1A\u0E1A Base64 \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A URL",
        json_string: "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E41\u0E1A\u0E1A JSON",
        e164: "\u0E40\u0E1A\u0E2D\u0E23\u0E4C\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28 (E.164)",
        jwt: "\u0E42\u0E17\u0E40\u0E04\u0E19 JWT",
        template_literal: "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E1B\u0E49\u0E2D\u0E19"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02",
        array: "\u0E2D\u0E32\u0E23\u0E4C\u0E40\u0E23\u0E22\u0E4C (Array)",
        null: "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E04\u0E48\u0E32 (null)"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E04}\u{E27}\u{E23}\u{E40}\u{E1B}\u{E47}\u{E19} instanceof ${issue.expected} \u{E41}\u{E15}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A} ${received}`;
                    return `\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E04}\u{E27}\u{E23}\u{E40}\u{E1B}\u{E47}\u{E19} ${expected} \u{E41}\u{E15}\u{E48}\u{E44}\u{E14}\u{E49}\u{E23}\u{E31}\u{E1A} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{E04}\u{E48}\u{E32}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E04}\u{E27}\u{E23}\u{E40}\u{E1B}\u{E47}\u{E19} ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `\u{E15}\u{E31}\u{E27}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E04}\u{E27}\u{E23}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E43}\u{E19} ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "\u0E44\u0E21\u0E48\u0E40\u0E01\u0E34\u0E19" : "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{E40}\u{E01}\u{E34}\u{E19}\u{E01}\u{E33}\u{E2B}\u{E19}\u{E14}: ${issue.origin ?? "\u0E04\u0E48\u0E32"} \u{E04}\u{E27}\u{E23}\u{E21}\u{E35}${adj} ${issue.maximum.toString()} ${sizing.unit ?? "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23"}`;
                    return `\u{E40}\u{E01}\u{E34}\u{E19}\u{E01}\u{E33}\u{E2B}\u{E19}\u{E14}: ${issue.origin ?? "\u0E04\u0E48\u0E32"} \u{E04}\u{E27}\u{E23}\u{E21}\u{E35}${adj} ${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? "\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22" : "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{E19}\u{E49}\u{E2D}\u{E22}\u{E01}\u{E27}\u{E48}\u{E32}\u{E01}\u{E33}\u{E2B}\u{E19}\u{E14}: ${issue.origin} \u{E04}\u{E27}\u{E23}\u{E21}\u{E35}${adj} ${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{E19}\u{E49}\u{E2D}\u{E22}\u{E01}\u{E27}\u{E48}\u{E32}\u{E01}\u{E33}\u{E2B}\u{E19}\u{E14}: ${issue.origin} \u{E04}\u{E27}\u{E23}\u{E21}\u{E35}${adj} ${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E02}\u{E36}\u{E49}\u{E19}\u{E15}\u{E49}\u{E19}\u{E14}\u{E49}\u{E27}\u{E22} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E25}\u{E07}\u{E17}\u{E49}\u{E32}\u{E22}\u{E14}\u{E49}\u{E27}\u{E22} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35} "${_issue.includes}" \u{E2D}\u{E22}\u{E39}\u{E48}\u{E43}\u{E19}\u{E02}\u{E49}\u{E2D}\u{E04}\u{E27}\u{E32}\u{E21}`;
                    if (_issue.format === "regex") return `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E15}\u{E49}\u{E2D}\u{E07}\u{E15}\u{E23}\u{E07}\u{E01}\u{E31}\u{E1A}\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E17}\u{E35}\u{E48}\u{E01}\u{E33}\u{E2B}\u{E19}\u{E14} ${_issue.pattern}`;
                    return `\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{E15}\u{E31}\u{E27}\u{E40}\u{E25}\u{E02}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}: \u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E08}\u{E33}\u{E19}\u{E27}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2B}\u{E32}\u{E23}\u{E14}\u{E49}\u{E27}\u{E22} ${issue.divisor} \u{E44}\u{E14}\u{E49}\u{E25}\u{E07}\u{E15}\u{E31}\u{E27}`;
            case "unrecognized_keys":
                return `\u{E1E}\u{E1A}\u{E04}\u{E35}\u{E22}\u{E4C}\u{E17}\u{E35}\u{E48}\u{E44}\u{E21}\u{E48}\u{E23}\u{E39}\u{E49}\u{E08}\u{E31}\u{E01}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{E04}\u{E35}\u{E22}\u{E4C}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E43}\u{E19} ${issue.origin}`;
            case "invalid_union":
                return "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07: \u0E44\u0E21\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E1A\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E22\u0E39\u0E40\u0E19\u0E35\u0E22\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E44\u0E27\u0E49";
            case "invalid_element":
                return `\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E43}\u{E19} ${issue.origin}`;
            default:
                return `\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9tMyQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "karakter",
            verb: "olmal\u0131"
        },
        file: {
            unit: "bayt",
            verb: "olmal\u0131"
        },
        array: {
            unit: "\xf6\u011Fe",
            verb: "olmal\u0131"
        },
        set: {
            unit: "\xf6\u011Fe",
            verb: "olmal\u0131"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "girdi",
        email: "e-posta adresi",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO tarih ve saat",
        date: "ISO tarih",
        time: "ISO saat",
        duration: "ISO s\xfcre",
        ipv4: "IPv4 adresi",
        ipv6: "IPv6 adresi",
        cidrv4: "IPv4 aral\u0131\u011F\u0131",
        cidrv6: "IPv6 aral\u0131\u011F\u0131",
        base64: "base64 ile \u015Fifrelenmi\u015F metin",
        base64url: "base64url ile \u015Fifrelenmi\u015F metin",
        json_string: "JSON dizesi",
        e164: "E.164 say\u0131s\u0131",
        jwt: "JWT",
        template_literal: "\u015Eablon dizesi"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Ge\xe7ersiz de\u{11F}er: beklenen instanceof ${issue.expected}, al\u{131}nan ${received}`;
                    return `Ge\xe7ersiz de\u{11F}er: beklenen ${expected}, al\u{131}nan ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Ge\xe7ersiz de\u{11F}er: beklenen ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Ge\xe7ersiz se\xe7enek: a\u{15F}a\u{11F}\u{131}dakilerden biri olmal\u{131}: ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\xc7ok b\xfcy\xfck: beklenen ${issue.origin ?? "de\u011Fer"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\xf6\u011Fe"}`;
                    return `\xc7ok b\xfcy\xfck: beklenen ${issue.origin ?? "de\u011Fer"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\xc7ok k\xfc\xe7\xfck: beklenen ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\xc7ok k\xfc\xe7\xfck: beklenen ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Ge\xe7ersiz metin: "${_issue.prefix}" ile ba\u{15F}lamal\u{131}`;
                    if (_issue.format === "ends_with") return `Ge\xe7ersiz metin: "${_issue.suffix}" ile bitmeli`;
                    if (_issue.format === "includes") return `Ge\xe7ersiz metin: "${_issue.includes}" i\xe7ermeli`;
                    if (_issue.format === "regex") return `Ge\xe7ersiz metin: ${_issue.pattern} desenine uymal\u{131}`;
                    return `Ge\xe7ersiz ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Ge\xe7ersiz say\u{131}: ${issue.divisor} ile tam b\xf6l\xfcnebilmeli`;
            case "unrecognized_keys":
                return `Tan\u{131}nmayan anahtar${issue.keys.length > 1 ? "lar" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} i\xe7inde ge\xe7ersiz anahtar`;
            case "invalid_union":
                return "Ge\xe7ersiz de\u011Fer";
            case "invalid_element":
                return `${issue.origin} i\xe7inde ge\xe7ersiz de\u{11F}er`;
            default:
                return `Ge\xe7ersiz de\u{11F}er`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"cLCYu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @deprecated Use `uk` instead. */ parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _ukJsDefault.default)();
    });
var _ukJs = require("./uk.js");
var _ukJsDefault = parcelHelpers.interopDefault(_ukJs);

},{"./uk.js":"hTLTa","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"hTLTa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
            verb: "\u043C\u0430\u0442\u0438\u043C\u0435"
        },
        file: {
            unit: "\u0431\u0430\u0439\u0442\u0456\u0432",
            verb: "\u043C\u0430\u0442\u0438\u043C\u0435"
        },
        array: {
            unit: "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432",
            verb: "\u043C\u0430\u0442\u0438\u043C\u0435"
        },
        set: {
            unit: "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432",
            verb: "\u043C\u0430\u0442\u0438\u043C\u0435"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0432\u0445\u0456\u0434\u043D\u0456 \u0434\u0430\u043D\u0456",
        email: "\u0430\u0434\u0440\u0435\u0441\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
        url: "URL",
        emoji: "\u0435\u043C\u043E\u0434\u0437\u0456",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\u0434\u0430\u0442\u0430 \u0442\u0430 \u0447\u0430\u0441 ISO",
        date: "\u0434\u0430\u0442\u0430 ISO",
        time: "\u0447\u0430\u0441 ISO",
        duration: "\u0442\u0440\u0438\u0432\u0430\u043B\u0456\u0441\u0442\u044C ISO",
        ipv4: "\u0430\u0434\u0440\u0435\u0441\u0430 IPv4",
        ipv6: "\u0430\u0434\u0440\u0435\u0441\u0430 IPv6",
        cidrv4: "\u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D IPv4",
        cidrv6: "\u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D IPv6",
        base64: "\u0440\u044F\u0434\u043E\u043A \u0443 \u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u0456 base64",
        base64url: "\u0440\u044F\u0434\u043E\u043A \u0443 \u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u0456 base64url",
        json_string: "\u0440\u044F\u0434\u043E\u043A JSON",
        e164: "\u043D\u043E\u043C\u0435\u0440 E.164",
        jwt: "JWT",
        template_literal: "\u0432\u0445\u0456\u0434\u043D\u0456 \u0434\u0430\u043D\u0456"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0447\u0438\u0441\u043B\u043E",
        array: "\u043C\u0430\u0441\u0438\u0432"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{456} \u{432}\u{445}\u{456}\u{434}\u{43D}\u{456} \u{434}\u{430}\u{43D}\u{456}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F} instanceof ${issue.expected}, \u{43E}\u{442}\u{440}\u{438}\u{43C}\u{430}\u{43D}\u{43E} ${received}`;
                    return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{456} \u{432}\u{445}\u{456}\u{434}\u{43D}\u{456} \u{434}\u{430}\u{43D}\u{456}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F} ${expected}, \u{43E}\u{442}\u{440}\u{438}\u{43C}\u{430}\u{43D}\u{43E} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{456} \u{432}\u{445}\u{456}\u{434}\u{43D}\u{456} \u{434}\u{430}\u{43D}\u{456}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F} ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{430} \u{43E}\u{43F}\u{446}\u{456}\u{44F}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F} \u{43E}\u{434}\u{43D}\u{435} \u{437} ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{43E} \u{432}\u{435}\u{43B}\u{438}\u{43A}\u{435}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F}, \u{449}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432"}`;
                    return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{43E} \u{432}\u{435}\u{43B}\u{438}\u{43A}\u{435}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F}, \u{449}\u{43E} ${issue.origin ?? "\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F"} \u{431}\u{443}\u{434}\u{435} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{43E} \u{43C}\u{430}\u{43B}\u{435}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F}, \u{449}\u{43E} ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{417}\u{430}\u{43D}\u{430}\u{434}\u{442}\u{43E} \u{43C}\u{430}\u{43B}\u{435}: \u{43E}\u{447}\u{456}\u{43A}\u{443}\u{454}\u{442}\u{44C}\u{441}\u{44F}, \u{449}\u{43E} ${issue.origin} \u{431}\u{443}\u{434}\u{435} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{440}\u{44F}\u{434}\u{43E}\u{43A}: \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{43F}\u{43E}\u{447}\u{438}\u{43D}\u{430}\u{442}\u{438}\u{441}\u{44F} \u{437} "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{440}\u{44F}\u{434}\u{43E}\u{43A}: \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{437}\u{430}\u{43A}\u{456}\u{43D}\u{447}\u{443}\u{432}\u{430}\u{442}\u{438}\u{441}\u{44F} \u{43D}\u{430} "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{440}\u{44F}\u{434}\u{43E}\u{43A}: \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{440}\u{44F}\u{434}\u{43E}\u{43A}: \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{432}\u{456}\u{434}\u{43F}\u{43E}\u{432}\u{456}\u{434}\u{430}\u{442}\u{438} \u{448}\u{430}\u{431}\u{43B}\u{43E}\u{43D}\u{443} ${_issue.pattern}`;
                    return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{435} \u{447}\u{438}\u{441}\u{43B}\u{43E}: \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{43D}\u{43E} \u{431}\u{443}\u{442}\u{438} \u{43A}\u{440}\u{430}\u{442}\u{43D}\u{438}\u{43C} ${issue.divisor}`;
            case "unrecognized_keys":
                return `\u{41D}\u{435}\u{440}\u{43E}\u{437}\u{43F}\u{456}\u{437}\u{43D}\u{430}\u{43D}\u{438}\u{439} \u{43A}\u{43B}\u{44E}\u{447}${issue.keys.length > 1 ? "\u0456" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{438}\u{439} \u{43A}\u{43B}\u{44E}\u{447} \u{443} ${issue.origin}`;
            case "invalid_union":
                return "\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0456 \u0432\u0445\u0456\u0434\u043D\u0456 \u0434\u0430\u043D\u0456";
            case "invalid_element":
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44F} \u{443} ${issue.origin}`;
            default:
                return `\u{41D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{456} \u{432}\u{445}\u{456}\u{434}\u{43D}\u{456} \u{434}\u{430}\u{43D}\u{456}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9NiID":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\u062D\u0631\u0648\u0641",
            verb: "\u06C1\u0648\u0646\u0627"
        },
        file: {
            unit: "\u0628\u0627\u0626\u0679\u0633",
            verb: "\u06C1\u0648\u0646\u0627"
        },
        array: {
            unit: "\u0622\u0626\u0679\u0645\u0632",
            verb: "\u06C1\u0648\u0646\u0627"
        },
        set: {
            unit: "\u0622\u0626\u0679\u0645\u0632",
            verb: "\u06C1\u0648\u0646\u0627"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0627\u0646 \u067E\u0679",
        email: "\u0627\u06CC \u0645\u06CC\u0644 \u0627\u06CC\u0688\u0631\u06CC\u0633",
        url: "\u06CC\u0648 \u0622\u0631 \u0627\u06CC\u0644",
        emoji: "\u0627\u06CC\u0645\u0648\u062C\u06CC",
        uuid: "\u06CC\u0648 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        uuidv4: "\u06CC\u0648 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC \u0648\u06CC 4",
        uuidv6: "\u06CC\u0648 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC \u0648\u06CC 6",
        nanoid: "\u0646\u06CC\u0646\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        guid: "\u062C\u06CC \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        cuid: "\u0633\u06CC \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        cuid2: "\u0633\u06CC \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC 2",
        ulid: "\u06CC\u0648 \u0627\u06CC\u0644 \u0622\u0626\u06CC \u0688\u06CC",
        xid: "\u0627\u06CC\u06A9\u0633 \u0622\u0626\u06CC \u0688\u06CC",
        ksuid: "\u06A9\u06D2 \u0627\u06CC\u0633 \u06CC\u0648 \u0622\u0626\u06CC \u0688\u06CC",
        datetime: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u0688\u06CC\u0679 \u0679\u0627\u0626\u0645",
        date: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u062A\u0627\u0631\u06CC\u062E",
        time: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u0648\u0642\u062A",
        duration: "\u0622\u0626\u06CC \u0627\u06CC\u0633 \u0627\u0648 \u0645\u062F\u062A",
        ipv4: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 4 \u0627\u06CC\u0688\u0631\u06CC\u0633",
        ipv6: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 6 \u0627\u06CC\u0688\u0631\u06CC\u0633",
        cidrv4: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 4 \u0631\u06CC\u0646\u062C",
        cidrv6: "\u0622\u0626\u06CC \u067E\u06CC \u0648\u06CC 6 \u0631\u06CC\u0646\u062C",
        base64: "\u0628\u06CC\u0633 64 \u0627\u0646 \u06A9\u0648\u0688\u0688 \u0633\u0679\u0631\u0646\u06AF",
        base64url: "\u0628\u06CC\u0633 64 \u06CC\u0648 \u0622\u0631 \u0627\u06CC\u0644 \u0627\u0646 \u06A9\u0648\u0688\u0688 \u0633\u0679\u0631\u0646\u06AF",
        json_string: "\u062C\u06D2 \u0627\u06CC\u0633 \u0627\u0648 \u0627\u06CC\u0646 \u0633\u0679\u0631\u0646\u06AF",
        e164: "\u0627\u06CC 164 \u0646\u0645\u0628\u0631",
        jwt: "\u062C\u06D2 \u0688\u0628\u0644\u06CC\u0648 \u0679\u06CC",
        template_literal: "\u0627\u0646 \u067E\u0679"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u0646\u0645\u0628\u0631",
        array: "\u0622\u0631\u06D2",
        null: "\u0646\u0644"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{63A}\u{644}\u{637} \u{627}\u{646} \u{67E}\u{679}: instanceof ${issue.expected} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}\u{60C} ${received} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648}\u{627}`;
                    return `\u{63A}\u{644}\u{637} \u{627}\u{646} \u{67E}\u{679}: ${expected} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}\u{60C} ${received} \u{645}\u{648}\u{635}\u{648}\u{644} \u{6C1}\u{648}\u{627}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{63A}\u{644}\u{637} \u{627}\u{646} \u{67E}\u{679}: ${_utilJs.stringifyPrimitive(issue.values[0])} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}`;
                return `\u{63A}\u{644}\u{637} \u{622}\u{67E}\u{634}\u{646}: ${_utilJs.joinValues(issue.values, "|")} \u{645}\u{6CC}\u{6BA} \u{633}\u{6D2} \u{627}\u{6CC}\u{6A9} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{628}\u{6C1}\u{62A} \u{628}\u{691}\u{627}: ${issue.origin ?? "\u0648\u06CC\u0644\u06CC\u0648"} \u{6A9}\u{6D2} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u0639\u0646\u0627\u0635\u0631"} \u{6C1}\u{648}\u{646}\u{6D2} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{6D2}`;
                    return `\u{628}\u{6C1}\u{62A} \u{628}\u{691}\u{627}: ${issue.origin ?? "\u0648\u06CC\u0644\u06CC\u0648"} \u{6A9}\u{627} ${adj}${issue.maximum.toString()} \u{6C1}\u{648}\u{646}\u{627} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{628}\u{6C1}\u{62A} \u{686}\u{6BE}\u{648}\u{679}\u{627}: ${issue.origin} \u{6A9}\u{6D2} ${adj}${issue.minimum.toString()} ${sizing.unit} \u{6C1}\u{648}\u{646}\u{6D2} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{6D2}`;
                    return `\u{628}\u{6C1}\u{62A} \u{686}\u{6BE}\u{648}\u{679}\u{627}: ${issue.origin} \u{6A9}\u{627} ${adj}${issue.minimum.toString()} \u{6C1}\u{648}\u{646}\u{627} \u{645}\u{62A}\u{648}\u{642}\u{639} \u{62A}\u{6BE}\u{627}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{63A}\u{644}\u{637} \u{633}\u{679}\u{631}\u{646}\u{6AF}: "${_issue.prefix}" \u{633}\u{6D2} \u{634}\u{631}\u{648}\u{639} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`;
                    if (_issue.format === "ends_with") return `\u{63A}\u{644}\u{637} \u{633}\u{679}\u{631}\u{646}\u{6AF}: "${_issue.suffix}" \u{67E}\u{631} \u{62E}\u{62A}\u{645} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`;
                    if (_issue.format === "includes") return `\u{63A}\u{644}\u{637} \u{633}\u{679}\u{631}\u{646}\u{6AF}: "${_issue.includes}" \u{634}\u{627}\u{645}\u{644} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`;
                    if (_issue.format === "regex") return `\u{63A}\u{644}\u{637} \u{633}\u{679}\u{631}\u{646}\u{6AF}: \u{67E}\u{6CC}\u{679}\u{631}\u{646} ${_issue.pattern} \u{633}\u{6D2} \u{645}\u{6CC}\u{686} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`;
                    return `\u{63A}\u{644}\u{637} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{63A}\u{644}\u{637} \u{646}\u{645}\u{628}\u{631}: ${issue.divisor} \u{6A9}\u{627} \u{645}\u{636}\u{627}\u{639}\u{641} \u{6C1}\u{648}\u{646}\u{627} \u{686}\u{627}\u{6C1}\u{6CC}\u{6D2}`;
            case "unrecognized_keys":
                return `\u{63A}\u{6CC}\u{631} \u{62A}\u{633}\u{644}\u{6CC}\u{645} \u{634}\u{62F}\u{6C1} \u{6A9}\u{6CC}${issue.keys.length > 1 ? "\u0632" : ""}: ${_utilJs.joinValues(issue.keys, "\u060C ")}`;
            case "invalid_key":
                return `${issue.origin} \u{645}\u{6CC}\u{6BA} \u{63A}\u{644}\u{637} \u{6A9}\u{6CC}`;
            case "invalid_union":
                return "\u063A\u0644\u0637 \u0627\u0646 \u067E\u0679";
            case "invalid_element":
                return `${issue.origin} \u{645}\u{6CC}\u{6BA} \u{63A}\u{644}\u{637} \u{648}\u{6CC}\u{644}\u{6CC}\u{648}`;
            default:
                return `\u{63A}\u{644}\u{637} \u{627}\u{646} \u{67E}\u{679}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gG1xl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "belgi",
            verb: "bo\u2018lishi kerak"
        },
        file: {
            unit: "bayt",
            verb: "bo\u2018lishi kerak"
        },
        array: {
            unit: "element",
            verb: "bo\u2018lishi kerak"
        },
        set: {
            unit: "element",
            verb: "bo\u2018lishi kerak"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "kirish",
        email: "elektron pochta manzili",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO sana va vaqti",
        date: "ISO sana",
        time: "ISO vaqt",
        duration: "ISO davomiylik",
        ipv4: "IPv4 manzil",
        ipv6: "IPv6 manzil",
        mac: "MAC manzil",
        cidrv4: "IPv4 diapazon",
        cidrv6: "IPv6 diapazon",
        base64: "base64 kodlangan satr",
        base64url: "base64url kodlangan satr",
        json_string: "JSON satr",
        e164: "E.164 raqam",
        jwt: "JWT",
        template_literal: "kirish"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "raqam",
        array: "massiv"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `Noto\u{2018}g\u{2018}ri kirish: kutilgan instanceof ${issue.expected}, qabul qilingan ${received}`;
                    return `Noto\u{2018}g\u{2018}ri kirish: kutilgan ${expected}, qabul qilingan ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Noto\u{2018}g\u{2018}ri kirish: kutilgan ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `Noto\u{2018}g\u{2018}ri variant: quyidagilardan biri kutilgan ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Juda katta: kutilgan ${issue.origin ?? "qiymat"} ${adj}${issue.maximum.toString()} ${sizing.unit} ${sizing.verb}`;
                    return `Juda katta: kutilgan ${issue.origin ?? "qiymat"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Juda kichik: kutilgan ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit} ${sizing.verb}`;
                    return `Juda kichik: kutilgan ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Noto\u{2018}g\u{2018}ri satr: "${_issue.prefix}" bilan boshlanishi kerak`;
                    if (_issue.format === "ends_with") return `Noto\u{2018}g\u{2018}ri satr: "${_issue.suffix}" bilan tugashi kerak`;
                    if (_issue.format === "includes") return `Noto\u{2018}g\u{2018}ri satr: "${_issue.includes}" ni o\u{2018}z ichiga olishi kerak`;
                    if (_issue.format === "regex") return `Noto\u{2018}g\u{2018}ri satr: ${_issue.pattern} shabloniga mos kelishi kerak`;
                    return `Noto\u{2018}g\u{2018}ri ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Noto\u{2018}g\u{2018}ri raqam: ${issue.divisor} ning karralisi bo\u{2018}lishi kerak`;
            case "unrecognized_keys":
                return `Noma\u{2019}lum kalit${issue.keys.length > 1 ? "lar" : ""}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} dagi kalit noto\u{2018}g\u{2018}ri`;
            case "invalid_union":
                return "Noto\u2018g\u2018ri kirish";
            case "invalid_element":
                return `${issue.origin} da noto\u{2018}g\u{2018}ri qiymat`;
            default:
                return `Noto\u{2018}g\u{2018}ri kirish`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9orAI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "k\xfd t\u1EF1",
            verb: "c\xf3"
        },
        file: {
            unit: "byte",
            verb: "c\xf3"
        },
        array: {
            unit: "ph\u1EA7n t\u1EED",
            verb: "c\xf3"
        },
        set: {
            unit: "ph\u1EA7n t\u1EED",
            verb: "c\xf3"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u0111\u1EA7u v\xe0o",
        email: "\u0111\u1ECBa ch\u1EC9 email",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ng\xe0y gi\u1EDD ISO",
        date: "ng\xe0y ISO",
        time: "gi\u1EDD ISO",
        duration: "kho\u1EA3ng th\u1EDDi gian ISO",
        ipv4: "\u0111\u1ECBa ch\u1EC9 IPv4",
        ipv6: "\u0111\u1ECBa ch\u1EC9 IPv6",
        cidrv4: "d\u1EA3i IPv4",
        cidrv6: "d\u1EA3i IPv6",
        base64: "chu\u1ED7i m\xe3 h\xf3a base64",
        base64url: "chu\u1ED7i m\xe3 h\xf3a base64url",
        json_string: "chu\u1ED7i JSON",
        e164: "s\u1ED1 E.164",
        jwt: "JWT",
        template_literal: "\u0111\u1EA7u v\xe0o"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "s\u1ED1",
        array: "m\u1EA3ng"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{110}\u{1EA7}u v\xe0o kh\xf4ng h\u{1EE3}p l\u{1EC7}: mong \u{111}\u{1EE3}i instanceof ${issue.expected}, nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c ${received}`;
                    return `\u{110}\u{1EA7}u v\xe0o kh\xf4ng h\u{1EE3}p l\u{1EC7}: mong \u{111}\u{1EE3}i ${expected}, nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{110}\u{1EA7}u v\xe0o kh\xf4ng h\u{1EE3}p l\u{1EC7}: mong \u{111}\u{1EE3}i ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `T\xf9y ch\u{1ECD}n kh\xf4ng h\u{1EE3}p l\u{1EC7}: mong \u{111}\u{1EE3}i m\u{1ED9}t trong c\xe1c gi\xe1 tr\u{1ECB} ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Qu\xe1 l\u{1EDB}n: mong \u{111}\u{1EE3}i ${issue.origin ?? "gi\xe1 tr\u1ECB"} ${sizing.verb} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "ph\u1EA7n t\u1EED"}`;
                    return `Qu\xe1 l\u{1EDB}n: mong \u{111}\u{1EE3}i ${issue.origin ?? "gi\xe1 tr\u1ECB"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Qu\xe1 nh\u{1ECF}: mong \u{111}\u{1EE3}i ${issue.origin} ${sizing.verb} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Qu\xe1 nh\u{1ECF}: mong \u{111}\u{1EE3}i ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Chu\u{1ED7}i kh\xf4ng h\u{1EE3}p l\u{1EC7}: ph\u{1EA3}i b\u{1EAF}t \u{111}\u{1EA7}u b\u{1EB1}ng "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Chu\u{1ED7}i kh\xf4ng h\u{1EE3}p l\u{1EC7}: ph\u{1EA3}i k\u{1EBF}t th\xfac b\u{1EB1}ng "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Chu\u{1ED7}i kh\xf4ng h\u{1EE3}p l\u{1EC7}: ph\u{1EA3}i bao g\u{1ED3}m "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Chu\u{1ED7}i kh\xf4ng h\u{1EE3}p l\u{1EC7}: ph\u{1EA3}i kh\u{1EDB}p v\u{1EDB}i m\u{1EAB}u ${_issue.pattern}`;
                    return `${FormatDictionary[_issue.format] ?? issue.format} kh\xf4ng h\u{1EE3}p l\u{1EC7}`;
                }
            case "not_multiple_of":
                return `S\u{1ED1} kh\xf4ng h\u{1EE3}p l\u{1EC7}: ph\u{1EA3}i l\xe0 b\u{1ED9}i s\u{1ED1} c\u{1EE7}a ${issue.divisor}`;
            case "unrecognized_keys":
                return `Kh\xf3a kh\xf4ng \u{111}\u{1B0}\u{1EE3}c nh\u{1EAD}n d\u{1EA1}ng: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Kh\xf3a kh\xf4ng h\u{1EE3}p l\u{1EC7} trong ${issue.origin}`;
            case "invalid_union":
                return "\u0110\u1EA7u v\xe0o kh\xf4ng h\u1EE3p l\u1EC7";
            case "invalid_element":
                return `Gi\xe1 tr\u{1ECB} kh\xf4ng h\u{1EE3}p l\u{1EC7} trong ${issue.origin}`;
            default:
                return `\u{110}\u{1EA7}u v\xe0o kh\xf4ng h\u{1EE3}p l\u{1EC7}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"PKpjY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\u5B57\u7B26",
            verb: "\u5305\u542B"
        },
        file: {
            unit: "\u5B57\u8282",
            verb: "\u5305\u542B"
        },
        array: {
            unit: "\u9879",
            verb: "\u5305\u542B"
        },
        set: {
            unit: "\u9879",
            verb: "\u5305\u542B"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u8F93\u5165",
        email: "\u7535\u5B50\u90AE\u4EF6",
        url: "URL",
        emoji: "\u8868\u60C5\u7B26\u53F7",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO\u65E5\u671F\u65F6\u95F4",
        date: "ISO\u65E5\u671F",
        time: "ISO\u65F6\u95F4",
        duration: "ISO\u65F6\u957F",
        ipv4: "IPv4\u5730\u5740",
        ipv6: "IPv6\u5730\u5740",
        cidrv4: "IPv4\u7F51\u6BB5",
        cidrv6: "IPv6\u7F51\u6BB5",
        base64: "base64\u7F16\u7801\u5B57\u7B26\u4E32",
        base64url: "base64url\u7F16\u7801\u5B57\u7B26\u4E32",
        json_string: "JSON\u5B57\u7B26\u4E32",
        e164: "E.164\u53F7\u7801",
        jwt: "JWT",
        template_literal: "\u8F93\u5165"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "\u6570\u5B57",
        array: "\u6570\u7EC4",
        null: "\u7A7A\u503C(null)"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{65E0}\u{6548}\u{8F93}\u{5165}\u{FF1A}\u{671F}\u{671B} instanceof ${issue.expected}\u{FF0C}\u{5B9E}\u{9645}\u{63A5}\u{6536} ${received}`;
                    return `\u{65E0}\u{6548}\u{8F93}\u{5165}\u{FF1A}\u{671F}\u{671B} ${expected}\u{FF0C}\u{5B9E}\u{9645}\u{63A5}\u{6536} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{65E0}\u{6548}\u{8F93}\u{5165}\u{FF1A}\u{671F}\u{671B} ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `\u{65E0}\u{6548}\u{9009}\u{9879}\u{FF1A}\u{671F}\u{671B}\u{4EE5}\u{4E0B}\u{4E4B}\u{4E00} ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{6570}\u{503C}\u{8FC7}\u{5927}\u{FF1A}\u{671F}\u{671B} ${issue.origin ?? "\u503C"} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u4E2A\u5143\u7D20"}`;
                    return `\u{6570}\u{503C}\u{8FC7}\u{5927}\u{FF1A}\u{671F}\u{671B} ${issue.origin ?? "\u503C"} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{6570}\u{503C}\u{8FC7}\u{5C0F}\u{FF1A}\u{671F}\u{671B} ${issue.origin} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{6570}\u{503C}\u{8FC7}\u{5C0F}\u{FF1A}\u{671F}\u{671B} ${issue.origin} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{65E0}\u{6548}\u{5B57}\u{7B26}\u{4E32}\u{FF1A}\u{5FC5}\u{987B}\u{4EE5} "${_issue.prefix}" \u{5F00}\u{5934}`;
                    if (_issue.format === "ends_with") return `\u{65E0}\u{6548}\u{5B57}\u{7B26}\u{4E32}\u{FF1A}\u{5FC5}\u{987B}\u{4EE5} "${_issue.suffix}" \u{7ED3}\u{5C3E}`;
                    if (_issue.format === "includes") return `\u{65E0}\u{6548}\u{5B57}\u{7B26}\u{4E32}\u{FF1A}\u{5FC5}\u{987B}\u{5305}\u{542B} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{65E0}\u{6548}\u{5B57}\u{7B26}\u{4E32}\u{FF1A}\u{5FC5}\u{987B}\u{6EE1}\u{8DB3}\u{6B63}\u{5219}\u{8868}\u{8FBE}\u{5F0F} ${_issue.pattern}`;
                    return `\u{65E0}\u{6548}${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{65E0}\u{6548}\u{6570}\u{5B57}\u{FF1A}\u{5FC5}\u{987B}\u{662F} ${issue.divisor} \u{7684}\u{500D}\u{6570}`;
            case "unrecognized_keys":
                return `\u{51FA}\u{73B0}\u{672A}\u{77E5}\u{7684}\u{952E}(key): ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `${issue.origin} \u{4E2D}\u{7684}\u{952E}(key)\u{65E0}\u{6548}`;
            case "invalid_union":
                return "\u65E0\u6548\u8F93\u5165";
            case "invalid_element":
                return `${issue.origin} \u{4E2D}\u{5305}\u{542B}\u{65E0}\u{6548}\u{503C}(value)`;
            default:
                return `\u{65E0}\u{6548}\u{8F93}\u{5165}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8R0Qg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\u5B57\u5143",
            verb: "\u64C1\u6709"
        },
        file: {
            unit: "\u4F4D\u5143\u7D44",
            verb: "\u64C1\u6709"
        },
        array: {
            unit: "\u9805\u76EE",
            verb: "\u64C1\u6709"
        },
        set: {
            unit: "\u9805\u76EE",
            verb: "\u64C1\u6709"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u8F38\u5165",
        email: "\u90F5\u4EF6\u5730\u5740",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO \u65E5\u671F\u6642\u9593",
        date: "ISO \u65E5\u671F",
        time: "ISO \u6642\u9593",
        duration: "ISO \u671F\u9593",
        ipv4: "IPv4 \u4F4D\u5740",
        ipv6: "IPv6 \u4F4D\u5740",
        cidrv4: "IPv4 \u7BC4\u570D",
        cidrv6: "IPv6 \u7BC4\u570D",
        base64: "base64 \u7DE8\u78BC\u5B57\u4E32",
        base64url: "base64url \u7DE8\u78BC\u5B57\u4E32",
        json_string: "JSON \u5B57\u4E32",
        e164: "E.164 \u6578\u503C",
        jwt: "JWT",
        template_literal: "\u8F38\u5165"
    };
    const TypeDictionary = {
        nan: "NaN"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\u{7121}\u{6548}\u{7684}\u{8F38}\u{5165}\u{503C}\u{FF1A}\u{9810}\u{671F}\u{70BA} instanceof ${issue.expected}\u{FF0C}\u{4F46}\u{6536}\u{5230} ${received}`;
                    return `\u{7121}\u{6548}\u{7684}\u{8F38}\u{5165}\u{503C}\u{FF1A}\u{9810}\u{671F}\u{70BA} ${expected}\u{FF0C}\u{4F46}\u{6536}\u{5230} ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\u{7121}\u{6548}\u{7684}\u{8F38}\u{5165}\u{503C}\u{FF1A}\u{9810}\u{671F}\u{70BA} ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `\u{7121}\u{6548}\u{7684}\u{9078}\u{9805}\u{FF1A}\u{9810}\u{671F}\u{70BA}\u{4EE5}\u{4E0B}\u{5176}\u{4E2D}\u{4E4B}\u{4E00} ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{6578}\u{503C}\u{904E}\u{5927}\u{FF1A}\u{9810}\u{671F} ${issue.origin ?? "\u503C"} \u{61C9}\u{70BA} ${adj}${issue.maximum.toString()} ${sizing.unit ?? "\u500B\u5143\u7D20"}`;
                    return `\u{6578}\u{503C}\u{904E}\u{5927}\u{FF1A}\u{9810}\u{671F} ${issue.origin ?? "\u503C"} \u{61C9}\u{70BA} ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `\u{6578}\u{503C}\u{904E}\u{5C0F}\u{FF1A}\u{9810}\u{671F} ${issue.origin} \u{61C9}\u{70BA} ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `\u{6578}\u{503C}\u{904E}\u{5C0F}\u{FF1A}\u{9810}\u{671F} ${issue.origin} \u{61C9}\u{70BA} ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{7121}\u{6548}\u{7684}\u{5B57}\u{4E32}\u{FF1A}\u{5FC5}\u{9808}\u{4EE5} "${_issue.prefix}" \u{958B}\u{982D}`;
                    if (_issue.format === "ends_with") return `\u{7121}\u{6548}\u{7684}\u{5B57}\u{4E32}\u{FF1A}\u{5FC5}\u{9808}\u{4EE5} "${_issue.suffix}" \u{7D50}\u{5C3E}`;
                    if (_issue.format === "includes") return `\u{7121}\u{6548}\u{7684}\u{5B57}\u{4E32}\u{FF1A}\u{5FC5}\u{9808}\u{5305}\u{542B} "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{7121}\u{6548}\u{7684}\u{5B57}\u{4E32}\u{FF1A}\u{5FC5}\u{9808}\u{7B26}\u{5408}\u{683C}\u{5F0F} ${_issue.pattern}`;
                    return `\u{7121}\u{6548}\u{7684} ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `\u{7121}\u{6548}\u{7684}\u{6578}\u{5B57}\u{FF1A}\u{5FC5}\u{9808}\u{70BA} ${issue.divisor} \u{7684}\u{500D}\u{6578}`;
            case "unrecognized_keys":
                return `\u{7121}\u{6CD5}\u{8B58}\u{5225}\u{7684}\u{9375}\u{503C}${issue.keys.length > 1 ? "\u5011" : ""}\u{FF1A}${_utilJs.joinValues(issue.keys, "\u3001")}`;
            case "invalid_key":
                return `${issue.origin} \u{4E2D}\u{6709}\u{7121}\u{6548}\u{7684}\u{9375}\u{503C}`;
            case "invalid_union":
                return "\u7121\u6548\u7684\u8F38\u5165\u503C";
            case "invalid_element":
                return `${issue.origin} \u{4E2D}\u{6709}\u{7121}\u{6548}\u{7684}\u{503C}`;
            default:
                return `\u{7121}\u{6548}\u{7684}\u{8F38}\u{5165}\u{503C}`;
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ho2L9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return {
            localeError: error()
        };
    });
var _utilJs = require("../core/util.js");
const error = ()=>{
    const Sizable = {
        string: {
            unit: "\xe0mi",
            verb: "n\xed"
        },
        file: {
            unit: "bytes",
            verb: "n\xed"
        },
        array: {
            unit: "nkan",
            verb: "n\xed"
        },
        set: {
            unit: "nkan",
            verb: "n\xed"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "\u1EB9\u0300r\u1ECD \xecb\xe1w\u1ECDl\xe9",
        email: "\xe0d\xedr\u1EB9\u0301s\xec \xecm\u1EB9\u0301l\xec",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "\xe0k\xf3k\xf2 ISO",
        date: "\u1ECDj\u1ECD\u0301 ISO",
        time: "\xe0k\xf3k\xf2 ISO",
        duration: "\xe0k\xf3k\xf2 t\xf3 p\xe9 ISO",
        ipv4: "\xe0d\xedr\u1EB9\u0301s\xec IPv4",
        ipv6: "\xe0d\xedr\u1EB9\u0301s\xec IPv6",
        cidrv4: "\xe0gb\xe8gb\xe8 IPv4",
        cidrv6: "\xe0gb\xe8gb\xe8 IPv6",
        base64: "\u1ECD\u0300r\u1ECD\u0300 t\xed a k\u1ECD\u0301 n\xed base64",
        base64url: "\u1ECD\u0300r\u1ECD\u0300 base64url",
        json_string: "\u1ECD\u0300r\u1ECD\u0300 JSON",
        e164: "n\u1ECD\u0301mb\xe0 E.164",
        jwt: "JWT",
        template_literal: "\u1EB9\u0300r\u1ECD \xecb\xe1w\u1ECDl\xe9"
    };
    const TypeDictionary = {
        nan: "NaN",
        number: "n\u1ECD\u0301mb\xe0",
        array: "akop\u1ECD"
    };
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = TypeDictionary[issue.expected] ?? issue.expected;
                    const receivedType = _utilJs.parsedType(issue.input);
                    const received = TypeDictionary[receivedType] ?? receivedType;
                    if (/^[A-Z]/.test(issue.expected)) return `\xccb\xe1w\u{1ECD}l\xe9 a\u{1E63}\xec\u{1E63}e: a n\xed l\xe1ti fi instanceof ${issue.expected}, \xe0m\u{1ECD}\u{300} a r\xed ${received}`;
                    return `\xccb\xe1w\u{1ECD}l\xe9 a\u{1E63}\xec\u{1E63}e: a n\xed l\xe1ti fi ${expected}, \xe0m\u{1ECD}\u{300} a r\xed ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `\xccb\xe1w\u{1ECD}l\xe9 a\u{1E63}\xec\u{1E63}e: a n\xed l\xe1ti fi ${_utilJs.stringifyPrimitive(issue.values[0])}`;
                return `\xc0\u{1E63}\xe0y\xe0n a\u{1E63}\xec\u{1E63}e: yan \u{1ECD}\u{300}kan l\xe1ra ${_utilJs.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `T\xf3 p\u{1ECD}\u{300} j\xf9: a n\xed l\xe1ti j\u{1EB9}\u{301} p\xe9 ${issue.origin ?? "iye"} ${sizing.verb} ${adj}${issue.maximum} ${sizing.unit}`;
                    return `T\xf3 p\u{1ECD}\u{300} j\xf9: a n\xed l\xe1ti j\u{1EB9}\u{301} ${adj}${issue.maximum}`;
                }
            case "too_small":
                {
                    const adj = issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `K\xe9r\xe9 ju: a n\xed l\xe1ti j\u{1EB9}\u{301} p\xe9 ${issue.origin} ${sizing.verb} ${adj}${issue.minimum} ${sizing.unit}`;
                    return `K\xe9r\xe9 ju: a n\xed l\xe1ti j\u{1EB9}\u{301} ${adj}${issue.minimum}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `\u{1ECC}\u{300}r\u{1ECD}\u{300} a\u{1E63}\xec\u{1E63}e: gb\u{1ECD}\u{301}d\u{1ECD}\u{300} b\u{1EB9}\u{300}r\u{1EB9}\u{300} p\u{1EB9}\u{300}l\xfa "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `\u{1ECC}\u{300}r\u{1ECD}\u{300} a\u{1E63}\xec\u{1E63}e: gb\u{1ECD}\u{301}d\u{1ECD}\u{300} par\xed p\u{1EB9}\u{300}l\xfa "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `\u{1ECC}\u{300}r\u{1ECD}\u{300} a\u{1E63}\xec\u{1E63}e: gb\u{1ECD}\u{301}d\u{1ECD}\u{300} n\xed "${_issue.includes}"`;
                    if (_issue.format === "regex") return `\u{1ECC}\u{300}r\u{1ECD}\u{300} a\u{1E63}\xec\u{1E63}e: gb\u{1ECD}\u{301}d\u{1ECD}\u{300} b\xe1 \xe0p\u{1EB9}\u{1EB9}r\u{1EB9} mu ${_issue.pattern}`;
                    return `A\u{1E63}\xec\u{1E63}e: ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `N\u{1ECD}\u{301}mb\xe0 a\u{1E63}\xec\u{1E63}e: gb\u{1ECD}\u{301}d\u{1ECD}\u{300} j\u{1EB9}\u{301} \xe8y\xe0 p\xedp\xedn ti ${issue.divisor}`;
            case "unrecognized_keys":
                return `B\u{1ECD}t\xecn\xec \xe0\xecm\u{1ECD}\u{300}: ${_utilJs.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `B\u{1ECD}t\xecn\xec a\u{1E63}\xec\u{1E63}e n\xedn\xfa ${issue.origin}`;
            case "invalid_union":
                return "\xccb\xe1w\u1ECDl\xe9 a\u1E63\xec\u1E63e";
            case "invalid_element":
                return `Iye a\u{1E63}\xec\u{1E63}e n\xedn\xfa ${issue.origin}`;
            default:
                return "\xccb\xe1w\u1ECDl\xe9 a\u1E63\xec\u1E63e";
        }
    };
};

},{"../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fccKK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$output", ()=>$output);
parcelHelpers.export(exports, "$input", ()=>$input);
parcelHelpers.export(exports, "$ZodRegistry", ()=>$ZodRegistry);
// registries
parcelHelpers.export(exports, "registry", ()=>registry);
parcelHelpers.export(exports, "globalRegistry", ()=>globalRegistry);
var _a;
const $output = Symbol("ZodOutput");
const $input = Symbol("ZodInput");
class $ZodRegistry {
    constructor(){
        this._map = new WeakMap();
        this._idmap = new Map();
    }
    add(schema, ..._meta) {
        const meta = _meta[0];
        this._map.set(schema, meta);
        if (meta && typeof meta === "object" && "id" in meta) this._idmap.set(meta.id, schema);
        return this;
    }
    clear() {
        this._map = new WeakMap();
        this._idmap = new Map();
        return this;
    }
    remove(schema) {
        const meta = this._map.get(schema);
        if (meta && typeof meta === "object" && "id" in meta) this._idmap.delete(meta.id);
        this._map.delete(schema);
        return this;
    }
    get(schema) {
        // return this._map.get(schema) as any;
        // inherit metadata
        const p = schema._zod.parent;
        if (p) {
            const pm = {
                ...this.get(p) ?? {}
            };
            delete pm.id; // do not inherit id
            const f = {
                ...pm,
                ...this._map.get(schema)
            };
            return Object.keys(f).length ? f : undefined;
        }
        return this._map.get(schema);
    }
    has(schema) {
        return this._map.has(schema);
    }
}
function registry() {
    return new $ZodRegistry();
}
(_a = globalThis).__zod_globalRegistry ?? (_a.__zod_globalRegistry = registry());
const globalRegistry = globalThis.__zod_globalRegistry;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"fE0q8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_string", ()=>_string);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_coercedString", ()=>_coercedString);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_email", ()=>_email);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_guid", ()=>_guid);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_uuid", ()=>_uuid);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_uuidv4", ()=>_uuidv4);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_uuidv6", ()=>_uuidv6);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_uuidv7", ()=>_uuidv7);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_url", ()=>_url);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_emoji", ()=>_emoji);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_nanoid", ()=>_nanoid);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_cuid", ()=>_cuid);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_cuid2", ()=>_cuid2);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_ulid", ()=>_ulid);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_xid", ()=>_xid);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_ksuid", ()=>_ksuid);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_ipv4", ()=>_ipv4);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_ipv6", ()=>_ipv6);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_mac", ()=>_mac);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_cidrv4", ()=>_cidrv4);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_cidrv6", ()=>_cidrv6);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_base64", ()=>_base64);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_base64url", ()=>_base64url);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_e164", ()=>_e164);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_jwt", ()=>_jwt);
parcelHelpers.export(exports, "TimePrecision", ()=>TimePrecision);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_isoDateTime", ()=>_isoDateTime);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_isoDate", ()=>_isoDate);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_isoTime", ()=>_isoTime);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_isoDuration", ()=>_isoDuration);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_number", ()=>_number);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_coercedNumber", ()=>_coercedNumber);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_int", ()=>_int);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_float32", ()=>_float32);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_float64", ()=>_float64);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_int32", ()=>_int32);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_uint32", ()=>_uint32);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_boolean", ()=>_boolean);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_coercedBoolean", ()=>_coercedBoolean);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_bigint", ()=>_bigint);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_coercedBigint", ()=>_coercedBigint);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_int64", ()=>_int64);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_uint64", ()=>_uint64);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_symbol", ()=>_symbol);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_undefined", ()=>_undefined);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_null", ()=>_null);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_any", ()=>_any);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_unknown", ()=>_unknown);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_never", ()=>_never);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_void", ()=>_void);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_date", ()=>_date);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_coercedDate", ()=>_coercedDate);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_nan", ()=>_nan);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_lt", ()=>_lt);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_lte", ()=>_lte);
parcelHelpers.export(exports, "_max", ()=>/** @deprecated Use `z.lte()` instead. */ _lte);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_gt", ()=>_gt);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_gte", ()=>_gte);
parcelHelpers.export(exports, "_min", ()=>/** @deprecated Use `z.gte()` instead. */ _gte);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_positive", ()=>_positive);
// negative
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_negative", ()=>_negative);
// nonpositive
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_nonpositive", ()=>_nonpositive);
// nonnegative
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_nonnegative", ()=>_nonnegative);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_multipleOf", ()=>_multipleOf);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_maxSize", ()=>_maxSize);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_minSize", ()=>_minSize);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_size", ()=>_size);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_maxLength", ()=>_maxLength);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_minLength", ()=>_minLength);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_length", ()=>_length);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_regex", ()=>_regex);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_lowercase", ()=>_lowercase);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_uppercase", ()=>_uppercase);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_includes", ()=>_includes);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_startsWith", ()=>_startsWith);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_endsWith", ()=>_endsWith);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_property", ()=>_property);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_mime", ()=>_mime);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_overwrite", ()=>_overwrite);
// normalize
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_normalize", ()=>_normalize);
// trim
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_trim", ()=>_trim);
// toLowerCase
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_toLowerCase", ()=>_toLowerCase);
// toUpperCase
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_toUpperCase", ()=>_toUpperCase);
// slugify
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_slugify", ()=>_slugify);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_array", ()=>_array);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_union", ()=>_union);
parcelHelpers.export(exports, "_xor", ()=>_xor);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_discriminatedUnion", ()=>_discriminatedUnion);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_intersection", ()=>_intersection);
// export function _tuple(
//   Class: util.SchemaClass<schemas.$ZodTuple>,
//   items: [],
//   params?: string | $ZodTupleParams
// ): schemas.$ZodTuple<[], null>;
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_tuple", ()=>_tuple);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_record", ()=>_record);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_map", ()=>_map);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_set", ()=>_set);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_enum", ()=>_enum);
// @__NO_SIDE_EFFECTS__
/** @deprecated This API has been merged into `z.enum()`. Use `z.enum()` instead.
 *
 * ```ts
 * enum Colors { red, green, blue }
 * z.enum(Colors);
 * ```
 */ parcelHelpers.export(exports, "_nativeEnum", ()=>_nativeEnum);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_literal", ()=>_literal);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_file", ()=>_file);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_transform", ()=>_transform);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_optional", ()=>_optional);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_nullable", ()=>_nullable);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_default", ()=>_default);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_nonoptional", ()=>_nonoptional);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_success", ()=>_success);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_catch", ()=>_catch);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_pipe", ()=>_pipe);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_readonly", ()=>_readonly);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_templateLiteral", ()=>_templateLiteral);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_lazy", ()=>_lazy);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_promise", ()=>_promise);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_custom", ()=>_custom);
// same as _custom but defaults to abort:false
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_refine", ()=>_refine);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_superRefine", ()=>_superRefine);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_check", ()=>_check);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "describe", ()=>describe);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "meta", ()=>meta);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_stringbool", ()=>_stringbool);
// @__NO_SIDE_EFFECTS__
parcelHelpers.export(exports, "_stringFormat", ()=>_stringFormat);
var _checksJs = require("./checks.js");
var _registriesJs = require("./registries.js");
var _schemasJs = require("./schemas.js");
var _utilJs = require("./util.js");
function _string(Class, params) {
    return new Class({
        type: "string",
        ..._utilJs.normalizeParams(params)
    });
}
function _coercedString(Class, params) {
    return new Class({
        type: "string",
        coerce: true,
        ..._utilJs.normalizeParams(params)
    });
}
function _email(Class, params) {
    return new Class({
        type: "string",
        format: "email",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _guid(Class, params) {
    return new Class({
        type: "string",
        format: "guid",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _uuid(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _uuidv4(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v4",
        ..._utilJs.normalizeParams(params)
    });
}
function _uuidv6(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v6",
        ..._utilJs.normalizeParams(params)
    });
}
function _uuidv7(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v7",
        ..._utilJs.normalizeParams(params)
    });
}
function _url(Class, params) {
    return new Class({
        type: "string",
        format: "url",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _emoji(Class, params) {
    return new Class({
        type: "string",
        format: "emoji",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _nanoid(Class, params) {
    return new Class({
        type: "string",
        format: "nanoid",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _cuid(Class, params) {
    return new Class({
        type: "string",
        format: "cuid",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _cuid2(Class, params) {
    return new Class({
        type: "string",
        format: "cuid2",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _ulid(Class, params) {
    return new Class({
        type: "string",
        format: "ulid",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _xid(Class, params) {
    return new Class({
        type: "string",
        format: "xid",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _ksuid(Class, params) {
    return new Class({
        type: "string",
        format: "ksuid",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _ipv4(Class, params) {
    return new Class({
        type: "string",
        format: "ipv4",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _ipv6(Class, params) {
    return new Class({
        type: "string",
        format: "ipv6",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _mac(Class, params) {
    return new Class({
        type: "string",
        format: "mac",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _cidrv4(Class, params) {
    return new Class({
        type: "string",
        format: "cidrv4",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _cidrv6(Class, params) {
    return new Class({
        type: "string",
        format: "cidrv6",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _base64(Class, params) {
    return new Class({
        type: "string",
        format: "base64",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _base64url(Class, params) {
    return new Class({
        type: "string",
        format: "base64url",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _e164(Class, params) {
    return new Class({
        type: "string",
        format: "e164",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _jwt(Class, params) {
    return new Class({
        type: "string",
        format: "jwt",
        check: "string_format",
        abort: false,
        ..._utilJs.normalizeParams(params)
    });
}
const TimePrecision = {
    Any: null,
    Minute: -1,
    Second: 0,
    Millisecond: 3,
    Microsecond: 6
};
function _isoDateTime(Class, params) {
    return new Class({
        type: "string",
        format: "datetime",
        check: "string_format",
        offset: false,
        local: false,
        precision: null,
        ..._utilJs.normalizeParams(params)
    });
}
function _isoDate(Class, params) {
    return new Class({
        type: "string",
        format: "date",
        check: "string_format",
        ..._utilJs.normalizeParams(params)
    });
}
function _isoTime(Class, params) {
    return new Class({
        type: "string",
        format: "time",
        check: "string_format",
        precision: null,
        ..._utilJs.normalizeParams(params)
    });
}
function _isoDuration(Class, params) {
    return new Class({
        type: "string",
        format: "duration",
        check: "string_format",
        ..._utilJs.normalizeParams(params)
    });
}
function _number(Class, params) {
    return new Class({
        type: "number",
        checks: [],
        ..._utilJs.normalizeParams(params)
    });
}
function _coercedNumber(Class, params) {
    return new Class({
        type: "number",
        coerce: true,
        checks: [],
        ..._utilJs.normalizeParams(params)
    });
}
function _int(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "safeint",
        ..._utilJs.normalizeParams(params)
    });
}
function _float32(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float32",
        ..._utilJs.normalizeParams(params)
    });
}
function _float64(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float64",
        ..._utilJs.normalizeParams(params)
    });
}
function _int32(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "int32",
        ..._utilJs.normalizeParams(params)
    });
}
function _uint32(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "uint32",
        ..._utilJs.normalizeParams(params)
    });
}
function _boolean(Class, params) {
    return new Class({
        type: "boolean",
        ..._utilJs.normalizeParams(params)
    });
}
function _coercedBoolean(Class, params) {
    return new Class({
        type: "boolean",
        coerce: true,
        ..._utilJs.normalizeParams(params)
    });
}
function _bigint(Class, params) {
    return new Class({
        type: "bigint",
        ..._utilJs.normalizeParams(params)
    });
}
function _coercedBigint(Class, params) {
    return new Class({
        type: "bigint",
        coerce: true,
        ..._utilJs.normalizeParams(params)
    });
}
function _int64(Class, params) {
    return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "int64",
        ..._utilJs.normalizeParams(params)
    });
}
function _uint64(Class, params) {
    return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "uint64",
        ..._utilJs.normalizeParams(params)
    });
}
function _symbol(Class, params) {
    return new Class({
        type: "symbol",
        ..._utilJs.normalizeParams(params)
    });
}
function _undefined(Class, params) {
    return new Class({
        type: "undefined",
        ..._utilJs.normalizeParams(params)
    });
}
function _null(Class, params) {
    return new Class({
        type: "null",
        ..._utilJs.normalizeParams(params)
    });
}
function _any(Class) {
    return new Class({
        type: "any"
    });
}
function _unknown(Class) {
    return new Class({
        type: "unknown"
    });
}
function _never(Class, params) {
    return new Class({
        type: "never",
        ..._utilJs.normalizeParams(params)
    });
}
function _void(Class, params) {
    return new Class({
        type: "void",
        ..._utilJs.normalizeParams(params)
    });
}
function _date(Class, params) {
    return new Class({
        type: "date",
        ..._utilJs.normalizeParams(params)
    });
}
function _coercedDate(Class, params) {
    return new Class({
        type: "date",
        coerce: true,
        ..._utilJs.normalizeParams(params)
    });
}
function _nan(Class, params) {
    return new Class({
        type: "nan",
        ..._utilJs.normalizeParams(params)
    });
}
function _lt(value, params) {
    return new _checksJs.$ZodCheckLessThan({
        check: "less_than",
        ..._utilJs.normalizeParams(params),
        value,
        inclusive: false
    });
}
function _lte(value, params) {
    return new _checksJs.$ZodCheckLessThan({
        check: "less_than",
        ..._utilJs.normalizeParams(params),
        value,
        inclusive: true
    });
}
function _gt(value, params) {
    return new _checksJs.$ZodCheckGreaterThan({
        check: "greater_than",
        ..._utilJs.normalizeParams(params),
        value,
        inclusive: false
    });
}
function _gte(value, params) {
    return new _checksJs.$ZodCheckGreaterThan({
        check: "greater_than",
        ..._utilJs.normalizeParams(params),
        value,
        inclusive: true
    });
}
function _positive(params) {
    return _gt(0, params);
}
function _negative(params) {
    return _lt(0, params);
}
function _nonpositive(params) {
    return _lte(0, params);
}
function _nonnegative(params) {
    return _gte(0, params);
}
function _multipleOf(value, params) {
    return new _checksJs.$ZodCheckMultipleOf({
        check: "multiple_of",
        ..._utilJs.normalizeParams(params),
        value
    });
}
function _maxSize(maximum, params) {
    return new _checksJs.$ZodCheckMaxSize({
        check: "max_size",
        ..._utilJs.normalizeParams(params),
        maximum
    });
}
function _minSize(minimum, params) {
    return new _checksJs.$ZodCheckMinSize({
        check: "min_size",
        ..._utilJs.normalizeParams(params),
        minimum
    });
}
function _size(size, params) {
    return new _checksJs.$ZodCheckSizeEquals({
        check: "size_equals",
        ..._utilJs.normalizeParams(params),
        size
    });
}
function _maxLength(maximum, params) {
    const ch = new _checksJs.$ZodCheckMaxLength({
        check: "max_length",
        ..._utilJs.normalizeParams(params),
        maximum
    });
    return ch;
}
function _minLength(minimum, params) {
    return new _checksJs.$ZodCheckMinLength({
        check: "min_length",
        ..._utilJs.normalizeParams(params),
        minimum
    });
}
function _length(length, params) {
    return new _checksJs.$ZodCheckLengthEquals({
        check: "length_equals",
        ..._utilJs.normalizeParams(params),
        length
    });
}
function _regex(pattern, params) {
    return new _checksJs.$ZodCheckRegex({
        check: "string_format",
        format: "regex",
        ..._utilJs.normalizeParams(params),
        pattern
    });
}
function _lowercase(params) {
    return new _checksJs.$ZodCheckLowerCase({
        check: "string_format",
        format: "lowercase",
        ..._utilJs.normalizeParams(params)
    });
}
function _uppercase(params) {
    return new _checksJs.$ZodCheckUpperCase({
        check: "string_format",
        format: "uppercase",
        ..._utilJs.normalizeParams(params)
    });
}
function _includes(includes, params) {
    return new _checksJs.$ZodCheckIncludes({
        check: "string_format",
        format: "includes",
        ..._utilJs.normalizeParams(params),
        includes
    });
}
function _startsWith(prefix, params) {
    return new _checksJs.$ZodCheckStartsWith({
        check: "string_format",
        format: "starts_with",
        ..._utilJs.normalizeParams(params),
        prefix
    });
}
function _endsWith(suffix, params) {
    return new _checksJs.$ZodCheckEndsWith({
        check: "string_format",
        format: "ends_with",
        ..._utilJs.normalizeParams(params),
        suffix
    });
}
function _property(property, schema, params) {
    return new _checksJs.$ZodCheckProperty({
        check: "property",
        property,
        schema,
        ..._utilJs.normalizeParams(params)
    });
}
function _mime(types, params) {
    return new _checksJs.$ZodCheckMimeType({
        check: "mime_type",
        mime: types,
        ..._utilJs.normalizeParams(params)
    });
}
function _overwrite(tx) {
    return new _checksJs.$ZodCheckOverwrite({
        check: "overwrite",
        tx
    });
}
function _normalize(form) {
    return _overwrite((input)=>input.normalize(form));
}
function _trim() {
    return _overwrite((input)=>input.trim());
}
function _toLowerCase() {
    return _overwrite((input)=>input.toLowerCase());
}
function _toUpperCase() {
    return _overwrite((input)=>input.toUpperCase());
}
function _slugify() {
    return _overwrite((input)=>_utilJs.slugify(input));
}
function _array(Class, element, params) {
    return new Class({
        type: "array",
        element,
        // get element() {
        //   return element;
        // },
        ..._utilJs.normalizeParams(params)
    });
}
function _union(Class, options, params) {
    return new Class({
        type: "union",
        options,
        ..._utilJs.normalizeParams(params)
    });
}
function _xor(Class, options, params) {
    return new Class({
        type: "union",
        options,
        inclusive: false,
        ..._utilJs.normalizeParams(params)
    });
}
function _discriminatedUnion(Class, discriminator, options, params) {
    return new Class({
        type: "union",
        options,
        discriminator,
        ..._utilJs.normalizeParams(params)
    });
}
function _intersection(Class, left, right) {
    return new Class({
        type: "intersection",
        left,
        right
    });
}
function _tuple(Class, items, _paramsOrRest, _params) {
    const hasRest = _paramsOrRest instanceof _schemasJs.$ZodType;
    const params = hasRest ? _params : _paramsOrRest;
    const rest = hasRest ? _paramsOrRest : null;
    return new Class({
        type: "tuple",
        items,
        rest,
        ..._utilJs.normalizeParams(params)
    });
}
function _record(Class, keyType, valueType, params) {
    return new Class({
        type: "record",
        keyType,
        valueType,
        ..._utilJs.normalizeParams(params)
    });
}
function _map(Class, keyType, valueType, params) {
    return new Class({
        type: "map",
        keyType,
        valueType,
        ..._utilJs.normalizeParams(params)
    });
}
function _set(Class, valueType, params) {
    return new Class({
        type: "set",
        valueType,
        ..._utilJs.normalizeParams(params)
    });
}
function _enum(Class, values, params) {
    const entries = Array.isArray(values) ? Object.fromEntries(values.map((v)=>[
            v,
            v
        ])) : values;
    // if (Array.isArray(values)) {
    //   for (const value of values) {
    //     entries[value] = value;
    //   }
    // } else {
    //   Object.assign(entries, values);
    // }
    // const entries: util.EnumLike = {};
    // for (const val of values) {
    //   entries[val] = val;
    // }
    return new Class({
        type: "enum",
        entries,
        ..._utilJs.normalizeParams(params)
    });
}
function _nativeEnum(Class, entries, params) {
    return new Class({
        type: "enum",
        entries,
        ..._utilJs.normalizeParams(params)
    });
}
function _literal(Class, value, params) {
    return new Class({
        type: "literal",
        values: Array.isArray(value) ? value : [
            value
        ],
        ..._utilJs.normalizeParams(params)
    });
}
function _file(Class, params) {
    return new Class({
        type: "file",
        ..._utilJs.normalizeParams(params)
    });
}
function _transform(Class, fn) {
    return new Class({
        type: "transform",
        transform: fn
    });
}
function _optional(Class, innerType) {
    return new Class({
        type: "optional",
        innerType
    });
}
function _nullable(Class, innerType) {
    return new Class({
        type: "nullable",
        innerType
    });
}
function _default(Class, innerType, defaultValue) {
    return new Class({
        type: "default",
        innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : _utilJs.shallowClone(defaultValue);
        }
    });
}
function _nonoptional(Class, innerType, params) {
    return new Class({
        type: "nonoptional",
        innerType,
        ..._utilJs.normalizeParams(params)
    });
}
function _success(Class, innerType) {
    return new Class({
        type: "success",
        innerType
    });
}
function _catch(Class, innerType, catchValue) {
    return new Class({
        type: "catch",
        innerType,
        catchValue: typeof catchValue === "function" ? catchValue : ()=>catchValue
    });
}
function _pipe(Class, in_, out) {
    return new Class({
        type: "pipe",
        in: in_,
        out
    });
}
function _readonly(Class, innerType) {
    return new Class({
        type: "readonly",
        innerType
    });
}
function _templateLiteral(Class, parts, params) {
    return new Class({
        type: "template_literal",
        parts,
        ..._utilJs.normalizeParams(params)
    });
}
function _lazy(Class, getter) {
    return new Class({
        type: "lazy",
        getter
    });
}
function _promise(Class, innerType) {
    return new Class({
        type: "promise",
        innerType
    });
}
function _custom(Class, fn, _params) {
    const norm = _utilJs.normalizeParams(_params);
    norm.abort ?? (norm.abort = true); // default to abort:false
    const schema = new Class({
        type: "custom",
        check: "custom",
        fn: fn,
        ...norm
    });
    return schema;
}
function _refine(Class, fn, _params) {
    const schema = new Class({
        type: "custom",
        check: "custom",
        fn: fn,
        ..._utilJs.normalizeParams(_params)
    });
    return schema;
}
function _superRefine(fn) {
    const ch = _check((payload)=>{
        payload.addIssue = (issue)=>{
            if (typeof issue === "string") payload.issues.push(_utilJs.issue(issue, payload.value, ch._zod.def));
            else {
                // for Zod 3 backwards compatibility
                const _issue = issue;
                if (_issue.fatal) _issue.continue = false;
                _issue.code ?? (_issue.code = "custom");
                _issue.input ?? (_issue.input = payload.value);
                _issue.inst ?? (_issue.inst = ch);
                _issue.continue ?? (_issue.continue = !ch._zod.def.abort); // abort is always undefined, so this is always true...
                payload.issues.push(_utilJs.issue(_issue));
            }
        };
        return fn(payload.value, payload);
    });
    return ch;
}
function _check(fn, params) {
    const ch = new _checksJs.$ZodCheck({
        check: "custom",
        ..._utilJs.normalizeParams(params)
    });
    ch._zod.check = fn;
    return ch;
}
function describe(description) {
    const ch = new _checksJs.$ZodCheck({
        check: "describe"
    });
    ch._zod.onattach = [
        (inst)=>{
            const existing = _registriesJs.globalRegistry.get(inst) ?? {};
            _registriesJs.globalRegistry.add(inst, {
                ...existing,
                description
            });
        }
    ];
    ch._zod.check = ()=>{}; // no-op check
    return ch;
}
function meta(metadata) {
    const ch = new _checksJs.$ZodCheck({
        check: "meta"
    });
    ch._zod.onattach = [
        (inst)=>{
            const existing = _registriesJs.globalRegistry.get(inst) ?? {};
            _registriesJs.globalRegistry.add(inst, {
                ...existing,
                ...metadata
            });
        }
    ];
    ch._zod.check = ()=>{}; // no-op check
    return ch;
}
function _stringbool(Classes, _params) {
    const params = _utilJs.normalizeParams(_params);
    let truthyArray = params.truthy ?? [
        "true",
        "1",
        "yes",
        "on",
        "y",
        "enabled"
    ];
    let falsyArray = params.falsy ?? [
        "false",
        "0",
        "no",
        "off",
        "n",
        "disabled"
    ];
    if (params.case !== "sensitive") {
        truthyArray = truthyArray.map((v)=>typeof v === "string" ? v.toLowerCase() : v);
        falsyArray = falsyArray.map((v)=>typeof v === "string" ? v.toLowerCase() : v);
    }
    const truthySet = new Set(truthyArray);
    const falsySet = new Set(falsyArray);
    const _Codec = Classes.Codec ?? _schemasJs.$ZodCodec;
    const _Boolean = Classes.Boolean ?? _schemasJs.$ZodBoolean;
    const _String = Classes.String ?? _schemasJs.$ZodString;
    const stringSchema = new _String({
        type: "string",
        error: params.error
    });
    const booleanSchema = new _Boolean({
        type: "boolean",
        error: params.error
    });
    const codec = new _Codec({
        type: "pipe",
        in: stringSchema,
        out: booleanSchema,
        transform: (input, payload)=>{
            let data = input;
            if (params.case !== "sensitive") data = data.toLowerCase();
            if (truthySet.has(data)) return true;
            else if (falsySet.has(data)) return false;
            else {
                payload.issues.push({
                    code: "invalid_value",
                    expected: "stringbool",
                    values: [
                        ...truthySet,
                        ...falsySet
                    ],
                    input: payload.value,
                    inst: codec,
                    continue: false
                });
                return {};
            }
        },
        reverseTransform: (input, _payload)=>{
            if (input === true) return truthyArray[0] || "true";
            else return falsyArray[0] || "false";
        },
        error: params.error
    });
    return codec;
}
function _stringFormat(Class, format, fnOrRegex, _params = {}) {
    const params = _utilJs.normalizeParams(_params);
    const def = {
        ..._utilJs.normalizeParams(_params),
        check: "string_format",
        type: "string",
        format,
        fn: typeof fnOrRegex === "function" ? fnOrRegex : (val)=>fnOrRegex.test(val),
        ...params
    };
    if (fnOrRegex instanceof RegExp) def.pattern = fnOrRegex;
    const inst = new Class(def);
    return inst;
}

},{"./checks.js":"f4OM4","./registries.js":"fccKK","./schemas.js":"c5Ly7","./util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7JRwT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// function initializeContext<T extends schemas.$ZodType>(inputs: JSONSchemaGeneratorParams<T>): ToJSONSchemaContext<T> {
//   return {
//     processor: inputs.processor,
//     metadataRegistry: inputs.metadata ?? globalRegistry,
//     target: inputs.target ?? "draft-2020-12",
//     unrepresentable: inputs.unrepresentable ?? "throw",
//   };
// }
parcelHelpers.export(exports, "initializeContext", ()=>initializeContext);
parcelHelpers.export(exports, "process", ()=>process);
parcelHelpers.export(exports, "extractDefs", ()=>extractDefs);
parcelHelpers.export(exports, "finalize", ()=>finalize);
parcelHelpers.export(exports, "createToJSONSchemaMethod", ()=>createToJSONSchemaMethod);
parcelHelpers.export(exports, "createStandardJSONSchemaMethod", ()=>createStandardJSONSchemaMethod);
var _registriesJs = require("./registries.js");
function initializeContext(params) {
    // Normalize target: convert old non-hyphenated versions to hyphenated versions
    let target = params?.target ?? "draft-2020-12";
    if (target === "draft-4") target = "draft-04";
    if (target === "draft-7") target = "draft-07";
    return {
        processors: params.processors ?? {},
        metadataRegistry: params?.metadata ?? (0, _registriesJs.globalRegistry),
        target,
        unrepresentable: params?.unrepresentable ?? "throw",
        override: params?.override ?? (()=>{}),
        io: params?.io ?? "output",
        counter: 0,
        seen: new Map(),
        cycles: params?.cycles ?? "ref",
        reused: params?.reused ?? "inline",
        external: params?.external ?? undefined
    };
}
function process(schema, ctx, _params = {
    path: [],
    schemaPath: []
}) {
    var _a;
    const def = schema._zod.def;
    // check for schema in seens
    const seen = ctx.seen.get(schema);
    if (seen) {
        seen.count++;
        // check if cycle
        const isCycle = _params.schemaPath.includes(schema);
        if (isCycle) seen.cycle = _params.path;
        return seen.schema;
    }
    // initialize
    const result = {
        schema: {},
        count: 1,
        cycle: undefined,
        path: _params.path
    };
    ctx.seen.set(schema, result);
    // custom method overrides default behavior
    const overrideSchema = schema._zod.toJSONSchema?.();
    if (overrideSchema) result.schema = overrideSchema;
    else {
        const params = {
            ..._params,
            schemaPath: [
                ..._params.schemaPath,
                schema
            ],
            path: _params.path
        };
        if (schema._zod.processJSONSchema) schema._zod.processJSONSchema(ctx, result.schema, params);
        else {
            const _json = result.schema;
            const processor = ctx.processors[def.type];
            if (!processor) throw new Error(`[toJSONSchema]: Non-representable type encountered: ${def.type}`);
            processor(schema, ctx, _json, params);
        }
        const parent = schema._zod.parent;
        if (parent) {
            // Also set ref if processor didn't (for inheritance)
            if (!result.ref) result.ref = parent;
            process(parent, ctx, params);
            ctx.seen.get(parent).isParent = true;
        }
    }
    // metadata
    const meta = ctx.metadataRegistry.get(schema);
    if (meta) Object.assign(result.schema, meta);
    if (ctx.io === "input" && isTransforming(schema)) {
        // examples/defaults only apply to output type of pipe
        delete result.schema.examples;
        delete result.schema.default;
    }
    // set prefault as default
    if (ctx.io === "input" && result.schema._prefault) (_a = result.schema).default ?? (_a.default = result.schema._prefault);
    delete result.schema._prefault;
    // pulling fresh from ctx.seen in case it was overwritten
    const _result = ctx.seen.get(schema);
    return _result.schema;
}
function extractDefs(ctx, schema) {
    // iterate over seen map;
    const root = ctx.seen.get(schema);
    if (!root) throw new Error("Unprocessed schema. This is a bug in Zod.");
    // Track ids to detect duplicates across different schemas
    const idToSchema = new Map();
    for (const entry of ctx.seen.entries()){
        const id = ctx.metadataRegistry.get(entry[0])?.id;
        if (id) {
            const existing = idToSchema.get(id);
            if (existing && existing !== entry[0]) throw new Error(`Duplicate schema id "${id}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
            idToSchema.set(id, entry[0]);
        }
    }
    // returns a ref to the schema
    // defId will be empty if the ref points to an external schema (or #)
    const makeURI = (entry)=>{
        // comparing the seen objects because sometimes
        // multiple schemas map to the same seen object.
        // e.g. lazy
        // external is configured
        const defsSegment = ctx.target === "draft-2020-12" ? "$defs" : "definitions";
        if (ctx.external) {
            const externalId = ctx.external.registry.get(entry[0])?.id; // ?? "__shared";// `__schema${ctx.counter++}`;
            // check if schema is in the external registry
            const uriGenerator = ctx.external.uri ?? ((id)=>id);
            if (externalId) return {
                ref: uriGenerator(externalId)
            };
            // otherwise, add to __shared
            const id = entry[1].defId ?? entry[1].schema.id ?? `schema${ctx.counter++}`;
            entry[1].defId = id; // set defId so it will be reused if needed
            return {
                defId: id,
                ref: `${uriGenerator("__shared")}#/${defsSegment}/${id}`
            };
        }
        if (entry[1] === root) return {
            ref: "#"
        };
        // self-contained schema
        const uriPrefix = `#`;
        const defUriPrefix = `${uriPrefix}/${defsSegment}/`;
        const defId = entry[1].schema.id ?? `__schema${ctx.counter++}`;
        return {
            defId,
            ref: defUriPrefix + defId
        };
    };
    // stored cached version in `def` property
    // remove all properties, set $ref
    const extractToDef = (entry)=>{
        // if the schema is already a reference, do not extract it
        if (entry[1].schema.$ref) return;
        const seen = entry[1];
        const { ref, defId } = makeURI(entry);
        seen.def = {
            ...seen.schema
        };
        // defId won't be set if the schema is a reference to an external schema
        // or if the schema is the root schema
        if (defId) seen.defId = defId;
        // wipe away all properties except $ref
        const schema = seen.schema;
        for(const key in schema)delete schema[key];
        schema.$ref = ref;
    };
    // throw on cycles
    // break cycles
    if (ctx.cycles === "throw") for (const entry of ctx.seen.entries()){
        const seen = entry[1];
        if (seen.cycle) throw new Error("Cycle detected: " + `#/${seen.cycle?.join("/")}/<root>` + '\n\nSet the `cycles` parameter to `"ref"` to resolve cyclical schemas with defs.');
    }
    // extract schemas into $defs
    for (const entry of ctx.seen.entries()){
        const seen = entry[1];
        // convert root schema to # $ref
        if (schema === entry[0]) {
            extractToDef(entry); // this has special handling for the root schema
            continue;
        }
        // extract schemas that are in the external registry
        if (ctx.external) {
            const ext = ctx.external.registry.get(entry[0])?.id;
            if (schema !== entry[0] && ext) {
                extractToDef(entry);
                continue;
            }
        }
        // extract schemas with `id` meta
        const id = ctx.metadataRegistry.get(entry[0])?.id;
        if (id) {
            extractToDef(entry);
            continue;
        }
        // break cycles
        if (seen.cycle) {
            // any
            extractToDef(entry);
            continue;
        }
        // extract reused schemas
        if (seen.count > 1) {
            if (ctx.reused === "ref") {
                extractToDef(entry);
                continue;
            }
        }
    }
}
function finalize(ctx, schema) {
    const root = ctx.seen.get(schema);
    if (!root) throw new Error("Unprocessed schema. This is a bug in Zod.");
    // flatten refs - inherit properties from parent schemas
    const flattenRef = (zodSchema)=>{
        const seen = ctx.seen.get(zodSchema);
        // already processed
        if (seen.ref === null) return;
        const schema = seen.def ?? seen.schema;
        const _cached = {
            ...schema
        };
        const ref = seen.ref;
        seen.ref = null; // prevent infinite recursion
        if (ref) {
            flattenRef(ref);
            const refSeen = ctx.seen.get(ref);
            const refSchema = refSeen.schema;
            // merge referenced schema into current
            if (refSchema.$ref && (ctx.target === "draft-07" || ctx.target === "draft-04" || ctx.target === "openapi-3.0")) {
                // older drafts can't combine $ref with other properties
                schema.allOf = schema.allOf ?? [];
                schema.allOf.push(refSchema);
            } else Object.assign(schema, refSchema);
            // restore child's own properties (child wins)
            Object.assign(schema, _cached);
            const isParentRef = zodSchema._zod.parent === ref;
            // For parent chain, child is a refinement - remove parent-only properties
            if (isParentRef) for(const key in schema){
                if (key === "$ref" || key === "allOf") continue;
                if (!(key in _cached)) delete schema[key];
            }
            // When ref was extracted to $defs, remove properties that match the definition
            if (refSchema.$ref) for(const key in schema){
                if (key === "$ref" || key === "allOf") continue;
                if (key in refSeen.def && JSON.stringify(schema[key]) === JSON.stringify(refSeen.def[key])) delete schema[key];
            }
        }
        // If parent was extracted (has $ref), propagate $ref to this schema
        // This handles cases like: readonly().meta({id}).describe()
        // where processor sets ref to innerType but parent should be referenced
        const parent = zodSchema._zod.parent;
        if (parent && parent !== ref) {
            // Ensure parent is processed first so its def has inherited properties
            flattenRef(parent);
            const parentSeen = ctx.seen.get(parent);
            if (parentSeen?.schema.$ref) {
                schema.$ref = parentSeen.schema.$ref;
                // De-duplicate with parent's definition
                if (parentSeen.def) for(const key in schema){
                    if (key === "$ref" || key === "allOf") continue;
                    if (key in parentSeen.def && JSON.stringify(schema[key]) === JSON.stringify(parentSeen.def[key])) delete schema[key];
                }
            }
        }
        // execute overrides
        ctx.override({
            zodSchema: zodSchema,
            jsonSchema: schema,
            path: seen.path ?? []
        });
    };
    for (const entry of [
        ...ctx.seen.entries()
    ].reverse())flattenRef(entry[0]);
    const result = {};
    if (ctx.target === "draft-2020-12") result.$schema = "https://json-schema.org/draft/2020-12/schema";
    else if (ctx.target === "draft-07") result.$schema = "http://json-schema.org/draft-07/schema#";
    else if (ctx.target === "draft-04") result.$schema = "http://json-schema.org/draft-04/schema#";
    else ctx.target;
    if (ctx.external?.uri) {
        const id = ctx.external.registry.get(schema)?.id;
        if (!id) throw new Error("Schema is missing an `id` property");
        result.$id = ctx.external.uri(id);
    }
    Object.assign(result, root.def ?? root.schema);
    // build defs object
    const defs = ctx.external?.defs ?? {};
    for (const entry of ctx.seen.entries()){
        const seen = entry[1];
        if (seen.def && seen.defId) defs[seen.defId] = seen.def;
    }
    // set definitions in result
    if (ctx.external) ;
    else if (Object.keys(defs).length > 0) {
        if (ctx.target === "draft-2020-12") result.$defs = defs;
        else result.definitions = defs;
    }
    try {
        // this "finalizes" this schema and ensures all cycles are removed
        // each call to finalize() is functionally independent
        // though the seen map is shared
        const finalized = JSON.parse(JSON.stringify(result));
        Object.defineProperty(finalized, "~standard", {
            value: {
                ...schema["~standard"],
                jsonSchema: {
                    input: createStandardJSONSchemaMethod(schema, "input", ctx.processors),
                    output: createStandardJSONSchemaMethod(schema, "output", ctx.processors)
                }
            },
            enumerable: false,
            writable: false
        });
        return finalized;
    } catch (_err) {
        throw new Error("Error converting schema to JSON.");
    }
}
function isTransforming(_schema, _ctx) {
    const ctx = _ctx ?? {
        seen: new Set()
    };
    if (ctx.seen.has(_schema)) return false;
    ctx.seen.add(_schema);
    const def = _schema._zod.def;
    if (def.type === "transform") return true;
    if (def.type === "array") return isTransforming(def.element, ctx);
    if (def.type === "set") return isTransforming(def.valueType, ctx);
    if (def.type === "lazy") return isTransforming(def.getter(), ctx);
    if (def.type === "promise" || def.type === "optional" || def.type === "nonoptional" || def.type === "nullable" || def.type === "readonly" || def.type === "default" || def.type === "prefault") return isTransforming(def.innerType, ctx);
    if (def.type === "intersection") return isTransforming(def.left, ctx) || isTransforming(def.right, ctx);
    if (def.type === "record" || def.type === "map") return isTransforming(def.keyType, ctx) || isTransforming(def.valueType, ctx);
    if (def.type === "pipe") return isTransforming(def.in, ctx) || isTransforming(def.out, ctx);
    if (def.type === "object") {
        for(const key in def.shape){
            if (isTransforming(def.shape[key], ctx)) return true;
        }
        return false;
    }
    if (def.type === "union") {
        for (const option of def.options){
            if (isTransforming(option, ctx)) return true;
        }
        return false;
    }
    if (def.type === "tuple") {
        for (const item of def.items){
            if (isTransforming(item, ctx)) return true;
        }
        if (def.rest && isTransforming(def.rest, ctx)) return true;
        return false;
    }
    return false;
}
const createToJSONSchemaMethod = (schema, processors = {})=>(params)=>{
        const ctx = initializeContext({
            ...params,
            processors
        });
        process(schema, ctx);
        extractDefs(ctx, schema);
        return finalize(ctx, schema);
    };
const createStandardJSONSchemaMethod = (schema, io, processors = {})=>(params)=>{
        const { libraryOptions, target } = params ?? {};
        const ctx = initializeContext({
            ...libraryOptions ?? {},
            target,
            io,
            processors
        });
        process(schema, ctx);
        extractDefs(ctx, schema);
        return finalize(ctx, schema);
    };

},{"./registries.js":"fccKK","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"c7eX7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stringProcessor", ()=>stringProcessor);
parcelHelpers.export(exports, "numberProcessor", ()=>numberProcessor);
parcelHelpers.export(exports, "booleanProcessor", ()=>booleanProcessor);
parcelHelpers.export(exports, "bigintProcessor", ()=>bigintProcessor);
parcelHelpers.export(exports, "symbolProcessor", ()=>symbolProcessor);
parcelHelpers.export(exports, "nullProcessor", ()=>nullProcessor);
parcelHelpers.export(exports, "undefinedProcessor", ()=>undefinedProcessor);
parcelHelpers.export(exports, "voidProcessor", ()=>voidProcessor);
parcelHelpers.export(exports, "neverProcessor", ()=>neverProcessor);
parcelHelpers.export(exports, "anyProcessor", ()=>anyProcessor);
parcelHelpers.export(exports, "unknownProcessor", ()=>unknownProcessor);
parcelHelpers.export(exports, "dateProcessor", ()=>dateProcessor);
parcelHelpers.export(exports, "enumProcessor", ()=>enumProcessor);
parcelHelpers.export(exports, "literalProcessor", ()=>literalProcessor);
parcelHelpers.export(exports, "nanProcessor", ()=>nanProcessor);
parcelHelpers.export(exports, "templateLiteralProcessor", ()=>templateLiteralProcessor);
parcelHelpers.export(exports, "fileProcessor", ()=>fileProcessor);
parcelHelpers.export(exports, "successProcessor", ()=>successProcessor);
parcelHelpers.export(exports, "customProcessor", ()=>customProcessor);
parcelHelpers.export(exports, "functionProcessor", ()=>functionProcessor);
parcelHelpers.export(exports, "transformProcessor", ()=>transformProcessor);
parcelHelpers.export(exports, "mapProcessor", ()=>mapProcessor);
parcelHelpers.export(exports, "setProcessor", ()=>setProcessor);
parcelHelpers.export(exports, "arrayProcessor", ()=>arrayProcessor);
parcelHelpers.export(exports, "objectProcessor", ()=>objectProcessor);
parcelHelpers.export(exports, "unionProcessor", ()=>unionProcessor);
parcelHelpers.export(exports, "intersectionProcessor", ()=>intersectionProcessor);
parcelHelpers.export(exports, "tupleProcessor", ()=>tupleProcessor);
parcelHelpers.export(exports, "recordProcessor", ()=>recordProcessor);
parcelHelpers.export(exports, "nullableProcessor", ()=>nullableProcessor);
parcelHelpers.export(exports, "nonoptionalProcessor", ()=>nonoptionalProcessor);
parcelHelpers.export(exports, "defaultProcessor", ()=>defaultProcessor);
parcelHelpers.export(exports, "prefaultProcessor", ()=>prefaultProcessor);
parcelHelpers.export(exports, "catchProcessor", ()=>catchProcessor);
parcelHelpers.export(exports, "pipeProcessor", ()=>pipeProcessor);
parcelHelpers.export(exports, "readonlyProcessor", ()=>readonlyProcessor);
parcelHelpers.export(exports, "promiseProcessor", ()=>promiseProcessor);
parcelHelpers.export(exports, "optionalProcessor", ()=>optionalProcessor);
parcelHelpers.export(exports, "lazyProcessor", ()=>lazyProcessor);
parcelHelpers.export(exports, "allProcessors", ()=>allProcessors);
parcelHelpers.export(exports, "toJSONSchema", ()=>toJSONSchema);
var _toJsonSchemaJs = require("./to-json-schema.js");
var _utilJs = require("./util.js");
const formatMap = {
    guid: "uuid",
    url: "uri",
    datetime: "date-time",
    json_string: "json-string",
    regex: ""
};
const stringProcessor = (schema, ctx, _json, _params)=>{
    const json = _json;
    json.type = "string";
    const { minimum, maximum, format, patterns, contentEncoding } = schema._zod.bag;
    if (typeof minimum === "number") json.minLength = minimum;
    if (typeof maximum === "number") json.maxLength = maximum;
    // custom pattern overrides format
    if (format) {
        json.format = formatMap[format] ?? format;
        if (json.format === "") delete json.format; // empty format is not valid
        // JSON Schema format: "time" requires a full time with offset or Z
        // z.iso.time() does not include timezone information, so format: "time" should never be used
        if (format === "time") delete json.format;
    }
    if (contentEncoding) json.contentEncoding = contentEncoding;
    if (patterns && patterns.size > 0) {
        const regexes = [
            ...patterns
        ];
        if (regexes.length === 1) json.pattern = regexes[0].source;
        else if (regexes.length > 1) json.allOf = [
            ...regexes.map((regex)=>({
                    ...ctx.target === "draft-07" || ctx.target === "draft-04" || ctx.target === "openapi-3.0" ? {
                        type: "string"
                    } : {},
                    pattern: regex.source
                }))
        ];
    }
};
const numberProcessor = (schema, ctx, _json, _params)=>{
    const json = _json;
    const { minimum, maximum, format, multipleOf, exclusiveMaximum, exclusiveMinimum } = schema._zod.bag;
    if (typeof format === "string" && format.includes("int")) json.type = "integer";
    else json.type = "number";
    if (typeof exclusiveMinimum === "number") {
        if (ctx.target === "draft-04" || ctx.target === "openapi-3.0") {
            json.minimum = exclusiveMinimum;
            json.exclusiveMinimum = true;
        } else json.exclusiveMinimum = exclusiveMinimum;
    }
    if (typeof minimum === "number") {
        json.minimum = minimum;
        if (typeof exclusiveMinimum === "number" && ctx.target !== "draft-04") {
            if (exclusiveMinimum >= minimum) delete json.minimum;
            else delete json.exclusiveMinimum;
        }
    }
    if (typeof exclusiveMaximum === "number") {
        if (ctx.target === "draft-04" || ctx.target === "openapi-3.0") {
            json.maximum = exclusiveMaximum;
            json.exclusiveMaximum = true;
        } else json.exclusiveMaximum = exclusiveMaximum;
    }
    if (typeof maximum === "number") {
        json.maximum = maximum;
        if (typeof exclusiveMaximum === "number" && ctx.target !== "draft-04") {
            if (exclusiveMaximum <= maximum) delete json.maximum;
            else delete json.exclusiveMaximum;
        }
    }
    if (typeof multipleOf === "number") json.multipleOf = multipleOf;
};
const booleanProcessor = (_schema, _ctx, json, _params)=>{
    json.type = "boolean";
};
const bigintProcessor = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("BigInt cannot be represented in JSON Schema");
};
const symbolProcessor = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Symbols cannot be represented in JSON Schema");
};
const nullProcessor = (_schema, ctx, json, _params)=>{
    if (ctx.target === "openapi-3.0") {
        json.type = "string";
        json.nullable = true;
        json.enum = [
            null
        ];
    } else json.type = "null";
};
const undefinedProcessor = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Undefined cannot be represented in JSON Schema");
};
const voidProcessor = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Void cannot be represented in JSON Schema");
};
const neverProcessor = (_schema, _ctx, json, _params)=>{
    json.not = {};
};
const anyProcessor = (_schema, _ctx, _json, _params)=>{
// empty schema accepts anything
};
const unknownProcessor = (_schema, _ctx, _json, _params)=>{
// empty schema accepts anything
};
const dateProcessor = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Date cannot be represented in JSON Schema");
};
const enumProcessor = (schema, _ctx, json, _params)=>{
    const def = schema._zod.def;
    const values = (0, _utilJs.getEnumValues)(def.entries);
    // Number enums can have both string and number values
    if (values.every((v)=>typeof v === "number")) json.type = "number";
    if (values.every((v)=>typeof v === "string")) json.type = "string";
    json.enum = values;
};
const literalProcessor = (schema, ctx, json, _params)=>{
    const def = schema._zod.def;
    const vals = [];
    for (const val of def.values){
        if (val === undefined) {
            if (ctx.unrepresentable === "throw") throw new Error("Literal `undefined` cannot be represented in JSON Schema");
        } else if (typeof val === "bigint") {
            if (ctx.unrepresentable === "throw") throw new Error("BigInt literals cannot be represented in JSON Schema");
            else vals.push(Number(val));
        } else vals.push(val);
    }
    if (vals.length === 0) ;
    else if (vals.length === 1) {
        const val = vals[0];
        json.type = val === null ? "null" : typeof val;
        if (ctx.target === "draft-04" || ctx.target === "openapi-3.0") json.enum = [
            val
        ];
        else json.const = val;
    } else {
        if (vals.every((v)=>typeof v === "number")) json.type = "number";
        if (vals.every((v)=>typeof v === "string")) json.type = "string";
        if (vals.every((v)=>typeof v === "boolean")) json.type = "boolean";
        if (vals.every((v)=>v === null)) json.type = "null";
        json.enum = vals;
    }
};
const nanProcessor = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("NaN cannot be represented in JSON Schema");
};
const templateLiteralProcessor = (schema, _ctx, json, _params)=>{
    const _json = json;
    const pattern = schema._zod.pattern;
    if (!pattern) throw new Error("Pattern not found in template literal");
    _json.type = "string";
    _json.pattern = pattern.source;
};
const fileProcessor = (schema, _ctx, json, _params)=>{
    const _json = json;
    const file = {
        type: "string",
        format: "binary",
        contentEncoding: "binary"
    };
    const { minimum, maximum, mime } = schema._zod.bag;
    if (minimum !== undefined) file.minLength = minimum;
    if (maximum !== undefined) file.maxLength = maximum;
    if (mime) {
        if (mime.length === 1) {
            file.contentMediaType = mime[0];
            Object.assign(_json, file);
        } else {
            Object.assign(_json, file); // shared props at root
            _json.anyOf = mime.map((m)=>({
                    contentMediaType: m
                })); // only contentMediaType differs
        }
    } else Object.assign(_json, file);
};
const successProcessor = (_schema, _ctx, json, _params)=>{
    json.type = "boolean";
};
const customProcessor = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Custom types cannot be represented in JSON Schema");
};
const functionProcessor = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Function types cannot be represented in JSON Schema");
};
const transformProcessor = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Transforms cannot be represented in JSON Schema");
};
const mapProcessor = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Map cannot be represented in JSON Schema");
};
const setProcessor = (_schema, ctx, _json, _params)=>{
    if (ctx.unrepresentable === "throw") throw new Error("Set cannot be represented in JSON Schema");
};
const arrayProcessor = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    const { minimum, maximum } = schema._zod.bag;
    if (typeof minimum === "number") json.minItems = minimum;
    if (typeof maximum === "number") json.maxItems = maximum;
    json.type = "array";
    json.items = (0, _toJsonSchemaJs.process)(def.element, ctx, {
        ...params,
        path: [
            ...params.path,
            "items"
        ]
    });
};
const objectProcessor = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    json.type = "object";
    json.properties = {};
    const shape = def.shape;
    for(const key in shape)json.properties[key] = (0, _toJsonSchemaJs.process)(shape[key], ctx, {
        ...params,
        path: [
            ...params.path,
            "properties",
            key
        ]
    });
    // required keys
    const allKeys = new Set(Object.keys(shape));
    const requiredKeys = new Set([
        ...allKeys
    ].filter((key)=>{
        const v = def.shape[key]._zod;
        if (ctx.io === "input") return v.optin === undefined;
        else return v.optout === undefined;
    }));
    if (requiredKeys.size > 0) json.required = Array.from(requiredKeys);
    // catchall
    if (def.catchall?._zod.def.type === "never") // strict
    json.additionalProperties = false;
    else if (!def.catchall) // regular
    {
        if (ctx.io === "output") json.additionalProperties = false;
    } else if (def.catchall) json.additionalProperties = (0, _toJsonSchemaJs.process)(def.catchall, ctx, {
        ...params,
        path: [
            ...params.path,
            "additionalProperties"
        ]
    });
};
const unionProcessor = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    // Exclusive unions (inclusive === false) use oneOf (exactly one match) instead of anyOf (one or more matches)
    // This includes both z.xor() and discriminated unions
    const isExclusive = def.inclusive === false;
    const options = def.options.map((x, i)=>(0, _toJsonSchemaJs.process)(x, ctx, {
            ...params,
            path: [
                ...params.path,
                isExclusive ? "oneOf" : "anyOf",
                i
            ]
        }));
    if (isExclusive) json.oneOf = options;
    else json.anyOf = options;
};
const intersectionProcessor = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    const a = (0, _toJsonSchemaJs.process)(def.left, ctx, {
        ...params,
        path: [
            ...params.path,
            "allOf",
            0
        ]
    });
    const b = (0, _toJsonSchemaJs.process)(def.right, ctx, {
        ...params,
        path: [
            ...params.path,
            "allOf",
            1
        ]
    });
    const isSimpleIntersection = (val)=>"allOf" in val && Object.keys(val).length === 1;
    const allOf = [
        ...isSimpleIntersection(a) ? a.allOf : [
            a
        ],
        ...isSimpleIntersection(b) ? b.allOf : [
            b
        ]
    ];
    json.allOf = allOf;
};
const tupleProcessor = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    json.type = "array";
    const prefixPath = ctx.target === "draft-2020-12" ? "prefixItems" : "items";
    const restPath = ctx.target === "draft-2020-12" ? "items" : ctx.target === "openapi-3.0" ? "items" : "additionalItems";
    const prefixItems = def.items.map((x, i)=>(0, _toJsonSchemaJs.process)(x, ctx, {
            ...params,
            path: [
                ...params.path,
                prefixPath,
                i
            ]
        }));
    const rest = def.rest ? (0, _toJsonSchemaJs.process)(def.rest, ctx, {
        ...params,
        path: [
            ...params.path,
            restPath,
            ...ctx.target === "openapi-3.0" ? [
                def.items.length
            ] : []
        ]
    }) : null;
    if (ctx.target === "draft-2020-12") {
        json.prefixItems = prefixItems;
        if (rest) json.items = rest;
    } else if (ctx.target === "openapi-3.0") {
        json.items = {
            anyOf: prefixItems
        };
        if (rest) json.items.anyOf.push(rest);
        json.minItems = prefixItems.length;
        if (!rest) json.maxItems = prefixItems.length;
    } else {
        json.items = prefixItems;
        if (rest) json.additionalItems = rest;
    }
    // length
    const { minimum, maximum } = schema._zod.bag;
    if (typeof minimum === "number") json.minItems = minimum;
    if (typeof maximum === "number") json.maxItems = maximum;
};
const recordProcessor = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    json.type = "object";
    // For looseRecord with regex patterns, use patternProperties
    // This correctly represents "only validate keys matching the pattern" semantics
    // and composes well with allOf (intersections)
    const keyType = def.keyType;
    const keyBag = keyType._zod.bag;
    const patterns = keyBag?.patterns;
    if (def.mode === "loose" && patterns && patterns.size > 0) {
        // Use patternProperties for looseRecord with regex patterns
        const valueSchema = (0, _toJsonSchemaJs.process)(def.valueType, ctx, {
            ...params,
            path: [
                ...params.path,
                "patternProperties",
                "*"
            ]
        });
        json.patternProperties = {};
        for (const pattern of patterns)json.patternProperties[pattern.source] = valueSchema;
    } else {
        // Default behavior: use propertyNames + additionalProperties
        if (ctx.target === "draft-07" || ctx.target === "draft-2020-12") json.propertyNames = (0, _toJsonSchemaJs.process)(def.keyType, ctx, {
            ...params,
            path: [
                ...params.path,
                "propertyNames"
            ]
        });
        json.additionalProperties = (0, _toJsonSchemaJs.process)(def.valueType, ctx, {
            ...params,
            path: [
                ...params.path,
                "additionalProperties"
            ]
        });
    }
    // Add required for keys with discrete values (enum, literal, etc.)
    const keyValues = keyType._zod.values;
    if (keyValues) {
        const validKeyValues = [
            ...keyValues
        ].filter((v)=>typeof v === "string" || typeof v === "number");
        if (validKeyValues.length > 0) json.required = validKeyValues;
    }
};
const nullableProcessor = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    const inner = (0, _toJsonSchemaJs.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    if (ctx.target === "openapi-3.0") {
        seen.ref = def.innerType;
        json.nullable = true;
    } else json.anyOf = [
        inner,
        {
            type: "null"
        }
    ];
};
const nonoptionalProcessor = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    (0, _toJsonSchemaJs.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
};
const defaultProcessor = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, _toJsonSchemaJs.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    json.default = JSON.parse(JSON.stringify(def.defaultValue));
};
const prefaultProcessor = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, _toJsonSchemaJs.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    if (ctx.io === "input") json._prefault = JSON.parse(JSON.stringify(def.defaultValue));
};
const catchProcessor = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, _toJsonSchemaJs.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    let catchValue;
    try {
        catchValue = def.catchValue(undefined);
    } catch  {
        throw new Error("Dynamic catch values are not supported in JSON Schema");
    }
    json.default = catchValue;
};
const pipeProcessor = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    const innerType = ctx.io === "input" ? def.in._zod.def.type === "transform" ? def.out : def.in : def.out;
    (0, _toJsonSchemaJs.process)(innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = innerType;
};
const readonlyProcessor = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, _toJsonSchemaJs.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    json.readOnly = true;
};
const promiseProcessor = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    (0, _toJsonSchemaJs.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
};
const optionalProcessor = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    (0, _toJsonSchemaJs.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
};
const lazyProcessor = (schema, ctx, _json, params)=>{
    const innerType = schema._zod.innerType;
    (0, _toJsonSchemaJs.process)(innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = innerType;
};
const allProcessors = {
    string: stringProcessor,
    number: numberProcessor,
    boolean: booleanProcessor,
    bigint: bigintProcessor,
    symbol: symbolProcessor,
    null: nullProcessor,
    undefined: undefinedProcessor,
    void: voidProcessor,
    never: neverProcessor,
    any: anyProcessor,
    unknown: unknownProcessor,
    date: dateProcessor,
    enum: enumProcessor,
    literal: literalProcessor,
    nan: nanProcessor,
    template_literal: templateLiteralProcessor,
    file: fileProcessor,
    success: successProcessor,
    custom: customProcessor,
    function: functionProcessor,
    transform: transformProcessor,
    map: mapProcessor,
    set: setProcessor,
    array: arrayProcessor,
    object: objectProcessor,
    union: unionProcessor,
    intersection: intersectionProcessor,
    tuple: tupleProcessor,
    record: recordProcessor,
    nullable: nullableProcessor,
    nonoptional: nonoptionalProcessor,
    default: defaultProcessor,
    prefault: prefaultProcessor,
    catch: catchProcessor,
    pipe: pipeProcessor,
    readonly: readonlyProcessor,
    promise: promiseProcessor,
    optional: optionalProcessor,
    lazy: lazyProcessor
};
function toJSONSchema(input, params) {
    if ("_idmap" in input) {
        // Registry case
        const registry = input;
        const ctx = (0, _toJsonSchemaJs.initializeContext)({
            ...params,
            processors: allProcessors
        });
        const defs = {};
        // First pass: process all schemas to build the seen map
        for (const entry of registry._idmap.entries()){
            const [_, schema] = entry;
            (0, _toJsonSchemaJs.process)(schema, ctx);
        }
        const schemas = {};
        const external = {
            registry,
            uri: params?.uri,
            defs
        };
        // Update the context with external configuration
        ctx.external = external;
        // Second pass: emit each schema
        for (const entry of registry._idmap.entries()){
            const [key, schema] = entry;
            (0, _toJsonSchemaJs.extractDefs)(ctx, schema);
            schemas[key] = (0, _toJsonSchemaJs.finalize)(ctx, schema);
        }
        if (Object.keys(defs).length > 0) {
            const defsSegment = ctx.target === "draft-2020-12" ? "$defs" : "definitions";
            schemas.__shared = {
                [defsSegment]: defs
            };
        }
        return {
            schemas
        };
    }
    // Single schema case
    const ctx = (0, _toJsonSchemaJs.initializeContext)({
        ...params,
        processors: allProcessors
    });
    (0, _toJsonSchemaJs.process)(input, ctx);
    (0, _toJsonSchemaJs.extractDefs)(ctx, input);
    return (0, _toJsonSchemaJs.finalize)(ctx, input);
}

},{"./to-json-schema.js":"7JRwT","./util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"40MpB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Legacy class-based interface for JSON Schema generation.
 * This class wraps the new functional implementation to provide backward compatibility.
 *
 * @deprecated Use the `toJSONSchema` function instead for new code.
 *
 * @example
 * ```typescript
 * // Legacy usage (still supported)
 * const gen = new JSONSchemaGenerator({ target: "draft-07" });
 * gen.process(schema);
 * const result = gen.emit(schema);
 *
 * // Preferred modern usage
 * const result = toJSONSchema(schema, { target: "draft-07" });
 * ```
 */ parcelHelpers.export(exports, "JSONSchemaGenerator", ()=>JSONSchemaGenerator);
var _jsonSchemaProcessorsJs = require("./json-schema-processors.js");
var _toJsonSchemaJs = require("./to-json-schema.js");
class JSONSchemaGenerator {
    /** @deprecated Access via ctx instead */ get metadataRegistry() {
        return this.ctx.metadataRegistry;
    }
    /** @deprecated Access via ctx instead */ get target() {
        return this.ctx.target;
    }
    /** @deprecated Access via ctx instead */ get unrepresentable() {
        return this.ctx.unrepresentable;
    }
    /** @deprecated Access via ctx instead */ get override() {
        return this.ctx.override;
    }
    /** @deprecated Access via ctx instead */ get io() {
        return this.ctx.io;
    }
    /** @deprecated Access via ctx instead */ get counter() {
        return this.ctx.counter;
    }
    set counter(value) {
        this.ctx.counter = value;
    }
    /** @deprecated Access via ctx instead */ get seen() {
        return this.ctx.seen;
    }
    constructor(params){
        // Normalize target for internal context
        let normalizedTarget = params?.target ?? "draft-2020-12";
        if (normalizedTarget === "draft-4") normalizedTarget = "draft-04";
        if (normalizedTarget === "draft-7") normalizedTarget = "draft-07";
        this.ctx = (0, _toJsonSchemaJs.initializeContext)({
            processors: (0, _jsonSchemaProcessorsJs.allProcessors),
            target: normalizedTarget,
            ...params?.metadata && {
                metadata: params.metadata
            },
            ...params?.unrepresentable && {
                unrepresentable: params.unrepresentable
            },
            ...params?.override && {
                override: params.override
            },
            ...params?.io && {
                io: params.io
            }
        });
    }
    /**
     * Process a schema to prepare it for JSON Schema generation.
     * This must be called before emit().
     */ process(schema, _params = {
        path: [],
        schemaPath: []
    }) {
        return (0, _toJsonSchemaJs.process)(schema, this.ctx, _params);
    }
    /**
     * Emit the final JSON Schema after processing.
     * Must call process() first.
     */ emit(schema, _params) {
        // Apply emit params to the context
        if (_params) {
            if (_params.cycles) this.ctx.cycles = _params.cycles;
            if (_params.reused) this.ctx.reused = _params.reused;
            if (_params.external) this.ctx.external = _params.external;
        }
        (0, _toJsonSchemaJs.extractDefs)(this.ctx, schema);
        const result = (0, _toJsonSchemaJs.finalize)(this.ctx, schema);
        // Strip ~standard property to match old implementation's return type
        const { "~standard": _, ...plainResult } = result;
        return plainResult;
    }
}

},{"./json-schema-processors.js":"c7eX7","./to-json-schema.js":"7JRwT","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gOGX9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6nTcv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZodType", ()=>ZodType);
parcelHelpers.export(exports, "_ZodString", ()=>_ZodString);
parcelHelpers.export(exports, "ZodString", ()=>ZodString);
parcelHelpers.export(exports, "string", ()=>string);
parcelHelpers.export(exports, "ZodStringFormat", ()=>ZodStringFormat);
parcelHelpers.export(exports, "ZodEmail", ()=>ZodEmail);
parcelHelpers.export(exports, "email", ()=>email);
parcelHelpers.export(exports, "ZodGUID", ()=>ZodGUID);
parcelHelpers.export(exports, "guid", ()=>guid);
parcelHelpers.export(exports, "ZodUUID", ()=>ZodUUID);
parcelHelpers.export(exports, "uuid", ()=>uuid);
parcelHelpers.export(exports, "uuidv4", ()=>uuidv4);
// ZodUUIDv6
parcelHelpers.export(exports, "uuidv6", ()=>uuidv6);
// ZodUUIDv7
parcelHelpers.export(exports, "uuidv7", ()=>uuidv7);
parcelHelpers.export(exports, "ZodURL", ()=>ZodURL);
parcelHelpers.export(exports, "url", ()=>url);
parcelHelpers.export(exports, "httpUrl", ()=>httpUrl);
parcelHelpers.export(exports, "ZodEmoji", ()=>ZodEmoji);
parcelHelpers.export(exports, "emoji", ()=>emoji);
parcelHelpers.export(exports, "ZodNanoID", ()=>ZodNanoID);
parcelHelpers.export(exports, "nanoid", ()=>nanoid);
parcelHelpers.export(exports, "ZodCUID", ()=>ZodCUID);
parcelHelpers.export(exports, "cuid", ()=>cuid);
parcelHelpers.export(exports, "ZodCUID2", ()=>ZodCUID2);
parcelHelpers.export(exports, "cuid2", ()=>cuid2);
parcelHelpers.export(exports, "ZodULID", ()=>ZodULID);
parcelHelpers.export(exports, "ulid", ()=>ulid);
parcelHelpers.export(exports, "ZodXID", ()=>ZodXID);
parcelHelpers.export(exports, "xid", ()=>xid);
parcelHelpers.export(exports, "ZodKSUID", ()=>ZodKSUID);
parcelHelpers.export(exports, "ksuid", ()=>ksuid);
parcelHelpers.export(exports, "ZodIPv4", ()=>ZodIPv4);
parcelHelpers.export(exports, "ipv4", ()=>ipv4);
parcelHelpers.export(exports, "ZodMAC", ()=>ZodMAC);
parcelHelpers.export(exports, "mac", ()=>mac);
parcelHelpers.export(exports, "ZodIPv6", ()=>ZodIPv6);
parcelHelpers.export(exports, "ipv6", ()=>ipv6);
parcelHelpers.export(exports, "ZodCIDRv4", ()=>ZodCIDRv4);
parcelHelpers.export(exports, "cidrv4", ()=>cidrv4);
parcelHelpers.export(exports, "ZodCIDRv6", ()=>ZodCIDRv6);
parcelHelpers.export(exports, "cidrv6", ()=>cidrv6);
parcelHelpers.export(exports, "ZodBase64", ()=>ZodBase64);
parcelHelpers.export(exports, "base64", ()=>base64);
parcelHelpers.export(exports, "ZodBase64URL", ()=>ZodBase64URL);
parcelHelpers.export(exports, "base64url", ()=>base64url);
parcelHelpers.export(exports, "ZodE164", ()=>ZodE164);
parcelHelpers.export(exports, "e164", ()=>e164);
parcelHelpers.export(exports, "ZodJWT", ()=>ZodJWT);
parcelHelpers.export(exports, "jwt", ()=>jwt);
parcelHelpers.export(exports, "ZodCustomStringFormat", ()=>ZodCustomStringFormat);
parcelHelpers.export(exports, "stringFormat", ()=>stringFormat);
parcelHelpers.export(exports, "hostname", ()=>hostname);
parcelHelpers.export(exports, "hex", ()=>hex);
parcelHelpers.export(exports, "hash", ()=>hash);
parcelHelpers.export(exports, "ZodNumber", ()=>ZodNumber);
parcelHelpers.export(exports, "number", ()=>number);
parcelHelpers.export(exports, "ZodNumberFormat", ()=>ZodNumberFormat);
parcelHelpers.export(exports, "int", ()=>int);
parcelHelpers.export(exports, "float32", ()=>float32);
parcelHelpers.export(exports, "float64", ()=>float64);
parcelHelpers.export(exports, "int32", ()=>int32);
parcelHelpers.export(exports, "uint32", ()=>uint32);
parcelHelpers.export(exports, "ZodBoolean", ()=>ZodBoolean);
parcelHelpers.export(exports, "boolean", ()=>boolean);
parcelHelpers.export(exports, "ZodBigInt", ()=>ZodBigInt);
parcelHelpers.export(exports, "bigint", ()=>bigint);
parcelHelpers.export(exports, "ZodBigIntFormat", ()=>ZodBigIntFormat);
// int64
parcelHelpers.export(exports, "int64", ()=>int64);
// uint64
parcelHelpers.export(exports, "uint64", ()=>uint64);
parcelHelpers.export(exports, "ZodSymbol", ()=>ZodSymbol);
parcelHelpers.export(exports, "symbol", ()=>symbol);
parcelHelpers.export(exports, "ZodUndefined", ()=>ZodUndefined);
parcelHelpers.export(exports, "undefined", ()=>_undefined);
parcelHelpers.export(exports, "ZodNull", ()=>ZodNull);
parcelHelpers.export(exports, "null", ()=>_null);
parcelHelpers.export(exports, "ZodAny", ()=>ZodAny);
parcelHelpers.export(exports, "any", ()=>any);
parcelHelpers.export(exports, "ZodUnknown", ()=>ZodUnknown);
parcelHelpers.export(exports, "unknown", ()=>unknown);
parcelHelpers.export(exports, "ZodNever", ()=>ZodNever);
parcelHelpers.export(exports, "never", ()=>never);
parcelHelpers.export(exports, "ZodVoid", ()=>ZodVoid);
parcelHelpers.export(exports, "void", ()=>_void);
parcelHelpers.export(exports, "ZodDate", ()=>ZodDate);
parcelHelpers.export(exports, "date", ()=>date);
parcelHelpers.export(exports, "ZodArray", ()=>ZodArray);
parcelHelpers.export(exports, "array", ()=>array);
// .keyof
parcelHelpers.export(exports, "keyof", ()=>keyof);
parcelHelpers.export(exports, "ZodObject", ()=>ZodObject);
parcelHelpers.export(exports, "object", ()=>object);
// strictObject
parcelHelpers.export(exports, "strictObject", ()=>strictObject);
// looseObject
parcelHelpers.export(exports, "looseObject", ()=>looseObject);
parcelHelpers.export(exports, "ZodUnion", ()=>ZodUnion);
parcelHelpers.export(exports, "union", ()=>union);
parcelHelpers.export(exports, "ZodXor", ()=>ZodXor);
/** Creates an exclusive union (XOR) where exactly one option must match.
 * Unlike regular unions that succeed when any option matches, xor fails if
 * zero or more than one option matches the input. */ parcelHelpers.export(exports, "xor", ()=>xor);
parcelHelpers.export(exports, "ZodDiscriminatedUnion", ()=>ZodDiscriminatedUnion);
parcelHelpers.export(exports, "discriminatedUnion", ()=>discriminatedUnion);
parcelHelpers.export(exports, "ZodIntersection", ()=>ZodIntersection);
parcelHelpers.export(exports, "intersection", ()=>intersection);
parcelHelpers.export(exports, "ZodTuple", ()=>ZodTuple);
parcelHelpers.export(exports, "tuple", ()=>tuple);
parcelHelpers.export(exports, "ZodRecord", ()=>ZodRecord);
parcelHelpers.export(exports, "record", ()=>record);
// type alksjf = core.output<core.$ZodRecordKey>;
parcelHelpers.export(exports, "partialRecord", ()=>partialRecord);
parcelHelpers.export(exports, "looseRecord", ()=>looseRecord);
parcelHelpers.export(exports, "ZodMap", ()=>ZodMap);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "ZodSet", ()=>ZodSet);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "ZodEnum", ()=>ZodEnum);
parcelHelpers.export(exports, "enum", ()=>_enum);
/** @deprecated This API has been merged into `z.enum()`. Use `z.enum()` instead.
 *
 * ```ts
 * enum Colors { red, green, blue }
 * z.enum(Colors);
 * ```
 */ parcelHelpers.export(exports, "nativeEnum", ()=>nativeEnum);
parcelHelpers.export(exports, "ZodLiteral", ()=>ZodLiteral);
parcelHelpers.export(exports, "literal", ()=>literal);
parcelHelpers.export(exports, "ZodFile", ()=>ZodFile);
parcelHelpers.export(exports, "file", ()=>file);
parcelHelpers.export(exports, "ZodTransform", ()=>ZodTransform);
parcelHelpers.export(exports, "transform", ()=>transform);
parcelHelpers.export(exports, "ZodOptional", ()=>ZodOptional);
parcelHelpers.export(exports, "optional", ()=>optional);
parcelHelpers.export(exports, "ZodExactOptional", ()=>ZodExactOptional);
parcelHelpers.export(exports, "exactOptional", ()=>exactOptional);
parcelHelpers.export(exports, "ZodNullable", ()=>ZodNullable);
parcelHelpers.export(exports, "nullable", ()=>nullable);
// nullish
parcelHelpers.export(exports, "nullish", ()=>nullish);
parcelHelpers.export(exports, "ZodDefault", ()=>ZodDefault);
parcelHelpers.export(exports, "_default", ()=>_default);
parcelHelpers.export(exports, "ZodPrefault", ()=>ZodPrefault);
parcelHelpers.export(exports, "prefault", ()=>prefault);
parcelHelpers.export(exports, "ZodNonOptional", ()=>ZodNonOptional);
parcelHelpers.export(exports, "nonoptional", ()=>nonoptional);
parcelHelpers.export(exports, "ZodSuccess", ()=>ZodSuccess);
parcelHelpers.export(exports, "success", ()=>success);
parcelHelpers.export(exports, "ZodCatch", ()=>ZodCatch);
parcelHelpers.export(exports, "catch", ()=>_catch);
parcelHelpers.export(exports, "ZodNaN", ()=>ZodNaN);
parcelHelpers.export(exports, "nan", ()=>nan);
parcelHelpers.export(exports, "ZodPipe", ()=>ZodPipe);
parcelHelpers.export(exports, "pipe", ()=>pipe);
parcelHelpers.export(exports, "ZodCodec", ()=>ZodCodec);
parcelHelpers.export(exports, "codec", ()=>codec);
parcelHelpers.export(exports, "ZodReadonly", ()=>ZodReadonly);
parcelHelpers.export(exports, "readonly", ()=>readonly);
parcelHelpers.export(exports, "ZodTemplateLiteral", ()=>ZodTemplateLiteral);
parcelHelpers.export(exports, "templateLiteral", ()=>templateLiteral);
parcelHelpers.export(exports, "ZodLazy", ()=>ZodLazy);
parcelHelpers.export(exports, "lazy", ()=>lazy);
parcelHelpers.export(exports, "ZodPromise", ()=>ZodPromise);
parcelHelpers.export(exports, "promise", ()=>promise);
parcelHelpers.export(exports, "ZodFunction", ()=>ZodFunction);
parcelHelpers.export(exports, "_function", ()=>_function);
parcelHelpers.export(exports, "function", ()=>_function);
parcelHelpers.export(exports, "ZodCustom", ()=>ZodCustom);
// custom checks
parcelHelpers.export(exports, "check", ()=>check);
parcelHelpers.export(exports, "custom", ()=>custom);
parcelHelpers.export(exports, "refine", ()=>refine);
// superRefine
parcelHelpers.export(exports, "superRefine", ()=>superRefine);
parcelHelpers.export(exports, "describe", ()=>describe);
parcelHelpers.export(exports, "meta", ()=>meta);
parcelHelpers.export(exports, "instanceof", ()=>_instanceof);
parcelHelpers.export(exports, "stringbool", ()=>stringbool);
parcelHelpers.export(exports, "json", ()=>json);
// preprocess
// /** @deprecated Use `z.pipe()` and `z.transform()` instead. */
parcelHelpers.export(exports, "preprocess", ()=>preprocess);
var _indexJs = require("../core/index.js");
var _jsonSchemaProcessorsJs = require("../core/json-schema-processors.js");
var _toJsonSchemaJs = require("../core/to-json-schema.js");
var _checksJs = require("./checks.js");
var _isoJs = require("./iso.js");
var _parseJs = require("./parse.js");
const ZodType = /*@__PURE__*/ _indexJs.$constructor("ZodType", (inst, def)=>{
    _indexJs.$ZodType.init(inst, def);
    Object.assign(inst["~standard"], {
        jsonSchema: {
            input: (0, _toJsonSchemaJs.createStandardJSONSchemaMethod)(inst, "input"),
            output: (0, _toJsonSchemaJs.createStandardJSONSchemaMethod)(inst, "output")
        }
    });
    inst.toJSONSchema = (0, _toJsonSchemaJs.createToJSONSchemaMethod)(inst, {});
    inst.def = def;
    inst.type = def.type;
    Object.defineProperty(inst, "_def", {
        value: def
    });
    // base methods
    inst.check = (...checks)=>{
        return inst.clone((0, _indexJs.util).mergeDefs(def, {
            checks: [
                ...def.checks ?? [],
                ...checks.map((ch)=>typeof ch === "function" ? {
                        _zod: {
                            check: ch,
                            def: {
                                check: "custom"
                            },
                            onattach: []
                        }
                    } : ch)
            ]
        }), {
            parent: true
        });
    };
    inst.with = inst.check;
    inst.clone = (def, params)=>_indexJs.clone(inst, def, params);
    inst.brand = ()=>inst;
    inst.register = (reg, meta)=>{
        reg.add(inst, meta);
        return inst;
    };
    // parsing
    inst.parse = (data, params)=>_parseJs.parse(inst, data, params, {
            callee: inst.parse
        });
    inst.safeParse = (data, params)=>_parseJs.safeParse(inst, data, params);
    inst.parseAsync = async (data, params)=>_parseJs.parseAsync(inst, data, params, {
            callee: inst.parseAsync
        });
    inst.safeParseAsync = async (data, params)=>_parseJs.safeParseAsync(inst, data, params);
    inst.spa = inst.safeParseAsync;
    // encoding/decoding
    inst.encode = (data, params)=>_parseJs.encode(inst, data, params);
    inst.decode = (data, params)=>_parseJs.decode(inst, data, params);
    inst.encodeAsync = async (data, params)=>_parseJs.encodeAsync(inst, data, params);
    inst.decodeAsync = async (data, params)=>_parseJs.decodeAsync(inst, data, params);
    inst.safeEncode = (data, params)=>_parseJs.safeEncode(inst, data, params);
    inst.safeDecode = (data, params)=>_parseJs.safeDecode(inst, data, params);
    inst.safeEncodeAsync = async (data, params)=>_parseJs.safeEncodeAsync(inst, data, params);
    inst.safeDecodeAsync = async (data, params)=>_parseJs.safeDecodeAsync(inst, data, params);
    // refinements
    inst.refine = (check, params)=>inst.check(refine(check, params));
    inst.superRefine = (refinement)=>inst.check(superRefine(refinement));
    inst.overwrite = (fn)=>inst.check(_checksJs.overwrite(fn));
    // wrappers
    inst.optional = ()=>optional(inst);
    inst.exactOptional = ()=>exactOptional(inst);
    inst.nullable = ()=>nullable(inst);
    inst.nullish = ()=>optional(nullable(inst));
    inst.nonoptional = (params)=>nonoptional(inst, params);
    inst.array = ()=>array(inst);
    inst.or = (arg)=>union([
            inst,
            arg
        ]);
    inst.and = (arg)=>intersection(inst, arg);
    inst.transform = (tx)=>pipe(inst, transform(tx));
    inst.default = (def)=>_default(inst, def);
    inst.prefault = (def)=>prefault(inst, def);
    // inst.coalesce = (def, params) => coalesce(inst, def, params);
    inst.catch = (params)=>_catch(inst, params);
    inst.pipe = (target)=>pipe(inst, target);
    inst.readonly = ()=>readonly(inst);
    // meta
    inst.describe = (description)=>{
        const cl = inst.clone();
        _indexJs.globalRegistry.add(cl, {
            description
        });
        return cl;
    };
    Object.defineProperty(inst, "description", {
        get () {
            return _indexJs.globalRegistry.get(inst)?.description;
        },
        configurable: true
    });
    inst.meta = (...args)=>{
        if (args.length === 0) return _indexJs.globalRegistry.get(inst);
        const cl = inst.clone();
        _indexJs.globalRegistry.add(cl, args[0]);
        return cl;
    };
    // helpers
    inst.isOptional = ()=>inst.safeParse(undefined).success;
    inst.isNullable = ()=>inst.safeParse(null).success;
    inst.apply = (fn)=>fn(inst);
    return inst;
});
const _ZodString = /*@__PURE__*/ _indexJs.$constructor("_ZodString", (inst, def)=>{
    _indexJs.$ZodString.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.stringProcessor(inst, ctx, json, params);
    const bag = inst._zod.bag;
    inst.format = bag.format ?? null;
    inst.minLength = bag.minimum ?? null;
    inst.maxLength = bag.maximum ?? null;
    // validations
    inst.regex = (...args)=>inst.check(_checksJs.regex(...args));
    inst.includes = (...args)=>inst.check(_checksJs.includes(...args));
    inst.startsWith = (...args)=>inst.check(_checksJs.startsWith(...args));
    inst.endsWith = (...args)=>inst.check(_checksJs.endsWith(...args));
    inst.min = (...args)=>inst.check(_checksJs.minLength(...args));
    inst.max = (...args)=>inst.check(_checksJs.maxLength(...args));
    inst.length = (...args)=>inst.check(_checksJs.length(...args));
    inst.nonempty = (...args)=>inst.check(_checksJs.minLength(1, ...args));
    inst.lowercase = (params)=>inst.check(_checksJs.lowercase(params));
    inst.uppercase = (params)=>inst.check(_checksJs.uppercase(params));
    // transforms
    inst.trim = ()=>inst.check(_checksJs.trim());
    inst.normalize = (...args)=>inst.check(_checksJs.normalize(...args));
    inst.toLowerCase = ()=>inst.check(_checksJs.toLowerCase());
    inst.toUpperCase = ()=>inst.check(_checksJs.toUpperCase());
    inst.slugify = ()=>inst.check(_checksJs.slugify());
});
const ZodString = /*@__PURE__*/ _indexJs.$constructor("ZodString", (inst, def)=>{
    _indexJs.$ZodString.init(inst, def);
    _ZodString.init(inst, def);
    inst.email = (params)=>inst.check(_indexJs._email(ZodEmail, params));
    inst.url = (params)=>inst.check(_indexJs._url(ZodURL, params));
    inst.jwt = (params)=>inst.check(_indexJs._jwt(ZodJWT, params));
    inst.emoji = (params)=>inst.check(_indexJs._emoji(ZodEmoji, params));
    inst.guid = (params)=>inst.check(_indexJs._guid(ZodGUID, params));
    inst.uuid = (params)=>inst.check(_indexJs._uuid(ZodUUID, params));
    inst.uuidv4 = (params)=>inst.check(_indexJs._uuidv4(ZodUUID, params));
    inst.uuidv6 = (params)=>inst.check(_indexJs._uuidv6(ZodUUID, params));
    inst.uuidv7 = (params)=>inst.check(_indexJs._uuidv7(ZodUUID, params));
    inst.nanoid = (params)=>inst.check(_indexJs._nanoid(ZodNanoID, params));
    inst.guid = (params)=>inst.check(_indexJs._guid(ZodGUID, params));
    inst.cuid = (params)=>inst.check(_indexJs._cuid(ZodCUID, params));
    inst.cuid2 = (params)=>inst.check(_indexJs._cuid2(ZodCUID2, params));
    inst.ulid = (params)=>inst.check(_indexJs._ulid(ZodULID, params));
    inst.base64 = (params)=>inst.check(_indexJs._base64(ZodBase64, params));
    inst.base64url = (params)=>inst.check(_indexJs._base64url(ZodBase64URL, params));
    inst.xid = (params)=>inst.check(_indexJs._xid(ZodXID, params));
    inst.ksuid = (params)=>inst.check(_indexJs._ksuid(ZodKSUID, params));
    inst.ipv4 = (params)=>inst.check(_indexJs._ipv4(ZodIPv4, params));
    inst.ipv6 = (params)=>inst.check(_indexJs._ipv6(ZodIPv6, params));
    inst.cidrv4 = (params)=>inst.check(_indexJs._cidrv4(ZodCIDRv4, params));
    inst.cidrv6 = (params)=>inst.check(_indexJs._cidrv6(ZodCIDRv6, params));
    inst.e164 = (params)=>inst.check(_indexJs._e164(ZodE164, params));
    // iso
    inst.datetime = (params)=>inst.check(_isoJs.datetime(params));
    inst.date = (params)=>inst.check(_isoJs.date(params));
    inst.time = (params)=>inst.check(_isoJs.time(params));
    inst.duration = (params)=>inst.check(_isoJs.duration(params));
});
function string(params) {
    return _indexJs._string(ZodString, params);
}
const ZodStringFormat = /*@__PURE__*/ _indexJs.$constructor("ZodStringFormat", (inst, def)=>{
    _indexJs.$ZodStringFormat.init(inst, def);
    _ZodString.init(inst, def);
});
const ZodEmail = /*@__PURE__*/ _indexJs.$constructor("ZodEmail", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodEmail.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function email(params) {
    return _indexJs._email(ZodEmail, params);
}
const ZodGUID = /*@__PURE__*/ _indexJs.$constructor("ZodGUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodGUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function guid(params) {
    return _indexJs._guid(ZodGUID, params);
}
const ZodUUID = /*@__PURE__*/ _indexJs.$constructor("ZodUUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodUUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function uuid(params) {
    return _indexJs._uuid(ZodUUID, params);
}
function uuidv4(params) {
    return _indexJs._uuidv4(ZodUUID, params);
}
function uuidv6(params) {
    return _indexJs._uuidv6(ZodUUID, params);
}
function uuidv7(params) {
    return _indexJs._uuidv7(ZodUUID, params);
}
const ZodURL = /*@__PURE__*/ _indexJs.$constructor("ZodURL", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodURL.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function url(params) {
    return _indexJs._url(ZodURL, params);
}
function httpUrl(params) {
    return _indexJs._url(ZodURL, {
        protocol: /^https?$/,
        hostname: _indexJs.regexes.domain,
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
const ZodEmoji = /*@__PURE__*/ _indexJs.$constructor("ZodEmoji", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodEmoji.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function emoji(params) {
    return _indexJs._emoji(ZodEmoji, params);
}
const ZodNanoID = /*@__PURE__*/ _indexJs.$constructor("ZodNanoID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodNanoID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function nanoid(params) {
    return _indexJs._nanoid(ZodNanoID, params);
}
const ZodCUID = /*@__PURE__*/ _indexJs.$constructor("ZodCUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodCUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cuid(params) {
    return _indexJs._cuid(ZodCUID, params);
}
const ZodCUID2 = /*@__PURE__*/ _indexJs.$constructor("ZodCUID2", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodCUID2.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cuid2(params) {
    return _indexJs._cuid2(ZodCUID2, params);
}
const ZodULID = /*@__PURE__*/ _indexJs.$constructor("ZodULID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodULID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ulid(params) {
    return _indexJs._ulid(ZodULID, params);
}
const ZodXID = /*@__PURE__*/ _indexJs.$constructor("ZodXID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodXID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function xid(params) {
    return _indexJs._xid(ZodXID, params);
}
const ZodKSUID = /*@__PURE__*/ _indexJs.$constructor("ZodKSUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodKSUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ksuid(params) {
    return _indexJs._ksuid(ZodKSUID, params);
}
const ZodIPv4 = /*@__PURE__*/ _indexJs.$constructor("ZodIPv4", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodIPv4.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ipv4(params) {
    return _indexJs._ipv4(ZodIPv4, params);
}
const ZodMAC = /*@__PURE__*/ _indexJs.$constructor("ZodMAC", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodMAC.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function mac(params) {
    return _indexJs._mac(ZodMAC, params);
}
const ZodIPv6 = /*@__PURE__*/ _indexJs.$constructor("ZodIPv6", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodIPv6.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ipv6(params) {
    return _indexJs._ipv6(ZodIPv6, params);
}
const ZodCIDRv4 = /*@__PURE__*/ _indexJs.$constructor("ZodCIDRv4", (inst, def)=>{
    _indexJs.$ZodCIDRv4.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cidrv4(params) {
    return _indexJs._cidrv4(ZodCIDRv4, params);
}
const ZodCIDRv6 = /*@__PURE__*/ _indexJs.$constructor("ZodCIDRv6", (inst, def)=>{
    _indexJs.$ZodCIDRv6.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cidrv6(params) {
    return _indexJs._cidrv6(ZodCIDRv6, params);
}
const ZodBase64 = /*@__PURE__*/ _indexJs.$constructor("ZodBase64", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodBase64.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function base64(params) {
    return _indexJs._base64(ZodBase64, params);
}
const ZodBase64URL = /*@__PURE__*/ _indexJs.$constructor("ZodBase64URL", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodBase64URL.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function base64url(params) {
    return _indexJs._base64url(ZodBase64URL, params);
}
const ZodE164 = /*@__PURE__*/ _indexJs.$constructor("ZodE164", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodE164.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function e164(params) {
    return _indexJs._e164(ZodE164, params);
}
const ZodJWT = /*@__PURE__*/ _indexJs.$constructor("ZodJWT", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodJWT.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function jwt(params) {
    return _indexJs._jwt(ZodJWT, params);
}
const ZodCustomStringFormat = /*@__PURE__*/ _indexJs.$constructor("ZodCustomStringFormat", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    _indexJs.$ZodCustomStringFormat.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function stringFormat(format, fnOrRegex, _params = {}) {
    return _indexJs._stringFormat(ZodCustomStringFormat, format, fnOrRegex, _params);
}
function hostname(_params) {
    return _indexJs._stringFormat(ZodCustomStringFormat, "hostname", _indexJs.regexes.hostname, _params);
}
function hex(_params) {
    return _indexJs._stringFormat(ZodCustomStringFormat, "hex", _indexJs.regexes.hex, _params);
}
function hash(alg, params) {
    const enc = params?.enc ?? "hex";
    const format = `${alg}_${enc}`;
    const regex = _indexJs.regexes[format];
    if (!regex) throw new Error(`Unrecognized hash format: ${format}`);
    return _indexJs._stringFormat(ZodCustomStringFormat, format, regex, params);
}
const ZodNumber = /*@__PURE__*/ _indexJs.$constructor("ZodNumber", (inst, def)=>{
    _indexJs.$ZodNumber.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.numberProcessor(inst, ctx, json, params);
    inst.gt = (value, params)=>inst.check(_checksJs.gt(value, params));
    inst.gte = (value, params)=>inst.check(_checksJs.gte(value, params));
    inst.min = (value, params)=>inst.check(_checksJs.gte(value, params));
    inst.lt = (value, params)=>inst.check(_checksJs.lt(value, params));
    inst.lte = (value, params)=>inst.check(_checksJs.lte(value, params));
    inst.max = (value, params)=>inst.check(_checksJs.lte(value, params));
    inst.int = (params)=>inst.check(int(params));
    inst.safe = (params)=>inst.check(int(params));
    inst.positive = (params)=>inst.check(_checksJs.gt(0, params));
    inst.nonnegative = (params)=>inst.check(_checksJs.gte(0, params));
    inst.negative = (params)=>inst.check(_checksJs.lt(0, params));
    inst.nonpositive = (params)=>inst.check(_checksJs.lte(0, params));
    inst.multipleOf = (value, params)=>inst.check(_checksJs.multipleOf(value, params));
    inst.step = (value, params)=>inst.check(_checksJs.multipleOf(value, params));
    // inst.finite = (params) => inst.check(core.finite(params));
    inst.finite = ()=>inst;
    const bag = inst._zod.bag;
    inst.minValue = Math.max(bag.minimum ?? Number.NEGATIVE_INFINITY, bag.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null;
    inst.maxValue = Math.min(bag.maximum ?? Number.POSITIVE_INFINITY, bag.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null;
    inst.isInt = (bag.format ?? "").includes("int") || Number.isSafeInteger(bag.multipleOf ?? 0.5);
    inst.isFinite = true;
    inst.format = bag.format ?? null;
});
function number(params) {
    return _indexJs._number(ZodNumber, params);
}
const ZodNumberFormat = /*@__PURE__*/ _indexJs.$constructor("ZodNumberFormat", (inst, def)=>{
    _indexJs.$ZodNumberFormat.init(inst, def);
    ZodNumber.init(inst, def);
});
function int(params) {
    return _indexJs._int(ZodNumberFormat, params);
}
function float32(params) {
    return _indexJs._float32(ZodNumberFormat, params);
}
function float64(params) {
    return _indexJs._float64(ZodNumberFormat, params);
}
function int32(params) {
    return _indexJs._int32(ZodNumberFormat, params);
}
function uint32(params) {
    return _indexJs._uint32(ZodNumberFormat, params);
}
const ZodBoolean = /*@__PURE__*/ _indexJs.$constructor("ZodBoolean", (inst, def)=>{
    _indexJs.$ZodBoolean.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.booleanProcessor(inst, ctx, json, params);
});
function boolean(params) {
    return _indexJs._boolean(ZodBoolean, params);
}
const ZodBigInt = /*@__PURE__*/ _indexJs.$constructor("ZodBigInt", (inst, def)=>{
    _indexJs.$ZodBigInt.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.bigintProcessor(inst, ctx, json, params);
    inst.gte = (value, params)=>inst.check(_checksJs.gte(value, params));
    inst.min = (value, params)=>inst.check(_checksJs.gte(value, params));
    inst.gt = (value, params)=>inst.check(_checksJs.gt(value, params));
    inst.gte = (value, params)=>inst.check(_checksJs.gte(value, params));
    inst.min = (value, params)=>inst.check(_checksJs.gte(value, params));
    inst.lt = (value, params)=>inst.check(_checksJs.lt(value, params));
    inst.lte = (value, params)=>inst.check(_checksJs.lte(value, params));
    inst.max = (value, params)=>inst.check(_checksJs.lte(value, params));
    inst.positive = (params)=>inst.check(_checksJs.gt(BigInt(0), params));
    inst.negative = (params)=>inst.check(_checksJs.lt(BigInt(0), params));
    inst.nonpositive = (params)=>inst.check(_checksJs.lte(BigInt(0), params));
    inst.nonnegative = (params)=>inst.check(_checksJs.gte(BigInt(0), params));
    inst.multipleOf = (value, params)=>inst.check(_checksJs.multipleOf(value, params));
    const bag = inst._zod.bag;
    inst.minValue = bag.minimum ?? null;
    inst.maxValue = bag.maximum ?? null;
    inst.format = bag.format ?? null;
});
function bigint(params) {
    return _indexJs._bigint(ZodBigInt, params);
}
const ZodBigIntFormat = /*@__PURE__*/ _indexJs.$constructor("ZodBigIntFormat", (inst, def)=>{
    _indexJs.$ZodBigIntFormat.init(inst, def);
    ZodBigInt.init(inst, def);
});
function int64(params) {
    return _indexJs._int64(ZodBigIntFormat, params);
}
function uint64(params) {
    return _indexJs._uint64(ZodBigIntFormat, params);
}
const ZodSymbol = /*@__PURE__*/ _indexJs.$constructor("ZodSymbol", (inst, def)=>{
    _indexJs.$ZodSymbol.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.symbolProcessor(inst, ctx, json, params);
});
function symbol(params) {
    return _indexJs._symbol(ZodSymbol, params);
}
const ZodUndefined = /*@__PURE__*/ _indexJs.$constructor("ZodUndefined", (inst, def)=>{
    _indexJs.$ZodUndefined.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.undefinedProcessor(inst, ctx, json, params);
});
function _undefined(params) {
    return _indexJs._undefined(ZodUndefined, params);
}
const ZodNull = /*@__PURE__*/ _indexJs.$constructor("ZodNull", (inst, def)=>{
    _indexJs.$ZodNull.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.nullProcessor(inst, ctx, json, params);
});
function _null(params) {
    return _indexJs._null(ZodNull, params);
}
const ZodAny = /*@__PURE__*/ _indexJs.$constructor("ZodAny", (inst, def)=>{
    _indexJs.$ZodAny.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.anyProcessor(inst, ctx, json, params);
});
function any() {
    return _indexJs._any(ZodAny);
}
const ZodUnknown = /*@__PURE__*/ _indexJs.$constructor("ZodUnknown", (inst, def)=>{
    _indexJs.$ZodUnknown.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.unknownProcessor(inst, ctx, json, params);
});
function unknown() {
    return _indexJs._unknown(ZodUnknown);
}
const ZodNever = /*@__PURE__*/ _indexJs.$constructor("ZodNever", (inst, def)=>{
    _indexJs.$ZodNever.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.neverProcessor(inst, ctx, json, params);
});
function never(params) {
    return _indexJs._never(ZodNever, params);
}
const ZodVoid = /*@__PURE__*/ _indexJs.$constructor("ZodVoid", (inst, def)=>{
    _indexJs.$ZodVoid.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.voidProcessor(inst, ctx, json, params);
});
function _void(params) {
    return _indexJs._void(ZodVoid, params);
}
const ZodDate = /*@__PURE__*/ _indexJs.$constructor("ZodDate", (inst, def)=>{
    _indexJs.$ZodDate.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.dateProcessor(inst, ctx, json, params);
    inst.min = (value, params)=>inst.check(_checksJs.gte(value, params));
    inst.max = (value, params)=>inst.check(_checksJs.lte(value, params));
    const c = inst._zod.bag;
    inst.minDate = c.minimum ? new Date(c.minimum) : null;
    inst.maxDate = c.maximum ? new Date(c.maximum) : null;
});
function date(params) {
    return _indexJs._date(ZodDate, params);
}
const ZodArray = /*@__PURE__*/ _indexJs.$constructor("ZodArray", (inst, def)=>{
    _indexJs.$ZodArray.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.arrayProcessor(inst, ctx, json, params);
    inst.element = def.element;
    inst.min = (minLength, params)=>inst.check(_checksJs.minLength(minLength, params));
    inst.nonempty = (params)=>inst.check(_checksJs.minLength(1, params));
    inst.max = (maxLength, params)=>inst.check(_checksJs.maxLength(maxLength, params));
    inst.length = (len, params)=>inst.check(_checksJs.length(len, params));
    inst.unwrap = ()=>inst.element;
});
function array(element, params) {
    return _indexJs._array(ZodArray, element, params);
}
function keyof(schema) {
    const shape = schema._zod.def.shape;
    return _enum(Object.keys(shape));
}
const ZodObject = /*@__PURE__*/ _indexJs.$constructor("ZodObject", (inst, def)=>{
    _indexJs.$ZodObjectJIT.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.objectProcessor(inst, ctx, json, params);
    (0, _indexJs.util).defineLazy(inst, "shape", ()=>{
        return def.shape;
    });
    inst.keyof = ()=>_enum(Object.keys(inst._zod.def.shape));
    inst.catchall = (catchall)=>inst.clone({
            ...inst._zod.def,
            catchall: catchall
        });
    inst.passthrough = ()=>inst.clone({
            ...inst._zod.def,
            catchall: unknown()
        });
    inst.loose = ()=>inst.clone({
            ...inst._zod.def,
            catchall: unknown()
        });
    inst.strict = ()=>inst.clone({
            ...inst._zod.def,
            catchall: never()
        });
    inst.strip = ()=>inst.clone({
            ...inst._zod.def,
            catchall: undefined
        });
    inst.extend = (incoming)=>{
        return (0, _indexJs.util).extend(inst, incoming);
    };
    inst.safeExtend = (incoming)=>{
        return (0, _indexJs.util).safeExtend(inst, incoming);
    };
    inst.merge = (other)=>(0, _indexJs.util).merge(inst, other);
    inst.pick = (mask)=>(0, _indexJs.util).pick(inst, mask);
    inst.omit = (mask)=>(0, _indexJs.util).omit(inst, mask);
    inst.partial = (...args)=>(0, _indexJs.util).partial(ZodOptional, inst, args[0]);
    inst.required = (...args)=>(0, _indexJs.util).required(ZodNonOptional, inst, args[0]);
});
function object(shape, params) {
    const def = {
        type: "object",
        shape: shape ?? {},
        ...(0, _indexJs.util).normalizeParams(params)
    };
    return new ZodObject(def);
}
function strictObject(shape, params) {
    return new ZodObject({
        type: "object",
        shape,
        catchall: never(),
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
function looseObject(shape, params) {
    return new ZodObject({
        type: "object",
        shape,
        catchall: unknown(),
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
const ZodUnion = /*@__PURE__*/ _indexJs.$constructor("ZodUnion", (inst, def)=>{
    _indexJs.$ZodUnion.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.unionProcessor(inst, ctx, json, params);
    inst.options = def.options;
});
function union(options, params) {
    return new ZodUnion({
        type: "union",
        options: options,
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
const ZodXor = /*@__PURE__*/ _indexJs.$constructor("ZodXor", (inst, def)=>{
    ZodUnion.init(inst, def);
    _indexJs.$ZodXor.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.unionProcessor(inst, ctx, json, params);
    inst.options = def.options;
});
function xor(options, params) {
    return new ZodXor({
        type: "union",
        options: options,
        inclusive: false,
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
const ZodDiscriminatedUnion = /*@__PURE__*/ _indexJs.$constructor("ZodDiscriminatedUnion", (inst, def)=>{
    ZodUnion.init(inst, def);
    _indexJs.$ZodDiscriminatedUnion.init(inst, def);
});
function discriminatedUnion(discriminator, options, params) {
    // const [options, params] = args;
    return new ZodDiscriminatedUnion({
        type: "union",
        options,
        discriminator,
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
const ZodIntersection = /*@__PURE__*/ _indexJs.$constructor("ZodIntersection", (inst, def)=>{
    _indexJs.$ZodIntersection.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.intersectionProcessor(inst, ctx, json, params);
});
function intersection(left, right) {
    return new ZodIntersection({
        type: "intersection",
        left: left,
        right: right
    });
}
const ZodTuple = /*@__PURE__*/ _indexJs.$constructor("ZodTuple", (inst, def)=>{
    _indexJs.$ZodTuple.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.tupleProcessor(inst, ctx, json, params);
    inst.rest = (rest)=>inst.clone({
            ...inst._zod.def,
            rest: rest
        });
});
function tuple(items, _paramsOrRest, _params) {
    const hasRest = _paramsOrRest instanceof _indexJs.$ZodType;
    const params = hasRest ? _params : _paramsOrRest;
    const rest = hasRest ? _paramsOrRest : null;
    return new ZodTuple({
        type: "tuple",
        items: items,
        rest,
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
const ZodRecord = /*@__PURE__*/ _indexJs.$constructor("ZodRecord", (inst, def)=>{
    _indexJs.$ZodRecord.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.recordProcessor(inst, ctx, json, params);
    inst.keyType = def.keyType;
    inst.valueType = def.valueType;
});
function record(keyType, valueType, params) {
    return new ZodRecord({
        type: "record",
        keyType,
        valueType: valueType,
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
function partialRecord(keyType, valueType, params) {
    const k = _indexJs.clone(keyType);
    k._zod.values = undefined;
    return new ZodRecord({
        type: "record",
        keyType: k,
        valueType: valueType,
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
function looseRecord(keyType, valueType, params) {
    return new ZodRecord({
        type: "record",
        keyType,
        valueType: valueType,
        mode: "loose",
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
const ZodMap = /*@__PURE__*/ _indexJs.$constructor("ZodMap", (inst, def)=>{
    _indexJs.$ZodMap.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.mapProcessor(inst, ctx, json, params);
    inst.keyType = def.keyType;
    inst.valueType = def.valueType;
    inst.min = (...args)=>inst.check(_indexJs._minSize(...args));
    inst.nonempty = (params)=>inst.check(_indexJs._minSize(1, params));
    inst.max = (...args)=>inst.check(_indexJs._maxSize(...args));
    inst.size = (...args)=>inst.check(_indexJs._size(...args));
});
function map(keyType, valueType, params) {
    return new ZodMap({
        type: "map",
        keyType: keyType,
        valueType: valueType,
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
const ZodSet = /*@__PURE__*/ _indexJs.$constructor("ZodSet", (inst, def)=>{
    _indexJs.$ZodSet.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.setProcessor(inst, ctx, json, params);
    inst.min = (...args)=>inst.check(_indexJs._minSize(...args));
    inst.nonempty = (params)=>inst.check(_indexJs._minSize(1, params));
    inst.max = (...args)=>inst.check(_indexJs._maxSize(...args));
    inst.size = (...args)=>inst.check(_indexJs._size(...args));
});
function set(valueType, params) {
    return new ZodSet({
        type: "set",
        valueType: valueType,
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
const ZodEnum = /*@__PURE__*/ _indexJs.$constructor("ZodEnum", (inst, def)=>{
    _indexJs.$ZodEnum.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.enumProcessor(inst, ctx, json, params);
    inst.enum = def.entries;
    inst.options = Object.values(def.entries);
    const keys = new Set(Object.keys(def.entries));
    inst.extract = (values, params)=>{
        const newEntries = {};
        for (const value of values){
            if (keys.has(value)) newEntries[value] = def.entries[value];
            else throw new Error(`Key ${value} not found in enum`);
        }
        return new ZodEnum({
            ...def,
            checks: [],
            ...(0, _indexJs.util).normalizeParams(params),
            entries: newEntries
        });
    };
    inst.exclude = (values, params)=>{
        const newEntries = {
            ...def.entries
        };
        for (const value of values){
            if (keys.has(value)) delete newEntries[value];
            else throw new Error(`Key ${value} not found in enum`);
        }
        return new ZodEnum({
            ...def,
            checks: [],
            ...(0, _indexJs.util).normalizeParams(params),
            entries: newEntries
        });
    };
});
function _enum(values, params) {
    const entries = Array.isArray(values) ? Object.fromEntries(values.map((v)=>[
            v,
            v
        ])) : values;
    return new ZodEnum({
        type: "enum",
        entries,
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
function nativeEnum(entries, params) {
    return new ZodEnum({
        type: "enum",
        entries,
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
const ZodLiteral = /*@__PURE__*/ _indexJs.$constructor("ZodLiteral", (inst, def)=>{
    _indexJs.$ZodLiteral.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.literalProcessor(inst, ctx, json, params);
    inst.values = new Set(def.values);
    Object.defineProperty(inst, "value", {
        get () {
            if (def.values.length > 1) throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
            return def.values[0];
        }
    });
});
function literal(value, params) {
    return new ZodLiteral({
        type: "literal",
        values: Array.isArray(value) ? value : [
            value
        ],
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
const ZodFile = /*@__PURE__*/ _indexJs.$constructor("ZodFile", (inst, def)=>{
    _indexJs.$ZodFile.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.fileProcessor(inst, ctx, json, params);
    inst.min = (size, params)=>inst.check(_indexJs._minSize(size, params));
    inst.max = (size, params)=>inst.check(_indexJs._maxSize(size, params));
    inst.mime = (types, params)=>inst.check(_indexJs._mime(Array.isArray(types) ? types : [
            types
        ], params));
});
function file(params) {
    return _indexJs._file(ZodFile, params);
}
const ZodTransform = /*@__PURE__*/ _indexJs.$constructor("ZodTransform", (inst, def)=>{
    _indexJs.$ZodTransform.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.transformProcessor(inst, ctx, json, params);
    inst._zod.parse = (payload, _ctx)=>{
        if (_ctx.direction === "backward") throw new _indexJs.$ZodEncodeError(inst.constructor.name);
        payload.addIssue = (issue)=>{
            if (typeof issue === "string") payload.issues.push((0, _indexJs.util).issue(issue, payload.value, def));
            else {
                // for Zod 3 backwards compatibility
                const _issue = issue;
                if (_issue.fatal) _issue.continue = false;
                _issue.code ?? (_issue.code = "custom");
                _issue.input ?? (_issue.input = payload.value);
                _issue.inst ?? (_issue.inst = inst);
                // _issue.continue ??= true;
                payload.issues.push((0, _indexJs.util).issue(_issue));
            }
        };
        const output = def.transform(payload.value, payload);
        if (output instanceof Promise) return output.then((output)=>{
            payload.value = output;
            return payload;
        });
        payload.value = output;
        return payload;
    };
});
function transform(fn) {
    return new ZodTransform({
        type: "transform",
        transform: fn
    });
}
const ZodOptional = /*@__PURE__*/ _indexJs.$constructor("ZodOptional", (inst, def)=>{
    _indexJs.$ZodOptional.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.optionalProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function optional(innerType) {
    return new ZodOptional({
        type: "optional",
        innerType: innerType
    });
}
const ZodExactOptional = /*@__PURE__*/ _indexJs.$constructor("ZodExactOptional", (inst, def)=>{
    _indexJs.$ZodExactOptional.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.optionalProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function exactOptional(innerType) {
    return new ZodExactOptional({
        type: "optional",
        innerType: innerType
    });
}
const ZodNullable = /*@__PURE__*/ _indexJs.$constructor("ZodNullable", (inst, def)=>{
    _indexJs.$ZodNullable.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.nullableProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function nullable(innerType) {
    return new ZodNullable({
        type: "nullable",
        innerType: innerType
    });
}
function nullish(innerType) {
    return optional(nullable(innerType));
}
const ZodDefault = /*@__PURE__*/ _indexJs.$constructor("ZodDefault", (inst, def)=>{
    _indexJs.$ZodDefault.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.defaultProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
    inst.removeDefault = inst.unwrap;
});
function _default(innerType, defaultValue) {
    return new ZodDefault({
        type: "default",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : (0, _indexJs.util).shallowClone(defaultValue);
        }
    });
}
const ZodPrefault = /*@__PURE__*/ _indexJs.$constructor("ZodPrefault", (inst, def)=>{
    _indexJs.$ZodPrefault.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.prefaultProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function prefault(innerType, defaultValue) {
    return new ZodPrefault({
        type: "prefault",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : (0, _indexJs.util).shallowClone(defaultValue);
        }
    });
}
const ZodNonOptional = /*@__PURE__*/ _indexJs.$constructor("ZodNonOptional", (inst, def)=>{
    _indexJs.$ZodNonOptional.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.nonoptionalProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function nonoptional(innerType, params) {
    return new ZodNonOptional({
        type: "nonoptional",
        innerType: innerType,
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
const ZodSuccess = /*@__PURE__*/ _indexJs.$constructor("ZodSuccess", (inst, def)=>{
    _indexJs.$ZodSuccess.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.successProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function success(innerType) {
    return new ZodSuccess({
        type: "success",
        innerType: innerType
    });
}
const ZodCatch = /*@__PURE__*/ _indexJs.$constructor("ZodCatch", (inst, def)=>{
    _indexJs.$ZodCatch.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.catchProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
    inst.removeCatch = inst.unwrap;
});
function _catch(innerType, catchValue) {
    return new ZodCatch({
        type: "catch",
        innerType: innerType,
        catchValue: typeof catchValue === "function" ? catchValue : ()=>catchValue
    });
}
const ZodNaN = /*@__PURE__*/ _indexJs.$constructor("ZodNaN", (inst, def)=>{
    _indexJs.$ZodNaN.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.nanProcessor(inst, ctx, json, params);
});
function nan(params) {
    return _indexJs._nan(ZodNaN, params);
}
const ZodPipe = /*@__PURE__*/ _indexJs.$constructor("ZodPipe", (inst, def)=>{
    _indexJs.$ZodPipe.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.pipeProcessor(inst, ctx, json, params);
    inst.in = def.in;
    inst.out = def.out;
});
function pipe(in_, out) {
    return new ZodPipe({
        type: "pipe",
        in: in_,
        out: out
    });
}
const ZodCodec = /*@__PURE__*/ _indexJs.$constructor("ZodCodec", (inst, def)=>{
    ZodPipe.init(inst, def);
    _indexJs.$ZodCodec.init(inst, def);
});
function codec(in_, out, params) {
    return new ZodCodec({
        type: "pipe",
        in: in_,
        out: out,
        transform: params.decode,
        reverseTransform: params.encode
    });
}
const ZodReadonly = /*@__PURE__*/ _indexJs.$constructor("ZodReadonly", (inst, def)=>{
    _indexJs.$ZodReadonly.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.readonlyProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function readonly(innerType) {
    return new ZodReadonly({
        type: "readonly",
        innerType: innerType
    });
}
const ZodTemplateLiteral = /*@__PURE__*/ _indexJs.$constructor("ZodTemplateLiteral", (inst, def)=>{
    _indexJs.$ZodTemplateLiteral.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.templateLiteralProcessor(inst, ctx, json, params);
});
function templateLiteral(parts, params) {
    return new ZodTemplateLiteral({
        type: "template_literal",
        parts,
        ...(0, _indexJs.util).normalizeParams(params)
    });
}
const ZodLazy = /*@__PURE__*/ _indexJs.$constructor("ZodLazy", (inst, def)=>{
    _indexJs.$ZodLazy.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.lazyProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.getter();
});
function lazy(getter) {
    return new ZodLazy({
        type: "lazy",
        getter: getter
    });
}
const ZodPromise = /*@__PURE__*/ _indexJs.$constructor("ZodPromise", (inst, def)=>{
    _indexJs.$ZodPromise.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.promiseProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function promise(innerType) {
    return new ZodPromise({
        type: "promise",
        innerType: innerType
    });
}
const ZodFunction = /*@__PURE__*/ _indexJs.$constructor("ZodFunction", (inst, def)=>{
    _indexJs.$ZodFunction.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.functionProcessor(inst, ctx, json, params);
});
function _function(params) {
    return new ZodFunction({
        type: "function",
        input: Array.isArray(params?.input) ? tuple(params?.input) : params?.input ?? array(unknown()),
        output: params?.output ?? unknown()
    });
}
const ZodCustom = /*@__PURE__*/ _indexJs.$constructor("ZodCustom", (inst, def)=>{
    _indexJs.$ZodCustom.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>_jsonSchemaProcessorsJs.customProcessor(inst, ctx, json, params);
});
function check(fn) {
    const ch = new _indexJs.$ZodCheck({
        check: "custom"
    });
    ch._zod.check = fn;
    return ch;
}
function custom(fn, _params) {
    return _indexJs._custom(ZodCustom, fn ?? (()=>true), _params);
}
function refine(fn, _params = {}) {
    return _indexJs._refine(ZodCustom, fn, _params);
}
function superRefine(fn) {
    return _indexJs._superRefine(fn);
}
const describe = _indexJs.describe;
const meta = _indexJs.meta;
function _instanceof(cls, params = {}) {
    const inst = new ZodCustom({
        type: "custom",
        check: "custom",
        fn: (data)=>data instanceof cls,
        abort: true,
        ...(0, _indexJs.util).normalizeParams(params)
    });
    inst._zod.bag.Class = cls;
    // Override check to emit invalid_type instead of custom
    inst._zod.check = (payload)=>{
        if (!(payload.value instanceof cls)) payload.issues.push({
            code: "invalid_type",
            expected: cls.name,
            input: payload.value,
            inst,
            path: [
                ...inst._zod.def.path ?? []
            ]
        });
    };
    return inst;
}
const stringbool = (...args)=>_indexJs._stringbool({
        Codec: ZodCodec,
        Boolean: ZodBoolean,
        String: ZodString
    }, ...args);
function json(params) {
    const jsonSchema = lazy(()=>{
        return union([
            string(params),
            number(),
            boolean(),
            _null(),
            array(jsonSchema),
            record(string(), jsonSchema)
        ]);
    });
    return jsonSchema;
}
function preprocess(fn, schema) {
    return pipe(transform(fn), schema);
}

},{"../core/index.js":"63UT7","../core/json-schema-processors.js":"c7eX7","../core/to-json-schema.js":"7JRwT","./checks.js":"1AKdd","./iso.js":"iqX89","./parse.js":"5Z06C","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1AKdd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lt", ()=>(0, _indexJs._lt));
parcelHelpers.export(exports, "lte", ()=>(0, _indexJs._lte));
parcelHelpers.export(exports, "gt", ()=>(0, _indexJs._gt));
parcelHelpers.export(exports, "gte", ()=>(0, _indexJs._gte));
parcelHelpers.export(exports, "positive", ()=>(0, _indexJs._positive));
parcelHelpers.export(exports, "negative", ()=>(0, _indexJs._negative));
parcelHelpers.export(exports, "nonpositive", ()=>(0, _indexJs._nonpositive));
parcelHelpers.export(exports, "nonnegative", ()=>(0, _indexJs._nonnegative));
parcelHelpers.export(exports, "multipleOf", ()=>(0, _indexJs._multipleOf));
parcelHelpers.export(exports, "maxSize", ()=>(0, _indexJs._maxSize));
parcelHelpers.export(exports, "minSize", ()=>(0, _indexJs._minSize));
parcelHelpers.export(exports, "size", ()=>(0, _indexJs._size));
parcelHelpers.export(exports, "maxLength", ()=>(0, _indexJs._maxLength));
parcelHelpers.export(exports, "minLength", ()=>(0, _indexJs._minLength));
parcelHelpers.export(exports, "length", ()=>(0, _indexJs._length));
parcelHelpers.export(exports, "regex", ()=>(0, _indexJs._regex));
parcelHelpers.export(exports, "lowercase", ()=>(0, _indexJs._lowercase));
parcelHelpers.export(exports, "uppercase", ()=>(0, _indexJs._uppercase));
parcelHelpers.export(exports, "includes", ()=>(0, _indexJs._includes));
parcelHelpers.export(exports, "startsWith", ()=>(0, _indexJs._startsWith));
parcelHelpers.export(exports, "endsWith", ()=>(0, _indexJs._endsWith));
parcelHelpers.export(exports, "property", ()=>(0, _indexJs._property));
parcelHelpers.export(exports, "mime", ()=>(0, _indexJs._mime));
parcelHelpers.export(exports, "overwrite", ()=>(0, _indexJs._overwrite));
parcelHelpers.export(exports, "normalize", ()=>(0, _indexJs._normalize));
parcelHelpers.export(exports, "trim", ()=>(0, _indexJs._trim));
parcelHelpers.export(exports, "toLowerCase", ()=>(0, _indexJs._toLowerCase));
parcelHelpers.export(exports, "toUpperCase", ()=>(0, _indexJs._toUpperCase));
parcelHelpers.export(exports, "slugify", ()=>(0, _indexJs._slugify));
var _indexJs = require("../core/index.js");

},{"../core/index.js":"63UT7","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"iqX89":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZodISODateTime", ()=>ZodISODateTime);
parcelHelpers.export(exports, "datetime", ()=>datetime);
parcelHelpers.export(exports, "ZodISODate", ()=>ZodISODate);
parcelHelpers.export(exports, "date", ()=>date);
parcelHelpers.export(exports, "ZodISOTime", ()=>ZodISOTime);
parcelHelpers.export(exports, "time", ()=>time);
parcelHelpers.export(exports, "ZodISODuration", ()=>ZodISODuration);
parcelHelpers.export(exports, "duration", ()=>duration);
var _indexJs = require("../core/index.js");
var _schemasJs = require("./schemas.js");
const ZodISODateTime = /*@__PURE__*/ _indexJs.$constructor("ZodISODateTime", (inst, def)=>{
    _indexJs.$ZodISODateTime.init(inst, def);
    _schemasJs.ZodStringFormat.init(inst, def);
});
function datetime(params) {
    return _indexJs._isoDateTime(ZodISODateTime, params);
}
const ZodISODate = /*@__PURE__*/ _indexJs.$constructor("ZodISODate", (inst, def)=>{
    _indexJs.$ZodISODate.init(inst, def);
    _schemasJs.ZodStringFormat.init(inst, def);
});
function date(params) {
    return _indexJs._isoDate(ZodISODate, params);
}
const ZodISOTime = /*@__PURE__*/ _indexJs.$constructor("ZodISOTime", (inst, def)=>{
    _indexJs.$ZodISOTime.init(inst, def);
    _schemasJs.ZodStringFormat.init(inst, def);
});
function time(params) {
    return _indexJs._isoTime(ZodISOTime, params);
}
const ZodISODuration = /*@__PURE__*/ _indexJs.$constructor("ZodISODuration", (inst, def)=>{
    _indexJs.$ZodISODuration.init(inst, def);
    _schemasJs.ZodStringFormat.init(inst, def);
});
function duration(params) {
    return _indexJs._isoDuration(ZodISODuration, params);
}

},{"../core/index.js":"63UT7","./schemas.js":"6nTcv","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5Z06C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "parseAsync", ()=>parseAsync);
parcelHelpers.export(exports, "safeParse", ()=>safeParse);
parcelHelpers.export(exports, "safeParseAsync", ()=>safeParseAsync);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "encodeAsync", ()=>encodeAsync);
parcelHelpers.export(exports, "decodeAsync", ()=>decodeAsync);
parcelHelpers.export(exports, "safeEncode", ()=>safeEncode);
parcelHelpers.export(exports, "safeDecode", ()=>safeDecode);
parcelHelpers.export(exports, "safeEncodeAsync", ()=>safeEncodeAsync);
parcelHelpers.export(exports, "safeDecodeAsync", ()=>safeDecodeAsync);
var _indexJs = require("../core/index.js");
var _errorsJs = require("./errors.js");
const parse = /* @__PURE__ */ _indexJs._parse((0, _errorsJs.ZodRealError));
const parseAsync = /* @__PURE__ */ _indexJs._parseAsync((0, _errorsJs.ZodRealError));
const safeParse = /* @__PURE__ */ _indexJs._safeParse((0, _errorsJs.ZodRealError));
const safeParseAsync = /* @__PURE__ */ _indexJs._safeParseAsync((0, _errorsJs.ZodRealError));
const encode = /* @__PURE__ */ _indexJs._encode((0, _errorsJs.ZodRealError));
const decode = /* @__PURE__ */ _indexJs._decode((0, _errorsJs.ZodRealError));
const encodeAsync = /* @__PURE__ */ _indexJs._encodeAsync((0, _errorsJs.ZodRealError));
const decodeAsync = /* @__PURE__ */ _indexJs._decodeAsync((0, _errorsJs.ZodRealError));
const safeEncode = /* @__PURE__ */ _indexJs._safeEncode((0, _errorsJs.ZodRealError));
const safeDecode = /* @__PURE__ */ _indexJs._safeDecode((0, _errorsJs.ZodRealError));
const safeEncodeAsync = /* @__PURE__ */ _indexJs._safeEncodeAsync((0, _errorsJs.ZodRealError));
const safeDecodeAsync = /* @__PURE__ */ _indexJs._safeDecodeAsync((0, _errorsJs.ZodRealError));

},{"../core/index.js":"63UT7","./errors.js":"8fkl5","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8fkl5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZodError", ()=>ZodError);
parcelHelpers.export(exports, "ZodRealError", ()=>ZodRealError);
var _indexJs = require("../core/index.js");
var _utilJs = require("../core/util.js");
const initializer = (inst, issues)=>{
    (0, _indexJs.$ZodError).init(inst, issues);
    inst.name = "ZodError";
    Object.defineProperties(inst, {
        format: {
            value: (mapper)=>_indexJs.formatError(inst, mapper)
        },
        flatten: {
            value: (mapper)=>_indexJs.flattenError(inst, mapper)
        },
        addIssue: {
            value: (issue)=>{
                inst.issues.push(issue);
                inst.message = JSON.stringify(inst.issues, _utilJs.jsonStringifyReplacer, 2);
            }
        },
        addIssues: {
            value: (issues)=>{
                inst.issues.push(...issues);
                inst.message = JSON.stringify(inst.issues, _utilJs.jsonStringifyReplacer, 2);
            }
        },
        isEmpty: {
            get () {
                return inst.issues.length === 0;
            }
        }
    });
// Object.defineProperty(inst, "isEmpty", {
//   get() {
//     return inst.issues.length === 0;
//   },
// });
};
const ZodError = _indexJs.$constructor("ZodError", initializer);
const ZodRealError = _indexJs.$constructor("ZodError", initializer, {
    Parent: Error
}); // /** @deprecated Use `z.core.$ZodErrorMapCtx` instead. */
 // export type ErrorMapCtx = core.$ZodErrorMapCtx;

},{"../core/index.js":"63UT7","../core/util.js":"kNqJY","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9Gu9u":[function(require,module,exports,__globalThis) {
// Zod 3 compat layer
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$brand", ()=>(0, _indexJs.$brand));
parcelHelpers.export(exports, "config", ()=>(0, _indexJs.config));
parcelHelpers.export(exports, "ZodIssueCode", ()=>ZodIssueCode);
/** @deprecated Use `z.config(params)` instead. */ parcelHelpers.export(exports, "setErrorMap", ()=>setErrorMap);
/** @deprecated Use `z.config()` instead. */ parcelHelpers.export(exports, "getErrorMap", ()=>getErrorMap);
parcelHelpers.export(exports, "ZodFirstPartyTypeKind", ()=>ZodFirstPartyTypeKind);
var _indexJs = require("../core/index.js");
const ZodIssueCode = {
    invalid_type: "invalid_type",
    too_big: "too_big",
    too_small: "too_small",
    invalid_format: "invalid_format",
    not_multiple_of: "not_multiple_of",
    unrecognized_keys: "unrecognized_keys",
    invalid_union: "invalid_union",
    invalid_key: "invalid_key",
    invalid_element: "invalid_element",
    invalid_value: "invalid_value",
    custom: "custom"
};
function setErrorMap(map) {
    _indexJs.config({
        customError: map
    });
}
function getErrorMap() {
    return _indexJs.config().customError;
}
var ZodFirstPartyTypeKind;
ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {});

},{"../core/index.js":"63UT7","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"19Ne8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts a JSON Schema to a Zod schema. This function should be considered semi-experimental. It's behavior is liable to change. */ parcelHelpers.export(exports, "fromJSONSchema", ()=>fromJSONSchema);
var _registriesJs = require("../core/registries.js");
var _checksJs = require("./checks.js");
var _isoJs = require("./iso.js");
var _schemasJs = require("./schemas.js");
// Local z object to avoid circular dependency with ../index.js
const z = {
    ..._schemasJs,
    ..._checksJs,
    iso: _isoJs
};
// Keys that are recognized and handled by the conversion logic
const RECOGNIZED_KEYS = new Set([
    // Schema identification
    "$schema",
    "$ref",
    "$defs",
    "definitions",
    // Core schema keywords
    "$id",
    "id",
    "$comment",
    "$anchor",
    "$vocabulary",
    "$dynamicRef",
    "$dynamicAnchor",
    // Type
    "type",
    "enum",
    "const",
    // Composition
    "anyOf",
    "oneOf",
    "allOf",
    "not",
    // Object
    "properties",
    "required",
    "additionalProperties",
    "patternProperties",
    "propertyNames",
    "minProperties",
    "maxProperties",
    // Array
    "items",
    "prefixItems",
    "additionalItems",
    "minItems",
    "maxItems",
    "uniqueItems",
    "contains",
    "minContains",
    "maxContains",
    // String
    "minLength",
    "maxLength",
    "pattern",
    "format",
    // Number
    "minimum",
    "maximum",
    "exclusiveMinimum",
    "exclusiveMaximum",
    "multipleOf",
    // Already handled metadata
    "description",
    "default",
    // Content
    "contentEncoding",
    "contentMediaType",
    "contentSchema",
    // Unsupported (error-throwing)
    "unevaluatedItems",
    "unevaluatedProperties",
    "if",
    "then",
    "else",
    "dependentSchemas",
    "dependentRequired",
    // OpenAPI
    "nullable",
    "readOnly"
]);
function detectVersion(schema, defaultTarget) {
    const $schema = schema.$schema;
    if ($schema === "https://json-schema.org/draft/2020-12/schema") return "draft-2020-12";
    if ($schema === "http://json-schema.org/draft-07/schema#") return "draft-7";
    if ($schema === "http://json-schema.org/draft-04/schema#") return "draft-4";
    // Use defaultTarget if provided, otherwise default to draft-2020-12
    return defaultTarget ?? "draft-2020-12";
}
function resolveRef(ref, ctx) {
    if (!ref.startsWith("#")) throw new Error("External $ref is not supported, only local refs (#/...) are allowed");
    const path = ref.slice(1).split("/").filter(Boolean);
    // Handle root reference "#"
    if (path.length === 0) return ctx.rootSchema;
    const defsKey = ctx.version === "draft-2020-12" ? "$defs" : "definitions";
    if (path[0] === defsKey) {
        const key = path[1];
        if (!key || !ctx.defs[key]) throw new Error(`Reference not found: ${ref}`);
        return ctx.defs[key];
    }
    throw new Error(`Reference not found: ${ref}`);
}
function convertBaseSchema(schema, ctx) {
    // Handle unsupported features
    if (schema.not !== undefined) {
        // Special case: { not: {} } represents never
        if (typeof schema.not === "object" && Object.keys(schema.not).length === 0) return z.never();
        throw new Error("not is not supported in Zod (except { not: {} } for never)");
    }
    if (schema.unevaluatedItems !== undefined) throw new Error("unevaluatedItems is not supported");
    if (schema.unevaluatedProperties !== undefined) throw new Error("unevaluatedProperties is not supported");
    if (schema.if !== undefined || schema.then !== undefined || schema.else !== undefined) throw new Error("Conditional schemas (if/then/else) are not supported");
    if (schema.dependentSchemas !== undefined || schema.dependentRequired !== undefined) throw new Error("dependentSchemas and dependentRequired are not supported");
    // Handle $ref
    if (schema.$ref) {
        const refPath = schema.$ref;
        if (ctx.refs.has(refPath)) return ctx.refs.get(refPath);
        if (ctx.processing.has(refPath)) // Circular reference - use lazy
        return z.lazy(()=>{
            if (!ctx.refs.has(refPath)) throw new Error(`Circular reference not resolved: ${refPath}`);
            return ctx.refs.get(refPath);
        });
        ctx.processing.add(refPath);
        const resolved = resolveRef(refPath, ctx);
        const zodSchema = convertSchema(resolved, ctx);
        ctx.refs.set(refPath, zodSchema);
        ctx.processing.delete(refPath);
        return zodSchema;
    }
    // Handle enum
    if (schema.enum !== undefined) {
        const enumValues = schema.enum;
        // Special case: OpenAPI 3.0 null representation { type: "string", nullable: true, enum: [null] }
        if (ctx.version === "openapi-3.0" && schema.nullable === true && enumValues.length === 1 && enumValues[0] === null) return z.null();
        if (enumValues.length === 0) return z.never();
        if (enumValues.length === 1) return z.literal(enumValues[0]);
        // Check if all values are strings
        if (enumValues.every((v)=>typeof v === "string")) return z.enum(enumValues);
        // Mixed types - use union of literals
        const literalSchemas = enumValues.map((v)=>z.literal(v));
        if (literalSchemas.length < 2) return literalSchemas[0];
        return z.union([
            literalSchemas[0],
            literalSchemas[1],
            ...literalSchemas.slice(2)
        ]);
    }
    // Handle const
    if (schema.const !== undefined) return z.literal(schema.const);
    // Handle type
    const type = schema.type;
    if (Array.isArray(type)) {
        // Expand type array into anyOf union
        const typeSchemas = type.map((t)=>{
            const typeSchema = {
                ...schema,
                type: t
            };
            return convertBaseSchema(typeSchema, ctx);
        });
        if (typeSchemas.length === 0) return z.never();
        if (typeSchemas.length === 1) return typeSchemas[0];
        return z.union(typeSchemas);
    }
    if (!type) // No type specified - empty schema (any)
    return z.any();
    let zodSchema;
    switch(type){
        case "string":
            {
                let stringSchema = z.string();
                // Apply format using .check() with Zod format functions
                if (schema.format) {
                    const format = schema.format;
                    // Map common formats to Zod check functions
                    if (format === "email") stringSchema = stringSchema.check(z.email());
                    else if (format === "uri" || format === "uri-reference") stringSchema = stringSchema.check(z.url());
                    else if (format === "uuid" || format === "guid") stringSchema = stringSchema.check(z.uuid());
                    else if (format === "date-time") stringSchema = stringSchema.check(z.iso.datetime());
                    else if (format === "date") stringSchema = stringSchema.check(z.iso.date());
                    else if (format === "time") stringSchema = stringSchema.check(z.iso.time());
                    else if (format === "duration") stringSchema = stringSchema.check(z.iso.duration());
                    else if (format === "ipv4") stringSchema = stringSchema.check(z.ipv4());
                    else if (format === "ipv6") stringSchema = stringSchema.check(z.ipv6());
                    else if (format === "mac") stringSchema = stringSchema.check(z.mac());
                    else if (format === "cidr") stringSchema = stringSchema.check(z.cidrv4());
                    else if (format === "cidr-v6") stringSchema = stringSchema.check(z.cidrv6());
                    else if (format === "base64") stringSchema = stringSchema.check(z.base64());
                    else if (format === "base64url") stringSchema = stringSchema.check(z.base64url());
                    else if (format === "e164") stringSchema = stringSchema.check(z.e164());
                    else if (format === "jwt") stringSchema = stringSchema.check(z.jwt());
                    else if (format === "emoji") stringSchema = stringSchema.check(z.emoji());
                    else if (format === "nanoid") stringSchema = stringSchema.check(z.nanoid());
                    else if (format === "cuid") stringSchema = stringSchema.check(z.cuid());
                    else if (format === "cuid2") stringSchema = stringSchema.check(z.cuid2());
                    else if (format === "ulid") stringSchema = stringSchema.check(z.ulid());
                    else if (format === "xid") stringSchema = stringSchema.check(z.xid());
                    else if (format === "ksuid") stringSchema = stringSchema.check(z.ksuid());
                // Note: json-string format is not currently supported by Zod
                // Custom formats are ignored - keep as plain string
                }
                // Apply constraints
                if (typeof schema.minLength === "number") stringSchema = stringSchema.min(schema.minLength);
                if (typeof schema.maxLength === "number") stringSchema = stringSchema.max(schema.maxLength);
                if (schema.pattern) // JSON Schema patterns are not implicitly anchored (match anywhere in string)
                stringSchema = stringSchema.regex(new RegExp(schema.pattern));
                zodSchema = stringSchema;
                break;
            }
        case "number":
        case "integer":
            {
                let numberSchema = type === "integer" ? z.number().int() : z.number();
                // Apply constraints
                if (typeof schema.minimum === "number") numberSchema = numberSchema.min(schema.minimum);
                if (typeof schema.maximum === "number") numberSchema = numberSchema.max(schema.maximum);
                if (typeof schema.exclusiveMinimum === "number") numberSchema = numberSchema.gt(schema.exclusiveMinimum);
                else if (schema.exclusiveMinimum === true && typeof schema.minimum === "number") numberSchema = numberSchema.gt(schema.minimum);
                if (typeof schema.exclusiveMaximum === "number") numberSchema = numberSchema.lt(schema.exclusiveMaximum);
                else if (schema.exclusiveMaximum === true && typeof schema.maximum === "number") numberSchema = numberSchema.lt(schema.maximum);
                if (typeof schema.multipleOf === "number") numberSchema = numberSchema.multipleOf(schema.multipleOf);
                zodSchema = numberSchema;
                break;
            }
        case "boolean":
            zodSchema = z.boolean();
            break;
        case "null":
            zodSchema = z.null();
            break;
        case "object":
            {
                const shape = {};
                const properties = schema.properties || {};
                const requiredSet = new Set(schema.required || []);
                // Convert properties - mark optional ones
                for (const [key, propSchema] of Object.entries(properties)){
                    const propZodSchema = convertSchema(propSchema, ctx);
                    // If not in required array, make it optional
                    shape[key] = requiredSet.has(key) ? propZodSchema : propZodSchema.optional();
                }
                // Handle propertyNames
                if (schema.propertyNames) {
                    const keySchema = convertSchema(schema.propertyNames, ctx);
                    const valueSchema = schema.additionalProperties && typeof schema.additionalProperties === "object" ? convertSchema(schema.additionalProperties, ctx) : z.any();
                    // Case A: No properties (pure record)
                    if (Object.keys(shape).length === 0) {
                        zodSchema = z.record(keySchema, valueSchema);
                        break;
                    }
                    // Case B: With properties (intersection of object and looseRecord)
                    const objectSchema = z.object(shape).passthrough();
                    const recordSchema = z.looseRecord(keySchema, valueSchema);
                    zodSchema = z.intersection(objectSchema, recordSchema);
                    break;
                }
                // Handle patternProperties
                if (schema.patternProperties) {
                    // patternProperties: keys matching pattern must satisfy corresponding schema
                    // Use loose records so non-matching keys pass through
                    const patternProps = schema.patternProperties;
                    const patternKeys = Object.keys(patternProps);
                    const looseRecords = [];
                    for (const pattern of patternKeys){
                        const patternValue = convertSchema(patternProps[pattern], ctx);
                        const keySchema = z.string().regex(new RegExp(pattern));
                        looseRecords.push(z.looseRecord(keySchema, patternValue));
                    }
                    // Build intersection: object schema + all pattern property records
                    const schemasToIntersect = [];
                    if (Object.keys(shape).length > 0) // Use passthrough so patternProperties can validate additional keys
                    schemasToIntersect.push(z.object(shape).passthrough());
                    schemasToIntersect.push(...looseRecords);
                    if (schemasToIntersect.length === 0) zodSchema = z.object({}).passthrough();
                    else if (schemasToIntersect.length === 1) zodSchema = schemasToIntersect[0];
                    else {
                        // Chain intersections: (A & B) & C & D ...
                        let result = z.intersection(schemasToIntersect[0], schemasToIntersect[1]);
                        for(let i = 2; i < schemasToIntersect.length; i++)result = z.intersection(result, schemasToIntersect[i]);
                        zodSchema = result;
                    }
                    break;
                }
                // Handle additionalProperties
                // In JSON Schema, additionalProperties defaults to true (allow any extra properties)
                // In Zod, objects strip unknown keys by default, so we need to handle this explicitly
                const objectSchema = z.object(shape);
                if (schema.additionalProperties === false) // Strict mode - no extra properties allowed
                zodSchema = objectSchema.strict();
                else if (typeof schema.additionalProperties === "object") // Extra properties must match the specified schema
                zodSchema = objectSchema.catchall(convertSchema(schema.additionalProperties, ctx));
                else // additionalProperties is true or undefined - allow any extra properties (passthrough)
                zodSchema = objectSchema.passthrough();
                break;
            }
        case "array":
            {
                // TODO: uniqueItems is not supported
                // TODO: contains/minContains/maxContains are not supported
                // Check if this is a tuple (prefixItems or items as array)
                const prefixItems = schema.prefixItems;
                const items = schema.items;
                if (prefixItems && Array.isArray(prefixItems)) {
                    // Tuple with prefixItems (draft-2020-12)
                    const tupleItems = prefixItems.map((item)=>convertSchema(item, ctx));
                    const rest = items && typeof items === "object" && !Array.isArray(items) ? convertSchema(items, ctx) : undefined;
                    if (rest) zodSchema = z.tuple(tupleItems).rest(rest);
                    else zodSchema = z.tuple(tupleItems);
                    // Apply minItems/maxItems constraints to tuples
                    if (typeof schema.minItems === "number") zodSchema = zodSchema.check(z.minLength(schema.minItems));
                    if (typeof schema.maxItems === "number") zodSchema = zodSchema.check(z.maxLength(schema.maxItems));
                } else if (Array.isArray(items)) {
                    // Tuple with items array (draft-7)
                    const tupleItems = items.map((item)=>convertSchema(item, ctx));
                    const rest = schema.additionalItems && typeof schema.additionalItems === "object" ? convertSchema(schema.additionalItems, ctx) : undefined; // additionalItems: false means no rest, handled by default tuple behavior
                    if (rest) zodSchema = z.tuple(tupleItems).rest(rest);
                    else zodSchema = z.tuple(tupleItems);
                    // Apply minItems/maxItems constraints to tuples
                    if (typeof schema.minItems === "number") zodSchema = zodSchema.check(z.minLength(schema.minItems));
                    if (typeof schema.maxItems === "number") zodSchema = zodSchema.check(z.maxLength(schema.maxItems));
                } else if (items !== undefined) {
                    // Regular array
                    const element = convertSchema(items, ctx);
                    let arraySchema = z.array(element);
                    // Apply constraints
                    if (typeof schema.minItems === "number") arraySchema = arraySchema.min(schema.minItems);
                    if (typeof schema.maxItems === "number") arraySchema = arraySchema.max(schema.maxItems);
                    zodSchema = arraySchema;
                } else // No items specified - array of any
                zodSchema = z.array(z.any());
                break;
            }
        default:
            throw new Error(`Unsupported type: ${type}`);
    }
    // Apply metadata
    if (schema.description) zodSchema = zodSchema.describe(schema.description);
    if (schema.default !== undefined) zodSchema = zodSchema.default(schema.default);
    return zodSchema;
}
function convertSchema(schema, ctx) {
    if (typeof schema === "boolean") return schema ? z.any() : z.never();
    // Convert base schema first (ignoring composition keywords)
    let baseSchema = convertBaseSchema(schema, ctx);
    const hasExplicitType = schema.type || schema.enum !== undefined || schema.const !== undefined;
    // Process composition keywords LAST (they can appear together)
    // Handle anyOf - wrap base schema with union
    if (schema.anyOf && Array.isArray(schema.anyOf)) {
        const options = schema.anyOf.map((s)=>convertSchema(s, ctx));
        const anyOfUnion = z.union(options);
        baseSchema = hasExplicitType ? z.intersection(baseSchema, anyOfUnion) : anyOfUnion;
    }
    // Handle oneOf - exclusive union (exactly one must match)
    if (schema.oneOf && Array.isArray(schema.oneOf)) {
        const options = schema.oneOf.map((s)=>convertSchema(s, ctx));
        const oneOfUnion = z.xor(options);
        baseSchema = hasExplicitType ? z.intersection(baseSchema, oneOfUnion) : oneOfUnion;
    }
    // Handle allOf - wrap base schema with intersection
    if (schema.allOf && Array.isArray(schema.allOf)) {
        if (schema.allOf.length === 0) baseSchema = hasExplicitType ? baseSchema : z.any();
        else {
            let result = hasExplicitType ? baseSchema : convertSchema(schema.allOf[0], ctx);
            const startIdx = hasExplicitType ? 0 : 1;
            for(let i = startIdx; i < schema.allOf.length; i++)result = z.intersection(result, convertSchema(schema.allOf[i], ctx));
            baseSchema = result;
        }
    }
    // Handle nullable (OpenAPI 3.0)
    if (schema.nullable === true && ctx.version === "openapi-3.0") baseSchema = z.nullable(baseSchema);
    // Handle readOnly
    if (schema.readOnly === true) baseSchema = z.readonly(baseSchema);
    // Collect metadata: core schema keywords and unrecognized keys
    const extraMeta = {};
    // Core schema keywords that should be captured as metadata
    const coreMetadataKeys = [
        "$id",
        "id",
        "$comment",
        "$anchor",
        "$vocabulary",
        "$dynamicRef",
        "$dynamicAnchor"
    ];
    for (const key of coreMetadataKeys)if (key in schema) extraMeta[key] = schema[key];
    // Content keywords - store as metadata
    const contentMetadataKeys = [
        "contentEncoding",
        "contentMediaType",
        "contentSchema"
    ];
    for (const key of contentMetadataKeys)if (key in schema) extraMeta[key] = schema[key];
    // Unrecognized keys (custom metadata)
    for (const key of Object.keys(schema))if (!RECOGNIZED_KEYS.has(key)) extraMeta[key] = schema[key];
    if (Object.keys(extraMeta).length > 0) ctx.registry.add(baseSchema, extraMeta);
    return baseSchema;
}
function fromJSONSchema(schema, params) {
    // Handle boolean schemas
    if (typeof schema === "boolean") return schema ? z.any() : z.never();
    const version = detectVersion(schema, params?.defaultTarget);
    const defs = schema.$defs || schema.definitions || {};
    const ctx = {
        version,
        defs,
        refs: new Map(),
        processing: new Set(),
        rootSchema: schema,
        registry: params?.registry ?? (0, _registriesJs.globalRegistry)
    };
    return convertSchema(schema, ctx);
}

},{"../core/registries.js":"fccKK","./checks.js":"1AKdd","./iso.js":"iqX89","./schemas.js":"6nTcv","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"DJhOY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "string", ()=>string);
parcelHelpers.export(exports, "number", ()=>number);
parcelHelpers.export(exports, "boolean", ()=>boolean);
parcelHelpers.export(exports, "bigint", ()=>bigint);
parcelHelpers.export(exports, "date", ()=>date);
var _indexJs = require("../core/index.js");
var _schemasJs = require("./schemas.js");
function string(params) {
    return _indexJs._coercedString(_schemasJs.ZodString, params);
}
function number(params) {
    return _indexJs._coercedNumber(_schemasJs.ZodNumber, params);
}
function boolean(params) {
    return _indexJs._coercedBoolean(_schemasJs.ZodBoolean, params);
}
function bigint(params) {
    return _indexJs._coercedBigint(_schemasJs.ZodBigInt, params);
}
function date(params) {
    return _indexJs._coercedDate(_schemasJs.ZodDate, params);
}

},{"../core/index.js":"63UT7","./schemas.js":"6nTcv","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7Dz6x":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>MoveDown);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M8 18L12 22L16 18",
            key: "cskvfv"
        }
    ],
    [
        "path",
        {
            d: "M12 2V22",
            key: "r89rzk"
        }
    ]
];
const MoveDown = (0, _createLucideIconJsDefault.default)("move-down", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7htqi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Spinner", ()=>Spinner);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _utils = require("@/client/lib/utils");
function Spinner({ className, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.LoaderCircle), {
        role: "status",
        "aria-label": "Loading",
        className: (0, _utils.cn)("size-4 animate-spin", className),
        ...props
    });
}

},{"react/jsx-runtime":"dQjte","lucide-react":[["LoaderCircle","gZHhk","default"]],"@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dl7Bp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("@tanstack/react-router");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _lucideReact = require("lucide-react");
var _runbook = require("@/client/content/runbook");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'runbook',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: RunbookIndexComponent
});
function RunbookIndexComponent() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    className: "mb-4 text-2xl font-semibold",
                    children: "Runbook"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "text-muted-foreground mb-6",
                    children: "Documentation and operational guides for the admin portal."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "grid gap-4 md:grid-cols-2 lg:grid-cols-3",
                    children: (0, _runbook.runbookPages).map((page)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                            to: "/runbook/$page",
                            params: {
                                page: page.slug
                            },
                            className: "flex items-center gap-3 p-4 rounded-lg border hover:bg-accent transition-colors",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FileText), {
                                    className: "h-5 w-5 text-muted-foreground"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-medium",
                                    children: page.title
                                })
                            ]
                        }, page.slug))
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","@tanstack/react-router":[["createRoute","hPO6R"],["Link","7k6Lq"],["redirect","jmFxY"]],"../__root":"enXay","@/client/layouts/layout":"d6QdD","lucide-react":[["FileText","jrUS7","default"]],"@/client/content/runbook":"42sj3","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"aKFRJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("@tanstack/react-router");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _markdown = require("@/client/components/ui/markdown");
var _lucideReact = require("lucide-react");
var _runbook = require("@/client/content/runbook");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'runbook/$page',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: RunbookPageComponent
});
function RunbookPageComponent() {
    const { page } = Route.useParams();
    const pageData = (0, _runbook.runbookBySlug)[page];
    if (!pageData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                    to: "/runbook",
                    className: "inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowLeft), {
                            className: "h-4 w-4"
                        }),
                        "Back to Runbook"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    className: "text-2xl font-semibold mb-4",
                    children: "Page Not Found"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "text-muted-foreground",
                    children: [
                        'The runbook page "',
                        page,
                        '" does not exist.'
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                    to: "/runbook",
                    className: "inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowLeft), {
                            className: "h-4 w-4"
                        }),
                        "Back to Runbook"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markdown.Markdown), {
                    children: pageData.content
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","@tanstack/react-router":[["createRoute","hPO6R"],["Link","7k6Lq"],["redirect","jmFxY"]],"../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/components/ui/markdown":"jn0Mn","lucide-react":[["ArrowLeft","2k0dn","default"]],"@/client/content/runbook":"42sj3","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jn0Mn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Markdown", ()=>MarkdownRenderer);
var _jsxRuntime = require("react/jsx-runtime");
var _markdownToJsx = require("markdown-to-jsx");
var _markdownToJsxDefault = parcelHelpers.interopDefault(_markdownToJsx);
var _utils = require("@/client/lib/utils");
const MarkdownRenderer = ({ children, className })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _utils.cn)("prose prose-sm dark:prose-invert max-w-none", "prose-headings:font-semibold prose-headings:tracking-tight", "prose-h1:text-2xl prose-h2:text-xl prose-h3:text-lg", "prose-p:leading-7 prose-p:my-4", "prose-a:text-primary prose-a:underline hover:prose-a:text-primary/80", "prose-code:bg-muted prose-code:px-1 prose-code:py-0.5 prose-code:rounded prose-code:text-sm", "prose-pre:bg-muted prose-pre:p-4 prose-pre:rounded-lg", "prose-ul:my-4 prose-ul:list-disc prose-ul:pl-6", "prose-ol:my-4 prose-ol:list-decimal prose-ol:pl-6", "prose-li:my-1", "prose-blockquote:border-l-4 prose-blockquote:border-muted-foreground/30 prose-blockquote:pl-4 prose-blockquote:italic", className),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _markdownToJsxDefault.default), {
            children: children
        })
    });
};

},{"react/jsx-runtime":"dQjte","markdown-to-jsx":"7b6J9","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7b6J9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slugify", ()=>dq) //# debugId=95E0D59AFEB65D2D64756E2164756E21
;
parcelHelpers.export(exports, "sanitizer", ()=>I1);
parcelHelpers.export(exports, "parser", ()=>fJ);
parcelHelpers.export(exports, "default", ()=>gY);
parcelHelpers.export(exports, "compiler", ()=>CZ);
parcelHelpers.export(exports, "RuleType", ()=>F);
parcelHelpers.export(exports, "Markdown", ()=>xJ);
var _nodeModule = require("node:module");
var _react = require("react");
var EJ = Object.defineProperty;
var PJ = (q, G)=>{
    for(var Y in G)EJ(q, Y, {
        get: G[Y],
        enumerable: !0,
        configurable: !0,
        set: (Z)=>G[Y] = ()=>Z
    });
};
var I = 32, p = 9, Lq = 13, Xq = 10, mq = 96, k1 = 126, y1 = 91, t1 = 94, B1 = 62, OG = 35, IY = 37, X1 = 45, S1 = 61, h1 = 92, FG = 42, e1 = 95, qG = 60, bG = 64, GG = 93, wG = 33, WG = 38, MG = 58, mY = 70, E1 = 102, P1 = 104, j1 = 119, PG = 116, JZ = 112, uZ = 115, dZ = 160, iZ = 12;
var YZ = 46, ZG = 47;
var CY = 34, cZ = 43, aZ = 124, rZ = 123;
var $Z = 120, VZ = 88, JG = 48, YG = 57, p1 = 65, l1 = 90, $G = 97, VG = 122, oq = 128, sZ = 32;
var IJ = {
    blockQuote: 0,
    breakLine: 1,
    breakThematic: 2,
    codeBlock: 3,
    codeInline: 4,
    footnote: 5,
    footnoteReference: 6,
    frontmatter: 7,
    gfmTask: 8,
    heading: 9,
    htmlBlock: 10,
    htmlComment: 11,
    htmlSelfClosing: 12,
    image: 13,
    link: 14,
    orderedList: 15,
    paragraph: 16,
    ref: 17,
    refCollection: 18,
    table: 19,
    text: 20,
    textFormatted: 21,
    unorderedList: 22
}, F = IJ;
var HZ = {};
PJ(HZ, {
    startsWith: ()=>n,
    slugify: ()=>dq,
    skipWhitespace: ()=>yq,
    shouldFilterTag: ()=>pG,
    sanitizer: ()=>I1,
    parseFrontmatterBounds: ()=>UZ,
    isVoidElement: ()=>KG,
    isUnicodeWhitespace: ()=>d1,
    isUnicodePunctuation: ()=>kG,
    isAlnumCode: ()=>mG,
    isASCIIWhitespace: ()=>BG,
    isASCIIPunctuation: ()=>pJ,
    inlineCharTypeTable: ()=>yG,
    includes: ()=>mJ,
    htmlAttrsToJSXProps: ()=>IG,
    hasKeys: ()=>hG,
    getTag: ()=>dJ,
    getOverrideProps: ()=>iJ,
    get: ()=>jZ,
    findLineEnd: ()=>x,
    extractPlainText: ()=>qJ,
    endsWith: ()=>CG,
    decodeEntityReferences: ()=>zG,
    charClassTable: ()=>XG,
    applyTagFilterToText: ()=>lG,
    VOID_ELEMENTS: ()=>KZ,
    SHOULD_RENDER_AS_BLOCK_R: ()=>QZ,
    SANITIZE_R: ()=>AG,
    NAMED_CODES_TO_UNICODE: ()=>zZ,
    HTML_TO_JSX_MAP: ()=>eZ,
    HTML_CHAR_CODE_R: ()=>tZ,
    ATTRIBUTES_TO_SANITIZE: ()=>DZ
});
var oZ = {
    af: "\u2061",
    applyfunction: "\u2061",
    ic: "\u2063",
    invisiblecomma: "\u2063",
    invisibletimes: "\u2062",
    it: "\u2062",
    lrm: "\u200E",
    negativemediumspace: "\u200B",
    negativethickspace: "\u200B",
    negativethinspace: "\u200B",
    negativeverythinspace: "\u200B",
    nobreak: "\u2060",
    rlm: "\u200F",
    shy: "\xad",
    zerowidthspace: "\u200B",
    zwj: "\u200D",
    zwnj: "\u200C",
    downbreve: "\u0311",
    tdot: "\u20DB",
    tripledot: "\u20DB",
    dotdot: "\u20DC",
    tab: "\t",
    newline: `
`,
    emsp: "\u2003",
    emsp13: "\u2004",
    emsp14: "\u2005",
    ensp: "\u2002",
    hairsp: "\u200A",
    mediumspace: "\u205F",
    puncsp: "\u2008",
    thinsp: "\u2009",
    thinspace: "\u2009",
    verythinspace: "\u200A",
    nbsp: "\xa0",
    nonbreakingspace: "\xa0",
    numsp: "\u2007",
    thickspace: "\u205F\u200A",
    oline: "\u203E",
    overbar: "\u203E",
    lowbar: "_",
    underbar: "_",
    dash: "\u2010",
    hyphen: "\u2010",
    ndash: "\u2013",
    mdash: "\u2014",
    horbar: "\u2015",
    comma: ",",
    semi: ";",
    bsemi: "\u204F",
    colon: ":",
    Colone: "\u2A74",
    excl: "!",
    iexcl: "\xa1",
    quest: "?",
    iquest: "\xbf",
    period: ".",
    nldr: "\u2025",
    hellip: "\u2026",
    mldr: "\u2026",
    centerdot: "\xb7",
    middot: "\xb7",
    apos: "'",
    lsquo: "\u2018",
    opencurlyquote: "\u2018",
    closecurlyquote: "\u2019",
    rsquo: "\u2019",
    rsquor: "\u2019",
    lsquor: "\u201A",
    sbquo: "\u201A",
    lsaquo: "\u2039",
    rsaquo: "\u203A",
    quot: '"',
    ldquo: "\u201C",
    opencurlydoublequote: "\u201C",
    closecurlydoublequote: "\u201D",
    rdquo: "\u201D",
    rdquor: "\u201D",
    bdquo: "\u201E",
    ldquor: "\u201E",
    laquo: "\xab",
    raquo: "\xbb",
    lpar: "(",
    rpar: ")",
    lbrack: "[",
    lsqb: "[",
    rbrack: "]",
    rsqb: "]",
    lbrace: "{",
    lcub: "{",
    rbrace: "}",
    rcub: "}",
    lceil: "\u2308",
    leftceiling: "\u2308",
    rceil: "\u2309",
    rightceiling: "\u2309",
    leftfloor: "\u230A",
    lfloor: "\u230A",
    rfloor: "\u230B",
    rightfloor: "\u230B",
    lopar: "\u2985",
    ropar: "\u2986",
    lbrke: "\u298B",
    rbrke: "\u298C",
    lbrkslu: "\u298D",
    rbrksld: "\u298E",
    lbrksld: "\u298F",
    rbrkslu: "\u2990",
    langd: "\u2991",
    rangd: "\u2992",
    lparlt: "\u2993",
    rpargt: "\u2994",
    gtlpar: "\u2995",
    ltrpar: "\u2996",
    leftdoublebracket: "\u27E6",
    lobrk: "\u27E6",
    rightdoublebracket: "\u27E7",
    robrk: "\u27E7",
    lang: "\u27E8",
    langle: "\u27E8",
    leftanglebracket: "\u27E8",
    rang: "\u27E9",
    rangle: "\u27E9",
    rightanglebracket: "\u27E9",
    Lang: "\u27EA",
    Rang: "\u27EB",
    loang: "\u27EC",
    roang: "\u27ED",
    lbbrk: "\u2772",
    rbbrk: "\u2773",
    Verbar: "\u2016",
    Vert: "\u2016",
    sect: "\xa7",
    para: "\xb6",
    commat: "@",
    ast: "*",
    midast: "*",
    sol: "/",
    bsol: "\\",
    amp: "&",
    num: "#",
    percnt: "%",
    permil: "\u2030",
    pertenk: "\u2031",
    dagger: "\u2020",
    Dagger: "\u2021",
    ddagger: "\u2021",
    bull: "\u2022",
    bullet: "\u2022",
    hybull: "\u2043",
    prime: "\u2032",
    Prime: "\u2033",
    tprime: "\u2034",
    qprime: "\u2057",
    backprime: "\u2035",
    bprime: "\u2035",
    caret: "\u2041",
    diacriticalgrave: "`",
    grave: "`",
    acute: "\xb4",
    diacriticalacute: "\xb4",
    diacriticaltilde: "\u02DC",
    tilde: "\u02DC",
    hat: "^",
    macr: "\xaf",
    strns: "\xaf",
    breve: "\u02D8",
    diacriticaldot: "\u02D9",
    dot: "\u02D9",
    die: "\xa8",
    Dot: "\xa8",
    doubledot: "\xa8",
    uml: "\xa8",
    ring: "\u02DA",
    dblac: "\u02DD",
    diacriticaldoubleacute: "\u02DD",
    cedil: "\xb8",
    cedilla: "\xb8",
    ogon: "\u02DB",
    circ: "\u02C6",
    caron: "\u02C7",
    hacek: "\u02C7",
    deg: "\xb0",
    copy: "\xa9",
    circledr: "\xae",
    reg: "\xae",
    copysr: "\u2117",
    weierp: "\u2118",
    wp: "\u2118",
    rx: "\u211E",
    mho: "\u2127",
    iiota: "\u2129",
    larr: "\u2190",
    leftarrow: "\u2190",
    shortleftarrow: "\u2190",
    slarr: "\u2190",
    nlarr: "\u219A",
    nleftarrow: "\u219A",
    rarr: "\u2192",
    rightarrow: "\u2192",
    shortrightarrow: "\u2192",
    srarr: "\u2192",
    nrarr: "\u219B",
    nrightarrow: "\u219B",
    shortuparrow: "\u2191",
    uarr: "\u2191",
    uparrow: "\u2191",
    darr: "\u2193",
    downarrow: "\u2193",
    shortdownarrow: "\u2193",
    harr: "\u2194",
    leftrightarrow: "\u2194",
    nharr: "\u21AE",
    nleftrightarrow: "\u21AE",
    updownarrow: "\u2195",
    varr: "\u2195",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    upperleftarrow: "\u2196",
    nearr: "\u2197",
    nearrow: "\u2197",
    upperrightarrow: "\u2197",
    lowerrightarrow: "\u2198",
    searr: "\u2198",
    searrow: "\u2198",
    lowerleftarrow: "\u2199",
    swarr: "\u2199",
    swarrow: "\u2199",
    rarrw: "\u219D",
    rightsquigarrow: "\u219D",
    nrarrw: "\u219D\u0338",
    Larr: "\u219E",
    twoheadleftarrow: "\u219E",
    Uarr: "\u219F",
    Rarr: "\u21A0",
    twoheadrightarrow: "\u21A0",
    Darr: "\u21A1",
    larrtl: "\u21A2",
    leftarrowtail: "\u21A2",
    rarrtl: "\u21A3",
    rightarrowtail: "\u21A3",
    leftteearrow: "\u21A4",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    upteearrow: "\u21A5",
    map: "\u21A6",
    mapsto: "\u21A6",
    rightteearrow: "\u21A6",
    downteearrow: "\u21A7",
    mapstodown: "\u21A7",
    hookleftarrow: "\u21A9",
    larrhk: "\u21A9",
    hookrightarrow: "\u21AA",
    rarrhk: "\u21AA",
    larrlp: "\u21AB",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    rarrlp: "\u21AC",
    harrw: "\u21AD",
    leftrightsquigarrow: "\u21AD",
    lsh: "\u21B0",
    rsh: "\u21B1",
    ldsh: "\u21B2",
    rdsh: "\u21B3",
    crarr: "\u21B5",
    cularr: "\u21B6",
    curvearrowleft: "\u21B6",
    curarr: "\u21B7",
    curvearrowright: "\u21B7",
    circlearrowleft: "\u21BA",
    olarr: "\u21BA",
    circlearrowright: "\u21BB",
    orarr: "\u21BB",
    leftharpoonup: "\u21BC",
    leftvector: "\u21BC",
    lharu: "\u21BC",
    downleftvector: "\u21BD",
    leftharpoondown: "\u21BD",
    lhard: "\u21BD",
    rightupvector: "\u21BE",
    uharr: "\u21BE",
    upharpoonright: "\u21BE",
    leftupvector: "\u21BF",
    uharl: "\u21BF",
    upharpoonleft: "\u21BF",
    rharu: "\u21C0",
    rightharpoonup: "\u21C0",
    rightvector: "\u21C0",
    downrightvector: "\u21C1",
    rhard: "\u21C1",
    rightharpoondown: "\u21C1",
    dharr: "\u21C2",
    downharpoonright: "\u21C2",
    rightdownvector: "\u21C2",
    dharl: "\u21C3",
    downharpoonleft: "\u21C3",
    leftdownvector: "\u21C3",
    rightarrowleftarrow: "\u21C4",
    rightleftarrows: "\u21C4",
    rlarr: "\u21C4",
    udarr: "\u21C5",
    uparrowdownarrow: "\u21C5",
    leftarrowrightarrow: "\u21C6",
    leftrightarrows: "\u21C6",
    lrarr: "\u21C6",
    leftleftarrows: "\u21C7",
    llarr: "\u21C7",
    upuparrows: "\u21C8",
    uuarr: "\u21C8",
    rightrightarrows: "\u21C9",
    rrarr: "\u21C9",
    ddarr: "\u21CA",
    downdownarrows: "\u21CA",
    leftrightharpoons: "\u21CB",
    lrhar: "\u21CB",
    reverseequilibrium: "\u21CB",
    equilibrium: "\u21CC",
    rightleftharpoons: "\u21CC",
    rlhar: "\u21CC",
    doubleleftarrow: "\u21D0",
    lArr: "\u21D0",
    Leftarrow: "\u21D0",
    nlArr: "\u21CD",
    nLeftarrow: "\u21CD",
    doubleuparrow: "\u21D1",
    uArr: "\u21D1",
    Uparrow: "\u21D1",
    doublerightarrow: "\u21D2",
    implies: "\u21D2",
    rArr: "\u21D2",
    Rightarrow: "\u21D2",
    nrArr: "\u21CF",
    nRightarrow: "\u21CF",
    dArr: "\u21D3",
    doubledownarrow: "\u21D3",
    Downarrow: "\u21D3",
    doubleleftrightarrow: "\u21D4",
    hArr: "\u21D4",
    iff: "\u21D4",
    Leftrightarrow: "\u21D4",
    nhArr: "\u21CE",
    nLeftrightarrow: "\u21CE",
    doubleupdownarrow: "\u21D5",
    Updownarrow: "\u21D5",
    vArr: "\u21D5",
    nwArr: "\u21D6",
    neArr: "\u21D7",
    seArr: "\u21D8",
    swArr: "\u21D9",
    laarr: "\u21DA",
    lleftarrow: "\u21DA",
    raarr: "\u21DB",
    rrightarrow: "\u21DB",
    zigrarr: "\u21DD",
    larrb: "\u21E4",
    leftarrowbar: "\u21E4",
    rarrb: "\u21E5",
    rightarrowbar: "\u21E5",
    downarrowuparrow: "\u21F5",
    duarr: "\u21F5",
    loarr: "\u21FD",
    roarr: "\u21FE",
    hoarr: "\u21FF",
    forall: "\u2200",
    comp: "\u2201",
    complement: "\u2201",
    part: "\u2202",
    partiald: "\u2202",
    npart: "\u2202\u0338",
    exist: "\u2203",
    exists: "\u2203",
    nexist: "\u2204",
    nexists: "\u2204",
    notexists: "\u2204",
    empty: "\u2205",
    emptyset: "\u2205",
    emptyv: "\u2205",
    varnothing: "\u2205",
    del: "\u2207",
    nabla: "\u2207",
    element: "\u2208",
    in: "\u2208",
    isin: "\u2208",
    isinv: "\u2208",
    notelement: "\u2209",
    notin: "\u2209",
    notinva: "\u2209",
    ni: "\u220B",
    niv: "\u220B",
    reverseelement: "\u220B",
    suchthat: "\u220B",
    notni: "\u220C",
    notniva: "\u220C",
    notreverseelement: "\u220C",
    backepsilon: "\u03F6",
    bepsi: "\u03F6",
    prod: "\u220F",
    product: "\u220F",
    coprod: "\u2210",
    coproduct: "\u2210",
    sum: "\u2211",
    plus: "+",
    plusminus: "\xb1",
    plusmn: "\xb1",
    pm: "\xb1",
    div: "\xf7",
    divide: "\xf7",
    times: "\xd7",
    lt: "<",
    nless: "\u226E",
    nlt: "\u226E",
    notless: "\u226E",
    nvlt: "<\u20D2",
    equals: "=",
    ne: "\u2260",
    notequal: "\u2260",
    bne: "=\u20E5",
    equal: "\u2A75",
    gt: ">",
    ngt: "\u226F",
    ngtr: "\u226F",
    notgreater: "\u226F",
    nvgt: ">\u20D2",
    not: "\xac",
    verbar: "|",
    vert: "|",
    verticalline: "|",
    brvbar: "\xa6",
    minus: "\u2212",
    minusplus: "\u2213",
    mnplus: "\u2213",
    mp: "\u2213",
    dotplus: "\u2214",
    plusdo: "\u2214",
    frasl: "\u2044",
    backslash: "\u2216",
    setminus: "\u2216",
    setmn: "\u2216",
    smallsetminus: "\u2216",
    ssetmn: "\u2216",
    lowast: "\u2217",
    compfn: "\u2218",
    smallcircle: "\u2218",
    radic: "\u221A",
    sqrt: "\u221A",
    prop: "\u221D",
    proportional: "\u221D",
    propto: "\u221D",
    varpropto: "\u221D",
    vprop: "\u221D",
    infin: "\u221E",
    angrt: "\u221F",
    ang: "\u2220",
    angle: "\u2220",
    nang: "\u2220\u20D2",
    angmsd: "\u2221",
    measuredangle: "\u2221",
    angsph: "\u2222",
    mid: "\u2223",
    shortmid: "\u2223",
    smid: "\u2223",
    verticalbar: "\u2223",
    nmid: "\u2224",
    notverticalbar: "\u2224",
    nshortmid: "\u2224",
    nsmid: "\u2224",
    doubleverticalbar: "\u2225",
    par: "\u2225",
    parallel: "\u2225",
    shortparallel: "\u2225",
    spar: "\u2225",
    notdoubleverticalbar: "\u2226",
    npar: "\u2226",
    nparallel: "\u2226",
    nshortparallel: "\u2226",
    nspar: "\u2226",
    and: "\u2227",
    wedge: "\u2227",
    or: "\u2228",
    vee: "\u2228",
    cap: "\u2229",
    caps: "\u2229\uFE00",
    cup: "\u222A",
    cups: "\u222A\uFE00",
    int: "\u222B",
    integral: "\u222B",
    Int: "\u222C",
    iiint: "\u222D",
    tint: "\u222D",
    iiiint: "\u2A0C",
    qint: "\u2A0C",
    conint: "\u222E",
    contourintegral: "\u222E",
    oint: "\u222E",
    Conint: "\u222F",
    doublecontourintegral: "\u222F",
    cconint: "\u2230",
    cwint: "\u2231",
    clockwisecontourintegral: "\u2232",
    cwconint: "\u2232",
    awconint: "\u2233",
    counterclockwisecontourintegral: "\u2233",
    there4: "\u2234",
    therefore: "\u2234",
    becaus: "\u2235",
    because: "\u2235",
    ratio: "\u2236",
    Colon: "\u2237",
    proportion: "\u2237",
    dotminus: "\u2238",
    minusd: "\u2238",
    mddot: "\u223A",
    homtht: "\u223B",
    sim: "\u223C",
    thicksim: "\u223C",
    thksim: "\u223C",
    Tilde: "\u223C",
    nottilde: "\u2241",
    nsim: "\u2241",
    nvsim: "\u223C\u20D2",
    backsim: "\u223D",
    bsim: "\u223D",
    race: "\u223D\u0331",
    ac: "\u223E",
    mstpos: "\u223E",
    ace: "\u223E\u0333",
    acd: "\u223F",
    verticaltilde: "\u2240",
    wr: "\u2240",
    wreath: "\u2240",
    eqsim: "\u2242",
    equaltilde: "\u2242",
    esim: "\u2242",
    nesim: "\u2242\u0338",
    notequaltilde: "\u2242\u0338",
    sime: "\u2243",
    simeq: "\u2243",
    tildeequal: "\u2243",
    nottildeequal: "\u2244",
    nsime: "\u2244",
    nsimeq: "\u2244",
    cong: "\u2245",
    tildefullequal: "\u2245",
    ncong: "\u2247",
    nottildefullequal: "\u2247",
    simne: "\u2246",
    ap: "\u2248",
    approx: "\u2248",
    asymp: "\u2248",
    thickapprox: "\u2248",
    thkap: "\u2248",
    tildetilde: "\u2248",
    nap: "\u2249",
    napprox: "\u2249",
    nottildetilde: "\u2249",
    ape: "\u224A",
    approxeq: "\u224A",
    apid: "\u224B",
    napid: "\u224B\u0338",
    backcong: "\u224C",
    bcong: "\u224C",
    asympeq: "\u224D",
    CupCap: "\u224D",
    notcupcap: "\u226D",
    nvap: "\u224D\u20D2",
    bump: "\u224E",
    Bumpeq: "\u224E",
    humpdownhump: "\u224E",
    nbump: "\u224E\u0338",
    nothumpdownhump: "\u224E\u0338",
    bumpe: "\u224F",
    bumpeq: "\u224F",
    humpequal: "\u224F",
    nbumpe: "\u224F\u0338",
    nothumpequal: "\u224F\u0338",
    doteq: "\u2250",
    dotequal: "\u2250",
    esdot: "\u2250",
    nedot: "\u2250\u0338",
    doteqdot: "\u2251",
    eDot: "\u2251",
    efdot: "\u2252",
    fallingdotseq: "\u2252",
    erdot: "\u2253",
    risingdotseq: "\u2253",
    assign: "\u2254",
    colone: "\u2254",
    coloneq: "\u2254",
    ecolon: "\u2255",
    eqcolon: "\u2255",
    ecir: "\u2256",
    eqcirc: "\u2256",
    circeq: "\u2257",
    cire: "\u2257",
    wedgeq: "\u2259",
    veeeq: "\u225A",
    triangleq: "\u225C",
    trie: "\u225C",
    equest: "\u225F",
    questeq: "\u225F",
    congruent: "\u2261",
    equiv: "\u2261",
    nequiv: "\u2262",
    notcongruent: "\u2262",
    bnequiv: "\u2261\u20E5",
    le: "\u2264",
    leq: "\u2264",
    nle: "\u2270",
    nleq: "\u2270",
    notlessequal: "\u2270",
    nvle: "\u2264\u20D2",
    ge: "\u2265",
    geq: "\u2265",
    greaterequal: "\u2265",
    nge: "\u2271",
    ngeq: "\u2271",
    notgreaterequal: "\u2271",
    nvge: "\u2265\u20D2",
    lE: "\u2266",
    leqq: "\u2266",
    lessfullequal: "\u2266",
    nlE: "\u2266\u0338",
    nleqq: "\u2266\u0338",
    gE: "\u2267",
    geqq: "\u2267",
    greaterfullequal: "\u2267",
    ngE: "\u2267\u0338",
    ngeqq: "\u2267\u0338",
    notgreaterfullequal: "\u2267\u0338",
    lnE: "\u2268",
    lneqq: "\u2268",
    lvertneqq: "\u2268\uFE00",
    lvne: "\u2268\uFE00",
    gnE: "\u2269",
    gneqq: "\u2269",
    gvertneqq: "\u2269\uFE00",
    gvne: "\u2269\uFE00",
    ll: "\u226A",
    Lt: "\u226A",
    nestedlessless: "\u226A",
    nltv: "\u226A\u0338",
    notlessless: "\u226A\u0338",
    nLt: "\u226A\u20D2",
    gg: "\u226B",
    Gt: "\u226B",
    nestedgreatergreater: "\u226B",
    ngtv: "\u226B\u0338",
    notgreatergreater: "\u226B\u0338",
    nGt: "\u226B\u20D2",
    between: "\u226C",
    twixt: "\u226C",
    lesssim: "\u2272",
    lesstilde: "\u2272",
    lsim: "\u2272",
    nlsim: "\u2274",
    notlesstilde: "\u2274",
    greatertilde: "\u2273",
    gsim: "\u2273",
    gtrsim: "\u2273",
    ngsim: "\u2275",
    notgreatertilde: "\u2275",
    lessgreater: "\u2276",
    lessgtr: "\u2276",
    lg: "\u2276",
    notlessgreater: "\u2278",
    ntlg: "\u2278",
    gl: "\u2277",
    greaterless: "\u2277",
    gtrless: "\u2277",
    notgreaterless: "\u2279",
    ntgl: "\u2279",
    pr: "\u227A",
    prec: "\u227A",
    precedes: "\u227A",
    notprecedes: "\u2280",
    npr: "\u2280",
    nprec: "\u2280",
    sc: "\u227B",
    succ: "\u227B",
    succeeds: "\u227B",
    notsucceeds: "\u2281",
    nsc: "\u2281",
    nsucc: "\u2281",
    prcue: "\u227C",
    preccurlyeq: "\u227C",
    precedesslantequal: "\u227C",
    notprecedesslantequal: "\u22E0",
    nprcue: "\u22E0",
    sccue: "\u227D",
    succcurlyeq: "\u227D",
    succeedsslantequal: "\u227D",
    notsucceedsslantequal: "\u22E1",
    nsccue: "\u22E1",
    precedestilde: "\u227E",
    precsim: "\u227E",
    prsim: "\u227E",
    scsim: "\u227F",
    succeedstilde: "\u227F",
    succsim: "\u227F",
    notsucceedstilde: "\u227F\u0338",
    sub: "\u2282",
    subset: "\u2282",
    nsub: "\u2284",
    notsubset: "\u2282\u20D2",
    nsubset: "\u2282\u20D2",
    vnsub: "\u2282\u20D2",
    sup: "\u2283",
    superset: "\u2283",
    supset: "\u2283",
    nsup: "\u2285",
    notsuperset: "\u2283\u20D2",
    nsupset: "\u2283\u20D2",
    vnsup: "\u2283\u20D2",
    sube: "\u2286",
    subseteq: "\u2286",
    subsetequal: "\u2286",
    notsubsetequal: "\u2288",
    nsube: "\u2288",
    nsubseteq: "\u2288",
    supe: "\u2287",
    supersetequal: "\u2287",
    supseteq: "\u2287",
    notsupersetequal: "\u2289",
    nsupe: "\u2289",
    nsupseteq: "\u2289",
    subne: "\u228A",
    subsetneq: "\u228A",
    varsubsetneq: "\u228A\uFE00",
    vsubne: "\u228A\uFE00",
    supne: "\u228B",
    supsetneq: "\u228B",
    varsupsetneq: "\u228B\uFE00",
    vsupne: "\u228B\uFE00",
    cupdot: "\u228D",
    unionplus: "\u228E",
    uplus: "\u228E",
    sqsub: "\u228F",
    sqsubset: "\u228F",
    squaresubset: "\u228F",
    notsquaresubset: "\u228F\u0338",
    sqsup: "\u2290",
    sqsupset: "\u2290",
    squaresuperset: "\u2290",
    notsquaresuperset: "\u2290\u0338",
    sqsube: "\u2291",
    sqsubseteq: "\u2291",
    squaresubsetequal: "\u2291",
    notsquaresubsetequal: "\u22E2",
    nsqsube: "\u22E2",
    sqsupe: "\u2292",
    sqsupseteq: "\u2292",
    squaresupersetequal: "\u2292",
    notsquaresupersetequal: "\u22E3",
    nsqsupe: "\u22E3",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    squareintersection: "\u2293",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    squareunion: "\u2294",
    circleplus: "\u2295",
    oplus: "\u2295",
    circleminus: "\u2296",
    ominus: "\u2296",
    circletimes: "\u2297",
    otimes: "\u2297",
    osol: "\u2298",
    circledot: "\u2299",
    odot: "\u2299",
    circledcirc: "\u229A",
    ocir: "\u229A",
    circledast: "\u229B",
    oast: "\u229B",
    circleddash: "\u229D",
    odash: "\u229D",
    boxplus: "\u229E",
    plusb: "\u229E",
    boxminus: "\u229F",
    minusb: "\u229F",
    boxtimes: "\u22A0",
    timesb: "\u22A0",
    dotsquare: "\u22A1",
    sdotb: "\u22A1",
    righttee: "\u22A2",
    vdash: "\u22A2",
    nvdash: "\u22AC",
    dashv: "\u22A3",
    lefttee: "\u22A3",
    downtee: "\u22A4",
    top: "\u22A4",
    bot: "\u22A5",
    bottom: "\u22A5",
    perp: "\u22A5",
    uptee: "\u22A5",
    models: "\u22A7",
    doublerighttee: "\u22A8",
    vDash: "\u22A8",
    nvDash: "\u22AD",
    Vdash: "\u22A9",
    nVdash: "\u22AE",
    vvdash: "\u22AA",
    VDash: "\u22AB",
    nVDash: "\u22AF",
    prurel: "\u22B0",
    lefttriangle: "\u22B2",
    vartriangleleft: "\u22B2",
    vltri: "\u22B2",
    nltri: "\u22EA",
    notlefttriangle: "\u22EA",
    ntriangleleft: "\u22EA",
    righttriangle: "\u22B3",
    vartriangleright: "\u22B3",
    vrtri: "\u22B3",
    notrighttriangle: "\u22EB",
    nrtri: "\u22EB",
    ntriangleright: "\u22EB",
    lefttriangleequal: "\u22B4",
    ltrie: "\u22B4",
    trianglelefteq: "\u22B4",
    nltrie: "\u22EC",
    notlefttriangleequal: "\u22EC",
    ntrianglelefteq: "\u22EC",
    nvltrie: "\u22B4\u20D2",
    righttriangleequal: "\u22B5",
    rtrie: "\u22B5",
    trianglerighteq: "\u22B5",
    notrighttriangleequal: "\u22ED",
    nrtrie: "\u22ED",
    ntrianglerighteq: "\u22ED",
    nvrtrie: "\u22B5\u20D2",
    origof: "\u22B6",
    imof: "\u22B7",
    multimap: "\u22B8",
    mumap: "\u22B8",
    hercon: "\u22B9",
    intcal: "\u22BA",
    intercal: "\u22BA",
    veebar: "\u22BB",
    barvee: "\u22BD",
    angrtvb: "\u22BE",
    lrtri: "\u22BF",
    bigwedge: "\u22C0",
    Wedge: "\u22C0",
    xwedge: "\u22C0",
    bigvee: "\u22C1",
    Vee: "\u22C1",
    xvee: "\u22C1",
    bigcap: "\u22C2",
    intersection: "\u22C2",
    xcap: "\u22C2",
    bigcup: "\u22C3",
    union: "\u22C3",
    xcup: "\u22C3",
    diam: "\u22C4",
    diamond: "\u22C4",
    sdot: "\u22C5",
    sstarf: "\u22C6",
    Star: "\u22C6",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    bowtie: "\u22C8",
    ltimes: "\u22C9",
    rtimes: "\u22CA",
    leftthreetimes: "\u22CB",
    lthree: "\u22CB",
    rightthreetimes: "\u22CC",
    rthree: "\u22CC",
    backsimeq: "\u22CD",
    bsime: "\u22CD",
    curlyvee: "\u22CE",
    cuvee: "\u22CE",
    curlywedge: "\u22CF",
    cuwed: "\u22CF",
    Sub: "\u22D0",
    Subset: "\u22D0",
    Sup: "\u22D1",
    Supset: "\u22D1",
    Cap: "\u22D2",
    Cup: "\u22D3",
    fork: "\u22D4",
    pitchfork: "\u22D4",
    epar: "\u22D5",
    lessdot: "\u22D6",
    ltdot: "\u22D6",
    gtdot: "\u22D7",
    gtrdot: "\u22D7",
    Ll: "\u22D8",
    nll: "\u22D8\u0338",
    Gg: "\u22D9",
    ggg: "\u22D9",
    ngg: "\u22D9\u0338",
    leg: "\u22DA",
    lesg: "\u22DA\uFE00",
    lesseqgtr: "\u22DA",
    lessequalgreater: "\u22DA",
    gel: "\u22DB",
    gesl: "\u22DB\uFE00",
    greaterequalless: "\u22DB",
    gtreqless: "\u22DB",
    cuepr: "\u22DE",
    curlyeqprec: "\u22DE",
    cuesc: "\u22DF",
    curlyeqsucc: "\u22DF",
    lnsim: "\u22E6",
    gnsim: "\u22E7",
    precnsim: "\u22E8",
    prnsim: "\u22E8",
    scnsim: "\u22E9",
    succnsim: "\u22E9",
    vellip: "\u22EE",
    ctdot: "\u22EF",
    utdot: "\u22F0",
    dtdot: "\u22F1",
    disin: "\u22F2",
    isinsv: "\u22F3",
    isins: "\u22F4",
    isindot: "\u22F5",
    notindot: "\u22F5\u0338",
    notinvc: "\u22F6",
    notinvb: "\u22F7",
    isine: "\u22F9",
    notine: "\u22F9\u0338",
    nisd: "\u22FA",
    xnis: "\u22FB",
    nis: "\u22FC",
    notnivc: "\u22FD",
    notnivb: "\u22FE",
    barwed: "\u2305",
    barwedge: "\u2305",
    Barwed: "\u2306",
    doublebarwedge: "\u2306",
    drcrop: "\u230C",
    dlcrop: "\u230D",
    urcrop: "\u230E",
    ulcrop: "\u230F",
    bnot: "\u2310",
    profline: "\u2312",
    profsurf: "\u2313",
    telrec: "\u2315",
    target: "\u2316",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    urcorn: "\u231D",
    urcorner: "\u231D",
    dlcorn: "\u231E",
    llcorner: "\u231E",
    drcorn: "\u231F",
    lrcorner: "\u231F",
    frown: "\u2322",
    sfrown: "\u2322",
    smile: "\u2323",
    ssmile: "\u2323",
    cylcty: "\u232D",
    profalar: "\u232E",
    topbot: "\u2336",
    ovbar: "\u233D",
    solbar: "\u233F",
    angzarr: "\u237C",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    overbracket: "\u23B4",
    tbrk: "\u23B4",
    bbrk: "\u23B5",
    underbracket: "\u23B5",
    bbrktbrk: "\u23B6",
    overparenthesis: "\u23DC",
    underparenthesis: "\u23DD",
    overbrace: "\u23DE",
    underbrace: "\u23DF",
    trpezium: "\u23E2",
    elinters: "\u23E7",
    blank: "\u2423",
    boxh: "\u2500",
    horizontalline: "\u2500",
    boxv: "\u2502",
    boxdr: "\u250C",
    boxdl: "\u2510",
    boxur: "\u2514",
    boxul: "\u2518",
    boxvr: "\u251C",
    boxvl: "\u2524",
    boxhd: "\u252C",
    boxhu: "\u2534",
    boxvh: "\u253C",
    boxH: "\u2550",
    boxV: "\u2551",
    boxdR: "\u2552",
    boxDr: "\u2553",
    boxDR: "\u2554",
    boxdL: "\u2555",
    boxDl: "\u2556",
    boxDL: "\u2557",
    boxuR: "\u2558",
    boxUr: "\u2559",
    boxUR: "\u255A",
    boxuL: "\u255B",
    boxUl: "\u255C",
    boxUL: "\u255D",
    boxvR: "\u255E",
    boxVr: "\u255F",
    boxVR: "\u2560",
    boxvL: "\u2561",
    boxVl: "\u2562",
    boxVL: "\u2563",
    boxHd: "\u2564",
    boxhD: "\u2565",
    boxHD: "\u2566",
    boxHu: "\u2567",
    boxhU: "\u2568",
    boxHU: "\u2569",
    boxvH: "\u256A",
    boxVh: "\u256B",
    boxVH: "\u256C",
    uhblk: "\u2580",
    lhblk: "\u2584",
    block: "\u2588",
    blk14: "\u2591",
    blk12: "\u2592",
    blk34: "\u2593",
    squ: "\u25A1",
    square: "\u25A1",
    blacksquare: "\u25AA",
    filledverysmallsquare: "\u25AA",
    squarf: "\u25AA",
    squf: "\u25AA",
    emptyverysmallsquare: "\u25AB",
    rect: "\u25AD",
    marker: "\u25AE",
    fltns: "\u25B1",
    bigtriangleup: "\u25B3",
    xutri: "\u25B3",
    blacktriangle: "\u25B4",
    utrif: "\u25B4",
    triangle: "\u25B5",
    utri: "\u25B5",
    blacktriangleright: "\u25B8",
    rtrif: "\u25B8",
    rtri: "\u25B9",
    triangleright: "\u25B9",
    bigtriangledown: "\u25BD",
    xdtri: "\u25BD",
    blacktriangledown: "\u25BE",
    dtrif: "\u25BE",
    dtri: "\u25BF",
    triangledown: "\u25BF",
    blacktriangleleft: "\u25C2",
    ltrif: "\u25C2",
    ltri: "\u25C3",
    triangleleft: "\u25C3",
    loz: "\u25CA",
    lozenge: "\u25CA",
    cir: "\u25CB",
    tridot: "\u25EC",
    bigcirc: "\u25EF",
    xcirc: "\u25EF",
    ultri: "\u25F8",
    urtri: "\u25F9",
    lltri: "\u25FA",
    emptysmallsquare: "\u25FB",
    filledsmallsquare: "\u25FC",
    bigstar: "\u2605",
    starf: "\u2605",
    star: "\u2606",
    phone: "\u260E",
    female: "\u2640",
    male: "\u2642",
    spades: "\u2660",
    spadesuit: "\u2660",
    clubs: "\u2663",
    clubsuit: "\u2663",
    hearts: "\u2665",
    heartsuit: "\u2665",
    diamondsuit: "\u2666",
    diams: "\u2666",
    sung: "\u266A",
    check: "\u2713",
    checkmark: "\u2713",
    cross: "\u2717",
    malt: "\u2720",
    maltese: "\u2720",
    sext: "\u2736",
    verticalseparator: "\u2758",
    bsolhsub: "\u27C8",
    suphsol: "\u27C9",
    longleftarrow: "\u27F5",
    xlarr: "\u27F5",
    longrightarrow: "\u27F6",
    xrarr: "\u27F6",
    longleftrightarrow: "\u27F7",
    xharr: "\u27F7",
    doublelongleftarrow: "\u27F8",
    Longleftarrow: "\u27F8",
    xlArr: "\u27F8",
    doublelongrightarrow: "\u27F9",
    Longrightarrow: "\u27F9",
    xrArr: "\u27F9",
    doublelongleftrightarrow: "\u27FA",
    Longleftrightarrow: "\u27FA",
    xhArr: "\u27FA",
    longmapsto: "\u27FC",
    xmap: "\u27FC",
    dzigrarr: "\u27FF",
    nvlarr: "\u2902",
    nvrarr: "\u2903",
    nvharr: "\u2904",
    Map: "\u2905",
    lbarr: "\u290C",
    bkarow: "\u290D",
    lBarr: "\u290E",
    dbkarow: "\u290F",
    rBarr: "\u290F",
    drbkarow: "\u2910",
    rbarr: "\u2910",
    RBarr: "\u2910",
    ddotrahd: "\u2911",
    uparrowbar: "\u2912",
    downarrowbar: "\u2913",
    Rarrtl: "\u2916",
    latail: "\u2919",
    ratail: "\u291A",
    lAtail: "\u291B",
    rAtail: "\u291C",
    larrfs: "\u291D",
    rarrfs: "\u291E",
    larrbfs: "\u291F",
    rarrbfs: "\u2920",
    nwarhk: "\u2923",
    nearhk: "\u2924",
    hksearow: "\u2925",
    searhk: "\u2925",
    hkswarow: "\u2926",
    swarhk: "\u2926",
    nwnear: "\u2927",
    nesear: "\u2928",
    toea: "\u2928",
    seswar: "\u2929",
    tosa: "\u2929",
    swnwar: "\u292A",
    rarrc: "\u2933",
    nrarrc: "\u2933\u0338",
    cudarrr: "\u2935",
    ldca: "\u2936",
    rdca: "\u2937",
    cudarrl: "\u2938",
    larrpl: "\u2939",
    curarrm: "\u293C",
    cularrp: "\u293D",
    rarrpl: "\u2945",
    harrcir: "\u2948",
    uarrocir: "\u2949",
    lurdshar: "\u294A",
    ldrushar: "\u294B",
    leftrightvector: "\u294E",
    rightupdownvector: "\u294F",
    downleftrightvector: "\u2950",
    leftupdownvector: "\u2951",
    leftvectorbar: "\u2952",
    rightvectorbar: "\u2953",
    rightupvectorbar: "\u2954",
    rightdownvectorbar: "\u2955",
    downleftvectorbar: "\u2956",
    downrightvectorbar: "\u2957",
    leftupvectorbar: "\u2958",
    leftdownvectorbar: "\u2959",
    leftteevector: "\u295A",
    rightteevector: "\u295B",
    rightupteevector: "\u295C",
    rightdownteevector: "\u295D",
    downleftteevector: "\u295E",
    downrightteevector: "\u295F",
    leftupteevector: "\u2960",
    leftdownteevector: "\u2961",
    lhar: "\u2962",
    uhar: "\u2963",
    rhar: "\u2964",
    dhar: "\u2965",
    luruhar: "\u2966",
    ldrdhar: "\u2967",
    ruluhar: "\u2968",
    rdldhar: "\u2969",
    lharul: "\u296A",
    llhard: "\u296B",
    rharul: "\u296C",
    lrhard: "\u296D",
    udhar: "\u296E",
    upequilibrium: "\u296E",
    duhar: "\u296F",
    reverseupequilibrium: "\u296F",
    roundimplies: "\u2970",
    erarr: "\u2971",
    simrarr: "\u2972",
    larrsim: "\u2973",
    rarrsim: "\u2974",
    rarrap: "\u2975",
    ltlarr: "\u2976",
    gtrarr: "\u2978",
    subrarr: "\u2979",
    suplarr: "\u297B",
    lfisht: "\u297C",
    rfisht: "\u297D",
    ufisht: "\u297E",
    dfisht: "\u297F",
    vzigzag: "\u299A",
    vangrt: "\u299C",
    angrtvbd: "\u299D",
    ange: "\u29A4",
    range: "\u29A5",
    dwangle: "\u29A6",
    uwangle: "\u29A7",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    bemptyv: "\u29B0",
    demptyv: "\u29B1",
    cemptyv: "\u29B2",
    raemptyv: "\u29B3",
    laemptyv: "\u29B4",
    ohbar: "\u29B5",
    omid: "\u29B6",
    opar: "\u29B7",
    operp: "\u29B9",
    olcross: "\u29BB",
    odsold: "\u29BC",
    olcir: "\u29BE",
    ofcir: "\u29BF",
    olt: "\u29C0",
    ogt: "\u29C1",
    cirscir: "\u29C2",
    cirE: "\u29C3",
    solb: "\u29C4",
    bsolb: "\u29C5",
    boxbox: "\u29C9",
    trisb: "\u29CD",
    rtriltri: "\u29CE",
    lefttrianglebar: "\u29CF",
    notlefttrianglebar: "\u29CF\u0338",
    righttrianglebar: "\u29D0",
    notrighttrianglebar: "\u29D0\u0338",
    iinfin: "\u29DC",
    infintie: "\u29DD",
    nvinfin: "\u29DE",
    eparsl: "\u29E3",
    smeparsl: "\u29E4",
    eqvparsl: "\u29E5",
    blacklozenge: "\u29EB",
    lozf: "\u29EB",
    ruledelayed: "\u29F4",
    dsol: "\u29F6",
    bigodot: "\u2A00",
    xodot: "\u2A00",
    bigoplus: "\u2A01",
    xoplus: "\u2A01",
    bigotimes: "\u2A02",
    xotime: "\u2A02",
    biguplus: "\u2A04",
    xuplus: "\u2A04",
    bigsqcup: "\u2A06",
    xsqcup: "\u2A06",
    fpartint: "\u2A0D",
    cirfnint: "\u2A10",
    awint: "\u2A11",
    rppolint: "\u2A12",
    scpolint: "\u2A13",
    npolint: "\u2A14",
    pointint: "\u2A15",
    quatint: "\u2A16",
    intlarhk: "\u2A17",
    pluscir: "\u2A22",
    plusacir: "\u2A23",
    simplus: "\u2A24",
    plusdu: "\u2A25",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    mcomma: "\u2A29",
    minusdu: "\u2A2A",
    loplus: "\u2A2D",
    roplus: "\u2A2E",
    Cross: "\u2A2F",
    timesd: "\u2A30",
    timesbar: "\u2A31",
    smashp: "\u2A33",
    lotimes: "\u2A34",
    rotimes: "\u2A35",
    otimesas: "\u2A36",
    Otimes: "\u2A37",
    odiv: "\u2A38",
    triplus: "\u2A39",
    triminus: "\u2A3A",
    tritime: "\u2A3B",
    intprod: "\u2A3C",
    iprod: "\u2A3C",
    amalg: "\u2A3F",
    capdot: "\u2A40",
    ncup: "\u2A42",
    ncap: "\u2A43",
    capand: "\u2A44",
    cupor: "\u2A45",
    cupcap: "\u2A46",
    capcup: "\u2A47",
    cupbrcap: "\u2A48",
    capbrcup: "\u2A49",
    cupcup: "\u2A4A",
    capcap: "\u2A4B",
    ccups: "\u2A4C",
    ccaps: "\u2A4D",
    ccupssm: "\u2A50",
    And: "\u2A53",
    Or: "\u2A54",
    andand: "\u2A55",
    oror: "\u2A56",
    orslope: "\u2A57",
    andslope: "\u2A58",
    andv: "\u2A5A",
    orv: "\u2A5B",
    andd: "\u2A5C",
    ord: "\u2A5D",
    wedbar: "\u2A5F",
    sdote: "\u2A66",
    simdot: "\u2A6A",
    congdot: "\u2A6D",
    ncongdot: "\u2A6D\u0338",
    easter: "\u2A6E",
    apacir: "\u2A6F",
    apE: "\u2A70",
    nape: "\u2A70\u0338",
    eplus: "\u2A71",
    pluse: "\u2A72",
    Esim: "\u2A73",
    ddotseq: "\u2A77",
    eddot: "\u2A77",
    equivdd: "\u2A78",
    ltcir: "\u2A79",
    gtcir: "\u2A7A",
    ltquest: "\u2A7B",
    gtquest: "\u2A7C",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lessslantequal: "\u2A7D",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    notlessslantequal: "\u2A7D\u0338",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    greaterslantequal: "\u2A7E",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    notgreaterslantequal: "\u2A7E\u0338",
    lesdot: "\u2A7F",
    gesdot: "\u2A80",
    lesdoto: "\u2A81",
    gesdoto: "\u2A82",
    lesdotor: "\u2A83",
    gesdotol: "\u2A84",
    lap: "\u2A85",
    lessapprox: "\u2A85",
    gap: "\u2A86",
    gtrapprox: "\u2A86",
    lne: "\u2A87",
    lneq: "\u2A87",
    gne: "\u2A88",
    gneq: "\u2A88",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    lEg: "\u2A8B",
    lesseqqgtr: "\u2A8B",
    gEl: "\u2A8C",
    gtreqqless: "\u2A8C",
    lsime: "\u2A8D",
    gsime: "\u2A8E",
    lsimg: "\u2A8F",
    gsiml: "\u2A90",
    lge: "\u2A91",
    gle: "\u2A92",
    lesges: "\u2A93",
    gesles: "\u2A94",
    els: "\u2A95",
    eqslantless: "\u2A95",
    egs: "\u2A96",
    eqslantgtr: "\u2A96",
    elsdot: "\u2A97",
    egsdot: "\u2A98",
    el: "\u2A99",
    eg: "\u2A9A",
    siml: "\u2A9D",
    simg: "\u2A9E",
    simle: "\u2A9F",
    simge: "\u2AA0",
    lessless: "\u2AA1",
    notnestedlessless: "\u2AA1\u0338",
    greatergreater: "\u2AA2",
    notnestedgreatergreater: "\u2AA2\u0338",
    glj: "\u2AA4",
    gla: "\u2AA5",
    ltcc: "\u2AA6",
    gtcc: "\u2AA7",
    lescc: "\u2AA8",
    gescc: "\u2AA9",
    smt: "\u2AAA",
    lat: "\u2AAB",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    bumpE: "\u2AAE",
    pre: "\u2AAF",
    precedesequal: "\u2AAF",
    preceq: "\u2AAF",
    notprecedesequal: "\u2AAF\u0338",
    npre: "\u2AAF\u0338",
    npreceq: "\u2AAF\u0338",
    sce: "\u2AB0",
    succeedsequal: "\u2AB0",
    succeq: "\u2AB0",
    notsucceedsequal: "\u2AB0\u0338",
    nsce: "\u2AB0\u0338",
    nsucceq: "\u2AB0\u0338",
    prE: "\u2AB3",
    scE: "\u2AB4",
    precneqq: "\u2AB5",
    prne: "\u2AB5",
    scne: "\u2AB6",
    succneqq: "\u2AB6",
    prap: "\u2AB7",
    precapprox: "\u2AB7",
    scap: "\u2AB8",
    succapprox: "\u2AB8",
    precnapprox: "\u2AB9",
    prnap: "\u2AB9",
    scnap: "\u2ABA",
    succnapprox: "\u2ABA",
    Pr: "\u2ABB",
    Sc: "\u2ABC",
    subdot: "\u2ABD",
    supdot: "\u2ABE",
    subplus: "\u2ABF",
    supplus: "\u2AC0",
    submult: "\u2AC1",
    supmult: "\u2AC2",
    subedot: "\u2AC3",
    supedot: "\u2AC4",
    subE: "\u2AC5",
    subseteqq: "\u2AC5",
    nsubE: "\u2AC5\u0338",
    nsubseteqq: "\u2AC5\u0338",
    supE: "\u2AC6",
    supseteqq: "\u2AC6",
    nsupE: "\u2AC6\u0338",
    nsupseteqq: "\u2AC6\u0338",
    subsim: "\u2AC7",
    supsim: "\u2AC8",
    subnE: "\u2ACB",
    subsetneqq: "\u2ACB",
    varsubsetneqq: "\u2ACB\uFE00",
    vsubnE: "\u2ACB\uFE00",
    supnE: "\u2ACC",
    supsetneqq: "\u2ACC",
    varsupsetneqq: "\u2ACC\uFE00",
    vsupnE: "\u2ACC\uFE00",
    csub: "\u2ACF",
    csup: "\u2AD0",
    csube: "\u2AD1",
    csupe: "\u2AD2",
    subsup: "\u2AD3",
    supsub: "\u2AD4",
    subsub: "\u2AD5",
    supsup: "\u2AD6",
    suphsub: "\u2AD7",
    supdsub: "\u2AD8",
    forkv: "\u2AD9",
    topfork: "\u2ADA",
    mlcp: "\u2ADB",
    Dashv: "\u2AE4",
    doublelefttee: "\u2AE4",
    vdashl: "\u2AE6",
    barv: "\u2AE7",
    vbar: "\u2AE8",
    vbarv: "\u2AE9",
    Vbar: "\u2AEB",
    Not: "\u2AEC",
    bNot: "\u2AED",
    rnmid: "\u2AEE",
    cirmid: "\u2AEF",
    midcir: "\u2AF0",
    topcir: "\u2AF1",
    nhpar: "\u2AF2",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    nparsl: "\u2AFD\u20E5",
    flat: "\u266D",
    natur: "\u266E",
    natural: "\u266E",
    sharp: "\u266F",
    curren: "\xa4",
    cent: "\xa2",
    dollar: "$",
    pound: "\xa3",
    yen: "\xa5",
    euro: "\u20AC",
    sup1: "\xb9",
    frac12: "\xbd",
    half: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    sup2: "\xb2",
    frac23: "\u2154",
    frac25: "\u2156",
    sup3: "\xb3",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    afr: "\uD835\uDD1E",
    aopf: "\uD835\uDD52",
    ascr: "\uD835\uDCB6",
    Afr: "\uD835\uDD04",
    Aopf: "\uD835\uDD38",
    Ascr: "\uD835\uDC9C",
    ordf: "\xaa",
    aacute: "\xe1",
    Aacute: "\xc1",
    agrave: "\xe0",
    Agrave: "\xc0",
    abreve: "\u0103",
    Abreve: "\u0102",
    acirc: "\xe2",
    Acirc: "\xc2",
    aring: "\xe5",
    angst: "\xc5",
    Aring: "\xc5",
    auml: "\xe4",
    Auml: "\xc4",
    atilde: "\xe3",
    Atilde: "\xc3",
    aogon: "\u0105",
    Aogon: "\u0104",
    amacr: "\u0101",
    Amacr: "\u0100",
    aelig: "\xc6",
    AElig: "\xc6",
    bfr: "\uD835\uDD1F",
    bopf: "\uD835\uDD53",
    bscr: "\uD835\uDCB7",
    bernou: "\u212C",
    bernoullis: "\u212C",
    Bfr: "\uD835\uDD05",
    Bopf: "\uD835\uDD39",
    Bscr: "\u212C",
    cfr: "\uD835\uDD20",
    copf: "\uD835\uDD54",
    cscr: "\uD835\uDCB8",
    cayleys: "\u212D",
    Cfr: "\u212D",
    complexes: "\u2102",
    Copf: "\u2102",
    Cscr: "\uD835\uDC9E",
    cacute: "\u0107",
    Cacute: "\u0106",
    ccirc: "\u0109",
    Ccirc: "\u0108",
    ccaron: "\u010D",
    Ccaron: "\u010C",
    cdot: "\u010B",
    Cdot: "\u010A",
    ccedil: "\xe7",
    Ccedil: "\xc7",
    incare: "\u2105",
    dfr: "\uD835\uDD21",
    differentiald: "\u2146",
    dopf: "\uD835\uDD55",
    dscr: "\uD835\uDCB9",
    capitaldifferentiald: "\u2145",
    dd: "\u2145",
    DD: "\u2145",
    Dfr: "\uD835\uDD07",
    Dopf: "\uD835\uDD3B",
    Dscr: "\uD835\uDC9F",
    dcaron: "\u010F",
    Dcaron: "\u010E",
    dstrok: "\u0111",
    Dstrok: "\u0110",
    eth: "\xf0",
    ETH: "\xd0",
    ee: "\u2147",
    efr: "\uD835\uDD22",
    eopf: "\uD835\uDD56",
    escr: "\u212F",
    exponentiale: "\u2147",
    Efr: "\uD835\uDD08",
    Eopf: "\uD835\uDD3C",
    Escr: "\u2130",
    expectation: "\u2130",
    eacute: "\xe9",
    Eacute: "\xc9",
    egrave: "\xe8",
    Egrave: "\xc8",
    ecirc: "\xea",
    Ecirc: "\xca",
    ecaron: "\u011B",
    Ecaron: "\u011A",
    euml: "\xeb",
    Euml: "\xcb",
    edot: "\u0117",
    Edot: "\u0116",
    eogon: "\u0119",
    Eogon: "\u0118",
    emacr: "\u0113",
    Emacr: "\u0112",
    ffr: "\uD835\uDD23",
    fopf: "\uD835\uDD57",
    fscr: "\uD835\uDCBB",
    Ffr: "\uD835\uDD09",
    Fopf: "\uD835\uDD3D",
    fouriertrf: "\u2131",
    Fscr: "\u2131",
    fflig: "\uFB00",
    ffilig: "\uFB03",
    ffllig: "\uFB04",
    filig: "\uFB01",
    fjlig: "fj",
    fllig: "\uFB02",
    fnof: "\u0192",
    gfr: "\uD835\uDD24",
    gopf: "\uD835\uDD58",
    gscr: "\u210A",
    Gfr: "\uD835\uDD0A",
    Gopf: "\uD835\uDD3E",
    Gscr: "\uD835\uDCA2",
    gacute: "\u01F5",
    gbreve: "\u011F",
    Gbreve: "\u011E",
    gcirc: "\u011D",
    Gcirc: "\u011C",
    gdot: "\u0121",
    Gdot: "\u0120",
    gcedil: "\u0122",
    hfr: "\uD835\uDD25",
    hopf: "\uD835\uDD59",
    hscr: "\uD835\uDCBD",
    planckh: "\u210E",
    hamilt: "\u210B",
    Hfr: "\u210C",
    hilbertspace: "\u210B",
    Hopf: "\u210D",
    Hscr: "\u210B",
    poincareplane: "\u210C",
    quaternions: "\u210D",
    hcirc: "\u0125",
    Hcirc: "\u0124",
    hbar: "\u210F",
    hslash: "\u210F",
    hstrok: "\u0127",
    planck: "\u210F",
    plankv: "\u210F",
    Hstrok: "\u0126",
    ifr: "\uD835\uDD26",
    ii: "\u2148",
    imaginaryi: "\u2148",
    iopf: "\uD835\uDD5A",
    iscr: "\uD835\uDCBE",
    Ifr: "\u2111",
    im: "\u2111",
    image: "\u2111",
    imagline: "\u2110",
    imagpart: "\u2111",
    Iopf: "\uD835\uDD40",
    Iscr: "\u2110",
    iacute: "\xed",
    Iacute: "\xcd",
    igrave: "\xec",
    Igrave: "\xcc",
    icirc: "\xee",
    Icirc: "\xce",
    iuml: "\xef",
    Iuml: "\xcf",
    itilde: "\u0129",
    Itilde: "\u0128",
    idot: "\u0130",
    iogon: "\u012F",
    Iogon: "\u012E",
    imacr: "\u012B",
    Imacr: "\u012A",
    ijlig: "\u0132",
    IJlig: "\u0132",
    imath: "\u0131",
    inodot: "\u0131",
    jfr: "\uD835\uDD27",
    jopf: "\uD835\uDD5B",
    jscr: "\uD835\uDCBF",
    Jfr: "\uD835\uDD0D",
    Jopf: "\uD835\uDD41",
    Jscr: "\uD835\uDCA5",
    jcirc: "\u0135",
    Jcirc: "\u0134",
    jmath: "\u0237",
    kfr: "\uD835\uDD28",
    kopf: "\uD835\uDD5C",
    kscr: "\uD835\uDCC0",
    Kfr: "\uD835\uDD0E",
    Kopf: "\uD835\uDD42",
    Kscr: "\uD835\uDCA6",
    kcedil: "\u0137",
    Kcedil: "\u0136",
    ell: "\u2113",
    lfr: "\uD835\uDD29",
    lopf: "\uD835\uDD5D",
    lscr: "\uD835\uDCC1",
    lagran: "\u2112",
    laplacetrf: "\u2112",
    Lfr: "\uD835\uDD0F",
    Lopf: "\uD835\uDD43",
    Lscr: "\u2112",
    lacute: "\u013A",
    Lacute: "\u0139",
    lcaron: "\u013E",
    Lcaron: "\u013D",
    lcedil: "\u013C",
    Lcedil: "\u013B",
    lstrok: "\u0142",
    Lstrok: "\u0141",
    lmidot: "\u0140",
    Lmidot: "\u013F",
    mfr: "\uD835\uDD2A",
    mopf: "\uD835\uDD5E",
    mscr: "\uD835\uDCC2",
    mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    Mopf: "\uD835\uDD44",
    Mscr: "\u2133",
    phmmat: "\u2133",
    nfr: "\uD835\uDD2B",
    nopf: "\uD835\uDD5F",
    nscr: "\uD835\uDCC3",
    naturals: "\u2115",
    Nfr: "\uD835\uDD11",
    Nopf: "\u2115",
    Nscr: "\uD835\uDCA9",
    nacute: "\u0144",
    Nacute: "\u0143",
    ncaron: "\u0148",
    Ncaron: "\u0147",
    ntilde: "\xf1",
    Ntilde: "\xd1",
    ncedil: "\u0146",
    Ncedil: "\u0145",
    numero: "\u2116",
    eng: "\u014B",
    ENG: "\u014A",
    ofr: "\uD835\uDD2C",
    oopf: "\uD835\uDD60",
    order: "\u2134",
    orderof: "\u2134",
    oscr: "\u2134",
    Ofr: "\uD835\uDD12",
    Oopf: "\uD835\uDD46",
    Oscr: "\uD835\uDCAA",
    ordm: "\xba",
    oacute: "\xf3",
    Oacute: "\xd3",
    ograve: "\xf2",
    Ograve: "\xd2",
    ocirc: "\xf4",
    Ocirc: "\xd4",
    ouml: "\xf6",
    Ouml: "\xd6",
    odblac: "\u0151",
    Odblac: "\u0150",
    otilde: "\xf5",
    Otilde: "\xd5",
    oslash: "\xf8",
    Oslash: "\xd8",
    omacr: "\u014D",
    Omacr: "\u014C",
    oelig: "\u0152",
    OElig: "\u0152",
    pfr: "\uD835\uDD2D",
    popf: "\uD835\uDD61",
    pscr: "\uD835\uDCC5",
    Pfr: "\uD835\uDD13",
    Popf: "\u2119",
    primes: "\u2119",
    Pscr: "\uD835\uDCAB",
    qfr: "\uD835\uDD2E",
    qopf: "\uD835\uDD62",
    qscr: "\uD835\uDCC6",
    Qfr: "\uD835\uDD14",
    Qopf: "\u211A",
    Qscr: "\uD835\uDCAC",
    rationals: "\u211A",
    kgreen: "\u0138",
    rfr: "\uD835\uDD2F",
    ropf: "\uD835\uDD63",
    rscr: "\uD835\uDCC7",
    re: "\u211C",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    Rfr: "\u211C",
    Ropf: "\u211D",
    Rscr: "\u211B",
    racute: "\u0155",
    Racute: "\u0154",
    rcaron: "\u0159",
    Rcaron: "\u0158",
    rcedil: "\u0157",
    Rcedil: "\u0156",
    sfr: "\uD835\uDD30",
    sopf: "\uD835\uDD64",
    sscr: "\uD835\uDCC8",
    Sfr: "\uD835\uDD16",
    Sopf: "\uD835\uDD4A",
    Sscr: "\uD835\uDCAE",
    circleds: "\u24C8",
    os: "\u24C8",
    sacute: "\u015B",
    Sacute: "\u015A",
    scirc: "\u015D",
    Scirc: "\u015C",
    scaron: "\u0161",
    Scaron: "\u0160",
    scedil: "\u015F",
    Scedil: "\u015E",
    szlig: "\xdf",
    tfr: "\uD835\uDD31",
    topf: "\uD835\uDD65",
    tscr: "\uD835\uDCC9",
    Tfr: "\uD835\uDD17",
    Topf: "\uD835\uDD4B",
    Tscr: "\uD835\uDCAF",
    tcaron: "\u0165",
    Tcaron: "\u0164",
    tcedil: "\u0163",
    Tcedil: "\u0162",
    trade: "\u2122",
    tstrok: "\u0167",
    Tstrok: "\u0166",
    ufr: "\uD835\uDD32",
    uopf: "\uD835\uDD66",
    uscr: "\uD835\uDCCA",
    Ufr: "\uD835\uDD18",
    Uopf: "\uD835\uDD4C",
    Uscr: "\uD835\uDCB0",
    uacute: "\xfa",
    Uacute: "\xda",
    ugrave: "\xf9",
    Ugrave: "\xd9",
    ubreve: "\u016D",
    Ubreve: "\u016C",
    ucirc: "\xfb",
    Ucirc: "\xdb",
    uring: "\u016F",
    Uring: "\u016E",
    uuml: "\xfc",
    Uuml: "\xdc",
    udblac: "\u0171",
    Udblac: "\u0170",
    utilde: "\u0169",
    Utilde: "\u0168",
    uogon: "\u0173",
    Uogon: "\u0172",
    umacr: "\u016B",
    Umacr: "\u016A",
    vfr: "\uD835\uDD33",
    vopf: "\uD835\uDD67",
    vscr: "\uD835\uDCCB",
    Vfr: "\uD835\uDD19",
    Vopf: "\uD835\uDD4D",
    Vscr: "\uD835\uDCB1",
    wfr: "\uD835\uDD34",
    wopf: "\uD835\uDD68",
    wscr: "\uD835\uDCCC",
    Wfr: "\uD835\uDD1A",
    Wopf: "\uD835\uDD4E",
    Wscr: "\uD835\uDCB2",
    wcirc: "\u0175",
    Wcirc: "\u0174",
    xfr: "\uD835\uDD35",
    xopf: "\uD835\uDD69",
    xscr: "\uD835\uDCCD",
    Xfr: "\uD835\uDD1B",
    Xopf: "\uD835\uDD4F",
    Xscr: "\uD835\uDCB3",
    yfr: "\uD835\uDD36",
    yopf: "\uD835\uDD6A",
    yscr: "\uD835\uDCCE",
    Yfr: "\uD835\uDD1C",
    Yopf: "\uD835\uDD50",
    Yscr: "\uD835\uDCB4",
    yacute: "\xfd",
    Yacute: "\xdd",
    ycirc: "\u0177",
    Ycirc: "\u0176",
    yuml: "\xff",
    Yuml: "\u0178",
    zfr: "\uD835\uDD37",
    zopf: "\uD835\uDD6B",
    zscr: "\uD835\uDCCF",
    integers: "\u2124",
    zeetrf: "\u2128",
    Zfr: "\u2128",
    Zopf: "\u2124",
    Zscr: "\uD835\uDCB5",
    zacute: "\u017A",
    Zacute: "\u0179",
    zcaron: "\u017E",
    Zcaron: "\u017D",
    zdot: "\u017C",
    Zdot: "\u017B",
    imped: "\u01B5",
    thorn: "\xfe",
    THORN: "\xde",
    napos: "\u0149",
    alpha: "\u03B1",
    Alpha: "\u0391",
    beta: "\u03B2",
    Beta: "\u0392",
    gamma: "\u03B3",
    Gamma: "\u0393",
    delta: "\u03B4",
    Delta: "\u0394",
    epsi: "\u03B5",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    straightepsilon: "\u03F5",
    varepsilon: "\u03F5",
    Epsilon: "\u0395",
    digamma: "\u03DD",
    gammad: "\u03DD",
    Gammad: "\u03DC",
    zeta: "\u03B6",
    Zeta: "\u0396",
    eta: "\u03B7",
    Eta: "\u0397",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    vartheta: "\u03D1",
    Theta: "\u0398",
    iota: "\u03B9",
    Iota: "\u0399",
    kappa: "\u03BA",
    kappav: "\u03F0",
    varkappa: "\u03F0",
    Kappa: "\u039A",
    lambda: "\u03BB",
    Lambda: "\u039B",
    mu: "\u03BC",
    micro: "\xb5",
    Mu: "\u039C",
    nu: "\u03BD",
    Nu: "\u039D",
    xi: "\u03BE",
    Xi: "\u039E",
    omicron: "\u03BF",
    Omicron: "\u039F",
    pi: "\u03C0",
    piv: "\u03D6",
    varpi: "\u03D6",
    Pi: "\u03A0",
    rho: "\u03C1",
    rhov: "\u03F1",
    varrho: "\u03F1",
    Rho: "\u03A1",
    sigma: "\u03C3",
    Sigma: "\u03A3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    varsigma: "\u03C2",
    tau: "\u03C4",
    Tau: "\u03A4",
    upsi: "\u03C5",
    upsilon: "\u03C5",
    Upsilon: "\u03A5",
    Upsi: "\u03D2",
    upsih: "\u03D2",
    phi: "\u03C6",
    phiv: "\u03D5",
    straightphi: "\u03D5",
    varphi: "\u03D5",
    Phi: "\u03A6",
    chi: "\u03C7",
    Chi: "\u03A7",
    psi: "\u03C8",
    Psi: "\u03A8",
    omega: "\u03C9",
    ohm: "\u03A9",
    Omega: "\u03A9",
    acy: "\u0430",
    Acy: "\u0410",
    bcy: "\u0431",
    Bcy: "\u0411",
    vcy: "\u0432",
    Vcy: "\u0412",
    gcy: "\u0433",
    Gcy: "\u0413",
    gjcy: "\u0403",
    GJcy: "\u0403",
    dcy: "\u0434",
    Dcy: "\u0414",
    djcy: "\u0402",
    DJcy: "\u0402",
    iecy: "\u0415",
    IEcy: "\u0415",
    iocy: "\u0401",
    IOcy: "\u0401",
    jukcy: "\u0454",
    Jukcy: "\u0404",
    zhcy: "\u0416",
    ZHcy: "\u0416",
    zcy: "\u0437",
    Zcy: "\u0417",
    dscy: "\u0405",
    DScy: "\u0405",
    icy: "\u0438",
    Icy: "\u0418",
    iukcy: "\u0456",
    Iukcy: "\u0406",
    yicy: "\u0407",
    YIcy: "\u0407",
    jcy: "\u0439",
    Jcy: "\u0419",
    jsercy: "\u0458",
    Jsercy: "\u0408",
    kcy: "\u043A",
    Kcy: "\u041A",
    kjcy: "\u040C",
    KJcy: "\u040C",
    lcy: "\u043B",
    Lcy: "\u041B",
    ljcy: "\u0409",
    LJcy: "\u0409",
    mcy: "\u043C",
    Mcy: "\u041C",
    ncy: "\u043D",
    Ncy: "\u041D",
    njcy: "\u040A",
    NJcy: "\u040A",
    ocy: "\u043E",
    Ocy: "\u041E",
    pcy: "\u043F",
    Pcy: "\u041F",
    rcy: "\u0440",
    Rcy: "\u0420",
    scy: "\u0441",
    Scy: "\u0421",
    tcy: "\u0442",
    Tcy: "\u0422",
    tshcy: "\u045B",
    TSHcy: "\u040B",
    ucy: "\u0443",
    Ucy: "\u0423",
    ubrcy: "\u045E",
    Ubrcy: "\u040E",
    fcy: "\u0444",
    Fcy: "\u0424",
    khcy: "\u0425",
    KHcy: "\u0425",
    tscy: "\u0426",
    TScy: "\u0426",
    chcy: "\u0427",
    CHcy: "\u0427",
    dzcy: "\u040F",
    DZcy: "\u040F",
    shcy: "\u0428",
    SHcy: "\u0428",
    shchcy: "\u0449",
    SHCHcy: "\u0429",
    hardcy: "\u044A",
    HARDcy: "\u042A",
    ycy: "\u044B",
    Ycy: "\u042B",
    softcy: "\u044C",
    SOFTcy: "\u042C",
    ecy: "\u044D",
    Ecy: "\u042D",
    yucy: "\u042E",
    YUcy: "\u042E",
    yacy: "\u042F",
    YAcy: "\u042F",
    alefsym: "\u2135",
    aleph: "\u2135",
    beth: "\u2136",
    gimel: "\u2137",
    daleth: "\u2138"
};
function UZ(q) {
    if (!n(q, "---")) return null;
    let G = 3;
    while(G < q.length && (q[G] === " " || q[G] === "\t"))G++;
    if (G >= q.length || q[G] !== `
`) return null;
    G++;
    let Y = !1;
    while(G < q.length){
        let Z = G;
        while(G < q.length && q[G] !== `
`)G++;
        if (G >= q.length) break;
        let J = G++;
        if (n(q, "---", Z)) return {
            endPos: G,
            hasValidYaml: Y
        };
        let X = q.indexOf(":", Z);
        if (X !== -1 && X < J) Y = !0;
    }
    return null;
}
var zZ = oZ, tZ = /&([a-zA-Z0-9]+|#[0-9]{1,7}|#x[0-9a-fA-F]{1,6});/gi, eZ = {
    class: "className",
    for: "htmlFor",
    allowfullscreen: "allowFullScreen",
    allowtransparency: "allowTransparency",
    autocomplete: "autoComplete",
    autofocus: "autoFocus",
    autoplay: "autoPlay",
    cellpadding: "cellPadding",
    cellspacing: "cellSpacing",
    charset: "charSet",
    classid: "classId",
    colspan: "colSpan",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    crossorigin: "crossOrigin",
    enctype: "encType",
    formaction: "formAction",
    formenctype: "formEncType",
    formmethod: "formMethod",
    formnovalidate: "formNoValidate",
    formtarget: "formTarget",
    frameborder: "frameBorder",
    hreflang: "hrefLang",
    inputmode: "inputMode",
    keyparams: "keyParams",
    keytype: "keyType",
    marginheight: "marginHeight",
    marginwidth: "marginWidth",
    maxlength: "maxLength",
    mediagroup: "mediaGroup",
    minlength: "minLength",
    novalidate: "noValidate",
    radiogroup: "radioGroup",
    readonly: "readOnly",
    rowspan: "rowSpan",
    spellcheck: "spellCheck",
    srcdoc: "srcDoc",
    srclang: "srcLang",
    srcset: "srcSet",
    tabindex: "tabIndex",
    usemap: "useMap"
};
function IG(q) {
    var G = {};
    for(var Y in q){
        var Z = Y.toLowerCase(), J = eZ[Z];
        G[J || Y] = q[Y];
    }
    return G;
}
var QZ = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/;
function zG(q) {
    if (q.indexOf("&") === -1) return q;
    return q.replace(tZ, (G, Y)=>{
        let Z = zZ[Y] || zZ[Y.toLowerCase()];
        if (Z) return Z;
        if (Y[0] === "#") {
            let J = Y[1] === "x" || Y[1] === "X" ? parseInt(Y.slice(2), 16) : parseInt(Y.slice(1), 10);
            if (J === 0 || J >= 55296 && J <= 57343 || J > 1114111) return "\uFFFD";
            return J <= 65535 ? String.fromCharCode(J) : String.fromCharCode(55296 + (J - 65536 >> 10), 56320 + (J - 65536 & 1023));
        }
        return G;
    });
}
var AG = /(javascript|vbscript|data(?!:image)):/i;
function I1(q) {
    if (AG.test(q)) return null;
    if (q.indexOf("%") === -1) return q;
    try {
        let G = decodeURIComponent(q).replace(/[^A-Za-z0-9/:]/g, "");
        if (AG.test(G)) return null;
    } catch (G) {
        return null;
    }
    return q;
}
var fq = {}, Cq, Wq;
Cq = [
    192,
    193,
    194,
    195,
    196,
    197,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    198
];
for(Wq = 0; Wq < Cq.length; Wq++)fq[Cq[Wq]] = "a";
fq[231] = fq[199] = "c";
fq[240] = fq[208] = "d";
Cq = [
    200,
    201,
    202,
    203,
    233,
    232,
    234,
    235
];
for(Wq = 0; Wq < Cq.length; Wq++)fq[Cq[Wq]] = "e";
Cq = [
    207,
    239,
    206,
    238,
    205,
    237,
    204,
    236
];
for(Wq = 0; Wq < Cq.length; Wq++)fq[Cq[Wq]] = "i";
fq[209] = fq[241] = "n";
Cq = [
    248,
    216,
    339,
    338,
    213,
    245,
    212,
    244,
    211,
    243,
    210,
    242
];
for(Wq = 0; Wq < Cq.length; Wq++)fq[Cq[Wq]] = "o";
Cq = [
    220,
    252,
    219,
    251,
    218,
    250,
    217,
    249
];
for(Wq = 0; Wq < Cq.length; Wq++)fq[Cq[Wq]] = "u";
fq[376] = fq[255] = fq[221] = fq[253] = "y";
function mG(q) {
    return q >= JG && q <= YG || q >= p1 && q <= l1 || q >= $G && q <= VG;
}
function dq(q) {
    var G = [];
    for(var Y = 0; Y < q.length; Y++){
        var Z = q.charCodeAt(Y);
        if (mG(Z)) {
            if (Z >= p1 && Z <= l1) G.push(String.fromCharCode(Z + sZ));
            else G.push(q[Y]);
        } else if (Z === I || Z === X1) G.push("-");
        else {
            var J = fq[Z];
            if (J) G.push(J);
        }
    }
    return G.join("");
}
function mJ(q, G) {
    return q.indexOf(G) !== -1;
}
function n(q, G, Y) {
    return q.startsWith(G, Y);
}
function CG(q, G, Y) {
    return q.startsWith(G, (Y === void 0 ? q.length : Y) - G.length);
}
var KZ = new Set([
    "area",
    "base",
    "br",
    "col",
    "embed",
    "hr",
    "img",
    "input",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr",
    "circle",
    "ellipse",
    "line",
    "path",
    "polygon",
    "polyline",
    "rect",
    "use",
    "stop",
    "animate",
    "animateTransform",
    "set"
]);
function KG(q) {
    let G = q.toLowerCase();
    if (KZ.has(G)) return !0;
    let Y = G.indexOf(":");
    if (Y !== -1) return G = G.slice(Y + 1), KZ.has(G);
    return !1;
}
var DZ = [
    "src",
    "href",
    "data",
    "formAction",
    "srcDoc",
    "action"
], _Z = 1, u1 = 2, nZ = 1, CJ = 2, kJ = 3, hJ = 4, XG = function() {
    let q = new Uint8Array(128), G;
    q[p] = q[Xq] = q[iZ] = q[Lq] = q[I] = _Z;
    for(G = wG; G <= ZG; G++)q[G] = u1;
    for(G = MG; G <= bG; G++)q[G] = u1;
    for(G = y1; G <= mq; G++)q[G] = u1;
    for(G = rZ; G <= k1; G++)q[G] = u1;
    return q;
}(), yG = function() {
    let q = new Uint8Array(128);
    return q[h1] = CJ, q[y1] = hJ, q[FG] = q[e1] = q[k1] = q[S1] = kJ, q[mq] = q[qG] = q[bG] = q[GG] = q[Xq] = q[I] = q[wG] = nZ, q[E1] = q[P1] = q[j1] = nZ, q;
}();
function pJ(q) {
    return q < oq && (XG[q] & u1) !== 0;
}
function BG(q) {
    return q < oq && (XG[q] & _Z) !== 0;
}
var lJ = /[\p{P}\p{S}]/u, uJ = /\p{Zs}/u;
function d1(q) {
    if (!q) return !0;
    let G = q.charCodeAt(0);
    return G < oq ? (XG[G] & _Z) !== 0 : uJ.test(q);
}
function kG(q) {
    if (typeof q === "number") return q < oq && (XG[q] & u1) !== 0;
    if (!q) return !1;
    let G = q.charCodeAt(0);
    return G < oq ? (XG[G] & u1) !== 0 : lJ.test(q);
}
function x(q, G) {
    let Y = q.indexOf(`
`, G);
    return Y !== -1 ? Y : q.length;
}
function yq(q, G, Y) {
    let Z = Y ?? q.length;
    while(G < Z && (q[G] === " " || q[G] === "\t"))G++;
    return G;
}
function hG(q) {
    if (!q) return !1;
    for(var G in q)return !0;
    return !1;
}
function jZ(q, G, Y) {
    var Z = q, J = G.split("."), X = 0;
    while(X < J.length){
        if (Z = Z?.[J[X]], Z === void 0) break;
        X++;
    }
    return Z || Y;
}
function dJ(q, G) {
    if (!G) return q;
    let Y = jZ(G, q, void 0);
    if (typeof Y === "string") return Y;
    if (typeof Y === "object" && Y.component) return Y.component;
    return q;
}
function iJ(q, G) {
    if (!G) return {};
    let Y = jZ(G, q, void 0);
    return typeof Y === "object" && Y.props ? Y.props : {};
}
function qJ(q, G) {
    var Y = "";
    for(var Z = 0, J = q.length; Z < J; Z++){
        var X = q[Z], $ = X.type;
        if ($ === G.text || $ === G.codeInline) {
            var K = X.text;
            if (K) Y += K;
        } else if ($ === G.textFormatted || $ === G.link) {
            if (X.children) Y += qJ(X.children, G);
        } else if ($ === G.image) {
            if (X.alt) Y += X.alt;
        }
    }
    return Y;
}
function pG(q) {
    var G = q.toLowerCase();
    return G === "title" || G === "textarea" || G === "style" || G === "xmp" || G === "iframe" || G === "noembed" || G === "noframes" || G === "script" || G === "plaintext";
}
function lG(q) {
    return q.replace(/<(\/?)(title|textarea|style|xmp|iframe|noembed|noframes|script|plaintext)(\s|>|\/)/gi, function(G, Y, Z, J) {
        return "&lt;" + Y + Z + J;
    });
}
function cJ(q) {
    console.warn(q);
}
function QG(q, G, Y, Z) {
    var J = B(Y), X = q.length, $ = Z ?? X - G, K = 0;
    while(K < $ && G + K < X && B(q, G + K) === J)K++;
    return K;
}
function GJ(q, G, Y, Z, J) {
    if (J === 0 ? Y >= Z : G <= Z) return !1;
    let X = J === 0 ? q[Y] : q[G - 1], $ = J === 0 ? G > 0 ? q[G - 1] : null : Y < q.length ? q[Y] : null;
    var K = B(X);
    if (K < oq ? BG(K) : d1(X)) return !1;
    var V = $ ? B($) : null, z = $ === null || $ === `
` || $ === "\r" || (V !== null ? V < oq ? BG(V) : d1($) : !0), j = nG(K, X);
    if (!j) return !0;
    if (z) return !0;
    return $ ? nG(B($), $) : !1;
}
function rG(q) {
    var G = "", Y = 0;
    while(Y < q.length)if (q[Y] === "\\" && Y + 1 < q.length) {
        var Z = q[Y + 1];
        G += kG(B(Z)) ? Z : "\\" + Z, Y += 2;
    } else G += q[Y++];
    return zG(G);
}
function u(q, G) {
    return G + (G < q.length ? 1 : 0);
}
function aJ(q, G) {
    if (q >= oq) return 0;
    var Y = yG[q];
    if (G && Y === 1 && (q === E1 || q === P1 || q === j1)) return 0;
    return Y;
}
function rJ(q, G, Y, Z, J, X) {
    if (!Y.length || Y[Y.length - 1].type !== F.blockQuote) return null;
    let $ = yq(Z, 0, Z.length);
    if ($ >= Z.length || Z[$] !== ">") return null;
    let K = yJ(q, G, J, X);
    if (!K) return null;
    let V = Y[Y.length - 1], z = K;
    if (z.children) V.children.push(...z.children);
    return z.endPos;
}
function sG(q, G, Y, Z) {
    return {
        type: F.heading,
        level: q,
        children: G,
        id: Z(Y)
    };
}
var MZ = /\\(.)/g, sJ = /\s+#+\s*$/, xZ = /^(?:(\d{1,9})([.)])\s+(.*)$|(\d{1,9})([.)])\s*$|([-*+])\s+(.*)$|([-*+])\s*$)/, AZ = /^(\d{1,9})([.)])(\s+|$)/, yZ = /^([*+\-])(\s+|$)/, HJ = /^<([a-z][^ >/\n\r]*) ?([^>]*?)>/i, vJ = /^<([a-z][^ >/]*) ?(?:[^>/]+[^/]|)>/i, B = function(q, G = 0) {
    return q.charCodeAt(G);
}, oG = function(q) {
    return mG(B(q));
}, BZ = function(q) {
    return BG(B(q));
}, Tq = function(q) {
    return q === " " || q === "\t";
}, nG = function(q, G) {
    return kG(q < oq ? q : G);
}, oJ = function(q) {
    var G = B(q);
    return oG(q) || G === X1 || G === e1 || G === MG || G === YZ;
};
function NZ(q, G) {
    var Y = q.length;
    if (G >= Y) return null;
    var Z = B(q[G]);
    if (!a1(Z)) return null;
    var J = G, X = G;
    while(X < Y){
        var $ = B(q[X]);
        if ($ >= $G && $ <= VG || $ >= p1 && $ <= l1 || $ >= JG && $ <= YG || $ === X1) X++;
        else {
            var K = B(q[X]);
            if (K === I || K === p || K === Xq || K === Lq || K === B1 || K === ZG) break;
            else return null;
        }
    }
    if (X === J) return null;
    var V = q.slice(J, X);
    for(var z = 0; z < V.length; z++){
        var $ = B(V[z]);
        if (!($ >= $G && $ <= VG || $ >= p1 && $ <= l1 || $ >= JG && $ <= YG || $ === X1)) return null;
    }
    return {
        tagName: V,
        tagLower: V.toLowerCase(),
        nextPos: X
    };
}
function c1(q, G) {
    var Y = aG(q, G);
    if (!Y || Y.kind !== "tag") return null;
    return {
        tagName: Y.tagName || "",
        tagLower: Y.tagNameLower || "",
        attrs: Y.attrs || "",
        endPos: Y.endPos,
        isClosing: Y.isClosing || !1,
        isSelfClosing: Y.isSelfClosing || !1,
        hasNewline: Y.hasNewline,
        hasSpaceBeforeSlash: !1,
        whitespaceBeforeAttrs: Y.whitespaceBeforeAttrs || ""
    };
}
function nJ(q, G, Y) {
    var Z = 1, J = G;
    while(Z > 0 && J < q.length){
        var X = q.indexOf("<", J);
        if (X === -1) return null;
        var $ = c1(q, X);
        if (!$) {
            J = X + 1;
            continue;
        }
        if ($.isClosing && $.tagLower === Y && --Z === 0) return [
            X,
            $.endPos
        ];
        if (!$.isClosing && !$.isSelfClosing && $.tagLower === Y) Z++;
        J = $.endPos;
    }
    return null;
}
var tJ = /^\{.*\}$/, OJ = /\n\n/, FJ = /^(\s{0,3}#[#\s]|\s{0,3}[-*+]\s|\s{0,3}\d+\.\s|\s{0,3}>\s|\s{0,3}```)/m, eJ = /<\/?(?:pre|script|style|textarea)\b/i, bJ = /^<[A-Z]/, qY = /\n$/, GY = new Set([
    "#",
    ">",
    "-",
    "*",
    "+",
    "`",
    "|",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
]);
function ZY(q, G, Y, Z) {
    let J = G;
    while(J < Y){
        if (q[J] === "\\" && J + 1 < Y) {
            J += 2;
            continue;
        }
        if (q[J] === Z) return J;
        J++;
    }
    return -1;
}
function ZJ(q, G) {
    var Y = G.indexOf(":");
    if (Y > 0) {
        var Z = G.slice(Y + 1).trim(), J = Z.length;
        if (J >= 2) {
            var X = Z[0];
            if ((X === '"' || X === "'") && Z[J - 1] === X) Z = Z.slice(1, -1);
        }
        q.push([
            G.slice(0, Y).trim(),
            Z
        ]);
    }
}
function JY(q) {
    var G = [];
    if (!q) return G;
    var Y = "", Z = 0, J = "";
    for(var X = 0; X < q.length; X++){
        var $ = q[X];
        if ($ === '"' || $ === "'") {
            if (!J) J = $, Z++;
            else if ($ === J) J = "", Z--;
        } else if ($ === "(" && CG(Y, "url")) Z++;
        else if ($ === ")" && Z > 0) Z--;
        else if ($ === ";" && Z === 0) {
            ZJ(G, Y), Y = "";
            continue;
        }
        Y += $;
    }
    return ZJ(G, Y), G;
}
function YY(q, G, Y, Z) {
    if (G === "style") return JY(Y).reduce(function(J, [X, $]) {
        let K = Z($, q, X);
        if (K != null) J[X.replace(/(-[a-z])/g, (V)=>V[1].toUpperCase())] = K;
        return J;
    }, {});
    if (DZ.indexOf(G) !== -1) return Z(Y ? Y.replace(MZ, "$1") : Y, q, G);
    if (Y.match(tJ)) Y = Y.slice(1, Y.length - 1), Y = Y ? Y.replace(MZ, "$1") : Y;
    return Y === "true" ? !0 : Y === "false" ? !1 : Y;
}
function i1(q, G, Y, Z) {
    let J = {};
    if (!q || !q.trim()) return J;
    let X = [], $ = 0, K = q.length;
    while($ < K){
        while($ < K && Tq(q[$]))$++;
        if ($ >= K) break;
        let j = $;
        while($ < K && oJ(q[$]))$++;
        if ($ === j) {
            $++;
            continue;
        }
        let b = q.slice(j, $);
        while($ < K && Tq(q[$]))$++;
        if ($ >= K || q[$] !== "=") {
            X.push(b);
            continue;
        }
        $++;
        while($ < K && Tq(q[$]))$++;
        if ($ >= K) {
            X.push(b + "=");
            break;
        }
        let U = $, Q = q[$];
        if (Q === '"' || Q === "'") {
            $++;
            while($ < K){
                if (q[$] === Q) {
                    if ($ + 1 >= K) {
                        $++;
                        break;
                    }
                    let v = q[$ + 1];
                    if (Tq(v) || v === "/") {
                        $++;
                        break;
                    }
                }
                $++;
            }
        } else if (Q === "{") {
            let v = 1;
            $++;
            while($ < K && v > 0){
                if (q[$] === "{") v++;
                else if (q[$] === "}") {
                    if (v--, v === 0) {
                        $++;
                        break;
                    }
                }
                $++;
            }
        } else while($ < K && !Tq(q[$]))$++;
        X.push(b + "=" + q.slice(U, $));
    }
    if (!X?.length) return J;
    let V = G.toLowerCase(), z = Y.length > 0 && Y[0] >= "A" && Y[0] <= "Z";
    for(let j = 0; j < X.length; j++){
        let b = X[j], U = b.indexOf("=");
        if (U !== -1) {
            let Q = b.slice(0, U).trim(), v = Q.toLowerCase();
            if (v === "ref") continue;
            let D = z ? Q : v, _ = b.slice(U + 1).trim(), H = ((O)=>{
                let w = O[0];
                if ((w === '"' || w === "'") && O.length >= 2 && O[O.length - 1] === w) return O.slice(1, -1);
                return O;
            })(_);
            if (v === "href" && V === "a" || v === "src" && V === "img") {
                let O = Z.sanitizer(H, V, v);
                if (O == null) {
                    cJ(`Stripped unsafe ${v} on <${Y}>`);
                    continue;
                }
                J[D] = O;
            } else {
                let O = YY(V, v, H, Z.sanitizer);
                J[D] = O;
            }
        } else if (b !== "style") J[z ? b : b.toLowerCase()] = !0;
    }
    if (AG.test(decodeURIComponent(q))) for(let j in J)delete J[j];
    return J;
}
var TG = function(q) {
    return GY.has(q);
};
function $Y(q, G, Y) {
    let Z = G + 1;
    while(Z < q.length && q[Z] !== "]"){
        if (q[Z] === "\\" && Z + 1 < q.length) {
            Z += 2;
            continue;
        }
        Z++;
    }
    if (Z >= q.length) return {
        shouldSkip: !1,
        newPos: 0
    };
    let J = G + 1, X = Z, $ = J < X && (q[J] === `
` || q[J] === "\r"), K = X > J && (q[X - 1] === `
` || q[X - 1] === "\r"), V = Z + 1;
    if (V = yq(q, V), V >= q.length || q[V] !== ":") return {
        shouldSkip: !1,
        newPos: 0
    };
    if (($ || K) && Y) {
        let z = V + 1;
        if (z = yq(q, z), z < q.length && q[z] === `
`) z = yq(q, z + 1);
        while(z < q.length && q[z] !== `
`)z++;
        if (z < q.length) z++;
        return {
            shouldSkip: !0,
            newPos: z
        };
    }
    return VY(q, V);
}
function VY(q, G) {
    let Y = G + 1;
    if (Y = yq(q, Y), Y < q.length && q[Y] === `
`) Y = yq(q, Y + 1);
    while(Y < q.length && q[Y] !== `
`)Y++;
    if (Y >= q.length) return {
        shouldSkip: !1,
        newPos: 0
    };
    Y++;
    let Z = yq(q, Y);
    if (Z >= q.length || q[Z] !== '"' && q[Z] !== "'") return {
        shouldSkip: !1,
        newPos: 0
    };
    let J = q[Z], X = Z + 1;
    while(X < q.length && q[X] !== J && q[X] !== `
`){
        if (q[X] === "\\" && X + 1 < q.length) {
            X += 2;
            continue;
        }
        X++;
    }
    if (X >= q.length || q[X] !== J) return {
        shouldSkip: !1,
        newPos: 0
    };
    let $ = yq(q, X + 1);
    if ($ < q.length && q[$] !== `
` && q[$] !== "\r") return {
        shouldSkip: !0,
        newPos: Y
    };
    return {
        shouldSkip: !1,
        newPos: 0
    };
}
function wJ(q) {
    for(var G = 0; G < q.length; G++){
        var Y = q[G];
        if (Y.type === F.link) return !0;
        if (Y.type === F.textFormatted) {
            var Z = Y;
            if (Z.children && wJ(Z.children)) return !0;
        }
    }
    return !1;
}
function RZ(q) {
    var G = "";
    for(var Y = 0, Z = q.length; Y < Z; Y++){
        var J = q[Y], X = J.type;
        if (X === F.text) G += J.text;
        else if (X === F.image) {
            var $ = J;
            if ($.alt) G += $.alt;
        } else if (X === F.textFormatted) {
            var K = J;
            if (K.children) G += RZ(K.children);
        } else if (X === F.link) {
            var V = J;
            if (V.children) G += RZ(V.children);
        }
    }
    return G;
}
var XY = new Set([
    " ",
    "\t",
    "\r",
    `
`,
    "\f",
    "\v"
]);
function r1(q, G, Y, Z, J) {
    var X = [], $ = [], K = [], V = G, z = G, j = J.disableAutoLink || Z.inAnchor, b = !1, U = !!Z.inAnchor, Q = !!J.disableParsingRawHTML, v = function(Eq, pq) {
        if (Q) return !1;
        if (!U && (!pq || !J.disableAutoLink)) {
            var sq = FZ(q, V, Z, J, "<");
            if (sq) return D(V), X.push(sq), V = sq.endPos, z = V, !0;
        }
        var b1 = GZ(q, V, Z, J);
        if (b1) return D(V), X.push(b1), V = b1.endPos, z = V, !0;
        if (!Eq) return !1;
        var wq = c1(q, V);
        if (!wq) return !1;
        var Y1 = V + (wq.isClosing ? 2 : 1);
        if (Y1 >= q.length || Tq(q[Y1])) return !1;
        var w1 = q.indexOf(">", V + 1);
        if (w1 !== -1) {
            var W1 = V + 1, n1 = w1 - W1;
            if (n1 >= 7) {
                var SG = n(q, "http://", W1);
                if (SG || n(q, "https://", W1)) {
                    for(var Gq = W1; Gq < w1; Gq++)if (Tq(q[Gq])) return !1;
                }
            }
        }
        var L1 = B(q, Y1);
        if (a1(L1) && Y1 + 1 < q.length && q[Y1 + 1] === ":") return !1;
        if (wq.isClosing && wq.attrs.trim().length) return !1;
        if (wq.attrs.length) {
            var M1 = !1, T1 = "";
            for(var lq = 0; lq < wq.attrs.length; lq++){
                var $1 = wq.attrs[lq];
                if (M1 && $1 === T1) M1 = !1;
                else if (!M1 && ($1 === '"' || $1 === "'")) M1 = !0, T1 = $1;
                else if ($1 === "*" || $1 === "#" || $1 === "!") {
                    var k = lq + 1;
                    while(k < wq.attrs.length && wq.attrs[k] !== "=" && wq.attrs[k] !== " " && wq.attrs[k] !== "\t")k++;
                    if (k < wq.attrs.length && wq.attrs[k] === "=") return !1;
                }
            }
        }
        var Oq = {
            type: F.htmlBlock,
            tag: wq.tagName,
            attrs: {},
            children: [],
            text: q.slice(V, wq.endPos),
            noInnerParse: !0,
            endPos: wq.endPos
        };
        return D(V), X.push(Oq), V = Oq.endPos, z = V, !0;
    }, D = function(Eq) {
        if (Eq > z) {
            var pq = q.slice(z, Eq);
            X.push({
                type: F.text,
                text: b ? zG(pq) : pq
            }), z = Eq, b = !1;
        }
    };
    while(V < Y){
        var _ = B(q, V), H = aJ(_, j);
        if (H === 0) {
            if (_ === WG) b = !0;
            V++;
            while(V < Y){
                if (_ = B(q, V), _ >= oq) break;
                if (_ === WG) b = !0;
                var O = yG[_];
                if (O !== 0) {
                    if (j && O === 1 && (_ === E1 || _ === P1 || _ === j1)) {
                        V++;
                        continue;
                    }
                    break;
                }
                V++;
            }
            continue;
        }
        if (_ === mq) {
            var w = V, T = 0;
            while(V + T < Y){
                if (B(q, V + T) !== mq) break;
                T++;
            }
            if (T > 0) {
                var g = V + T, M = -1, y = g;
                while(y < Y){
                    while(y < Y && B(q, y) !== mq)y++;
                    if (y >= Y) break;
                    var f = 0;
                    while(y + f < Y && B(q, y + f) === mq)f++;
                    if (f > T) f = T;
                    var W = y + f;
                    if (f === T && (y <= g || B(q, y - 1) !== mq) && (W >= Y || B(q, W) !== mq)) {
                        M = y, y = W;
                        break;
                    }
                    y++;
                }
                if (M !== -1) {
                    var A = q.slice(g, M), N = !1;
                    for(var L = 0; L < A.length; L++){
                        var P = B(A, L);
                        if (P === Xq || P === Lq) {
                            N = !0;
                            break;
                        }
                    }
                    var E = A;
                    if (N) E = A.replace(/\r\n/g, " ").replace(/\r/g, " ").replace(/\n/g, " ");
                    if (E.length > 0) {
                        var S = B(E, 0), C = B(E, E.length - 1);
                        if (S === I && C === I) {
                            for(var l = 1; l < E.length - 1; l++)if (B(E, l) !== I) {
                                E = E.slice(1, E.length - 1);
                                break;
                            }
                        }
                    }
                    D(w), X.push({
                        type: F.codeInline,
                        text: E
                    }), V = y, z = V;
                    continue;
                }
                V = g;
                continue;
            }
        }
        if (!U && !j && (_ === E1 || _ === P1 || _ === j1)) {
            var R = null, Jq = V + 1 < Y ? B(q, V + 1) : 0, i = V + 2 < Y ? B(q, V + 2) : 0, $q = V + 3 < Y ? B(q, V + 3) : 0, Mq = V + 4 < Y ? B(q, V + 4) : 0, Uq = V + 5 < Y ? B(q, V + 5) : 0;
            if (_ === P1 && Jq === PG && i === PG && $q === JZ) R = "h";
            else if (_ === j1 && Jq === j1 && i === j1 && $q === YZ) R = "w";
            else if (_ === E1 && Jq === PG && i === JZ && $q === MG && Mq === ZG && Uq === ZG) R = "f";
            if (R) {
                var Hq = FZ(q, V, Z, J, R);
                if (Hq) {
                    D(V), X.push(Hq), V = Hq.endPos, z = V;
                    continue;
                }
            }
        }
        if (!U && !j && _ === bG) {
            var m = FZ(q, V, Z, J, "@");
            if (m && "emailStart" in m) {
                var { emailStart: c, endPos: t } = m, a = [];
                for(var W = $.length - 1; W >= 0; W--){
                    var zq = $[W];
                    if (zq.sourcePos >= c && zq.sourcePos < t) {
                        if (zq.nodeIndex >= 0 && zq.nodeIndex < X.length) X.splice(zq.nodeIndex, 1), a.push(zq.nodeIndex);
                        $.splice(W, 1);
                    }
                }
                if (c < z) {
                    for(var y = X.length - 1; y >= 0; y--)if (X[y].type === F.text) {
                        X.splice(y, 1), a.push(y);
                        break;
                    }
                    z = c;
                }
                if (a.length) {
                    a.sort(function(Eq, pq) {
                        return Eq - pq;
                    });
                    var Qq = 0;
                    for(var Bq = 0; Bq < $.length; Bq++){
                        var zq = $[Bq];
                        while(Qq < a.length && a[Qq] < zq.nodeIndex)Qq++;
                        zq.nodeIndex -= Qq;
                    }
                }
                D(c), X.push(m), V = t, z = V;
                continue;
            }
        }
        if (_ === qG) {
            if (v(!0, !1)) continue;
        }
        if (_ === h1) {
            if (V + 1 < Y && B(q, V + 1) === Xq) {
                var r = V + 2;
                while(r < Y && B(q, r) === I)r++;
                if (r >= Y) {
                    V++;
                    continue;
                }
                D(V), X.push({
                    type: F.breakLine
                }), V += 2;
                while(V < Y && B(q, V) === I)V++;
                z = V;
                continue;
            }
            var nq = V + 1 < Y ? q[V + 1] : "";
            if (nq && "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~".indexOf(nq) !== -1) {
                D(V), X.push({
                    type: F.text,
                    text: nq === "&" ? "&\u200B" : nq
                }), V += 2, z = V;
                continue;
            }
        }
        if (_ === y1) {
            if (!U) {
                if (V + 1 < Y && q[V + 1] === "^") {
                    var iq = V + 2;
                    while(iq < Y && q[iq] !== "]")iq++;
                    if (iq < Y) {
                        var qq = q.slice(V + 2, iq);
                        D(V), X.push({
                            type: F.footnoteReference,
                            target: `#${J.slugify(qq)}`,
                            text: qq
                        }), V = iq + 1, z = V;
                        continue;
                    }
                }
                if (Z.inList && V + 2 < Y && B(q, V + 2) === GG) {
                    var e = B(q, V + 1);
                    if (e === I || e === $Z || e === VZ) {
                        D(V), X.push({
                            type: F.gfmTask,
                            completed: e === $Z || e === VZ
                        }), V += 3, z = V;
                        continue;
                    }
                }
            }
            var cq = !1;
            if (V > G && q[V - 1] === "!") {
                var K1 = 0;
                for(var Vq = V - 2; Vq >= G && q[Vq] === "\\"; Vq--)K1++;
                if ((K1 & 1) === 0) {
                    if (cq = !0, z < V - 1) D(V - 1);
                    if (X.length > 0 && X[X.length - 1].type === F.text) {
                        var G1 = X[X.length - 1];
                        if (G1.text.endsWith("!")) {
                            if (G1.text = G1.text.slice(0, -1), !G1.text) X.pop();
                        }
                    }
                }
            }
            if (!cq) D(V);
            if (z = V + 1, !U || cq) K.push({
                type: cq ? "image" : "link",
                pos: cq ? V - 1 : V,
                resultIdx: X.length,
                inAnchor: U
            });
            V++;
            continue;
        }
        if (_ === GG && K.length > 0) {
            var Nq = K[K.length - 1], kq = Nq.pos + (Nq.type === "image" ? 2 : 1), jq = V;
            D(V);
            var aq = V + 1, N1 = SZ(X, Nq), Z1 = Nq.type === "link" && wJ(N1), U1 = !1;
            if (!Z1 && aq < Y && q[aq] === "(") {
                var H1 = QY(q, aq + 1, !0);
                if (H1) {
                    JJ(X, $, K, Nq, kq, jq, J.sanitizer(rG(H1.target), "a", "href"), H1.title ? rG(H1.title) : void 0), V = H1.endPos, z = V;
                    continue;
                }
            }
            var tq = Z.refs || {};
            hG(tq);
            var hq = null, Q1 = V;
            if (aq < Y && q[aq] === "[") {
                var bq = aq + 1, y = bq;
                while(y < Y && q[y] !== "]")y++;
                if (y < Y) hq = q.slice(bq, y), Q1 = y, U1 = !0;
            }
            if (!U1 || hq === "") hq = q.slice(kq, jq);
            var rq = MJ(hq);
            if (!Z1 && tq && tq[rq]) {
                var v1 = tq[rq];
                JJ(X, $, K, Nq, kq, jq, v1.target, v1.title), V = Q1 + 1, z = V;
                continue;
            }
            var O1 = Nq.resultIdx;
            if (K.pop(), X.length = O1, Nq.type === "image") X.push({
                type: F.text,
                text: "!"
            });
            X.push({
                type: F.text,
                text: "["
            }, ...N1, {
                type: F.text,
                text: "]"
            });
            for(var L = 0; L < $.length; L++)if ($[L].nodeIndex >= O1) $[L].nodeIndex++;
            V++, z = V;
            continue;
        }
        if (_ === FG || _ === e1 || _ === k1 || _ === S1) {
            var gq = q[V], Dq = V, xq = QG(q, V, gq);
            if ((gq === "~" || gq === "=") && xq !== 2) {
                V++;
                continue;
            }
            var eq = Dq + xq, R1 = GJ(q, Dq, eq, Y, 0), Kq = GJ(q, Dq, eq, G, 1), J1 = R1, D1 = Kq;
            if (gq === "_" && R1 && Kq) {
                if (Dq > 0) {
                    var Sq = q[Dq - 1], jG = B(Sq);
                    J1 = nG(jG, Sq);
                }
                if (eq < Y) {
                    var _1 = q[eq], F1 = B(_1);
                    D1 = nG(F1, _1);
                }
            }
            D(Dq), $.push({
                nodeIndex: X.length,
                type: gq,
                length: xq,
                canOpen: J1,
                canClose: D1,
                active: !0,
                sourcePos: Dq,
                inAnchor: U
            }), X.push({
                type: F.text,
                text: q.slice(Dq, Dq + xq)
            }), V = Dq + xq, z = V;
            continue;
        }
        if (_ === Xq) {
            var Vq = V - 1, s1 = 0;
            while(Vq >= z && B(q, Vq) === I)s1++, Vq--;
            if (s1 >= 2) {
                var r = V + 1;
                while(r < Y && B(q, r) === I)r++;
                if (r >= Y) {
                    D(Vq + 1), V = Y, z = Y;
                    continue;
                }
                D(Vq + 1), X.push({
                    type: F.breakLine
                }), V++;
                while(V < Y && B(q, V) === I)V++;
                z = V;
                continue;
            }
            var o1 = V > z ? B(q, V - 1) : 0, e = V + 1 < Y ? B(q, V + 1) : 0, HG = V > z && o1 === I && e === I ? V - 1 : V;
            if (D(HG), X.push({
                type: F.text,
                text: `
`
            }), z = V + 1, V > G && o1 === I && z < Y && B(q, z) === I) z++;
            V = z;
            continue;
        }
        if (_ === WG) b = !0;
        V++;
        while(V < Y){
            var _ = B(q, V);
            if (_ >= oq) break;
            if (_ === WG) b = !0;
            var O = yG[_];
            if (O === 0) {
                V++;
                continue;
            }
            if (O === 1 && (_ === E1 || _ === P1 || _ === j1) && j) {
                V++;
                continue;
            }
            break;
        }
    }
    if (D(V), $.length) TJ(X, $, null);
    if (K.length) {
        K.sort(function(Eq, pq) {
            return Eq.resultIdx - pq.resultIdx;
        });
        for(var y = 0; y < K.length; y++)X.splice(K[y].resultIdx + y, 0, {
            type: F.text,
            text: K[y].type === "image" ? "![" : "["
        });
    }
    return X;
}
function zY(q, G, Y, Z, J) {
    var X = !1;
    for(var $ = 0; $ < G.length; $++)if (G[$].sourcePos >= Z && G[$].sourcePos < J) {
        X = !0;
        break;
    }
    if (!X) return;
    var K = SZ(q, Y), V = [];
    for(var $ = 0; $ < G.length; $++){
        var z = G[$];
        if (z.sourcePos >= Z && z.sourcePos < J) V.push({
            nodeIndex: z.nodeIndex - Y.resultIdx,
            type: z.type,
            length: z.length,
            canOpen: z.canOpen,
            canClose: z.canClose,
            active: z.active,
            sourcePos: z.sourcePos,
            inAnchor: z.inAnchor
        });
    }
    TJ(K, V, null), q.length = Y.resultIdx;
    for(var j = 0; j < K.length; j++)q.push(K[j]);
    var b = [];
    for(var $ = 0; $ < G.length; $++)if (G[$].sourcePos < Z || G[$].sourcePos >= J) b.push(G[$]);
    G.length = 0;
    for(var j = 0; j < b.length; j++)G.push(b[j]);
}
function KY(q, G, Y, Z) {
    if (q.type === "link") return {
        type: F.link,
        target: Y,
        title: Z,
        children: G
    };
    return {
        type: F.image,
        target: Y || "",
        alt: RZ(G),
        title: Z
    };
}
function SZ(q, G) {
    return q.slice(G.resultIdx);
}
function JJ(q, G, Y, Z, J, X, $, K) {
    zY(q, G, Z, J, X);
    var V = SZ(q, Z);
    Y.pop(), q.length = Z.resultIdx, q.push(KY(Z, V, $, K));
}
function UY(q, G, Y) {
    let Z = yq(q, G), J = Z < q.length && q[Z] === "<";
    if (J) Z++;
    let X = Z;
    if (J && Z < q.length && q[Z] === ">") return {
        target: "",
        endPos: Z + 1,
        hadSpace: !1
    };
    let $, K;
    var V = !1;
    if (J) {
        K = Z;
        while(K < q.length && q[K] !== ">"){
            let b = q[K];
            if (b === `
` || b === "\r" || b === "<") return null;
            if (b === "\\") {
                K += 2;
                continue;
            }
            K++;
        }
        if (K >= q.length || q[K] !== ">") return null;
        K++;
        let z = X;
        while(z < K - 1 && Tq(q[z]))z++;
        let j = K - 1;
        while(j > z && Tq(q[j - 1]))j--;
        $ = q.slice(z, j), Z = K;
    } else {
        let z = 0;
        K = Z;
        while(K < q.length){
            let j = q[K];
            if (j === " " || j === "\t" || j === `
`) {
                V = !0;
                break;
            }
            if (!Y && j === ")") break;
            if (Y && j === "(") {
                if (K > 0 && q[K - 1] === "\\") {
                    K++;
                    continue;
                }
                z++, K++;
                continue;
            }
            if (Y && j === ")") {
                if (K > 0 && q[K - 1] === "\\") {
                    K++;
                    continue;
                }
                if (z === 0) break;
                z--, K++;
                continue;
            }
            K++;
        }
        $ = q.slice(X, K), Z = K;
    }
    return {
        target: $,
        endPos: Z,
        hadSpace: V
    };
}
function YJ(q, G, Y, Z) {
    let J = G, X = 0;
    while(J < q.length){
        let K = q[J];
        if (Tq(K)) J++;
        else if (K === `
`) {
            if (X >= 1) break;
            X++, J++;
        } else if (d1(K)) break;
        else break;
    }
    if (Y && !Z) {
        if (J >= q.length || q[J] !== '"' && q[J] !== "'" && q[J] !== "(") return {
            title: void 0,
            endPos: J
        };
    }
    let $ = void 0;
    if (J < q.length) {
        let K = q[J];
        if (K === '"' || K === "'") {
            J++;
            let V = J;
            while(J < q.length && q[J] !== K){
                if (q[J] === "\\") J++;
                J++;
            }
            if (J < q.length) $ = q.slice(V, J), J++;
        } else if (K === "(") {
            J++;
            let V = J, z = 1;
            while(J < q.length && z > 0){
                if (q[J] === "\\" && J + 1 < q.length) J++;
                else if (q[J] === "(") z++;
                else if (q[J] === ")") z--;
                J++;
            }
            if (z === 0) $ = q.slice(V, J - 1);
        }
    }
    return J = yq(q, J), {
        title: $,
        endPos: J
    };
}
function QY(q, G, Y) {
    let Z = UY(q, G, Y);
    if (!Z) return null;
    let J = G;
    J = yq(q, J);
    let X = J < q.length && q[J] === "<";
    if (X && Z.target === "" && Z.endPos === J + 2) {
        let K = YJ(q, Z.endPos, !1, X);
        if (K.endPos >= q.length || q[K.endPos] !== ")") return null;
        return {
            target: "",
            title: K.title,
            endPos: K.endPos + 1
        };
    }
    let $ = YJ(q, Z.endPos, Z.hadSpace, X);
    if ($.endPos >= q.length || q[$.endPos] !== ")") return null;
    return {
        target: Z.target,
        title: $.title,
        endPos: $.endPos + 1
    };
}
function a1(q) {
    return q >= p1 && q <= l1 || q >= $G && q <= VG;
}
function WJ(q) {
    let G = q.indexOf(":");
    if (G < 2 || G > 32) return !1;
    let Y = B(q);
    if (!a1(Y)) return !1;
    for(let Z = 1; Z < G; Z++){
        let J = q[Z], X = B(J);
        if (!oG(J) && J !== "+" && J !== "." && J !== "-") return !1;
    }
    return !0;
}
function $J(q, G, Y) {
    if (G === 0) return !0;
    return (Y ? ` 	
\r*_~(` : ` 	
*_~(`).indexOf(q[G - 1]) !== -1;
}
function vZ(q, G, Y, Z, J) {
    let X = Z(q, "a", "href");
    if (!X) return null;
    return {
        type: F.link,
        target: X,
        children: [
            {
                type: F.text,
                text: G
            }
        ],
        endPos: Y,
        ...J !== void 0 ? {
            emailStart: J
        } : {}
    };
}
function OZ(q, G, Y, Z, J) {
    if (Y.inAnchor || J !== 2 && Z.disableAutoLink) return null;
    if (J === 2) {
        if (q[G] !== "<") return null;
        let U = G + 1;
        while(U < q.length && q[U] !== ">"){
            if (Tq(q[U])) return null;
            U++;
        }
        if (U >= q.length || q[U] !== ">") return null;
        let Q = q.slice(G + 1, U);
        if (!Q.length) return null;
        let v = Q.indexOf("\\") !== -1, D = WJ(Q), _ = n(Q, "http://") || n(Q, "https://"), H = Q.toLowerCase(), O = n(H, "mailto:"), w = !v && Q.indexOf("@") !== -1 && Q.indexOf("//") === -1 && !D;
        if (!_ && !O && !w && !D) return null;
        let T = Q, g = Q;
        if (D || _) ;
        else if (O) {
            let M = H.indexOf(":");
            g = Q.slice(M + 1), T = "mailto:" + g;
        } else if (w) T = "mailto:" + Q;
        return vZ(T, g, U + 1, Z.sanitizer);
    }
    if (J === 1) {
        let U = G;
        while(U > 0 && (oG(q[U - 1]) || ".+-_".indexOf(q[U - 1]) !== -1))U--;
        if (U >= G || !$J(q, U, !0)) return null;
        let Q = G + 1, v = !1;
        while(Q < q.length){
            let H = q[Q];
            if (H === ".") v = !0, Q++;
            else if (oG(H) || H === "-" || H === "_") Q++;
            else break;
        }
        if (!v || Q <= G + 1) return null;
        while(Q > G + 1 && q[Q - 1] === ".")Q--;
        if (Q > G + 1 && (q[Q - 1] === "-" || q[Q - 1] === "_")) return null;
        if (Q - (G + 1) < 1e4) {
            if (q.indexOf(".", G + 1) >= Q || q.indexOf(".", G + 1) === -1) return null;
        } else if (q.slice(G + 1, Q).indexOf(".") === -1) return null;
        let _ = q.slice(U, Q);
        return vZ("mailto:" + _, _, Q, Z.sanitizer, U);
    }
    let X = n(q, "http://", G) || n(q, "https://", G), $ = !X && n(q, "ftp://", G), K = !X && !$ && n(q, "www.", G);
    if (!(X || $ || K) || !$J(q, G, !1)) return null;
    var V = G + (X ? B(q, G + 4) === uZ ? 8 : 7 : $ ? 6 : 4), z = V;
    while(V < q.length){
        let U = B(q, V);
        if (U === I || U === p || U === Xq || U === qG || U === B1) break;
        V++;
    }
    if (V <= z) return null;
    let j = V;
    while(j > z){
        let U = q[j - 1];
        if (j > z + 1 && q[j - 2] === "\\") break;
        if (U === "?" || U === "!" || U === "." || U === "," || U === ":" || U === "*" || U === "_" || U === "~") j--;
        else if (U === ";") {
            let Q = j - 2;
            while(Q >= z && q[Q] !== "&" && q[Q] !== " ")Q--;
            if (Q >= z && q[Q] === "&") {
                let v = q.slice(Q + 1, j - 1);
                if (v.length >= 2 && v.length <= 10 && /^[a-zA-Z0-9]+$/.test(v) && (v === "lt" || v === "gt" || v.length >= 3 && (n(v, "amp") || n(v, "apos") || n(v, "quot") || n(v, "nbsp") || /^[a-z]{3,10}$/.test(v)))) break;
                j = Q;
                break;
            }
            j--;
        } else if (U === ")") {
            let Q = 0, v = 0;
            for(let D = z; D < j; D++){
                if (q[D] === "(") Q++;
                if (q[D] === ")") v++;
            }
            if (v > Q) j--;
            else break;
        } else break;
    }
    if (V = j, V <= z) return null;
    let b = q.slice(G, V);
    return vZ(K ? "http://" + b : b, b, V, Z.sanitizer);
}
function FZ(q, G, Y, Z, J) {
    if (J === "<") return OZ(q, G, Y, Z, 2);
    if (J === "h" || J === "f" || J === "w") return OZ(q, G, Y, Z, 0);
    if (J === "@") return OZ(q, G, Y, Z, 1);
    return null;
}
function MJ(q) {
    var G = q.trim(), Y = G.replace(/[\s\t\n\r]+/g, " ");
    if (Y.indexOf("\u1E9E") !== -1) return Y.replace(/\u1E9E/g, "ss").toLowerCase();
    return Y.toLowerCase();
}
function DY(q, G, Y) {
    if (G + 3 >= q.length || q[G] !== "[") return null;
    let Z = q[G + 1];
    if (Z !== " " && Z !== "x" && Z !== "X") return null;
    if (q[G + 2] !== "]") return null;
    return {
        type: F.gfmTask,
        completed: Z.toLowerCase() === "x",
        endPos: G + 3
    };
}
function EZ(q, G, Y, Z) {
    let { inline: J, inList: X, inBlockQuote: $ } = G;
    if (Z.inline !== void 0) G.inline = Z.inline;
    if (Z.list !== void 0) G.inList = Z.list;
    if (Z.inBlockQuote !== void 0) G.inBlockQuote = Z.inBlockQuote;
    let K = PZ(q, G, Y);
    return G.inline = J, G.inList = X, G.inBlockQuote = $, K;
}
function fG(q, G, Y, Z, J) {
    return qZ(Z, !0, ()=>r1(q, G, Y, Z, J));
}
function gG(q, G, Y, Z) {
    var J = q[G];
    if (J === void 0) return null;
    var X = G, $ = null, K = J, V = null, z = B(J), j = z === I || z === p;
    if (j) {
        if (V = x(q, G), $ = d(q, G, V), X = G + $.charCount, X >= q.length) return dG(q, G, Y);
        K = q[X];
    }
    var b = $ ? $.spaceEquivalent : 0;
    if (b >= 4) {
        if (j) return dG(q, G, Y);
        return null;
    }
    var U = B(K);
    if (U === B1) {
        var Q = yJ(q, G, Y, Z);
        if (Q) return Q;
    } else if (U === e1) return tG(q, G, Y, Z);
    else if (U === X1 || U === FG || U === cZ) {
        var v = tG(q, G, Y, Z);
        if (v) return v;
        var D = gZ(q, G, Y, Z);
        if (D) return D;
    } else if (U >= JG && U <= YG) {
        var D = gZ(q, G, Y, Z);
        if (D) return D;
    } else if (U === OG) return _Y(q, X, Y, Z);
    else if (U === y1) return _G(q, X, Y, Z, X + 1 < q.length && B(q, X + 1) === t1);
    else if (U === qG && !Z.disableParsingRawHTML) return GZ(q, X, Y, Z);
    else if (U === mq || U === k1) {
        if (!V) V = x(q, G);
        if (!$) $ = d(q, G, V);
        if ($.spaceEquivalent <= 3) return IZ(q, X, Y, Z);
    } else if (U === aZ) return OY(q, G, Y, Z);
    if (j) return dG(q, G, Y);
    return null;
}
function PZ(q, G, Y) {
    let Z = [], J = 0;
    while(J < q.length){
        while(J < q.length && q[J] === `
`)J++;
        if (J >= q.length) break;
        var X = q[J];
        if (G.inList && Z.length > 0) {
            var $ = Z[Z.length - 1];
            if ($?.type === F.paragraph) {
                var K = $, V = B(X);
                if (V === X1 || V === S1 || V === I || V === p) {
                    var z = x(q, J), j = q.slice(J, z), b = d(q, J, z);
                    if (b.spaceEquivalent < 4) {
                        var U = j.slice(b.charCount).trim();
                        if (LJ(Z, U, Y)) {
                            J = z + (z < q.length && q[z] === `
` ? 1 : 0);
                            continue;
                        }
                    }
                }
            }
        }
        var Q = gG(q, J, G, Y);
        if (Q) {
            Z.push(Q), J = Q.endPos;
            continue;
        }
        var v = AJ(q, J, G, Y);
        if (v) {
            Z.push(v), J = v.endPos;
            continue;
        }
        var D = q.slice(J).trim();
        if (D) {
            if (G.inBlockQuote && Z.length > 0) {
                let w = function(T) {
                    if (T.type === F.blockQuote) {
                        var g = T;
                        if (g.children && g.children.length > 0) {
                            var M = g.children[g.children.length - 1];
                            if (M.type === F.paragraph) return M;
                        }
                    } else if (T.type === F.orderedList || T.type === F.unorderedList) {
                        var y = T;
                        if (y.items && y.items.length > 0) {
                            var f = y.items[y.items.length - 1];
                            if (f && f.length > 0) {
                                var W = f[f.length - 1], A = w(W);
                                if (A) return A;
                            }
                        }
                    }
                    return null;
                };
                for(var _ = Z.length - 1; _ >= 0; _--){
                    var K = w(Z[_]);
                    if (K) {
                        var O = LZ(q, J, G, Y);
                        if (O) {
                            var H = O;
                            if (K.children && H.children) K.children.push({
                                type: F.text,
                                text: `
`
                            }, ...H.children);
                            J = O.endPos;
                            continue;
                        }
                    }
                }
            }
            var O = LZ(q, J, G, Y);
            if (O) {
                Z.push(O), J = O.endPos;
                continue;
            }
        }
        J++;
    }
    return Z;
}
function _Y(q, G, Y, Z) {
    if (Y.inline) return null;
    let J = x(q, G), X = d(q, G, J, 3);
    if (X.spaceEquivalent > 3 && !Y.inList) return null;
    var $ = G + X.charCount;
    if ($ >= q.length || q[$] !== "#") return null;
    let K = QG(q, $, "#", 6);
    if ($ += K, $ >= q.length) return null;
    let V = q[$];
    if (V === `
` || V === "\r") {
        let Q = x(q, $);
        return {
            ...sG(K, [], "", Z.slugify),
            endPos: Q + (Q < q.length ? 1 : 0)
        };
    }
    if (V !== " " && V !== "\t") return null;
    let z = $, j = x(q, z);
    var b = q.slice(z, j).replace(sJ, "").trim();
    let U = fG(b, 0, b.length, Y, Z);
    return {
        ...sG(K, U, b, Z.slugify),
        endPos: j + (j < q.length ? 1 : 0)
    };
}
function AJ(q, G, Y, Z) {
    if (Y.inline || Y.inBlockQuote || Y.inList) return null;
    let J = x(q, G);
    if (J >= q.length) return null;
    let X = J + 1, $ = -1, K = null;
    for(var V = 0; X < q.length && V < 10; V++){
        let A = x(q, X);
        if (A >= q.length) break;
        var z = X;
        while(z < A && (B(q, z) === I || B(q, z) === p || B(q, z) === Lq))z++;
        if (z >= A) break;
        var j = 0, b = X;
        while(b < A && j < 3 && B(q, b) === I)j++, b++;
        if (b < A) {
            let N = B(q, b);
            if (N === S1 || N === X1) {
                let L = q[b];
                var U = 0, Q = !1, v = b;
                while(v < A){
                    let P = B(q, v);
                    if (P === N) {
                        if (Q) {
                            U = 0;
                            break;
                        }
                        U++;
                    } else if (P === I || P === p) Q = !0;
                    else {
                        U = 0;
                        break;
                    }
                    v++;
                }
                if (U >= 1) {
                    $ = A, K = L;
                    break;
                }
            }
        }
        X = A + 1;
    }
    if (!K) return null;
    let D = B(q, G);
    if (D === OG || D === B1 || q[G] === "|") return null;
    let _ = G;
    var H = G, O = !1;
    while(H < X){
        let A = x(q, H);
        if (A >= X) break;
        var w = H;
        while(w < A && (B(q, w) === I || B(q, w) === p || B(q, w) === Lq))w++;
        if (w < A) O = !0, _ = A;
        H = A + 1;
    }
    if (!O) return null;
    let T = q.slice(G, _);
    var g = 0, M = T.length;
    while(g < M && (T.charCodeAt(g) === I || T.charCodeAt(g) === p || T.charCodeAt(g) === Lq || T.charCodeAt(g) === Xq))g++;
    while(M > g && (T.charCodeAt(M - 1) === I || T.charCodeAt(M - 1) === p || T.charCodeAt(M - 1) === Lq || T.charCodeAt(M - 1) === Xq))M--;
    let y = T.slice(g, M);
    if (!y) return null;
    let f = K === "=" ? 1 : 2, W = fG(y, 0, y.length, Y, Z);
    return {
        ...sG(f, W, y, Z.slugify),
        endPos: $ + ($ < q.length ? 1 : 0)
    };
}
function LZ(q, G, Y, Z) {
    if (Y.inline) return null;
    let J = G, X = q.length;
    while(J < X){
        let c = x(q, J), t = !0;
        for(let qq = J; qq < c; qq++){
            let e = B(q, qq);
            if (e !== I && e !== p && e !== Lq) {
                t = !1;
                break;
            }
        }
        if (t) {
            J = c;
            break;
        }
        if (c >= X) {
            J = X;
            break;
        }
        let a = c + 1;
        if (a >= X) {
            J = X;
            break;
        }
        let zq = x(q, a), Qq = !0, Bq = "";
        for(let qq = a; qq < zq; qq++){
            let e = B(q, qq);
            if (e !== I && e !== p && e !== Lq) {
                if (Qq = !1, Bq === "") Bq = q[qq];
                break;
            }
        }
        if (Qq) {
            J = c;
            break;
        }
        let r = !1, nq = d(q, a, zq), iq = nq.spaceEquivalent === 4 && nq.charCount === 4;
        if (Bq === "<" && !iq && !Z.disableParsingRawHTML) {
            let e = a, cq = 0;
            while(e < zq && cq < 3){
                let K1 = B(q, e);
                if (K1 === I || K1 === p) cq++, e++;
                else break;
            }
            if (e < zq && q[e] === "<") {
                var $ = GZ(q, e, {
                    ...Y,
                    inline: !1
                }, Z);
                if ($) r = !("canInterruptParagraph" in $) || $.canInterruptParagraph;
            }
        }
        if (iq) r = !1;
        else if (!r && Bq && TG(Bq)) {
            if (Bq === "[") {
                let qq = a;
                if (qq + 1 >= X || q[qq + 1] !== "^") r = !1;
                else r = !0;
            } else if (Bq === "*" || Bq === "+") {
                if (tG(q, a, Y, Z)) r = !0;
                else {
                    let e = a + 1 < X ? q[a + 1] : "";
                    if (e && Tq(e)) r = !0;
                    else r = !1;
                }
            } else {
                let qq = gG(q, a, Y, Z);
                if (qq) {
                    if (qq.type === F.codeBlock) {
                        if (d(q, a, zq).spaceEquivalent >= 4) r = !1;
                        else r = !0;
                    } else if (qq.type === F.unorderedList || qq.type === F.orderedList) {
                        if (qq.type === F.orderedList) r = qq.start === 1;
                        else r = !0;
                    } else if (Bq === "-") {
                        if (J > G) r = !0;
                        else r = !0;
                    } else if (qq.type === F.ref) r = !1;
                    else r = !0;
                }
            }
        }
        if (r) {
            J = c;
            break;
        }
        J = c + 1;
    }
    if (J <= G) return null;
    var K = G, V = J;
    while(K < V){
        let c = B(q, K);
        if (c === I || c === p) K++;
        else break;
    }
    let z = x(q, K);
    var j = V > z, b;
    if (!j) b = q.slice(K, V);
    else {
        var U = [], Q = K, v = 0;
        while(Q < V){
            var D = x(q, Q);
            if (D > V) D = V;
            if (v === 0) U.push(q.slice(Q, D));
            else {
                var _ = 0;
                while(_ < 4 && Q + _ < D)if (B(q, Q + _) === I) _++;
                else break;
                var H = _ === 4 ? Q + 4 : Q;
                U.push(q.slice(H, D));
            }
            if (D < V && B(q, D) === Xq) U.push(`
`), Q = D + 1;
            else Q = V;
            v++;
        }
        b = U.join("");
    }
    var O = b.length;
    while(O > 0){
        var w = b.charCodeAt(O - 1);
        if (w === I || w === p) O--;
        else break;
    }
    if (O < b.length) b = b.slice(0, O);
    let T = !1;
    for(let c = 0; c < b.length; c++){
        let t = b.charCodeAt(c);
        if (t !== I && t !== p && t !== Xq && t !== Lq) {
            T = !0;
            break;
        }
    }
    if (!T) return null;
    var g = b, M = J, y = -1, f = J - 1;
    while(f >= K){
        if (B(q, f) === Xq) {
            y = f;
            break;
        }
        f--;
    }
    if (y >= 0) {
        var W = !1;
        for(var A = K; A < y; A++){
            let c = B(q, A);
            if (c !== I && c !== p && c !== Xq && c !== Lq) {
                W = !0;
                break;
            }
        }
        if (!W) {
            var N = y + 1;
            while(N < q.length){
                let c = B(q, N);
                if (c === I || c === p) N++;
                else break;
            }
            var L = N - (y + 1);
            if (L < 4 && N < q.length && q[N] === "[") {
                var P = {
                    ...Y,
                    inline: !1
                }, E = _G(q, N, P, Z, !1);
                if (E) {
                    var S = 0, f = K;
                    while(f <= y){
                        let t = q.indexOf(`
`, f);
                        if (t === -1 || t > y) break;
                        S++, f = t + 1;
                    }
                    var C = 0, l = 0;
                    f = 0;
                    while(f < b.length){
                        let t = b.indexOf(`
`, f);
                        if (t === -1) break;
                        if (l++, l === S) {
                            C = t + 1;
                            break;
                        }
                        f = t + 1;
                    }
                    if (C > 0) g = b.slice(0, C - 1);
                    M = E.endPos, Y.refs = P.refs;
                }
            }
        }
    }
    let R = fG(g, 0, g.length, Y, Z);
    var Jq = {
        type: F.paragraph,
        children: R,
        endPos: M
    };
    if (R.length > 0) {
        var i = [];
        for(var $q = R.length - 1; $q >= 0; $q--){
            var Mq = R[$q];
            if (Mq.type === F.htmlSelfClosing && Mq.isClosingTag === !0) i.push($q);
            else if (Mq.type === F.text) {
                var Uq = Mq;
                if (Uq.text && Uq.text.trim().length > 0) break;
            } else break;
        }
        if (i.length >= 3) {
            var Hq = i[i.length - 1], m = R.slice(Hq + 1);
            R.splice(Hq + 1), Jq.removedClosingTags = m;
        }
    }
    return Jq;
}
function jY(q, G) {
    if (G !== 0) return null;
    let Y = UZ(q);
    if (!Y?.hasValidYaml) return null;
    return {
        type: F.frontmatter,
        text: q.slice(0, Y.endPos - 1),
        endPos: Y.endPos
    };
}
function tG(q, G, Y, Z) {
    let J = x(q, G), X = d(q, G, J, 3);
    if (X.spaceEquivalent > 3) return null;
    var $ = G + X.charCount;
    if ($ >= J) return null;
    let K = q[$];
    if (K !== "-" && K !== "*" && K !== "_") return null;
    var V = 0, z = $;
    while(z < J){
        var j = q[z];
        if (j === K) V++;
        else if (j !== " " && j !== "\t") return null;
        z++;
    }
    if (V < 3) return null;
    return {
        type: F.breakThematic,
        endPos: u(q, J)
    };
}
function d(q, G, Y, Z) {
    let J = 0, X = 0, $ = G;
    while($ < Y){
        var K = B(q, $);
        if (K !== I && K !== p) break;
        if (Z !== void 0 && J >= Z) break;
        if (K === p) J += 4 - J % 4;
        else J += 1;
        X++, $++;
    }
    return {
        spaceEquivalent: J,
        charCount: X
    };
}
function VJ(q, G, Y, Z) {
    let J = 0, X = 0, $ = Z;
    for(let b = G; b < Y && X < 4; b++){
        var K = B(q, b);
        if (K === p) {
            let U = 4 - $ % 4;
            if (X += U, J++, $ += U, X >= 4) break;
        } else if (K === I) {
            if (X++, J++, $++, X >= 4) break;
        } else break;
    }
    let V = q.slice(G + J, Y);
    var z = 0;
    for(var j = G; j < Y; j++){
        if (q[j] === "\t") z++;
        if (z >= 2) break;
    }
    if (z >= 2 && n(V, "\t") && Z > 0) V = "  " + V.slice(1);
    return V;
}
function dG(q, G, Y) {
    let Z = x(q, G), J = d(q, G, Z);
    if (J.spaceEquivalent < 4) return null;
    let X = J.spaceEquivalent, $ = x(q, G + J.charCount), K = G, V = 0;
    var z = K - 1;
    while(z >= 0 && q[z] !== `
` && q[z] !== "\r")z--;
    z++;
    while(z < K){
        if (q[z] === "\t") V = V + 4 - V % 4;
        else V++;
        z++;
    }
    let j = VJ(q, K, $, V), b = u(q, $);
    if (b >= q.length) {
        if (!j.trim()) return null;
        return {
            type: F.codeBlock,
            text: j,
            endPos: b
        };
    }
    var U = [];
    U.push(j);
    let Q = b;
    while(Q < q.length){
        let D = x(q, Q);
        if (z1(q, Q, D)) {
            let _ = D + 1;
            if (_ < q.length) {
                let H = x(q, _), O = d(q, _, H), w = q[_ + O.charCount];
                if (w && w !== `
` && (O.spaceEquivalent < 4 || w === ">" && O.spaceEquivalent < X)) break;
            }
            U.push(`
`);
        } else {
            if (d(q, Q, D).spaceEquivalent < 4) break;
            let H = VJ(q, Q, D, 0);
            U.push(`
`), U.push(H);
        }
        Q = u(q, D);
    }
    let v = U.join("");
    if (v = v.replace(qY, ""), !v.trim()) return null;
    return {
        type: F.codeBlock,
        text: v,
        endPos: Q
    };
}
function IZ(q, G, Y, Z) {
    let J = q[G];
    if (J !== "`" && J !== "~") return null;
    let X = QG(q, G, J);
    if (X < 3) return null;
    let $ = G;
    while($ > 0 && B(q, $ - 1) !== Xq)$--;
    let K = d(q, $, G), V = K.spaceEquivalent, z = V;
    if (V === 4 && K.charCount === 4) V = 0, z = 4;
    if (V >= 4) return null;
    let j = yq(q, G + X), b = x(q, j), U = q.slice(j, b).trim();
    if (J === "`" && U.indexOf("`") !== -1) return null;
    U = U.replace(MZ, "$1");
    let Q = U.indexOf(" "), v = Q > 0 ? U.slice(0, Q) : U, D = Q > 0 ? U.slice(Q + 1).trim() : "", _ = D && /=\s*["']/.test(D) ? i1(D, "code", "code", Z) : void 0, H = u(q, b), O = H;
    while(O < q.length){
        let M = x(q, O), y = O, f = 0;
        while(y < M){
            let W = B(q, y);
            if (W === I) {
                if (f++, y++, f >= 4) break;
            } else if (W === p) {
                if (f += 4 - f % 4, y++, f >= 4) break;
            } else break;
        }
        if (f < 4) {
            let W = QG(q, y, J, M - y);
            if (W >= X) {
                let A = y + W;
                while(A < M){
                    let N = B(q, A);
                    if (N === I || N === p) A++;
                    else break;
                }
                if (A === M) break;
            }
        } else if (z === 4 && V === 0 && f === 4) {
            let W = QG(q, y, J, M - y);
            if (W >= X && z1(q, y + W, M)) break;
        }
        O = u(q, M);
    }
    let w = O > H && q[O - 1] === `
` ? O - 1 : O, T = q.slice(H, w);
    if (z) T = TZ(T, z);
    let g = O < q.length ? u(q, x(q, O)) : O;
    return {
        type: F.codeBlock,
        text: T,
        lang: v,
        attrs: _,
        endPos: g
    };
}
function HY(q, G, Y) {
    for(var Z = 0; Z < q.length; Z++)if (!BZ(q[Z])) {
        let X = EZ(q, G, Y, {
            inline: !1,
            inBlockQuote: !0
        });
        for(var J = 0; J < X.length; J++){
            let $ = X[J];
            if ("endPos" in $) delete $.endPos;
        }
        return X;
    }
    return [];
}
function yJ(q, G, Y, Z) {
    if (Y.inline) return null;
    let J = G;
    while(J < q.length && (q[J] === " " || q[J] === "\t"))J++;
    if (J >= q.length || q[J] !== ">") return null;
    let X = G;
    var $ = [], K = void 0, V = !1, z = -1, j = !1, b = null, U = null, Q = 0, v = !1;
    while(X < q.length){
        let M = x(q, X), y = X;
        while(y < M && (q[y] === " " || q[y] === "\t"))y++;
        if (y < M && q[y] === ">") {
            let f = y + 1;
            if (f < M && q[f] === " ") f++;
            let A = d(q, f, M).spaceEquivalent >= 4, N = !1, L = null, P = 0;
            if (f < M) {
                let S = q[f];
                if (S === "`" || S === "~") {
                    let C = 0, l = f;
                    while(l < M && q[l] === S && C < 20)C++, l++;
                    if (C >= 3) N = !0, L = S, P = C;
                }
            }
            if (j && b === "fenced" && L === U && P >= Q) j = !1, b = null, U = null, Q = 0;
            else if (A || N) j = !0, b = A ? "indented" : "fenced", U = L, Q = P;
            var D = !A && !N;
            if (D) {
                for(var _ = f; _ < M; _++)if (!BZ(q[_])) {
                    D = !1;
                    break;
                }
            }
            if (v = D, z === -1 && !D) z = $.length;
            if (!D) V = !0;
            let E = y + 1;
            if (E < M && q[E] === "\t") {
                $.push("  ");
                let S = 4;
                for(let C = E + 1; C < M; C++){
                    let l = q[C];
                    var H = B(l);
                    if (H === p) {
                        let R = 4 - S % 4;
                        if (R === 1) $.push(" ");
                        else if (R === 2) $.push("  ");
                        else if (R === 3) $.push("   ");
                        else $.push(" ".repeat(R));
                        S += R;
                    } else $.push(l), S++;
                }
                if (M < q.length) $.push(`
`);
            } else {
                let S = E;
                if (S < M && q[S] === " ") S++;
                if ($.push(q.slice(S, M)), M < q.length) $.push(`
`);
            }
        } else {
            var O = !0;
            for(var _ = X; _ < M; _++)if (!BZ(q[_])) {
                O = !1;
                break;
            }
            if (O || j) break;
            if (d(q, X, M).spaceEquivalent === 0) {
                let W = gG(q, X, Y, Z);
                if (W && W.type !== F.ref && W.type !== F.codeBlock) break;
                if (v) break;
            }
            if ($.push(q.slice(X, M)), M < q.length) $.push(`
`);
        }
        X = u(q, M);
    }
    if (X === G) return null;
    if ($.length > 0 && $[$.length - 1] === `
`) $.pop();
    let w = $.join("");
    if (w.length >= 4 && w.charCodeAt(0) === y1 && w.charCodeAt(1) === wG) {
        let M = w.indexOf(`]
`, 2);
        if (M > 2) K = w.slice(2, M), w = w.slice(M + 2);
    }
    let T = HY(w, Y, Z), g = {
        type: F.blockQuote,
        children: T,
        endPos: X
    };
    if (K) g.alert = K;
    return g;
}
function TZ(q, G) {
    return q.split(`
`).map(function(Y) {
        if (Y.length === 0) return Y;
        let Z = G, J = 0, X = 0, $ = 0;
        while(X < Y.length && J < Z)if (Y[X] === " ") J++, $++, X++;
        else if (Y[X] === "\t") {
            let K = 4 - $ % 4;
            if (J + K <= Z) J += K, $ += K, X++;
            else {
                let V = Z - J, z = Math.max(0, K - V);
                return " ".repeat(z) + Y.slice(X + 1);
            }
        } else break;
        return Y.slice(X);
    }).join(`
`);
}
function iG(q, G, Y, Z, J = !0) {
    let X = (J ? `
` : "") + q, $ = fG(X, 0, X.length, Y, Z);
    if (G.length > 0 && G[G.length - 1].type === F.paragraph) G[G.length - 1].children.push(...$);
    else G.push(...$);
}
function NG(q) {
    return q.some(function(G) {
        return G.type === F.codeBlock || G.type === F.paragraph || G.type === F.blockQuote || G.type === F.orderedList || G.type === F.unorderedList || G.type === F.heading;
    });
}
function XJ(q) {
    return !!q.match(xZ);
}
function BJ(q) {
    if (q.length === 0) return q;
    var G = q[q.length - 1];
    if ((G.type === F.orderedList || G.type === F.unorderedList) && G.items?.length > 0) return BJ(G.items.slice(-1)[0]);
    return q;
}
function fZ(q, G, Y, Z, J, X, $) {
    if (!n(J, "[")) return null;
    var K = {
        inline: !1,
        list: !1,
        refs: X.refs || {}
    }, V = _G(q, G + Z.charCount, K, $, !1);
    return V ? V.endPos : null;
}
function zJ(q, G, Y, Z) {
    if (q.length !== 1 || !Y) return !1;
    if (q[0].length !== 0) return !1;
    if (G) return !0;
    if (!G && Z.trim() === "") return !0;
    return !1;
}
function KJ(q, G) {
    var Y = q.index || 0;
    return G ? Y + q[1].length + q[2].length + 1 : Y + q[1].length + 1;
}
function eG(q, G, Y, Z, J) {
    var X = 0, $ = Z + J, K = G;
    while(K < Y && X < 4){
        var V = B(q, K);
        if (V === I) X++, $++;
        else if (V === p) {
            var z = 4 - $ % 4;
            if (X + z > 4) break;
            X += z, $ += z;
        } else break;
        K++;
    }
    return {
        contentStartColumn: $,
        contentStartPos: K
    };
}
function bZ(q) {
    var G = q.match(xZ);
    if (!G) return null;
    if (G[1]) return {
        match: [
            q,
            G[1],
            G[2],
            G[3]
        ],
        ordered: !0,
        listItemRegex: AZ
    };
    if (G[4]) return {
        match: [
            q,
            G[4],
            G[5],
            ""
        ],
        ordered: !0,
        listItemRegex: AZ
    };
    if (G[6]) return {
        match: [
            q,
            G[6],
            G[7]
        ],
        ordered: !1,
        listItemRegex: yZ
    };
    if (G[8]) return {
        match: [
            q,
            G[8],
            ""
        ],
        ordered: !1,
        listItemRegex: yZ
    };
    return null;
}
function m1(q, G, Y, Z, J, X, $) {
    if (G.spaceEquivalent !== X) return !1;
    var K = q.match($);
    if (K) return Y ? K[2] === J : K[1] === Z;
    var V = q.match(xZ);
    if (!V) return !1;
    if (Y) return V[4] && V[5] === J;
    else return V[8] === Z;
}
function NJ(q, G, Y, Z) {
    var J = G, X = Y, $ = G[0];
    while(X < q.length){
        var K = x(q, X), V = q.slice(X, K), z = n(V, " ".repeat(Z)) ? V.slice(Z) : V;
        if (n(z.trim(), $) && QG(z.trim(), 0, $) >= 3) return {
            content: J,
            endPos: u(q, K)
        };
        J += `
` + z, X = u(q, K);
    }
    return {
        content: J,
        endPos: X
    };
}
function uG(q, G, Y, Z, J, X, $, K, V, z, j, b, U) {
    var Q = z ? void 0 : V[1], v = z ? V[2] : void 0, D = z ? AZ : yZ, _ = j;
    if (!j) {
        var H = u(q, X), O = H;
        while(O < q.length){
            var w = x(q, O), T = q.slice(O, w), g = d(q, O, w), M = g.spaceEquivalent;
            if (z1(q, O, w)) {
                var y = u(q, w);
                if (y < q.length) {
                    var f = x(q, y), W = d(q, y, f), A = W.spaceEquivalent, P = KJ(V, z), E = J + K + P, S = eG(q, E, X, $, P), C = S.contentStartColumn;
                    if (A + 1 > C) {
                        _ = !0;
                        break;
                    }
                }
                break;
            } else if (M <= $) {
                var N = T.slice(g.charCount), L = N.match(D);
                if (L && (z ? L[2] === v : L[1] === Q)) break;
            }
            O = u(q, w);
        }
    }
    var P = KJ(V, z), E = J + K + P, S = eG(q, E, X, $, P), C = S.contentStartColumn, l = Z, R = u(q, X);
    if (n(Z, "```") || n(Z, "~~~")) {
        var Jq = z ? V[1].length + V[2].length + 1 : V[1].length + 1, i = NJ(q, Z, R, Jq);
        l = i.content, R = i.endPos;
    }
    return G.push(RJ(l, _, b, U)), Y.push(C), {
        newCurrentPos: R,
        itemHasBlankLine: _
    };
}
function UJ(q, G, Y, Z, J, X) {
    if (J > Z || X.disableParsingRawHTML) return !1;
    let $ = G + Y;
    if ($ >= q.length || q[$] !== "<") return !1;
    return vY(q, $);
}
function vY(q, G) {
    if (G >= q.length || q[G] !== "<") return !1;
    let Y = q.length, Z = G + 1;
    if (Z < Y && q[Z] === "/") Z++;
    if (Z >= Y) return !1;
    let J = B(q, Z);
    if (!a1(J)) return !1;
    Z++;
    while(Z < Y){
        let $ = q[Z], K = B(q, Z);
        if ($ === ">" || $ === " " || $ === "\t" || $ === `
` || $ === "\r" || $ === "/") break;
        if ($ === "-" || $ === "_" || a1(K) || K >= 48 && K <= 57) Z++;
        else return !1;
    }
    let X = 0;
    while(Z < Y){
        let $ = q[Z], K = B(q, Z);
        if (X === 1) {
            if ($ === '"') X = 0;
            Z++;
        } else if (X === 2) {
            if ($ === "'") X = 0;
            Z++;
        } else if ($ === '"') X = 1, Z++;
        else if ($ === "'") X = 2, Z++;
        else if ($ === ">") return !0;
        else if ($ === "/" && Z + 1 < Y && q[Z + 1] === ">") return !0;
        else if (K === 10 || K === 13) return !1;
        else Z++;
    }
    return !1;
}
function QJ(q, G, Y, Z, J, X, $, K, V, z, j, b) {
    let U = Z, Q = !1;
    while(U < q.length){
        let v = x(q, U), D = d(q, U, v), _ = D.spaceEquivalent;
        if (z1(q, U, v)) {
            Q = !0, U = u(q, v);
            continue;
        }
        let H = q.slice(U + D.charCount, v);
        if (_ <= J && m1(H, D, X, $, K, J, V)) break;
        if (_ >= Y) {
            if (b && Q) {
                let w = fZ(q, U, v, D, H, z, j);
                if (w) {
                    U = w, Q = !1;
                    continue;
                }
            }
            let O = cG(q, U, v, D, Y - 1, Y, G, Q, z, j, void 0, J);
            if (O.processed) {
                U = O.newPos, Q = O.wasBlank;
                continue;
            }
        } else break;
    }
    return U;
}
function DJ(q, G, Y, Z) {
    let J = EZ(q, Y, Z, {
        inline: !1,
        list: !0
    });
    if (J.length > 0) return !G && J.length === 1 && J[0].type === F.paragraph ? J[0].children : J;
    let X = qZ(Y, !0, ()=>r1(q, 0, q.length, Y, Z));
    return G && X.length > 0 ? [
        {
            type: F.paragraph,
            children: X
        }
    ] : X;
}
function RJ(q, G, Y, Z) {
    let J = DY(q, 0, Y);
    if (!(J && (J.endPos >= q.length || q[J.endPos] === " "))) return DJ(q, G, Y, Z);
    let $ = J.endPos < q.length ? J.endPos + 1 : J.endPos, K = q.slice($), V = DJ(K, G, Y, Z), z = [
        J
    ];
    if (J.endPos < q.length) z.push({
        type: F.text,
        text: " "
    });
    return z.push(...V), z;
}
function _J(q, G) {
    if (!q[0]) return !1;
    let Y = q[0].indexOf(G);
    if (Y === -1) return !1;
    let Z = Y + G.length;
    if (Z >= q[0].length) return !1;
    let J = q[0][Z];
    return J ? B(J) === dZ : !1;
}
function LJ(q, G, Y) {
    if (q.length === 0) return !1;
    let Z = q[q.length - 1], J = G.trim();
    if (!n(J, "=") && !n(J, "-") || J.length < 1 || !/^[=-]+[ \t]*$/.test(J)) return !1;
    let X = [], $ = "";
    if (Z.type === F.paragraph) {
        let z = Z;
        X = z.children, $ = z.children.map((j)=>j.type === F.text ? j.text : "").join("").trim();
    } else if (Z.type === F.text) {
        let z = [], j = q.length - 1;
        while(j >= 0 && q[j].type === F.text)z.unshift(q[j]), j--;
        if (z.length > 0) X = z, $ = z.map((b)=>b.text).join("").trim();
    }
    if (!$) return !1;
    let V = J[0] === "=" ? 1 : 2;
    if (Z.type === F.paragraph) q.pop();
    else if (Z.type === F.text) while(q.length > 0 && q[q.length - 1].type === F.text)q.pop();
    return q.push(sG(V, X, $, Y.slugify)), !0;
}
function cG(q, G, Y, Z, J, X, $, K, V, z, j, b) {
    let U = Z.spaceEquivalent, Q = q.slice(G + Z.charCount, Y);
    if (U >= J + 4) {
        let H = dG(q, G, V);
        if (H) {
            let O = H, w = TZ(O.text || "", X);
            return $.push({
                ...O,
                text: w
            }), {
                processed: !0,
                newPos: O.endPos,
                wasBlank: !1
            };
        }
    }
    let v = U - (X - 1);
    if (U + 1 >= X && v <= 3) {
        let H = G + Z.charCount;
        if (H < Y) {
            let O = q[H];
            if (O === "`" || O === "~") {
                let w = IZ(q, H, V, z);
                if (w) {
                    let T = w, g = TZ(T.text || "", X - 1);
                    return $.push({
                        ...T,
                        text: g,
                        endPos: T.endPos
                    }), {
                        processed: !0,
                        newPos: T.endPos,
                        wasBlank: !1
                    };
                }
            }
        }
    }
    if (Q.length > 0 && (Q[0] === "-" || Q[0] === "*" || Q[0] === "+" || Q[0] >= "0" && Q[0] <= "9")) {
        if (/^([-*+]|\d{1,9}[.)])\s+/.test(Q)) {
            let O = fG(Q, 0, Q.length, V, z);
            return $.push({
                type: F.text,
                text: `
`
            }, ...O), {
                processed: !0,
                newPos: u(q, Y),
                wasBlank: !1
            };
        }
    }
    let D = rJ(q, G, $, Q, V, z);
    if (D !== null) return {
        processed: !0,
        newPos: D,
        wasBlank: !1
    };
    let _ = EZ(Q, V, z, {
        inline: !1,
        list: !0
    });
    if (_.length > 0) {
        if (j && _[0].type === F.paragraph) {
            let H = _[0];
            if ($.push({
                type: F.text,
                text: `
`
            }, ...H.children), _.length > 1) $.push(..._.slice(1));
        } else if (!K && _[0].type === F.paragraph && $.length > 0) {
            let H = $[$.length - 1], O = _[0];
            if (H.type === F.paragraph) H.children.push({
                type: F.text,
                text: `
`
            }, ...O.children);
            else if (H.type === F.heading) $.push(...O.children);
            else if (!NG($)) $.push({
                type: F.text,
                text: " "
            }, ...O.children);
            else $.push(..._);
            if (_.length > 1) $.push(..._.slice(1));
        } else $.push(..._);
        return {
            processed: !0,
            newPos: u(q, Y),
            wasBlank: !1
        };
    }
    if (K) {
        let H = qZ(V, !0, ()=>r1(Q, 0, Q.length, V, z));
        $.push({
            type: F.paragraph,
            children: H
        });
    } else iG(Q, $, V, z);
    return {
        processed: !0,
        newPos: u(q, Y),
        wasBlank: !1
    };
}
function gZ(q, G, Y, Z) {
    if (Y.inline) return null;
    var J = Y.inList;
    if (Y.inList = !0, G > 0) {
        var X = B(q, G - 1);
        if (X !== Xq && X !== Lq) return Y.inList = J, null;
    }
    var $ = x(q, G), K = d(q, G, $);
    if (K.spaceEquivalent > 3 && !Y.inList) return Y.inList = J, null;
    var V = q.slice(G, $), z = K.charCount, j = V.slice(z), b = bZ(j);
    if (!b) return Y.inList = J, null;
    var { match: U, ordered: Q, listItemRegex: v } = b, D = K.spaceEquivalent, _ = Q ? parseInt(U[1], 10) : void 0, H = Q ? U[2] : void 0, O = Q ? void 0 : U[1], w = Q ? U[3] === "" : U[2] === "";
    function T(k, Oq) {
        if (k === 0) return !0;
        var Fq = B(q, k - 1);
        if (Fq !== Xq) return !1;
        if (!Oq) return !0;
        var Zq = k - 2;
        while(Zq >= 0){
            var h = B(q, Zq);
            if (h !== I && h !== p) break;
            Zq--;
        }
        return Zq < 0 || B(q, Zq) === Xq;
    }
    if (w && !T(G, !0)) return Y.inList = J, null;
    if (Q && _ !== 1 && !T(G, !1)) return null;
    if (!Q && _J(U, O)) return null;
    var g = U.index || 0, M = Q ? g + U[1].length + U[2].length + 1 : w ? g + U[1].length : g + U[1].length + 1, y = G + z + M, f = eG(q, y, $, D, M), W = f.contentStartColumn, A = D + g + U[1].length, N = Q ? A + U[2].length + 1 : w ? A : A + 1, L = [], P = [];
    function E(k, Oq, Fq) {
        return Fq ? k >= Oq : k > Oq;
    }
    function S() {
        return L[L.length - 1];
    }
    function C() {
        return P[P.length - 1] ?? W;
    }
    function l(k, Oq) {
        let Fq = BJ(Oq), Zq = Y.inList;
        Y.inList = !0;
        let h = gZ(q, k, Y, Z);
        if (Y.inList = Zq, h) return Fq.push(h), h;
        return null;
    }
    var R = u(q, $), Jq = R, i = !1;
    while(Jq < q.length){
        var $q = x(q, Jq), Mq = q.slice(Jq, $q);
        if (Mq.trim() === "") {
            var Uq = u(q, $q);
            while(Uq < q.length){
                var Hq = B(q, Uq);
                if (Hq === Xq) ;
                else if (!XY.has(q[Uq])) break;
                Uq++;
            }
            var m = x(q, Uq), c = q.slice(Uq, m), t = d(q, Uq, m), a = c.slice(t.charCount);
            if (m1(a, t, Q, O, H, D, v)) i = !0;
            else {
                var zq = fZ(q, Uq, m, t, a, Y, Z);
                if (zq) {
                    var Qq = zq;
                    while(Qq < q.length && B(q, Qq) === Xq)Qq++;
                    if (Qq < q.length) {
                        var Bq = x(q, Qq), r = q.slice(Qq, Bq), nq = d(q, Qq, Bq), iq = r.slice(nq.charCount);
                        if (m1(iq, nq, Q, O, H, D, v)) i = !0;
                    }
                }
            }
            break;
        }
        var qq = d(q, Jq, $q), e = Mq.slice(qq.charCount), cq = bZ(e);
        if (!cq) break;
        var K1 = cq.match;
        if (Q) {
            if (K1[2] !== H) break;
        } else if (K1[1] !== O) break;
        Jq = u(q, $q);
    }
    var Vq = Q ? U[3] : U[2];
    Vq = Vq.trimStart();
    var G1 = G + z + (U.index || 0), Nq = Q ? G1 + U[1].length + U[2].length : G1 + U[1].length, kq = Nq;
    while(kq < q.length){
        var Hq = B(q, kq);
        if (Hq !== I && Hq !== p) break;
        kq++;
    }
    var jq = 0, aq = Nq;
    while(aq < $){
        var Hq = B(q, aq);
        if (Hq === p) jq += 4 - jq % 4;
        else if (Hq === I) jq++;
        else break;
        aq++;
    }
    var N1 = !1;
    if (Nq < q.length && B(q, Nq) === p) {
        var Z1 = 1, U1 = Nq + 1;
        while(U1 < q.length && B(q, U1) === p)Z1++, U1++;
        if (Z1 >= 2) Vq = "      " + Vq, N1 = !0;
    }
    if (!Q) w = w && jq === 0;
    if (jq >= 4 && !N1) Vq = " ".repeat(jq - 1) + Vq.trimStart();
    var H1 = Vq.trim() === "";
    let tq = i;
    if (!i && R < q.length) {
        var hq = R;
        while(hq < q.length){
            var Q1 = x(q, hq), bq = q.slice(hq, Q1);
            if (z1(q, hq, Q1)) {
                var rq = u(q, Q1);
                while(rq < q.length){
                    var v1 = x(q, rq);
                    if (z1(q, rq, v1)) rq = u(q, v1);
                    else break;
                }
                if (rq < q.length) {
                    var O1 = d(q, rq, q.length), gq = O1.spaceEquivalent;
                    if (gq >= D) {
                        var Dq = q.slice(rq, x(q, rq)), xq = Dq.slice(O1.charCount).match(v), eq = xq && (Q ? xq[2] === H : xq[1] === O), R1 = null;
                        for(var Kq = R; Kq < hq; Kq = x(q, Kq) + 1){
                            var J1 = x(q, Kq), D1 = d(q, Kq, J1), Sq = q.slice(Kq, J1).slice(D1.charCount).match(v), jG = Sq && D1.spaceEquivalent > D && D1.spaceEquivalent >= W && (Q ? Sq[2] === H : Sq[1] === O);
                            if (jG) {
                                var _1 = D1.spaceEquivalent + 1, F1 = Q ? _1 + Sq[1].length + Sq[2].length + 1 : _1 + Sq[1].length + 1, s1 = Kq + D1.charCount + Sq[0].length, o1 = eG(q, s1, J1, _1, F1 - _1);
                                R1 = o1.contentStartColumn;
                                break;
                            }
                        }
                        var HG = jq >= 5 ? N : W;
                        if (!eq && gq >= HG && (R1 === null || gq + 1 < R1)) tq = !0;
                    }
                }
                break;
            }
            var Eq = d(q, hq, Q1), pq = Eq.spaceEquivalent, sq = bq.slice(Eq.charCount), b1 = sq.match(v), wq = b1 && (Q ? b1[2] === H : b1[1] === O);
            if (wq) {
                if (pq <= D) break;
            }
            hq = u(q, Q1);
        }
    }
    var Y1 = Vq;
    if (n(Vq, "```") || n(Vq, "~~~")) {
        var w1 = Q ? U[1].length + U[2].length + 1 : U[1].length + 1, W1 = NJ(q, Vq, R, w1);
        Y1 = W1.content, R = W1.endPos;
    }
    var n1 = !w && Vq.trim() === "" && jq > 0 && jq < 5;
    if (n1 && !tq) {
        var G = R;
        while(G < q.length){
            var $ = x(q, G), V = q.slice(G, $);
            if (V.trim() === "") break;
            var K = d(q, G, $);
            if (K.spaceEquivalent < N) break;
            var j = V.slice(K.charCount);
            if (K.spaceEquivalent <= D && m1(j, K, Q, O, H, D, v)) break;
            Y1 += `
` + j, R = G = u(q, $);
        }
    }
    if (L.push(RJ(Y1, tq, Y, Z)), P.push(W), tq && (jq >= 5 || n1)) {
        let k = S();
        R = QJ(q, k, N, R, D, Q, O, H, v, Y, Z, !0);
    } else if (!tq) {
        let k = N - 1;
        while(R < q.length){
            let Oq = x(q, R), Fq = q.slice(R, Oq), Zq = d(q, R, Oq), h = Zq.spaceEquivalent, _q = Fq.slice(Zq.charCount);
            if (Fq.trim() === "" || h <= D && m1(_q, Zq, Q, O, H, D, v) || XJ(_q) && h > D || h < k) break;
            let A1 = S(), Pq = cG(q, R, Oq, Zq, k, W, A1, !1, Y, Z, !0, D);
            if (Pq.processed) R = Pq.newPos;
            else break;
        }
    }
    var Gq = !1;
    while(R < q.length){
        let k = x(q, R), Oq = q.slice(R, k), Fq = d(q, R, k), Zq = Fq.charCount, h = Fq.spaceEquivalent;
        if (Oq.trim() === "") i = !0, Gq = !0, R = u(q, k);
        else if (h < D) {
            let _q = Oq.slice(Zq);
            if (_q.startsWith("<") && UJ(q, R, Zq, D, h, Z)) break;
            let A1 = _q.trim();
            if (A1.length > 0 && L.length > 0 && !TG(A1[0]) && !m1(_q, Fq, Q, O, H, D, v)) {
                let Pq = S();
                if (Pq.length > 0) {
                    let Yq = Pq[Pq.length - 1];
                    if (Yq.type === F.paragraph || Yq.type === F.text) {
                        iG(_q, Pq, Y, Z), Gq = !1, R = u(q, k);
                        continue;
                    }
                }
            }
            break;
        } else {
            let _q = Oq.slice(Zq);
            if (L.length > 0) {
                let s = P[L.length - 1] || W;
                if (h + 1 >= s && !m1(_q, Fq, Q, O, H, D, v)) {
                    let Aq = S();
                    if (Aq.length > 0 && LJ(Aq, _q, Z)) {
                        R = u(q, k);
                        continue;
                    }
                }
            }
            if (tG(q, R, Y, Z)) break;
            if (Gq) {
                let s = fZ(q, R, k, Fq, _q, Y, Z);
                if (s) {
                    R = s, Gq = !1;
                    continue;
                }
            }
            if (h <= D) {
                if (_q.startsWith("<") && UJ(q, R, Zq, D, h, Z)) break;
                if (!m1(_q, Fq, Q, O, H, D, v)) {
                    if (h === D && !Gq) {
                        let s = _q.trim();
                        if (s.length > 0 && !TG(s[0])) {
                            let Aq = gG(q, R, Y, Z);
                            if (Aq && Aq.type !== F.paragraph) break;
                            let vq = S();
                            if (vq.length > 0 && !NG(vq)) {
                                iG(_q, vq, Y, Z, !1), Gq = !1, R = u(q, k);
                                continue;
                            }
                        }
                    }
                    break;
                }
            }
            if (zJ(L, w, Gq, Vq)) break;
            let Pq = bZ(_q), Yq = Pq ? Pq.match : null, f1 = Yq && (Q ? Yq[2] === H : Yq[1] === O);
            if (f1 && h > 3 && Gq) break;
            if (f1 && h <= D + 3) {
                if (h >= 4 && Gq) break;
                if (h === D) {
                    let s = Q ? Yq[3] : Yq[2];
                    if (s = s.trimStart(), R = uG(q, L, P, s, R, k, h, Zq, Yq, Q, i, Y, Z).newCurrentPos, Gq = !1, s.trim() === "") {
                        let vq = L[L.length - 1], Rq = C();
                        R = QJ(q, vq, Rq, R, D, Q, O, H, v, Y, Z);
                    }
                    continue;
                }
                if (h > D) {
                    if (Gq) {
                        let Rq = Q ? Yq[3] : Yq[2];
                        Rq = Rq.trimStart(), R = uG(q, L, P, Rq, R, k, h, Zq, Yq, Q, i, Y, Z).newCurrentPos, Gq = !1;
                        continue;
                    }
                    let s = S(), Aq = h + 1, vq = E(Aq, C(), NG(s));
                    if (vq) {
                        let Rq = l(R, s);
                        if (Rq) {
                            R = Rq.endPos, Gq = !1;
                            continue;
                        }
                    }
                    if (!vq && f1) {
                        let Rq = Q ? Yq[3] : Yq[2];
                        if (Rq = Rq.trimStart(), !i) {
                            let Iq = u(q, k);
                            while(Iq < q.length){
                                let V1 = x(q, Iq), q1 = q.slice(Iq, V1), uq = d(q, Iq, V1), g1 = uq.spaceEquivalent;
                                if (q1.trim() === "") {
                                    let vG = u(q, V1);
                                    if (vG < q.length) {
                                        let EG = d(q, vG, q.length).spaceEquivalent, x1 = h + (Q ? Yq[1].length + Yq[2].length + 1 : Yq[1].length + 1);
                                        if (EG + 1 > x1) break;
                                    }
                                    break;
                                } else if (g1 <= D) {
                                    let C1 = q1.slice(uq.charCount).match(v);
                                    if (C1 && (Q ? C1[2] === H : C1[1] === O) && g1 <= D) break;
                                }
                                Iq = u(q, V1);
                            }
                        }
                        R = uG(q, L, P, Rq, R, k, h, Zq, Yq, Q, i, Y, Z).newCurrentPos, Gq = !1;
                        continue;
                    } else if (!vq && !f1) break;
                    {
                        let Rq = S(), o = Rq.length === 0;
                        if (o && zJ(L, w, Gq, Vq)) break;
                        let Iq = Rq.some((uq)=>uq.type === F.codeBlock || uq.type === F.paragraph || uq.type === F.blockQuote || uq.type === F.orderedList || uq.type === F.unorderedList || uq.type === F.heading), V1 = o && L.length === 1 ? N : W;
                        if (Iq ? h >= V1 : h > V1) {
                            let uq = cG(q, R, k, Fq, V1, W, S(), Gq, Y, Z, void 0, D);
                            if (uq.processed) {
                                Gq = uq.wasBlank, R = uq.newPos;
                                continue;
                            }
                        } else break;
                    }
                } else if (h === D) {
                    if (!Q && Yq && _J(Yq, Yq[1])) break;
                    let s = Q ? Yq[3] : Yq[2];
                    s = s.trimStart(), R = uG(q, L, P, s, R, k, D, Zq, Yq, Q, i, Y, Z).newCurrentPos, Gq = !1;
                }
            } else if (h > D) {
                let s = S();
                if (XJ(_q)) {
                    let o = h + 1;
                    if (E(o, C(), NG(s))) {
                        let q1 = l(R, s);
                        if (q1) {
                            R = q1.endPos, Gq = !1;
                            continue;
                        }
                    }
                    if (h - D > 3) {
                        let q1 = s.length > 0 ? s[s.length - 1] : null;
                        if (q1 && (q1.type === F.paragraph || q1.type === F.text)) {
                            iG(_q, s, Y, Z), Gq = !1, R = u(q, k);
                            continue;
                        }
                    } else break;
                } else {
                    let o = l(R, s);
                    if (o) {
                        R = o.endPos, Gq = !1;
                        continue;
                    }
                }
                let vq = W;
                if (NG(s) ? h >= vq - 1 : h > vq - 1) {
                    let o = cG(q, R, k, Fq, vq - 1, W, S(), Gq, Y, Z, void 0, D);
                    if (o.processed) {
                        Gq = o.wasBlank, R = o.newPos;
                        continue;
                    }
                } else break;
            } else break;
        }
    }
    if (i && L.length > 1 && L[0].length > 0 && L[0][0].type !== F.paragraph) {
        for(var L1 = 1; L1 < L.length; L1++)if (L[L1].length > 0 && L[L1][0].type === F.paragraph) {
            var M1 = !1;
            for(var T1 = 0; T1 < L[0].length; T1++){
                var lq = L[0][T1].type;
                if (lq === F.codeBlock || lq === F.heading || lq === F.blockQuote || lq === F.orderedList || lq === F.unorderedList || lq === F.htmlBlock || lq === F.breakThematic) {
                    M1 = !0;
                    break;
                }
            }
            if (!M1) L[0] = [
                {
                    type: F.paragraph,
                    children: L[0]
                }
            ];
            break;
        }
    }
    let $1 = Q ? {
        type: F.orderedList,
        items: L,
        ordered: !0,
        start: _
    } : {
        type: F.unorderedList,
        items: L,
        ordered: !1
    };
    return Y.inList = J, {
        ...$1,
        endPos: R
    };
}
function OY(q, G, Y, Z) {
    if (Y.inline) return null;
    let J = [], X = G;
    while(X < q.length){
        let v = x(q, X);
        if (z1(q, X, v)) break;
        let D = q.slice(X, v).trim();
        if (!(D.indexOf("|") !== -1 || J.length >= 3 && D && !TG(D[0]))) break;
        J.push(D), X = u(q, v);
    }
    if (J.length < 2) return null;
    let $ = (v)=>v[0] === "|" && v[v.length - 1] === "|" ? v.slice(1, -1) : v, K = (v)=>{
        let D = [], _ = "", H = !1;
        for(let O = 0; O < v.length; O++){
            let w = v[O];
            if (w === "\\" && O + 1 < v.length && v[O + 1] === "|") _ += "|", O++;
            else if (w === "`") H = !H, _ += w;
            else if (w === "|" && !H) D.push(_.trim()), _ = "";
            else _ += w;
        }
        return D.push(_.trim()), D;
    }, V = K($(J[0]));
    if (!V.length) return null;
    let z = K($(J[1]));
    if (z.length !== V.length || z.some((v)=>!/^:?-+:?$/.test(v))) return null;
    let j = z.map((v)=>{
        let D = v[0] === ":", _ = v[v.length - 1] === ":";
        return D && _ ? "center" : D ? "left" : _ ? "right" : null;
    }), b = (v)=>qZ(Y, !0, ()=>v.map((D)=>r1(D, 0, D.length, Y, Z))), U = b(V), Q = J.slice(2).map((v)=>{
        let D = v.indexOf("|") !== -1 ? K($(v)) : [
            v.trim()
        ], _ = V.length;
        while(D.length < _)D.push("");
        return D.length = _, b(D);
    });
    return {
        type: F.table,
        header: U,
        cells: Q,
        align: j,
        endPos: X
    };
}
var FY = [
    "div",
    "p",
    "section",
    "article",
    "aside",
    "nav",
    "header",
    "footer",
    "main",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "blockquote",
    "ul",
    "ol",
    "li",
    "dl",
    "dt",
    "dd",
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr",
    "td",
    "th",
    "form",
    "fieldset",
    "hr",
    "pre",
    "details",
    "summary",
    "figure",
    "figcaption"
], bY = new Set([
    "pre",
    "script",
    "style",
    "textarea"
]);
function RG(q) {
    return FY.indexOf(q.toLowerCase()) !== -1;
}
function DG(q) {
    return bY.has(q);
}
function z1(q, G, Y) {
    for(var Z = G; Z < Y; Z++){
        let J = B(q, Z);
        if (J !== I && J !== p && J !== Lq) return !1;
    }
    return !0;
}
function qZ(q, G, Y) {
    let Z = q.inline;
    q.inline = G;
    try {
        return Y();
    } finally{
        q.inline = Z;
    }
}
function wZ(q, G, Y) {
    var Z = G;
    while(Z < Y){
        var J = x(q, Z);
        if (z1(q, Z, J)) return Z;
        Z = J + (J < Y ? 1 : 0);
    }
    return Y;
}
function WZ(q, G, Y) {
    return {
        type: F.htmlComment,
        text: q,
        endPos: G,
        ...Y
    };
}
function UG(q, G, Y, Z, J, X, $, K) {
    var V = G;
    if (K && K.forceBlock && G && !X) {
        var z = new RegExp("^<" + q.toLowerCase() + "(\\s[^>]*)?>$", "i");
        if (z.test(G.trim())) V = "";
    }
    return {
        type: F.htmlBlock,
        tag: q,
        attrs: Z || {},
        rawAttrs: J,
        children: [],
        text: V,
        noInnerParse: !0,
        isClosingTag: X,
        canInterruptParagraph: $,
        endPos: Y
    };
}
function LG(q) {
    let G = FJ.test(q), Y = OJ.test(q), Z = eJ.test(q);
    return G || Y && !Z;
}
function jJ(q, G, Y, Z, J, X, $, K, V, z) {
    if (!K.inHTML && !K.inline && !CG(J, `
`)) {
        let m = X, c = $.length;
        while(m < c){
            let t = x($, m);
            if (z1($, m, t)) break;
            let a = $.slice(m, t).trim();
            if (a.length > 0 && TG(a[0])) {
                let zq = GZ($, m, K, z);
                if (zq) {
                    m = zq.endPos;
                    continue;
                }
                let Qq = c1($, m);
                if (Qq) {
                    m = Qq.endPos;
                    continue;
                }
                return null;
            }
            m = u($, t);
        }
    }
    let j = G, b = DG(j);
    var U = !b && !KG(G), Q = void 0;
    if (J) {
        var v = J.indexOf(">");
        if (v !== -1) {
            var D = J.slice(0, v + 1);
            if (D.indexOf(`
`) !== -1) Q = D;
            var _ = v;
            for(var H = 1; H < v; H++){
                var O = D[H];
                if (O === " " || O === "\t" || O === `
` || O === ">") {
                    _ = H;
                    break;
                }
            }
            Y = D.slice(_, v);
        }
    }
    var w = Y.replace(/^[\s\n\r\t]+/, ""), T = i1(w, G, q, z), g = {
        ...T
    }, M = !1, y = !1;
    if (U && Z.length > 0) {
        var f = "</" + j, W = Z.indexOf(f);
        if (W >= 0) {
            var A = W + f.length;
            while(A < Z.length && (Z[A] === " " || Z[A] === "\t"))A++;
            if (A < Z.length && Z[A] === ">") {
                var N = Z.slice(0, W);
                if (LG(N)) Z = N, y = !0;
                else M = !0;
            }
        }
        if (!y) {
            var L = Z.length - 1;
            if (Z[L] === `
`) {
                L--;
                while(L >= 0 && (Z[L] === " " || Z[L] === "\t" || Z[L] === "\r"))L--;
                if (L >= 0 && Z[L] === `
`) M = !0;
            }
        }
    }
    var P = b || U && M && !LG(Z);
    if (P) {
        if (Z.length > 0 && Z[0] === `
`) Z = Z.slice(1);
        if (Z.length > 0 && Z[Z.length - 1] === `
`) Z = Z.slice(0, -1);
    }
    let E = Z.match(/^([ \t]*)/), S = E ? E[1] : "", C = new RegExp(`^${S.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}`, "gm"), l = Z.replace(C, ""), R = OJ.test(l), Jq = FJ.test(l), i = j === "p", $q = HJ.test(l), Mq = i ? R : R || Jq || K.inHTML && $q, Uq = [];
    if (!P && l) {
        if (Mq || $q) {
            let m = {
                ...K,
                inline: !1,
                inHTML: !0,
                inAnchor: K.inAnchor || j === "a"
            };
            Uq = PZ(l, m, z);
        } else {
            let m = {
                ...K,
                inline: !0,
                inAnchor: V || K.inAnchor || j === "a"
            };
            Uq = r1(l, 0, l.length, m, z);
        }
    }
    var Hq = void 0;
    if (P) {
        if (Q !== void 0) Hq = Q + Z;
        else Hq = Z;
    }
    return {
        type: F.htmlBlock,
        tag: P ? G : q,
        attrs: g,
        rawAttrs: Y,
        children: Uq,
        text: Hq,
        noInnerParse: P,
        canInterruptParagraph: !0,
        endPos: X
    };
}
function GZ(q, G, Y, Z) {
    if (q[G] !== "<") return null;
    Y.inline;
    if (G + 1 < q.length) {
        if (q[G + 1] === "?") {
            var J = aG(q, G);
            if (J && J.kind === "pi") return WZ(J.text || "", J.endPos, {
                raw: !0
            });
        } else if (q[G + 1] === "!") {
            if (G + 3 < q.length && q.slice(G, G + 4) === "<!--") {
                Y.inline;
                var X = aG(q, G);
                if (X && X.kind === "comment") {
                    var $ = X.text || "", K = !1;
                    if ($ === "<!-->") $ = "", K = !0;
                    else if ($ === "<!--->") $ = "-", K = !0;
                    else if ($.startsWith("<!--") && $.endsWith("-->")) $ = $.slice(4, -3);
                    Y.inline;
                    return WZ($, X.endPos, {
                        endsWithGreaterThan: K
                    });
                }
            }
            var V = aG(q, G);
            if (V && (V.kind === "declaration" || V.kind === "cdata")) return WZ(V.text || "", V.endPos, {
                raw: !0
            });
        }
    }
    if (G + 1 < q.length) {
        let x1 = q[G + 1];
        if (x1 === " " || x1 === `
` || x1 === "\t" || x1 === "\r") return null;
    }
    var z = q.indexOf(">", G + 1);
    if (z !== -1) {
        var j = q.slice(G + 1, z), b = j.indexOf(" ") !== -1 || j.indexOf("\t") !== -1;
        if (!b && (n(j, "http://") || n(j, "https://"))) return null;
        if (!b && WJ(j)) return null;
    }
    var U = c1(q, G);
    if (!U && !Y.inline) {
        var Q = q.length, v = x(q, G), D = G, _ = 0;
        while(D < v && _ < 3 && (q[D] === " " || q[D] === "\t"))_++, D++;
        if (D >= v || q[D] !== "<") return null;
        if (D + 1 < v) {
            var Aq = NZ(q, D + 1);
            if (Aq) {
                var vq = Aq.tagName, H = RG(vq);
                if (!H) return null;
                var O = Aq.nextPos, w = !1, T = !1, g = "", M = v, y = !1;
                while(M < Q && !y){
                    var f = !1;
                    while(O < M){
                        var W = q[O];
                        if (T) {
                            if (W === g) T = !1, g = "";
                            if (W === `
` || W === "\r") w = !0;
                            O++, f = !0;
                        } else if (W === '"' || W === "'") T = !0, g = W, O++, f = !0;
                        else if (W === `
` || W === "\r") {
                            w = !0, O++, f = !0;
                            var A = x(q, O);
                            if (A === O) break;
                            M = A;
                        } else if (W === ">") {
                            O++, y = !0;
                            break;
                        } else O++, f = !0;
                    }
                    if (y) break;
                    if (!f && O >= M) {
                        var N = x(q, M + 1);
                        if (N <= M) break;
                        M = N;
                    } else if (O >= M && M < Q) {
                        var N = x(q, M + 1);
                        if (N <= M) break;
                        M = N;
                    } else break;
                }
                if (!w && y) return null;
                if (O >= v && v < Q) O = v;
                var L = H ? "type6" : "type7", P = O, E = wZ(q, v + 1, Q), S = q.slice(P, E), C = G + 1 < q.length && q[G + 1] === "/";
                if (L === "type7" && S.trim() === "") {
                    var l = q.slice(G, E), R = x(l, 0);
                    if (R < l.length) R++;
                    var Jq = l.slice(0, R);
                    return UG(vq, Jq, E, {}, void 0, C, !1, Z);
                }
                var i = q.slice(G, E);
                return UG(vq, i, E, {}, void 0, C, L === "type6", Z);
            }
        }
        return null;
    }
    if (!U) return null;
    if (z !== -1) {
        var $q = q.slice(G + 1, z);
        if ((n($q, "http://") || n($q, "https://")) && ($q.indexOf(" ") !== -1 || $q.indexOf("\t") !== -1)) return null;
    }
    var a = G + (U.isClosing ? 2 : 1);
    if (a < q.length) {
        var Mq = q[a], Uq = B(Mq);
        if (Uq >= 97 && Uq <= 122 || Uq >= 65 && Uq <= 90) {
            if (a + 1 < q.length && q[a + 1] === ":") return null;
        }
    }
    if (U.isClosing) {
        var Hq = U.attrs.trim();
        if (Hq.length > 0) return null;
        if (!Y.inline) {
            var Q = q.length, v = x(q, G), P = U.endPos, m = P;
            while(m < v && (q[m] === " " || q[m] === "\t" || q[m] === "\r"))m++;
            var c = m >= v || q[m] === "<" && function() {
                var pZ = c1(q, m);
                return pZ && RG(pZ.tagLower);
            }();
            if (c) {
                var E = wZ(q, v + 1, Q), S = q.slice(P, E);
                if (S.length > 0 && S[0] === `
`) S = S.slice(1);
                let SJ = U.tagLower || U.tagName.toLowerCase();
                return UG(U.tagName, S, E, i1(U.whitespaceBeforeAttrs + U.attrs, SJ, U.tagName, Z), U.whitespaceBeforeAttrs + U.attrs, !0, !1);
            }
        }
        var t = q.slice(G, U.endPos);
        return {
            type: F.htmlSelfClosing,
            tag: U.tagName,
            attrs: {},
            endPos: U.endPos,
            isClosingTag: !0,
            rawText: t
        };
    }
    var a = G + (U.isClosing ? 2 : 1);
    if (a < q.length) {
        var zq = q[a];
        if (zq === " " || zq === "\t" || zq === `
` || zq === "\r") return null;
    }
    var Qq = U.tagLower, Bq = KG(U.tagName);
    let r = U.tagName.length > 0 && U.tagName[0] >= "A" && U.tagName[0] <= "Z";
    if (U.isSelfClosing || Bq && Qq !== "a") {
        if (U.hasNewline && !r) return null;
        if (!Y.inHTML && !Y.inline && !r) return null;
        var nq = U.attrs.replace(/\/\s*$/, ""), iq = i1(nq, Qq, U.tagName, Z), t = Y.inline ? q.slice(G, U.endPos) : void 0;
        let hZ = {
            type: F.htmlSelfClosing,
            tag: U.tagName,
            attrs: iq,
            endPos: U.endPos
        };
        if (t !== void 0) hZ.rawText = t;
        return hZ;
    }
    if (Y.inline) {
        var qq = U.attrs.replace(/\/\s*$/, ""), e = U.whitespaceBeforeAttrs + qq, cq = i1(qq, Qq, U.tagName, Z), K1 = {
            ...cq
        }, Vq = U.endPos, G1 = [];
        if (!KG(U.tagName)) {
            var Nq = nJ(q, U.endPos, Qq);
            if (Nq !== null) {
                var kq = q.slice(U.endPos, Nq[0]);
                if (kq) {
                    if (Y.inHTML && HJ.test(kq) || LG(kq)) G1 = PZ(kq, {
                        ...Y,
                        inline: !1,
                        inHTML: !0,
                        inAnchor: Y.inAnchor || Qq === "a"
                    }, Z);
                    else G1 = r1(kq, 0, kq.length, {
                        ...Y,
                        inline: !0,
                        inAnchor: Y.inAnchor || Qq === "a"
                    }, Z);
                }
                Vq = Nq[1];
            }
        }
        return {
            type: F.htmlBlock,
            tag: U.tagName,
            attrs: K1,
            rawAttrs: e,
            children: G1,
            noInnerParse: !1,
            endPos: Vq
        };
    }
    if (!Y.inline) {
        var Q = q.length, v = x(q, G), jq = U.tagLower, aq = DG(jq), N1 = !aq && RG(U.tagName), Z1 = !1, U1 = G;
        while(U1 < U.endPos){
            if (q[U1] === ">") {
                Z1 = !0;
                break;
            }
            U1++;
        }
        var m = U.endPos;
        while(m < v && (q[m] === " " || q[m] === "\t"))m++;
        var H1 = m >= v || q[m] === `
` || q[m] === "\r" || N1 && m < v || !Z1;
        if (aq && Z1 && !U.isClosing) {
            var { tagName: tq, endPos: hq, attrs: Q1 } = U, bq = hq;
            if (q[bq] === `
`) bq++;
            var rq = bq, v1 = bq, O1 = 1, gq = jq.length + 1;
            while(O1 > 0){
                var Dq = q.indexOf("<", bq);
                if (Dq === -1) {
                    v1 = Q, bq = Q;
                    break;
                }
                var xq = -1, eq = -1;
                if (q[Dq + 1] === "/") eq = Dq;
                else if (Dq + gq + 1 <= Q && (q[Dq + 1] === jq[0] || q[Dq + 1] === tq[0])) {
                    var R1 = q.substring(Dq + 1, Dq + gq);
                    if (R1.toLowerCase() === jq && (q[Dq + gq] === " " || q[Dq + gq] === ">")) xq = Dq;
                }
                if (xq === -1 && eq === -1) {
                    bq = Dq + 1;
                    continue;
                }
                if (xq !== -1 && (eq === -1 || xq < eq)) bq = xq + gq + 1, O1++;
                else {
                    var Kq = eq + 2;
                    while(Kq < Q){
                        var J1 = q[Kq];
                        if (J1 !== " " && J1 !== "\t" && J1 !== `
` && J1 !== "\r") break;
                        Kq++;
                    }
                    if (Kq + jq.length > Q) break;
                    var D1 = q.substring(Kq, Kq + jq.length);
                    if (D1.toLowerCase() !== jq) {
                        bq = Kq;
                        continue;
                    }
                    Kq += jq.length;
                    while(Kq < Q){
                        var Sq = q[Kq];
                        if (Sq !== " " && Sq !== "\t" && Sq !== `
` && Sq !== "\r") break;
                        Kq++;
                    }
                    if (Kq >= Q || q[Kq] !== ">") {
                        bq = Kq;
                        continue;
                    }
                    var jG = Kq + 1, _1 = x(q, jG);
                    v1 = _1, bq = _1 + 1, O1--;
                }
            }
            var F1 = 0;
            while(bq + F1 < Q && q[bq + F1] === `
`)F1++;
            var s1 = q.slice(G, bq + F1), o1 = q.slice(rq, v1), HG = bq + F1;
            return jJ(U.tagName, U.tagName, Q1, o1, s1, HG, q, Y, !1, Z);
        }
        if (H1 || !Z1) {
            var L = N1 ? "type6" : "type7", P = U.endPos, E = wZ(q, v + 1, Q);
            if (L === "type6" && !U.isClosing) {
                var Eq = "</" + (U.tagLower || U.tagName.toLowerCase()), pq = q.indexOf(Eq, P);
                if (pq !== -1) {
                    var sq = pq + Eq.length;
                    while(sq < Q && (q[sq] === " " || q[sq] === "\t"))sq++;
                    if (sq < Q && q[sq] === ">") {
                        var b1 = q.slice(P, pq), wq = LG(b1);
                        if (wq) {
                            var Y1 = x(q, sq + 1);
                            E = Y1;
                        }
                    }
                }
            }
            var S = q.slice(P, E), w1 = U.whitespaceBeforeAttrs + U.attrs, C = U.isClosing;
            if (L === "type7" && S.trim() === "") {
                var W1 = q.slice(G, U.endPos), n1 = W1.indexOf(`
`) !== -1;
                if (n1) return null;
                var SG = U.endPos, R = x(q, SG);
                if (R < q.length) R++;
                var Jq = q.slice(G, R);
                return UG(U.tagName, Jq, E, {}, void 0, C, !1, Z);
            }
            var Gq = U.hasNewline, L1 = !Z1;
            if ((Gq || L1) && L === "type7") {
                var M1 = U.endPos, T1 = q.slice(G, M1), lq = S, i = T1 + lq;
                return UG(U.tagName, i, E, {}, void 0, C, !1, Z);
            }
            let lZ = U.tagLower || U.tagName.toLowerCase();
            var $1 = i1(w1, lZ, U.tagName, Z), k = {
                ...$1
            };
            if (L === "type6") {
                var Oq = S, Fq = S.indexOf("</" + lZ);
                if (Fq >= 0) {
                    var m = Fq + 2 + U.tagName.length;
                    while(m < S.length && (S[m] === " " || S[m] === "\t"))m++;
                    if (m < S.length && S[m] === ">") Oq = S.slice(0, Fq);
                }
                if (LG(Oq)) return jJ(U.tagName, U.tagName, w1, Oq, q.slice(G, U.endPos), E, q, Y, !1, Z);
            }
            var Zq = S;
            if (Zq.length > 0 && Zq[0] === `
`) Zq = Zq.slice(1);
            var h = Zq.split(`
`), _q = 1 / 0;
            for(var A1 = 0; A1 < h.length; A1++){
                var Pq = h[A1];
                if (Pq.trim().length === 0) continue;
                var _ = 0;
                while(_ < Pq.length && (Pq[_] === " " || Pq[_] === "\t"))_++;
                if (_ < _q) _q = _;
            }
            if (_q > 0 && _q < 1 / 0) {
                var Yq = [];
                for(var f1 = 0; f1 < h.length; f1++){
                    var s = h[f1];
                    if (s.trim().length === 0) Yq.push(s);
                    else Yq.push(s.slice(_q));
                }
                Zq = Yq.join(`
`);
            }
            return UG(U.tagName, Zq, E, k, w1, C, L === "type6" ? !0 : !1, Z);
        }
    }
    if (Y.inline) return null;
    var Aq = NZ(q, G + 1);
    if (!Aq) return null;
    var vq = Aq.tagName;
    if (!KG(vq)) return null;
    let Rq = Aq.tagLower;
    var o = Aq.nextPos, Iq = q.length;
    while(o < Iq && Tq(q[o]))o++;
    var V1 = o;
    while(o < Iq && q[o] !== ">")o++;
    if (o >= Iq) return null;
    let q1 = q.slice(V1, o).trim(), g1 = o + 1;
    while(g1 < Iq && Tq(q[g1]))g1++;
    let vG = "</" + Rq + ">", C1 = q.toLowerCase().indexOf(vG, g1);
    if (C1 !== -1) {
        if (q.slice(g1, C1).trim()) return null;
    }
    o++;
    let EG = o;
    while(o < Iq && Tq(q[o]))o++;
    if (o < Iq && q[o] === `
`) o++;
    let kZ = i1(q1, vq, vq, Z);
    return {
        type: F.htmlSelfClosing,
        tag: vq,
        attrs: kZ,
        endPos: EG
    };
}
function wY(q, G) {
    if (q[G] !== "<") return null;
    var Y = q.length, Z = !1, J = G + 1;
    if (G + 1 < Y && q[G + 1] === "/") Z = !0, J = G + 2;
    var X = NZ(q, J);
    if (!X) return null;
    var { tagName: $, tagLower: K, nextPos: V } = X;
    if (V < Y) {
        var z = q[V];
        if (z === ">" || z === "/") {
            var j = z === ">" ? V + 1 : V + 2;
            if (z === "/" && (V + 1 >= Y || q[V + 1] !== ">")) return null;
            var b = z === "/", U = RG($), Q = !DG(K) && !U;
            return {
                kind: "tag",
                tagNameLower: K,
                tagName: $,
                isClosing: Z,
                isSelfClosing: b,
                hasNewline: !1,
                type6Candidate: U,
                type7Candidate: Q,
                endPos: j,
                attrs: "",
                whitespaceBeforeAttrs: ""
            };
        }
    }
    var v = V, D = !1;
    while(V < Y){
        var _ = q[V], H = B(q, V);
        if (_ === " " || _ === "\t") ;
        else if (H === 10 || H === 13) D = !0;
        else break;
        V++;
    }
    var O = q.slice(v, V), w = V, T = !1, g = "", M = 0, y = !1, f = !1, W = 0;
    while(w < Y){
        var A = q[w], H = B(q, w);
        if (W === 1) {
            if (A === '"') {
                if (w + 1 < Y && q[w + 1] === '"') return null;
                W = 0;
            }
            w++;
        } else if (W === 2) {
            if (A === "'") W = 0;
            w++;
        } else if (A === '"') W = 1, w++;
        else if (A === "'") W = 2, w++;
        else if (A === "{" || A === "}" && M > 0) M += A === "{" ? 1 : -1, w++;
        else if (A === ">" && M === 0) {
            if (w > V) {
                var N = w - 1;
                while(N >= V){
                    var L = q[N];
                    if (L !== " " && L !== "\t") break;
                    N--;
                }
                if (N >= V && q[N] === "/") y = !0, f = N < w - 1;
            }
            w++;
            break;
        } else {
            if (A === "*" || A === "#" || A === "!") {
                var P = w + 1;
                while(P < Y){
                    var E = q[P];
                    if (E === "=" || E === " " || E === "\t" || E === `
` || E === "\r" || E === ">") break;
                    P++;
                }
                if (P < Y && q[P] === "=") return null;
            }
            if (H === 10 || H === 13) D = !0;
            w++;
        }
    }
    if (w > Y || q[w - 1] !== ">") return null;
    if (W === 1 || W === 2) return null;
    if (M > 0) return null;
    if (f) return null;
    var S = w - 1;
    if (y) S--;
    var C = q.slice(V, S), l = y, R = -1, Jq = !1, i = "", $q = !1;
    for(var Mq = 0; Mq < C.length; Mq++){
        var _ = C[Mq];
        if (Jq) {
            if (_ === i) Jq = !1, R = Mq, i = "", $q = !1;
        } else if (_ === '"' || _ === "'") Jq = !0, i = _, $q = !1;
        else if (_ === "=") $q = !0;
        else if (R !== -1 && Mq === R + 1) {
            var H = _.charCodeAt(0);
            if (a1(H)) return null;
        } else if ($q && !Jq && (_ === "*" || _ === "#" || _ === "!")) return null;
        else if (Tq(_)) $q = !1;
    }
    var Uq = RG($), Hq = !DG(K) && !Uq;
    return {
        kind: "tag",
        tagNameLower: K,
        tagName: $,
        isClosing: Z,
        isSelfClosing: l,
        hasNewline: D,
        type6Candidate: Uq,
        type7Candidate: Hq,
        endPos: w,
        attrs: C,
        whitespaceBeforeAttrs: O
    };
}
function aG(q, G) {
    if (G >= q.length || q[G] !== "<") return null;
    var Y = q.length;
    if (G + 1 >= Y) return null;
    var Z = q[G + 1];
    if (Z === "!") {
        if (G + 4 <= Y && q.slice(G, G + 4) === "<!--") {
            var J = G + 4;
            if (J < Y && q[J] === ">") return {
                kind: "comment",
                hasNewline: !1,
                endPos: J + 1,
                text: q.slice(G, J + 1),
                raw: !0
            };
            if (J + 1 < Y && q[J] === "-" && q[J + 1] === ">") return {
                kind: "comment",
                hasNewline: !1,
                endPos: J + 2,
                text: q.slice(G, J + 2),
                raw: !0
            };
            while(J + 2 < Y){
                if (q.slice(J, J + 3) === "-->") return {
                    kind: "comment",
                    hasNewline: !1,
                    endPos: J + 3,
                    text: q.slice(G, J + 3),
                    raw: !0
                };
                J++;
            }
            return null;
        }
        if (G + 9 <= Y && q.slice(G, G + 9) === "<![CDATA[") {
            var J = G + 9;
            while(J + 2 < Y){
                if (q.slice(J, J + 3) === "]]>") return {
                    kind: "cdata",
                    hasNewline: !1,
                    endPos: J + 3,
                    text: q.slice(G, J + 3),
                    raw: !0
                };
                J++;
            }
            return null;
        }
        if (G + 2 < Y && a1(q.charCodeAt(G + 2))) {
            var J = G + 2;
            while(J < Y && q[J] !== ">")J++;
            if (J >= Y) return null;
            return {
                kind: "declaration",
                hasNewline: !1,
                endPos: J + 1,
                text: q.slice(G, J + 1),
                raw: !0
            };
        }
        return null;
    }
    if (Z === "?") {
        var J = G + 2;
        while(J + 1 < Y){
            if (q.slice(J, J + 2) === "?>") return {
                kind: "pi",
                hasNewline: !1,
                endPos: J + 2,
                text: q.slice(G, J + 2),
                raw: !0
            };
            J++;
        }
        return null;
    }
    return wY(q, G);
}
function WY(q, G, Y) {
    let Z = q.length, J = G, X = J < Z && q[J] === "<";
    if (X) J++;
    let $ = J, K = $;
    if ($ >= Z) {
        if (!X) return null;
        K = $;
    } else if (Y > 0 && $ < Z && q[$] === `
`) return null;
    else while(K < Z){
        if (X && q[K] === ">") break;
        if (q[K] === `
`) {
            let W = K + 1;
            if (W >= Z) break;
            if (W < Z && q[W] === `
`) break;
            let A = W;
            while(A < Z && (q[A] === " " || q[A] === "\t"))A++;
            if (A < Z && (q[A] === '"' || q[A] === "'" || q[A] === "(")) break;
            if (A < Z && q[A] === "[") break;
            if (A < Z) {
                let N = q[A];
                if (N === "=" || N === "-" || N === "_" || N === "*" || N === "#" || N === ">" || N === "`" || N === "~" || N === "[" || N >= "0" && N <= "9") break;
                if (N >= "a" && N <= "z") {
                    let L = A + 1;
                    while(L < Z && L < A + 32 && (q[L] >= "a" && q[L] <= "z" || q[L] >= "A" && q[L] <= "Z" || q[L] >= "0" && q[L] <= "9" || q[L] === "+" || q[L] === "." || q[L] === "-"))L++;
                    if (L < Z && q[L] === ":") ;
                    else break;
                }
            }
            K = A;
            continue;
        }
        if (!X && (q[K] === " " || q[K] === "\t")) {
            let W = K + 1;
            while(W < Z && (q[W] === " " || q[W] === "\t"))W++;
            if (W < Z && (q[W] === '"' || q[W] === "'" || q[W] === "(")) break;
            if (W < Z && q[W] === `
`) {
                let A = W + 1;
                if (A < Z && q[A] === `
`) break;
                let N = A;
                while(N < Z && (q[N] === " " || q[N] === "\t"))N++;
                if (N < Z && (q[N] === '"' || q[N] === "'" || q[N] === "(")) break;
            }
        }
        K++;
    }
    if (X && (K >= Z || q[K] !== ">")) return null;
    let V = q.slice($, K), z = [], j = 0;
    for(let W = 0; W <= V.length; W++)if (W === V.length || V[W] === `
`) {
        let A = V.slice(j, W);
        if (A = A.trim(), A.length > 0 || z.length === 0) {
            if (z.push(A), W < V.length) z.push(`
`);
        } else if (W < V.length) z.push(`
`);
        j = W + 1;
    }
    V = z.join(""), V = V.trim(), J = X ? K + 1 : K;
    var b = !1;
    if (J < Z && q[J] === `
`) {
        var U = J + 1, Q = U;
        while(Q < Z && (q[Q] === " " || q[Q] === "\t"))Q++;
        if (Q < Z) {
            let W = q[Q];
            if (W === "[" || W === "=" || W === "-" || W === "_" || W === "*" || W === "#" || W === ">" || W === "`" || W === "~" || W >= "0" && W <= "9") b = !0;
            if (!b && W !== "=" && W !== "-") {
                var v = x(q, Q);
                if (v < Z) {
                    var D = v + 1, _ = D;
                    while(_ < Z && (q[_] === " " || q[_] === "\t"))_++;
                    if (_ < Z) {
                        var H = q[_];
                        if (H === "=" || H === "-") b = !0;
                    }
                }
            }
        }
    }
    if (!b && J < Z && (q[J] === '"' || q[J] === "'" || q[J] === "(")) return null;
    let O = 0;
    while(J < Z && !b){
        let W = q[J];
        if (W === `
`) {
            if (O++, O > 1) break;
            J++;
            var w = J;
            if (J = yq(q, J), J < Z && d1(q[J]) && q[J] !== `
`) {
                J = w - 1;
                break;
            }
            if (J < Z) {
                let A = q[J];
                if (A === "[" || A === "=" || A === "-" || A === "_" || A === "*" || A === "#" || A === ">" || A === "`" || A === "~" || A >= "0" && A <= "9") {
                    b = !0, J = w - 1;
                    break;
                }
            }
        } else if (W === " " || W === "\t") J++;
        else if (d1(W)) break;
        else break;
    }
    let T = void 0, g = J;
    if (J < Z) {
        let W = q[J];
        if (W === '"' || W === "'") {
            J++;
            let A = J, N = !1, L = !1;
            while(J < Z && q[J] !== W)if (q[J] === `
`) {
                if (L) {
                    N = !0;
                    break;
                }
                L = !0, J++;
            } else {
                if (L = !1, q[J] === "\\" && J + 1 < Z) J++;
                J++;
            }
            if (N) return null;
            if (J < Z && q[J] === W) {
                T = q.slice(A, J), g = J + 1, J = g;
                var M = J;
                while(M < Z && (q[M] === " " || q[M] === "\t"))M++;
                if (M < Z && q[M] !== `
` && q[M] !== "\r") return null;
                J = M;
            }
        } else if (W === "(") {
            J++;
            let A = J, N = 1, L = !1, P = !1;
            while(J < Z && N > 0)if (q[J] === `
`) {
                if (P) {
                    L = !0;
                    break;
                }
                P = !0, J++;
            } else {
                if (P = !1, q[J] === "\\" && J + 1 < Z) J++;
                else if (q[J] === "(") N++;
                else if (q[J] === ")") N--;
                J++;
            }
            if (L) return null;
            if (N === 0) T = q.slice(A, J - 1), g = J, J = g;
        }
    }
    if (J = yq(q, J), J < Z && q[J] !== `
`) {
        var y = J;
        while(y < Z && q[y] !== `
`){
            if (q[y] !== " " && q[y] !== "\t") return null;
            y++;
        }
    }
    if (T === void 0 && J < Z && q[J] !== `
`) {
        var f = J;
        while(f < Z && q[f] !== `
`){
            if (q[f] !== " " && q[f] !== "\t") return null;
            f++;
        }
    }
    return {
        endPos: J < Z && q[J] === `
` ? J + 1 : J,
        target: V,
        title: T
    };
}
function MY(q, G) {
    let Y = G, Z = Y, J = !1;
    while(Z < q.length){
        let v = Z === 0 || q[Z - 1] === `
`;
        if (Z + 1 < q.length && q[Z] === `
` && q[Z + 1] === `
` && Z > Y) {
            let D = Z + 2;
            while(D < q.length && (q[D] === " " || q[D] === "\t"))D++;
            if (D < q.length && q[D] !== `
` && D - (Z + 2) < 4) {
                J = !0;
                break;
            }
        }
        if (v && n(q, "[^", Z)) {
            let D = Z + 2;
            while(D < q.length && q[D] !== "]")D++;
            if (D < q.length && q[D] === "]" && D + 1 < q.length && q[D + 1] === ":") break;
        }
        Z++;
    }
    let X = Z, $ = G;
    var K = [];
    let V = $, z = 0, j = !1;
    while(V < X){
        let v = V;
        while(v < X && q[v] !== `
`)v++;
        if (z === 0) {
            let D = v;
            while(D > V && (q[D - 1] === " " || q[D - 1] === "\t"))D--;
            let _ = q.slice(V, D);
            K.push(_), j = _.length === 0;
        } else {
            let D = 0, _ = V;
            while(_ < v && _ < V + 4 && q[_] === " ")D++, _++;
            let H = !1;
            for(let w = V; w < v; w++)if (q[w] !== " " && q[w] !== "\t" && q[w] !== "\r") {
                H = !0;
                break;
            }
            let O = !H;
            if (D >= 4 && j) K.push(q.slice(V, v));
            else if (D === 4 && !j) K.push(q.slice(V + 4, v));
            else K.push(q.slice(V, v));
            j = O;
        }
        if (v < X && q[v] === `
`) K.push(`
`), V = v + 1;
        else V = X;
        z++;
    }
    let b = K.join("");
    if (J) b = b.replace(/\n$/, "");
    var U = b.length;
    while(U > 0){
        var Q = b[U - 1];
        if (Q === `
` || Q === " ") U--;
        else break;
    }
    if (U < b.length) b = b.slice(0, U);
    return {
        endPos: Z,
        target: b,
        title: void 0
    };
}
function _G(q, G, Y, Z, J) {
    if (q[G] !== "[") return null;
    var X = G + 1 < q.length && q[G + 1] === "^";
    if (J ? !X : X) return null;
    var $ = G;
    while($ > 0 && q[$ - 1] !== `
`)$--;
    if (d(q, $, G).spaceEquivalent >= 4 || Y.inline) return null;
    var K = G + (J ? 2 : 1), V = q.length, z = ZY(q, K, V, "]");
    if (z === -1) return null;
    var j = q.slice(K, z);
    if (j.length > 999) return null;
    var b = !1, U = !1, Q = !1;
    for(var v = 0; v < j.length; v++){
        var D = j[v];
        if (D === "\\" && v + 1 < j.length) {
            v++;
            continue;
        }
        var _ = B(D);
        if (_ === y1 || _ === GG) U = !0;
        else if (_ === Xq || _ === Lq) Q = !0;
        else if (_ !== I && _ !== p) b = !0;
    }
    if (!b || U) return null;
    var H = z + 1;
    if (Q) {
        var O = B(q, K), w = B(q, z - 1);
        if (O === Xq || O === Lq || w === Xq || w === Lq || H >= V || q[H] !== ":") return null;
    } else if (H >= V || q[H] !== ":") {
        if (H = yq(q, H), H < V && B(q, H) === Xq) H = yq(q, H + 1);
        if (H >= V || q[H] !== ":") return null;
    }
    H++;
    var T = 0;
    while(H < V){
        var g = B(q, H);
        if (g === Xq) {
            if (++T > 1) break;
            H = yq(q, H + 1);
        } else if (g === I || g === p) H++;
        else break;
    }
    let M = J ? MY(q, H) : WY(q, H, T);
    if (!M) return null;
    let y = MJ(j), f = Y.refs || {}, W = J ? `^${y}` : y;
    if (!f[W]) f[W] = {
        target: rG(M.target.trim()),
        title: M.title ? rG(M.title) : void 0
    }, Y.refs = f;
    return {
        type: J ? F.footnote : F.ref,
        endPos: M.endPos
    };
}
function TJ(q, G, Y) {
    var Z = [], J = Y === null ? 0 : Y + 1;
    while(J < G.length){
        var X = G[J];
        if (!X || X.type !== "*" && X.type !== "_" && X.type !== "~" && X.type !== "=") {
            J++;
            continue;
        }
        if (!X.canClose || !X.active) {
            J++;
            continue;
        }
        var $ = X.type === "*" ? 0 : X.type === "_" ? 1 : X.type === "~" ? 2 : 3, K = $ * 6 + X.length % 3 * 2 + (X.canOpen ? 1 : 0), V = Z[K] !== void 0 ? Z[K] : Y === null ? -1 : Y, z = -1, j = X.type, b = X.inAnchor, U = X.canOpen, Q = X.length, v = Q % 3;
        for(var D = J - 1; D > V; D--){
            var _ = G[D];
            if (!_ || !_.active || _.type !== j || !_.canOpen || _.inAnchor !== b) continue;
            var H = _.length;
            if (!U && !_.canClose || v === 0 || (H + Q) % 3 !== 0) {
                z = D;
                break;
            }
        }
        if (z >= 0) {
            var O = G[z], H = O.length, w = H >= 2 && Q >= 2, T = w ? 2 : 1;
            if (T > H || T > Q) {
                J++;
                continue;
            }
            var g = O.nodeIndex, M = X.nodeIndex, y = g + 1, f = M, W = q.slice(y, f);
            if (W.length > 0) {
                var A = f - y;
                q.splice(y, A);
                for(var N = 0; N < G.length; N++)if (G[N].nodeIndex > y) G[N].nodeIndex -= A;
                if (M > y) M -= A;
            }
            var L = O.type === "~" ? "del" : O.type === "=" ? "mark" : w ? "strong" : "em", P = {
                type: F.textFormatted,
                tag: L,
                children: W
            }, E = q[g];
            if (!E || !E.text) {
                O.active = X.active = !1;
                continue;
            }
            var S = E.text.length <= T;
            if (S) {
                q.splice(g, 1);
                for(var N = 0; N < G.length; N++)if (G[N].nodeIndex > g) G[N].nodeIndex--;
                if (M > g) M--;
            } else E.text = E.text.slice(T);
            var C = q[M];
            if (!C || !C.text) {
                O.active = X.active = !1;
                continue;
            }
            var l = C.text.length <= T;
            if (l) {
                q.splice(M, 1);
                for(var N = 0; N < G.length; N++)if (G[N].nodeIndex > M) G[N].nodeIndex--;
            } else C.text = C.text.slice(T);
            var R = S ? g < M ? M - 1 : g : g + 1;
            if (R < 0 || R > q.length) R = R < 0 ? 0 : q.length;
            q.splice(R, 0, P);
            for(var N = 0; N < G.length; N++)if (G[N].nodeIndex >= R) G[N].nodeIndex++;
            for(var N = z + 1; N < J; N++)G[N].active = !1;
            if (S) O.active = !1;
            else if (O.length -= T, O.length === 0) O.active = !1;
            if (l) X.active = !1, J++;
            else if (X.length -= T, X.length === 0) X.active = !1, J++;
        } else {
            if (Z[K] = J - 1, !X.canOpen) X.active = !1;
            J++;
        }
    }
    var Jq = 0;
    for(var D = 0; D < G.length; D++)if (G[D].active) G[Jq++] = G[D];
    G.length = Jq;
}
function xG(q, G, Y) {
    var Z = [], J = 0, X = -3, $ = X;
    if (G.inline) return r1(q, 0, q.length, G, Y);
    if (J === 0 && q.startsWith("---")) {
        var K = jY(q, J);
        if (K) Z.push(K), J = K.endPos;
    }
    while(J < q.length){
        while(J < q.length && q[J] === `
`)J++;
        if (J >= q.length) break;
        $ = X;
        let b = q[J], U = gG(q, J, G, Y);
        if (U) {
            let H = U.type;
            if (H === F.codeBlock) {
                var V = b === "`" || b === "~";
                if (!V && (b === " " || b === "\t")) {
                    let O = x(q, J), w = d(q, J, O);
                    V = w.spaceEquivalent <= 3 && J + w.charCount < q.length && (q[J + w.charCount] === "`" || q[J + w.charCount] === "~");
                }
            } else if (H === F.breakThematic) ;
            else if (H === F.blockQuote) ;
            else if (H === F.heading) ;
            else if (H === F.orderedList || H === F.unorderedList) ;
            else if (H === F.table) ;
            else if (H === F.htmlComment) ;
            else if (H === F.htmlBlock) ;
            else F.ref;
            if (U.type === F.htmlComment) {
                Z.push(U);
                let O = J;
                J = U.endPos;
                let w = x(q, O);
                if (J < w) {
                    let T = q.slice(J, w);
                    if (T.trim().length > 0) Z.push({
                        type: F.text,
                        text: T
                    });
                    if (J = w, J < q.length && q[J] === `
`) J++;
                }
                continue;
            }
            if (U.type === F.htmlBlock || U.type === F.htmlSelfClosing) {
                if (U.type === F.htmlSelfClosing && U.isClosingTag === !0 && !G.inline && !G.inHTML) ;
                else {
                    Z.push(U), J = U.endPos;
                    continue;
                }
            } else {
                Z.push(U), J = U.endPos;
                continue;
            }
        }
        let Q = $ !== X ? $ : J;
        if ($ === X) {
            if (Tq(b)) {
                let H = x(q, J), O = d(q, J, H), w = J + O.charCount;
                if (O.spaceEquivalent <= 3 && w < q.length && q[w] === "[") Q = w;
                else Q = -1;
            } else if (b === "[") Q = J;
            else Q = -1;
            $ = Q;
        }
        if (Q >= 0 && Q + 1 < q.length && q[Q + 1] === "^") Q = -1;
        if (Q >= 0) {
            let H = _G(q, Q, G, Y, !1);
            if (H) {
                Z.push(H), J = H.endPos;
                continue;
            }
            let O = $Y(q, Q, J === 0);
            if (O.shouldSkip) {
                J = O.newPos;
                continue;
            }
        }
        let v = AJ(q, J, G, Y);
        if (v) {
            Z.push(v), J = v.endPos;
            continue;
        }
        let D = J;
        if (Tq(q[D])) {
            let H = x(q, J), O = d(q, J, H);
            D = J + O.charCount;
        }
        if (D < q.length && q[D] === "[" && D + 1 < q.length && q[D + 1] === "^") {
            let H = _G(q, D, G, Y, !0);
            if (H) {
                J = H.endPos;
                continue;
            }
        }
        let _ = LZ(q, J, G, Y);
        if (_) {
            Z.push(_), J = _.endPos;
            continue;
        }
        J++;
    }
    let z = G.refs || {}, j = {};
    for(let b in z)j[b] = z[b];
    if (hG(j)) return [
        {
            type: F.refCollection,
            refs: j
        },
        ...Z
    ];
    return Z;
}
function ZZ(q, G, Y) {
    var Z = 0, J = !0;
    let X = q.length;
    while(Z < X){
        var $ = 0;
        while(Z < X && B(q, Z) === Xq)$++, Z++;
        if (Z >= X) break;
        if ($ > 0) J = !0;
        let w = B(q, Z);
        if (w === mq || w === k1) {
            var K = IZ(q, Z, {
                inline: !1
            }, Y);
            if (K) {
                Z = K.endPos, J = !0;
                continue;
            }
        }
        var V = Z, z = 0;
        while(V < X && z < 4){
            let T = B(q, V);
            if (T === I) z++, V++;
            else if (T === p) z += 4 - z % 4, V++;
            else break;
        }
        if (z < 4 && V < X && B(q, V) === y1 && J) {
            if (V + 1 < X && B(q, V + 1) === t1) {
                J = !1;
                var H = x(q, Z);
                Z = H >= X ? X : H + 1;
                continue;
            } else {
                var j = _G(q, V, {
                    inline: !1,
                    refs: G
                }, Y, !1);
                if (j) {
                    Z = j.endPos, J = !0;
                    continue;
                }
                var H = x(q, Z), b = q.indexOf(":", V + 1);
                if (b === -1 || b >= H) {
                    var U = d(q, Z, H);
                    if (!z1(q, Z, H) && w !== OG && w !== B1 && w !== X1 && w !== S1 && U.spaceEquivalent < 4) J = !1;
                }
                Z = H >= X ? X : H + 1;
                continue;
            }
        }
        if (w === B1 && J) {
            var Q = Z, v = [];
            while(Q < X){
                var H = x(q, Q), D = Q;
                while(D < H){
                    let g = B(q, D);
                    if (g === I || g === p) D++;
                    else break;
                }
                if (D >= H || B(q, D) !== B1) break;
                var _ = D + 1;
                if (_ < H && (B(q, _) === I || B(q, _) === p)) _++;
                v.push(q.slice(_, H)), Q = H + 1;
            }
            if (v.length) {
                ZZ(v.join(`
`), G, Y), Z = Q, J = !0;
                continue;
            }
        }
        var H = x(q, Z);
        if (H >= X) Z = X;
        else {
            var O = z1(q, Z, H), U = d(q, Z, H);
            Z = H + 1, J = w === OG || w === B1 || w === X1 || w === S1 || O || U.spaceEquivalent >= 4;
        }
    }
}
function fJ(q, G) {
    let Z = {
        inline: !1,
        refs: {}
    }, J = {
        ...G,
        slugify: G?.slugify ? ($)=>G.slugify($, dq) : dq,
        sanitizer: G?.sanitizer || I1,
        tagfilter: G?.tagfilter !== !1
    };
    if (!Z.inline) ZZ(q, Z.refs || {}, J);
    return xG(q, Z, J);
}
var yY = /^\n+/;
function BY(q) {
    let G = !1;
    for(let Z = 0; Z < q.length; Z++){
        let J = q.charCodeAt(Z);
        if (J > 127 || J === h1 || J === mq) {
            G = !0;
            break;
        }
    }
    if (!G) return q;
    let Y = "";
    for(let Z = 0; Z < q.length; Z++){
        let J = q[Z];
        if (J === "%" && Z + 2 < q.length && /[0-9A-Fa-f]/.test(q[Z + 1]) && /[0-9A-Fa-f]/.test(q[Z + 2])) Y += q[Z] + q[Z + 1] + q[Z + 2], Z += 2;
        else if (J.charCodeAt(0) === h1) Y += "%5C";
        else if (J.charCodeAt(0) === mq) Y += "%60";
        else {
            let X = J.charCodeAt(0);
            Y += X > 127 ? encodeURIComponent(J) : J;
        }
    }
    return Y;
}
function NY(q, G, Y, Z, J, X, $, K) {
    switch(q.type){
        case F.blockQuote:
            {
                let z = {
                    key: Y.key
                };
                if (q.alert) z.className = "markdown-alert-" + X(q.alert.toLowerCase(), dq), q.children.unshift({
                    attrs: {},
                    children: [
                        {
                            type: F.text,
                            text: q.alert
                        }
                    ],
                    noInnerParse: !0,
                    type: F.htmlBlock,
                    tag: "header"
                });
                return Z("blockquote", z, G(q.children, Y));
            }
        case F.breakLine:
            return Z("br", {
                key: Y.key
            });
        case F.breakThematic:
            return Z("hr", {
                key: Y.key
            });
        case F.frontmatter:
            if (K.preserveFrontmatter) return Z("pre", {
                key: Y.key
            }, q.text);
            return null;
        case F.codeBlock:
            let V = q.lang ? zG(q.lang) : "";
            return Z("pre", {
                key: Y.key
            }, Z("code", {
                ...IG(q.attrs || {}),
                className: V ? `language-${V} lang-${V}` : ""
            }, q.text));
        case F.codeInline:
            return Z("code", {
                key: Y.key
            }, q.text);
        case F.footnoteReference:
            return Z("a", {
                key: Y.key,
                href: J(q.target, "a", "href")
            }, Z("sup", {
                key: Y.key
            }, q.text));
        case F.gfmTask:
            return Z("input", {
                checked: q.completed,
                key: Y.key,
                readOnly: !0,
                type: "checkbox"
            });
        case F.heading:
            return Z(`h${q.level}`, {
                id: q.id,
                key: Y.key
            }, G(q.children, Y));
        case F.htmlBlock:
            {
                let z = q;
                if (K.tagfilter && pG(z.tag)) {
                    let j;
                    if ("rawText" in z && typeof z.rawText === "string") j = z.rawText;
                    else {
                        let b = "";
                        if (z.attrs) {
                            for (let [U, Q] of Object.entries(z.attrs))if (Q === !0) b += ` ${U}`;
                            else if (Q !== void 0 && Q !== null && Q !== !1) b += ` ${U}="${String(Q)}"`;
                        }
                        j = `<${z.tag}${b}>`;
                    }
                    return Z("span", {
                        key: Y.key
                    }, j);
                }
                if (z.text && z.noInnerParse) {
                    let O = function(w) {
                        if (w.type === F.htmlSelfClosing && "isClosingTag" in w && w.isClosingTag) return [];
                        if (w.type === F.paragraph) {
                            let T = w.children;
                            return T ? T.flatMap(O) : [];
                        }
                        if (w.type === F.text) return w.text?.trim() ? [
                            w
                        ] : [];
                        if (w.type === F.htmlBlock && w.children) return [
                            {
                                ...w,
                                children: w.children?.flatMap(O)
                            }
                        ];
                        return [
                            w
                        ];
                    }, j = z.tag.toLowerCase(), b = DG(j), U = /<[a-z][^>]{0,100}>/i.test(z.text), Q = /<\/?pre\b/i.test(z.text);
                    if (b && !U) {
                        let w = z.text.replace(new RegExp("\\s*</" + j + ">\\s*$", "i"), "");
                        if (K.tagfilter) w = lG(w);
                        return Z(q.tag, {
                            key: Y.key,
                            ...q.attrs
                        }, w);
                    }
                    if (Q) {
                        let w = K.tagfilter ? lG(z.text) : z.text;
                        return Z(q.tag, {
                            key: Y.key,
                            ...q.attrs,
                            dangerouslySetInnerHTML: {
                                __html: w
                            }
                        });
                    }
                    let v = {
                        slugify: (w)=>X(w, dq),
                        sanitizer: J,
                        tagfilter: !0
                    }, D = z.text.replace(/>\s+</g, "><").replace(/\n+/g, " ").trim();
                    if (new RegExp(`^<${z.tag}(\\s[^>]*)?>(\\s*</${z.tag}>)?$`, "i").test(D)) return Z(q.tag, {
                        key: Y.key,
                        ...q.attrs
                    });
                    let H = xG(D, {
                        inline: !1,
                        refs: $,
                        inHTML: !1
                    }, v);
                    return Z(q.tag, {
                        key: Y.key,
                        ...q.attrs
                    }, G(H.flatMap(O), Y));
                }
                return Z(q.tag, {
                    key: Y.key,
                    ...q.attrs
                }, q.children ? G(q.children, Y) : "");
            }
        case F.htmlSelfClosing:
            {
                let z = q;
                if (K.tagfilter && pG(z.tag)) {
                    let j;
                    if ("rawText" in z && typeof z.rawText === "string") j = z.rawText;
                    else {
                        let b = "";
                        if (z.attrs) {
                            for (let [U, Q] of Object.entries(z.attrs))if (Q === !0) b += ` ${U}`;
                            else if (Q !== void 0 && Q !== null && Q !== !1) b += ` ${U}="${String(Q)}"`;
                        }
                        j = `<${z.tag}${b} />`;
                    }
                    return Z("span", {
                        key: Y.key
                    }, j);
                }
                return Z(q.tag, {
                    key: Y.key,
                    ...q.attrs
                });
            }
        case F.image:
            return Z("img", {
                key: Y.key,
                alt: q.alt && q.alt.length > 0 ? q.alt : void 0,
                title: q.title || void 0,
                src: J(q.target, "img", "src")
            });
        case F.link:
            {
                let z = {
                    key: Y.key
                };
                if (q.target != null) z.href = BY(q.target);
                if (q.title) z.title = q.title;
                return Z("a", z, G(q.children, Y));
            }
        case F.table:
            {
                let z = q;
                return Z("table", {
                    key: Y.key
                }, Z("thead", null, Z("tr", null, z.header.map(function(b, U) {
                    return Z("th", {
                        key: U,
                        style: z.align[U] == null ? {} : {
                            textAlign: z.align[U]
                        }
                    }, G(b, Y));
                }))), Z("tbody", null, z.cells.map(function(b, U) {
                    return Z("tr", {
                        key: U
                    }, b.map(function(v, D) {
                        return Z("td", {
                            key: D,
                            style: z.align[D] == null ? {} : {
                                textAlign: z.align[D]
                            }
                        }, G(v, Y));
                    }));
                })));
            }
        case F.text:
            return q.text;
        case F.textFormatted:
            return Z(q.tag, {
                key: Y.key
            }, G(q.children, Y));
        case F.orderedList:
        case F.unorderedList:
            {
                let z = q.type === F.orderedList ? "ol" : "ul";
                return Z(z, {
                    key: Y.key,
                    start: q.type === F.orderedList ? q.start : void 0
                }, q.items.map(function(b, U) {
                    return Z("li", {
                        key: U
                    }, G(b, Y));
                }));
            }
        case F.paragraph:
            return Z("p", {
                key: Y.key
            }, G(q.children, Y));
        case F.ref:
            return null;
        default:
            return null;
    }
}
var RY = (q, G, Y, Z, J, X)=>{
    let $ = (z, j, b)=>{
        let U = ()=>NY(z, j, b, G, Y, Z, J, X);
        return q ? q(U, z, j, b) : U();
    }, K = (z)=>z.map((j)=>"text" in j ? j.text : ""), V = (z, j = {})=>{
        let b = (j.renderDepth || 0) + 1;
        if (b > 2500) return K(z);
        j.renderDepth = b;
        let U = j.key, Q = [], v = !1;
        for(let D = 0; D < z.length; D++){
            j.key = D;
            let _ = $(z[D], V, j), H = typeof _ === "string";
            if (H && v) Q[Q.length - 1] += _;
            else if (_ !== null) {
                if (Array.isArray(_)) for(let O = 0; O < _.length; O++)Q.push(_[O]);
                else Q.push(_);
            }
            v = H;
        }
        return j.key = U, j.renderDepth = b - 1, Q;
    };
    return V;
}, LY = (...q)=>q.filter(Boolean).join(" "), mZ = (q, G, Y)=>{
    let Z = q, J = G.split("."), X = 0;
    while(X < J.length){
        if (Z = Z?.[J[X]], Z === void 0) break;
        X++;
    }
    return Z || Y;
}, TY = (q, G)=>{
    let Y = mZ(G, q, void 0);
    return !Y ? q : typeof Y === "function" || typeof Y === "object" && "render" in Y ? Y : mZ(G, `${q}.component`, q);
};
function fY(q, G) {
    let Y = {
        ...G || {}
    };
    Y.overrides = Y.overrides || {};
    let Z = Y.slugify || dq, J = Y.sanitizer || I1, X = Y.createElement || _react.createElement, $ = (_)=>CZ(_, {
            ...Y,
            wrapper: null
        });
    function K(_, H, ...O) {
        let w = mZ(Y.overrides, `${_}.props`, {}), T = IG(H || {});
        if ($) {
            for (let [g, M] of Object.entries(T))if (typeof M === "string" && M.length > 0 && M[0] === "<" && (vJ.test(M) || bJ.test(M) || c1(M, 0))) T[g] = $(M.trim());
        }
        return X(TY(_, Y.overrides), {
            ...T,
            ...w,
            className: LY(T?.className, w.className) || void 0
        }, ...O);
    }
    let V = [];
    for(let _ = 0; _ < q.length; _++){
        let H = q[_];
        if (H.type === F.htmlBlock && "text" in H && H.text && /<\/?pre\b/i.test(H.text) && _ + 1 < q.length && q[_ + 1].type === F.paragraph && "removedClosingTags" in q[_ + 1] && q[_ + 1].removedClosingTags) {
            let T = function(M) {
                let y = "";
                for (let f of M){
                    let W = f.type;
                    if (W === F.text) y += f.text;
                    else if (W === F.htmlSelfClosing && "rawText" in f && f.rawText) y += f.rawText;
                    else if (W === F.textFormatted) {
                        let A = f, N = A.tag === "em" ? "_" : A.tag === "strong" ? "**" : "";
                        y += N + T(A.children) + N;
                    } else if ("children" in f && f.children) y += T(f.children);
                }
                return y;
            }, O = H, w = q[_ + 1], g = T(w.children);
            if (w.removedClosingTags) g += w.removedClosingTags.filter((M)=>M.type === F.htmlSelfClosing && "rawText" in M && M.rawText && M.rawText.indexOf(`</${O.tag}>`) === -1).map((M)=>M.type === F.htmlSelfClosing && "rawText" in M ? M.rawText || "" : "").join("");
            O.text += `
` + g, _++;
        }
        V.push(H);
    }
    q = V;
    let z = {
        ...Y,
        slugify: (_)=>Z(_, dq),
        sanitizer: J,
        tagfilter: Y.tagfilter !== !1
    }, j = q[0] && q[0].type === F.refCollection ? q[0].refs : {}, b = RY(Y.renderRule, K, J, Z, j, Y), U = b(q, {
        inline: Y.forceInline,
        refs: j
    }), Q = [];
    for(let _ in j)if (_.charCodeAt(0) === t1) Q.push({
        identifier: _,
        footnote: j[_].target
    });
    if (Q.length) U.push(K("footer", {
        key: "footer"
    }, Q.map(function(H) {
        let O = H.identifier.charCodeAt(0) === t1 ? H.identifier.slice(1) : H.identifier, w = xG(H.footnote, {
            inline: !0,
            refs: j
        }, z);
        return K("div", {
            id: Z(O, dq),
            key: H.identifier
        }, O + ": ", b(w, {
            inline: !0,
            refs: j
        }));
    })));
    if (Y.wrapper === null) return U;
    let v = Y.wrapper || (Y.forceInline ? "span" : "div"), D;
    if (U.length > 1 || Y.forceWrapper) D = U;
    else if (U.length === 1) return U[0];
    else return null;
    return X(v, {
        key: "outer",
        ...Y.wrapperProps
    }, D);
}
function CZ(q = "", G = {}) {
    let Y = {
        ...G || {}
    };
    Y.overrides = Y.overrides || {};
    let Z = Y.slugify || dq, J = Y.sanitizer || I1;
    function X(V) {
        let z = Y.forceInline || !Y.forceBlock && !QZ.test(V), j = {
            ...Y,
            slugify: (Q)=>Z(Q, dq),
            sanitizer: J,
            tagfilter: Y.tagfilter !== !1
        };
        if (!z) ZZ(V, $, j);
        let b = V;
        if (!z) {
            let Q = b.length;
            while(Q > 0 && (b[Q - 1] === `
` || b[Q - 1] === "\r"))Q--;
            b = b.slice(0, Q), b = `${b.replace(yY, "")}

`;
        }
        let U = xG(z ? V : b, {
            inline: z,
            refs: $
        }, j);
        return fY(U, {
            ...j,
            forceInline: z
        });
    }
    let $ = {};
    return X(q);
}
var xJ = ({ children: q, options: G, ...Y })=>{
    return CZ(q === null || q === void 0 ? "" : q, {
        ...G,
        wrapperProps: {
            ...G?.wrapperProps,
            ...Y
        }
    });
}, gY = xJ;

},{"node:module":"8PfwX","react":"eGun2","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8PfwX":[function(require,module,exports,__globalThis) {
"use strict";

},{}],"jce4T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _reactTable = require("@tanstack/react-table");
var _dateFns = require("date-fns");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _transcodeJobsStore = require("@/client/store/transcodeJobsStore");
var _clientsStore = require("@/client/store/clientsStore");
var _useStallDetection = require("@/client/hooks/useStallDetection");
var _usePersistedSearch = require("@/client/hooks/usePersistedSearch");
var _resetFiltersButton = require("@/client/components/reset-filters-button");
var _transcodeJobsColumns = require("@/client/components/tables/transcode-jobs-columns");
var _table = require("@/client/components/ui/table");
var _input = require("@/client/components/ui/input");
var _button = require("@/client/components/ui/button");
var _dropdownMenu = require("@/client/components/ui/dropdown-menu");
var _badge = require("@/client/components/ui/badge");
var _lucideReact = require("lucide-react");
var _pagination = require("@/client/components/ui/pagination");
// Quick range presets
const QUICK_RANGES = [
    {
        label: '24h',
        hours: 24
    },
    {
        label: '48h',
        hours: 48
    },
    {
        label: '72h',
        hours: 72
    },
    {
        label: '1 week',
        hours: 168
    },
    {
        label: '1 month',
        hours: 720
    },
    {
        label: '2 months',
        hours: 1440
    },
    {
        label: '3 months',
        hours: 2160
    }
];
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'transcode-jobs',
    validateSearch: (search)=>{
        return {
            clientID: typeof search.clientID === 'string' ? search.clientID : undefined,
            range: typeof search.range === 'string' ? search.range : undefined
        };
    },
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: TranscodeJobsComponent
});
function getDateRangeFromQuickRange(rangeLabel) {
    const now = new Date();
    const range = QUICK_RANGES.find((r)=>r.label === rangeLabel) || QUICK_RANGES[0]; // Default to 24h
    const start = range.hours <= 72 ? (0, _dateFns.subHours)(now, range.hours) : (0, _dateFns.subDays)(now, range.hours / 24);
    return {
        startDate: (0, _dateFns.format)(start, 'yyyy-MM-dd'),
        endDate: (0, _dateFns.format)(now, 'yyyy-MM-dd')
    };
}
function TranscodeJobsComponent() {
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    const navigate = (0, _reactRouter.useNavigate)();
    const { clientID, range = '24h' } = (0, _reactRouter.useSearch)({
        from: '/transcode-jobs'
    });
    // Persist search params across navigation
    (0, _usePersistedSearch.usePersistedSearch)('/transcode-jobs', {
        clientID: undefined,
        range: '24h'
    });
    // Store state
    const processing = (0, _transcodeJobsStore.useTranscodeJobsStore)((state)=>state.processing);
    const failed = (0, _transcodeJobsStore.useTranscodeJobsStore)((state)=>state.failed);
    const success = (0, _transcodeJobsStore.useTranscodeJobsStore)((state)=>state.success);
    const successPaginated = (0, _transcodeJobsStore.useTranscodeJobsStore)((state)=>state.successPaginated);
    const loading = (0, _transcodeJobsStore.useTranscodeJobsStore)((state)=>state.loading);
    const error = (0, _transcodeJobsStore.useTranscodeJobsStore)((state)=>state.error);
    const lastMeta = (0, _transcodeJobsStore.useTranscodeJobsStore)((state)=>state.lastMeta);
    const fetchJobs = (0, _transcodeJobsStore.useTranscodeJobsStore)((state)=>state.fetchJobs);
    const fetchSuccessJobs = (0, _transcodeJobsStore.useTranscodeJobsStore)((state)=>state.fetchSuccessJobs);
    const { clients, fetchClients } = (0, _clientsStore.useClientsStore)();
    const [sorting, setSorting] = (0, _react.useState)([
        {
            id: 'createdAt',
            desc: true
        }
    ]);
    const [searchFilter, setSearchFilter] = (0, _react.useState)('');
    const [activeTab, setActiveTab] = (0, _react.useState)('processing');
    // Enable stall detection while on this page
    (0, _useStallDetection.useStallDetection)();
    const filteredClient = clientID ? clients.find((c)=>c.clientID === clientID) : null;
    // Convert Map to array for display
    const processingJobs = (0, _react.useMemo)(()=>Array.from(processing.values()), [
        processing
    ]);
    // Count stalled/silent-failure jobs
    const problemJobsCount = (0, _react.useMemo)(()=>{
        return processingJobs.filter((j)=>j.stallStatus !== 'normal').length;
    }, [
        processingJobs
    ]);
    // Get jobs for current tab
    // For success tab, combine WSS live completions with paginated historical data
    const currentJobs = (0, _react.useMemo)(()=>{
        switch(activeTab){
            case 'processing':
                return processingJobs;
            case 'failed':
                return failed;
            case 'success':
                // Combine live WSS completions with paginated API results
                // Deduplicate by job ID (WSS takes priority)
                const wssIds = new Set(success.map((j)=>j.id));
                const deduped = successPaginated.jobs.filter((j)=>!wssIds.has(j.id));
                return [
                    ...success,
                    ...deduped
                ];
            default:
                return [];
        }
    }, [
        activeTab,
        processingJobs,
        failed,
        success,
        successPaginated.jobs
    ]);
    // Apply search filter
    const filteredJobs = (0, _react.useMemo)(()=>{
        if (!searchFilter) return currentJobs;
        const search = searchFilter.toLowerCase();
        return currentJobs.filter((job)=>job.id.toLowerCase().includes(search) || job.jobType?.toLowerCase().includes(search) || job.clientID?.toLowerCase().includes(search) || job.eventID?.toLowerCase().includes(search) || job.assetID?.toLowerCase().includes(search));
    }, [
        currentJobs,
        searchFilter
    ]);
    const loadData = (0, _react.useCallback)(async ()=>{
        try {
            const token = await getAccessTokenSilently();
            const { startDate, endDate } = getDateRangeFromQuickRange(range);
            await Promise.all([
                fetchJobs(token, logout, {
                    clientID,
                    startDate,
                    endDate
                }),
                clients.length === 0 ? fetchClients(token, logout) : Promise.resolve()
            ]);
            setLastFetchTime(Date.now());
        } catch (err) {
            console.error('Error fetching data:', err);
        }
    }, [
        getAccessTokenSilently,
        fetchJobs,
        fetchClients,
        clients.length,
        clientID,
        range
    ]);
    // Initial load
    (0, _react.useEffect)(()=>{
        loadData();
    }, [
        loadData
    ]);
    // Track last fetch time for visibility change cooldown
    const [lastFetchTime, setLastFetchTime] = (0, _react.useState)(Date.now());
    // Track what success jobs filter params we've already fetched
    // This prevents infinite loops when the API returns empty results
    const [successFetchedFor, setSuccessFetchedFor] = (0, _react.useState)(null);
    // Fetch success jobs when switching to success tab or changing date range
    const loadSuccessJobs = (0, _react.useCallback)(async (page = 1)=>{
        try {
            const token = await getAccessTokenSilently();
            const { startDate, endDate } = getDateRangeFromQuickRange(range);
            await fetchSuccessJobs(token, logout, page, {
                clientID,
                startDate,
                endDate
            });
        } catch (err) {
            console.error('Error fetching success jobs:', err);
        }
    }, [
        getAccessTokenSilently,
        fetchSuccessJobs,
        range,
        clientID,
        logout
    ]);
    // Fetch success jobs on tab switch or when filters change
    (0, _react.useEffect)(()=>{
        // Create a key representing current filter state
        const filterKey = `${range}:${clientID ?? 'all'}`;
        const alreadyFetched = successFetchedFor === filterKey;
        // Fetch if on success tab AND we haven't fetched for these filters yet
        if (activeTab === 'success' && !successPaginated.loading && !alreadyFetched) {
            setSuccessFetchedFor(filterKey);
            loadSuccessJobs(1);
        }
    }, [
        activeTab,
        successPaginated.loading,
        loadSuccessJobs,
        range,
        clientID,
        successFetchedFor
    ]);
    // Reset the fetched-for tracker when filters change so we re-fetch with new params
    (0, _react.useEffect)(()=>{
        setSuccessFetchedFor(null);
    }, [
        range,
        clientID
    ]);
    const handlePageChange = (0, _react.useCallback)((newPage)=>{
        loadSuccessJobs(newPage);
    }, [
        loadSuccessJobs
    ]);
    // Refresh on wake from sleep / tab visibility change (with 5-minute cooldown)
    (0, _react.useEffect)(()=>{
        const VISIBILITY_REFETCH_COOLDOWN = 300000; // 5 minutes
        const handleVisibilityChange = ()=>{
            if (document.visibilityState === 'visible') {
                const timeSinceLastFetch = Date.now() - lastFetchTime;
                if (timeSinceLastFetch >= VISIBILITY_REFETCH_COOLDOWN) loadData();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, [
        loadData,
        lastFetchTime
    ]);
    const table = (0, _reactTable.useReactTable)({
        data: filteredJobs,
        columns: (0, _transcodeJobsColumns.columns),
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        onSortingChange: setSorting,
        getSortedRowModel: (0, _reactTable.getSortedRowModel)(),
        state: {
            sorting
        }
    });
    const handleRefresh = async ()=>{
        try {
            const token = await getAccessTokenSilently();
            const { startDate, endDate } = getDateRangeFromQuickRange(range);
            await fetchJobs(token, logout, {
                clientID,
                startDate,
                endDate
            });
        } catch (err) {
            console.error('Error refreshing jobs:', err);
        }
    };
    const clearClientFilter = ()=>{
        navigate({
            to: '/transcode-jobs',
            search: {
                range
            }
        });
    };
    const handleRangeChange = (newRange)=>{
        navigate({
            to: '/transcode-jobs',
            search: {
                clientID,
                range: newRange
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex justify-between items-center mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "text-2xl font-semibold",
                                        children: "Transcode Jobs"
                                    }),
                                    filteredClient && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-1 px-3 py-1 bg-muted rounded-full text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: filteredClient.name
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: clearClientFilter,
                                                className: "ml-1 hover:bg-accent rounded-full p-0.5",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.X), {
                                                    className: "h-3 w-3"
                                                })
                                            })
                                        ]
                                    }),
                                    problemJobsCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                        variant: "destructive",
                                        className: "gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                                                className: "h-3 w-3"
                                            }),
                                            problemJobsCount,
                                            " job",
                                            problemJobsCount !== 1 ? 's' : '',
                                            " need attention"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "font-mono text-sm text-muted-foreground",
                                children: "Live data"
                            })
                        ]
                    }),
                    loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Loading transcode jobs..."
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-4 bg-red-100 border-l-4 border-red-600 rounded mt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "m-0 text-red-800 font-medium",
                            children: [
                                "Error: ",
                                error
                            ]
                        })
                    }),
                    !loading && !error && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex justify-between items-center gap-4 mb-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex gap-1 p-1 bg-muted rounded-lg",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                variant: activeTab === 'processing' ? 'default' : 'ghost',
                                                size: "sm",
                                                onClick: ()=>setActiveTab('processing'),
                                                className: "gap-2",
                                                children: [
                                                    "Processing",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                                        variant: "secondary",
                                                        className: "ml-1",
                                                        children: processingJobs.length
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                variant: activeTab === 'failed' ? 'default' : 'ghost',
                                                size: "sm",
                                                onClick: ()=>setActiveTab('failed'),
                                                className: "gap-2",
                                                children: [
                                                    "Failed",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                                        variant: "secondary",
                                                        className: "ml-1",
                                                        children: failed.length
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                variant: activeTab === 'success' ? 'default' : 'ghost',
                                                size: "sm",
                                                onClick: ()=>setActiveTab('success'),
                                                className: "gap-2",
                                                children: [
                                                    "Success",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                                        variant: "secondary",
                                                        className: "ml-1",
                                                        children: successPaginated.totalCount > 0 ? successPaginated.totalCount : success.length
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenu), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuTrigger), {
                                                        asChild: true,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                            variant: "outline",
                                                            className: "w-32 justify-between",
                                                            children: [
                                                                range,
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                                    className: "ml-2 h-4 w-4 opacity-50"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuContent), {
                                                        align: "end",
                                                        children: QUICK_RANGES.map((r)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                                onClick: ()=>handleRangeChange(r.label),
                                                                children: r.label
                                                            }, r.label))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                                placeholder: "Filter by ID, type, client...",
                                                value: searchFilter,
                                                onChange: (e)=>setSearchFilter(e.target.value),
                                                className: "w-64"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                variant: "outline",
                                                onClick: handleRefresh,
                                                disabled: loading,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                                        className: `h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`
                                                    }),
                                                    "Force Refresh"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetFiltersButton.ResetFiltersButton), {
                                                routePath: "/transcode-jobs",
                                                defaultValues: {
                                                    clientID: undefined,
                                                    range: '24h'
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            activeTab === 'success' && successPaginated.loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "text-center py-8 text-muted-foreground",
                                children: "Loading success jobs..."
                            }),
                            filteredJobs.length === 0 && !(activeTab === 'success' && successPaginated.loading) ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "text-center py-8 text-muted-foreground",
                                children: [
                                    "No ",
                                    activeTab,
                                    " jobs found for the selected time range."
                                ]
                            }) : filteredJobs.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "rounded-md border",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                                    children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                            children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                                    children: header.isPlaceholder ? null : (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())
                                                                }, header.id))
                                                        }, headerGroup.id))
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                                    children: table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                            children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    children: (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                                                }, cell.id))
                                                        }, row.id))
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "mt-2 flex justify-between items-center text-sm text-muted-foreground",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: activeTab === 'success' && successPaginated.totalCount > 0 ? `Showing page ${successPaginated.page} of ${successPaginated.totalPages} (${successPaginated.totalCount} total)` : `Showing ${filteredJobs.length} ${activeTab} job${filteredJobs.length !== 1 ? 's' : ''}`
                                            }),
                                            lastMeta && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                children: [
                                                    "Range: ",
                                                    new Date(lastMeta.startDate).toLocaleDateString(),
                                                    " - ",
                                                    new Date(lastMeta.endDate).toLocaleDateString()
                                                ]
                                            })
                                        ]
                                    }),
                                    activeTab === 'success' && successPaginated.totalPages > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mt-4 flex justify-center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.Pagination), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pagination.PaginationContent), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.PaginationItem), {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                            variant: "ghost",
                                                            size: "sm",
                                                            onClick: ()=>handlePageChange(successPaginated.page - 1),
                                                            disabled: successPaginated.page <= 1 || successPaginated.loading,
                                                            className: "gap-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronLeft), {
                                                                    className: "h-4 w-4"
                                                                }),
                                                                "Previous"
                                                            ]
                                                        })
                                                    }),
                                                    Array.from({
                                                        length: Math.min(5, successPaginated.totalPages)
                                                    }, (_, i)=>{
                                                        let pageNum;
                                                        if (successPaginated.totalPages <= 5) pageNum = i + 1;
                                                        else if (successPaginated.page <= 3) pageNum = i + 1;
                                                        else if (successPaginated.page >= successPaginated.totalPages - 2) pageNum = successPaginated.totalPages - 4 + i;
                                                        else pageNum = successPaginated.page - 2 + i;
                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.PaginationItem), {
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.PaginationLink), {
                                                                onClick: ()=>handlePageChange(pageNum),
                                                                isActive: pageNum === successPaginated.page,
                                                                className: "cursor-pointer",
                                                                children: pageNum
                                                            })
                                                        }, pageNum);
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.PaginationItem), {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                            variant: "ghost",
                                                            size: "sm",
                                                            onClick: ()=>handlePageChange(successPaginated.page + 1),
                                                            disabled: successPaginated.page >= successPaginated.totalPages || successPaginated.loading,
                                                            className: "gap-1",
                                                            children: [
                                                                "Next",
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                                                                    className: "h-4 w-4"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useNavigate","aMhxM"],["useSearch","4yVFL"]],"@auth0/auth0-react":"gpXrE","@tanstack/react-table":[["flexRender","brwh1"],["useReactTable","brwh1"],["getCoreRowModel","3MlnA"],["getSortedRowModel","3MlnA"]],"date-fns":[["format","4NYjc"],["subDays","gyc2T"],["subHours","3Dxf0"]],"../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/store/transcodeJobsStore":"c7Bdn","@/client/store/clientsStore":"6bg3l","@/client/hooks/useStallDetection":"h0I3W","@/client/hooks/usePersistedSearch":"kPA60","@/client/components/reset-filters-button":"9d8BP","@/client/components/tables/transcode-jobs-columns":"dR6Ff","@/client/components/ui/table":"5vxZ8","@/client/components/ui/input":"8UHwi","@/client/components/ui/button":"armlb","@/client/components/ui/dropdown-menu":"8ox96","@/client/components/ui/badge":"h4e1f","lucide-react":[["AlertTriangle","cdePa","default"],["ChevronDown","kVmgC","default"],["ChevronLeft","gT7FB","default"],["ChevronRight","lOb49","default"],["RefreshCw","7a8jT","default"],["X","8HSxK","default"]],"@/client/components/ui/pagination":"0uRki","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gyc2T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link subDays} function options.
 */ /**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 * @param options - An object with options
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ parcelHelpers.export(exports, "subDays", ()=>subDays);
var _addDaysJs = require("./addDays.js");
function subDays(date, amount, options) {
    return (0, _addDaysJs.addDays)(date, -amount, options);
}
// Fallback for modularized imports:
exports.default = subDays;

},{"./addDays.js":"489Ts","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3Dxf0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link subHours} function options.
 */ /**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 * @param options - The options
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */ parcelHelpers.export(exports, "subHours", ()=>subHours);
var _addHoursJs = require("./addHours.js");
function subHours(date, amount, options) {
    return (0, _addHoursJs.addHours)(date, -amount, options);
}
// Fallback for modularized imports:
exports.default = subHours;

},{"./addHours.js":"jOclr","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jOclr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addHours} function options.
 */ /**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added
 * @param options - An object with options
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ parcelHelpers.export(exports, "addHours", ()=>addHours);
var _addMillisecondsJs = require("./addMilliseconds.js");
var _constantsJs = require("./constants.js");
function addHours(date, amount, options) {
    return (0, _addMillisecondsJs.addMilliseconds)(date, amount * (0, _constantsJs.millisecondsInHour), options);
}
// Fallback for modularized imports:
exports.default = addHours;

},{"./addMilliseconds.js":"gcVhS","./constants.js":"Sfkj0","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gcVhS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addMilliseconds} function options.
 */ /**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 * @param options - The options object
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ parcelHelpers.export(exports, "addMilliseconds", ()=>addMilliseconds);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function addMilliseconds(date, amount, options) {
    return (0, _constructFromJs.constructFrom)(options?.in || date, +(0, _toDateJs.toDate)(date) + amount);
}
// Fallback for modularized imports:
exports.default = addMilliseconds;

},{"./constructFrom.js":"aMZJE","./toDate.js":"3EOaA","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"h0I3W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook to periodically re-evaluate stall status for processing transcode jobs.
 * Should be used on the transcode jobs monitoring page.
 *
 * @param enabled - Whether to run the interval (default: true)
 */ parcelHelpers.export(exports, "useStallDetection", ()=>useStallDetection);
var _react = require("react");
var _transcodeJobsStore = require("@/client/store/transcodeJobsStore");
var _types = require("@shared/types");
const { STALL_CHECK_INTERVAL_MS } = (0, _types.TRANSCODE_CONFIG);
function useStallDetection(enabled = true) {
    const reEvaluateStallStatus = (0, _transcodeJobsStore.useTranscodeJobsStore)((state)=>state.reEvaluateStallStatus);
    const processingCount = (0, _transcodeJobsStore.useTranscodeJobsStore)((state)=>state.processing.size);
    (0, _react.useEffect)(()=>{
        // Don't run if disabled or no processing jobs
        if (!enabled || processingCount === 0) return;
        const interval = setInterval(()=>{
            reEvaluateStallStatus();
        }, STALL_CHECK_INTERVAL_MS);
        return ()=>clearInterval(interval);
    }, [
        enabled,
        processingCount,
        reEvaluateStallStatus
    ]);
}

},{"react":"eGun2","@/client/store/transcodeJobsStore":"c7Bdn","@shared/types":"dzHsw","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dR6Ff":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "columns", ()=>columns);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _button = require("@/client/components/ui/button");
var _progress = require("@/client/components/ui/progress");
var _badge = require("@/client/components/ui/badge");
var _tooltip = require("@/client/components/ui/tooltip");
var _cells = require("./cells");
// Type guard to check if job is a TrackedJob (has stall detection fields)
function isTrackedJob(job) {
    return 'stallStatus' in job;
}
function StallIndicator({ stallStatus }) {
    if (stallStatus === 'normal') return null;
    if (stallStatus === 'stalled') return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltip.Tooltip), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipTrigger), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                    variant: "outline",
                    className: "border-amber-500 text-amber-600 gap-1",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                            className: "h-3 w-3"
                        }),
                        "Stalled"
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipContent), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "No progress for 5+ minutes"
                })
            })
        ]
    });
    if (stallStatus === 'silent-failure') return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltip.Tooltip), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipTrigger), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                    variant: "destructive",
                    className: "gap-1",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertCircle), {
                            className: "h-3 w-3"
                        }),
                        "Silent Failure"
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipContent), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "Stuck at 100% for 10+ minutes without completing"
                })
            })
        ]
    });
    return null;
}
function JobStatus({ job }) {
    const status = job.status;
    const stallStatus = isTrackedJob(job) ? job.stallStatus : 'normal';
    if (!status) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-muted-foreground",
        children: "-"
    });
    // Show stall indicator for processing jobs
    if (status === 'processing' && stallStatus !== 'normal') return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StallIndicator, {
        stallStatus: stallStatus
    });
    switch(status){
        case 'processing':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                variant: "outline",
                className: "border-blue-500 text-blue-600",
                children: "Processing"
            });
        case 'success':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                variant: "outline",
                className: "border-green-500 text-green-600",
                children: "Success"
            });
        case 'failed':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                variant: "destructive",
                children: "Failed"
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                variant: "secondary",
                children: status
            });
    }
}
function JobProgress({ progress, status, stallStatus }) {
    if (status === 'success') return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-green-600 text-sm",
        children: "100%"
    });
    if (status === 'failed') return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-red-600 text-sm",
        children: "-"
    });
    if (progress === null) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-muted-foreground text-sm",
        children: "-"
    });
    // Determine progress bar color based on stall status
    const progressBarClass = stallStatus === 'stalled' ? '[&>div]:bg-amber-500' : stallStatus === 'silent-failure' ? '[&>div]:bg-red-500' : '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-2 min-w-[100px]",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progress.Progress), {
                value: progress,
                className: `h-2 flex-1 ${progressBarClass}`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "text-sm text-muted-foreground w-10",
                children: [
                    progress.toFixed(0),
                    "%"
                ]
            })
        ]
    });
}
const columns = [
    {
        accessorKey: 'id',
        header: 'Job ID',
        cell: ({ row })=>{
            const id = row.getValue('id');
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.CopyableCell), {
                value: id
            });
        },
        enableSorting: false
    },
    {
        accessorKey: 'jobType',
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Type",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            }),
        cell: ({ row })=>row.getValue('jobType') || '-'
    },
    {
        accessorKey: 'status',
        header: 'Status',
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(JobStatus, {
                job: row.original
            }),
        enableSorting: false
    },
    {
        accessorKey: 'progress',
        header: 'Progress',
        cell: ({ row })=>{
            const stallStatus = isTrackedJob(row.original) ? row.original.stallStatus : undefined;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(JobProgress, {
                progress: row.getValue('progress'),
                status: row.original.status,
                stallStatus: stallStatus
            });
        },
        enableSorting: false
    },
    {
        accessorKey: 'createdAt',
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                variant: "ghost",
                onClick: ()=>column.toggleSorting(column.getIsSorted() === 'asc'),
                children: [
                    "Created",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowUpDown), {
                        className: "ml-2 h-4 w-4"
                    })
                ]
            }),
        cell: ({ row })=>{
            const value = row.getValue('createdAt');
            return value ? new Date(value).toLocaleString() : '-';
        }
    },
    {
        accessorKey: 'clientID',
        header: 'Client ID',
        cell: ({ row })=>{
            const clientID = row.getValue('clientID');
            if (!clientID) return '-';
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.ClientIDCell), {
                clientID: clientID
            });
        },
        enableSorting: false
    },
    {
        accessorKey: 'eventID',
        size: 80,
        header: 'Event ID',
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EventIDCell), {
                eventID: row.getValue('eventID')
            }),
        enableSorting: false
    },
    {
        id: 'eventLinks',
        header: 'Links',
        cell: ({ row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EventLinksCell), {
                eventID: row.original.eventID,
                clientID: row.original.clientID
            }),
        size: 70,
        enableSorting: false
    }
];

},{"react/jsx-runtime":"dQjte","lucide-react":[["AlertCircle","65jRl","default"],["AlertTriangle","cdePa","default"],["ArrowUpDown","amX4k","default"]],"@/client/components/ui/button":"armlb","@/client/components/ui/progress":"2BCJM","@/client/components/ui/badge":"h4e1f","@/client/components/ui/tooltip":"dWqZd","./cells":"5BSEg","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2BCJM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Progress", ()=>Progress);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactProgress = require("@radix-ui/react-progress");
var _utils = require("@/client/lib/utils");
const Progress = /*#__PURE__*/ _react.forwardRef(({ className, value, indicatorClassName, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactProgress.Root, {
        ref: ref,
        className: (0, _utils.cn)("relative h-4 w-full overflow-hidden rounded-full bg-secondary", className),
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactProgress.Indicator, {
            className: (0, _utils.cn)("h-full w-full flex-1 bg-primary transition-all", indicatorClassName),
            style: {
                transform: `translateX(-${100 - (value || 0)}%)`
            }
        })
    }));
Progress.displayName = _reactProgress.Root.displayName;

},{"react/jsx-runtime":"dQjte","react":"eGun2","@radix-ui/react-progress":"gLNCj","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gLNCj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Indicator", ()=>Indicator);
parcelHelpers.export(exports, "Progress", ()=>Progress);
parcelHelpers.export(exports, "ProgressIndicator", ()=>ProgressIndicator);
parcelHelpers.export(exports, "Root", ()=>Root);
parcelHelpers.export(exports, "createProgressScope", ()=>createProgressScope);
// src/progress.tsx
var _react = require("react");
var _reactContext = require("@radix-ui/react-context");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var PROGRESS_NAME = "Progress";
var DEFAULT_MAX = 100;
var [createProgressContext, createProgressScope] = (0, _reactContext.createContextScope)(PROGRESS_NAME);
var [ProgressProvider, useProgressContext] = createProgressContext(PROGRESS_NAME);
var Progress = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeProgress, value: valueProp = null, max: maxProp, getValueLabel = defaultGetValueLabel, ...progressProps } = props;
    if ((maxProp || maxProp === 0) && !isValidMaxNumber(maxProp)) console.error(getInvalidMaxError(`${maxProp}`, "Progress"));
    const max = isValidMaxNumber(maxProp) ? maxProp : DEFAULT_MAX;
    if (valueProp !== null && !isValidValueNumber(valueProp, max)) console.error(getInvalidValueError(`${valueProp}`, "Progress"));
    const value = isValidValueNumber(valueProp, max) ? valueProp : null;
    const valueLabel = isNumber(value) ? getValueLabel(value, max) : void 0;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(ProgressProvider, {
        scope: __scopeProgress,
        value,
        max,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
            "aria-valuemax": max,
            "aria-valuemin": 0,
            "aria-valuenow": isNumber(value) ? value : void 0,
            "aria-valuetext": valueLabel,
            role: "progressbar",
            "data-state": getProgressState(value, max),
            "data-value": value ?? void 0,
            "data-max": max,
            ...progressProps,
            ref: forwardedRef
        })
    });
});
Progress.displayName = PROGRESS_NAME;
var INDICATOR_NAME = "ProgressIndicator";
var ProgressIndicator = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeProgress, ...indicatorProps } = props;
    const context = useProgressContext(INDICATOR_NAME, __scopeProgress);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        "data-state": getProgressState(context.value, context.max),
        "data-value": context.value ?? void 0,
        "data-max": context.max,
        ...indicatorProps,
        ref: forwardedRef
    });
});
ProgressIndicator.displayName = INDICATOR_NAME;
function defaultGetValueLabel(value, max) {
    return `${Math.round(value / max * 100)}%`;
}
function getProgressState(value, maxValue) {
    return value == null ? "indeterminate" : value === maxValue ? "complete" : "loading";
}
function isNumber(value) {
    return typeof value === "number";
}
function isValidMaxNumber(max) {
    return isNumber(max) && !isNaN(max) && max > 0;
}
function isValidValueNumber(value, max) {
    return isNumber(value) && !isNaN(value) && value <= max && value >= 0;
}
function getInvalidMaxError(propValue, componentName) {
    return `Invalid prop \`max\` of value \`${propValue}\` supplied to \`${componentName}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${DEFAULT_MAX}\`.`;
}
function getInvalidValueError(propValue, componentName) {
    return `Invalid prop \`value\` of value \`${propValue}\` supplied to \`${componentName}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${DEFAULT_MAX} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var Root = Progress;
var Indicator = ProgressIndicator;

},{"react":"eGun2","@radix-ui/react-context":"5biLi","@radix-ui/react-primitive":"i36AJ","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5biLi":[function(require,module,exports,__globalThis) {
// src/create-context.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContext", ()=>createContext2);
parcelHelpers.export(exports, "createContextScope", ()=>createContextScope);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function createContext2(rootComponentName, defaultContext) {
    const Context = _react.createContext(defaultContext);
    Context.displayName = rootComponentName + "Context";
    const Provider = (props)=>{
        const { children, ...context } = props;
        const value = _react.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Context.Provider, {
            value,
            children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = _react.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function createContextScope(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = _react.createContext(defaultContext);
        BaseContext.displayName = rootComponentName + "Context";
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope, children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = _react.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Context.Provider, {
                value,
                children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = _react.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return _react.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return _react.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return _react.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}

},{"react":"eGun2","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gT7FB":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronLeft);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const ChevronLeft = (0, _createLucideIconJsDefault.default)("chevron-left", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"0uRki":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pagination", ()=>Pagination);
parcelHelpers.export(exports, "PaginationContent", ()=>PaginationContent);
parcelHelpers.export(exports, "PaginationEllipsis", ()=>PaginationEllipsis);
parcelHelpers.export(exports, "PaginationItem", ()=>PaginationItem);
parcelHelpers.export(exports, "PaginationLink", ()=>PaginationLink);
parcelHelpers.export(exports, "PaginationNext", ()=>PaginationNext);
parcelHelpers.export(exports, "PaginationPrevious", ()=>PaginationPrevious);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _lucideReact = require("lucide-react");
var _utils = require("@/client/lib/utils");
var _button = require("@/client/components/ui/button");
const Pagination = ({ className, ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
        role: "navigation",
        "aria-label": "pagination",
        className: (0, _utils.cn)("mx-auto flex w-full justify-center", className),
        ...props
    });
Pagination.displayName = "Pagination";
const PaginationContent = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
        ref: ref,
        className: (0, _utils.cn)("flex flex-row items-center gap-1", className),
        ...props
    }));
PaginationContent.displayName = "PaginationContent";
const PaginationItem = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        ref: ref,
        className: (0, _utils.cn)("", className),
        ...props
    }));
PaginationItem.displayName = "PaginationItem";
const PaginationLink = ({ className, isActive, size = "icon", ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        "aria-current": isActive ? "page" : undefined,
        className: (0, _utils.cn)((0, _button.buttonVariants)({
            variant: isActive ? "outline" : "ghost",
            size
        }), className),
        ...props
    });
PaginationLink.displayName = "PaginationLink";
const PaginationPrevious = ({ className, ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(PaginationLink, {
        "aria-label": "Go to previous page",
        size: "default",
        className: (0, _utils.cn)("gap-1 pl-2.5", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronLeft), {
                className: "h-4 w-4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: "Previous"
            })
        ]
    });
PaginationPrevious.displayName = "PaginationPrevious";
const PaginationNext = ({ className, ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(PaginationLink, {
        "aria-label": "Go to next page",
        size: "default",
        className: (0, _utils.cn)("gap-1 pr-2.5", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: "Next"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                className: "h-4 w-4"
            })
        ]
    });
PaginationNext.displayName = "PaginationNext";
const PaginationEllipsis = ({ className, ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        "aria-hidden": true,
        className: (0, _utils.cn)("flex h-9 w-9 items-center justify-center", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.MoreHorizontal), {
                className: "h-4 w-4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "sr-only",
                children: "More pages"
            })
        ]
    });
PaginationEllipsis.displayName = "PaginationEllipsis";

},{"react/jsx-runtime":"dQjte","react":"eGun2","lucide-react":[["ChevronLeft","gT7FB","default"],["ChevronRight","lOb49","default"],["MoreHorizontal","lv8Ja","default"]],"@/client/lib/utils":"1ankz","@/client/components/ui/button":"armlb","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"lv8Ja":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Ellipsis);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ],
    [
        "circle",
        {
            cx: "19",
            cy: "12",
            r: "1",
            key: "1wjl8i"
        }
    ],
    [
        "circle",
        {
            cx: "5",
            cy: "12",
            r: "1",
            key: "1pcz8c"
        }
    ]
];
const Ellipsis = (0, _createLucideIconJsDefault.default)("ellipsis", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3h6Rn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _dateFns = require("date-fns");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _config = require("@/client/config");
var _pipelineLogsStore = require("@/client/store/pipelineLogsStore");
var _button = require("@/client/components/ui/button");
var _input = require("@/client/components/ui/input");
var _badge = require("@/client/components/ui/badge");
var _select = require("@/client/components/ui/select");
var _lucideReact = require("lucide-react");
var _dropdownMenu = require("@/client/components/ui/dropdown-menu");
var _popover = require("@/client/components/ui/popover");
var _checkbox = require("@/client/components/ui/checkbox");
var _utils = require("@/client/lib/utils");
var _types = require("@shared/types");
// Quick range presets (max ~3 months per API constraint)
const QUICK_RANGES = [
    {
        label: '1h',
        hours: 1
    },
    {
        label: '6h',
        hours: 6
    },
    {
        label: '12h',
        hours: 12
    },
    {
        label: '24h',
        hours: 24
    },
    {
        label: '48h',
        hours: 48
    },
    {
        label: '72h',
        hours: 72
    },
    {
        label: '7d',
        hours: 168
    },
    {
        label: '1m',
        hours: 730
    },
    {
        label: '3m',
        hours: 2191
    }
];
const SEARCH_TYPES = [
    {
        value: 'eventID',
        label: 'Event ID'
    },
    {
        value: 'clientID',
        label: 'Client ID'
    },
    {
        value: 'encoderID',
        label: 'Encoder ID'
    },
    {
        value: 'assetID',
        label: 'Asset ID'
    },
    {
        value: 'freetext',
        label: 'Free Text'
    }
];
const LOG_TYPES = [
    {
        value: 'critical',
        label: 'Critical',
        color: 'bg-red-500'
    },
    {
        value: 'error',
        label: 'Error',
        color: 'bg-red-400'
    },
    {
        value: 'warning',
        label: 'Warning',
        color: 'bg-amber-400'
    },
    {
        value: 'info',
        label: 'Info',
        color: 'bg-blue-400'
    },
    {
        value: 'debug',
        label: 'Debug',
        color: 'bg-gray-400'
    }
];
const QUICK_PRESETS = [
    {
        label: 'Health Check',
        description: 'Recent errors, warnings & critical issues',
        searchType: 'freetext',
        searchValue: 'error OR warning OR fail',
        logTypes: [
            'critical',
            'error',
            'warning'
        ],
        range: '24h'
    },
    {
        label: 'Infrastructure Errors',
        description: 'Critical + error level messages',
        searchType: 'freetext',
        searchValue: 'EC2 OR AWS OR scale OR egress',
        logTypes: [
            'critical',
            'error'
        ],
        range: '24h'
    },
    {
        label: 'Egress Capacity',
        description: 'NO EGRESS and scaling warnings',
        searchType: 'freetext',
        searchValue: 'NO EGRESS',
        logTypes: [
            'warning',
            'error'
        ],
        range: '24h'
    },
    {
        label: 'FTP Failures',
        description: 'CDN sync and FTP transfer issues',
        searchType: 'freetext',
        searchValue: 'ftp_',
        logTypes: [
            'critical',
            'error'
        ],
        range: '48h'
    },
    {
        label: 'Transcode Stuck',
        description: 'Transcode processing issues',
        searchType: 'freetext',
        searchValue: 'transcode',
        logTypes: [
            'error',
            'warning'
        ],
        range: '24h'
    }
];
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'pipeline-logs',
    validateSearch: (search)=>{
        return {
            searchType: typeof search.searchType === 'string' ? search.searchType : undefined,
            searchValue: typeof search.searchValue === 'string' ? search.searchValue : undefined,
            range: typeof search.range === 'string' ? search.range : undefined,
            logTypes: typeof search.logTypes === 'string' ? search.logTypes : undefined
        };
    },
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: PipelineLogsComponent
});
function getDateRangeFromQuickRange(rangeLabel) {
    const now = new Date();
    const range = QUICK_RANGES.find((r)=>r.label === rangeLabel) || QUICK_RANGES[0];
    const start = range.hours <= 72 ? (0, _dateFns.subHours)(now, range.hours) : (0, _dateFns.subDays)(now, range.hours / 24);
    return {
        dateFrom: start.toISOString(),
        dateTo: now.toISOString()
    };
}
function PipelineLogsComponent() {
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    const navigate = (0, _reactRouter.useNavigate)();
    const searchParams = (0, _reactRouter.useSearch)({
        from: '/pipeline-logs'
    });
    // Local form state
    const [searchType, setSearchType] = (0, _react.useState)(searchParams.searchType || 'eventID');
    const [searchValue, setSearchValue] = (0, _react.useState)(searchParams.searchValue || '');
    const [range, setRange] = (0, _react.useState)(searchParams.range || '24h');
    const [selectedLogTypes, setSelectedLogTypes] = (0, _react.useState)(()=>{
        if (searchParams.logTypes) {
            const types = searchParams.logTypes.split(',').filter((t)=>[
                    'critical',
                    'error',
                    'warning',
                    'info',
                    'debug'
                ].includes(t));
            return new Set(types);
        }
        return new Set(); // empty = all types
    });
    // Expanded state for timeline entries
    const [expandedIds, setExpandedIds] = (0, _react.useState)(new Set());
    // Export all state
    const [exporting, setExporting] = (0, _react.useState)(false);
    // Store state
    const logs = (0, _pipelineLogsStore.usePipelineLogsStore)((s)=>s.logs);
    const hasMore = (0, _pipelineLogsStore.usePipelineLogsStore)((s)=>s.hasMore);
    const meta = (0, _pipelineLogsStore.usePipelineLogsStore)((s)=>s.meta);
    const loading = (0, _pipelineLogsStore.usePipelineLogsStore)((s)=>s.loading);
    const error = (0, _pipelineLogsStore.usePipelineLogsStore)((s)=>s.error);
    const fetchLogs = (0, _pipelineLogsStore.usePipelineLogsStore)((s)=>s.fetchLogs);
    const handleSearch = (0, _react.useCallback)(async ()=>{
        if (!searchValue.trim()) return;
        const logTypesParam = selectedLogTypes.size > 0 ? Array.from(selectedLogTypes).join(',') : undefined;
        // Update URL with search params
        navigate({
            to: '/pipeline-logs',
            search: {
                searchType,
                searchValue: searchValue.trim(),
                range,
                logTypes: logTypesParam
            }
        });
        try {
            const token = await getAccessTokenSilently();
            const { dateFrom, dateTo } = getDateRangeFromQuickRange(range);
            await fetchLogs(token, logout, {
                searchType,
                searchValue: searchValue.trim(),
                dateFrom,
                dateTo,
                logTypes: logTypesParam,
                limit: (0, _types.PIPELINE_CONFIG).DEFAULT_LIMIT
            });
        } catch (err) {
            console.error('Error fetching pipeline logs:', err);
        }
    }, [
        searchType,
        searchValue,
        range,
        selectedLogTypes,
        getAccessTokenSilently,
        fetchLogs,
        logout,
        navigate
    ]);
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter') handleSearch();
    };
    const handleLoadMore = (0, _react.useCallback)(async (newOffset)=>{
        if (!searchValue.trim()) return;
        const logTypesParam = selectedLogTypes.size > 0 ? Array.from(selectedLogTypes).join(',') : undefined;
        try {
            const token = await getAccessTokenSilently();
            const { dateFrom, dateTo } = getDateRangeFromQuickRange(range);
            await fetchLogs(token, logout, {
                searchType,
                searchValue: searchValue.trim(),
                dateFrom,
                dateTo,
                logTypes: logTypesParam,
                limit: (0, _types.PIPELINE_CONFIG).DEFAULT_LIMIT,
                offset: newOffset
            });
        } catch (err) {
            console.error('Error fetching more pipeline logs:', err);
        }
    }, [
        searchType,
        searchValue,
        range,
        selectedLogTypes,
        getAccessTokenSilently,
        fetchLogs,
        logout
    ]);
    const toggleExpanded = (0, _react.useCallback)((id)=>{
        setExpandedIds((prev)=>{
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    }, []);
    const expandAll = (0, _react.useCallback)(()=>{
        setExpandedIds(new Set(logs.map((log)=>log.id)));
    }, [
        logs
    ]);
    const collapseAll = (0, _react.useCallback)(()=>{
        setExpandedIds(new Set());
    }, []);
    const toggleLogType = (0, _react.useCallback)((type)=>{
        setSelectedLogTypes((prev)=>{
            const next = new Set(prev);
            if (next.has(type)) next.delete(type);
            else next.add(type);
            return next;
        });
    }, []);
    const applyPreset = (0, _react.useCallback)((preset)=>{
        setSearchType(preset.searchType);
        setSearchValue(preset.searchValue);
        setRange(preset.range);
        setSelectedLogTypes(new Set(preset.logTypes));
    }, []);
    // Export to CSV (truncated message for readability)
    const exportToCSV = (0, _react.useCallback)(()=>{
        if (logs.length === 0) return;
        // Add metadata comment rows at top
        const metaRows = [
            `# Pipeline Logs Export - ${(0, _dateFns.format)(new Date(), 'yyyy-MM-dd HH:mm:ss')}`,
            `# Search: ${searchType} = ${searchValue}`,
            meta ? `# Date Range: ${(0, _dateFns.format)(new Date(meta.dateFrom), 'MMM d yyyy HH:mm')} - ${(0, _dateFns.format)(new Date(meta.dateTo), 'MMM d yyyy HH:mm')}` : '',
            `# Showing ${logs.length} entries${hasMore ? ' (PARTIAL - more results available, use pagination to view all)' : ''}`,
            ''
        ].filter(Boolean);
        const headers = [
            'Timestamp',
            'Severity',
            'Category',
            'Action',
            'Event ID',
            'Client ID',
            'Encoder ID',
            'Encoder Name',
            'Asset ID',
            'Error',
            'Message Preview'
        ];
        const rows = logs.map((log)=>{
            // Create a clean message preview - extract key info or truncate
            let messagePreview = log.extracted.errorMessage || '';
            if (!messagePreview) {
                // For non-JSON messages, use truncated raw text
                const cleaned = log.rawMessage.replace(/\n/g, ' ').replace(/"/g, "'");
                messagePreview = cleaned.length > 150 ? cleaned.slice(0, 150) + '...' : cleaned;
            }
            return [
                (0, _dateFns.format)(new Date(log.logDate), 'yyyy-MM-dd HH:mm:ss'),
                log.type,
                log.extracted.category || '',
                log.extracted.action || '',
                log.extracted.eventID || '',
                log.extracted.clientID || '',
                log.extracted.encoderID || '',
                log.extracted.encoderName || '',
                log.extracted.assetID || '',
                log.extracted.errorMessage || '',
                `"${messagePreview}"`
            ];
        });
        const csvContent = [
            ...metaRows,
            headers.join(','),
            ...rows.map((row)=>row.join(','))
        ].join('\n');
        const blob = new Blob([
            csvContent
        ], {
            type: 'text/csv;charset=utf-8;'
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const partialSuffix = hasMore ? '-partial' : '';
        link.download = `pipeline-logs-${searchType}-${searchValue}${partialSuffix}-${(0, _dateFns.format)(new Date(), "yyyyMMdd'T'HHmmss")}.csv`;
        link.click();
        URL.revokeObjectURL(url);
    }, [
        logs,
        meta,
        hasMore,
        searchType,
        searchValue
    ]);
    // Export to JSON (full data)
    const exportToJSON = (0, _react.useCallback)(()=>{
        if (logs.length === 0) return;
        const exportData = {
            exportDate: new Date().toISOString(),
            search: {
                type: searchType,
                value: searchValue
            },
            dateRange: meta ? {
                from: meta.dateFrom,
                to: meta.dateTo
            } : null,
            count: logs.length,
            hasMore,
            logs: logs.map((log)=>({
                    ...log,
                    logDate: log.logDate
                }))
        };
        const jsonContent = JSON.stringify(exportData, null, 2);
        const blob = new Blob([
            jsonContent
        ], {
            type: 'application/json;charset=utf-8;'
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `pipeline-logs-${searchType}-${searchValue}-${(0, _dateFns.format)(new Date(), "yyyyMMdd'T'HHmmss")}.json`;
        link.click();
        URL.revokeObjectURL(url);
    }, [
        logs,
        meta,
        hasMore,
        searchType,
        searchValue
    ]);
    // Export to Plain Text
    const exportToText = (0, _react.useCallback)(()=>{
        if (logs.length === 0) return;
        const header = [
            'Pipeline Logs Export',
            "\u2550".repeat(50),
            `Search: ${searchType} = ${searchValue}`,
            meta ? `Date Range: ${(0, _dateFns.format)(new Date(meta.dateFrom), 'MMM d, yyyy HH:mm')} - ${(0, _dateFns.format)(new Date(meta.dateTo), 'MMM d, yyyy HH:mm')}` : '',
            `Showing ${logs.length} entries${hasMore ? ' (more available)' : ''}`,
            "\u2500".repeat(50),
            ''
        ].join('\n');
        const entries = logs.map((log)=>{
            const lines = [
                `${(0, _dateFns.format)(new Date(log.logDate), 'HH:mm:ss')} [${log.type}] ${log.extracted.category || ''}${log.extracted.action ? '/' + log.extracted.action : ''}`
            ];
            // Add extracted IDs
            const ids = [];
            if (log.extracted.eventID) ids.push(`Event: ${log.extracted.eventID}`);
            if (log.extracted.clientID) ids.push(`Client: ${log.extracted.clientID}`);
            if (log.extracted.encoderID) ids.push(`Encoder: ${log.extracted.encoderID}`);
            if (log.extracted.assetID) ids.push(`Asset: ${log.extracted.assetID.slice(0, 16)}...`);
            if (ids.length > 0) lines.push(`  ${ids.join(' | ')}`);
            // Add error message if present
            if (log.extracted.errorMessage) lines.push(`  Error: ${log.extracted.errorMessage}`);
            // Add message preview (truncated for readability)
            const msgPreview = log.rawMessage.slice(0, 200).replace(/\n/g, ' ');
            lines.push(`  ${msgPreview}${log.rawMessage.length > 200 ? '...' : ''}`);
            return lines.join('\n');
        }).join('\n\n');
        const textContent = header + entries;
        const blob = new Blob([
            textContent
        ], {
            type: 'text/plain;charset=utf-8;'
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `pipeline-logs-${searchType}-${searchValue}-${(0, _dateFns.format)(new Date(), "yyyyMMdd'T'HHmmss")}.txt`;
        link.click();
        URL.revokeObjectURL(url);
    }, [
        logs,
        meta,
        hasMore,
        searchType,
        searchValue
    ]);
    // Export ALL matching logs via server-side endpoint (bypasses pagination)
    const exportAll = (0, _react.useCallback)(async ()=>{
        if (!meta || exporting) return;
        setExporting(true);
        try {
            const token = await getAccessTokenSilently();
            const params = new URLSearchParams();
            params.set('searchType', searchType);
            params.set('searchValue', searchValue);
            params.set('dateFrom', meta.dateFrom);
            params.set('dateTo', meta.dateTo);
            const logTypesParam = selectedLogTypes.size > 0 ? Array.from(selectedLogTypes).join(',') : undefined;
            if (logTypesParam) params.set('logTypes', logTypesParam);
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/pipeline/logs/export?${params}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error(`Export failed: ${response.statusText}`);
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `pipeline-logs-${searchType}-${searchValue}-all-${(0, _dateFns.format)(new Date(), "yyyyMMdd'T'HHmmss")}.csv`;
            link.click();
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Export all failed:', err);
        } finally{
            setExporting(false);
        }
    }, [
        meta,
        exporting,
        searchType,
        searchValue,
        selectedLogTypes,
        getAccessTokenSilently
    ]);
    // Pagination controls - reused at top and bottom of results
    const PaginationControls = ({ showLabel = false })=>{
        if (!meta || meta.offset === 0 && !hasMore) return null;
        const currentPage = Math.floor(meta.offset / (0, _types.PIPELINE_CONFIG).DEFAULT_LIMIT) + 1;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                    variant: "outline",
                    size: "sm",
                    disabled: loading || meta.offset === 0,
                    onClick: ()=>handleLoadMore(Math.max(0, meta.offset - (0, _types.PIPELINE_CONFIG).DEFAULT_LIMIT)),
                    children: "Previous"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "text-sm text-muted-foreground min-w-[60px] text-center",
                    children: [
                        "Page ",
                        currentPage
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                    variant: "outline",
                    size: "sm",
                    disabled: loading || !hasMore,
                    onClick: ()=>handleLoadMore(meta.offset + (0, _types.PIPELINE_CONFIG).DEFAULT_LIMIT),
                    children: "Next"
                }),
                showLabel && hasMore && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-sm text-muted-foreground ml-2",
                    children: "\xb7 more available"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-wrap items-start justify-between gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    className: "text-2xl font-semibold",
                                    children: "Pipeline Message Log"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-muted-foreground",
                                    children: "Search and debug pipeline events by entity ID"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _popover.Popover), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.PopoverTrigger), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                        variant: "outline",
                                        size: "sm",
                                        children: [
                                            "Quick Searches",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                className: "h-4 w-4 ml-2"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.PopoverContent), {
                                    className: "w-[220px] p-2",
                                    align: "end",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "space-y-1",
                                        children: QUICK_PRESETS.map((preset)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                className: "w-full text-left px-2 py-1.5 rounded hover:bg-muted",
                                                onClick: ()=>applyPreset(preset),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-sm font-medium",
                                                        children: preset.label
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "text-xs text-muted-foreground",
                                                        children: preset.description
                                                    })
                                                ]
                                            }, preset.label))
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-wrap gap-3 items-end p-4 bg-muted/30 rounded-lg border",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    className: "text-xs text-muted-foreground",
                                    children: "Search By"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                                    value: searchType,
                                    onValueChange: (v)=>setSearchType(v),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectTrigger), {
                                            className: "w-[140px]",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectValue), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectContent), {
                                            children: SEARCH_TYPES.map((t)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                                    value: t.value,
                                                    children: t.label
                                                }, t.value))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-1 flex-1 min-w-[200px]",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    className: "text-xs text-muted-foreground",
                                    children: "Value"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                    placeholder: `Enter ${searchType}...`,
                                    value: searchValue,
                                    onChange: (e)=>setSearchValue(e.target.value),
                                    onKeyDown: handleKeyDown,
                                    className: "w-full"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    className: "text-xs text-muted-foreground",
                                    children: "Time Range"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                                    value: range,
                                    onValueChange: (v)=>setRange(v),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectTrigger), {
                                            className: "w-[100px]",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectValue), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectContent), {
                                            children: QUICK_RANGES.map((r)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                                    value: r.label,
                                                    children: r.label
                                                }, r.label))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    className: "text-xs text-muted-foreground",
                                    children: "Severity"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _popover.Popover), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.PopoverTrigger), {
                                                asChild: true,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                    variant: "outline",
                                                    className: "w-[140px] justify-between font-normal",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "truncate",
                                                            children: selectedLogTypes.size === 0 ? 'All Levels' : selectedLogTypes.size === 1 ? LOG_TYPES.find((t)=>selectedLogTypes.has(t.value))?.label : `${selectedLogTypes.size} selected`
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                            className: "h-4 w-4 opacity-50 ml-2 flex-shrink-0"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.PopoverContent), {
                                                className: "w-[160px] p-2",
                                                align: "start",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "space-y-1",
                                                    children: [
                                                        LOG_TYPES.map((t)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                                className: "flex items-center gap-2 px-2 py-1.5 rounded hover:bg-muted cursor-pointer",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                                                        checked: selectedLogTypes.has(t.value),
                                                                        onCheckedChange: ()=>toggleLogType(t.value)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: (0, _utils.cn)('h-2 w-2 rounded-full', t.color)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "text-sm",
                                                                        children: t.label
                                                                    })
                                                                ]
                                                            }, t.value)),
                                                        selectedLogTypes.size > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "border-t my-1"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                                    variant: "ghost",
                                                                    size: "sm",
                                                                    className: "w-full h-7 text-xs",
                                                                    onClick: ()=>setSelectedLogTypes(new Set()),
                                                                    children: "Clear All"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                            onClick: handleSearch,
                            disabled: loading || !searchValue.trim(),
                            children: [
                                loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Loader2), {
                                    className: "h-4 w-4 mr-2 animate-spin"
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Search), {
                                    className: "h-4 w-4 mr-2"
                                }),
                                "Search"
                            ]
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "p-4 bg-destructive/10 border border-destructive/20 rounded-lg flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertCircle), {
                            className: "h-4 w-4 text-destructive"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "text-destructive",
                            children: error
                        })
                    ]
                }),
                logs.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex justify-between items-center flex-wrap gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "text-sm text-muted-foreground",
                                            children: [
                                                "Showing ",
                                                logs.length,
                                                " results",
                                                hasMore && ' (more available)'
                                            ]
                                        }),
                                        meta && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "text-xs text-muted-foreground",
                                            children: [
                                                "(",
                                                (0, _dateFns.format)(new Date(meta.dateFrom), 'MMM d, HH:mm'),
                                                " - ",
                                                (0, _dateFns.format)(new Date(meta.dateTo), 'MMM d, HH:mm'),
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-muted-foreground",
                                            children: "\xb7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            variant: "ghost",
                                            size: "sm",
                                            className: "h-6 px-2 text-xs",
                                            onClick: expandAll,
                                            children: "Expand All"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            variant: "ghost",
                                            size: "sm",
                                            className: "h-6 px-2 text-xs",
                                            onClick: collapseAll,
                                            children: "Collapse All"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-muted-foreground",
                                            children: "\xb7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenu), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuTrigger), {
                                                    asChild: true,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                        variant: "ghost",
                                                        size: "sm",
                                                        className: "h-6 px-2 text-xs",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                                                className: "h-3 w-3 mr-1"
                                                            }),
                                                            "Export"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenuContent), {
                                                    align: "start",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                            onClick: exportToCSV,
                                                            children: "Export Page as CSV"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                            onClick: exportToText,
                                                            children: "Export Page as Text"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                            onClick: exportToJSON,
                                                            children: "Export Page as JSON"
                                                        }),
                                                        hasMore && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuSeparator), {}),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                                    onClick: exportAll,
                                                                    disabled: exporting,
                                                                    children: exporting ? 'Exporting...' : 'Export All Matching (CSV)'
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationControls, {})
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "absolute left-[19px] top-0 bottom-0 w-px bg-border"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "space-y-1",
                                    children: logs.map((log, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(TimelineEntry, {
                                            log: log,
                                            isFirst: index === 0,
                                            isLast: index === logs.length - 1,
                                            isExpanded: expandedIds.has(log.id),
                                            onToggle: ()=>toggleExpanded(log.id)
                                        }, log.id))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "flex justify-center pt-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationControls, {
                                showLabel: true
                            })
                        })
                    ]
                }),
                !loading && logs.length === 0 && searchParams.searchValue && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "text-center py-12 text-muted-foreground",
                    children: "No logs found for the specified search criteria."
                }),
                !loading && logs.length === 0 && !searchParams.searchValue && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "text-center py-12 text-muted-foreground",
                    children: "Enter a search value above to find pipeline logs."
                })
            ]
        })
    });
}
const SEVERITY_COLORS = {
    critical: 'bg-red-500 ring-red-500/20',
    error: 'bg-red-400 ring-red-400/20',
    warning: 'bg-amber-400 ring-amber-400/20',
    info: 'bg-blue-400 ring-blue-400/20',
    debug: 'bg-gray-400 ring-gray-400/20'
};
const ACTION_COLORS = {
    connect: 'text-green-600 dark:text-green-400',
    connected: 'text-green-600 dark:text-green-400',
    disconnected: 'text-orange-500 dark:text-orange-400',
    reconnected: 'text-green-600 dark:text-green-400',
    starting: 'text-blue-500 dark:text-blue-400',
    stopping: 'text-blue-500 dark:text-blue-400',
    completed: 'text-green-600 dark:text-green-400',
    processing: 'text-muted-foreground',
    scale: 'text-yellow-600 dark:text-yellow-400',
    error: 'text-red-500 dark:text-red-400'
};
const CATEGORY_COLORS = {
    encoder: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
    transcode: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
    events: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
    egress: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300',
    asset: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-300',
    infrastructure: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
    storage: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300',
    email: 'bg-pink-100 text-pink-700 dark:bg-pink-900/30 dark:text-pink-300',
    other: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400'
};
/**
 * Format raw message - pretty-print JSON if valid, otherwise return as-is
 */ function formatRawMessage(message) {
    // Handle PLAYER: prefix
    const jsonPart = message.startsWith('PLAYER: ') ? message.slice(8) : message;
    // Try to parse and pretty-print JSON
    if (jsonPart.startsWith('{')) try {
        const parsed = JSON.parse(jsonPart);
        const formatted = JSON.stringify(parsed, null, 2);
        return message.startsWith('PLAYER: ') ? `PLAYER: ${formatted}` : formatted;
    } catch  {
        // Not valid JSON (truncated), return as-is
        return message;
    }
    return message;
}
/**
 * Generate a preview string for the collapsed view
 */ function getMessagePreview(log) {
    // If we have an extracted error message, show that
    if (log.extracted.errorMessage) return log.extracted.errorMessage.slice(0, 60) + (log.extracted.errorMessage.length > 60 ? '...' : '');
    // For plain text messages (not JSON), show a truncated preview
    const msg = log.rawMessage;
    if (!msg.startsWith('{') && !msg.startsWith('PLAYER: {')) {
        // Skip if message is very short or already covered by action/category
        if (msg.length < 20) return null;
        return msg.slice(0, 80) + (msg.length > 80 ? '...' : '');
    }
    // For JSON messages, try to extract a meaningful summary
    if (log.extracted.streamName) return `stream: ${log.extracted.streamName}`;
    if (log.extracted.assetID) return `asset: ${log.extracted.assetID.slice(0, 12)}...`;
    return null;
}
function TimelineEntry({ log, isExpanded, onToggle }) {
    const preview = getMessagePreview(log);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "relative pl-10",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _utils.cn)('absolute left-[15px] top-3 h-2.5 w-2.5 rounded-full ring-4 ring-background z-10', SEVERITY_COLORS[log.type] || 'bg-gray-400')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _utils.cn)('p-3 rounded-lg border transition-all', isExpanded && 'bg-muted/30 border-foreground/10'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-2 flex-wrap cursor-pointer hover:bg-muted/20 -m-1 p-1 rounded",
                        onClick: onToggle,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                                className: (0, _utils.cn)('h-4 w-4 text-muted-foreground transition-transform flex-shrink-0', isExpanded && 'rotate-90')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-xs text-muted-foreground font-mono flex-shrink-0",
                                children: (0, _dateFns.format)(new Date(log.logDate), 'HH:mm:ss')
                            }),
                            log.extracted.category && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: (0, _utils.cn)('text-xs px-1.5 py-0.5 rounded font-medium', CATEGORY_COLORS[log.extracted.category]),
                                children: log.extracted.category
                            }),
                            log.extracted.action && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: (0, _utils.cn)('text-xs font-medium', ACTION_COLORS[log.extracted.action]),
                                children: log.extracted.action
                            }),
                            log.type !== 'info' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                variant: "outline",
                                className: (0, _utils.cn)('text-xs', log.type === 'critical' && 'border-red-500 text-red-500', log.type === 'error' && 'border-red-400 text-red-400', log.type === 'warning' && 'border-amber-500 text-amber-500', log.type === 'debug' && 'border-gray-400 text-gray-400'),
                                children: log.type
                            }),
                            log.isTruncated && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                variant: "secondary",
                                className: "text-xs",
                                children: "truncated"
                            }),
                            preview && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-xs text-muted-foreground truncate max-w-[300px] hidden sm:inline",
                                title: preview,
                                children: preview
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex gap-2 ml-auto text-xs font-mono text-muted-foreground flex-shrink-0",
                                children: [
                                    log.extracted.encoderName && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "text-purple-600 dark:text-purple-400",
                                        children: log.extracted.encoderName
                                    }),
                                    log.extracted.eventID && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        children: [
                                            "e:",
                                            log.extracted.eventID
                                        ]
                                    }),
                                    log.extracted.encoderID && !log.extracted.encoderName && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        children: [
                                            "enc:",
                                            log.extracted.encoderID
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isExpanded && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mt-3 pt-3 border-t border-dashed space-y-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-2 md:grid-cols-4 gap-2 text-xs",
                                children: [
                                    log.extracted.clientID && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-muted-foreground",
                                                children: "Client:"
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                                to: "/clients/$clientID",
                                                params: {
                                                    clientID: log.extracted.clientID
                                                },
                                                className: "font-mono text-blue-600 dark:text-blue-400 hover:underline inline-flex items-center gap-1",
                                                onClick: (e)=>e.stopPropagation(),
                                                children: [
                                                    log.extracted.clientID,
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ExternalLink), {
                                                        className: "h-3 w-3"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    log.extracted.eventID && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-muted-foreground",
                                                children: "Event:"
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-mono",
                                                children: log.extracted.eventID
                                            })
                                        ]
                                    }),
                                    log.extracted.encoderID && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-muted-foreground",
                                                children: "Encoder:"
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                                to: "/encoders/$encoderID",
                                                params: {
                                                    encoderID: log.extracted.encoderID
                                                },
                                                className: "font-mono text-blue-600 dark:text-blue-400 hover:underline inline-flex items-center gap-1",
                                                onClick: (e)=>e.stopPropagation(),
                                                children: [
                                                    log.extracted.encoderID,
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ExternalLink), {
                                                        className: "h-3 w-3"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    log.extracted.assetID && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-muted-foreground",
                                                children: "Asset:"
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "font-mono",
                                                children: [
                                                    log.extracted.assetID.slice(0, 16),
                                                    "..."
                                                ]
                                            })
                                        ]
                                    }),
                                    log.extracted.instanceID && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-muted-foreground",
                                                children: "Instance:"
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-mono",
                                                children: log.extracted.instanceID
                                            })
                                        ]
                                    }),
                                    log.extracted.ipAddress && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-muted-foreground",
                                                children: "IP:"
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-mono",
                                                children: log.extracted.ipAddress
                                            })
                                        ]
                                    }),
                                    log.extracted.streamName && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-muted-foreground",
                                                children: "Stream:"
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-mono",
                                                children: log.extracted.streamName
                                            })
                                        ]
                                    }),
                                    log.extracted.transcodeID && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-muted-foreground",
                                                children: "Transcode:"
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "font-mono",
                                                children: [
                                                    log.extracted.transcodeID.slice(0, 8),
                                                    "..."
                                                ]
                                            })
                                        ]
                                    }),
                                    log.extracted.errorFile && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "col-span-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-muted-foreground",
                                                children: "File:"
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "font-mono text-red-600 dark:text-red-400",
                                                children: [
                                                    log.extracted.errorFile,
                                                    log.extracted.errorLine && `:${log.extracted.errorLine}`
                                                ]
                                            })
                                        ]
                                    }),
                                    log.extracted.errorClass && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-muted-foreground",
                                                children: "Class:"
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "font-mono text-red-600 dark:text-red-400",
                                                children: log.extracted.errorClass
                                            })
                                        ]
                                    }),
                                    log.extracted.errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "col-span-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-muted-foreground",
                                                children: "Error:"
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "text-red-600 dark:text-red-400",
                                                children: log.extracted.errorMessage
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "bg-muted/50 rounded p-2 overflow-x-auto",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                                    className: "text-xs font-mono whitespace-pre-wrap break-all leading-relaxed",
                                    children: formatRawMessage(log.rawMessage)
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["Link","7k6Lq"],["redirect","jmFxY"],["useNavigate","aMhxM"],["useSearch","4yVFL"]],"@auth0/auth0-react":"gpXrE","date-fns":[["format","4NYjc"],["subDays","gyc2T"],["subHours","3Dxf0"]],"../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/config":"8SWgh","@/client/store/pipelineLogsStore":"2TIlI","@/client/components/ui/button":"armlb","@/client/components/ui/input":"8UHwi","@/client/components/ui/badge":"h4e1f","@/client/components/ui/select":"7QcOK","lucide-react":[["AlertCircle","65jRl","default"],["ChevronDown","kVmgC","default"],["ChevronRight","lOb49","default"],["Download","eRiW1","default"],["ExternalLink","kIIQA","default"],["Loader2","gZHhk","default"],["Search","7AEK5","default"]],"@/client/components/ui/dropdown-menu":"8ox96","@/client/components/ui/popover":"aASXh","@/client/components/ui/checkbox":"fh9Pm","@/client/lib/utils":"1ankz","@shared/types":"dzHsw","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2TIlI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePipelineLogsStore", ()=>usePipelineLogsStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
var _config = require("@/client/config");
var _apiError = require("@/client/lib/apiError");
const usePipelineLogsStore = (0, _zustand.create)()((0, _middleware.devtools)((set)=>({
        // Initial state
        logs: [],
        hasMore: false,
        lastSearchParams: null,
        meta: null,
        loading: false,
        error: null,
        fetchLogs: async (accessToken, logout, params)=>{
            set({
                loading: true,
                error: null
            });
            try {
                const searchParams = new URLSearchParams();
                searchParams.set('searchType', params.searchType);
                searchParams.set('searchValue', params.searchValue);
                searchParams.set('dateFrom', params.dateFrom);
                if (params.dateTo) searchParams.set('dateTo', params.dateTo);
                // Prefer logTypes (multi-select) over logType (single)
                if (params.logTypes) searchParams.set('logTypes', params.logTypes);
                else if (params.logType) searchParams.set('logType', params.logType);
                if (params.limit) searchParams.set('limit', params.limit.toString());
                if (params.offset) searchParams.set('offset', params.offset.toString());
                const url = `${(0, _config.API_BASE_URL)}/api/pipeline/logs?${searchParams}`;
                const response = await fetch(url, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    }
                });
                if (!response.ok) {
                    if ((0, _apiError.handleApiError)(response, logout)) return;
                    throw new Error(`Failed to fetch pipeline logs: ${response.statusText}`);
                }
                const data = await response.json();
                set({
                    logs: data.logs,
                    hasMore: data.meta.hasMore,
                    lastSearchParams: params,
                    meta: {
                        dateFrom: data.meta.dateFrom,
                        dateTo: data.meta.dateTo,
                        limit: data.meta.limit,
                        offset: data.meta.offset
                    },
                    loading: false
                });
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
                set({
                    error: errorMessage,
                    loading: false
                });
            }
        },
        clearLogs: ()=>{
            set({
                logs: [],
                hasMore: false,
                lastSearchParams: null,
                meta: null,
                error: null
            });
        }
    }), {
    name: 'pipeline-logs-store'
}));

},{"zustand":"Ze5I5","zustand/middleware":"9udS2","@/client/config":"8SWgh","@/client/lib/apiError":"aL0RR","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7QcOK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", ()=>Select);
parcelHelpers.export(exports, "SelectGroup", ()=>SelectGroup);
parcelHelpers.export(exports, "SelectValue", ()=>SelectValue);
parcelHelpers.export(exports, "SelectTrigger", ()=>SelectTrigger);
parcelHelpers.export(exports, "SelectContent", ()=>SelectContent);
parcelHelpers.export(exports, "SelectLabel", ()=>SelectLabel);
parcelHelpers.export(exports, "SelectItem", ()=>SelectItem);
parcelHelpers.export(exports, "SelectSeparator", ()=>SelectSeparator);
parcelHelpers.export(exports, "SelectScrollUpButton", ()=>SelectScrollUpButton);
parcelHelpers.export(exports, "SelectScrollDownButton", ()=>SelectScrollDownButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactSelect = require("@radix-ui/react-select");
var _lucideReact = require("lucide-react");
var _utils = require("@/client/lib/utils");
const Select = _reactSelect.Root;
const SelectGroup = _reactSelect.Group;
const SelectValue = _reactSelect.Value;
const SelectTrigger = /*#__PURE__*/ _react.forwardRef(({ className, children, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactSelect.Trigger, {
        ref: ref,
        className: (0, _utils.cn)("flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background data-[placeholder]:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1", className),
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactSelect.Icon, {
                asChild: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                    className: "h-4 w-4 opacity-50"
                })
            })
        ]
    }));
SelectTrigger.displayName = _reactSelect.Trigger.displayName;
const SelectScrollUpButton = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactSelect.ScrollUpButton, {
        ref: ref,
        className: (0, _utils.cn)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronUp), {
            className: "h-4 w-4"
        })
    }));
SelectScrollUpButton.displayName = _reactSelect.ScrollUpButton.displayName;
const SelectScrollDownButton = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactSelect.ScrollDownButton, {
        ref: ref,
        className: (0, _utils.cn)("flex cursor-default items-center justify-center py-1", className),
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
            className: "h-4 w-4"
        })
    }));
SelectScrollDownButton.displayName = _reactSelect.ScrollDownButton.displayName;
const SelectContent = /*#__PURE__*/ _react.forwardRef(({ className, children, position = "popper", ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactSelect.Portal, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactSelect.Content, {
            ref: ref,
            className: (0, _utils.cn)("relative z-50 max-h-[--radix-select-content-available-height] min-w-[8rem] overflow-y-auto overflow-x-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-select-content-transform-origin]", position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", className),
            position: position,
            ...props,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectScrollUpButton, {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactSelect.Viewport, {
                    className: (0, _utils.cn)("p-1", position === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"),
                    children: children
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectScrollDownButton, {})
            ]
        })
    }));
SelectContent.displayName = _reactSelect.Content.displayName;
const SelectLabel = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactSelect.Label, {
        ref: ref,
        className: (0, _utils.cn)("py-1.5 pl-8 pr-2 text-sm font-semibold", className),
        ...props
    }));
SelectLabel.displayName = _reactSelect.Label.displayName;
const SelectItem = /*#__PURE__*/ _react.forwardRef(({ className, children, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactSelect.Item, {
        ref: ref,
        className: (0, _utils.cn)("relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className),
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactSelect.ItemIndicator, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                        className: "h-4 w-4"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactSelect.ItemText, {
                children: children
            })
        ]
    }));
SelectItem.displayName = _reactSelect.Item.displayName;
const SelectSeparator = /*#__PURE__*/ _react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactSelect.Separator, {
        ref: ref,
        className: (0, _utils.cn)("-mx-1 my-1 h-px bg-muted", className),
        ...props
    }));
SelectSeparator.displayName = _reactSelect.Separator.displayName;

},{"react/jsx-runtime":"dQjte","react":"eGun2","@radix-ui/react-select":"5fwls","lucide-react":[["Check","bajJU","default"],["ChevronDown","kVmgC","default"],["ChevronUp","9DiT4","default"]],"@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5fwls":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Arrow", ()=>Arrow2);
parcelHelpers.export(exports, "Content", ()=>Content2);
parcelHelpers.export(exports, "Group", ()=>Group);
parcelHelpers.export(exports, "Icon", ()=>Icon);
parcelHelpers.export(exports, "Item", ()=>Item);
parcelHelpers.export(exports, "ItemIndicator", ()=>ItemIndicator);
parcelHelpers.export(exports, "ItemText", ()=>ItemText);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "Portal", ()=>Portal);
parcelHelpers.export(exports, "Root", ()=>Root2);
parcelHelpers.export(exports, "ScrollDownButton", ()=>ScrollDownButton);
parcelHelpers.export(exports, "ScrollUpButton", ()=>ScrollUpButton);
parcelHelpers.export(exports, "Select", ()=>Select);
parcelHelpers.export(exports, "SelectArrow", ()=>SelectArrow);
parcelHelpers.export(exports, "SelectContent", ()=>SelectContent);
parcelHelpers.export(exports, "SelectGroup", ()=>SelectGroup);
parcelHelpers.export(exports, "SelectIcon", ()=>SelectIcon);
parcelHelpers.export(exports, "SelectItem", ()=>SelectItem);
parcelHelpers.export(exports, "SelectItemIndicator", ()=>SelectItemIndicator);
parcelHelpers.export(exports, "SelectItemText", ()=>SelectItemText);
parcelHelpers.export(exports, "SelectLabel", ()=>SelectLabel);
parcelHelpers.export(exports, "SelectPortal", ()=>SelectPortal);
parcelHelpers.export(exports, "SelectScrollDownButton", ()=>SelectScrollDownButton);
parcelHelpers.export(exports, "SelectScrollUpButton", ()=>SelectScrollUpButton);
parcelHelpers.export(exports, "SelectSeparator", ()=>SelectSeparator);
parcelHelpers.export(exports, "SelectTrigger", ()=>SelectTrigger);
parcelHelpers.export(exports, "SelectValue", ()=>SelectValue);
parcelHelpers.export(exports, "SelectViewport", ()=>SelectViewport);
parcelHelpers.export(exports, "Separator", ()=>Separator);
parcelHelpers.export(exports, "Trigger", ()=>Trigger);
parcelHelpers.export(exports, "Value", ()=>Value);
parcelHelpers.export(exports, "Viewport", ()=>Viewport);
parcelHelpers.export(exports, "createSelectScope", ()=>createSelectScope);
// src/select.tsx
var _react = require("react");
var _reactDom = require("react-dom");
var _number = require("@radix-ui/number");
var _primitive = require("@radix-ui/primitive");
var _reactCollection = require("@radix-ui/react-collection");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactContext = require("@radix-ui/react-context");
var _reactDirection = require("@radix-ui/react-direction");
var _reactDismissableLayer = require("@radix-ui/react-dismissable-layer");
var _reactFocusGuards = require("@radix-ui/react-focus-guards");
var _reactFocusScope = require("@radix-ui/react-focus-scope");
var _reactId = require("@radix-ui/react-id");
var _reactPopper = require("@radix-ui/react-popper");
var _reactPortal = require("@radix-ui/react-portal");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactSlot = require("@radix-ui/react-slot");
var _reactUseCallbackRef = require("@radix-ui/react-use-callback-ref");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var _reactUsePrevious = require("@radix-ui/react-use-previous");
var _reactVisuallyHidden = require("@radix-ui/react-visually-hidden");
var _ariaHidden = require("aria-hidden");
var _reactRemoveScroll = require("react-remove-scroll");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var OPEN_KEYS = [
    " ",
    "Enter",
    "ArrowUp",
    "ArrowDown"
];
var SELECTION_KEYS = [
    " ",
    "Enter"
];
var SELECT_NAME = "Select";
var [Collection, useCollection, createCollectionScope] = (0, _reactCollection.createCollection)(SELECT_NAME);
var [createSelectContext, createSelectScope] = (0, _reactContext.createContextScope)(SELECT_NAME, [
    createCollectionScope,
    (0, _reactPopper.createPopperScope)
]);
var usePopperScope = (0, _reactPopper.createPopperScope)();
var [SelectProvider, useSelectContext] = createSelectContext(SELECT_NAME);
var [SelectNativeOptionsProvider, useSelectNativeOptionsContext] = createSelectContext(SELECT_NAME);
var Select = (props)=>{
    const { __scopeSelect, children, open: openProp, defaultOpen, onOpenChange, value: valueProp, defaultValue, onValueChange, dir, name, autoComplete, disabled, required, form } = props;
    const popperScope = usePopperScope(__scopeSelect);
    const [trigger, setTrigger] = _react.useState(null);
    const [valueNode, setValueNode] = _react.useState(null);
    const [valueNodeHasChildren, setValueNodeHasChildren] = _react.useState(false);
    const direction = (0, _reactDirection.useDirection)(dir);
    const [open, setOpen] = (0, _reactUseControllableState.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: SELECT_NAME
    });
    const [value, setValue] = (0, _reactUseControllableState.useControllableState)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange,
        caller: SELECT_NAME
    });
    const triggerPointerDownPosRef = _react.useRef(null);
    const isFormControl = trigger ? form || !!trigger.closest("form") : true;
    const [nativeOptionsSet, setNativeOptionsSet] = _react.useState(/* @__PURE__ */ new Set());
    const nativeSelectKey = Array.from(nativeOptionsSet).map((option)=>option.props.value).join(";");
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Root, {
        ...popperScope,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)(SelectProvider, {
            required,
            scope: __scopeSelect,
            trigger,
            onTriggerChange: setTrigger,
            valueNode,
            onValueNodeChange: setValueNode,
            valueNodeHasChildren,
            onValueNodeHasChildrenChange: setValueNodeHasChildren,
            contentId: (0, _reactId.useId)(),
            value,
            onValueChange: setValue,
            open,
            onOpenChange: setOpen,
            dir: direction,
            triggerPointerDownPosRef,
            disabled,
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.Provider, {
                    scope: __scopeSelect,
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(SelectNativeOptionsProvider, {
                        scope: props.__scopeSelect,
                        onNativeOptionAdd: _react.useCallback((option)=>{
                            setNativeOptionsSet((prev)=>new Set(prev).add(option));
                        }, []),
                        onNativeOptionRemove: _react.useCallback((option)=>{
                            setNativeOptionsSet((prev)=>{
                                const optionsSet = new Set(prev);
                                optionsSet.delete(option);
                                return optionsSet;
                            });
                        }, []),
                        children
                    })
                }),
                isFormControl ? /* @__PURE__ */ (0, _jsxRuntime.jsxs)(SelectBubbleInput, {
                    "aria-hidden": true,
                    required,
                    tabIndex: -1,
                    name,
                    autoComplete,
                    value,
                    onChange: (event)=>setValue(event.target.value),
                    disabled,
                    form,
                    children: [
                        value === void 0 ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
                            value: ""
                        }) : null,
                        Array.from(nativeOptionsSet)
                    ]
                }, nativeSelectKey) : null
            ]
        })
    });
};
Select.displayName = SELECT_NAME;
var TRIGGER_NAME = "SelectTrigger";
var SelectTrigger = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect, disabled = false, ...triggerProps } = props;
    const popperScope = usePopperScope(__scopeSelect);
    const context = useSelectContext(TRIGGER_NAME, __scopeSelect);
    const isDisabled = context.disabled || disabled;
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, context.onTriggerChange);
    const getItems = useCollection(__scopeSelect);
    const pointerTypeRef = _react.useRef("touch");
    const [searchRef, handleTypeaheadSearch, resetTypeahead] = useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.value === context.value);
        const nextItem = findNextItem(enabledItems, search, currentItem);
        if (nextItem !== void 0) context.onValueChange(nextItem.value);
    });
    const handleOpen = (pointerEvent)=>{
        if (!isDisabled) {
            context.onOpenChange(true);
            resetTypeahead();
        }
        if (pointerEvent) context.triggerPointerDownPosRef.current = {
            x: Math.round(pointerEvent.pageX),
            y: Math.round(pointerEvent.pageY)
        };
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Anchor, {
        asChild: true,
        ...popperScope,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).button, {
            type: "button",
            role: "combobox",
            "aria-controls": context.contentId,
            "aria-expanded": context.open,
            "aria-required": context.required,
            "aria-autocomplete": "none",
            dir: context.dir,
            "data-state": context.open ? "open" : "closed",
            disabled: isDisabled,
            "data-disabled": isDisabled ? "" : void 0,
            "data-placeholder": shouldShowPlaceholder(context.value) ? "" : void 0,
            ...triggerProps,
            ref: composedRefs,
            onClick: (0, _primitive.composeEventHandlers)(triggerProps.onClick, (event)=>{
                event.currentTarget.focus();
                if (pointerTypeRef.current !== "mouse") handleOpen(event);
            }),
            onPointerDown: (0, _primitive.composeEventHandlers)(triggerProps.onPointerDown, (event)=>{
                pointerTypeRef.current = event.pointerType;
                const target = event.target;
                if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
                if (event.button === 0 && event.ctrlKey === false && event.pointerType === "mouse") {
                    handleOpen(event);
                    event.preventDefault();
                }
            }),
            onKeyDown: (0, _primitive.composeEventHandlers)(triggerProps.onKeyDown, (event)=>{
                const isTypingAhead = searchRef.current !== "";
                const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                if (isTypingAhead && event.key === " ") return;
                if (OPEN_KEYS.includes(event.key)) {
                    handleOpen();
                    event.preventDefault();
                }
            })
        })
    });
});
SelectTrigger.displayName = TRIGGER_NAME;
var VALUE_NAME = "SelectValue";
var SelectValue = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect, className, style, children, placeholder = "", ...valueProps } = props;
    const context = useSelectContext(VALUE_NAME, __scopeSelect);
    const { onValueNodeHasChildrenChange } = context;
    const hasChildren = children !== void 0;
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, context.onValueNodeChange);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        onValueNodeHasChildrenChange(hasChildren);
    }, [
        onValueNodeHasChildrenChange,
        hasChildren
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).span, {
        ...valueProps,
        ref: composedRefs,
        style: {
            pointerEvents: "none"
        },
        children: shouldShowPlaceholder(context.value) ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: placeholder
        }) : children
    });
});
SelectValue.displayName = VALUE_NAME;
var ICON_NAME = "SelectIcon";
var SelectIcon = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect, children, ...iconProps } = props;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).span, {
        "aria-hidden": true,
        ...iconProps,
        ref: forwardedRef,
        children: children || "\u25BC"
    });
});
SelectIcon.displayName = ICON_NAME;
var PORTAL_NAME = "SelectPortal";
var SelectPortal = (props)=>{
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPortal.Portal), {
        asChild: true,
        ...props
    });
};
SelectPortal.displayName = PORTAL_NAME;
var CONTENT_NAME = "SelectContent";
var SelectContent = _react.forwardRef((props, forwardedRef)=>{
    const context = useSelectContext(CONTENT_NAME, props.__scopeSelect);
    const [fragment, setFragment] = _react.useState();
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        setFragment(new DocumentFragment());
    }, []);
    if (!context.open) {
        const frag = fragment;
        return frag ? _reactDom.createPortal(/* @__PURE__ */ (0, _jsxRuntime.jsx)(SelectContentProvider, {
            scope: props.__scopeSelect,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.Slot, {
                scope: props.__scopeSelect,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    children: props.children
                })
            })
        }), frag) : null;
    }
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(SelectContentImpl, {
        ...props,
        ref: forwardedRef
    });
});
SelectContent.displayName = CONTENT_NAME;
var CONTENT_MARGIN = 10;
var [SelectContentProvider, useSelectContentContext] = createSelectContext(CONTENT_NAME);
var CONTENT_IMPL_NAME = "SelectContentImpl";
var Slot = (0, _reactSlot.createSlot)("SelectContent.RemoveScroll");
var SelectContentImpl = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect, position = "item-aligned", onCloseAutoFocus, onEscapeKeyDown, onPointerDownOutside, //
    // PopperContent props
    side, sideOffset, align, alignOffset, arrowPadding, collisionBoundary, collisionPadding, sticky, hideWhenDetached, avoidCollisions, //
    ...contentProps } = props;
    const context = useSelectContext(CONTENT_NAME, __scopeSelect);
    const [content, setContent] = _react.useState(null);
    const [viewport, setViewport] = _react.useState(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, (node)=>setContent(node));
    const [selectedItem, setSelectedItem] = _react.useState(null);
    const [selectedItemText, setSelectedItemText] = _react.useState(null);
    const getItems = useCollection(__scopeSelect);
    const [isPositioned, setIsPositioned] = _react.useState(false);
    const firstValidItemFoundRef = _react.useRef(false);
    _react.useEffect(()=>{
        if (content) return (0, _ariaHidden.hideOthers)(content);
    }, [
        content
    ]);
    (0, _reactFocusGuards.useFocusGuards)();
    const focusFirst = _react.useCallback((candidates)=>{
        const [firstItem, ...restItems] = getItems().map((item)=>item.ref.current);
        const [lastItem] = restItems.slice(-1);
        const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
        for (const candidate of candidates){
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate?.scrollIntoView({
                block: "nearest"
            });
            if (candidate === firstItem && viewport) viewport.scrollTop = 0;
            if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
            candidate?.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    }, [
        getItems,
        viewport
    ]);
    const focusSelectedItem = _react.useCallback(()=>focusFirst([
            selectedItem,
            content
        ]), [
        focusFirst,
        selectedItem,
        content
    ]);
    _react.useEffect(()=>{
        if (isPositioned) focusSelectedItem();
    }, [
        isPositioned,
        focusSelectedItem
    ]);
    const { onOpenChange, triggerPointerDownPosRef } = context;
    _react.useEffect(()=>{
        if (content) {
            let pointerMoveDelta = {
                x: 0,
                y: 0
            };
            const handlePointerMove = (event)=>{
                pointerMoveDelta = {
                    x: Math.abs(Math.round(event.pageX) - (triggerPointerDownPosRef.current?.x ?? 0)),
                    y: Math.abs(Math.round(event.pageY) - (triggerPointerDownPosRef.current?.y ?? 0))
                };
            };
            const handlePointerUp = (event)=>{
                if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();
                else if (!content.contains(event.target)) onOpenChange(false);
                document.removeEventListener("pointermove", handlePointerMove);
                triggerPointerDownPosRef.current = null;
            };
            if (triggerPointerDownPosRef.current !== null) {
                document.addEventListener("pointermove", handlePointerMove);
                document.addEventListener("pointerup", handlePointerUp, {
                    capture: true,
                    once: true
                });
            }
            return ()=>{
                document.removeEventListener("pointermove", handlePointerMove);
                document.removeEventListener("pointerup", handlePointerUp, {
                    capture: true
                });
            };
        }
    }, [
        content,
        onOpenChange,
        triggerPointerDownPosRef
    ]);
    _react.useEffect(()=>{
        const close = ()=>onOpenChange(false);
        window.addEventListener("blur", close);
        window.addEventListener("resize", close);
        return ()=>{
            window.removeEventListener("blur", close);
            window.removeEventListener("resize", close);
        };
    }, [
        onOpenChange
    ]);
    const [searchRef, handleTypeaheadSearch] = useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.ref.current === document.activeElement);
        const nextItem = findNextItem(enabledItems, search, currentItem);
        if (nextItem) setTimeout(()=>nextItem.ref.current.focus());
    });
    const itemRefCallback = _react.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
            setSelectedItem(node);
            if (isFirstValidItem) firstValidItemFoundRef.current = true;
        }
    }, [
        context.value
    ]);
    const handleItemLeave = _react.useCallback(()=>content?.focus(), [
        content
    ]);
    const itemTextRefCallback = _react.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) setSelectedItemText(node);
    }, [
        context.value
    ]);
    const SelectPosition = position === "popper" ? SelectPopperPosition : SelectItemAlignedPosition;
    const popperContentProps = SelectPosition === SelectPopperPosition ? {
        side,
        sideOffset,
        align,
        alignOffset,
        arrowPadding,
        collisionBoundary,
        collisionPadding,
        sticky,
        hideWhenDetached,
        avoidCollisions
    } : {};
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(SelectContentProvider, {
        scope: __scopeSelect,
        content,
        viewport,
        onViewportChange: setViewport,
        itemRefCallback,
        selectedItem,
        onItemLeave: handleItemLeave,
        itemTextRefCallback,
        focusSelectedItem,
        selectedItemText,
        position,
        isPositioned,
        searchRef,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactRemoveScroll.RemoveScroll), {
            as: Slot,
            allowPinchZoom: true,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactFocusScope.FocusScope), {
                asChild: true,
                trapped: context.open,
                onMountAutoFocus: (event)=>{
                    event.preventDefault();
                },
                onUnmountAutoFocus: (0, _primitive.composeEventHandlers)(onCloseAutoFocus, (event)=>{
                    context.trigger?.focus({
                        preventScroll: true
                    });
                    event.preventDefault();
                }),
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactDismissableLayer.DismissableLayer), {
                    asChild: true,
                    disableOutsidePointerEvents: true,
                    onEscapeKeyDown,
                    onPointerDownOutside,
                    onFocusOutside: (event)=>event.preventDefault(),
                    onDismiss: ()=>context.onOpenChange(false),
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(SelectPosition, {
                        role: "listbox",
                        id: context.contentId,
                        "data-state": context.open ? "open" : "closed",
                        dir: context.dir,
                        onContextMenu: (event)=>event.preventDefault(),
                        ...contentProps,
                        ...popperContentProps,
                        onPlaced: ()=>setIsPositioned(true),
                        ref: composedRefs,
                        style: {
                            // flex layout so we can place the scroll buttons properly
                            display: "flex",
                            flexDirection: "column",
                            // reset the outline by default as the content MAY get focused
                            outline: "none",
                            ...contentProps.style
                        },
                        onKeyDown: (0, _primitive.composeEventHandlers)(contentProps.onKeyDown, (event)=>{
                            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                            if (event.key === "Tab") event.preventDefault();
                            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                            if ([
                                "ArrowUp",
                                "ArrowDown",
                                "Home",
                                "End"
                            ].includes(event.key)) {
                                const items = getItems().filter((item)=>!item.disabled);
                                let candidateNodes = items.map((item)=>item.ref.current);
                                if ([
                                    "ArrowUp",
                                    "End"
                                ].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
                                if ([
                                    "ArrowUp",
                                    "ArrowDown"
                                ].includes(event.key)) {
                                    const currentElement = event.target;
                                    const currentIndex = candidateNodes.indexOf(currentElement);
                                    candidateNodes = candidateNodes.slice(currentIndex + 1);
                                }
                                setTimeout(()=>focusFirst(candidateNodes));
                                event.preventDefault();
                            }
                        })
                    })
                })
            })
        })
    });
});
SelectContentImpl.displayName = CONTENT_IMPL_NAME;
var ITEM_ALIGNED_POSITION_NAME = "SelectItemAlignedPosition";
var SelectItemAlignedPosition = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect, onPlaced, ...popperProps } = props;
    const context = useSelectContext(CONTENT_NAME, __scopeSelect);
    const contentContext = useSelectContentContext(CONTENT_NAME, __scopeSelect);
    const [contentWrapper, setContentWrapper] = _react.useState(null);
    const [content, setContent] = _react.useState(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, (node)=>setContent(node));
    const getItems = useCollection(__scopeSelect);
    const shouldExpandOnScrollRef = _react.useRef(false);
    const shouldRepositionRef = _react.useRef(true);
    const { viewport, selectedItem, selectedItemText, focusSelectedItem } = contentContext;
    const position = _react.useCallback(()=>{
        if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
            const triggerRect = context.trigger.getBoundingClientRect();
            const contentRect = content.getBoundingClientRect();
            const valueNodeRect = context.valueNode.getBoundingClientRect();
            const itemTextRect = selectedItemText.getBoundingClientRect();
            if (context.dir !== "rtl") {
                const itemTextOffset = itemTextRect.left - contentRect.left;
                const left = valueNodeRect.left - itemTextOffset;
                const leftDelta = triggerRect.left - left;
                const minContentWidth = triggerRect.width + leftDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const rightEdge = window.innerWidth - CONTENT_MARGIN;
                const clampedLeft = (0, _number.clamp)(left, [
                    CONTENT_MARGIN,
                    // Prevents the content from going off the starting edge of the
                    // viewport. It may still go off the ending edge, but this can be
                    // controlled by the user since they may want to manage overflow in a
                    // specific way.
                    // https://github.com/radix-ui/primitives/issues/2049
                    Math.max(CONTENT_MARGIN, rightEdge - contentWidth)
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.left = clampedLeft + "px";
            } else {
                const itemTextOffset = contentRect.right - itemTextRect.right;
                const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
                const rightDelta = window.innerWidth - triggerRect.right - right;
                const minContentWidth = triggerRect.width + rightDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const leftEdge = window.innerWidth - CONTENT_MARGIN;
                const clampedRight = (0, _number.clamp)(right, [
                    CONTENT_MARGIN,
                    Math.max(CONTENT_MARGIN, leftEdge - contentWidth)
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.right = clampedRight + "px";
            }
            const items = getItems();
            const availableHeight = window.innerHeight - CONTENT_MARGIN * 2;
            const itemsHeight = viewport.scrollHeight;
            const contentStyles = window.getComputedStyle(content);
            const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
            const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
            const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
            const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
            const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth;
            const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
            const viewportStyles = window.getComputedStyle(viewport);
            const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
            const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
            const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - CONTENT_MARGIN;
            const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
            const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
            const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
            const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
            const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
            const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
            if (willAlignWithoutTopOverflow) {
                const isLastItem = items.length > 0 && selectedItem === items[items.length - 1].ref.current;
                contentWrapper.style.bottom = "0px";
                const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
                const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + // viewport might have padding bottom, include it to avoid a scrollable viewport
                (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
                const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
                contentWrapper.style.height = height + "px";
            } else {
                const isFirstItem = items.length > 0 && selectedItem === items[0].ref.current;
                contentWrapper.style.top = "0px";
                const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
                (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
                const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
                contentWrapper.style.height = height + "px";
                viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
            }
            contentWrapper.style.margin = `${CONTENT_MARGIN}px 0`;
            contentWrapper.style.minHeight = minContentHeight + "px";
            contentWrapper.style.maxHeight = availableHeight + "px";
            onPlaced?.();
            requestAnimationFrame(()=>shouldExpandOnScrollRef.current = true);
        }
    }, [
        getItems,
        context.trigger,
        context.valueNode,
        contentWrapper,
        content,
        viewport,
        selectedItem,
        selectedItemText,
        context.dir,
        onPlaced
    ]);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>position(), [
        position
    ]);
    const [contentZIndex, setContentZIndex] = _react.useState();
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    const handleScrollButtonChange = _react.useCallback((node)=>{
        if (node && shouldRepositionRef.current === true) {
            position();
            focusSelectedItem?.();
            shouldRepositionRef.current = false;
        }
    }, [
        position,
        focusSelectedItem
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(SelectViewportProvider, {
        scope: __scopeSelect,
        contentWrapper,
        shouldExpandOnScrollRef,
        onScrollButtonChange: handleScrollButtonChange,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            ref: setContentWrapper,
            style: {
                display: "flex",
                flexDirection: "column",
                position: "fixed",
                zIndex: contentZIndex
            },
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
                ...popperProps,
                ref: composedRefs,
                style: {
                    // When we get the height of the content, it includes borders. If we were to set
                    // the height without having `boxSizing: 'border-box'` it would be too big.
                    boxSizing: "border-box",
                    // We need to ensure the content doesn't get taller than the wrapper
                    maxHeight: "100%",
                    ...popperProps.style
                }
            })
        })
    });
});
SelectItemAlignedPosition.displayName = ITEM_ALIGNED_POSITION_NAME;
var POPPER_POSITION_NAME = "SelectPopperPosition";
var SelectPopperPosition = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect, align = "start", collisionPadding = CONTENT_MARGIN, ...popperProps } = props;
    const popperScope = usePopperScope(__scopeSelect);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Content, {
        ...popperScope,
        ...popperProps,
        ref: forwardedRef,
        align,
        collisionPadding,
        style: {
            // Ensure border-box for floating-ui calculations
            boxSizing: "border-box",
            ...popperProps.style,
            "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-select-content-available-width": "var(--radix-popper-available-width)",
            "--radix-select-content-available-height": "var(--radix-popper-available-height)",
            "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
SelectPopperPosition.displayName = POPPER_POSITION_NAME;
var [SelectViewportProvider, useSelectViewportContext] = createSelectContext(CONTENT_NAME, {});
var VIEWPORT_NAME = "SelectViewport";
var SelectViewport = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect, nonce, ...viewportProps } = props;
    const contentContext = useSelectContentContext(VIEWPORT_NAME, __scopeSelect);
    const viewportContext = useSelectViewportContext(VIEWPORT_NAME, __scopeSelect);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, contentContext.onViewportChange);
    const prevScrollTopRef = _react.useRef(0);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
                },
                nonce
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.Slot, {
                scope: __scopeSelect,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
                    "data-radix-select-viewport": "",
                    role: "presentation",
                    ...viewportProps,
                    ref: composedRefs,
                    style: {
                        // we use position: 'relative' here on the `viewport` so that when we call
                        // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
                        // (independent of the scrollUpButton).
                        position: "relative",
                        flex: 1,
                        // Viewport should only be scrollable in the vertical direction.
                        // This won't work in vertical writing modes, so we'll need to
                        // revisit this if/when that is supported
                        // https://developer.chrome.com/blog/vertical-form-controls
                        overflow: "hidden auto",
                        ...viewportProps.style
                    },
                    onScroll: (0, _primitive.composeEventHandlers)(viewportProps.onScroll, (event)=>{
                        const viewport = event.currentTarget;
                        const { contentWrapper, shouldExpandOnScrollRef } = viewportContext;
                        if (shouldExpandOnScrollRef?.current && contentWrapper) {
                            const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
                            if (scrolledBy > 0) {
                                const availableHeight = window.innerHeight - CONTENT_MARGIN * 2;
                                const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
                                const cssHeight = parseFloat(contentWrapper.style.height);
                                const prevHeight = Math.max(cssMinHeight, cssHeight);
                                if (prevHeight < availableHeight) {
                                    const nextHeight = prevHeight + scrolledBy;
                                    const clampedNextHeight = Math.min(availableHeight, nextHeight);
                                    const heightDiff = nextHeight - clampedNextHeight;
                                    contentWrapper.style.height = clampedNextHeight + "px";
                                    if (contentWrapper.style.bottom === "0px") {
                                        viewport.scrollTop = heightDiff > 0 ? heightDiff : 0;
                                        contentWrapper.style.justifyContent = "flex-end";
                                    }
                                }
                            }
                        }
                        prevScrollTopRef.current = viewport.scrollTop;
                    })
                })
            })
        ]
    });
});
SelectViewport.displayName = VIEWPORT_NAME;
var GROUP_NAME = "SelectGroup";
var [SelectGroupContextProvider, useSelectGroupContext] = createSelectContext(GROUP_NAME);
var SelectGroup = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect, ...groupProps } = props;
    const groupId = (0, _reactId.useId)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(SelectGroupContextProvider, {
        scope: __scopeSelect,
        id: groupId,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
            role: "group",
            "aria-labelledby": groupId,
            ...groupProps,
            ref: forwardedRef
        })
    });
});
SelectGroup.displayName = GROUP_NAME;
var LABEL_NAME = "SelectLabel";
var SelectLabel = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect, ...labelProps } = props;
    const groupContext = useSelectGroupContext(LABEL_NAME, __scopeSelect);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        id: groupContext.id,
        ...labelProps,
        ref: forwardedRef
    });
});
SelectLabel.displayName = LABEL_NAME;
var ITEM_NAME = "SelectItem";
var [SelectItemContextProvider, useSelectItemContext] = createSelectContext(ITEM_NAME);
var SelectItem = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect, value, disabled = false, textValue: textValueProp, ...itemProps } = props;
    const context = useSelectContext(ITEM_NAME, __scopeSelect);
    const contentContext = useSelectContentContext(ITEM_NAME, __scopeSelect);
    const isSelected = context.value === value;
    const [textValue, setTextValue] = _react.useState(textValueProp ?? "");
    const [isFocused, setIsFocused] = _react.useState(false);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, (node)=>contentContext.itemRefCallback?.(node, value, disabled));
    const textId = (0, _reactId.useId)();
    const pointerTypeRef = _react.useRef("touch");
    const handleSelect = ()=>{
        if (!disabled) {
            context.onValueChange(value);
            context.onOpenChange(false);
        }
    };
    if (value === "") throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(SelectItemContextProvider, {
        scope: __scopeSelect,
        value,
        disabled,
        textId,
        isSelected,
        onItemTextChange: _react.useCallback((node)=>{
            setTextValue((prevTextValue)=>prevTextValue || (node?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.ItemSlot, {
            scope: __scopeSelect,
            value,
            disabled,
            textValue,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
                role: "option",
                "aria-labelledby": textId,
                "data-highlighted": isFocused ? "" : void 0,
                "aria-selected": isSelected && isFocused,
                "data-state": isSelected ? "checked" : "unchecked",
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                tabIndex: disabled ? void 0 : -1,
                ...itemProps,
                ref: composedRefs,
                onFocus: (0, _primitive.composeEventHandlers)(itemProps.onFocus, ()=>setIsFocused(true)),
                onBlur: (0, _primitive.composeEventHandlers)(itemProps.onBlur, ()=>setIsFocused(false)),
                onClick: (0, _primitive.composeEventHandlers)(itemProps.onClick, ()=>{
                    if (pointerTypeRef.current !== "mouse") handleSelect();
                }),
                onPointerUp: (0, _primitive.composeEventHandlers)(itemProps.onPointerUp, ()=>{
                    if (pointerTypeRef.current === "mouse") handleSelect();
                }),
                onPointerDown: (0, _primitive.composeEventHandlers)(itemProps.onPointerDown, (event)=>{
                    pointerTypeRef.current = event.pointerType;
                }),
                onPointerMove: (0, _primitive.composeEventHandlers)(itemProps.onPointerMove, (event)=>{
                    pointerTypeRef.current = event.pointerType;
                    if (disabled) contentContext.onItemLeave?.();
                    else if (pointerTypeRef.current === "mouse") event.currentTarget.focus({
                        preventScroll: true
                    });
                }),
                onPointerLeave: (0, _primitive.composeEventHandlers)(itemProps.onPointerLeave, (event)=>{
                    if (event.currentTarget === document.activeElement) contentContext.onItemLeave?.();
                }),
                onKeyDown: (0, _primitive.composeEventHandlers)(itemProps.onKeyDown, (event)=>{
                    const isTypingAhead = contentContext.searchRef?.current !== "";
                    if (isTypingAhead && event.key === " ") return;
                    if (SELECTION_KEYS.includes(event.key)) handleSelect();
                    if (event.key === " ") event.preventDefault();
                })
            })
        })
    });
});
SelectItem.displayName = ITEM_NAME;
var ITEM_TEXT_NAME = "SelectItemText";
var SelectItemText = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect, className, style, ...itemTextProps } = props;
    const context = useSelectContext(ITEM_TEXT_NAME, __scopeSelect);
    const contentContext = useSelectContentContext(ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = useSelectItemContext(ITEM_TEXT_NAME, __scopeSelect);
    const nativeOptionsContext = useSelectNativeOptionsContext(ITEM_TEXT_NAME, __scopeSelect);
    const [itemTextNode, setItemTextNode] = _react.useState(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, (node)=>setItemTextNode(node), itemContext.onItemTextChange, (node)=>contentContext.itemTextRefCallback?.(node, itemContext.value, itemContext.disabled));
    const textContent = itemTextNode?.textContent;
    const nativeOption = _react.useMemo(()=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("option", {
            value: itemContext.value,
            disabled: itemContext.disabled,
            children: textContent
        }, itemContext.value), [
        itemContext.disabled,
        itemContext.value,
        textContent
    ]);
    const { onNativeOptionAdd, onNativeOptionRemove } = nativeOptionsContext;
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        onNativeOptionAdd(nativeOption);
        return ()=>onNativeOptionRemove(nativeOption);
    }, [
        onNativeOptionAdd,
        onNativeOptionRemove,
        nativeOption
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).span, {
                id: itemContext.textId,
                ...itemTextProps,
                ref: composedRefs
            }),
            itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? _reactDom.createPortal(itemTextProps.children, context.valueNode) : null
        ]
    });
});
SelectItemText.displayName = ITEM_TEXT_NAME;
var ITEM_INDICATOR_NAME = "SelectItemIndicator";
var SelectItemIndicator = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect, ...itemIndicatorProps } = props;
    const itemContext = useSelectItemContext(ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).span, {
        "aria-hidden": true,
        ...itemIndicatorProps,
        ref: forwardedRef
    }) : null;
});
SelectItemIndicator.displayName = ITEM_INDICATOR_NAME;
var SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
var SelectScrollUpButton = _react.forwardRef((props, forwardedRef)=>{
    const contentContext = useSelectContentContext(SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = useSelectViewportContext(SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const [canScrollUp, setCanScrollUp] = _react.useState(false);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const canScrollUp2 = viewport.scrollTop > 0;
                setCanScrollUp(canScrollUp2);
            };
            var handleScroll = handleScroll2;
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollUp ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(SelectScrollButtonImpl, {
        ...props,
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport, selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
        }
    }) : null;
});
SelectScrollUpButton.displayName = SCROLL_UP_BUTTON_NAME;
var SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
var SelectScrollDownButton = _react.forwardRef((props, forwardedRef)=>{
    const contentContext = useSelectContentContext(SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = useSelectViewportContext(SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const [canScrollDown, setCanScrollDown] = _react.useState(false);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const maxScroll = viewport.scrollHeight - viewport.clientHeight;
                const canScrollDown2 = Math.ceil(viewport.scrollTop) < maxScroll;
                setCanScrollDown(canScrollDown2);
            };
            var handleScroll = handleScroll2;
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollDown ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(SelectScrollButtonImpl, {
        ...props,
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport, selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
        }
    }) : null;
});
SelectScrollDownButton.displayName = SCROLL_DOWN_BUTTON_NAME;
var SelectScrollButtonImpl = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect, onAutoScroll, ...scrollIndicatorProps } = props;
    const contentContext = useSelectContentContext("SelectScrollButton", __scopeSelect);
    const autoScrollTimerRef = _react.useRef(null);
    const getItems = useCollection(__scopeSelect);
    const clearAutoScrollTimer = _react.useCallback(()=>{
        if (autoScrollTimerRef.current !== null) {
            window.clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
    }, []);
    _react.useEffect(()=>{
        return ()=>clearAutoScrollTimer();
    }, [
        clearAutoScrollTimer
    ]);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        const activeItem = getItems().find((item)=>item.ref.current === document.activeElement);
        activeItem?.ref.current?.scrollIntoView({
            block: "nearest"
        });
    }, [
        getItems
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        "aria-hidden": true,
        ...scrollIndicatorProps,
        ref: forwardedRef,
        style: {
            flexShrink: 0,
            ...scrollIndicatorProps.style
        },
        onPointerDown: (0, _primitive.composeEventHandlers)(scrollIndicatorProps.onPointerDown, ()=>{
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerMove: (0, _primitive.composeEventHandlers)(scrollIndicatorProps.onPointerMove, ()=>{
            contentContext.onItemLeave?.();
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerLeave: (0, _primitive.composeEventHandlers)(scrollIndicatorProps.onPointerLeave, ()=>{
            clearAutoScrollTimer();
        })
    });
});
var SEPARATOR_NAME = "SelectSeparator";
var SelectSeparator = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect, ...separatorProps } = props;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        "aria-hidden": true,
        ...separatorProps,
        ref: forwardedRef
    });
});
SelectSeparator.displayName = SEPARATOR_NAME;
var ARROW_NAME = "SelectArrow";
var SelectArrow = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect, ...arrowProps } = props;
    const popperScope = usePopperScope(__scopeSelect);
    const context = useSelectContext(ARROW_NAME, __scopeSelect);
    const contentContext = useSelectContentContext(ARROW_NAME, __scopeSelect);
    return context.open && contentContext.position === "popper" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Arrow, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    }) : null;
});
SelectArrow.displayName = ARROW_NAME;
var BUBBLE_INPUT_NAME = "SelectBubbleInput";
var SelectBubbleInput = _react.forwardRef(({ __scopeSelect, value, ...props }, forwardedRef)=>{
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    const prevValue = (0, _reactUsePrevious.usePrevious)(value);
    _react.useEffect(()=>{
        const select = ref.current;
        if (!select) return;
        const selectProto = window.HTMLSelectElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(selectProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event("change", {
                bubbles: true
            });
            setValue.call(select, value);
            select.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).select, {
        ...props,
        style: {
            ...(0, _reactVisuallyHidden.VISUALLY_HIDDEN_STYLES),
            ...props.style
        },
        ref: composedRefs,
        defaultValue: value
    });
});
SelectBubbleInput.displayName = BUBBLE_INPUT_NAME;
function shouldShowPlaceholder(value) {
    return value === "" || value === void 0;
}
function useTypeaheadSearch(onSearchChange) {
    const handleSearchChange = (0, _reactUseCallbackRef.useCallbackRef)(onSearchChange);
    const searchRef = _react.useRef("");
    const timerRef = _react.useRef(0);
    const handleTypeaheadSearch = _react.useCallback((key)=>{
        const search = searchRef.current + key;
        handleSearchChange(search);
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1e3);
        })(search);
    }, [
        handleSearchChange
    ]);
    const resetTypeahead = _react.useCallback(()=>{
        searchRef.current = "";
        window.clearTimeout(timerRef.current);
    }, []);
    _react.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    return [
        searchRef,
        handleTypeaheadSearch,
        resetTypeahead
    ];
}
function findNextItem(items, search, currentItem) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
    let wrappedItems = wrapArray(items, Math.max(currentItemIndex, 0));
    const excludeCurrentItem = normalizedSearch.length === 1;
    if (excludeCurrentItem) wrappedItems = wrappedItems.filter((v)=>v !== currentItem);
    const nextItem = wrappedItems.find((item)=>item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextItem !== currentItem ? nextItem : void 0;
}
function wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var Root2 = Select;
var Trigger = SelectTrigger;
var Value = SelectValue;
var Icon = SelectIcon;
var Portal = SelectPortal;
var Content2 = SelectContent;
var Viewport = SelectViewport;
var Group = SelectGroup;
var Label = SelectLabel;
var Item = SelectItem;
var ItemText = SelectItemText;
var ItemIndicator = SelectItemIndicator;
var ScrollUpButton = SelectScrollUpButton;
var ScrollDownButton = SelectScrollDownButton;
var Separator = SelectSeparator;
var Arrow2 = SelectArrow;

},{"react":"eGun2","react-dom":"bLJc5","@radix-ui/number":"7R109","@radix-ui/primitive":"k8C5A","@radix-ui/react-collection":"kU6H9","@radix-ui/react-compose-refs":"nN23r","@radix-ui/react-context":"4wywa","@radix-ui/react-direction":"boYIn","@radix-ui/react-dismissable-layer":"gdhJG","@radix-ui/react-focus-guards":"h3kF4","@radix-ui/react-focus-scope":"dkOta","@radix-ui/react-id":"hoLx9","@radix-ui/react-popper":"5wakN","@radix-ui/react-portal":"4FFRT","@radix-ui/react-primitive":"hQJ44","@radix-ui/react-slot":"4sJVf","@radix-ui/react-use-callback-ref":"bakzF","@radix-ui/react-use-controllable-state":"ThW7y","@radix-ui/react-use-layout-effect":"dRDMB","@radix-ui/react-use-previous":"5zGdn","@radix-ui/react-visually-hidden":"iPxB6","aria-hidden":"8h7XP","react-remove-scroll":[["RemoveScroll","emctR","default"]],"react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"7R109":[function(require,module,exports,__globalThis) {
// packages/core/number/src/number.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clamp", ()=>clamp);
function clamp(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"6Nrpu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _config = require("@/client/config");
var _date = require("@/client/lib/date");
var _csv = require("@/client/lib/csv");
var _lucideReact = require("lucide-react");
var _badge = require("@/client/components/ui/badge");
var _button = require("@/client/components/ui/button");
var _checkbox = require("@/client/components/ui/checkbox");
var _label = require("@/client/components/ui/label");
var _switch = require("@/client/components/ui/switch");
var _cacheTimestamp = require("@/client/components/cache-timestamp");
var _table = require("@/client/components/ui/table");
var _separator = require("@/client/components/ui/separator");
var _clientSelector = require("@/client/components/client-selector");
var _dateRangePicker = require("@/client/components/date-range-picker");
var _resetFiltersButton = require("@/client/components/reset-filters-button");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'captioning/reports',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: CaptioningReportsComponent
});
function formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(amount);
}
function formatNumber(value) {
    return new Intl.NumberFormat('en-US').format(value);
}
function minutesToHours(minutes) {
    const hours = minutes / 60;
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(hours);
}
function CaptioningReportsComponent() {
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    // Date range state
    const [startDate, setStartDate] = (0, _react.useState)('');
    const [endDate, setEndDate] = (0, _react.useState)('');
    const [quickRange, setQuickRange] = (0, _react.useState)('');
    // Client selection state
    const [selectedClientId, setSelectedClientId] = (0, _react.useState)('');
    const [selectedClient, setSelectedClient] = (0, _react.useState)(null);
    const [allClients, setAllClients] = (0, _react.useState)(false);
    // Report state - single client
    const [transcriptionData, setTranscriptionData] = (0, _react.useState)(null);
    const [captionData, setCaptionData] = (0, _react.useState)(null);
    // Report state - all clients
    const [allClientsTranscription, setAllClientsTranscription] = (0, _react.useState)(null);
    const [allClientsCaptions, setAllClientsCaptions] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    const [confirmPending, setConfirmPending] = (0, _react.useState)(false);
    const [hideZeroRows, setHideZeroRows] = (0, _react.useState)(false);
    // Can generate report if dates are set AND (allClients OR specific client selected)
    const canGenerateReport = startDate && endDate && (allClients || selectedClientId);
    const handleClientChange = (clientId, client)=>{
        setSelectedClientId(clientId);
        setSelectedClient(client);
        // Clear all report data when client changes
        setTranscriptionData(null);
        setCaptionData(null);
        setAllClientsTranscription(null);
        setAllClientsCaptions(null);
        setConfirmPending(false);
    };
    const handleAllClientsChange = (checked)=>{
        setAllClients(checked);
        // Clear all report data when toggle changes
        setTranscriptionData(null);
        setCaptionData(null);
        setAllClientsTranscription(null);
        setAllClientsCaptions(null);
        setConfirmPending(false);
    };
    const handleGenerateReport = async ()=>{
        if (!canGenerateReport) return;
        if (!confirmPending) {
            setConfirmPending(true);
            return;
        }
        setConfirmPending(false);
        setLoading(true);
        setError(null);
        try {
            const token = await getAccessTokenSilently();
            const headers = {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            };
            if (allClients) {
                // All-clients mode: fetch aggregate data for all clients
                const [transcriptionRes, captionRes] = await Promise.all([
                    fetch(`${(0, _config.API_BASE_URL)}/api/transcription/usage/all?startDate=${startDate}&endDate=${endDate}`, {
                        headers
                    }),
                    fetch(`${(0, _config.API_BASE_URL)}/api/captions/usage/all?startDate=${startDate}&endDate=${endDate}`, {
                        headers
                    })
                ]);
                if (!transcriptionRes.ok) throw new Error(`Failed to fetch transcription data: ${transcriptionRes.statusText}`);
                if (!captionRes.ok) throw new Error(`Failed to fetch caption data: ${captionRes.statusText}`);
                const [transcription, captions] = await Promise.all([
                    transcriptionRes.json(),
                    captionRes.json()
                ]);
                setAllClientsTranscription(transcription);
                setAllClientsCaptions(captions);
                // Clear single-client data
                setTranscriptionData(null);
                setCaptionData(null);
            } else {
                // Single-client mode: fetch data for specific client
                const [transcriptionRes, captionRes] = await Promise.all([
                    fetch(`${(0, _config.API_BASE_URL)}/api/transcription/usage?clientID=${selectedClientId}&startDate=${startDate}&endDate=${endDate}`, {
                        headers
                    }),
                    fetch(`${(0, _config.API_BASE_URL)}/api/captions/usage?clientID=${selectedClientId}&startDate=${startDate}&endDate=${endDate}`, {
                        headers
                    })
                ]);
                if (!transcriptionRes.ok) throw new Error(`Failed to fetch transcription data: ${transcriptionRes.statusText}`);
                if (!captionRes.ok) throw new Error(`Failed to fetch caption data: ${captionRes.statusText}`);
                const [transcription, captions] = await Promise.all([
                    transcriptionRes.json(),
                    captionRes.json()
                ]);
                setTranscriptionData(transcription);
                setCaptionData(captions);
                // Clear all-clients data
                setAllClientsTranscription(null);
                setAllClientsCaptions(null);
            }
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred';
            setError(errorMessage);
        } finally{
            setLoading(false);
        }
    };
    const handleExportTranscription = ()=>{
        if (!transcriptionData) return;
        const headers = [
            'Year',
            'Month',
            'Event Count',
            'Total Minutes',
            'Total Hours'
        ];
        const rows = transcriptionData.monthly.map((row)=>[
                row.year.toString(),
                (0, _date.getMonthName)(row.month),
                row.eventCount.toString(),
                row.totalMinutes.toString(),
                (row.totalMinutes / 60).toFixed(2)
            ]);
        rows.push([
            'TOTAL',
            '',
            transcriptionData.totals.eventCount.toString(),
            transcriptionData.totals.totalMinutes.toString(),
            (transcriptionData.totals.totalMinutes / 60).toFixed(2)
        ]);
        const clientName = selectedClient?.name.replace(/[^a-zA-Z0-9]/g, '_') || 'client';
        (0, _csv.downloadCSV)(`transcription_${clientName}_${transcriptionData.dateRange.start}_to_${transcriptionData.dateRange.end}.csv`, headers, rows);
    };
    const handleExportCaptions = ()=>{
        if (!captionData) return;
        const headers = [
            'Year',
            'Month',
            'Session Count',
            'Total Minutes',
            'Total Hours'
        ];
        const rows = captionData.monthly.map((row)=>[
                row.year.toString(),
                (0, _date.getMonthName)(row.month),
                row.sessionCount.toString(),
                row.totalDurationMinutes.toString(),
                (row.totalDurationMinutes / 60).toFixed(2)
            ]);
        rows.push([
            'TOTAL',
            '',
            captionData.totals.sessionCount.toString(),
            captionData.totals.totalDurationMinutes.toString(),
            (captionData.totals.totalDurationMinutes / 60).toFixed(2)
        ]);
        const clientName = selectedClient?.name.replace(/[^a-zA-Z0-9]/g, '_') || 'client';
        (0, _csv.downloadCSV)(`live_captions_${clientName}_${captionData.dateRange.start}_to_${captionData.dateRange.end}.csv`, headers, rows);
    };
    // Export functions for all-clients mode
    const handleExportAllClientsTranscription = ()=>{
        if (!allClientsTranscription) return;
        const headers = [
            'Client ID',
            'Client Name',
            'Events',
            'Total Minutes',
            'Total Hours'
        ];
        const rows = allClientsTranscription.clients.map((client)=>[
                client.clientID,
                client.clientName,
                client.eventCount.toString(),
                client.totalMinutes.toString(),
                client.totalHours.toFixed(2)
            ]);
        rows.push([
            'GRAND TOTAL',
            `(${allClientsTranscription.grandTotals.clientCount} clients)`,
            allClientsTranscription.grandTotals.eventCount.toString(),
            allClientsTranscription.grandTotals.totalMinutes.toString(),
            allClientsTranscription.grandTotals.totalHours.toFixed(2)
        ]);
        (0, _csv.downloadCSV)(`transcription_all_clients_${allClientsTranscription.dateRange.start}_to_${allClientsTranscription.dateRange.end}.csv`, headers, rows);
    };
    const handleExportAllClientsCaptions = ()=>{
        if (!allClientsCaptions) return;
        const headers = [
            'Client ID',
            'Client Name',
            'Sessions',
            'Total Minutes',
            'Total Hours'
        ];
        const rows = allClientsCaptions.clients.map((client)=>[
                client.clientID,
                client.clientName,
                client.sessionCount.toString(),
                client.totalDurationMinutes.toString(),
                client.totalDurationHours.toFixed(2)
            ]);
        rows.push([
            'GRAND TOTAL',
            `(${allClientsCaptions.grandTotals.clientCount} clients)`,
            allClientsCaptions.grandTotals.sessionCount.toString(),
            allClientsCaptions.grandTotals.totalDurationMinutes.toString(),
            allClientsCaptions.grandTotals.totalDurationHours.toFixed(2)
        ]);
        (0, _csv.downloadCSV)(`live_captions_all_clients_${allClientsCaptions.dateRange.start}_to_${allClientsCaptions.dateRange.end}.csv`, headers, rows);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            className: "text-2xl font-semibold",
                            children: "Captioning Reports"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cacheTimestamp.CacheTimestamp), {
                            cachedAt: transcriptionData?.cacheInfo?.cachedAt ?? captionData?.cacheInfo?.cachedAt ?? allClientsTranscription?.cacheInfo?.cachedAt ?? allClientsCaptions?.cacheInfo?.cachedAt ?? null
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "border rounded-lg p-4 space-y-4 bg-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-xs font-medium text-muted-foreground uppercase tracking-wide",
                                    children: "Date Range"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex flex-wrap gap-4 items-end",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateRangePicker.DateRangePicker), {
                                        startDate: startDate,
                                        endDate: endDate,
                                        onStartDateChange: setStartDate,
                                        onEndDateChange: setEndDate,
                                        quickRange: quickRange,
                                        onQuickRangeChange: setQuickRange,
                                        showToday: false,
                                        onDateChange: ()=>setConfirmPending(false)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-xs font-medium text-muted-foreground uppercase tracking-wide",
                                    children: "Client"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-wrap gap-x-4 gap-y-3 items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                                    id: "all-clients",
                                                    checked: allClients,
                                                    onCheckedChange: (checked)=>handleAllClientsChange(checked === true)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                                    htmlFor: "all-clients",
                                                    className: "cursor-pointer",
                                                    children: "All Clients"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "text-muted-foreground",
                                            children: "or"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientSelector.ClientSelector), {
                                            value: selectedClientId,
                                            onChange: handleClientChange,
                                            className: "min-w-[250px]",
                                            label: "",
                                            disabled: allClients
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            onClick: handleGenerateReport,
                                            disabled: !canGenerateReport || loading,
                                            variant: confirmPending ? 'destructive' : 'default',
                                            className: "min-w-[175px]",
                                            children: loading ? 'Loading...' : confirmPending ? 'Click to Confirm' : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FileSpreadsheet), {
                                                        className: "mr-2 h-4 w-4"
                                                    }),
                                                    "Generate Report"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetFiltersButton.ResetFiltersButton), {
                                            routePath: "/captioning/reports",
                                            defaultValues: {
                                                clientID: undefined,
                                                startDate: undefined,
                                                endDate: undefined,
                                                quickRange: undefined,
                                                allClients: false
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "p-4 bg-red-100 border-l-4 border-red-600 rounded",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "m-0 text-red-800 font-medium",
                        children: [
                            "Error: ",
                            error
                        ]
                    })
                }),
                (transcriptionData || captionData) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "space-y-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-sm text-muted-foreground",
                            children: [
                                "Report for Client ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                    variant: "outline",
                                    className: "text-xs font-mono",
                                    children: selectedClientId
                                }),
                                " from ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                    variant: "outline",
                                    className: "text-xs font-mono",
                                    children: [
                                        startDate,
                                        " to ",
                                        endDate
                                    ]
                                })
                            ]
                        }),
                        transcriptionData && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    className: "text-lg font-semibold",
                                                    children: "VOD Transcription"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _separator.Separator), {
                                                    orientation: "vertical",
                                                    className: "mx-2 h-4"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switch.Switch), {
                                                            id: "hide-zero-transcription",
                                                            checked: hideZeroRows,
                                                            onCheckedChange: setHideZeroRows
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                                            htmlFor: "hide-zero-transcription",
                                                            className: "text-sm text-muted-foreground cursor-pointer",
                                                            children: "Hide empty records"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            variant: "outline",
                                            size: "sm",
                                            onClick: handleExportTranscription,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                                    className: "mr-2 h-4 w-4"
                                                }),
                                                "Export CSV"
                                            ]
                                        })
                                    ]
                                }),
                                transcriptionData.rateConfig && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-wrap gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                            variant: "outline",
                                            className: "font-normal",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-medium mr-1",
                                                    children: "Rate:"
                                                }),
                                                formatCurrency(transcriptionData.rateConfig.effectiveRate),
                                                "/min"
                                            ]
                                        }),
                                        transcriptionData.rateConfig.rateDiscount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                            variant: "outline",
                                            className: "font-normal",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-medium mr-1",
                                                    children: "Discount:"
                                                }),
                                                transcriptionData.rateConfig.rateDiscount,
                                                "% = ",
                                                formatCurrency(transcriptionData.rateConfig.rateAfterDiscount),
                                                "/min"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                            variant: "outline",
                                            className: "font-normal",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-medium mr-1",
                                                    children: "Included:"
                                                }),
                                                formatNumber(transcriptionData.rateConfig.monthlyBulkMinutes),
                                                " min/month"
                                            ]
                                        }),
                                        (quickRange === 'this-year' || quickRange === 'last-year') && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                            variant: "outline",
                                            className: "font-normal",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-medium mr-1",
                                                    children: "Contracted Annual:"
                                                }),
                                                formatNumber(transcriptionData.rateConfig.annualContractedHours),
                                                " hrs"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rounded-md border",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Year"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Month"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Events"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Total Minutes"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Total Hours"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                                children: transcriptionData.monthly.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        colSpan: 5,
                                                        className: "text-center text-muted-foreground",
                                                        children: "No transcription data for this period"
                                                    })
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        transcriptionData.monthly.filter((row)=>!hideZeroRows || row.eventCount > 0 || row.totalMinutes > 0).map((row, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: row.year
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: (0, _date.getMonthName)(row.month)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: formatNumber(row.eventCount)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: formatNumber(row.totalMinutes)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: minutesToHours(row.totalMinutes)
                                                                    })
                                                                ]
                                                            }, idx)),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                            className: "bg-muted/50 font-semibold",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    colSpan: 2,
                                                                    children: "Total"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: formatNumber(transcriptionData.totals.eventCount)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: formatNumber(transcriptionData.totals.totalMinutes)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: minutesToHours(transcriptionData.totals.totalMinutes)
                                                                })
                                                            ]
                                                        }),
                                                        transcriptionData.totals.billableMinutes !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                            className: "bg-muted/30 text-sm",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableCell), {
                                                                    colSpan: 4,
                                                                    className: "text-right",
                                                                    children: [
                                                                        "Billable (after ",
                                                                        formatNumber(transcriptionData.totals.includedMinutes ?? 0),
                                                                        " included):"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableCell), {
                                                                    className: "text-right font-medium",
                                                                    children: [
                                                                        formatNumber(transcriptionData.totals.billableMinutes),
                                                                        " min",
                                                                        transcriptionData.totals.estimatedCost !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                            children: [
                                                                                " = ",
                                                                                formatCurrency(transcriptionData.totals.estimatedCost)
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        captionData && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    className: "text-lg font-semibold",
                                                    children: "Live AI Captioning"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _separator.Separator), {
                                                    orientation: "vertical",
                                                    className: "mx-2 h-4"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switch.Switch), {
                                                            id: "hide-zero-captions",
                                                            checked: hideZeroRows,
                                                            onCheckedChange: setHideZeroRows
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                                            htmlFor: "hide-zero-captions",
                                                            className: "text-sm text-muted-foreground cursor-pointer",
                                                            children: "Hide empty records"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            variant: "outline",
                                            size: "sm",
                                            onClick: handleExportCaptions,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                                    className: "mr-2 h-4 w-4"
                                                }),
                                                "Export CSV"
                                            ]
                                        })
                                    ]
                                }),
                                captionData.rateConfig && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex flex-wrap gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                            variant: "outline",
                                            className: "font-normal",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-medium mr-1",
                                                    children: "Rate:"
                                                }),
                                                formatCurrency(captionData.rateConfig.effectiveRate),
                                                "/min"
                                            ]
                                        }),
                                        captionData.rateConfig.rateDiscount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                            variant: "outline",
                                            className: "font-normal",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-medium mr-1",
                                                    children: "Discount:"
                                                }),
                                                captionData.rateConfig.rateDiscount,
                                                "% = ",
                                                formatCurrency(captionData.rateConfig.rateAfterDiscount),
                                                "/min"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                            variant: "outline",
                                            className: "font-normal",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-medium mr-1",
                                                    children: "Included:"
                                                }),
                                                formatNumber(captionData.rateConfig.monthlyBulkMinutes),
                                                " min/month"
                                            ]
                                        }),
                                        (quickRange === 'this-year' || quickRange === 'last-year') && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                            variant: "outline",
                                            className: "font-normal",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-medium mr-1",
                                                    children: "Contracted Annual:"
                                                }),
                                                formatNumber(captionData.rateConfig.annualContractedHours),
                                                " hrs"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rounded-md border",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Year"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Month"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Sessions"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Total Minutes"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Total Hours"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                                children: captionData.monthly.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        colSpan: 5,
                                                        className: "text-center text-muted-foreground",
                                                        children: "No live captioning data for this period"
                                                    })
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        captionData.monthly.filter((row)=>!hideZeroRows || row.sessionCount > 0 || row.totalDurationMinutes > 0).map((row, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: row.year
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: (0, _date.getMonthName)(row.month)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: formatNumber(row.sessionCount)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: formatNumber(row.totalDurationMinutes)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: minutesToHours(row.totalDurationMinutes)
                                                                    })
                                                                ]
                                                            }, idx)),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                            className: "bg-muted/50 font-semibold",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    colSpan: 2,
                                                                    children: "Total"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: formatNumber(captionData.totals.sessionCount)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: formatNumber(captionData.totals.totalDurationMinutes)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: minutesToHours(captionData.totals.totalDurationMinutes)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                (allClientsTranscription || allClientsCaptions) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "space-y-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-sm text-muted-foreground",
                            children: [
                                "All Clients Report from ",
                                startDate,
                                " to ",
                                endDate
                            ]
                        }),
                        allClientsTranscription && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    className: "text-lg font-semibold",
                                                    children: "VOD Transcription - All Clients"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _separator.Separator), {
                                                    orientation: "vertical",
                                                    className: "mx-2 h-4"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switch.Switch), {
                                                            id: "hide-zero-all-transcription",
                                                            checked: hideZeroRows,
                                                            onCheckedChange: setHideZeroRows
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                                            htmlFor: "hide-zero-all-transcription",
                                                            className: "text-sm text-muted-foreground cursor-pointer",
                                                            children: "Hide empty records"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            variant: "outline",
                                            size: "sm",
                                            onClick: handleExportAllClientsTranscription,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                                    className: "mr-2 h-4 w-4"
                                                }),
                                                "Export CSV"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rounded-md border",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Client ID"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Client Name"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Events"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Total Minutes"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Total Hours"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                                children: allClientsTranscription.clients.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        colSpan: 5,
                                                        className: "text-center text-muted-foreground",
                                                        children: "No transcription data for this period"
                                                    })
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        allClientsTranscription.clients.filter((client)=>!hideZeroRows || client.eventCount > 0 || client.totalMinutes > 0).map((client)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: client.clientID
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: client.clientName
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: formatNumber(client.eventCount)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: formatNumber(client.totalMinutes)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: client.totalHours.toFixed(2)
                                                                    })
                                                                ]
                                                            }, client.clientID)),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                            className: "bg-muted/50 font-semibold",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    children: "Grand Total"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableCell), {
                                                                    className: "text-muted-foreground",
                                                                    children: [
                                                                        "(",
                                                                        allClientsTranscription.grandTotals.clientCount,
                                                                        " clients)"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: formatNumber(allClientsTranscription.grandTotals.eventCount)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: formatNumber(allClientsTranscription.grandTotals.totalMinutes)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: allClientsTranscription.grandTotals.totalHours.toFixed(2)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        allClientsCaptions && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex justify-between items-center",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    className: "text-lg font-semibold",
                                                    children: "Live AI Captioning - All Clients"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _separator.Separator), {
                                                    orientation: "vertical",
                                                    className: "mx-2 h-4"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _switch.Switch), {
                                                            id: "hide-zero-all-captions",
                                                            checked: hideZeroRows,
                                                            onCheckedChange: setHideZeroRows
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                                            htmlFor: "hide-zero-all-captions",
                                                            className: "text-sm text-muted-foreground cursor-pointer",
                                                            children: "Hide empty records"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            variant: "outline",
                                            size: "sm",
                                            onClick: handleExportAllClientsCaptions,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                                    className: "mr-2 h-4 w-4"
                                                }),
                                                "Export CSV"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rounded-md border",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Client ID"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: "Client Name"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Sessions"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Total Minutes"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            className: "text-right",
                                                            children: "Total Hours"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                                children: allClientsCaptions.clients.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        colSpan: 5,
                                                        className: "text-center text-muted-foreground",
                                                        children: "No live captioning data for this period"
                                                    })
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        allClientsCaptions.clients.filter((client)=>!hideZeroRows || client.sessionCount > 0 || client.totalDurationMinutes > 0).map((client)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: client.clientID
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        children: client.clientName
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: formatNumber(client.sessionCount)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: formatNumber(client.totalDurationMinutes)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                        className: "text-right",
                                                                        children: client.totalDurationHours.toFixed(2)
                                                                    })
                                                                ]
                                                            }, client.clientID)),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                            className: "bg-muted/50 font-semibold",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    children: "Grand Total"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableCell), {
                                                                    className: "text-muted-foreground",
                                                                    children: [
                                                                        "(",
                                                                        allClientsCaptions.grandTotals.clientCount,
                                                                        " clients)"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: formatNumber(allClientsCaptions.grandTotals.sessionCount)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: formatNumber(allClientsCaptions.grandTotals.totalDurationMinutes)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                                    className: "text-right",
                                                                    children: allClientsCaptions.grandTotals.totalDurationHours.toFixed(2)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"]],"@auth0/auth0-react":"gpXrE","../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/config":"8SWgh","@/client/lib/date":"7ZbER","@/client/lib/csv":"2NpE4","lucide-react":[["Download","eRiW1","default"],["FileSpreadsheet","fkevk","default"]],"@/client/components/ui/badge":"h4e1f","@/client/components/ui/button":"armlb","@/client/components/ui/checkbox":"fh9Pm","@/client/components/ui/label":"cLMZq","@/client/components/ui/switch":"1p4xh","@/client/components/cache-timestamp":"f5Zyx","@/client/components/ui/table":"5vxZ8","@/client/components/ui/separator":"3WCKI","@/client/components/client-selector":"gxoYe","@/client/components/date-range-picker":"iSBDP","@/client/components/reset-filters-button":"9d8BP","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dmJnG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouter = require("@tanstack/react-router");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _table = require("@/client/components/ui/table");
var _badge = require("@/client/components/ui/badge");
var _lucideReact = require("lucide-react");
const SOURCE_URL = 'https://www.multistate.us/resources/2027-legislative-session-dates';
const LAST_GENERATED = 'October 28, 2026';
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'key-dates/legislative-sessions',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: LegislativeSessionsComponent
});
const LEGISLATIVE_SESSIONS_2027 = [
    {
        state: 'Alaska',
        sessionStart: '1/19/27',
        sessionEnd: '5/19/27',
        introDeadlineHouse: null,
        introDeadlineSenate: null,
        crossover: null,
        carryoverFromPrior: false,
        carryoverToNext: true,
        notes: null
    },
    {
        state: 'Arizona',
        sessionStart: '1/11/27',
        sessionEnd: '5/21/27',
        introDeadlineHouse: null,
        introDeadlineSenate: null,
        crossover: null,
        carryoverFromPrior: false,
        carryoverToNext: false,
        notes: null
    },
    {
        state: 'Oregon',
        sessionStart: '1/11/27',
        sessionEnd: '6/19/27',
        introDeadlineHouse: null,
        introDeadlineSenate: null,
        crossover: null,
        carryoverFromPrior: false,
        carryoverToNext: false,
        notes: null
    },
    {
        state: 'Washington',
        sessionStart: '1/11/27',
        sessionEnd: '4/26/27',
        introDeadlineHouse: null,
        introDeadlineSenate: null,
        crossover: null,
        carryoverFromPrior: false,
        carryoverToNext: true,
        notes: null
    },
    {
        state: 'Wisconsin',
        sessionStart: '1/4/27',
        sessionEnd: '12/31/27',
        introDeadlineHouse: null,
        introDeadlineSenate: null,
        crossover: null,
        carryoverFromPrior: false,
        carryoverToNext: true,
        notes: null
    }
];
function formatDate(dateStr) {
    if (!dateStr) return "\u2014";
    return dateStr;
}
function LegislativeSessionsComponent() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "text-2xl font-semibold",
                                    children: "2027 Legislative Sessions"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-sm text-muted-foreground mt-1",
                                    children: "Key dates for state legislative sessions relevant to our clients"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                            href: SOURCE_URL,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "inline-flex items-center gap-1.5 text-sm text-primary hover:underline shrink-0",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ExternalLink), {
                                    className: "h-4 w-4"
                                }),
                                "View Source (MultiState)"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center gap-2 p-3 rounded-md border bg-muted/50 text-sm",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Info), {
                            className: "h-4 w-4 text-muted-foreground shrink-0"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            children: [
                                "Last generated on ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: LAST_GENERATED
                                }),
                                ". Check the source link above for the latest updates."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "rounded-md border",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                            children: "State"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                            children: "Session Start"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                            children: "Session End"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                            children: "Intro Deadline (House)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                            children: "Intro Deadline (Senate)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                            children: "Crossover"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                            children: "Carryover '26 to '27"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                            children: "Carryover '27 to '28"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                            className: "min-w-[200px]",
                                            children: "Notes"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                children: LEGISLATIVE_SESSIONS_2027.map((session)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                className: "font-medium",
                                                children: session.state
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                children: formatDate(session.sessionStart)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                children: formatDate(session.sessionEnd)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                children: formatDate(session.introDeadlineHouse)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                children: formatDate(session.introDeadlineSenate)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                children: formatDate(session.crossover)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                                    variant: session.carryoverFromPrior ? 'default' : 'secondary',
                                                    children: session.carryoverFromPrior ? 'Yes' : 'No'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                                    variant: session.carryoverToNext ? 'default' : 'secondary',
                                                    children: session.carryoverToNext ? 'Yes' : 'No'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                className: "text-sm text-muted-foreground",
                                                children: session.notes || "\u2014"
                                            })
                                        ]
                                    }, session.state))
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "text-xs text-muted-foreground space-y-1",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: "Carryover:"
                                }),
                                " Indicates if bills can carry over between years (2026 into 2027, and 2027 into 2028)"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: "Notes:"
                                }),
                                " Special session info, veto recesses, and other important dates"
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"]],"../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/components/ui/table":"5vxZ8","@/client/components/ui/badge":"h4e1f","lucide-react":[["ExternalLink","kIIQA","default"],["Info","4BuJn","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3itSR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _zod = require("zod");
var _lucideReact = require("lucide-react");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _input = require("@/client/components/ui/input");
var _button = require("@/client/components/ui/button");
var _card = require("@/client/components/ui/card");
var _badge = require("@/client/components/ui/badge");
var _table = require("@/client/components/ui/table");
var _spinner = require("@/client/components/ui/spinner");
var _config = require("@/client/config");
const masterIDSchema = (0, _zod.z).string().regex(/^\d{10}_\d+$/, 'Format: clientID_eventID (e.g., 1234567890_12345)');
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'utilities/media-probe',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: MediaProbeComponent
});
function MediaProbeComponent() {
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const [masterID, setMasterID] = (0, _react.useState)('');
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    const [validationError, setValidationError] = (0, _react.useState)(null);
    const [result, setResult] = (0, _react.useState)(null);
    const [expandedAssets, setExpandedAssets] = (0, _react.useState)(new Set());
    // Deep probe state
    const [deepProbeResults, setDeepProbeResults] = (0, _react.useState)(new Map());
    const [deepProbeLoading, setDeepProbeLoading] = (0, _react.useState)(new Set());
    const handleDiagnose = async (e)=>{
        e.preventDefault();
        setValidationError(null);
        const validation = masterIDSchema.safeParse(masterID.trim());
        if (!validation.success) {
            setValidationError(validation.error.issues[0].message);
            return;
        }
        setLoading(true);
        setError(null);
        setResult(null);
        try {
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/events/${encodeURIComponent(masterID)}/diagnose`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (!response.ok) {
                const errData = await response.json().catch(()=>({}));
                throw new Error(errData.message || `HTTP ${response.status}`);
            }
            const data = await response.json();
            setResult(data);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Unknown error');
        } finally{
            setLoading(false);
        }
    };
    const toggleAssetExpand = (assetID)=>{
        setExpandedAssets((prev)=>{
            const next = new Set(prev);
            if (next.has(assetID)) next.delete(assetID);
            else next.add(assetID);
            return next;
        });
    };
    const handleDeepProbe = async (assetID, url)=>{
        if (!url) return;
        setDeepProbeLoading((prev)=>new Set(prev).add(assetID));
        try {
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/probe/deep`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    uri: url
                })
            });
            const data = await response.json();
            setDeepProbeResults((prev)=>new Map(prev).set(assetID, data));
        } catch (err) {
            setDeepProbeResults((prev)=>new Map(prev).set(assetID, {
                    success: false,
                    inputUri: url,
                    error: err instanceof Error ? err.message : 'Unknown error',
                    probeTimeMs: 0
                }));
        } finally{
            setDeepProbeLoading((prev)=>{
                const next = new Set(prev);
                next.delete(assetID);
                return next;
            });
        }
    };
    const handleExportText = (0, _react.useCallback)(()=>{
        if (!result) return;
        const lines = [];
        const hr = '='.repeat(70);
        const divider = '-'.repeat(70);
        // Header
        lines.push(hr);
        lines.push('EVENT MEDIA PROBE REPORT');
        lines.push(hr);
        lines.push(`Event ID:       ${result.eventID}`);
        lines.push(`Assets:         ${result.assetCount}`);
        lines.push(`Overall Status: ${result.overallStatus.toUpperCase()}`);
        lines.push(`Critical:       ${result.summary.critical}`);
        lines.push(`Warnings:       ${result.summary.warnings}`);
        lines.push(`Generated:      ${new Date().toLocaleString()}`);
        lines.push('');
        // Cross-asset checks
        if (result.crossAssetChecks.length > 0) {
            lines.push(divider);
            lines.push('CROSS-ASSET CHECKS');
            lines.push(divider);
            for (const check of result.crossAssetChecks){
                const icon = check.status === 'pass' ? 'PASS' : check.status === 'fail' ? 'FAIL' : 'SKIP';
                lines.push(`  [${icon}] ${formatCheckName(check.name)}${check.message ? ` \u{2014} ${check.message}` : ''}`);
            }
            lines.push('');
        }
        // Assets
        for (const asset of result.assets){
            lines.push(divider);
            lines.push(`ASSET: ${asset.originalFileName || asset.assetID}`);
            lines.push(divider);
            lines.push(`  Asset ID:   ${asset.assetID}`);
            lines.push(`  Status:     ${asset.status.toUpperCase()}`);
            lines.push(`  URL:        ${asset.url || 'N/A'}`);
            // Probed metadata
            lines.push('');
            lines.push('  Probed Metadata:');
            if (asset.probeResult) {
                const p = asset.probeResult;
                lines.push(`    Duration:     ${p.duration ? `${(p.duration / 60).toFixed(1)} min` : '-'}`);
                lines.push(`    Resolution:   ${p.video ? `${p.video.width}x${p.video.height}` : '-'}`);
                lines.push(`    Video:        ${formatVideoInfo(p.video)}`);
                lines.push(`    Audio:        ${formatAudioInfo(p.audio)}`);
                lines.push(`    Bitrate:      ${formatBitrate(p.bitrate)}`);
                lines.push(`    Pixel Format: ${p.video?.pixelFormat || '-'}`);
                lines.push(`    File Size:    ${formatFileSize(p.size)}`);
            } else lines.push('    (probe failed or no data)');
            // Stored metadata comparison
            const s = asset.storedMetadata;
            if (s.runtimeMin || s.dims || s.avgBitrate || s.fileSize) {
                lines.push('');
                lines.push('  Stored Metadata:');
                if (s.runtimeMin) lines.push(`    Duration:   ${s.runtimeMin} min`);
                if (s.dims) lines.push(`    Resolution: ${s.dims}`);
                if (s.avgBitrate) lines.push(`    Bitrate:    ${s.avgBitrate}`);
                if (s.fileSize) lines.push(`    File Size:  ${formatFileSize(s.fileSize)}`);
            }
            // Checks
            lines.push('');
            lines.push('  Checks:');
            for (const check of asset.checks){
                const icon = check.status === 'pass' ? 'PASS' : check.status === 'fail' ? 'FAIL' : 'SKIP';
                lines.push(`    [${icon}] ${formatCheckName(check.name)}${check.message ? ` \u{2014} ${check.message}` : ''}`);
            }
            // Deep probe results if available
            const deepResult = deepProbeResults.get(asset.assetID);
            if (deepResult?.success) {
                lines.push('');
                lines.push('  Deep Probe:');
                if (deepResult.bitrateAnalysis) {
                    const b = deepResult.bitrateAnalysis;
                    lines.push(`    Bitrate Mode: ${b.mode} (avg ${formatBitrate(b.avgBitrate)})`);
                    if (b.nominalBitrate) lines.push(`    Nominal:      ${formatBitrate(b.nominalBitrate)}`);
                    if (b.maxBitrate) lines.push(`    Max:          ${formatBitrate(b.maxBitrate)}`);
                    if (b.audioBitrateMode) lines.push(`    Audio Mode:   ${b.audioBitrateMode}${b.audioBitrate ? ` (${formatBitrate(b.audioBitrate)})` : ''}`);
                }
                if (deepResult.gopAnalysis) {
                    const g = deepResult.gopAnalysis;
                    if (g.gopSize) lines.push(`    GOP Size:     ${g.gopSize} frames${g.gopDurationSec ? ` / ${g.gopDurationSec}s` : ''}`);
                    if (g.gopStructure) lines.push(`    GOP Structure: ${g.gopStructure}`);
                }
            }
            lines.push('');
        }
        lines.push(hr);
        lines.push('END OF REPORT');
        lines.push(hr);
        const text = lines.join('\n');
        const blob = new Blob([
            text
        ], {
            type: 'text/plain;charset=utf-8;'
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `media-probe_${result.eventID}_${new Date().toISOString().slice(0, 10)}.txt`;
        link.click();
        URL.revokeObjectURL(link.href);
    }, [
        result,
        deepProbeResults
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center justify-between mb-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "text-2xl font-semibold",
                                    children: "Event Media Probe"
                                }),
                                result && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                    variant: "outline",
                                    size: "sm",
                                    onClick: handleExportText,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                            className: "size-4 mr-2"
                                        }),
                                        "Export as Text"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-muted-foreground mb-6",
                            children: "Diagnose video assets for an Event by probing files and comparing against stored metadata."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                            onSubmit: handleDiagnose,
                            className: "flex gap-2 max-w-lg mb-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                    type: "text",
                                    placeholder: "clientID_eventID",
                                    value: masterID,
                                    onChange: (e)=>{
                                        setMasterID(e.target.value);
                                        if (validationError) setValidationError(null);
                                    },
                                    disabled: loading,
                                    className: "font-mono"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                    type: "submit",
                                    disabled: loading || !masterID.trim(),
                                    children: [
                                        loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {
                                            className: "size-4"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Search), {
                                            className: "size-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "ml-2",
                                            children: "Diagnose"
                                        })
                                    ]
                                })
                            ]
                        }),
                        validationError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-sm text-red-600 -mt-4 mb-4",
                            children: validationError
                        }),
                        error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "p-3 text-sm text-red-500 bg-red-50 dark:bg-red-950 rounded-md mb-6",
                            children: error
                        })
                    ]
                }),
                result && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                                    className: "pb-3",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardTitle), {
                                                className: "text-lg",
                                                children: "Diagnosis Summary"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusBadge, {
                                                status: result.overallStatus
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardContent), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "grid grid-cols-2 md:grid-cols-4 gap-4 text-sm",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "text-muted-foreground",
                                                            children: "Event ID"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "font-mono",
                                                            children: result.eventID
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "text-muted-foreground",
                                                            children: "Assets"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "font-semibold",
                                                            children: result.assetCount
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "text-muted-foreground",
                                                            children: "Issues"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex gap-2 mt-1",
                                                            children: [
                                                                result.summary.critical > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                                                    variant: "destructive",
                                                                    children: [
                                                                        result.summary.critical,
                                                                        " critical"
                                                                    ]
                                                                }),
                                                                result.summary.warnings > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                                                    variant: "outline",
                                                                    className: "border-yellow-500 text-yellow-600",
                                                                    children: [
                                                                        result.summary.warnings,
                                                                        " warnings"
                                                                    ]
                                                                }),
                                                                result.summary.critical === 0 && result.summary.warnings === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                                                    variant: "outline",
                                                                    className: "border-green-500 text-green-600",
                                                                    children: "All checks passed"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckSummary, {
                                            assets: result.assets
                                        })
                                    ]
                                })
                            ]
                        }),
                        result.crossAssetChecks.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                                    className: "pb-3",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardTitle), {
                                        className: "text-lg",
                                        children: "Cross-Asset Checks"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "space-y-2",
                                        children: result.crossAssetChecks.map((check, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckRow, {
                                                check: check
                                            }, idx))
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                                    className: "pb-3",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardTitle), {
                                        className: "text-lg",
                                        children: "Assets"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                                    className: "p-0",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "rounded-md border overflow-x-auto",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                                className: "w-10"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                                children: "File Name"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                                children: "Status"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                                children: "Duration"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                                children: "Resolution"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                                children: "Checks"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                                    children: result.assets.map((asset)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(AssetRow, {
                                                            asset: asset,
                                                            expanded: expandedAssets.has(asset.assetID),
                                                            onToggle: ()=>toggleAssetExpand(asset.assetID),
                                                            deepProbeResult: deepProbeResults.get(asset.assetID),
                                                            deepProbeLoading: deepProbeLoading.has(asset.assetID),
                                                            onDeepProbe: ()=>handleDeepProbe(asset.assetID, asset.url || '')
                                                        }, asset.assetID))
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
// ============================================================================
// Helper Components
// ============================================================================
function StatusBadge({ status }) {
    switch(status){
        case 'ok':
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                variant: "outline",
                className: "border-green-500 text-green-600",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CheckCircle2), {
                        className: "size-3 mr-1"
                    }),
                    " OK"
                ]
            });
        case 'warning':
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                variant: "outline",
                className: "border-yellow-500 text-yellow-600",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                        className: "size-3 mr-1"
                    }),
                    " Warning"
                ]
            });
        case 'critical':
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                variant: "destructive",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XCircle), {
                        className: "size-3 mr-1"
                    }),
                    " Critical"
                ]
            });
        case 'error':
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                variant: "destructive",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XCircle), {
                        className: "size-3 mr-1"
                    }),
                    " Error"
                ]
            });
    }
}
function CheckIcon({ check }) {
    if (check.status === 'pass') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CheckCircle2), {
        className: "size-4 text-green-500"
    });
    if (check.status === 'fail') {
        if (check.severity === 'critical') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XCircle), {
            className: "size-4 text-red-500"
        });
        if (check.severity === 'warning') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
            className: "size-4 text-yellow-500"
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
            className: "size-4 text-blue-500"
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.HelpCircle), {
        className: "size-4 text-muted-foreground"
    });
}
function CheckRow({ check }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-2 text-sm",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckIcon, {
                check: check
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-medium",
                children: formatCheckName(check.name)
            }),
            check.message && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "text-muted-foreground",
                children: [
                    "- ",
                    check.message
                ]
            })
        ]
    });
}
function formatCheckName(name) {
    return name.replace(/_/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase());
}
function formatDuration(seconds) {
    if (seconds === null || seconds === undefined) return '-';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
}
function formatFileSize(bytes) {
    if (bytes === null || bytes === undefined) return '-';
    const num = typeof bytes === 'string' ? parseInt(bytes, 10) : bytes;
    if (isNaN(num)) return '-';
    if (num < 1024) return `${num} B`;
    if (num < 1048576) return `${(num / 1024).toFixed(1)} KB`;
    if (num < 1073741824) return `${(num / 1048576).toFixed(1)} MB`;
    return `${(num / 1073741824).toFixed(2)} GB`;
}
function formatBitrate(bps) {
    if (bps === null || bps === undefined) return '-';
    return `${(bps / 1000000).toFixed(2)} Mbps`;
}
function formatVideoInfo(video) {
    if (!video) return '-';
    const fps = video.frameRate ? ` @ ${video.frameRate.toFixed(2)}fps` : '';
    // Include profile/level if available (e.g., "h264 (High 4.1) @ 29.97fps")
    const profileLevel = video.profile || video.level ? ` (${[
        video.profile,
        video.level
    ].filter(Boolean).join(' ')})` : '';
    return `${video.codec}${profileLevel}${fps}`;
}
function formatAudioInfo(audio) {
    if (!audio) return '-';
    const channelLabel = audio.channels === 1 ? 'mono' : audio.channels === 2 ? 'stereo' : `${audio.channels}ch`;
    const sampleRate = audio.sampleRate >= 1000 ? `${(audio.sampleRate / 1000).toFixed(1)}kHz` : `${audio.sampleRate}Hz`;
    return `${audio.codec} ${channelLabel} (${sampleRate})`;
}
function CheckSummary({ assets }) {
    if (assets.length === 0) return null;
    // Aggregate key checks across all assets
    const keyChecks = [
        'file_exists',
        'has_audio',
        'web_optimized'
    ];
    const checkStats = keyChecks.map((checkName)=>{
        const allChecks = assets.flatMap((a)=>a.checks.filter((c)=>c.name === checkName));
        const passed = allChecks.filter((c)=>c.status === 'pass').length;
        const failed = allChecks.filter((c)=>c.status === 'fail').length;
        const total = passed + failed;
        return {
            name: checkName,
            passed,
            failed,
            total
        };
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-wrap gap-3 mt-4 pt-4 border-t text-xs",
        children: checkStats.map(({ name, passed, failed, total })=>{
            if (total === 0) return null;
            const allPassed = failed === 0;
            const label = formatCheckName(name);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-1.5",
                children: [
                    allPassed ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CheckCircle2), {
                        className: "size-3.5 text-green-500"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                        className: "size-3.5 text-yellow-500"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: allPassed ? 'text-green-600' : 'text-yellow-600',
                        children: allPassed ? name === 'file_exists' ? 'All files exist' : name === 'has_audio' ? 'All have audio' : `All ${label.toLowerCase()}` : `${passed}/${total} ${label.toLowerCase()}`
                    })
                ]
            }, name);
        })
    });
}
function CopyableID({ id, truncateLength = 6 }) {
    const [copied, setCopied] = (0, _react.useState)(false);
    const handleCopy = (0, _react.useCallback)(async (e)=>{
        e.stopPropagation();
        await navigator.clipboard.writeText(id);
        setCopied(true);
        setTimeout(()=>setCopied(false), 1500);
    }, [
        id
    ]);
    const truncated = id.length > truncateLength ? `${id.slice(0, truncateLength)}\u{2026}` : id;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        onClick: handleCopy,
        className: "inline-flex items-center gap-1 font-mono text-xs px-1.5 py-0.5 rounded bg-muted hover:bg-muted/80 transition-colors cursor-pointer",
        title: `Click to copy: ${id}`,
        children: [
            truncated,
            copied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                className: "size-3 text-green-500"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Copy), {
                className: "size-3 text-muted-foreground"
            })
        ]
    });
}
function AssetRow({ asset, expanded, onToggle, deepProbeResult, deepProbeLoading, onDeepProbe }) {
    const passedChecks = asset.checks.filter((c)=>c.status === 'pass').length;
    const failedChecks = asset.checks.filter((c)=>c.status === 'fail').length;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                className: "cursor-pointer hover:bg-muted/50",
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                        children: expanded ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronUp), {
                            className: "size-4 text-muted-foreground"
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                            className: "size-4 text-muted-foreground"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "max-w-xs truncate",
                            title: asset.originalFileName || asset.assetID,
                            children: asset.originalFileName || asset.assetID
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusBadge, {
                            status: asset.status
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                        className: "font-mono text-sm",
                        children: formatDuration(asset.probeResult?.duration)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                        className: "font-mono text-sm",
                        children: asset.probeResult?.video ? `${asset.probeResult.video.width}x${asset.probeResult.video.height}` : '-'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableCell), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "text-green-600",
                                children: [
                                    passedChecks,
                                    " passed"
                                ]
                            }),
                            failedChecks > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "text-red-500 ml-2",
                                children: [
                                    failedChecks,
                                    " failed"
                                ]
                            })
                        ]
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                    colSpan: 6,
                    className: "bg-muted/30 p-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grid md:grid-cols-2 gap-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                        className: "font-semibold mb-2 text-sm",
                                        children: "URL"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "text-xs font-mono break-all text-muted-foreground",
                                        children: asset.url || 'N/A'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                        className: "font-semibold mb-2 text-sm",
                                        children: "Metadata"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "grid grid-cols-2 gap-x-4 gap-y-1 text-xs",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-muted-foreground",
                                                children: "Asset ID:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CopyableID, {
                                                    id: asset.assetID
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-muted-foreground",
                                                children: "Video:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-mono",
                                                children: formatVideoInfo(asset.probeResult?.video)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-muted-foreground",
                                                children: "Audio:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-mono",
                                                children: formatAudioInfo(asset.probeResult?.audio)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-muted-foreground",
                                                children: "Resolution:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "font-mono",
                                                children: [
                                                    asset.probeResult?.video ? `${asset.probeResult.video.width}x${asset.probeResult.video.height}` : '-',
                                                    asset.storedMetadata.dims && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-muted-foreground",
                                                        children: [
                                                            " (stored: ",
                                                            asset.storedMetadata.dims,
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-muted-foreground",
                                                children: "Duration:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "font-mono",
                                                children: [
                                                    asset.probeResult?.duration ? `${(asset.probeResult.duration / 60).toFixed(1)} min` : '-',
                                                    asset.storedMetadata.runtimeMin && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-muted-foreground",
                                                        children: [
                                                            " (stored: ",
                                                            asset.storedMetadata.runtimeMin,
                                                            " min)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-muted-foreground",
                                                children: "Bitrate:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-mono",
                                                children: formatBitrate(asset.probeResult?.bitrate)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-muted-foreground",
                                                children: "Pixel Format:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "font-mono",
                                                children: asset.probeResult?.video?.pixelFormat || '-'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "text-muted-foreground",
                                                children: "File Size:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "font-mono",
                                                children: [
                                                    formatFileSize(asset.probeResult?.size),
                                                    asset.storedMetadata.fileSize && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "text-muted-foreground",
                                                        children: [
                                                            " (stored: ",
                                                            formatFileSize(asset.storedMetadata.fileSize),
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "md:col-span-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                        className: "font-semibold mb-2 text-sm",
                                        children: "Checks"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "grid md:grid-cols-2 gap-2",
                                        children: asset.checks.map((check, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckRow, {
                                                check: check
                                            }, idx))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "md:col-span-2 pt-4 border-t",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-3 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                className: "font-semibold text-sm",
                                                children: "Deep Probe"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                size: "sm",
                                                variant: "outline",
                                                onClick: (e)=>{
                                                    e.stopPropagation();
                                                    onDeepProbe();
                                                },
                                                disabled: deepProbeLoading || !asset.url,
                                                className: "h-7 text-xs",
                                                children: deepProbeLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {
                                                            className: "size-3 mr-1"
                                                        }),
                                                        "Analyzing..."
                                                    ]
                                                }) : deepProbeResult ? 'Re-analyze' : 'Analyze Bitrate & GOP'
                                            }),
                                            deepProbeResult?.probeTimeMs && deepProbeResult.probeTimeMs > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "text-xs text-muted-foreground",
                                                children: [
                                                    "(",
                                                    (deepProbeResult.probeTimeMs / 1000).toFixed(1),
                                                    "s)"
                                                ]
                                            })
                                        ]
                                    }),
                                    deepProbeResult && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeepProbeDisplay, {
                                        result: deepProbeResult
                                    }),
                                    !deepProbeResult && !deepProbeLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "text-xs text-muted-foreground",
                                        children: "Analyzes bitrate mode (CBR/VBR) and GOP structure using MediaInfo."
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function BitrateModeBadge({ mode }) {
    const className = mode === 'CBR' ? 'border-green-500 text-green-600' : mode === 'VBR' ? 'border-blue-500 text-blue-600' : mode === 'ABR' ? 'border-yellow-500 text-yellow-600' : '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
        variant: "outline",
        className: className,
        children: mode
    });
}
/** 3-column row: Simple Name | Value | Technical Context */ function ProbeRow({ label, value, context }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "grid grid-cols-[120px_1fr_1fr] gap-x-4 items-center text-sm",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-muted-foreground",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "font-mono",
                children: value
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-muted-foreground text-xs",
                children: context
            })
        ]
    });
}
function DeepProbeDisplay({ result }) {
    if (!result.success) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "text-sm text-red-500 flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XCircle), {
                className: "size-4"
            }),
            result.error || 'Deep probe failed'
        ]
    });
    const { bitrateAnalysis, gopAnalysis } = result;
    // Build technical context strings
    const bitrateContext = bitrateAnalysis ? [
        bitrateAnalysis.nominalBitrate && `target ${formatBitrate(bitrateAnalysis.nominalBitrate)}`,
        bitrateAnalysis.maxBitrate && `max ${formatBitrate(bitrateAnalysis.maxBitrate)}`
    ].filter(Boolean).join(" \xb7 ") : '';
    const gopContext = gopAnalysis?.gopStructure || '';
    const keyframeValue = gopAnalysis ? `${gopAnalysis.gopSize ?? '?'} frames${gopAnalysis.gopDurationSec ? ` / ${gopAnalysis.gopDurationSec}s` : ''}` : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "space-y-4 text-xs",
        children: [
            bitrateAnalysis && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "space-y-1.5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                        className: "font-medium text-sm",
                        children: "Video"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProbeRow, {
                        label: "Bitrate Mode",
                        value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(BitrateModeBadge, {
                                    mode: bitrateAnalysis.mode
                                }),
                                formatBitrate(bitrateAnalysis.avgBitrate)
                            ]
                        }),
                        context: bitrateContext
                    }),
                    gopAnalysis && keyframeValue && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProbeRow, {
                        label: "Keyframes",
                        value: keyframeValue,
                        context: `GOP ${gopContext}`
                    })
                ]
            }),
            bitrateAnalysis?.audioBitrateMode && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "space-y-1.5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                        className: "font-medium text-sm",
                        children: "Audio"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProbeRow, {
                        label: "Bitrate Mode",
                        value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(BitrateModeBadge, {
                                    mode: bitrateAnalysis.audioBitrateMode
                                }),
                                bitrateAnalysis.audioBitrate ? formatBitrate(bitrateAnalysis.audioBitrate) : ''
                            ]
                        }),
                        context: bitrateAnalysis.audioBitrateMode === 'CBR' ? 'constant bitrate' : 'variable bitrate'
                    })
                ]
            }),
            !bitrateAnalysis && !gopAnalysis && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-muted-foreground",
                children: "No analysis data available. MediaInfo could not extract bitrate or GOP information."
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"]],"@auth0/auth0-react":"gpXrE","zod":"dmnwW","lucide-react":[["AlertTriangle","cdePa","default"],["Check","bajJU","default"],["CheckCircle2","jNsZg","default"],["ChevronDown","kVmgC","default"],["ChevronUp","9DiT4","default"],["Copy","jM41N","default"],["Download","eRiW1","default"],["HelpCircle","iDfGt","default"],["Search","7AEK5","default"],["XCircle","aDWrd","default"]],"../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/components/ui/input":"8UHwi","@/client/components/ui/button":"armlb","@/client/components/ui/card":"dhIfn","@/client/components/ui/badge":"h4e1f","@/client/components/ui/table":"5vxZ8","@/client/components/ui/spinner":"7htqi","@/client/config":"8SWgh","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"jNsZg":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>CircleCheck);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const CircleCheck = (0, _createLucideIconJsDefault.default)("circle-check", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"iDfGt":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>CircleQuestionMark);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
            key: "1u773s"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const CircleQuestionMark = (0, _createLucideIconJsDefault.default)("circle-question-mark", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5VnDV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _zod = require("zod");
var _lucideReact = require("lucide-react");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _playerButton = require("@/client/components/player-button");
var _input = require("@/client/components/ui/input");
var _button = require("@/client/components/ui/button");
var _card = require("@/client/components/ui/card");
var _badge = require("@/client/components/ui/badge");
var _tabs = require("@/client/components/ui/tabs");
var _table = require("@/client/components/ui/table");
var _spinner = require("@/client/components/ui/spinner");
var _config = require("@/client/config");
var _types = require("@shared/types");
const vttUrlSchema = (0, _zod.z).string().url('Please enter a valid URL');
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'utilities/vtt-analyzer',
    validateSearch: (search)=>({
            url: typeof search.url === 'string' ? search.url : undefined
        }),
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: VttAnalyzerComponent
});
/** Format seconds as HH:MM:SS */ function formatTimestamp(seconds) {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor(seconds % 3600 / 60);
    const secs = Math.round(seconds % 60);
    return `${hrs}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}
/** Format seconds as human-readable duration */ function formatDuration(seconds) {
    if (seconds < 60) return `${seconds.toFixed(1)}s`;
    const mins = Math.floor(seconds / 60);
    const secs = Math.round(seconds % 60);
    return `${mins}m ${secs}s`;
}
function VttAnalyzerComponent() {
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const { url: initialUrl } = (0, _reactRouter.useSearch)({
        from: '/utilities/vtt-analyzer'
    });
    const [url, setUrl] = (0, _react.useState)(initialUrl ?? '');
    const [loading, setLoading] = (0, _react.useState)(false);
    const [result, setResult] = (0, _react.useState)(null);
    const [validationError, setValidationError] = (0, _react.useState)(null);
    /** Check if input looks like an eventID (clientID_eventSuffix) rather than a URL */ const isEventID = (input)=>/^\d+_\S+$/.test(input.trim()) && !input.includes('://');
    const handleAnalyze = async (e)=>{
        e.preventDefault();
        setValidationError(null);
        setLoading(true);
        setResult(null);
        const input = url.trim();
        try {
            const token = await getAccessTokenSilently();
            // If input looks like an eventID, resolve it to a VTT URL first
            let vttUrl = input;
            if (isEventID(input)) {
                const resolveRes = await fetch(`${(0, _config.API_BASE_URL)}/api/vtt/resolve/${encodeURIComponent(input)}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (!resolveRes.ok) {
                    const err = await resolveRes.json().catch(()=>({
                            error: 'No caption found'
                        }));
                    setValidationError(err.error || 'No caption VTT found for this event');
                    setLoading(false);
                    return;
                }
                const { url: resolvedUrl } = await resolveRes.json();
                vttUrl = resolvedUrl;
                setUrl(vttUrl); // Update input to show resolved URL
            } else {
                const validation = vttUrlSchema.safeParse(vttUrl);
                if (!validation.success) {
                    setValidationError(validation.error.issues[0].message);
                    setLoading(false);
                    return;
                }
            }
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/vtt/analyze`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    url: vttUrl
                })
            });
            const data = await response.json();
            setResult(data);
        } catch (err) {
            setResult({
                url: input,
                success: false,
                error: err instanceof Error ? err.message : 'Unknown error',
                totalSegments: 0,
                firstTimestamp: 0,
                lastTimestamp: 0,
                totalDurationSeconds: 0,
                minutesWithNoCoverage: [],
                significantGaps: [],
                largeGaps: []
            });
        } finally{
            setLoading(false);
        }
    };
    const hallucinationScore = result?.hallucinations?.score ?? 0;
    const hasHallucinations = hallucinationScore > 0;
    const hasIssues = result?.success && (result.largeGaps.length > 0 || result.minutesWithNoCoverage.length > 0 || hasHallucinations);
    const isClean = result?.success && !hasIssues;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            className: "text-2xl font-semibold mb-2",
                            children: "VTT Caption Analyzer"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-muted-foreground mb-6",
                            children: "Analyze WebVTT caption files for gaps, missing segments, and coverage issues."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                            onSubmit: handleAnalyze,
                            className: "flex gap-2 w-full mb-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                    type: "text",
                                    placeholder: "https://m-download.invintus.com/.../captions.vtt or clientID_eventID",
                                    value: url,
                                    onChange: (e)=>{
                                        setUrl(e.target.value);
                                        if (validationError) setValidationError(null);
                                    },
                                    disabled: loading,
                                    className: "font-mono text-sm"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                    type: "submit",
                                    disabled: loading || !url.trim(),
                                    children: [
                                        loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {
                                            className: "size-4"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Search), {
                                            className: "size-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "ml-2",
                                            children: "Analyze"
                                        })
                                    ]
                                })
                            ]
                        }),
                        validationError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-sm text-red-600 -mt-4",
                            children: validationError
                        })
                    ]
                }),
                result && !result.success && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.Card), {
                    className: "border-red-200 dark:border-red-900",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardContent), {
                        className: "pt-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2 text-red-600",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XCircle), {
                                        className: "size-5"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-medium",
                                        children: "Analysis Failed"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "mt-2 text-sm text-muted-foreground",
                                children: result.error
                            })
                        ]
                    })
                }),
                result?.success && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        result.eventInfo && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center rounded-lg border border-blue-500/40 bg-blue-500/10 px-4 py-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "text-base text-muted-foreground mr-2",
                                    children: "Event:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                                    to: "/events/$eventId",
                                    params: {
                                        eventId: result.eventInfo.eventID
                                    },
                                    className: "text-base font-semibold text-primary hover:underline inline-flex items-center gap-1",
                                    children: [
                                        result.eventInfo.eventTitle || result.eventInfo.eventID,
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowRight), {
                                            className: "size-4"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ml-auto",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _playerButton.PlayerButton), {
                                        clientID: result.eventInfo.clientID,
                                        eventID: (()=>{
                                            const parts = result.eventInfo.eventID.split('_');
                                            return parts.length >= 2 ? parts.slice(1).join('_') : result.eventInfo.eventID;
                                        })()
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                                    className: "pb-3",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                                                className: "text-lg flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FileText), {
                                                        className: "size-5"
                                                    }),
                                                    "Analysis Summary"
                                                ]
                                            }),
                                            isClean ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                                variant: "outline",
                                                className: "border-green-500 text-green-600",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CheckCircle2), {
                                                        className: "size-3 mr-1"
                                                    }),
                                                    " No Issues"
                                                ]
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                                variant: "outline",
                                                className: "border-yellow-500 text-yellow-600",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                                                        className: "size-3 mr-1"
                                                    }),
                                                    " Issues Found"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "grid grid-cols-2 md:grid-cols-4 gap-4 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-muted-foreground",
                                                        children: "Segments"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "font-semibold text-lg",
                                                        children: result.totalSegments.toLocaleString()
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-muted-foreground",
                                                        children: "Duration"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "font-semibold text-lg",
                                                        children: formatDuration(result.totalDurationSeconds)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-muted-foreground",
                                                        children: "Coverage"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "font-mono",
                                                        children: [
                                                            formatTimestamp(result.firstTimestamp),
                                                            " - ",
                                                            formatTimestamp(result.lastTimestamp)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-muted-foreground",
                                                        children: "Issues"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex flex-wrap gap-2 mt-1",
                                                        children: [
                                                            hallucinationScore > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                                                variant: "destructive",
                                                                className: "bg-purple-600",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Bug), {
                                                                        className: "size-3 mr-1"
                                                                    }),
                                                                    "Hallucinations (",
                                                                    hallucinationScore,
                                                                    ")"
                                                                ]
                                                            }),
                                                            result.largeGaps.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                                                variant: "destructive",
                                                                children: [
                                                                    result.largeGaps.length,
                                                                    " large gaps"
                                                                ]
                                                            }),
                                                            result.minutesWithNoCoverage.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                                                variant: "outline",
                                                                className: "border-yellow-500 text-yellow-600",
                                                                children: [
                                                                    result.minutesWithNoCoverage.length,
                                                                    " min uncovered"
                                                                ]
                                                            }),
                                                            isClean && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                                                variant: "outline",
                                                                className: "border-green-500 text-green-600",
                                                                children: "All clear"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReportTabs, {
                            result: result
                        })
                    ]
                })
            ]
        })
    });
}
function ReportTabs({ result }) {
    const markers = result.repetition?.markers;
    const phrases = result.repetition?.topRepeatedPhrases ?? [];
    const runs = result.repetition?.runs ?? [];
    const consecutiveDuplicates = result.repetition?.consecutiveDuplicates ?? 0;
    const longestRun = result.repetition?.longestRun ?? 0;
    const longLines = result.quality?.longLines ?? [];
    const avgChars = result.quality?.avgCharsPerSegment ?? 0;
    const hallucinations = result.hallucinations;
    const hallucinationCount = (hallucinations?.wordRepetitions.length ?? 0) + (hallucinations?.duplicateTexts.length ?? 0) + (hallucinations?.hallucinationPhrases.length ?? 0);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabs.Tabs), {
        defaultValue: hallucinationCount > 0 ? 'hallucinations' : 'markers',
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabs.TabsList), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabs.TabsTrigger), {
                        value: "hallucinations",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Bug), {
                                className: "size-4"
                            }),
                            "Hallucinations",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                variant: hallucinationCount > 0 ? 'destructive' : 'secondary',
                                className: hallucinationCount > 0 ? 'bg-purple-600' : '',
                                children: hallucinations?.score ?? 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabs.TabsTrigger), {
                        value: "markers",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Volume2), {
                                className: "size-4"
                            }),
                            "Markers",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                variant: "secondary",
                                children: markers?.totalMarkers ?? 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabs.TabsTrigger), {
                        value: "phrases",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FileText), {
                                className: "size-4"
                            }),
                            "Phrases",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                variant: "secondary",
                                children: phrases.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabs.TabsTrigger), {
                        value: "runs",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Repeat), {
                                className: "size-4"
                            }),
                            "Runs",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                variant: "secondary",
                                children: runs.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabs.TabsTrigger), {
                        value: "longLines",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.TextCursorInput), {
                                className: "size-4"
                            }),
                            "Long",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                variant: longLines.length > 0 ? 'outline' : 'secondary',
                                className: longLines.length > 0 ? 'border-yellow-500 text-yellow-600' : '',
                                children: longLines.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabs.TabsTrigger), {
                        value: "largeGaps",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XCircle), {
                                className: "size-4"
                            }),
                            "Large Gaps",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                variant: result.largeGaps.length > 0 ? 'destructive' : 'secondary',
                                children: result.largeGaps.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabs.TabsTrigger), {
                        value: "significantGaps",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Clock), {
                                className: "size-4"
                            }),
                            "Gaps",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                variant: "secondary",
                                children: result.significantGaps.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabs.TabsTrigger), {
                        value: "uncovered",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                                className: "size-4"
                            }),
                            "Uncovered",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                variant: result.minutesWithNoCoverage.length > 0 ? 'outline' : 'secondary',
                                className: result.minutesWithNoCoverage.length > 0 ? 'border-yellow-500 text-yellow-600' : '',
                                children: result.minutesWithNoCoverage.length
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabs.TabsContent), {
                value: "hallucinations",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(HallucinationsTab, {
                    hallucinations: hallucinations
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabs.TabsContent), {
                value: "markers",
                children: !markers || markers.totalMarkers === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyTabMessage, {
                    message: "No marker segments found in this VTT."
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardHeader), {
                            className: "pb-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                                    className: "text-lg flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Volume2), {
                                            className: "size-5"
                                        }),
                                        "Marker Segments"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "text-sm text-muted-foreground",
                                    children: [
                                        markers.totalMarkers,
                                        " marker segment",
                                        markers.totalMarkers !== 1 ? 's' : '',
                                        " (",
                                        markers.markerPercentage.toFixed(1),
                                        "% of total)"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-wrap gap-2",
                                children: Object.entries(markers.byType).sort((a, b)=>b[1] - a[1]).map(([type, count])=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                        variant: "outline",
                                        className: "font-mono",
                                        children: [
                                            "[",
                                            type,
                                            "] \xd7 ",
                                            count
                                        ]
                                    }, type))
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabs.TabsContent), {
                value: "phrases",
                children: phrases.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyTabMessage, {
                    message: "No repeated phrases (3+ occurrences) found in this VTT."
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardHeader), {
                            className: "pb-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                                    className: "text-lg flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FileText), {
                                            className: "size-5"
                                        }),
                                        "Top Repeated Phrases"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-sm text-muted-foreground",
                                    children: "Non-marker text appearing 3+ times (may be legitimate procedural phrases)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                            className: "p-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "rounded-md border overflow-x-auto",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                        className: "w-20",
                                                        children: "Count"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                        children: "Phrase"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                            children: phrases.map((item, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableCell), {
                                                            className: "font-semibold",
                                                            children: [
                                                                item.count,
                                                                "x"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                            className: "text-sm font-mono",
                                                            children: item.phrase
                                                        })
                                                    ]
                                                }, idx))
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabs.TabsContent), {
                value: "runs",
                children: runs.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyTabMessage, {
                    message: "No consecutive identical segments found in this VTT."
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardHeader), {
                            className: "pb-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                                    className: "text-lg flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Repeat), {
                                            className: "size-5"
                                        }),
                                        "Consecutive Identical Segments"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "text-sm text-muted-foreground",
                                    children: [
                                        consecutiveDuplicates,
                                        " consecutive duplicate pair",
                                        consecutiveDuplicates !== 1 ? 's' : '',
                                        " found",
                                        longestRun > 0 && ` (longest run: ${longestRun} segments)`
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                            className: "p-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "rounded-md border overflow-x-auto",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                        children: "Count"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                        children: "Time Range"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                        children: "Text"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                            children: runs.map((run, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableCell), {
                                                            className: "font-semibold",
                                                            children: [
                                                                run.count,
                                                                "x"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableCell), {
                                                            className: "font-mono text-sm whitespace-nowrap",
                                                            children: [
                                                                formatTimestamp(run.startTime),
                                                                " - ",
                                                                formatTimestamp(run.endTime)
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                            className: "text-sm max-w-md truncate",
                                                            title: run.text,
                                                            children: run.text
                                                        })
                                                    ]
                                                }, idx))
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabs.TabsContent), {
                value: "longLines",
                children: longLines.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyTabMessage, {
                    message: `No lines exceed ${(0, _types.VTT_LONG_LINE_THRESHOLD)} characters.`
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                    className: "border-yellow-200 dark:border-yellow-900",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardHeader), {
                            className: "pb-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                                    className: "text-lg flex items-center gap-2 text-yellow-600",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.TextCursorInput), {
                                            className: "size-5"
                                        }),
                                        "Long Lines (>",
                                        (0, _types.VTT_LONG_LINE_THRESHOLD),
                                        " chars)"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "text-sm text-muted-foreground",
                                    children: [
                                        longLines.length,
                                        " segment",
                                        longLines.length !== 1 ? 's' : '',
                                        " exceed the character threshold (avg: ",
                                        avgChars,
                                        " chars/segment)"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                            className: "p-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "rounded-md border overflow-x-auto",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                        className: "w-20",
                                                        children: "Chars"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                        className: "w-28",
                                                        children: "Time"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                        children: "Text"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                            children: longLines.map((line, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                            className: "font-semibold",
                                                            children: line.charCount
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                            className: "font-mono text-sm",
                                                            children: formatTimestamp(line.start)
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                            className: "text-sm max-w-md truncate",
                                                            title: line.text,
                                                            children: line.text
                                                        })
                                                    ]
                                                }, idx))
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabs.TabsContent), {
                value: "largeGaps",
                children: result.largeGaps.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyTabMessage, {
                    message: "No gaps larger than 30 seconds found."
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                    className: "border-red-200 dark:border-red-900",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardHeader), {
                            className: "pb-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                                    className: "text-lg flex items-center gap-2 text-red-600",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XCircle), {
                                            className: "size-5"
                                        }),
                                        "Large Gaps (>30s) - Likely Missing Segments"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "text-sm text-muted-foreground",
                                    children: [
                                        result.largeGaps.length,
                                        " gap",
                                        result.largeGaps.length !== 1 ? 's' : '',
                                        " detected"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                            className: "p-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(GapsTable, {
                                gaps: result.largeGaps
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabs.TabsContent), {
                value: "significantGaps",
                children: result.significantGaps.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyTabMessage, {
                    message: "No gaps larger than 5 seconds found."
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardHeader), {
                            className: "pb-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                                    className: "text-lg flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Clock), {
                                            className: "size-5"
                                        }),
                                        "Significant Gaps (>5s)"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "text-sm text-muted-foreground",
                                    children: [
                                        result.significantGaps.length,
                                        " gap",
                                        result.significantGaps.length !== 1 ? 's' : '',
                                        " sorted chronologically"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                            className: "p-0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(GapsTable, {
                                gaps: [
                                    ...result.significantGaps
                                ].sort((a, b)=>a.afterEnd - b.afterEnd)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabs.TabsContent), {
                value: "uncovered",
                children: result.minutesWithNoCoverage.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyTabMessage, {
                    message: "All minutes have caption coverage."
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                    className: "border-yellow-200 dark:border-yellow-900",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardHeader), {
                            className: "pb-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                                    className: "text-lg flex items-center gap-2 text-yellow-600",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                                            className: "size-5"
                                        }),
                                        "Minutes with No Caption Coverage"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "text-sm text-muted-foreground",
                                    children: [
                                        result.minutesWithNoCoverage.length,
                                        " minute",
                                        result.minutesWithNoCoverage.length !== 1 ? 's' : '',
                                        " have zero caption coverage"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "flex flex-wrap gap-2",
                                children: result.minutesWithNoCoverage.map((min)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                        variant: "outline",
                                        className: "font-mono",
                                        children: [
                                            min,
                                            ":00"
                                        ]
                                    }, min))
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function GapsTable({ gaps }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "rounded-md border overflow-x-auto",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                children: "Gap Duration"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                children: "From"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                children: "To"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                    children: gaps.map((gap, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                    className: "font-semibold",
                                    children: formatDuration(gap.gapSeconds)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                    className: "font-mono text-sm",
                                    children: formatTimestamp(gap.afterEnd)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                    className: "font-mono text-sm",
                                    children: formatTimestamp(gap.beforeStart)
                                })
                            ]
                        }, idx))
                })
            ]
        })
    });
}
function HallucinationsTab({ hallucinations }) {
    const wordReps = hallucinations?.wordRepetitions ?? [];
    const duplicates = hallucinations?.duplicateTexts ?? [];
    const phrases = hallucinations?.hallucinationPhrases ?? [];
    const score = hallucinations?.score ?? 0;
    const totalIssues = wordReps.length + duplicates.length + phrases.length;
    if (totalIssues === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyTabMessage, {
        message: "No hallucination patterns detected."
    });
    // Determine severity color based on score
    const severityColor = score >= 50 ? 'border-red-500' : score >= 25 ? 'border-yellow-500' : 'border-purple-500';
    const severityText = score >= 50 ? 'High' : score >= 25 ? 'Medium' : 'Low';
    const severityTextColor = score >= 50 ? 'text-red-600' : score >= 25 ? 'text-yellow-600' : 'text-purple-600';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.Card), {
                className: severityColor,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardHeader), {
                    className: "pb-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                            className: "text-lg flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Bug), {
                                    className: `size-5 ${severityTextColor}`
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: severityTextColor,
                                    children: [
                                        "Hallucination Score: ",
                                        score,
                                        "/100"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _badge.Badge), {
                                    variant: "outline",
                                    className: severityColor + ' ' + severityTextColor,
                                    children: [
                                        severityText,
                                        " Severity"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "text-sm text-muted-foreground",
                            children: "Whisper transcription artifacts detected. These indicate audio segments where the model failed to transcribe correctly."
                        })
                    ]
                })
            }),
            wordReps.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                className: "border-red-200 dark:border-red-900",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardHeader), {
                        className: "pb-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                                className: "text-lg flex items-center gap-2 text-red-600",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Repeat), {
                                        className: "size-5"
                                    }),
                                    "Repeated Word Loops"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-sm text-muted-foreground",
                                children: "Segments where a single word repeats excessively (>10 times) \u2014 classic Whisper failure mode"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                        className: "p-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rounded-md border overflow-x-auto",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    className: "w-20",
                                                    children: "Word"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    className: "w-20",
                                                    children: "Count"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    className: "w-28",
                                                    children: "Time"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    children: "Text Preview"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                        children: wordReps.map((rep, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableCell), {
                                                        className: "font-mono font-semibold text-red-600",
                                                        children: [
                                                            '"',
                                                            rep.word,
                                                            '"'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableCell), {
                                                        className: "font-semibold",
                                                        children: [
                                                            rep.count,
                                                            "x"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "font-mono text-sm",
                                                        children: formatTimestamp(rep.start)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "text-sm max-w-md truncate text-muted-foreground",
                                                        title: rep.text,
                                                        children: rep.text
                                                    })
                                                ]
                                            }, idx))
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            duplicates.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                className: "border-yellow-200 dark:border-yellow-900",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardHeader), {
                        className: "pb-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                                className: "text-lg flex items-center gap-2 text-yellow-600",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.FileText), {
                                        className: "size-5"
                                    }),
                                    "Non-Adjacent Duplicate Text"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-sm text-muted-foreground",
                                children: "Identical long text appearing at different times \u2014 may indicate hallucinated content"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                        className: "p-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rounded-md border overflow-x-auto",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    className: "w-20",
                                                    children: "Count"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    children: "Timestamps"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    children: "Text"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                        children: duplicates.map((dup, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableCell), {
                                                        className: "font-semibold",
                                                        children: [
                                                            dup.count,
                                                            "x"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "font-mono text-sm max-w-[400px]",
                                                        children: dup.timestamps.map((t)=>formatTimestamp(t)).join(', ')
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "text-sm max-w-md truncate",
                                                        title: dup.text,
                                                        children: dup.text
                                                    })
                                                ]
                                            }, idx))
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            phrases.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                className: "border-purple-200 dark:border-purple-900",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardHeader), {
                        className: "pb-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                                className: "text-lg flex items-center gap-2 text-purple-600",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                                        className: "size-5"
                                    }),
                                    "Known Whisper Hallucination Phrases"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-sm text-muted-foreground",
                                children: "Common phrases Whisper hallucinates during silence or unclear audio"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
                        className: "p-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rounded-md border overflow-x-auto",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    className: "w-24",
                                                    children: "Type"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    className: "w-28",
                                                    children: "Time"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    children: "Phrase"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                        children: phrases.map((p, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                                            variant: "outline",
                                                            className: "border-purple-500 text-purple-600 capitalize",
                                                            children: p.type
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "font-mono text-sm",
                                                        children: formatTimestamp(p.start)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "text-sm max-w-md truncate",
                                                        title: p.phrase,
                                                        children: p.phrase
                                                    })
                                                ]
                                            }, idx))
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}
function EmptyTabMessage({ message }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.Card), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardContent), {
            className: "py-8",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center justify-center gap-2 text-muted-foreground",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CheckCircle2), {
                        className: "size-5 text-green-500"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: message
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["Link","7k6Lq"],["redirect","jmFxY"],["useSearch","4yVFL"]],"@auth0/auth0-react":"gpXrE","zod":"dmnwW","lucide-react":[["AlertTriangle","cdePa","default"],["ArrowRight","itm6a","default"],["Bug","5JXbL","default"],["CheckCircle2","jNsZg","default"],["Clock","eqIIU","default"],["FileText","jrUS7","default"],["Repeat","adQQK","default"],["Search","7AEK5","default"],["TextCursorInput","bjH2G","default"],["Volume2","13G7V","default"],["XCircle","aDWrd","default"]],"../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/components/player-button":"k3ESH","@/client/components/ui/input":"8UHwi","@/client/components/ui/button":"armlb","@/client/components/ui/card":"dhIfn","@/client/components/ui/badge":"h4e1f","@/client/components/ui/tabs":"eYFPA","@/client/components/ui/table":"5vxZ8","@/client/components/ui/spinner":"7htqi","@/client/config":"8SWgh","@shared/types":"dzHsw","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"5JXbL":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Bug);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 20v-9",
            key: "1qisl0"
        }
    ],
    [
        "path",
        {
            d: "M14 7a4 4 0 0 1 4 4v3a6 6 0 0 1-12 0v-3a4 4 0 0 1 4-4z",
            key: "uouzyp"
        }
    ],
    [
        "path",
        {
            d: "M14.12 3.88 16 2",
            key: "qol33r"
        }
    ],
    [
        "path",
        {
            d: "M21 21a4 4 0 0 0-3.81-4",
            key: "1b0z45"
        }
    ],
    [
        "path",
        {
            d: "M21 5a4 4 0 0 1-3.55 3.97",
            key: "5cxbf6"
        }
    ],
    [
        "path",
        {
            d: "M22 13h-4",
            key: "1jl80f"
        }
    ],
    [
        "path",
        {
            d: "M3 21a4 4 0 0 1 3.81-4",
            key: "1fjd4g"
        }
    ],
    [
        "path",
        {
            d: "M3 5a4 4 0 0 0 3.55 3.97",
            key: "1d7oge"
        }
    ],
    [
        "path",
        {
            d: "M6 13H2",
            key: "82j7cp"
        }
    ],
    [
        "path",
        {
            d: "m8 2 1.88 1.88",
            key: "fmnt4t"
        }
    ],
    [
        "path",
        {
            d: "M9 7.13V6a3 3 0 1 1 6 0v1.13",
            key: "1vgav8"
        }
    ]
];
const Bug = (0, _createLucideIconJsDefault.default)("bug", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"adQQK":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Repeat);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m17 2 4 4-4 4",
            key: "nntrym"
        }
    ],
    [
        "path",
        {
            d: "M3 11v-1a4 4 0 0 1 4-4h14",
            key: "84bu3i"
        }
    ],
    [
        "path",
        {
            d: "m7 22-4-4 4-4",
            key: "1wqhfi"
        }
    ],
    [
        "path",
        {
            d: "M21 13v1a4 4 0 0 1-4 4H3",
            key: "1rx37r"
        }
    ]
];
const Repeat = (0, _createLucideIconJsDefault.default)("repeat", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"bjH2G":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>TextCursorInput);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M12 20h-1a2 2 0 0 1-2-2 2 2 0 0 1-2 2H6",
            key: "1528k5"
        }
    ],
    [
        "path",
        {
            d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7",
            key: "13ksps"
        }
    ],
    [
        "path",
        {
            d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1",
            key: "1n9rhb"
        }
    ],
    [
        "path",
        {
            d: "M6 4h1a2 2 0 0 1 2 2 2 2 0 0 1 2-2h1",
            key: "1mj8rg"
        }
    ],
    [
        "path",
        {
            d: "M9 6v12",
            key: "velyjx"
        }
    ]
];
const TextCursorInput = (0, _createLucideIconJsDefault.default)("text-cursor-input", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eYFPA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tabs", ()=>Tabs);
parcelHelpers.export(exports, "TabsList", ()=>TabsList);
parcelHelpers.export(exports, "TabsTrigger", ()=>TabsTrigger);
parcelHelpers.export(exports, "TabsContent", ()=>TabsContent);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactTabs = require("@radix-ui/react-tabs");
var _utils = require("@/client/lib/utils");
"use client";
function Tabs({ className, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactTabs.Root, {
        "data-slot": "tabs",
        className: (0, _utils.cn)("flex flex-col gap-2", className),
        ...props
    });
}
function TabsList({ className, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactTabs.List, {
        "data-slot": "tabs-list",
        className: (0, _utils.cn)("bg-muted text-muted-foreground inline-flex h-9 w-fit items-center justify-center rounded-lg p-[3px]", className),
        ...props
    });
}
function TabsTrigger({ className, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactTabs.Trigger, {
        "data-slot": "tabs-trigger",
        className: (0, _utils.cn)("data-[state=active]:bg-background dark:data-[state=active]:text-foreground focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring dark:data-[state=active]:border-input dark:data-[state=active]:bg-input/30 text-foreground dark:text-muted-foreground inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 rounded-md border border-transparent px-2 py-1 text-sm font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:shadow-sm [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className),
        ...props
    });
}
function TabsContent({ className, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactTabs.Content, {
        "data-slot": "tabs-content",
        className: (0, _utils.cn)("flex-1 outline-none", className),
        ...props
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@radix-ui/react-tabs":"dHeWc","@/client/lib/utils":"1ankz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dHeWc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Content", ()=>Content);
parcelHelpers.export(exports, "List", ()=>List);
parcelHelpers.export(exports, "Root", ()=>Root2);
parcelHelpers.export(exports, "Tabs", ()=>Tabs);
parcelHelpers.export(exports, "TabsContent", ()=>TabsContent);
parcelHelpers.export(exports, "TabsList", ()=>TabsList);
parcelHelpers.export(exports, "TabsTrigger", ()=>TabsTrigger);
parcelHelpers.export(exports, "Trigger", ()=>Trigger);
parcelHelpers.export(exports, "createTabsScope", ()=>createTabsScope);
// src/tabs.tsx
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactContext = require("@radix-ui/react-context");
var _reactRovingFocus = require("@radix-ui/react-roving-focus");
var _reactPresence = require("@radix-ui/react-presence");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactDirection = require("@radix-ui/react-direction");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _reactId = require("@radix-ui/react-id");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var TABS_NAME = "Tabs";
var [createTabsContext, createTabsScope] = (0, _reactContext.createContextScope)(TABS_NAME, [
    (0, _reactRovingFocus.createRovingFocusGroupScope)
]);
var useRovingFocusGroupScope = (0, _reactRovingFocus.createRovingFocusGroupScope)();
var [TabsProvider, useTabsContext] = createTabsContext(TABS_NAME);
var Tabs = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs, value: valueProp, onValueChange, defaultValue, orientation = "horizontal", dir, activationMode = "automatic", ...tabsProps } = props;
    const direction = (0, _reactDirection.useDirection)(dir);
    const [value, setValue] = (0, _reactUseControllableState.useControllableState)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue ?? "",
        caller: TABS_NAME
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(TabsProvider, {
        scope: __scopeTabs,
        baseId: (0, _reactId.useId)(),
        value,
        onValueChange: setValue,
        orientation,
        dir: direction,
        activationMode,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
            dir: direction,
            "data-orientation": orientation,
            ...tabsProps,
            ref: forwardedRef
        })
    });
});
Tabs.displayName = TABS_NAME;
var TAB_LIST_NAME = "TabsList";
var TabsList = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs, loop = true, ...listProps } = props;
    const context = useTabsContext(TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeTabs);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactRovingFocus.Root, {
        asChild: true,
        ...rovingFocusGroupScope,
        orientation: context.orientation,
        dir: context.dir,
        loop,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
            role: "tablist",
            "aria-orientation": context.orientation,
            ...listProps,
            ref: forwardedRef
        })
    });
});
TabsList.displayName = TAB_LIST_NAME;
var TRIGGER_NAME = "TabsTrigger";
var TabsTrigger = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs, value, disabled = false, ...triggerProps } = props;
    const context = useTabsContext(TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeTabs);
    const triggerId = makeTriggerId(context.baseId, value);
    const contentId = makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactRovingFocus.Item, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: isSelected,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).button, {
            type: "button",
            role: "tab",
            "aria-selected": isSelected,
            "aria-controls": contentId,
            "data-state": isSelected ? "active" : "inactive",
            "data-disabled": disabled ? "" : void 0,
            disabled,
            id: triggerId,
            ...triggerProps,
            ref: forwardedRef,
            onMouseDown: (0, _primitive.composeEventHandlers)(props.onMouseDown, (event)=>{
                if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
                else event.preventDefault();
            }),
            onKeyDown: (0, _primitive.composeEventHandlers)(props.onKeyDown, (event)=>{
                if ([
                    " ",
                    "Enter"
                ].includes(event.key)) context.onValueChange(value);
            }),
            onFocus: (0, _primitive.composeEventHandlers)(props.onFocus, ()=>{
                const isAutomaticActivation = context.activationMode !== "manual";
                if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
            })
        })
    });
});
TabsTrigger.displayName = TRIGGER_NAME;
var CONTENT_NAME = "TabsContent";
var TabsContent = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs, value, forceMount, children, ...contentProps } = props;
    const context = useTabsContext(CONTENT_NAME, __scopeTabs);
    const triggerId = makeTriggerId(context.baseId, value);
    const contentId = makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = _react.useRef(isSelected);
    _react.useEffect(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
        present: forceMount || isSelected,
        children: ({ present })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
                "data-state": isSelected ? "active" : "inactive",
                "data-orientation": context.orientation,
                role: "tabpanel",
                "aria-labelledby": triggerId,
                hidden: !present,
                id: contentId,
                tabIndex: 0,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...props.style,
                    animationDuration: isMountAnimationPreventedRef.current ? "0s" : void 0
                },
                children: present && children
            })
    });
});
TabsContent.displayName = CONTENT_NAME;
function makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
var Root2 = Tabs;
var List = TabsList;
var Trigger = TabsTrigger;
var Content = TabsContent;

},{"react":"eGun2","@radix-ui/primitive":"k8C5A","@radix-ui/react-context":"4wywa","@radix-ui/react-roving-focus":"gOMXg","@radix-ui/react-presence":"eh7qi","@radix-ui/react-primitive":"hQJ44","@radix-ui/react-direction":"boYIn","@radix-ui/react-use-controllable-state":"ThW7y","@radix-ui/react-id":"hoLx9","react/jsx-runtime":"dQjte","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"3Kygk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _zod = require("zod");
var _sonner = require("sonner");
var _lucideReact = require("lucide-react");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _input = require("@/client/components/ui/input");
var _button = require("@/client/components/ui/button");
var _label = require("@/client/components/ui/label");
var _select = require("@/client/components/ui/select");
var _dialog = require("@/client/components/ui/dialog");
var _table = require("@/client/components/ui/table");
var _crud = require("@/client/utils/crud");
var _clientsStore = require("@/client/store/clientsStore");
var _config = require("@/client/config");
var _events = require("@shared/types/events");
/** Statuses safe to force via this utility (production use cases only) */ const ALLOWED_TARGET_STATUSES = [
    4,
    7
];
const lookupSchema = (0, _zod.z).object({
    clientID: (0, _zod.z).string().length(10, 'Client ID must be 10 digits').regex(/^\d+$/, 'Client ID must be a number'),
    eventID: (0, _zod.z).string().min(1, 'Event ID is required')
});
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'utilities/update-event-status',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: UpdateEventStatusComponent
});
// ---------------------------------------------------------------------------
// Small UI helpers
// ---------------------------------------------------------------------------
function CheckIcon({ status }) {
    switch(status){
        case 'pass':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CheckCircle2), {
                className: "size-4 text-green-600"
            });
        case 'fail':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XCircle), {
                className: "size-4 text-red-600"
            });
        case 'warn':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                className: "size-4 text-amber-500"
            });
        case 'not_found':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.HelpCircle), {
                className: "size-4 text-muted-foreground"
            });
    }
}
function RequestPreview({ path, payload }) {
    if (!payload) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "rounded bg-muted p-3 font-mono text-xs space-y-1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "text-muted-foreground",
                children: [
                    "POST ",
                    path
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                className: "text-foreground",
                children: JSON.stringify(payload, null, 2)
            })
        ]
    });
}
function DiagnosticCard({ check, fields, expectedField }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "border rounded-lg p-3 space-y-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2 text-sm",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckIcon, {
                        status: check.status
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "font-medium",
                        children: check.label
                    })
                ]
            }),
            fields && fields.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "ml-6 space-y-0.5",
                children: fields.map((f)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-2 text-xs",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "text-muted-foreground w-28 shrink-0",
                                children: [
                                    f.label,
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "font-mono break-all",
                                children: f.value ?? "\u2014"
                            }),
                            f.label === expectedField && check.expected && check.status !== 'pass' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "inline-flex items-center rounded-md bg-red-500/10 px-1.5 py-0.5 text-[11px] font-medium text-red-500 ring-1 ring-inset ring-red-500/20",
                                children: [
                                    "expected: ",
                                    check.expected
                                ]
                            })
                        ]
                    }, f.label))
            }),
            check.status === 'not_found' && !fields?.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "ml-6 text-xs text-muted-foreground italic",
                children: "not found"
            })
        ]
    });
}
function StatusSelect({ value, onChange, disabled, id }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
        value: value?.toString() ?? '',
        onValueChange: (val)=>onChange(Number(val)),
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectTrigger), {
                id: id,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectValue), {
                    placeholder: "Select target status"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectContent), {
                children: ALLOWED_TARGET_STATUSES.map((idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                        value: idx.toString(),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "capitalize",
                                children: (0, _events.EVENT_STATUS_NAMES)[idx]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "text-muted-foreground ml-2",
                                children: [
                                    "(",
                                    idx,
                                    ")"
                                ]
                            })
                        ]
                    }, idx))
            })
        ]
    });
}
// ---------------------------------------------------------------------------
// Main component
// ---------------------------------------------------------------------------
function UpdateEventStatusComponent() {
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    // Form state
    const [clientID, setClientID] = (0, _react.useState)('');
    const [eventID, setEventID] = (0, _react.useState)('');
    const [eventStatus, setEventStatus] = (0, _react.useState)(null);
    // Flow state
    const [diagnosing, setDiagnosing] = (0, _react.useState)(false);
    const [updating, setUpdating] = (0, _react.useState)(false);
    const [diagnostic, setDiagnostic] = (0, _react.useState)(null);
    const [diagnosticOverride, setDiagnosticOverride] = (0, _react.useState)(false);
    // Client picker
    const [clientDialogOpen, setClientDialogOpen] = (0, _react.useState)(false);
    const [clientFilter, setClientFilter] = (0, _react.useState)('');
    const { clients, fetchClients, loading: clientsLoading } = (0, _clientsStore.useClientsStore)();
    (0, _react.useEffect)(()=>{
        const loadClients = async ()=>{
            const token = await getAccessTokenSilently();
            await fetchClients(token, logout);
        };
        if (clients.length === 0) loadClients();
    }, [
        getAccessTokenSilently,
        fetchClients,
        clients.length
    ]);
    const activeClients = clients.filter((client)=>client.active === 1).filter((client)=>clientFilter === '' || client.name.toLowerCase().includes(clientFilter.toLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
    const selectedClientName = clients.find((c)=>c.clientID === clientID)?.name;
    // Derived state
    const allChecksPassed = diagnostic?.checks.every((c)=>c.status === 'pass') ?? false;
    const currentStatus = diagnostic?.eventStatus?.eventStatus ?? null;
    const isPublishedAndHealthy = allChecksPassed && currentStatus === 7;
    const hasActiveLiveStream = diagnostic?.liveStream != null && diagnostic.liveStream.status !== 'terminated';
    const isCurrentlyPublishing = currentStatus === 6;
    const isActiveProcess = hasActiveLiveStream || isCurrentlyPublishing;
    const isTargetSameAsCurrent = eventStatus !== null && currentStatus !== null && eventStatus === currentStatus;
    const isPublishWithoutPrereqs = eventStatus === 7 && diagnostic != null && (!diagnostic.transcodeJob || diagnostic.transcodeJob.progress !== 100 || !diagnostic.mediaAsset);
    const updateUnlocked = !isPublishedAndHealthy && !isActiveProcess && (allChecksPassed || diagnosticOverride);
    const canDiagnose = !diagnosing && !updating && clientID && eventID;
    const canUpdate = !updating && !diagnosing && updateUnlocked && eventStatus !== null && clientID && eventID && !isTargetSameAsCurrent && !isPublishWithoutPrereqs;
    // ---------------------------------------------------------------------------
    // Handlers
    // ---------------------------------------------------------------------------
    const resetFlow = ()=>{
        setDiagnostic(null);
        setDiagnosticOverride(false);
        setEventStatus(null);
    };
    const handleClientSelect = (selectedClientID)=>{
        setClientID(selectedClientID);
        setClientDialogOpen(false);
        setClientFilter('');
        resetFlow();
    };
    const handleClientIDChange = (val)=>{
        setClientID(val);
        resetFlow();
    };
    const handleEventIDChange = (val)=>{
        setEventID(val);
        resetFlow();
    };
    const handleDiagnose = async ()=>{
        const validation = lookupSchema.safeParse({
            clientID,
            eventID
        });
        if (!validation.success) {
            (0, _sonner.toast).error(validation.error.issues[0].message);
            return;
        }
        setDiagnosing(true);
        setDiagnostic(null);
        setDiagnosticOverride(false);
        try {
            const accessToken = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/events/${clientID}/${eventID}/status-diagnostic`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
            if (!response.ok) {
                const err = await response.json().catch(()=>({}));
                throw new Error(err.message || `Diagnostic failed: ${response.statusText}`);
            }
            const data = await response.json();
            setDiagnostic(data);
        } catch (err) {
            (0, _sonner.toast).error(err instanceof Error ? err.message : 'Failed to run diagnostic');
        } finally{
            setDiagnosing(false);
        }
    };
    const handleUpdate = async ()=>{
        if (eventStatus === null) return;
        setUpdating(true);
        try {
            const accessToken = await getAccessTokenSilently();
            const payload = {
                clientID,
                eventID,
                eventStatus
            };
            const response = await (0, _crud.callCrudApi)('/events/update', payload, accessToken);
            const crudResponse = response.data;
            if (crudResponse?.errors?.hasError) (0, _sonner.toast).error(crudResponse.errors.message || 'CRUD API returned an error');
            else if (crudResponse?.data) {
                (0, _sonner.toast).success(`Event ${crudResponse.data.eventID} \u{2192} ${crudResponse.data.eventStatus}`, {
                    description: crudResponse.data.title || undefined
                });
                setDiagnostic(null);
                setEventStatus(null);
                setDiagnosticOverride(false);
                handleDiagnose();
            } else {
                const directResponse = response;
                if (directResponse?.errors?.hasError === false && directResponse?.data) {
                    (0, _sonner.toast).success(`Event ${directResponse.data.eventID} \u{2192} ${directResponse.data.eventStatus}`, {
                        description: directResponse.data.title || undefined
                    });
                    setDiagnostic(null);
                    setEventStatus(null);
                    setDiagnosticOverride(false);
                    handleDiagnose();
                } else (0, _sonner.toast).error('Unexpected response format');
            }
        } catch (err) {
            (0, _sonner.toast).error(err instanceof Error ? err.message : 'An unexpected error occurred');
        } finally{
            setUpdating(false);
        }
    };
    // ---------------------------------------------------------------------------
    // Render
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Layout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "text-2xl font-semibold mb-1",
                                children: "Update Event Status"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-muted-foreground mb-6 text-sm",
                                children: "Force an event into a specific status via the CRUD API. Diagnose first to confirm the event is stuck, then apply the change."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "max-w-md space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                                htmlFor: "clientID",
                                                children: "Client ID"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                                        id: "clientID",
                                                        type: "text",
                                                        value: clientID,
                                                        onChange: (e)=>handleClientIDChange(e.target.value),
                                                        placeholder: "Enter client ID",
                                                        required: true,
                                                        disabled: diagnosing || updating,
                                                        className: "font-mono"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                        type: "button",
                                                        variant: "outline",
                                                        onClick: ()=>setClientDialogOpen(true),
                                                        disabled: diagnosing || updating,
                                                        children: "Browse"
                                                    })
                                                ]
                                            }),
                                            selectedClientName && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-sm text-muted-foreground",
                                                children: selectedClientName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                                htmlFor: "eventID",
                                                children: "Event ID"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                                id: "eventID",
                                                type: "text",
                                                value: eventID,
                                                onChange: (e)=>handleEventIDChange(e.target.value),
                                                placeholder: "e.g. 2026021263",
                                                required: true,
                                                disabled: diagnosing || updating,
                                                className: "font-mono"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-xs text-muted-foreground",
                                                children: "Event ID only (without client ID prefix)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "flex items-center gap-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            onClick: handleDiagnose,
                                            disabled: !canDiagnose,
                                            variant: "secondary",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Search), {
                                                    className: "size-4 mr-2"
                                                }),
                                                diagnosing ? 'Diagnosing...' : 'Diagnose'
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    diagnostic && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                className: "font-semibold",
                                children: "Pre-flight Checks"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "space-y-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DiagnosticCard, {
                                        check: diagnostic.checks.find((c)=>c.label === 'Event status record'),
                                        expectedField: "eventStatus",
                                        fields: diagnostic.eventStatus ? [
                                            {
                                                label: 'eventStatus',
                                                value: `${diagnostic.eventStatus.eventStatusName} (${diagnostic.eventStatus.eventStatus})`
                                            },
                                            {
                                                label: 'published',
                                                value: String(diagnostic.eventStatus.published)
                                            },
                                            {
                                                label: 'lastError',
                                                value: diagnostic.eventStatus.lastError
                                            }
                                        ] : undefined
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DiagnosticCard, {
                                        check: diagnostic.checks.find((c)=>c.label === 'Live stream terminated'),
                                        expectedField: "status",
                                        fields: diagnostic.liveStream ? [
                                            {
                                                label: 'liveID',
                                                value: diagnostic.liveStream.liveID
                                            },
                                            {
                                                label: 'status',
                                                value: diagnostic.liveStream.status
                                            },
                                            {
                                                label: 'encoderID',
                                                value: diagnostic.liveStream.encoderID
                                            },
                                            {
                                                label: 'startDateTime',
                                                value: diagnostic.liveStream.startDateTime
                                            },
                                            {
                                                label: 'endDateTime',
                                                value: diagnostic.liveStream.endDateTime
                                            }
                                        ] : undefined
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DiagnosticCard, {
                                        check: diagnostic.checks.find((c)=>c.label === 'Transcode job complete'),
                                        expectedField: "progress",
                                        fields: diagnostic.transcodeJob ? [
                                            {
                                                label: 'id',
                                                value: diagnostic.transcodeJob.id
                                            },
                                            {
                                                label: 'progress',
                                                value: `${diagnostic.transcodeJob.progress}%`
                                            },
                                            {
                                                label: 'status',
                                                value: diagnostic.transcodeJob.status
                                            },
                                            {
                                                label: 'jobType',
                                                value: diagnostic.transcodeJob.jobType
                                            },
                                            {
                                                label: 'createdAt',
                                                value: diagnostic.transcodeJob.createdAt
                                            }
                                        ] : undefined
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DiagnosticCard, {
                                        check: diagnostic.checks.find((c)=>c.label === 'Live recording asset'),
                                        expectedField: "currentStatus",
                                        fields: diagnostic.mediaAsset ? [
                                            {
                                                label: 'assetID',
                                                value: diagnostic.mediaAsset.assetID
                                            },
                                            {
                                                label: 'currentStatus',
                                                value: diagnostic.mediaAsset.currentStatus
                                            },
                                            {
                                                label: 'assetType',
                                                value: diagnostic.mediaAsset.assetType
                                            },
                                            {
                                                label: 'fileSize',
                                                value: diagnostic.mediaAsset.fileSize ? `${(Number(diagnostic.mediaAsset.fileSize) / 1000000).toFixed(1)} MB` : null
                                            },
                                            {
                                                label: 'path',
                                                value: diagnostic.mediaAsset.path
                                            },
                                            {
                                                label: 'liveID',
                                                value: diagnostic.mediaAsset.liveID
                                            }
                                        ] : undefined
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "border-t pt-4 space-y-3",
                                children: [
                                    isActiveProcess ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h4", {
                                                className: "font-semibold flex items-center gap-2 text-sm text-red-500",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XCircle), {
                                                        className: "size-4"
                                                    }),
                                                    hasActiveLiveStream ? "Active live stream \u2014 cannot modify" : "Event is publishing \u2014 cannot modify"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-xs text-muted-foreground mt-1",
                                                children: hasActiveLiveStream ? `Live stream status is "${diagnostic?.liveStream?.status}". Wait for the stream to terminate before changing event status.` : 'The event is currently being published. Wait for publishing to complete before changing status.'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "text-xs text-muted-foreground mt-2",
                                                children: [
                                                    hasActiveLiveStream && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                                                to: "/events/$eventId",
                                                                params: {
                                                                    eventId: `${clientID}_${eventID}`
                                                                },
                                                                className: "font-medium text-foreground underline hover:text-primary",
                                                                children: "View event detail"
                                                            }),
                                                            " \xb7 "
                                                        ]
                                                    }),
                                                    "If this process appears stuck, check the",
                                                    ' ',
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-medium text-foreground",
                                                        children: "liveStreams"
                                                    }),
                                                    " and",
                                                    ' ',
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-medium text-foreground",
                                                        children: "eventStatus"
                                                    }),
                                                    " tables in the database, review the ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-medium text-foreground",
                                                        children: "Stalled Publish runbook"
                                                    }),
                                                    ", or consult the team before forcing a status change."
                                                ]
                                            })
                                        ]
                                    }) : isPublishedAndHealthy ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h4", {
                                                className: "font-semibold flex items-center gap-2 text-sm",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CheckCircle2), {
                                                        className: "size-4 text-green-600"
                                                    }),
                                                    "All checks passed \u2014 event is published"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "text-xs text-muted-foreground mt-1",
                                                children: [
                                                    "This event is published with valid data. If a status change is truly needed, update the ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-medium text-foreground",
                                                        children: "eventStatus"
                                                    }),
                                                    " table directly in the database and coordinate with the team."
                                                ]
                                            })
                                        ]
                                    }) : allChecksPassed ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h4", {
                                        className: "font-semibold flex items-center gap-2 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CheckCircle2), {
                                                className: "size-4 text-green-600"
                                            }),
                                            "All checks passed \u2014 ready to update"
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h4", {
                                                className: "font-semibold flex items-center gap-2 text-sm text-amber-500",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertTriangle), {
                                                        className: "size-4"
                                                    }),
                                                    "Some checks did not pass"
                                                ]
                                            }),
                                            !diagnosticOverride && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "text-xs text-muted-foreground hover:text-foreground underline mt-1",
                                                onClick: ()=>setDiagnosticOverride(true),
                                                children: "I understand the risks \u2014 unlock update"
                                            })
                                        ]
                                    }),
                                    updateUnlocked && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "max-w-md space-y-3",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex gap-3 items-end",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex-1 space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                                                htmlFor: "eventStatus",
                                                                children: "New Status"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusSelect, {
                                                                value: eventStatus,
                                                                onChange: setEventStatus,
                                                                disabled: updating,
                                                                id: "eventStatus"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                        onClick: handleUpdate,
                                                        disabled: !canUpdate,
                                                        children: updating ? 'Updating...' : 'Update Status'
                                                    })
                                                ]
                                            }),
                                            isTargetSameAsCurrent && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-xs text-amber-500",
                                                children: "Event is already in this status."
                                            }),
                                            isPublishWithoutPrereqs && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "text-xs text-red-500",
                                                children: [
                                                    "Cannot set to published \u2014 requires a completed transcode job and a media asset. Check the ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-medium",
                                                        children: "transcodeJobs"
                                                    }),
                                                    " and",
                                                    ' ',
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "font-medium",
                                                        children: "mediaassets"
                                                    }),
                                                    " tables if you believe this is incorrect."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(RequestPreview, {
                                                path: "/events/update",
                                                payload: eventStatus !== null ? {
                                                    clientID,
                                                    eventID,
                                                    eventStatus
                                                } : null
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
                open: clientDialogOpen,
                onOpenChange: (open)=>{
                    setClientDialogOpen(open);
                    if (!open) setClientFilter('');
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.DialogContent), {
                    className: "max-w-2xl max-h-[80vh] flex flex-col top-[10%] translate-y-0",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.DialogHeader), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.DialogTitle), {
                                    children: "Select Client"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.DialogDescription), {
                                    children: "Choose an active client from the list below."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                            type: "text",
                            placeholder: "Filter by client name...",
                            value: clientFilter,
                            onChange: (e)=>setClientFilter(e.target.value),
                            className: "mb-2"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overflow-auto flex-1",
                            children: clientsLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "py-8 text-center text-muted-foreground",
                                children: "Loading clients..."
                            }) : activeClients.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "py-8 text-center text-muted-foreground",
                                children: "No active clients found."
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                className: "table-fixed",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    className: "w-32",
                                                    children: "Client ID"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                    children: "Name"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                        children: activeClients.map((client)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                                className: "cursor-pointer hover:bg-muted",
                                                onClick: ()=>handleClientSelect(client.clientID),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        className: "font-mono",
                                                        children: client.clientID
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                        children: client.name
                                                    })
                                                ]
                                            }, client.clientID))
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["Link","7k6Lq"],["redirect","jmFxY"]],"@auth0/auth0-react":"gpXrE","zod":"dmnwW","sonner":"2p5sL","lucide-react":[["AlertTriangle","cdePa","default"],["CheckCircle2","jNsZg","default"],["HelpCircle","iDfGt","default"],["Search","7AEK5","default"],["XCircle","aDWrd","default"]],"../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/components/ui/input":"8UHwi","@/client/components/ui/button":"armlb","@/client/components/ui/label":"cLMZq","@/client/components/ui/select":"7QcOK","@/client/components/ui/dialog":"6jjic","@/client/components/ui/table":"5vxZ8","@/client/utils/crud":"3ws1j","@/client/store/clientsStore":"6bg3l","@/client/config":"8SWgh","@shared/types/events":"d1idH","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"2Jvui":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _sonner = require("sonner");
var _lucideReact = require("lucide-react");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _input = require("@/client/components/ui/input");
var _button = require("@/client/components/ui/button");
var _label = require("@/client/components/ui/label");
var _select = require("@/client/components/ui/select");
var _clientsStore = require("@/client/store/clientsStore");
var _config = require("@/client/config");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'utilities/export-vtt',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: ExportVttComponent
});
function firstOfMonth(d = new Date()) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
}
function todayISO(d = new Date()) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
function ExportVttComponent() {
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    const { clients, fetchClients, loading: clientsLoading } = (0, _clientsStore.useClientsStore)();
    const [clientID, setClientID] = (0, _react.useState)('');
    const [startDate, setStartDate] = (0, _react.useState)(firstOfMonth());
    const [endDate, setEndDate] = (0, _react.useState)(todayISO());
    const [downloading, setDownloading] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        const load = async ()=>{
            const token = await getAccessTokenSilently();
            await fetchClients(token, logout);
        };
        if (clients.length === 0) load();
    }, [
        getAccessTokenSilently,
        fetchClients,
        logout,
        clients.length
    ]);
    const activeClients = (0, _react.useMemo)(()=>clients.filter((c)=>c.active === 1).sort((a, b)=>a.name.localeCompare(b.name)), [
        clients
    ]);
    const selectedClient = clients.find((c)=>c.clientID === clientID);
    const canSubmit = !!clientID && !!startDate && !!endDate && !downloading && startDate <= endDate;
    const handleDownload = async ()=>{
        setDownloading(true);
        try {
            const token = await getAccessTokenSilently();
            const params = new URLSearchParams({
                clientID,
                startDate,
                endDate
            });
            const res = await fetch(`${(0, _config.API_BASE_URL)}/api/vtt/export?${params.toString()}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (!res.ok) {
                const body = await res.text().catch(()=>'');
                throw new Error(`HTTP ${res.status}: ${body || res.statusText}`);
            }
            const total = Number(res.headers.get('X-Export-Total') ?? '0');
            const failed = Number(res.headers.get('X-Export-Failed') ?? '0');
            const blob = await res.blob();
            const disposition = res.headers.get('Content-Disposition') ?? '';
            const match = disposition.match(/filename="?([^"]+)"?/);
            const filename = match?.[1] ?? `vtt-export_${clientID}_${startDate}_to_${endDate}.zip`;
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
            const ok = total - failed;
            if (failed > 0) (0, _sonner.toast).warning(`Exported ${ok}/${total} captions (${failed} skipped)`);
            else (0, _sonner.toast).success(`Exported ${ok} caption${ok === 1 ? '' : 's'}`);
        } catch (err) {
            const msg = err instanceof Error ? err.message : 'Unknown error';
            (0, _sonner.toast).error(`Export failed: ${msg}`);
        } finally{
            setDownloading(false);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex justify-between items-center mb-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            className: "text-2xl font-semibold",
                            children: "Export VTT Manifest"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "text-muted-foreground mb-6",
                        children: [
                            "Produces a ZIP of every caption VTT bound to a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "font-medium",
                                children: "published"
                            }),
                            " event for the selected client in the date range, plus a ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "manifest.csv"
                            }),
                            " listing",
                            ' ',
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "eventID"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "dateCreated"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "playerUrl"
                            }),
                            ", and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "pathInZip"
                            }),
                            ". Larger ranges may take a while \u2014 the server fetches every file before sending."
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-end gap-4 mb-4 flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "space-y-2 min-w-[280px]",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                        htmlFor: "clientID",
                                        children: "Client"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                                        value: clientID,
                                        onValueChange: setClientID,
                                        disabled: clientsLoading,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectTrigger), {
                                                id: "clientID",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectValue), {
                                                    placeholder: clientsLoading ? 'Loading clients...' : 'Select a client'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectContent), {
                                                children: activeClients.map((c)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectItem), {
                                                        value: c.clientID,
                                                        children: [
                                                            c.name,
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "text-muted-foreground ml-2 text-xs font-mono",
                                                                children: c.clientID
                                                            })
                                                        ]
                                                    }, c.clientID))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "space-y-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                        htmlFor: "startDate",
                                        children: "Start date"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                        id: "startDate",
                                        type: "date",
                                        value: startDate,
                                        onChange: (e)=>setStartDate(e.target.value),
                                        className: "w-[180px]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "space-y-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _label.Label), {
                                        htmlFor: "endDate",
                                        children: "End date"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                        id: "endDate",
                                        type: "date",
                                        value: endDate,
                                        onChange: (e)=>setEndDate(e.target.value),
                                        className: "w-[180px]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "ml-auto",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                    onClick: handleDownload,
                                    disabled: !canSubmit,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Download), {
                                            className: "size-4 mr-2"
                                        }),
                                        downloading ? 'Building ZIP...' : selectedClient ? `Download ZIP for ${selectedClient.name}` : 'Download ZIP'
                                    ]
                                })
                            })
                        ]
                    }),
                    startDate && endDate && startDate > endDate && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-sm text-destructive mb-4",
                        children: "Start date must be on or before end date."
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"]],"@auth0/auth0-react":"gpXrE","sonner":"2p5sL","lucide-react":[["Download","eRiW1","default"]],"../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/components/ui/input":"8UHwi","@/client/components/ui/button":"armlb","@/client/components/ui/label":"cLMZq","@/client/components/ui/select":"7QcOK","@/client/store/clientsStore":"6bg3l","@/client/config":"8SWgh","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eTAI9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "PLATFORM_COLORS", ()=>PLATFORM_COLORS);
parcelHelpers.export(exports, "STATUS_COLORS", ()=>STATUS_COLORS);
/** Format date for display */ parcelHelpers.export(exports, "formatDate", ()=>formatDate);
/** Status badge component */ parcelHelpers.export(exports, "StatusBadge", ()=>StatusBadge);
/** Platform badge component */ parcelHelpers.export(exports, "PlatformBadge", ()=>PlatformBadge);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _dateFns = require("date-fns");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _input = require("@/client/components/ui/input");
var _button = require("@/client/components/ui/button");
var _badge = require("@/client/components/ui/badge");
var _select = require("@/client/components/ui/select");
var _lucideReact = require("lucide-react");
var _config = require("@/client/config");
/** Status filter configuration */ const STATUS_FILTER_OPTIONS = [
    {
        value: 'active',
        label: 'Active (Published, Review, Pending, Rejected)'
    },
    {
        value: 'all',
        label: 'All Statuses'
    },
    {
        value: 'Published',
        label: 'Published'
    },
    {
        value: 'Review',
        label: 'In Review'
    },
    {
        value: 'Pending',
        label: 'Pending'
    },
    {
        value: 'Rejected',
        label: 'Rejected'
    },
    {
        value: 'Draft',
        label: 'Draft'
    },
    {
        value: 'no-status',
        label: 'No Status'
    }
];
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'ott-manager',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: OTTManagerComponent
});
const PLATFORM_COLORS = {
    FireTV: {
        bg: '#FF9900',
        text: '#000000'
    },
    AppleTV: {
        bg: '#000000',
        text: '#FFFFFF'
    },
    Roku: {
        bg: '#662D91',
        text: '#FFFFFF'
    },
    SamsungTV: {
        bg: '#1428A0',
        text: '#FFFFFF'
    },
    Android: {
        bg: '#3DDC84',
        text: '#000000'
    },
    IOS: {
        bg: '#555555',
        text: '#FFFFFF'
    },
    WebPage: {
        bg: '#475569',
        text: '#FFFFFF'
    }
};
const STATUS_COLORS = {
    Draft: {
        bg: '#6B7280',
        text: '#FFFFFF'
    },
    Pending: {
        bg: '#3B82F6',
        text: '#FFFFFF'
    },
    Review: {
        bg: '#EAB308',
        text: '#000000'
    },
    Published: {
        bg: '#22C55E',
        text: '#FFFFFF'
    },
    Rejected: {
        bg: '#EF4444',
        text: '#FFFFFF'
    }
};
function formatDate(dateStr) {
    if (!dateStr) return '-';
    try {
        return (0, _dateFns.format)(new Date(dateStr), 'MMM d, yyyy');
    } catch  {
        return '-';
    }
}
function StatusBadge({ status }) {
    if (!status) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
        variant: "outline",
        className: "text-muted-foreground text-xs",
        children: "No Status"
    });
    const colors = STATUS_COLORS[status];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
        className: "border-0 text-xs",
        style: {
            backgroundColor: colors.bg,
            color: colors.text
        },
        children: status
    });
}
function PlatformBadge({ platform }) {
    const colors = PLATFORM_COLORS[platform];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
        className: "text-xs border-0",
        style: colors ? {
            backgroundColor: colors.bg,
            color: colors.text
        } : undefined,
        variant: colors ? undefined : 'outline',
        children: platform
    });
}
/** Get aggregated status for an app (worst status across all targets) */ function getAppStatus(app) {
    const statuses = app.storeTargets.map((t)=>t.currentSubmission?.statusName).filter(Boolean);
    if (statuses.length === 0) return null;
    const statusPriority = {
        Rejected: 0,
        Draft: 1,
        Pending: 2,
        Review: 3,
        Published: 4
    };
    return statuses.reduce((worst, current)=>statusPriority[current] < statusPriority[worst] ? current : worst);
}
/** Get the client updated date (manifest last edited) */ function getClientUpdatedAt(app) {
    return app.manifestUpdatedAt;
}
/** Get the most recent vendor update date across all targets */ function getVendorUpdatedAt(app) {
    const dates = app.storeTargets.map((t)=>t.currentSubmission?.vendorUpdatedAt).filter((d)=>d !== null);
    if (dates.length === 0) return null;
    return dates.reduce((latest, current)=>new Date(current) > new Date(latest) ? current : latest);
}
/** Check if app has any rejections */ function hasRejections(app) {
    return app.storeTargets.some((t)=>t.submissions.some((s)=>s.statusName === 'Rejected'));
}
/** Single app row */ function AppRow({ app, onClick }) {
    const status = getAppStatus(app);
    const clientUpdated = getClientUpdatedAt(app);
    const vendorUpdated = getVendorUpdatedAt(app);
    const showRejectionWarning = hasRejections(app);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        onClick: onClick,
        className: "flex items-center justify-between py-3 px-4 hover:bg-accent/50 cursor-pointer rounded-lg group",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-4 flex-1 min-w-0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "font-medium min-w-[180px] max-w-[180px] truncate",
                        title: app.appName,
                        children: app.appName
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex flex-wrap flex-1 gap-1 min-w-[200px] max-w-[280px]",
                        children: app.storeTargets.map((target)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(PlatformBadge, {
                                platform: target.targetName
                            }, target.idx))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-sm flex-1 text-muted-foreground min-w-[100px]",
                        children: formatDate(clientUpdated)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-sm flex-1 text-muted-foreground min-w-[100px]",
                        children: formatDate(vendorUpdated)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-1 items-center gap-2 min-w-[120px]",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusBadge, {
                                status: status
                            }),
                            showRejectionWarning && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                title: "Has rejections",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.AlertCircle), {
                                    className: "h-4 w-4 text-red-500"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                className: "h-4 w-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity"
            })
        ]
    });
}
/** Client section with header and app list */ function ClientSection({ client }) {
    const navigate = (0, _reactRouter.useNavigate)();
    // Sort apps alphabetically
    const sortedApps = (0, _react.useMemo)(()=>[
            ...client.apps
        ].sort((a, b)=>a.appName.localeCompare(b.appName)), [
        client.apps
    ]);
    const handleAppClick = (app)=>{
        navigate({
            to: '/ott-manager/$apIdx',
            params: {
                apIdx: String(app.apIdx)
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "mb-8 pb-6 border-b border-border/50 last:border-b-0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2 mb-3 px-2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Building2), {
                        className: "h-4 w-4 text-muted-foreground"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "font-semibold text-lg",
                        children: client.clientName
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "text-sm text-muted-foreground",
                        children: [
                            "(",
                            client.apps.length,
                            " app",
                            client.apps.length !== 1 ? 's' : '',
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "ml-10 space-y-1",
                children: sortedApps.map((app)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(AppRow, {
                        app: app,
                        onClick: ()=>handleAppClick(app)
                    }, app.apIdx))
            })
        ]
    });
}
function OTTManagerComponent() {
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const [clients, setClients] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(null);
    const [searchFilter, setSearchFilter] = (0, _react.useState)('');
    const [statusFilter, setStatusFilter] = (0, _react.useState)('active');
    const [clientFilter, setClientFilter] = (0, _react.useState)('all');
    const fetchData = async ()=>{
        try {
            setLoading(true);
            setError(null);
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/ott-manager`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (!response.ok) throw new Error(`Failed to fetch: ${response.statusText}`);
            const data = await response.json();
            setClients(data.clients);
        } catch (err) {
            console.error('Error fetching OTT data:', err);
            setError(err instanceof Error ? err.message : 'Failed to fetch data');
        } finally{
            setLoading(false);
        }
    };
    (0, _react.useEffect)(()=>{
        fetchData();
    }, [
        getAccessTokenSilently
    ]);
    /** Check if an app matches the status filter */ const appMatchesStatusFilter = (app)=>{
        const appStatus = getAppStatus(app);
        switch(statusFilter){
            case 'all':
                return true;
            case 'active':
                // Show everything except Draft and No Status
                return appStatus !== null && appStatus !== 'Draft';
            case 'no-status':
                return appStatus === null;
            default:
                // Specific status filter
                return appStatus === statusFilter;
        }
    };
    // Sort clients alphabetically, then filter
    const sortedAndFilteredClients = (0, _react.useMemo)(()=>{
        // First sort alphabetically
        const sorted = [
            ...clients
        ].sort((a, b)=>a.clientName.localeCompare(b.clientName));
        // Apply client filter first
        const clientFiltered = clientFilter && clientFilter !== 'all' ? sorted.filter((c)=>c.clientID === clientFilter) : sorted;
        const search = searchFilter.toLowerCase();
        return clientFiltered.map((client)=>{
            const clientNameMatches = search && client.clientName.toLowerCase().includes(search);
            let filteredApps = client.apps.filter((app)=>{
                // First check status filter
                if (!appMatchesStatusFilter(app)) return false;
                // Then check text search
                if (!search) return true;
                const appMatches = app.appName.toLowerCase().includes(search);
                const platformMatches = app.storeTargets.some((t)=>t.targetName.toLowerCase().includes(search));
                const statusMatches = app.storeTargets.some((t)=>t.currentSubmission?.statusName?.toLowerCase().includes(search));
                return appMatches || platformMatches || statusMatches;
            });
            // If client name matches search, show all apps that pass status filter
            if (clientNameMatches) filteredApps = client.apps.filter(appMatchesStatusFilter);
            if (filteredApps.length > 0) return {
                ...client,
                apps: filteredApps
            };
            return null;
        }).filter(Boolean);
    }, [
        clients,
        searchFilter,
        statusFilter,
        clientFilter
    ]);
    // Count totals
    const totalApps = clients.reduce((sum, c)=>sum + c.apps.length, 0);
    const totalTargets = clients.reduce((sum, c)=>sum + c.apps.reduce((s, a)=>s + a.storeTargets.length, 0), 0);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex justify-between items-center mb-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "text-2xl font-semibold",
                                children: "OTT Manager"
                            }),
                            !loading && !error && clients.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "text-sm text-muted-foreground",
                                children: [
                                    clients.length,
                                    " clients \xb7 ",
                                    totalApps,
                                    " apps"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-muted-foreground mb-6",
                        children: "Manage OTT app submissions across all clients. Click an app to view submission details."
                    }),
                    loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Loading..."
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-4 bg-red-100 border-l-4 border-red-600 rounded mt-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "m-0 text-red-800 font-medium",
                            children: [
                                "Error: ",
                                error
                            ]
                        })
                    }),
                    !loading && !error && clients.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "No OTT clients found."
                    }),
                    !loading && !error && clients.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-wrap items-end gap-4 mb-6",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-col gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                className: "text-xs font-medium text-muted-foreground",
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                                                value: statusFilter,
                                                onValueChange: (v)=>setStatusFilter(v),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectTrigger), {
                                                        className: "w-[280px]",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectValue), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectContent), {
                                                        children: STATUS_FILTER_OPTIONS.map((opt)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                                                value: opt.value,
                                                                children: opt.label
                                                            }, opt.value))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-col gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                className: "text-xs font-medium text-muted-foreground",
                                                children: "Client"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "flex items-center gap-1",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                                                        value: clientFilter,
                                                        onValueChange: setClientFilter,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectTrigger), {
                                                                className: "w-[220px]",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectValue), {})
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectContent), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                                                        value: "all",
                                                                        children: "All Clients"
                                                                    }),
                                                                    clients.slice().sort((a, b)=>a.clientName.localeCompare(b.clientName)).map((c)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                                                            value: c.clientID,
                                                                            children: c.clientName
                                                                        }, c.clientID))
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    clientFilter && clientFilter !== 'all' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                        variant: "ghost",
                                                        size: "icon",
                                                        className: "h-8 w-8",
                                                        onClick: ()=>setClientFilter('all'),
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.X), {
                                                            className: "h-4 w-4"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex flex-col gap-1 flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                className: "text-xs font-medium text-muted-foreground",
                                                children: "Search"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                                placeholder: "Filter by app name, platform...",
                                                value: searchFilter,
                                                onChange: (e)=>setSearchFilter(e.target.value),
                                                className: "max-w-sm"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "ml-auto",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            variant: "outline",
                                            onClick: fetchData,
                                            disabled: loading,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                                    className: `h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`
                                                }),
                                                "Refresh"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-4 px-4 py-2 text-xs font-medium text-muted-foreground uppercase tracking-wide border-b border-border/50 mb-4 ml-6",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "min-w-[180px]",
                                        children: "App"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "min-w-[200px] max-w-[280px] flex-1",
                                        children: "Platforms"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "min-w-[100px] flex-1",
                                        children: "Client Updated"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "min-w-[100px] flex-1",
                                        children: "Vendor Updated"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "min-w-[120px] flex-1",
                                        children: "Status"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: sortedAndFilteredClients.map((client)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ClientSection, {
                                        client: client
                                    }, client.clientID))
                            }),
                            searchFilter && sortedAndFilteredClients.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "text-center text-muted-foreground py-8",
                                children: [
                                    'No results match "',
                                    searchFilter,
                                    '"'
                                ]
                            }),
                            searchFilter && sortedAndFilteredClients.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "mt-4 text-sm text-muted-foreground",
                                children: [
                                    "Showing ",
                                    sortedAndFilteredClients.length,
                                    " of ",
                                    clients.length,
                                    " clients"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useNavigate","aMhxM"]],"@auth0/auth0-react":"gpXrE","date-fns":"4NYjc","../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/components/ui/input":"8UHwi","@/client/components/ui/button":"armlb","@/client/components/ui/badge":"h4e1f","@/client/components/ui/select":"7QcOK","lucide-react":[["AlertCircle","65jRl","default"],["Building2","8fJ8N","default"],["ChevronRight","lOb49","default"],["RefreshCw","7a8jT","default"],["X","8HSxK","default"]],"@/client/config":"8SWgh","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8fJ8N":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Building2);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M10 12h4",
            key: "a56b0p"
        }
    ],
    [
        "path",
        {
            d: "M10 8h4",
            key: "1sr2af"
        }
    ],
    [
        "path",
        {
            d: "M14 21v-3a2 2 0 0 0-4 0v3",
            key: "1rgiei"
        }
    ],
    [
        "path",
        {
            d: "M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2",
            key: "secmi2"
        }
    ],
    [
        "path",
        {
            d: "M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16",
            key: "16ra0t"
        }
    ]
];
const Building2 = (0, _createLucideIconJsDefault.default)("building-2", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"FgD33":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _zod = require("zod");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _input = require("@/client/components/ui/input");
var _button = require("@/client/components/ui/button");
var _badge = require("@/client/components/ui/badge");
var _select = require("@/client/components/ui/select");
var _card = require("@/client/components/ui/card");
var _lucideReact = require("lucide-react");
var _config = require("@/client/config");
var _swapClientDialog = require("@/client/components/swap-client-dialog");
var _index = require("./index");
// Optional URL validation - valid URL, empty string, or null
const optionalUrlSchema = (0, _zod.z).string().nullable().refine((val)=>!val || (0, _zod.z).string().url().safeParse(val).success, 'Please enter a valid URL');
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'ott-manager/$apIdx',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: OTTAppDetailComponent
});
/** Copy to clipboard helper */ function useCopyToClipboard() {
    const [copied, setCopied] = (0, _react.useState)(null);
    const copy = (0, _react.useCallback)((text, id)=>{
        navigator.clipboard.writeText(text);
        setCopied(id);
        setTimeout(()=>setCopied(null), 2000);
    }, []);
    return {
        copied,
        copy
    };
}
/** Parse yyyy-MM-dd string to local Date (avoids timezone offset issues) */ function parseLocalDate(dateStr) {
    const [year, month, day] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day, 12, 0, 0); // noon local time to avoid DST edge cases
}
/** Format ISO string to yyyy-MM-dd for input display */ function toDateInputValue(isoString) {
    if (!isoString) return '';
    const date = new Date(isoString);
    // Use UTC methods to avoid timezone shift when displaying stored dates
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
/** Date input component for nullable dates */ function DateInput({ value, onChange, disabled = false }) {
    // Use local state to prevent controlled input from overwriting during typing
    const [localValue, setLocalValue] = (0, _react.useState)(toDateInputValue(value));
    // Sync local state when parent value changes (e.g., on save/reset)
    (0, _react.useEffect)(()=>{
        setLocalValue(toDateInputValue(value));
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
        type: "date",
        value: localValue,
        onChange: (e)=>{
            const newValue = e.target.value;
            setLocalValue(newValue);
            if (!newValue) {
                onChange(null);
                return;
            }
            // Only propagate to parent if valid date with reasonable year
            const [year] = newValue.split('-').map(Number);
            if (year >= 1900 && year <= 2100) {
                // Create date at noon local time, then convert to ISO
                const localDate = parseLocalDate(newValue);
                onChange(localDate.toISOString());
            }
        },
        disabled: disabled,
        className: `w-40 cursor-pointer date-input ${!localValue ? 'date-muted' : ''}`
    });
}
/** Single submission card with editable fields */ function SubmissionCard({ submission, statuses, isLatest, edits, hasStoreIDEdit, onEdit, onSave, saving }) {
    const [expanded, setExpanded] = (0, _react.useState)(isLatest);
    // Check if there are unsaved changes (including Store ID for latest submission)
    const hasEdits = Object.keys(edits).length > 0 || isLatest && hasStoreIDEdit;
    // Get current values (edited or original)
    // Use 'in' check for fields that can be explicitly set to null (to clear them)
    const currentStatusId = 'statusId' in edits ? edits.statusId : submission.statusId;
    const currentStatus = statuses.find((s)=>s.statusId === currentStatusId)?.statusName ?? submission.statusName;
    const currentTicketURL = ('ticketURL' in edits ? edits.ticketURL : submission.ticketURL) ?? '';
    const currentDateSubmittedVendor = 'dateSubmittedVendor' in edits ? edits.dateSubmittedVendor ?? null : submission.dateSubmittedVendor;
    const currentDateApprovedVendor = 'dateApprovedVendor' in edits ? edits.dateApprovedVendor ?? null : submission.dateApprovedVendor;
    const currentRejectionDate = 'rejectionDate' in edits ? edits.rejectionDate ?? null : submission.rejectionDate;
    const currentRejectionURL = ('rejectionURL' in edits ? edits.rejectionURL : submission.rejectionURL) ?? '';
    const isRejected = currentStatus === 'Rejected' || currentRejectionDate;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "border rounded-lg bg-card",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center justify-between p-3 cursor-pointer hover:bg-accent/30",
                onClick: ()=>setExpanded(!expanded),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "text-sm font-mono text-muted-foreground",
                                children: [
                                    "#",
                                    submission.submissionId
                                ]
                            }),
                            isLatest && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                variant: "outline",
                                className: "text-xs",
                                children: "Current"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.StatusBadge), {
                                status: currentStatus
                            }),
                            submission.ticketURL && /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: submission.ticketURL,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                onClick: (e)=>e.stopPropagation(),
                                className: "text-muted-foreground hover:text-foreground",
                                title: "View ticket",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Ticket), {
                                    className: "h-4 w-4"
                                })
                            }),
                            hasEdits && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                variant: "secondary",
                                className: "text-xs bg-amber-100 text-amber-800",
                                children: "Unsaved"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-sm text-muted-foreground",
                                children: (0, _index.formatDate)(submission.dateSubmittedClient)
                            }),
                            expanded ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronUp), {
                                className: "h-4 w-4 text-muted-foreground"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                className: "h-4 w-4 text-muted-foreground"
                            })
                        ]
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "p-4 border-t space-y-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grid grid-cols-[140px_1fr] gap-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                className: "text-sm text-muted-foreground",
                                children: "Status"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                                value: String(currentStatusId ?? ''),
                                onValueChange: (val)=>onEdit('statusId', parseInt(val, 10)),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectTrigger), {
                                        className: "w-40",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectValue), {
                                            placeholder: "Select status"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectContent), {
                                        children: statuses.map((status)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                                value: String(status.statusId),
                                                children: status.statusName
                                            }, status.statusId))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grid grid-cols-[140px_1fr] gap-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                className: "text-sm text-muted-foreground",
                                children: "Ticket URL"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                value: currentTicketURL,
                                onChange: (e)=>onEdit('ticketURL', e.target.value || null),
                                placeholder: "https://invintus-support.freshdesk.com/a/tickets/...",
                                className: "max-w-md"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                className: "text-sm font-medium",
                                children: "Dates"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-[140px_1fr] gap-2 items-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        className: "text-sm text-muted-foreground",
                                        children: "Client Submitted"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "text-sm",
                                        children: (0, _index.formatDate)(submission.dateSubmittedClient)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-[140px_1fr] gap-2 items-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        className: "text-sm text-muted-foreground",
                                        children: "Vendor Submitted"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {
                                        value: currentDateSubmittedVendor,
                                        onChange: (val)=>onEdit('dateSubmittedVendor', val)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-[140px_1fr] gap-2 items-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        className: "text-sm text-muted-foreground",
                                        children: "Vendor Approved"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {
                                        value: currentDateApprovedVendor,
                                        onChange: (val)=>onEdit('dateApprovedVendor', val)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grid grid-cols-[140px_1fr] gap-2 items-center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        className: "text-sm text-muted-foreground",
                                        children: "Rejection Date"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {
                                                value: currentRejectionDate,
                                                onChange: (val)=>onEdit('rejectionDate', val)
                                            }),
                                            currentRejectionDate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                variant: "ghost",
                                                size: "icon",
                                                className: "h-8 w-8",
                                                onClick: ()=>onEdit('rejectionDate', null),
                                                title: "Clear rejection date",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.X), {
                                                    className: "h-4 w-4"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isRejected && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grid grid-cols-[140px_1fr] gap-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                className: "text-sm text-muted-foreground",
                                children: "Rejection URL"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                        value: currentRejectionURL,
                                        onChange: (e)=>onEdit('rejectionURL', e.target.value || null),
                                        placeholder: "Link to vendor rejection notice",
                                        className: "max-w-md"
                                    }),
                                    currentRejectionURL && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        variant: "ghost",
                                        size: "icon",
                                        className: "h-8 w-8",
                                        onClick: ()=>onEdit('rejectionURL', null),
                                        title: "Clear rejection URL",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.X), {
                                            className: "h-4 w-4"
                                        })
                                    }),
                                    submission.rejectionURL && /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: submission.rejectionURL,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "text-muted-foreground hover:text-foreground",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ExternalLink), {
                                            className: "h-4 w-4"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    hasEdits && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex justify-end pt-2",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            onClick: onSave,
                            disabled: saving,
                            children: saving ? 'Saving...' : 'Save Changes'
                        })
                    })
                ]
            })
        ]
    });
}
/** Platform card with store ID and submission history */ function PlatformCard({ target, statuses, storeIDEdits, submissionEdits, onStoreIDEdit, onSubmissionEdit, onSaveSubmission, onCreateSubmission, savingSubmission, creatingSubmission }) {
    const { copied, copy } = useCopyToClipboard();
    const colors = (0, _index.PLATFORM_COLORS)[target.targetName];
    // Get current store ID from latest submission
    const latestSubmission = target.currentSubmission;
    const currentStoreID = storeIDEdits[target.idx] ?? latestSubmission?.storeID ?? '';
    const hasStoreIDEdit = target.idx in storeIDEdits && storeIDEdits[target.idx] !== (latestSubmission?.storeID ?? '');
    // Sort submissions by date (newest first)
    const sortedSubmissions = [
        ...target.submissions
    ].sort((a, b)=>new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                className: "pb-3",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex items-center justify-between",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardTitle), {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.PlatformBadge), {
                                platform: target.targetName
                            }),
                            target.currentSubmission && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.StatusBadge), {
                                status: target.currentSubmission.statusName
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardContent), {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                className: "text-sm font-mediu",
                                children: "Store ID"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                        value: currentStoreID,
                                        onChange: (e)=>onStoreIDEdit(target.idx, e.target.value),
                                        placeholder: "Store ID...",
                                        className: "flex-1 font-mono text-sm"
                                    }),
                                    currentStoreID && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        variant: "outline",
                                        size: "icon",
                                        onClick: ()=>copy(currentStoreID, `store-${target.idx}`),
                                        children: copied === `store-${target.idx}` ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                                            className: "h-4 w-4 text-green-600"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Copy), {
                                            className: "h-4 w-4"
                                        })
                                    })
                                ]
                            }),
                            hasStoreIDEdit && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-xs text-amber-600",
                                children: "Store ID will be saved with the submission"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h4", {
                                        className: "text-sm font-medium",
                                        children: [
                                            "Submission History (",
                                            target.submissions.length,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        variant: "outline",
                                        size: "sm",
                                        onClick: ()=>onCreateSubmission(target.idx, currentStoreID || undefined),
                                        disabled: creatingSubmission === target.idx,
                                        children: creatingSubmission === target.idx ? 'Creating...' : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Plus), {
                                                    className: "h-4 w-4 mr-1"
                                                }),
                                                "New Submission"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            sortedSubmissions.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-sm text-muted-foreground",
                                children: "No submissions yet"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "space-y-2",
                                children: sortedSubmissions.map((submission, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SubmissionCard, {
                                        submission: submission,
                                        statuses: statuses,
                                        isLatest: idx === 0,
                                        edits: submissionEdits[submission.submissionId] ?? {},
                                        hasStoreIDEdit: hasStoreIDEdit,
                                        onEdit: (field, value)=>onSubmissionEdit(submission.submissionId, field, value),
                                        onSave: ()=>onSaveSubmission(submission.submissionId),
                                        saving: savingSubmission === submission.submissionId
                                    }, submission.submissionId))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function OTTAppDetailComponent() {
    const navigate = (0, _reactRouter.useNavigate)();
    const { apIdx } = Route.useParams();
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const [app, setApp] = (0, _react.useState)(null);
    const [clientID, setClientID] = (0, _react.useState)('');
    const [clientName, setClientName] = (0, _react.useState)('');
    const [statuses, setStatuses] = (0, _react.useState)([]);
    const [platforms, setPlatforms] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(null);
    // Edit state
    const [storeIDEdits, setStoreIDEdits] = (0, _react.useState)({});
    const [submissionEdits, setSubmissionEdits] = (0, _react.useState)({});
    const [savingSubmission, setSavingSubmission] = (0, _react.useState)(null);
    const [creatingSubmission, setCreatingSubmission] = (0, _react.useState)(null);
    // Add platform state
    const [addingPlatform, setAddingPlatform] = (0, _react.useState)(null);
    // Swap client state
    const [swapDialogOpen, setSwapDialogOpen] = (0, _react.useState)(false);
    const { copied, copy } = useCopyToClipboard();
    // Check if client swap is needed
    const { needsSwap } = (0, _swapClientDialog.useClientSwapInfo)(clientID);
    // openAfterSwap is handled globally in __root.tsx
    const fetchData = async ()=>{
        try {
            setLoading(true);
            setError(null);
            const token = await getAccessTokenSilently();
            // Fetch app detail and platforms in parallel
            const [appResponse, platformsResponse] = await Promise.all([
                fetch(`${(0, _config.API_BASE_URL)}/api/ott-manager/${apIdx}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }),
                fetch(`${(0, _config.API_BASE_URL)}/api/ott-manager/platforms`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
            ]);
            if (!appResponse.ok) {
                if (appResponse.status === 404) throw new Error(`App with ID ${apIdx} not found`);
                throw new Error(`Failed to fetch: ${appResponse.statusText}`);
            }
            const [appData, platformsData] = await Promise.all([
                appResponse.json(),
                platformsResponse.ok ? platformsResponse.json() : {
                    platforms: []
                }
            ]);
            setApp(appData.app);
            setClientID(appData.clientID);
            setClientName(appData.clientName);
            setStatuses(appData.statuses);
            setPlatforms(platformsData.platforms ?? []);
        } catch (err) {
            console.error('Error fetching app detail:', err);
            setError(err instanceof Error ? err.message : 'Failed to fetch data');
        } finally{
            setLoading(false);
        }
    };
    (0, _react.useEffect)(()=>{
        fetchData();
    }, [
        apIdx,
        getAccessTokenSilently
    ]);
    const handleStoreIDEdit = (idx, value)=>{
        setStoreIDEdits((prev)=>({
                ...prev,
                [idx]: value
            }));
    };
    const handleSubmissionEdit = (submissionId, field, value)=>{
        setSubmissionEdits((prev)=>({
                ...prev,
                [submissionId]: {
                    ...prev[submissionId],
                    [field]: value
                }
            }));
    };
    const handleSaveSubmission = async (submissionId)=>{
        const edits = submissionEdits[submissionId] ?? {};
        // Validate URL fields before saving
        const urlValidations = [
            {
                field: 'Ticket URL',
                value: edits.ticketURL
            },
            {
                field: 'Rejection URL',
                value: edits.rejectionURL
            }
        ];
        for (const { field, value } of urlValidations)if (value !== undefined) {
            const result = optionalUrlSchema.safeParse(value);
            if (!result.success) {
                setError(`${field}: ${result.error.issues[0].message}`);
                return;
            }
        }
        setSavingSubmission(submissionId);
        try {
            const token = await getAccessTokenSilently();
            // Find which target this submission belongs to (for Store ID edit lookup)
            let targetIdx = null;
            for (const target of app?.storeTargets ?? [])if (target.submissions.some((s)=>s.submissionId === submissionId)) {
                targetIdx = target.idx;
                break;
            }
            // Include Store ID edit if present for this target
            // Empty string means user wants to clear it
            const payload = {
                ...edits
            };
            if (targetIdx !== null && targetIdx in storeIDEdits) payload.storeID = storeIDEdits[targetIdx];
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/ott-manager/submissions/${submissionId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });
            if (!response.ok) throw new Error(`Failed to save: ${response.statusText}`);
            // Clear edits for this submission
            setSubmissionEdits((prev)=>{
                const next = {
                    ...prev
                };
                delete next[submissionId];
                return next;
            });
            // Clear Store ID edit for this target if it was included
            if (targetIdx !== null && targetIdx in storeIDEdits) setStoreIDEdits((prev)=>{
                const next = {
                    ...prev
                };
                delete next[targetIdx];
                return next;
            });
            // Refresh data to get updated values
            await fetchData();
        } catch (err) {
            console.error('Error saving submission:', err);
            setError(err instanceof Error ? err.message : 'Failed to save submission');
        } finally{
            setSavingSubmission(null);
        }
    };
    const handleAddPlatform = async (targetIdx)=>{
        setAddingPlatform(targetIdx);
        try {
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/ott-manager/targets`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    apIdx: parseInt(apIdx, 10),
                    targetIdx
                })
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || `Failed to add platform: ${response.statusText}`);
            }
            // Refresh data to get new store target
            await fetchData();
        } catch (err) {
            console.error('Error adding platform:', err);
            setError(err instanceof Error ? err.message : 'Failed to add platform');
        } finally{
            setAddingPlatform(null);
        }
    };
    const handleCreateSubmission = async (targetIdx, storeID)=>{
        setCreatingSubmission(targetIdx);
        try {
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/ott-manager/submissions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    appsToTargetsIdx: targetIdx,
                    storeID: storeID || null,
                    statusId: 1
                })
            });
            if (!response.ok) throw new Error(`Failed to create: ${response.statusText}`);
            // Clear store ID edit for this target since it's now saved
            setStoreIDEdits((prev)=>{
                const next = {
                    ...prev
                };
                delete next[targetIdx];
                return next;
            });
            // Refresh data to get new submission
            await fetchData();
        } catch (err) {
            console.error('Error creating submission:', err);
            setError(err instanceof Error ? err.message : 'Failed to create submission');
        } finally{
            setCreatingSubmission(null);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                    variant: "ghost",
                    onClick: ()=>navigate({
                            to: '/ott-manager'
                        }),
                    className: "mb-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowLeft), {
                            className: "h-4 w-4 mr-2"
                        }),
                        "Back to OTT Manager"
                    ]
                }),
                loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "Loading..."
                }),
                error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "p-4 bg-red-100 border-l-4 border-red-600 rounded",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "m-0 text-red-800 font-medium",
                        children: [
                            "Error: ",
                            error
                        ]
                    })
                }),
                !loading && !error && app && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "flex items-center justify-between mb-2",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        className: "text-2xl font-semibold",
                                        children: app.appName
                                    })
                                }),
                                (()=>{
                                    const hasUnsavedEdits = Object.keys(submissionEdits).length > 0 || Object.keys(storeIDEdits).length > 0;
                                    const editorDisabled = needsSwap || hasUnsavedEdits;
                                    const editorTitle = needsSwap ? 'Switch to this client first' : 'Save changes before opening editor';
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "flex items-center gap-4 text-sm text-muted-foreground",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                children: [
                                                    "Client: ",
                                                    clientName
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "|"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                children: [
                                                    "Manifest Updated: ",
                                                    (0, _index.formatDate)(app.manifestUpdatedAt)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "|"
                                            }),
                                            needsSwap && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                        variant: "outline",
                                                        size: "sm",
                                                        onClick: ()=>setSwapDialogOpen(true),
                                                        className: "h-7",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                                                className: "h-3 w-3 mr-1"
                                                            }),
                                                            "Switch to ",
                                                            clientName
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ArrowLeftRight), {
                                                        className: "h-3 w-3 text-muted-foreground/50"
                                                    })
                                                ]
                                            }),
                                            editorDisabled ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "flex items-center gap-1 text-muted-foreground/50 cursor-not-allowed",
                                                title: editorTitle,
                                                children: [
                                                    "Open OTT Editor",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ExternalLink), {
                                                        className: "h-3 w-3"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                href: app.editorUrl,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "flex items-center gap-1 text-primary hover:underline",
                                                children: [
                                                    "Open OTT Editor",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ExternalLink), {
                                                        className: "h-3 w-3"
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })()
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _swapClientDialog.SwapClientDialog), {
                            open: swapDialogOpen,
                            onOpenChange: setSwapDialogOpen,
                            targetClientID: clientID,
                            targetClientName: clientName,
                            hasUnsavedChanges: Object.keys(submissionEdits).length > 0 || Object.keys(storeIDEdits).length > 0
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                app.storeTargets.map((target)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(PlatformCard, {
                                        target: target,
                                        statuses: statuses,
                                        storeIDEdits: storeIDEdits,
                                        submissionEdits: submissionEdits,
                                        onStoreIDEdit: handleStoreIDEdit,
                                        onSubmissionEdit: handleSubmissionEdit,
                                        onSaveSubmission: handleSaveSubmission,
                                        onCreateSubmission: handleCreateSubmission,
                                        savingSubmission: savingSubmission,
                                        creatingSubmission: creatingSubmission
                                    }, target.idx)),
                                (()=>{
                                    // Filter out platforms that are already added
                                    const existingTargetIdxs = new Set(app.storeTargets.map((t)=>t.targetIdx));
                                    const availablePlatforms = platforms.filter((p)=>!existingTargetIdxs.has(p.targetIdx));
                                    if (availablePlatforms.length === 0 && app.storeTargets.length > 0) return null; // All platforms already added
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
                                        className: app.storeTargets.length === 0 ? '' : 'border-dashed',
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardHeader), {
                                                className: "pb-3",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.CardTitle), {
                                                    className: "text-base",
                                                    children: app.storeTargets.length === 0 ? 'Add Store Targets' : 'Add Another Platform'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.CardContent), {
                                                children: [
                                                    app.storeTargets.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "text-sm text-muted-foreground mb-4",
                                                        children: "No store targets configured for this app. Select platforms to add:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "flex flex-wrap gap-2",
                                                        children: [
                                                            availablePlatforms.map((platform)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                                    variant: "outline",
                                                                    size: "sm",
                                                                    onClick: ()=>handleAddPlatform(platform.targetIdx),
                                                                    disabled: addingPlatform !== null,
                                                                    children: addingPlatform === platform.targetIdx ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                                                                className: "h-4 w-4 mr-1 animate-spin"
                                                                            }),
                                                                            "Adding..."
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Plus), {
                                                                                className: "h-4 w-4 mr-1"
                                                                            }),
                                                                            platform.targetName
                                                                        ]
                                                                    })
                                                                }, platform.targetIdx)),
                                                            availablePlatforms.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "text-sm text-muted-foreground",
                                                                children: "All available platforms have been added."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })()
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useNavigate","aMhxM"]],"@auth0/auth0-react":"gpXrE","zod":"dmnwW","../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/components/ui/input":"8UHwi","@/client/components/ui/button":"armlb","@/client/components/ui/badge":"h4e1f","@/client/components/ui/select":"7QcOK","@/client/components/ui/card":"dhIfn","lucide-react":[["ArrowLeft","2k0dn","default"],["ArrowLeftRight","g6U9n","default"],["Check","bajJU","default"],["ChevronDown","kVmgC","default"],["ChevronUp","9DiT4","default"],["Copy","jM41N","default"],["ExternalLink","kIIQA","default"],["Plus","koF8D","default"],["RefreshCw","7a8jT","default"],["Ticket","eLK5A","default"],["X","8HSxK","default"]],"@/client/config":"8SWgh","@/client/components/swap-client-dialog":"dD6eo","./index":"eTAI9","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"koF8D":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Plus);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
];
const Plus = (0, _createLucideIconJsDefault.default)("plus", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eLK5A":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Ticket);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
            key: "qn84l0"
        }
    ],
    [
        "path",
        {
            d: "M13 5v2",
            key: "dyzc3o"
        }
    ],
    [
        "path",
        {
            d: "M13 17v2",
            key: "1ont0d"
        }
    ],
    [
        "path",
        {
            d: "M13 11v2",
            key: "1wjjxi"
        }
    ]
];
const Ticket = (0, _createLucideIconJsDefault.default)("ticket", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"4eQku":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _reactTable = require("@tanstack/react-table");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _table = require("@/client/components/ui/table");
var _button = require("@/client/components/ui/button");
var _cacheTimestamp = require("@/client/components/cache-timestamp");
var _lucideReact = require("lucide-react");
var _config = require("@/client/config");
var _tableUtils = require("@/client/components/table-utils");
var _badge = require("@/client/components/ui/badge");
var _progress = require("@/client/components/ui/progress");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'aws/rds-health',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: RDSHealthComponent
});
const columnHelper = (0, _reactTable.createColumnHelper)();
function StatusBadge({ status }) {
    const variant = status === 'available' ? 'default' : status === 'stopped' ? 'secondary' : [
        'failed',
        'storage-full'
    ].includes(status) ? 'destructive' : 'outline';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
        variant: variant,
        className: status === 'available' ? 'bg-green-600' : '',
        children: status
    });
}
function CPUCell({ cpu }) {
    if (cpu === undefined) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-muted-foreground",
        children: "-"
    });
    const color = cpu > 80 ? 'bg-red-500' : cpu > 60 ? 'bg-yellow-500' : 'bg-green-500';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-2 min-w-[100px]",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progress.Progress), {
                value: cpu,
                className: "h-2 w-16",
                indicatorClassName: color
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "text-sm",
                children: [
                    cpu,
                    "%"
                ]
            })
        ]
    });
}
function formatBytes(bytes) {
    if (bytes >= 1024 ** 3) return `${(bytes / 1024 ** 3).toFixed(1)} GB`;
    if (bytes >= 1024 ** 2) return `${(bytes / 1024 ** 2).toFixed(0)} MB`;
    return `${(bytes / 1024).toFixed(0)} KB`;
}
const columns = [
    columnHelper.accessor('identifier', {
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Instance"
            }),
        cell: (info)=>{
            const id = info.getValue();
            const truncated = id.length > 20 ? `${id.slice(0, 17)}...` : id;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-mono text-sm",
                title: id,
                children: truncated
            });
        }
    }),
    columnHelper.accessor('status', {
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Status"
            }),
        cell: (info)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusBadge, {
                status: info.getValue()
            })
    }),
    columnHelper.accessor((row)=>row.metrics?.cpu, {
        id: 'cpu',
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "CPU"
            }),
        cell: (info)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CPUCell, {
                cpu: info.getValue()
            })
    }),
    columnHelper.accessor((row)=>row.metrics?.connections, {
        id: 'connections',
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Conns"
            }),
        cell: (info)=>{
            const val = info.getValue();
            return val !== undefined ? val : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-muted-foreground",
                children: "-"
            });
        }
    }),
    columnHelper.accessor((row)=>row.metrics?.freeableMemory, {
        id: 'memory',
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Free Memory"
            }),
        cell: (info)=>{
            const val = info.getValue();
            return val !== undefined ? formatBytes(val) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-muted-foreground",
                children: "-"
            });
        }
    }),
    columnHelper.accessor('engine', {
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Engine"
            }),
        cell: (info)=>info.getValue()
    })
];
function RDSHealthComponent() {
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const navigate = (0, _reactRouter.useNavigate)();
    const [instances, setInstances] = (0, _react.useState)([]);
    const [metrics, setMetrics] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(null);
    const [cacheInfo, setCacheInfo] = (0, _react.useState)(null);
    const [sorting, setSorting] = (0, _react.useState)([
        {
            id: 'identifier',
            desc: false
        }
    ]);
    const fetchData = async (forceRefresh = false)=>{
        try {
            setLoading(true);
            setError(null);
            const token = await getAccessTokenSilently();
            if (forceRefresh) await Promise.all([
                fetch(`${(0, _config.API_BASE_URL)}/api/cache/invalidate`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        key: 'aws:rds:instances'
                    })
                }),
                fetch(`${(0, _config.API_BASE_URL)}/api/cache/invalidate`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        key: 'aws:rds:metrics'
                    })
                })
            ]);
            const [instancesRes, metricsRes] = await Promise.all([
                fetch(`${(0, _config.API_BASE_URL)}/api/aws/rds/instances`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }),
                fetch(`${(0, _config.API_BASE_URL)}/api/aws/rds/metrics`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            ]);
            if (!instancesRes.ok) {
                const err = await instancesRes.json();
                throw new Error(err.message || 'Failed to fetch RDS instances');
            }
            const instancesData = await instancesRes.json();
            setInstances(instancesData.instances);
            setCacheInfo(instancesData.cacheInfo ?? null);
            if (metricsRes.ok) {
                const metricsData = await metricsRes.json();
                setMetrics(metricsData.metrics);
            }
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Unknown error');
        } finally{
            setLoading(false);
        }
    };
    (0, _react.useEffect)(()=>{
        fetchData();
    }, [
        getAccessTokenSilently
    ]);
    // Merge instances with metrics
    const instancesWithMetrics = (0, _react.useMemo)(()=>{
        const metricsMap = new Map(metrics.map((m)=>[
                m.identifier,
                m
            ]));
        return instances.map((instance)=>({
                ...instance,
                metrics: metricsMap.get(instance.identifier)
            }));
    }, [
        instances,
        metrics
    ]);
    const table = (0, _reactTable.useReactTable)({
        data: instancesWithMetrics,
        columns,
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        onSortingChange: setSorting,
        getSortedRowModel: (0, _reactTable.getSortedRowModel)(),
        state: {
            sorting
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex justify-between items-center mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "text-2xl font-semibold",
                                children: "RDS Health"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cacheTimestamp.CacheTimestamp), {
                                cachedAt: cacheInfo?.cachedAt ?? null
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-4 bg-red-100 border-l-4 border-red-600 rounded mt-4 mb-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "m-0 text-red-800 font-medium",
                            children: [
                                "Error: ",
                                error
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex justify-end items-center gap-4 mb-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                            variant: "outline",
                            onClick: ()=>fetchData(true),
                            disabled: loading,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                    className: `h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`
                                }),
                                "Force Refresh"
                            ]
                        })
                    }),
                    loading && instances.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Loading RDS instances..."
                    }),
                    !loading && !error && instances.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "No RDS instances found."
                    }),
                    instances.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "rounded-md border",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                            children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: header.isPlaceholder ? null : (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())
                                                        }, header.id))
                                                }, headerGroup.id))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                            children: table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    className: "cursor-pointer hover:bg-muted/50",
                                                    onClick: ()=>navigate({
                                                            to: '/aws/rds/$instanceId',
                                                            params: {
                                                                instanceId: row.original.identifier
                                                            }
                                                        }),
                                                    children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                            children: (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                                        }, cell.id))
                                                }, row.id))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "mt-2 text-sm text-muted-foreground",
                                children: [
                                    instances.length,
                                    " RDS instance",
                                    instances.length !== 1 ? 's' : '',
                                    " \u2022 Click row for details \u2022 Metrics refresh every 60s"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useNavigate","aMhxM"]],"@auth0/auth0-react":"gpXrE","@tanstack/react-table":[["createColumnHelper","3MlnA"],["getCoreRowModel","3MlnA"],["getSortedRowModel","3MlnA"],["flexRender","brwh1"],["useReactTable","brwh1"]],"../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/components/ui/table":"5vxZ8","@/client/components/ui/button":"armlb","@/client/components/cache-timestamp":"f5Zyx","lucide-react":[["RefreshCw","7a8jT","default"]],"@/client/config":"8SWgh","@/client/components/table-utils":"lB8sT","@/client/components/ui/badge":"h4e1f","@/client/components/ui/progress":"2BCJM","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"1YgAR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _root = require("../../__root");
var _layout = require("@/client/layouts/layout");
var _detailView = require("@/client/components/ui/detail-view");
var _button = require("@/client/components/ui/button");
var _badge = require("@/client/components/ui/badge");
var _progress = require("@/client/components/ui/progress");
var _lucideReact = require("lucide-react");
var _config = require("@/client/config");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'aws/rds/$instanceId',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: RDSDetailComponent
});
function StatusBadge({ status }) {
    const variant = status === 'available' ? 'default' : status === 'stopped' ? 'secondary' : [
        'failed',
        'storage-full'
    ].includes(status) ? 'destructive' : 'outline';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
        variant: variant,
        className: status === 'available' ? 'bg-green-600' : '',
        children: status
    });
}
function CPUCell({ cpu }) {
    if (cpu === undefined) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-muted-foreground",
        children: "-"
    });
    const color = cpu > 80 ? 'bg-red-500' : cpu > 60 ? 'bg-yellow-500' : 'bg-green-500';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progress.Progress), {
                value: cpu,
                className: "h-2 w-16",
                indicatorClassName: color
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "text-sm",
                children: [
                    cpu,
                    "%"
                ]
            })
        ]
    });
}
function formatBytes(bytes) {
    if (bytes >= 1024 ** 3) return `${(bytes / 1024 ** 3).toFixed(1)} GB`;
    if (bytes >= 1024 ** 2) return `${(bytes / 1024 ** 2).toFixed(0)} MB`;
    return `${(bytes / 1024).toFixed(0)} KB`;
}
function RDSDetailComponent() {
    const { instanceId } = (0, _reactRouter.useParams)({
        from: '/aws/rds/$instanceId'
    });
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const navigate = (0, _reactRouter.useNavigate)();
    const [instance, setInstance] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(null);
    const fetchData = async (forceRefresh = false)=>{
        try {
            setLoading(true);
            setError(null);
            const token = await getAccessTokenSilently();
            if (forceRefresh) await Promise.all([
                fetch(`${(0, _config.API_BASE_URL)}/api/cache/invalidate`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        key: 'aws:rds:instances'
                    })
                }),
                fetch(`${(0, _config.API_BASE_URL)}/api/cache/invalidate`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        key: 'aws:rds:metrics'
                    })
                })
            ]);
            const [instancesRes, metricsRes] = await Promise.all([
                fetch(`${(0, _config.API_BASE_URL)}/api/aws/rds/instances`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }),
                fetch(`${(0, _config.API_BASE_URL)}/api/aws/rds/metrics`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            ]);
            if (!instancesRes.ok) {
                const err = await instancesRes.json();
                throw new Error(err.message || 'Failed to fetch RDS instances');
            }
            const instancesData = await instancesRes.json();
            const metricsData = metricsRes.ok ? await metricsRes.json() : {
                metrics: []
            };
            // Find the matching instance
            const foundInstance = instancesData.instances.find((i)=>i.identifier === instanceId);
            if (foundInstance) {
                const metricsForInstance = metricsData.metrics.find((m)=>m.identifier === instanceId);
                setInstance({
                    ...foundInstance,
                    metrics: metricsForInstance
                });
            } else setError('Instance not found');
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Unknown error');
        } finally{
            setLoading(false);
        }
    };
    (0, _react.useEffect)(()=>{
        fetchData();
    }, [
        instanceId,
        getAccessTokenSilently
    ]);
    // Loading state
    if (loading && !instance) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Layout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailHeader), {
                title: "Loading...",
                backTo: "/aws/rds-health",
                backLabel: "Back to RDS Health"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "rounded-lg border p-8 text-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Loader2), {
                        className: "h-8 w-8 animate-spin mx-auto text-muted-foreground"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-muted-foreground mt-4",
                        children: "Loading instance data..."
                    })
                ]
            })
        ]
    });
    // Not found state
    if (!instance || error) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Layout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailHeader), {
                title: "Instance Not Found",
                backTo: "/aws/rds-health",
                backLabel: "Back to RDS Health"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "rounded-lg border p-8 text-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-muted-foreground mb-4",
                        children: error || 'This RDS instance could not be found.'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        variant: "outline",
                        onClick: ()=>navigate({
                                to: '/aws/rds-health'
                            }),
                        children: "Return to RDS Health"
                    })
                ]
            })
        ]
    });
    const m = instance.metrics;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Layout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailHeader), {
                title: instance.identifier,
                backTo: "/aws/rds-health",
                backLabel: "Back to RDS Health",
                badge: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusBadge, {
                    status: instance.status
                }),
                actions: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center gap-1",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            size: "sm",
                            className: "bg-amber-500 hover:bg-amber-600 text-black hover:text-white",
                            title: "View in AWS Console",
                            asChild: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                href: `https://console.aws.amazon.com/rds/home?region=${instance.availabilityZone.slice(0, -1)}#database:id=${instance.identifier};is-cluster=false`,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: [
                                    "Open in AWS",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ExternalLink), {
                                        className: "h-3.5 w-3.5 ml-1.5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            variant: "ghost",
                            size: "icon",
                            title: "Refresh",
                            onClick: ()=>fetchData(true),
                            disabled: loading,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                className: `h-4 w-4 ${loading ? 'animate-spin' : ''}`
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailView.DetailGrid), {
                columns: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailCard), {
                        title: "Instance Info",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailView.DetailList), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Identifier",
                                    value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.CopyableText), {
                                        text: instance.identifier
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Status",
                                    value: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusBadge, {
                                        status: instance.status
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Engine",
                                    value: `${instance.engine} ${instance.engineVersion}`
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Instance Class",
                                    value: instance.instanceClass,
                                    mono: true
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Availability Zone",
                                    value: instance.availabilityZone
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Multi-AZ",
                                    value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.BooleanBadge), {
                                        value: instance.multiAZ
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailCard), {
                        title: "Endpoint",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailList), {
                            children: instance.endpoint ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                        label: "Address",
                                        value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.CopyableText), {
                                            text: instance.endpoint.address
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                        label: "Port",
                                        value: instance.endpoint.port,
                                        mono: true
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                label: "Status",
                                value: "No endpoint available"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailCard), {
                        title: "Storage",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailView.DetailList), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Allocated",
                                    value: `${instance.allocatedStorage} GB`
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Type",
                                    value: instance.storageType
                                }),
                                instance.iops && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Provisioned IOPS",
                                    value: instance.iops
                                }),
                                m?.freeStorageSpace !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Free Space",
                                    value: formatBytes(m.freeStorageSpace)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailCard), {
                        title: "Current Metrics",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailView.DetailList), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "CPU",
                                    value: m?.cpu !== undefined ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(CPUCell, {
                                        cpu: m.cpu
                                    }) : '-'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Connections",
                                    value: m?.connections !== undefined ? m.connections : '-'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Free Memory",
                                    value: m?.freeableMemory !== undefined ? formatBytes(m.freeableMemory) : '-'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Read IOPS",
                                    value: m?.readIOPS !== undefined ? m.readIOPS : '-'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Write IOPS",
                                    value: m?.writeIOPS !== undefined ? m.writeIOPS : '-'
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useNavigate","aMhxM"],["useParams","jBvHB"]],"@auth0/auth0-react":"gpXrE","../../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/components/ui/detail-view":"5pGcz","@/client/components/ui/button":"armlb","@/client/components/ui/badge":"h4e1f","@/client/components/ui/progress":"2BCJM","lucide-react":[["ExternalLink","kIIQA","default"],["Loader2","gZHhk","default"],["RefreshCw","7a8jT","default"]],"@/client/config":"8SWgh","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9z5Ei":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _reactTable = require("@tanstack/react-table");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _table = require("@/client/components/ui/table");
var _button = require("@/client/components/ui/button");
var _cacheTimestamp = require("@/client/components/cache-timestamp");
var _lucideReact = require("lucide-react");
var _config = require("@/client/config");
var _tableUtils = require("@/client/components/table-utils");
var _badge = require("@/client/components/ui/badge");
var _progress = require("@/client/components/ui/progress");
var _select = require("@/client/components/ui/select");
var _dateFns = require("date-fns");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'aws/ec2-health',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: EC2HealthComponent
});
const columnHelper = (0, _reactTable.createColumnHelper)();
function StateBadge({ state }) {
    if (!state) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-muted-foreground",
        children: "-"
    });
    const variant = state === 'running' ? 'default' : state === 'stopped' ? 'secondary' : [
        'terminated',
        'shutting-down'
    ].includes(state) ? 'destructive' : 'outline';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
        variant: variant,
        className: state === 'running' ? 'bg-green-600' : '',
        children: state
    });
}
function ServerTypeBadge({ type }) {
    const colors = {
        ingress: 'bg-blue-600',
        egress: 'bg-purple-600',
        transcode: 'bg-orange-600',
        unknown: 'bg-gray-500'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
        className: colors[type],
        children: type
    });
}
function CPUCell({ cpu }) {
    if (cpu === undefined) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-muted-foreground",
        children: "-"
    });
    const color = cpu > 80 ? 'bg-red-500' : cpu > 60 ? 'bg-yellow-500' : 'bg-green-500';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-2 min-w-[80px]",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progress.Progress), {
                value: cpu,
                className: "h-2 w-12",
                indicatorClassName: color
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "text-sm",
                children: [
                    cpu,
                    "%"
                ]
            })
        ]
    });
}
// Simplified columns for main table
const columns = [
    columnHelper.accessor('instanceId', {
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Instance ID"
            }),
        cell: (info)=>{
            const id = info.getValue();
            const truncated = id.length > 12 ? `${id.slice(0, 10)}...` : id;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-mono text-sm",
                title: id,
                children: truncated
            });
        }
    }),
    columnHelper.accessor('name', {
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Name"
            }),
        cell: (info)=>info.getValue() ?? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-muted-foreground italic",
                children: "unnamed"
            }),
        sortingFn: (rowA, rowB)=>{
            const a = rowA.original.name;
            const b = rowB.original.name;
            // Named instances first, then unnamed (nulls last)
            if (a === null && b === null) return 0;
            if (a === null) return 1;
            if (b === null) return -1;
            return a.localeCompare(b);
        }
    }),
    columnHelper.accessor('serverType', {
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Type"
            }),
        cell: (info)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ServerTypeBadge, {
                type: info.getValue()
            }),
        filterFn: 'equals',
        sortingFn: (rowA, rowB)=>{
            const order = {
                ingress: 0,
                egress: 1,
                transcode: 2,
                unknown: 3
            };
            return order[rowA.original.serverType] - order[rowB.original.serverType];
        }
    }),
    columnHelper.accessor('state', {
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "State"
            }),
        cell: (info)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StateBadge, {
                state: info.getValue()
            }),
        filterFn: 'equals'
    }),
    columnHelper.accessor((row)=>row.metrics?.cpu, {
        id: 'cpu',
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "CPU"
            }),
        cell: (info)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CPUCell, {
                cpu: info.getValue()
            })
    }),
    columnHelper.accessor('launchTime', {
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Uptime"
            }),
        cell: (info)=>{
            const launchTime = info.getValue();
            if (!launchTime) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-muted-foreground",
                children: "-"
            });
            return (0, _dateFns.formatDistanceToNow)(new Date(launchTime), {
                addSuffix: false
            });
        }
    }),
    columnHelper.accessor('instanceType', {
        header: ({ column })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableUtils.SortableHeader), {
                column: column,
                children: "Instance Type"
            }),
        cell: (info)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-mono text-sm",
                children: info.getValue() ?? '-'
            })
    })
];
function EC2HealthComponent() {
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const navigate = (0, _reactRouter.useNavigate)();
    const [instances, setInstances] = (0, _react.useState)([]);
    const [metrics, setMetrics] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(null);
    const [cacheInfo, setCacheInfo] = (0, _react.useState)(null);
    const [sorting, setSorting] = (0, _react.useState)([
        {
            id: 'serverType',
            desc: false
        }
    ]);
    const [columnFilters, setColumnFilters] = (0, _react.useState)([]);
    const [typeFilter, setTypeFilter] = (0, _react.useState)('all');
    const [stateFilter, setStateFilter] = (0, _react.useState)('running');
    const fetchData = async (forceRefresh = false)=>{
        try {
            setLoading(true);
            setError(null);
            const token = await getAccessTokenSilently();
            if (forceRefresh) await Promise.all([
                fetch(`${(0, _config.API_BASE_URL)}/api/cache/invalidate`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        key: 'aws:ec2:instances'
                    })
                }),
                fetch(`${(0, _config.API_BASE_URL)}/api/cache/invalidate`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        key: 'aws:ec2:metrics'
                    })
                })
            ]);
            const [instancesRes, metricsRes] = await Promise.all([
                fetch(`${(0, _config.API_BASE_URL)}/api/aws/ec2/instances`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }),
                fetch(`${(0, _config.API_BASE_URL)}/api/aws/ec2/metrics`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            ]);
            if (!instancesRes.ok) {
                const err = await instancesRes.json();
                throw new Error(err.message || 'Failed to fetch EC2 instances');
            }
            const instancesData = await instancesRes.json();
            setInstances(instancesData.instances);
            setCacheInfo(instancesData.cacheInfo ?? null);
            if (metricsRes.ok) {
                const metricsData = await metricsRes.json();
                setMetrics(metricsData.metrics);
            }
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Unknown error');
        } finally{
            setLoading(false);
        }
    };
    (0, _react.useEffect)(()=>{
        fetchData();
    }, [
        getAccessTokenSilently
    ]);
    // Apply filters
    (0, _react.useEffect)(()=>{
        const filters = [];
        if (typeFilter !== 'all') filters.push({
            id: 'serverType',
            value: typeFilter
        });
        if (stateFilter !== 'all') filters.push({
            id: 'state',
            value: stateFilter
        });
        setColumnFilters(filters);
    }, [
        typeFilter,
        stateFilter
    ]);
    // Merge instances with metrics
    const instancesWithMetrics = (0, _react.useMemo)(()=>{
        const metricsMap = new Map(metrics.map((m)=>[
                m.instanceId,
                m
            ]));
        return instances.map((instance)=>({
                ...instance,
                metrics: metricsMap.get(instance.instanceId)
            }));
    }, [
        instances,
        metrics
    ]);
    const table = (0, _reactTable.useReactTable)({
        data: instancesWithMetrics,
        columns,
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        onSortingChange: setSorting,
        getSortedRowModel: (0, _reactTable.getSortedRowModel)(),
        onColumnFiltersChange: setColumnFilters,
        getFilteredRowModel: (0, _reactTable.getFilteredRowModel)(),
        state: {
            sorting,
            columnFilters
        }
    });
    // Count by type for summary
    const typeCounts = (0, _react.useMemo)(()=>{
        const counts = {
            ingress: 0,
            egress: 0,
            transcode: 0,
            unknown: 0,
            total: 0
        };
        const running = instances.filter((i)=>i.state === 'running');
        running.forEach((i)=>{
            counts[i.serverType]++;
            counts.total++;
        });
        return counts;
    }, [
        instances
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex justify-between items-center mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "text-2xl font-semibold",
                                children: "EC2 Health"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cacheTimestamp.CacheTimestamp), {
                                cachedAt: cacheInfo?.cachedAt ?? null
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grid grid-cols-4 gap-4 mb-6",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-4 border rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-muted-foreground",
                                        children: "Running Instances"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-2xl font-bold",
                                        children: typeCounts.total
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-4 border rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-muted-foreground",
                                        children: "Ingress"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-2xl font-bold text-blue-600",
                                        children: typeCounts.ingress
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-4 border rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-muted-foreground",
                                        children: "Egress"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-2xl font-bold text-purple-600",
                                        children: typeCounts.egress
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "p-4 border rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-muted-foreground",
                                        children: "Transcode"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-2xl font-bold text-orange-600",
                                        children: typeCounts.transcode
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "p-4 bg-red-100 border-l-4 border-red-600 rounded mt-4 mb-4",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "m-0 text-red-800 font-medium",
                            children: [
                                "Error: ",
                                error
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex justify-between items-center gap-4 mb-4",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                                        value: typeFilter,
                                        onValueChange: setTypeFilter,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectTrigger), {
                                                className: "w-[150px]",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectValue), {
                                                    placeholder: "Server Type"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectContent), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                                        value: "all",
                                                        children: "All Types"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                                        value: "ingress",
                                                        children: "Ingress"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                                        value: "egress",
                                                        children: "Egress"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                                        value: "transcode",
                                                        children: "Transcode"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                                        value: "unknown",
                                                        children: "Unknown"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.Select), {
                                        value: stateFilter,
                                        onValueChange: setStateFilter,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectTrigger), {
                                                className: "w-[150px]",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectValue), {
                                                    placeholder: "State"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _select.SelectContent), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                                        value: "all",
                                                        children: "All States"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                                        value: "running",
                                                        children: "Running"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                                        value: "stopped",
                                                        children: "Stopped"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.SelectItem), {
                                                        value: "terminated",
                                                        children: "Terminated"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                variant: "outline",
                                onClick: ()=>fetchData(true),
                                disabled: loading,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                        className: `h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`
                                    }),
                                    "Force Refresh"
                                ]
                            })
                        ]
                    }),
                    loading && instances.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Loading EC2 instances..."
                    }),
                    !loading && !error && instances.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "No EC2 instances found."
                    }),
                    instances.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "rounded-md border",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                            children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                            children: header.isPlaceholder ? null : (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())
                                                        }, header.id))
                                                }, headerGroup.id))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                            children: table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                                    onClick: ()=>navigate({
                                                            to: '/aws/ec2/$instanceId',
                                                            params: {
                                                                instanceId: row.original.instanceId
                                                            }
                                                        }),
                                                    className: "cursor-pointer hover:bg-accent",
                                                    children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                            children: (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                                        }, cell.id))
                                                }, row.id))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "mt-2 text-sm text-muted-foreground",
                                children: [
                                    "Showing ",
                                    table.getRowModel().rows.length,
                                    " of ",
                                    instances.length,
                                    " instances \u2022 Click row for details"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useNavigate","aMhxM"]],"@auth0/auth0-react":"gpXrE","@tanstack/react-table":[["createColumnHelper","3MlnA"],["getCoreRowModel","3MlnA"],["getFilteredRowModel","3MlnA"],["getSortedRowModel","3MlnA"],["flexRender","brwh1"],["useReactTable","brwh1"]],"../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/components/ui/table":"5vxZ8","@/client/components/ui/button":"armlb","@/client/components/cache-timestamp":"f5Zyx","lucide-react":[["RefreshCw","7a8jT","default"]],"@/client/config":"8SWgh","@/client/components/table-utils":"lB8sT","@/client/components/ui/badge":"h4e1f","@/client/components/ui/progress":"2BCJM","@/client/components/ui/select":"7QcOK","date-fns":"1DXja","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"ksSF1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _root = require("../../__root");
var _layout = require("@/client/layouts/layout");
var _detailView = require("@/client/components/ui/detail-view");
var _table = require("@/client/components/ui/table");
var _cells = require("@/client/components/tables/cells");
var _liveStreamsColumns = require("@/client/components/tables/live-streams-columns");
var _dateFns = require("date-fns");
var _button = require("@/client/components/ui/button");
var _badge = require("@/client/components/ui/badge");
var _progress = require("@/client/components/ui/progress");
var _lucideReact = require("lucide-react");
var _config = require("@/client/config");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'aws/ec2/$instanceId',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: EC2DetailComponent
});
function StateBadge({ state }) {
    if (!state) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-muted-foreground",
        children: "-"
    });
    const variant = state === 'running' ? 'default' : state === 'stopped' ? 'secondary' : [
        'terminated',
        'shutting-down'
    ].includes(state) ? 'destructive' : 'outline';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
        variant: variant,
        className: state === 'running' ? 'bg-green-600' : '',
        children: state
    });
}
function ServerTypeBadge({ type }) {
    const colors = {
        ingress: 'bg-blue-600',
        egress: 'bg-purple-600',
        transcode: 'bg-orange-600',
        unknown: 'bg-gray-500'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
        className: colors[type],
        children: type
    });
}
function CPUCell({ cpu }) {
    if (cpu === undefined) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-muted-foreground",
        children: "-"
    });
    const color = cpu > 80 ? 'bg-red-500' : cpu > 60 ? 'bg-yellow-500' : 'bg-green-500';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progress.Progress), {
                value: cpu,
                className: "h-2 w-16",
                indicatorClassName: color
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "text-sm",
                children: [
                    cpu,
                    "%"
                ]
            })
        ]
    });
}
function EC2DetailComponent() {
    const { instanceId } = (0, _reactRouter.useParams)({
        from: '/aws/ec2/$instanceId'
    });
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const navigate = (0, _reactRouter.useNavigate)();
    const [instance, setInstance] = (0, _react.useState)(null);
    const [activeStreams, setActiveStreams] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(null);
    const fetchData = async (forceRefresh = false)=>{
        try {
            setLoading(true);
            setError(null);
            const token = await getAccessTokenSilently();
            if (forceRefresh) await Promise.all([
                fetch(`${(0, _config.API_BASE_URL)}/api/cache/invalidate`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        key: 'aws:ec2:instances'
                    })
                }),
                fetch(`${(0, _config.API_BASE_URL)}/api/cache/invalidate`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        key: 'aws:ec2:metrics'
                    })
                })
            ]);
            const [instancesRes, metricsRes, streamsRes] = await Promise.all([
                fetch(`${(0, _config.API_BASE_URL)}/api/aws/ec2/instances`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }),
                fetch(`${(0, _config.API_BASE_URL)}/api/aws/ec2/metrics`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }),
                fetch(`${(0, _config.API_BASE_URL)}/api/aws/ec2/${instanceId}/streams`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            ]);
            if (!instancesRes.ok) {
                const err = await instancesRes.json();
                throw new Error(err.message || 'Failed to fetch EC2 instances');
            }
            const instancesData = await instancesRes.json();
            const metricsData = metricsRes.ok ? await metricsRes.json() : {
                metrics: []
            };
            const streamsData = streamsRes.ok ? await streamsRes.json() : {
                streams: []
            };
            setActiveStreams(streamsData.streams || []);
            // Find the matching instance
            const foundInstance = instancesData.instances.find((i)=>i.instanceId === instanceId);
            if (foundInstance) {
                const metricsForInstance = metricsData.metrics.find((m)=>m.instanceId === instanceId);
                setInstance({
                    ...foundInstance,
                    metrics: metricsForInstance
                });
            } else setError('Instance not found');
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Unknown error');
        } finally{
            setLoading(false);
        }
    };
    (0, _react.useEffect)(()=>{
        fetchData();
    }, [
        instanceId,
        getAccessTokenSilently
    ]);
    // Loading state
    if (loading && !instance) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Layout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailHeader), {
                title: "Loading...",
                backTo: "/aws/ec2-health",
                backLabel: "Back to EC2 Health"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "rounded-lg border p-8 text-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Loader2), {
                        className: "h-8 w-8 animate-spin mx-auto text-muted-foreground"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-muted-foreground mt-4",
                        children: "Loading instance data..."
                    })
                ]
            })
        ]
    });
    // Not found state
    if (!instance || error) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Layout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailHeader), {
                title: "Instance Not Found",
                backTo: "/aws/ec2-health",
                backLabel: "Back to EC2 Health"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "rounded-lg border p-8 text-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-muted-foreground mb-4",
                        children: error || 'This EC2 instance could not be found.'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        variant: "outline",
                        onClick: ()=>navigate({
                                to: '/aws/ec2-health'
                            }),
                        children: "Return to EC2 Health"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Layout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailHeader), {
                title: instance.name ?? 'Unnamed Instance',
                subtitle: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.CopyableText), {
                    text: instance.instanceId
                }),
                backTo: "/aws/ec2-health",
                backLabel: "Back to EC2 Health",
                badge: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StateBadge, {
                    state: instance.state
                }),
                actions: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                    variant: "ghost",
                    size: "icon",
                    title: "Refresh",
                    onClick: ()=>fetchData(true),
                    disabled: loading,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                        className: `h-4 w-4 ${loading ? 'animate-spin' : ''}`
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailView.DetailGrid), {
                columns: 2,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailCard), {
                        title: "Status",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailView.DetailList), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "State",
                                    value: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StateBadge, {
                                        state: instance.state
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Server Type",
                                    value: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ServerTypeBadge, {
                                        type: instance.serverType
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "CPU",
                                    value: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CPUCell, {
                                        cpu: instance.metrics?.cpu
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Uptime",
                                    value: instance.launchTime ? (0, _dateFns.formatDistanceToNow)(new Date(instance.launchTime), {
                                        addSuffix: false
                                    }) : '-'
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailCard), {
                        title: "Instance Details",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailView.DetailList), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Instance ID",
                                    value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.CopyableText), {
                                        text: instance.instanceId
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Instance Type",
                                    value: instance.instanceType,
                                    mono: true
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Availability Zone",
                                    value: instance.availabilityZone
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailCard), {
                        title: "Network",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailView.DetailList), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Private IP",
                                    value: instance.privateIp ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.CopyableText), {
                                        text: instance.privateIp
                                    }) : '-'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Public IP",
                                    value: instance.publicIp ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.CopyableText), {
                                        text: instance.publicIp
                                    }) : '-'
                                })
                            ]
                        })
                    }),
                    instance.dbInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailCard), {
                        title: "Database Info",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailView.DetailList), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "DB Status",
                                    value: instance.dbInfo.dbStatus ?? '-'
                                }),
                                instance.dbInfo.serverType === 'ingress' && instance.dbInfo.maxSources && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Sources",
                                    value: `${instance.dbInfo.sourceConnectionCount ?? 0} / ${instance.dbInfo.maxSources}`
                                }),
                                instance.dbInfo.serverType === 'transcode' && instance.dbInfo.maxSlots && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Free Slots",
                                    value: `${instance.dbInfo.freeSlots ?? 0} / ${instance.dbInfo.maxSlots}`
                                }),
                                instance.dbInfo.serverType === 'egress' && instance.dbInfo.sysType && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "System Type",
                                    value: instance.dbInfo.sysType
                                }),
                                instance.dbInfo.timestamp && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                                    label: "Last Updated",
                                    value: (0, _dateFns.formatDistanceToNow)(new Date(instance.dbInfo.timestamp), {
                                        addSuffix: true
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            activeStreams.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "rounded-lg border-2 border-green-500/50 bg-green-500/5",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2 px-4 py-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Radio), {
                                    className: "h-4 w-4 text-green-500 animate-pulse"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                    className: "font-medium text-sm text-green-600 dark:text-green-400",
                                    children: [
                                        "Active Stream",
                                        activeStreams.length > 1 ? 's' : '',
                                        " on This Instance"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                            className: "table-fixed",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                        className: "border-green-500/30 hover:bg-transparent",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                className: "text-xs w-[25%]",
                                                children: "Client"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                className: "text-xs w-[35%]",
                                                children: "Event"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                className: "text-xs w-[10%]",
                                                children: "Encoder"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                className: "text-xs w-[10%]",
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHead), {
                                                className: "text-xs text-right w-[20%]",
                                                children: "Started"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                    children: activeStreams.map((stream, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableRow), {
                                            className: "border-green-500/20 hover:bg-green-500/5",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "py-2 truncate",
                                                    children: stream.clientID && stream.clientName ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                                        to: "/clients/$clientID",
                                                        params: {
                                                            clientID: stream.clientID
                                                        },
                                                        className: "text-xs hover:underline truncate block",
                                                        title: stream.clientName,
                                                        children: stream.clientName
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-xs text-muted-foreground",
                                                        children: "-"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "py-2 truncate",
                                                    children: stream.eventID && stream.clientID ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                                                        to: "/events/$eventId",
                                                        params: {
                                                            eventId: stream.eventID
                                                        },
                                                        className: "text-xs hover:underline truncate block",
                                                        title: stream.eventTitle || stream.eventID,
                                                        children: stream.eventTitle || stream.eventID
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-xs truncate",
                                                        children: stream.eventTitle || '-'
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "py-2",
                                                    children: stream.encoderID ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EncoderIDCell), {
                                                        encoderID: stream.encoderID
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "text-xs text-muted-foreground",
                                                        children: "-"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "py-2",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _liveStreamsColumns.StatusBadge), {
                                                        status: stream.status
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    className: "py-2 text-right text-xs text-muted-foreground",
                                                    children: stream.startDateTime ? (0, _dateFns.formatDistanceToNowStrict)(new Date(stream.startDateTime), {
                                                        addSuffix: true
                                                    }) : '-'
                                                })
                                            ]
                                        }, stream.liveID || index))
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["Link","7k6Lq"],["redirect","jmFxY"],["useNavigate","aMhxM"],["useParams","jBvHB"]],"@auth0/auth0-react":"gpXrE","../../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/components/ui/detail-view":"5pGcz","@/client/components/ui/table":"5vxZ8","@/client/components/tables/cells":"5BSEg","@/client/components/tables/live-streams-columns":"ba3MU","date-fns":[["formatDistanceToNow","1DXja"],["formatDistanceToNowStrict","kln57"]],"@/client/components/ui/button":"armlb","@/client/components/ui/badge":"h4e1f","@/client/components/ui/progress":"2BCJM","lucide-react":[["Loader2","gZHhk","default"],["Radio","8O5hz","default"],["RefreshCw","7a8jT","default"]],"@/client/config":"8SWgh","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"kln57":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link formatDistanceToNowStrict} function options.
 */ /**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */ parcelHelpers.export(exports, "formatDistanceToNowStrict", ()=>formatDistanceToNowStrict);
var _constructNowJs = require("./constructNow.js");
var _formatDistanceStrictJs = require("./formatDistanceStrict.js");
function formatDistanceToNowStrict(date, options) {
    return (0, _formatDistanceStrictJs.formatDistanceStrict)(date, (0, _constructNowJs.constructNow)(date), options);
}
// Fallback for modularized imports:
exports.default = formatDistanceToNowStrict;

},{"./constructNow.js":"eumfa","./formatDistanceStrict.js":"03bGy","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"03bGy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link formatDistanceStrict} function options.
 */ /**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */ /**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param laterDate - The date
 * @param earlierDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */ parcelHelpers.export(exports, "formatDistanceStrict", ()=>formatDistanceStrict);
var _defaultLocaleJs = require("./_lib/defaultLocale.js");
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _getRoundingMethodJs = require("./_lib/getRoundingMethod.js");
var _getTimezoneOffsetInMillisecondsJs = require("./_lib/getTimezoneOffsetInMilliseconds.js");
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
var _compareAscJs = require("./compareAsc.js");
var _constantsJs = require("./constants.js");
function formatDistanceStrict(laterDate, earlierDate, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, _defaultLocaleJs.defaultLocale);
    const comparison = (0, _compareAscJs.compareAsc)(laterDate, earlierDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    const [laterDate_, earlierDate_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, ...comparison > 0 ? [
        earlierDate,
        laterDate
    ] : [
        laterDate,
        earlierDate
    ]);
    const roundingMethod = (0, _getRoundingMethodJs.getRoundingMethod)(options?.roundingMethod ?? "round");
    const milliseconds = earlierDate_.getTime() - laterDate_.getTime();
    const minutes = milliseconds / (0, _constantsJs.millisecondsInMinute);
    const timezoneOffset = (0, _getTimezoneOffsetInMillisecondsJs.getTimezoneOffsetInMilliseconds)(earlierDate_) - (0, _getTimezoneOffsetInMillisecondsJs.getTimezoneOffsetInMilliseconds)(laterDate_);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / (0, _constantsJs.millisecondsInMinute);
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < (0, _constantsJs.minutesInDay)) unit = "hour";
        else if (dstNormalizedMinutes < (0, _constantsJs.minutesInMonth)) unit = "day";
        else if (dstNormalizedMinutes < (0, _constantsJs.minutesInYear)) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / (0, _constantsJs.minutesInDay));
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / (0, _constantsJs.minutesInMonth));
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / (0, _constantsJs.minutesInYear));
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}
// Fallback for modularized imports:
exports.default = formatDistanceStrict;

},{"./_lib/defaultLocale.js":[["defaultLocale","3UxOA","enUS"]],"./_lib/defaultOptions.js":"4407t","./_lib/getRoundingMethod.js":"aHzbs","./_lib/getTimezoneOffsetInMilliseconds.js":"bKJ63","./_lib/normalizeDates.js":"eMMqq","./compareAsc.js":"i7cG8","./constants.js":"Sfkj0","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"eUtwb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _reactTable = require("@tanstack/react-table");
var _dateFns = require("date-fns");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _usePersistedSearch = require("@/client/hooks/usePersistedSearch");
var _resetFiltersButton = require("@/client/components/reset-filters-button");
var _clientSelector = require("@/client/components/client-selector");
var _cacheTimestamp = require("@/client/components/cache-timestamp");
var _cells = require("@/client/components/tables/cells");
var _config = require("@/client/config");
var _captionJobs = require("@shared/types/captionJobs");
var _table = require("@/client/components/ui/table");
var _button = require("@/client/components/ui/button");
var _badge = require("@/client/components/ui/badge");
var _skeleton = require("@/client/components/ui/skeleton");
var _dropdownMenu = require("@/client/components/ui/dropdown-menu");
var _pagination = require("@/client/components/ui/pagination");
var _lucideReact = require("lucide-react");
// Quick range presets
const QUICK_RANGES = [
    {
        label: '24h',
        hours: 24
    },
    {
        label: '48h',
        hours: 48
    },
    {
        label: '72h',
        hours: 72
    },
    {
        label: '1 week',
        hours: 168
    },
    {
        label: '2 weeks',
        hours: 336
    },
    {
        label: '1 month',
        hours: 720
    }
];
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'monitoring/caption-jobs',
    validateSearch: (search)=>{
        return {
            clientID: typeof search.clientID === 'string' ? search.clientID : undefined,
            range: typeof search.range === 'string' ? search.range : undefined,
            status: typeof search.status === 'string' ? search.status : undefined,
            page: typeof search.page === 'number' ? search.page : undefined
        };
    },
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: CaptionJobsComponent
});
function getDateRange(rangeLabel) {
    const now = new Date();
    const range = QUICK_RANGES.find((r)=>r.label === rangeLabel) || QUICK_RANGES[0]; // Default 24hrs
    const start = new Date(now.getTime() - range.hours * 3600000);
    return {
        startDate: (0, _dateFns.format)(start, 'yyyy-MM-dd'),
        endDate: (0, _dateFns.format)(now, 'yyyy-MM-dd')
    };
}
const STATUS_CONFIG = {
    captioned: {
        label: 'Captioned',
        icon: (0, _lucideReact.CheckCircle),
        className: 'text-green-500'
    },
    missing: {
        label: 'Missing',
        icon: (0, _lucideReact.AlertTriangle),
        className: 'text-destructive'
    },
    pending: {
        label: 'Pending',
        icon: (0, _lucideReact.Circle),
        className: 'text-muted-foreground'
    }
};
function StatusIcon({ status }) {
    const config = STATUS_CONFIG[status];
    const Icon = config.icon;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        title: config.label,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
            className: `h-4 w-4 ${config.className}`
        })
    });
}
function formatFileSize(bytes) {
    if (bytes === null) return '-';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1048576).toFixed(1)} MB`;
}
function formatDuration(seconds) {
    if (seconds === null) return '-';
    if (seconds < 60) return `${seconds}s`;
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    return `${h}h ${m}m`;
}
const columnHelper = (0, _reactTable.createColumnHelper)();
/** Badge classes for quality score severity */ const SEVERITY_BADGE_CLASSES = {
    good: 'bg-green-500/15 text-green-700 border-green-500/25 hover:bg-green-500/25 dark:text-green-400',
    fair: 'bg-yellow-500/15 text-yellow-700 border-yellow-500/25 hover:bg-yellow-500/25 dark:text-yellow-400',
    poor: 'bg-red-500/15 text-red-700 border-red-500/25 hover:bg-red-500/25 dark:text-red-400'
};
function buildColumns(scores, scoresLoading) {
    return [
        columnHelper.accessor('status', {
            header: '',
            cell: (info)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusIcon, {
                    status: info.getValue()
                }),
            size: 40,
            enableSorting: false
        }),
        columnHelper.accessor('eventID', {
            header: 'Event ID',
            cell: (info)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EventIDCell), {
                    eventID: info.getValue()
                }),
            size: 80
        }),
        columnHelper.accessor('clientName', {
            header: 'Client',
            cell: (info)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.ClientNameCell), {
                    clientID: info.row.original.clientID,
                    clientName: info.getValue()
                }),
            size: 180
        }),
        columnHelper.accessor('sessionStart', {
            header: 'Session Start',
            cell: (info)=>{
                const val = info.getValue();
                return val ? (0, _dateFns.format)(new Date(val), 'MMM d, yyyy HH:mm') : '-';
            },
            size: 160
        }),
        columnHelper.accessor('captionDuration', {
            header: 'Duration',
            cell: (info)=>formatDuration(info.getValue()),
            size: 100
        }),
        columnHelper.accessor('publishedAt', {
            header: 'Published',
            cell: (info)=>{
                const val = info.getValue();
                return val ? (0, _dateFns.format)(new Date(val), 'MMM d, HH:mm') : '-';
            },
            size: 130
        }),
        columnHelper.accessor('timeToCaptionSeconds', {
            header: 'Time to Caption',
            cell: (info)=>{
                const val = info.getValue();
                if (val === null) return '-';
                return formatDuration(val);
            },
            size: 130
        }),
        columnHelper.accessor('captionFileSize', {
            header: 'VTT Size',
            cell: (info)=>formatFileSize(info.getValue()),
            size: 100
        }),
        columnHelper.display({
            id: 'qualityScore',
            header: 'Quality',
            size: 80,
            enableSorting: false,
            cell: (info)=>{
                const row = info.row.original;
                if (row.status !== 'captioned' || !row.captionPath) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-muted-foreground",
                    children: "\u2014"
                });
                const score = scores[row.eventID];
                if (!score && scoresLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.Skeleton), {
                    className: "h-5 w-12"
                });
                if (!score) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-muted-foreground",
                    children: "\u2014"
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouter.Link), {
                    to: "/utilities/vtt-analyzer",
                    search: {
                        url: row.captionPath
                    },
                    onClick: (e)=>e.stopPropagation(),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                        variant: "outline",
                        className: `cursor-pointer ${SEVERITY_BADGE_CLASSES[score.severity]}`,
                        children: score.score
                    })
                });
            }
        }),
        columnHelper.display({
            id: 'eventLinks',
            header: 'Links',
            cell: (info)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.EventLinksCell), {
                    eventID: info.row.original.eventID,
                    clientID: info.row.original.clientID
                }),
            size: 70
        })
    ];
}
function CaptionJobsComponent() {
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    const navigate = (0, _reactRouter.useNavigate)();
    const { clientID, range = '24h', status: statusFilter, page = 1 } = (0, _reactRouter.useSearch)({
        from: '/monitoring/caption-jobs'
    });
    (0, _usePersistedSearch.usePersistedSearch)('/monitoring/caption-jobs', {
        clientID: undefined,
        range: '24h',
        status: undefined,
        page: undefined
    });
    const [data, setData] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    const [sorting, setSorting] = (0, _react.useState)([
        {
            id: 'sessionStart',
            desc: true
        }
    ]);
    const [scores, setScores] = (0, _react.useState)({});
    const [scoresLoading, setScoresLoading] = (0, _react.useState)(false);
    const [qualityFilter, setQualityFilter] = (0, _react.useState)(undefined);
    const loadData = (0, _react.useCallback)(async ()=>{
        try {
            setLoading(true);
            setError(null);
            const token = await getAccessTokenSilently();
            const { startDate, endDate } = getDateRange(range);
            const params = new URLSearchParams();
            if (clientID) params.set('clientID', clientID);
            if (statusFilter) params.set('status', statusFilter);
            params.set('startDate', startDate);
            params.set('endDate', endDate);
            params.set('page', String(page));
            params.set('limit', String((0, _captionJobs.CAPTION_JOBS_CONFIG).DEFAULT_LIMIT));
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/monitoring/caption-jobs?${params}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.status === 401) {
                logout({
                    logoutParams: {
                        returnTo: window.location.origin
                    }
                });
                return;
            }
            if (!response.ok) throw new Error(`API error: ${response.status}`);
            const result = await response.json();
            setData(result);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to load caption jobs');
        } finally{
            setLoading(false);
        }
    }, [
        getAccessTokenSilently,
        logout,
        clientID,
        range,
        statusFilter,
        page
    ]);
    const forceRefresh = (0, _react.useCallback)(async ()=>{
        const token = await getAccessTokenSilently();
        await fetch(`${(0, _config.API_BASE_URL)}/api/cache/invalidate`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                pattern: 'caption-jobs:*'
            })
        });
        loadData();
    }, [
        getAccessTokenSilently,
        loadData
    ]);
    (0, _react.useEffect)(()=>{
        loadData();
    }, [
        loadData
    ]);
    // Fetch quality scores for captioned rows on the current page
    (0, _react.useEffect)(()=>{
        if (!data?.jobs?.length) {
            setScores({});
            return;
        }
        const captionedJobs = data.jobs.filter((j)=>j.status === 'captioned' && j.captionPath);
        if (captionedJobs.length === 0) {
            setScores({});
            return;
        }
        let cancelled = false;
        const fetchScores = async ()=>{
            setScoresLoading(true);
            try {
                const token = await getAccessTokenSilently();
                const res = await fetch(`${(0, _config.API_BASE_URL)}/api/vtt/analyze-batch`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        items: captionedJobs.map((j)=>({
                                eventID: j.eventID,
                                captionPath: j.captionPath,
                                captionDuration: j.captionDuration
                            }))
                    })
                });
                if (res.ok && !cancelled) {
                    const result = await res.json();
                    setScores(result.scores);
                }
            } catch (err) {
                console.error('Failed to fetch VTT quality scores:', err);
            } finally{
                if (!cancelled) setScoresLoading(false);
            }
        };
        fetchScores();
        return ()=>{
            cancelled = true;
        };
    }, [
        data?.jobs,
        getAccessTokenSilently
    ]);
    const columns = (0, _react.useMemo)(()=>buildColumns(scores, scoresLoading), [
        scores,
        scoresLoading
    ]);
    // Apply client-side quality filter
    const filteredJobs = (0, _react.useMemo)(()=>{
        const jobs = data?.jobs ?? [];
        if (!qualityFilter) return jobs;
        return jobs.filter((job)=>{
            const score = scores[job.eventID];
            return score?.severity === qualityFilter;
        });
    }, [
        data?.jobs,
        qualityFilter,
        scores
    ]);
    const table = (0, _reactTable.useReactTable)({
        data: filteredJobs,
        columns,
        state: {
            sorting
        },
        onSortingChange: setSorting,
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        getSortedRowModel: (0, _reactTable.getSortedRowModel)()
    });
    const updateSearch = (updates)=>{
        navigate({
            to: '/monitoring/caption-jobs',
            search: {
                clientID: 'clientID' in updates ? updates.clientID : clientID,
                range: 'range' in updates ? updates.range : range,
                status: 'status' in updates ? updates.status : statusFilter,
                // Reset page when filters change (unless page is being set explicitly)
                page: 'page' in updates ? updates.page : 1
            }
        });
    };
    const hasFilters = clientID || statusFilter || range !== '24h' || qualityFilter;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    className: "text-2xl font-bold",
                                    children: "Live Caption Jobs"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-sm text-muted-foreground",
                                    children: "Monitor AI caption generation for published events"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cacheTimestamp.CacheTimestamp), {
                                    cachedAt: data?.cacheInfo?.cachedAt ?? null
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    variant: "ghost",
                                    size: "icon",
                                    title: "Force refresh",
                                    onClick: ()=>forceRefresh(),
                                    disabled: loading,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                        className: `h-4 w-4 ${loading ? 'animate-spin' : ''}`
                                    })
                                })
                            ]
                        })
                    ]
                }),
                data?.summary && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "grid grid-cols-3 gap-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            onClick: ()=>updateSearch({
                                    status: statusFilter === 'captioned' ? undefined : 'captioned'
                                }),
                            className: `rounded-lg border p-3 text-left transition-colors hover:bg-accent ${statusFilter === 'captioned' ? 'ring-2 ring-ring' : ''}`,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-sm text-muted-foreground",
                                    children: "Captioned"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-2xl font-bold",
                                    children: data.summary.captioned
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            onClick: ()=>updateSearch({
                                    status: statusFilter === 'missing' ? undefined : 'missing'
                                }),
                            className: `rounded-lg border p-3 text-left transition-colors hover:bg-accent ${statusFilter === 'missing' ? 'ring-2 ring-ring' : ''} ${data.summary.missing > 0 ? 'border-destructive' : ''}`,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-sm text-muted-foreground",
                                    children: "Missing"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: `text-2xl font-bold ${data.summary.missing > 0 ? 'text-destructive' : ''}`,
                                    children: data.summary.missing
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            onClick: ()=>updateSearch({
                                    status: statusFilter === 'pending' ? undefined : 'pending'
                                }),
                            className: `rounded-lg border p-3 text-left transition-colors hover:bg-accent ${statusFilter === 'pending' ? 'ring-2 ring-ring' : ''}`,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-sm text-muted-foreground",
                                    children: "Pending"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-2xl font-bold",
                                    children: data.summary.pending
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center gap-2 flex-wrap",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenu), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuTrigger), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                        variant: "outline",
                                        size: "sm",
                                        children: [
                                            range,
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                className: "ml-2 h-4 w-4"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuContent), {
                                    children: QUICK_RANGES.map((r)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                            onClick: ()=>updateSearch({
                                                    range: r.label
                                                }),
                                            children: r.label
                                        }, r.label))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenu), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuTrigger), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                        variant: "outline",
                                        size: "sm",
                                        children: [
                                            statusFilter ? STATUS_CONFIG[statusFilter].label : 'All Statuses',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                className: "ml-2 h-4 w-4"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenuContent), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                            onClick: ()=>updateSearch({
                                                    status: undefined
                                                }),
                                            children: "All Statuses"
                                        }),
                                        Object.keys(STATUS_CONFIG).map((s)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                onClick: ()=>updateSearch({
                                                        status: s
                                                    }),
                                                children: STATUS_CONFIG[s].label
                                            }, s))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenu), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuTrigger), {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                        variant: "outline",
                                        size: "sm",
                                        disabled: scoresLoading && Object.keys(scores).length === 0,
                                        children: [
                                            qualityFilter ? `Quality: ${qualityFilter.charAt(0).toUpperCase() + qualityFilter.slice(1)}` : 'All Qualities',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                className: "ml-2 h-4 w-4"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenuContent), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                            onClick: ()=>setQualityFilter(undefined),
                                            children: "All Qualities"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenuItem), {
                                            onClick: ()=>setQualityFilter('good'),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "mr-2 h-2 w-2 rounded-full bg-green-500 inline-block"
                                                }),
                                                "Good (80-100)"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenuItem), {
                                            onClick: ()=>setQualityFilter('fair'),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "mr-2 h-2 w-2 rounded-full bg-yellow-500 inline-block"
                                                }),
                                                "Fair (50-79)"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenuItem), {
                                            onClick: ()=>setQualityFilter('poor'),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "mr-2 h-2 w-2 rounded-full bg-red-500 inline-block"
                                                }),
                                                "Poor (0-49)"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "ml-auto flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientSelector.ClientSelector), {
                                    value: clientID ?? '',
                                    onChange: (id, _client)=>updateSearch({
                                            clientID: id || undefined
                                        }),
                                    label: "",
                                    className: "min-w-[250px]"
                                }),
                                hasFilters && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    onClick: ()=>setQualityFilter(undefined),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetFiltersButton.ResetFiltersButton), {
                                        routePath: "/monitoring/caption-jobs",
                                        defaultValues: {
                                            clientID: undefined,
                                            range: '24h',
                                            status: undefined
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                    variant: "outline",
                                    size: "sm",
                                    onClick: loadData,
                                    disabled: loading,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                            className: `h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`
                                        }),
                                        "Refresh"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "rounded-lg border border-destructive p-4 text-destructive",
                    children: error
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "rounded-md border",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                        children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableHead), {
                                                className: "cursor-pointer select-none",
                                                onClick: header.column.getToggleSortingHandler(),
                                                style: {
                                                    width: header.getSize()
                                                },
                                                children: [
                                                    (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext()),
                                                    header.column.getIsSorted() === 'asc' ? ' \u2191' : header.column.getIsSorted() === 'desc' ? ' \u2193' : ''
                                                ]
                                            }, header.id))
                                    }, headerGroup.id))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                children: loading && !data ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                        colSpan: columns.length,
                                        className: "text-center py-8 text-muted-foreground",
                                        children: "Loading..."
                                    })
                                }) : table.getRowModel().rows.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                        colSpan: columns.length,
                                        className: "text-center py-8 text-muted-foreground",
                                        children: "No caption jobs found for the selected filters"
                                    })
                                }) : table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                        className: "cursor-pointer hover:bg-muted",
                                        onClick: ()=>navigate({
                                                to: '/events/$eventId',
                                                params: {
                                                    eventId: row.original.eventID
                                                }
                                            }),
                                        children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                style: {
                                                    width: cell.column.getSize()
                                                },
                                                children: (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                            }, cell.id))
                                    }, row.id))
                            })
                        ]
                    })
                }),
                data?.pagination && data.pagination.totalPages > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "text-sm text-muted-foreground",
                            children: [
                                "Page ",
                                data.pagination.page,
                                " of ",
                                data.pagination.totalPages,
                                " (",
                                data.pagination.totalCount,
                                " total)"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.Pagination), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pagination.PaginationContent), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.PaginationItem), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            variant: "outline",
                                            size: "sm",
                                            disabled: page <= 1,
                                            onClick: ()=>updateSearch({
                                                    page: page - 1
                                                }),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronLeft), {
                                                className: "h-4 w-4"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.PaginationItem), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            variant: "outline",
                                            size: "sm",
                                            disabled: page >= data.pagination.totalPages,
                                            onClick: ()=>updateSearch({
                                                    page: page + 1
                                                }),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                                                className: "h-4 w-4"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["Link","7k6Lq"],["redirect","jmFxY"],["useNavigate","aMhxM"],["useSearch","4yVFL"]],"@auth0/auth0-react":"gpXrE","@tanstack/react-table":[["createColumnHelper","3MlnA"],["getCoreRowModel","3MlnA"],["getSortedRowModel","3MlnA"],["flexRender","brwh1"],["useReactTable","brwh1"]],"date-fns":"4NYjc","../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/hooks/usePersistedSearch":"kPA60","@/client/components/reset-filters-button":"9d8BP","@/client/components/client-selector":"gxoYe","@/client/components/cache-timestamp":"f5Zyx","@/client/components/tables/cells":"5BSEg","@/client/config":"8SWgh","@shared/types/captionJobs":"1j7E5","@/client/components/ui/table":"5vxZ8","@/client/components/ui/button":"armlb","@/client/components/ui/badge":"h4e1f","@/client/components/ui/skeleton":"bIzUl","@/client/components/ui/dropdown-menu":"8ox96","@/client/components/ui/pagination":"0uRki","lucide-react":[["AlertTriangle","cdePa","default"],["CheckCircle","2O3dV","default"],["ChevronDown","kVmgC","default"],["ChevronLeft","gT7FB","default"],["ChevronRight","lOb49","default"],["Circle","lGLGY","default"],["RefreshCw","7a8jT","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"92SBh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _reactTable = require("@tanstack/react-table");
var _dateFns = require("date-fns");
var _root = require("../__root");
var _layout = require("@/client/layouts/layout");
var _usePersistedSearch = require("@/client/hooks/usePersistedSearch");
var _resetFiltersButton = require("@/client/components/reset-filters-button");
var _clientSelector = require("@/client/components/client-selector");
var _cacheTimestamp = require("@/client/components/cache-timestamp");
var _cells = require("@/client/components/tables/cells");
var _config = require("@/client/config");
var _utils = require("@/client/lib/utils");
var _webhookLogs = require("@shared/types/webhookLogs");
var _table = require("@/client/components/ui/table");
var _button = require("@/client/components/ui/button");
var _badge = require("@/client/components/ui/badge");
var _input = require("@/client/components/ui/input");
var _jsonSyntaxHighlight = require("@/client/components/ui/json-syntax-highlight");
var _dialog = require("@/client/components/ui/dialog");
var _dropdownMenu = require("@/client/components/ui/dropdown-menu");
var _pagination = require("@/client/components/ui/pagination");
var _lucideReact = require("lucide-react");
const DEFAULT_RANGE = '24h';
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'monitoring/webhook-logs',
    validateSearch: (search)=>{
        return {
            clientID: typeof search.clientID === 'string' ? search.clientID : undefined,
            range: typeof search.range === 'string' ? search.range : undefined,
            status: typeof search.status === 'string' ? search.status : undefined,
            eventID: typeof search.eventID === 'string' ? search.eventID : undefined,
            page: typeof search.page === 'number' ? search.page : undefined
        };
    },
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: WebhookLogsComponent
});
const STATUS_CONFIG = {
    ok: {
        label: 'OK',
        icon: (0, _lucideReact.CheckCircle),
        className: 'text-green-500'
    },
    error: {
        label: 'Error',
        icon: (0, _lucideReact.AlertTriangle),
        className: 'text-destructive'
    }
};
function StatusIcon({ status }) {
    const config = STATUS_CONFIG[status];
    const Icon = config.icon;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        title: config.label,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
            className: `h-4 w-4 ${config.className}`
        })
    });
}
/** Human-readable payload size */ function formatPayloadSize(chars) {
    if (chars === 0) return '0';
    if (chars < 1024) return `${chars} B`;
    return `${(chars / 1024).toFixed(1)} KB`;
}
/** Copy-to-clipboard button that doesn't render the value it copies */ function CopyButton({ value, label = 'Copy', disabled = false, className }) {
    const [copied, setCopied] = (0, _react.useState)(false);
    const handleCopy = (0, _react.useCallback)((e)=>{
        e.stopPropagation();
        if (!value) return;
        navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(()=>setCopied(false), 2000);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
        variant: "outline",
        size: "sm",
        onClick: handleCopy,
        disabled: disabled || !value,
        className: className,
        title: label,
        children: [
            copied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {
                className: "h-3.5 w-3.5 mr-1.5 text-green-500"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Copy), {
                className: "h-3.5 w-3.5 mr-1.5"
            }),
            copied ? 'Copied' : label
        ]
    });
}
/** Truncated single-line payload preview — full value lives in the detail dialog */ function PayloadPreviewCell({ preview, length }) {
    if (!preview || length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "text-xs text-muted-foreground",
        children: "-"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-0.5 min-w-0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-mono text-xs truncate block max-w-[280px] text-muted-foreground",
                children: preview.slice(0, 120)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-[10px] text-muted-foreground/70",
                children: formatPayloadSize(length)
            })
        ]
    });
}
const columnHelper = (0, _reactTable.createColumnHelper)();
const columns = [
    columnHelper.accessor('status', {
        header: '',
        cell: (info)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusIcon, {
                status: info.getValue()
            }),
        size: 40,
        enableSorting: false
    }),
    columnHelper.accessor('timeStamp', {
        header: 'Timestamp',
        cell: (info)=>{
            const val = info.getValue();
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-xs whitespace-nowrap",
                children: val ? (0, _dateFns.format)(new Date(val), 'MMM d, yyyy HH:mm:ss') : '-'
            });
        },
        size: 170
    }),
    columnHelper.accessor('clientName', {
        header: 'Client',
        cell: (info)=>{
            const row = info.row.original;
            const name = info.getValue();
            if (!name) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-mono text-xs text-muted-foreground",
                children: row.clientID
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cells.ClientNameCell), {
                clientID: row.clientID,
                clientName: name
            });
        },
        size: 170
    }),
    columnHelper.accessor('eventID', {
        header: 'Event ID',
        cell: (info)=>{
            const val = info.getValue();
            return val ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-mono text-xs",
                children: val
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-xs text-muted-foreground",
                children: "-"
            });
        },
        size: 100
    }),
    columnHelper.accessor('callback', {
        header: 'Callback',
        cell: (info)=>{
            const val = info.getValue();
            if (!val) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "text-xs text-muted-foreground",
                children: "-"
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "font-mono text-xs truncate block max-w-[240px]",
                title: val,
                children: val
            });
        },
        size: 240
    }),
    columnHelper.display({
        id: 'result',
        header: 'Result',
        size: 220,
        cell: (info)=>{
            const row = info.row.original;
            if (row.status === 'error') return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    row.errorCode !== null && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                        variant: "outline",
                        className: "border-destructive/40 text-destructive",
                        children: row.errorCode
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-xs text-destructive truncate max-w-[160px]",
                        title: row.errorMessage ?? '',
                        children: row.errorMessage ?? 'Error'
                    })
                ]
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PayloadPreviewCell, {
                preview: row.returnPreview,
                length: row.returnLength
            });
        }
    }),
    columnHelper.display({
        id: 'inputValue',
        header: 'Payload',
        size: 300,
        cell: (info)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(PayloadPreviewCell, {
                preview: info.row.original.inputPreview,
                length: info.row.original.inputLength
            })
    })
];
// ============================================================================
// Detail Dialog
// ============================================================================
function PayloadBlock({ title, value, length }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                className: "text-sm font-medium",
                                children: title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-xs text-muted-foreground",
                                children: formatPayloadSize(length)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CopyButton, {
                        value: value,
                        label: "Copy"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "rounded-md border bg-muted/30 p-3 max-h-[280px] overflow-auto",
                children: value ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsonSyntaxHighlight.JsonSyntaxHighlight), {
                    json: value,
                    className: "text-xs font-mono leading-relaxed"
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-xs text-muted-foreground",
                    children: "Empty"
                })
            })
        ]
    });
}
function WebhookLogDetailDialog({ webhookIdx, onClose }) {
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    const [detail, setDetail] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        if (webhookIdx === null) {
            setDetail(null);
            setError(null);
            return;
        }
        let cancelled = false;
        const load = async ()=>{
            setLoading(true);
            setError(null);
            try {
                const token = await getAccessTokenSilently();
                const response = await fetch(`${(0, _config.API_BASE_URL)}/api/monitoring/webhook-logs/${webhookIdx}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (response.status === 401) {
                    logout({
                        logoutParams: {
                            returnTo: window.location.origin
                        }
                    });
                    return;
                }
                if (!response.ok) throw new Error(`API error: ${response.status}`);
                const result = await response.json();
                if (!cancelled) setDetail(result.log);
            } catch (err) {
                if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load webhook log');
            } finally{
                if (!cancelled) setLoading(false);
            }
        };
        load();
        return ()=>{
            cancelled = true;
        };
    }, [
        webhookIdx,
        getAccessTokenSilently,
        logout
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
        open: webhookIdx !== null,
        onOpenChange: (open)=>!open && onClose(),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.DialogContent), {
            className: "max-w-4xl",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.DialogHeader), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialog.DialogTitle), {
                            className: "flex items-center gap-2",
                            children: [
                                detail && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StatusIcon, {
                                    status: detail.status
                                }),
                                "Webhook Log #",
                                webhookIdx
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.DialogDescription), {
                            children: detail?.timeStamp ? (0, _dateFns.format)(new Date(detail.timeStamp), 'MMM d, yyyy HH:mm:ss') : 'Full request and response payloads'
                        })
                    ]
                }),
                loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "py-8 text-center text-muted-foreground",
                    children: "Loading..."
                }),
                error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "rounded-lg border border-destructive p-4 text-destructive text-sm",
                    children: error
                }),
                detail && !loading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "grid grid-cols-2 gap-3 text-sm",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-xs text-muted-foreground",
                                            children: "Client"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            children: [
                                                detail.clientName ?? "\u2014",
                                                ' ',
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-mono text-xs text-muted-foreground",
                                                    children: detail.clientID
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-xs text-muted-foreground",
                                            children: "Event ID"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "font-mono text-xs",
                                            children: detail.eventID ?? "\u2014"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "col-span-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-xs text-muted-foreground",
                                            children: "Callback"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "font-mono text-xs break-all",
                                                    children: detail.callback ?? "\u2014"
                                                }),
                                                detail.callback && /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                    href: detail.callback,
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    className: "text-muted-foreground hover:text-foreground flex-shrink-0",
                                                    title: "Open callback URL",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ExternalLink), {
                                                        className: "h-3.5 w-3.5"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                detail.status === 'error' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "col-span-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "text-xs text-muted-foreground",
                                            children: "Error"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "text-sm text-destructive",
                                            children: [
                                                detail.errorCode !== null && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
                                                    variant: "outline",
                                                    className: "mr-2 border-destructive/40 text-destructive",
                                                    children: detail.errorCode
                                                }),
                                                detail.errorMessage
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(PayloadBlock, {
                            title: "Request Payload (inputValue)",
                            value: detail.inputValue,
                            length: detail.inputLength
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(PayloadBlock, {
                            title: "Response (returnValue)",
                            value: detail.returnValue,
                            length: detail.returnLength
                        })
                    ]
                })
            ]
        })
    });
}
// ============================================================================
// Route Component
// ============================================================================
function WebhookLogsComponent() {
    const { getAccessTokenSilently, logout } = (0, _auth0React.useAuth0)();
    const navigate = (0, _reactRouter.useNavigate)();
    const { clientID, range = DEFAULT_RANGE, status: statusFilter, eventID, page = 1 } = (0, _reactRouter.useSearch)({
        from: '/monitoring/webhook-logs'
    });
    (0, _usePersistedSearch.usePersistedSearch)('/monitoring/webhook-logs', {
        clientID: undefined,
        range: DEFAULT_RANGE,
        status: undefined,
        eventID: undefined,
        page: undefined
    });
    const [data, setData] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    const [sorting, setSorting] = (0, _react.useState)([]);
    const [detailIdx, setDetailIdx] = (0, _react.useState)(null);
    const [eventIDInput, setEventIDInput] = (0, _react.useState)(eventID ?? '');
    const hours = (0, _react.useMemo)(()=>(0, _webhookLogs.WEBHOOK_LOG_RANGES).find((r)=>r.label === range)?.hours ?? (0, _webhookLogs.WEBHOOK_LOG_RANGES)[0].hours, [
        range
    ]);
    const updateSearch = (0, _react.useCallback)((updates)=>{
        navigate({
            to: '/monitoring/webhook-logs',
            search: {
                clientID: 'clientID' in updates ? updates.clientID : clientID,
                range: 'range' in updates ? updates.range : range,
                status: 'status' in updates ? updates.status : statusFilter,
                eventID: 'eventID' in updates ? updates.eventID : eventID,
                // Reset page when filters change (unless page is being set explicitly)
                page: 'page' in updates ? updates.page : 1
            }
        });
    }, [
        navigate,
        clientID,
        range,
        statusFilter,
        eventID
    ]);
    // Keep the local input in sync when the search param changes elsewhere (reset, back nav)
    (0, _react.useEffect)(()=>{
        setEventIDInput(eventID ?? '');
    }, [
        eventID
    ]);
    // Debounce eventID typing into the URL
    (0, _react.useEffect)(()=>{
        const trimmed = eventIDInput.trim();
        if (trimmed === (eventID ?? '')) return;
        const timer = setTimeout(()=>{
            updateSearch({
                eventID: trimmed || undefined
            });
        }, 500);
        return ()=>clearTimeout(timer);
    }, [
        eventIDInput,
        eventID,
        updateSearch
    ]);
    const loadData = (0, _react.useCallback)(async ()=>{
        try {
            setLoading(true);
            setError(null);
            const token = await getAccessTokenSilently();
            const params = new URLSearchParams();
            if (clientID) params.set('clientID', clientID);
            if (statusFilter) params.set('status', statusFilter);
            if (eventID) params.set('eventID', eventID);
            params.set('hours', String(hours));
            params.set('page', String(page));
            params.set('limit', String((0, _webhookLogs.WEBHOOK_LOGS_CONFIG).DEFAULT_LIMIT));
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/monitoring/webhook-logs?${params}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.status === 401) {
                logout({
                    logoutParams: {
                        returnTo: window.location.origin
                    }
                });
                return;
            }
            if (!response.ok) throw new Error(`API error: ${response.status}`);
            const result = await response.json();
            setData(result);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to load webhook logs');
        } finally{
            setLoading(false);
        }
    }, [
        getAccessTokenSilently,
        logout,
        clientID,
        statusFilter,
        eventID,
        hours,
        page
    ]);
    const forceRefresh = (0, _react.useCallback)(async ()=>{
        const token = await getAccessTokenSilently();
        await fetch(`${(0, _config.API_BASE_URL)}/api/cache/invalidate`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                pattern: 'webhook-logs:*'
            })
        });
        loadData();
    }, [
        getAccessTokenSilently,
        loadData
    ]);
    (0, _react.useEffect)(()=>{
        loadData();
    }, [
        loadData
    ]);
    const table = (0, _reactTable.useReactTable)({
        data: data?.logs ?? [],
        columns,
        state: {
            sorting
        },
        onSortingChange: setSorting,
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        getSortedRowModel: (0, _reactTable.getSortedRowModel)()
    });
    const summary = data?.summary;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Layout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        className: "text-2xl font-bold",
                                        children: "Webhook Logs"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "text-sm text-muted-foreground",
                                        children: "Read-only view of webhook delivery attempts and failures"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cacheTimestamp.CacheTimestamp), {
                                        cachedAt: data?.cacheInfo?.cachedAt ?? null
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        variant: "ghost",
                                        size: "icon",
                                        title: "Force refresh",
                                        onClick: ()=>forceRefresh(),
                                        disabled: loading,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                            className: `h-4 w-4 ${loading ? 'animate-spin' : ''}`
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    summary && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "grid grid-cols-3 gap-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                onClick: ()=>updateSearch({
                                        status: undefined
                                    }),
                                className: (0, _utils.cn)('rounded-lg border p-3 text-left transition-colors hover:bg-accent', !statusFilter && 'ring-2 ring-ring'),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-muted-foreground",
                                        children: "Total"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-2xl font-bold",
                                        children: summary.total
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                onClick: ()=>updateSearch({
                                        status: statusFilter === 'ok' ? undefined : 'ok'
                                    }),
                                className: (0, _utils.cn)('rounded-lg border p-3 text-left transition-colors hover:bg-accent', statusFilter === 'ok' && 'ring-2 ring-ring'),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-muted-foreground",
                                        children: "OK"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-2xl font-bold text-green-600 dark:text-green-500",
                                        children: summary.ok
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                onClick: ()=>updateSearch({
                                        status: statusFilter === 'error' ? undefined : 'error'
                                    }),
                                className: (0, _utils.cn)('rounded-lg border p-3 text-left transition-colors hover:bg-accent', statusFilter === 'error' && 'ring-2 ring-ring', summary.error > 0 && 'border-destructive'),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "text-sm text-muted-foreground",
                                        children: "Error"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: (0, _utils.cn)('text-2xl font-bold', summary.error > 0 && 'text-destructive'),
                                        children: summary.error
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center gap-2 flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenu), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuTrigger), {
                                        asChild: true,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            variant: "outline",
                                            size: "sm",
                                            children: [
                                                range,
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                    className: "ml-2 h-4 w-4"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuContent), {
                                        children: (0, _webhookLogs.WEBHOOK_LOG_RANGES).map((r)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                onClick: ()=>updateSearch({
                                                        range: r.label
                                                    }),
                                                children: r.label
                                            }, r.label))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenu), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuTrigger), {
                                        asChild: true,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                            variant: "outline",
                                            size: "sm",
                                            children: [
                                                statusFilter ? STATUS_CONFIG[statusFilter].label : 'All Statuses',
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                                                    className: "ml-2 h-4 w-4"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dropdownMenu.DropdownMenuContent), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                onClick: ()=>updateSearch({
                                                        status: undefined
                                                    }),
                                                children: "All Statuses"
                                            }),
                                            Object.keys(STATUS_CONFIG).map((s)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownMenu.DropdownMenuItem), {
                                                    onClick: ()=>updateSearch({
                                                            status: s
                                                        }),
                                                    children: STATUS_CONFIG[s].label
                                                }, s))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "ml-auto flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientSelector.ClientSelector), {
                                        value: clientID ?? '',
                                        onChange: (id)=>updateSearch({
                                                clientID: id || undefined
                                            }),
                                        label: "",
                                        className: "min-w-[250px]"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _input.Input), {
                                        value: eventIDInput,
                                        onChange: (e)=>setEventIDInput(e.target.value),
                                        placeholder: "Event ID",
                                        className: "h-9 w-[150px]"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetFiltersButton.ResetFiltersButton), {
                                        routePath: "/monitoring/webhook-logs",
                                        defaultValues: {
                                            clientID: undefined,
                                            range: DEFAULT_RANGE,
                                            status: undefined,
                                            eventID: undefined
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                        variant: "outline",
                                        size: "sm",
                                        onClick: loadData,
                                        disabled: loading,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.RefreshCw), {
                                                className: `h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`
                                            }),
                                            "Refresh"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rounded-lg border border-destructive p-4 text-destructive",
                        children: error
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rounded-md border",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableHeader), {
                                    children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                            children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableHead), {
                                                    className: "cursor-pointer select-none",
                                                    onClick: header.column.getToggleSortingHandler(),
                                                    style: {
                                                        width: header.getSize()
                                                    },
                                                    children: [
                                                        (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext()),
                                                        header.column.getIsSorted() === 'asc' ? " \u2191" : header.column.getIsSorted() === 'desc' ? " \u2193" : ''
                                                    ]
                                                }, header.id))
                                        }, headerGroup.id))
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                                    children: loading && !data ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                            colSpan: columns.length,
                                            className: "text-center py-8 text-muted-foreground",
                                            children: "Loading..."
                                        })
                                    }) : table.getRowModel().rows.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                            colSpan: columns.length,
                                            className: "text-center py-8 text-muted-foreground",
                                            children: "No webhook logs found for the selected filters"
                                        })
                                    }) : table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableRow), {
                                            className: "cursor-pointer hover:bg-muted",
                                            onClick: ()=>setDetailIdx(row.original.webhookIdx),
                                            children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableCell), {
                                                    style: {
                                                        width: cell.column.getSize()
                                                    },
                                                    children: (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                                }, cell.id))
                                        }, row.id))
                                })
                            ]
                        })
                    }),
                    data?.pagination && data.pagination.totalPages > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "text-sm text-muted-foreground",
                                children: [
                                    "Page ",
                                    data.pagination.page,
                                    " of ",
                                    data.pagination.totalPages,
                                    " (",
                                    data.pagination.totalCount,
                                    " total)"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.Pagination), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pagination.PaginationContent), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.PaginationItem), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                variant: "outline",
                                                size: "sm",
                                                disabled: page <= 1,
                                                onClick: ()=>updateSearch({
                                                        page: page - 1
                                                    }),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronLeft), {
                                                    className: "h-4 w-4"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.PaginationItem), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                variant: "outline",
                                                size: "sm",
                                                disabled: page >= data.pagination.totalPages,
                                                onClick: ()=>updateSearch({
                                                        page: page + 1
                                                    }),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {
                                                    className: "h-4 w-4"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(WebhookLogDetailDialog, {
                webhookIdx: detailIdx,
                onClose: ()=>setDetailIdx(null)
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useNavigate","aMhxM"],["useSearch","4yVFL"]],"@auth0/auth0-react":"gpXrE","@tanstack/react-table":[["createColumnHelper","3MlnA"],["getCoreRowModel","3MlnA"],["getSortedRowModel","3MlnA"],["flexRender","brwh1"],["useReactTable","brwh1"]],"date-fns":"4NYjc","../__root":"enXay","@/client/layouts/layout":"d6QdD","@/client/hooks/usePersistedSearch":"kPA60","@/client/components/reset-filters-button":"9d8BP","@/client/components/client-selector":"gxoYe","@/client/components/cache-timestamp":"f5Zyx","@/client/components/tables/cells":"5BSEg","@/client/config":"8SWgh","@/client/lib/utils":"1ankz","@shared/types/webhookLogs":"6kaS8","@/client/components/ui/table":"5vxZ8","@/client/components/ui/button":"armlb","@/client/components/ui/badge":"h4e1f","@/client/components/ui/input":"8UHwi","@/client/components/ui/json-syntax-highlight":"cBuOL","@/client/components/ui/dialog":"6jjic","@/client/components/ui/dropdown-menu":"8ox96","@/client/components/ui/pagination":"0uRki","lucide-react":[["AlertTriangle","cdePa","default"],["Check","bajJU","default"],["CheckCircle","2O3dV","default"],["ChevronDown","kVmgC","default"],["ChevronLeft","gT7FB","default"],["ChevronRight","lOb49","default"],["Copy","jM41N","default"],["ExternalLink","kIIQA","default"],["RefreshCw","7a8jT","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"dAXMa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Route", ()=>Route);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouter = require("@tanstack/react-router");
var _auth0React = require("@auth0/auth0-react");
var _root = require("../__root");
var _config = require("@/client/config");
var _streamDetailView = require("@/client/components/stream-detail-view");
var _captionPipelineCard = require("@/client/components/caption-pipeline-card");
var _simulcastTargetsCard = require("@/client/components/simulcast-targets-card");
var _format = require("@/client/lib/format");
var _layout = require("@/client/layouts/layout");
var _detailView = require("@/client/components/ui/detail-view");
var _button = require("@/client/components/ui/button");
var _lucideReact = require("lucide-react");
const Route = (0, _reactRouter.createRoute)({
    getParentRoute: ()=>(0, _root.Route),
    path: 'events/$eventId',
    beforeLoad: async ({ context })=>{
        if (!context.auth.isAuthenticated) throw (0, _reactRouter.redirect)({
            to: '/'
        });
    },
    component: EventDetailComponent
});
function EventDetailComponent() {
    const { eventId } = (0, _reactRouter.useParams)({
        from: '/events/$eventId'
    });
    const { getAccessTokenSilently } = (0, _auth0React.useAuth0)();
    const [eventData, setEventData] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(null);
    // Parse clientID and eventID from composite eventId
    const [clientID, eventID] = (0, _react.useMemo)(()=>{
        const parts = eventId.split('_');
        if (parts.length >= 2) return [
            parts[0],
            parts.slice(1).join('_')
        ];
        return [
            null,
            eventId
        ];
    }, [
        eventId
    ]);
    const fetchEventDetails = async ()=>{
        if (!clientID || !eventID) {
            setError('Invalid event ID');
            setLoading(false);
            return;
        }
        try {
            setLoading(true);
            setError(null);
            const token = await getAccessTokenSilently();
            const response = await fetch(`${(0, _config.API_BASE_URL)}/api/events/${clientID}/${eventID}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) {
                setError(response.status === 404 ? 'Event not found' : 'Failed to load event details');
                setLoading(false);
                return;
            }
            const data = await response.json();
            setEventData(data);
        } catch (err) {
            console.error('Error fetching event details:', err);
            setError('Failed to load event details');
        } finally{
            setLoading(false);
        }
    };
    (0, _react.useEffect)(()=>{
        fetchEventDetails();
    }, [
        clientID,
        eventID,
        getAccessTokenSilently
    ]);
    // Transform API response to StreamDetailData format
    const stream = (0, _react.useMemo)(()=>{
        if (!eventData) return null;
        const isLive = [
            'live',
            'starting',
            'on break',
            'stopping'
        ].includes(eventData.status);
        return {
            clientID: eventData.clientID,
            clientName: eventData.clientName,
            eventID: eventData.eventID,
            eventTitle: eventData.eventTitle,
            status: eventData.status,
            streamStatus: eventData.streamStatus,
            eventStartDateTime: eventData.eventStartDateTime,
            eventEndDateTime: eventData.eventEndDateTime,
            startDateTime: eventData.startDateTime,
            endDateTime: null,
            autoStart: eventData.autoStart,
            autoStop: eventData.autoStop,
            preroll: eventData.preroll,
            customID: eventData.customID,
            description: eventData.description,
            notes: eventData.notes,
            private: eventData.private,
            liveToBreak: eventData.liveToBreak,
            encoderID: eventData.encoderID,
            liveID: eventData.liveID,
            ingInstanceID: eventData.ingInstanceID,
            egInstanceID: eventData.egInstanceID,
            wcStreamID: eventData.wcStreamID,
            streamingURIs: clientID && eventID ? (0, _format.generateStreamingURIs)(clientID, eventID) : null
        };
    }, [
        eventData,
        clientID,
        eventID
    ]);
    const isLiveStream = eventData ? [
        'live',
        'starting',
        'on break',
        'stopping'
    ].includes(eventData.status) : false;
    // Loading state
    if (loading && !eventData) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Layout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailHeader), {
                title: "Loading...",
                backTo: "/monitoring/caption-jobs",
                backLabel: "Back"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "rounded-lg border p-8 text-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Loader2), {
                        className: "h-8 w-8 animate-spin mx-auto text-muted-foreground"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-muted-foreground mt-4",
                        children: "Loading event data..."
                    })
                ]
            })
        ]
    });
    // Error / not found
    if (error && !eventData) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _layout.Layout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailHeader), {
                title: "Event Not Found",
                backTo: "/monitoring/caption-jobs",
                backLabel: "Back"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "rounded-lg border p-8 text-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-muted-foreground mb-4",
                        children: error
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        variant: "outline",
                        onClick: ()=>window.history.back(),
                        children: "Go back"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _streamDetailView.StreamDetailView), {
        stream: stream,
        loading: loading,
        backTo: "/monitoring/caption-jobs",
        backLabel: "Back",
        onRefresh: fetchEventDetails,
        streamId: eventId,
        isLiveStream: isLiveStream,
        hasAiCaptions: eventData?.captionPipeline !== null && eventData?.captionPipeline !== undefined,
        extraCards: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                eventData?.captionPipeline && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _captionPipelineCard.CaptionPipelineCard), {
                    pipeline: eventData.captionPipeline,
                    isLive: isLiveStream
                }),
                eventData?.simulcastTargets && eventData.simulcastTargets.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simulcastTargetsCard.SimulcastTargetsCard), {
                    targets: eventData.simulcastTargets
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dQjte","react":"eGun2","@tanstack/react-router":[["createRoute","hPO6R"],["redirect","jmFxY"],["useParams","jBvHB"]],"@auth0/auth0-react":"gpXrE","../__root":"enXay","@/client/config":"8SWgh","@/client/components/stream-detail-view":"j7NNO","@/client/components/caption-pipeline-card":"gb5AR","@/client/components/simulcast-targets-card":"iSH28","@/client/lib/format":"iLptT","@/client/layouts/layout":"d6QdD","@/client/components/ui/detail-view":"5pGcz","@/client/components/ui/button":"armlb","lucide-react":[["Loader2","gZHhk","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"gb5AR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CaptionPipelineCard", ()=>CaptionPipelineCard);
var _jsxRuntime = require("react/jsx-runtime");
var _dateFns = require("date-fns");
var _lucideReact = require("lucide-react");
var _reactRouter = require("@tanstack/react-router");
var _format = require("@/client/lib/format");
var _button = require("@/client/components/ui/button");
var _detailView = require("@/client/components/ui/detail-view");
function StepStatus({ ok, label }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: `inline-flex items-center gap-1 text-sm ${ok ? 'text-green-500' : 'text-destructive'}`,
        children: [
            ok ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CheckCircle), {
                className: "h-3.5 w-3.5"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XCircle), {
                className: "h-3.5 w-3.5"
            }),
            label
        ]
    });
}
function PendingStatus({ label }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "inline-flex items-center gap-1 text-sm text-muted-foreground",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Clock), {
                className: "h-3.5 w-3.5"
            }),
            label
        ]
    });
}
function CaptionPipelineCard({ pipeline, isLive = false }) {
    const sessionEnded = [
        'ended',
        'end',
        'End of Transcribe'
    ].includes(pipeline.leacStatus ?? '');
    const isPublished = pipeline.publishedAt !== null;
    const hasVtt = pipeline.captionVtt.exists;
    // Compute time since publish for missing captions
    let timeSincePublish = null;
    if (isPublished && !hasVtt && pipeline.publishedAt) timeSincePublish = (0, _dateFns.formatDistanceStrict)(new Date(pipeline.publishedAt), new Date(), {
        addSuffix: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailView.DetailCard), {
        title: "Caption Pipeline",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _detailView.DetailList), {
                children: [
                    !isLive && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                        label: "Live Session",
                        value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                pipeline.sessionStart && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-mono text-sm",
                                    children: (0, _dateFns.format)(new Date(pipeline.sessionStart), 'MMM d, HH:mm')
                                }),
                                sessionEnded ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepStatus, {
                                    ok: true,
                                    label: pipeline.leacStatus ?? 'ended'
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(PendingStatus, {
                                    label: pipeline.leacStatus ?? 'unknown'
                                })
                            ]
                        })
                    }),
                    pipeline.captionDuration !== null && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                        label: "Session Duration",
                        value: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-mono text-sm",
                            children: (0, _format.formatDuration)(pipeline.captionDuration)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                        label: "Published",
                        value: isPublished && pipeline.publishedAt ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-mono text-sm",
                                    children: (0, _dateFns.format)(new Date(pipeline.publishedAt), 'MMM d, HH:mm')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepStatus, {
                                    ok: true,
                                    label: "archive"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(PendingStatus, {
                            label: "not published"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                        label: "Caption VTT",
                        value: hasVtt ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                pipeline.captionVtt.createdAt && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "font-mono text-sm",
                                    children: (0, _dateFns.format)(new Date(pipeline.captionVtt.createdAt), 'MMM d, HH:mm')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepStatus, {
                                    ok: true,
                                    label: (0, _format.formatFileSize)(pipeline.captionVtt.fileSize)
                                })
                            ]
                        }) : isPublished ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StepStatus, {
                                    ok: false,
                                    label: "missing"
                                }),
                                timeSincePublish && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "text-xs text-muted-foreground",
                                    children: [
                                        "(published ",
                                        timeSincePublish,
                                        ")"
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(PendingStatus, {
                            label: "awaiting publish"
                        })
                    }),
                    pipeline.timeToCaptionSeconds !== null && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                        label: "Time to Caption",
                        value: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "font-mono text-sm",
                            children: (0, _format.formatDuration)(pipeline.timeToCaptionSeconds)
                        })
                    })
                ]
            }),
            hasVtt && pipeline.captionVtt.path && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mt-3 pt-3 border-t",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                    asChild: true,
                    variant: "outline",
                    size: "sm",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouter.Link), {
                        to: "/utilities/vtt-analyzer",
                        search: {
                            url: pipeline.captionVtt.path
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ExternalLink), {
                                className: "h-3.5 w-3.5 mr-1.5"
                            }),
                            "Analyze VTT"
                        ]
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"dQjte","date-fns":[["format","4NYjc"],["formatDistanceStrict","03bGy"]],"lucide-react":[["CheckCircle","2O3dV","default"],["Clock","eqIIU","default"],["ExternalLink","kIIQA","default"],["XCircle","aDWrd","default"]],"@tanstack/react-router":"7k6Lq","@/client/lib/format":"iLptT","@/client/components/ui/button":"armlb","@/client/components/ui/detail-view":"5pGcz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"iSH28":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SimulcastTargetsCard", ()=>SimulcastTargetsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _detailView = require("@/client/components/ui/detail-view");
function TransmitStatus({ target }) {
    if (target.transmissionErrorMsg) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "inline-flex items-center gap-1 text-xs text-destructive",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.XCircle), {
                className: "h-3 w-3"
            }),
            target.transmissionErrorMsg
        ]
    });
    if (target.transmitting) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "inline-flex items-center gap-1 text-xs text-green-500",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CheckCircle), {
                className: "h-3 w-3"
            }),
            "Transmitting"
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "inline-flex items-center gap-1 text-xs text-muted-foreground",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Circle), {
                className: "h-3 w-3"
            }),
            "Idle"
        ]
    });
}
function SimulcastTargetsCard({ targets }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailCard), {
        title: `Simulcast Destinations (${targets.length})`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailList), {
            children: targets.map((target, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailView.DetailRow), {
                    label: target.providerName,
                    value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col items-end gap-0.5",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "text-sm",
                                children: [
                                    target.destName || target.fqdn,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "text-muted-foreground ml-1.5 text-xs",
                                        children: [
                                            "(",
                                            target.protocol,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransmitStatus, {
                                target: target
                            })
                        ]
                    })
                }, i))
        })
    });
}

},{"react/jsx-runtime":"dQjte","lucide-react":[["CheckCircle","2O3dV","default"],["Circle","lGLGY","default"],["XCircle","aDWrd","default"]],"@/client/components/ui/detail-view":"5pGcz","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"9ofSQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Toaster", ()=>Toaster);
var _jsxRuntime = require("react/jsx-runtime");
var _lucideReact = require("lucide-react");
var _themeProvider = require("@/client/components/theme-provider");
var _sonner = require("sonner");
const Toaster = ({ ...props })=>{
    const { theme = "system" } = (0, _themeProvider.useTheme)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sonner.Toaster), {
        theme: theme,
        className: "toaster group",
        icons: {
            success: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.CircleCheck), {
                className: "h-4 w-4"
            }),
            info: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Info), {
                className: "h-4 w-4"
            }),
            warning: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.TriangleAlert), {
                className: "h-4 w-4"
            }),
            error: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.OctagonX), {
                className: "h-4 w-4"
            }),
            loading: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.LoaderCircle), {
                className: "h-4 w-4 animate-spin"
            })
        },
        toastOptions: {
            classNames: {
                toast: [
                    "group toast",
                    "group-[.toaster]:bg-background",
                    "group-[.toaster]:text-foreground",
                    "group-[.toaster]:border-border",
                    "group-[.toaster]:shadow-lg"
                ].join(" "),
                description: "group-[.toast]:text-muted-foreground",
                actionButton: [
                    "group-[.toast]:bg-primary",
                    "group-[.toast]:text-primary-foreground"
                ].join(" "),
                cancelButton: [
                    "group-[.toast]:bg-muted",
                    "group-[.toast]:text-muted-foreground"
                ].join(" "),
                success: [
                    "group-[.toaster]:!bg-emerald-600",
                    "group-[.toaster]:!text-white",
                    "group-[.toaster]:!border-emerald-500"
                ].join(" "),
                info: [
                    "group-[.toaster]:border-0",
                    // Light mode
                    "group-[.toaster]:bg-gray-800",
                    "group-[.toaster]:text-gray-50",
                    // Dark mode
                    "dark:group-[.toaster]:bg-gray-50",
                    "dark:group-[.toaster]:text-gray-800"
                ].join(" ")
            }
        },
        richColors: true,
        ...props
    });
};

},{"react/jsx-runtime":"dQjte","lucide-react":[["CircleCheck","jNsZg","default"],["Info","4BuJn","default"],["LoaderCircle","gZHhk","default"],["OctagonX","8zcUg","default"],["TriangleAlert","cdePa","default"]],"@/client/components/theme-provider":"6OWVF","sonner":"2p5sL","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"8zcUg":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>OctagonX);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
            key: "2d38gg"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
];
const OctagonX = (0, _createLucideIconJsDefault.default)("octagon-x", __iconNode);

},{"../createLucideIcon.js":"exGNd","@parcel/transformer-js/src/esmodule-helpers.js":"3Iwn0"}],"giRzh":[function() {},{}]},["1xCJv"], "1xCJv", "parcelRequire1f08", {})

//# sourceMappingURL=client.69fac41e.js.map
